var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined")
    return require.apply(this, arguments);
  throw new Error('Dynamic require of "' + x + '" is not supported');
});
var __commonJS = (cb, mod) => function __require2() {
  return mod || (0, cb[Object.keys(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// (disabled):crypto
var require_crypto = __commonJS({
  "(disabled):crypto"() {
  }
});

// dist/web-ifc-mt.js
var require_web_ifc_mt = __commonJS({
  "dist/web-ifc-mt.js"(exports, module) {
    var WebIFCWasm2 = (() => {
      var _scriptDir = typeof document !== "undefined" && document.currentScript ? document.currentScript.src : void 0;
      if (typeof __filename !== "undefined")
        _scriptDir = _scriptDir || __filename;
      return function(WebIFCWasm3 = {}) {
        function GROWABLE_HEAP_I8() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }
          return HEAP8;
        }
        function GROWABLE_HEAP_U8() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }
          return HEAPU8;
        }
        function GROWABLE_HEAP_I16() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }
          return HEAP16;
        }
        function GROWABLE_HEAP_U16() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }
          return HEAPU16;
        }
        function GROWABLE_HEAP_I32() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }
          return HEAP32;
        }
        function GROWABLE_HEAP_U32() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }
          return HEAPU32;
        }
        function GROWABLE_HEAP_F32() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }
          return HEAPF32;
        }
        function GROWABLE_HEAP_F64() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }
          return HEAPF64;
        }
        var Module = typeof WebIFCWasm3 != "undefined" ? WebIFCWasm3 : {};
        var readyPromiseResolve, readyPromiseReject;
        Module["ready"] = new Promise(function(resolve, reject) {
          readyPromiseResolve = resolve;
          readyPromiseReject = reject;
        });
        var moduleOverrides = Object.assign({}, Module);
        var arguments_ = [];
        var thisProgram = "./this.program";
        var quit_ = (status, toThrow) => {
          throw toThrow;
        };
        var ENVIRONMENT_IS_WEB = typeof window == "object";
        var ENVIRONMENT_IS_WORKER = typeof importScripts == "function";
        var ENVIRONMENT_IS_NODE = typeof process == "object" && typeof process.versions == "object" && typeof process.versions.node == "string";
        var ENVIRONMENT_IS_PTHREAD = Module["ENVIRONMENT_IS_PTHREAD"] || false;
        var scriptDirectory = "";
        function locateFile(path) {
          if (Module["locateFile"]) {
            return Module["locateFile"](path, scriptDirectory);
          }
          return scriptDirectory + path;
        }
        var read_, readAsync, readBinary, setWindowTitle;
        function logExceptionOnExit(e) {
          if (e instanceof ExitStatus)
            return;
          let toLog = e;
          err("exiting due to exception: " + toLog);
        }
        if (ENVIRONMENT_IS_NODE) {
          var fs = __require("fs");
          var nodePath = __require("path");
          if (ENVIRONMENT_IS_WORKER) {
            scriptDirectory = nodePath.dirname(scriptDirectory) + "/";
          } else {
            scriptDirectory = __dirname + "/";
          }
          read_ = (filename, binary) => {
            filename = isFileURI(filename) ? new URL(filename) : nodePath.normalize(filename);
            return fs.readFileSync(filename, binary ? void 0 : "utf8");
          };
          readBinary = (filename) => {
            var ret = read_(filename, true);
            if (!ret.buffer) {
              ret = new Uint8Array(ret);
            }
            return ret;
          };
          readAsync = (filename, onload, onerror) => {
            filename = isFileURI(filename) ? new URL(filename) : nodePath.normalize(filename);
            fs.readFile(filename, function(err2, data) {
              if (err2)
                onerror(err2);
              else
                onload(data.buffer);
            });
          };
          if (process["argv"].length > 1) {
            thisProgram = process["argv"][1].replace(/\\/g, "/");
          }
          arguments_ = process["argv"].slice(2);
          process["on"]("uncaughtException", function(ex) {
            if (!(ex instanceof ExitStatus)) {
              throw ex;
            }
          });
          var nodeMajor = process.version.match(/^v(\d+)\./)[1];
          if (nodeMajor < 15) {
            process["on"]("unhandledRejection", function(reason) {
              throw reason;
            });
          }
          quit_ = (status, toThrow) => {
            if (keepRuntimeAlive()) {
              process["exitCode"] = status;
              throw toThrow;
            }
            logExceptionOnExit(toThrow);
            process["exit"](status);
          };
          Module["inspect"] = function() {
            return "[Emscripten Module object]";
          };
          let nodeWorkerThreads;
          try {
            nodeWorkerThreads = __require("worker_threads");
          } catch (e) {
            console.error('The "worker_threads" module is not supported in this node.js build - perhaps a newer version is needed?');
            throw e;
          }
          global.Worker = nodeWorkerThreads.Worker;
        } else if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
          if (ENVIRONMENT_IS_WORKER) {
            scriptDirectory = self.location.href;
          } else if (typeof document != "undefined" && document.currentScript) {
            scriptDirectory = document.currentScript.src;
          }
          if (_scriptDir) {
            scriptDirectory = _scriptDir;
          }
          if (scriptDirectory.indexOf("blob:") !== 0) {
            scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
          } else {
            scriptDirectory = "";
          }
          if (!ENVIRONMENT_IS_NODE) {
            read_ = (url) => {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, false);
              xhr.send(null);
              return xhr.responseText;
            };
            if (ENVIRONMENT_IS_WORKER) {
              readBinary = (url) => {
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, false);
                xhr.responseType = "arraybuffer";
                xhr.send(null);
                return new Uint8Array(xhr.response);
              };
            }
            readAsync = (url, onload, onerror) => {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, true);
              xhr.responseType = "arraybuffer";
              xhr.onload = () => {
                if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                  onload(xhr.response);
                  return;
                }
                onerror();
              };
              xhr.onerror = onerror;
              xhr.send(null);
            };
          }
          setWindowTitle = (title) => document.title = title;
        } else {
        }
        if (ENVIRONMENT_IS_NODE) {
          if (typeof performance == "undefined") {
            global.performance = __require("perf_hooks").performance;
          }
        }
        var defaultPrint = console.log.bind(console);
        var defaultPrintErr = console.warn.bind(console);
        if (ENVIRONMENT_IS_NODE) {
          defaultPrint = (str) => fs.writeSync(1, str + "\n");
          defaultPrintErr = (str) => fs.writeSync(2, str + "\n");
        }
        var out = Module["print"] || defaultPrint;
        var err = Module["printErr"] || defaultPrintErr;
        Object.assign(Module, moduleOverrides);
        moduleOverrides = null;
        if (Module["arguments"])
          arguments_ = Module["arguments"];
        if (Module["thisProgram"])
          thisProgram = Module["thisProgram"];
        if (Module["quit"])
          quit_ = Module["quit"];
        var wasmBinary;
        if (Module["wasmBinary"])
          wasmBinary = Module["wasmBinary"];
        var noExitRuntime = Module["noExitRuntime"] || true;
        if (typeof WebAssembly != "object") {
          abort("no native wasm support detected");
        }
        var wasmMemory;
        var wasmModule;
        var ABORT = false;
        var EXITSTATUS;
        function assert(condition, text) {
          if (!condition) {
            abort(text);
          }
        }
        var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : void 0;
        function UTF8ArrayToString(heapOrArray, idx, maxBytesToRead) {
          idx >>>= 0;
          var endIdx = idx + maxBytesToRead;
          var endPtr = idx;
          while (heapOrArray[endPtr] && !(endPtr >= endIdx))
            ++endPtr;
          if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) {
            return UTF8Decoder.decode(heapOrArray.buffer instanceof SharedArrayBuffer ? heapOrArray.slice(idx, endPtr) : heapOrArray.subarray(idx, endPtr));
          }
          var str = "";
          while (idx < endPtr) {
            var u0 = heapOrArray[idx++];
            if (!(u0 & 128)) {
              str += String.fromCharCode(u0);
              continue;
            }
            var u1 = heapOrArray[idx++] & 63;
            if ((u0 & 224) == 192) {
              str += String.fromCharCode((u0 & 31) << 6 | u1);
              continue;
            }
            var u2 = heapOrArray[idx++] & 63;
            if ((u0 & 240) == 224) {
              u0 = (u0 & 15) << 12 | u1 << 6 | u2;
            } else {
              u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
            }
            if (u0 < 65536) {
              str += String.fromCharCode(u0);
            } else {
              var ch = u0 - 65536;
              str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
            }
          }
          return str;
        }
        function UTF8ToString(ptr, maxBytesToRead) {
          ptr >>>= 0;
          return ptr ? UTF8ArrayToString(GROWABLE_HEAP_U8(), ptr, maxBytesToRead) : "";
        }
        function stringToUTF8Array(str, heap, outIdx, maxBytesToWrite) {
          outIdx >>>= 0;
          if (!(maxBytesToWrite > 0))
            return 0;
          var startIdx = outIdx;
          var endIdx = outIdx + maxBytesToWrite - 1;
          for (var i = 0; i < str.length; ++i) {
            var u = str.charCodeAt(i);
            if (u >= 55296 && u <= 57343) {
              var u1 = str.charCodeAt(++i);
              u = 65536 + ((u & 1023) << 10) | u1 & 1023;
            }
            if (u <= 127) {
              if (outIdx >= endIdx)
                break;
              heap[outIdx++ >>> 0] = u;
            } else if (u <= 2047) {
              if (outIdx + 1 >= endIdx)
                break;
              heap[outIdx++ >>> 0] = 192 | u >> 6;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            } else if (u <= 65535) {
              if (outIdx + 2 >= endIdx)
                break;
              heap[outIdx++ >>> 0] = 224 | u >> 12;
              heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            } else {
              if (outIdx + 3 >= endIdx)
                break;
              heap[outIdx++ >>> 0] = 240 | u >> 18;
              heap[outIdx++ >>> 0] = 128 | u >> 12 & 63;
              heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            }
          }
          heap[outIdx >>> 0] = 0;
          return outIdx - startIdx;
        }
        function stringToUTF8(str, outPtr, maxBytesToWrite) {
          return stringToUTF8Array(str, GROWABLE_HEAP_U8(), outPtr, maxBytesToWrite);
        }
        function lengthBytesUTF8(str) {
          var len = 0;
          for (var i = 0; i < str.length; ++i) {
            var c = str.charCodeAt(i);
            if (c <= 127) {
              len++;
            } else if (c <= 2047) {
              len += 2;
            } else if (c >= 55296 && c <= 57343) {
              len += 4;
              ++i;
            } else {
              len += 3;
            }
          }
          return len;
        }
        var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
        function updateMemoryViews() {
          var b = wasmMemory.buffer;
          Module["HEAP8"] = HEAP8 = new Int8Array(b);
          Module["HEAP16"] = HEAP16 = new Int16Array(b);
          Module["HEAP32"] = HEAP32 = new Int32Array(b);
          Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
          Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
          Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
          Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
          Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
        }
        var INITIAL_MEMORY = Module["INITIAL_MEMORY"] || 16777216;
        assert(INITIAL_MEMORY >= 5242880, "INITIAL_MEMORY should be larger than STACK_SIZE, was " + INITIAL_MEMORY + "! (STACK_SIZE=" + 5242880 + ")");
        if (ENVIRONMENT_IS_PTHREAD) {
          wasmMemory = Module["wasmMemory"];
        } else {
          if (Module["wasmMemory"]) {
            wasmMemory = Module["wasmMemory"];
          } else {
            wasmMemory = new WebAssembly.Memory({ "initial": INITIAL_MEMORY / 65536, "maximum": 4294967296 / 65536, "shared": true });
            if (!(wasmMemory.buffer instanceof SharedArrayBuffer)) {
              err("requested a shared WebAssembly.Memory but the returned buffer is not a SharedArrayBuffer, indicating that while the browser has SharedArrayBuffer it does not have WebAssembly threads support - you may need to set a flag");
              if (ENVIRONMENT_IS_NODE) {
                err("(on node you may need: --experimental-wasm-threads --experimental-wasm-bulk-memory and/or recent version)");
              }
              throw Error("bad memory");
            }
          }
        }
        updateMemoryViews();
        INITIAL_MEMORY = wasmMemory.buffer.byteLength;
        var wasmTable;
        var __ATPRERUN__ = [];
        var __ATINIT__ = [];
        var __ATPOSTRUN__ = [];
        var runtimeInitialized = false;
        function keepRuntimeAlive() {
          return noExitRuntime;
        }
        function preRun() {
          if (Module["preRun"]) {
            if (typeof Module["preRun"] == "function")
              Module["preRun"] = [Module["preRun"]];
            while (Module["preRun"].length) {
              addOnPreRun(Module["preRun"].shift());
            }
          }
          callRuntimeCallbacks(__ATPRERUN__);
        }
        function initRuntime() {
          runtimeInitialized = true;
          if (ENVIRONMENT_IS_PTHREAD)
            return;
          if (!Module["noFSInit"] && !FS.init.initialized)
            FS.init();
          FS.ignorePermissions = false;
          TTY.init();
          callRuntimeCallbacks(__ATINIT__);
        }
        function postRun() {
          if (ENVIRONMENT_IS_PTHREAD)
            return;
          if (Module["postRun"]) {
            if (typeof Module["postRun"] == "function")
              Module["postRun"] = [Module["postRun"]];
            while (Module["postRun"].length) {
              addOnPostRun(Module["postRun"].shift());
            }
          }
          callRuntimeCallbacks(__ATPOSTRUN__);
        }
        function addOnPreRun(cb) {
          __ATPRERUN__.unshift(cb);
        }
        function addOnInit(cb) {
          __ATINIT__.unshift(cb);
        }
        function addOnPostRun(cb) {
          __ATPOSTRUN__.unshift(cb);
        }
        var runDependencies = 0;
        var runDependencyWatcher = null;
        var dependenciesFulfilled = null;
        function getUniqueRunDependency(id) {
          return id;
        }
        function addRunDependency(id) {
          runDependencies++;
          if (Module["monitorRunDependencies"]) {
            Module["monitorRunDependencies"](runDependencies);
          }
        }
        function removeRunDependency(id) {
          runDependencies--;
          if (Module["monitorRunDependencies"]) {
            Module["monitorRunDependencies"](runDependencies);
          }
          if (runDependencies == 0) {
            if (runDependencyWatcher !== null) {
              clearInterval(runDependencyWatcher);
              runDependencyWatcher = null;
            }
            if (dependenciesFulfilled) {
              var callback = dependenciesFulfilled;
              dependenciesFulfilled = null;
              callback();
            }
          }
        }
        function abort(what) {
          if (Module["onAbort"]) {
            Module["onAbort"](what);
          }
          what = "Aborted(" + what + ")";
          err(what);
          ABORT = true;
          EXITSTATUS = 1;
          what += ". Build with -sASSERTIONS for more info.";
          var e = new WebAssembly.RuntimeError(what);
          readyPromiseReject(e);
          throw e;
        }
        var dataURIPrefix = "data:application/octet-stream;base64,";
        function isDataURI(filename) {
          return filename.startsWith(dataURIPrefix);
        }
        function isFileURI(filename) {
          return filename.startsWith("file://");
        }
        var wasmBinaryFile;
        wasmBinaryFile = "web-ifc-mt.wasm";
        if (!isDataURI(wasmBinaryFile)) {
          wasmBinaryFile = locateFile(wasmBinaryFile);
        }
        function getBinary(file) {
          try {
            if (file == wasmBinaryFile && wasmBinary) {
              return new Uint8Array(wasmBinary);
            }
            if (readBinary) {
              return readBinary(file);
            }
            throw "both async and sync fetching of the wasm failed";
          } catch (err2) {
            abort(err2);
          }
        }
        function getBinaryPromise() {
          if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
            if (typeof fetch == "function" && !isFileURI(wasmBinaryFile)) {
              return fetch(wasmBinaryFile, { credentials: "same-origin" }).then(function(response) {
                if (!response["ok"]) {
                  throw "failed to load wasm binary file at '" + wasmBinaryFile + "'";
                }
                return response["arrayBuffer"]();
              }).catch(function() {
                return getBinary(wasmBinaryFile);
              });
            } else {
              if (readAsync) {
                return new Promise(function(resolve, reject) {
                  readAsync(wasmBinaryFile, function(response) {
                    resolve(new Uint8Array(response));
                  }, reject);
                });
              }
            }
          }
          return Promise.resolve().then(function() {
            return getBinary(wasmBinaryFile);
          });
        }
        function createWasm() {
          var info = { "a": wasmImports };
          function receiveInstance(instance, module2) {
            var exports3 = instance.exports;
            Module["asm"] = exports3;
            registerTLSInit(Module["asm"]["ma"]);
            wasmTable = Module["asm"]["ka"];
            addOnInit(Module["asm"]["ja"]);
            wasmModule = module2;
            PThread.loadWasmModuleToAllWorkers(() => removeRunDependency("wasm-instantiate"));
          }
          addRunDependency("wasm-instantiate");
          function receiveInstantiationResult(result) {
            receiveInstance(result["instance"], result["module"]);
          }
          function instantiateArrayBuffer(receiver) {
            return getBinaryPromise().then(function(binary) {
              return WebAssembly.instantiate(binary, info);
            }).then(function(instance) {
              return instance;
            }).then(receiver, function(reason) {
              err("failed to asynchronously prepare wasm: " + reason);
              abort(reason);
            });
          }
          function instantiateAsync() {
            if (!wasmBinary && typeof WebAssembly.instantiateStreaming == "function" && !isDataURI(wasmBinaryFile) && !isFileURI(wasmBinaryFile) && !ENVIRONMENT_IS_NODE && typeof fetch == "function") {
              return fetch(wasmBinaryFile, { credentials: "same-origin" }).then(function(response) {
                var result = WebAssembly.instantiateStreaming(response, info);
                return result.then(receiveInstantiationResult, function(reason) {
                  err("wasm streaming compile failed: " + reason);
                  err("falling back to ArrayBuffer instantiation");
                  return instantiateArrayBuffer(receiveInstantiationResult);
                });
              });
            } else {
              return instantiateArrayBuffer(receiveInstantiationResult);
            }
          }
          if (Module["instantiateWasm"]) {
            try {
              var exports2 = Module["instantiateWasm"](info, receiveInstance);
              return exports2;
            } catch (e) {
              err("Module.instantiateWasm callback failed with error: " + e);
              readyPromiseReject(e);
            }
          }
          instantiateAsync().catch(readyPromiseReject);
          return {};
        }
        var tempDouble;
        var tempI64;
        function ExitStatus(status) {
          this.name = "ExitStatus";
          this.message = "Program terminated with exit(" + status + ")";
          this.status = status;
        }
        function killThread(pthread_ptr) {
          var worker = PThread.pthreads[pthread_ptr];
          delete PThread.pthreads[pthread_ptr];
          worker.terminate();
          __emscripten_thread_free_data(pthread_ptr);
          PThread.runningWorkers.splice(PThread.runningWorkers.indexOf(worker), 1);
          worker.pthread_ptr = 0;
        }
        function cancelThread(pthread_ptr) {
          var worker = PThread.pthreads[pthread_ptr];
          worker.postMessage({ "cmd": "cancel" });
        }
        function cleanupThread(pthread_ptr) {
          var worker = PThread.pthreads[pthread_ptr];
          assert(worker);
          PThread.returnWorkerToPool(worker);
        }
        function spawnThread(threadParams) {
          var worker = PThread.getNewWorker();
          if (!worker) {
            return 6;
          }
          PThread.runningWorkers.push(worker);
          PThread.pthreads[threadParams.pthread_ptr] = worker;
          worker.pthread_ptr = threadParams.pthread_ptr;
          var msg = { "cmd": "run", "start_routine": threadParams.startRoutine, "arg": threadParams.arg, "pthread_ptr": threadParams.pthread_ptr };
          if (ENVIRONMENT_IS_NODE) {
            worker.ref();
          }
          worker.postMessage(msg, threadParams.transferList);
          return 0;
        }
        var PATH = { isAbs: (path) => path.charAt(0) === "/", splitPath: (filename) => {
          var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
          return splitPathRe.exec(filename).slice(1);
        }, normalizeArray: (parts, allowAboveRoot) => {
          var up = 0;
          for (var i = parts.length - 1; i >= 0; i--) {
            var last = parts[i];
            if (last === ".") {
              parts.splice(i, 1);
            } else if (last === "..") {
              parts.splice(i, 1);
              up++;
            } else if (up) {
              parts.splice(i, 1);
              up--;
            }
          }
          if (allowAboveRoot) {
            for (; up; up--) {
              parts.unshift("..");
            }
          }
          return parts;
        }, normalize: (path) => {
          var isAbsolute = PATH.isAbs(path), trailingSlash = path.substr(-1) === "/";
          path = PATH.normalizeArray(path.split("/").filter((p) => !!p), !isAbsolute).join("/");
          if (!path && !isAbsolute) {
            path = ".";
          }
          if (path && trailingSlash) {
            path += "/";
          }
          return (isAbsolute ? "/" : "") + path;
        }, dirname: (path) => {
          var result = PATH.splitPath(path), root = result[0], dir = result[1];
          if (!root && !dir) {
            return ".";
          }
          if (dir) {
            dir = dir.substr(0, dir.length - 1);
          }
          return root + dir;
        }, basename: (path) => {
          if (path === "/")
            return "/";
          path = PATH.normalize(path);
          path = path.replace(/\/$/, "");
          var lastSlash = path.lastIndexOf("/");
          if (lastSlash === -1)
            return path;
          return path.substr(lastSlash + 1);
        }, join: function() {
          var paths = Array.prototype.slice.call(arguments);
          return PATH.normalize(paths.join("/"));
        }, join2: (l, r) => {
          return PATH.normalize(l + "/" + r);
        } };
        function getRandomDevice() {
          if (typeof crypto == "object" && typeof crypto["getRandomValues"] == "function") {
            var randomBuffer = new Uint8Array(1);
            return () => {
              crypto.getRandomValues(randomBuffer);
              return randomBuffer[0];
            };
          } else if (ENVIRONMENT_IS_NODE) {
            try {
              var crypto_module = require_crypto();
              return () => crypto_module["randomBytes"](1)[0];
            } catch (e) {
            }
          }
          return () => abort("randomDevice");
        }
        var PATH_FS = { resolve: function() {
          var resolvedPath = "", resolvedAbsolute = false;
          for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
            var path = i >= 0 ? arguments[i] : FS.cwd();
            if (typeof path != "string") {
              throw new TypeError("Arguments to path.resolve must be strings");
            } else if (!path) {
              return "";
            }
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = PATH.isAbs(path);
          }
          resolvedPath = PATH.normalizeArray(resolvedPath.split("/").filter((p) => !!p), !resolvedAbsolute).join("/");
          return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
        }, relative: (from, to) => {
          from = PATH_FS.resolve(from).substr(1);
          to = PATH_FS.resolve(to).substr(1);
          function trim(arr) {
            var start = 0;
            for (; start < arr.length; start++) {
              if (arr[start] !== "")
                break;
            }
            var end = arr.length - 1;
            for (; end >= 0; end--) {
              if (arr[end] !== "")
                break;
            }
            if (start > end)
              return [];
            return arr.slice(start, end - start + 1);
          }
          var fromParts = trim(from.split("/"));
          var toParts = trim(to.split("/"));
          var length = Math.min(fromParts.length, toParts.length);
          var samePartsLength = length;
          for (var i = 0; i < length; i++) {
            if (fromParts[i] !== toParts[i]) {
              samePartsLength = i;
              break;
            }
          }
          var outputParts = [];
          for (var i = samePartsLength; i < fromParts.length; i++) {
            outputParts.push("..");
          }
          outputParts = outputParts.concat(toParts.slice(samePartsLength));
          return outputParts.join("/");
        } };
        function intArrayFromString(stringy, dontAddNull, length) {
          var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
          var u8array = new Array(len);
          var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
          if (dontAddNull)
            u8array.length = numBytesWritten;
          return u8array;
        }
        var TTY = { ttys: [], init: function() {
        }, shutdown: function() {
        }, register: function(dev, ops) {
          TTY.ttys[dev] = { input: [], output: [], ops };
          FS.registerDevice(dev, TTY.stream_ops);
        }, stream_ops: { open: function(stream) {
          var tty = TTY.ttys[stream.node.rdev];
          if (!tty) {
            throw new FS.ErrnoError(43);
          }
          stream.tty = tty;
          stream.seekable = false;
        }, close: function(stream) {
          stream.tty.ops.fsync(stream.tty);
        }, fsync: function(stream) {
          stream.tty.ops.fsync(stream.tty);
        }, read: function(stream, buffer, offset, length, pos) {
          if (!stream.tty || !stream.tty.ops.get_char) {
            throw new FS.ErrnoError(60);
          }
          var bytesRead = 0;
          for (var i = 0; i < length; i++) {
            var result;
            try {
              result = stream.tty.ops.get_char(stream.tty);
            } catch (e) {
              throw new FS.ErrnoError(29);
            }
            if (result === void 0 && bytesRead === 0) {
              throw new FS.ErrnoError(6);
            }
            if (result === null || result === void 0)
              break;
            bytesRead++;
            buffer[offset + i] = result;
          }
          if (bytesRead) {
            stream.node.timestamp = Date.now();
          }
          return bytesRead;
        }, write: function(stream, buffer, offset, length, pos) {
          if (!stream.tty || !stream.tty.ops.put_char) {
            throw new FS.ErrnoError(60);
          }
          try {
            for (var i = 0; i < length; i++) {
              stream.tty.ops.put_char(stream.tty, buffer[offset + i]);
            }
          } catch (e) {
            throw new FS.ErrnoError(29);
          }
          if (length) {
            stream.node.timestamp = Date.now();
          }
          return i;
        } }, default_tty_ops: { get_char: function(tty) {
          if (!tty.input.length) {
            var result = null;
            if (ENVIRONMENT_IS_NODE) {
              var BUFSIZE = 256;
              var buf = Buffer.alloc(BUFSIZE);
              var bytesRead = 0;
              try {
                bytesRead = fs.readSync(process.stdin.fd, buf, 0, BUFSIZE, -1);
              } catch (e) {
                if (e.toString().includes("EOF"))
                  bytesRead = 0;
                else
                  throw e;
              }
              if (bytesRead > 0) {
                result = buf.slice(0, bytesRead).toString("utf-8");
              } else {
                result = null;
              }
            } else if (typeof window != "undefined" && typeof window.prompt == "function") {
              result = window.prompt("Input: ");
              if (result !== null) {
                result += "\n";
              }
            } else if (typeof readline == "function") {
              result = readline();
              if (result !== null) {
                result += "\n";
              }
            }
            if (!result) {
              return null;
            }
            tty.input = intArrayFromString(result, true);
          }
          return tty.input.shift();
        }, put_char: function(tty, val) {
          if (val === null || val === 10) {
            out(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          } else {
            if (val != 0)
              tty.output.push(val);
          }
        }, fsync: function(tty) {
          if (tty.output && tty.output.length > 0) {
            out(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          }
        } }, default_tty1_ops: { put_char: function(tty, val) {
          if (val === null || val === 10) {
            err(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          } else {
            if (val != 0)
              tty.output.push(val);
          }
        }, fsync: function(tty) {
          if (tty.output && tty.output.length > 0) {
            err(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          }
        } } };
        function mmapAlloc(size) {
          abort();
        }
        var MEMFS = { ops_table: null, mount: function(mount) {
          return MEMFS.createNode(null, "/", 16384 | 511, 0);
        }, createNode: function(parent, name, mode, dev) {
          if (FS.isBlkdev(mode) || FS.isFIFO(mode)) {
            throw new FS.ErrnoError(63);
          }
          if (!MEMFS.ops_table) {
            MEMFS.ops_table = { dir: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr, lookup: MEMFS.node_ops.lookup, mknod: MEMFS.node_ops.mknod, rename: MEMFS.node_ops.rename, unlink: MEMFS.node_ops.unlink, rmdir: MEMFS.node_ops.rmdir, readdir: MEMFS.node_ops.readdir, symlink: MEMFS.node_ops.symlink }, stream: { llseek: MEMFS.stream_ops.llseek } }, file: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr }, stream: { llseek: MEMFS.stream_ops.llseek, read: MEMFS.stream_ops.read, write: MEMFS.stream_ops.write, allocate: MEMFS.stream_ops.allocate, mmap: MEMFS.stream_ops.mmap, msync: MEMFS.stream_ops.msync } }, link: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr, readlink: MEMFS.node_ops.readlink }, stream: {} }, chrdev: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr }, stream: FS.chrdev_stream_ops } };
          }
          var node = FS.createNode(parent, name, mode, dev);
          if (FS.isDir(node.mode)) {
            node.node_ops = MEMFS.ops_table.dir.node;
            node.stream_ops = MEMFS.ops_table.dir.stream;
            node.contents = {};
          } else if (FS.isFile(node.mode)) {
            node.node_ops = MEMFS.ops_table.file.node;
            node.stream_ops = MEMFS.ops_table.file.stream;
            node.usedBytes = 0;
            node.contents = null;
          } else if (FS.isLink(node.mode)) {
            node.node_ops = MEMFS.ops_table.link.node;
            node.stream_ops = MEMFS.ops_table.link.stream;
          } else if (FS.isChrdev(node.mode)) {
            node.node_ops = MEMFS.ops_table.chrdev.node;
            node.stream_ops = MEMFS.ops_table.chrdev.stream;
          }
          node.timestamp = Date.now();
          if (parent) {
            parent.contents[name] = node;
            parent.timestamp = node.timestamp;
          }
          return node;
        }, getFileDataAsTypedArray: function(node) {
          if (!node.contents)
            return new Uint8Array(0);
          if (node.contents.subarray)
            return node.contents.subarray(0, node.usedBytes);
          return new Uint8Array(node.contents);
        }, expandFileStorage: function(node, newCapacity) {
          newCapacity >>>= 0;
          var prevCapacity = node.contents ? node.contents.length : 0;
          if (prevCapacity >= newCapacity)
            return;
          var CAPACITY_DOUBLING_MAX = 1024 * 1024;
          newCapacity = Math.max(newCapacity, prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2 : 1.125) >>> 0);
          if (prevCapacity != 0)
            newCapacity = Math.max(newCapacity, 256);
          var oldContents = node.contents;
          node.contents = new Uint8Array(newCapacity);
          if (node.usedBytes > 0)
            node.contents.set(oldContents.subarray(0, node.usedBytes), 0);
        }, resizeFileStorage: function(node, newSize) {
          newSize >>>= 0;
          if (node.usedBytes == newSize)
            return;
          if (newSize == 0) {
            node.contents = null;
            node.usedBytes = 0;
          } else {
            var oldContents = node.contents;
            node.contents = new Uint8Array(newSize);
            if (oldContents) {
              node.contents.set(oldContents.subarray(0, Math.min(newSize, node.usedBytes)));
            }
            node.usedBytes = newSize;
          }
        }, node_ops: { getattr: function(node) {
          var attr = {};
          attr.dev = FS.isChrdev(node.mode) ? node.id : 1;
          attr.ino = node.id;
          attr.mode = node.mode;
          attr.nlink = 1;
          attr.uid = 0;
          attr.gid = 0;
          attr.rdev = node.rdev;
          if (FS.isDir(node.mode)) {
            attr.size = 4096;
          } else if (FS.isFile(node.mode)) {
            attr.size = node.usedBytes;
          } else if (FS.isLink(node.mode)) {
            attr.size = node.link.length;
          } else {
            attr.size = 0;
          }
          attr.atime = new Date(node.timestamp);
          attr.mtime = new Date(node.timestamp);
          attr.ctime = new Date(node.timestamp);
          attr.blksize = 4096;
          attr.blocks = Math.ceil(attr.size / attr.blksize);
          return attr;
        }, setattr: function(node, attr) {
          if (attr.mode !== void 0) {
            node.mode = attr.mode;
          }
          if (attr.timestamp !== void 0) {
            node.timestamp = attr.timestamp;
          }
          if (attr.size !== void 0) {
            MEMFS.resizeFileStorage(node, attr.size);
          }
        }, lookup: function(parent, name) {
          throw FS.genericErrors[44];
        }, mknod: function(parent, name, mode, dev) {
          return MEMFS.createNode(parent, name, mode, dev);
        }, rename: function(old_node, new_dir, new_name) {
          if (FS.isDir(old_node.mode)) {
            var new_node;
            try {
              new_node = FS.lookupNode(new_dir, new_name);
            } catch (e) {
            }
            if (new_node) {
              for (var i in new_node.contents) {
                throw new FS.ErrnoError(55);
              }
            }
          }
          delete old_node.parent.contents[old_node.name];
          old_node.parent.timestamp = Date.now();
          old_node.name = new_name;
          new_dir.contents[new_name] = old_node;
          new_dir.timestamp = old_node.parent.timestamp;
          old_node.parent = new_dir;
        }, unlink: function(parent, name) {
          delete parent.contents[name];
          parent.timestamp = Date.now();
        }, rmdir: function(parent, name) {
          var node = FS.lookupNode(parent, name);
          for (var i in node.contents) {
            throw new FS.ErrnoError(55);
          }
          delete parent.contents[name];
          parent.timestamp = Date.now();
        }, readdir: function(node) {
          var entries = [".", ".."];
          for (var key in node.contents) {
            if (!node.contents.hasOwnProperty(key)) {
              continue;
            }
            entries.push(key);
          }
          return entries;
        }, symlink: function(parent, newname, oldpath) {
          var node = MEMFS.createNode(parent, newname, 511 | 40960, 0);
          node.link = oldpath;
          return node;
        }, readlink: function(node) {
          if (!FS.isLink(node.mode)) {
            throw new FS.ErrnoError(28);
          }
          return node.link;
        } }, stream_ops: { read: function(stream, buffer, offset, length, position) {
          var contents = stream.node.contents;
          if (position >= stream.node.usedBytes)
            return 0;
          var size = Math.min(stream.node.usedBytes - position, length);
          if (size > 8 && contents.subarray) {
            buffer.set(contents.subarray(position, position + size), offset);
          } else {
            for (var i = 0; i < size; i++)
              buffer[offset + i] = contents[position + i];
          }
          return size;
        }, write: function(stream, buffer, offset, length, position, canOwn) {
          if (buffer.buffer === GROWABLE_HEAP_I8().buffer) {
            canOwn = false;
          }
          if (!length)
            return 0;
          var node = stream.node;
          node.timestamp = Date.now();
          if (buffer.subarray && (!node.contents || node.contents.subarray)) {
            if (canOwn) {
              node.contents = buffer.subarray(offset, offset + length);
              node.usedBytes = length;
              return length;
            } else if (node.usedBytes === 0 && position === 0) {
              node.contents = buffer.slice(offset, offset + length);
              node.usedBytes = length;
              return length;
            } else if (position + length <= node.usedBytes) {
              node.contents.set(buffer.subarray(offset, offset + length), position);
              return length;
            }
          }
          MEMFS.expandFileStorage(node, position + length);
          if (node.contents.subarray && buffer.subarray) {
            node.contents.set(buffer.subarray(offset, offset + length), position);
          } else {
            for (var i = 0; i < length; i++) {
              node.contents[position + i] = buffer[offset + i];
            }
          }
          node.usedBytes = Math.max(node.usedBytes, position + length);
          return length;
        }, llseek: function(stream, offset, whence) {
          var position = offset;
          if (whence === 1) {
            position += stream.position;
          } else if (whence === 2) {
            if (FS.isFile(stream.node.mode)) {
              position += stream.node.usedBytes;
            }
          }
          if (position < 0) {
            throw new FS.ErrnoError(28);
          }
          return position;
        }, allocate: function(stream, offset, length) {
          MEMFS.expandFileStorage(stream.node, offset + length);
          stream.node.usedBytes = Math.max(stream.node.usedBytes, offset + length);
        }, mmap: function(stream, length, position, prot, flags) {
          if (!FS.isFile(stream.node.mode)) {
            throw new FS.ErrnoError(43);
          }
          var ptr;
          var allocated;
          var contents = stream.node.contents;
          if (!(flags & 2) && contents.buffer === GROWABLE_HEAP_I8().buffer) {
            allocated = false;
            ptr = contents.byteOffset;
          } else {
            if (position > 0 || position + length < contents.length) {
              if (contents.subarray) {
                contents = contents.subarray(position, position + length);
              } else {
                contents = Array.prototype.slice.call(contents, position, position + length);
              }
            }
            allocated = true;
            ptr = mmapAlloc(length);
            if (!ptr) {
              throw new FS.ErrnoError(48);
            }
            ptr >>>= 0;
            GROWABLE_HEAP_I8().set(contents, ptr >>> 0);
          }
          return { ptr, allocated };
        }, msync: function(stream, buffer, offset, length, mmapFlags) {
          MEMFS.stream_ops.write(stream, buffer, 0, length, offset, false);
          return 0;
        } } };
        function asyncLoad(url, onload, onerror, noRunDep) {
          var dep = !noRunDep ? getUniqueRunDependency("al " + url) : "";
          readAsync(url, (arrayBuffer) => {
            assert(arrayBuffer, 'Loading data file "' + url + '" failed (no arrayBuffer).');
            onload(new Uint8Array(arrayBuffer));
            if (dep)
              removeRunDependency(dep);
          }, (event) => {
            if (onerror) {
              onerror();
            } else {
              throw 'Loading data file "' + url + '" failed.';
            }
          });
          if (dep)
            addRunDependency(dep);
        }
        var FS = { root: null, mounts: [], devices: {}, streams: [], nextInode: 1, nameTable: null, currentPath: "/", initialized: false, ignorePermissions: true, ErrnoError: null, genericErrors: {}, filesystems: null, syncFSRequests: 0, lookupPath: (path, opts = {}) => {
          path = PATH_FS.resolve(path);
          if (!path)
            return { path: "", node: null };
          var defaults = { follow_mount: true, recurse_count: 0 };
          opts = Object.assign(defaults, opts);
          if (opts.recurse_count > 8) {
            throw new FS.ErrnoError(32);
          }
          var parts = path.split("/").filter((p) => !!p);
          var current = FS.root;
          var current_path = "/";
          for (var i = 0; i < parts.length; i++) {
            var islast = i === parts.length - 1;
            if (islast && opts.parent) {
              break;
            }
            current = FS.lookupNode(current, parts[i]);
            current_path = PATH.join2(current_path, parts[i]);
            if (FS.isMountpoint(current)) {
              if (!islast || islast && opts.follow_mount) {
                current = current.mounted.root;
              }
            }
            if (!islast || opts.follow) {
              var count = 0;
              while (FS.isLink(current.mode)) {
                var link = FS.readlink(current_path);
                current_path = PATH_FS.resolve(PATH.dirname(current_path), link);
                var lookup = FS.lookupPath(current_path, { recurse_count: opts.recurse_count + 1 });
                current = lookup.node;
                if (count++ > 40) {
                  throw new FS.ErrnoError(32);
                }
              }
            }
          }
          return { path: current_path, node: current };
        }, getPath: (node) => {
          var path;
          while (true) {
            if (FS.isRoot(node)) {
              var mount = node.mount.mountpoint;
              if (!path)
                return mount;
              return mount[mount.length - 1] !== "/" ? mount + "/" + path : mount + path;
            }
            path = path ? node.name + "/" + path : node.name;
            node = node.parent;
          }
        }, hashName: (parentid, name) => {
          var hash = 0;
          for (var i = 0; i < name.length; i++) {
            hash = (hash << 5) - hash + name.charCodeAt(i) | 0;
          }
          return (parentid + hash >>> 0) % FS.nameTable.length;
        }, hashAddNode: (node) => {
          var hash = FS.hashName(node.parent.id, node.name);
          node.name_next = FS.nameTable[hash];
          FS.nameTable[hash] = node;
        }, hashRemoveNode: (node) => {
          var hash = FS.hashName(node.parent.id, node.name);
          if (FS.nameTable[hash] === node) {
            FS.nameTable[hash] = node.name_next;
          } else {
            var current = FS.nameTable[hash];
            while (current) {
              if (current.name_next === node) {
                current.name_next = node.name_next;
                break;
              }
              current = current.name_next;
            }
          }
        }, lookupNode: (parent, name) => {
          var errCode = FS.mayLookup(parent);
          if (errCode) {
            throw new FS.ErrnoError(errCode, parent);
          }
          var hash = FS.hashName(parent.id, name);
          for (var node = FS.nameTable[hash]; node; node = node.name_next) {
            var nodeName = node.name;
            if (node.parent.id === parent.id && nodeName === name) {
              return node;
            }
          }
          return FS.lookup(parent, name);
        }, createNode: (parent, name, mode, rdev) => {
          var node = new FS.FSNode(parent, name, mode, rdev);
          FS.hashAddNode(node);
          return node;
        }, destroyNode: (node) => {
          FS.hashRemoveNode(node);
        }, isRoot: (node) => {
          return node === node.parent;
        }, isMountpoint: (node) => {
          return !!node.mounted;
        }, isFile: (mode) => {
          return (mode & 61440) === 32768;
        }, isDir: (mode) => {
          return (mode & 61440) === 16384;
        }, isLink: (mode) => {
          return (mode & 61440) === 40960;
        }, isChrdev: (mode) => {
          return (mode & 61440) === 8192;
        }, isBlkdev: (mode) => {
          return (mode & 61440) === 24576;
        }, isFIFO: (mode) => {
          return (mode & 61440) === 4096;
        }, isSocket: (mode) => {
          return (mode & 49152) === 49152;
        }, flagModes: { "r": 0, "r+": 2, "w": 577, "w+": 578, "a": 1089, "a+": 1090 }, modeStringToFlags: (str) => {
          var flags = FS.flagModes[str];
          if (typeof flags == "undefined") {
            throw new Error("Unknown file open mode: " + str);
          }
          return flags;
        }, flagsToPermissionString: (flag) => {
          var perms = ["r", "w", "rw"][flag & 3];
          if (flag & 512) {
            perms += "w";
          }
          return perms;
        }, nodePermissions: (node, perms) => {
          if (FS.ignorePermissions) {
            return 0;
          }
          if (perms.includes("r") && !(node.mode & 292)) {
            return 2;
          } else if (perms.includes("w") && !(node.mode & 146)) {
            return 2;
          } else if (perms.includes("x") && !(node.mode & 73)) {
            return 2;
          }
          return 0;
        }, mayLookup: (dir) => {
          var errCode = FS.nodePermissions(dir, "x");
          if (errCode)
            return errCode;
          if (!dir.node_ops.lookup)
            return 2;
          return 0;
        }, mayCreate: (dir, name) => {
          try {
            var node = FS.lookupNode(dir, name);
            return 20;
          } catch (e) {
          }
          return FS.nodePermissions(dir, "wx");
        }, mayDelete: (dir, name, isdir) => {
          var node;
          try {
            node = FS.lookupNode(dir, name);
          } catch (e) {
            return e.errno;
          }
          var errCode = FS.nodePermissions(dir, "wx");
          if (errCode) {
            return errCode;
          }
          if (isdir) {
            if (!FS.isDir(node.mode)) {
              return 54;
            }
            if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) {
              return 10;
            }
          } else {
            if (FS.isDir(node.mode)) {
              return 31;
            }
          }
          return 0;
        }, mayOpen: (node, flags) => {
          if (!node) {
            return 44;
          }
          if (FS.isLink(node.mode)) {
            return 32;
          } else if (FS.isDir(node.mode)) {
            if (FS.flagsToPermissionString(flags) !== "r" || flags & 512) {
              return 31;
            }
          }
          return FS.nodePermissions(node, FS.flagsToPermissionString(flags));
        }, MAX_OPEN_FDS: 4096, nextfd: (fd_start = 0, fd_end = FS.MAX_OPEN_FDS) => {
          for (var fd = fd_start; fd <= fd_end; fd++) {
            if (!FS.streams[fd]) {
              return fd;
            }
          }
          throw new FS.ErrnoError(33);
        }, getStream: (fd) => FS.streams[fd], createStream: (stream, fd_start, fd_end) => {
          if (!FS.FSStream) {
            FS.FSStream = function() {
              this.shared = {};
            };
            FS.FSStream.prototype = {};
            Object.defineProperties(FS.FSStream.prototype, { object: { get: function() {
              return this.node;
            }, set: function(val) {
              this.node = val;
            } }, isRead: { get: function() {
              return (this.flags & 2097155) !== 1;
            } }, isWrite: { get: function() {
              return (this.flags & 2097155) !== 0;
            } }, isAppend: { get: function() {
              return this.flags & 1024;
            } }, flags: { get: function() {
              return this.shared.flags;
            }, set: function(val) {
              this.shared.flags = val;
            } }, position: { get: function() {
              return this.shared.position;
            }, set: function(val) {
              this.shared.position = val;
            } } });
          }
          stream = Object.assign(new FS.FSStream(), stream);
          var fd = FS.nextfd(fd_start, fd_end);
          stream.fd = fd;
          FS.streams[fd] = stream;
          return stream;
        }, closeStream: (fd) => {
          FS.streams[fd] = null;
        }, chrdev_stream_ops: { open: (stream) => {
          var device = FS.getDevice(stream.node.rdev);
          stream.stream_ops = device.stream_ops;
          if (stream.stream_ops.open) {
            stream.stream_ops.open(stream);
          }
        }, llseek: () => {
          throw new FS.ErrnoError(70);
        } }, major: (dev) => dev >> 8, minor: (dev) => dev & 255, makedev: (ma, mi) => ma << 8 | mi, registerDevice: (dev, ops) => {
          FS.devices[dev] = { stream_ops: ops };
        }, getDevice: (dev) => FS.devices[dev], getMounts: (mount) => {
          var mounts = [];
          var check = [mount];
          while (check.length) {
            var m = check.pop();
            mounts.push(m);
            check.push.apply(check, m.mounts);
          }
          return mounts;
        }, syncfs: (populate, callback) => {
          if (typeof populate == "function") {
            callback = populate;
            populate = false;
          }
          FS.syncFSRequests++;
          if (FS.syncFSRequests > 1) {
            err("warning: " + FS.syncFSRequests + " FS.syncfs operations in flight at once, probably just doing extra work");
          }
          var mounts = FS.getMounts(FS.root.mount);
          var completed = 0;
          function doCallback(errCode) {
            FS.syncFSRequests--;
            return callback(errCode);
          }
          function done(errCode) {
            if (errCode) {
              if (!done.errored) {
                done.errored = true;
                return doCallback(errCode);
              }
              return;
            }
            if (++completed >= mounts.length) {
              doCallback(null);
            }
          }
          mounts.forEach((mount) => {
            if (!mount.type.syncfs) {
              return done(null);
            }
            mount.type.syncfs(mount, populate, done);
          });
        }, mount: (type, opts, mountpoint) => {
          var root = mountpoint === "/";
          var pseudo = !mountpoint;
          var node;
          if (root && FS.root) {
            throw new FS.ErrnoError(10);
          } else if (!root && !pseudo) {
            var lookup = FS.lookupPath(mountpoint, { follow_mount: false });
            mountpoint = lookup.path;
            node = lookup.node;
            if (FS.isMountpoint(node)) {
              throw new FS.ErrnoError(10);
            }
            if (!FS.isDir(node.mode)) {
              throw new FS.ErrnoError(54);
            }
          }
          var mount = { type, opts, mountpoint, mounts: [] };
          var mountRoot = type.mount(mount);
          mountRoot.mount = mount;
          mount.root = mountRoot;
          if (root) {
            FS.root = mountRoot;
          } else if (node) {
            node.mounted = mount;
            if (node.mount) {
              node.mount.mounts.push(mount);
            }
          }
          return mountRoot;
        }, unmount: (mountpoint) => {
          var lookup = FS.lookupPath(mountpoint, { follow_mount: false });
          if (!FS.isMountpoint(lookup.node)) {
            throw new FS.ErrnoError(28);
          }
          var node = lookup.node;
          var mount = node.mounted;
          var mounts = FS.getMounts(mount);
          Object.keys(FS.nameTable).forEach((hash) => {
            var current = FS.nameTable[hash];
            while (current) {
              var next = current.name_next;
              if (mounts.includes(current.mount)) {
                FS.destroyNode(current);
              }
              current = next;
            }
          });
          node.mounted = null;
          var idx = node.mount.mounts.indexOf(mount);
          node.mount.mounts.splice(idx, 1);
        }, lookup: (parent, name) => {
          return parent.node_ops.lookup(parent, name);
        }, mknod: (path, mode, dev) => {
          var lookup = FS.lookupPath(path, { parent: true });
          var parent = lookup.node;
          var name = PATH.basename(path);
          if (!name || name === "." || name === "..") {
            throw new FS.ErrnoError(28);
          }
          var errCode = FS.mayCreate(parent, name);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!parent.node_ops.mknod) {
            throw new FS.ErrnoError(63);
          }
          return parent.node_ops.mknod(parent, name, mode, dev);
        }, create: (path, mode) => {
          mode = mode !== void 0 ? mode : 438;
          mode &= 4095;
          mode |= 32768;
          return FS.mknod(path, mode, 0);
        }, mkdir: (path, mode) => {
          mode = mode !== void 0 ? mode : 511;
          mode &= 511 | 512;
          mode |= 16384;
          return FS.mknod(path, mode, 0);
        }, mkdirTree: (path, mode) => {
          var dirs = path.split("/");
          var d = "";
          for (var i = 0; i < dirs.length; ++i) {
            if (!dirs[i])
              continue;
            d += "/" + dirs[i];
            try {
              FS.mkdir(d, mode);
            } catch (e) {
              if (e.errno != 20)
                throw e;
            }
          }
        }, mkdev: (path, mode, dev) => {
          if (typeof dev == "undefined") {
            dev = mode;
            mode = 438;
          }
          mode |= 8192;
          return FS.mknod(path, mode, dev);
        }, symlink: (oldpath, newpath) => {
          if (!PATH_FS.resolve(oldpath)) {
            throw new FS.ErrnoError(44);
          }
          var lookup = FS.lookupPath(newpath, { parent: true });
          var parent = lookup.node;
          if (!parent) {
            throw new FS.ErrnoError(44);
          }
          var newname = PATH.basename(newpath);
          var errCode = FS.mayCreate(parent, newname);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!parent.node_ops.symlink) {
            throw new FS.ErrnoError(63);
          }
          return parent.node_ops.symlink(parent, newname, oldpath);
        }, rename: (old_path, new_path) => {
          var old_dirname = PATH.dirname(old_path);
          var new_dirname = PATH.dirname(new_path);
          var old_name = PATH.basename(old_path);
          var new_name = PATH.basename(new_path);
          var lookup, old_dir, new_dir;
          lookup = FS.lookupPath(old_path, { parent: true });
          old_dir = lookup.node;
          lookup = FS.lookupPath(new_path, { parent: true });
          new_dir = lookup.node;
          if (!old_dir || !new_dir)
            throw new FS.ErrnoError(44);
          if (old_dir.mount !== new_dir.mount) {
            throw new FS.ErrnoError(75);
          }
          var old_node = FS.lookupNode(old_dir, old_name);
          var relative = PATH_FS.relative(old_path, new_dirname);
          if (relative.charAt(0) !== ".") {
            throw new FS.ErrnoError(28);
          }
          relative = PATH_FS.relative(new_path, old_dirname);
          if (relative.charAt(0) !== ".") {
            throw new FS.ErrnoError(55);
          }
          var new_node;
          try {
            new_node = FS.lookupNode(new_dir, new_name);
          } catch (e) {
          }
          if (old_node === new_node) {
            return;
          }
          var isdir = FS.isDir(old_node.mode);
          var errCode = FS.mayDelete(old_dir, old_name, isdir);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          errCode = new_node ? FS.mayDelete(new_dir, new_name, isdir) : FS.mayCreate(new_dir, new_name);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!old_dir.node_ops.rename) {
            throw new FS.ErrnoError(63);
          }
          if (FS.isMountpoint(old_node) || new_node && FS.isMountpoint(new_node)) {
            throw new FS.ErrnoError(10);
          }
          if (new_dir !== old_dir) {
            errCode = FS.nodePermissions(old_dir, "w");
            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }
          }
          FS.hashRemoveNode(old_node);
          try {
            old_dir.node_ops.rename(old_node, new_dir, new_name);
          } catch (e) {
            throw e;
          } finally {
            FS.hashAddNode(old_node);
          }
        }, rmdir: (path) => {
          var lookup = FS.lookupPath(path, { parent: true });
          var parent = lookup.node;
          var name = PATH.basename(path);
          var node = FS.lookupNode(parent, name);
          var errCode = FS.mayDelete(parent, name, true);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!parent.node_ops.rmdir) {
            throw new FS.ErrnoError(63);
          }
          if (FS.isMountpoint(node)) {
            throw new FS.ErrnoError(10);
          }
          parent.node_ops.rmdir(parent, name);
          FS.destroyNode(node);
        }, readdir: (path) => {
          var lookup = FS.lookupPath(path, { follow: true });
          var node = lookup.node;
          if (!node.node_ops.readdir) {
            throw new FS.ErrnoError(54);
          }
          return node.node_ops.readdir(node);
        }, unlink: (path) => {
          var lookup = FS.lookupPath(path, { parent: true });
          var parent = lookup.node;
          if (!parent) {
            throw new FS.ErrnoError(44);
          }
          var name = PATH.basename(path);
          var node = FS.lookupNode(parent, name);
          var errCode = FS.mayDelete(parent, name, false);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!parent.node_ops.unlink) {
            throw new FS.ErrnoError(63);
          }
          if (FS.isMountpoint(node)) {
            throw new FS.ErrnoError(10);
          }
          parent.node_ops.unlink(parent, name);
          FS.destroyNode(node);
        }, readlink: (path) => {
          var lookup = FS.lookupPath(path);
          var link = lookup.node;
          if (!link) {
            throw new FS.ErrnoError(44);
          }
          if (!link.node_ops.readlink) {
            throw new FS.ErrnoError(28);
          }
          return PATH_FS.resolve(FS.getPath(link.parent), link.node_ops.readlink(link));
        }, stat: (path, dontFollow) => {
          var lookup = FS.lookupPath(path, { follow: !dontFollow });
          var node = lookup.node;
          if (!node) {
            throw new FS.ErrnoError(44);
          }
          if (!node.node_ops.getattr) {
            throw new FS.ErrnoError(63);
          }
          return node.node_ops.getattr(node);
        }, lstat: (path) => {
          return FS.stat(path, true);
        }, chmod: (path, mode, dontFollow) => {
          var node;
          if (typeof path == "string") {
            var lookup = FS.lookupPath(path, { follow: !dontFollow });
            node = lookup.node;
          } else {
            node = path;
          }
          if (!node.node_ops.setattr) {
            throw new FS.ErrnoError(63);
          }
          node.node_ops.setattr(node, { mode: mode & 4095 | node.mode & ~4095, timestamp: Date.now() });
        }, lchmod: (path, mode) => {
          FS.chmod(path, mode, true);
        }, fchmod: (fd, mode) => {
          var stream = FS.getStream(fd);
          if (!stream) {
            throw new FS.ErrnoError(8);
          }
          FS.chmod(stream.node, mode);
        }, chown: (path, uid, gid, dontFollow) => {
          var node;
          if (typeof path == "string") {
            var lookup = FS.lookupPath(path, { follow: !dontFollow });
            node = lookup.node;
          } else {
            node = path;
          }
          if (!node.node_ops.setattr) {
            throw new FS.ErrnoError(63);
          }
          node.node_ops.setattr(node, { timestamp: Date.now() });
        }, lchown: (path, uid, gid) => {
          FS.chown(path, uid, gid, true);
        }, fchown: (fd, uid, gid) => {
          var stream = FS.getStream(fd);
          if (!stream) {
            throw new FS.ErrnoError(8);
          }
          FS.chown(stream.node, uid, gid);
        }, truncate: (path, len) => {
          if (len < 0) {
            throw new FS.ErrnoError(28);
          }
          var node;
          if (typeof path == "string") {
            var lookup = FS.lookupPath(path, { follow: true });
            node = lookup.node;
          } else {
            node = path;
          }
          if (!node.node_ops.setattr) {
            throw new FS.ErrnoError(63);
          }
          if (FS.isDir(node.mode)) {
            throw new FS.ErrnoError(31);
          }
          if (!FS.isFile(node.mode)) {
            throw new FS.ErrnoError(28);
          }
          var errCode = FS.nodePermissions(node, "w");
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          node.node_ops.setattr(node, { size: len, timestamp: Date.now() });
        }, ftruncate: (fd, len) => {
          var stream = FS.getStream(fd);
          if (!stream) {
            throw new FS.ErrnoError(8);
          }
          if ((stream.flags & 2097155) === 0) {
            throw new FS.ErrnoError(28);
          }
          FS.truncate(stream.node, len);
        }, utime: (path, atime, mtime) => {
          var lookup = FS.lookupPath(path, { follow: true });
          var node = lookup.node;
          node.node_ops.setattr(node, { timestamp: Math.max(atime, mtime) });
        }, open: (path, flags, mode) => {
          if (path === "") {
            throw new FS.ErrnoError(44);
          }
          flags = typeof flags == "string" ? FS.modeStringToFlags(flags) : flags;
          mode = typeof mode == "undefined" ? 438 : mode;
          if (flags & 64) {
            mode = mode & 4095 | 32768;
          } else {
            mode = 0;
          }
          var node;
          if (typeof path == "object") {
            node = path;
          } else {
            path = PATH.normalize(path);
            try {
              var lookup = FS.lookupPath(path, { follow: !(flags & 131072) });
              node = lookup.node;
            } catch (e) {
            }
          }
          var created = false;
          if (flags & 64) {
            if (node) {
              if (flags & 128) {
                throw new FS.ErrnoError(20);
              }
            } else {
              node = FS.mknod(path, mode, 0);
              created = true;
            }
          }
          if (!node) {
            throw new FS.ErrnoError(44);
          }
          if (FS.isChrdev(node.mode)) {
            flags &= ~512;
          }
          if (flags & 65536 && !FS.isDir(node.mode)) {
            throw new FS.ErrnoError(54);
          }
          if (!created) {
            var errCode = FS.mayOpen(node, flags);
            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }
          }
          if (flags & 512 && !created) {
            FS.truncate(node, 0);
          }
          flags &= ~(128 | 512 | 131072);
          var stream = FS.createStream({ node, path: FS.getPath(node), flags, seekable: true, position: 0, stream_ops: node.stream_ops, ungotten: [], error: false });
          if (stream.stream_ops.open) {
            stream.stream_ops.open(stream);
          }
          if (Module["logReadFiles"] && !(flags & 1)) {
            if (!FS.readFiles)
              FS.readFiles = {};
            if (!(path in FS.readFiles)) {
              FS.readFiles[path] = 1;
            }
          }
          return stream;
        }, close: (stream) => {
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if (stream.getdents)
            stream.getdents = null;
          try {
            if (stream.stream_ops.close) {
              stream.stream_ops.close(stream);
            }
          } catch (e) {
            throw e;
          } finally {
            FS.closeStream(stream.fd);
          }
          stream.fd = null;
        }, isClosed: (stream) => {
          return stream.fd === null;
        }, llseek: (stream, offset, whence) => {
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if (!stream.seekable || !stream.stream_ops.llseek) {
            throw new FS.ErrnoError(70);
          }
          if (whence != 0 && whence != 1 && whence != 2) {
            throw new FS.ErrnoError(28);
          }
          stream.position = stream.stream_ops.llseek(stream, offset, whence);
          stream.ungotten = [];
          return stream.position;
        }, read: (stream, buffer, offset, length, position) => {
          offset >>>= 0;
          if (length < 0 || position < 0) {
            throw new FS.ErrnoError(28);
          }
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if ((stream.flags & 2097155) === 1) {
            throw new FS.ErrnoError(8);
          }
          if (FS.isDir(stream.node.mode)) {
            throw new FS.ErrnoError(31);
          }
          if (!stream.stream_ops.read) {
            throw new FS.ErrnoError(28);
          }
          var seeking = typeof position != "undefined";
          if (!seeking) {
            position = stream.position;
          } else if (!stream.seekable) {
            throw new FS.ErrnoError(70);
          }
          var bytesRead = stream.stream_ops.read(stream, buffer, offset, length, position);
          if (!seeking)
            stream.position += bytesRead;
          return bytesRead;
        }, write: (stream, buffer, offset, length, position, canOwn) => {
          offset >>>= 0;
          if (length < 0 || position < 0) {
            throw new FS.ErrnoError(28);
          }
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if ((stream.flags & 2097155) === 0) {
            throw new FS.ErrnoError(8);
          }
          if (FS.isDir(stream.node.mode)) {
            throw new FS.ErrnoError(31);
          }
          if (!stream.stream_ops.write) {
            throw new FS.ErrnoError(28);
          }
          if (stream.seekable && stream.flags & 1024) {
            FS.llseek(stream, 0, 2);
          }
          var seeking = typeof position != "undefined";
          if (!seeking) {
            position = stream.position;
          } else if (!stream.seekable) {
            throw new FS.ErrnoError(70);
          }
          var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length, position, canOwn);
          if (!seeking)
            stream.position += bytesWritten;
          return bytesWritten;
        }, allocate: (stream, offset, length) => {
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if (offset < 0 || length <= 0) {
            throw new FS.ErrnoError(28);
          }
          if ((stream.flags & 2097155) === 0) {
            throw new FS.ErrnoError(8);
          }
          if (!FS.isFile(stream.node.mode) && !FS.isDir(stream.node.mode)) {
            throw new FS.ErrnoError(43);
          }
          if (!stream.stream_ops.allocate) {
            throw new FS.ErrnoError(138);
          }
          stream.stream_ops.allocate(stream, offset, length);
        }, mmap: (stream, length, position, prot, flags) => {
          if ((prot & 2) !== 0 && (flags & 2) === 0 && (stream.flags & 2097155) !== 2) {
            throw new FS.ErrnoError(2);
          }
          if ((stream.flags & 2097155) === 1) {
            throw new FS.ErrnoError(2);
          }
          if (!stream.stream_ops.mmap) {
            throw new FS.ErrnoError(43);
          }
          return stream.stream_ops.mmap(stream, length, position, prot, flags);
        }, msync: (stream, buffer, offset, length, mmapFlags) => {
          offset >>>= 0;
          if (!stream.stream_ops.msync) {
            return 0;
          }
          return stream.stream_ops.msync(stream, buffer, offset, length, mmapFlags);
        }, munmap: (stream) => 0, ioctl: (stream, cmd, arg) => {
          if (!stream.stream_ops.ioctl) {
            throw new FS.ErrnoError(59);
          }
          return stream.stream_ops.ioctl(stream, cmd, arg);
        }, readFile: (path, opts = {}) => {
          opts.flags = opts.flags || 0;
          opts.encoding = opts.encoding || "binary";
          if (opts.encoding !== "utf8" && opts.encoding !== "binary") {
            throw new Error('Invalid encoding type "' + opts.encoding + '"');
          }
          var ret;
          var stream = FS.open(path, opts.flags);
          var stat = FS.stat(path);
          var length = stat.size;
          var buf = new Uint8Array(length);
          FS.read(stream, buf, 0, length, 0);
          if (opts.encoding === "utf8") {
            ret = UTF8ArrayToString(buf, 0);
          } else if (opts.encoding === "binary") {
            ret = buf;
          }
          FS.close(stream);
          return ret;
        }, writeFile: (path, data, opts = {}) => {
          opts.flags = opts.flags || 577;
          var stream = FS.open(path, opts.flags, opts.mode);
          if (typeof data == "string") {
            var buf = new Uint8Array(lengthBytesUTF8(data) + 1);
            var actualNumBytes = stringToUTF8Array(data, buf, 0, buf.length);
            FS.write(stream, buf, 0, actualNumBytes, void 0, opts.canOwn);
          } else if (ArrayBuffer.isView(data)) {
            FS.write(stream, data, 0, data.byteLength, void 0, opts.canOwn);
          } else {
            throw new Error("Unsupported data type");
          }
          FS.close(stream);
        }, cwd: () => FS.currentPath, chdir: (path) => {
          var lookup = FS.lookupPath(path, { follow: true });
          if (lookup.node === null) {
            throw new FS.ErrnoError(44);
          }
          if (!FS.isDir(lookup.node.mode)) {
            throw new FS.ErrnoError(54);
          }
          var errCode = FS.nodePermissions(lookup.node, "x");
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          FS.currentPath = lookup.path;
        }, createDefaultDirectories: () => {
          FS.mkdir("/tmp");
          FS.mkdir("/home");
          FS.mkdir("/home/web_user");
        }, createDefaultDevices: () => {
          FS.mkdir("/dev");
          FS.registerDevice(FS.makedev(1, 3), { read: () => 0, write: (stream, buffer, offset, length, pos) => length });
          FS.mkdev("/dev/null", FS.makedev(1, 3));
          TTY.register(FS.makedev(5, 0), TTY.default_tty_ops);
          TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops);
          FS.mkdev("/dev/tty", FS.makedev(5, 0));
          FS.mkdev("/dev/tty1", FS.makedev(6, 0));
          var random_device = getRandomDevice();
          FS.createDevice("/dev", "random", random_device);
          FS.createDevice("/dev", "urandom", random_device);
          FS.mkdir("/dev/shm");
          FS.mkdir("/dev/shm/tmp");
        }, createSpecialDirectories: () => {
          FS.mkdir("/proc");
          var proc_self = FS.mkdir("/proc/self");
          FS.mkdir("/proc/self/fd");
          FS.mount({ mount: () => {
            var node = FS.createNode(proc_self, "fd", 16384 | 511, 73);
            node.node_ops = { lookup: (parent, name) => {
              var fd = +name;
              var stream = FS.getStream(fd);
              if (!stream)
                throw new FS.ErrnoError(8);
              var ret = { parent: null, mount: { mountpoint: "fake" }, node_ops: { readlink: () => stream.path } };
              ret.parent = ret;
              return ret;
            } };
            return node;
          } }, {}, "/proc/self/fd");
        }, createStandardStreams: () => {
          if (Module["stdin"]) {
            FS.createDevice("/dev", "stdin", Module["stdin"]);
          } else {
            FS.symlink("/dev/tty", "/dev/stdin");
          }
          if (Module["stdout"]) {
            FS.createDevice("/dev", "stdout", null, Module["stdout"]);
          } else {
            FS.symlink("/dev/tty", "/dev/stdout");
          }
          if (Module["stderr"]) {
            FS.createDevice("/dev", "stderr", null, Module["stderr"]);
          } else {
            FS.symlink("/dev/tty1", "/dev/stderr");
          }
          var stdin = FS.open("/dev/stdin", 0);
          var stdout = FS.open("/dev/stdout", 1);
          var stderr = FS.open("/dev/stderr", 1);
        }, ensureErrnoError: () => {
          if (FS.ErrnoError)
            return;
          FS.ErrnoError = function ErrnoError(errno, node) {
            this.node = node;
            this.setErrno = function(errno2) {
              this.errno = errno2;
            };
            this.setErrno(errno);
            this.message = "FS error";
          };
          FS.ErrnoError.prototype = new Error();
          FS.ErrnoError.prototype.constructor = FS.ErrnoError;
          [44].forEach((code) => {
            FS.genericErrors[code] = new FS.ErrnoError(code);
            FS.genericErrors[code].stack = "<generic error, no stack>";
          });
        }, staticInit: () => {
          FS.ensureErrnoError();
          FS.nameTable = new Array(4096);
          FS.mount(MEMFS, {}, "/");
          FS.createDefaultDirectories();
          FS.createDefaultDevices();
          FS.createSpecialDirectories();
          FS.filesystems = { "MEMFS": MEMFS };
        }, init: (input, output, error) => {
          FS.init.initialized = true;
          FS.ensureErrnoError();
          Module["stdin"] = input || Module["stdin"];
          Module["stdout"] = output || Module["stdout"];
          Module["stderr"] = error || Module["stderr"];
          FS.createStandardStreams();
        }, quit: () => {
          FS.init.initialized = false;
          for (var i = 0; i < FS.streams.length; i++) {
            var stream = FS.streams[i];
            if (!stream) {
              continue;
            }
            FS.close(stream);
          }
        }, getMode: (canRead, canWrite) => {
          var mode = 0;
          if (canRead)
            mode |= 292 | 73;
          if (canWrite)
            mode |= 146;
          return mode;
        }, findObject: (path, dontResolveLastLink) => {
          var ret = FS.analyzePath(path, dontResolveLastLink);
          if (!ret.exists) {
            return null;
          }
          return ret.object;
        }, analyzePath: (path, dontResolveLastLink) => {
          try {
            var lookup = FS.lookupPath(path, { follow: !dontResolveLastLink });
            path = lookup.path;
          } catch (e) {
          }
          var ret = { isRoot: false, exists: false, error: 0, name: null, path: null, object: null, parentExists: false, parentPath: null, parentObject: null };
          try {
            var lookup = FS.lookupPath(path, { parent: true });
            ret.parentExists = true;
            ret.parentPath = lookup.path;
            ret.parentObject = lookup.node;
            ret.name = PATH.basename(path);
            lookup = FS.lookupPath(path, { follow: !dontResolveLastLink });
            ret.exists = true;
            ret.path = lookup.path;
            ret.object = lookup.node;
            ret.name = lookup.node.name;
            ret.isRoot = lookup.path === "/";
          } catch (e) {
            ret.error = e.errno;
          }
          return ret;
        }, createPath: (parent, path, canRead, canWrite) => {
          parent = typeof parent == "string" ? parent : FS.getPath(parent);
          var parts = path.split("/").reverse();
          while (parts.length) {
            var part = parts.pop();
            if (!part)
              continue;
            var current = PATH.join2(parent, part);
            try {
              FS.mkdir(current);
            } catch (e) {
            }
            parent = current;
          }
          return current;
        }, createFile: (parent, name, properties, canRead, canWrite) => {
          var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
          var mode = FS.getMode(canRead, canWrite);
          return FS.create(path, mode);
        }, createDataFile: (parent, name, data, canRead, canWrite, canOwn) => {
          var path = name;
          if (parent) {
            parent = typeof parent == "string" ? parent : FS.getPath(parent);
            path = name ? PATH.join2(parent, name) : parent;
          }
          var mode = FS.getMode(canRead, canWrite);
          var node = FS.create(path, mode);
          if (data) {
            if (typeof data == "string") {
              var arr = new Array(data.length);
              for (var i = 0, len = data.length; i < len; ++i)
                arr[i] = data.charCodeAt(i);
              data = arr;
            }
            FS.chmod(node, mode | 146);
            var stream = FS.open(node, 577);
            FS.write(stream, data, 0, data.length, 0, canOwn);
            FS.close(stream);
            FS.chmod(node, mode);
          }
          return node;
        }, createDevice: (parent, name, input, output) => {
          var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
          var mode = FS.getMode(!!input, !!output);
          if (!FS.createDevice.major)
            FS.createDevice.major = 64;
          var dev = FS.makedev(FS.createDevice.major++, 0);
          FS.registerDevice(dev, { open: (stream) => {
            stream.seekable = false;
          }, close: (stream) => {
            if (output && output.buffer && output.buffer.length) {
              output(10);
            }
          }, read: (stream, buffer, offset, length, pos) => {
            var bytesRead = 0;
            for (var i = 0; i < length; i++) {
              var result;
              try {
                result = input();
              } catch (e) {
                throw new FS.ErrnoError(29);
              }
              if (result === void 0 && bytesRead === 0) {
                throw new FS.ErrnoError(6);
              }
              if (result === null || result === void 0)
                break;
              bytesRead++;
              buffer[offset + i] = result;
            }
            if (bytesRead) {
              stream.node.timestamp = Date.now();
            }
            return bytesRead;
          }, write: (stream, buffer, offset, length, pos) => {
            for (var i = 0; i < length; i++) {
              try {
                output(buffer[offset + i]);
              } catch (e) {
                throw new FS.ErrnoError(29);
              }
            }
            if (length) {
              stream.node.timestamp = Date.now();
            }
            return i;
          } });
          return FS.mkdev(path, mode, dev);
        }, forceLoadFile: (obj) => {
          if (obj.isDevice || obj.isFolder || obj.link || obj.contents)
            return true;
          if (typeof XMLHttpRequest != "undefined") {
            throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
          } else if (read_) {
            try {
              obj.contents = intArrayFromString(read_(obj.url), true);
              obj.usedBytes = obj.contents.length;
            } catch (e) {
              throw new FS.ErrnoError(29);
            }
          } else {
            throw new Error("Cannot load without read() or XMLHttpRequest.");
          }
        }, createLazyFile: (parent, name, url, canRead, canWrite) => {
          function LazyUint8Array() {
            this.lengthKnown = false;
            this.chunks = [];
          }
          LazyUint8Array.prototype.get = function LazyUint8Array_get(idx) {
            if (idx > this.length - 1 || idx < 0) {
              return void 0;
            }
            var chunkOffset = idx % this.chunkSize;
            var chunkNum = idx / this.chunkSize | 0;
            return this.getter(chunkNum)[chunkOffset];
          };
          LazyUint8Array.prototype.setDataGetter = function LazyUint8Array_setDataGetter(getter) {
            this.getter = getter;
          };
          LazyUint8Array.prototype.cacheLength = function LazyUint8Array_cacheLength() {
            var xhr = new XMLHttpRequest();
            xhr.open("HEAD", url, false);
            xhr.send(null);
            if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304))
              throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
            var datalength = Number(xhr.getResponseHeader("Content-length"));
            var header;
            var hasByteServing = (header = xhr.getResponseHeader("Accept-Ranges")) && header === "bytes";
            var usesGzip = (header = xhr.getResponseHeader("Content-Encoding")) && header === "gzip";
            var chunkSize = 1024 * 1024;
            if (!hasByteServing)
              chunkSize = datalength;
            var doXHR = (from, to) => {
              if (from > to)
                throw new Error("invalid range (" + from + ", " + to + ") or no bytes requested!");
              if (to > datalength - 1)
                throw new Error("only " + datalength + " bytes available! programmer error!");
              var xhr2 = new XMLHttpRequest();
              xhr2.open("GET", url, false);
              if (datalength !== chunkSize)
                xhr2.setRequestHeader("Range", "bytes=" + from + "-" + to);
              xhr2.responseType = "arraybuffer";
              if (xhr2.overrideMimeType) {
                xhr2.overrideMimeType("text/plain; charset=x-user-defined");
              }
              xhr2.send(null);
              if (!(xhr2.status >= 200 && xhr2.status < 300 || xhr2.status === 304))
                throw new Error("Couldn't load " + url + ". Status: " + xhr2.status);
              if (xhr2.response !== void 0) {
                return new Uint8Array(xhr2.response || []);
              }
              return intArrayFromString(xhr2.responseText || "", true);
            };
            var lazyArray2 = this;
            lazyArray2.setDataGetter((chunkNum) => {
              var start = chunkNum * chunkSize;
              var end = (chunkNum + 1) * chunkSize - 1;
              end = Math.min(end, datalength - 1);
              if (typeof lazyArray2.chunks[chunkNum] == "undefined") {
                lazyArray2.chunks[chunkNum] = doXHR(start, end);
              }
              if (typeof lazyArray2.chunks[chunkNum] == "undefined")
                throw new Error("doXHR failed!");
              return lazyArray2.chunks[chunkNum];
            });
            if (usesGzip || !datalength) {
              chunkSize = datalength = 1;
              datalength = this.getter(0).length;
              chunkSize = datalength;
              out("LazyFiles on gzip forces download of the whole file when length is accessed");
            }
            this._length = datalength;
            this._chunkSize = chunkSize;
            this.lengthKnown = true;
          };
          if (typeof XMLHttpRequest != "undefined") {
            if (!ENVIRONMENT_IS_WORKER)
              throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
            var lazyArray = new LazyUint8Array();
            Object.defineProperties(lazyArray, { length: { get: function() {
              if (!this.lengthKnown) {
                this.cacheLength();
              }
              return this._length;
            } }, chunkSize: { get: function() {
              if (!this.lengthKnown) {
                this.cacheLength();
              }
              return this._chunkSize;
            } } });
            var properties = { isDevice: false, contents: lazyArray };
          } else {
            var properties = { isDevice: false, url };
          }
          var node = FS.createFile(parent, name, properties, canRead, canWrite);
          if (properties.contents) {
            node.contents = properties.contents;
          } else if (properties.url) {
            node.contents = null;
            node.url = properties.url;
          }
          Object.defineProperties(node, { usedBytes: { get: function() {
            return this.contents.length;
          } } });
          var stream_ops = {};
          var keys = Object.keys(node.stream_ops);
          keys.forEach((key) => {
            var fn = node.stream_ops[key];
            stream_ops[key] = function forceLoadLazyFile() {
              FS.forceLoadFile(node);
              return fn.apply(null, arguments);
            };
          });
          function writeChunks(stream, buffer, offset, length, position) {
            var contents = stream.node.contents;
            if (position >= contents.length)
              return 0;
            var size = Math.min(contents.length - position, length);
            if (contents.slice) {
              for (var i = 0; i < size; i++) {
                buffer[offset + i] = contents[position + i];
              }
            } else {
              for (var i = 0; i < size; i++) {
                buffer[offset + i] = contents.get(position + i);
              }
            }
            return size;
          }
          stream_ops.read = (stream, buffer, offset, length, position) => {
            FS.forceLoadFile(node);
            return writeChunks(stream, buffer, offset, length, position);
          };
          stream_ops.mmap = (stream, length, position, prot, flags) => {
            FS.forceLoadFile(node);
            var ptr = mmapAlloc(length);
            if (!ptr) {
              throw new FS.ErrnoError(48);
            }
            writeChunks(stream, GROWABLE_HEAP_I8(), ptr, length, position);
            return { ptr, allocated: true };
          };
          node.stream_ops = stream_ops;
          return node;
        }, createPreloadedFile: (parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish) => {
          var fullname = name ? PATH_FS.resolve(PATH.join2(parent, name)) : parent;
          var dep = getUniqueRunDependency("cp " + fullname);
          function processData(byteArray) {
            function finish(byteArray2) {
              if (preFinish)
                preFinish();
              if (!dontCreateFile) {
                FS.createDataFile(parent, name, byteArray2, canRead, canWrite, canOwn);
              }
              if (onload)
                onload();
              removeRunDependency(dep);
            }
            if (Browser.handledByPreloadPlugin(byteArray, fullname, finish, () => {
              if (onerror)
                onerror();
              removeRunDependency(dep);
            })) {
              return;
            }
            finish(byteArray);
          }
          addRunDependency(dep);
          if (typeof url == "string") {
            asyncLoad(url, (byteArray) => processData(byteArray), onerror);
          } else {
            processData(url);
          }
        }, indexedDB: () => {
          return window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
        }, DB_NAME: () => {
          return "EM_FS_" + window.location.pathname;
        }, DB_VERSION: 20, DB_STORE_NAME: "FILE_DATA", saveFilesToDB: (paths, onload = () => {
        }, onerror = () => {
        }) => {
          var indexedDB = FS.indexedDB();
          try {
            var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
          } catch (e) {
            return onerror(e);
          }
          openRequest.onupgradeneeded = () => {
            out("creating db");
            var db = openRequest.result;
            db.createObjectStore(FS.DB_STORE_NAME);
          };
          openRequest.onsuccess = () => {
            var db = openRequest.result;
            var transaction = db.transaction([FS.DB_STORE_NAME], "readwrite");
            var files = transaction.objectStore(FS.DB_STORE_NAME);
            var ok = 0, fail = 0, total = paths.length;
            function finish() {
              if (fail == 0)
                onload();
              else
                onerror();
            }
            paths.forEach((path) => {
              var putRequest = files.put(FS.analyzePath(path).object.contents, path);
              putRequest.onsuccess = () => {
                ok++;
                if (ok + fail == total)
                  finish();
              };
              putRequest.onerror = () => {
                fail++;
                if (ok + fail == total)
                  finish();
              };
            });
            transaction.onerror = onerror;
          };
          openRequest.onerror = onerror;
        }, loadFilesFromDB: (paths, onload = () => {
        }, onerror = () => {
        }) => {
          var indexedDB = FS.indexedDB();
          try {
            var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
          } catch (e) {
            return onerror(e);
          }
          openRequest.onupgradeneeded = onerror;
          openRequest.onsuccess = () => {
            var db = openRequest.result;
            try {
              var transaction = db.transaction([FS.DB_STORE_NAME], "readonly");
            } catch (e) {
              onerror(e);
              return;
            }
            var files = transaction.objectStore(FS.DB_STORE_NAME);
            var ok = 0, fail = 0, total = paths.length;
            function finish() {
              if (fail == 0)
                onload();
              else
                onerror();
            }
            paths.forEach((path) => {
              var getRequest = files.get(path);
              getRequest.onsuccess = () => {
                if (FS.analyzePath(path).exists) {
                  FS.unlink(path);
                }
                FS.createDataFile(PATH.dirname(path), PATH.basename(path), getRequest.result, true, true, true);
                ok++;
                if (ok + fail == total)
                  finish();
              };
              getRequest.onerror = () => {
                fail++;
                if (ok + fail == total)
                  finish();
              };
            });
            transaction.onerror = onerror;
          };
          openRequest.onerror = onerror;
        } };
        var SYSCALLS = { DEFAULT_POLLMASK: 5, calculateAt: function(dirfd, path, allowEmpty) {
          if (PATH.isAbs(path)) {
            return path;
          }
          var dir;
          if (dirfd === -100) {
            dir = FS.cwd();
          } else {
            var dirstream = SYSCALLS.getStreamFromFD(dirfd);
            dir = dirstream.path;
          }
          if (path.length == 0) {
            if (!allowEmpty) {
              throw new FS.ErrnoError(44);
            }
            return dir;
          }
          return PATH.join2(dir, path);
        }, doStat: function(func, path, buf) {
          try {
            var stat = func(path);
          } catch (e) {
            if (e && e.node && PATH.normalize(path) !== PATH.normalize(FS.getPath(e.node))) {
              return -54;
            }
            throw e;
          }
          GROWABLE_HEAP_I32()[buf >>> 2] = stat.dev;
          GROWABLE_HEAP_I32()[buf + 8 >>> 2] = stat.ino;
          GROWABLE_HEAP_I32()[buf + 12 >>> 2] = stat.mode;
          GROWABLE_HEAP_U32()[buf + 16 >>> 2] = stat.nlink;
          GROWABLE_HEAP_I32()[buf + 20 >>> 2] = stat.uid;
          GROWABLE_HEAP_I32()[buf + 24 >>> 2] = stat.gid;
          GROWABLE_HEAP_I32()[buf + 28 >>> 2] = stat.rdev;
          tempI64 = [stat.size >>> 0, (tempDouble = stat.size, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[buf + 40 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 44 >>> 2] = tempI64[1];
          GROWABLE_HEAP_I32()[buf + 48 >>> 2] = 4096;
          GROWABLE_HEAP_I32()[buf + 52 >>> 2] = stat.blocks;
          var atime = stat.atime.getTime();
          var mtime = stat.mtime.getTime();
          var ctime = stat.ctime.getTime();
          tempI64 = [Math.floor(atime / 1e3) >>> 0, (tempDouble = Math.floor(atime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[buf + 56 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 60 >>> 2] = tempI64[1];
          GROWABLE_HEAP_U32()[buf + 64 >>> 2] = atime % 1e3 * 1e3;
          tempI64 = [Math.floor(mtime / 1e3) >>> 0, (tempDouble = Math.floor(mtime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[buf + 72 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 76 >>> 2] = tempI64[1];
          GROWABLE_HEAP_U32()[buf + 80 >>> 2] = mtime % 1e3 * 1e3;
          tempI64 = [Math.floor(ctime / 1e3) >>> 0, (tempDouble = Math.floor(ctime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[buf + 88 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 92 >>> 2] = tempI64[1];
          GROWABLE_HEAP_U32()[buf + 96 >>> 2] = ctime % 1e3 * 1e3;
          tempI64 = [stat.ino >>> 0, (tempDouble = stat.ino, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[buf + 104 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 108 >>> 2] = tempI64[1];
          return 0;
        }, doMsync: function(addr, stream, len, flags, offset) {
          if (!FS.isFile(stream.node.mode)) {
            throw new FS.ErrnoError(43);
          }
          if (flags & 2) {
            return 0;
          }
          addr >>>= 0;
          var buffer = GROWABLE_HEAP_U8().slice(addr, addr + len);
          FS.msync(stream, buffer, offset, len, flags);
        }, varargs: void 0, get: function() {
          SYSCALLS.varargs += 4;
          var ret = GROWABLE_HEAP_I32()[SYSCALLS.varargs - 4 >>> 2];
          return ret;
        }, getStr: function(ptr) {
          var ret = UTF8ToString(ptr);
          return ret;
        }, getStreamFromFD: function(fd) {
          var stream = FS.getStream(fd);
          if (!stream)
            throw new FS.ErrnoError(8);
          return stream;
        } };
        function _proc_exit(code) {
          if (ENVIRONMENT_IS_PTHREAD)
            return _emscripten_proxy_to_main_thread_js(1, 1, code);
          EXITSTATUS = code;
          if (!keepRuntimeAlive()) {
            PThread.terminateAllThreads();
            if (Module["onExit"])
              Module["onExit"](code);
            ABORT = true;
          }
          quit_(code, new ExitStatus(code));
        }
        function exitJS(status, implicit) {
          EXITSTATUS = status;
          if (!implicit) {
            if (ENVIRONMENT_IS_PTHREAD) {
              exitOnMainThread(status);
              throw "unwind";
            } else {
            }
          }
          _proc_exit(status);
        }
        var _exit = exitJS;
        function handleException(e) {
          if (e instanceof ExitStatus || e == "unwind") {
            return EXITSTATUS;
          }
          quit_(1, e);
        }
        var PThread = { unusedWorkers: [], runningWorkers: [], tlsInitFunctions: [], pthreads: {}, init: function() {
          if (ENVIRONMENT_IS_PTHREAD) {
            PThread.initWorker();
          } else {
            PThread.initMainThread();
          }
        }, initMainThread: function() {
          var pthreadPoolSize = navigator.hardwareConcurrency;
          while (pthreadPoolSize--) {
            PThread.allocateUnusedWorker();
          }
        }, initWorker: function() {
          noExitRuntime = false;
        }, setExitStatus: function(status) {
          EXITSTATUS = status;
        }, terminateAllThreads: function() {
          for (var worker of Object.values(PThread.pthreads)) {
            PThread.returnWorkerToPool(worker);
          }
          for (var worker of PThread.unusedWorkers) {
            worker.terminate();
          }
          PThread.unusedWorkers = [];
        }, returnWorkerToPool: function(worker) {
          var pthread_ptr = worker.pthread_ptr;
          delete PThread.pthreads[pthread_ptr];
          PThread.unusedWorkers.push(worker);
          PThread.runningWorkers.splice(PThread.runningWorkers.indexOf(worker), 1);
          worker.pthread_ptr = 0;
          if (ENVIRONMENT_IS_NODE) {
            worker.unref();
          }
          __emscripten_thread_free_data(pthread_ptr);
        }, receiveObjectTransfer: function(data) {
        }, threadInitTLS: function() {
          PThread.tlsInitFunctions.forEach((f) => f());
        }, loadWasmModuleToWorker: (worker) => new Promise((onFinishedLoading) => {
          worker.onmessage = (e) => {
            var d = e["data"];
            var cmd = d["cmd"];
            if (worker.pthread_ptr)
              PThread.currentProxiedOperationCallerThread = worker.pthread_ptr;
            if (d["targetThread"] && d["targetThread"] != _pthread_self()) {
              var targetWorker = PThread.pthreads[d.targetThread];
              if (targetWorker) {
                targetWorker.postMessage(d, d["transferList"]);
              } else {
                err('Internal error! Worker sent a message "' + cmd + '" to target pthread ' + d["targetThread"] + ", but that thread no longer exists!");
              }
              PThread.currentProxiedOperationCallerThread = void 0;
              return;
            }
            if (cmd === "processProxyingQueue") {
              executeNotifiedProxyingQueue(d["queue"]);
            } else if (cmd === "spawnThread") {
              spawnThread(d);
            } else if (cmd === "cleanupThread") {
              cleanupThread(d["thread"]);
            } else if (cmd === "killThread") {
              killThread(d["thread"]);
            } else if (cmd === "cancelThread") {
              cancelThread(d["thread"]);
            } else if (cmd === "loaded") {
              worker.loaded = true;
              if (ENVIRONMENT_IS_NODE && !worker.pthread_ptr) {
                worker.unref();
              }
              onFinishedLoading(worker);
            } else if (cmd === "print") {
              out("Thread " + d["threadId"] + ": " + d["text"]);
            } else if (cmd === "printErr") {
              err("Thread " + d["threadId"] + ": " + d["text"]);
            } else if (cmd === "alert") {
              alert("Thread " + d["threadId"] + ": " + d["text"]);
            } else if (d.target === "setimmediate") {
              worker.postMessage(d);
            } else if (cmd === "callHandler") {
              Module[d["handler"]](...d["args"]);
            } else if (cmd) {
              err("worker sent an unknown command " + cmd);
            }
            PThread.currentProxiedOperationCallerThread = void 0;
          };
          worker.onerror = (e) => {
            var message = "worker sent an error!";
            err(message + " " + e.filename + ":" + e.lineno + ": " + e.message);
            throw e;
          };
          if (ENVIRONMENT_IS_NODE) {
            worker.on("message", function(data) {
              worker.onmessage({ data });
            });
            worker.on("error", function(e) {
              worker.onerror(e);
            });
            worker.on("detachedExit", function() {
            });
          }
          var handlers = [];
          var knownHandlers = ["onExit", "onAbort", "print", "printErr"];
          for (var handler of knownHandlers) {
            if (Module.hasOwnProperty(handler)) {
              handlers.push(handler);
            }
          }
          worker.postMessage({ "cmd": "load", "handlers": handlers, "urlOrBlob": Module["mainScriptUrlOrBlob"] || _scriptDir, "wasmMemory": wasmMemory, "wasmModule": wasmModule });
        }), loadWasmModuleToAllWorkers: function(onMaybeReady) {
          if (ENVIRONMENT_IS_PTHREAD) {
            return onMaybeReady();
          }
          let pthreadPoolReady = Promise.all(PThread.unusedWorkers.map(PThread.loadWasmModuleToWorker));
          pthreadPoolReady.then(onMaybeReady);
        }, allocateUnusedWorker: function() {
          var worker;
          var pthreadMainJs = locateFile("web-ifc-mt.worker.js");
          worker = new Worker(pthreadMainJs);
          PThread.unusedWorkers.push(worker);
        }, getNewWorker: function() {
          if (PThread.unusedWorkers.length == 0) {
            PThread.allocateUnusedWorker();
            PThread.loadWasmModuleToWorker(PThread.unusedWorkers[0]);
          }
          return PThread.unusedWorkers.pop();
        } };
        Module["PThread"] = PThread;
        function callRuntimeCallbacks(callbacks) {
          while (callbacks.length > 0) {
            callbacks.shift()(Module);
          }
        }
        function establishStackSpace() {
          var pthread_ptr = _pthread_self();
          var stackTop = GROWABLE_HEAP_I32()[pthread_ptr + 52 >>> 2];
          var stackSize = GROWABLE_HEAP_I32()[pthread_ptr + 56 >>> 2];
          var stackMax = stackTop - stackSize;
          _emscripten_stack_set_limits(stackTop, stackMax);
          stackRestore(stackTop);
        }
        Module["establishStackSpace"] = establishStackSpace;
        function exitOnMainThread(returnCode) {
          if (ENVIRONMENT_IS_PTHREAD)
            return _emscripten_proxy_to_main_thread_js(2, 0, returnCode);
          try {
            _exit(returnCode);
          } catch (e) {
            handleException(e);
          }
        }
        var wasmTableMirror = [];
        function getWasmTableEntry(funcPtr) {
          var func = wasmTableMirror[funcPtr];
          if (!func) {
            if (funcPtr >= wasmTableMirror.length)
              wasmTableMirror.length = funcPtr + 1;
            wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);
          }
          return func;
        }
        function invokeEntryPoint(ptr, arg) {
          var result = getWasmTableEntry(ptr)(arg);
          if (keepRuntimeAlive()) {
            PThread.setExitStatus(result);
          } else {
            __emscripten_thread_exit(result);
          }
        }
        Module["invokeEntryPoint"] = invokeEntryPoint;
        function registerTLSInit(tlsInitFunc) {
          PThread.tlsInitFunctions.push(tlsInitFunc);
        }
        function ExceptionInfo(excPtr) {
          this.excPtr = excPtr;
          this.ptr = excPtr - 24;
          this.set_type = function(type) {
            GROWABLE_HEAP_U32()[this.ptr + 4 >>> 2] = type;
          };
          this.get_type = function() {
            return GROWABLE_HEAP_U32()[this.ptr + 4 >>> 2];
          };
          this.set_destructor = function(destructor) {
            GROWABLE_HEAP_U32()[this.ptr + 8 >>> 2] = destructor;
          };
          this.get_destructor = function() {
            return GROWABLE_HEAP_U32()[this.ptr + 8 >>> 2];
          };
          this.set_refcount = function(refcount) {
            GROWABLE_HEAP_I32()[this.ptr >>> 2] = refcount;
          };
          this.set_caught = function(caught) {
            caught = caught ? 1 : 0;
            GROWABLE_HEAP_I8()[this.ptr + 12 >>> 0] = caught;
          };
          this.get_caught = function() {
            return GROWABLE_HEAP_I8()[this.ptr + 12 >>> 0] != 0;
          };
          this.set_rethrown = function(rethrown) {
            rethrown = rethrown ? 1 : 0;
            GROWABLE_HEAP_I8()[this.ptr + 13 >>> 0] = rethrown;
          };
          this.get_rethrown = function() {
            return GROWABLE_HEAP_I8()[this.ptr + 13 >>> 0] != 0;
          };
          this.init = function(type, destructor) {
            this.set_adjusted_ptr(0);
            this.set_type(type);
            this.set_destructor(destructor);
            this.set_refcount(0);
            this.set_caught(false);
            this.set_rethrown(false);
          };
          this.add_ref = function() {
            Atomics.add(GROWABLE_HEAP_I32(), this.ptr + 0 >> 2, 1);
          };
          this.release_ref = function() {
            var prev = Atomics.sub(GROWABLE_HEAP_I32(), this.ptr + 0 >> 2, 1);
            return prev === 1;
          };
          this.set_adjusted_ptr = function(adjustedPtr) {
            GROWABLE_HEAP_U32()[this.ptr + 16 >>> 2] = adjustedPtr;
          };
          this.get_adjusted_ptr = function() {
            return GROWABLE_HEAP_U32()[this.ptr + 16 >>> 2];
          };
          this.get_exception_ptr = function() {
            var isPointer = ___cxa_is_pointer_type(this.get_type());
            if (isPointer) {
              return GROWABLE_HEAP_U32()[this.excPtr >>> 2];
            }
            var adjusted = this.get_adjusted_ptr();
            if (adjusted !== 0)
              return adjusted;
            return this.excPtr;
          };
        }
        var exceptionLast = 0;
        var uncaughtExceptionCount = 0;
        function ___cxa_throw(ptr, type, destructor) {
          var info = new ExceptionInfo(ptr);
          info.init(type, destructor);
          exceptionLast = ptr;
          uncaughtExceptionCount++;
          throw ptr;
        }
        function ___emscripten_init_main_thread_js(tb) {
          __emscripten_thread_init(tb, !ENVIRONMENT_IS_WORKER, 1, !ENVIRONMENT_IS_WEB);
          PThread.threadInitTLS();
        }
        function ___emscripten_thread_cleanup(thread) {
          if (!ENVIRONMENT_IS_PTHREAD)
            cleanupThread(thread);
          else
            postMessage({ "cmd": "cleanupThread", "thread": thread });
        }
        function setErrNo(value) {
          GROWABLE_HEAP_I32()[___errno_location() >>> 2] = value;
          return value;
        }
        function ___syscall_fcntl64(fd, cmd, varargs) {
          if (ENVIRONMENT_IS_PTHREAD)
            return _emscripten_proxy_to_main_thread_js(3, 1, fd, cmd, varargs);
          SYSCALLS.varargs = varargs;
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            switch (cmd) {
              case 0: {
                var arg = SYSCALLS.get();
                if (arg < 0) {
                  return -28;
                }
                var newStream;
                newStream = FS.createStream(stream, arg);
                return newStream.fd;
              }
              case 1:
              case 2:
                return 0;
              case 3:
                return stream.flags;
              case 4: {
                var arg = SYSCALLS.get();
                stream.flags |= arg;
                return 0;
              }
              case 5: {
                var arg = SYSCALLS.get();
                var offset = 0;
                GROWABLE_HEAP_I16()[arg + offset >>> 1] = 2;
                return 0;
              }
              case 6:
              case 7:
                return 0;
              case 16:
              case 8:
                return -28;
              case 9:
                setErrNo(28);
                return -1;
              default: {
                return -28;
              }
            }
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError))
              throw e;
            return -e.errno;
          }
        }
        function ___syscall_ioctl(fd, op, varargs) {
          if (ENVIRONMENT_IS_PTHREAD)
            return _emscripten_proxy_to_main_thread_js(4, 1, fd, op, varargs);
          SYSCALLS.varargs = varargs;
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            switch (op) {
              case 21509:
              case 21505: {
                if (!stream.tty)
                  return -59;
                return 0;
              }
              case 21510:
              case 21511:
              case 21512:
              case 21506:
              case 21507:
              case 21508: {
                if (!stream.tty)
                  return -59;
                return 0;
              }
              case 21519: {
                if (!stream.tty)
                  return -59;
                var argp = SYSCALLS.get();
                GROWABLE_HEAP_I32()[argp >>> 2] = 0;
                return 0;
              }
              case 21520: {
                if (!stream.tty)
                  return -59;
                return -28;
              }
              case 21531: {
                var argp = SYSCALLS.get();
                return FS.ioctl(stream, op, argp);
              }
              case 21523: {
                if (!stream.tty)
                  return -59;
                return 0;
              }
              case 21524: {
                if (!stream.tty)
                  return -59;
                return 0;
              }
              default:
                return -28;
            }
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError))
              throw e;
            return -e.errno;
          }
        }
        function ___syscall_openat(dirfd, path, flags, varargs) {
          if (ENVIRONMENT_IS_PTHREAD)
            return _emscripten_proxy_to_main_thread_js(5, 1, dirfd, path, flags, varargs);
          SYSCALLS.varargs = varargs;
          try {
            path = SYSCALLS.getStr(path);
            path = SYSCALLS.calculateAt(dirfd, path);
            var mode = varargs ? SYSCALLS.get() : 0;
            return FS.open(path, flags, mode).fd;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError))
              throw e;
            return -e.errno;
          }
        }
        function __dlinit(main_dso_handle) {
        }
        var dlopenMissingError = "To use dlopen, you need enable dynamic linking, see https://github.com/emscripten-core/emscripten/wiki/Linking";
        function __dlopen_js(handle) {
          abort(dlopenMissingError);
        }
        function __dlsym_catchup_js(handle, symbolIndex) {
          abort(dlopenMissingError);
        }
        var tupleRegistrations = {};
        function runDestructors(destructors) {
          while (destructors.length) {
            var ptr = destructors.pop();
            var del = destructors.pop();
            del(ptr);
          }
        }
        function simpleReadValueFromPointer(pointer) {
          return this["fromWireType"](GROWABLE_HEAP_I32()[pointer >>> 2]);
        }
        var awaitingDependencies = {};
        var registeredTypes = {};
        var typeDependencies = {};
        var char_0 = 48;
        var char_9 = 57;
        function makeLegalFunctionName(name) {
          if (name === void 0) {
            return "_unknown";
          }
          name = name.replace(/[^a-zA-Z0-9_]/g, "$");
          var f = name.charCodeAt(0);
          if (f >= char_0 && f <= char_9) {
            return "_" + name;
          }
          return name;
        }
        function createNamedFunction(name, body) {
          name = makeLegalFunctionName(name);
          return new Function("body", "return function " + name + '() {\n    "use strict";    return body.apply(this, arguments);\n};\n')(body);
        }
        function extendError(baseErrorType, errorName) {
          var errorClass = createNamedFunction(errorName, function(message) {
            this.name = errorName;
            this.message = message;
            var stack = new Error(message).stack;
            if (stack !== void 0) {
              this.stack = this.toString() + "\n" + stack.replace(/^Error(:[^\n]*)?\n/, "");
            }
          });
          errorClass.prototype = Object.create(baseErrorType.prototype);
          errorClass.prototype.constructor = errorClass;
          errorClass.prototype.toString = function() {
            if (this.message === void 0) {
              return this.name;
            } else {
              return this.name + ": " + this.message;
            }
          };
          return errorClass;
        }
        var InternalError = void 0;
        function throwInternalError(message) {
          throw new InternalError(message);
        }
        function whenDependentTypesAreResolved(myTypes, dependentTypes, getTypeConverters) {
          myTypes.forEach(function(type) {
            typeDependencies[type] = dependentTypes;
          });
          function onComplete(typeConverters2) {
            var myTypeConverters = getTypeConverters(typeConverters2);
            if (myTypeConverters.length !== myTypes.length) {
              throwInternalError("Mismatched type converter count");
            }
            for (var i = 0; i < myTypes.length; ++i) {
              registerType(myTypes[i], myTypeConverters[i]);
            }
          }
          var typeConverters = new Array(dependentTypes.length);
          var unregisteredTypes = [];
          var registered = 0;
          dependentTypes.forEach((dt, i) => {
            if (registeredTypes.hasOwnProperty(dt)) {
              typeConverters[i] = registeredTypes[dt];
            } else {
              unregisteredTypes.push(dt);
              if (!awaitingDependencies.hasOwnProperty(dt)) {
                awaitingDependencies[dt] = [];
              }
              awaitingDependencies[dt].push(() => {
                typeConverters[i] = registeredTypes[dt];
                ++registered;
                if (registered === unregisteredTypes.length) {
                  onComplete(typeConverters);
                }
              });
            }
          });
          if (unregisteredTypes.length === 0) {
            onComplete(typeConverters);
          }
        }
        function __embind_finalize_value_array(rawTupleType) {
          var reg = tupleRegistrations[rawTupleType];
          delete tupleRegistrations[rawTupleType];
          var elements = reg.elements;
          var elementsLength = elements.length;
          var elementTypes = elements.map(function(elt) {
            return elt.getterReturnType;
          }).concat(elements.map(function(elt) {
            return elt.setterArgumentType;
          }));
          var rawConstructor = reg.rawConstructor;
          var rawDestructor = reg.rawDestructor;
          whenDependentTypesAreResolved([rawTupleType], elementTypes, function(elementTypes2) {
            elements.forEach((elt, i) => {
              var getterReturnType = elementTypes2[i];
              var getter = elt.getter;
              var getterContext = elt.getterContext;
              var setterArgumentType = elementTypes2[i + elementsLength];
              var setter = elt.setter;
              var setterContext = elt.setterContext;
              elt.read = (ptr) => {
                return getterReturnType["fromWireType"](getter(getterContext, ptr));
              };
              elt.write = (ptr, o) => {
                var destructors = [];
                setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                runDestructors(destructors);
              };
            });
            return [{ name: reg.name, "fromWireType": function(ptr) {
              var rv = new Array(elementsLength);
              for (var i = 0; i < elementsLength; ++i) {
                rv[i] = elements[i].read(ptr);
              }
              rawDestructor(ptr);
              return rv;
            }, "toWireType": function(destructors, o) {
              if (elementsLength !== o.length) {
                throw new TypeError("Incorrect number of tuple elements for " + reg.name + ": expected=" + elementsLength + ", actual=" + o.length);
              }
              var ptr = rawConstructor();
              for (var i = 0; i < elementsLength; ++i) {
                elements[i].write(ptr, o[i]);
              }
              if (destructors !== null) {
                destructors.push(rawDestructor, ptr);
              }
              return ptr;
            }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: rawDestructor }];
          });
        }
        var structRegistrations = {};
        function __embind_finalize_value_object(structType) {
          var reg = structRegistrations[structType];
          delete structRegistrations[structType];
          var rawConstructor = reg.rawConstructor;
          var rawDestructor = reg.rawDestructor;
          var fieldRecords = reg.fields;
          var fieldTypes = fieldRecords.map((field) => field.getterReturnType).concat(fieldRecords.map((field) => field.setterArgumentType));
          whenDependentTypesAreResolved([structType], fieldTypes, (fieldTypes2) => {
            var fields = {};
            fieldRecords.forEach((field, i) => {
              var fieldName = field.fieldName;
              var getterReturnType = fieldTypes2[i];
              var getter = field.getter;
              var getterContext = field.getterContext;
              var setterArgumentType = fieldTypes2[i + fieldRecords.length];
              var setter = field.setter;
              var setterContext = field.setterContext;
              fields[fieldName] = { read: (ptr) => {
                return getterReturnType["fromWireType"](getter(getterContext, ptr));
              }, write: (ptr, o) => {
                var destructors = [];
                setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                runDestructors(destructors);
              } };
            });
            return [{ name: reg.name, "fromWireType": function(ptr) {
              var rv = {};
              for (var i in fields) {
                rv[i] = fields[i].read(ptr);
              }
              rawDestructor(ptr);
              return rv;
            }, "toWireType": function(destructors, o) {
              for (var fieldName in fields) {
                if (!(fieldName in o)) {
                  throw new TypeError('Missing field:  "' + fieldName + '"');
                }
              }
              var ptr = rawConstructor();
              for (fieldName in fields) {
                fields[fieldName].write(ptr, o[fieldName]);
              }
              if (destructors !== null) {
                destructors.push(rawDestructor, ptr);
              }
              return ptr;
            }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: rawDestructor }];
          });
        }
        function __embind_register_bigint(primitiveType, name, size, minRange, maxRange) {
        }
        function getShiftFromSize(size) {
          switch (size) {
            case 1:
              return 0;
            case 2:
              return 1;
            case 4:
              return 2;
            case 8:
              return 3;
            default:
              throw new TypeError("Unknown type size: " + size);
          }
        }
        function embind_init_charCodes() {
          var codes = new Array(256);
          for (var i = 0; i < 256; ++i) {
            codes[i] = String.fromCharCode(i);
          }
          embind_charCodes = codes;
        }
        var embind_charCodes = void 0;
        function readLatin1String(ptr) {
          var ret = "";
          var c = ptr;
          while (GROWABLE_HEAP_U8()[c >>> 0]) {
            ret += embind_charCodes[GROWABLE_HEAP_U8()[c++ >>> 0]];
          }
          return ret;
        }
        var BindingError = void 0;
        function throwBindingError(message) {
          throw new BindingError(message);
        }
        function registerType(rawType, registeredInstance, options = {}) {
          if (!("argPackAdvance" in registeredInstance)) {
            throw new TypeError("registerType registeredInstance requires argPackAdvance");
          }
          var name = registeredInstance.name;
          if (!rawType) {
            throwBindingError('type "' + name + '" must have a positive integer typeid pointer');
          }
          if (registeredTypes.hasOwnProperty(rawType)) {
            if (options.ignoreDuplicateRegistrations) {
              return;
            } else {
              throwBindingError("Cannot register type '" + name + "' twice");
            }
          }
          registeredTypes[rawType] = registeredInstance;
          delete typeDependencies[rawType];
          if (awaitingDependencies.hasOwnProperty(rawType)) {
            var callbacks = awaitingDependencies[rawType];
            delete awaitingDependencies[rawType];
            callbacks.forEach((cb) => cb());
          }
        }
        function __embind_register_bool(rawType, name, size, trueValue, falseValue) {
          var shift = getShiftFromSize(size);
          name = readLatin1String(name);
          registerType(rawType, { name, "fromWireType": function(wt) {
            return !!wt;
          }, "toWireType": function(destructors, o) {
            return o ? trueValue : falseValue;
          }, "argPackAdvance": 8, "readValueFromPointer": function(pointer) {
            var heap;
            if (size === 1) {
              heap = GROWABLE_HEAP_I8();
            } else if (size === 2) {
              heap = GROWABLE_HEAP_I16();
            } else if (size === 4) {
              heap = GROWABLE_HEAP_I32();
            } else {
              throw new TypeError("Unknown boolean type size: " + name);
            }
            return this["fromWireType"](heap[pointer >>> shift]);
          }, destructorFunction: null });
        }
        function ClassHandle_isAliasOf(other) {
          if (!(this instanceof ClassHandle)) {
            return false;
          }
          if (!(other instanceof ClassHandle)) {
            return false;
          }
          var leftClass = this.$$.ptrType.registeredClass;
          var left = this.$$.ptr;
          var rightClass = other.$$.ptrType.registeredClass;
          var right = other.$$.ptr;
          while (leftClass.baseClass) {
            left = leftClass.upcast(left);
            leftClass = leftClass.baseClass;
          }
          while (rightClass.baseClass) {
            right = rightClass.upcast(right);
            rightClass = rightClass.baseClass;
          }
          return leftClass === rightClass && left === right;
        }
        function shallowCopyInternalPointer(o) {
          return { count: o.count, deleteScheduled: o.deleteScheduled, preservePointerOnDelete: o.preservePointerOnDelete, ptr: o.ptr, ptrType: o.ptrType, smartPtr: o.smartPtr, smartPtrType: o.smartPtrType };
        }
        function throwInstanceAlreadyDeleted(obj) {
          function getInstanceTypeName(handle) {
            return handle.$$.ptrType.registeredClass.name;
          }
          throwBindingError(getInstanceTypeName(obj) + " instance already deleted");
        }
        var finalizationRegistry = false;
        function detachFinalizer(handle) {
        }
        function runDestructor($$) {
          if ($$.smartPtr) {
            $$.smartPtrType.rawDestructor($$.smartPtr);
          } else {
            $$.ptrType.registeredClass.rawDestructor($$.ptr);
          }
        }
        function releaseClassHandle($$) {
          $$.count.value -= 1;
          var toDelete = $$.count.value === 0;
          if (toDelete) {
            runDestructor($$);
          }
        }
        function downcastPointer(ptr, ptrClass, desiredClass) {
          if (ptrClass === desiredClass) {
            return ptr;
          }
          if (desiredClass.baseClass === void 0) {
            return null;
          }
          var rv = downcastPointer(ptr, ptrClass, desiredClass.baseClass);
          if (rv === null) {
            return null;
          }
          return desiredClass.downcast(rv);
        }
        var registeredPointers = {};
        function getInheritedInstanceCount() {
          return Object.keys(registeredInstances).length;
        }
        function getLiveInheritedInstances() {
          var rv = [];
          for (var k in registeredInstances) {
            if (registeredInstances.hasOwnProperty(k)) {
              rv.push(registeredInstances[k]);
            }
          }
          return rv;
        }
        var deletionQueue = [];
        function flushPendingDeletes() {
          while (deletionQueue.length) {
            var obj = deletionQueue.pop();
            obj.$$.deleteScheduled = false;
            obj["delete"]();
          }
        }
        var delayFunction = void 0;
        function setDelayFunction(fn) {
          delayFunction = fn;
          if (deletionQueue.length && delayFunction) {
            delayFunction(flushPendingDeletes);
          }
        }
        function init_embind() {
          Module["getInheritedInstanceCount"] = getInheritedInstanceCount;
          Module["getLiveInheritedInstances"] = getLiveInheritedInstances;
          Module["flushPendingDeletes"] = flushPendingDeletes;
          Module["setDelayFunction"] = setDelayFunction;
        }
        var registeredInstances = {};
        function getBasestPointer(class_, ptr) {
          if (ptr === void 0) {
            throwBindingError("ptr should not be undefined");
          }
          while (class_.baseClass) {
            ptr = class_.upcast(ptr);
            class_ = class_.baseClass;
          }
          return ptr;
        }
        function getInheritedInstance(class_, ptr) {
          ptr = getBasestPointer(class_, ptr);
          return registeredInstances[ptr];
        }
        function makeClassHandle(prototype, record) {
          if (!record.ptrType || !record.ptr) {
            throwInternalError("makeClassHandle requires ptr and ptrType");
          }
          var hasSmartPtrType = !!record.smartPtrType;
          var hasSmartPtr = !!record.smartPtr;
          if (hasSmartPtrType !== hasSmartPtr) {
            throwInternalError("Both smartPtrType and smartPtr must be specified");
          }
          record.count = { value: 1 };
          return attachFinalizer(Object.create(prototype, { $$: { value: record } }));
        }
        function RegisteredPointer_fromWireType(ptr) {
          var rawPointer = this.getPointee(ptr);
          if (!rawPointer) {
            this.destructor(ptr);
            return null;
          }
          var registeredInstance = getInheritedInstance(this.registeredClass, rawPointer);
          if (registeredInstance !== void 0) {
            if (registeredInstance.$$.count.value === 0) {
              registeredInstance.$$.ptr = rawPointer;
              registeredInstance.$$.smartPtr = ptr;
              return registeredInstance["clone"]();
            } else {
              var rv = registeredInstance["clone"]();
              this.destructor(ptr);
              return rv;
            }
          }
          function makeDefaultHandle() {
            if (this.isSmartPointer) {
              return makeClassHandle(this.registeredClass.instancePrototype, { ptrType: this.pointeeType, ptr: rawPointer, smartPtrType: this, smartPtr: ptr });
            } else {
              return makeClassHandle(this.registeredClass.instancePrototype, { ptrType: this, ptr });
            }
          }
          var actualType = this.registeredClass.getActualType(rawPointer);
          var registeredPointerRecord = registeredPointers[actualType];
          if (!registeredPointerRecord) {
            return makeDefaultHandle.call(this);
          }
          var toType;
          if (this.isConst) {
            toType = registeredPointerRecord.constPointerType;
          } else {
            toType = registeredPointerRecord.pointerType;
          }
          var dp = downcastPointer(rawPointer, this.registeredClass, toType.registeredClass);
          if (dp === null) {
            return makeDefaultHandle.call(this);
          }
          if (this.isSmartPointer) {
            return makeClassHandle(toType.registeredClass.instancePrototype, { ptrType: toType, ptr: dp, smartPtrType: this, smartPtr: ptr });
          } else {
            return makeClassHandle(toType.registeredClass.instancePrototype, { ptrType: toType, ptr: dp });
          }
        }
        function attachFinalizer(handle) {
          if (typeof FinalizationRegistry === "undefined") {
            attachFinalizer = (handle2) => handle2;
            return handle;
          }
          finalizationRegistry = new FinalizationRegistry((info) => {
            releaseClassHandle(info.$$);
          });
          attachFinalizer = (handle2) => {
            var $$ = handle2.$$;
            var hasSmartPtr = !!$$.smartPtr;
            if (hasSmartPtr) {
              var info = { $$ };
              finalizationRegistry.register(handle2, info, handle2);
            }
            return handle2;
          };
          detachFinalizer = (handle2) => finalizationRegistry.unregister(handle2);
          return attachFinalizer(handle);
        }
        function ClassHandle_clone() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }
          if (this.$$.preservePointerOnDelete) {
            this.$$.count.value += 1;
            return this;
          } else {
            var clone = attachFinalizer(Object.create(Object.getPrototypeOf(this), { $$: { value: shallowCopyInternalPointer(this.$$) } }));
            clone.$$.count.value += 1;
            clone.$$.deleteScheduled = false;
            return clone;
          }
        }
        function ClassHandle_delete() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }
          if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
            throwBindingError("Object already scheduled for deletion");
          }
          detachFinalizer(this);
          releaseClassHandle(this.$$);
          if (!this.$$.preservePointerOnDelete) {
            this.$$.smartPtr = void 0;
            this.$$.ptr = void 0;
          }
        }
        function ClassHandle_isDeleted() {
          return !this.$$.ptr;
        }
        function ClassHandle_deleteLater() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }
          if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
            throwBindingError("Object already scheduled for deletion");
          }
          deletionQueue.push(this);
          if (deletionQueue.length === 1 && delayFunction) {
            delayFunction(flushPendingDeletes);
          }
          this.$$.deleteScheduled = true;
          return this;
        }
        function init_ClassHandle() {
          ClassHandle.prototype["isAliasOf"] = ClassHandle_isAliasOf;
          ClassHandle.prototype["clone"] = ClassHandle_clone;
          ClassHandle.prototype["delete"] = ClassHandle_delete;
          ClassHandle.prototype["isDeleted"] = ClassHandle_isDeleted;
          ClassHandle.prototype["deleteLater"] = ClassHandle_deleteLater;
        }
        function ClassHandle() {
        }
        function ensureOverloadTable(proto, methodName, humanName) {
          if (proto[methodName].overloadTable === void 0) {
            var prevFunc = proto[methodName];
            proto[methodName] = function() {
              if (!proto[methodName].overloadTable.hasOwnProperty(arguments.length)) {
                throwBindingError("Function '" + humanName + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + proto[methodName].overloadTable + ")!");
              }
              return proto[methodName].overloadTable[arguments.length].apply(this, arguments);
            };
            proto[methodName].overloadTable = [];
            proto[methodName].overloadTable[prevFunc.argCount] = prevFunc;
          }
        }
        function exposePublicSymbol(name, value, numArguments) {
          if (Module.hasOwnProperty(name)) {
            if (numArguments === void 0 || Module[name].overloadTable !== void 0 && Module[name].overloadTable[numArguments] !== void 0) {
              throwBindingError("Cannot register public name '" + name + "' twice");
            }
            ensureOverloadTable(Module, name, name);
            if (Module.hasOwnProperty(numArguments)) {
              throwBindingError("Cannot register multiple overloads of a function with the same number of arguments (" + numArguments + ")!");
            }
            Module[name].overloadTable[numArguments] = value;
          } else {
            Module[name] = value;
            if (numArguments !== void 0) {
              Module[name].numArguments = numArguments;
            }
          }
        }
        function RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast) {
          this.name = name;
          this.constructor = constructor;
          this.instancePrototype = instancePrototype;
          this.rawDestructor = rawDestructor;
          this.baseClass = baseClass;
          this.getActualType = getActualType;
          this.upcast = upcast;
          this.downcast = downcast;
          this.pureVirtualFunctions = [];
        }
        function upcastPointer(ptr, ptrClass, desiredClass) {
          while (ptrClass !== desiredClass) {
            if (!ptrClass.upcast) {
              throwBindingError("Expected null or instance of " + desiredClass.name + ", got an instance of " + ptrClass.name);
            }
            ptr = ptrClass.upcast(ptr);
            ptrClass = ptrClass.baseClass;
          }
          return ptr;
        }
        function constNoSmartPtrRawPointerToWireType(destructors, handle) {
          if (handle === null) {
            if (this.isReference) {
              throwBindingError("null is not a valid " + this.name);
            }
            return 0;
          }
          if (!handle.$$) {
            throwBindingError('Cannot pass "' + embindRepr(handle) + '" as a ' + this.name);
          }
          if (!handle.$$.ptr) {
            throwBindingError("Cannot pass deleted object as a pointer of type " + this.name);
          }
          var handleClass = handle.$$.ptrType.registeredClass;
          var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
          return ptr;
        }
        function genericPointerToWireType(destructors, handle) {
          var ptr;
          if (handle === null) {
            if (this.isReference) {
              throwBindingError("null is not a valid " + this.name);
            }
            if (this.isSmartPointer) {
              ptr = this.rawConstructor();
              if (destructors !== null) {
                destructors.push(this.rawDestructor, ptr);
              }
              return ptr;
            } else {
              return 0;
            }
          }
          if (!handle.$$) {
            throwBindingError('Cannot pass "' + embindRepr(handle) + '" as a ' + this.name);
          }
          if (!handle.$$.ptr) {
            throwBindingError("Cannot pass deleted object as a pointer of type " + this.name);
          }
          if (!this.isConst && handle.$$.ptrType.isConst) {
            throwBindingError("Cannot convert argument of type " + (handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name) + " to parameter type " + this.name);
          }
          var handleClass = handle.$$.ptrType.registeredClass;
          ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
          if (this.isSmartPointer) {
            if (handle.$$.smartPtr === void 0) {
              throwBindingError("Passing raw pointer to smart pointer is illegal");
            }
            switch (this.sharingPolicy) {
              case 0:
                if (handle.$$.smartPtrType === this) {
                  ptr = handle.$$.smartPtr;
                } else {
                  throwBindingError("Cannot convert argument of type " + (handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name) + " to parameter type " + this.name);
                }
                break;
              case 1:
                ptr = handle.$$.smartPtr;
                break;
              case 2:
                if (handle.$$.smartPtrType === this) {
                  ptr = handle.$$.smartPtr;
                } else {
                  var clonedHandle = handle["clone"]();
                  ptr = this.rawShare(ptr, Emval.toHandle(function() {
                    clonedHandle["delete"]();
                  }));
                  if (destructors !== null) {
                    destructors.push(this.rawDestructor, ptr);
                  }
                }
                break;
              default:
                throwBindingError("Unsupporting sharing policy");
            }
          }
          return ptr;
        }
        function nonConstNoSmartPtrRawPointerToWireType(destructors, handle) {
          if (handle === null) {
            if (this.isReference) {
              throwBindingError("null is not a valid " + this.name);
            }
            return 0;
          }
          if (!handle.$$) {
            throwBindingError('Cannot pass "' + embindRepr(handle) + '" as a ' + this.name);
          }
          if (!handle.$$.ptr) {
            throwBindingError("Cannot pass deleted object as a pointer of type " + this.name);
          }
          if (handle.$$.ptrType.isConst) {
            throwBindingError("Cannot convert argument of type " + handle.$$.ptrType.name + " to parameter type " + this.name);
          }
          var handleClass = handle.$$.ptrType.registeredClass;
          var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
          return ptr;
        }
        function RegisteredPointer_getPointee(ptr) {
          if (this.rawGetPointee) {
            ptr = this.rawGetPointee(ptr);
          }
          return ptr;
        }
        function RegisteredPointer_destructor(ptr) {
          if (this.rawDestructor) {
            this.rawDestructor(ptr);
          }
        }
        function RegisteredPointer_deleteObject(handle) {
          if (handle !== null) {
            handle["delete"]();
          }
        }
        function init_RegisteredPointer() {
          RegisteredPointer.prototype.getPointee = RegisteredPointer_getPointee;
          RegisteredPointer.prototype.destructor = RegisteredPointer_destructor;
          RegisteredPointer.prototype["argPackAdvance"] = 8;
          RegisteredPointer.prototype["readValueFromPointer"] = simpleReadValueFromPointer;
          RegisteredPointer.prototype["deleteObject"] = RegisteredPointer_deleteObject;
          RegisteredPointer.prototype["fromWireType"] = RegisteredPointer_fromWireType;
        }
        function RegisteredPointer(name, registeredClass, isReference, isConst, isSmartPointer, pointeeType, sharingPolicy, rawGetPointee, rawConstructor, rawShare, rawDestructor) {
          this.name = name;
          this.registeredClass = registeredClass;
          this.isReference = isReference;
          this.isConst = isConst;
          this.isSmartPointer = isSmartPointer;
          this.pointeeType = pointeeType;
          this.sharingPolicy = sharingPolicy;
          this.rawGetPointee = rawGetPointee;
          this.rawConstructor = rawConstructor;
          this.rawShare = rawShare;
          this.rawDestructor = rawDestructor;
          if (!isSmartPointer && registeredClass.baseClass === void 0) {
            if (isConst) {
              this["toWireType"] = constNoSmartPtrRawPointerToWireType;
              this.destructorFunction = null;
            } else {
              this["toWireType"] = nonConstNoSmartPtrRawPointerToWireType;
              this.destructorFunction = null;
            }
          } else {
            this["toWireType"] = genericPointerToWireType;
          }
        }
        function replacePublicSymbol(name, value, numArguments) {
          if (!Module.hasOwnProperty(name)) {
            throwInternalError("Replacing nonexistant public symbol");
          }
          if (Module[name].overloadTable !== void 0 && numArguments !== void 0) {
            Module[name].overloadTable[numArguments] = value;
          } else {
            Module[name] = value;
            Module[name].argCount = numArguments;
          }
        }
        function dynCallLegacy(sig, ptr, args) {
          var f = Module["dynCall_" + sig];
          return args && args.length ? f.apply(null, [ptr].concat(args)) : f.call(null, ptr);
        }
        function dynCall(sig, ptr, args) {
          if (sig.includes("j")) {
            return dynCallLegacy(sig, ptr, args);
          }
          var rtn = getWasmTableEntry(ptr).apply(null, args);
          return rtn;
        }
        function getDynCaller(sig, ptr) {
          var argCache = [];
          return function() {
            argCache.length = 0;
            Object.assign(argCache, arguments);
            return dynCall(sig, ptr, argCache);
          };
        }
        function embind__requireFunction(signature, rawFunction) {
          signature = readLatin1String(signature);
          function makeDynCaller() {
            if (signature.includes("j")) {
              return getDynCaller(signature, rawFunction);
            }
            return getWasmTableEntry(rawFunction);
          }
          var fp = makeDynCaller();
          if (typeof fp != "function") {
            throwBindingError("unknown function pointer with signature " + signature + ": " + rawFunction);
          }
          return fp;
        }
        var UnboundTypeError = void 0;
        function getTypeName(type) {
          var ptr = ___getTypeName(type);
          var rv = readLatin1String(ptr);
          _free(ptr);
          return rv;
        }
        function throwUnboundTypeError(message, types) {
          var unboundTypes = [];
          var seen = {};
          function visit(type) {
            if (seen[type]) {
              return;
            }
            if (registeredTypes[type]) {
              return;
            }
            if (typeDependencies[type]) {
              typeDependencies[type].forEach(visit);
              return;
            }
            unboundTypes.push(type);
            seen[type] = true;
          }
          types.forEach(visit);
          throw new UnboundTypeError(message + ": " + unboundTypes.map(getTypeName).join([", "]));
        }
        function __embind_register_class(rawType, rawPointerType, rawConstPointerType, baseClassRawType, getActualTypeSignature, getActualType, upcastSignature, upcast, downcastSignature, downcast, name, destructorSignature, rawDestructor) {
          name = readLatin1String(name);
          getActualType = embind__requireFunction(getActualTypeSignature, getActualType);
          if (upcast) {
            upcast = embind__requireFunction(upcastSignature, upcast);
          }
          if (downcast) {
            downcast = embind__requireFunction(downcastSignature, downcast);
          }
          rawDestructor = embind__requireFunction(destructorSignature, rawDestructor);
          var legalFunctionName = makeLegalFunctionName(name);
          exposePublicSymbol(legalFunctionName, function() {
            throwUnboundTypeError("Cannot construct " + name + " due to unbound types", [baseClassRawType]);
          });
          whenDependentTypesAreResolved([rawType, rawPointerType, rawConstPointerType], baseClassRawType ? [baseClassRawType] : [], function(base) {
            base = base[0];
            var baseClass;
            var basePrototype;
            if (baseClassRawType) {
              baseClass = base.registeredClass;
              basePrototype = baseClass.instancePrototype;
            } else {
              basePrototype = ClassHandle.prototype;
            }
            var constructor = createNamedFunction(legalFunctionName, function() {
              if (Object.getPrototypeOf(this) !== instancePrototype) {
                throw new BindingError("Use 'new' to construct " + name);
              }
              if (registeredClass.constructor_body === void 0) {
                throw new BindingError(name + " has no accessible constructor");
              }
              var body = registeredClass.constructor_body[arguments.length];
              if (body === void 0) {
                throw new BindingError("Tried to invoke ctor of " + name + " with invalid number of parameters (" + arguments.length + ") - expected (" + Object.keys(registeredClass.constructor_body).toString() + ") parameters instead!");
              }
              return body.apply(this, arguments);
            });
            var instancePrototype = Object.create(basePrototype, { constructor: { value: constructor } });
            constructor.prototype = instancePrototype;
            var registeredClass = new RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast);
            var referenceConverter = new RegisteredPointer(name, registeredClass, true, false, false);
            var pointerConverter = new RegisteredPointer(name + "*", registeredClass, false, false, false);
            var constPointerConverter = new RegisteredPointer(name + " const*", registeredClass, false, true, false);
            registeredPointers[rawType] = { pointerType: pointerConverter, constPointerType: constPointerConverter };
            replacePublicSymbol(legalFunctionName, constructor);
            return [referenceConverter, pointerConverter, constPointerConverter];
          });
        }
        function heap32VectorToArray(count, firstElement) {
          var array = [];
          for (var i = 0; i < count; i++) {
            array.push(GROWABLE_HEAP_U32()[firstElement + i * 4 >>> 2]);
          }
          return array;
        }
        function new_(constructor, argumentList) {
          if (!(constructor instanceof Function)) {
            throw new TypeError("new_ called with constructor type " + typeof constructor + " which is not a function");
          }
          var dummy = createNamedFunction(constructor.name || "unknownFunctionName", function() {
          });
          dummy.prototype = constructor.prototype;
          var obj = new dummy();
          var r = constructor.apply(obj, argumentList);
          return r instanceof Object ? r : obj;
        }
        function craftInvokerFunction(humanName, argTypes, classType, cppInvokerFunc, cppTargetFunc) {
          var argCount = argTypes.length;
          if (argCount < 2) {
            throwBindingError("argTypes array size mismatch! Must at least get return value and 'this' types!");
          }
          var isClassMethodFunc = argTypes[1] !== null && classType !== null;
          var needsDestructorStack = false;
          for (var i = 1; i < argTypes.length; ++i) {
            if (argTypes[i] !== null && argTypes[i].destructorFunction === void 0) {
              needsDestructorStack = true;
              break;
            }
          }
          var returns = argTypes[0].name !== "void";
          var argsList = "";
          var argsListWired = "";
          for (var i = 0; i < argCount - 2; ++i) {
            argsList += (i !== 0 ? ", " : "") + "arg" + i;
            argsListWired += (i !== 0 ? ", " : "") + "arg" + i + "Wired";
          }
          var invokerFnBody = "return function " + makeLegalFunctionName(humanName) + "(" + argsList + ") {\nif (arguments.length !== " + (argCount - 2) + ") {\nthrowBindingError('function " + humanName + " called with ' + arguments.length + ' arguments, expected " + (argCount - 2) + " args!');\n}\n";
          if (needsDestructorStack) {
            invokerFnBody += "var destructors = [];\n";
          }
          var dtorStack = needsDestructorStack ? "destructors" : "null";
          var args1 = ["throwBindingError", "invoker", "fn", "runDestructors", "retType", "classParam"];
          var args2 = [throwBindingError, cppInvokerFunc, cppTargetFunc, runDestructors, argTypes[0], argTypes[1]];
          if (isClassMethodFunc) {
            invokerFnBody += "var thisWired = classParam.toWireType(" + dtorStack + ", this);\n";
          }
          for (var i = 0; i < argCount - 2; ++i) {
            invokerFnBody += "var arg" + i + "Wired = argType" + i + ".toWireType(" + dtorStack + ", arg" + i + "); // " + argTypes[i + 2].name + "\n";
            args1.push("argType" + i);
            args2.push(argTypes[i + 2]);
          }
          if (isClassMethodFunc) {
            argsListWired = "thisWired" + (argsListWired.length > 0 ? ", " : "") + argsListWired;
          }
          invokerFnBody += (returns ? "var rv = " : "") + "invoker(fn" + (argsListWired.length > 0 ? ", " : "") + argsListWired + ");\n";
          if (needsDestructorStack) {
            invokerFnBody += "runDestructors(destructors);\n";
          } else {
            for (var i = isClassMethodFunc ? 1 : 2; i < argTypes.length; ++i) {
              var paramName = i === 1 ? "thisWired" : "arg" + (i - 2) + "Wired";
              if (argTypes[i].destructorFunction !== null) {
                invokerFnBody += paramName + "_dtor(" + paramName + "); // " + argTypes[i].name + "\n";
                args1.push(paramName + "_dtor");
                args2.push(argTypes[i].destructorFunction);
              }
            }
          }
          if (returns) {
            invokerFnBody += "var ret = retType.fromWireType(rv);\nreturn ret;\n";
          } else {
          }
          invokerFnBody += "}\n";
          args1.push(invokerFnBody);
          var invokerFunction = new_(Function, args1).apply(null, args2);
          return invokerFunction;
        }
        function __embind_register_class_constructor(rawClassType, argCount, rawArgTypesAddr, invokerSignature, invoker, rawConstructor) {
          assert(argCount > 0);
          var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          invoker = embind__requireFunction(invokerSignature, invoker);
          whenDependentTypesAreResolved([], [rawClassType], function(classType) {
            classType = classType[0];
            var humanName = "constructor " + classType.name;
            if (classType.registeredClass.constructor_body === void 0) {
              classType.registeredClass.constructor_body = [];
            }
            if (classType.registeredClass.constructor_body[argCount - 1] !== void 0) {
              throw new BindingError("Cannot register multiple constructors with identical number of parameters (" + (argCount - 1) + ") for class '" + classType.name + "'! Overload resolution is currently only performed using the parameter count, not actual type info!");
            }
            classType.registeredClass.constructor_body[argCount - 1] = () => {
              throwUnboundTypeError("Cannot construct " + classType.name + " due to unbound types", rawArgTypes);
            };
            whenDependentTypesAreResolved([], rawArgTypes, function(argTypes) {
              argTypes.splice(1, 0, null);
              classType.registeredClass.constructor_body[argCount - 1] = craftInvokerFunction(humanName, argTypes, null, invoker, rawConstructor);
              return [];
            });
            return [];
          });
        }
        function __embind_register_class_function(rawClassType, methodName, argCount, rawArgTypesAddr, invokerSignature, rawInvoker, context, isPureVirtual) {
          var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          methodName = readLatin1String(methodName);
          rawInvoker = embind__requireFunction(invokerSignature, rawInvoker);
          whenDependentTypesAreResolved([], [rawClassType], function(classType) {
            classType = classType[0];
            var humanName = classType.name + "." + methodName;
            if (methodName.startsWith("@@")) {
              methodName = Symbol[methodName.substring(2)];
            }
            if (isPureVirtual) {
              classType.registeredClass.pureVirtualFunctions.push(methodName);
            }
            function unboundTypesHandler() {
              throwUnboundTypeError("Cannot call " + humanName + " due to unbound types", rawArgTypes);
            }
            var proto = classType.registeredClass.instancePrototype;
            var method = proto[methodName];
            if (method === void 0 || method.overloadTable === void 0 && method.className !== classType.name && method.argCount === argCount - 2) {
              unboundTypesHandler.argCount = argCount - 2;
              unboundTypesHandler.className = classType.name;
              proto[methodName] = unboundTypesHandler;
            } else {
              ensureOverloadTable(proto, methodName, humanName);
              proto[methodName].overloadTable[argCount - 2] = unboundTypesHandler;
            }
            whenDependentTypesAreResolved([], rawArgTypes, function(argTypes) {
              var memberFunction = craftInvokerFunction(humanName, argTypes, classType, rawInvoker, context);
              if (proto[methodName].overloadTable === void 0) {
                memberFunction.argCount = argCount - 2;
                proto[methodName] = memberFunction;
              } else {
                proto[methodName].overloadTable[argCount - 2] = memberFunction;
              }
              return [];
            });
            return [];
          });
        }
        var emval_free_list = [];
        var emval_handle_array = [{}, { value: void 0 }, { value: null }, { value: true }, { value: false }];
        function __emval_decref(handle) {
          if (handle > 4 && --emval_handle_array[handle].refcount === 0) {
            emval_handle_array[handle] = void 0;
            emval_free_list.push(handle);
          }
        }
        function count_emval_handles() {
          var count = 0;
          for (var i = 5; i < emval_handle_array.length; ++i) {
            if (emval_handle_array[i] !== void 0) {
              ++count;
            }
          }
          return count;
        }
        function get_first_emval() {
          for (var i = 5; i < emval_handle_array.length; ++i) {
            if (emval_handle_array[i] !== void 0) {
              return emval_handle_array[i];
            }
          }
          return null;
        }
        function init_emval() {
          Module["count_emval_handles"] = count_emval_handles;
          Module["get_first_emval"] = get_first_emval;
        }
        var Emval = { toValue: (handle) => {
          if (!handle) {
            throwBindingError("Cannot use deleted val. handle = " + handle);
          }
          return emval_handle_array[handle].value;
        }, toHandle: (value) => {
          switch (value) {
            case void 0:
              return 1;
            case null:
              return 2;
            case true:
              return 3;
            case false:
              return 4;
            default: {
              var handle = emval_free_list.length ? emval_free_list.pop() : emval_handle_array.length;
              emval_handle_array[handle] = { refcount: 1, value };
              return handle;
            }
          }
        } };
        function __embind_register_emval(rawType, name) {
          name = readLatin1String(name);
          registerType(rawType, { name, "fromWireType": function(handle) {
            var rv = Emval.toValue(handle);
            __emval_decref(handle);
            return rv;
          }, "toWireType": function(destructors, value) {
            return Emval.toHandle(value);
          }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: null });
        }
        function enumReadValueFromPointer(name, shift, signed) {
          switch (shift) {
            case 0:
              return function(pointer) {
                var heap = signed ? GROWABLE_HEAP_I8() : GROWABLE_HEAP_U8();
                return this["fromWireType"](heap[pointer >>> 0]);
              };
            case 1:
              return function(pointer) {
                var heap = signed ? GROWABLE_HEAP_I16() : GROWABLE_HEAP_U16();
                return this["fromWireType"](heap[pointer >>> 1]);
              };
            case 2:
              return function(pointer) {
                var heap = signed ? GROWABLE_HEAP_I32() : GROWABLE_HEAP_U32();
                return this["fromWireType"](heap[pointer >>> 2]);
              };
            default:
              throw new TypeError("Unknown integer type: " + name);
          }
        }
        function __embind_register_enum(rawType, name, size, isSigned) {
          var shift = getShiftFromSize(size);
          name = readLatin1String(name);
          function ctor() {
          }
          ctor.values = {};
          registerType(rawType, { name, constructor: ctor, "fromWireType": function(c) {
            return this.constructor.values[c];
          }, "toWireType": function(destructors, c) {
            return c.value;
          }, "argPackAdvance": 8, "readValueFromPointer": enumReadValueFromPointer(name, shift, isSigned), destructorFunction: null });
          exposePublicSymbol(name, ctor);
        }
        function requireRegisteredType(rawType, humanName) {
          var impl = registeredTypes[rawType];
          if (impl === void 0) {
            throwBindingError(humanName + " has unknown type " + getTypeName(rawType));
          }
          return impl;
        }
        function __embind_register_enum_value(rawEnumType, name, enumValue) {
          var enumType = requireRegisteredType(rawEnumType, "enum");
          name = readLatin1String(name);
          var Enum = enumType.constructor;
          var Value = Object.create(enumType.constructor.prototype, { value: { value: enumValue }, constructor: { value: createNamedFunction(enumType.name + "_" + name, function() {
          }) } });
          Enum.values[enumValue] = Value;
          Enum[name] = Value;
        }
        function embindRepr(v) {
          if (v === null) {
            return "null";
          }
          var t = typeof v;
          if (t === "object" || t === "array" || t === "function") {
            return v.toString();
          } else {
            return "" + v;
          }
        }
        function floatReadValueFromPointer(name, shift) {
          switch (shift) {
            case 2:
              return function(pointer) {
                return this["fromWireType"](GROWABLE_HEAP_F32()[pointer >>> 2]);
              };
            case 3:
              return function(pointer) {
                return this["fromWireType"](GROWABLE_HEAP_F64()[pointer >>> 3]);
              };
            default:
              throw new TypeError("Unknown float type: " + name);
          }
        }
        function __embind_register_float(rawType, name, size) {
          var shift = getShiftFromSize(size);
          name = readLatin1String(name);
          registerType(rawType, { name, "fromWireType": function(value) {
            return value;
          }, "toWireType": function(destructors, value) {
            return value;
          }, "argPackAdvance": 8, "readValueFromPointer": floatReadValueFromPointer(name, shift), destructorFunction: null });
        }
        function __embind_register_function(name, argCount, rawArgTypesAddr, signature, rawInvoker, fn) {
          var argTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          name = readLatin1String(name);
          rawInvoker = embind__requireFunction(signature, rawInvoker);
          exposePublicSymbol(name, function() {
            throwUnboundTypeError("Cannot call " + name + " due to unbound types", argTypes);
          }, argCount - 1);
          whenDependentTypesAreResolved([], argTypes, function(argTypes2) {
            var invokerArgsArray = [argTypes2[0], null].concat(argTypes2.slice(1));
            replacePublicSymbol(name, craftInvokerFunction(name, invokerArgsArray, null, rawInvoker, fn), argCount - 1);
            return [];
          });
        }
        function integerReadValueFromPointer(name, shift, signed) {
          switch (shift) {
            case 0:
              return signed ? function readS8FromPointer(pointer) {
                return GROWABLE_HEAP_I8()[pointer >>> 0];
              } : function readU8FromPointer(pointer) {
                return GROWABLE_HEAP_U8()[pointer >>> 0];
              };
            case 1:
              return signed ? function readS16FromPointer(pointer) {
                return GROWABLE_HEAP_I16()[pointer >>> 1];
              } : function readU16FromPointer(pointer) {
                return GROWABLE_HEAP_U16()[pointer >>> 1];
              };
            case 2:
              return signed ? function readS32FromPointer(pointer) {
                return GROWABLE_HEAP_I32()[pointer >>> 2];
              } : function readU32FromPointer(pointer) {
                return GROWABLE_HEAP_U32()[pointer >>> 2];
              };
            default:
              throw new TypeError("Unknown integer type: " + name);
          }
        }
        function __embind_register_integer(primitiveType, name, size, minRange, maxRange) {
          name = readLatin1String(name);
          if (maxRange === -1) {
            maxRange = 4294967295;
          }
          var shift = getShiftFromSize(size);
          var fromWireType = (value) => value;
          if (minRange === 0) {
            var bitshift = 32 - 8 * size;
            fromWireType = (value) => value << bitshift >>> bitshift;
          }
          var isUnsignedType = name.includes("unsigned");
          var checkAssertions = (value, toTypeName) => {
          };
          var toWireType;
          if (isUnsignedType) {
            toWireType = function(destructors, value) {
              checkAssertions(value, this.name);
              return value >>> 0;
            };
          } else {
            toWireType = function(destructors, value) {
              checkAssertions(value, this.name);
              return value;
            };
          }
          registerType(primitiveType, { name, "fromWireType": fromWireType, "toWireType": toWireType, "argPackAdvance": 8, "readValueFromPointer": integerReadValueFromPointer(name, shift, minRange !== 0), destructorFunction: null });
        }
        function __embind_register_memory_view(rawType, dataTypeIndex, name) {
          var typeMapping = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array];
          var TA = typeMapping[dataTypeIndex];
          function decodeMemoryView(handle) {
            handle = handle >> 2;
            var heap = GROWABLE_HEAP_U32();
            var size = heap[handle >>> 0];
            var data = heap[handle + 1 >>> 0];
            return new TA(heap.buffer, data, size);
          }
          name = readLatin1String(name);
          registerType(rawType, { name, "fromWireType": decodeMemoryView, "argPackAdvance": 8, "readValueFromPointer": decodeMemoryView }, { ignoreDuplicateRegistrations: true });
        }
        function __embind_register_std_string(rawType, name) {
          name = readLatin1String(name);
          var stdStringIsUTF8 = name === "std::string";
          registerType(rawType, { name, "fromWireType": function(value) {
            var length = GROWABLE_HEAP_U32()[value >>> 2];
            var payload = value + 4;
            var str;
            if (stdStringIsUTF8) {
              var decodeStartPtr = payload;
              for (var i = 0; i <= length; ++i) {
                var currentBytePtr = payload + i;
                if (i == length || GROWABLE_HEAP_U8()[currentBytePtr >>> 0] == 0) {
                  var maxRead = currentBytePtr - decodeStartPtr;
                  var stringSegment = UTF8ToString(decodeStartPtr, maxRead);
                  if (str === void 0) {
                    str = stringSegment;
                  } else {
                    str += String.fromCharCode(0);
                    str += stringSegment;
                  }
                  decodeStartPtr = currentBytePtr + 1;
                }
              }
            } else {
              var a = new Array(length);
              for (var i = 0; i < length; ++i) {
                a[i] = String.fromCharCode(GROWABLE_HEAP_U8()[payload + i >>> 0]);
              }
              str = a.join("");
            }
            _free(value);
            return str;
          }, "toWireType": function(destructors, value) {
            if (value instanceof ArrayBuffer) {
              value = new Uint8Array(value);
            }
            var length;
            var valueIsOfTypeString = typeof value == "string";
            if (!(valueIsOfTypeString || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Int8Array)) {
              throwBindingError("Cannot pass non-string to std::string");
            }
            if (stdStringIsUTF8 && valueIsOfTypeString) {
              length = lengthBytesUTF8(value);
            } else {
              length = value.length;
            }
            var base = _malloc(4 + length + 1);
            var ptr = base + 4;
            ptr >>>= 0;
            GROWABLE_HEAP_U32()[base >>> 2] = length;
            if (stdStringIsUTF8 && valueIsOfTypeString) {
              stringToUTF8(value, ptr, length + 1);
            } else {
              if (valueIsOfTypeString) {
                for (var i = 0; i < length; ++i) {
                  var charCode = value.charCodeAt(i);
                  if (charCode > 255) {
                    _free(ptr);
                    throwBindingError("String has UTF-16 code units that do not fit in 8 bits");
                  }
                  GROWABLE_HEAP_U8()[ptr + i >>> 0] = charCode;
                }
              } else {
                for (var i = 0; i < length; ++i) {
                  GROWABLE_HEAP_U8()[ptr + i >>> 0] = value[i];
                }
              }
            }
            if (destructors !== null) {
              destructors.push(_free, base);
            }
            return base;
          }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: function(ptr) {
            _free(ptr);
          } });
        }
        var UTF16Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : void 0;
        function UTF16ToString(ptr, maxBytesToRead) {
          var endPtr = ptr;
          var idx = endPtr >> 1;
          var maxIdx = idx + maxBytesToRead / 2;
          while (!(idx >= maxIdx) && GROWABLE_HEAP_U16()[idx >>> 0])
            ++idx;
          endPtr = idx << 1;
          if (endPtr - ptr > 32 && UTF16Decoder)
            return UTF16Decoder.decode(GROWABLE_HEAP_U8().slice(ptr, endPtr));
          var str = "";
          for (var i = 0; !(i >= maxBytesToRead / 2); ++i) {
            var codeUnit = GROWABLE_HEAP_I16()[ptr + i * 2 >>> 1];
            if (codeUnit == 0)
              break;
            str += String.fromCharCode(codeUnit);
          }
          return str;
        }
        function stringToUTF16(str, outPtr, maxBytesToWrite) {
          if (maxBytesToWrite === void 0) {
            maxBytesToWrite = 2147483647;
          }
          if (maxBytesToWrite < 2)
            return 0;
          maxBytesToWrite -= 2;
          var startPtr = outPtr;
          var numCharsToWrite = maxBytesToWrite < str.length * 2 ? maxBytesToWrite / 2 : str.length;
          for (var i = 0; i < numCharsToWrite; ++i) {
            var codeUnit = str.charCodeAt(i);
            GROWABLE_HEAP_I16()[outPtr >>> 1] = codeUnit;
            outPtr += 2;
          }
          GROWABLE_HEAP_I16()[outPtr >>> 1] = 0;
          return outPtr - startPtr;
        }
        function lengthBytesUTF16(str) {
          return str.length * 2;
        }
        function UTF32ToString(ptr, maxBytesToRead) {
          var i = 0;
          var str = "";
          while (!(i >= maxBytesToRead / 4)) {
            var utf32 = GROWABLE_HEAP_I32()[ptr + i * 4 >>> 2];
            if (utf32 == 0)
              break;
            ++i;
            if (utf32 >= 65536) {
              var ch = utf32 - 65536;
              str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
            } else {
              str += String.fromCharCode(utf32);
            }
          }
          return str;
        }
        function stringToUTF32(str, outPtr, maxBytesToWrite) {
          outPtr >>>= 0;
          if (maxBytesToWrite === void 0) {
            maxBytesToWrite = 2147483647;
          }
          if (maxBytesToWrite < 4)
            return 0;
          var startPtr = outPtr;
          var endPtr = startPtr + maxBytesToWrite - 4;
          for (var i = 0; i < str.length; ++i) {
            var codeUnit = str.charCodeAt(i);
            if (codeUnit >= 55296 && codeUnit <= 57343) {
              var trailSurrogate = str.charCodeAt(++i);
              codeUnit = 65536 + ((codeUnit & 1023) << 10) | trailSurrogate & 1023;
            }
            GROWABLE_HEAP_I32()[outPtr >>> 2] = codeUnit;
            outPtr += 4;
            if (outPtr + 4 > endPtr)
              break;
          }
          GROWABLE_HEAP_I32()[outPtr >>> 2] = 0;
          return outPtr - startPtr;
        }
        function lengthBytesUTF32(str) {
          var len = 0;
          for (var i = 0; i < str.length; ++i) {
            var codeUnit = str.charCodeAt(i);
            if (codeUnit >= 55296 && codeUnit <= 57343)
              ++i;
            len += 4;
          }
          return len;
        }
        function __embind_register_std_wstring(rawType, charSize, name) {
          name = readLatin1String(name);
          var decodeString, encodeString, getHeap, lengthBytesUTF, shift;
          if (charSize === 2) {
            decodeString = UTF16ToString;
            encodeString = stringToUTF16;
            lengthBytesUTF = lengthBytesUTF16;
            getHeap = () => GROWABLE_HEAP_U16();
            shift = 1;
          } else if (charSize === 4) {
            decodeString = UTF32ToString;
            encodeString = stringToUTF32;
            lengthBytesUTF = lengthBytesUTF32;
            getHeap = () => GROWABLE_HEAP_U32();
            shift = 2;
          }
          registerType(rawType, { name, "fromWireType": function(value) {
            var length = GROWABLE_HEAP_U32()[value >>> 2];
            var HEAP = getHeap();
            var str;
            var decodeStartPtr = value + 4;
            for (var i = 0; i <= length; ++i) {
              var currentBytePtr = value + 4 + i * charSize;
              if (i == length || HEAP[currentBytePtr >>> shift] == 0) {
                var maxReadBytes = currentBytePtr - decodeStartPtr;
                var stringSegment = decodeString(decodeStartPtr, maxReadBytes);
                if (str === void 0) {
                  str = stringSegment;
                } else {
                  str += String.fromCharCode(0);
                  str += stringSegment;
                }
                decodeStartPtr = currentBytePtr + charSize;
              }
            }
            _free(value);
            return str;
          }, "toWireType": function(destructors, value) {
            if (!(typeof value == "string")) {
              throwBindingError("Cannot pass non-string to C++ string type " + name);
            }
            var length = lengthBytesUTF(value);
            var ptr = _malloc(4 + length + charSize);
            ptr >>>= 0;
            GROWABLE_HEAP_U32()[ptr >>> 2] = length >> shift;
            encodeString(value, ptr + 4, length + charSize);
            if (destructors !== null) {
              destructors.push(_free, ptr);
            }
            return ptr;
          }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: function(ptr) {
            _free(ptr);
          } });
        }
        function __embind_register_value_array(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
          tupleRegistrations[rawType] = { name: readLatin1String(name), rawConstructor: embind__requireFunction(constructorSignature, rawConstructor), rawDestructor: embind__requireFunction(destructorSignature, rawDestructor), elements: [] };
        }
        function __embind_register_value_array_element(rawTupleType, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
          tupleRegistrations[rawTupleType].elements.push({ getterReturnType, getter: embind__requireFunction(getterSignature, getter), getterContext, setterArgumentType, setter: embind__requireFunction(setterSignature, setter), setterContext });
        }
        function __embind_register_value_object(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
          structRegistrations[rawType] = { name: readLatin1String(name), rawConstructor: embind__requireFunction(constructorSignature, rawConstructor), rawDestructor: embind__requireFunction(destructorSignature, rawDestructor), fields: [] };
        }
        function __embind_register_value_object_field(structType, fieldName, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
          structRegistrations[structType].fields.push({ fieldName: readLatin1String(fieldName), getterReturnType, getter: embind__requireFunction(getterSignature, getter), getterContext, setterArgumentType, setter: embind__requireFunction(setterSignature, setter), setterContext });
        }
        function __embind_register_void(rawType, name) {
          name = readLatin1String(name);
          registerType(rawType, { isVoid: true, name, "argPackAdvance": 0, "fromWireType": function() {
            return void 0;
          }, "toWireType": function(destructors, o) {
            return void 0;
          } });
        }
        function __emscripten_err(str) {
          err(UTF8ToString(str));
        }
        function executeNotifiedProxyingQueue(queue) {
          Atomics.store(GROWABLE_HEAP_I32(), queue >> 2, 1);
          if (_pthread_self()) {
            __emscripten_proxy_execute_task_queue(queue);
          }
          Atomics.compareExchange(GROWABLE_HEAP_I32(), queue >> 2, 1, 0);
        }
        Module["executeNotifiedProxyingQueue"] = executeNotifiedProxyingQueue;
        function __emscripten_notify_task_queue(targetThreadId, currThreadId, mainThreadId, queue) {
          if (targetThreadId == currThreadId) {
            setTimeout(() => executeNotifiedProxyingQueue(queue));
          } else if (ENVIRONMENT_IS_PTHREAD) {
            postMessage({ "targetThread": targetThreadId, "cmd": "processProxyingQueue", "queue": queue });
          } else {
            var worker = PThread.pthreads[targetThreadId];
            if (!worker) {
              return;
            }
            worker.postMessage({ "cmd": "processProxyingQueue", "queue": queue });
          }
          return 1;
        }
        function __emscripten_set_offscreencanvas_size(target, width, height) {
          return -1;
        }
        function __emval_as(handle, returnType, destructorsRef) {
          handle = Emval.toValue(handle);
          returnType = requireRegisteredType(returnType, "emval::as");
          var destructors = [];
          var rd = Emval.toHandle(destructors);
          GROWABLE_HEAP_U32()[destructorsRef >>> 2] = rd;
          return returnType["toWireType"](destructors, handle);
        }
        function emval_lookupTypes(argCount, argTypes) {
          var a = new Array(argCount);
          for (var i = 0; i < argCount; ++i) {
            a[i] = requireRegisteredType(GROWABLE_HEAP_U32()[argTypes + i * 4 >>> 2], "parameter " + i);
          }
          return a;
        }
        function __emval_call(handle, argCount, argTypes, argv) {
          handle = Emval.toValue(handle);
          var types = emval_lookupTypes(argCount, argTypes);
          var args = new Array(argCount);
          for (var i = 0; i < argCount; ++i) {
            var type = types[i];
            args[i] = type["readValueFromPointer"](argv);
            argv += type["argPackAdvance"];
          }
          var rv = handle.apply(void 0, args);
          return Emval.toHandle(rv);
        }
        var emval_symbols = {};
        function getStringOrSymbol(address) {
          var symbol = emval_symbols[address];
          if (symbol === void 0) {
            return readLatin1String(address);
          }
          return symbol;
        }
        function emval_get_global() {
          if (typeof globalThis == "object") {
            return globalThis;
          }
          return function() {
            return Function;
          }()("return this")();
        }
        function __emval_get_global(name) {
          if (name === 0) {
            return Emval.toHandle(emval_get_global());
          } else {
            name = getStringOrSymbol(name);
            return Emval.toHandle(emval_get_global()[name]);
          }
        }
        function __emval_get_property(handle, key) {
          handle = Emval.toValue(handle);
          key = Emval.toValue(key);
          return Emval.toHandle(handle[key]);
        }
        function __emval_incref(handle) {
          if (handle > 4) {
            emval_handle_array[handle].refcount += 1;
          }
        }
        function __emval_instanceof(object, constructor) {
          object = Emval.toValue(object);
          constructor = Emval.toValue(constructor);
          return object instanceof constructor;
        }
        function __emval_is_number(handle) {
          handle = Emval.toValue(handle);
          return typeof handle == "number";
        }
        function __emval_new_array() {
          return Emval.toHandle([]);
        }
        function __emval_new_cstring(v) {
          return Emval.toHandle(getStringOrSymbol(v));
        }
        function __emval_new_object() {
          return Emval.toHandle({});
        }
        function __emval_run_destructors(handle) {
          var destructors = Emval.toValue(handle);
          runDestructors(destructors);
          __emval_decref(handle);
        }
        function __emval_set_property(handle, key, value) {
          handle = Emval.toValue(handle);
          key = Emval.toValue(key);
          value = Emval.toValue(value);
          handle[key] = value;
        }
        function __emval_take_value(type, arg) {
          type = requireRegisteredType(type, "_emval_take_value");
          var v = type["readValueFromPointer"](arg);
          return Emval.toHandle(v);
        }
        function _abort() {
          abort("");
        }
        function warnOnce(text) {
          if (!warnOnce.shown)
            warnOnce.shown = {};
          if (!warnOnce.shown[text]) {
            warnOnce.shown[text] = 1;
            if (ENVIRONMENT_IS_NODE)
              text = "warning: " + text;
            err(text);
          }
        }
        function _emscripten_check_blocking_allowed() {
          if (ENVIRONMENT_IS_NODE)
            return;
          if (ENVIRONMENT_IS_WORKER)
            return;
          warnOnce("Blocking on the main thread is very dangerous, see https://emscripten.org/docs/porting/pthreads.html#blocking-on-the-main-browser-thread");
        }
        var _emscripten_get_now;
        if (ENVIRONMENT_IS_NODE) {
          _emscripten_get_now = () => {
            var t = process["hrtime"]();
            return t[0] * 1e3 + t[1] / 1e6;
          };
        } else
          _emscripten_get_now = () => performance.timeOrigin + performance.now();
        function _emscripten_memcpy_big(dest, src, num) {
          GROWABLE_HEAP_U8().copyWithin(dest >>> 0, src >>> 0, src + num >>> 0);
        }
        function withStackSave(f) {
          var stack = stackSave();
          var ret = f();
          stackRestore(stack);
          return ret;
        }
        function _emscripten_proxy_to_main_thread_js(index, sync) {
          var numCallArgs = arguments.length - 2;
          var outerArgs = arguments;
          return withStackSave(() => {
            var serializedNumCallArgs = numCallArgs;
            var args = stackAlloc(serializedNumCallArgs * 8);
            var b = args >> 3;
            for (var i = 0; i < numCallArgs; i++) {
              var arg = outerArgs[2 + i];
              GROWABLE_HEAP_F64()[b + i >>> 0] = arg;
            }
            return _emscripten_run_in_main_runtime_thread_js(index, serializedNumCallArgs, args, sync);
          });
        }
        var _emscripten_receive_on_main_thread_js_callArgs = [];
        function _emscripten_receive_on_main_thread_js(index, numCallArgs, args) {
          _emscripten_receive_on_main_thread_js_callArgs.length = numCallArgs;
          var b = args >> 3;
          for (var i = 0; i < numCallArgs; i++) {
            _emscripten_receive_on_main_thread_js_callArgs[i] = GROWABLE_HEAP_F64()[b + i >>> 0];
          }
          var func = proxiedFunctionTable[index];
          return func.apply(null, _emscripten_receive_on_main_thread_js_callArgs);
        }
        function getHeapMax() {
          return 4294901760;
        }
        function emscripten_realloc_buffer(size) {
          var b = wasmMemory.buffer;
          try {
            wasmMemory.grow(size - b.byteLength + 65535 >>> 16);
            updateMemoryViews();
            return 1;
          } catch (e) {
          }
        }
        function _emscripten_resize_heap(requestedSize) {
          var oldSize = GROWABLE_HEAP_U8().length;
          requestedSize = requestedSize >>> 0;
          if (requestedSize <= oldSize) {
            return false;
          }
          var maxHeapSize = getHeapMax();
          if (requestedSize > maxHeapSize) {
            return false;
          }
          let alignUp = (x, multiple) => x + (multiple - x % multiple) % multiple;
          for (var cutDown = 1; cutDown <= 4; cutDown *= 2) {
            var overGrownHeapSize = oldSize * (1 + 0.2 / cutDown);
            overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
            var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
            var replacement = emscripten_realloc_buffer(newSize);
            if (replacement) {
              return true;
            }
          }
          return false;
        }
        function _emscripten_unwind_to_js_event_loop() {
          throw "unwind";
        }
        var ENV = {};
        function getExecutableName() {
          return thisProgram || "./this.program";
        }
        function getEnvStrings() {
          if (!getEnvStrings.strings) {
            var lang = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8";
            var env = { "USER": "web_user", "LOGNAME": "web_user", "PATH": "/", "PWD": "/", "HOME": "/home/web_user", "LANG": lang, "_": getExecutableName() };
            for (var x in ENV) {
              if (ENV[x] === void 0)
                delete env[x];
              else
                env[x] = ENV[x];
            }
            var strings = [];
            for (var x in env) {
              strings.push(x + "=" + env[x]);
            }
            getEnvStrings.strings = strings;
          }
          return getEnvStrings.strings;
        }
        function writeAsciiToMemory(str, buffer, dontAddNull) {
          for (var i = 0; i < str.length; ++i) {
            GROWABLE_HEAP_I8()[buffer++ >>> 0] = str.charCodeAt(i);
          }
          if (!dontAddNull)
            GROWABLE_HEAP_I8()[buffer >>> 0] = 0;
        }
        function _environ_get(__environ, environ_buf) {
          if (ENVIRONMENT_IS_PTHREAD)
            return _emscripten_proxy_to_main_thread_js(6, 1, __environ, environ_buf);
          var bufSize = 0;
          getEnvStrings().forEach(function(string, i) {
            var ptr = environ_buf + bufSize;
            GROWABLE_HEAP_U32()[__environ + i * 4 >>> 2] = ptr;
            writeAsciiToMemory(string, ptr);
            bufSize += string.length + 1;
          });
          return 0;
        }
        function _environ_sizes_get(penviron_count, penviron_buf_size) {
          if (ENVIRONMENT_IS_PTHREAD)
            return _emscripten_proxy_to_main_thread_js(7, 1, penviron_count, penviron_buf_size);
          var strings = getEnvStrings();
          GROWABLE_HEAP_U32()[penviron_count >>> 2] = strings.length;
          var bufSize = 0;
          strings.forEach(function(string) {
            bufSize += string.length + 1;
          });
          GROWABLE_HEAP_U32()[penviron_buf_size >>> 2] = bufSize;
          return 0;
        }
        function _fd_close(fd) {
          if (ENVIRONMENT_IS_PTHREAD)
            return _emscripten_proxy_to_main_thread_js(8, 1, fd);
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            FS.close(stream);
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError))
              throw e;
            return e.errno;
          }
        }
        function doReadv(stream, iov, iovcnt, offset) {
          var ret = 0;
          for (var i = 0; i < iovcnt; i++) {
            var ptr = GROWABLE_HEAP_U32()[iov >>> 2];
            var len = GROWABLE_HEAP_U32()[iov + 4 >>> 2];
            iov += 8;
            var curr = FS.read(stream, GROWABLE_HEAP_I8(), ptr, len, offset);
            if (curr < 0)
              return -1;
            ret += curr;
            if (curr < len)
              break;
            if (typeof offset !== "undefined") {
              offset += curr;
            }
          }
          return ret;
        }
        function _fd_read(fd, iov, iovcnt, pnum) {
          if (ENVIRONMENT_IS_PTHREAD)
            return _emscripten_proxy_to_main_thread_js(9, 1, fd, iov, iovcnt, pnum);
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            var num = doReadv(stream, iov, iovcnt);
            GROWABLE_HEAP_U32()[pnum >>> 2] = num;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError))
              throw e;
            return e.errno;
          }
        }
        function convertI32PairToI53Checked(lo, hi) {
          return hi + 2097152 >>> 0 < 4194305 - !!lo ? (lo >>> 0) + hi * 4294967296 : NaN;
        }
        function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
          if (ENVIRONMENT_IS_PTHREAD)
            return _emscripten_proxy_to_main_thread_js(10, 1, fd, offset_low, offset_high, whence, newOffset);
          try {
            var offset = convertI32PairToI53Checked(offset_low, offset_high);
            if (isNaN(offset))
              return 61;
            var stream = SYSCALLS.getStreamFromFD(fd);
            FS.llseek(stream, offset, whence);
            tempI64 = [stream.position >>> 0, (tempDouble = stream.position, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[newOffset >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[newOffset + 4 >>> 2] = tempI64[1];
            if (stream.getdents && offset === 0 && whence === 0)
              stream.getdents = null;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError))
              throw e;
            return e.errno;
          }
        }
        function doWritev(stream, iov, iovcnt, offset) {
          var ret = 0;
          for (var i = 0; i < iovcnt; i++) {
            var ptr = GROWABLE_HEAP_U32()[iov >>> 2];
            var len = GROWABLE_HEAP_U32()[iov + 4 >>> 2];
            iov += 8;
            var curr = FS.write(stream, GROWABLE_HEAP_I8(), ptr, len, offset);
            if (curr < 0)
              return -1;
            ret += curr;
            if (typeof offset !== "undefined") {
              offset += curr;
            }
          }
          return ret;
        }
        function _fd_write(fd, iov, iovcnt, pnum) {
          if (ENVIRONMENT_IS_PTHREAD)
            return _emscripten_proxy_to_main_thread_js(11, 1, fd, iov, iovcnt, pnum);
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            var num = doWritev(stream, iov, iovcnt);
            GROWABLE_HEAP_U32()[pnum >>> 2] = num;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError))
              throw e;
            return e.errno;
          }
        }
        function __isLeapYear(year) {
          return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
        }
        function __arraySum(array, index) {
          var sum = 0;
          for (var i = 0; i <= index; sum += array[i++]) {
          }
          return sum;
        }
        var __MONTH_DAYS_LEAP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        var __MONTH_DAYS_REGULAR = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        function __addDays(date, days) {
          var newDate = new Date(date.getTime());
          while (days > 0) {
            var leap = __isLeapYear(newDate.getFullYear());
            var currentMonth = newDate.getMonth();
            var daysInCurrentMonth = (leap ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR)[currentMonth];
            if (days > daysInCurrentMonth - newDate.getDate()) {
              days -= daysInCurrentMonth - newDate.getDate() + 1;
              newDate.setDate(1);
              if (currentMonth < 11) {
                newDate.setMonth(currentMonth + 1);
              } else {
                newDate.setMonth(0);
                newDate.setFullYear(newDate.getFullYear() + 1);
              }
            } else {
              newDate.setDate(newDate.getDate() + days);
              return newDate;
            }
          }
          return newDate;
        }
        function writeArrayToMemory(array, buffer) {
          GROWABLE_HEAP_I8().set(array, buffer >>> 0);
        }
        function _strftime(s, maxsize, format, tm) {
          var tm_zone = GROWABLE_HEAP_I32()[tm + 40 >>> 2];
          var date = { tm_sec: GROWABLE_HEAP_I32()[tm >>> 2], tm_min: GROWABLE_HEAP_I32()[tm + 4 >>> 2], tm_hour: GROWABLE_HEAP_I32()[tm + 8 >>> 2], tm_mday: GROWABLE_HEAP_I32()[tm + 12 >>> 2], tm_mon: GROWABLE_HEAP_I32()[tm + 16 >>> 2], tm_year: GROWABLE_HEAP_I32()[tm + 20 >>> 2], tm_wday: GROWABLE_HEAP_I32()[tm + 24 >>> 2], tm_yday: GROWABLE_HEAP_I32()[tm + 28 >>> 2], tm_isdst: GROWABLE_HEAP_I32()[tm + 32 >>> 2], tm_gmtoff: GROWABLE_HEAP_I32()[tm + 36 >>> 2], tm_zone: tm_zone ? UTF8ToString(tm_zone) : "" };
          var pattern = UTF8ToString(format);
          var EXPANSION_RULES_1 = { "%c": "%a %b %d %H:%M:%S %Y", "%D": "%m/%d/%y", "%F": "%Y-%m-%d", "%h": "%b", "%r": "%I:%M:%S %p", "%R": "%H:%M", "%T": "%H:%M:%S", "%x": "%m/%d/%y", "%X": "%H:%M:%S", "%Ec": "%c", "%EC": "%C", "%Ex": "%m/%d/%y", "%EX": "%H:%M:%S", "%Ey": "%y", "%EY": "%Y", "%Od": "%d", "%Oe": "%e", "%OH": "%H", "%OI": "%I", "%Om": "%m", "%OM": "%M", "%OS": "%S", "%Ou": "%u", "%OU": "%U", "%OV": "%V", "%Ow": "%w", "%OW": "%W", "%Oy": "%y" };
          for (var rule in EXPANSION_RULES_1) {
            pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_1[rule]);
          }
          var WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
          var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          function leadingSomething(value, digits, character) {
            var str = typeof value == "number" ? value.toString() : value || "";
            while (str.length < digits) {
              str = character[0] + str;
            }
            return str;
          }
          function leadingNulls(value, digits) {
            return leadingSomething(value, digits, "0");
          }
          function compareByDay(date1, date2) {
            function sgn(value) {
              return value < 0 ? -1 : value > 0 ? 1 : 0;
            }
            var compare;
            if ((compare = sgn(date1.getFullYear() - date2.getFullYear())) === 0) {
              if ((compare = sgn(date1.getMonth() - date2.getMonth())) === 0) {
                compare = sgn(date1.getDate() - date2.getDate());
              }
            }
            return compare;
          }
          function getFirstWeekStartDate(janFourth) {
            switch (janFourth.getDay()) {
              case 0:
                return new Date(janFourth.getFullYear() - 1, 11, 29);
              case 1:
                return janFourth;
              case 2:
                return new Date(janFourth.getFullYear(), 0, 3);
              case 3:
                return new Date(janFourth.getFullYear(), 0, 2);
              case 4:
                return new Date(janFourth.getFullYear(), 0, 1);
              case 5:
                return new Date(janFourth.getFullYear() - 1, 11, 31);
              case 6:
                return new Date(janFourth.getFullYear() - 1, 11, 30);
            }
          }
          function getWeekBasedYear(date2) {
            var thisDate = __addDays(new Date(date2.tm_year + 1900, 0, 1), date2.tm_yday);
            var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4);
            var janFourthNextYear = new Date(thisDate.getFullYear() + 1, 0, 4);
            var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
            var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);
            if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {
              if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) {
                return thisDate.getFullYear() + 1;
              }
              return thisDate.getFullYear();
            }
            return thisDate.getFullYear() - 1;
          }
          var EXPANSION_RULES_2 = { "%a": function(date2) {
            return WEEKDAYS[date2.tm_wday].substring(0, 3);
          }, "%A": function(date2) {
            return WEEKDAYS[date2.tm_wday];
          }, "%b": function(date2) {
            return MONTHS[date2.tm_mon].substring(0, 3);
          }, "%B": function(date2) {
            return MONTHS[date2.tm_mon];
          }, "%C": function(date2) {
            var year = date2.tm_year + 1900;
            return leadingNulls(year / 100 | 0, 2);
          }, "%d": function(date2) {
            return leadingNulls(date2.tm_mday, 2);
          }, "%e": function(date2) {
            return leadingSomething(date2.tm_mday, 2, " ");
          }, "%g": function(date2) {
            return getWeekBasedYear(date2).toString().substring(2);
          }, "%G": function(date2) {
            return getWeekBasedYear(date2);
          }, "%H": function(date2) {
            return leadingNulls(date2.tm_hour, 2);
          }, "%I": function(date2) {
            var twelveHour = date2.tm_hour;
            if (twelveHour == 0)
              twelveHour = 12;
            else if (twelveHour > 12)
              twelveHour -= 12;
            return leadingNulls(twelveHour, 2);
          }, "%j": function(date2) {
            return leadingNulls(date2.tm_mday + __arraySum(__isLeapYear(date2.tm_year + 1900) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, date2.tm_mon - 1), 3);
          }, "%m": function(date2) {
            return leadingNulls(date2.tm_mon + 1, 2);
          }, "%M": function(date2) {
            return leadingNulls(date2.tm_min, 2);
          }, "%n": function() {
            return "\n";
          }, "%p": function(date2) {
            if (date2.tm_hour >= 0 && date2.tm_hour < 12) {
              return "AM";
            }
            return "PM";
          }, "%S": function(date2) {
            return leadingNulls(date2.tm_sec, 2);
          }, "%t": function() {
            return "	";
          }, "%u": function(date2) {
            return date2.tm_wday || 7;
          }, "%U": function(date2) {
            var days = date2.tm_yday + 7 - date2.tm_wday;
            return leadingNulls(Math.floor(days / 7), 2);
          }, "%V": function(date2) {
            var val = Math.floor((date2.tm_yday + 7 - (date2.tm_wday + 6) % 7) / 7);
            if ((date2.tm_wday + 371 - date2.tm_yday - 2) % 7 <= 2) {
              val++;
            }
            if (!val) {
              val = 52;
              var dec31 = (date2.tm_wday + 7 - date2.tm_yday - 1) % 7;
              if (dec31 == 4 || dec31 == 5 && __isLeapYear(date2.tm_year % 400 - 1)) {
                val++;
              }
            } else if (val == 53) {
              var jan1 = (date2.tm_wday + 371 - date2.tm_yday) % 7;
              if (jan1 != 4 && (jan1 != 3 || !__isLeapYear(date2.tm_year)))
                val = 1;
            }
            return leadingNulls(val, 2);
          }, "%w": function(date2) {
            return date2.tm_wday;
          }, "%W": function(date2) {
            var days = date2.tm_yday + 7 - (date2.tm_wday + 6) % 7;
            return leadingNulls(Math.floor(days / 7), 2);
          }, "%y": function(date2) {
            return (date2.tm_year + 1900).toString().substring(2);
          }, "%Y": function(date2) {
            return date2.tm_year + 1900;
          }, "%z": function(date2) {
            var off = date2.tm_gmtoff;
            var ahead = off >= 0;
            off = Math.abs(off) / 60;
            off = off / 60 * 100 + off % 60;
            return (ahead ? "+" : "-") + String("0000" + off).slice(-4);
          }, "%Z": function(date2) {
            return date2.tm_zone;
          }, "%%": function() {
            return "%";
          } };
          pattern = pattern.replace(/%%/g, "\0\0");
          for (var rule in EXPANSION_RULES_2) {
            if (pattern.includes(rule)) {
              pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_2[rule](date));
            }
          }
          pattern = pattern.replace(/\0\0/g, "%");
          var bytes = intArrayFromString(pattern, false);
          if (bytes.length > maxsize) {
            return 0;
          }
          writeArrayToMemory(bytes, s);
          return bytes.length - 1;
        }
        function _strftime_l(s, maxsize, format, tm, loc) {
          return _strftime(s, maxsize, format, tm);
        }
        PThread.init();
        var FSNode = function(parent, name, mode, rdev) {
          if (!parent) {
            parent = this;
          }
          this.parent = parent;
          this.mount = parent.mount;
          this.mounted = null;
          this.id = FS.nextInode++;
          this.name = name;
          this.mode = mode;
          this.node_ops = {};
          this.stream_ops = {};
          this.rdev = rdev;
        };
        var readMode = 292 | 73;
        var writeMode = 146;
        Object.defineProperties(FSNode.prototype, { read: { get: function() {
          return (this.mode & readMode) === readMode;
        }, set: function(val) {
          val ? this.mode |= readMode : this.mode &= ~readMode;
        } }, write: { get: function() {
          return (this.mode & writeMode) === writeMode;
        }, set: function(val) {
          val ? this.mode |= writeMode : this.mode &= ~writeMode;
        } }, isFolder: { get: function() {
          return FS.isDir(this.mode);
        } }, isDevice: { get: function() {
          return FS.isChrdev(this.mode);
        } } });
        FS.FSNode = FSNode;
        FS.staticInit();
        InternalError = Module["InternalError"] = extendError(Error, "InternalError");
        embind_init_charCodes();
        BindingError = Module["BindingError"] = extendError(Error, "BindingError");
        init_ClassHandle();
        init_embind();
        init_RegisteredPointer();
        UnboundTypeError = Module["UnboundTypeError"] = extendError(Error, "UnboundTypeError");
        init_emval();
        var proxiedFunctionTable = [null, _proc_exit, exitOnMainThread, ___syscall_fcntl64, ___syscall_ioctl, ___syscall_openat, _environ_get, _environ_sizes_get, _fd_close, _fd_read, _fd_seek, _fd_write];
        var wasmImports = { "f": ___cxa_throw, "V": ___emscripten_init_main_thread_js, "K": ___emscripten_thread_cleanup, "B": ___syscall_fcntl64, "P": ___syscall_ioctl, "Q": ___syscall_openat, "Z": __dlinit, "aa": __dlopen_js, "$": __dlsym_catchup_js, "fa": __embind_finalize_value_array, "u": __embind_finalize_value_object, "I": __embind_register_bigint, "da": __embind_register_bool, "t": __embind_register_class, "s": __embind_register_class_constructor, "d": __embind_register_class_function, "ca": __embind_register_emval, "F": __embind_register_enum, "q": __embind_register_enum_value, "D": __embind_register_float, "c": __embind_register_function, "p": __embind_register_integer, "i": __embind_register_memory_view, "E": __embind_register_std_string, "x": __embind_register_std_wstring, "ga": __embind_register_value_array, "k": __embind_register_value_array_element, "v": __embind_register_value_object, "h": __embind_register_value_object_field, "ea": __embind_register_void, "_": __emscripten_err, "X": __emscripten_notify_task_queue, "U": __emscripten_set_offscreencanvas_size, "m": __emval_as, "z": __emval_call, "b": __emval_decref, "G": __emval_get_global, "n": __emval_get_property, "o": __emval_incref, "ia": __emval_instanceof, "ha": __emval_is_number, "y": __emval_new_array, "g": __emval_new_cstring, "w": __emval_new_object, "l": __emval_run_destructors, "j": __emval_set_property, "e": __emval_take_value, "C": _abort, "W": _emscripten_check_blocking_allowed, "r": _emscripten_get_now, "Y": _emscripten_memcpy_big, "T": _emscripten_receive_on_main_thread_js, "R": _emscripten_resize_heap, "ba": _emscripten_unwind_to_js_event_loop, "M": _environ_get, "N": _environ_sizes_get, "J": _exit, "A": _fd_close, "O": _fd_read, "H": _fd_seek, "S": _fd_write, "a": wasmMemory || Module["wasmMemory"], "L": _strftime_l };
        var asm = createWasm();
        var ___wasm_call_ctors = function() {
          return (___wasm_call_ctors = Module["asm"]["ja"]).apply(null, arguments);
        };
        var _malloc = function() {
          return (_malloc = Module["asm"]["la"]).apply(null, arguments);
        };
        var __emscripten_tls_init = Module["__emscripten_tls_init"] = function() {
          return (__emscripten_tls_init = Module["__emscripten_tls_init"] = Module["asm"]["ma"]).apply(null, arguments);
        };
        var _pthread_self = Module["_pthread_self"] = function() {
          return (_pthread_self = Module["_pthread_self"] = Module["asm"]["na"]).apply(null, arguments);
        };
        var ___getTypeName = Module["___getTypeName"] = function() {
          return (___getTypeName = Module["___getTypeName"] = Module["asm"]["oa"]).apply(null, arguments);
        };
        var __embind_initialize_bindings = Module["__embind_initialize_bindings"] = function() {
          return (__embind_initialize_bindings = Module["__embind_initialize_bindings"] = Module["asm"]["pa"]).apply(null, arguments);
        };
        var ___errno_location = function() {
          return (___errno_location = Module["asm"]["qa"]).apply(null, arguments);
        };
        var __emscripten_thread_init = Module["__emscripten_thread_init"] = function() {
          return (__emscripten_thread_init = Module["__emscripten_thread_init"] = Module["asm"]["ra"]).apply(null, arguments);
        };
        var __emscripten_thread_crashed = Module["__emscripten_thread_crashed"] = function() {
          return (__emscripten_thread_crashed = Module["__emscripten_thread_crashed"] = Module["asm"]["sa"]).apply(null, arguments);
        };
        var _emscripten_main_browser_thread_id = function() {
          return (_emscripten_main_browser_thread_id = Module["asm"]["emscripten_main_browser_thread_id"]).apply(null, arguments);
        };
        var _emscripten_main_thread_process_queued_calls = function() {
          return (_emscripten_main_thread_process_queued_calls = Module["asm"]["emscripten_main_thread_process_queued_calls"]).apply(null, arguments);
        };
        var _emscripten_run_in_main_runtime_thread_js = function() {
          return (_emscripten_run_in_main_runtime_thread_js = Module["asm"]["ta"]).apply(null, arguments);
        };
        var _emscripten_dispatch_to_thread_ = function() {
          return (_emscripten_dispatch_to_thread_ = Module["asm"]["emscripten_dispatch_to_thread_"]).apply(null, arguments);
        };
        var __emscripten_proxy_execute_task_queue = Module["__emscripten_proxy_execute_task_queue"] = function() {
          return (__emscripten_proxy_execute_task_queue = Module["__emscripten_proxy_execute_task_queue"] = Module["asm"]["ua"]).apply(null, arguments);
        };
        var __emscripten_thread_free_data = function() {
          return (__emscripten_thread_free_data = Module["asm"]["va"]).apply(null, arguments);
        };
        var __emscripten_thread_exit = Module["__emscripten_thread_exit"] = function() {
          return (__emscripten_thread_exit = Module["__emscripten_thread_exit"] = Module["asm"]["wa"]).apply(null, arguments);
        };
        var _free = function() {
          return (_free = Module["asm"]["xa"]).apply(null, arguments);
        };
        var _emscripten_stack_set_limits = function() {
          return (_emscripten_stack_set_limits = Module["asm"]["ya"]).apply(null, arguments);
        };
        var stackSave = function() {
          return (stackSave = Module["asm"]["za"]).apply(null, arguments);
        };
        var stackRestore = function() {
          return (stackRestore = Module["asm"]["Aa"]).apply(null, arguments);
        };
        var stackAlloc = function() {
          return (stackAlloc = Module["asm"]["Ba"]).apply(null, arguments);
        };
        var ___cxa_is_pointer_type = function() {
          return (___cxa_is_pointer_type = Module["asm"]["Ca"]).apply(null, arguments);
        };
        var dynCall_jiji = Module["dynCall_jiji"] = function() {
          return (dynCall_jiji = Module["dynCall_jiji"] = Module["asm"]["Da"]).apply(null, arguments);
        };
        var dynCall_viijii = Module["dynCall_viijii"] = function() {
          return (dynCall_viijii = Module["dynCall_viijii"] = Module["asm"]["Ea"]).apply(null, arguments);
        };
        var dynCall_iiiiij = Module["dynCall_iiiiij"] = function() {
          return (dynCall_iiiiij = Module["dynCall_iiiiij"] = Module["asm"]["Fa"]).apply(null, arguments);
        };
        var dynCall_iiiiijj = Module["dynCall_iiiiijj"] = function() {
          return (dynCall_iiiiijj = Module["dynCall_iiiiijj"] = Module["asm"]["Ga"]).apply(null, arguments);
        };
        var dynCall_iiiiiijj = Module["dynCall_iiiiiijj"] = function() {
          return (dynCall_iiiiiijj = Module["dynCall_iiiiiijj"] = Module["asm"]["Ha"]).apply(null, arguments);
        };
        Module["keepRuntimeAlive"] = keepRuntimeAlive;
        Module["wasmMemory"] = wasmMemory;
        Module["ExitStatus"] = ExitStatus;
        Module["PThread"] = PThread;
        var calledRun;
        dependenciesFulfilled = function runCaller() {
          if (!calledRun)
            run();
          if (!calledRun)
            dependenciesFulfilled = runCaller;
        };
        function run() {
          if (runDependencies > 0) {
            return;
          }
          if (ENVIRONMENT_IS_PTHREAD) {
            readyPromiseResolve(Module);
            initRuntime();
            startWorker(Module);
            return;
          }
          preRun();
          if (runDependencies > 0) {
            return;
          }
          function doRun() {
            if (calledRun)
              return;
            calledRun = true;
            Module["calledRun"] = true;
            if (ABORT)
              return;
            initRuntime();
            readyPromiseResolve(Module);
            if (Module["onRuntimeInitialized"])
              Module["onRuntimeInitialized"]();
            postRun();
          }
          if (Module["setStatus"]) {
            Module["setStatus"]("Running...");
            setTimeout(function() {
              setTimeout(function() {
                Module["setStatus"]("");
              }, 1);
              doRun();
            }, 1);
          } else {
            doRun();
          }
        }
        if (Module["preInit"]) {
          if (typeof Module["preInit"] == "function")
            Module["preInit"] = [Module["preInit"]];
          while (Module["preInit"].length > 0) {
            Module["preInit"].pop()();
          }
        }
        run();
        return WebIFCWasm3.ready;
      };
    })();
    if (typeof exports === "object" && typeof module === "object")
      module.exports = WebIFCWasm2;
    else if (typeof define === "function" && define["amd"])
      define([], function() {
        return WebIFCWasm2;
      });
    else if (typeof exports === "object")
      exports["WebIFCWasm"] = WebIFCWasm2;
  }
});

// dist/web-ifc.js
var require_web_ifc = __commonJS({
  "dist/web-ifc.js"(exports, module) {
    var WebIFCWasm2 = (() => {
      var _scriptDir = typeof document !== "undefined" && document.currentScript ? document.currentScript.src : void 0;
      if (typeof __filename !== "undefined")
        _scriptDir = _scriptDir || __filename;
      return function(WebIFCWasm3 = {}) {
        var Module = typeof WebIFCWasm3 != "undefined" ? WebIFCWasm3 : {};
        var readyPromiseResolve, readyPromiseReject;
        Module["ready"] = new Promise(function(resolve, reject) {
          readyPromiseResolve = resolve;
          readyPromiseReject = reject;
        });
        var moduleOverrides = Object.assign({}, Module);
        var arguments_ = [];
        var thisProgram = "./this.program";
        var quit_ = (status, toThrow) => {
          throw toThrow;
        };
        var ENVIRONMENT_IS_WEB = typeof window == "object";
        var ENVIRONMENT_IS_WORKER = typeof importScripts == "function";
        var ENVIRONMENT_IS_NODE = typeof process == "object" && typeof process.versions == "object" && typeof process.versions.node == "string";
        var scriptDirectory = "";
        function locateFile(path) {
          if (Module["locateFile"]) {
            return Module["locateFile"](path, scriptDirectory);
          }
          return scriptDirectory + path;
        }
        var read_, readAsync, readBinary, setWindowTitle;
        function logExceptionOnExit(e) {
          if (e instanceof ExitStatus)
            return;
          let toLog = e;
          err("exiting due to exception: " + toLog);
        }
        if (ENVIRONMENT_IS_NODE) {
          var fs = __require("fs");
          var nodePath = __require("path");
          if (ENVIRONMENT_IS_WORKER) {
            scriptDirectory = nodePath.dirname(scriptDirectory) + "/";
          } else {
            scriptDirectory = __dirname + "/";
          }
          read_ = (filename, binary) => {
            filename = isFileURI(filename) ? new URL(filename) : nodePath.normalize(filename);
            return fs.readFileSync(filename, binary ? void 0 : "utf8");
          };
          readBinary = (filename) => {
            var ret = read_(filename, true);
            if (!ret.buffer) {
              ret = new Uint8Array(ret);
            }
            return ret;
          };
          readAsync = (filename, onload, onerror) => {
            filename = isFileURI(filename) ? new URL(filename) : nodePath.normalize(filename);
            fs.readFile(filename, function(err2, data) {
              if (err2)
                onerror(err2);
              else
                onload(data.buffer);
            });
          };
          if (process["argv"].length > 1) {
            thisProgram = process["argv"][1].replace(/\\/g, "/");
          }
          arguments_ = process["argv"].slice(2);
          process["on"]("uncaughtException", function(ex) {
            if (!(ex instanceof ExitStatus)) {
              throw ex;
            }
          });
          var nodeMajor = process.version.match(/^v(\d+)\./)[1];
          if (nodeMajor < 15) {
            process["on"]("unhandledRejection", function(reason) {
              throw reason;
            });
          }
          quit_ = (status, toThrow) => {
            if (keepRuntimeAlive()) {
              process["exitCode"] = status;
              throw toThrow;
            }
            logExceptionOnExit(toThrow);
            process["exit"](status);
          };
          Module["inspect"] = function() {
            return "[Emscripten Module object]";
          };
        } else if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
          if (ENVIRONMENT_IS_WORKER) {
            scriptDirectory = self.location.href;
          } else if (typeof document != "undefined" && document.currentScript) {
            scriptDirectory = document.currentScript.src;
          }
          if (_scriptDir) {
            scriptDirectory = _scriptDir;
          }
          if (scriptDirectory.indexOf("blob:") !== 0) {
            scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
          } else {
            scriptDirectory = "";
          }
          {
            read_ = (url) => {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, false);
              xhr.send(null);
              return xhr.responseText;
            };
            if (ENVIRONMENT_IS_WORKER) {
              readBinary = (url) => {
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, false);
                xhr.responseType = "arraybuffer";
                xhr.send(null);
                return new Uint8Array(xhr.response);
              };
            }
            readAsync = (url, onload, onerror) => {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, true);
              xhr.responseType = "arraybuffer";
              xhr.onload = () => {
                if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                  onload(xhr.response);
                  return;
                }
                onerror();
              };
              xhr.onerror = onerror;
              xhr.send(null);
            };
          }
          setWindowTitle = (title) => document.title = title;
        } else {
        }
        var out = Module["print"] || console.log.bind(console);
        var err = Module["printErr"] || console.warn.bind(console);
        Object.assign(Module, moduleOverrides);
        moduleOverrides = null;
        if (Module["arguments"])
          arguments_ = Module["arguments"];
        if (Module["thisProgram"])
          thisProgram = Module["thisProgram"];
        if (Module["quit"])
          quit_ = Module["quit"];
        var wasmBinary;
        if (Module["wasmBinary"])
          wasmBinary = Module["wasmBinary"];
        var noExitRuntime = Module["noExitRuntime"] || true;
        if (typeof WebAssembly != "object") {
          abort("no native wasm support detected");
        }
        var wasmMemory;
        var ABORT = false;
        var EXITSTATUS;
        function assert(condition, text) {
          if (!condition) {
            abort(text);
          }
        }
        var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : void 0;
        function UTF8ArrayToString(heapOrArray, idx, maxBytesToRead) {
          idx >>>= 0;
          var endIdx = idx + maxBytesToRead;
          var endPtr = idx;
          while (heapOrArray[endPtr] && !(endPtr >= endIdx))
            ++endPtr;
          if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) {
            return UTF8Decoder.decode(heapOrArray.subarray(idx, endPtr));
          }
          var str = "";
          while (idx < endPtr) {
            var u0 = heapOrArray[idx++];
            if (!(u0 & 128)) {
              str += String.fromCharCode(u0);
              continue;
            }
            var u1 = heapOrArray[idx++] & 63;
            if ((u0 & 224) == 192) {
              str += String.fromCharCode((u0 & 31) << 6 | u1);
              continue;
            }
            var u2 = heapOrArray[idx++] & 63;
            if ((u0 & 240) == 224) {
              u0 = (u0 & 15) << 12 | u1 << 6 | u2;
            } else {
              u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
            }
            if (u0 < 65536) {
              str += String.fromCharCode(u0);
            } else {
              var ch = u0 - 65536;
              str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
            }
          }
          return str;
        }
        function UTF8ToString(ptr, maxBytesToRead) {
          ptr >>>= 0;
          return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";
        }
        function stringToUTF8Array(str, heap, outIdx, maxBytesToWrite) {
          outIdx >>>= 0;
          if (!(maxBytesToWrite > 0))
            return 0;
          var startIdx = outIdx;
          var endIdx = outIdx + maxBytesToWrite - 1;
          for (var i = 0; i < str.length; ++i) {
            var u = str.charCodeAt(i);
            if (u >= 55296 && u <= 57343) {
              var u1 = str.charCodeAt(++i);
              u = 65536 + ((u & 1023) << 10) | u1 & 1023;
            }
            if (u <= 127) {
              if (outIdx >= endIdx)
                break;
              heap[outIdx++ >>> 0] = u;
            } else if (u <= 2047) {
              if (outIdx + 1 >= endIdx)
                break;
              heap[outIdx++ >>> 0] = 192 | u >> 6;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            } else if (u <= 65535) {
              if (outIdx + 2 >= endIdx)
                break;
              heap[outIdx++ >>> 0] = 224 | u >> 12;
              heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            } else {
              if (outIdx + 3 >= endIdx)
                break;
              heap[outIdx++ >>> 0] = 240 | u >> 18;
              heap[outIdx++ >>> 0] = 128 | u >> 12 & 63;
              heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            }
          }
          heap[outIdx >>> 0] = 0;
          return outIdx - startIdx;
        }
        function stringToUTF8(str, outPtr, maxBytesToWrite) {
          return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
        }
        function lengthBytesUTF8(str) {
          var len = 0;
          for (var i = 0; i < str.length; ++i) {
            var c = str.charCodeAt(i);
            if (c <= 127) {
              len++;
            } else if (c <= 2047) {
              len += 2;
            } else if (c >= 55296 && c <= 57343) {
              len += 4;
              ++i;
            } else {
              len += 3;
            }
          }
          return len;
        }
        var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
        function updateMemoryViews() {
          var b = wasmMemory.buffer;
          Module["HEAP8"] = HEAP8 = new Int8Array(b);
          Module["HEAP16"] = HEAP16 = new Int16Array(b);
          Module["HEAP32"] = HEAP32 = new Int32Array(b);
          Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
          Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
          Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
          Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
          Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
        }
        var wasmTable;
        var __ATPRERUN__ = [];
        var __ATINIT__ = [];
        var __ATPOSTRUN__ = [];
        var runtimeInitialized = false;
        function keepRuntimeAlive() {
          return noExitRuntime;
        }
        function preRun() {
          if (Module["preRun"]) {
            if (typeof Module["preRun"] == "function")
              Module["preRun"] = [Module["preRun"]];
            while (Module["preRun"].length) {
              addOnPreRun(Module["preRun"].shift());
            }
          }
          callRuntimeCallbacks(__ATPRERUN__);
        }
        function initRuntime() {
          runtimeInitialized = true;
          if (!Module["noFSInit"] && !FS.init.initialized)
            FS.init();
          FS.ignorePermissions = false;
          TTY.init();
          callRuntimeCallbacks(__ATINIT__);
        }
        function postRun() {
          if (Module["postRun"]) {
            if (typeof Module["postRun"] == "function")
              Module["postRun"] = [Module["postRun"]];
            while (Module["postRun"].length) {
              addOnPostRun(Module["postRun"].shift());
            }
          }
          callRuntimeCallbacks(__ATPOSTRUN__);
        }
        function addOnPreRun(cb) {
          __ATPRERUN__.unshift(cb);
        }
        function addOnInit(cb) {
          __ATINIT__.unshift(cb);
        }
        function addOnPostRun(cb) {
          __ATPOSTRUN__.unshift(cb);
        }
        var runDependencies = 0;
        var runDependencyWatcher = null;
        var dependenciesFulfilled = null;
        function getUniqueRunDependency(id) {
          return id;
        }
        function addRunDependency(id) {
          runDependencies++;
          if (Module["monitorRunDependencies"]) {
            Module["monitorRunDependencies"](runDependencies);
          }
        }
        function removeRunDependency(id) {
          runDependencies--;
          if (Module["monitorRunDependencies"]) {
            Module["monitorRunDependencies"](runDependencies);
          }
          if (runDependencies == 0) {
            if (runDependencyWatcher !== null) {
              clearInterval(runDependencyWatcher);
              runDependencyWatcher = null;
            }
            if (dependenciesFulfilled) {
              var callback = dependenciesFulfilled;
              dependenciesFulfilled = null;
              callback();
            }
          }
        }
        function abort(what) {
          if (Module["onAbort"]) {
            Module["onAbort"](what);
          }
          what = "Aborted(" + what + ")";
          err(what);
          ABORT = true;
          EXITSTATUS = 1;
          what += ". Build with -sASSERTIONS for more info.";
          var e = new WebAssembly.RuntimeError(what);
          readyPromiseReject(e);
          throw e;
        }
        var dataURIPrefix = "data:application/octet-stream;base64,";
        function isDataURI(filename) {
          return filename.startsWith(dataURIPrefix);
        }
        function isFileURI(filename) {
          return filename.startsWith("file://");
        }
        var wasmBinaryFile;
        wasmBinaryFile = "web-ifc.wasm";
        if (!isDataURI(wasmBinaryFile)) {
          wasmBinaryFile = locateFile(wasmBinaryFile);
        }
        function getBinary(file) {
          try {
            if (file == wasmBinaryFile && wasmBinary) {
              return new Uint8Array(wasmBinary);
            }
            if (readBinary) {
              return readBinary(file);
            }
            throw "both async and sync fetching of the wasm failed";
          } catch (err2) {
            abort(err2);
          }
        }
        function getBinaryPromise() {
          if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
            if (typeof fetch == "function" && !isFileURI(wasmBinaryFile)) {
              return fetch(wasmBinaryFile, { credentials: "same-origin" }).then(function(response) {
                if (!response["ok"]) {
                  throw "failed to load wasm binary file at '" + wasmBinaryFile + "'";
                }
                return response["arrayBuffer"]();
              }).catch(function() {
                return getBinary(wasmBinaryFile);
              });
            } else {
              if (readAsync) {
                return new Promise(function(resolve, reject) {
                  readAsync(wasmBinaryFile, function(response) {
                    resolve(new Uint8Array(response));
                  }, reject);
                });
              }
            }
          }
          return Promise.resolve().then(function() {
            return getBinary(wasmBinaryFile);
          });
        }
        function createWasm() {
          var info = { "a": wasmImports };
          function receiveInstance(instance, module2) {
            var exports3 = instance.exports;
            Module["asm"] = exports3;
            wasmMemory = Module["asm"]["X"];
            updateMemoryViews();
            wasmTable = Module["asm"]["Z"];
            addOnInit(Module["asm"]["Y"]);
            removeRunDependency("wasm-instantiate");
          }
          addRunDependency("wasm-instantiate");
          function receiveInstantiationResult(result) {
            receiveInstance(result["instance"]);
          }
          function instantiateArrayBuffer(receiver) {
            return getBinaryPromise().then(function(binary) {
              return WebAssembly.instantiate(binary, info);
            }).then(function(instance) {
              return instance;
            }).then(receiver, function(reason) {
              err("failed to asynchronously prepare wasm: " + reason);
              abort(reason);
            });
          }
          function instantiateAsync() {
            if (!wasmBinary && typeof WebAssembly.instantiateStreaming == "function" && !isDataURI(wasmBinaryFile) && !isFileURI(wasmBinaryFile) && !ENVIRONMENT_IS_NODE && typeof fetch == "function") {
              return fetch(wasmBinaryFile, { credentials: "same-origin" }).then(function(response) {
                var result = WebAssembly.instantiateStreaming(response, info);
                return result.then(receiveInstantiationResult, function(reason) {
                  err("wasm streaming compile failed: " + reason);
                  err("falling back to ArrayBuffer instantiation");
                  return instantiateArrayBuffer(receiveInstantiationResult);
                });
              });
            } else {
              return instantiateArrayBuffer(receiveInstantiationResult);
            }
          }
          if (Module["instantiateWasm"]) {
            try {
              var exports2 = Module["instantiateWasm"](info, receiveInstance);
              return exports2;
            } catch (e) {
              err("Module.instantiateWasm callback failed with error: " + e);
              readyPromiseReject(e);
            }
          }
          instantiateAsync().catch(readyPromiseReject);
          return {};
        }
        var tempDouble;
        var tempI64;
        function ExitStatus(status) {
          this.name = "ExitStatus";
          this.message = "Program terminated with exit(" + status + ")";
          this.status = status;
        }
        function callRuntimeCallbacks(callbacks) {
          while (callbacks.length > 0) {
            callbacks.shift()(Module);
          }
        }
        function ExceptionInfo(excPtr) {
          this.excPtr = excPtr;
          this.ptr = excPtr - 24;
          this.set_type = function(type) {
            HEAPU32[this.ptr + 4 >>> 2] = type;
          };
          this.get_type = function() {
            return HEAPU32[this.ptr + 4 >>> 2];
          };
          this.set_destructor = function(destructor) {
            HEAPU32[this.ptr + 8 >>> 2] = destructor;
          };
          this.get_destructor = function() {
            return HEAPU32[this.ptr + 8 >>> 2];
          };
          this.set_refcount = function(refcount) {
            HEAP32[this.ptr >>> 2] = refcount;
          };
          this.set_caught = function(caught) {
            caught = caught ? 1 : 0;
            HEAP8[this.ptr + 12 >>> 0] = caught;
          };
          this.get_caught = function() {
            return HEAP8[this.ptr + 12 >>> 0] != 0;
          };
          this.set_rethrown = function(rethrown) {
            rethrown = rethrown ? 1 : 0;
            HEAP8[this.ptr + 13 >>> 0] = rethrown;
          };
          this.get_rethrown = function() {
            return HEAP8[this.ptr + 13 >>> 0] != 0;
          };
          this.init = function(type, destructor) {
            this.set_adjusted_ptr(0);
            this.set_type(type);
            this.set_destructor(destructor);
            this.set_refcount(0);
            this.set_caught(false);
            this.set_rethrown(false);
          };
          this.add_ref = function() {
            var value = HEAP32[this.ptr >>> 2];
            HEAP32[this.ptr >>> 2] = value + 1;
          };
          this.release_ref = function() {
            var prev = HEAP32[this.ptr >>> 2];
            HEAP32[this.ptr >>> 2] = prev - 1;
            return prev === 1;
          };
          this.set_adjusted_ptr = function(adjustedPtr) {
            HEAPU32[this.ptr + 16 >>> 2] = adjustedPtr;
          };
          this.get_adjusted_ptr = function() {
            return HEAPU32[this.ptr + 16 >>> 2];
          };
          this.get_exception_ptr = function() {
            var isPointer = ___cxa_is_pointer_type(this.get_type());
            if (isPointer) {
              return HEAPU32[this.excPtr >>> 2];
            }
            var adjusted = this.get_adjusted_ptr();
            if (adjusted !== 0)
              return adjusted;
            return this.excPtr;
          };
        }
        var exceptionLast = 0;
        var uncaughtExceptionCount = 0;
        function ___cxa_throw(ptr, type, destructor) {
          var info = new ExceptionInfo(ptr);
          info.init(type, destructor);
          exceptionLast = ptr;
          uncaughtExceptionCount++;
          throw ptr;
        }
        function setErrNo(value) {
          HEAP32[___errno_location() >>> 2] = value;
          return value;
        }
        var PATH = { isAbs: (path) => path.charAt(0) === "/", splitPath: (filename) => {
          var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
          return splitPathRe.exec(filename).slice(1);
        }, normalizeArray: (parts, allowAboveRoot) => {
          var up = 0;
          for (var i = parts.length - 1; i >= 0; i--) {
            var last = parts[i];
            if (last === ".") {
              parts.splice(i, 1);
            } else if (last === "..") {
              parts.splice(i, 1);
              up++;
            } else if (up) {
              parts.splice(i, 1);
              up--;
            }
          }
          if (allowAboveRoot) {
            for (; up; up--) {
              parts.unshift("..");
            }
          }
          return parts;
        }, normalize: (path) => {
          var isAbsolute = PATH.isAbs(path), trailingSlash = path.substr(-1) === "/";
          path = PATH.normalizeArray(path.split("/").filter((p) => !!p), !isAbsolute).join("/");
          if (!path && !isAbsolute) {
            path = ".";
          }
          if (path && trailingSlash) {
            path += "/";
          }
          return (isAbsolute ? "/" : "") + path;
        }, dirname: (path) => {
          var result = PATH.splitPath(path), root = result[0], dir = result[1];
          if (!root && !dir) {
            return ".";
          }
          if (dir) {
            dir = dir.substr(0, dir.length - 1);
          }
          return root + dir;
        }, basename: (path) => {
          if (path === "/")
            return "/";
          path = PATH.normalize(path);
          path = path.replace(/\/$/, "");
          var lastSlash = path.lastIndexOf("/");
          if (lastSlash === -1)
            return path;
          return path.substr(lastSlash + 1);
        }, join: function() {
          var paths = Array.prototype.slice.call(arguments);
          return PATH.normalize(paths.join("/"));
        }, join2: (l, r) => {
          return PATH.normalize(l + "/" + r);
        } };
        function getRandomDevice() {
          if (typeof crypto == "object" && typeof crypto["getRandomValues"] == "function") {
            var randomBuffer = new Uint8Array(1);
            return () => {
              crypto.getRandomValues(randomBuffer);
              return randomBuffer[0];
            };
          } else if (ENVIRONMENT_IS_NODE) {
            try {
              var crypto_module = require_crypto();
              return () => crypto_module["randomBytes"](1)[0];
            } catch (e) {
            }
          }
          return () => abort("randomDevice");
        }
        var PATH_FS = { resolve: function() {
          var resolvedPath = "", resolvedAbsolute = false;
          for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
            var path = i >= 0 ? arguments[i] : FS.cwd();
            if (typeof path != "string") {
              throw new TypeError("Arguments to path.resolve must be strings");
            } else if (!path) {
              return "";
            }
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = PATH.isAbs(path);
          }
          resolvedPath = PATH.normalizeArray(resolvedPath.split("/").filter((p) => !!p), !resolvedAbsolute).join("/");
          return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
        }, relative: (from, to) => {
          from = PATH_FS.resolve(from).substr(1);
          to = PATH_FS.resolve(to).substr(1);
          function trim(arr) {
            var start = 0;
            for (; start < arr.length; start++) {
              if (arr[start] !== "")
                break;
            }
            var end = arr.length - 1;
            for (; end >= 0; end--) {
              if (arr[end] !== "")
                break;
            }
            if (start > end)
              return [];
            return arr.slice(start, end - start + 1);
          }
          var fromParts = trim(from.split("/"));
          var toParts = trim(to.split("/"));
          var length = Math.min(fromParts.length, toParts.length);
          var samePartsLength = length;
          for (var i = 0; i < length; i++) {
            if (fromParts[i] !== toParts[i]) {
              samePartsLength = i;
              break;
            }
          }
          var outputParts = [];
          for (var i = samePartsLength; i < fromParts.length; i++) {
            outputParts.push("..");
          }
          outputParts = outputParts.concat(toParts.slice(samePartsLength));
          return outputParts.join("/");
        } };
        function intArrayFromString(stringy, dontAddNull, length) {
          var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
          var u8array = new Array(len);
          var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
          if (dontAddNull)
            u8array.length = numBytesWritten;
          return u8array;
        }
        var TTY = { ttys: [], init: function() {
        }, shutdown: function() {
        }, register: function(dev, ops) {
          TTY.ttys[dev] = { input: [], output: [], ops };
          FS.registerDevice(dev, TTY.stream_ops);
        }, stream_ops: { open: function(stream) {
          var tty = TTY.ttys[stream.node.rdev];
          if (!tty) {
            throw new FS.ErrnoError(43);
          }
          stream.tty = tty;
          stream.seekable = false;
        }, close: function(stream) {
          stream.tty.ops.fsync(stream.tty);
        }, fsync: function(stream) {
          stream.tty.ops.fsync(stream.tty);
        }, read: function(stream, buffer, offset, length, pos) {
          if (!stream.tty || !stream.tty.ops.get_char) {
            throw new FS.ErrnoError(60);
          }
          var bytesRead = 0;
          for (var i = 0; i < length; i++) {
            var result;
            try {
              result = stream.tty.ops.get_char(stream.tty);
            } catch (e) {
              throw new FS.ErrnoError(29);
            }
            if (result === void 0 && bytesRead === 0) {
              throw new FS.ErrnoError(6);
            }
            if (result === null || result === void 0)
              break;
            bytesRead++;
            buffer[offset + i] = result;
          }
          if (bytesRead) {
            stream.node.timestamp = Date.now();
          }
          return bytesRead;
        }, write: function(stream, buffer, offset, length, pos) {
          if (!stream.tty || !stream.tty.ops.put_char) {
            throw new FS.ErrnoError(60);
          }
          try {
            for (var i = 0; i < length; i++) {
              stream.tty.ops.put_char(stream.tty, buffer[offset + i]);
            }
          } catch (e) {
            throw new FS.ErrnoError(29);
          }
          if (length) {
            stream.node.timestamp = Date.now();
          }
          return i;
        } }, default_tty_ops: { get_char: function(tty) {
          if (!tty.input.length) {
            var result = null;
            if (ENVIRONMENT_IS_NODE) {
              var BUFSIZE = 256;
              var buf = Buffer.alloc(BUFSIZE);
              var bytesRead = 0;
              try {
                bytesRead = fs.readSync(process.stdin.fd, buf, 0, BUFSIZE, -1);
              } catch (e) {
                if (e.toString().includes("EOF"))
                  bytesRead = 0;
                else
                  throw e;
              }
              if (bytesRead > 0) {
                result = buf.slice(0, bytesRead).toString("utf-8");
              } else {
                result = null;
              }
            } else if (typeof window != "undefined" && typeof window.prompt == "function") {
              result = window.prompt("Input: ");
              if (result !== null) {
                result += "\n";
              }
            } else if (typeof readline == "function") {
              result = readline();
              if (result !== null) {
                result += "\n";
              }
            }
            if (!result) {
              return null;
            }
            tty.input = intArrayFromString(result, true);
          }
          return tty.input.shift();
        }, put_char: function(tty, val) {
          if (val === null || val === 10) {
            out(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          } else {
            if (val != 0)
              tty.output.push(val);
          }
        }, fsync: function(tty) {
          if (tty.output && tty.output.length > 0) {
            out(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          }
        } }, default_tty1_ops: { put_char: function(tty, val) {
          if (val === null || val === 10) {
            err(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          } else {
            if (val != 0)
              tty.output.push(val);
          }
        }, fsync: function(tty) {
          if (tty.output && tty.output.length > 0) {
            err(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          }
        } } };
        function mmapAlloc(size) {
          abort();
        }
        var MEMFS = { ops_table: null, mount: function(mount) {
          return MEMFS.createNode(null, "/", 16384 | 511, 0);
        }, createNode: function(parent, name, mode, dev) {
          if (FS.isBlkdev(mode) || FS.isFIFO(mode)) {
            throw new FS.ErrnoError(63);
          }
          if (!MEMFS.ops_table) {
            MEMFS.ops_table = { dir: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr, lookup: MEMFS.node_ops.lookup, mknod: MEMFS.node_ops.mknod, rename: MEMFS.node_ops.rename, unlink: MEMFS.node_ops.unlink, rmdir: MEMFS.node_ops.rmdir, readdir: MEMFS.node_ops.readdir, symlink: MEMFS.node_ops.symlink }, stream: { llseek: MEMFS.stream_ops.llseek } }, file: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr }, stream: { llseek: MEMFS.stream_ops.llseek, read: MEMFS.stream_ops.read, write: MEMFS.stream_ops.write, allocate: MEMFS.stream_ops.allocate, mmap: MEMFS.stream_ops.mmap, msync: MEMFS.stream_ops.msync } }, link: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr, readlink: MEMFS.node_ops.readlink }, stream: {} }, chrdev: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr }, stream: FS.chrdev_stream_ops } };
          }
          var node = FS.createNode(parent, name, mode, dev);
          if (FS.isDir(node.mode)) {
            node.node_ops = MEMFS.ops_table.dir.node;
            node.stream_ops = MEMFS.ops_table.dir.stream;
            node.contents = {};
          } else if (FS.isFile(node.mode)) {
            node.node_ops = MEMFS.ops_table.file.node;
            node.stream_ops = MEMFS.ops_table.file.stream;
            node.usedBytes = 0;
            node.contents = null;
          } else if (FS.isLink(node.mode)) {
            node.node_ops = MEMFS.ops_table.link.node;
            node.stream_ops = MEMFS.ops_table.link.stream;
          } else if (FS.isChrdev(node.mode)) {
            node.node_ops = MEMFS.ops_table.chrdev.node;
            node.stream_ops = MEMFS.ops_table.chrdev.stream;
          }
          node.timestamp = Date.now();
          if (parent) {
            parent.contents[name] = node;
            parent.timestamp = node.timestamp;
          }
          return node;
        }, getFileDataAsTypedArray: function(node) {
          if (!node.contents)
            return new Uint8Array(0);
          if (node.contents.subarray)
            return node.contents.subarray(0, node.usedBytes);
          return new Uint8Array(node.contents);
        }, expandFileStorage: function(node, newCapacity) {
          newCapacity >>>= 0;
          var prevCapacity = node.contents ? node.contents.length : 0;
          if (prevCapacity >= newCapacity)
            return;
          var CAPACITY_DOUBLING_MAX = 1024 * 1024;
          newCapacity = Math.max(newCapacity, prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2 : 1.125) >>> 0);
          if (prevCapacity != 0)
            newCapacity = Math.max(newCapacity, 256);
          var oldContents = node.contents;
          node.contents = new Uint8Array(newCapacity);
          if (node.usedBytes > 0)
            node.contents.set(oldContents.subarray(0, node.usedBytes), 0);
        }, resizeFileStorage: function(node, newSize) {
          newSize >>>= 0;
          if (node.usedBytes == newSize)
            return;
          if (newSize == 0) {
            node.contents = null;
            node.usedBytes = 0;
          } else {
            var oldContents = node.contents;
            node.contents = new Uint8Array(newSize);
            if (oldContents) {
              node.contents.set(oldContents.subarray(0, Math.min(newSize, node.usedBytes)));
            }
            node.usedBytes = newSize;
          }
        }, node_ops: { getattr: function(node) {
          var attr = {};
          attr.dev = FS.isChrdev(node.mode) ? node.id : 1;
          attr.ino = node.id;
          attr.mode = node.mode;
          attr.nlink = 1;
          attr.uid = 0;
          attr.gid = 0;
          attr.rdev = node.rdev;
          if (FS.isDir(node.mode)) {
            attr.size = 4096;
          } else if (FS.isFile(node.mode)) {
            attr.size = node.usedBytes;
          } else if (FS.isLink(node.mode)) {
            attr.size = node.link.length;
          } else {
            attr.size = 0;
          }
          attr.atime = new Date(node.timestamp);
          attr.mtime = new Date(node.timestamp);
          attr.ctime = new Date(node.timestamp);
          attr.blksize = 4096;
          attr.blocks = Math.ceil(attr.size / attr.blksize);
          return attr;
        }, setattr: function(node, attr) {
          if (attr.mode !== void 0) {
            node.mode = attr.mode;
          }
          if (attr.timestamp !== void 0) {
            node.timestamp = attr.timestamp;
          }
          if (attr.size !== void 0) {
            MEMFS.resizeFileStorage(node, attr.size);
          }
        }, lookup: function(parent, name) {
          throw FS.genericErrors[44];
        }, mknod: function(parent, name, mode, dev) {
          return MEMFS.createNode(parent, name, mode, dev);
        }, rename: function(old_node, new_dir, new_name) {
          if (FS.isDir(old_node.mode)) {
            var new_node;
            try {
              new_node = FS.lookupNode(new_dir, new_name);
            } catch (e) {
            }
            if (new_node) {
              for (var i in new_node.contents) {
                throw new FS.ErrnoError(55);
              }
            }
          }
          delete old_node.parent.contents[old_node.name];
          old_node.parent.timestamp = Date.now();
          old_node.name = new_name;
          new_dir.contents[new_name] = old_node;
          new_dir.timestamp = old_node.parent.timestamp;
          old_node.parent = new_dir;
        }, unlink: function(parent, name) {
          delete parent.contents[name];
          parent.timestamp = Date.now();
        }, rmdir: function(parent, name) {
          var node = FS.lookupNode(parent, name);
          for (var i in node.contents) {
            throw new FS.ErrnoError(55);
          }
          delete parent.contents[name];
          parent.timestamp = Date.now();
        }, readdir: function(node) {
          var entries = [".", ".."];
          for (var key in node.contents) {
            if (!node.contents.hasOwnProperty(key)) {
              continue;
            }
            entries.push(key);
          }
          return entries;
        }, symlink: function(parent, newname, oldpath) {
          var node = MEMFS.createNode(parent, newname, 511 | 40960, 0);
          node.link = oldpath;
          return node;
        }, readlink: function(node) {
          if (!FS.isLink(node.mode)) {
            throw new FS.ErrnoError(28);
          }
          return node.link;
        } }, stream_ops: { read: function(stream, buffer, offset, length, position) {
          var contents = stream.node.contents;
          if (position >= stream.node.usedBytes)
            return 0;
          var size = Math.min(stream.node.usedBytes - position, length);
          if (size > 8 && contents.subarray) {
            buffer.set(contents.subarray(position, position + size), offset);
          } else {
            for (var i = 0; i < size; i++)
              buffer[offset + i] = contents[position + i];
          }
          return size;
        }, write: function(stream, buffer, offset, length, position, canOwn) {
          if (buffer.buffer === HEAP8.buffer) {
            canOwn = false;
          }
          if (!length)
            return 0;
          var node = stream.node;
          node.timestamp = Date.now();
          if (buffer.subarray && (!node.contents || node.contents.subarray)) {
            if (canOwn) {
              node.contents = buffer.subarray(offset, offset + length);
              node.usedBytes = length;
              return length;
            } else if (node.usedBytes === 0 && position === 0) {
              node.contents = buffer.slice(offset, offset + length);
              node.usedBytes = length;
              return length;
            } else if (position + length <= node.usedBytes) {
              node.contents.set(buffer.subarray(offset, offset + length), position);
              return length;
            }
          }
          MEMFS.expandFileStorage(node, position + length);
          if (node.contents.subarray && buffer.subarray) {
            node.contents.set(buffer.subarray(offset, offset + length), position);
          } else {
            for (var i = 0; i < length; i++) {
              node.contents[position + i] = buffer[offset + i];
            }
          }
          node.usedBytes = Math.max(node.usedBytes, position + length);
          return length;
        }, llseek: function(stream, offset, whence) {
          var position = offset;
          if (whence === 1) {
            position += stream.position;
          } else if (whence === 2) {
            if (FS.isFile(stream.node.mode)) {
              position += stream.node.usedBytes;
            }
          }
          if (position < 0) {
            throw new FS.ErrnoError(28);
          }
          return position;
        }, allocate: function(stream, offset, length) {
          MEMFS.expandFileStorage(stream.node, offset + length);
          stream.node.usedBytes = Math.max(stream.node.usedBytes, offset + length);
        }, mmap: function(stream, length, position, prot, flags) {
          if (!FS.isFile(stream.node.mode)) {
            throw new FS.ErrnoError(43);
          }
          var ptr;
          var allocated;
          var contents = stream.node.contents;
          if (!(flags & 2) && contents.buffer === HEAP8.buffer) {
            allocated = false;
            ptr = contents.byteOffset;
          } else {
            if (position > 0 || position + length < contents.length) {
              if (contents.subarray) {
                contents = contents.subarray(position, position + length);
              } else {
                contents = Array.prototype.slice.call(contents, position, position + length);
              }
            }
            allocated = true;
            ptr = mmapAlloc(length);
            if (!ptr) {
              throw new FS.ErrnoError(48);
            }
            ptr >>>= 0;
            HEAP8.set(contents, ptr >>> 0);
          }
          return { ptr, allocated };
        }, msync: function(stream, buffer, offset, length, mmapFlags) {
          MEMFS.stream_ops.write(stream, buffer, 0, length, offset, false);
          return 0;
        } } };
        function asyncLoad(url, onload, onerror, noRunDep) {
          var dep = !noRunDep ? getUniqueRunDependency("al " + url) : "";
          readAsync(url, (arrayBuffer) => {
            assert(arrayBuffer, 'Loading data file "' + url + '" failed (no arrayBuffer).');
            onload(new Uint8Array(arrayBuffer));
            if (dep)
              removeRunDependency(dep);
          }, (event) => {
            if (onerror) {
              onerror();
            } else {
              throw 'Loading data file "' + url + '" failed.';
            }
          });
          if (dep)
            addRunDependency(dep);
        }
        var FS = { root: null, mounts: [], devices: {}, streams: [], nextInode: 1, nameTable: null, currentPath: "/", initialized: false, ignorePermissions: true, ErrnoError: null, genericErrors: {}, filesystems: null, syncFSRequests: 0, lookupPath: (path, opts = {}) => {
          path = PATH_FS.resolve(path);
          if (!path)
            return { path: "", node: null };
          var defaults = { follow_mount: true, recurse_count: 0 };
          opts = Object.assign(defaults, opts);
          if (opts.recurse_count > 8) {
            throw new FS.ErrnoError(32);
          }
          var parts = path.split("/").filter((p) => !!p);
          var current = FS.root;
          var current_path = "/";
          for (var i = 0; i < parts.length; i++) {
            var islast = i === parts.length - 1;
            if (islast && opts.parent) {
              break;
            }
            current = FS.lookupNode(current, parts[i]);
            current_path = PATH.join2(current_path, parts[i]);
            if (FS.isMountpoint(current)) {
              if (!islast || islast && opts.follow_mount) {
                current = current.mounted.root;
              }
            }
            if (!islast || opts.follow) {
              var count = 0;
              while (FS.isLink(current.mode)) {
                var link = FS.readlink(current_path);
                current_path = PATH_FS.resolve(PATH.dirname(current_path), link);
                var lookup = FS.lookupPath(current_path, { recurse_count: opts.recurse_count + 1 });
                current = lookup.node;
                if (count++ > 40) {
                  throw new FS.ErrnoError(32);
                }
              }
            }
          }
          return { path: current_path, node: current };
        }, getPath: (node) => {
          var path;
          while (true) {
            if (FS.isRoot(node)) {
              var mount = node.mount.mountpoint;
              if (!path)
                return mount;
              return mount[mount.length - 1] !== "/" ? mount + "/" + path : mount + path;
            }
            path = path ? node.name + "/" + path : node.name;
            node = node.parent;
          }
        }, hashName: (parentid, name) => {
          var hash = 0;
          for (var i = 0; i < name.length; i++) {
            hash = (hash << 5) - hash + name.charCodeAt(i) | 0;
          }
          return (parentid + hash >>> 0) % FS.nameTable.length;
        }, hashAddNode: (node) => {
          var hash = FS.hashName(node.parent.id, node.name);
          node.name_next = FS.nameTable[hash];
          FS.nameTable[hash] = node;
        }, hashRemoveNode: (node) => {
          var hash = FS.hashName(node.parent.id, node.name);
          if (FS.nameTable[hash] === node) {
            FS.nameTable[hash] = node.name_next;
          } else {
            var current = FS.nameTable[hash];
            while (current) {
              if (current.name_next === node) {
                current.name_next = node.name_next;
                break;
              }
              current = current.name_next;
            }
          }
        }, lookupNode: (parent, name) => {
          var errCode = FS.mayLookup(parent);
          if (errCode) {
            throw new FS.ErrnoError(errCode, parent);
          }
          var hash = FS.hashName(parent.id, name);
          for (var node = FS.nameTable[hash]; node; node = node.name_next) {
            var nodeName = node.name;
            if (node.parent.id === parent.id && nodeName === name) {
              return node;
            }
          }
          return FS.lookup(parent, name);
        }, createNode: (parent, name, mode, rdev) => {
          var node = new FS.FSNode(parent, name, mode, rdev);
          FS.hashAddNode(node);
          return node;
        }, destroyNode: (node) => {
          FS.hashRemoveNode(node);
        }, isRoot: (node) => {
          return node === node.parent;
        }, isMountpoint: (node) => {
          return !!node.mounted;
        }, isFile: (mode) => {
          return (mode & 61440) === 32768;
        }, isDir: (mode) => {
          return (mode & 61440) === 16384;
        }, isLink: (mode) => {
          return (mode & 61440) === 40960;
        }, isChrdev: (mode) => {
          return (mode & 61440) === 8192;
        }, isBlkdev: (mode) => {
          return (mode & 61440) === 24576;
        }, isFIFO: (mode) => {
          return (mode & 61440) === 4096;
        }, isSocket: (mode) => {
          return (mode & 49152) === 49152;
        }, flagModes: { "r": 0, "r+": 2, "w": 577, "w+": 578, "a": 1089, "a+": 1090 }, modeStringToFlags: (str) => {
          var flags = FS.flagModes[str];
          if (typeof flags == "undefined") {
            throw new Error("Unknown file open mode: " + str);
          }
          return flags;
        }, flagsToPermissionString: (flag) => {
          var perms = ["r", "w", "rw"][flag & 3];
          if (flag & 512) {
            perms += "w";
          }
          return perms;
        }, nodePermissions: (node, perms) => {
          if (FS.ignorePermissions) {
            return 0;
          }
          if (perms.includes("r") && !(node.mode & 292)) {
            return 2;
          } else if (perms.includes("w") && !(node.mode & 146)) {
            return 2;
          } else if (perms.includes("x") && !(node.mode & 73)) {
            return 2;
          }
          return 0;
        }, mayLookup: (dir) => {
          var errCode = FS.nodePermissions(dir, "x");
          if (errCode)
            return errCode;
          if (!dir.node_ops.lookup)
            return 2;
          return 0;
        }, mayCreate: (dir, name) => {
          try {
            var node = FS.lookupNode(dir, name);
            return 20;
          } catch (e) {
          }
          return FS.nodePermissions(dir, "wx");
        }, mayDelete: (dir, name, isdir) => {
          var node;
          try {
            node = FS.lookupNode(dir, name);
          } catch (e) {
            return e.errno;
          }
          var errCode = FS.nodePermissions(dir, "wx");
          if (errCode) {
            return errCode;
          }
          if (isdir) {
            if (!FS.isDir(node.mode)) {
              return 54;
            }
            if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) {
              return 10;
            }
          } else {
            if (FS.isDir(node.mode)) {
              return 31;
            }
          }
          return 0;
        }, mayOpen: (node, flags) => {
          if (!node) {
            return 44;
          }
          if (FS.isLink(node.mode)) {
            return 32;
          } else if (FS.isDir(node.mode)) {
            if (FS.flagsToPermissionString(flags) !== "r" || flags & 512) {
              return 31;
            }
          }
          return FS.nodePermissions(node, FS.flagsToPermissionString(flags));
        }, MAX_OPEN_FDS: 4096, nextfd: (fd_start = 0, fd_end = FS.MAX_OPEN_FDS) => {
          for (var fd = fd_start; fd <= fd_end; fd++) {
            if (!FS.streams[fd]) {
              return fd;
            }
          }
          throw new FS.ErrnoError(33);
        }, getStream: (fd) => FS.streams[fd], createStream: (stream, fd_start, fd_end) => {
          if (!FS.FSStream) {
            FS.FSStream = function() {
              this.shared = {};
            };
            FS.FSStream.prototype = {};
            Object.defineProperties(FS.FSStream.prototype, { object: { get: function() {
              return this.node;
            }, set: function(val) {
              this.node = val;
            } }, isRead: { get: function() {
              return (this.flags & 2097155) !== 1;
            } }, isWrite: { get: function() {
              return (this.flags & 2097155) !== 0;
            } }, isAppend: { get: function() {
              return this.flags & 1024;
            } }, flags: { get: function() {
              return this.shared.flags;
            }, set: function(val) {
              this.shared.flags = val;
            } }, position: { get: function() {
              return this.shared.position;
            }, set: function(val) {
              this.shared.position = val;
            } } });
          }
          stream = Object.assign(new FS.FSStream(), stream);
          var fd = FS.nextfd(fd_start, fd_end);
          stream.fd = fd;
          FS.streams[fd] = stream;
          return stream;
        }, closeStream: (fd) => {
          FS.streams[fd] = null;
        }, chrdev_stream_ops: { open: (stream) => {
          var device = FS.getDevice(stream.node.rdev);
          stream.stream_ops = device.stream_ops;
          if (stream.stream_ops.open) {
            stream.stream_ops.open(stream);
          }
        }, llseek: () => {
          throw new FS.ErrnoError(70);
        } }, major: (dev) => dev >> 8, minor: (dev) => dev & 255, makedev: (ma, mi) => ma << 8 | mi, registerDevice: (dev, ops) => {
          FS.devices[dev] = { stream_ops: ops };
        }, getDevice: (dev) => FS.devices[dev], getMounts: (mount) => {
          var mounts = [];
          var check = [mount];
          while (check.length) {
            var m = check.pop();
            mounts.push(m);
            check.push.apply(check, m.mounts);
          }
          return mounts;
        }, syncfs: (populate, callback) => {
          if (typeof populate == "function") {
            callback = populate;
            populate = false;
          }
          FS.syncFSRequests++;
          if (FS.syncFSRequests > 1) {
            err("warning: " + FS.syncFSRequests + " FS.syncfs operations in flight at once, probably just doing extra work");
          }
          var mounts = FS.getMounts(FS.root.mount);
          var completed = 0;
          function doCallback(errCode) {
            FS.syncFSRequests--;
            return callback(errCode);
          }
          function done(errCode) {
            if (errCode) {
              if (!done.errored) {
                done.errored = true;
                return doCallback(errCode);
              }
              return;
            }
            if (++completed >= mounts.length) {
              doCallback(null);
            }
          }
          mounts.forEach((mount) => {
            if (!mount.type.syncfs) {
              return done(null);
            }
            mount.type.syncfs(mount, populate, done);
          });
        }, mount: (type, opts, mountpoint) => {
          var root = mountpoint === "/";
          var pseudo = !mountpoint;
          var node;
          if (root && FS.root) {
            throw new FS.ErrnoError(10);
          } else if (!root && !pseudo) {
            var lookup = FS.lookupPath(mountpoint, { follow_mount: false });
            mountpoint = lookup.path;
            node = lookup.node;
            if (FS.isMountpoint(node)) {
              throw new FS.ErrnoError(10);
            }
            if (!FS.isDir(node.mode)) {
              throw new FS.ErrnoError(54);
            }
          }
          var mount = { type, opts, mountpoint, mounts: [] };
          var mountRoot = type.mount(mount);
          mountRoot.mount = mount;
          mount.root = mountRoot;
          if (root) {
            FS.root = mountRoot;
          } else if (node) {
            node.mounted = mount;
            if (node.mount) {
              node.mount.mounts.push(mount);
            }
          }
          return mountRoot;
        }, unmount: (mountpoint) => {
          var lookup = FS.lookupPath(mountpoint, { follow_mount: false });
          if (!FS.isMountpoint(lookup.node)) {
            throw new FS.ErrnoError(28);
          }
          var node = lookup.node;
          var mount = node.mounted;
          var mounts = FS.getMounts(mount);
          Object.keys(FS.nameTable).forEach((hash) => {
            var current = FS.nameTable[hash];
            while (current) {
              var next = current.name_next;
              if (mounts.includes(current.mount)) {
                FS.destroyNode(current);
              }
              current = next;
            }
          });
          node.mounted = null;
          var idx = node.mount.mounts.indexOf(mount);
          node.mount.mounts.splice(idx, 1);
        }, lookup: (parent, name) => {
          return parent.node_ops.lookup(parent, name);
        }, mknod: (path, mode, dev) => {
          var lookup = FS.lookupPath(path, { parent: true });
          var parent = lookup.node;
          var name = PATH.basename(path);
          if (!name || name === "." || name === "..") {
            throw new FS.ErrnoError(28);
          }
          var errCode = FS.mayCreate(parent, name);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!parent.node_ops.mknod) {
            throw new FS.ErrnoError(63);
          }
          return parent.node_ops.mknod(parent, name, mode, dev);
        }, create: (path, mode) => {
          mode = mode !== void 0 ? mode : 438;
          mode &= 4095;
          mode |= 32768;
          return FS.mknod(path, mode, 0);
        }, mkdir: (path, mode) => {
          mode = mode !== void 0 ? mode : 511;
          mode &= 511 | 512;
          mode |= 16384;
          return FS.mknod(path, mode, 0);
        }, mkdirTree: (path, mode) => {
          var dirs = path.split("/");
          var d = "";
          for (var i = 0; i < dirs.length; ++i) {
            if (!dirs[i])
              continue;
            d += "/" + dirs[i];
            try {
              FS.mkdir(d, mode);
            } catch (e) {
              if (e.errno != 20)
                throw e;
            }
          }
        }, mkdev: (path, mode, dev) => {
          if (typeof dev == "undefined") {
            dev = mode;
            mode = 438;
          }
          mode |= 8192;
          return FS.mknod(path, mode, dev);
        }, symlink: (oldpath, newpath) => {
          if (!PATH_FS.resolve(oldpath)) {
            throw new FS.ErrnoError(44);
          }
          var lookup = FS.lookupPath(newpath, { parent: true });
          var parent = lookup.node;
          if (!parent) {
            throw new FS.ErrnoError(44);
          }
          var newname = PATH.basename(newpath);
          var errCode = FS.mayCreate(parent, newname);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!parent.node_ops.symlink) {
            throw new FS.ErrnoError(63);
          }
          return parent.node_ops.symlink(parent, newname, oldpath);
        }, rename: (old_path, new_path) => {
          var old_dirname = PATH.dirname(old_path);
          var new_dirname = PATH.dirname(new_path);
          var old_name = PATH.basename(old_path);
          var new_name = PATH.basename(new_path);
          var lookup, old_dir, new_dir;
          lookup = FS.lookupPath(old_path, { parent: true });
          old_dir = lookup.node;
          lookup = FS.lookupPath(new_path, { parent: true });
          new_dir = lookup.node;
          if (!old_dir || !new_dir)
            throw new FS.ErrnoError(44);
          if (old_dir.mount !== new_dir.mount) {
            throw new FS.ErrnoError(75);
          }
          var old_node = FS.lookupNode(old_dir, old_name);
          var relative = PATH_FS.relative(old_path, new_dirname);
          if (relative.charAt(0) !== ".") {
            throw new FS.ErrnoError(28);
          }
          relative = PATH_FS.relative(new_path, old_dirname);
          if (relative.charAt(0) !== ".") {
            throw new FS.ErrnoError(55);
          }
          var new_node;
          try {
            new_node = FS.lookupNode(new_dir, new_name);
          } catch (e) {
          }
          if (old_node === new_node) {
            return;
          }
          var isdir = FS.isDir(old_node.mode);
          var errCode = FS.mayDelete(old_dir, old_name, isdir);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          errCode = new_node ? FS.mayDelete(new_dir, new_name, isdir) : FS.mayCreate(new_dir, new_name);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!old_dir.node_ops.rename) {
            throw new FS.ErrnoError(63);
          }
          if (FS.isMountpoint(old_node) || new_node && FS.isMountpoint(new_node)) {
            throw new FS.ErrnoError(10);
          }
          if (new_dir !== old_dir) {
            errCode = FS.nodePermissions(old_dir, "w");
            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }
          }
          FS.hashRemoveNode(old_node);
          try {
            old_dir.node_ops.rename(old_node, new_dir, new_name);
          } catch (e) {
            throw e;
          } finally {
            FS.hashAddNode(old_node);
          }
        }, rmdir: (path) => {
          var lookup = FS.lookupPath(path, { parent: true });
          var parent = lookup.node;
          var name = PATH.basename(path);
          var node = FS.lookupNode(parent, name);
          var errCode = FS.mayDelete(parent, name, true);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!parent.node_ops.rmdir) {
            throw new FS.ErrnoError(63);
          }
          if (FS.isMountpoint(node)) {
            throw new FS.ErrnoError(10);
          }
          parent.node_ops.rmdir(parent, name);
          FS.destroyNode(node);
        }, readdir: (path) => {
          var lookup = FS.lookupPath(path, { follow: true });
          var node = lookup.node;
          if (!node.node_ops.readdir) {
            throw new FS.ErrnoError(54);
          }
          return node.node_ops.readdir(node);
        }, unlink: (path) => {
          var lookup = FS.lookupPath(path, { parent: true });
          var parent = lookup.node;
          if (!parent) {
            throw new FS.ErrnoError(44);
          }
          var name = PATH.basename(path);
          var node = FS.lookupNode(parent, name);
          var errCode = FS.mayDelete(parent, name, false);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          if (!parent.node_ops.unlink) {
            throw new FS.ErrnoError(63);
          }
          if (FS.isMountpoint(node)) {
            throw new FS.ErrnoError(10);
          }
          parent.node_ops.unlink(parent, name);
          FS.destroyNode(node);
        }, readlink: (path) => {
          var lookup = FS.lookupPath(path);
          var link = lookup.node;
          if (!link) {
            throw new FS.ErrnoError(44);
          }
          if (!link.node_ops.readlink) {
            throw new FS.ErrnoError(28);
          }
          return PATH_FS.resolve(FS.getPath(link.parent), link.node_ops.readlink(link));
        }, stat: (path, dontFollow) => {
          var lookup = FS.lookupPath(path, { follow: !dontFollow });
          var node = lookup.node;
          if (!node) {
            throw new FS.ErrnoError(44);
          }
          if (!node.node_ops.getattr) {
            throw new FS.ErrnoError(63);
          }
          return node.node_ops.getattr(node);
        }, lstat: (path) => {
          return FS.stat(path, true);
        }, chmod: (path, mode, dontFollow) => {
          var node;
          if (typeof path == "string") {
            var lookup = FS.lookupPath(path, { follow: !dontFollow });
            node = lookup.node;
          } else {
            node = path;
          }
          if (!node.node_ops.setattr) {
            throw new FS.ErrnoError(63);
          }
          node.node_ops.setattr(node, { mode: mode & 4095 | node.mode & ~4095, timestamp: Date.now() });
        }, lchmod: (path, mode) => {
          FS.chmod(path, mode, true);
        }, fchmod: (fd, mode) => {
          var stream = FS.getStream(fd);
          if (!stream) {
            throw new FS.ErrnoError(8);
          }
          FS.chmod(stream.node, mode);
        }, chown: (path, uid, gid, dontFollow) => {
          var node;
          if (typeof path == "string") {
            var lookup = FS.lookupPath(path, { follow: !dontFollow });
            node = lookup.node;
          } else {
            node = path;
          }
          if (!node.node_ops.setattr) {
            throw new FS.ErrnoError(63);
          }
          node.node_ops.setattr(node, { timestamp: Date.now() });
        }, lchown: (path, uid, gid) => {
          FS.chown(path, uid, gid, true);
        }, fchown: (fd, uid, gid) => {
          var stream = FS.getStream(fd);
          if (!stream) {
            throw new FS.ErrnoError(8);
          }
          FS.chown(stream.node, uid, gid);
        }, truncate: (path, len) => {
          if (len < 0) {
            throw new FS.ErrnoError(28);
          }
          var node;
          if (typeof path == "string") {
            var lookup = FS.lookupPath(path, { follow: true });
            node = lookup.node;
          } else {
            node = path;
          }
          if (!node.node_ops.setattr) {
            throw new FS.ErrnoError(63);
          }
          if (FS.isDir(node.mode)) {
            throw new FS.ErrnoError(31);
          }
          if (!FS.isFile(node.mode)) {
            throw new FS.ErrnoError(28);
          }
          var errCode = FS.nodePermissions(node, "w");
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          node.node_ops.setattr(node, { size: len, timestamp: Date.now() });
        }, ftruncate: (fd, len) => {
          var stream = FS.getStream(fd);
          if (!stream) {
            throw new FS.ErrnoError(8);
          }
          if ((stream.flags & 2097155) === 0) {
            throw new FS.ErrnoError(28);
          }
          FS.truncate(stream.node, len);
        }, utime: (path, atime, mtime) => {
          var lookup = FS.lookupPath(path, { follow: true });
          var node = lookup.node;
          node.node_ops.setattr(node, { timestamp: Math.max(atime, mtime) });
        }, open: (path, flags, mode) => {
          if (path === "") {
            throw new FS.ErrnoError(44);
          }
          flags = typeof flags == "string" ? FS.modeStringToFlags(flags) : flags;
          mode = typeof mode == "undefined" ? 438 : mode;
          if (flags & 64) {
            mode = mode & 4095 | 32768;
          } else {
            mode = 0;
          }
          var node;
          if (typeof path == "object") {
            node = path;
          } else {
            path = PATH.normalize(path);
            try {
              var lookup = FS.lookupPath(path, { follow: !(flags & 131072) });
              node = lookup.node;
            } catch (e) {
            }
          }
          var created = false;
          if (flags & 64) {
            if (node) {
              if (flags & 128) {
                throw new FS.ErrnoError(20);
              }
            } else {
              node = FS.mknod(path, mode, 0);
              created = true;
            }
          }
          if (!node) {
            throw new FS.ErrnoError(44);
          }
          if (FS.isChrdev(node.mode)) {
            flags &= ~512;
          }
          if (flags & 65536 && !FS.isDir(node.mode)) {
            throw new FS.ErrnoError(54);
          }
          if (!created) {
            var errCode = FS.mayOpen(node, flags);
            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }
          }
          if (flags & 512 && !created) {
            FS.truncate(node, 0);
          }
          flags &= ~(128 | 512 | 131072);
          var stream = FS.createStream({ node, path: FS.getPath(node), flags, seekable: true, position: 0, stream_ops: node.stream_ops, ungotten: [], error: false });
          if (stream.stream_ops.open) {
            stream.stream_ops.open(stream);
          }
          if (Module["logReadFiles"] && !(flags & 1)) {
            if (!FS.readFiles)
              FS.readFiles = {};
            if (!(path in FS.readFiles)) {
              FS.readFiles[path] = 1;
            }
          }
          return stream;
        }, close: (stream) => {
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if (stream.getdents)
            stream.getdents = null;
          try {
            if (stream.stream_ops.close) {
              stream.stream_ops.close(stream);
            }
          } catch (e) {
            throw e;
          } finally {
            FS.closeStream(stream.fd);
          }
          stream.fd = null;
        }, isClosed: (stream) => {
          return stream.fd === null;
        }, llseek: (stream, offset, whence) => {
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if (!stream.seekable || !stream.stream_ops.llseek) {
            throw new FS.ErrnoError(70);
          }
          if (whence != 0 && whence != 1 && whence != 2) {
            throw new FS.ErrnoError(28);
          }
          stream.position = stream.stream_ops.llseek(stream, offset, whence);
          stream.ungotten = [];
          return stream.position;
        }, read: (stream, buffer, offset, length, position) => {
          offset >>>= 0;
          if (length < 0 || position < 0) {
            throw new FS.ErrnoError(28);
          }
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if ((stream.flags & 2097155) === 1) {
            throw new FS.ErrnoError(8);
          }
          if (FS.isDir(stream.node.mode)) {
            throw new FS.ErrnoError(31);
          }
          if (!stream.stream_ops.read) {
            throw new FS.ErrnoError(28);
          }
          var seeking = typeof position != "undefined";
          if (!seeking) {
            position = stream.position;
          } else if (!stream.seekable) {
            throw new FS.ErrnoError(70);
          }
          var bytesRead = stream.stream_ops.read(stream, buffer, offset, length, position);
          if (!seeking)
            stream.position += bytesRead;
          return bytesRead;
        }, write: (stream, buffer, offset, length, position, canOwn) => {
          offset >>>= 0;
          if (length < 0 || position < 0) {
            throw new FS.ErrnoError(28);
          }
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if ((stream.flags & 2097155) === 0) {
            throw new FS.ErrnoError(8);
          }
          if (FS.isDir(stream.node.mode)) {
            throw new FS.ErrnoError(31);
          }
          if (!stream.stream_ops.write) {
            throw new FS.ErrnoError(28);
          }
          if (stream.seekable && stream.flags & 1024) {
            FS.llseek(stream, 0, 2);
          }
          var seeking = typeof position != "undefined";
          if (!seeking) {
            position = stream.position;
          } else if (!stream.seekable) {
            throw new FS.ErrnoError(70);
          }
          var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length, position, canOwn);
          if (!seeking)
            stream.position += bytesWritten;
          return bytesWritten;
        }, allocate: (stream, offset, length) => {
          if (FS.isClosed(stream)) {
            throw new FS.ErrnoError(8);
          }
          if (offset < 0 || length <= 0) {
            throw new FS.ErrnoError(28);
          }
          if ((stream.flags & 2097155) === 0) {
            throw new FS.ErrnoError(8);
          }
          if (!FS.isFile(stream.node.mode) && !FS.isDir(stream.node.mode)) {
            throw new FS.ErrnoError(43);
          }
          if (!stream.stream_ops.allocate) {
            throw new FS.ErrnoError(138);
          }
          stream.stream_ops.allocate(stream, offset, length);
        }, mmap: (stream, length, position, prot, flags) => {
          if ((prot & 2) !== 0 && (flags & 2) === 0 && (stream.flags & 2097155) !== 2) {
            throw new FS.ErrnoError(2);
          }
          if ((stream.flags & 2097155) === 1) {
            throw new FS.ErrnoError(2);
          }
          if (!stream.stream_ops.mmap) {
            throw new FS.ErrnoError(43);
          }
          return stream.stream_ops.mmap(stream, length, position, prot, flags);
        }, msync: (stream, buffer, offset, length, mmapFlags) => {
          offset >>>= 0;
          if (!stream.stream_ops.msync) {
            return 0;
          }
          return stream.stream_ops.msync(stream, buffer, offset, length, mmapFlags);
        }, munmap: (stream) => 0, ioctl: (stream, cmd, arg) => {
          if (!stream.stream_ops.ioctl) {
            throw new FS.ErrnoError(59);
          }
          return stream.stream_ops.ioctl(stream, cmd, arg);
        }, readFile: (path, opts = {}) => {
          opts.flags = opts.flags || 0;
          opts.encoding = opts.encoding || "binary";
          if (opts.encoding !== "utf8" && opts.encoding !== "binary") {
            throw new Error('Invalid encoding type "' + opts.encoding + '"');
          }
          var ret;
          var stream = FS.open(path, opts.flags);
          var stat = FS.stat(path);
          var length = stat.size;
          var buf = new Uint8Array(length);
          FS.read(stream, buf, 0, length, 0);
          if (opts.encoding === "utf8") {
            ret = UTF8ArrayToString(buf, 0);
          } else if (opts.encoding === "binary") {
            ret = buf;
          }
          FS.close(stream);
          return ret;
        }, writeFile: (path, data, opts = {}) => {
          opts.flags = opts.flags || 577;
          var stream = FS.open(path, opts.flags, opts.mode);
          if (typeof data == "string") {
            var buf = new Uint8Array(lengthBytesUTF8(data) + 1);
            var actualNumBytes = stringToUTF8Array(data, buf, 0, buf.length);
            FS.write(stream, buf, 0, actualNumBytes, void 0, opts.canOwn);
          } else if (ArrayBuffer.isView(data)) {
            FS.write(stream, data, 0, data.byteLength, void 0, opts.canOwn);
          } else {
            throw new Error("Unsupported data type");
          }
          FS.close(stream);
        }, cwd: () => FS.currentPath, chdir: (path) => {
          var lookup = FS.lookupPath(path, { follow: true });
          if (lookup.node === null) {
            throw new FS.ErrnoError(44);
          }
          if (!FS.isDir(lookup.node.mode)) {
            throw new FS.ErrnoError(54);
          }
          var errCode = FS.nodePermissions(lookup.node, "x");
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
          FS.currentPath = lookup.path;
        }, createDefaultDirectories: () => {
          FS.mkdir("/tmp");
          FS.mkdir("/home");
          FS.mkdir("/home/web_user");
        }, createDefaultDevices: () => {
          FS.mkdir("/dev");
          FS.registerDevice(FS.makedev(1, 3), { read: () => 0, write: (stream, buffer, offset, length, pos) => length });
          FS.mkdev("/dev/null", FS.makedev(1, 3));
          TTY.register(FS.makedev(5, 0), TTY.default_tty_ops);
          TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops);
          FS.mkdev("/dev/tty", FS.makedev(5, 0));
          FS.mkdev("/dev/tty1", FS.makedev(6, 0));
          var random_device = getRandomDevice();
          FS.createDevice("/dev", "random", random_device);
          FS.createDevice("/dev", "urandom", random_device);
          FS.mkdir("/dev/shm");
          FS.mkdir("/dev/shm/tmp");
        }, createSpecialDirectories: () => {
          FS.mkdir("/proc");
          var proc_self = FS.mkdir("/proc/self");
          FS.mkdir("/proc/self/fd");
          FS.mount({ mount: () => {
            var node = FS.createNode(proc_self, "fd", 16384 | 511, 73);
            node.node_ops = { lookup: (parent, name) => {
              var fd = +name;
              var stream = FS.getStream(fd);
              if (!stream)
                throw new FS.ErrnoError(8);
              var ret = { parent: null, mount: { mountpoint: "fake" }, node_ops: { readlink: () => stream.path } };
              ret.parent = ret;
              return ret;
            } };
            return node;
          } }, {}, "/proc/self/fd");
        }, createStandardStreams: () => {
          if (Module["stdin"]) {
            FS.createDevice("/dev", "stdin", Module["stdin"]);
          } else {
            FS.symlink("/dev/tty", "/dev/stdin");
          }
          if (Module["stdout"]) {
            FS.createDevice("/dev", "stdout", null, Module["stdout"]);
          } else {
            FS.symlink("/dev/tty", "/dev/stdout");
          }
          if (Module["stderr"]) {
            FS.createDevice("/dev", "stderr", null, Module["stderr"]);
          } else {
            FS.symlink("/dev/tty1", "/dev/stderr");
          }
          var stdin = FS.open("/dev/stdin", 0);
          var stdout = FS.open("/dev/stdout", 1);
          var stderr = FS.open("/dev/stderr", 1);
        }, ensureErrnoError: () => {
          if (FS.ErrnoError)
            return;
          FS.ErrnoError = function ErrnoError(errno, node) {
            this.node = node;
            this.setErrno = function(errno2) {
              this.errno = errno2;
            };
            this.setErrno(errno);
            this.message = "FS error";
          };
          FS.ErrnoError.prototype = new Error();
          FS.ErrnoError.prototype.constructor = FS.ErrnoError;
          [44].forEach((code) => {
            FS.genericErrors[code] = new FS.ErrnoError(code);
            FS.genericErrors[code].stack = "<generic error, no stack>";
          });
        }, staticInit: () => {
          FS.ensureErrnoError();
          FS.nameTable = new Array(4096);
          FS.mount(MEMFS, {}, "/");
          FS.createDefaultDirectories();
          FS.createDefaultDevices();
          FS.createSpecialDirectories();
          FS.filesystems = { "MEMFS": MEMFS };
        }, init: (input, output, error) => {
          FS.init.initialized = true;
          FS.ensureErrnoError();
          Module["stdin"] = input || Module["stdin"];
          Module["stdout"] = output || Module["stdout"];
          Module["stderr"] = error || Module["stderr"];
          FS.createStandardStreams();
        }, quit: () => {
          FS.init.initialized = false;
          for (var i = 0; i < FS.streams.length; i++) {
            var stream = FS.streams[i];
            if (!stream) {
              continue;
            }
            FS.close(stream);
          }
        }, getMode: (canRead, canWrite) => {
          var mode = 0;
          if (canRead)
            mode |= 292 | 73;
          if (canWrite)
            mode |= 146;
          return mode;
        }, findObject: (path, dontResolveLastLink) => {
          var ret = FS.analyzePath(path, dontResolveLastLink);
          if (!ret.exists) {
            return null;
          }
          return ret.object;
        }, analyzePath: (path, dontResolveLastLink) => {
          try {
            var lookup = FS.lookupPath(path, { follow: !dontResolveLastLink });
            path = lookup.path;
          } catch (e) {
          }
          var ret = { isRoot: false, exists: false, error: 0, name: null, path: null, object: null, parentExists: false, parentPath: null, parentObject: null };
          try {
            var lookup = FS.lookupPath(path, { parent: true });
            ret.parentExists = true;
            ret.parentPath = lookup.path;
            ret.parentObject = lookup.node;
            ret.name = PATH.basename(path);
            lookup = FS.lookupPath(path, { follow: !dontResolveLastLink });
            ret.exists = true;
            ret.path = lookup.path;
            ret.object = lookup.node;
            ret.name = lookup.node.name;
            ret.isRoot = lookup.path === "/";
          } catch (e) {
            ret.error = e.errno;
          }
          return ret;
        }, createPath: (parent, path, canRead, canWrite) => {
          parent = typeof parent == "string" ? parent : FS.getPath(parent);
          var parts = path.split("/").reverse();
          while (parts.length) {
            var part = parts.pop();
            if (!part)
              continue;
            var current = PATH.join2(parent, part);
            try {
              FS.mkdir(current);
            } catch (e) {
            }
            parent = current;
          }
          return current;
        }, createFile: (parent, name, properties, canRead, canWrite) => {
          var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
          var mode = FS.getMode(canRead, canWrite);
          return FS.create(path, mode);
        }, createDataFile: (parent, name, data, canRead, canWrite, canOwn) => {
          var path = name;
          if (parent) {
            parent = typeof parent == "string" ? parent : FS.getPath(parent);
            path = name ? PATH.join2(parent, name) : parent;
          }
          var mode = FS.getMode(canRead, canWrite);
          var node = FS.create(path, mode);
          if (data) {
            if (typeof data == "string") {
              var arr = new Array(data.length);
              for (var i = 0, len = data.length; i < len; ++i)
                arr[i] = data.charCodeAt(i);
              data = arr;
            }
            FS.chmod(node, mode | 146);
            var stream = FS.open(node, 577);
            FS.write(stream, data, 0, data.length, 0, canOwn);
            FS.close(stream);
            FS.chmod(node, mode);
          }
          return node;
        }, createDevice: (parent, name, input, output) => {
          var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
          var mode = FS.getMode(!!input, !!output);
          if (!FS.createDevice.major)
            FS.createDevice.major = 64;
          var dev = FS.makedev(FS.createDevice.major++, 0);
          FS.registerDevice(dev, { open: (stream) => {
            stream.seekable = false;
          }, close: (stream) => {
            if (output && output.buffer && output.buffer.length) {
              output(10);
            }
          }, read: (stream, buffer, offset, length, pos) => {
            var bytesRead = 0;
            for (var i = 0; i < length; i++) {
              var result;
              try {
                result = input();
              } catch (e) {
                throw new FS.ErrnoError(29);
              }
              if (result === void 0 && bytesRead === 0) {
                throw new FS.ErrnoError(6);
              }
              if (result === null || result === void 0)
                break;
              bytesRead++;
              buffer[offset + i] = result;
            }
            if (bytesRead) {
              stream.node.timestamp = Date.now();
            }
            return bytesRead;
          }, write: (stream, buffer, offset, length, pos) => {
            for (var i = 0; i < length; i++) {
              try {
                output(buffer[offset + i]);
              } catch (e) {
                throw new FS.ErrnoError(29);
              }
            }
            if (length) {
              stream.node.timestamp = Date.now();
            }
            return i;
          } });
          return FS.mkdev(path, mode, dev);
        }, forceLoadFile: (obj) => {
          if (obj.isDevice || obj.isFolder || obj.link || obj.contents)
            return true;
          if (typeof XMLHttpRequest != "undefined") {
            throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
          } else if (read_) {
            try {
              obj.contents = intArrayFromString(read_(obj.url), true);
              obj.usedBytes = obj.contents.length;
            } catch (e) {
              throw new FS.ErrnoError(29);
            }
          } else {
            throw new Error("Cannot load without read() or XMLHttpRequest.");
          }
        }, createLazyFile: (parent, name, url, canRead, canWrite) => {
          function LazyUint8Array() {
            this.lengthKnown = false;
            this.chunks = [];
          }
          LazyUint8Array.prototype.get = function LazyUint8Array_get(idx) {
            if (idx > this.length - 1 || idx < 0) {
              return void 0;
            }
            var chunkOffset = idx % this.chunkSize;
            var chunkNum = idx / this.chunkSize | 0;
            return this.getter(chunkNum)[chunkOffset];
          };
          LazyUint8Array.prototype.setDataGetter = function LazyUint8Array_setDataGetter(getter) {
            this.getter = getter;
          };
          LazyUint8Array.prototype.cacheLength = function LazyUint8Array_cacheLength() {
            var xhr = new XMLHttpRequest();
            xhr.open("HEAD", url, false);
            xhr.send(null);
            if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304))
              throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
            var datalength = Number(xhr.getResponseHeader("Content-length"));
            var header;
            var hasByteServing = (header = xhr.getResponseHeader("Accept-Ranges")) && header === "bytes";
            var usesGzip = (header = xhr.getResponseHeader("Content-Encoding")) && header === "gzip";
            var chunkSize = 1024 * 1024;
            if (!hasByteServing)
              chunkSize = datalength;
            var doXHR = (from, to) => {
              if (from > to)
                throw new Error("invalid range (" + from + ", " + to + ") or no bytes requested!");
              if (to > datalength - 1)
                throw new Error("only " + datalength + " bytes available! programmer error!");
              var xhr2 = new XMLHttpRequest();
              xhr2.open("GET", url, false);
              if (datalength !== chunkSize)
                xhr2.setRequestHeader("Range", "bytes=" + from + "-" + to);
              xhr2.responseType = "arraybuffer";
              if (xhr2.overrideMimeType) {
                xhr2.overrideMimeType("text/plain; charset=x-user-defined");
              }
              xhr2.send(null);
              if (!(xhr2.status >= 200 && xhr2.status < 300 || xhr2.status === 304))
                throw new Error("Couldn't load " + url + ". Status: " + xhr2.status);
              if (xhr2.response !== void 0) {
                return new Uint8Array(xhr2.response || []);
              }
              return intArrayFromString(xhr2.responseText || "", true);
            };
            var lazyArray2 = this;
            lazyArray2.setDataGetter((chunkNum) => {
              var start = chunkNum * chunkSize;
              var end = (chunkNum + 1) * chunkSize - 1;
              end = Math.min(end, datalength - 1);
              if (typeof lazyArray2.chunks[chunkNum] == "undefined") {
                lazyArray2.chunks[chunkNum] = doXHR(start, end);
              }
              if (typeof lazyArray2.chunks[chunkNum] == "undefined")
                throw new Error("doXHR failed!");
              return lazyArray2.chunks[chunkNum];
            });
            if (usesGzip || !datalength) {
              chunkSize = datalength = 1;
              datalength = this.getter(0).length;
              chunkSize = datalength;
              out("LazyFiles on gzip forces download of the whole file when length is accessed");
            }
            this._length = datalength;
            this._chunkSize = chunkSize;
            this.lengthKnown = true;
          };
          if (typeof XMLHttpRequest != "undefined") {
            if (!ENVIRONMENT_IS_WORKER)
              throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
            var lazyArray = new LazyUint8Array();
            Object.defineProperties(lazyArray, { length: { get: function() {
              if (!this.lengthKnown) {
                this.cacheLength();
              }
              return this._length;
            } }, chunkSize: { get: function() {
              if (!this.lengthKnown) {
                this.cacheLength();
              }
              return this._chunkSize;
            } } });
            var properties = { isDevice: false, contents: lazyArray };
          } else {
            var properties = { isDevice: false, url };
          }
          var node = FS.createFile(parent, name, properties, canRead, canWrite);
          if (properties.contents) {
            node.contents = properties.contents;
          } else if (properties.url) {
            node.contents = null;
            node.url = properties.url;
          }
          Object.defineProperties(node, { usedBytes: { get: function() {
            return this.contents.length;
          } } });
          var stream_ops = {};
          var keys = Object.keys(node.stream_ops);
          keys.forEach((key) => {
            var fn = node.stream_ops[key];
            stream_ops[key] = function forceLoadLazyFile() {
              FS.forceLoadFile(node);
              return fn.apply(null, arguments);
            };
          });
          function writeChunks(stream, buffer, offset, length, position) {
            var contents = stream.node.contents;
            if (position >= contents.length)
              return 0;
            var size = Math.min(contents.length - position, length);
            if (contents.slice) {
              for (var i = 0; i < size; i++) {
                buffer[offset + i] = contents[position + i];
              }
            } else {
              for (var i = 0; i < size; i++) {
                buffer[offset + i] = contents.get(position + i);
              }
            }
            return size;
          }
          stream_ops.read = (stream, buffer, offset, length, position) => {
            FS.forceLoadFile(node);
            return writeChunks(stream, buffer, offset, length, position);
          };
          stream_ops.mmap = (stream, length, position, prot, flags) => {
            FS.forceLoadFile(node);
            var ptr = mmapAlloc(length);
            if (!ptr) {
              throw new FS.ErrnoError(48);
            }
            writeChunks(stream, HEAP8, ptr, length, position);
            return { ptr, allocated: true };
          };
          node.stream_ops = stream_ops;
          return node;
        }, createPreloadedFile: (parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish) => {
          var fullname = name ? PATH_FS.resolve(PATH.join2(parent, name)) : parent;
          var dep = getUniqueRunDependency("cp " + fullname);
          function processData(byteArray) {
            function finish(byteArray2) {
              if (preFinish)
                preFinish();
              if (!dontCreateFile) {
                FS.createDataFile(parent, name, byteArray2, canRead, canWrite, canOwn);
              }
              if (onload)
                onload();
              removeRunDependency(dep);
            }
            if (Browser.handledByPreloadPlugin(byteArray, fullname, finish, () => {
              if (onerror)
                onerror();
              removeRunDependency(dep);
            })) {
              return;
            }
            finish(byteArray);
          }
          addRunDependency(dep);
          if (typeof url == "string") {
            asyncLoad(url, (byteArray) => processData(byteArray), onerror);
          } else {
            processData(url);
          }
        }, indexedDB: () => {
          return window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
        }, DB_NAME: () => {
          return "EM_FS_" + window.location.pathname;
        }, DB_VERSION: 20, DB_STORE_NAME: "FILE_DATA", saveFilesToDB: (paths, onload = () => {
        }, onerror = () => {
        }) => {
          var indexedDB = FS.indexedDB();
          try {
            var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
          } catch (e) {
            return onerror(e);
          }
          openRequest.onupgradeneeded = () => {
            out("creating db");
            var db = openRequest.result;
            db.createObjectStore(FS.DB_STORE_NAME);
          };
          openRequest.onsuccess = () => {
            var db = openRequest.result;
            var transaction = db.transaction([FS.DB_STORE_NAME], "readwrite");
            var files = transaction.objectStore(FS.DB_STORE_NAME);
            var ok = 0, fail = 0, total = paths.length;
            function finish() {
              if (fail == 0)
                onload();
              else
                onerror();
            }
            paths.forEach((path) => {
              var putRequest = files.put(FS.analyzePath(path).object.contents, path);
              putRequest.onsuccess = () => {
                ok++;
                if (ok + fail == total)
                  finish();
              };
              putRequest.onerror = () => {
                fail++;
                if (ok + fail == total)
                  finish();
              };
            });
            transaction.onerror = onerror;
          };
          openRequest.onerror = onerror;
        }, loadFilesFromDB: (paths, onload = () => {
        }, onerror = () => {
        }) => {
          var indexedDB = FS.indexedDB();
          try {
            var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
          } catch (e) {
            return onerror(e);
          }
          openRequest.onupgradeneeded = onerror;
          openRequest.onsuccess = () => {
            var db = openRequest.result;
            try {
              var transaction = db.transaction([FS.DB_STORE_NAME], "readonly");
            } catch (e) {
              onerror(e);
              return;
            }
            var files = transaction.objectStore(FS.DB_STORE_NAME);
            var ok = 0, fail = 0, total = paths.length;
            function finish() {
              if (fail == 0)
                onload();
              else
                onerror();
            }
            paths.forEach((path) => {
              var getRequest = files.get(path);
              getRequest.onsuccess = () => {
                if (FS.analyzePath(path).exists) {
                  FS.unlink(path);
                }
                FS.createDataFile(PATH.dirname(path), PATH.basename(path), getRequest.result, true, true, true);
                ok++;
                if (ok + fail == total)
                  finish();
              };
              getRequest.onerror = () => {
                fail++;
                if (ok + fail == total)
                  finish();
              };
            });
            transaction.onerror = onerror;
          };
          openRequest.onerror = onerror;
        } };
        var SYSCALLS = { DEFAULT_POLLMASK: 5, calculateAt: function(dirfd, path, allowEmpty) {
          if (PATH.isAbs(path)) {
            return path;
          }
          var dir;
          if (dirfd === -100) {
            dir = FS.cwd();
          } else {
            var dirstream = SYSCALLS.getStreamFromFD(dirfd);
            dir = dirstream.path;
          }
          if (path.length == 0) {
            if (!allowEmpty) {
              throw new FS.ErrnoError(44);
            }
            return dir;
          }
          return PATH.join2(dir, path);
        }, doStat: function(func, path, buf) {
          try {
            var stat = func(path);
          } catch (e) {
            if (e && e.node && PATH.normalize(path) !== PATH.normalize(FS.getPath(e.node))) {
              return -54;
            }
            throw e;
          }
          HEAP32[buf >>> 2] = stat.dev;
          HEAP32[buf + 8 >>> 2] = stat.ino;
          HEAP32[buf + 12 >>> 2] = stat.mode;
          HEAPU32[buf + 16 >>> 2] = stat.nlink;
          HEAP32[buf + 20 >>> 2] = stat.uid;
          HEAP32[buf + 24 >>> 2] = stat.gid;
          HEAP32[buf + 28 >>> 2] = stat.rdev;
          tempI64 = [stat.size >>> 0, (tempDouble = stat.size, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 40 >>> 2] = tempI64[0], HEAP32[buf + 44 >>> 2] = tempI64[1];
          HEAP32[buf + 48 >>> 2] = 4096;
          HEAP32[buf + 52 >>> 2] = stat.blocks;
          var atime = stat.atime.getTime();
          var mtime = stat.mtime.getTime();
          var ctime = stat.ctime.getTime();
          tempI64 = [Math.floor(atime / 1e3) >>> 0, (tempDouble = Math.floor(atime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 56 >>> 2] = tempI64[0], HEAP32[buf + 60 >>> 2] = tempI64[1];
          HEAPU32[buf + 64 >>> 2] = atime % 1e3 * 1e3;
          tempI64 = [Math.floor(mtime / 1e3) >>> 0, (tempDouble = Math.floor(mtime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 72 >>> 2] = tempI64[0], HEAP32[buf + 76 >>> 2] = tempI64[1];
          HEAPU32[buf + 80 >>> 2] = mtime % 1e3 * 1e3;
          tempI64 = [Math.floor(ctime / 1e3) >>> 0, (tempDouble = Math.floor(ctime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 88 >>> 2] = tempI64[0], HEAP32[buf + 92 >>> 2] = tempI64[1];
          HEAPU32[buf + 96 >>> 2] = ctime % 1e3 * 1e3;
          tempI64 = [stat.ino >>> 0, (tempDouble = stat.ino, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 104 >>> 2] = tempI64[0], HEAP32[buf + 108 >>> 2] = tempI64[1];
          return 0;
        }, doMsync: function(addr, stream, len, flags, offset) {
          if (!FS.isFile(stream.node.mode)) {
            throw new FS.ErrnoError(43);
          }
          if (flags & 2) {
            return 0;
          }
          addr >>>= 0;
          var buffer = HEAPU8.slice(addr, addr + len);
          FS.msync(stream, buffer, offset, len, flags);
        }, varargs: void 0, get: function() {
          SYSCALLS.varargs += 4;
          var ret = HEAP32[SYSCALLS.varargs - 4 >>> 2];
          return ret;
        }, getStr: function(ptr) {
          var ret = UTF8ToString(ptr);
          return ret;
        }, getStreamFromFD: function(fd) {
          var stream = FS.getStream(fd);
          if (!stream)
            throw new FS.ErrnoError(8);
          return stream;
        } };
        function ___syscall_fcntl64(fd, cmd, varargs) {
          SYSCALLS.varargs = varargs;
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            switch (cmd) {
              case 0: {
                var arg = SYSCALLS.get();
                if (arg < 0) {
                  return -28;
                }
                var newStream;
                newStream = FS.createStream(stream, arg);
                return newStream.fd;
              }
              case 1:
              case 2:
                return 0;
              case 3:
                return stream.flags;
              case 4: {
                var arg = SYSCALLS.get();
                stream.flags |= arg;
                return 0;
              }
              case 5: {
                var arg = SYSCALLS.get();
                var offset = 0;
                HEAP16[arg + offset >>> 1] = 2;
                return 0;
              }
              case 6:
              case 7:
                return 0;
              case 16:
              case 8:
                return -28;
              case 9:
                setErrNo(28);
                return -1;
              default: {
                return -28;
              }
            }
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError))
              throw e;
            return -e.errno;
          }
        }
        function ___syscall_ioctl(fd, op, varargs) {
          SYSCALLS.varargs = varargs;
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            switch (op) {
              case 21509:
              case 21505: {
                if (!stream.tty)
                  return -59;
                return 0;
              }
              case 21510:
              case 21511:
              case 21512:
              case 21506:
              case 21507:
              case 21508: {
                if (!stream.tty)
                  return -59;
                return 0;
              }
              case 21519: {
                if (!stream.tty)
                  return -59;
                var argp = SYSCALLS.get();
                HEAP32[argp >>> 2] = 0;
                return 0;
              }
              case 21520: {
                if (!stream.tty)
                  return -59;
                return -28;
              }
              case 21531: {
                var argp = SYSCALLS.get();
                return FS.ioctl(stream, op, argp);
              }
              case 21523: {
                if (!stream.tty)
                  return -59;
                return 0;
              }
              case 21524: {
                if (!stream.tty)
                  return -59;
                return 0;
              }
              default:
                return -28;
            }
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError))
              throw e;
            return -e.errno;
          }
        }
        function ___syscall_openat(dirfd, path, flags, varargs) {
          SYSCALLS.varargs = varargs;
          try {
            path = SYSCALLS.getStr(path);
            path = SYSCALLS.calculateAt(dirfd, path);
            var mode = varargs ? SYSCALLS.get() : 0;
            return FS.open(path, flags, mode).fd;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError))
              throw e;
            return -e.errno;
          }
        }
        var tupleRegistrations = {};
        function runDestructors(destructors) {
          while (destructors.length) {
            var ptr = destructors.pop();
            var del = destructors.pop();
            del(ptr);
          }
        }
        function simpleReadValueFromPointer(pointer) {
          return this["fromWireType"](HEAP32[pointer >>> 2]);
        }
        var awaitingDependencies = {};
        var registeredTypes = {};
        var typeDependencies = {};
        var char_0 = 48;
        var char_9 = 57;
        function makeLegalFunctionName(name) {
          if (name === void 0) {
            return "_unknown";
          }
          name = name.replace(/[^a-zA-Z0-9_]/g, "$");
          var f = name.charCodeAt(0);
          if (f >= char_0 && f <= char_9) {
            return "_" + name;
          }
          return name;
        }
        function createNamedFunction(name, body) {
          name = makeLegalFunctionName(name);
          return new Function("body", "return function " + name + '() {\n    "use strict";    return body.apply(this, arguments);\n};\n')(body);
        }
        function extendError(baseErrorType, errorName) {
          var errorClass = createNamedFunction(errorName, function(message) {
            this.name = errorName;
            this.message = message;
            var stack = new Error(message).stack;
            if (stack !== void 0) {
              this.stack = this.toString() + "\n" + stack.replace(/^Error(:[^\n]*)?\n/, "");
            }
          });
          errorClass.prototype = Object.create(baseErrorType.prototype);
          errorClass.prototype.constructor = errorClass;
          errorClass.prototype.toString = function() {
            if (this.message === void 0) {
              return this.name;
            } else {
              return this.name + ": " + this.message;
            }
          };
          return errorClass;
        }
        var InternalError = void 0;
        function throwInternalError(message) {
          throw new InternalError(message);
        }
        function whenDependentTypesAreResolved(myTypes, dependentTypes, getTypeConverters) {
          myTypes.forEach(function(type) {
            typeDependencies[type] = dependentTypes;
          });
          function onComplete(typeConverters2) {
            var myTypeConverters = getTypeConverters(typeConverters2);
            if (myTypeConverters.length !== myTypes.length) {
              throwInternalError("Mismatched type converter count");
            }
            for (var i = 0; i < myTypes.length; ++i) {
              registerType(myTypes[i], myTypeConverters[i]);
            }
          }
          var typeConverters = new Array(dependentTypes.length);
          var unregisteredTypes = [];
          var registered = 0;
          dependentTypes.forEach((dt, i) => {
            if (registeredTypes.hasOwnProperty(dt)) {
              typeConverters[i] = registeredTypes[dt];
            } else {
              unregisteredTypes.push(dt);
              if (!awaitingDependencies.hasOwnProperty(dt)) {
                awaitingDependencies[dt] = [];
              }
              awaitingDependencies[dt].push(() => {
                typeConverters[i] = registeredTypes[dt];
                ++registered;
                if (registered === unregisteredTypes.length) {
                  onComplete(typeConverters);
                }
              });
            }
          });
          if (unregisteredTypes.length === 0) {
            onComplete(typeConverters);
          }
        }
        function __embind_finalize_value_array(rawTupleType) {
          var reg = tupleRegistrations[rawTupleType];
          delete tupleRegistrations[rawTupleType];
          var elements = reg.elements;
          var elementsLength = elements.length;
          var elementTypes = elements.map(function(elt) {
            return elt.getterReturnType;
          }).concat(elements.map(function(elt) {
            return elt.setterArgumentType;
          }));
          var rawConstructor = reg.rawConstructor;
          var rawDestructor = reg.rawDestructor;
          whenDependentTypesAreResolved([rawTupleType], elementTypes, function(elementTypes2) {
            elements.forEach((elt, i) => {
              var getterReturnType = elementTypes2[i];
              var getter = elt.getter;
              var getterContext = elt.getterContext;
              var setterArgumentType = elementTypes2[i + elementsLength];
              var setter = elt.setter;
              var setterContext = elt.setterContext;
              elt.read = (ptr) => {
                return getterReturnType["fromWireType"](getter(getterContext, ptr));
              };
              elt.write = (ptr, o) => {
                var destructors = [];
                setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                runDestructors(destructors);
              };
            });
            return [{ name: reg.name, "fromWireType": function(ptr) {
              var rv = new Array(elementsLength);
              for (var i = 0; i < elementsLength; ++i) {
                rv[i] = elements[i].read(ptr);
              }
              rawDestructor(ptr);
              return rv;
            }, "toWireType": function(destructors, o) {
              if (elementsLength !== o.length) {
                throw new TypeError("Incorrect number of tuple elements for " + reg.name + ": expected=" + elementsLength + ", actual=" + o.length);
              }
              var ptr = rawConstructor();
              for (var i = 0; i < elementsLength; ++i) {
                elements[i].write(ptr, o[i]);
              }
              if (destructors !== null) {
                destructors.push(rawDestructor, ptr);
              }
              return ptr;
            }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: rawDestructor }];
          });
        }
        var structRegistrations = {};
        function __embind_finalize_value_object(structType) {
          var reg = structRegistrations[structType];
          delete structRegistrations[structType];
          var rawConstructor = reg.rawConstructor;
          var rawDestructor = reg.rawDestructor;
          var fieldRecords = reg.fields;
          var fieldTypes = fieldRecords.map((field) => field.getterReturnType).concat(fieldRecords.map((field) => field.setterArgumentType));
          whenDependentTypesAreResolved([structType], fieldTypes, (fieldTypes2) => {
            var fields = {};
            fieldRecords.forEach((field, i) => {
              var fieldName = field.fieldName;
              var getterReturnType = fieldTypes2[i];
              var getter = field.getter;
              var getterContext = field.getterContext;
              var setterArgumentType = fieldTypes2[i + fieldRecords.length];
              var setter = field.setter;
              var setterContext = field.setterContext;
              fields[fieldName] = { read: (ptr) => {
                return getterReturnType["fromWireType"](getter(getterContext, ptr));
              }, write: (ptr, o) => {
                var destructors = [];
                setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                runDestructors(destructors);
              } };
            });
            return [{ name: reg.name, "fromWireType": function(ptr) {
              var rv = {};
              for (var i in fields) {
                rv[i] = fields[i].read(ptr);
              }
              rawDestructor(ptr);
              return rv;
            }, "toWireType": function(destructors, o) {
              for (var fieldName in fields) {
                if (!(fieldName in o)) {
                  throw new TypeError('Missing field:  "' + fieldName + '"');
                }
              }
              var ptr = rawConstructor();
              for (fieldName in fields) {
                fields[fieldName].write(ptr, o[fieldName]);
              }
              if (destructors !== null) {
                destructors.push(rawDestructor, ptr);
              }
              return ptr;
            }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: rawDestructor }];
          });
        }
        function __embind_register_bigint(primitiveType, name, size, minRange, maxRange) {
        }
        function getShiftFromSize(size) {
          switch (size) {
            case 1:
              return 0;
            case 2:
              return 1;
            case 4:
              return 2;
            case 8:
              return 3;
            default:
              throw new TypeError("Unknown type size: " + size);
          }
        }
        function embind_init_charCodes() {
          var codes = new Array(256);
          for (var i = 0; i < 256; ++i) {
            codes[i] = String.fromCharCode(i);
          }
          embind_charCodes = codes;
        }
        var embind_charCodes = void 0;
        function readLatin1String(ptr) {
          var ret = "";
          var c = ptr;
          while (HEAPU8[c >>> 0]) {
            ret += embind_charCodes[HEAPU8[c++ >>> 0]];
          }
          return ret;
        }
        var BindingError = void 0;
        function throwBindingError(message) {
          throw new BindingError(message);
        }
        function registerType(rawType, registeredInstance, options = {}) {
          if (!("argPackAdvance" in registeredInstance)) {
            throw new TypeError("registerType registeredInstance requires argPackAdvance");
          }
          var name = registeredInstance.name;
          if (!rawType) {
            throwBindingError('type "' + name + '" must have a positive integer typeid pointer');
          }
          if (registeredTypes.hasOwnProperty(rawType)) {
            if (options.ignoreDuplicateRegistrations) {
              return;
            } else {
              throwBindingError("Cannot register type '" + name + "' twice");
            }
          }
          registeredTypes[rawType] = registeredInstance;
          delete typeDependencies[rawType];
          if (awaitingDependencies.hasOwnProperty(rawType)) {
            var callbacks = awaitingDependencies[rawType];
            delete awaitingDependencies[rawType];
            callbacks.forEach((cb) => cb());
          }
        }
        function __embind_register_bool(rawType, name, size, trueValue, falseValue) {
          var shift = getShiftFromSize(size);
          name = readLatin1String(name);
          registerType(rawType, { name, "fromWireType": function(wt) {
            return !!wt;
          }, "toWireType": function(destructors, o) {
            return o ? trueValue : falseValue;
          }, "argPackAdvance": 8, "readValueFromPointer": function(pointer) {
            var heap;
            if (size === 1) {
              heap = HEAP8;
            } else if (size === 2) {
              heap = HEAP16;
            } else if (size === 4) {
              heap = HEAP32;
            } else {
              throw new TypeError("Unknown boolean type size: " + name);
            }
            return this["fromWireType"](heap[pointer >>> shift]);
          }, destructorFunction: null });
        }
        function ClassHandle_isAliasOf(other) {
          if (!(this instanceof ClassHandle)) {
            return false;
          }
          if (!(other instanceof ClassHandle)) {
            return false;
          }
          var leftClass = this.$$.ptrType.registeredClass;
          var left = this.$$.ptr;
          var rightClass = other.$$.ptrType.registeredClass;
          var right = other.$$.ptr;
          while (leftClass.baseClass) {
            left = leftClass.upcast(left);
            leftClass = leftClass.baseClass;
          }
          while (rightClass.baseClass) {
            right = rightClass.upcast(right);
            rightClass = rightClass.baseClass;
          }
          return leftClass === rightClass && left === right;
        }
        function shallowCopyInternalPointer(o) {
          return { count: o.count, deleteScheduled: o.deleteScheduled, preservePointerOnDelete: o.preservePointerOnDelete, ptr: o.ptr, ptrType: o.ptrType, smartPtr: o.smartPtr, smartPtrType: o.smartPtrType };
        }
        function throwInstanceAlreadyDeleted(obj) {
          function getInstanceTypeName(handle) {
            return handle.$$.ptrType.registeredClass.name;
          }
          throwBindingError(getInstanceTypeName(obj) + " instance already deleted");
        }
        var finalizationRegistry = false;
        function detachFinalizer(handle) {
        }
        function runDestructor($$) {
          if ($$.smartPtr) {
            $$.smartPtrType.rawDestructor($$.smartPtr);
          } else {
            $$.ptrType.registeredClass.rawDestructor($$.ptr);
          }
        }
        function releaseClassHandle($$) {
          $$.count.value -= 1;
          var toDelete = $$.count.value === 0;
          if (toDelete) {
            runDestructor($$);
          }
        }
        function downcastPointer(ptr, ptrClass, desiredClass) {
          if (ptrClass === desiredClass) {
            return ptr;
          }
          if (desiredClass.baseClass === void 0) {
            return null;
          }
          var rv = downcastPointer(ptr, ptrClass, desiredClass.baseClass);
          if (rv === null) {
            return null;
          }
          return desiredClass.downcast(rv);
        }
        var registeredPointers = {};
        function getInheritedInstanceCount() {
          return Object.keys(registeredInstances).length;
        }
        function getLiveInheritedInstances() {
          var rv = [];
          for (var k in registeredInstances) {
            if (registeredInstances.hasOwnProperty(k)) {
              rv.push(registeredInstances[k]);
            }
          }
          return rv;
        }
        var deletionQueue = [];
        function flushPendingDeletes() {
          while (deletionQueue.length) {
            var obj = deletionQueue.pop();
            obj.$$.deleteScheduled = false;
            obj["delete"]();
          }
        }
        var delayFunction = void 0;
        function setDelayFunction(fn) {
          delayFunction = fn;
          if (deletionQueue.length && delayFunction) {
            delayFunction(flushPendingDeletes);
          }
        }
        function init_embind() {
          Module["getInheritedInstanceCount"] = getInheritedInstanceCount;
          Module["getLiveInheritedInstances"] = getLiveInheritedInstances;
          Module["flushPendingDeletes"] = flushPendingDeletes;
          Module["setDelayFunction"] = setDelayFunction;
        }
        var registeredInstances = {};
        function getBasestPointer(class_, ptr) {
          if (ptr === void 0) {
            throwBindingError("ptr should not be undefined");
          }
          while (class_.baseClass) {
            ptr = class_.upcast(ptr);
            class_ = class_.baseClass;
          }
          return ptr;
        }
        function getInheritedInstance(class_, ptr) {
          ptr = getBasestPointer(class_, ptr);
          return registeredInstances[ptr];
        }
        function makeClassHandle(prototype, record) {
          if (!record.ptrType || !record.ptr) {
            throwInternalError("makeClassHandle requires ptr and ptrType");
          }
          var hasSmartPtrType = !!record.smartPtrType;
          var hasSmartPtr = !!record.smartPtr;
          if (hasSmartPtrType !== hasSmartPtr) {
            throwInternalError("Both smartPtrType and smartPtr must be specified");
          }
          record.count = { value: 1 };
          return attachFinalizer(Object.create(prototype, { $$: { value: record } }));
        }
        function RegisteredPointer_fromWireType(ptr) {
          var rawPointer = this.getPointee(ptr);
          if (!rawPointer) {
            this.destructor(ptr);
            return null;
          }
          var registeredInstance = getInheritedInstance(this.registeredClass, rawPointer);
          if (registeredInstance !== void 0) {
            if (registeredInstance.$$.count.value === 0) {
              registeredInstance.$$.ptr = rawPointer;
              registeredInstance.$$.smartPtr = ptr;
              return registeredInstance["clone"]();
            } else {
              var rv = registeredInstance["clone"]();
              this.destructor(ptr);
              return rv;
            }
          }
          function makeDefaultHandle() {
            if (this.isSmartPointer) {
              return makeClassHandle(this.registeredClass.instancePrototype, { ptrType: this.pointeeType, ptr: rawPointer, smartPtrType: this, smartPtr: ptr });
            } else {
              return makeClassHandle(this.registeredClass.instancePrototype, { ptrType: this, ptr });
            }
          }
          var actualType = this.registeredClass.getActualType(rawPointer);
          var registeredPointerRecord = registeredPointers[actualType];
          if (!registeredPointerRecord) {
            return makeDefaultHandle.call(this);
          }
          var toType;
          if (this.isConst) {
            toType = registeredPointerRecord.constPointerType;
          } else {
            toType = registeredPointerRecord.pointerType;
          }
          var dp = downcastPointer(rawPointer, this.registeredClass, toType.registeredClass);
          if (dp === null) {
            return makeDefaultHandle.call(this);
          }
          if (this.isSmartPointer) {
            return makeClassHandle(toType.registeredClass.instancePrototype, { ptrType: toType, ptr: dp, smartPtrType: this, smartPtr: ptr });
          } else {
            return makeClassHandle(toType.registeredClass.instancePrototype, { ptrType: toType, ptr: dp });
          }
        }
        function attachFinalizer(handle) {
          if (typeof FinalizationRegistry === "undefined") {
            attachFinalizer = (handle2) => handle2;
            return handle;
          }
          finalizationRegistry = new FinalizationRegistry((info) => {
            releaseClassHandle(info.$$);
          });
          attachFinalizer = (handle2) => {
            var $$ = handle2.$$;
            var hasSmartPtr = !!$$.smartPtr;
            if (hasSmartPtr) {
              var info = { $$ };
              finalizationRegistry.register(handle2, info, handle2);
            }
            return handle2;
          };
          detachFinalizer = (handle2) => finalizationRegistry.unregister(handle2);
          return attachFinalizer(handle);
        }
        function ClassHandle_clone() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }
          if (this.$$.preservePointerOnDelete) {
            this.$$.count.value += 1;
            return this;
          } else {
            var clone = attachFinalizer(Object.create(Object.getPrototypeOf(this), { $$: { value: shallowCopyInternalPointer(this.$$) } }));
            clone.$$.count.value += 1;
            clone.$$.deleteScheduled = false;
            return clone;
          }
        }
        function ClassHandle_delete() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }
          if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
            throwBindingError("Object already scheduled for deletion");
          }
          detachFinalizer(this);
          releaseClassHandle(this.$$);
          if (!this.$$.preservePointerOnDelete) {
            this.$$.smartPtr = void 0;
            this.$$.ptr = void 0;
          }
        }
        function ClassHandle_isDeleted() {
          return !this.$$.ptr;
        }
        function ClassHandle_deleteLater() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }
          if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
            throwBindingError("Object already scheduled for deletion");
          }
          deletionQueue.push(this);
          if (deletionQueue.length === 1 && delayFunction) {
            delayFunction(flushPendingDeletes);
          }
          this.$$.deleteScheduled = true;
          return this;
        }
        function init_ClassHandle() {
          ClassHandle.prototype["isAliasOf"] = ClassHandle_isAliasOf;
          ClassHandle.prototype["clone"] = ClassHandle_clone;
          ClassHandle.prototype["delete"] = ClassHandle_delete;
          ClassHandle.prototype["isDeleted"] = ClassHandle_isDeleted;
          ClassHandle.prototype["deleteLater"] = ClassHandle_deleteLater;
        }
        function ClassHandle() {
        }
        function ensureOverloadTable(proto, methodName, humanName) {
          if (proto[methodName].overloadTable === void 0) {
            var prevFunc = proto[methodName];
            proto[methodName] = function() {
              if (!proto[methodName].overloadTable.hasOwnProperty(arguments.length)) {
                throwBindingError("Function '" + humanName + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + proto[methodName].overloadTable + ")!");
              }
              return proto[methodName].overloadTable[arguments.length].apply(this, arguments);
            };
            proto[methodName].overloadTable = [];
            proto[methodName].overloadTable[prevFunc.argCount] = prevFunc;
          }
        }
        function exposePublicSymbol(name, value, numArguments) {
          if (Module.hasOwnProperty(name)) {
            if (numArguments === void 0 || Module[name].overloadTable !== void 0 && Module[name].overloadTable[numArguments] !== void 0) {
              throwBindingError("Cannot register public name '" + name + "' twice");
            }
            ensureOverloadTable(Module, name, name);
            if (Module.hasOwnProperty(numArguments)) {
              throwBindingError("Cannot register multiple overloads of a function with the same number of arguments (" + numArguments + ")!");
            }
            Module[name].overloadTable[numArguments] = value;
          } else {
            Module[name] = value;
            if (numArguments !== void 0) {
              Module[name].numArguments = numArguments;
            }
          }
        }
        function RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast) {
          this.name = name;
          this.constructor = constructor;
          this.instancePrototype = instancePrototype;
          this.rawDestructor = rawDestructor;
          this.baseClass = baseClass;
          this.getActualType = getActualType;
          this.upcast = upcast;
          this.downcast = downcast;
          this.pureVirtualFunctions = [];
        }
        function upcastPointer(ptr, ptrClass, desiredClass) {
          while (ptrClass !== desiredClass) {
            if (!ptrClass.upcast) {
              throwBindingError("Expected null or instance of " + desiredClass.name + ", got an instance of " + ptrClass.name);
            }
            ptr = ptrClass.upcast(ptr);
            ptrClass = ptrClass.baseClass;
          }
          return ptr;
        }
        function constNoSmartPtrRawPointerToWireType(destructors, handle) {
          if (handle === null) {
            if (this.isReference) {
              throwBindingError("null is not a valid " + this.name);
            }
            return 0;
          }
          if (!handle.$$) {
            throwBindingError('Cannot pass "' + embindRepr(handle) + '" as a ' + this.name);
          }
          if (!handle.$$.ptr) {
            throwBindingError("Cannot pass deleted object as a pointer of type " + this.name);
          }
          var handleClass = handle.$$.ptrType.registeredClass;
          var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
          return ptr;
        }
        function genericPointerToWireType(destructors, handle) {
          var ptr;
          if (handle === null) {
            if (this.isReference) {
              throwBindingError("null is not a valid " + this.name);
            }
            if (this.isSmartPointer) {
              ptr = this.rawConstructor();
              if (destructors !== null) {
                destructors.push(this.rawDestructor, ptr);
              }
              return ptr;
            } else {
              return 0;
            }
          }
          if (!handle.$$) {
            throwBindingError('Cannot pass "' + embindRepr(handle) + '" as a ' + this.name);
          }
          if (!handle.$$.ptr) {
            throwBindingError("Cannot pass deleted object as a pointer of type " + this.name);
          }
          if (!this.isConst && handle.$$.ptrType.isConst) {
            throwBindingError("Cannot convert argument of type " + (handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name) + " to parameter type " + this.name);
          }
          var handleClass = handle.$$.ptrType.registeredClass;
          ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
          if (this.isSmartPointer) {
            if (handle.$$.smartPtr === void 0) {
              throwBindingError("Passing raw pointer to smart pointer is illegal");
            }
            switch (this.sharingPolicy) {
              case 0:
                if (handle.$$.smartPtrType === this) {
                  ptr = handle.$$.smartPtr;
                } else {
                  throwBindingError("Cannot convert argument of type " + (handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name) + " to parameter type " + this.name);
                }
                break;
              case 1:
                ptr = handle.$$.smartPtr;
                break;
              case 2:
                if (handle.$$.smartPtrType === this) {
                  ptr = handle.$$.smartPtr;
                } else {
                  var clonedHandle = handle["clone"]();
                  ptr = this.rawShare(ptr, Emval.toHandle(function() {
                    clonedHandle["delete"]();
                  }));
                  if (destructors !== null) {
                    destructors.push(this.rawDestructor, ptr);
                  }
                }
                break;
              default:
                throwBindingError("Unsupporting sharing policy");
            }
          }
          return ptr;
        }
        function nonConstNoSmartPtrRawPointerToWireType(destructors, handle) {
          if (handle === null) {
            if (this.isReference) {
              throwBindingError("null is not a valid " + this.name);
            }
            return 0;
          }
          if (!handle.$$) {
            throwBindingError('Cannot pass "' + embindRepr(handle) + '" as a ' + this.name);
          }
          if (!handle.$$.ptr) {
            throwBindingError("Cannot pass deleted object as a pointer of type " + this.name);
          }
          if (handle.$$.ptrType.isConst) {
            throwBindingError("Cannot convert argument of type " + handle.$$.ptrType.name + " to parameter type " + this.name);
          }
          var handleClass = handle.$$.ptrType.registeredClass;
          var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
          return ptr;
        }
        function RegisteredPointer_getPointee(ptr) {
          if (this.rawGetPointee) {
            ptr = this.rawGetPointee(ptr);
          }
          return ptr;
        }
        function RegisteredPointer_destructor(ptr) {
          if (this.rawDestructor) {
            this.rawDestructor(ptr);
          }
        }
        function RegisteredPointer_deleteObject(handle) {
          if (handle !== null) {
            handle["delete"]();
          }
        }
        function init_RegisteredPointer() {
          RegisteredPointer.prototype.getPointee = RegisteredPointer_getPointee;
          RegisteredPointer.prototype.destructor = RegisteredPointer_destructor;
          RegisteredPointer.prototype["argPackAdvance"] = 8;
          RegisteredPointer.prototype["readValueFromPointer"] = simpleReadValueFromPointer;
          RegisteredPointer.prototype["deleteObject"] = RegisteredPointer_deleteObject;
          RegisteredPointer.prototype["fromWireType"] = RegisteredPointer_fromWireType;
        }
        function RegisteredPointer(name, registeredClass, isReference, isConst, isSmartPointer, pointeeType, sharingPolicy, rawGetPointee, rawConstructor, rawShare, rawDestructor) {
          this.name = name;
          this.registeredClass = registeredClass;
          this.isReference = isReference;
          this.isConst = isConst;
          this.isSmartPointer = isSmartPointer;
          this.pointeeType = pointeeType;
          this.sharingPolicy = sharingPolicy;
          this.rawGetPointee = rawGetPointee;
          this.rawConstructor = rawConstructor;
          this.rawShare = rawShare;
          this.rawDestructor = rawDestructor;
          if (!isSmartPointer && registeredClass.baseClass === void 0) {
            if (isConst) {
              this["toWireType"] = constNoSmartPtrRawPointerToWireType;
              this.destructorFunction = null;
            } else {
              this["toWireType"] = nonConstNoSmartPtrRawPointerToWireType;
              this.destructorFunction = null;
            }
          } else {
            this["toWireType"] = genericPointerToWireType;
          }
        }
        function replacePublicSymbol(name, value, numArguments) {
          if (!Module.hasOwnProperty(name)) {
            throwInternalError("Replacing nonexistant public symbol");
          }
          if (Module[name].overloadTable !== void 0 && numArguments !== void 0) {
            Module[name].overloadTable[numArguments] = value;
          } else {
            Module[name] = value;
            Module[name].argCount = numArguments;
          }
        }
        function dynCallLegacy(sig, ptr, args) {
          var f = Module["dynCall_" + sig];
          return args && args.length ? f.apply(null, [ptr].concat(args)) : f.call(null, ptr);
        }
        var wasmTableMirror = [];
        function getWasmTableEntry(funcPtr) {
          var func = wasmTableMirror[funcPtr];
          if (!func) {
            if (funcPtr >= wasmTableMirror.length)
              wasmTableMirror.length = funcPtr + 1;
            wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);
          }
          return func;
        }
        function dynCall(sig, ptr, args) {
          if (sig.includes("j")) {
            return dynCallLegacy(sig, ptr, args);
          }
          var rtn = getWasmTableEntry(ptr).apply(null, args);
          return rtn;
        }
        function getDynCaller(sig, ptr) {
          var argCache = [];
          return function() {
            argCache.length = 0;
            Object.assign(argCache, arguments);
            return dynCall(sig, ptr, argCache);
          };
        }
        function embind__requireFunction(signature, rawFunction) {
          signature = readLatin1String(signature);
          function makeDynCaller() {
            if (signature.includes("j")) {
              return getDynCaller(signature, rawFunction);
            }
            return getWasmTableEntry(rawFunction);
          }
          var fp = makeDynCaller();
          if (typeof fp != "function") {
            throwBindingError("unknown function pointer with signature " + signature + ": " + rawFunction);
          }
          return fp;
        }
        var UnboundTypeError = void 0;
        function getTypeName(type) {
          var ptr = ___getTypeName(type);
          var rv = readLatin1String(ptr);
          _free(ptr);
          return rv;
        }
        function throwUnboundTypeError(message, types) {
          var unboundTypes = [];
          var seen = {};
          function visit(type) {
            if (seen[type]) {
              return;
            }
            if (registeredTypes[type]) {
              return;
            }
            if (typeDependencies[type]) {
              typeDependencies[type].forEach(visit);
              return;
            }
            unboundTypes.push(type);
            seen[type] = true;
          }
          types.forEach(visit);
          throw new UnboundTypeError(message + ": " + unboundTypes.map(getTypeName).join([", "]));
        }
        function __embind_register_class(rawType, rawPointerType, rawConstPointerType, baseClassRawType, getActualTypeSignature, getActualType, upcastSignature, upcast, downcastSignature, downcast, name, destructorSignature, rawDestructor) {
          name = readLatin1String(name);
          getActualType = embind__requireFunction(getActualTypeSignature, getActualType);
          if (upcast) {
            upcast = embind__requireFunction(upcastSignature, upcast);
          }
          if (downcast) {
            downcast = embind__requireFunction(downcastSignature, downcast);
          }
          rawDestructor = embind__requireFunction(destructorSignature, rawDestructor);
          var legalFunctionName = makeLegalFunctionName(name);
          exposePublicSymbol(legalFunctionName, function() {
            throwUnboundTypeError("Cannot construct " + name + " due to unbound types", [baseClassRawType]);
          });
          whenDependentTypesAreResolved([rawType, rawPointerType, rawConstPointerType], baseClassRawType ? [baseClassRawType] : [], function(base) {
            base = base[0];
            var baseClass;
            var basePrototype;
            if (baseClassRawType) {
              baseClass = base.registeredClass;
              basePrototype = baseClass.instancePrototype;
            } else {
              basePrototype = ClassHandle.prototype;
            }
            var constructor = createNamedFunction(legalFunctionName, function() {
              if (Object.getPrototypeOf(this) !== instancePrototype) {
                throw new BindingError("Use 'new' to construct " + name);
              }
              if (registeredClass.constructor_body === void 0) {
                throw new BindingError(name + " has no accessible constructor");
              }
              var body = registeredClass.constructor_body[arguments.length];
              if (body === void 0) {
                throw new BindingError("Tried to invoke ctor of " + name + " with invalid number of parameters (" + arguments.length + ") - expected (" + Object.keys(registeredClass.constructor_body).toString() + ") parameters instead!");
              }
              return body.apply(this, arguments);
            });
            var instancePrototype = Object.create(basePrototype, { constructor: { value: constructor } });
            constructor.prototype = instancePrototype;
            var registeredClass = new RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast);
            var referenceConverter = new RegisteredPointer(name, registeredClass, true, false, false);
            var pointerConverter = new RegisteredPointer(name + "*", registeredClass, false, false, false);
            var constPointerConverter = new RegisteredPointer(name + " const*", registeredClass, false, true, false);
            registeredPointers[rawType] = { pointerType: pointerConverter, constPointerType: constPointerConverter };
            replacePublicSymbol(legalFunctionName, constructor);
            return [referenceConverter, pointerConverter, constPointerConverter];
          });
        }
        function heap32VectorToArray(count, firstElement) {
          var array = [];
          for (var i = 0; i < count; i++) {
            array.push(HEAPU32[firstElement + i * 4 >>> 2]);
          }
          return array;
        }
        function new_(constructor, argumentList) {
          if (!(constructor instanceof Function)) {
            throw new TypeError("new_ called with constructor type " + typeof constructor + " which is not a function");
          }
          var dummy = createNamedFunction(constructor.name || "unknownFunctionName", function() {
          });
          dummy.prototype = constructor.prototype;
          var obj = new dummy();
          var r = constructor.apply(obj, argumentList);
          return r instanceof Object ? r : obj;
        }
        function craftInvokerFunction(humanName, argTypes, classType, cppInvokerFunc, cppTargetFunc) {
          var argCount = argTypes.length;
          if (argCount < 2) {
            throwBindingError("argTypes array size mismatch! Must at least get return value and 'this' types!");
          }
          var isClassMethodFunc = argTypes[1] !== null && classType !== null;
          var needsDestructorStack = false;
          for (var i = 1; i < argTypes.length; ++i) {
            if (argTypes[i] !== null && argTypes[i].destructorFunction === void 0) {
              needsDestructorStack = true;
              break;
            }
          }
          var returns = argTypes[0].name !== "void";
          var argsList = "";
          var argsListWired = "";
          for (var i = 0; i < argCount - 2; ++i) {
            argsList += (i !== 0 ? ", " : "") + "arg" + i;
            argsListWired += (i !== 0 ? ", " : "") + "arg" + i + "Wired";
          }
          var invokerFnBody = "return function " + makeLegalFunctionName(humanName) + "(" + argsList + ") {\nif (arguments.length !== " + (argCount - 2) + ") {\nthrowBindingError('function " + humanName + " called with ' + arguments.length + ' arguments, expected " + (argCount - 2) + " args!');\n}\n";
          if (needsDestructorStack) {
            invokerFnBody += "var destructors = [];\n";
          }
          var dtorStack = needsDestructorStack ? "destructors" : "null";
          var args1 = ["throwBindingError", "invoker", "fn", "runDestructors", "retType", "classParam"];
          var args2 = [throwBindingError, cppInvokerFunc, cppTargetFunc, runDestructors, argTypes[0], argTypes[1]];
          if (isClassMethodFunc) {
            invokerFnBody += "var thisWired = classParam.toWireType(" + dtorStack + ", this);\n";
          }
          for (var i = 0; i < argCount - 2; ++i) {
            invokerFnBody += "var arg" + i + "Wired = argType" + i + ".toWireType(" + dtorStack + ", arg" + i + "); // " + argTypes[i + 2].name + "\n";
            args1.push("argType" + i);
            args2.push(argTypes[i + 2]);
          }
          if (isClassMethodFunc) {
            argsListWired = "thisWired" + (argsListWired.length > 0 ? ", " : "") + argsListWired;
          }
          invokerFnBody += (returns ? "var rv = " : "") + "invoker(fn" + (argsListWired.length > 0 ? ", " : "") + argsListWired + ");\n";
          if (needsDestructorStack) {
            invokerFnBody += "runDestructors(destructors);\n";
          } else {
            for (var i = isClassMethodFunc ? 1 : 2; i < argTypes.length; ++i) {
              var paramName = i === 1 ? "thisWired" : "arg" + (i - 2) + "Wired";
              if (argTypes[i].destructorFunction !== null) {
                invokerFnBody += paramName + "_dtor(" + paramName + "); // " + argTypes[i].name + "\n";
                args1.push(paramName + "_dtor");
                args2.push(argTypes[i].destructorFunction);
              }
            }
          }
          if (returns) {
            invokerFnBody += "var ret = retType.fromWireType(rv);\nreturn ret;\n";
          } else {
          }
          invokerFnBody += "}\n";
          args1.push(invokerFnBody);
          var invokerFunction = new_(Function, args1).apply(null, args2);
          return invokerFunction;
        }
        function __embind_register_class_constructor(rawClassType, argCount, rawArgTypesAddr, invokerSignature, invoker, rawConstructor) {
          assert(argCount > 0);
          var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          invoker = embind__requireFunction(invokerSignature, invoker);
          whenDependentTypesAreResolved([], [rawClassType], function(classType) {
            classType = classType[0];
            var humanName = "constructor " + classType.name;
            if (classType.registeredClass.constructor_body === void 0) {
              classType.registeredClass.constructor_body = [];
            }
            if (classType.registeredClass.constructor_body[argCount - 1] !== void 0) {
              throw new BindingError("Cannot register multiple constructors with identical number of parameters (" + (argCount - 1) + ") for class '" + classType.name + "'! Overload resolution is currently only performed using the parameter count, not actual type info!");
            }
            classType.registeredClass.constructor_body[argCount - 1] = () => {
              throwUnboundTypeError("Cannot construct " + classType.name + " due to unbound types", rawArgTypes);
            };
            whenDependentTypesAreResolved([], rawArgTypes, function(argTypes) {
              argTypes.splice(1, 0, null);
              classType.registeredClass.constructor_body[argCount - 1] = craftInvokerFunction(humanName, argTypes, null, invoker, rawConstructor);
              return [];
            });
            return [];
          });
        }
        function __embind_register_class_function(rawClassType, methodName, argCount, rawArgTypesAddr, invokerSignature, rawInvoker, context, isPureVirtual) {
          var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          methodName = readLatin1String(methodName);
          rawInvoker = embind__requireFunction(invokerSignature, rawInvoker);
          whenDependentTypesAreResolved([], [rawClassType], function(classType) {
            classType = classType[0];
            var humanName = classType.name + "." + methodName;
            if (methodName.startsWith("@@")) {
              methodName = Symbol[methodName.substring(2)];
            }
            if (isPureVirtual) {
              classType.registeredClass.pureVirtualFunctions.push(methodName);
            }
            function unboundTypesHandler() {
              throwUnboundTypeError("Cannot call " + humanName + " due to unbound types", rawArgTypes);
            }
            var proto = classType.registeredClass.instancePrototype;
            var method = proto[methodName];
            if (method === void 0 || method.overloadTable === void 0 && method.className !== classType.name && method.argCount === argCount - 2) {
              unboundTypesHandler.argCount = argCount - 2;
              unboundTypesHandler.className = classType.name;
              proto[methodName] = unboundTypesHandler;
            } else {
              ensureOverloadTable(proto, methodName, humanName);
              proto[methodName].overloadTable[argCount - 2] = unboundTypesHandler;
            }
            whenDependentTypesAreResolved([], rawArgTypes, function(argTypes) {
              var memberFunction = craftInvokerFunction(humanName, argTypes, classType, rawInvoker, context);
              if (proto[methodName].overloadTable === void 0) {
                memberFunction.argCount = argCount - 2;
                proto[methodName] = memberFunction;
              } else {
                proto[methodName].overloadTable[argCount - 2] = memberFunction;
              }
              return [];
            });
            return [];
          });
        }
        var emval_free_list = [];
        var emval_handle_array = [{}, { value: void 0 }, { value: null }, { value: true }, { value: false }];
        function __emval_decref(handle) {
          if (handle > 4 && --emval_handle_array[handle].refcount === 0) {
            emval_handle_array[handle] = void 0;
            emval_free_list.push(handle);
          }
        }
        function count_emval_handles() {
          var count = 0;
          for (var i = 5; i < emval_handle_array.length; ++i) {
            if (emval_handle_array[i] !== void 0) {
              ++count;
            }
          }
          return count;
        }
        function get_first_emval() {
          for (var i = 5; i < emval_handle_array.length; ++i) {
            if (emval_handle_array[i] !== void 0) {
              return emval_handle_array[i];
            }
          }
          return null;
        }
        function init_emval() {
          Module["count_emval_handles"] = count_emval_handles;
          Module["get_first_emval"] = get_first_emval;
        }
        var Emval = { toValue: (handle) => {
          if (!handle) {
            throwBindingError("Cannot use deleted val. handle = " + handle);
          }
          return emval_handle_array[handle].value;
        }, toHandle: (value) => {
          switch (value) {
            case void 0:
              return 1;
            case null:
              return 2;
            case true:
              return 3;
            case false:
              return 4;
            default: {
              var handle = emval_free_list.length ? emval_free_list.pop() : emval_handle_array.length;
              emval_handle_array[handle] = { refcount: 1, value };
              return handle;
            }
          }
        } };
        function __embind_register_emval(rawType, name) {
          name = readLatin1String(name);
          registerType(rawType, { name, "fromWireType": function(handle) {
            var rv = Emval.toValue(handle);
            __emval_decref(handle);
            return rv;
          }, "toWireType": function(destructors, value) {
            return Emval.toHandle(value);
          }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: null });
        }
        function enumReadValueFromPointer(name, shift, signed) {
          switch (shift) {
            case 0:
              return function(pointer) {
                var heap = signed ? HEAP8 : HEAPU8;
                return this["fromWireType"](heap[pointer >>> 0]);
              };
            case 1:
              return function(pointer) {
                var heap = signed ? HEAP16 : HEAPU16;
                return this["fromWireType"](heap[pointer >>> 1]);
              };
            case 2:
              return function(pointer) {
                var heap = signed ? HEAP32 : HEAPU32;
                return this["fromWireType"](heap[pointer >>> 2]);
              };
            default:
              throw new TypeError("Unknown integer type: " + name);
          }
        }
        function __embind_register_enum(rawType, name, size, isSigned) {
          var shift = getShiftFromSize(size);
          name = readLatin1String(name);
          function ctor() {
          }
          ctor.values = {};
          registerType(rawType, { name, constructor: ctor, "fromWireType": function(c) {
            return this.constructor.values[c];
          }, "toWireType": function(destructors, c) {
            return c.value;
          }, "argPackAdvance": 8, "readValueFromPointer": enumReadValueFromPointer(name, shift, isSigned), destructorFunction: null });
          exposePublicSymbol(name, ctor);
        }
        function requireRegisteredType(rawType, humanName) {
          var impl = registeredTypes[rawType];
          if (impl === void 0) {
            throwBindingError(humanName + " has unknown type " + getTypeName(rawType));
          }
          return impl;
        }
        function __embind_register_enum_value(rawEnumType, name, enumValue) {
          var enumType = requireRegisteredType(rawEnumType, "enum");
          name = readLatin1String(name);
          var Enum = enumType.constructor;
          var Value = Object.create(enumType.constructor.prototype, { value: { value: enumValue }, constructor: { value: createNamedFunction(enumType.name + "_" + name, function() {
          }) } });
          Enum.values[enumValue] = Value;
          Enum[name] = Value;
        }
        function embindRepr(v) {
          if (v === null) {
            return "null";
          }
          var t = typeof v;
          if (t === "object" || t === "array" || t === "function") {
            return v.toString();
          } else {
            return "" + v;
          }
        }
        function floatReadValueFromPointer(name, shift) {
          switch (shift) {
            case 2:
              return function(pointer) {
                return this["fromWireType"](HEAPF32[pointer >>> 2]);
              };
            case 3:
              return function(pointer) {
                return this["fromWireType"](HEAPF64[pointer >>> 3]);
              };
            default:
              throw new TypeError("Unknown float type: " + name);
          }
        }
        function __embind_register_float(rawType, name, size) {
          var shift = getShiftFromSize(size);
          name = readLatin1String(name);
          registerType(rawType, { name, "fromWireType": function(value) {
            return value;
          }, "toWireType": function(destructors, value) {
            return value;
          }, "argPackAdvance": 8, "readValueFromPointer": floatReadValueFromPointer(name, shift), destructorFunction: null });
        }
        function __embind_register_function(name, argCount, rawArgTypesAddr, signature, rawInvoker, fn) {
          var argTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          name = readLatin1String(name);
          rawInvoker = embind__requireFunction(signature, rawInvoker);
          exposePublicSymbol(name, function() {
            throwUnboundTypeError("Cannot call " + name + " due to unbound types", argTypes);
          }, argCount - 1);
          whenDependentTypesAreResolved([], argTypes, function(argTypes2) {
            var invokerArgsArray = [argTypes2[0], null].concat(argTypes2.slice(1));
            replacePublicSymbol(name, craftInvokerFunction(name, invokerArgsArray, null, rawInvoker, fn), argCount - 1);
            return [];
          });
        }
        function integerReadValueFromPointer(name, shift, signed) {
          switch (shift) {
            case 0:
              return signed ? function readS8FromPointer(pointer) {
                return HEAP8[pointer >>> 0];
              } : function readU8FromPointer(pointer) {
                return HEAPU8[pointer >>> 0];
              };
            case 1:
              return signed ? function readS16FromPointer(pointer) {
                return HEAP16[pointer >>> 1];
              } : function readU16FromPointer(pointer) {
                return HEAPU16[pointer >>> 1];
              };
            case 2:
              return signed ? function readS32FromPointer(pointer) {
                return HEAP32[pointer >>> 2];
              } : function readU32FromPointer(pointer) {
                return HEAPU32[pointer >>> 2];
              };
            default:
              throw new TypeError("Unknown integer type: " + name);
          }
        }
        function __embind_register_integer(primitiveType, name, size, minRange, maxRange) {
          name = readLatin1String(name);
          if (maxRange === -1) {
            maxRange = 4294967295;
          }
          var shift = getShiftFromSize(size);
          var fromWireType = (value) => value;
          if (minRange === 0) {
            var bitshift = 32 - 8 * size;
            fromWireType = (value) => value << bitshift >>> bitshift;
          }
          var isUnsignedType = name.includes("unsigned");
          var checkAssertions = (value, toTypeName) => {
          };
          var toWireType;
          if (isUnsignedType) {
            toWireType = function(destructors, value) {
              checkAssertions(value, this.name);
              return value >>> 0;
            };
          } else {
            toWireType = function(destructors, value) {
              checkAssertions(value, this.name);
              return value;
            };
          }
          registerType(primitiveType, { name, "fromWireType": fromWireType, "toWireType": toWireType, "argPackAdvance": 8, "readValueFromPointer": integerReadValueFromPointer(name, shift, minRange !== 0), destructorFunction: null });
        }
        function __embind_register_memory_view(rawType, dataTypeIndex, name) {
          var typeMapping = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array];
          var TA = typeMapping[dataTypeIndex];
          function decodeMemoryView(handle) {
            handle = handle >> 2;
            var heap = HEAPU32;
            var size = heap[handle >>> 0];
            var data = heap[handle + 1 >>> 0];
            return new TA(heap.buffer, data, size);
          }
          name = readLatin1String(name);
          registerType(rawType, { name, "fromWireType": decodeMemoryView, "argPackAdvance": 8, "readValueFromPointer": decodeMemoryView }, { ignoreDuplicateRegistrations: true });
        }
        function __embind_register_std_string(rawType, name) {
          name = readLatin1String(name);
          var stdStringIsUTF8 = name === "std::string";
          registerType(rawType, { name, "fromWireType": function(value) {
            var length = HEAPU32[value >>> 2];
            var payload = value + 4;
            var str;
            if (stdStringIsUTF8) {
              var decodeStartPtr = payload;
              for (var i = 0; i <= length; ++i) {
                var currentBytePtr = payload + i;
                if (i == length || HEAPU8[currentBytePtr >>> 0] == 0) {
                  var maxRead = currentBytePtr - decodeStartPtr;
                  var stringSegment = UTF8ToString(decodeStartPtr, maxRead);
                  if (str === void 0) {
                    str = stringSegment;
                  } else {
                    str += String.fromCharCode(0);
                    str += stringSegment;
                  }
                  decodeStartPtr = currentBytePtr + 1;
                }
              }
            } else {
              var a = new Array(length);
              for (var i = 0; i < length; ++i) {
                a[i] = String.fromCharCode(HEAPU8[payload + i >>> 0]);
              }
              str = a.join("");
            }
            _free(value);
            return str;
          }, "toWireType": function(destructors, value) {
            if (value instanceof ArrayBuffer) {
              value = new Uint8Array(value);
            }
            var length;
            var valueIsOfTypeString = typeof value == "string";
            if (!(valueIsOfTypeString || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Int8Array)) {
              throwBindingError("Cannot pass non-string to std::string");
            }
            if (stdStringIsUTF8 && valueIsOfTypeString) {
              length = lengthBytesUTF8(value);
            } else {
              length = value.length;
            }
            var base = _malloc(4 + length + 1);
            var ptr = base + 4;
            ptr >>>= 0;
            HEAPU32[base >>> 2] = length;
            if (stdStringIsUTF8 && valueIsOfTypeString) {
              stringToUTF8(value, ptr, length + 1);
            } else {
              if (valueIsOfTypeString) {
                for (var i = 0; i < length; ++i) {
                  var charCode = value.charCodeAt(i);
                  if (charCode > 255) {
                    _free(ptr);
                    throwBindingError("String has UTF-16 code units that do not fit in 8 bits");
                  }
                  HEAPU8[ptr + i >>> 0] = charCode;
                }
              } else {
                for (var i = 0; i < length; ++i) {
                  HEAPU8[ptr + i >>> 0] = value[i];
                }
              }
            }
            if (destructors !== null) {
              destructors.push(_free, base);
            }
            return base;
          }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: function(ptr) {
            _free(ptr);
          } });
        }
        var UTF16Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : void 0;
        function UTF16ToString(ptr, maxBytesToRead) {
          var endPtr = ptr;
          var idx = endPtr >> 1;
          var maxIdx = idx + maxBytesToRead / 2;
          while (!(idx >= maxIdx) && HEAPU16[idx >>> 0])
            ++idx;
          endPtr = idx << 1;
          if (endPtr - ptr > 32 && UTF16Decoder)
            return UTF16Decoder.decode(HEAPU8.subarray(ptr >>> 0, endPtr >>> 0));
          var str = "";
          for (var i = 0; !(i >= maxBytesToRead / 2); ++i) {
            var codeUnit = HEAP16[ptr + i * 2 >>> 1];
            if (codeUnit == 0)
              break;
            str += String.fromCharCode(codeUnit);
          }
          return str;
        }
        function stringToUTF16(str, outPtr, maxBytesToWrite) {
          if (maxBytesToWrite === void 0) {
            maxBytesToWrite = 2147483647;
          }
          if (maxBytesToWrite < 2)
            return 0;
          maxBytesToWrite -= 2;
          var startPtr = outPtr;
          var numCharsToWrite = maxBytesToWrite < str.length * 2 ? maxBytesToWrite / 2 : str.length;
          for (var i = 0; i < numCharsToWrite; ++i) {
            var codeUnit = str.charCodeAt(i);
            HEAP16[outPtr >>> 1] = codeUnit;
            outPtr += 2;
          }
          HEAP16[outPtr >>> 1] = 0;
          return outPtr - startPtr;
        }
        function lengthBytesUTF16(str) {
          return str.length * 2;
        }
        function UTF32ToString(ptr, maxBytesToRead) {
          var i = 0;
          var str = "";
          while (!(i >= maxBytesToRead / 4)) {
            var utf32 = HEAP32[ptr + i * 4 >>> 2];
            if (utf32 == 0)
              break;
            ++i;
            if (utf32 >= 65536) {
              var ch = utf32 - 65536;
              str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
            } else {
              str += String.fromCharCode(utf32);
            }
          }
          return str;
        }
        function stringToUTF32(str, outPtr, maxBytesToWrite) {
          outPtr >>>= 0;
          if (maxBytesToWrite === void 0) {
            maxBytesToWrite = 2147483647;
          }
          if (maxBytesToWrite < 4)
            return 0;
          var startPtr = outPtr;
          var endPtr = startPtr + maxBytesToWrite - 4;
          for (var i = 0; i < str.length; ++i) {
            var codeUnit = str.charCodeAt(i);
            if (codeUnit >= 55296 && codeUnit <= 57343) {
              var trailSurrogate = str.charCodeAt(++i);
              codeUnit = 65536 + ((codeUnit & 1023) << 10) | trailSurrogate & 1023;
            }
            HEAP32[outPtr >>> 2] = codeUnit;
            outPtr += 4;
            if (outPtr + 4 > endPtr)
              break;
          }
          HEAP32[outPtr >>> 2] = 0;
          return outPtr - startPtr;
        }
        function lengthBytesUTF32(str) {
          var len = 0;
          for (var i = 0; i < str.length; ++i) {
            var codeUnit = str.charCodeAt(i);
            if (codeUnit >= 55296 && codeUnit <= 57343)
              ++i;
            len += 4;
          }
          return len;
        }
        function __embind_register_std_wstring(rawType, charSize, name) {
          name = readLatin1String(name);
          var decodeString, encodeString, getHeap, lengthBytesUTF, shift;
          if (charSize === 2) {
            decodeString = UTF16ToString;
            encodeString = stringToUTF16;
            lengthBytesUTF = lengthBytesUTF16;
            getHeap = () => HEAPU16;
            shift = 1;
          } else if (charSize === 4) {
            decodeString = UTF32ToString;
            encodeString = stringToUTF32;
            lengthBytesUTF = lengthBytesUTF32;
            getHeap = () => HEAPU32;
            shift = 2;
          }
          registerType(rawType, { name, "fromWireType": function(value) {
            var length = HEAPU32[value >>> 2];
            var HEAP = getHeap();
            var str;
            var decodeStartPtr = value + 4;
            for (var i = 0; i <= length; ++i) {
              var currentBytePtr = value + 4 + i * charSize;
              if (i == length || HEAP[currentBytePtr >>> shift] == 0) {
                var maxReadBytes = currentBytePtr - decodeStartPtr;
                var stringSegment = decodeString(decodeStartPtr, maxReadBytes);
                if (str === void 0) {
                  str = stringSegment;
                } else {
                  str += String.fromCharCode(0);
                  str += stringSegment;
                }
                decodeStartPtr = currentBytePtr + charSize;
              }
            }
            _free(value);
            return str;
          }, "toWireType": function(destructors, value) {
            if (!(typeof value == "string")) {
              throwBindingError("Cannot pass non-string to C++ string type " + name);
            }
            var length = lengthBytesUTF(value);
            var ptr = _malloc(4 + length + charSize);
            ptr >>>= 0;
            HEAPU32[ptr >>> 2] = length >> shift;
            encodeString(value, ptr + 4, length + charSize);
            if (destructors !== null) {
              destructors.push(_free, ptr);
            }
            return ptr;
          }, "argPackAdvance": 8, "readValueFromPointer": simpleReadValueFromPointer, destructorFunction: function(ptr) {
            _free(ptr);
          } });
        }
        function __embind_register_value_array(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
          tupleRegistrations[rawType] = { name: readLatin1String(name), rawConstructor: embind__requireFunction(constructorSignature, rawConstructor), rawDestructor: embind__requireFunction(destructorSignature, rawDestructor), elements: [] };
        }
        function __embind_register_value_array_element(rawTupleType, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
          tupleRegistrations[rawTupleType].elements.push({ getterReturnType, getter: embind__requireFunction(getterSignature, getter), getterContext, setterArgumentType, setter: embind__requireFunction(setterSignature, setter), setterContext });
        }
        function __embind_register_value_object(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
          structRegistrations[rawType] = { name: readLatin1String(name), rawConstructor: embind__requireFunction(constructorSignature, rawConstructor), rawDestructor: embind__requireFunction(destructorSignature, rawDestructor), fields: [] };
        }
        function __embind_register_value_object_field(structType, fieldName, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
          structRegistrations[structType].fields.push({ fieldName: readLatin1String(fieldName), getterReturnType, getter: embind__requireFunction(getterSignature, getter), getterContext, setterArgumentType, setter: embind__requireFunction(setterSignature, setter), setterContext });
        }
        function __embind_register_void(rawType, name) {
          name = readLatin1String(name);
          registerType(rawType, { isVoid: true, name, "argPackAdvance": 0, "fromWireType": function() {
            return void 0;
          }, "toWireType": function(destructors, o) {
            return void 0;
          } });
        }
        function __emval_as(handle, returnType, destructorsRef) {
          handle = Emval.toValue(handle);
          returnType = requireRegisteredType(returnType, "emval::as");
          var destructors = [];
          var rd = Emval.toHandle(destructors);
          HEAPU32[destructorsRef >>> 2] = rd;
          return returnType["toWireType"](destructors, handle);
        }
        function emval_lookupTypes(argCount, argTypes) {
          var a = new Array(argCount);
          for (var i = 0; i < argCount; ++i) {
            a[i] = requireRegisteredType(HEAPU32[argTypes + i * 4 >>> 2], "parameter " + i);
          }
          return a;
        }
        function __emval_call(handle, argCount, argTypes, argv) {
          handle = Emval.toValue(handle);
          var types = emval_lookupTypes(argCount, argTypes);
          var args = new Array(argCount);
          for (var i = 0; i < argCount; ++i) {
            var type = types[i];
            args[i] = type["readValueFromPointer"](argv);
            argv += type["argPackAdvance"];
          }
          var rv = handle.apply(void 0, args);
          return Emval.toHandle(rv);
        }
        var emval_symbols = {};
        function getStringOrSymbol(address) {
          var symbol = emval_symbols[address];
          if (symbol === void 0) {
            return readLatin1String(address);
          }
          return symbol;
        }
        function emval_get_global() {
          if (typeof globalThis == "object") {
            return globalThis;
          }
          return function() {
            return Function;
          }()("return this")();
        }
        function __emval_get_global(name) {
          if (name === 0) {
            return Emval.toHandle(emval_get_global());
          } else {
            name = getStringOrSymbol(name);
            return Emval.toHandle(emval_get_global()[name]);
          }
        }
        function __emval_get_property(handle, key) {
          handle = Emval.toValue(handle);
          key = Emval.toValue(key);
          return Emval.toHandle(handle[key]);
        }
        function __emval_incref(handle) {
          if (handle > 4) {
            emval_handle_array[handle].refcount += 1;
          }
        }
        function __emval_instanceof(object, constructor) {
          object = Emval.toValue(object);
          constructor = Emval.toValue(constructor);
          return object instanceof constructor;
        }
        function __emval_is_number(handle) {
          handle = Emval.toValue(handle);
          return typeof handle == "number";
        }
        function __emval_new_array() {
          return Emval.toHandle([]);
        }
        function __emval_new_cstring(v) {
          return Emval.toHandle(getStringOrSymbol(v));
        }
        function __emval_new_object() {
          return Emval.toHandle({});
        }
        function __emval_run_destructors(handle) {
          var destructors = Emval.toValue(handle);
          runDestructors(destructors);
          __emval_decref(handle);
        }
        function __emval_set_property(handle, key, value) {
          handle = Emval.toValue(handle);
          key = Emval.toValue(key);
          value = Emval.toValue(value);
          handle[key] = value;
        }
        function __emval_take_value(type, arg) {
          type = requireRegisteredType(type, "_emval_take_value");
          var v = type["readValueFromPointer"](arg);
          return Emval.toHandle(v);
        }
        function _abort() {
          abort("");
        }
        function _emscripten_memcpy_big(dest, src, num) {
          HEAPU8.copyWithin(dest >>> 0, src >>> 0, src + num >>> 0);
        }
        function getHeapMax() {
          return 4294901760;
        }
        function emscripten_realloc_buffer(size) {
          var b = wasmMemory.buffer;
          try {
            wasmMemory.grow(size - b.byteLength + 65535 >>> 16);
            updateMemoryViews();
            return 1;
          } catch (e) {
          }
        }
        function _emscripten_resize_heap(requestedSize) {
          var oldSize = HEAPU8.length;
          requestedSize = requestedSize >>> 0;
          var maxHeapSize = getHeapMax();
          if (requestedSize > maxHeapSize) {
            return false;
          }
          let alignUp = (x, multiple) => x + (multiple - x % multiple) % multiple;
          for (var cutDown = 1; cutDown <= 4; cutDown *= 2) {
            var overGrownHeapSize = oldSize * (1 + 0.2 / cutDown);
            overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
            var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
            var replacement = emscripten_realloc_buffer(newSize);
            if (replacement) {
              return true;
            }
          }
          return false;
        }
        var ENV = {};
        function getExecutableName() {
          return thisProgram || "./this.program";
        }
        function getEnvStrings() {
          if (!getEnvStrings.strings) {
            var lang = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8";
            var env = { "USER": "web_user", "LOGNAME": "web_user", "PATH": "/", "PWD": "/", "HOME": "/home/web_user", "LANG": lang, "_": getExecutableName() };
            for (var x in ENV) {
              if (ENV[x] === void 0)
                delete env[x];
              else
                env[x] = ENV[x];
            }
            var strings = [];
            for (var x in env) {
              strings.push(x + "=" + env[x]);
            }
            getEnvStrings.strings = strings;
          }
          return getEnvStrings.strings;
        }
        function writeAsciiToMemory(str, buffer, dontAddNull) {
          for (var i = 0; i < str.length; ++i) {
            HEAP8[buffer++ >>> 0] = str.charCodeAt(i);
          }
          if (!dontAddNull)
            HEAP8[buffer >>> 0] = 0;
        }
        function _environ_get(__environ, environ_buf) {
          var bufSize = 0;
          getEnvStrings().forEach(function(string, i) {
            var ptr = environ_buf + bufSize;
            HEAPU32[__environ + i * 4 >>> 2] = ptr;
            writeAsciiToMemory(string, ptr);
            bufSize += string.length + 1;
          });
          return 0;
        }
        function _environ_sizes_get(penviron_count, penviron_buf_size) {
          var strings = getEnvStrings();
          HEAPU32[penviron_count >>> 2] = strings.length;
          var bufSize = 0;
          strings.forEach(function(string) {
            bufSize += string.length + 1;
          });
          HEAPU32[penviron_buf_size >>> 2] = bufSize;
          return 0;
        }
        function _fd_close(fd) {
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            FS.close(stream);
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError))
              throw e;
            return e.errno;
          }
        }
        function doReadv(stream, iov, iovcnt, offset) {
          var ret = 0;
          for (var i = 0; i < iovcnt; i++) {
            var ptr = HEAPU32[iov >>> 2];
            var len = HEAPU32[iov + 4 >>> 2];
            iov += 8;
            var curr = FS.read(stream, HEAP8, ptr, len, offset);
            if (curr < 0)
              return -1;
            ret += curr;
            if (curr < len)
              break;
            if (typeof offset !== "undefined") {
              offset += curr;
            }
          }
          return ret;
        }
        function _fd_read(fd, iov, iovcnt, pnum) {
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            var num = doReadv(stream, iov, iovcnt);
            HEAPU32[pnum >>> 2] = num;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError))
              throw e;
            return e.errno;
          }
        }
        function convertI32PairToI53Checked(lo, hi) {
          return hi + 2097152 >>> 0 < 4194305 - !!lo ? (lo >>> 0) + hi * 4294967296 : NaN;
        }
        function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
          try {
            var offset = convertI32PairToI53Checked(offset_low, offset_high);
            if (isNaN(offset))
              return 61;
            var stream = SYSCALLS.getStreamFromFD(fd);
            FS.llseek(stream, offset, whence);
            tempI64 = [stream.position >>> 0, (tempDouble = stream.position, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[newOffset >>> 2] = tempI64[0], HEAP32[newOffset + 4 >>> 2] = tempI64[1];
            if (stream.getdents && offset === 0 && whence === 0)
              stream.getdents = null;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError))
              throw e;
            return e.errno;
          }
        }
        function doWritev(stream, iov, iovcnt, offset) {
          var ret = 0;
          for (var i = 0; i < iovcnt; i++) {
            var ptr = HEAPU32[iov >>> 2];
            var len = HEAPU32[iov + 4 >>> 2];
            iov += 8;
            var curr = FS.write(stream, HEAP8, ptr, len, offset);
            if (curr < 0)
              return -1;
            ret += curr;
            if (typeof offset !== "undefined") {
              offset += curr;
            }
          }
          return ret;
        }
        function _fd_write(fd, iov, iovcnt, pnum) {
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            var num = doWritev(stream, iov, iovcnt);
            HEAPU32[pnum >>> 2] = num;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError))
              throw e;
            return e.errno;
          }
        }
        function __isLeapYear(year) {
          return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
        }
        function __arraySum(array, index) {
          var sum = 0;
          for (var i = 0; i <= index; sum += array[i++]) {
          }
          return sum;
        }
        var __MONTH_DAYS_LEAP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        var __MONTH_DAYS_REGULAR = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        function __addDays(date, days) {
          var newDate = new Date(date.getTime());
          while (days > 0) {
            var leap = __isLeapYear(newDate.getFullYear());
            var currentMonth = newDate.getMonth();
            var daysInCurrentMonth = (leap ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR)[currentMonth];
            if (days > daysInCurrentMonth - newDate.getDate()) {
              days -= daysInCurrentMonth - newDate.getDate() + 1;
              newDate.setDate(1);
              if (currentMonth < 11) {
                newDate.setMonth(currentMonth + 1);
              } else {
                newDate.setMonth(0);
                newDate.setFullYear(newDate.getFullYear() + 1);
              }
            } else {
              newDate.setDate(newDate.getDate() + days);
              return newDate;
            }
          }
          return newDate;
        }
        function writeArrayToMemory(array, buffer) {
          HEAP8.set(array, buffer >>> 0);
        }
        function _strftime(s, maxsize, format, tm) {
          var tm_zone = HEAP32[tm + 40 >>> 2];
          var date = { tm_sec: HEAP32[tm >>> 2], tm_min: HEAP32[tm + 4 >>> 2], tm_hour: HEAP32[tm + 8 >>> 2], tm_mday: HEAP32[tm + 12 >>> 2], tm_mon: HEAP32[tm + 16 >>> 2], tm_year: HEAP32[tm + 20 >>> 2], tm_wday: HEAP32[tm + 24 >>> 2], tm_yday: HEAP32[tm + 28 >>> 2], tm_isdst: HEAP32[tm + 32 >>> 2], tm_gmtoff: HEAP32[tm + 36 >>> 2], tm_zone: tm_zone ? UTF8ToString(tm_zone) : "" };
          var pattern = UTF8ToString(format);
          var EXPANSION_RULES_1 = { "%c": "%a %b %d %H:%M:%S %Y", "%D": "%m/%d/%y", "%F": "%Y-%m-%d", "%h": "%b", "%r": "%I:%M:%S %p", "%R": "%H:%M", "%T": "%H:%M:%S", "%x": "%m/%d/%y", "%X": "%H:%M:%S", "%Ec": "%c", "%EC": "%C", "%Ex": "%m/%d/%y", "%EX": "%H:%M:%S", "%Ey": "%y", "%EY": "%Y", "%Od": "%d", "%Oe": "%e", "%OH": "%H", "%OI": "%I", "%Om": "%m", "%OM": "%M", "%OS": "%S", "%Ou": "%u", "%OU": "%U", "%OV": "%V", "%Ow": "%w", "%OW": "%W", "%Oy": "%y" };
          for (var rule in EXPANSION_RULES_1) {
            pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_1[rule]);
          }
          var WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
          var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          function leadingSomething(value, digits, character) {
            var str = typeof value == "number" ? value.toString() : value || "";
            while (str.length < digits) {
              str = character[0] + str;
            }
            return str;
          }
          function leadingNulls(value, digits) {
            return leadingSomething(value, digits, "0");
          }
          function compareByDay(date1, date2) {
            function sgn(value) {
              return value < 0 ? -1 : value > 0 ? 1 : 0;
            }
            var compare;
            if ((compare = sgn(date1.getFullYear() - date2.getFullYear())) === 0) {
              if ((compare = sgn(date1.getMonth() - date2.getMonth())) === 0) {
                compare = sgn(date1.getDate() - date2.getDate());
              }
            }
            return compare;
          }
          function getFirstWeekStartDate(janFourth) {
            switch (janFourth.getDay()) {
              case 0:
                return new Date(janFourth.getFullYear() - 1, 11, 29);
              case 1:
                return janFourth;
              case 2:
                return new Date(janFourth.getFullYear(), 0, 3);
              case 3:
                return new Date(janFourth.getFullYear(), 0, 2);
              case 4:
                return new Date(janFourth.getFullYear(), 0, 1);
              case 5:
                return new Date(janFourth.getFullYear() - 1, 11, 31);
              case 6:
                return new Date(janFourth.getFullYear() - 1, 11, 30);
            }
          }
          function getWeekBasedYear(date2) {
            var thisDate = __addDays(new Date(date2.tm_year + 1900, 0, 1), date2.tm_yday);
            var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4);
            var janFourthNextYear = new Date(thisDate.getFullYear() + 1, 0, 4);
            var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
            var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);
            if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {
              if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) {
                return thisDate.getFullYear() + 1;
              }
              return thisDate.getFullYear();
            }
            return thisDate.getFullYear() - 1;
          }
          var EXPANSION_RULES_2 = { "%a": function(date2) {
            return WEEKDAYS[date2.tm_wday].substring(0, 3);
          }, "%A": function(date2) {
            return WEEKDAYS[date2.tm_wday];
          }, "%b": function(date2) {
            return MONTHS[date2.tm_mon].substring(0, 3);
          }, "%B": function(date2) {
            return MONTHS[date2.tm_mon];
          }, "%C": function(date2) {
            var year = date2.tm_year + 1900;
            return leadingNulls(year / 100 | 0, 2);
          }, "%d": function(date2) {
            return leadingNulls(date2.tm_mday, 2);
          }, "%e": function(date2) {
            return leadingSomething(date2.tm_mday, 2, " ");
          }, "%g": function(date2) {
            return getWeekBasedYear(date2).toString().substring(2);
          }, "%G": function(date2) {
            return getWeekBasedYear(date2);
          }, "%H": function(date2) {
            return leadingNulls(date2.tm_hour, 2);
          }, "%I": function(date2) {
            var twelveHour = date2.tm_hour;
            if (twelveHour == 0)
              twelveHour = 12;
            else if (twelveHour > 12)
              twelveHour -= 12;
            return leadingNulls(twelveHour, 2);
          }, "%j": function(date2) {
            return leadingNulls(date2.tm_mday + __arraySum(__isLeapYear(date2.tm_year + 1900) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, date2.tm_mon - 1), 3);
          }, "%m": function(date2) {
            return leadingNulls(date2.tm_mon + 1, 2);
          }, "%M": function(date2) {
            return leadingNulls(date2.tm_min, 2);
          }, "%n": function() {
            return "\n";
          }, "%p": function(date2) {
            if (date2.tm_hour >= 0 && date2.tm_hour < 12) {
              return "AM";
            }
            return "PM";
          }, "%S": function(date2) {
            return leadingNulls(date2.tm_sec, 2);
          }, "%t": function() {
            return "	";
          }, "%u": function(date2) {
            return date2.tm_wday || 7;
          }, "%U": function(date2) {
            var days = date2.tm_yday + 7 - date2.tm_wday;
            return leadingNulls(Math.floor(days / 7), 2);
          }, "%V": function(date2) {
            var val = Math.floor((date2.tm_yday + 7 - (date2.tm_wday + 6) % 7) / 7);
            if ((date2.tm_wday + 371 - date2.tm_yday - 2) % 7 <= 2) {
              val++;
            }
            if (!val) {
              val = 52;
              var dec31 = (date2.tm_wday + 7 - date2.tm_yday - 1) % 7;
              if (dec31 == 4 || dec31 == 5 && __isLeapYear(date2.tm_year % 400 - 1)) {
                val++;
              }
            } else if (val == 53) {
              var jan1 = (date2.tm_wday + 371 - date2.tm_yday) % 7;
              if (jan1 != 4 && (jan1 != 3 || !__isLeapYear(date2.tm_year)))
                val = 1;
            }
            return leadingNulls(val, 2);
          }, "%w": function(date2) {
            return date2.tm_wday;
          }, "%W": function(date2) {
            var days = date2.tm_yday + 7 - (date2.tm_wday + 6) % 7;
            return leadingNulls(Math.floor(days / 7), 2);
          }, "%y": function(date2) {
            return (date2.tm_year + 1900).toString().substring(2);
          }, "%Y": function(date2) {
            return date2.tm_year + 1900;
          }, "%z": function(date2) {
            var off = date2.tm_gmtoff;
            var ahead = off >= 0;
            off = Math.abs(off) / 60;
            off = off / 60 * 100 + off % 60;
            return (ahead ? "+" : "-") + String("0000" + off).slice(-4);
          }, "%Z": function(date2) {
            return date2.tm_zone;
          }, "%%": function() {
            return "%";
          } };
          pattern = pattern.replace(/%%/g, "\0\0");
          for (var rule in EXPANSION_RULES_2) {
            if (pattern.includes(rule)) {
              pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_2[rule](date));
            }
          }
          pattern = pattern.replace(/\0\0/g, "%");
          var bytes = intArrayFromString(pattern, false);
          if (bytes.length > maxsize) {
            return 0;
          }
          writeArrayToMemory(bytes, s);
          return bytes.length - 1;
        }
        function _strftime_l(s, maxsize, format, tm, loc) {
          return _strftime(s, maxsize, format, tm);
        }
        var FSNode = function(parent, name, mode, rdev) {
          if (!parent) {
            parent = this;
          }
          this.parent = parent;
          this.mount = parent.mount;
          this.mounted = null;
          this.id = FS.nextInode++;
          this.name = name;
          this.mode = mode;
          this.node_ops = {};
          this.stream_ops = {};
          this.rdev = rdev;
        };
        var readMode = 292 | 73;
        var writeMode = 146;
        Object.defineProperties(FSNode.prototype, { read: { get: function() {
          return (this.mode & readMode) === readMode;
        }, set: function(val) {
          val ? this.mode |= readMode : this.mode &= ~readMode;
        } }, write: { get: function() {
          return (this.mode & writeMode) === writeMode;
        }, set: function(val) {
          val ? this.mode |= writeMode : this.mode &= ~writeMode;
        } }, isFolder: { get: function() {
          return FS.isDir(this.mode);
        } }, isDevice: { get: function() {
          return FS.isChrdev(this.mode);
        } } });
        FS.FSNode = FSNode;
        FS.staticInit();
        InternalError = Module["InternalError"] = extendError(Error, "InternalError");
        embind_init_charCodes();
        BindingError = Module["BindingError"] = extendError(Error, "BindingError");
        init_ClassHandle();
        init_embind();
        init_RegisteredPointer();
        UnboundTypeError = Module["UnboundTypeError"] = extendError(Error, "UnboundTypeError");
        init_emval();
        var wasmImports = { "e": ___cxa_throw, "z": ___syscall_fcntl64, "L": ___syscall_ioctl, "M": ___syscall_openat, "T": __embind_finalize_value_array, "s": __embind_finalize_value_object, "G": __embind_register_bigint, "R": __embind_register_bool, "r": __embind_register_class, "q": __embind_register_class_constructor, "c": __embind_register_class_function, "Q": __embind_register_emval, "D": __embind_register_enum, "p": __embind_register_enum_value, "B": __embind_register_float, "b": __embind_register_function, "o": __embind_register_integer, "h": __embind_register_memory_view, "C": __embind_register_std_string, "v": __embind_register_std_wstring, "U": __embind_register_value_array, "j": __embind_register_value_array_element, "t": __embind_register_value_object, "g": __embind_register_value_object_field, "S": __embind_register_void, "l": __emval_as, "x": __emval_call, "a": __emval_decref, "E": __emval_get_global, "m": __emval_get_property, "n": __emval_incref, "W": __emval_instanceof, "V": __emval_is_number, "w": __emval_new_array, "f": __emval_new_cstring, "u": __emval_new_object, "k": __emval_run_destructors, "i": __emval_set_property, "d": __emval_take_value, "A": _abort, "P": _emscripten_memcpy_big, "N": _emscripten_resize_heap, "I": _environ_get, "J": _environ_sizes_get, "y": _fd_close, "K": _fd_read, "F": _fd_seek, "O": _fd_write, "H": _strftime_l };
        var asm = createWasm();
        var ___wasm_call_ctors = function() {
          return (___wasm_call_ctors = Module["asm"]["Y"]).apply(null, arguments);
        };
        var _malloc = function() {
          return (_malloc = Module["asm"]["_"]).apply(null, arguments);
        };
        var ___getTypeName = Module["___getTypeName"] = function() {
          return (___getTypeName = Module["___getTypeName"] = Module["asm"]["$"]).apply(null, arguments);
        };
        var __embind_initialize_bindings = Module["__embind_initialize_bindings"] = function() {
          return (__embind_initialize_bindings = Module["__embind_initialize_bindings"] = Module["asm"]["aa"]).apply(null, arguments);
        };
        var ___errno_location = function() {
          return (___errno_location = Module["asm"]["ba"]).apply(null, arguments);
        };
        var _free = function() {
          return (_free = Module["asm"]["ca"]).apply(null, arguments);
        };
        var ___cxa_is_pointer_type = function() {
          return (___cxa_is_pointer_type = Module["asm"]["da"]).apply(null, arguments);
        };
        var dynCall_jiji = Module["dynCall_jiji"] = function() {
          return (dynCall_jiji = Module["dynCall_jiji"] = Module["asm"]["ea"]).apply(null, arguments);
        };
        var dynCall_viijii = Module["dynCall_viijii"] = function() {
          return (dynCall_viijii = Module["dynCall_viijii"] = Module["asm"]["fa"]).apply(null, arguments);
        };
        var dynCall_iiiiij = Module["dynCall_iiiiij"] = function() {
          return (dynCall_iiiiij = Module["dynCall_iiiiij"] = Module["asm"]["ga"]).apply(null, arguments);
        };
        var dynCall_iiiiijj = Module["dynCall_iiiiijj"] = function() {
          return (dynCall_iiiiijj = Module["dynCall_iiiiijj"] = Module["asm"]["ha"]).apply(null, arguments);
        };
        var dynCall_iiiiiijj = Module["dynCall_iiiiiijj"] = function() {
          return (dynCall_iiiiiijj = Module["dynCall_iiiiiijj"] = Module["asm"]["ia"]).apply(null, arguments);
        };
        var calledRun;
        dependenciesFulfilled = function runCaller() {
          if (!calledRun)
            run();
          if (!calledRun)
            dependenciesFulfilled = runCaller;
        };
        function run() {
          if (runDependencies > 0) {
            return;
          }
          preRun();
          if (runDependencies > 0) {
            return;
          }
          function doRun() {
            if (calledRun)
              return;
            calledRun = true;
            Module["calledRun"] = true;
            if (ABORT)
              return;
            initRuntime();
            readyPromiseResolve(Module);
            if (Module["onRuntimeInitialized"])
              Module["onRuntimeInitialized"]();
            postRun();
          }
          if (Module["setStatus"]) {
            Module["setStatus"]("Running...");
            setTimeout(function() {
              setTimeout(function() {
                Module["setStatus"]("");
              }, 1);
              doRun();
            }, 1);
          } else {
            doRun();
          }
        }
        if (Module["preInit"]) {
          if (typeof Module["preInit"] == "function")
            Module["preInit"] = [Module["preInit"]];
          while (Module["preInit"].length > 0) {
            Module["preInit"].pop()();
          }
        }
        run();
        return WebIFCWasm3.ready;
      };
    })();
    if (typeof exports === "object" && typeof module === "object")
      module.exports = WebIFCWasm2;
    else if (typeof define === "function" && define["amd"])
      define([], function() {
        return WebIFCWasm2;
      });
    else if (typeof exports === "object")
      exports["WebIFCWasm"] = WebIFCWasm2;
  }
});

// dist/ifc-schema.ts
var IFCURIREFERENCE = 950732822;
var IFCTIME = 4075327185;
var IFCTEMPERATURERATEOFCHANGEMEASURE = 1209108979;
var IFCSOUNDPRESSURELEVELMEASURE = 3457685358;
var IFCSOUNDPOWERLEVELMEASURE = 4157543285;
var IFCPROPERTYSETDEFINITIONSET = 2798247006;
var IFCPOSITIVEINTEGER = 1790229001;
var IFCNONNEGATIVELENGTHMEASURE = 525895558;
var IFCLINEINDEX = 1774176899;
var IFCLANGUAGEID = 1275358634;
var IFCDURATION = 2541165894;
var IFCDAYINWEEKNUMBER = 3701338814;
var IFCDATETIME = 2195413836;
var IFCDATE = 937566702;
var IFCCARDINALPOINTREFERENCE = 1683019596;
var IFCBINARY = 2314439260;
var IFCAREADENSITYMEASURE = 1500781891;
var IFCARCINDEX = 3683503648;
var IFCYEARNUMBER = 4065007721;
var IFCWARPINGMOMENTMEASURE = 1718600412;
var IFCWARPINGCONSTANTMEASURE = 51269191;
var IFCVOLUMETRICFLOWRATEMEASURE = 2593997549;
var IFCVOLUMEMEASURE = 3458127941;
var IFCVAPORPERMEABILITYMEASURE = 3345633955;
var IFCTORQUEMEASURE = 1278329552;
var IFCTIMESTAMP = 2591213694;
var IFCTIMEMEASURE = 2726807636;
var IFCTHERMODYNAMICTEMPERATUREMEASURE = 743184107;
var IFCTHERMALTRANSMITTANCEMEASURE = 2016195849;
var IFCTHERMALRESISTANCEMEASURE = 857959152;
var IFCTHERMALEXPANSIONCOEFFICIENTMEASURE = 2281867870;
var IFCTHERMALCONDUCTIVITYMEASURE = 2645777649;
var IFCTHERMALADMITTANCEMEASURE = 232962298;
var IFCTEXTTRANSFORMATION = 296282323;
var IFCTEXTFONTNAME = 603696268;
var IFCTEXTDECORATION = 3490877962;
var IFCTEXTALIGNMENT = 1460886941;
var IFCTEXT = 2801250643;
var IFCTEMPERATUREGRADIENTMEASURE = 58845555;
var IFCSPECULARROUGHNESS = 361837227;
var IFCSPECULAREXPONENT = 2757832317;
var IFCSPECIFICHEATCAPACITYMEASURE = 3477203348;
var IFCSOUNDPRESSUREMEASURE = 993287707;
var IFCSOUNDPOWERMEASURE = 846465480;
var IFCSOLIDANGLEMEASURE = 3471399674;
var IFCSHEARMODULUSMEASURE = 408310005;
var IFCSECTIONALAREAINTEGRALMEASURE = 2190458107;
var IFCSECTIONMODULUSMEASURE = 3467162246;
var IFCSECONDINMINUTE = 2766185779;
var IFCROTATIONALSTIFFNESSMEASURE = 3211557302;
var IFCROTATIONALMASSMEASURE = 1755127002;
var IFCROTATIONALFREQUENCYMEASURE = 2133746277;
var IFCREAL = 200335297;
var IFCRATIOMEASURE = 96294661;
var IFCRADIOACTIVITYMEASURE = 3972513137;
var IFCPRESSUREMEASURE = 3665567075;
var IFCPRESENTABLETEXT = 2169031380;
var IFCPOWERMEASURE = 1364037233;
var IFCPOSITIVERATIOMEASURE = 1245737093;
var IFCPOSITIVEPLANEANGLEMEASURE = 3054510233;
var IFCPOSITIVELENGTHMEASURE = 2815919920;
var IFCPLANEANGLEMEASURE = 4042175685;
var IFCPLANARFORCEMEASURE = 2642773653;
var IFCPARAMETERVALUE = 2260317790;
var IFCPHMEASURE = 929793134;
var IFCNUMERICMEASURE = 2395907400;
var IFCNORMALISEDRATIOMEASURE = 2095195183;
var IFCMONTHINYEARNUMBER = 765770214;
var IFCMONETARYMEASURE = 2615040989;
var IFCMOMENTOFINERTIAMEASURE = 3114022597;
var IFCMOLECULARWEIGHTMEASURE = 1648970520;
var IFCMOISTUREDIFFUSIVITYMEASURE = 3177669450;
var IFCMODULUSOFSUBGRADEREACTIONMEASURE = 1753493141;
var IFCMODULUSOFROTATIONALSUBGRADEREACTIONMEASURE = 1052454078;
var IFCMODULUSOFLINEARSUBGRADEREACTIONMEASURE = 2173214787;
var IFCMODULUSOFELASTICITYMEASURE = 3341486342;
var IFCMINUTEINHOUR = 102610177;
var IFCMASSPERLENGTHMEASURE = 3531705166;
var IFCMASSMEASURE = 3124614049;
var IFCMASSFLOWRATEMEASURE = 4017473158;
var IFCMASSDENSITYMEASURE = 1477762836;
var IFCMAGNETICFLUXMEASURE = 2486716878;
var IFCMAGNETICFLUXDENSITYMEASURE = 286949696;
var IFCLUMINOUSINTENSITYMEASURE = 151039812;
var IFCLUMINOUSINTENSITYDISTRIBUTIONMEASURE = 2755797622;
var IFCLUMINOUSFLUXMEASURE = 2095003142;
var IFCLOGICAL = 503418787;
var IFCLINEARVELOCITYMEASURE = 3086160713;
var IFCLINEARSTIFFNESSMEASURE = 1307019551;
var IFCLINEARMOMENTMEASURE = 2128979029;
var IFCLINEARFORCEMEASURE = 191860431;
var IFCLENGTHMEASURE = 1243674935;
var IFCLABEL = 3258342251;
var IFCKINEMATICVISCOSITYMEASURE = 2054016361;
var IFCISOTHERMALMOISTURECAPACITYMEASURE = 3192672207;
var IFCIONCONCENTRATIONMEASURE = 3686016028;
var IFCINTEGERCOUNTRATEMEASURE = 3809634241;
var IFCINTEGER = 1939436016;
var IFCINDUCTANCEMEASURE = 2679005408;
var IFCILLUMINANCEMEASURE = 3358199106;
var IFCIDENTIFIER = 983778844;
var IFCHOURINDAY = 2589826445;
var IFCHEATINGVALUEMEASURE = 1158859006;
var IFCHEATFLUXDENSITYMEASURE = 3113092358;
var IFCGLOBALLYUNIQUEID = 3064340077;
var IFCFREQUENCYMEASURE = 3044325142;
var IFCFORCEMEASURE = 1361398929;
var IFCFONTWEIGHT = 2590844177;
var IFCFONTVARIANT = 2715512545;
var IFCFONTSTYLE = 1102727119;
var IFCENERGYMEASURE = 2078135608;
var IFCELECTRICVOLTAGEMEASURE = 2506197118;
var IFCELECTRICRESISTANCEMEASURE = 2951915441;
var IFCELECTRICCURRENTMEASURE = 3790457270;
var IFCELECTRICCONDUCTANCEMEASURE = 2093906313;
var IFCELECTRICCHARGEMEASURE = 3818826038;
var IFCELECTRICCAPACITANCEMEASURE = 1827137117;
var IFCDYNAMICVISCOSITYMEASURE = 69416015;
var IFCDOSEEQUIVALENTMEASURE = 524656162;
var IFCDIMENSIONCOUNT = 4134073009;
var IFCDESCRIPTIVEMEASURE = 1514641115;
var IFCDAYLIGHTSAVINGHOUR = 300323983;
var IFCDAYINMONTHNUMBER = 86635668;
var IFCCURVATUREMEASURE = 94842927;
var IFCCOUNTMEASURE = 1778710042;
var IFCCONTEXTDEPENDENTMEASURE = 3238673880;
var IFCCOMPOUNDPLANEANGLEMEASURE = 3812528620;
var IFCCOMPLEXNUMBER = 2991860651;
var IFCBOXALIGNMENT = 1867003952;
var IFCBOOLEAN = 2735952531;
var IFCAREAMEASURE = 2650437152;
var IFCANGULARVELOCITYMEASURE = 632304761;
var IFCAMOUNTOFSUBSTANCEMEASURE = 360377573;
var IFCACCELERATIONMEASURE = 4182062534;
var IFCABSORBEDDOSEMEASURE = 3699917729;
var IFCBEAMSTANDARDCASE = 2906023776;
var IFCWINDOWSTANDARDCASE = 486154966;
var IFCWALLELEMENTEDCASE = 4156078855;
var IFCSLABSTANDARDCASE = 3027962421;
var IFCSLABELEMENTEDCASE = 3127900445;
var IFCPLATESTANDARDCASE = 1156407060;
var IFCMEMBERSTANDARDCASE = 1911478936;
var IFCDOORSTANDARDCASE = 3242481149;
var IFCCOLUMNSTANDARDCASE = 905975707;
var IFCOPENINGSTANDARDCASE = 3079942009;
var IFCCONTROLLER = 25142252;
var IFCALARM = 3087945054;
var IFCACTUATOR = 4288193352;
var IFCUNITARYCONTROLELEMENT = 630975310;
var IFCSENSOR = 4086658281;
var IFCPROTECTIVEDEVICETRIPPINGUNIT = 2295281155;
var IFCGEOSLICE = 1971632696;
var IFCGEOMODEL = 2680139844;
var IFCFLOWINSTRUMENT = 182646315;
var IFCFIRESUPPRESSIONTERMINAL = 1426591983;
var IFCFILTER = 819412036;
var IFCFAN = 3415622556;
var IFCELECTRICTIMECONTROL = 1003880860;
var IFCELECTRICMOTOR = 402227799;
var IFCELECTRICGENERATOR = 264262732;
var IFCELECTRICFLOWTREATMENTDEVICE = 24726584;
var IFCELECTRICFLOWSTORAGEDEVICE = 3310460725;
var IFCELECTRICDISTRIBUTIONBOARD = 862014818;
var IFCELECTRICAPPLIANCE = 1904799276;
var IFCDUCTSILENCER = 1360408905;
var IFCDUCTSEGMENT = 3518393246;
var IFCDUCTFITTING = 342316401;
var IFCDISTRIBUTIONCIRCUIT = 562808652;
var IFCDISTRIBUTIONBOARD = 3693000487;
var IFCDAMPER = 4074379575;
var IFCCOOLINGTOWER = 3640358203;
var IFCCOOLEDBEAM = 4136498852;
var IFCCONVEYORSEGMENT = 3460952963;
var IFCCONDENSER = 2272882330;
var IFCCOMPRESSOR = 3571504051;
var IFCCOMMUNICATIONSAPPLIANCE = 3221913625;
var IFCCOIL = 639361253;
var IFCCHILLER = 3902619387;
var IFCCAISSONFOUNDATION = 3999819293;
var IFCCABLESEGMENT = 4217484030;
var IFCCABLEFITTING = 1051757585;
var IFCCABLECARRIERSEGMENT = 3758799889;
var IFCCABLECARRIERFITTING = 635142910;
var IFCBURNER = 2938176219;
var IFCBOREHOLE = 3314249567;
var IFCBOILER = 32344328;
var IFCBEARING = 4196446775;
var IFCAUDIOVISUALAPPLIANCE = 277319702;
var IFCALIGNMENT = 325726236;
var IFCAIRTOAIRHEATRECOVERY = 2056796094;
var IFCAIRTERMINALBOX = 177149247;
var IFCAIRTERMINAL = 1634111441;
var IFCWASTETERMINAL = 4237592921;
var IFCVALVE = 4207607924;
var IFCUNITARYEQUIPMENT = 4292641817;
var IFCUNITARYCONTROLELEMENTTYPE = 3179687236;
var IFCTUBEBUNDLE = 3026737570;
var IFCTRANSFORMER = 3825984169;
var IFCTRACKELEMENT = 3425753595;
var IFCTANK = 812556717;
var IFCSWITCHINGDEVICE = 1162798199;
var IFCSTRUCTURALLOADCASE = 385403989;
var IFCSTACKTERMINAL = 1404847402;
var IFCSPACEHEATER = 1999602285;
var IFCSOLARDEVICE = 3420628829;
var IFCSIGNAL = 991950508;
var IFCSHADINGDEVICE = 1329646415;
var IFCSANITARYTERMINAL = 3053780830;
var IFCREINFORCINGBARTYPE = 2572171363;
var IFCREINFORCEDSOIL = 3798194928;
var IFCRATIONALBSPLINECURVEWITHKNOTS = 1232101972;
var IFCRAIL = 3290496277;
var IFCPUMP = 90941305;
var IFCPROTECTIVEDEVICETRIPPINGUNITTYPE = 655969474;
var IFCPROTECTIVEDEVICE = 738039164;
var IFCPIPESEGMENT = 3612865200;
var IFCPIPEFITTING = 310824031;
var IFCPAVEMENT = 1383356374;
var IFCOUTLET = 3694346114;
var IFCOUTERBOUNDARYCURVE = 144952367;
var IFCNAVIGATIONELEMENT = 2182337498;
var IFCMOTORCONNECTION = 2474470126;
var IFCMOORINGDEVICE = 234836483;
var IFCMOBILETELECOMMUNICATIONSAPPLIANCE = 2078563270;
var IFCMEDICALDEVICE = 1437502449;
var IFCLIQUIDTERMINAL = 1638804497;
var IFCLINEARPOSITIONINGELEMENT = 1154579445;
var IFCLIGHTFIXTURE = 629592764;
var IFCLAMP = 76236018;
var IFCKERB = 2696325953;
var IFCJUNCTIONBOX = 2176052936;
var IFCINTERCEPTOR = 4175244083;
var IFCHUMIDIFIER = 2068733104;
var IFCHEATEXCHANGER = 3319311131;
var IFCGEOTECHNICALASSEMBLY = 2713699986;
var IFCFLOWMETER = 2188021234;
var IFCEXTERNALSPATIALELEMENT = 1209101575;
var IFCEVAPORATOR = 484807127;
var IFCEVAPORATIVECOOLER = 3747195512;
var IFCENGINE = 2814081492;
var IFCELECTRICFLOWTREATMENTDEVICETYPE = 2142170206;
var IFCELECTRICDISTRIBUTIONBOARDTYPE = 2417008758;
var IFCEARTHWORKSFILL = 3376911765;
var IFCEARTHWORKSELEMENT = 1077100507;
var IFCEARTHWORKSCUT = 3071239417;
var IFCDISTRIBUTIONSYSTEM = 3205830791;
var IFCDISTRIBUTIONBOARDTYPE = 479945903;
var IFCDEEPFOUNDATION = 3426335179;
var IFCCOURSE = 1502416096;
var IFCCONVEYORSEGMENTTYPE = 2940368186;
var IFCCOMMUNICATIONSAPPLIANCETYPE = 400855858;
var IFCCIVILELEMENT = 1677625105;
var IFCCHIMNEY = 3296154744;
var IFCCAISSONFOUNDATIONTYPE = 3203706013;
var IFCCABLEFITTINGTYPE = 2674252688;
var IFCBURNERTYPE = 2188180465;
var IFCBUILTSYSTEM = 3862327254;
var IFCBUILTELEMENT = 1876633798;
var IFCBUILDINGSYSTEM = 1177604601;
var IFCBUILDINGELEMENTPARTTYPE = 39481116;
var IFCBRIDGEPART = 963979645;
var IFCBRIDGE = 644574406;
var IFCBOUNDARYCURVE = 1136057603;
var IFCBEARINGTYPE = 3649138523;
var IFCBSPLINECURVEWITHKNOTS = 2461110595;
var IFCAUDIOVISUALAPPLIANCETYPE = 1532957894;
var IFCALIGNMENTVERTICAL = 1662888072;
var IFCALIGNMENTSEGMENT = 317615605;
var IFCALIGNMENTHORIZONTAL = 1545765605;
var IFCALIGNMENTCANT = 4266260250;
var IFCWORKCALENDAR = 4088093105;
var IFCWINDOWTYPE = 4009809668;
var IFCVOIDINGFEATURE = 926996030;
var IFCVIBRATIONISOLATOR = 2391383451;
var IFCVIBRATIONDAMPERTYPE = 3956297820;
var IFCVIBRATIONDAMPER = 1530820697;
var IFCVEHICLE = 840318589;
var IFCTRANSPORTATIONDEVICE = 1953115116;
var IFCTRACKELEMENTTYPE = 618700268;
var IFCTENDONTYPE = 2415094496;
var IFCTENDONCONDUITTYPE = 2281632017;
var IFCTENDONCONDUIT = 3663046924;
var IFCTENDONANCHORTYPE = 3081323446;
var IFCSYSTEMFURNITUREELEMENT = 413509423;
var IFCSURFACEFEATURE = 3101698114;
var IFCSTRUCTURALSURFACEACTION = 3657597509;
var IFCSTRUCTURALCURVEREACTION = 2757150158;
var IFCSTRUCTURALCURVEACTION = 1004757350;
var IFCSTAIRTYPE = 338393293;
var IFCSOLARDEVICETYPE = 1072016465;
var IFCSINESPIRAL = 42703149;
var IFCSIGNALTYPE = 1894708472;
var IFCSIGNTYPE = 3599934289;
var IFCSIGN = 33720170;
var IFCSHADINGDEVICETYPE = 4074543187;
var IFCSEVENTHORDERPOLYNOMIALSPIRAL = 1027922057;
var IFCSEGMENTEDREFERENCECURVE = 544395925;
var IFCSECONDORDERPOLYNOMIALSPIRAL = 3649235739;
var IFCSEAMCURVE = 2157484638;
var IFCROOFTYPE = 2781568857;
var IFCROADPART = 550521510;
var IFCROAD = 146592293;
var IFCRELADHERESTOELEMENT = 3818125796;
var IFCREINFORCINGMESHTYPE = 2310774935;
var IFCREINFORCINGELEMENTTYPE = 964333572;
var IFCREFERENT = 4021432810;
var IFCRATIONALBSPLINESURFACEWITHKNOTS = 683857671;
var IFCRAMPTYPE = 1469900589;
var IFCRAILWAYPART = 1891881377;
var IFCRAILWAY = 3992365140;
var IFCRAILTYPE = 1763565496;
var IFCPOSITIONINGELEMENT = 1946335990;
var IFCPOLYGONALFACESET = 2839578677;
var IFCPILETYPE = 1158309216;
var IFCPAVEMENTTYPE = 514975943;
var IFCNAVIGATIONELEMENTTYPE = 506776471;
var IFCMOORINGDEVICETYPE = 710110818;
var IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE = 1950438474;
var IFCMEDICALDEVICETYPE = 1114901282;
var IFCMARINEPART = 976884017;
var IFCMARINEFACILITY = 525669439;
var IFCLIQUIDTERMINALTYPE = 1770583370;
var IFCLINEARELEMENT = 2176059722;
var IFCKERBTYPE = 679976338;
var IFCINTERSECTIONCURVE = 3113134337;
var IFCINTERCEPTORTYPE = 3946677679;
var IFCINDEXEDPOLYCURVE = 2571569899;
var IFCIMPACTPROTECTIONDEVICETYPE = 3948183225;
var IFCIMPACTPROTECTIONDEVICE = 2568555532;
var IFCGRADIENTCURVE = 2898700619;
var IFCGEOTECHNICALSTRATUM = 1594536857;
var IFCGEOTECHNICALELEMENT = 4230923436;
var IFCGEOGRAPHICELEMENT = 3493046030;
var IFCFURNITURE = 1509553395;
var IFCFOOTINGTYPE = 1893162501;
var IFCFACILITYPARTCOMMON = 4228831410;
var IFCFACILITYPART = 1310830890;
var IFCFACILITY = 24185140;
var IFCEXTERNALSPATIALSTRUCTUREELEMENT = 2853485674;
var IFCEVENT = 4148101412;
var IFCENGINETYPE = 132023988;
var IFCELEMENTASSEMBLYTYPE = 2397081782;
var IFCDOORTYPE = 2323601079;
var IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID = 4234616927;
var IFCDEEPFOUNDATIONTYPE = 1306400036;
var IFCCYLINDRICALSURFACE = 1213902940;
var IFCCOURSETYPE = 4189326743;
var IFCCOSINESPIRAL = 2000195564;
var IFCCONSTRUCTIONPRODUCTRESOURCETYPE = 1525564444;
var IFCCONSTRUCTIONMATERIALRESOURCETYPE = 4105962743;
var IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE = 2185764099;
var IFCCOMPOSITECURVEONSURFACE = 15328376;
var IFCCOMPLEXPROPERTYTEMPLATE = 3875453745;
var IFCCLOTHOID = 3497074424;
var IFCCIVILELEMENTTYPE = 3893394355;
var IFCCHIMNEYTYPE = 2197970202;
var IFCBUILTELEMENTTYPE = 1626504194;
var IFCBSPLINESURFACEWITHKNOTS = 167062518;
var IFCBSPLINESURFACE = 2887950389;
var IFCADVANCEDBREPWITHVOIDS = 2603310189;
var IFCADVANCEDBREP = 1635779807;
var IFCVEHICLETYPE = 3651464721;
var IFCTRIANGULATEDIRREGULARNETWORK = 1229763772;
var IFCTRIANGULATEDFACESET = 2916149573;
var IFCTRANSPORTATIONDEVICETYPE = 3665877780;
var IFCTOROIDALSURFACE = 1935646853;
var IFCTHIRDORDERPOLYNOMIALSPIRAL = 782932809;
var IFCTESSELLATEDFACESET = 2387106220;
var IFCTASKTYPE = 3206491090;
var IFCSURFACECURVE = 699246055;
var IFCSUBCONTRACTRESOURCETYPE = 4095615324;
var IFCSTRUCTURALSURFACEREACTION = 603775116;
var IFCSPIRAL = 2735484536;
var IFCSPHERICALSURFACE = 4015995234;
var IFCSPATIALZONETYPE = 2481509218;
var IFCSPATIALZONE = 463610769;
var IFCSPATIALELEMENTTYPE = 710998568;
var IFCSPATIALELEMENT = 1412071761;
var IFCSIMPLEPROPERTYTEMPLATE = 3663146110;
var IFCSECTIONEDSURFACE = 1356537516;
var IFCSECTIONEDSOLIDHORIZONTAL = 1290935644;
var IFCSECTIONEDSOLID = 1862484736;
var IFCREVOLVEDAREASOLIDTAPERED = 3243963512;
var IFCREPARAMETRISEDCOMPOSITECURVESEGMENT = 816062949;
var IFCRELSPACEBOUNDARY2NDLEVEL = 1521410863;
var IFCRELSPACEBOUNDARY1STLEVEL = 3523091289;
var IFCRELPOSITIONS = 1441486842;
var IFCRELINTERFERESELEMENTS = 427948657;
var IFCRELDEFINESBYTEMPLATE = 307848117;
var IFCRELDEFINESBYOBJECT = 1462361463;
var IFCRELDECLARES = 2565941209;
var IFCRELASSOCIATESPROFILEDEF = 1033248425;
var IFCRELASSIGNSTOGROUPBYFACTOR = 1027710054;
var IFCPROPERTYTEMPLATE = 3521284610;
var IFCPROPERTYSETTEMPLATE = 492091185;
var IFCPROJECTLIBRARY = 653396225;
var IFCPROCEDURETYPE = 569719735;
var IFCPREDEFINEDPROPERTYSET = 3967405729;
var IFCPOLYNOMIALCURVE = 3381221214;
var IFCPCURVE = 1682466193;
var IFCOFFSETCURVEBYDISTANCES = 2485787929;
var IFCOFFSETCURVE = 590820931;
var IFCLABORRESOURCETYPE = 428585644;
var IFCINDEXEDPOLYGONALTEXTUREMAP = 3465909080;
var IFCINDEXEDPOLYGONALFACEWITHVOIDS = 2294589976;
var IFCINDEXEDPOLYGONALFACE = 178912537;
var IFCGEOGRAPHICELEMENTTYPE = 4095422895;
var IFCFIXEDREFERENCESWEPTAREASOLID = 2652556860;
var IFCEXTRUDEDAREASOLIDTAPERED = 2804161546;
var IFCEVENTTYPE = 4024345920;
var IFCDIRECTRIXCURVESWEPTAREASOLID = 593015953;
var IFCCURVESEGMENT = 4212018352;
var IFCCURVEBOUNDEDSURFACE = 2629017746;
var IFCCREWRESOURCETYPE = 1815067380;
var IFCCONTEXT = 3419103109;
var IFCCONSTRUCTIONRESOURCETYPE = 2574617495;
var IFCCARTESIANPOINTLIST3D = 2059837836;
var IFCCARTESIANPOINTLIST2D = 1675464909;
var IFCCARTESIANPOINTLIST = 574549367;
var IFCAXIS2PLACEMENTLINEAR = 3425423356;
var IFCADVANCEDFACE = 3406155212;
var IFCTYPERESOURCE = 3698973494;
var IFCTYPEPROCESS = 3736923433;
var IFCTESSELLATEDITEM = 901063453;
var IFCSWEPTDISKSOLIDPOLYGONAL = 1096409881;
var IFCSEGMENT = 823603102;
var IFCRESOURCETIME = 1042787934;
var IFCRESOURCECONSTRAINTRELATIONSHIP = 1608871552;
var IFCRESOURCEAPPROVALRELATIONSHIP = 2943643501;
var IFCQUANTITYSET = 2090586900;
var IFCPROPERTYTEMPLATEDEFINITION = 1482703590;
var IFCPREDEFINEDPROPERTIES = 3778827333;
var IFCPOINTBYDISTANCEEXPRESSION = 2165702409;
var IFCOPENCROSSPROFILEDEF = 182550632;
var IFCMIRROREDPROFILEDEF = 2998442950;
var IFCMATERIALRELATIONSHIP = 853536259;
var IFCMATERIALPROFILESETUSAGETAPERING = 3404854881;
var IFCMATERIALPROFILESETUSAGE = 3079605661;
var IFCMATERIALCONSTITUENTSET = 2852063980;
var IFCMATERIALCONSTITUENT = 3708119e3;
var IFCLINEARPLACEMENT = 388784114;
var IFCLAGTIME = 1585845231;
var IFCINDEXEDTRIANGLETEXTUREMAP = 2133299955;
var IFCINDEXEDTEXTUREMAP = 1437953363;
var IFCINDEXEDCOLOURMAP = 3570813810;
var IFCEXTERNALREFERENCERELATIONSHIP = 1437805879;
var IFCEXTENDEDPROPERTIES = 297599258;
var IFCEVENTTIME = 211053100;
var IFCCONVERSIONBASEDUNITWITHOFFSET = 2713554722;
var IFCCOLOURRGBLIST = 3285139300;
var IFCALIGNMENTHORIZONTALSEGMENT = 536804194;
var IFCALIGNMENTCANTSEGMENT = 3752311538;
var IFCWORKTIME = 1236880293;
var IFCTIMEPERIOD = 1199560280;
var IFCTEXTUREVERTEXLIST = 3611470254;
var IFCTEXTURECOORDINATEINDICESWITHVOIDS = 1010789467;
var IFCTEXTURECOORDINATEINDICES = 222769930;
var IFCTASKTIMERECURRING = 2771591690;
var IFCTASKTIME = 1549132990;
var IFCTABLECOLUMN = 2043862942;
var IFCSURFACEREINFORCEMENTAREA = 2934153892;
var IFCSTRUCTURALLOADORRESULT = 609421318;
var IFCSTRUCTURALLOADCONFIGURATION = 3478079324;
var IFCSCHEDULINGTIME = 1054537805;
var IFCRESOURCELEVELRELATIONSHIP = 2439245199;
var IFCREFERENCE = 2433181523;
var IFCRECURRENCEPATTERN = 3915482550;
var IFCQUANTITYNUMBER = 2691318326;
var IFCPROPERTYABSTRACTION = 986844984;
var IFCPROJECTEDCRS = 3843373140;
var IFCPRESENTATIONITEM = 677532197;
var IFCMATERIALUSAGEDEFINITION = 1507914824;
var IFCMATERIALPROFILEWITHOFFSETS = 552965576;
var IFCMATERIALPROFILESET = 164193824;
var IFCMATERIALPROFILE = 2235152071;
var IFCMATERIALLAYERWITHOFFSETS = 1847252529;
var IFCMATERIALDEFINITION = 760658860;
var IFCMAPCONVERSION = 3057273783;
var IFCEXTERNALINFORMATION = 4294318154;
var IFCCOORDINATEREFERENCESYSTEM = 1466758467;
var IFCCOORDINATEOPERATION = 1785450214;
var IFCCONNECTIONVOLUMEGEOMETRY = 775493141;
var IFCALIGNMENTVERTICALSEGMENT = 3633395639;
var IFCALIGNMENTPARAMETERSEGMENT = 2879124712;
var IFCREINFORCINGBAR = 979691226;
var IFCELECTRICDISTRIBUTIONPOINT = 3700593921;
var IFCDISTRIBUTIONCONTROLELEMENT = 1062813311;
var IFCDISTRIBUTIONCHAMBERELEMENT = 1052013943;
var IFCCONTROLLERTYPE = 578613899;
var IFCCHAMFEREDGEFEATURE = 2454782716;
var IFCBEAM = 753842376;
var IFCALARMTYPE = 3001207471;
var IFCACTUATORTYPE = 2874132201;
var IFCWINDOW = 3304561284;
var IFCWALLSTANDARDCASE = 3512223829;
var IFCWALL = 2391406946;
var IFCVIBRATIONISOLATORTYPE = 3313531582;
var IFCTENDONANCHOR = 2347447852;
var IFCTENDON = 3824725483;
var IFCSTRUCTURALANALYSISMODEL = 2515109513;
var IFCSTAIRFLIGHT = 4252922144;
var IFCSTAIR = 331165859;
var IFCSLAB = 1529196076;
var IFCSENSORTYPE = 1783015770;
var IFCROUNDEDEDGEFEATURE = 1376911519;
var IFCROOF = 2016517767;
var IFCREINFORCINGMESH = 2320036040;
var IFCREINFORCINGELEMENT = 3027567501;
var IFCRATIONALBEZIERCURVE = 3055160366;
var IFCRAMPFLIGHT = 3283111854;
var IFCRAMP = 3024970846;
var IFCRAILING = 2262370178;
var IFCPLATE = 3171933400;
var IFCPILE = 1687234759;
var IFCMEMBER = 1073191201;
var IFCFOOTING = 900683007;
var IFCFLOWTREATMENTDEVICE = 3508470533;
var IFCFLOWTERMINAL = 2223149337;
var IFCFLOWSTORAGEDEVICE = 707683696;
var IFCFLOWSEGMENT = 987401354;
var IFCFLOWMOVINGDEVICE = 3132237377;
var IFCFLOWINSTRUMENTTYPE = 4037862832;
var IFCFLOWFITTING = 4278956645;
var IFCFLOWCONTROLLER = 2058353004;
var IFCFIRESUPPRESSIONTERMINALTYPE = 4222183408;
var IFCFILTERTYPE = 1810631287;
var IFCFANTYPE = 346874300;
var IFCENERGYCONVERSIONDEVICE = 1658829314;
var IFCELECTRICALELEMENT = 857184966;
var IFCELECTRICALCIRCUIT = 1634875225;
var IFCELECTRICTIMECONTROLTYPE = 712377611;
var IFCELECTRICMOTORTYPE = 1217240411;
var IFCELECTRICHEATERTYPE = 1365060375;
var IFCELECTRICGENERATORTYPE = 1534661035;
var IFCELECTRICFLOWSTORAGEDEVICETYPE = 3277789161;
var IFCELECTRICAPPLIANCETYPE = 663422040;
var IFCEDGEFEATURE = 855621170;
var IFCDUCTSILENCERTYPE = 2030761528;
var IFCDUCTSEGMENTTYPE = 3760055223;
var IFCDUCTFITTINGTYPE = 869906466;
var IFCDOOR = 395920057;
var IFCDISTRIBUTIONPORT = 3041715199;
var IFCDISTRIBUTIONFLOWELEMENT = 3040386961;
var IFCDISTRIBUTIONELEMENT = 1945004755;
var IFCDISTRIBUTIONCONTROLELEMENTTYPE = 2063403501;
var IFCDISTRIBUTIONCHAMBERELEMENTTYPE = 1599208980;
var IFCDISCRETEACCESSORYTYPE = 2635815018;
var IFCDISCRETEACCESSORY = 1335981549;
var IFCDIAMETERDIMENSION = 4147604152;
var IFCDAMPERTYPE = 3961806047;
var IFCCURTAINWALL = 3495092785;
var IFCCOVERING = 1973544240;
var IFCCOOLINGTOWERTYPE = 2954562838;
var IFCCOOLEDBEAMTYPE = 335055490;
var IFCCONSTRUCTIONPRODUCTRESOURCE = 488727124;
var IFCCONSTRUCTIONMATERIALRESOURCE = 1060000209;
var IFCCONSTRUCTIONEQUIPMENTRESOURCE = 3898045240;
var IFCCONDITIONCRITERION = 1163958913;
var IFCCONDITION = 2188551683;
var IFCCONDENSERTYPE = 2816379211;
var IFCCOMPRESSORTYPE = 3850581409;
var IFCCOLUMN = 843113511;
var IFCCOILTYPE = 2301859152;
var IFCCIRCLE = 2611217952;
var IFCCHILLERTYPE = 2951183804;
var IFCCABLESEGMENTTYPE = 1285652485;
var IFCCABLECARRIERSEGMENTTYPE = 3293546465;
var IFCCABLECARRIERFITTINGTYPE = 395041908;
var IFCBUILDINGELEMENTPROXYTYPE = 1909888760;
var IFCBUILDINGELEMENTPROXY = 1095909175;
var IFCBUILDINGELEMENTPART = 2979338954;
var IFCBUILDINGELEMENTCOMPONENT = 52481810;
var IFCBUILDINGELEMENT = 3299480353;
var IFCBOILERTYPE = 231477066;
var IFCBEZIERCURVE = 1916977116;
var IFCBEAMTYPE = 819618141;
var IFCBSPLINECURVE = 1967976161;
var IFCASSET = 3460190687;
var IFCANGULARDIMENSION = 2470393545;
var IFCAIRTOAIRHEATRECOVERYTYPE = 1871374353;
var IFCAIRTERMINALTYPE = 3352864051;
var IFCAIRTERMINALBOXTYPE = 1411407467;
var IFCACTIONREQUEST = 3821786052;
var IFC2DCOMPOSITECURVE = 1213861670;
var IFCZONE = 1033361043;
var IFCWORKSCHEDULE = 3342526732;
var IFCWORKPLAN = 4218914973;
var IFCWORKCONTROL = 1028945134;
var IFCWASTETERMINALTYPE = 1133259667;
var IFCWALLTYPE = 1898987631;
var IFCVIRTUALELEMENT = 2769231204;
var IFCVALVETYPE = 728799441;
var IFCUNITARYEQUIPMENTTYPE = 1911125066;
var IFCTUBEBUNDLETYPE = 1600972822;
var IFCTRIMMEDCURVE = 3593883385;
var IFCTRANSPORTELEMENT = 1620046519;
var IFCTRANSFORMERTYPE = 1692211062;
var IFCTIMESERIESSCHEDULE = 1637806684;
var IFCTANKTYPE = 5716631;
var IFCSYSTEM = 2254336722;
var IFCSWITCHINGDEVICETYPE = 2315554128;
var IFCSUBCONTRACTRESOURCE = 148013059;
var IFCSTRUCTURALSURFACECONNECTION = 1975003073;
var IFCSTRUCTURALRESULTGROUP = 2986769608;
var IFCSTRUCTURALPOINTREACTION = 1235345126;
var IFCSTRUCTURALPOINTCONNECTION = 734778138;
var IFCSTRUCTURALPOINTACTION = 2082059205;
var IFCSTRUCTURALPLANARACTIONVARYING = 3987759626;
var IFCSTRUCTURALPLANARACTION = 1621171031;
var IFCSTRUCTURALLOADGROUP = 1252848954;
var IFCSTRUCTURALLINEARACTIONVARYING = 1721250024;
var IFCSTRUCTURALLINEARACTION = 1807405624;
var IFCSTRUCTURALCURVEMEMBERVARYING = 2445595289;
var IFCSTRUCTURALCURVEMEMBER = 214636428;
var IFCSTRUCTURALCURVECONNECTION = 4243806635;
var IFCSTRUCTURALCONNECTION = 1179482911;
var IFCSTRUCTURALACTION = 682877961;
var IFCSTAIRFLIGHTTYPE = 1039846685;
var IFCSTACKTERMINALTYPE = 3112655638;
var IFCSPACETYPE = 3812236995;
var IFCSPACEPROGRAM = 652456506;
var IFCSPACEHEATERTYPE = 1305183839;
var IFCSPACE = 3856911033;
var IFCSLABTYPE = 2533589738;
var IFCSITE = 4097777520;
var IFCSERVICELIFE = 4105383287;
var IFCSCHEDULETIMECONTROL = 3517283431;
var IFCSANITARYTERMINALTYPE = 1768891740;
var IFCRELASSIGNSTASKS = 2863920197;
var IFCRELAGGREGATES = 160246688;
var IFCRAMPFLIGHTTYPE = 2324767716;
var IFCRAILINGTYPE = 2893384427;
var IFCRADIUSDIMENSION = 3248260540;
var IFCPUMPTYPE = 2250791053;
var IFCPROTECTIVEDEVICETYPE = 1842657554;
var IFCPROJECTIONELEMENT = 3651124850;
var IFCPROJECTORDERRECORD = 3642467123;
var IFCPROJECTORDER = 2904328755;
var IFCPROCEDURE = 2744685151;
var IFCPORT = 3740093272;
var IFCPOLYLINE = 3724593414;
var IFCPLATETYPE = 4017108033;
var IFCPIPESEGMENTTYPE = 4231323485;
var IFCPIPEFITTINGTYPE = 804291784;
var IFCPERMIT = 3327091369;
var IFCPERFORMANCEHISTORY = 2382730787;
var IFCOUTLETTYPE = 2837617999;
var IFCORDERACTION = 3425660407;
var IFCOPENINGELEMENT = 3588315303;
var IFCOCCUPANT = 4143007308;
var IFCMOVE = 1916936684;
var IFCMOTORCONNECTIONTYPE = 977012517;
var IFCMEMBERTYPE = 3181161470;
var IFCMECHANICALFASTENERTYPE = 2108223431;
var IFCMECHANICALFASTENER = 377706215;
var IFCLINEARDIMENSION = 2506943328;
var IFCLIGHTFIXTURETYPE = 1161773419;
var IFCLAMPTYPE = 1051575348;
var IFCLABORRESOURCE = 3827777499;
var IFCJUNCTIONBOXTYPE = 4288270099;
var IFCINVENTORY = 2391368822;
var IFCHUMIDIFIERTYPE = 1806887404;
var IFCHEATEXCHANGERTYPE = 1251058090;
var IFCGROUP = 2706460486;
var IFCGRID = 3009204131;
var IFCGASTERMINALTYPE = 200128114;
var IFCFURNITURESTANDARD = 814719939;
var IFCFURNISHINGELEMENT = 263784265;
var IFCFLOWTREATMENTDEVICETYPE = 3009222698;
var IFCFLOWTERMINALTYPE = 2297155007;
var IFCFLOWSTORAGEDEVICETYPE = 1339347760;
var IFCFLOWSEGMENTTYPE = 1834744321;
var IFCFLOWMOVINGDEVICETYPE = 1482959167;
var IFCFLOWMETERTYPE = 3815607619;
var IFCFLOWFITTINGTYPE = 3198132628;
var IFCFLOWCONTROLLERTYPE = 3907093117;
var IFCFEATUREELEMENTSUBTRACTION = 1287392070;
var IFCFEATUREELEMENTADDITION = 2143335405;
var IFCFEATUREELEMENT = 2827207264;
var IFCFASTENERTYPE = 2489546625;
var IFCFASTENER = 647756555;
var IFCFACETEDBREPWITHVOIDS = 3737207727;
var IFCFACETEDBREP = 807026263;
var IFCEVAPORATORTYPE = 3390157468;
var IFCEVAPORATIVECOOLERTYPE = 3174744832;
var IFCEQUIPMENTSTANDARD = 3272907226;
var IFCEQUIPMENTELEMENT = 1962604670;
var IFCENERGYCONVERSIONDEVICETYPE = 2107101300;
var IFCELLIPSE = 1704287377;
var IFCELEMENTCOMPONENTTYPE = 2590856083;
var IFCELEMENTCOMPONENT = 1623761950;
var IFCELEMENTASSEMBLY = 4123344466;
var IFCELEMENT = 1758889154;
var IFCELECTRICALBASEPROPERTIES = 360485395;
var IFCDISTRIBUTIONFLOWELEMENTTYPE = 3849074793;
var IFCDISTRIBUTIONELEMENTTYPE = 3256556792;
var IFCDIMENSIONCURVEDIRECTEDCALLOUT = 681481545;
var IFCCURTAINWALLTYPE = 1457835157;
var IFCCREWRESOURCE = 3295246426;
var IFCCOVERINGTYPE = 1916426348;
var IFCCOSTSCHEDULE = 1419761937;
var IFCCOSTITEM = 3895139033;
var IFCCONTROL = 3293443760;
var IFCCONSTRUCTIONRESOURCE = 2559216714;
var IFCCONIC = 2510884976;
var IFCCOMPOSITECURVE = 3732776249;
var IFCCOLUMNTYPE = 300633059;
var IFCCIRCLEHOLLOWPROFILEDEF = 2937912522;
var IFCBUILDINGSTOREY = 3124254112;
var IFCBUILDINGELEMENTTYPE = 1950629157;
var IFCBUILDING = 4031249490;
var IFCBOUNDEDCURVE = 1260505505;
var IFCBOOLEANCLIPPINGRESULT = 3649129432;
var IFCBLOCK = 1334484129;
var IFCASYMMETRICISHAPEPROFILEDEF = 3207858831;
var IFCANNOTATION = 1674181508;
var IFCACTOR = 2296667514;
var IFCTRANSPORTELEMENTTYPE = 2097647324;
var IFCTASK = 3473067441;
var IFCSYSTEMFURNITUREELEMENTTYPE = 1580310250;
var IFCSURFACEOFREVOLUTION = 4124788165;
var IFCSURFACEOFLINEAREXTRUSION = 2809605785;
var IFCSURFACECURVESWEPTAREASOLID = 2028607225;
var IFCSTRUCTUREDDIMENSIONCALLOUT = 4070609034;
var IFCSTRUCTURALSURFACEMEMBERVARYING = 2218152070;
var IFCSTRUCTURALSURFACEMEMBER = 3979015343;
var IFCSTRUCTURALREACTION = 3689010777;
var IFCSTRUCTURALMEMBER = 530289379;
var IFCSTRUCTURALITEM = 3136571912;
var IFCSTRUCTURALACTIVITY = 3544373492;
var IFCSPHERE = 451544542;
var IFCSPATIALSTRUCTUREELEMENTTYPE = 3893378262;
var IFCSPATIALSTRUCTUREELEMENT = 2706606064;
var IFCRIGHTCIRCULARCYLINDER = 3626867408;
var IFCRIGHTCIRCULARCONE = 4158566097;
var IFCREVOLVEDAREASOLID = 1856042241;
var IFCRESOURCE = 2914609552;
var IFCRELVOIDSELEMENT = 1401173127;
var IFCRELSPACEBOUNDARY = 3451746338;
var IFCRELSERVICESBUILDINGS = 366585022;
var IFCRELSEQUENCE = 4122056220;
var IFCRELSCHEDULESCOSTITEMS = 1058617721;
var IFCRELREFERENCEDINSPATIALSTRUCTURE = 1245217292;
var IFCRELPROJECTSELEMENT = 750771296;
var IFCRELOVERRIDESPROPERTIES = 202636808;
var IFCRELOCCUPIESSPACES = 2051452291;
var IFCRELNESTS = 3268803585;
var IFCRELINTERACTIONREQUIREMENTS = 4189434867;
var IFCRELFLOWCONTROLELEMENTS = 279856033;
var IFCRELFILLSELEMENT = 3940055652;
var IFCRELDEFINESBYTYPE = 781010003;
var IFCRELDEFINESBYPROPERTIES = 4186316022;
var IFCRELDEFINES = 693640335;
var IFCRELDECOMPOSES = 2551354335;
var IFCRELCOVERSSPACES = 2802773753;
var IFCRELCOVERSBLDGELEMENTS = 886880790;
var IFCRELCONTAINEDINSPATIALSTRUCTURE = 3242617779;
var IFCRELCONNECTSWITHREALIZINGELEMENTS = 3678494232;
var IFCRELCONNECTSWITHECCENTRICITY = 504942748;
var IFCRELCONNECTSSTRUCTURALMEMBER = 1638771189;
var IFCRELCONNECTSSTRUCTURALELEMENT = 3912681535;
var IFCRELCONNECTSSTRUCTURALACTIVITY = 2127690289;
var IFCRELCONNECTSPORTS = 3190031847;
var IFCRELCONNECTSPORTTOELEMENT = 4201705270;
var IFCRELCONNECTSPATHELEMENTS = 3945020480;
var IFCRELCONNECTSELEMENTS = 1204542856;
var IFCRELCONNECTS = 826625072;
var IFCRELASSOCIATESPROFILEPROPERTIES = 2851387026;
var IFCRELASSOCIATESMATERIAL = 2655215786;
var IFCRELASSOCIATESLIBRARY = 3840914261;
var IFCRELASSOCIATESDOCUMENT = 982818633;
var IFCRELASSOCIATESCONSTRAINT = 2728634034;
var IFCRELASSOCIATESCLASSIFICATION = 919958153;
var IFCRELASSOCIATESAPPROVAL = 4095574036;
var IFCRELASSOCIATESAPPLIEDVALUE = 1327628568;
var IFCRELASSOCIATES = 1865459582;
var IFCRELASSIGNSTORESOURCE = 205026976;
var IFCRELASSIGNSTOPROJECTORDER = 3372526763;
var IFCRELASSIGNSTOPRODUCT = 2857406711;
var IFCRELASSIGNSTOPROCESS = 4278684876;
var IFCRELASSIGNSTOGROUP = 1307041759;
var IFCRELASSIGNSTOCONTROL = 2495723537;
var IFCRELASSIGNSTOACTOR = 1683148259;
var IFCRELASSIGNS = 3939117080;
var IFCRECTANGULARTRIMMEDSURFACE = 3454111270;
var IFCRECTANGULARPYRAMID = 2798486643;
var IFCRECTANGLEHOLLOWPROFILEDEF = 2770003689;
var IFCPROXY = 3219374653;
var IFCPROPERTYSET = 1451395588;
var IFCPROJECTIONCURVE = 4194566429;
var IFCPROJECT = 103090709;
var IFCPRODUCT = 4208778838;
var IFCPROCESS = 2945172077;
var IFCPLANE = 220341763;
var IFCPLANARBOX = 603570806;
var IFCPERMEABLECOVERINGPROPERTIES = 3566463478;
var IFCOFFSETCURVE3D = 3505215534;
var IFCOFFSETCURVE2D = 3388369263;
var IFCOBJECT = 3888040117;
var IFCMANIFOLDSOLIDBREP = 1425443689;
var IFCLINE = 1281925730;
var IFCLSHAPEPROFILEDEF = 572779678;
var IFCISHAPEPROFILEDEF = 1484403080;
var IFCGEOMETRICCURVESET = 987898635;
var IFCFURNITURETYPE = 1268542332;
var IFCFURNISHINGELEMENTTYPE = 4238390223;
var IFCFLUIDFLOWPROPERTIES = 3455213021;
var IFCFILLAREASTYLETILES = 315944413;
var IFCFILLAREASTYLETILESYMBOLWITHSTYLE = 4203026998;
var IFCFILLAREASTYLEHATCHING = 374418227;
var IFCFACEBASEDSURFACEMODEL = 2047409740;
var IFCEXTRUDEDAREASOLID = 477187591;
var IFCENERGYPROPERTIES = 80994333;
var IFCELLIPSEPROFILEDEF = 2835456948;
var IFCELEMENTARYSURFACE = 2777663545;
var IFCELEMENTTYPE = 339256511;
var IFCELEMENTQUANTITY = 1883228015;
var IFCEDGELOOP = 1472233963;
var IFCDRAUGHTINGPREDEFINEDCURVEFONT = 4006246654;
var IFCDRAUGHTINGPREDEFINEDCOLOUR = 445594917;
var IFCDRAUGHTINGCALLOUT = 3073041342;
var IFCDOORSTYLE = 526551008;
var IFCDOORPANELPROPERTIES = 1714330368;
var IFCDOORLININGPROPERTIES = 2963535650;
var IFCDIRECTION = 32440307;
var IFCDIMENSIONCURVETERMINATOR = 4054601972;
var IFCDIMENSIONCURVE = 606661476;
var IFCDEFINEDSYMBOL = 693772133;
var IFCCURVEBOUNDEDPLANE = 2827736869;
var IFCCURVE = 2601014836;
var IFCCSGSOLID = 2147822146;
var IFCCSGPRIMITIVE3D = 2506170314;
var IFCCRANERAILFSHAPEPROFILEDEF = 194851669;
var IFCCRANERAILASHAPEPROFILEDEF = 4133800736;
var IFCCOMPOSITECURVESEGMENT = 2485617015;
var IFCCLOSEDSHELL = 2205249479;
var IFCCIRCLEPROFILEDEF = 1383045692;
var IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM = 1416205885;
var IFCCARTESIANTRANSFORMATIONOPERATOR3D = 3331915920;
var IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM = 3486308946;
var IFCCARTESIANTRANSFORMATIONOPERATOR2D = 3749851601;
var IFCCARTESIANTRANSFORMATIONOPERATOR = 59481748;
var IFCCARTESIANPOINT = 1123145078;
var IFCCSHAPEPROFILEDEF = 2898889636;
var IFCBOXEDHALFSPACE = 2713105998;
var IFCBOUNDINGBOX = 2581212453;
var IFCBOUNDEDSURFACE = 4182860854;
var IFCBOOLEANRESULT = 2736907675;
var IFCAXIS2PLACEMENT3D = 2740243338;
var IFCAXIS2PLACEMENT2D = 3125803723;
var IFCAXIS1PLACEMENT = 4261334040;
var IFCANNOTATIONSURFACE = 1302238472;
var IFCANNOTATIONFILLAREAOCCURRENCE = 2265737646;
var IFCANNOTATIONFILLAREA = 669184980;
var IFCANNOTATIONCURVEOCCURRENCE = 3288037868;
var IFCZSHAPEPROFILEDEF = 2543172580;
var IFCWINDOWSTYLE = 1299126871;
var IFCWINDOWPANELPROPERTIES = 512836454;
var IFCWINDOWLININGPROPERTIES = 336235671;
var IFCVERTEXLOOP = 2759199220;
var IFCVECTOR = 1417489154;
var IFCUSHAPEPROFILEDEF = 427810014;
var IFCTYPEPRODUCT = 2347495698;
var IFCTYPEOBJECT = 1628702193;
var IFCTWODIRECTIONREPEATFACTOR = 1345879162;
var IFCTRAPEZIUMPROFILEDEF = 2715220739;
var IFCTEXTLITERALWITHEXTENT = 3124975700;
var IFCTEXTLITERAL = 4282788508;
var IFCTERMINATORSYMBOL = 3028897424;
var IFCTSHAPEPROFILEDEF = 3071757647;
var IFCSWEPTSURFACE = 230924584;
var IFCSWEPTDISKSOLID = 1260650574;
var IFCSWEPTAREASOLID = 2247615214;
var IFCSURFACESTYLERENDERING = 1878645084;
var IFCSURFACE = 2513912981;
var IFCSUBEDGE = 2233826070;
var IFCSTRUCTURALSTEELPROFILEPROPERTIES = 3653947884;
var IFCSTRUCTURALPROFILEPROPERTIES = 3843319758;
var IFCSTRUCTURALLOADSINGLEFORCEWARPING = 1190533807;
var IFCSTRUCTURALLOADSINGLEFORCE = 1597423693;
var IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION = 1973038258;
var IFCSTRUCTURALLOADSINGLEDISPLACEMENT = 2473145415;
var IFCSTRUCTURALLOADPLANARFORCE = 2668620305;
var IFCSTRUCTURALLOADLINEARFORCE = 1595516126;
var IFCSPACETHERMALLOADPROPERTIES = 390701378;
var IFCSOUNDVALUE = 1202362311;
var IFCSOUNDPROPERTIES = 2485662743;
var IFCSOLIDMODEL = 723233188;
var IFCSLIPPAGECONNECTIONCONDITION = 2609359061;
var IFCSHELLBASEDSURFACEMODEL = 4124623270;
var IFCSERVICELIFEFACTOR = 2411513650;
var IFCSECTIONEDSPINE = 1509187699;
var IFCROUNDEDRECTANGLEPROFILEDEF = 2778083089;
var IFCRELATIONSHIP = 478536968;
var IFCREINFORCEMENTDEFINITIONPROPERTIES = 3765753017;
var IFCREGULARTIMESERIES = 3413951693;
var IFCRECTANGLEPROFILEDEF = 3615266464;
var IFCPROPERTYTABLEVALUE = 110355661;
var IFCPROPERTYSINGLEVALUE = 3650150729;
var IFCPROPERTYSETDEFINITION = 3357820518;
var IFCPROPERTYREFERENCEVALUE = 941946838;
var IFCPROPERTYLISTVALUE = 2752243245;
var IFCPROPERTYENUMERATEDVALUE = 4166981789;
var IFCPROPERTYDEFINITION = 1680319473;
var IFCPROPERTYBOUNDEDVALUE = 871118103;
var IFCPRODUCTDEFINITIONSHAPE = 673634403;
var IFCPREDEFINEDPOINTMARKERSYMBOL = 179317114;
var IFCPREDEFINEDDIMENSIONSYMBOL = 433424934;
var IFCPREDEFINEDCURVEFONT = 2559016684;
var IFCPREDEFINEDCOLOUR = 759155922;
var IFCPOLYGONALBOUNDEDHALFSPACE = 2775532180;
var IFCPOLYLOOP = 2924175390;
var IFCPOINTONSURFACE = 1423911732;
var IFCPOINTONCURVE = 4022376103;
var IFCPOINT = 2067069095;
var IFCPLANAREXTENT = 1663979128;
var IFCPLACEMENT = 2004835150;
var IFCPIXELTEXTURE = 597895409;
var IFCPHYSICALCOMPLEXQUANTITY = 3021840470;
var IFCPATH = 2519244187;
var IFCPARAMETERIZEDPROFILEDEF = 2529465313;
var IFCORIENTEDEDGE = 1029017970;
var IFCOPENSHELL = 2665983363;
var IFCONEDIRECTIONREPEATFACTOR = 2833995503;
var IFCOBJECTDEFINITION = 219451334;
var IFCMECHANICALCONCRETEMATERIALPROPERTIES = 1430189142;
var IFCMATERIALDEFINITIONREPRESENTATION = 2022407955;
var IFCMAPPEDITEM = 2347385850;
var IFCLOOP = 1008929658;
var IFCLOCALPLACEMENT = 2624227202;
var IFCLIGHTSOURCESPOT = 3422422726;
var IFCLIGHTSOURCEPOSITIONAL = 1520743889;
var IFCLIGHTSOURCEGONIOMETRIC = 4266656042;
var IFCLIGHTSOURCEDIRECTIONAL = 2604431987;
var IFCLIGHTSOURCEAMBIENT = 125510826;
var IFCLIGHTSOURCE = 1402838566;
var IFCIRREGULARTIMESERIES = 3741457305;
var IFCIMAGETEXTURE = 3905492369;
var IFCHYGROSCOPICMATERIALPROPERTIES = 2445078500;
var IFCHALFSPACESOLID = 812098782;
var IFCGRIDPLACEMENT = 178086475;
var IFCGEOMETRICSET = 3590301190;
var IFCGEOMETRICREPRESENTATIONSUBCONTEXT = 4142052618;
var IFCGEOMETRICREPRESENTATIONITEM = 2453401579;
var IFCGEOMETRICREPRESENTATIONCONTEXT = 3448662350;
var IFCGENERALPROFILEPROPERTIES = 1446786286;
var IFCGENERALMATERIALPROPERTIES = 803998398;
var IFCFUELPROPERTIES = 3857492461;
var IFCFILLAREASTYLE = 738692330;
var IFCFAILURECONNECTIONCONDITION = 4219587988;
var IFCFACESURFACE = 3008276851;
var IFCFACEOUTERBOUND = 803316827;
var IFCFACEBOUND = 1809719519;
var IFCFACE = 2556980723;
var IFCEXTENDEDMATERIALPROPERTIES = 1860660968;
var IFCEDGECURVE = 476780140;
var IFCEDGE = 3900360178;
var IFCDRAUGHTINGPREDEFINEDTEXTFONT = 4170525392;
var IFCDOCUMENTREFERENCE = 3732053477;
var IFCDIMENSIONPAIR = 1694125774;
var IFCDIMENSIONCALLOUTRELATIONSHIP = 2273265877;
var IFCDERIVEDPROFILEDEF = 3632507154;
var IFCCURVESTYLE = 3800577675;
var IFCCONVERSIONBASEDUNIT = 2889183280;
var IFCCONTEXTDEPENDENTUNIT = 3050246964;
var IFCCONNECTIONPOINTECCENTRICITY = 45288368;
var IFCCONNECTIONCURVEGEOMETRY = 1981873012;
var IFCCONNECTEDFACESET = 370225590;
var IFCCOMPOSITEPROFILEDEF = 1485152156;
var IFCCOMPLEXPROPERTY = 2542286263;
var IFCCOLOURRGB = 776857604;
var IFCCLASSIFICATIONREFERENCE = 647927063;
var IFCCENTERLINEPROFILEDEF = 3150382593;
var IFCBLOBTEXTURE = 616511568;
var IFCARBITRARYPROFILEDEFWITHVOIDS = 2705031697;
var IFCARBITRARYOPENPROFILEDEF = 1310608509;
var IFCARBITRARYCLOSEDPROFILEDEF = 3798115385;
var IFCANNOTATIONTEXTOCCURRENCE = 2297822566;
var IFCANNOTATIONSYMBOLOCCURRENCE = 3612888222;
var IFCANNOTATIONSURFACEOCCURRENCE = 962685235;
var IFCANNOTATIONOCCURRENCE = 2442683028;
var IFCWATERPROPERTIES = 1065908215;
var IFCVIRTUALGRIDINTERSECTION = 891718957;
var IFCVERTEXPOINT = 1907098498;
var IFCVERTEXBASEDTEXTUREMAP = 3304826586;
var IFCVERTEX = 2799835756;
var IFCUNITASSIGNMENT = 180925521;
var IFCTOPOLOGYREPRESENTATION = 1735638870;
var IFCTOPOLOGICALREPRESENTATIONITEM = 1377556343;
var IFCTIMESERIESVALUE = 581633288;
var IFCTIMESERIESREFERENCERELATIONSHIP = 1718945513;
var IFCTIMESERIES = 3101149627;
var IFCTHERMALMATERIALPROPERTIES = 3317419933;
var IFCTEXTUREVERTEX = 1210645708;
var IFCTEXTUREMAP = 2552916305;
var IFCTEXTURECOORDINATEGENERATOR = 1742049831;
var IFCTEXTURECOORDINATE = 280115917;
var IFCTEXTSTYLEWITHBOXCHARACTERISTICS = 1484833681;
var IFCTEXTSTYLETEXTMODEL = 1640371178;
var IFCTEXTSTYLEFORDEFINEDFONT = 2636378356;
var IFCTEXTSTYLEFONTMODEL = 1983826977;
var IFCTEXTSTYLE = 1447204868;
var IFCTELECOMADDRESS = 912023232;
var IFCTABLEROW = 531007025;
var IFCTABLE = 985171141;
var IFCSYMBOLSTYLE = 1290481447;
var IFCSURFACETEXTURE = 626085974;
var IFCSURFACESTYLEWITHTEXTURES = 1351298697;
var IFCSURFACESTYLESHADING = 846575682;
var IFCSURFACESTYLEREFRACTION = 1607154358;
var IFCSURFACESTYLELIGHTING = 3303107099;
var IFCSURFACESTYLE = 1300840506;
var IFCSTYLEDREPRESENTATION = 3049322572;
var IFCSTYLEDITEM = 3958052878;
var IFCSTYLEMODEL = 2830218821;
var IFCSTRUCTURALLOADTEMPERATURE = 3408363356;
var IFCSTRUCTURALLOADSTATIC = 2525727697;
var IFCSTRUCTURALLOAD = 2162789131;
var IFCSTRUCTURALCONNECTIONCONDITION = 2273995522;
var IFCSIMPLEPROPERTY = 3692461612;
var IFCSHAPEREPRESENTATION = 4240577450;
var IFCSHAPEMODEL = 3982875396;
var IFCSHAPEASPECT = 867548509;
var IFCSECTIONREINFORCEMENTPROPERTIES = 4165799628;
var IFCSECTIONPROPERTIES = 2042790032;
var IFCSIUNIT = 448429030;
var IFCROOT = 2341007311;
var IFCRIBPLATEPROFILEPROPERTIES = 3679540991;
var IFCREPRESENTATIONMAP = 1660063152;
var IFCREPRESENTATIONITEM = 3008791417;
var IFCREPRESENTATIONCONTEXT = 3377609919;
var IFCREPRESENTATION = 1076942058;
var IFCRELAXATION = 1222501353;
var IFCREINFORCEMENTBARPROPERTIES = 1580146022;
var IFCREFERENCESVALUEDOCUMENT = 2692823254;
var IFCQUANTITYWEIGHT = 825690147;
var IFCQUANTITYVOLUME = 2405470396;
var IFCQUANTITYTIME = 3252649465;
var IFCQUANTITYLENGTH = 931644368;
var IFCQUANTITYCOUNT = 2093928680;
var IFCQUANTITYAREA = 2044713172;
var IFCPROPERTYENUMERATION = 3710013099;
var IFCPROPERTYDEPENDENCYRELATIONSHIP = 148025276;
var IFCPROPERTYCONSTRAINTRELATIONSHIP = 3896028662;
var IFCPROPERTY = 2598011224;
var IFCPROFILEPROPERTIES = 2802850158;
var IFCPROFILEDEF = 3958567839;
var IFCPRODUCTSOFCOMBUSTIONPROPERTIES = 2267347899;
var IFCPRODUCTREPRESENTATION = 2095639259;
var IFCPRESENTATIONSTYLEASSIGNMENT = 2417041796;
var IFCPRESENTATIONSTYLE = 3119450353;
var IFCPRESENTATIONLAYERWITHSTYLE = 1304840413;
var IFCPRESENTATIONLAYERASSIGNMENT = 2022622350;
var IFCPREDEFINEDTEXTFONT = 1775413392;
var IFCPREDEFINEDTERMINATORSYMBOL = 3213052703;
var IFCPREDEFINEDSYMBOL = 990879717;
var IFCPREDEFINEDITEM = 3727388367;
var IFCPOSTALADDRESS = 3355820592;
var IFCPHYSICALSIMPLEQUANTITY = 2226359599;
var IFCPHYSICALQUANTITY = 2483315170;
var IFCPERSONANDORGANIZATION = 101040310;
var IFCPERSON = 2077209135;
var IFCOWNERHISTORY = 1207048766;
var IFCORGANIZATIONRELATIONSHIP = 1411181986;
var IFCORGANIZATION = 4251960020;
var IFCOPTICALMATERIALPROPERTIES = 1227763645;
var IFCOBJECTIVE = 2251480897;
var IFCOBJECTPLACEMENT = 3701648758;
var IFCNAMEDUNIT = 1918398963;
var IFCMONETARYUNIT = 2706619895;
var IFCMETRIC = 3368373690;
var IFCMECHANICALSTEELMATERIALPROPERTIES = 677618848;
var IFCMECHANICALMATERIALPROPERTIES = 4256014907;
var IFCMEASUREWITHUNIT = 2597039031;
var IFCMATERIALPROPERTIES = 3265635763;
var IFCMATERIALLIST = 2199411900;
var IFCMATERIALLAYERSETUSAGE = 1303795690;
var IFCMATERIALLAYERSET = 3303938423;
var IFCMATERIALLAYER = 248100487;
var IFCMATERIALCLASSIFICATIONRELATIONSHIP = 1847130766;
var IFCMATERIAL = 1838606355;
var IFCLOCALTIME = 30780891;
var IFCLIGHTINTENSITYDISTRIBUTION = 1566485204;
var IFCLIGHTDISTRIBUTIONDATA = 4162380809;
var IFCLIBRARYREFERENCE = 3452421091;
var IFCLIBRARYINFORMATION = 2655187982;
var IFCIRREGULARTIMESERIESVALUE = 3020489413;
var IFCGRIDAXIS = 852622518;
var IFCEXTERNALLYDEFINEDTEXTFONT = 3548104201;
var IFCEXTERNALLYDEFINEDSYMBOL = 3207319532;
var IFCEXTERNALLYDEFINEDSURFACESTYLE = 1040185647;
var IFCEXTERNALLYDEFINEDHATCHSTYLE = 2242383968;
var IFCEXTERNALREFERENCE = 3200245327;
var IFCENVIRONMENTALIMPACTVALUE = 1648886627;
var IFCDRAUGHTINGCALLOUTRELATIONSHIP = 3796139169;
var IFCDOCUMENTINFORMATIONRELATIONSHIP = 770865208;
var IFCDOCUMENTINFORMATION = 1154170062;
var IFCDOCUMENTELECTRONICFORMAT = 1376555844;
var IFCDIMENSIONALEXPONENTS = 2949456006;
var IFCDERIVEDUNITELEMENT = 1045800335;
var IFCDERIVEDUNIT = 1765591967;
var IFCDATEANDTIME = 1072939445;
var IFCCURVESTYLEFONTPATTERN = 3510044353;
var IFCCURVESTYLEFONTANDSCALING = 2367409068;
var IFCCURVESTYLEFONT = 1105321065;
var IFCCURRENCYRELATIONSHIP = 539742890;
var IFCCOSTVALUE = 602808272;
var IFCCOORDINATEDUNIVERSALTIMEOFFSET = 1065062679;
var IFCCONSTRAINTRELATIONSHIP = 347226245;
var IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP = 613356794;
var IFCCONSTRAINTAGGREGATIONRELATIONSHIP = 1658513725;
var IFCCONSTRAINT = 1959218052;
var IFCCONNECTIONSURFACEGEOMETRY = 2732653382;
var IFCCONNECTIONPORTGEOMETRY = 4257277454;
var IFCCONNECTIONPOINTGEOMETRY = 2614616156;
var IFCCONNECTIONGEOMETRY = 2859738748;
var IFCCOLOURSPECIFICATION = 3264961684;
var IFCCLASSIFICATIONNOTATIONFACET = 3639012971;
var IFCCLASSIFICATIONNOTATION = 938368621;
var IFCCLASSIFICATIONITEMRELATIONSHIP = 1098599126;
var IFCCLASSIFICATIONITEM = 1767535486;
var IFCCLASSIFICATION = 747523909;
var IFCCALENDARDATE = 622194075;
var IFCBOUNDARYNODECONDITIONWARPING = 2069777674;
var IFCBOUNDARYNODECONDITION = 1387855156;
var IFCBOUNDARYFACECONDITION = 3367102660;
var IFCBOUNDARYEDGECONDITION = 1560379544;
var IFCBOUNDARYCONDITION = 4037036970;
var IFCAPPROVALRELATIONSHIP = 3869604511;
var IFCAPPROVALPROPERTYRELATIONSHIP = 390851274;
var IFCAPPROVALACTORRELATIONSHIP = 2080292479;
var IFCAPPROVAL = 130549933;
var IFCAPPLIEDVALUERELATIONSHIP = 1110488051;
var IFCAPPLIEDVALUE = 411424972;
var IFCAPPLICATION = 639542469;
var IFCADDRESS = 618182010;
var IFCACTORROLE = 3630933823;
var FILE_DESCRIPTION = 599546466;
var FILE_NAME = 1390159747;
var FILE_SCHEMA = 1109904537;
var Handle = class {
  constructor(value) {
    this.value = value;
    this.type = 5;
  }
};
var IfcLineObject = class {
  constructor(expressID) {
    this.expressID = expressID;
    this.type = 0;
  }
};
var FromRawLineData = [];
var InversePropertyDef = {};
var InheritanceDef = {};
var Constructors = {};
var ToRawLineData = {};
var TypeInitialisers = {};
var SchemaNames = [];
function TypeInitialiser(schema, tapeItem) {
  if (tapeItem.typecode)
    return TypeInitialisers[schema][tapeItem.typecode](tapeItem.value);
  else
    return tapeItem.value;
}
function Labelise(tapeItem) {
  tapeItem.valueType = tapeItem.type;
  tapeItem.type = 2;
  tapeItem.label = tapeItem.constructor.name.toUpperCase();
  return tapeItem;
}
var Schemas;
(function(Schemas2) {
  Schemas2["IFC2X3"] = "IFC2X3";
  Schemas2["IFC4_3"] = "IFC4.3";
  Schemas2["IFC4"] = "IFC4";
})(Schemas || (Schemas = {}));
SchemaNames[1] = "IFC2X3";
FromRawLineData[1] = {
  3630933823: (id, v) => new IFC2X3.IfcActorRole(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcText(v[2].value)),
  618182010: (id, v) => new IFC2X3.IfcAddress(id, v[0], !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  639542469: (id, v) => new IFC2X3.IfcApplication(id, new Handle(v[0].value), new IFC2X3.IfcLabel(v[1].value), new IFC2X3.IfcLabel(v[2].value), new IFC2X3.IfcIdentifier(v[3].value)),
  411424972: (id, v) => new IFC2X3.IfcAppliedValue(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value)),
  1110488051: (id, v) => new IFC2X3.IfcAppliedValueRelationship(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), v[2], !v[3] ? null : new IFC2X3.IfcLabel(v[3].value), !v[4] ? null : new IFC2X3.IfcText(v[4].value)),
  130549933: (id, v) => new IFC2X3.IfcApproval(id, !v[0] ? null : new IFC2X3.IfcText(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcLabel(v[3].value), !v[4] ? null : new IFC2X3.IfcText(v[4].value), new IFC2X3.IfcLabel(v[5].value), new IFC2X3.IfcIdentifier(v[6].value)),
  2080292479: (id, v) => new IFC2X3.IfcApprovalActorRelationship(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value)),
  390851274: (id, v) => new IFC2X3.IfcApprovalPropertyRelationship(id, v[0].map((p) => new Handle(p.value)), new Handle(v[1].value)),
  3869604511: (id, v) => new IFC2X3.IfcApprovalRelationship(id, new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcText(v[2].value), new IFC2X3.IfcLabel(v[3].value)),
  4037036970: (id, v) => new IFC2X3.IfcBoundaryCondition(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value)),
  1560379544: (id, v) => new IFC2X3.IfcBoundaryEdgeCondition(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcModulusOfLinearSubgradeReactionMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcModulusOfLinearSubgradeReactionMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcModulusOfLinearSubgradeReactionMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcModulusOfRotationalSubgradeReactionMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcModulusOfRotationalSubgradeReactionMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcModulusOfRotationalSubgradeReactionMeasure(v[6].value)),
  3367102660: (id, v) => new IFC2X3.IfcBoundaryFaceCondition(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcModulusOfSubgradeReactionMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcModulusOfSubgradeReactionMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcModulusOfSubgradeReactionMeasure(v[3].value)),
  1387855156: (id, v) => new IFC2X3.IfcBoundaryNodeCondition(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLinearStiffnessMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcLinearStiffnessMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcLinearStiffnessMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcRotationalStiffnessMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcRotationalStiffnessMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcRotationalStiffnessMeasure(v[6].value)),
  2069777674: (id, v) => new IFC2X3.IfcBoundaryNodeConditionWarping(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLinearStiffnessMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcLinearStiffnessMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcLinearStiffnessMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcRotationalStiffnessMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcRotationalStiffnessMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcRotationalStiffnessMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcWarpingMomentMeasure(v[7].value)),
  622194075: (id, v) => new IFC2X3.IfcCalendarDate(id, new IFC2X3.IfcDayInMonthNumber(v[0].value), new IFC2X3.IfcMonthInYearNumber(v[1].value), new IFC2X3.IfcYearNumber(v[2].value)),
  747523909: (id, v) => new IFC2X3.IfcClassification(id, new IFC2X3.IfcLabel(v[0].value), new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC2X3.IfcLabel(v[3].value)),
  1767535486: (id, v) => new IFC2X3.IfcClassificationItem(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new IFC2X3.IfcLabel(v[2].value)),
  1098599126: (id, v) => new IFC2X3.IfcClassificationItemRelationship(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value))),
  938368621: (id, v) => new IFC2X3.IfcClassificationNotation(id, v[0].map((p) => new Handle(p.value))),
  3639012971: (id, v) => new IFC2X3.IfcClassificationNotationFacet(id, new IFC2X3.IfcLabel(v[0].value)),
  3264961684: (id, v) => new IFC2X3.IfcColourSpecification(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value)),
  2859738748: (id, _) => new IFC2X3.IfcConnectionGeometry(id),
  2614616156: (id, v) => new IFC2X3.IfcConnectionPointGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  4257277454: (id, v) => new IFC2X3.IfcConnectionPortGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value)),
  2732653382: (id, v) => new IFC2X3.IfcConnectionSurfaceGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  1959218052: (id, v) => new IFC2X3.IfcConstraint(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2], !v[3] ? null : new IFC2X3.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value)),
  1658513725: (id, v) => new IFC2X3.IfcConstraintAggregationRelationship(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value)), v[4]),
  613356794: (id, v) => new IFC2X3.IfcConstraintClassificationRelationship(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value))),
  347226245: (id, v) => new IFC2X3.IfcConstraintRelationship(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value))),
  1065062679: (id, v) => new IFC2X3.IfcCoordinatedUniversalTimeOffset(id, new IFC2X3.IfcHourInDay(v[0].value), !v[1] ? null : new IFC2X3.IfcMinuteInHour(v[1].value), v[2]),
  602808272: (id, v) => new IFC2X3.IfcCostValue(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new IFC2X3.IfcText(v[7].value)),
  539742890: (id, v) => new IFC2X3.IfcCurrencyRelationship(id, new Handle(v[0].value), new Handle(v[1].value), new IFC2X3.IfcPositiveRatioMeasure(v[2].value), new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value)),
  1105321065: (id, v) => new IFC2X3.IfcCurveStyleFont(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), v[1].map((p) => new Handle(p.value))),
  2367409068: (id, v) => new IFC2X3.IfcCurveStyleFontAndScaling(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new Handle(v[1].value), new IFC2X3.IfcPositiveRatioMeasure(v[2].value)),
  3510044353: (id, v) => new IFC2X3.IfcCurveStyleFontPattern(id, new IFC2X3.IfcLengthMeasure(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value)),
  1072939445: (id, v) => new IFC2X3.IfcDateAndTime(id, new Handle(v[0].value), new Handle(v[1].value)),
  1765591967: (id, v) => new IFC2X3.IfcDerivedUnit(id, v[0].map((p) => new Handle(p.value)), v[1], !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  1045800335: (id, v) => new IFC2X3.IfcDerivedUnitElement(id, new Handle(v[0].value), v[1].value),
  2949456006: (id, v) => new IFC2X3.IfcDimensionalExponents(id, v[0].value, v[1].value, v[2].value, v[3].value, v[4].value, v[5].value, v[6].value),
  1376555844: (id, v) => new IFC2X3.IfcDocumentElectronicFormat(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  1154170062: (id, v) => new IFC2X3.IfcDocumentInformation(id, new IFC2X3.IfcIdentifier(v[0].value), new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcText(v[2].value), !v[3] ? null : v[3].map((p) => new Handle(p.value)), !v[4] ? null : new IFC2X3.IfcText(v[4].value), !v[5] ? null : new IFC2X3.IfcText(v[5].value), !v[6] ? null : new IFC2X3.IfcText(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new Handle(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new Handle(v[10].value), !v[11] ? null : new Handle(v[11].value), !v[12] ? null : new Handle(v[12].value), !v[13] ? null : new Handle(v[13].value), !v[14] ? null : new Handle(v[14].value), v[15], v[16]),
  770865208: (id, v) => new IFC2X3.IfcDocumentInformationRelationship(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  3796139169: (id, v) => new IFC2X3.IfcDraughtingCalloutRelationship(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value)),
  1648886627: (id, v) => new IFC2X3.IfcEnvironmentalImpactValue(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  3200245327: (id, v) => new IFC2X3.IfcExternalReference(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  2242383968: (id, v) => new IFC2X3.IfcExternallyDefinedHatchStyle(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  1040185647: (id, v) => new IFC2X3.IfcExternallyDefinedSurfaceStyle(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  3207319532: (id, v) => new IFC2X3.IfcExternallyDefinedSymbol(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  3548104201: (id, v) => new IFC2X3.IfcExternallyDefinedTextFont(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  852622518: (id, v) => new IFC2X3.IfcGridAxis(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new Handle(v[1].value), new IFC2X3.IfcBoolean(v[2].value)),
  3020489413: (id, v) => new IFC2X3.IfcIrregularTimeSeriesValue(id, new Handle(v[0].value), v[1].map((p) => TypeInitialiser(1, p))),
  2655187982: (id, v) => new IFC2X3.IfcLibraryInformation(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map((p) => new Handle(p.value))),
  3452421091: (id, v) => new IFC2X3.IfcLibraryReference(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  4162380809: (id, v) => new IFC2X3.IfcLightDistributionData(id, new IFC2X3.IfcPlaneAngleMeasure(v[0].value), v[1].map((p) => new IFC2X3.IfcPlaneAngleMeasure(p.value)), v[2].map((p) => new IFC2X3.IfcLuminousIntensityDistributionMeasure(p.value))),
  1566485204: (id, v) => new IFC2X3.IfcLightIntensityDistribution(id, v[0], v[1].map((p) => new Handle(p.value))),
  30780891: (id, v) => new IFC2X3.IfcLocalTime(id, new IFC2X3.IfcHourInDay(v[0].value), !v[1] ? null : new IFC2X3.IfcMinuteInHour(v[1].value), !v[2] ? null : new IFC2X3.IfcSecondInMinute(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC2X3.IfcDaylightSavingHour(v[4].value)),
  1838606355: (id, v) => new IFC2X3.IfcMaterial(id, new IFC2X3.IfcLabel(v[0].value)),
  1847130766: (id, v) => new IFC2X3.IfcMaterialClassificationRelationship(id, v[0].map((p) => new Handle(p.value)), new Handle(v[1].value)),
  248100487: (id, v) => new IFC2X3.IfcMaterialLayer(id, !v[0] ? null : new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcLogical(v[2].value)),
  3303938423: (id, v) => new IFC2X3.IfcMaterialLayerSet(id, v[0].map((p) => new Handle(p.value)), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value)),
  1303795690: (id, v) => new IFC2X3.IfcMaterialLayerSetUsage(id, new Handle(v[0].value), v[1], v[2], new IFC2X3.IfcLengthMeasure(v[3].value)),
  2199411900: (id, v) => new IFC2X3.IfcMaterialList(id, v[0].map((p) => new Handle(p.value))),
  3265635763: (id, v) => new IFC2X3.IfcMaterialProperties(id, new Handle(v[0].value)),
  2597039031: (id, v) => new IFC2X3.IfcMeasureWithUnit(id, TypeInitialiser(1, v[0]), new Handle(v[1].value)),
  4256014907: (id, v) => new IFC2X3.IfcMechanicalMaterialProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcDynamicViscosityMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcModulusOfElasticityMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcModulusOfElasticityMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcThermalExpansionCoefficientMeasure(v[5].value)),
  677618848: (id, v) => new IFC2X3.IfcMechanicalSteelMaterialProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcDynamicViscosityMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcModulusOfElasticityMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcModulusOfElasticityMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcThermalExpansionCoefficientMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPressureMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPressureMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcModulusOfElasticityMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcPressureMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[11].value), !v[12] ? null : v[12].map((p) => new Handle(p.value))),
  3368373690: (id, v) => new IFC2X3.IfcMetric(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2], !v[3] ? null : new IFC2X3.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), new Handle(v[9].value)),
  2706619895: (id, v) => new IFC2X3.IfcMonetaryUnit(id, v[0]),
  1918398963: (id, v) => new IFC2X3.IfcNamedUnit(id, new Handle(v[0].value), v[1]),
  3701648758: (id, _) => new IFC2X3.IfcObjectPlacement(id),
  2251480897: (id, v) => new IFC2X3.IfcObjective(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2], !v[3] ? null : new IFC2X3.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value), v[9], !v[10] ? null : new IFC2X3.IfcLabel(v[10].value)),
  1227763645: (id, v) => new IFC2X3.IfcOpticalMaterialProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[9].value)),
  4251960020: (id, v) => new IFC2X3.IfcOrganization(id, !v[0] ? null : new IFC2X3.IfcIdentifier(v[0].value), new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcText(v[2].value), !v[3] ? null : v[3].map((p) => new Handle(p.value)), !v[4] ? null : v[4].map((p) => new Handle(p.value))),
  1411181986: (id, v) => new IFC2X3.IfcOrganizationRelationship(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value))),
  1207048766: (id, v) => new IFC2X3.IfcOwnerHistory(id, new Handle(v[0].value), new Handle(v[1].value), v[2], v[3], !v[4] ? null : new IFC2X3.IfcTimeStamp(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new IFC2X3.IfcTimeStamp(v[7].value)),
  2077209135: (id, v) => new IFC2X3.IfcPerson(id, !v[0] ? null : new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : v[3].map((p) => new IFC2X3.IfcLabel(p.value)), !v[4] ? null : v[4].map((p) => new IFC2X3.IfcLabel(p.value)), !v[5] ? null : v[5].map((p) => new IFC2X3.IfcLabel(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : v[7].map((p) => new Handle(p.value))),
  101040310: (id, v) => new IFC2X3.IfcPersonAndOrganization(id, new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : v[2].map((p) => new Handle(p.value))),
  2483315170: (id, v) => new IFC2X3.IfcPhysicalQuantity(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value)),
  2226359599: (id, v) => new IFC2X3.IfcPhysicalSimpleQuantity(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value)),
  3355820592: (id, v) => new IFC2X3.IfcPostalAddress(id, v[0], !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcLabel(v[3].value), !v[4] ? null : v[4].map((p) => new IFC2X3.IfcLabel(p.value)), !v[5] ? null : new IFC2X3.IfcLabel(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), !v[9] ? null : new IFC2X3.IfcLabel(v[9].value)),
  3727388367: (id, v) => new IFC2X3.IfcPreDefinedItem(id, new IFC2X3.IfcLabel(v[0].value)),
  990879717: (id, v) => new IFC2X3.IfcPreDefinedSymbol(id, new IFC2X3.IfcLabel(v[0].value)),
  3213052703: (id, v) => new IFC2X3.IfcPreDefinedTerminatorSymbol(id, new IFC2X3.IfcLabel(v[0].value)),
  1775413392: (id, v) => new IFC2X3.IfcPreDefinedTextFont(id, new IFC2X3.IfcLabel(v[0].value)),
  2022622350: (id, v) => new IFC2X3.IfcPresentationLayerAssignment(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), !v[3] ? null : new IFC2X3.IfcIdentifier(v[3].value)),
  1304840413: (id, v) => new IFC2X3.IfcPresentationLayerWithStyle(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), !v[3] ? null : new IFC2X3.IfcIdentifier(v[3].value), v[4].value, v[5].value, v[6].value, v[7].map((p) => new Handle(p.value))),
  3119450353: (id, v) => new IFC2X3.IfcPresentationStyle(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value)),
  2417041796: (id, v) => new IFC2X3.IfcPresentationStyleAssignment(id, v[0].map((p) => new Handle(p.value))),
  2095639259: (id, v) => new IFC2X3.IfcProductRepresentation(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map((p) => new Handle(p.value))),
  2267347899: (id, v) => new IFC2X3.IfcProductsOfCombustionProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcSpecificHeatCapacityMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[4].value)),
  3958567839: (id, v) => new IFC2X3.IfcProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value)),
  2802850158: (id, v) => new IFC2X3.IfcProfileProperties(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  2598011224: (id, v) => new IFC2X3.IfcProperty(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value)),
  3896028662: (id, v) => new IFC2X3.IfcPropertyConstraintRelationship(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value)),
  148025276: (id, v) => new IFC2X3.IfcPropertyDependencyRelationship(id, new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcText(v[4].value)),
  3710013099: (id, v) => new IFC2X3.IfcPropertyEnumeration(id, new IFC2X3.IfcLabel(v[0].value), v[1].map((p) => TypeInitialiser(1, p)), !v[2] ? null : new Handle(v[2].value)),
  2044713172: (id, v) => new IFC2X3.IfcQuantityArea(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC2X3.IfcAreaMeasure(v[3].value)),
  2093928680: (id, v) => new IFC2X3.IfcQuantityCount(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC2X3.IfcCountMeasure(v[3].value)),
  931644368: (id, v) => new IFC2X3.IfcQuantityLength(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC2X3.IfcLengthMeasure(v[3].value)),
  3252649465: (id, v) => new IFC2X3.IfcQuantityTime(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC2X3.IfcTimeMeasure(v[3].value)),
  2405470396: (id, v) => new IFC2X3.IfcQuantityVolume(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC2X3.IfcVolumeMeasure(v[3].value)),
  825690147: (id, v) => new IFC2X3.IfcQuantityWeight(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC2X3.IfcMassMeasure(v[3].value)),
  2692823254: (id, v) => new IFC2X3.IfcReferencesValueDocument(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value)),
  1580146022: (id, v) => new IFC2X3.IfcReinforcementBarProperties(id, new IFC2X3.IfcAreaMeasure(v[0].value), new IFC2X3.IfcLabel(v[1].value), v[2], !v[3] ? null : new IFC2X3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcCountMeasure(v[5].value)),
  1222501353: (id, v) => new IFC2X3.IfcRelaxation(id, new IFC2X3.IfcNormalisedRatioMeasure(v[0].value), new IFC2X3.IfcNormalisedRatioMeasure(v[1].value)),
  1076942058: (id, v) => new IFC2X3.IfcRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  3377609919: (id, v) => new IFC2X3.IfcRepresentationContext(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value)),
  3008791417: (id, _) => new IFC2X3.IfcRepresentationItem(id),
  1660063152: (id, v) => new IFC2X3.IfcRepresentationMap(id, new Handle(v[0].value), new Handle(v[1].value)),
  3679540991: (id, v) => new IFC2X3.IfcRibPlateProfileProperties(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[5].value), v[6]),
  2341007311: (id, v) => new IFC2X3.IfcRoot(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value)),
  448429030: (id, v) => new IFC2X3.IfcSIUnit(id, v[0], v[1], v[2]),
  2042790032: (id, v) => new IFC2X3.IfcSectionProperties(id, v[0], new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value)),
  4165799628: (id, v) => new IFC2X3.IfcSectionReinforcementProperties(id, new IFC2X3.IfcLengthMeasure(v[0].value), new IFC2X3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcLengthMeasure(v[2].value), v[3], new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  867548509: (id, v) => new IFC2X3.IfcShapeAspect(id, v[0].map((p) => new Handle(p.value)), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcText(v[2].value), v[3].value, new Handle(v[4].value)),
  3982875396: (id, v) => new IFC2X3.IfcShapeModel(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  4240577450: (id, v) => new IFC2X3.IfcShapeRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  3692461612: (id, v) => new IFC2X3.IfcSimpleProperty(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value)),
  2273995522: (id, v) => new IFC2X3.IfcStructuralConnectionCondition(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value)),
  2162789131: (id, v) => new IFC2X3.IfcStructuralLoad(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value)),
  2525727697: (id, v) => new IFC2X3.IfcStructuralLoadStatic(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value)),
  3408363356: (id, v) => new IFC2X3.IfcStructuralLoadTemperature(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(v[3].value)),
  2830218821: (id, v) => new IFC2X3.IfcStyleModel(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  3958052878: (id, v) => new IFC2X3.IfcStyledItem(id, !v[0] ? null : new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  3049322572: (id, v) => new IFC2X3.IfcStyledRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  1300840506: (id, v) => new IFC2X3.IfcSurfaceStyle(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), v[1], v[2].map((p) => new Handle(p.value))),
  3303107099: (id, v) => new IFC2X3.IfcSurfaceStyleLighting(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new Handle(v[3].value)),
  1607154358: (id, v) => new IFC2X3.IfcSurfaceStyleRefraction(id, !v[0] ? null : new IFC2X3.IfcReal(v[0].value), !v[1] ? null : new IFC2X3.IfcReal(v[1].value)),
  846575682: (id, v) => new IFC2X3.IfcSurfaceStyleShading(id, new Handle(v[0].value)),
  1351298697: (id, v) => new IFC2X3.IfcSurfaceStyleWithTextures(id, v[0].map((p) => new Handle(p.value))),
  626085974: (id, v) => new IFC2X3.IfcSurfaceTexture(id, v[0].value, v[1].value, v[2], !v[3] ? null : new Handle(v[3].value)),
  1290481447: (id, v) => new IFC2X3.IfcSymbolStyle(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), TypeInitialiser(1, v[1])),
  985171141: (id, v) => new IFC2X3.IfcTable(id, v[0].value, v[1].map((p) => new Handle(p.value))),
  531007025: (id, v) => new IFC2X3.IfcTableRow(id, v[0].map((p) => TypeInitialiser(1, p)), v[1].value),
  912023232: (id, v) => new IFC2X3.IfcTelecomAddress(id, v[0], !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : v[3].map((p) => new IFC2X3.IfcLabel(p.value)), !v[4] ? null : v[4].map((p) => new IFC2X3.IfcLabel(p.value)), !v[5] ? null : new IFC2X3.IfcLabel(v[5].value), !v[6] ? null : v[6].map((p) => new IFC2X3.IfcLabel(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value)),
  1447204868: (id, v) => new IFC2X3.IfcTextStyle(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value), new Handle(v[3].value)),
  1983826977: (id, v) => new IFC2X3.IfcTextStyleFontModel(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : v[1].map((p) => new IFC2X3.IfcTextFontName(p.value)), !v[2] ? null : new IFC2X3.IfcFontStyle(v[2].value), !v[3] ? null : new IFC2X3.IfcFontVariant(v[3].value), !v[4] ? null : new IFC2X3.IfcFontWeight(v[4].value), TypeInitialiser(1, v[5])),
  2636378356: (id, v) => new IFC2X3.IfcTextStyleForDefinedFont(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  1640371178: (id, v) => new IFC2X3.IfcTextStyleTextModel(id, !v[0] ? null : TypeInitialiser(1, v[0]), !v[1] ? null : new IFC2X3.IfcTextAlignment(v[1].value), !v[2] ? null : new IFC2X3.IfcTextDecoration(v[2].value), !v[3] ? null : TypeInitialiser(1, v[3]), !v[4] ? null : TypeInitialiser(1, v[4]), !v[5] ? null : new IFC2X3.IfcTextTransformation(v[5].value), !v[6] ? null : TypeInitialiser(1, v[6])),
  1484833681: (id, v) => new IFC2X3.IfcTextStyleWithBoxCharacteristics(id, !v[0] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[0].value), !v[1] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[3].value), !v[4] ? null : TypeInitialiser(1, v[4])),
  280115917: (id, _) => new IFC2X3.IfcTextureCoordinate(id),
  1742049831: (id, v) => new IFC2X3.IfcTextureCoordinateGenerator(id, new IFC2X3.IfcLabel(v[0].value), v[1].map((p) => TypeInitialiser(1, p))),
  2552916305: (id, v) => new IFC2X3.IfcTextureMap(id, v[0].map((p) => new Handle(p.value))),
  1210645708: (id, v) => new IFC2X3.IfcTextureVertex(id, v[0].map((p) => new IFC2X3.IfcParameterValue(p.value))),
  3317419933: (id, v) => new IFC2X3.IfcThermalMaterialProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcSpecificHeatCapacityMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcThermalConductivityMeasure(v[4].value)),
  3101149627: (id, v) => new IFC2X3.IfcTimeSeries(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value), v[4], v[5], !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  1718945513: (id, v) => new IFC2X3.IfcTimeSeriesReferenceRelationship(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value))),
  581633288: (id, v) => new IFC2X3.IfcTimeSeriesValue(id, v[0].map((p) => TypeInitialiser(1, p))),
  1377556343: (id, _) => new IFC2X3.IfcTopologicalRepresentationItem(id),
  1735638870: (id, v) => new IFC2X3.IfcTopologyRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  180925521: (id, v) => new IFC2X3.IfcUnitAssignment(id, v[0].map((p) => new Handle(p.value))),
  2799835756: (id, _) => new IFC2X3.IfcVertex(id),
  3304826586: (id, v) => new IFC2X3.IfcVertexBasedTextureMap(id, v[0].map((p) => new Handle(p.value)), v[1].map((p) => new Handle(p.value))),
  1907098498: (id, v) => new IFC2X3.IfcVertexPoint(id, new Handle(v[0].value)),
  891718957: (id, v) => new IFC2X3.IfcVirtualGridIntersection(id, v[0].map((p) => new Handle(p.value)), v[1].map((p) => new IFC2X3.IfcLengthMeasure(p.value))),
  1065908215: (id, v) => new IFC2X3.IfcWaterProperties(id, new Handle(v[0].value), !v[1] ? null : v[1].value, !v[2] ? null : new IFC2X3.IfcIonConcentrationMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcIonConcentrationMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcIonConcentrationMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPHMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[7].value)),
  2442683028: (id, v) => new IFC2X3.IfcAnnotationOccurrence(id, !v[0] ? null : new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  962685235: (id, v) => new IFC2X3.IfcAnnotationSurfaceOccurrence(id, !v[0] ? null : new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  3612888222: (id, v) => new IFC2X3.IfcAnnotationSymbolOccurrence(id, !v[0] ? null : new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  2297822566: (id, v) => new IFC2X3.IfcAnnotationTextOccurrence(id, !v[0] ? null : new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  3798115385: (id, v) => new IFC2X3.IfcArbitraryClosedProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value)),
  1310608509: (id, v) => new IFC2X3.IfcArbitraryOpenProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value)),
  2705031697: (id, v) => new IFC2X3.IfcArbitraryProfileDefWithVoids(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value))),
  616511568: (id, v) => new IFC2X3.IfcBlobTexture(id, v[0].value, v[1].value, v[2], !v[3] ? null : new Handle(v[3].value), new IFC2X3.IfcIdentifier(v[4].value), v[5].value),
  3150382593: (id, v) => new IFC2X3.IfcCenterLineProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value)),
  647927063: (id, v) => new IFC2X3.IfcClassificationReference(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new Handle(v[3].value)),
  776857604: (id, v) => new IFC2X3.IfcColourRgb(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new IFC2X3.IfcNormalisedRatioMeasure(v[1].value), new IFC2X3.IfcNormalisedRatioMeasure(v[2].value), new IFC2X3.IfcNormalisedRatioMeasure(v[3].value)),
  2542286263: (id, v) => new IFC2X3.IfcComplexProperty(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new IFC2X3.IfcIdentifier(v[2].value), v[3].map((p) => new Handle(p.value))),
  1485152156: (id, v) => new IFC2X3.IfcCompositeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), v[2].map((p) => new Handle(p.value)), !v[3] ? null : new IFC2X3.IfcLabel(v[3].value)),
  370225590: (id, v) => new IFC2X3.IfcConnectedFaceSet(id, v[0].map((p) => new Handle(p.value))),
  1981873012: (id, v) => new IFC2X3.IfcConnectionCurveGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  45288368: (id, v) => new IFC2X3.IfcConnectionPointEccentricity(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcLengthMeasure(v[4].value)),
  3050246964: (id, v) => new IFC2X3.IfcContextDependentUnit(id, new Handle(v[0].value), v[1], new IFC2X3.IfcLabel(v[2].value)),
  2889183280: (id, v) => new IFC2X3.IfcConversionBasedUnit(id, new Handle(v[0].value), v[1], new IFC2X3.IfcLabel(v[2].value), new Handle(v[3].value)),
  3800577675: (id, v) => new IFC2X3.IfcCurveStyle(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : TypeInitialiser(1, v[2]), !v[3] ? null : new Handle(v[3].value)),
  3632507154: (id, v) => new IFC2X3.IfcDerivedProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value)),
  2273265877: (id, v) => new IFC2X3.IfcDimensionCalloutRelationship(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value)),
  1694125774: (id, v) => new IFC2X3.IfcDimensionPair(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value)),
  3732053477: (id, v) => new IFC2X3.IfcDocumentReference(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  4170525392: (id, v) => new IFC2X3.IfcDraughtingPreDefinedTextFont(id, new IFC2X3.IfcLabel(v[0].value)),
  3900360178: (id, v) => new IFC2X3.IfcEdge(id, new Handle(v[0].value), new Handle(v[1].value)),
  476780140: (id, v) => new IFC2X3.IfcEdgeCurve(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), v[3].value),
  1860660968: (id, v) => new IFC2X3.IfcExtendedMaterialProperties(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC2X3.IfcText(v[2].value), new IFC2X3.IfcLabel(v[3].value)),
  2556980723: (id, v) => new IFC2X3.IfcFace(id, v[0].map((p) => new Handle(p.value))),
  1809719519: (id, v) => new IFC2X3.IfcFaceBound(id, new Handle(v[0].value), v[1].value),
  803316827: (id, v) => new IFC2X3.IfcFaceOuterBound(id, new Handle(v[0].value), v[1].value),
  3008276851: (id, v) => new IFC2X3.IfcFaceSurface(id, v[0].map((p) => new Handle(p.value)), new Handle(v[1].value), v[2].value),
  4219587988: (id, v) => new IFC2X3.IfcFailureConnectionCondition(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcForceMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcForceMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcForceMeasure(v[6].value)),
  738692330: (id, v) => new IFC2X3.IfcFillAreaStyle(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), v[1].map((p) => new Handle(p.value))),
  3857492461: (id, v) => new IFC2X3.IfcFuelProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcHeatingValueMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcHeatingValueMeasure(v[4].value)),
  803998398: (id, v) => new IFC2X3.IfcGeneralMaterialProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcMolecularWeightMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcMassDensityMeasure(v[3].value)),
  1446786286: (id, v) => new IFC2X3.IfcGeneralProfileProperties(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcMassPerLengthMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcAreaMeasure(v[6].value)),
  3448662350: (id, v) => new IFC2X3.IfcGeometricRepresentationContext(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new IFC2X3.IfcDimensionCount(v[2].value), !v[3] ? null : v[3].value, new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value)),
  2453401579: (id, _) => new IFC2X3.IfcGeometricRepresentationItem(id),
  4142052618: (id, v) => new IFC2X3.IfcGeometricRepresentationSubContext(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[3].value), v[4], !v[5] ? null : new IFC2X3.IfcLabel(v[5].value)),
  3590301190: (id, v) => new IFC2X3.IfcGeometricSet(id, v[0].map((p) => new Handle(p.value))),
  178086475: (id, v) => new IFC2X3.IfcGridPlacement(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  812098782: (id, v) => new IFC2X3.IfcHalfSpaceSolid(id, new Handle(v[0].value), v[1].value),
  2445078500: (id, v) => new IFC2X3.IfcHygroscopicMaterialProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcIsothermalMoistureCapacityMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcVaporPermeabilityMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcMoistureDiffusivityMeasure(v[5].value)),
  3905492369: (id, v) => new IFC2X3.IfcImageTexture(id, v[0].value, v[1].value, v[2], !v[3] ? null : new Handle(v[3].value), new IFC2X3.IfcIdentifier(v[4].value)),
  3741457305: (id, v) => new IFC2X3.IfcIrregularTimeSeries(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value), v[4], v[5], !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), v[8].map((p) => new Handle(p.value))),
  1402838566: (id, v) => new IFC2X3.IfcLightSource(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[3].value)),
  125510826: (id, v) => new IFC2X3.IfcLightSourceAmbient(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[3].value)),
  2604431987: (id, v) => new IFC2X3.IfcLightSourceDirectional(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value)),
  4266656042: (id, v) => new IFC2X3.IfcLightSourceGoniometric(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), new IFC2X3.IfcThermodynamicTemperatureMeasure(v[6].value), new IFC2X3.IfcLuminousFluxMeasure(v[7].value), v[8], new Handle(v[9].value)),
  1520743889: (id, v) => new IFC2X3.IfcLightSourcePositional(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcReal(v[6].value), new IFC2X3.IfcReal(v[7].value), new IFC2X3.IfcReal(v[8].value)),
  3422422726: (id, v) => new IFC2X3.IfcLightSourceSpot(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcReal(v[6].value), new IFC2X3.IfcReal(v[7].value), new IFC2X3.IfcReal(v[8].value), new Handle(v[9].value), !v[10] ? null : new IFC2X3.IfcReal(v[10].value), new IFC2X3.IfcPositivePlaneAngleMeasure(v[11].value), new IFC2X3.IfcPositivePlaneAngleMeasure(v[12].value)),
  2624227202: (id, v) => new IFC2X3.IfcLocalPlacement(id, !v[0] ? null : new Handle(v[0].value), new Handle(v[1].value)),
  1008929658: (id, _) => new IFC2X3.IfcLoop(id),
  2347385850: (id, v) => new IFC2X3.IfcMappedItem(id, new Handle(v[0].value), new Handle(v[1].value)),
  2022407955: (id, v) => new IFC2X3.IfcMaterialDefinitionRepresentation(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), new Handle(v[3].value)),
  1430189142: (id, v) => new IFC2X3.IfcMechanicalConcreteMaterialProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcDynamicViscosityMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcModulusOfElasticityMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcModulusOfElasticityMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcThermalExpansionCoefficientMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPressureMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcText(v[8].value), !v[9] ? null : new IFC2X3.IfcText(v[9].value), !v[10] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcText(v[11].value)),
  219451334: (id, v) => new IFC2X3.IfcObjectDefinition(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value)),
  2833995503: (id, v) => new IFC2X3.IfcOneDirectionRepeatFactor(id, new Handle(v[0].value)),
  2665983363: (id, v) => new IFC2X3.IfcOpenShell(id, v[0].map((p) => new Handle(p.value))),
  1029017970: (id, v) => new IFC2X3.IfcOrientedEdge(id, new Handle(v[0].value), v[1].value),
  2529465313: (id, v) => new IFC2X3.IfcParameterizedProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value)),
  2519244187: (id, v) => new IFC2X3.IfcPath(id, v[0].map((p) => new Handle(p.value))),
  3021840470: (id, v) => new IFC2X3.IfcPhysicalComplexQuantity(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), new IFC2X3.IfcLabel(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcLabel(v[5].value)),
  597895409: (id, v) => new IFC2X3.IfcPixelTexture(id, v[0].value, v[1].value, v[2], !v[3] ? null : new Handle(v[3].value), new IFC2X3.IfcInteger(v[4].value), new IFC2X3.IfcInteger(v[5].value), new IFC2X3.IfcInteger(v[6].value), v[7].map((p) => p.value)),
  2004835150: (id, v) => new IFC2X3.IfcPlacement(id, new Handle(v[0].value)),
  1663979128: (id, v) => new IFC2X3.IfcPlanarExtent(id, new IFC2X3.IfcLengthMeasure(v[0].value), new IFC2X3.IfcLengthMeasure(v[1].value)),
  2067069095: (id, _) => new IFC2X3.IfcPoint(id),
  4022376103: (id, v) => new IFC2X3.IfcPointOnCurve(id, new Handle(v[0].value), new IFC2X3.IfcParameterValue(v[1].value)),
  1423911732: (id, v) => new IFC2X3.IfcPointOnSurface(id, new Handle(v[0].value), new IFC2X3.IfcParameterValue(v[1].value), new IFC2X3.IfcParameterValue(v[2].value)),
  2924175390: (id, v) => new IFC2X3.IfcPolyLoop(id, v[0].map((p) => new Handle(p.value))),
  2775532180: (id, v) => new IFC2X3.IfcPolygonalBoundedHalfSpace(id, new Handle(v[0].value), v[1].value, new Handle(v[2].value), new Handle(v[3].value)),
  759155922: (id, v) => new IFC2X3.IfcPreDefinedColour(id, new IFC2X3.IfcLabel(v[0].value)),
  2559016684: (id, v) => new IFC2X3.IfcPreDefinedCurveFont(id, new IFC2X3.IfcLabel(v[0].value)),
  433424934: (id, v) => new IFC2X3.IfcPreDefinedDimensionSymbol(id, new IFC2X3.IfcLabel(v[0].value)),
  179317114: (id, v) => new IFC2X3.IfcPreDefinedPointMarkerSymbol(id, new IFC2X3.IfcLabel(v[0].value)),
  673634403: (id, v) => new IFC2X3.IfcProductDefinitionShape(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map((p) => new Handle(p.value))),
  871118103: (id, v) => new IFC2X3.IfcPropertyBoundedValue(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : TypeInitialiser(1, v[2]), !v[3] ? null : TypeInitialiser(1, v[3]), !v[4] ? null : new Handle(v[4].value)),
  1680319473: (id, v) => new IFC2X3.IfcPropertyDefinition(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value)),
  4166981789: (id, v) => new IFC2X3.IfcPropertyEnumeratedValue(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map((p) => TypeInitialiser(1, p)), !v[3] ? null : new Handle(v[3].value)),
  2752243245: (id, v) => new IFC2X3.IfcPropertyListValue(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map((p) => TypeInitialiser(1, p)), !v[3] ? null : new Handle(v[3].value)),
  941946838: (id, v) => new IFC2X3.IfcPropertyReferenceValue(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), new Handle(v[3].value)),
  3357820518: (id, v) => new IFC2X3.IfcPropertySetDefinition(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value)),
  3650150729: (id, v) => new IFC2X3.IfcPropertySingleValue(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : TypeInitialiser(1, v[2]), !v[3] ? null : new Handle(v[3].value)),
  110355661: (id, v) => new IFC2X3.IfcPropertyTableValue(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map((p) => TypeInitialiser(1, p)), v[3].map((p) => TypeInitialiser(1, p)), !v[4] ? null : new IFC2X3.IfcText(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  3615266464: (id, v) => new IFC2X3.IfcRectangleProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value)),
  3413951693: (id, v) => new IFC2X3.IfcRegularTimeSeries(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value), v[4], v[5], !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), new IFC2X3.IfcTimeMeasure(v[8].value), v[9].map((p) => new Handle(p.value))),
  3765753017: (id, v) => new IFC2X3.IfcReinforcementDefinitionProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), v[5].map((p) => new Handle(p.value))),
  478536968: (id, v) => new IFC2X3.IfcRelationship(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value)),
  2778083089: (id, v) => new IFC2X3.IfcRoundedRectangleProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value)),
  1509187699: (id, v) => new IFC2X3.IfcSectionedSpine(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), v[2].map((p) => new Handle(p.value))),
  2411513650: (id, v) => new IFC2X3.IfcServiceLifeFactor(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4], !v[5] ? null : TypeInitialiser(1, v[5]), TypeInitialiser(1, v[6]), !v[7] ? null : TypeInitialiser(1, v[7])),
  4124623270: (id, v) => new IFC2X3.IfcShellBasedSurfaceModel(id, v[0].map((p) => new Handle(p.value))),
  2609359061: (id, v) => new IFC2X3.IfcSlippageConnectionCondition(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcLengthMeasure(v[3].value)),
  723233188: (id, _) => new IFC2X3.IfcSolidModel(id),
  2485662743: (id, v) => new IFC2X3.IfcSoundProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new IFC2X3.IfcBoolean(v[4].value), v[5], v[6].map((p) => new Handle(p.value))),
  1202362311: (id, v) => new IFC2X3.IfcSoundValue(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new IFC2X3.IfcFrequencyMeasure(v[5].value), !v[6] ? null : TypeInitialiser(1, v[6])),
  390701378: (id, v) => new IFC2X3.IfcSpaceThermalLoadProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[4].value), v[5], v[6], !v[7] ? null : new IFC2X3.IfcText(v[7].value), new IFC2X3.IfcPowerMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPowerMeasure(v[9].value), !v[10] ? null : new Handle(v[10].value), !v[11] ? null : new IFC2X3.IfcLabel(v[11].value), !v[12] ? null : new IFC2X3.IfcLabel(v[12].value), v[13]),
  1595516126: (id, v) => new IFC2X3.IfcStructuralLoadLinearForce(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLinearForceMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcLinearForceMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcLinearForceMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcLinearMomentMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcLinearMomentMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcLinearMomentMeasure(v[6].value)),
  2668620305: (id, v) => new IFC2X3.IfcStructuralLoadPlanarForce(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcPlanarForceMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcPlanarForceMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcPlanarForceMeasure(v[3].value)),
  2473145415: (id, v) => new IFC2X3.IfcStructuralLoadSingleDisplacement(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[6].value)),
  1973038258: (id, v) => new IFC2X3.IfcStructuralLoadSingleDisplacementDistortion(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcCurvatureMeasure(v[7].value)),
  1597423693: (id, v) => new IFC2X3.IfcStructuralLoadSingleForce(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcTorqueMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcTorqueMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcTorqueMeasure(v[6].value)),
  1190533807: (id, v) => new IFC2X3.IfcStructuralLoadSingleForceWarping(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcTorqueMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcTorqueMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcTorqueMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcWarpingMomentMeasure(v[7].value)),
  3843319758: (id, v) => new IFC2X3.IfcStructuralProfileProperties(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcMassPerLengthMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcAreaMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcMomentOfInertiaMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcMomentOfInertiaMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcMomentOfInertiaMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcMomentOfInertiaMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcWarpingConstantMeasure(v[11].value), !v[12] ? null : new IFC2X3.IfcLengthMeasure(v[12].value), !v[13] ? null : new IFC2X3.IfcLengthMeasure(v[13].value), !v[14] ? null : new IFC2X3.IfcAreaMeasure(v[14].value), !v[15] ? null : new IFC2X3.IfcAreaMeasure(v[15].value), !v[16] ? null : new IFC2X3.IfcSectionModulusMeasure(v[16].value), !v[17] ? null : new IFC2X3.IfcSectionModulusMeasure(v[17].value), !v[18] ? null : new IFC2X3.IfcSectionModulusMeasure(v[18].value), !v[19] ? null : new IFC2X3.IfcSectionModulusMeasure(v[19].value), !v[20] ? null : new IFC2X3.IfcSectionModulusMeasure(v[20].value), !v[21] ? null : new IFC2X3.IfcLengthMeasure(v[21].value), !v[22] ? null : new IFC2X3.IfcLengthMeasure(v[22].value)),
  3653947884: (id, v) => new IFC2X3.IfcStructuralSteelProfileProperties(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcMassPerLengthMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcAreaMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcMomentOfInertiaMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcMomentOfInertiaMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcMomentOfInertiaMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcMomentOfInertiaMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcWarpingConstantMeasure(v[11].value), !v[12] ? null : new IFC2X3.IfcLengthMeasure(v[12].value), !v[13] ? null : new IFC2X3.IfcLengthMeasure(v[13].value), !v[14] ? null : new IFC2X3.IfcAreaMeasure(v[14].value), !v[15] ? null : new IFC2X3.IfcAreaMeasure(v[15].value), !v[16] ? null : new IFC2X3.IfcSectionModulusMeasure(v[16].value), !v[17] ? null : new IFC2X3.IfcSectionModulusMeasure(v[17].value), !v[18] ? null : new IFC2X3.IfcSectionModulusMeasure(v[18].value), !v[19] ? null : new IFC2X3.IfcSectionModulusMeasure(v[19].value), !v[20] ? null : new IFC2X3.IfcSectionModulusMeasure(v[20].value), !v[21] ? null : new IFC2X3.IfcLengthMeasure(v[21].value), !v[22] ? null : new IFC2X3.IfcLengthMeasure(v[22].value), !v[23] ? null : new IFC2X3.IfcAreaMeasure(v[23].value), !v[24] ? null : new IFC2X3.IfcAreaMeasure(v[24].value), !v[25] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[25].value), !v[26] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[26].value)),
  2233826070: (id, v) => new IFC2X3.IfcSubedge(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value)),
  2513912981: (id, _) => new IFC2X3.IfcSurface(id),
  1878645084: (id, v) => new IFC2X3.IfcSurfaceStyleRendering(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : TypeInitialiser(1, v[7]), v[8]),
  2247615214: (id, v) => new IFC2X3.IfcSweptAreaSolid(id, new Handle(v[0].value), new Handle(v[1].value)),
  1260650574: (id, v) => new IFC2X3.IfcSweptDiskSolid(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[2].value), new IFC2X3.IfcParameterValue(v[3].value), new IFC2X3.IfcParameterValue(v[4].value)),
  230924584: (id, v) => new IFC2X3.IfcSweptSurface(id, new Handle(v[0].value), new Handle(v[1].value)),
  3071757647: (id, v) => new IFC2X3.IfcTShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[11].value), !v[12] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[12].value)),
  3028897424: (id, v) => new IFC2X3.IfcTerminatorSymbol(id, !v[0] ? null : new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), new Handle(v[3].value)),
  4282788508: (id, v) => new IFC2X3.IfcTextLiteral(id, new IFC2X3.IfcPresentableText(v[0].value), new Handle(v[1].value), v[2]),
  3124975700: (id, v) => new IFC2X3.IfcTextLiteralWithExtent(id, new IFC2X3.IfcPresentableText(v[0].value), new Handle(v[1].value), v[2], new Handle(v[3].value), new IFC2X3.IfcBoxAlignment(v[4].value)),
  2715220739: (id, v) => new IFC2X3.IfcTrapeziumProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcLengthMeasure(v[6].value)),
  1345879162: (id, v) => new IFC2X3.IfcTwoDirectionRepeatFactor(id, new Handle(v[0].value), new Handle(v[1].value)),
  1628702193: (id, v) => new IFC2X3.IfcTypeObject(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value))),
  2347495698: (id, v) => new IFC2X3.IfcTypeProduct(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value)),
  427810014: (id, v) => new IFC2X3.IfcUShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[10].value)),
  1417489154: (id, v) => new IFC2X3.IfcVector(id, new Handle(v[0].value), new IFC2X3.IfcLengthMeasure(v[1].value)),
  2759199220: (id, v) => new IFC2X3.IfcVertexLoop(id, new Handle(v[0].value)),
  336235671: (id, v) => new IFC2X3.IfcWindowLiningProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[11].value), !v[12] ? null : new Handle(v[12].value)),
  512836454: (id, v) => new IFC2X3.IfcWindowPanelProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4], v[5], !v[6] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new Handle(v[8].value)),
  1299126871: (id, v) => new IFC2X3.IfcWindowStyle(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8], v[9], v[10].value, v[11].value),
  2543172580: (id, v) => new IFC2X3.IfcZShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value)),
  3288037868: (id, v) => new IFC2X3.IfcAnnotationCurveOccurrence(id, !v[0] ? null : new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  669184980: (id, v) => new IFC2X3.IfcAnnotationFillArea(id, new Handle(v[0].value), !v[1] ? null : v[1].map((p) => new Handle(p.value))),
  2265737646: (id, v) => new IFC2X3.IfcAnnotationFillAreaOccurrence(id, !v[0] ? null : new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new Handle(v[3].value), v[4]),
  1302238472: (id, v) => new IFC2X3.IfcAnnotationSurface(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  4261334040: (id, v) => new IFC2X3.IfcAxis1Placement(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  3125803723: (id, v) => new IFC2X3.IfcAxis2Placement2D(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  2740243338: (id, v) => new IFC2X3.IfcAxis2Placement3D(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value)),
  2736907675: (id, v) => new IFC2X3.IfcBooleanResult(id, v[0], new Handle(v[1].value), new Handle(v[2].value)),
  4182860854: (id, _) => new IFC2X3.IfcBoundedSurface(id),
  2581212453: (id, v) => new IFC2X3.IfcBoundingBox(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value), new IFC2X3.IfcPositiveLengthMeasure(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value)),
  2713105998: (id, v) => new IFC2X3.IfcBoxedHalfSpace(id, new Handle(v[0].value), v[1].value, new Handle(v[2].value)),
  2898889636: (id, v) => new IFC2X3.IfcCShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value)),
  1123145078: (id, v) => new IFC2X3.IfcCartesianPoint(id, v[0].map((p) => new IFC2X3.IfcLengthMeasure(p.value))),
  59481748: (id, v) => new IFC2X3.IfcCartesianTransformationOperator(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : v[3].value),
  3749851601: (id, v) => new IFC2X3.IfcCartesianTransformationOperator2D(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : v[3].value),
  3486308946: (id, v) => new IFC2X3.IfcCartesianTransformationOperator2DnonUniform(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : v[3].value, !v[4] ? null : v[4].value),
  3331915920: (id, v) => new IFC2X3.IfcCartesianTransformationOperator3D(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : v[3].value, !v[4] ? null : new Handle(v[4].value)),
  1416205885: (id, v) => new IFC2X3.IfcCartesianTransformationOperator3DnonUniform(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : v[3].value, !v[4] ? null : new Handle(v[4].value), !v[5] ? null : v[5].value, !v[6] ? null : v[6].value),
  1383045692: (id, v) => new IFC2X3.IfcCircleProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value)),
  2205249479: (id, v) => new IFC2X3.IfcClosedShell(id, v[0].map((p) => new Handle(p.value))),
  2485617015: (id, v) => new IFC2X3.IfcCompositeCurveSegment(id, v[0], v[1].value, new Handle(v[2].value)),
  4133800736: (id, v) => new IFC2X3.IfcCraneRailAShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcPositiveLengthMeasure(v[6].value), new IFC2X3.IfcPositiveLengthMeasure(v[7].value), new IFC2X3.IfcPositiveLengthMeasure(v[8].value), new IFC2X3.IfcPositiveLengthMeasure(v[9].value), new IFC2X3.IfcPositiveLengthMeasure(v[10].value), new IFC2X3.IfcPositiveLengthMeasure(v[11].value), new IFC2X3.IfcPositiveLengthMeasure(v[12].value), new IFC2X3.IfcPositiveLengthMeasure(v[13].value), !v[14] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[14].value)),
  194851669: (id, v) => new IFC2X3.IfcCraneRailFShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcPositiveLengthMeasure(v[6].value), new IFC2X3.IfcPositiveLengthMeasure(v[7].value), new IFC2X3.IfcPositiveLengthMeasure(v[8].value), new IFC2X3.IfcPositiveLengthMeasure(v[9].value), new IFC2X3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[11].value)),
  2506170314: (id, v) => new IFC2X3.IfcCsgPrimitive3D(id, new Handle(v[0].value)),
  2147822146: (id, v) => new IFC2X3.IfcCsgSolid(id, new Handle(v[0].value)),
  2601014836: (id, _) => new IFC2X3.IfcCurve(id),
  2827736869: (id, v) => new IFC2X3.IfcCurveBoundedPlane(id, new Handle(v[0].value), new Handle(v[1].value), v[2].map((p) => new Handle(p.value))),
  693772133: (id, v) => new IFC2X3.IfcDefinedSymbol(id, new Handle(v[0].value), new Handle(v[1].value)),
  606661476: (id, v) => new IFC2X3.IfcDimensionCurve(id, !v[0] ? null : new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  4054601972: (id, v) => new IFC2X3.IfcDimensionCurveTerminator(id, !v[0] ? null : new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), new Handle(v[3].value), v[4]),
  32440307: (id, v) => new IFC2X3.IfcDirection(id, v[0].map((p) => p.value)),
  2963535650: (id, v) => new IFC2X3.IfcDoorLiningProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcLengthMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcLengthMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcLengthMeasure(v[11].value), !v[12] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[12].value), !v[13] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[13].value), !v[14] ? null : new Handle(v[14].value)),
  1714330368: (id, v) => new IFC2X3.IfcDoorPanelProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), v[5], !v[6] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value)),
  526551008: (id, v) => new IFC2X3.IfcDoorStyle(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8], v[9], v[10].value, v[11].value),
  3073041342: (id, v) => new IFC2X3.IfcDraughtingCallout(id, v[0].map((p) => new Handle(p.value))),
  445594917: (id, v) => new IFC2X3.IfcDraughtingPreDefinedColour(id, new IFC2X3.IfcLabel(v[0].value)),
  4006246654: (id, v) => new IFC2X3.IfcDraughtingPreDefinedCurveFont(id, new IFC2X3.IfcLabel(v[0].value)),
  1472233963: (id, v) => new IFC2X3.IfcEdgeLoop(id, v[0].map((p) => new Handle(p.value))),
  1883228015: (id, v) => new IFC2X3.IfcElementQuantity(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), v[5].map((p) => new Handle(p.value))),
  339256511: (id, v) => new IFC2X3.IfcElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  2777663545: (id, v) => new IFC2X3.IfcElementarySurface(id, new Handle(v[0].value)),
  2835456948: (id, v) => new IFC2X3.IfcEllipseProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value)),
  80994333: (id, v) => new IFC2X3.IfcEnergyProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4], !v[5] ? null : new IFC2X3.IfcLabel(v[5].value)),
  477187591: (id, v) => new IFC2X3.IfcExtrudedAreaSolid(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value)),
  2047409740: (id, v) => new IFC2X3.IfcFaceBasedSurfaceModel(id, v[0].map((p) => new Handle(p.value))),
  374418227: (id, v) => new IFC2X3.IfcFillAreaStyleHatching(id, new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), new IFC2X3.IfcPlaneAngleMeasure(v[4].value)),
  4203026998: (id, v) => new IFC2X3.IfcFillAreaStyleTileSymbolWithStyle(id, new Handle(v[0].value)),
  315944413: (id, v) => new IFC2X3.IfcFillAreaStyleTiles(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), new IFC2X3.IfcPositiveRatioMeasure(v[2].value)),
  3455213021: (id, v) => new IFC2X3.IfcFluidFlowProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4], !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), new Handle(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new IFC2X3.IfcLabel(v[10].value), !v[11] ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(v[11].value), !v[12] ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(v[12].value), !v[13] ? null : new Handle(v[13].value), !v[14] ? null : new Handle(v[14].value), !v[15] ? null : TypeInitialiser(1, v[15]), !v[16] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[16].value), !v[17] ? null : new IFC2X3.IfcLinearVelocityMeasure(v[17].value), !v[18] ? null : new IFC2X3.IfcPressureMeasure(v[18].value)),
  4238390223: (id, v) => new IFC2X3.IfcFurnishingElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  1268542332: (id, v) => new IFC2X3.IfcFurnitureType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  987898635: (id, v) => new IFC2X3.IfcGeometricCurveSet(id, v[0].map((p) => new Handle(p.value))),
  1484403080: (id, v) => new IFC2X3.IfcIShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value)),
  572779678: (id, v) => new IFC2X3.IfcLShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[10].value)),
  1281925730: (id, v) => new IFC2X3.IfcLine(id, new Handle(v[0].value), new Handle(v[1].value)),
  1425443689: (id, v) => new IFC2X3.IfcManifoldSolidBrep(id, new Handle(v[0].value)),
  3888040117: (id, v) => new IFC2X3.IfcObject(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value)),
  3388369263: (id, v) => new IFC2X3.IfcOffsetCurve2D(id, new Handle(v[0].value), new IFC2X3.IfcLengthMeasure(v[1].value), v[2].value),
  3505215534: (id, v) => new IFC2X3.IfcOffsetCurve3D(id, new Handle(v[0].value), new IFC2X3.IfcLengthMeasure(v[1].value), v[2].value, new Handle(v[3].value)),
  3566463478: (id, v) => new IFC2X3.IfcPermeableCoveringProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4], v[5], !v[6] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new Handle(v[8].value)),
  603570806: (id, v) => new IFC2X3.IfcPlanarBox(id, new IFC2X3.IfcLengthMeasure(v[0].value), new IFC2X3.IfcLengthMeasure(v[1].value), new Handle(v[2].value)),
  220341763: (id, v) => new IFC2X3.IfcPlane(id, new Handle(v[0].value)),
  2945172077: (id, v) => new IFC2X3.IfcProcess(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value)),
  4208778838: (id, v) => new IFC2X3.IfcProduct(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  103090709: (id, v) => new IFC2X3.IfcProject(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcLabel(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7].map((p) => new Handle(p.value)), new Handle(v[8].value)),
  4194566429: (id, v) => new IFC2X3.IfcProjectionCurve(id, !v[0] ? null : new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value)),
  1451395588: (id, v) => new IFC2X3.IfcPropertySet(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value))),
  3219374653: (id, v) => new IFC2X3.IfcProxy(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  2770003689: (id, v) => new IFC2X3.IfcRectangleHollowProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value)),
  2798486643: (id, v) => new IFC2X3.IfcRectangularPyramid(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value), new IFC2X3.IfcPositiveLengthMeasure(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value)),
  3454111270: (id, v) => new IFC2X3.IfcRectangularTrimmedSurface(id, new Handle(v[0].value), new IFC2X3.IfcParameterValue(v[1].value), new IFC2X3.IfcParameterValue(v[2].value), new IFC2X3.IfcParameterValue(v[3].value), new IFC2X3.IfcParameterValue(v[4].value), v[5].value, v[6].value),
  3939117080: (id, v) => new IFC2X3.IfcRelAssigns(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5]),
  1683148259: (id, v) => new IFC2X3.IfcRelAssignsToActor(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  2495723537: (id, v) => new IFC2X3.IfcRelAssignsToControl(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value)),
  1307041759: (id, v) => new IFC2X3.IfcRelAssignsToGroup(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value)),
  4278684876: (id, v) => new IFC2X3.IfcRelAssignsToProcess(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  2857406711: (id, v) => new IFC2X3.IfcRelAssignsToProduct(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value)),
  3372526763: (id, v) => new IFC2X3.IfcRelAssignsToProjectOrder(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value)),
  205026976: (id, v) => new IFC2X3.IfcRelAssignsToResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value)),
  1865459582: (id, v) => new IFC2X3.IfcRelAssociates(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value))),
  1327628568: (id, v) => new IFC2X3.IfcRelAssociatesAppliedValue(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  4095574036: (id, v) => new IFC2X3.IfcRelAssociatesApproval(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  919958153: (id, v) => new IFC2X3.IfcRelAssociatesClassification(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  2728634034: (id, v) => new IFC2X3.IfcRelAssociatesConstraint(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new IFC2X3.IfcLabel(v[5].value), new Handle(v[6].value)),
  982818633: (id, v) => new IFC2X3.IfcRelAssociatesDocument(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  3840914261: (id, v) => new IFC2X3.IfcRelAssociatesLibrary(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  2655215786: (id, v) => new IFC2X3.IfcRelAssociatesMaterial(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  2851387026: (id, v) => new IFC2X3.IfcRelAssociatesProfileProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  826625072: (id, v) => new IFC2X3.IfcRelConnects(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value)),
  1204542856: (id, v) => new IFC2X3.IfcRelConnectsElements(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value)),
  3945020480: (id, v) => new IFC2X3.IfcRelConnectsPathElements(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value), v[7].map((p) => p.value), v[8].map((p) => p.value), v[9], v[10]),
  4201705270: (id, v) => new IFC2X3.IfcRelConnectsPortToElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value)),
  3190031847: (id, v) => new IFC2X3.IfcRelConnectsPorts(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  2127690289: (id, v) => new IFC2X3.IfcRelConnectsStructuralActivity(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value)),
  3912681535: (id, v) => new IFC2X3.IfcRelConnectsStructuralElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value)),
  1638771189: (id, v) => new IFC2X3.IfcRelConnectsStructuralMember(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new IFC2X3.IfcLengthMeasure(v[8].value), !v[9] ? null : new Handle(v[9].value)),
  504942748: (id, v) => new IFC2X3.IfcRelConnectsWithEccentricity(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new IFC2X3.IfcLengthMeasure(v[8].value), !v[9] ? null : new Handle(v[9].value), new Handle(v[10].value)),
  3678494232: (id, v) => new IFC2X3.IfcRelConnectsWithRealizingElements(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value), v[7].map((p) => new Handle(p.value)), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  3242617779: (id, v) => new IFC2X3.IfcRelContainedInSpatialStructure(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  886880790: (id, v) => new IFC2X3.IfcRelCoversBldgElements(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  2802773753: (id, v) => new IFC2X3.IfcRelCoversSpaces(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  2551354335: (id, v) => new IFC2X3.IfcRelDecomposes(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  693640335: (id, v) => new IFC2X3.IfcRelDefines(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value))),
  4186316022: (id, v) => new IFC2X3.IfcRelDefinesByProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  781010003: (id, v) => new IFC2X3.IfcRelDefinesByType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  3940055652: (id, v) => new IFC2X3.IfcRelFillsElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value)),
  279856033: (id, v) => new IFC2X3.IfcRelFlowControlElements(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  4189434867: (id, v) => new IFC2X3.IfcRelInteractionRequirements(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcCountMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), new Handle(v[8].value)),
  3268803585: (id, v) => new IFC2X3.IfcRelNests(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  2051452291: (id, v) => new IFC2X3.IfcRelOccupiesSpaces(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  202636808: (id, v) => new IFC2X3.IfcRelOverridesProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value), v[6].map((p) => new Handle(p.value))),
  750771296: (id, v) => new IFC2X3.IfcRelProjectsElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value)),
  1245217292: (id, v) => new IFC2X3.IfcRelReferencedInSpatialStructure(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  1058617721: (id, v) => new IFC2X3.IfcRelSchedulesCostItems(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value)),
  4122056220: (id, v) => new IFC2X3.IfcRelSequence(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), new IFC2X3.IfcTimeMeasure(v[6].value), v[7]),
  366585022: (id, v) => new IFC2X3.IfcRelServicesBuildings(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  3451746338: (id, v) => new IFC2X3.IfcRelSpaceBoundary(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8]),
  1401173127: (id, v) => new IFC2X3.IfcRelVoidsElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value)),
  2914609552: (id, v) => new IFC2X3.IfcResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value)),
  1856042241: (id, v) => new IFC2X3.IfcRevolvedAreaSolid(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPlaneAngleMeasure(v[3].value)),
  4158566097: (id, v) => new IFC2X3.IfcRightCircularCone(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value), new IFC2X3.IfcPositiveLengthMeasure(v[2].value)),
  3626867408: (id, v) => new IFC2X3.IfcRightCircularCylinder(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value), new IFC2X3.IfcPositiveLengthMeasure(v[2].value)),
  2706606064: (id, v) => new IFC2X3.IfcSpatialStructureElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8]),
  3893378262: (id, v) => new IFC2X3.IfcSpatialStructureElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  451544542: (id, v) => new IFC2X3.IfcSphere(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value)),
  3544373492: (id, v) => new IFC2X3.IfcStructuralActivity(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]),
  3136571912: (id, v) => new IFC2X3.IfcStructuralItem(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  530289379: (id, v) => new IFC2X3.IfcStructuralMember(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  3689010777: (id, v) => new IFC2X3.IfcStructuralReaction(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]),
  3979015343: (id, v) => new IFC2X3.IfcStructuralSurfaceMember(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value)),
  2218152070: (id, v) => new IFC2X3.IfcStructuralSurfaceMemberVarying(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), v[9].map((p) => new IFC2X3.IfcPositiveLengthMeasure(p.value)), new Handle(v[10].value)),
  4070609034: (id, v) => new IFC2X3.IfcStructuredDimensionCallout(id, v[0].map((p) => new Handle(p.value))),
  2028607225: (id, v) => new IFC2X3.IfcSurfaceCurveSweptAreaSolid(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new IFC2X3.IfcParameterValue(v[3].value), new IFC2X3.IfcParameterValue(v[4].value), new Handle(v[5].value)),
  2809605785: (id, v) => new IFC2X3.IfcSurfaceOfLinearExtrusion(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new IFC2X3.IfcLengthMeasure(v[3].value)),
  4124788165: (id, v) => new IFC2X3.IfcSurfaceOfRevolution(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value)),
  1580310250: (id, v) => new IFC2X3.IfcSystemFurnitureElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  3473067441: (id, v) => new IFC2X3.IfcTask(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8].value, !v[9] ? null : v[9].value),
  2097647324: (id, v) => new IFC2X3.IfcTransportElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2296667514: (id, v) => new IFC2X3.IfcActor(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new Handle(v[5].value)),
  1674181508: (id, v) => new IFC2X3.IfcAnnotation(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  3207858831: (id, v) => new IFC2X3.IfcAsymmetricIShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[11].value)),
  1334484129: (id, v) => new IFC2X3.IfcBlock(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value), new IFC2X3.IfcPositiveLengthMeasure(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value)),
  3649129432: (id, v) => new IFC2X3.IfcBooleanClippingResult(id, v[0], new Handle(v[1].value), new Handle(v[2].value)),
  1260505505: (id, _) => new IFC2X3.IfcBoundedCurve(id),
  4031249490: (id, v) => new IFC2X3.IfcBuilding(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC2X3.IfcLengthMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcLengthMeasure(v[10].value), !v[11] ? null : new Handle(v[11].value)),
  1950629157: (id, v) => new IFC2X3.IfcBuildingElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  3124254112: (id, v) => new IFC2X3.IfcBuildingStorey(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC2X3.IfcLengthMeasure(v[9].value)),
  2937912522: (id, v) => new IFC2X3.IfcCircleHollowProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value)),
  300633059: (id, v) => new IFC2X3.IfcColumnType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  3732776249: (id, v) => new IFC2X3.IfcCompositeCurve(id, v[0].map((p) => new Handle(p.value)), v[1].value),
  2510884976: (id, v) => new IFC2X3.IfcConic(id, new Handle(v[0].value)),
  2559216714: (id, v) => new IFC2X3.IfcConstructionResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value)),
  3293443760: (id, v) => new IFC2X3.IfcControl(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value)),
  3895139033: (id, v) => new IFC2X3.IfcCostItem(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value)),
  1419761937: (id, v) => new IFC2X3.IfcCostSchedule(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new Handle(v[10].value), new IFC2X3.IfcIdentifier(v[11].value), v[12]),
  1916426348: (id, v) => new IFC2X3.IfcCoveringType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  3295246426: (id, v) => new IFC2X3.IfcCrewResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value)),
  1457835157: (id, v) => new IFC2X3.IfcCurtainWallType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  681481545: (id, v) => new IFC2X3.IfcDimensionCurveDirectedCallout(id, v[0].map((p) => new Handle(p.value))),
  3256556792: (id, v) => new IFC2X3.IfcDistributionElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  3849074793: (id, v) => new IFC2X3.IfcDistributionFlowElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  360485395: (id, v) => new IFC2X3.IfcElectricalBaseProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4], !v[5] ? null : new IFC2X3.IfcLabel(v[5].value), v[6], new IFC2X3.IfcElectricVoltageMeasure(v[7].value), new IFC2X3.IfcFrequencyMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcElectricCurrentMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcElectricCurrentMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcPowerMeasure(v[11].value), !v[12] ? null : new IFC2X3.IfcPowerMeasure(v[12].value), v[13].value),
  1758889154: (id, v) => new IFC2X3.IfcElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  4123344466: (id, v) => new IFC2X3.IfcElementAssembly(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8], v[9]),
  1623761950: (id, v) => new IFC2X3.IfcElementComponent(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  2590856083: (id, v) => new IFC2X3.IfcElementComponentType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  1704287377: (id, v) => new IFC2X3.IfcEllipse(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value), new IFC2X3.IfcPositiveLengthMeasure(v[2].value)),
  2107101300: (id, v) => new IFC2X3.IfcEnergyConversionDeviceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  1962604670: (id, v) => new IFC2X3.IfcEquipmentElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  3272907226: (id, v) => new IFC2X3.IfcEquipmentStandard(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value)),
  3174744832: (id, v) => new IFC2X3.IfcEvaporativeCoolerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  3390157468: (id, v) => new IFC2X3.IfcEvaporatorType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  807026263: (id, v) => new IFC2X3.IfcFacetedBrep(id, new Handle(v[0].value)),
  3737207727: (id, v) => new IFC2X3.IfcFacetedBrepWithVoids(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value))),
  647756555: (id, v) => new IFC2X3.IfcFastener(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  2489546625: (id, v) => new IFC2X3.IfcFastenerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  2827207264: (id, v) => new IFC2X3.IfcFeatureElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  2143335405: (id, v) => new IFC2X3.IfcFeatureElementAddition(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  1287392070: (id, v) => new IFC2X3.IfcFeatureElementSubtraction(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  3907093117: (id, v) => new IFC2X3.IfcFlowControllerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  3198132628: (id, v) => new IFC2X3.IfcFlowFittingType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  3815607619: (id, v) => new IFC2X3.IfcFlowMeterType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1482959167: (id, v) => new IFC2X3.IfcFlowMovingDeviceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  1834744321: (id, v) => new IFC2X3.IfcFlowSegmentType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  1339347760: (id, v) => new IFC2X3.IfcFlowStorageDeviceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  2297155007: (id, v) => new IFC2X3.IfcFlowTerminalType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  3009222698: (id, v) => new IFC2X3.IfcFlowTreatmentDeviceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  263784265: (id, v) => new IFC2X3.IfcFurnishingElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  814719939: (id, v) => new IFC2X3.IfcFurnitureStandard(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value)),
  200128114: (id, v) => new IFC2X3.IfcGasTerminalType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  3009204131: (id, v) => new IFC2X3.IfcGrid(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7].map((p) => new Handle(p.value)), v[8].map((p) => new Handle(p.value)), !v[9] ? null : v[9].map((p) => new Handle(p.value))),
  2706460486: (id, v) => new IFC2X3.IfcGroup(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value)),
  1251058090: (id, v) => new IFC2X3.IfcHeatExchangerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1806887404: (id, v) => new IFC2X3.IfcHumidifierType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2391368822: (id, v) => new IFC2X3.IfcInventory(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), v[5], new Handle(v[6].value), v[7].map((p) => new Handle(p.value)), new Handle(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value)),
  4288270099: (id, v) => new IFC2X3.IfcJunctionBoxType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  3827777499: (id, v) => new IFC2X3.IfcLaborResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value), !v[9] ? null : new IFC2X3.IfcText(v[9].value)),
  1051575348: (id, v) => new IFC2X3.IfcLampType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1161773419: (id, v) => new IFC2X3.IfcLightFixtureType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2506943328: (id, v) => new IFC2X3.IfcLinearDimension(id, v[0].map((p) => new Handle(p.value))),
  377706215: (id, v) => new IFC2X3.IfcMechanicalFastener(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value)),
  2108223431: (id, v) => new IFC2X3.IfcMechanicalFastenerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  3181161470: (id, v) => new IFC2X3.IfcMemberType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  977012517: (id, v) => new IFC2X3.IfcMotorConnectionType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1916936684: (id, v) => new IFC2X3.IfcMove(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8].value, !v[9] ? null : v[9].value, new Handle(v[10].value), new Handle(v[11].value), !v[12] ? null : v[12].map((p) => new IFC2X3.IfcText(p.value))),
  4143007308: (id, v) => new IFC2X3.IfcOccupant(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new Handle(v[5].value), v[6]),
  3588315303: (id, v) => new IFC2X3.IfcOpeningElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  3425660407: (id, v) => new IFC2X3.IfcOrderAction(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8].value, !v[9] ? null : v[9].value, new IFC2X3.IfcIdentifier(v[10].value)),
  2837617999: (id, v) => new IFC2X3.IfcOutletType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2382730787: (id, v) => new IFC2X3.IfcPerformanceHistory(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcLabel(v[5].value)),
  3327091369: (id, v) => new IFC2X3.IfcPermit(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value)),
  804291784: (id, v) => new IFC2X3.IfcPipeFittingType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  4231323485: (id, v) => new IFC2X3.IfcPipeSegmentType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  4017108033: (id, v) => new IFC2X3.IfcPlateType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  3724593414: (id, v) => new IFC2X3.IfcPolyline(id, v[0].map((p) => new Handle(p.value))),
  3740093272: (id, v) => new IFC2X3.IfcPort(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  2744685151: (id, v) => new IFC2X3.IfcProcedure(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC2X3.IfcLabel(v[7].value)),
  2904328755: (id, v) => new IFC2X3.IfcProjectOrder(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC2X3.IfcLabel(v[7].value)),
  3642467123: (id, v) => new IFC2X3.IfcProjectOrderRecord(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), v[5].map((p) => new Handle(p.value)), v[6]),
  3651124850: (id, v) => new IFC2X3.IfcProjectionElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  1842657554: (id, v) => new IFC2X3.IfcProtectiveDeviceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2250791053: (id, v) => new IFC2X3.IfcPumpType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  3248260540: (id, v) => new IFC2X3.IfcRadiusDimension(id, v[0].map((p) => new Handle(p.value))),
  2893384427: (id, v) => new IFC2X3.IfcRailingType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2324767716: (id, v) => new IFC2X3.IfcRampFlightType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  160246688: (id, v) => new IFC2X3.IfcRelAggregates(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  2863920197: (id, v) => new IFC2X3.IfcRelAssignsTasks(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  1768891740: (id, v) => new IFC2X3.IfcSanitaryTerminalType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  3517283431: (id, v) => new IFC2X3.IfcScheduleTimeControl(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value), !v[11] ? null : new Handle(v[11].value), !v[12] ? null : new Handle(v[12].value), !v[13] ? null : new IFC2X3.IfcTimeMeasure(v[13].value), !v[14] ? null : new IFC2X3.IfcTimeMeasure(v[14].value), !v[15] ? null : new IFC2X3.IfcTimeMeasure(v[15].value), !v[16] ? null : new IFC2X3.IfcTimeMeasure(v[16].value), !v[17] ? null : new IFC2X3.IfcTimeMeasure(v[17].value), !v[18] ? null : v[18].value, !v[19] ? null : new Handle(v[19].value), !v[20] ? null : new IFC2X3.IfcTimeMeasure(v[20].value), !v[21] ? null : new IFC2X3.IfcTimeMeasure(v[21].value), !v[22] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[22].value)),
  4105383287: (id, v) => new IFC2X3.IfcServiceLife(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), v[5], new IFC2X3.IfcTimeMeasure(v[6].value)),
  4097777520: (id, v) => new IFC2X3.IfcSite(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC2X3.IfcCompoundPlaneAngleMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcCompoundPlaneAngleMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcLengthMeasure(v[11].value), !v[12] ? null : new IFC2X3.IfcLabel(v[12].value), !v[13] ? null : new Handle(v[13].value)),
  2533589738: (id, v) => new IFC2X3.IfcSlabType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  3856911033: (id, v) => new IFC2X3.IfcSpace(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8], v[9], !v[10] ? null : new IFC2X3.IfcLengthMeasure(v[10].value)),
  1305183839: (id, v) => new IFC2X3.IfcSpaceHeaterType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  652456506: (id, v) => new IFC2X3.IfcSpaceProgram(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcAreaMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcAreaMeasure(v[7].value), !v[8] ? null : new Handle(v[8].value), new IFC2X3.IfcAreaMeasure(v[9].value)),
  3812236995: (id, v) => new IFC2X3.IfcSpaceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  3112655638: (id, v) => new IFC2X3.IfcStackTerminalType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1039846685: (id, v) => new IFC2X3.IfcStairFlightType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  682877961: (id, v) => new IFC2X3.IfcStructuralAction(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9].value, !v[10] ? null : new Handle(v[10].value)),
  1179482911: (id, v) => new IFC2X3.IfcStructuralConnection(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  4243806635: (id, v) => new IFC2X3.IfcStructuralCurveConnection(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  214636428: (id, v) => new IFC2X3.IfcStructuralCurveMember(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7]),
  2445595289: (id, v) => new IFC2X3.IfcStructuralCurveMemberVarying(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7]),
  1807405624: (id, v) => new IFC2X3.IfcStructuralLinearAction(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9].value, !v[10] ? null : new Handle(v[10].value), v[11]),
  1721250024: (id, v) => new IFC2X3.IfcStructuralLinearActionVarying(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9].value, !v[10] ? null : new Handle(v[10].value), v[11], new Handle(v[12].value), v[13].map((p) => new Handle(p.value))),
  1252848954: (id, v) => new IFC2X3.IfcStructuralLoadGroup(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), v[5], v[6], v[7], !v[8] ? null : new IFC2X3.IfcRatioMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcLabel(v[9].value)),
  1621171031: (id, v) => new IFC2X3.IfcStructuralPlanarAction(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9].value, !v[10] ? null : new Handle(v[10].value), v[11]),
  3987759626: (id, v) => new IFC2X3.IfcStructuralPlanarActionVarying(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9].value, !v[10] ? null : new Handle(v[10].value), v[11], new Handle(v[12].value), v[13].map((p) => new Handle(p.value))),
  2082059205: (id, v) => new IFC2X3.IfcStructuralPointAction(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9].value, !v[10] ? null : new Handle(v[10].value)),
  734778138: (id, v) => new IFC2X3.IfcStructuralPointConnection(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  1235345126: (id, v) => new IFC2X3.IfcStructuralPointReaction(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]),
  2986769608: (id, v) => new IFC2X3.IfcStructuralResultGroup(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), v[5], !v[6] ? null : new Handle(v[6].value), v[7].value),
  1975003073: (id, v) => new IFC2X3.IfcStructuralSurfaceConnection(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  148013059: (id, v) => new IFC2X3.IfcSubContractResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new IFC2X3.IfcText(v[10].value)),
  2315554128: (id, v) => new IFC2X3.IfcSwitchingDeviceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2254336722: (id, v) => new IFC2X3.IfcSystem(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value)),
  5716631: (id, v) => new IFC2X3.IfcTankType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1637806684: (id, v) => new IFC2X3.IfcTimeSeriesSchedule(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), v[6], new Handle(v[7].value)),
  1692211062: (id, v) => new IFC2X3.IfcTransformerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1620046519: (id, v) => new IFC2X3.IfcTransportElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8], !v[9] ? null : new IFC2X3.IfcMassMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcCountMeasure(v[10].value)),
  3593883385: (id, v) => new IFC2X3.IfcTrimmedCurve(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), v[2].map((p) => new Handle(p.value)), v[3].value, v[4]),
  1600972822: (id, v) => new IFC2X3.IfcTubeBundleType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1911125066: (id, v) => new IFC2X3.IfcUnitaryEquipmentType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  728799441: (id, v) => new IFC2X3.IfcValveType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2769231204: (id, v) => new IFC2X3.IfcVirtualElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  1898987631: (id, v) => new IFC2X3.IfcWallType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1133259667: (id, v) => new IFC2X3.IfcWasteTerminalType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1028945134: (id, v) => new IFC2X3.IfcWorkControl(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), new Handle(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), !v[9] ? null : new IFC2X3.IfcTimeMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcTimeMeasure(v[10].value), new Handle(v[11].value), !v[12] ? null : new Handle(v[12].value), v[13], !v[14] ? null : new IFC2X3.IfcLabel(v[14].value)),
  4218914973: (id, v) => new IFC2X3.IfcWorkPlan(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), new Handle(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), !v[9] ? null : new IFC2X3.IfcTimeMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcTimeMeasure(v[10].value), new Handle(v[11].value), !v[12] ? null : new Handle(v[12].value), v[13], !v[14] ? null : new IFC2X3.IfcLabel(v[14].value)),
  3342526732: (id, v) => new IFC2X3.IfcWorkSchedule(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), new Handle(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), !v[9] ? null : new IFC2X3.IfcTimeMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcTimeMeasure(v[10].value), new Handle(v[11].value), !v[12] ? null : new Handle(v[12].value), v[13], !v[14] ? null : new IFC2X3.IfcLabel(v[14].value)),
  1033361043: (id, v) => new IFC2X3.IfcZone(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value)),
  1213861670: (id, v) => new IFC2X3.Ifc2DCompositeCurve(id, v[0].map((p) => new Handle(p.value)), v[1].value),
  3821786052: (id, v) => new IFC2X3.IfcActionRequest(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value)),
  1411407467: (id, v) => new IFC2X3.IfcAirTerminalBoxType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  3352864051: (id, v) => new IFC2X3.IfcAirTerminalType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1871374353: (id, v) => new IFC2X3.IfcAirToAirHeatRecoveryType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2470393545: (id, v) => new IFC2X3.IfcAngularDimension(id, v[0].map((p) => new Handle(p.value))),
  3460190687: (id, v) => new IFC2X3.IfcAsset(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), new Handle(v[6].value), new Handle(v[7].value), new Handle(v[8].value), new Handle(v[9].value), new Handle(v[10].value), new Handle(v[11].value), new Handle(v[12].value), new Handle(v[13].value)),
  1967976161: (id, v) => new IFC2X3.IfcBSplineCurve(id, v[0].value, v[1].map((p) => new Handle(p.value)), v[2], v[3].value, v[4].value),
  819618141: (id, v) => new IFC2X3.IfcBeamType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1916977116: (id, v) => new IFC2X3.IfcBezierCurve(id, v[0].value, v[1].map((p) => new Handle(p.value)), v[2], v[3].value, v[4].value),
  231477066: (id, v) => new IFC2X3.IfcBoilerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  3299480353: (id, v) => new IFC2X3.IfcBuildingElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  52481810: (id, v) => new IFC2X3.IfcBuildingElementComponent(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  2979338954: (id, v) => new IFC2X3.IfcBuildingElementPart(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  1095909175: (id, v) => new IFC2X3.IfcBuildingElementProxy(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8]),
  1909888760: (id, v) => new IFC2X3.IfcBuildingElementProxyType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  395041908: (id, v) => new IFC2X3.IfcCableCarrierFittingType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  3293546465: (id, v) => new IFC2X3.IfcCableCarrierSegmentType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1285652485: (id, v) => new IFC2X3.IfcCableSegmentType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2951183804: (id, v) => new IFC2X3.IfcChillerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2611217952: (id, v) => new IFC2X3.IfcCircle(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value)),
  2301859152: (id, v) => new IFC2X3.IfcCoilType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  843113511: (id, v) => new IFC2X3.IfcColumn(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  3850581409: (id, v) => new IFC2X3.IfcCompressorType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2816379211: (id, v) => new IFC2X3.IfcCondenserType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2188551683: (id, v) => new IFC2X3.IfcCondition(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value)),
  1163958913: (id, v) => new IFC2X3.IfcConditionCriterion(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new Handle(v[5].value), new Handle(v[6].value)),
  3898045240: (id, v) => new IFC2X3.IfcConstructionEquipmentResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value)),
  1060000209: (id, v) => new IFC2X3.IfcConstructionMaterialResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new IFC2X3.IfcRatioMeasure(v[10].value)),
  488727124: (id, v) => new IFC2X3.IfcConstructionProductResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value)),
  335055490: (id, v) => new IFC2X3.IfcCooledBeamType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2954562838: (id, v) => new IFC2X3.IfcCoolingTowerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1973544240: (id, v) => new IFC2X3.IfcCovering(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8]),
  3495092785: (id, v) => new IFC2X3.IfcCurtainWall(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  3961806047: (id, v) => new IFC2X3.IfcDamperType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  4147604152: (id, v) => new IFC2X3.IfcDiameterDimension(id, v[0].map((p) => new Handle(p.value))),
  1335981549: (id, v) => new IFC2X3.IfcDiscreteAccessory(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  2635815018: (id, v) => new IFC2X3.IfcDiscreteAccessoryType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  1599208980: (id, v) => new IFC2X3.IfcDistributionChamberElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2063403501: (id, v) => new IFC2X3.IfcDistributionControlElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  1945004755: (id, v) => new IFC2X3.IfcDistributionElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  3040386961: (id, v) => new IFC2X3.IfcDistributionFlowElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  3041715199: (id, v) => new IFC2X3.IfcDistributionPort(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7]),
  395920057: (id, v) => new IFC2X3.IfcDoor(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value)),
  869906466: (id, v) => new IFC2X3.IfcDuctFittingType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  3760055223: (id, v) => new IFC2X3.IfcDuctSegmentType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2030761528: (id, v) => new IFC2X3.IfcDuctSilencerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  855621170: (id, v) => new IFC2X3.IfcEdgeFeature(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value)),
  663422040: (id, v) => new IFC2X3.IfcElectricApplianceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  3277789161: (id, v) => new IFC2X3.IfcElectricFlowStorageDeviceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1534661035: (id, v) => new IFC2X3.IfcElectricGeneratorType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1365060375: (id, v) => new IFC2X3.IfcElectricHeaterType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1217240411: (id, v) => new IFC2X3.IfcElectricMotorType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  712377611: (id, v) => new IFC2X3.IfcElectricTimeControlType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1634875225: (id, v) => new IFC2X3.IfcElectricalCircuit(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value)),
  857184966: (id, v) => new IFC2X3.IfcElectricalElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  1658829314: (id, v) => new IFC2X3.IfcEnergyConversionDevice(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  346874300: (id, v) => new IFC2X3.IfcFanType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1810631287: (id, v) => new IFC2X3.IfcFilterType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  4222183408: (id, v) => new IFC2X3.IfcFireSuppressionTerminalType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2058353004: (id, v) => new IFC2X3.IfcFlowController(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  4278956645: (id, v) => new IFC2X3.IfcFlowFitting(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  4037862832: (id, v) => new IFC2X3.IfcFlowInstrumentType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  3132237377: (id, v) => new IFC2X3.IfcFlowMovingDevice(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  987401354: (id, v) => new IFC2X3.IfcFlowSegment(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  707683696: (id, v) => new IFC2X3.IfcFlowStorageDevice(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  2223149337: (id, v) => new IFC2X3.IfcFlowTerminal(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  3508470533: (id, v) => new IFC2X3.IfcFlowTreatmentDevice(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  900683007: (id, v) => new IFC2X3.IfcFooting(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8]),
  1073191201: (id, v) => new IFC2X3.IfcMember(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  1687234759: (id, v) => new IFC2X3.IfcPile(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8], v[9]),
  3171933400: (id, v) => new IFC2X3.IfcPlate(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  2262370178: (id, v) => new IFC2X3.IfcRailing(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8]),
  3024970846: (id, v) => new IFC2X3.IfcRamp(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8]),
  3283111854: (id, v) => new IFC2X3.IfcRampFlight(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  3055160366: (id, v) => new IFC2X3.IfcRationalBezierCurve(id, v[0].value, v[1].map((p) => new Handle(p.value)), v[2], v[3].value, v[4].value, v[5].map((p) => p.value)),
  3027567501: (id, v) => new IFC2X3.IfcReinforcingElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  2320036040: (id, v) => new IFC2X3.IfcReinforcingMesh(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[10].value), new IFC2X3.IfcPositiveLengthMeasure(v[11].value), new IFC2X3.IfcPositiveLengthMeasure(v[12].value), new IFC2X3.IfcAreaMeasure(v[13].value), new IFC2X3.IfcAreaMeasure(v[14].value), new IFC2X3.IfcPositiveLengthMeasure(v[15].value), new IFC2X3.IfcPositiveLengthMeasure(v[16].value)),
  2016517767: (id, v) => new IFC2X3.IfcRoof(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8]),
  1376911519: (id, v) => new IFC2X3.IfcRoundedEdgeFeature(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value)),
  1783015770: (id, v) => new IFC2X3.IfcSensorType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1529196076: (id, v) => new IFC2X3.IfcSlab(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8]),
  331165859: (id, v) => new IFC2X3.IfcStair(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8]),
  4252922144: (id, v) => new IFC2X3.IfcStairFlight(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : v[8].value, !v[9] ? null : v[9].value, !v[10] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[11].value)),
  2515109513: (id, v) => new IFC2X3.IfcStructuralAnalysisModel(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), v[5], !v[6] ? null : new Handle(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : v[8].map((p) => new Handle(p.value))),
  3824725483: (id, v) => new IFC2X3.IfcTendon(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9], new IFC2X3.IfcPositiveLengthMeasure(v[10].value), new IFC2X3.IfcAreaMeasure(v[11].value), !v[12] ? null : new IFC2X3.IfcForceMeasure(v[12].value), !v[13] ? null : new IFC2X3.IfcPressureMeasure(v[13].value), !v[14] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[14].value), !v[15] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[15].value), !v[16] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[16].value)),
  2347447852: (id, v) => new IFC2X3.IfcTendonAnchor(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value)),
  3313531582: (id, v) => new IFC2X3.IfcVibrationIsolatorType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  2391406946: (id, v) => new IFC2X3.IfcWall(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  3512223829: (id, v) => new IFC2X3.IfcWallStandardCase(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  3304561284: (id, v) => new IFC2X3.IfcWindow(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value)),
  2874132201: (id, v) => new IFC2X3.IfcActuatorType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  3001207471: (id, v) => new IFC2X3.IfcAlarmType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  753842376: (id, v) => new IFC2X3.IfcBeam(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  2454782716: (id, v) => new IFC2X3.IfcChamferEdgeFeature(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[10].value)),
  578613899: (id, v) => new IFC2X3.IfcControllerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]),
  1052013943: (id, v) => new IFC2X3.IfcDistributionChamberElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value)),
  1062813311: (id, v) => new IFC2X3.IfcDistributionControlElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcIdentifier(v[8].value)),
  3700593921: (id, v) => new IFC2X3.IfcElectricDistributionPoint(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8], !v[9] ? null : new IFC2X3.IfcLabel(v[9].value)),
  979691226: (id, v) => new IFC2X3.IfcReinforcingBar(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), new IFC2X3.IfcPositiveLengthMeasure(v[9].value), new IFC2X3.IfcAreaMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[11].value), v[12], v[13])
};
InheritanceDef[1] = {
  618182010: [IFCTELECOMADDRESS, IFCPOSTALADDRESS],
  411424972: [IFCENVIRONMENTALIMPACTVALUE, IFCCOSTVALUE],
  4037036970: [IFCBOUNDARYNODECONDITIONWARPING, IFCBOUNDARYNODECONDITION, IFCBOUNDARYFACECONDITION, IFCBOUNDARYEDGECONDITION],
  1387855156: [IFCBOUNDARYNODECONDITIONWARPING],
  3264961684: [IFCCOLOURRGB],
  2859738748: [IFCCONNECTIONCURVEGEOMETRY, IFCCONNECTIONSURFACEGEOMETRY, IFCCONNECTIONPORTGEOMETRY, IFCCONNECTIONPOINTECCENTRICITY, IFCCONNECTIONPOINTGEOMETRY],
  2614616156: [IFCCONNECTIONPOINTECCENTRICITY],
  1959218052: [IFCOBJECTIVE, IFCMETRIC],
  3796139169: [IFCDIMENSIONPAIR, IFCDIMENSIONCALLOUTRELATIONSHIP],
  3200245327: [IFCDOCUMENTREFERENCE, IFCCLASSIFICATIONREFERENCE, IFCLIBRARYREFERENCE, IFCEXTERNALLYDEFINEDTEXTFONT, IFCEXTERNALLYDEFINEDSYMBOL, IFCEXTERNALLYDEFINEDSURFACESTYLE, IFCEXTERNALLYDEFINEDHATCHSTYLE],
  3265635763: [IFCHYGROSCOPICMATERIALPROPERTIES, IFCGENERALMATERIALPROPERTIES, IFCFUELPROPERTIES, IFCEXTENDEDMATERIALPROPERTIES, IFCWATERPROPERTIES, IFCTHERMALMATERIALPROPERTIES, IFCPRODUCTSOFCOMBUSTIONPROPERTIES, IFCOPTICALMATERIALPROPERTIES, IFCMECHANICALCONCRETEMATERIALPROPERTIES, IFCMECHANICALSTEELMATERIALPROPERTIES, IFCMECHANICALMATERIALPROPERTIES],
  4256014907: [IFCMECHANICALCONCRETEMATERIALPROPERTIES, IFCMECHANICALSTEELMATERIALPROPERTIES],
  1918398963: [IFCCONVERSIONBASEDUNIT, IFCCONTEXTDEPENDENTUNIT, IFCSIUNIT],
  3701648758: [IFCLOCALPLACEMENT, IFCGRIDPLACEMENT],
  2483315170: [IFCPHYSICALCOMPLEXQUANTITY, IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA, IFCPHYSICALSIMPLEQUANTITY],
  2226359599: [IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA],
  3727388367: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCDRAUGHTINGPREDEFINEDTEXTFONT, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT, IFCPREDEFINEDPOINTMARKERSYMBOL, IFCPREDEFINEDDIMENSIONSYMBOL, IFCPREDEFINEDTERMINATORSYMBOL, IFCPREDEFINEDSYMBOL],
  990879717: [IFCPREDEFINEDPOINTMARKERSYMBOL, IFCPREDEFINEDDIMENSIONSYMBOL, IFCPREDEFINEDTERMINATORSYMBOL],
  1775413392: [IFCDRAUGHTINGPREDEFINEDTEXTFONT, IFCTEXTSTYLEFONTMODEL],
  2022622350: [IFCPRESENTATIONLAYERWITHSTYLE],
  3119450353: [IFCFILLAREASTYLE, IFCCURVESTYLE, IFCTEXTSTYLE, IFCSYMBOLSTYLE, IFCSURFACESTYLE],
  2095639259: [IFCPRODUCTDEFINITIONSHAPE, IFCMATERIALDEFINITIONREPRESENTATION],
  3958567839: [IFCLSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCRANERAILFSHAPEPROFILEDEF, IFCCRANERAILASHAPEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF, IFCPARAMETERIZEDPROFILEDEF, IFCDERIVEDPROFILEDEF, IFCCOMPOSITEPROFILEDEF, IFCCENTERLINEPROFILEDEF, IFCARBITRARYOPENPROFILEDEF, IFCARBITRARYPROFILEDEFWITHVOIDS, IFCARBITRARYCLOSEDPROFILEDEF],
  2802850158: [IFCSTRUCTURALSTEELPROFILEPROPERTIES, IFCSTRUCTURALPROFILEPROPERTIES, IFCGENERALPROFILEPROPERTIES, IFCRIBPLATEPROFILEPROPERTIES],
  2598011224: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY],
  1076942058: [IFCSTYLEDREPRESENTATION, IFCSTYLEMODEL, IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION, IFCSHAPEMODEL],
  3377609919: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT, IFCGEOMETRICREPRESENTATIONCONTEXT],
  3008791417: [IFCMAPPEDITEM, IFCFILLAREASTYLETILES, IFCFILLAREASTYLETILESYMBOLWITHSTYLE, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIAMETERDIMENSION, IFCANGULARDIMENSION, IFCRADIUSDIMENSION, IFCLINEARDIMENSION, IFCDIMENSIONCURVEDIRECTEDCALLOUT, IFCSTRUCTUREDDIMENSIONCALLOUT, IFCDRAUGHTINGCALLOUT, IFCDIRECTION, IFCDEFINEDSYMBOL, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFC2DCOMPOSITECURVE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCCOMPOSITECURVESEGMENT, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONSURFACE, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPLANE, IFCELEMENTARYSURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCTWODIRECTIONREPEATFACTOR, IFCONEDIRECTIONREPEATFACTOR, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET, IFCGEOMETRICREPRESENTATIONITEM, IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX, IFCTOPOLOGICALREPRESENTATIONITEM, IFCANNOTATIONFILLAREAOCCURRENCE, IFCPROJECTIONCURVE, IFCDIMENSIONCURVE, IFCANNOTATIONCURVEOCCURRENCE, IFCANNOTATIONTEXTOCCURRENCE, IFCDIMENSIONCURVETERMINATOR, IFCTERMINATORSYMBOL, IFCANNOTATIONSYMBOLOCCURRENCE, IFCANNOTATIONSURFACEOCCURRENCE, IFCANNOTATIONOCCURRENCE, IFCSTYLEDITEM],
  2341007311: [IFCRELDEFINESBYTYPE, IFCRELOVERRIDESPROPERTIES, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELVOIDSELEMENT, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPROJECTSELEMENT, IFCRELINTERACTIONREQUIREMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALELEMENT, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESPROFILEPROPERTIES, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATESAPPLIEDVALUE, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTASKS, IFCRELSCHEDULESCOSTITEMS, IFCRELASSIGNSTOPROJECTORDER, IFCRELASSIGNSTOCONTROL, IFCRELOCCUPIESSPACES, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS, IFCRELATIONSHIP, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCFLUIDFLOWPROPERTIES, IFCELECTRICALBASEPROPERTIES, IFCENERGYPROPERTIES, IFCELEMENTQUANTITY, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCSPACETHERMALLOADPROPERTIES, IFCSOUNDVALUE, IFCSOUNDPROPERTIES, IFCSERVICELIFEFACTOR, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPROPERTYSETDEFINITION, IFCPROPERTYDEFINITION, IFCCONDITION, IFCASSET, IFCZONE, IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCCONDITIONCRITERION, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCTIMESERIESSCHEDULE, IFCSPACEPROGRAM, IFCSERVICELIFE, IFCSCHEDULETIMECONTROL, IFCPROJECTORDERRECORD, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCFURNITURESTANDARD, IFCEQUIPMENTSTANDARD, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCPROJECT, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCORDERACTION, IFCMOVE, IFCTASK, IFCPROCESS, IFCOBJECT, IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTYPEOBJECT, IFCOBJECTDEFINITION],
  3982875396: [IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION],
  3692461612: [IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE],
  2273995522: [IFCSLIPPAGECONNECTIONCONDITION, IFCFAILURECONNECTIONCONDITION],
  2162789131: [IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC],
  2525727697: [IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE],
  2830218821: [IFCSTYLEDREPRESENTATION],
  3958052878: [IFCANNOTATIONFILLAREAOCCURRENCE, IFCPROJECTIONCURVE, IFCDIMENSIONCURVE, IFCANNOTATIONCURVEOCCURRENCE, IFCANNOTATIONTEXTOCCURRENCE, IFCDIMENSIONCURVETERMINATOR, IFCTERMINATORSYMBOL, IFCANNOTATIONSYMBOLOCCURRENCE, IFCANNOTATIONSURFACEOCCURRENCE, IFCANNOTATIONOCCURRENCE],
  846575682: [IFCSURFACESTYLERENDERING],
  626085974: [IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE],
  280115917: [IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR],
  3101149627: [IFCREGULARTIMESERIES, IFCIRREGULARTIMESERIES],
  1377556343: [IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX],
  2799835756: [IFCVERTEXPOINT],
  2442683028: [IFCANNOTATIONFILLAREAOCCURRENCE, IFCPROJECTIONCURVE, IFCDIMENSIONCURVE, IFCANNOTATIONCURVEOCCURRENCE, IFCANNOTATIONTEXTOCCURRENCE, IFCDIMENSIONCURVETERMINATOR, IFCTERMINATORSYMBOL, IFCANNOTATIONSYMBOLOCCURRENCE, IFCANNOTATIONSURFACEOCCURRENCE],
  3612888222: [IFCDIMENSIONCURVETERMINATOR, IFCTERMINATORSYMBOL],
  3798115385: [IFCARBITRARYPROFILEDEFWITHVOIDS],
  1310608509: [IFCCENTERLINEPROFILEDEF],
  370225590: [IFCCLOSEDSHELL, IFCOPENSHELL],
  3900360178: [IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE],
  2556980723: [IFCFACESURFACE],
  1809719519: [IFCFACEOUTERBOUND],
  1446786286: [IFCSTRUCTURALSTEELPROFILEPROPERTIES, IFCSTRUCTURALPROFILEPROPERTIES],
  3448662350: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT],
  2453401579: [IFCFILLAREASTYLETILES, IFCFILLAREASTYLETILESYMBOLWITHSTYLE, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIAMETERDIMENSION, IFCANGULARDIMENSION, IFCRADIUSDIMENSION, IFCLINEARDIMENSION, IFCDIMENSIONCURVEDIRECTEDCALLOUT, IFCSTRUCTUREDDIMENSIONCALLOUT, IFCDRAUGHTINGCALLOUT, IFCDIRECTION, IFCDEFINEDSYMBOL, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFC2DCOMPOSITECURVE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCCOMPOSITECURVESEGMENT, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONSURFACE, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPLANE, IFCELEMENTARYSURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCTWODIRECTIONREPEATFACTOR, IFCONEDIRECTIONREPEATFACTOR, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET],
  3590301190: [IFCGEOMETRICCURVESET],
  812098782: [IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE],
  1402838566: [IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT],
  1520743889: [IFCLIGHTSOURCESPOT],
  1008929658: [IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP],
  219451334: [IFCCONDITION, IFCASSET, IFCZONE, IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCCONDITIONCRITERION, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCTIMESERIESSCHEDULE, IFCSPACEPROGRAM, IFCSERVICELIFE, IFCSCHEDULETIMECONTROL, IFCPROJECTORDERRECORD, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCFURNITURESTANDARD, IFCEQUIPMENTSTANDARD, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCPROJECT, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCORDERACTION, IFCMOVE, IFCTASK, IFCPROCESS, IFCOBJECT, IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTYPEOBJECT],
  2833995503: [IFCTWODIRECTIONREPEATFACTOR],
  2529465313: [IFCLSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCRANERAILFSHAPEPROFILEDEF, IFCCRANERAILASHAPEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF],
  2004835150: [IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT],
  1663979128: [IFCPLANARBOX],
  2067069095: [IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE],
  759155922: [IFCDRAUGHTINGPREDEFINEDCOLOUR],
  2559016684: [IFCDRAUGHTINGPREDEFINEDCURVEFONT],
  1680319473: [IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCFLUIDFLOWPROPERTIES, IFCELECTRICALBASEPROPERTIES, IFCENERGYPROPERTIES, IFCELEMENTQUANTITY, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCSPACETHERMALLOADPROPERTIES, IFCSOUNDVALUE, IFCSOUNDPROPERTIES, IFCSERVICELIFEFACTOR, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPROPERTYSETDEFINITION],
  3357820518: [IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCFLUIDFLOWPROPERTIES, IFCELECTRICALBASEPROPERTIES, IFCENERGYPROPERTIES, IFCELEMENTQUANTITY, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCSPACETHERMALLOADPROPERTIES, IFCSOUNDVALUE, IFCSOUNDPROPERTIES, IFCSERVICELIFEFACTOR, IFCREINFORCEMENTDEFINITIONPROPERTIES],
  3615266464: [IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF],
  478536968: [IFCRELDEFINESBYTYPE, IFCRELOVERRIDESPROPERTIES, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELVOIDSELEMENT, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPROJECTSELEMENT, IFCRELINTERACTIONREQUIREMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALELEMENT, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESPROFILEPROPERTIES, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATESAPPLIEDVALUE, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTASKS, IFCRELSCHEDULESCOSTITEMS, IFCRELASSIGNSTOPROJECTORDER, IFCRELASSIGNSTOCONTROL, IFCRELOCCUPIESSPACES, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS],
  723233188: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID],
  2473145415: [IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION],
  1597423693: [IFCSTRUCTURALLOADSINGLEFORCEWARPING],
  3843319758: [IFCSTRUCTURALSTEELPROFILEPROPERTIES],
  2513912981: [IFCPLANE, IFCELEMENTARYSURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE],
  2247615214: [IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLID],
  230924584: [IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION],
  3028897424: [IFCDIMENSIONCURVETERMINATOR],
  4282788508: [IFCTEXTLITERALWITHEXTENT],
  1628702193: [IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT],
  2347495698: [IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE],
  3288037868: [IFCPROJECTIONCURVE, IFCDIMENSIONCURVE],
  2736907675: [IFCBOOLEANCLIPPINGRESULT],
  4182860854: [IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDPLANE],
  59481748: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D],
  3749851601: [IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM],
  3331915920: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM],
  1383045692: [IFCCIRCLEHOLLOWPROFILEDEF],
  2506170314: [IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID],
  2601014836: [IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFC2DCOMPOSITECURVE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE],
  3073041342: [IFCDIAMETERDIMENSION, IFCANGULARDIMENSION, IFCRADIUSDIMENSION, IFCLINEARDIMENSION, IFCDIMENSIONCURVEDIRECTEDCALLOUT, IFCSTRUCTUREDDIMENSIONCALLOUT],
  339256511: [IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE],
  2777663545: [IFCPLANE],
  80994333: [IFCELECTRICALBASEPROPERTIES],
  4238390223: [IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE],
  1484403080: [IFCASYMMETRICISHAPEPROFILEDEF],
  1425443689: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP],
  3888040117: [IFCCONDITION, IFCASSET, IFCZONE, IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCCONDITIONCRITERION, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCTIMESERIESSCHEDULE, IFCSPACEPROGRAM, IFCSERVICELIFE, IFCSCHEDULETIMECONTROL, IFCPROJECTORDERRECORD, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCFURNITURESTANDARD, IFCEQUIPMENTSTANDARD, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCPROJECT, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCORDERACTION, IFCMOVE, IFCTASK, IFCPROCESS],
  2945172077: [IFCPROCEDURE, IFCORDERACTION, IFCMOVE, IFCTASK],
  4208778838: [IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCPROXY],
  3939117080: [IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTASKS, IFCRELSCHEDULESCOSTITEMS, IFCRELASSIGNSTOPROJECTORDER, IFCRELASSIGNSTOCONTROL, IFCRELOCCUPIESSPACES, IFCRELASSIGNSTOACTOR],
  1683148259: [IFCRELOCCUPIESSPACES],
  2495723537: [IFCRELASSIGNSTASKS, IFCRELSCHEDULESCOSTITEMS, IFCRELASSIGNSTOPROJECTORDER],
  1865459582: [IFCRELASSOCIATESPROFILEPROPERTIES, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATESAPPLIEDVALUE],
  826625072: [IFCRELVOIDSELEMENT, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPROJECTSELEMENT, IFCRELINTERACTIONREQUIREMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALELEMENT, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS],
  1204542856: [IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS],
  1638771189: [IFCRELCONNECTSWITHECCENTRICITY],
  2551354335: [IFCRELAGGREGATES, IFCRELNESTS],
  693640335: [IFCRELDEFINESBYTYPE, IFCRELOVERRIDESPROPERTIES, IFCRELDEFINESBYPROPERTIES],
  4186316022: [IFCRELOVERRIDESPROPERTIES],
  2914609552: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE],
  2706606064: [IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING],
  3893378262: [IFCSPACETYPE],
  3544373492: [IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION],
  3136571912: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER],
  530289379: [IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER],
  3689010777: [IFCSTRUCTURALPOINTREACTION],
  3979015343: [IFCSTRUCTURALSURFACEMEMBERVARYING],
  3473067441: [IFCORDERACTION, IFCMOVE],
  2296667514: [IFCOCCUPANT],
  1260505505: [IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFC2DCOMPOSITECURVE, IFCCOMPOSITECURVE],
  1950629157: [IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE],
  3732776249: [IFC2DCOMPOSITECURVE],
  2510884976: [IFCCIRCLE, IFCELLIPSE],
  2559216714: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE],
  3293443760: [IFCCONDITIONCRITERION, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCTIMESERIESSCHEDULE, IFCSPACEPROGRAM, IFCSERVICELIFE, IFCSCHEDULETIMECONTROL, IFCPROJECTORDERRECORD, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCFURNITURESTANDARD, IFCEQUIPMENTSTANDARD, IFCCOSTSCHEDULE, IFCCOSTITEM],
  681481545: [IFCDIAMETERDIMENSION, IFCANGULARDIMENSION, IFCRADIUSDIMENSION, IFCLINEARDIMENSION],
  3256556792: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE],
  3849074793: [IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE],
  1758889154: [IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY],
  1623761950: [IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER],
  2590856083: [IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE],
  2107101300: [IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE],
  647756555: [IFCMECHANICALFASTENER],
  2489546625: [IFCMECHANICALFASTENERTYPE],
  2827207264: [IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION],
  2143335405: [IFCPROJECTIONELEMENT],
  1287392070: [IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT],
  3907093117: [IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE],
  3198132628: [IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE],
  1482959167: [IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE],
  1834744321: [IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE],
  1339347760: [IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE],
  2297155007: [IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE],
  3009222698: [IFCFILTERTYPE, IFCDUCTSILENCERTYPE],
  2706460486: [IFCCONDITION, IFCASSET, IFCZONE, IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADGROUP, IFCINVENTORY],
  3740093272: [IFCDISTRIBUTIONPORT],
  682877961: [IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION],
  1179482911: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION],
  214636428: [IFCSTRUCTURALCURVEMEMBERVARYING],
  1807405624: [IFCSTRUCTURALLINEARACTIONVARYING],
  1621171031: [IFCSTRUCTURALPLANARACTIONVARYING],
  2254336722: [IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT],
  1028945134: [IFCWORKSCHEDULE, IFCWORKPLAN],
  1967976161: [IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE],
  1916977116: [IFCRATIONALBEZIERCURVE],
  3299480353: [IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT],
  52481810: [IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART],
  2635815018: [IFCVIBRATIONISOLATORTYPE],
  2063403501: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE],
  1945004755: [IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT],
  3040386961: [IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE],
  855621170: [IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE],
  2058353004: [IFCELECTRICDISTRIBUTIONPOINT],
  3027567501: [IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH],
  2391406946: [IFCWALLSTANDARDCASE]
};
InversePropertyDef[1] = {
  618182010: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  411424972: [["ValuesReferenced", IFCREFERENCESVALUEDOCUMENT, 1, true], ["ValueOfComponents", IFCAPPLIEDVALUERELATIONSHIP, 0, true], ["IsComponentIn", IFCAPPLIEDVALUERELATIONSHIP, 1, true]],
  130549933: [["Actors", IFCAPPROVALACTORRELATIONSHIP, 1, true], ["IsRelatedWith", IFCAPPROVALRELATIONSHIP, 0, true], ["Relates", IFCAPPROVALRELATIONSHIP, 1, true]],
  747523909: [["Contains", IFCCLASSIFICATIONITEM, 1, true]],
  1767535486: [["IsClassifiedItemIn", IFCCLASSIFICATIONITEMRELATIONSHIP, 1, true], ["IsClassifyingItemIn", IFCCLASSIFICATIONITEMRELATIONSHIP, 0, true]],
  1959218052: [["ClassifiedAs", IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP, 0, true], ["RelatesConstraints", IFCCONSTRAINTRELATIONSHIP, 2, true], ["IsRelatedWith", IFCCONSTRAINTRELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCPROPERTYCONSTRAINTRELATIONSHIP, 0, true], ["Aggregates", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 2, true], ["IsAggregatedIn", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 3, true]],
  602808272: [["ValuesReferenced", IFCREFERENCESVALUEDOCUMENT, 1, true], ["ValueOfComponents", IFCAPPLIEDVALUERELATIONSHIP, 0, true], ["IsComponentIn", IFCAPPLIEDVALUERELATIONSHIP, 1, true]],
  1154170062: [["IsPointedTo", IFCDOCUMENTINFORMATIONRELATIONSHIP, 1, true], ["IsPointer", IFCDOCUMENTINFORMATIONRELATIONSHIP, 0, true]],
  1648886627: [["ValuesReferenced", IFCREFERENCESVALUEDOCUMENT, 1, true], ["ValueOfComponents", IFCAPPLIEDVALUERELATIONSHIP, 0, true], ["IsComponentIn", IFCAPPLIEDVALUERELATIONSHIP, 1, true]],
  852622518: [["PartOfW", IFCGRID, 9, true], ["PartOfV", IFCGRID, 8, true], ["PartOfU", IFCGRID, 7, true], ["HasIntersections", IFCVIRTUALGRIDINTERSECTION, 0, true]],
  3452421091: [["ReferenceIntoLibrary", IFCLIBRARYINFORMATION, 4, true]],
  1838606355: [["HasRepresentation", IFCMATERIALDEFINITIONREPRESENTATION, 3, true], ["ClassifiedAs", IFCMATERIALCLASSIFICATIONRELATIONSHIP, 1, true]],
  248100487: [["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, false]],
  3368373690: [["ClassifiedAs", IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP, 0, true], ["RelatesConstraints", IFCCONSTRAINTRELATIONSHIP, 2, true], ["IsRelatedWith", IFCCONSTRAINTRELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCPROPERTYCONSTRAINTRELATIONSHIP, 0, true], ["Aggregates", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 2, true], ["IsAggregatedIn", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 3, true]],
  3701648758: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  2251480897: [["ClassifiedAs", IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP, 0, true], ["RelatesConstraints", IFCCONSTRAINTRELATIONSHIP, 2, true], ["IsRelatedWith", IFCCONSTRAINTRELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCPROPERTYCONSTRAINTRELATIONSHIP, 0, true], ["Aggregates", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 2, true], ["IsAggregatedIn", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 3, true]],
  4251960020: [["IsRelatedBy", IFCORGANIZATIONRELATIONSHIP, 3, true], ["Relates", IFCORGANIZATIONRELATIONSHIP, 2, true], ["Engages", IFCPERSONANDORGANIZATION, 1, true]],
  2077209135: [["EngagedIn", IFCPERSONANDORGANIZATION, 0, true]],
  2483315170: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2226359599: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3355820592: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  2598011224: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  2044713172: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2093928680: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  931644368: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3252649465: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2405470396: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  825690147: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  1076942058: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3377609919: [["RepresentationsInContext", IFCREPRESENTATION, 0, true]],
  3008791417: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1660063152: [["MapUsage", IFCMAPPEDITEM, 0, true]],
  3982875396: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  4240577450: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  3692461612: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  2830218821: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3958052878: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3049322572: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  531007025: [["OfTable", IFCTABLE, 1, false]],
  912023232: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  280115917: [["AnnotatedSurface", IFCANNOTATIONSURFACE, 1, true]],
  1742049831: [["AnnotatedSurface", IFCANNOTATIONSURFACE, 1, true]],
  2552916305: [["AnnotatedSurface", IFCANNOTATIONSURFACE, 1, true]],
  3101149627: [["DocumentedBy", IFCTIMESERIESREFERENCERELATIONSHIP, 0, true]],
  1377556343: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1735638870: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  2799835756: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1907098498: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2442683028: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  962685235: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3612888222: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2297822566: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2542286263: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  370225590: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3732053477: [["ReferenceToDocument", IFCDOCUMENTINFORMATION, 3, true]],
  3900360178: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  476780140: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2556980723: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1809719519: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  803316827: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3008276851: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3448662350: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true]],
  2453401579: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4142052618: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true]],
  3590301190: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  178086475: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  812098782: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3741457305: [["DocumentedBy", IFCTIMESERIESREFERENCERELATIONSHIP, 0, true]],
  1402838566: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  125510826: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2604431987: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4266656042: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1520743889: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3422422726: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2624227202: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  1008929658: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2347385850: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  219451334: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  2833995503: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2665983363: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1029017970: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2519244187: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3021840470: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2004835150: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1663979128: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2067069095: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4022376103: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1423911732: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2924175390: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2775532180: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  673634403: [["ShapeOfProduct", IFCPRODUCT, 6, true], ["HasShapeAspects", IFCSHAPEASPECT, 4, true]],
  871118103: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  1680319473: [["HasAssociations", IFCRELASSOCIATES, 4, true]],
  4166981789: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  2752243245: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  941946838: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  3357820518: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  3650150729: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  110355661: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  3413951693: [["DocumentedBy", IFCTIMESERIESREFERENCERELATIONSHIP, 0, true]],
  3765753017: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  1509187699: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2411513650: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  4124623270: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  723233188: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2485662743: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  1202362311: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  390701378: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  2233826070: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2513912981: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2247615214: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260650574: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  230924584: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3028897424: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4282788508: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3124975700: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1345879162: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1628702193: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2347495698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1417489154: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2759199220: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  336235671: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  512836454: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  1299126871: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3288037868: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  669184980: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2265737646: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1302238472: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4261334040: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3125803723: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2740243338: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2736907675: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4182860854: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2581212453: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2713105998: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1123145078: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  59481748: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3749851601: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3486308946: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3331915920: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1416205885: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2205249479: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2485617015: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  2506170314: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2147822146: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2601014836: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2827736869: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  693772133: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  606661476: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["AnnotatedBySymbols", IFCTERMINATORSYMBOL, 3, true]],
  4054601972: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  32440307: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2963535650: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  1714330368: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  526551008: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3073041342: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  1472233963: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1883228015: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  339256511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2777663545: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  80994333: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  477187591: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2047409740: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  374418227: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4203026998: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  315944413: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3455213021: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  4238390223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1268542332: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  987898635: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1281925730: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1425443689: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3888040117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true]],
  3388369263: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3505215534: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3566463478: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  603570806: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  220341763: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2945172077: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true]],
  4208778838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  103090709: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true]],
  4194566429: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1451395588: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  3219374653: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2798486643: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3454111270: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2914609552: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1856042241: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4158566097: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3626867408: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2706606064: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true]],
  3893378262: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  451544542: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3544373492: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  3136571912: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true]],
  530289379: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  3689010777: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false], ["Causes", IFCSTRUCTURALACTION, 10, true]],
  3979015343: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2218152070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  4070609034: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  2028607225: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2809605785: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4124788165: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1580310250: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3473067441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true]],
  2097647324: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2296667514: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  1674181508: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1334484129: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3649129432: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260505505: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4031249490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true]],
  1950629157: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3124254112: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true]],
  300633059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3732776249: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2510884976: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2559216714: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3293443760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3895139033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1419761937: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1916426348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3295246426: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1457835157: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  681481545: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  3256556792: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3849074793: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  360485395: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  1758889154: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  4123344466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1623761950: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2590856083: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1704287377: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2107101300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1962604670: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3272907226: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3174744832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3390157468: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  807026263: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3737207727: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  647756555: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2489546625: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2827207264: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2143335405: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1287392070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  3907093117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3198132628: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3815607619: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1482959167: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1834744321: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1339347760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2297155007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3009222698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  263784265: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  814719939: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  200128114: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3009204131: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2706460486: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false]],
  1251058090: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1806887404: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2391368822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false]],
  4288270099: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3827777499: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1051575348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1161773419: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2506943328: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  377706215: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2108223431: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3181161470: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  977012517: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1916936684: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true]],
  4143007308: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  3588315303: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false], ["HasFillings", IFCRELFILLSELEMENT, 4, true]],
  3425660407: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true]],
  2837617999: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2382730787: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3327091369: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  804291784: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  4231323485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  4017108033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3724593414: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3740093272: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, false], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  2744685151: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true]],
  2904328755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3642467123: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3651124850: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1842657554: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2250791053: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3248260540: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  2893384427: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2324767716: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1768891740: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3517283431: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true], ["ScheduleTimeControlAssigned", IFCRELASSIGNSTASKS, 7, false]],
  4105383287: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  4097777520: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true]],
  2533589738: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3856911033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["HasCoverings", IFCRELCOVERSSPACES, 4, true], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, true]],
  1305183839: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  652456506: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true], ["HasInteractionReqsFrom", IFCRELINTERACTIONREQUIREMENTS, 7, true], ["HasInteractionReqsTo", IFCRELINTERACTIONREQUIREMENTS, 8, true]],
  3812236995: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3112655638: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1039846685: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  682877961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  1179482911: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  4243806635: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  214636428: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2445595289: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  1807405624: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  1721250024: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  1252848954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, true], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, true]],
  1621171031: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  3987759626: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  2082059205: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  734778138: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  1235345126: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false], ["Causes", IFCSTRUCTURALACTION, 10, true]],
  2986769608: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false], ["ResultGroupFor", IFCSTRUCTURALANALYSISMODEL, 8, true]],
  1975003073: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  148013059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2315554128: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2254336722: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  5716631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1637806684: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1692211062: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1620046519: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3593883385: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1600972822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1911125066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  728799441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2769231204: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1898987631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1133259667: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1028945134: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  4218914973: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3342526732: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1033361043: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false]],
  1213861670: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3821786052: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1411407467: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3352864051: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1871374353: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2470393545: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  3460190687: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false]],
  1967976161: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  819618141: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1916977116: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  231477066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3299480353: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  52481810: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2979338954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1095909175: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1909888760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  395041908: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3293546465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1285652485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2951183804: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2611217952: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2301859152: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  843113511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3850581409: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2816379211: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2188551683: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false]],
  1163958913: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3898045240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1060000209: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  488727124: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  335055490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2954562838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1973544240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["CoversSpaces", IFCRELCOVERSSPACES, 5, true], ["Covers", IFCRELCOVERSBLDGELEMENTS, 5, true]],
  3495092785: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3961806047: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  4147604152: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  1335981549: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2635815018: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1599208980: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2063403501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1945004755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3040386961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3041715199: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, false], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  395920057: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  869906466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3760055223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2030761528: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  855621170: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  663422040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3277789161: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1534661035: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1365060375: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1217240411: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  712377611: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1634875225: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  857184966: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1658829314: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  346874300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1810631287: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  4222183408: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2058353004: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4278956645: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4037862832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3132237377: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  987401354: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  707683696: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2223149337: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3508470533: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  900683007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1073191201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1687234759: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3171933400: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2262370178: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3024970846: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3283111854: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3055160366: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3027567501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2320036040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2016517767: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1376911519: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  1783015770: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1529196076: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  331165859: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  4252922144: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2515109513: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  3824725483: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2347447852: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3313531582: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2391406946: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3512223829: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3304561284: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2874132201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3001207471: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  753842376: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2454782716: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  578613899: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1052013943: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1062813311: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  3700593921: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  979691226: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]]
};
Constructors[1] = {
  3630933823: (ID, a) => new IFC2X3.IfcActorRole(ID, a[0], a[1], a[2]),
  618182010: (ID, a) => new IFC2X3.IfcAddress(ID, a[0], a[1], a[2]),
  639542469: (ID, a) => new IFC2X3.IfcApplication(ID, a[0], a[1], a[2], a[3]),
  411424972: (ID, a) => new IFC2X3.IfcAppliedValue(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1110488051: (ID, a) => new IFC2X3.IfcAppliedValueRelationship(ID, a[0], a[1], a[2], a[3], a[4]),
  130549933: (ID, a) => new IFC2X3.IfcApproval(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2080292479: (ID, a) => new IFC2X3.IfcApprovalActorRelationship(ID, a[0], a[1], a[2]),
  390851274: (ID, a) => new IFC2X3.IfcApprovalPropertyRelationship(ID, a[0], a[1]),
  3869604511: (ID, a) => new IFC2X3.IfcApprovalRelationship(ID, a[0], a[1], a[2], a[3]),
  4037036970: (ID, a) => new IFC2X3.IfcBoundaryCondition(ID, a[0]),
  1560379544: (ID, a) => new IFC2X3.IfcBoundaryEdgeCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3367102660: (ID, a) => new IFC2X3.IfcBoundaryFaceCondition(ID, a[0], a[1], a[2], a[3]),
  1387855156: (ID, a) => new IFC2X3.IfcBoundaryNodeCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2069777674: (ID, a) => new IFC2X3.IfcBoundaryNodeConditionWarping(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  622194075: (ID, a) => new IFC2X3.IfcCalendarDate(ID, a[0], a[1], a[2]),
  747523909: (ID, a) => new IFC2X3.IfcClassification(ID, a[0], a[1], a[2], a[3]),
  1767535486: (ID, a) => new IFC2X3.IfcClassificationItem(ID, a[0], a[1], a[2]),
  1098599126: (ID, a) => new IFC2X3.IfcClassificationItemRelationship(ID, a[0], a[1]),
  938368621: (ID, a) => new IFC2X3.IfcClassificationNotation(ID, a[0]),
  3639012971: (ID, a) => new IFC2X3.IfcClassificationNotationFacet(ID, a[0]),
  3264961684: (ID, a) => new IFC2X3.IfcColourSpecification(ID, a[0]),
  2859738748: (ID, _) => new IFC2X3.IfcConnectionGeometry(ID),
  2614616156: (ID, a) => new IFC2X3.IfcConnectionPointGeometry(ID, a[0], a[1]),
  4257277454: (ID, a) => new IFC2X3.IfcConnectionPortGeometry(ID, a[0], a[1], a[2]),
  2732653382: (ID, a) => new IFC2X3.IfcConnectionSurfaceGeometry(ID, a[0], a[1]),
  1959218052: (ID, a) => new IFC2X3.IfcConstraint(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1658513725: (ID, a) => new IFC2X3.IfcConstraintAggregationRelationship(ID, a[0], a[1], a[2], a[3], a[4]),
  613356794: (ID, a) => new IFC2X3.IfcConstraintClassificationRelationship(ID, a[0], a[1]),
  347226245: (ID, a) => new IFC2X3.IfcConstraintRelationship(ID, a[0], a[1], a[2], a[3]),
  1065062679: (ID, a) => new IFC2X3.IfcCoordinatedUniversalTimeOffset(ID, a[0], a[1], a[2]),
  602808272: (ID, a) => new IFC2X3.IfcCostValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  539742890: (ID, a) => new IFC2X3.IfcCurrencyRelationship(ID, a[0], a[1], a[2], a[3], a[4]),
  1105321065: (ID, a) => new IFC2X3.IfcCurveStyleFont(ID, a[0], a[1]),
  2367409068: (ID, a) => new IFC2X3.IfcCurveStyleFontAndScaling(ID, a[0], a[1], a[2]),
  3510044353: (ID, a) => new IFC2X3.IfcCurveStyleFontPattern(ID, a[0], a[1]),
  1072939445: (ID, a) => new IFC2X3.IfcDateAndTime(ID, a[0], a[1]),
  1765591967: (ID, a) => new IFC2X3.IfcDerivedUnit(ID, a[0], a[1], a[2]),
  1045800335: (ID, a) => new IFC2X3.IfcDerivedUnitElement(ID, a[0], a[1]),
  2949456006: (ID, a) => new IFC2X3.IfcDimensionalExponents(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1376555844: (ID, a) => new IFC2X3.IfcDocumentElectronicFormat(ID, a[0], a[1], a[2]),
  1154170062: (ID, a) => new IFC2X3.IfcDocumentInformation(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  770865208: (ID, a) => new IFC2X3.IfcDocumentInformationRelationship(ID, a[0], a[1], a[2]),
  3796139169: (ID, a) => new IFC2X3.IfcDraughtingCalloutRelationship(ID, a[0], a[1], a[2], a[3]),
  1648886627: (ID, a) => new IFC2X3.IfcEnvironmentalImpactValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3200245327: (ID, a) => new IFC2X3.IfcExternalReference(ID, a[0], a[1], a[2]),
  2242383968: (ID, a) => new IFC2X3.IfcExternallyDefinedHatchStyle(ID, a[0], a[1], a[2]),
  1040185647: (ID, a) => new IFC2X3.IfcExternallyDefinedSurfaceStyle(ID, a[0], a[1], a[2]),
  3207319532: (ID, a) => new IFC2X3.IfcExternallyDefinedSymbol(ID, a[0], a[1], a[2]),
  3548104201: (ID, a) => new IFC2X3.IfcExternallyDefinedTextFont(ID, a[0], a[1], a[2]),
  852622518: (ID, a) => new IFC2X3.IfcGridAxis(ID, a[0], a[1], a[2]),
  3020489413: (ID, a) => new IFC2X3.IfcIrregularTimeSeriesValue(ID, a[0], a[1]),
  2655187982: (ID, a) => new IFC2X3.IfcLibraryInformation(ID, a[0], a[1], a[2], a[3], a[4]),
  3452421091: (ID, a) => new IFC2X3.IfcLibraryReference(ID, a[0], a[1], a[2]),
  4162380809: (ID, a) => new IFC2X3.IfcLightDistributionData(ID, a[0], a[1], a[2]),
  1566485204: (ID, a) => new IFC2X3.IfcLightIntensityDistribution(ID, a[0], a[1]),
  30780891: (ID, a) => new IFC2X3.IfcLocalTime(ID, a[0], a[1], a[2], a[3], a[4]),
  1838606355: (ID, a) => new IFC2X3.IfcMaterial(ID, a[0]),
  1847130766: (ID, a) => new IFC2X3.IfcMaterialClassificationRelationship(ID, a[0], a[1]),
  248100487: (ID, a) => new IFC2X3.IfcMaterialLayer(ID, a[0], a[1], a[2]),
  3303938423: (ID, a) => new IFC2X3.IfcMaterialLayerSet(ID, a[0], a[1]),
  1303795690: (ID, a) => new IFC2X3.IfcMaterialLayerSetUsage(ID, a[0], a[1], a[2], a[3]),
  2199411900: (ID, a) => new IFC2X3.IfcMaterialList(ID, a[0]),
  3265635763: (ID, a) => new IFC2X3.IfcMaterialProperties(ID, a[0]),
  2597039031: (ID, a) => new IFC2X3.IfcMeasureWithUnit(ID, a[0], a[1]),
  4256014907: (ID, a) => new IFC2X3.IfcMechanicalMaterialProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  677618848: (ID, a) => new IFC2X3.IfcMechanicalSteelMaterialProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  3368373690: (ID, a) => new IFC2X3.IfcMetric(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2706619895: (ID, a) => new IFC2X3.IfcMonetaryUnit(ID, a[0]),
  1918398963: (ID, a) => new IFC2X3.IfcNamedUnit(ID, a[0], a[1]),
  3701648758: (ID, _) => new IFC2X3.IfcObjectPlacement(ID),
  2251480897: (ID, a) => new IFC2X3.IfcObjective(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1227763645: (ID, a) => new IFC2X3.IfcOpticalMaterialProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4251960020: (ID, a) => new IFC2X3.IfcOrganization(ID, a[0], a[1], a[2], a[3], a[4]),
  1411181986: (ID, a) => new IFC2X3.IfcOrganizationRelationship(ID, a[0], a[1], a[2], a[3]),
  1207048766: (ID, a) => new IFC2X3.IfcOwnerHistory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2077209135: (ID, a) => new IFC2X3.IfcPerson(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  101040310: (ID, a) => new IFC2X3.IfcPersonAndOrganization(ID, a[0], a[1], a[2]),
  2483315170: (ID, a) => new IFC2X3.IfcPhysicalQuantity(ID, a[0], a[1]),
  2226359599: (ID, a) => new IFC2X3.IfcPhysicalSimpleQuantity(ID, a[0], a[1], a[2]),
  3355820592: (ID, a) => new IFC2X3.IfcPostalAddress(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3727388367: (ID, a) => new IFC2X3.IfcPreDefinedItem(ID, a[0]),
  990879717: (ID, a) => new IFC2X3.IfcPreDefinedSymbol(ID, a[0]),
  3213052703: (ID, a) => new IFC2X3.IfcPreDefinedTerminatorSymbol(ID, a[0]),
  1775413392: (ID, a) => new IFC2X3.IfcPreDefinedTextFont(ID, a[0]),
  2022622350: (ID, a) => new IFC2X3.IfcPresentationLayerAssignment(ID, a[0], a[1], a[2], a[3]),
  1304840413: (ID, a) => new IFC2X3.IfcPresentationLayerWithStyle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3119450353: (ID, a) => new IFC2X3.IfcPresentationStyle(ID, a[0]),
  2417041796: (ID, a) => new IFC2X3.IfcPresentationStyleAssignment(ID, a[0]),
  2095639259: (ID, a) => new IFC2X3.IfcProductRepresentation(ID, a[0], a[1], a[2]),
  2267347899: (ID, a) => new IFC2X3.IfcProductsOfCombustionProperties(ID, a[0], a[1], a[2], a[3], a[4]),
  3958567839: (ID, a) => new IFC2X3.IfcProfileDef(ID, a[0], a[1]),
  2802850158: (ID, a) => new IFC2X3.IfcProfileProperties(ID, a[0], a[1]),
  2598011224: (ID, a) => new IFC2X3.IfcProperty(ID, a[0], a[1]),
  3896028662: (ID, a) => new IFC2X3.IfcPropertyConstraintRelationship(ID, a[0], a[1], a[2], a[3]),
  148025276: (ID, a) => new IFC2X3.IfcPropertyDependencyRelationship(ID, a[0], a[1], a[2], a[3], a[4]),
  3710013099: (ID, a) => new IFC2X3.IfcPropertyEnumeration(ID, a[0], a[1], a[2]),
  2044713172: (ID, a) => new IFC2X3.IfcQuantityArea(ID, a[0], a[1], a[2], a[3]),
  2093928680: (ID, a) => new IFC2X3.IfcQuantityCount(ID, a[0], a[1], a[2], a[3]),
  931644368: (ID, a) => new IFC2X3.IfcQuantityLength(ID, a[0], a[1], a[2], a[3]),
  3252649465: (ID, a) => new IFC2X3.IfcQuantityTime(ID, a[0], a[1], a[2], a[3]),
  2405470396: (ID, a) => new IFC2X3.IfcQuantityVolume(ID, a[0], a[1], a[2], a[3]),
  825690147: (ID, a) => new IFC2X3.IfcQuantityWeight(ID, a[0], a[1], a[2], a[3]),
  2692823254: (ID, a) => new IFC2X3.IfcReferencesValueDocument(ID, a[0], a[1], a[2], a[3]),
  1580146022: (ID, a) => new IFC2X3.IfcReinforcementBarProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1222501353: (ID, a) => new IFC2X3.IfcRelaxation(ID, a[0], a[1]),
  1076942058: (ID, a) => new IFC2X3.IfcRepresentation(ID, a[0], a[1], a[2], a[3]),
  3377609919: (ID, a) => new IFC2X3.IfcRepresentationContext(ID, a[0], a[1]),
  3008791417: (ID, _) => new IFC2X3.IfcRepresentationItem(ID),
  1660063152: (ID, a) => new IFC2X3.IfcRepresentationMap(ID, a[0], a[1]),
  3679540991: (ID, a) => new IFC2X3.IfcRibPlateProfileProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2341007311: (ID, a) => new IFC2X3.IfcRoot(ID, a[0], a[1], a[2], a[3]),
  448429030: (ID, a) => new IFC2X3.IfcSIUnit(ID, a[0], a[1], a[2]),
  2042790032: (ID, a) => new IFC2X3.IfcSectionProperties(ID, a[0], a[1], a[2]),
  4165799628: (ID, a) => new IFC2X3.IfcSectionReinforcementProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  867548509: (ID, a) => new IFC2X3.IfcShapeAspect(ID, a[0], a[1], a[2], a[3], a[4]),
  3982875396: (ID, a) => new IFC2X3.IfcShapeModel(ID, a[0], a[1], a[2], a[3]),
  4240577450: (ID, a) => new IFC2X3.IfcShapeRepresentation(ID, a[0], a[1], a[2], a[3]),
  3692461612: (ID, a) => new IFC2X3.IfcSimpleProperty(ID, a[0], a[1]),
  2273995522: (ID, a) => new IFC2X3.IfcStructuralConnectionCondition(ID, a[0]),
  2162789131: (ID, a) => new IFC2X3.IfcStructuralLoad(ID, a[0]),
  2525727697: (ID, a) => new IFC2X3.IfcStructuralLoadStatic(ID, a[0]),
  3408363356: (ID, a) => new IFC2X3.IfcStructuralLoadTemperature(ID, a[0], a[1], a[2], a[3]),
  2830218821: (ID, a) => new IFC2X3.IfcStyleModel(ID, a[0], a[1], a[2], a[3]),
  3958052878: (ID, a) => new IFC2X3.IfcStyledItem(ID, a[0], a[1], a[2]),
  3049322572: (ID, a) => new IFC2X3.IfcStyledRepresentation(ID, a[0], a[1], a[2], a[3]),
  1300840506: (ID, a) => new IFC2X3.IfcSurfaceStyle(ID, a[0], a[1], a[2]),
  3303107099: (ID, a) => new IFC2X3.IfcSurfaceStyleLighting(ID, a[0], a[1], a[2], a[3]),
  1607154358: (ID, a) => new IFC2X3.IfcSurfaceStyleRefraction(ID, a[0], a[1]),
  846575682: (ID, a) => new IFC2X3.IfcSurfaceStyleShading(ID, a[0]),
  1351298697: (ID, a) => new IFC2X3.IfcSurfaceStyleWithTextures(ID, a[0]),
  626085974: (ID, a) => new IFC2X3.IfcSurfaceTexture(ID, a[0], a[1], a[2], a[3]),
  1290481447: (ID, a) => new IFC2X3.IfcSymbolStyle(ID, a[0], a[1]),
  985171141: (ID, a) => new IFC2X3.IfcTable(ID, a[0], a[1]),
  531007025: (ID, a) => new IFC2X3.IfcTableRow(ID, a[0], a[1]),
  912023232: (ID, a) => new IFC2X3.IfcTelecomAddress(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1447204868: (ID, a) => new IFC2X3.IfcTextStyle(ID, a[0], a[1], a[2], a[3]),
  1983826977: (ID, a) => new IFC2X3.IfcTextStyleFontModel(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2636378356: (ID, a) => new IFC2X3.IfcTextStyleForDefinedFont(ID, a[0], a[1]),
  1640371178: (ID, a) => new IFC2X3.IfcTextStyleTextModel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1484833681: (ID, a) => new IFC2X3.IfcTextStyleWithBoxCharacteristics(ID, a[0], a[1], a[2], a[3], a[4]),
  280115917: (ID, _) => new IFC2X3.IfcTextureCoordinate(ID),
  1742049831: (ID, a) => new IFC2X3.IfcTextureCoordinateGenerator(ID, a[0], a[1]),
  2552916305: (ID, a) => new IFC2X3.IfcTextureMap(ID, a[0]),
  1210645708: (ID, a) => new IFC2X3.IfcTextureVertex(ID, a[0]),
  3317419933: (ID, a) => new IFC2X3.IfcThermalMaterialProperties(ID, a[0], a[1], a[2], a[3], a[4]),
  3101149627: (ID, a) => new IFC2X3.IfcTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1718945513: (ID, a) => new IFC2X3.IfcTimeSeriesReferenceRelationship(ID, a[0], a[1]),
  581633288: (ID, a) => new IFC2X3.IfcTimeSeriesValue(ID, a[0]),
  1377556343: (ID, _) => new IFC2X3.IfcTopologicalRepresentationItem(ID),
  1735638870: (ID, a) => new IFC2X3.IfcTopologyRepresentation(ID, a[0], a[1], a[2], a[3]),
  180925521: (ID, a) => new IFC2X3.IfcUnitAssignment(ID, a[0]),
  2799835756: (ID, _) => new IFC2X3.IfcVertex(ID),
  3304826586: (ID, a) => new IFC2X3.IfcVertexBasedTextureMap(ID, a[0], a[1]),
  1907098498: (ID, a) => new IFC2X3.IfcVertexPoint(ID, a[0]),
  891718957: (ID, a) => new IFC2X3.IfcVirtualGridIntersection(ID, a[0], a[1]),
  1065908215: (ID, a) => new IFC2X3.IfcWaterProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2442683028: (ID, a) => new IFC2X3.IfcAnnotationOccurrence(ID, a[0], a[1], a[2]),
  962685235: (ID, a) => new IFC2X3.IfcAnnotationSurfaceOccurrence(ID, a[0], a[1], a[2]),
  3612888222: (ID, a) => new IFC2X3.IfcAnnotationSymbolOccurrence(ID, a[0], a[1], a[2]),
  2297822566: (ID, a) => new IFC2X3.IfcAnnotationTextOccurrence(ID, a[0], a[1], a[2]),
  3798115385: (ID, a) => new IFC2X3.IfcArbitraryClosedProfileDef(ID, a[0], a[1], a[2]),
  1310608509: (ID, a) => new IFC2X3.IfcArbitraryOpenProfileDef(ID, a[0], a[1], a[2]),
  2705031697: (ID, a) => new IFC2X3.IfcArbitraryProfileDefWithVoids(ID, a[0], a[1], a[2], a[3]),
  616511568: (ID, a) => new IFC2X3.IfcBlobTexture(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3150382593: (ID, a) => new IFC2X3.IfcCenterLineProfileDef(ID, a[0], a[1], a[2], a[3]),
  647927063: (ID, a) => new IFC2X3.IfcClassificationReference(ID, a[0], a[1], a[2], a[3]),
  776857604: (ID, a) => new IFC2X3.IfcColourRgb(ID, a[0], a[1], a[2], a[3]),
  2542286263: (ID, a) => new IFC2X3.IfcComplexProperty(ID, a[0], a[1], a[2], a[3]),
  1485152156: (ID, a) => new IFC2X3.IfcCompositeProfileDef(ID, a[0], a[1], a[2], a[3]),
  370225590: (ID, a) => new IFC2X3.IfcConnectedFaceSet(ID, a[0]),
  1981873012: (ID, a) => new IFC2X3.IfcConnectionCurveGeometry(ID, a[0], a[1]),
  45288368: (ID, a) => new IFC2X3.IfcConnectionPointEccentricity(ID, a[0], a[1], a[2], a[3], a[4]),
  3050246964: (ID, a) => new IFC2X3.IfcContextDependentUnit(ID, a[0], a[1], a[2]),
  2889183280: (ID, a) => new IFC2X3.IfcConversionBasedUnit(ID, a[0], a[1], a[2], a[3]),
  3800577675: (ID, a) => new IFC2X3.IfcCurveStyle(ID, a[0], a[1], a[2], a[3]),
  3632507154: (ID, a) => new IFC2X3.IfcDerivedProfileDef(ID, a[0], a[1], a[2], a[3], a[4]),
  2273265877: (ID, a) => new IFC2X3.IfcDimensionCalloutRelationship(ID, a[0], a[1], a[2], a[3]),
  1694125774: (ID, a) => new IFC2X3.IfcDimensionPair(ID, a[0], a[1], a[2], a[3]),
  3732053477: (ID, a) => new IFC2X3.IfcDocumentReference(ID, a[0], a[1], a[2]),
  4170525392: (ID, a) => new IFC2X3.IfcDraughtingPreDefinedTextFont(ID, a[0]),
  3900360178: (ID, a) => new IFC2X3.IfcEdge(ID, a[0], a[1]),
  476780140: (ID, a) => new IFC2X3.IfcEdgeCurve(ID, a[0], a[1], a[2], a[3]),
  1860660968: (ID, a) => new IFC2X3.IfcExtendedMaterialProperties(ID, a[0], a[1], a[2], a[3]),
  2556980723: (ID, a) => new IFC2X3.IfcFace(ID, a[0]),
  1809719519: (ID, a) => new IFC2X3.IfcFaceBound(ID, a[0], a[1]),
  803316827: (ID, a) => new IFC2X3.IfcFaceOuterBound(ID, a[0], a[1]),
  3008276851: (ID, a) => new IFC2X3.IfcFaceSurface(ID, a[0], a[1], a[2]),
  4219587988: (ID, a) => new IFC2X3.IfcFailureConnectionCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  738692330: (ID, a) => new IFC2X3.IfcFillAreaStyle(ID, a[0], a[1]),
  3857492461: (ID, a) => new IFC2X3.IfcFuelProperties(ID, a[0], a[1], a[2], a[3], a[4]),
  803998398: (ID, a) => new IFC2X3.IfcGeneralMaterialProperties(ID, a[0], a[1], a[2], a[3]),
  1446786286: (ID, a) => new IFC2X3.IfcGeneralProfileProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3448662350: (ID, a) => new IFC2X3.IfcGeometricRepresentationContext(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2453401579: (ID, _) => new IFC2X3.IfcGeometricRepresentationItem(ID),
  4142052618: (ID, a) => new IFC2X3.IfcGeometricRepresentationSubContext(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3590301190: (ID, a) => new IFC2X3.IfcGeometricSet(ID, a[0]),
  178086475: (ID, a) => new IFC2X3.IfcGridPlacement(ID, a[0], a[1]),
  812098782: (ID, a) => new IFC2X3.IfcHalfSpaceSolid(ID, a[0], a[1]),
  2445078500: (ID, a) => new IFC2X3.IfcHygroscopicMaterialProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3905492369: (ID, a) => new IFC2X3.IfcImageTexture(ID, a[0], a[1], a[2], a[3], a[4]),
  3741457305: (ID, a) => new IFC2X3.IfcIrregularTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1402838566: (ID, a) => new IFC2X3.IfcLightSource(ID, a[0], a[1], a[2], a[3]),
  125510826: (ID, a) => new IFC2X3.IfcLightSourceAmbient(ID, a[0], a[1], a[2], a[3]),
  2604431987: (ID, a) => new IFC2X3.IfcLightSourceDirectional(ID, a[0], a[1], a[2], a[3], a[4]),
  4266656042: (ID, a) => new IFC2X3.IfcLightSourceGoniometric(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1520743889: (ID, a) => new IFC2X3.IfcLightSourcePositional(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3422422726: (ID, a) => new IFC2X3.IfcLightSourceSpot(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  2624227202: (ID, a) => new IFC2X3.IfcLocalPlacement(ID, a[0], a[1]),
  1008929658: (ID, _) => new IFC2X3.IfcLoop(ID),
  2347385850: (ID, a) => new IFC2X3.IfcMappedItem(ID, a[0], a[1]),
  2022407955: (ID, a) => new IFC2X3.IfcMaterialDefinitionRepresentation(ID, a[0], a[1], a[2], a[3]),
  1430189142: (ID, a) => new IFC2X3.IfcMechanicalConcreteMaterialProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  219451334: (ID, a) => new IFC2X3.IfcObjectDefinition(ID, a[0], a[1], a[2], a[3]),
  2833995503: (ID, a) => new IFC2X3.IfcOneDirectionRepeatFactor(ID, a[0]),
  2665983363: (ID, a) => new IFC2X3.IfcOpenShell(ID, a[0]),
  1029017970: (ID, a) => new IFC2X3.IfcOrientedEdge(ID, a[0], a[1]),
  2529465313: (ID, a) => new IFC2X3.IfcParameterizedProfileDef(ID, a[0], a[1], a[2]),
  2519244187: (ID, a) => new IFC2X3.IfcPath(ID, a[0]),
  3021840470: (ID, a) => new IFC2X3.IfcPhysicalComplexQuantity(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  597895409: (ID, a) => new IFC2X3.IfcPixelTexture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2004835150: (ID, a) => new IFC2X3.IfcPlacement(ID, a[0]),
  1663979128: (ID, a) => new IFC2X3.IfcPlanarExtent(ID, a[0], a[1]),
  2067069095: (ID, _) => new IFC2X3.IfcPoint(ID),
  4022376103: (ID, a) => new IFC2X3.IfcPointOnCurve(ID, a[0], a[1]),
  1423911732: (ID, a) => new IFC2X3.IfcPointOnSurface(ID, a[0], a[1], a[2]),
  2924175390: (ID, a) => new IFC2X3.IfcPolyLoop(ID, a[0]),
  2775532180: (ID, a) => new IFC2X3.IfcPolygonalBoundedHalfSpace(ID, a[0], a[1], a[2], a[3]),
  759155922: (ID, a) => new IFC2X3.IfcPreDefinedColour(ID, a[0]),
  2559016684: (ID, a) => new IFC2X3.IfcPreDefinedCurveFont(ID, a[0]),
  433424934: (ID, a) => new IFC2X3.IfcPreDefinedDimensionSymbol(ID, a[0]),
  179317114: (ID, a) => new IFC2X3.IfcPreDefinedPointMarkerSymbol(ID, a[0]),
  673634403: (ID, a) => new IFC2X3.IfcProductDefinitionShape(ID, a[0], a[1], a[2]),
  871118103: (ID, a) => new IFC2X3.IfcPropertyBoundedValue(ID, a[0], a[1], a[2], a[3], a[4]),
  1680319473: (ID, a) => new IFC2X3.IfcPropertyDefinition(ID, a[0], a[1], a[2], a[3]),
  4166981789: (ID, a) => new IFC2X3.IfcPropertyEnumeratedValue(ID, a[0], a[1], a[2], a[3]),
  2752243245: (ID, a) => new IFC2X3.IfcPropertyListValue(ID, a[0], a[1], a[2], a[3]),
  941946838: (ID, a) => new IFC2X3.IfcPropertyReferenceValue(ID, a[0], a[1], a[2], a[3]),
  3357820518: (ID, a) => new IFC2X3.IfcPropertySetDefinition(ID, a[0], a[1], a[2], a[3]),
  3650150729: (ID, a) => new IFC2X3.IfcPropertySingleValue(ID, a[0], a[1], a[2], a[3]),
  110355661: (ID, a) => new IFC2X3.IfcPropertyTableValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3615266464: (ID, a) => new IFC2X3.IfcRectangleProfileDef(ID, a[0], a[1], a[2], a[3], a[4]),
  3413951693: (ID, a) => new IFC2X3.IfcRegularTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3765753017: (ID, a) => new IFC2X3.IfcReinforcementDefinitionProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  478536968: (ID, a) => new IFC2X3.IfcRelationship(ID, a[0], a[1], a[2], a[3]),
  2778083089: (ID, a) => new IFC2X3.IfcRoundedRectangleProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1509187699: (ID, a) => new IFC2X3.IfcSectionedSpine(ID, a[0], a[1], a[2]),
  2411513650: (ID, a) => new IFC2X3.IfcServiceLifeFactor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4124623270: (ID, a) => new IFC2X3.IfcShellBasedSurfaceModel(ID, a[0]),
  2609359061: (ID, a) => new IFC2X3.IfcSlippageConnectionCondition(ID, a[0], a[1], a[2], a[3]),
  723233188: (ID, _) => new IFC2X3.IfcSolidModel(ID),
  2485662743: (ID, a) => new IFC2X3.IfcSoundProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1202362311: (ID, a) => new IFC2X3.IfcSoundValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  390701378: (ID, a) => new IFC2X3.IfcSpaceThermalLoadProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  1595516126: (ID, a) => new IFC2X3.IfcStructuralLoadLinearForce(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2668620305: (ID, a) => new IFC2X3.IfcStructuralLoadPlanarForce(ID, a[0], a[1], a[2], a[3]),
  2473145415: (ID, a) => new IFC2X3.IfcStructuralLoadSingleDisplacement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1973038258: (ID, a) => new IFC2X3.IfcStructuralLoadSingleDisplacementDistortion(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1597423693: (ID, a) => new IFC2X3.IfcStructuralLoadSingleForce(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1190533807: (ID, a) => new IFC2X3.IfcStructuralLoadSingleForceWarping(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3843319758: (ID, a) => new IFC2X3.IfcStructuralProfileProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20], a[21], a[22]),
  3653947884: (ID, a) => new IFC2X3.IfcStructuralSteelProfileProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20], a[21], a[22], a[23], a[24], a[25], a[26]),
  2233826070: (ID, a) => new IFC2X3.IfcSubedge(ID, a[0], a[1], a[2]),
  2513912981: (ID, _) => new IFC2X3.IfcSurface(ID),
  1878645084: (ID, a) => new IFC2X3.IfcSurfaceStyleRendering(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2247615214: (ID, a) => new IFC2X3.IfcSweptAreaSolid(ID, a[0], a[1]),
  1260650574: (ID, a) => new IFC2X3.IfcSweptDiskSolid(ID, a[0], a[1], a[2], a[3], a[4]),
  230924584: (ID, a) => new IFC2X3.IfcSweptSurface(ID, a[0], a[1]),
  3071757647: (ID, a) => new IFC2X3.IfcTShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  3028897424: (ID, a) => new IFC2X3.IfcTerminatorSymbol(ID, a[0], a[1], a[2], a[3]),
  4282788508: (ID, a) => new IFC2X3.IfcTextLiteral(ID, a[0], a[1], a[2]),
  3124975700: (ID, a) => new IFC2X3.IfcTextLiteralWithExtent(ID, a[0], a[1], a[2], a[3], a[4]),
  2715220739: (ID, a) => new IFC2X3.IfcTrapeziumProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1345879162: (ID, a) => new IFC2X3.IfcTwoDirectionRepeatFactor(ID, a[0], a[1]),
  1628702193: (ID, a) => new IFC2X3.IfcTypeObject(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2347495698: (ID, a) => new IFC2X3.IfcTypeProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  427810014: (ID, a) => new IFC2X3.IfcUShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1417489154: (ID, a) => new IFC2X3.IfcVector(ID, a[0], a[1]),
  2759199220: (ID, a) => new IFC2X3.IfcVertexLoop(ID, a[0]),
  336235671: (ID, a) => new IFC2X3.IfcWindowLiningProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  512836454: (ID, a) => new IFC2X3.IfcWindowPanelProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1299126871: (ID, a) => new IFC2X3.IfcWindowStyle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2543172580: (ID, a) => new IFC2X3.IfcZShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3288037868: (ID, a) => new IFC2X3.IfcAnnotationCurveOccurrence(ID, a[0], a[1], a[2]),
  669184980: (ID, a) => new IFC2X3.IfcAnnotationFillArea(ID, a[0], a[1]),
  2265737646: (ID, a) => new IFC2X3.IfcAnnotationFillAreaOccurrence(ID, a[0], a[1], a[2], a[3], a[4]),
  1302238472: (ID, a) => new IFC2X3.IfcAnnotationSurface(ID, a[0], a[1]),
  4261334040: (ID, a) => new IFC2X3.IfcAxis1Placement(ID, a[0], a[1]),
  3125803723: (ID, a) => new IFC2X3.IfcAxis2Placement2D(ID, a[0], a[1]),
  2740243338: (ID, a) => new IFC2X3.IfcAxis2Placement3D(ID, a[0], a[1], a[2]),
  2736907675: (ID, a) => new IFC2X3.IfcBooleanResult(ID, a[0], a[1], a[2]),
  4182860854: (ID, _) => new IFC2X3.IfcBoundedSurface(ID),
  2581212453: (ID, a) => new IFC2X3.IfcBoundingBox(ID, a[0], a[1], a[2], a[3]),
  2713105998: (ID, a) => new IFC2X3.IfcBoxedHalfSpace(ID, a[0], a[1], a[2]),
  2898889636: (ID, a) => new IFC2X3.IfcCShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1123145078: (ID, a) => new IFC2X3.IfcCartesianPoint(ID, a[0]),
  59481748: (ID, a) => new IFC2X3.IfcCartesianTransformationOperator(ID, a[0], a[1], a[2], a[3]),
  3749851601: (ID, a) => new IFC2X3.IfcCartesianTransformationOperator2D(ID, a[0], a[1], a[2], a[3]),
  3486308946: (ID, a) => new IFC2X3.IfcCartesianTransformationOperator2DnonUniform(ID, a[0], a[1], a[2], a[3], a[4]),
  3331915920: (ID, a) => new IFC2X3.IfcCartesianTransformationOperator3D(ID, a[0], a[1], a[2], a[3], a[4]),
  1416205885: (ID, a) => new IFC2X3.IfcCartesianTransformationOperator3DnonUniform(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1383045692: (ID, a) => new IFC2X3.IfcCircleProfileDef(ID, a[0], a[1], a[2], a[3]),
  2205249479: (ID, a) => new IFC2X3.IfcClosedShell(ID, a[0]),
  2485617015: (ID, a) => new IFC2X3.IfcCompositeCurveSegment(ID, a[0], a[1], a[2]),
  4133800736: (ID, a) => new IFC2X3.IfcCraneRailAShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
  194851669: (ID, a) => new IFC2X3.IfcCraneRailFShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2506170314: (ID, a) => new IFC2X3.IfcCsgPrimitive3D(ID, a[0]),
  2147822146: (ID, a) => new IFC2X3.IfcCsgSolid(ID, a[0]),
  2601014836: (ID, _) => new IFC2X3.IfcCurve(ID),
  2827736869: (ID, a) => new IFC2X3.IfcCurveBoundedPlane(ID, a[0], a[1], a[2]),
  693772133: (ID, a) => new IFC2X3.IfcDefinedSymbol(ID, a[0], a[1]),
  606661476: (ID, a) => new IFC2X3.IfcDimensionCurve(ID, a[0], a[1], a[2]),
  4054601972: (ID, a) => new IFC2X3.IfcDimensionCurveTerminator(ID, a[0], a[1], a[2], a[3], a[4]),
  32440307: (ID, a) => new IFC2X3.IfcDirection(ID, a[0]),
  2963535650: (ID, a) => new IFC2X3.IfcDoorLiningProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
  1714330368: (ID, a) => new IFC2X3.IfcDoorPanelProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  526551008: (ID, a) => new IFC2X3.IfcDoorStyle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  3073041342: (ID, a) => new IFC2X3.IfcDraughtingCallout(ID, a[0]),
  445594917: (ID, a) => new IFC2X3.IfcDraughtingPreDefinedColour(ID, a[0]),
  4006246654: (ID, a) => new IFC2X3.IfcDraughtingPreDefinedCurveFont(ID, a[0]),
  1472233963: (ID, a) => new IFC2X3.IfcEdgeLoop(ID, a[0]),
  1883228015: (ID, a) => new IFC2X3.IfcElementQuantity(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  339256511: (ID, a) => new IFC2X3.IfcElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2777663545: (ID, a) => new IFC2X3.IfcElementarySurface(ID, a[0]),
  2835456948: (ID, a) => new IFC2X3.IfcEllipseProfileDef(ID, a[0], a[1], a[2], a[3], a[4]),
  80994333: (ID, a) => new IFC2X3.IfcEnergyProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  477187591: (ID, a) => new IFC2X3.IfcExtrudedAreaSolid(ID, a[0], a[1], a[2], a[3]),
  2047409740: (ID, a) => new IFC2X3.IfcFaceBasedSurfaceModel(ID, a[0]),
  374418227: (ID, a) => new IFC2X3.IfcFillAreaStyleHatching(ID, a[0], a[1], a[2], a[3], a[4]),
  4203026998: (ID, a) => new IFC2X3.IfcFillAreaStyleTileSymbolWithStyle(ID, a[0]),
  315944413: (ID, a) => new IFC2X3.IfcFillAreaStyleTiles(ID, a[0], a[1], a[2]),
  3455213021: (ID, a) => new IFC2X3.IfcFluidFlowProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18]),
  4238390223: (ID, a) => new IFC2X3.IfcFurnishingElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1268542332: (ID, a) => new IFC2X3.IfcFurnitureType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  987898635: (ID, a) => new IFC2X3.IfcGeometricCurveSet(ID, a[0]),
  1484403080: (ID, a) => new IFC2X3.IfcIShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  572779678: (ID, a) => new IFC2X3.IfcLShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1281925730: (ID, a) => new IFC2X3.IfcLine(ID, a[0], a[1]),
  1425443689: (ID, a) => new IFC2X3.IfcManifoldSolidBrep(ID, a[0]),
  3888040117: (ID, a) => new IFC2X3.IfcObject(ID, a[0], a[1], a[2], a[3], a[4]),
  3388369263: (ID, a) => new IFC2X3.IfcOffsetCurve2D(ID, a[0], a[1], a[2]),
  3505215534: (ID, a) => new IFC2X3.IfcOffsetCurve3D(ID, a[0], a[1], a[2], a[3]),
  3566463478: (ID, a) => new IFC2X3.IfcPermeableCoveringProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  603570806: (ID, a) => new IFC2X3.IfcPlanarBox(ID, a[0], a[1], a[2]),
  220341763: (ID, a) => new IFC2X3.IfcPlane(ID, a[0]),
  2945172077: (ID, a) => new IFC2X3.IfcProcess(ID, a[0], a[1], a[2], a[3], a[4]),
  4208778838: (ID, a) => new IFC2X3.IfcProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  103090709: (ID, a) => new IFC2X3.IfcProject(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4194566429: (ID, a) => new IFC2X3.IfcProjectionCurve(ID, a[0], a[1], a[2]),
  1451395588: (ID, a) => new IFC2X3.IfcPropertySet(ID, a[0], a[1], a[2], a[3], a[4]),
  3219374653: (ID, a) => new IFC2X3.IfcProxy(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2770003689: (ID, a) => new IFC2X3.IfcRectangleHollowProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2798486643: (ID, a) => new IFC2X3.IfcRectangularPyramid(ID, a[0], a[1], a[2], a[3]),
  3454111270: (ID, a) => new IFC2X3.IfcRectangularTrimmedSurface(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3939117080: (ID, a) => new IFC2X3.IfcRelAssigns(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1683148259: (ID, a) => new IFC2X3.IfcRelAssignsToActor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2495723537: (ID, a) => new IFC2X3.IfcRelAssignsToControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1307041759: (ID, a) => new IFC2X3.IfcRelAssignsToGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  4278684876: (ID, a) => new IFC2X3.IfcRelAssignsToProcess(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2857406711: (ID, a) => new IFC2X3.IfcRelAssignsToProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3372526763: (ID, a) => new IFC2X3.IfcRelAssignsToProjectOrder(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  205026976: (ID, a) => new IFC2X3.IfcRelAssignsToResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1865459582: (ID, a) => new IFC2X3.IfcRelAssociates(ID, a[0], a[1], a[2], a[3], a[4]),
  1327628568: (ID, a) => new IFC2X3.IfcRelAssociatesAppliedValue(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  4095574036: (ID, a) => new IFC2X3.IfcRelAssociatesApproval(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  919958153: (ID, a) => new IFC2X3.IfcRelAssociatesClassification(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2728634034: (ID, a) => new IFC2X3.IfcRelAssociatesConstraint(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  982818633: (ID, a) => new IFC2X3.IfcRelAssociatesDocument(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3840914261: (ID, a) => new IFC2X3.IfcRelAssociatesLibrary(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2655215786: (ID, a) => new IFC2X3.IfcRelAssociatesMaterial(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2851387026: (ID, a) => new IFC2X3.IfcRelAssociatesProfileProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  826625072: (ID, a) => new IFC2X3.IfcRelConnects(ID, a[0], a[1], a[2], a[3]),
  1204542856: (ID, a) => new IFC2X3.IfcRelConnectsElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3945020480: (ID, a) => new IFC2X3.IfcRelConnectsPathElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4201705270: (ID, a) => new IFC2X3.IfcRelConnectsPortToElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3190031847: (ID, a) => new IFC2X3.IfcRelConnectsPorts(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2127690289: (ID, a) => new IFC2X3.IfcRelConnectsStructuralActivity(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3912681535: (ID, a) => new IFC2X3.IfcRelConnectsStructuralElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1638771189: (ID, a) => new IFC2X3.IfcRelConnectsStructuralMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  504942748: (ID, a) => new IFC2X3.IfcRelConnectsWithEccentricity(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3678494232: (ID, a) => new IFC2X3.IfcRelConnectsWithRealizingElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3242617779: (ID, a) => new IFC2X3.IfcRelContainedInSpatialStructure(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  886880790: (ID, a) => new IFC2X3.IfcRelCoversBldgElements(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2802773753: (ID, a) => new IFC2X3.IfcRelCoversSpaces(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2551354335: (ID, a) => new IFC2X3.IfcRelDecomposes(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  693640335: (ID, a) => new IFC2X3.IfcRelDefines(ID, a[0], a[1], a[2], a[3], a[4]),
  4186316022: (ID, a) => new IFC2X3.IfcRelDefinesByProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  781010003: (ID, a) => new IFC2X3.IfcRelDefinesByType(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3940055652: (ID, a) => new IFC2X3.IfcRelFillsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  279856033: (ID, a) => new IFC2X3.IfcRelFlowControlElements(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  4189434867: (ID, a) => new IFC2X3.IfcRelInteractionRequirements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3268803585: (ID, a) => new IFC2X3.IfcRelNests(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2051452291: (ID, a) => new IFC2X3.IfcRelOccupiesSpaces(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  202636808: (ID, a) => new IFC2X3.IfcRelOverridesProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  750771296: (ID, a) => new IFC2X3.IfcRelProjectsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1245217292: (ID, a) => new IFC2X3.IfcRelReferencedInSpatialStructure(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1058617721: (ID, a) => new IFC2X3.IfcRelSchedulesCostItems(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  4122056220: (ID, a) => new IFC2X3.IfcRelSequence(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  366585022: (ID, a) => new IFC2X3.IfcRelServicesBuildings(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3451746338: (ID, a) => new IFC2X3.IfcRelSpaceBoundary(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1401173127: (ID, a) => new IFC2X3.IfcRelVoidsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2914609552: (ID, a) => new IFC2X3.IfcResource(ID, a[0], a[1], a[2], a[3], a[4]),
  1856042241: (ID, a) => new IFC2X3.IfcRevolvedAreaSolid(ID, a[0], a[1], a[2], a[3]),
  4158566097: (ID, a) => new IFC2X3.IfcRightCircularCone(ID, a[0], a[1], a[2]),
  3626867408: (ID, a) => new IFC2X3.IfcRightCircularCylinder(ID, a[0], a[1], a[2]),
  2706606064: (ID, a) => new IFC2X3.IfcSpatialStructureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3893378262: (ID, a) => new IFC2X3.IfcSpatialStructureElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  451544542: (ID, a) => new IFC2X3.IfcSphere(ID, a[0], a[1]),
  3544373492: (ID, a) => new IFC2X3.IfcStructuralActivity(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3136571912: (ID, a) => new IFC2X3.IfcStructuralItem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  530289379: (ID, a) => new IFC2X3.IfcStructuralMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3689010777: (ID, a) => new IFC2X3.IfcStructuralReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3979015343: (ID, a) => new IFC2X3.IfcStructuralSurfaceMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2218152070: (ID, a) => new IFC2X3.IfcStructuralSurfaceMemberVarying(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4070609034: (ID, a) => new IFC2X3.IfcStructuredDimensionCallout(ID, a[0]),
  2028607225: (ID, a) => new IFC2X3.IfcSurfaceCurveSweptAreaSolid(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2809605785: (ID, a) => new IFC2X3.IfcSurfaceOfLinearExtrusion(ID, a[0], a[1], a[2], a[3]),
  4124788165: (ID, a) => new IFC2X3.IfcSurfaceOfRevolution(ID, a[0], a[1], a[2]),
  1580310250: (ID, a) => new IFC2X3.IfcSystemFurnitureElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3473067441: (ID, a) => new IFC2X3.IfcTask(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2097647324: (ID, a) => new IFC2X3.IfcTransportElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2296667514: (ID, a) => new IFC2X3.IfcActor(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1674181508: (ID, a) => new IFC2X3.IfcAnnotation(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3207858831: (ID, a) => new IFC2X3.IfcAsymmetricIShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1334484129: (ID, a) => new IFC2X3.IfcBlock(ID, a[0], a[1], a[2], a[3]),
  3649129432: (ID, a) => new IFC2X3.IfcBooleanClippingResult(ID, a[0], a[1], a[2]),
  1260505505: (ID, _) => new IFC2X3.IfcBoundedCurve(ID),
  4031249490: (ID, a) => new IFC2X3.IfcBuilding(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1950629157: (ID, a) => new IFC2X3.IfcBuildingElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3124254112: (ID, a) => new IFC2X3.IfcBuildingStorey(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2937912522: (ID, a) => new IFC2X3.IfcCircleHollowProfileDef(ID, a[0], a[1], a[2], a[3], a[4]),
  300633059: (ID, a) => new IFC2X3.IfcColumnType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3732776249: (ID, a) => new IFC2X3.IfcCompositeCurve(ID, a[0], a[1]),
  2510884976: (ID, a) => new IFC2X3.IfcConic(ID, a[0]),
  2559216714: (ID, a) => new IFC2X3.IfcConstructionResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3293443760: (ID, a) => new IFC2X3.IfcControl(ID, a[0], a[1], a[2], a[3], a[4]),
  3895139033: (ID, a) => new IFC2X3.IfcCostItem(ID, a[0], a[1], a[2], a[3], a[4]),
  1419761937: (ID, a) => new IFC2X3.IfcCostSchedule(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  1916426348: (ID, a) => new IFC2X3.IfcCoveringType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3295246426: (ID, a) => new IFC2X3.IfcCrewResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1457835157: (ID, a) => new IFC2X3.IfcCurtainWallType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  681481545: (ID, a) => new IFC2X3.IfcDimensionCurveDirectedCallout(ID, a[0]),
  3256556792: (ID, a) => new IFC2X3.IfcDistributionElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3849074793: (ID, a) => new IFC2X3.IfcDistributionFlowElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  360485395: (ID, a) => new IFC2X3.IfcElectricalBaseProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  1758889154: (ID, a) => new IFC2X3.IfcElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4123344466: (ID, a) => new IFC2X3.IfcElementAssembly(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1623761950: (ID, a) => new IFC2X3.IfcElementComponent(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2590856083: (ID, a) => new IFC2X3.IfcElementComponentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1704287377: (ID, a) => new IFC2X3.IfcEllipse(ID, a[0], a[1], a[2]),
  2107101300: (ID, a) => new IFC2X3.IfcEnergyConversionDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1962604670: (ID, a) => new IFC2X3.IfcEquipmentElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3272907226: (ID, a) => new IFC2X3.IfcEquipmentStandard(ID, a[0], a[1], a[2], a[3], a[4]),
  3174744832: (ID, a) => new IFC2X3.IfcEvaporativeCoolerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3390157468: (ID, a) => new IFC2X3.IfcEvaporatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  807026263: (ID, a) => new IFC2X3.IfcFacetedBrep(ID, a[0]),
  3737207727: (ID, a) => new IFC2X3.IfcFacetedBrepWithVoids(ID, a[0], a[1]),
  647756555: (ID, a) => new IFC2X3.IfcFastener(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2489546625: (ID, a) => new IFC2X3.IfcFastenerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2827207264: (ID, a) => new IFC2X3.IfcFeatureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2143335405: (ID, a) => new IFC2X3.IfcFeatureElementAddition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1287392070: (ID, a) => new IFC2X3.IfcFeatureElementSubtraction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3907093117: (ID, a) => new IFC2X3.IfcFlowControllerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3198132628: (ID, a) => new IFC2X3.IfcFlowFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3815607619: (ID, a) => new IFC2X3.IfcFlowMeterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1482959167: (ID, a) => new IFC2X3.IfcFlowMovingDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1834744321: (ID, a) => new IFC2X3.IfcFlowSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1339347760: (ID, a) => new IFC2X3.IfcFlowStorageDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2297155007: (ID, a) => new IFC2X3.IfcFlowTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3009222698: (ID, a) => new IFC2X3.IfcFlowTreatmentDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  263784265: (ID, a) => new IFC2X3.IfcFurnishingElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  814719939: (ID, a) => new IFC2X3.IfcFurnitureStandard(ID, a[0], a[1], a[2], a[3], a[4]),
  200128114: (ID, a) => new IFC2X3.IfcGasTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3009204131: (ID, a) => new IFC2X3.IfcGrid(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2706460486: (ID, a) => new IFC2X3.IfcGroup(ID, a[0], a[1], a[2], a[3], a[4]),
  1251058090: (ID, a) => new IFC2X3.IfcHeatExchangerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1806887404: (ID, a) => new IFC2X3.IfcHumidifierType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2391368822: (ID, a) => new IFC2X3.IfcInventory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4288270099: (ID, a) => new IFC2X3.IfcJunctionBoxType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3827777499: (ID, a) => new IFC2X3.IfcLaborResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1051575348: (ID, a) => new IFC2X3.IfcLampType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1161773419: (ID, a) => new IFC2X3.IfcLightFixtureType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2506943328: (ID, a) => new IFC2X3.IfcLinearDimension(ID, a[0]),
  377706215: (ID, a) => new IFC2X3.IfcMechanicalFastener(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2108223431: (ID, a) => new IFC2X3.IfcMechanicalFastenerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3181161470: (ID, a) => new IFC2X3.IfcMemberType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  977012517: (ID, a) => new IFC2X3.IfcMotorConnectionType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1916936684: (ID, a) => new IFC2X3.IfcMove(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  4143007308: (ID, a) => new IFC2X3.IfcOccupant(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3588315303: (ID, a) => new IFC2X3.IfcOpeningElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3425660407: (ID, a) => new IFC2X3.IfcOrderAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2837617999: (ID, a) => new IFC2X3.IfcOutletType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2382730787: (ID, a) => new IFC2X3.IfcPerformanceHistory(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3327091369: (ID, a) => new IFC2X3.IfcPermit(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  804291784: (ID, a) => new IFC2X3.IfcPipeFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4231323485: (ID, a) => new IFC2X3.IfcPipeSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4017108033: (ID, a) => new IFC2X3.IfcPlateType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3724593414: (ID, a) => new IFC2X3.IfcPolyline(ID, a[0]),
  3740093272: (ID, a) => new IFC2X3.IfcPort(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2744685151: (ID, a) => new IFC2X3.IfcProcedure(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2904328755: (ID, a) => new IFC2X3.IfcProjectOrder(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3642467123: (ID, a) => new IFC2X3.IfcProjectOrderRecord(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3651124850: (ID, a) => new IFC2X3.IfcProjectionElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1842657554: (ID, a) => new IFC2X3.IfcProtectiveDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2250791053: (ID, a) => new IFC2X3.IfcPumpType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3248260540: (ID, a) => new IFC2X3.IfcRadiusDimension(ID, a[0]),
  2893384427: (ID, a) => new IFC2X3.IfcRailingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2324767716: (ID, a) => new IFC2X3.IfcRampFlightType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  160246688: (ID, a) => new IFC2X3.IfcRelAggregates(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2863920197: (ID, a) => new IFC2X3.IfcRelAssignsTasks(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1768891740: (ID, a) => new IFC2X3.IfcSanitaryTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3517283431: (ID, a) => new IFC2X3.IfcScheduleTimeControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20], a[21], a[22]),
  4105383287: (ID, a) => new IFC2X3.IfcServiceLife(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  4097777520: (ID, a) => new IFC2X3.IfcSite(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  2533589738: (ID, a) => new IFC2X3.IfcSlabType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3856911033: (ID, a) => new IFC2X3.IfcSpace(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1305183839: (ID, a) => new IFC2X3.IfcSpaceHeaterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  652456506: (ID, a) => new IFC2X3.IfcSpaceProgram(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3812236995: (ID, a) => new IFC2X3.IfcSpaceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3112655638: (ID, a) => new IFC2X3.IfcStackTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1039846685: (ID, a) => new IFC2X3.IfcStairFlightType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  682877961: (ID, a) => new IFC2X3.IfcStructuralAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1179482911: (ID, a) => new IFC2X3.IfcStructuralConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4243806635: (ID, a) => new IFC2X3.IfcStructuralCurveConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  214636428: (ID, a) => new IFC2X3.IfcStructuralCurveMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2445595289: (ID, a) => new IFC2X3.IfcStructuralCurveMemberVarying(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1807405624: (ID, a) => new IFC2X3.IfcStructuralLinearAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1721250024: (ID, a) => new IFC2X3.IfcStructuralLinearActionVarying(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  1252848954: (ID, a) => new IFC2X3.IfcStructuralLoadGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1621171031: (ID, a) => new IFC2X3.IfcStructuralPlanarAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  3987759626: (ID, a) => new IFC2X3.IfcStructuralPlanarActionVarying(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  2082059205: (ID, a) => new IFC2X3.IfcStructuralPointAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  734778138: (ID, a) => new IFC2X3.IfcStructuralPointConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1235345126: (ID, a) => new IFC2X3.IfcStructuralPointReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2986769608: (ID, a) => new IFC2X3.IfcStructuralResultGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1975003073: (ID, a) => new IFC2X3.IfcStructuralSurfaceConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  148013059: (ID, a) => new IFC2X3.IfcSubContractResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2315554128: (ID, a) => new IFC2X3.IfcSwitchingDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2254336722: (ID, a) => new IFC2X3.IfcSystem(ID, a[0], a[1], a[2], a[3], a[4]),
  5716631: (ID, a) => new IFC2X3.IfcTankType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1637806684: (ID, a) => new IFC2X3.IfcTimeSeriesSchedule(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1692211062: (ID, a) => new IFC2X3.IfcTransformerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1620046519: (ID, a) => new IFC2X3.IfcTransportElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3593883385: (ID, a) => new IFC2X3.IfcTrimmedCurve(ID, a[0], a[1], a[2], a[3], a[4]),
  1600972822: (ID, a) => new IFC2X3.IfcTubeBundleType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1911125066: (ID, a) => new IFC2X3.IfcUnitaryEquipmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  728799441: (ID, a) => new IFC2X3.IfcValveType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2769231204: (ID, a) => new IFC2X3.IfcVirtualElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1898987631: (ID, a) => new IFC2X3.IfcWallType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1133259667: (ID, a) => new IFC2X3.IfcWasteTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1028945134: (ID, a) => new IFC2X3.IfcWorkControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
  4218914973: (ID, a) => new IFC2X3.IfcWorkPlan(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
  3342526732: (ID, a) => new IFC2X3.IfcWorkSchedule(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
  1033361043: (ID, a) => new IFC2X3.IfcZone(ID, a[0], a[1], a[2], a[3], a[4]),
  1213861670: (ID, a) => new IFC2X3.Ifc2DCompositeCurve(ID, a[0], a[1]),
  3821786052: (ID, a) => new IFC2X3.IfcActionRequest(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1411407467: (ID, a) => new IFC2X3.IfcAirTerminalBoxType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3352864051: (ID, a) => new IFC2X3.IfcAirTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1871374353: (ID, a) => new IFC2X3.IfcAirToAirHeatRecoveryType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2470393545: (ID, a) => new IFC2X3.IfcAngularDimension(ID, a[0]),
  3460190687: (ID, a) => new IFC2X3.IfcAsset(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  1967976161: (ID, a) => new IFC2X3.IfcBSplineCurve(ID, a[0], a[1], a[2], a[3], a[4]),
  819618141: (ID, a) => new IFC2X3.IfcBeamType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1916977116: (ID, a) => new IFC2X3.IfcBezierCurve(ID, a[0], a[1], a[2], a[3], a[4]),
  231477066: (ID, a) => new IFC2X3.IfcBoilerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3299480353: (ID, a) => new IFC2X3.IfcBuildingElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  52481810: (ID, a) => new IFC2X3.IfcBuildingElementComponent(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2979338954: (ID, a) => new IFC2X3.IfcBuildingElementPart(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1095909175: (ID, a) => new IFC2X3.IfcBuildingElementProxy(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1909888760: (ID, a) => new IFC2X3.IfcBuildingElementProxyType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  395041908: (ID, a) => new IFC2X3.IfcCableCarrierFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3293546465: (ID, a) => new IFC2X3.IfcCableCarrierSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1285652485: (ID, a) => new IFC2X3.IfcCableSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2951183804: (ID, a) => new IFC2X3.IfcChillerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2611217952: (ID, a) => new IFC2X3.IfcCircle(ID, a[0], a[1]),
  2301859152: (ID, a) => new IFC2X3.IfcCoilType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  843113511: (ID, a) => new IFC2X3.IfcColumn(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3850581409: (ID, a) => new IFC2X3.IfcCompressorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2816379211: (ID, a) => new IFC2X3.IfcCondenserType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2188551683: (ID, a) => new IFC2X3.IfcCondition(ID, a[0], a[1], a[2], a[3], a[4]),
  1163958913: (ID, a) => new IFC2X3.IfcConditionCriterion(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3898045240: (ID, a) => new IFC2X3.IfcConstructionEquipmentResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1060000209: (ID, a) => new IFC2X3.IfcConstructionMaterialResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  488727124: (ID, a) => new IFC2X3.IfcConstructionProductResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  335055490: (ID, a) => new IFC2X3.IfcCooledBeamType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2954562838: (ID, a) => new IFC2X3.IfcCoolingTowerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1973544240: (ID, a) => new IFC2X3.IfcCovering(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3495092785: (ID, a) => new IFC2X3.IfcCurtainWall(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3961806047: (ID, a) => new IFC2X3.IfcDamperType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4147604152: (ID, a) => new IFC2X3.IfcDiameterDimension(ID, a[0]),
  1335981549: (ID, a) => new IFC2X3.IfcDiscreteAccessory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2635815018: (ID, a) => new IFC2X3.IfcDiscreteAccessoryType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1599208980: (ID, a) => new IFC2X3.IfcDistributionChamberElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2063403501: (ID, a) => new IFC2X3.IfcDistributionControlElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1945004755: (ID, a) => new IFC2X3.IfcDistributionElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3040386961: (ID, a) => new IFC2X3.IfcDistributionFlowElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3041715199: (ID, a) => new IFC2X3.IfcDistributionPort(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  395920057: (ID, a) => new IFC2X3.IfcDoor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  869906466: (ID, a) => new IFC2X3.IfcDuctFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3760055223: (ID, a) => new IFC2X3.IfcDuctSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2030761528: (ID, a) => new IFC2X3.IfcDuctSilencerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  855621170: (ID, a) => new IFC2X3.IfcEdgeFeature(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  663422040: (ID, a) => new IFC2X3.IfcElectricApplianceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3277789161: (ID, a) => new IFC2X3.IfcElectricFlowStorageDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1534661035: (ID, a) => new IFC2X3.IfcElectricGeneratorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1365060375: (ID, a) => new IFC2X3.IfcElectricHeaterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1217240411: (ID, a) => new IFC2X3.IfcElectricMotorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  712377611: (ID, a) => new IFC2X3.IfcElectricTimeControlType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1634875225: (ID, a) => new IFC2X3.IfcElectricalCircuit(ID, a[0], a[1], a[2], a[3], a[4]),
  857184966: (ID, a) => new IFC2X3.IfcElectricalElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1658829314: (ID, a) => new IFC2X3.IfcEnergyConversionDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  346874300: (ID, a) => new IFC2X3.IfcFanType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1810631287: (ID, a) => new IFC2X3.IfcFilterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4222183408: (ID, a) => new IFC2X3.IfcFireSuppressionTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2058353004: (ID, a) => new IFC2X3.IfcFlowController(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4278956645: (ID, a) => new IFC2X3.IfcFlowFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4037862832: (ID, a) => new IFC2X3.IfcFlowInstrumentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3132237377: (ID, a) => new IFC2X3.IfcFlowMovingDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  987401354: (ID, a) => new IFC2X3.IfcFlowSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  707683696: (ID, a) => new IFC2X3.IfcFlowStorageDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2223149337: (ID, a) => new IFC2X3.IfcFlowTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3508470533: (ID, a) => new IFC2X3.IfcFlowTreatmentDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  900683007: (ID, a) => new IFC2X3.IfcFooting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1073191201: (ID, a) => new IFC2X3.IfcMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1687234759: (ID, a) => new IFC2X3.IfcPile(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3171933400: (ID, a) => new IFC2X3.IfcPlate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2262370178: (ID, a) => new IFC2X3.IfcRailing(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3024970846: (ID, a) => new IFC2X3.IfcRamp(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3283111854: (ID, a) => new IFC2X3.IfcRampFlight(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3055160366: (ID, a) => new IFC2X3.IfcRationalBezierCurve(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3027567501: (ID, a) => new IFC2X3.IfcReinforcingElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2320036040: (ID, a) => new IFC2X3.IfcReinforcingMesh(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  2016517767: (ID, a) => new IFC2X3.IfcRoof(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1376911519: (ID, a) => new IFC2X3.IfcRoundedEdgeFeature(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1783015770: (ID, a) => new IFC2X3.IfcSensorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1529196076: (ID, a) => new IFC2X3.IfcSlab(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  331165859: (ID, a) => new IFC2X3.IfcStair(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4252922144: (ID, a) => new IFC2X3.IfcStairFlight(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2515109513: (ID, a) => new IFC2X3.IfcStructuralAnalysisModel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3824725483: (ID, a) => new IFC2X3.IfcTendon(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  2347447852: (ID, a) => new IFC2X3.IfcTendonAnchor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3313531582: (ID, a) => new IFC2X3.IfcVibrationIsolatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2391406946: (ID, a) => new IFC2X3.IfcWall(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3512223829: (ID, a) => new IFC2X3.IfcWallStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3304561284: (ID, a) => new IFC2X3.IfcWindow(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2874132201: (ID, a) => new IFC2X3.IfcActuatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3001207471: (ID, a) => new IFC2X3.IfcAlarmType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  753842376: (ID, a) => new IFC2X3.IfcBeam(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2454782716: (ID, a) => new IFC2X3.IfcChamferEdgeFeature(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  578613899: (ID, a) => new IFC2X3.IfcControllerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1052013943: (ID, a) => new IFC2X3.IfcDistributionChamberElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1062813311: (ID, a) => new IFC2X3.IfcDistributionControlElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3700593921: (ID, a) => new IFC2X3.IfcElectricDistributionPoint(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  979691226: (ID, a) => new IFC2X3.IfcReinforcingBar(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13])
};
ToRawLineData[1] = {
  3630933823: (i) => [i.Role, i.UserDefinedRole, i.Description],
  618182010: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose],
  639542469: (i) => [i.ApplicationDeveloper, i.Version, i.ApplicationFullName, i.ApplicationIdentifier],
  411424972: (i) => [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate],
  1110488051: (i) => [i.ComponentOfTotal, i.Components, i.ArithmeticOperator, i.Name, i.Description],
  130549933: (i) => [i.Description, i.ApprovalDateTime, i.ApprovalStatus, i.ApprovalLevel, i.ApprovalQualifier, i.Name, i.Identifier],
  2080292479: (i) => [i.Actor, i.Approval, i.Role],
  390851274: (i) => [i.ApprovedProperties, i.Approval],
  3869604511: (i) => [i.RelatedApproval, i.RelatingApproval, i.Description, i.Name],
  4037036970: (i) => [i.Name],
  1560379544: (i) => [i.Name, i.LinearStiffnessByLengthX, i.LinearStiffnessByLengthY, i.LinearStiffnessByLengthZ, i.RotationalStiffnessByLengthX, i.RotationalStiffnessByLengthY, i.RotationalStiffnessByLengthZ],
  3367102660: (i) => [i.Name, i.LinearStiffnessByAreaX, i.LinearStiffnessByAreaY, i.LinearStiffnessByAreaZ],
  1387855156: (i) => [i.Name, i.LinearStiffnessX, i.LinearStiffnessY, i.LinearStiffnessZ, i.RotationalStiffnessX, i.RotationalStiffnessY, i.RotationalStiffnessZ],
  2069777674: (i) => [i.Name, i.LinearStiffnessX, i.LinearStiffnessY, i.LinearStiffnessZ, i.RotationalStiffnessX, i.RotationalStiffnessY, i.RotationalStiffnessZ, i.WarpingStiffness],
  622194075: (i) => [i.DayComponent, i.MonthComponent, i.YearComponent],
  747523909: (i) => [i.Source, i.Edition, i.EditionDate, i.Name],
  1767535486: (i) => [i.Notation, i.ItemOf, i.Title],
  1098599126: (i) => [i.RelatingItem, i.RelatedItems],
  938368621: (i) => [i.NotationFacets],
  3639012971: (i) => [i.NotationValue],
  3264961684: (i) => [i.Name],
  2859738748: (_) => [],
  2614616156: (i) => [i.PointOnRelatingElement, i.PointOnRelatedElement],
  4257277454: (i) => [i.LocationAtRelatingElement, i.LocationAtRelatedElement, i.ProfileOfPort],
  2732653382: (i) => [i.SurfaceOnRelatingElement, i.SurfaceOnRelatedElement],
  1959218052: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade],
  1658513725: (i) => [i.Name, i.Description, i.RelatingConstraint, i.RelatedConstraints, i.LogicalAggregator],
  613356794: (i) => [i.ClassifiedConstraint, i.RelatedClassifications],
  347226245: (i) => [i.Name, i.Description, i.RelatingConstraint, i.RelatedConstraints],
  1065062679: (i) => [i.HourOffset, i.MinuteOffset, i.Sense],
  602808272: (i) => [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.CostType, i.Condition],
  539742890: (i) => [i.RelatingMonetaryUnit, i.RelatedMonetaryUnit, i.ExchangeRate, i.RateDateTime, i.RateSource],
  1105321065: (i) => [i.Name, i.PatternList],
  2367409068: (i) => [i.Name, i.CurveFont, i.CurveFontScaling],
  3510044353: (i) => [i.VisibleSegmentLength, i.InvisibleSegmentLength],
  1072939445: (i) => [i.DateComponent, i.TimeComponent],
  1765591967: (i) => [i.Elements, i.UnitType, i.UserDefinedType],
  1045800335: (i) => [i.Unit, i.Exponent],
  2949456006: (i) => [i.LengthExponent, i.MassExponent, i.TimeExponent, i.ElectricCurrentExponent, i.ThermodynamicTemperatureExponent, i.AmountOfSubstanceExponent, i.LuminousIntensityExponent],
  1376555844: (i) => [i.FileExtension, i.MimeContentType, i.MimeSubtype],
  1154170062: (i) => [i.DocumentId, i.Name, i.Description, i.DocumentReferences, i.Purpose, i.IntendedUse, i.Scope, i.Revision, i.DocumentOwner, i.Editors, i.CreationTime, i.LastRevisionTime, i.ElectronicFormat, i.ValidFrom, i.ValidUntil, i.Confidentiality, i.Status],
  770865208: (i) => [i.RelatingDocument, i.RelatedDocuments, i.RelationshipType],
  3796139169: (i) => [i.Name, i.Description, i.RelatingDraughtingCallout, i.RelatedDraughtingCallout],
  1648886627: (i) => [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.ImpactType, i.Category, i.UserDefinedCategory],
  3200245327: (i) => [i.Location, i.ItemReference, i.Name],
  2242383968: (i) => [i.Location, i.ItemReference, i.Name],
  1040185647: (i) => [i.Location, i.ItemReference, i.Name],
  3207319532: (i) => [i.Location, i.ItemReference, i.Name],
  3548104201: (i) => [i.Location, i.ItemReference, i.Name],
  852622518: (i) => [i.AxisTag, i.AxisCurve, i.SameSense],
  3020489413: (i) => [i.TimeStamp, i.ListValues.map((p) => Labelise(p))],
  2655187982: (i) => [i.Name, i.Version, i.Publisher, i.VersionDate, i.LibraryReference],
  3452421091: (i) => [i.Location, i.ItemReference, i.Name],
  4162380809: (i) => [i.MainPlaneAngle, i.SecondaryPlaneAngle, i.LuminousIntensity],
  1566485204: (i) => [i.LightDistributionCurve, i.DistributionData],
  30780891: (i) => [i.HourComponent, i.MinuteComponent, i.SecondComponent, i.Zone, i.DaylightSavingOffset],
  1838606355: (i) => [i.Name],
  1847130766: (i) => [i.MaterialClassifications, i.ClassifiedMaterial],
  248100487: (i) => [i.Material, i.LayerThickness, i.IsVentilated],
  3303938423: (i) => [i.MaterialLayers, i.LayerSetName],
  1303795690: (i) => [i.ForLayerSet, i.LayerSetDirection, i.DirectionSense, i.OffsetFromReferenceLine],
  2199411900: (i) => [i.Materials],
  3265635763: (i) => [i.Material],
  2597039031: (i) => [Labelise(i.ValueComponent), i.UnitComponent],
  4256014907: (i) => [i.Material, i.DynamicViscosity, i.YoungModulus, i.ShearModulus, i.PoissonRatio, i.ThermalExpansionCoefficient],
  677618848: (i) => [i.Material, i.DynamicViscosity, i.YoungModulus, i.ShearModulus, i.PoissonRatio, i.ThermalExpansionCoefficient, i.YieldStress, i.UltimateStress, i.UltimateStrain, i.HardeningModule, i.ProportionalStress, i.PlasticStrain, i.Relaxations],
  3368373690: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.Benchmark, i.ValueSource, i.DataValue],
  2706619895: (i) => [i.Currency],
  1918398963: (i) => [i.Dimensions, i.UnitType],
  3701648758: (_) => [],
  2251480897: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.BenchmarkValues, i.ResultValues, i.ObjectiveQualifier, i.UserDefinedQualifier],
  1227763645: (i) => [i.Material, i.VisibleTransmittance, i.SolarTransmittance, i.ThermalIrTransmittance, i.ThermalIrEmissivityBack, i.ThermalIrEmissivityFront, i.VisibleReflectanceBack, i.VisibleReflectanceFront, i.SolarReflectanceFront, i.SolarReflectanceBack],
  4251960020: (i) => [i.Id, i.Name, i.Description, i.Roles, i.Addresses],
  1411181986: (i) => [i.Name, i.Description, i.RelatingOrganization, i.RelatedOrganizations],
  1207048766: (i) => [i.OwningUser, i.OwningApplication, i.State, i.ChangeAction, i.LastModifiedDate, i.LastModifyingUser, i.LastModifyingApplication, i.CreationDate],
  2077209135: (i) => [i.Id, i.FamilyName, i.GivenName, i.MiddleNames, i.PrefixTitles, i.SuffixTitles, i.Roles, i.Addresses],
  101040310: (i) => [i.ThePerson, i.TheOrganization, i.Roles],
  2483315170: (i) => [i.Name, i.Description],
  2226359599: (i) => [i.Name, i.Description, i.Unit],
  3355820592: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose, i.InternalLocation, i.AddressLines, i.PostalBox, i.Town, i.Region, i.PostalCode, i.Country],
  3727388367: (i) => [i.Name],
  990879717: (i) => [i.Name],
  3213052703: (i) => [i.Name],
  1775413392: (i) => [i.Name],
  2022622350: (i) => [i.Name, i.Description, i.AssignedItems, i.Identifier],
  1304840413: (i) => [i.Name, i.Description, i.AssignedItems, i.Identifier, i.LayerOn, i.LayerFrozen, i.LayerBlocked, i.LayerStyles],
  3119450353: (i) => [i.Name],
  2417041796: (i) => [i.Styles],
  2095639259: (i) => [i.Name, i.Description, i.Representations],
  2267347899: (i) => [i.Material, i.SpecificHeatCapacity, i.N20Content, i.COContent, i.CO2Content],
  3958567839: (i) => [i.ProfileType, i.ProfileName],
  2802850158: (i) => [i.ProfileName, i.ProfileDefinition],
  2598011224: (i) => [i.Name, i.Description],
  3896028662: (i) => [i.RelatingConstraint, i.RelatedProperties, i.Name, i.Description],
  148025276: (i) => [i.DependingProperty, i.DependantProperty, i.Name, i.Description, i.Expression],
  3710013099: (i) => [i.Name, i.EnumerationValues.map((p) => Labelise(p)), i.Unit],
  2044713172: (i) => [i.Name, i.Description, i.Unit, i.AreaValue],
  2093928680: (i) => [i.Name, i.Description, i.Unit, i.CountValue],
  931644368: (i) => [i.Name, i.Description, i.Unit, i.LengthValue],
  3252649465: (i) => [i.Name, i.Description, i.Unit, i.TimeValue],
  2405470396: (i) => [i.Name, i.Description, i.Unit, i.VolumeValue],
  825690147: (i) => [i.Name, i.Description, i.Unit, i.WeightValue],
  2692823254: (i) => [i.ReferencedDocument, i.ReferencingValues, i.Name, i.Description],
  1580146022: (i) => [i.TotalCrossSectionArea, i.SteelGrade, i.BarSurface, i.EffectiveDepth, i.NominalBarDiameter, i.BarCount],
  1222501353: (i) => [i.RelaxationValue, i.InitialStress],
  1076942058: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  3377609919: (i) => [i.ContextIdentifier, i.ContextType],
  3008791417: (_) => [],
  1660063152: (i) => [i.MappingOrigin, i.MappedRepresentation],
  3679540991: (i) => [i.ProfileName, i.ProfileDefinition, i.Thickness, i.RibHeight, i.RibWidth, i.RibSpacing, i.Direction],
  2341007311: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  448429030: (i) => [i.Dimensions, i.UnitType, i.Prefix, i.Name],
  2042790032: (i) => [i.SectionType, i.StartProfile, i.EndProfile],
  4165799628: (i) => [i.LongitudinalStartPosition, i.LongitudinalEndPosition, i.TransversePosition, i.ReinforcementRole, i.SectionDefinition, i.CrossSectionReinforcementDefinitions],
  867548509: (i) => [i.ShapeRepresentations, i.Name, i.Description, i.ProductDefinitional, i.PartOfProductDefinitionShape],
  3982875396: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  4240577450: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  3692461612: (i) => [i.Name, i.Description],
  2273995522: (i) => [i.Name],
  2162789131: (i) => [i.Name],
  2525727697: (i) => [i.Name],
  3408363356: (i) => [i.Name, i.DeltaT_Constant, i.DeltaT_Y, i.DeltaT_Z],
  2830218821: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  3958052878: (i) => [i.Item, i.Styles, i.Name],
  3049322572: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  1300840506: (i) => [i.Name, i.Side, i.Styles],
  3303107099: (i) => [i.DiffuseTransmissionColour, i.DiffuseReflectionColour, i.TransmissionColour, i.ReflectanceColour],
  1607154358: (i) => [i.RefractionIndex, i.DispersionFactor],
  846575682: (i) => [i.SurfaceColour],
  1351298697: (i) => [i.Textures],
  626085974: (i) => [i.RepeatS, i.RepeatT, i.TextureType, i.TextureTransform],
  1290481447: (i) => [i.Name, Labelise(i.StyleOfSymbol)],
  985171141: (i) => [i.Name, i.Rows],
  531007025: (i) => [i.RowCells.map((p) => Labelise(p)), i.IsHeading],
  912023232: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose, i.TelephoneNumbers, i.FacsimileNumbers, i.PagerNumber, i.ElectronicMailAddresses, i.WWWHomePageURL],
  1447204868: (i) => [i.Name, i.TextCharacterAppearance, i.TextStyle, i.TextFontStyle],
  1983826977: (i) => [i.Name, i.FontFamily, i.FontStyle, i.FontVariant, i.FontWeight, Labelise(i.FontSize)],
  2636378356: (i) => [i.Colour, i.BackgroundColour],
  1640371178: (i) => [!i.TextIndent ? null : Labelise(i.TextIndent), i.TextAlign, i.TextDecoration, !i.LetterSpacing ? null : Labelise(i.LetterSpacing), !i.WordSpacing ? null : Labelise(i.WordSpacing), i.TextTransform, !i.LineHeight ? null : Labelise(i.LineHeight)],
  1484833681: (i) => [i.BoxHeight, i.BoxWidth, i.BoxSlantAngle, i.BoxRotateAngle, !i.CharacterSpacing ? null : Labelise(i.CharacterSpacing)],
  280115917: (_) => [],
  1742049831: (i) => [i.Mode, i.Parameter.map((p) => Labelise(p))],
  2552916305: (i) => [i.TextureMaps],
  1210645708: (i) => [i.Coordinates],
  3317419933: (i) => [i.Material, i.SpecificHeatCapacity, i.BoilingPoint, i.FreezingPoint, i.ThermalConductivity],
  3101149627: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit],
  1718945513: (i) => [i.ReferencedTimeSeries, i.TimeSeriesReferences],
  581633288: (i) => [i.ListValues.map((p) => Labelise(p))],
  1377556343: (_) => [],
  1735638870: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  180925521: (i) => [i.Units],
  2799835756: (_) => [],
  3304826586: (i) => [i.TextureVertices, i.TexturePoints],
  1907098498: (i) => [i.VertexGeometry],
  891718957: (i) => [i.IntersectingAxes, i.OffsetDistances],
  1065908215: (i) => [i.Material, i.IsPotable, i.Hardness, i.AlkalinityConcentration, i.AcidityConcentration, i.ImpuritiesContent, i.PHLevel, i.DissolvedSolidsContent],
  2442683028: (i) => [i.Item, i.Styles, i.Name],
  962685235: (i) => [i.Item, i.Styles, i.Name],
  3612888222: (i) => [i.Item, i.Styles, i.Name],
  2297822566: (i) => [i.Item, i.Styles, i.Name],
  3798115385: (i) => [i.ProfileType, i.ProfileName, i.OuterCurve],
  1310608509: (i) => [i.ProfileType, i.ProfileName, i.Curve],
  2705031697: (i) => [i.ProfileType, i.ProfileName, i.OuterCurve, i.InnerCurves],
  616511568: (i) => [i.RepeatS, i.RepeatT, i.TextureType, i.TextureTransform, i.RasterFormat, i.RasterCode],
  3150382593: (i) => [i.ProfileType, i.ProfileName, i.Curve, i.Thickness],
  647927063: (i) => [i.Location, i.ItemReference, i.Name, i.ReferencedSource],
  776857604: (i) => [i.Name, i.Red, i.Green, i.Blue],
  2542286263: (i) => [i.Name, i.Description, i.UsageName, i.HasProperties],
  1485152156: (i) => [i.ProfileType, i.ProfileName, i.Profiles, i.Label],
  370225590: (i) => [i.CfsFaces],
  1981873012: (i) => [i.CurveOnRelatingElement, i.CurveOnRelatedElement],
  45288368: (i) => [i.PointOnRelatingElement, i.PointOnRelatedElement, i.EccentricityInX, i.EccentricityInY, i.EccentricityInZ],
  3050246964: (i) => [i.Dimensions, i.UnitType, i.Name],
  2889183280: (i) => [i.Dimensions, i.UnitType, i.Name, i.ConversionFactor],
  3800577675: (i) => [i.Name, i.CurveFont, !i.CurveWidth ? null : Labelise(i.CurveWidth), i.CurveColour],
  3632507154: (i) => [i.ProfileType, i.ProfileName, i.ParentProfile, i.Operator, i.Label],
  2273265877: (i) => [i.Name, i.Description, i.RelatingDraughtingCallout, i.RelatedDraughtingCallout],
  1694125774: (i) => [i.Name, i.Description, i.RelatingDraughtingCallout, i.RelatedDraughtingCallout],
  3732053477: (i) => [i.Location, i.ItemReference, i.Name],
  4170525392: (i) => [i.Name],
  3900360178: (i) => [i.EdgeStart, i.EdgeEnd],
  476780140: (i) => [i.EdgeStart, i.EdgeEnd, i.EdgeGeometry, i.SameSense],
  1860660968: (i) => [i.Material, i.ExtendedProperties, i.Description, i.Name],
  2556980723: (i) => [i.Bounds],
  1809719519: (i) => [i.Bound, i.Orientation],
  803316827: (i) => [i.Bound, i.Orientation],
  3008276851: (i) => [i.Bounds, i.FaceSurface, i.SameSense],
  4219587988: (i) => [i.Name, i.TensionFailureX, i.TensionFailureY, i.TensionFailureZ, i.CompressionFailureX, i.CompressionFailureY, i.CompressionFailureZ],
  738692330: (i) => [i.Name, i.FillStyles],
  3857492461: (i) => [i.Material, i.CombustionTemperature, i.CarbonContent, i.LowerHeatingValue, i.HigherHeatingValue],
  803998398: (i) => [i.Material, i.MolecularWeight, i.Porosity, i.MassDensity],
  1446786286: (i) => [i.ProfileName, i.ProfileDefinition, i.PhysicalWeight, i.Perimeter, i.MinimumPlateThickness, i.MaximumPlateThickness, i.CrossSectionArea],
  3448662350: (i) => [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth],
  2453401579: (_) => [],
  4142052618: (i) => [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth, i.ParentContext, i.TargetScale, i.TargetView, i.UserDefinedTargetView],
  3590301190: (i) => [i.Elements],
  178086475: (i) => [i.PlacementLocation, i.PlacementRefDirection],
  812098782: (i) => [i.BaseSurface, i.AgreementFlag],
  2445078500: (i) => [i.Material, i.UpperVaporResistanceFactor, i.LowerVaporResistanceFactor, i.IsothermalMoistureCapacity, i.VaporPermeability, i.MoistureDiffusivity],
  3905492369: (i) => [i.RepeatS, i.RepeatT, i.TextureType, i.TextureTransform, i.UrlReference],
  3741457305: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.Values],
  1402838566: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity],
  125510826: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity],
  2604431987: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Orientation],
  4266656042: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.ColourAppearance, i.ColourTemperature, i.LuminousFlux, i.LightEmissionSource, i.LightDistributionDataSource],
  1520743889: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation],
  3422422726: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation, i.Orientation, i.ConcentrationExponent, i.SpreadAngle, i.BeamWidthAngle],
  2624227202: (i) => [i.PlacementRelTo, i.RelativePlacement],
  1008929658: (_) => [],
  2347385850: (i) => [i.MappingSource, i.MappingTarget],
  2022407955: (i) => [i.Name, i.Description, i.Representations, i.RepresentedMaterial],
  1430189142: (i) => [i.Material, i.DynamicViscosity, i.YoungModulus, i.ShearModulus, i.PoissonRatio, i.ThermalExpansionCoefficient, i.CompressiveStrength, i.MaxAggregateSize, i.AdmixturesDescription, i.Workability, i.ProtectivePoreRatio, i.WaterImpermeability],
  219451334: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  2833995503: (i) => [i.RepeatFactor],
  2665983363: (i) => [i.CfsFaces],
  1029017970: (i) => [i.EdgeStart, i.EdgeEnd, i.EdgeElement, i.Orientation],
  2529465313: (i) => [i.ProfileType, i.ProfileName, i.Position],
  2519244187: (i) => [i.EdgeList],
  3021840470: (i) => [i.Name, i.Description, i.HasQuantities, i.Discrimination, i.Quality, i.Usage],
  597895409: (i) => [i.RepeatS, i.RepeatT, i.TextureType, i.TextureTransform, i.Width, i.Height, i.ColourComponents, i.Pixel],
  2004835150: (i) => [i.Location],
  1663979128: (i) => [i.SizeInX, i.SizeInY],
  2067069095: (_) => [],
  4022376103: (i) => [i.BasisCurve, i.PointParameter],
  1423911732: (i) => [i.BasisSurface, i.PointParameterU, i.PointParameterV],
  2924175390: (i) => [i.Polygon],
  2775532180: (i) => [i.BaseSurface, i.AgreementFlag, i.Position, i.PolygonalBoundary],
  759155922: (i) => [i.Name],
  2559016684: (i) => [i.Name],
  433424934: (i) => [i.Name],
  179317114: (i) => [i.Name],
  673634403: (i) => [i.Name, i.Description, i.Representations],
  871118103: (i) => [i.Name, i.Description, !i.UpperBoundValue ? null : Labelise(i.UpperBoundValue), !i.LowerBoundValue ? null : Labelise(i.LowerBoundValue), i.Unit],
  1680319473: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  4166981789: (i) => [i.Name, i.Description, i.EnumerationValues.map((p) => Labelise(p)), i.EnumerationReference],
  2752243245: (i) => [i.Name, i.Description, i.ListValues.map((p) => Labelise(p)), i.Unit],
  941946838: (i) => [i.Name, i.Description, i.UsageName, i.PropertyReference],
  3357820518: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  3650150729: (i) => [i.Name, i.Description, !i.NominalValue ? null : Labelise(i.NominalValue), i.Unit],
  110355661: (i) => [i.Name, i.Description, i.DefiningValues.map((p) => Labelise(p)), i.DefinedValues.map((p) => Labelise(p)), i.Expression, i.DefiningUnit, i.DefinedUnit],
  3615266464: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim],
  3413951693: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.TimeStep, i.Values],
  3765753017: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.DefinitionType, i.ReinforcementSectionDefinitions],
  478536968: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  2778083089: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.RoundingRadius],
  1509187699: (i) => [i.SpineCurve, i.CrossSections, i.CrossSectionPositions],
  2411513650: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.PredefinedType, !i.UpperValue ? null : Labelise(i.UpperValue), Labelise(i.MostUsedValue), !i.LowerValue ? null : Labelise(i.LowerValue)],
  4124623270: (i) => [i.SbsmBoundary],
  2609359061: (i) => [i.Name, i.SlippageX, i.SlippageY, i.SlippageZ],
  723233188: (_) => [],
  2485662743: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.IsAttenuating, i.SoundScale, i.SoundValues],
  1202362311: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.SoundLevelTimeSeries, i.Frequency, !i.SoundLevelSingleValue ? null : Labelise(i.SoundLevelSingleValue)],
  390701378: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableValueRatio, i.ThermalLoadSource, i.PropertySource, i.SourceDescription, i.MaximumValue, i.MinimumValue, i.ThermalLoadTimeSeriesValues, i.UserDefinedThermalLoadSource, i.UserDefinedPropertySource, i.ThermalLoadType],
  1595516126: (i) => [i.Name, i.LinearForceX, i.LinearForceY, i.LinearForceZ, i.LinearMomentX, i.LinearMomentY, i.LinearMomentZ],
  2668620305: (i) => [i.Name, i.PlanarForceX, i.PlanarForceY, i.PlanarForceZ],
  2473145415: (i) => [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ],
  1973038258: (i) => [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ, i.Distortion],
  1597423693: (i) => [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ],
  1190533807: (i) => [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ, i.WarpingMoment],
  3843319758: (i) => [i.ProfileName, i.ProfileDefinition, i.PhysicalWeight, i.Perimeter, i.MinimumPlateThickness, i.MaximumPlateThickness, i.CrossSectionArea, i.TorsionalConstantX, i.MomentOfInertiaYZ, i.MomentOfInertiaY, i.MomentOfInertiaZ, i.WarpingConstant, i.ShearCentreZ, i.ShearCentreY, i.ShearDeformationAreaZ, i.ShearDeformationAreaY, i.MaximumSectionModulusY, i.MinimumSectionModulusY, i.MaximumSectionModulusZ, i.MinimumSectionModulusZ, i.TorsionalSectionModulus, i.CentreOfGravityInX, i.CentreOfGravityInY],
  3653947884: (i) => [i.ProfileName, i.ProfileDefinition, i.PhysicalWeight, i.Perimeter, i.MinimumPlateThickness, i.MaximumPlateThickness, i.CrossSectionArea, i.TorsionalConstantX, i.MomentOfInertiaYZ, i.MomentOfInertiaY, i.MomentOfInertiaZ, i.WarpingConstant, i.ShearCentreZ, i.ShearCentreY, i.ShearDeformationAreaZ, i.ShearDeformationAreaY, i.MaximumSectionModulusY, i.MinimumSectionModulusY, i.MaximumSectionModulusZ, i.MinimumSectionModulusZ, i.TorsionalSectionModulus, i.CentreOfGravityInX, i.CentreOfGravityInY, i.ShearAreaZ, i.ShearAreaY, i.PlasticShapeFactorY, i.PlasticShapeFactorZ],
  2233826070: (i) => [i.EdgeStart, i.EdgeEnd, i.ParentEdge],
  2513912981: (_) => [],
  1878645084: (i) => [i.SurfaceColour, i.Transparency, i.DiffuseColour, i.TransmissionColour, i.DiffuseTransmissionColour, i.ReflectionColour, i.SpecularColour, !i.SpecularHighlight ? null : Labelise(i.SpecularHighlight), i.ReflectanceMethod],
  2247615214: (i) => [i.SweptArea, i.Position],
  1260650574: (i) => [i.Directrix, i.Radius, i.InnerRadius, i.StartParam, i.EndParam],
  230924584: (i) => [i.SweptCurve, i.Position],
  3071757647: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.FlangeEdgeRadius, i.WebEdgeRadius, i.WebSlope, i.FlangeSlope, i.CentreOfGravityInY],
  3028897424: (i) => [i.Item, i.Styles, i.Name, i.AnnotatedCurve],
  4282788508: (i) => [i.Literal, i.Placement, i.Path],
  3124975700: (i) => [i.Literal, i.Placement, i.Path, i.Extent, i.BoxAlignment],
  2715220739: (i) => [i.ProfileType, i.ProfileName, i.Position, i.BottomXDim, i.TopXDim, i.YDim, i.TopXOffset],
  1345879162: (i) => [i.RepeatFactor, i.SecondRepeatFactor],
  1628702193: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets],
  2347495698: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag],
  427810014: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius, i.FlangeSlope, i.CentreOfGravityInX],
  1417489154: (i) => [i.Orientation, i.Magnitude],
  2759199220: (i) => [i.LoopVertex],
  336235671: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.TransomThickness, i.MullionThickness, i.FirstTransomOffset, i.SecondTransomOffset, i.FirstMullionOffset, i.SecondMullionOffset, i.ShapeAspectStyle],
  512836454: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle],
  1299126871: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ConstructionType, i.OperationType, i.ParameterTakesPrecedence, i.Sizeable],
  2543172580: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius],
  3288037868: (i) => [i.Item, i.Styles, i.Name],
  669184980: (i) => [i.OuterBoundary, i.InnerBoundaries],
  2265737646: (i) => [i.Item, i.Styles, i.Name, i.FillStyleTarget, i.GlobalOrLocal],
  1302238472: (i) => [i.Item, i.TextureCoordinates],
  4261334040: (i) => [i.Location, i.Axis],
  3125803723: (i) => [i.Location, i.RefDirection],
  2740243338: (i) => [i.Location, i.Axis, i.RefDirection],
  2736907675: (i) => [i.Operator, i.FirstOperand, i.SecondOperand],
  4182860854: (_) => [],
  2581212453: (i) => [i.Corner, i.XDim, i.YDim, i.ZDim],
  2713105998: (i) => [i.BaseSurface, i.AgreementFlag, i.Enclosure],
  2898889636: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.WallThickness, i.Girth, i.InternalFilletRadius, i.CentreOfGravityInX],
  1123145078: (i) => [i.Coordinates],
  59481748: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale],
  3749851601: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale],
  3486308946: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Scale2],
  3331915920: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3],
  1416205885: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3, i.Scale2, i.Scale3],
  1383045692: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Radius],
  2205249479: (i) => [i.CfsFaces],
  2485617015: (i) => [i.Transition, i.SameSense, i.ParentCurve],
  4133800736: (i) => [i.ProfileType, i.ProfileName, i.Position, i.OverallHeight, i.BaseWidth2, i.Radius, i.HeadWidth, i.HeadDepth2, i.HeadDepth3, i.WebThickness, i.BaseWidth4, i.BaseDepth1, i.BaseDepth2, i.BaseDepth3, i.CentreOfGravityInY],
  194851669: (i) => [i.ProfileType, i.ProfileName, i.Position, i.OverallHeight, i.HeadWidth, i.Radius, i.HeadDepth2, i.HeadDepth3, i.WebThickness, i.BaseDepth1, i.BaseDepth2, i.CentreOfGravityInY],
  2506170314: (i) => [i.Position],
  2147822146: (i) => [i.TreeRootExpression],
  2601014836: (_) => [],
  2827736869: (i) => [i.BasisSurface, i.OuterBoundary, i.InnerBoundaries],
  693772133: (i) => [i.Definition, i.Target],
  606661476: (i) => [i.Item, i.Styles, i.Name],
  4054601972: (i) => [i.Item, i.Styles, i.Name, i.AnnotatedCurve, i.Role],
  32440307: (i) => [i.DirectionRatios],
  2963535650: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.ThresholdDepth, i.ThresholdThickness, i.TransomThickness, i.TransomOffset, i.LiningOffset, i.ThresholdOffset, i.CasingThickness, i.CasingDepth, i.ShapeAspectStyle],
  1714330368: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.PanelDepth, i.PanelOperation, i.PanelWidth, i.PanelPosition, i.ShapeAspectStyle],
  526551008: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.OperationType, i.ConstructionType, i.ParameterTakesPrecedence, i.Sizeable],
  3073041342: (i) => [i.Contents],
  445594917: (i) => [i.Name],
  4006246654: (i) => [i.Name],
  1472233963: (i) => [i.EdgeList],
  1883228015: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.MethodOfMeasurement, i.Quantities],
  339256511: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2777663545: (i) => [i.Position],
  2835456948: (i) => [i.ProfileType, i.ProfileName, i.Position, i.SemiAxis1, i.SemiAxis2],
  80994333: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.EnergySequence, i.UserDefinedEnergySequence],
  477187591: (i) => [i.SweptArea, i.Position, i.ExtrudedDirection, i.Depth],
  2047409740: (i) => [i.FbsmFaces],
  374418227: (i) => [i.HatchLineAppearance, i.StartOfNextHatchLine, i.PointOfReferenceHatchLine, i.PatternStart, i.HatchLineAngle],
  4203026998: (i) => [i.Symbol],
  315944413: (i) => [i.TilingPattern, i.Tiles, i.TilingScale],
  3455213021: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.PropertySource, i.FlowConditionTimeSeries, i.VelocityTimeSeries, i.FlowrateTimeSeries, i.Fluid, i.PressureTimeSeries, i.UserDefinedPropertySource, i.TemperatureSingleValue, i.WetBulbTemperatureSingleValue, i.WetBulbTemperatureTimeSeries, i.TemperatureTimeSeries, !i.FlowrateSingleValue ? null : Labelise(i.FlowrateSingleValue), i.FlowConditionSingleValue, i.VelocitySingleValue, i.PressureSingleValue],
  4238390223: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1268542332: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.AssemblyPlace],
  987898635: (i) => [i.Elements],
  1484403080: (i) => [i.ProfileType, i.ProfileName, i.Position, i.OverallWidth, i.OverallDepth, i.WebThickness, i.FlangeThickness, i.FilletRadius],
  572779678: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.Thickness, i.FilletRadius, i.EdgeRadius, i.LegSlope, i.CentreOfGravityInX, i.CentreOfGravityInY],
  1281925730: (i) => [i.Pnt, i.Dir],
  1425443689: (i) => [i.Outer],
  3888040117: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  3388369263: (i) => [i.BasisCurve, i.Distance, i.SelfIntersect],
  3505215534: (i) => [i.BasisCurve, i.Distance, i.SelfIntersect, i.RefDirection],
  3566463478: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle],
  603570806: (i) => [i.SizeInX, i.SizeInY, i.Placement],
  220341763: (i) => [i.Position],
  2945172077: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  4208778838: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  103090709: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext],
  4194566429: (i) => [i.Item, i.Styles, i.Name],
  1451395588: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.HasProperties],
  3219374653: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.ProxyType, i.Tag],
  2770003689: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.WallThickness, i.InnerFilletRadius, i.OuterFilletRadius],
  2798486643: (i) => [i.Position, i.XLength, i.YLength, i.Height],
  3454111270: (i) => [i.BasisSurface, i.U1, i.V1, i.U2, i.V2, i.Usense, i.Vsense],
  3939117080: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType],
  1683148259: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingActor, i.ActingRole],
  2495723537: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl],
  1307041759: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingGroup],
  4278684876: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProcess, i.QuantityInProcess],
  2857406711: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProduct],
  3372526763: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl],
  205026976: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingResource],
  1865459582: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects],
  1327628568: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingAppliedValue],
  4095574036: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingApproval],
  919958153: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingClassification],
  2728634034: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.Intent, i.RelatingConstraint],
  982818633: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingDocument],
  3840914261: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingLibrary],
  2655215786: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingMaterial],
  2851387026: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingProfileProperties, i.ProfileSectionLocation, i.ProfileOrientation],
  826625072: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  1204542856: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement],
  3945020480: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RelatingPriorities, i.RelatedPriorities, i.RelatedConnectionType, i.RelatingConnectionType],
  4201705270: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedElement],
  3190031847: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedPort, i.RealizingElement],
  2127690289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedStructuralActivity],
  3912681535: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedStructuralMember],
  1638771189: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem],
  504942748: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem, i.ConnectionConstraint],
  3678494232: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RealizingElements, i.ConnectionType],
  3242617779: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure],
  886880790: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedCoverings],
  2802773753: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedSpace, i.RelatedCoverings],
  2551354335: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects],
  693640335: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects],
  4186316022: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingPropertyDefinition],
  781010003: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingType],
  3940055652: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingOpeningElement, i.RelatedBuildingElement],
  279856033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedControlElements, i.RelatingFlowElement],
  4189434867: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.DailyInteraction, i.ImportanceRating, i.LocationOfInteraction, i.RelatedSpaceProgram, i.RelatingSpaceProgram],
  3268803585: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects],
  2051452291: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingActor, i.ActingRole],
  202636808: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingPropertyDefinition, i.OverridingProperties],
  750771296: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedFeatureElement],
  1245217292: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure],
  1058617721: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl],
  4122056220: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingProcess, i.RelatedProcess, i.TimeLag, i.SequenceType],
  366585022: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSystem, i.RelatedBuildings],
  3451746338: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary],
  1401173127: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedOpeningElement],
  2914609552: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  1856042241: (i) => [i.SweptArea, i.Position, i.Axis, i.Angle],
  4158566097: (i) => [i.Position, i.Height, i.BottomRadius],
  3626867408: (i) => [i.Position, i.Height, i.Radius],
  2706606064: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType],
  3893378262: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  451544542: (i) => [i.Position, i.Radius],
  3544373492: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  3136571912: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  530289379: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  3689010777: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  3979015343: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness],
  2218152070: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness, i.SubsequentThickness, i.VaryingThicknessLocation],
  4070609034: (i) => [i.Contents],
  2028607225: (i) => [i.SweptArea, i.Position, i.Directrix, i.StartParam, i.EndParam, i.ReferenceSurface],
  2809605785: (i) => [i.SweptCurve, i.Position, i.ExtrudedDirection, i.Depth],
  4124788165: (i) => [i.SweptCurve, i.Position, i.AxisPosition],
  1580310250: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3473067441: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TaskId, i.Status, i.WorkMethod, i.IsMilestone, i.Priority],
  2097647324: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2296667514: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor],
  1674181508: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  3207858831: (i) => [i.ProfileType, i.ProfileName, i.Position, i.OverallWidth, i.OverallDepth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.TopFlangeWidth, i.TopFlangeThickness, i.TopFlangeFilletRadius, i.CentreOfGravityInY],
  1334484129: (i) => [i.Position, i.XLength, i.YLength, i.ZLength],
  3649129432: (i) => [i.Operator, i.FirstOperand, i.SecondOperand],
  1260505505: (_) => [],
  4031249490: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.ElevationOfRefHeight, i.ElevationOfTerrain, i.BuildingAddress],
  1950629157: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3124254112: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.Elevation],
  2937912522: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Radius, i.WallThickness],
  300633059: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3732776249: (i) => [i.Segments, i.SelfIntersect],
  2510884976: (i) => [i.Position],
  2559216714: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity],
  3293443760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  3895139033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  1419761937: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.SubmittedBy, i.PreparedBy, i.SubmittedOn, i.Status, i.TargetUsers, i.UpdateDate, i.ID, i.PredefinedType],
  1916426348: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3295246426: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity],
  1457835157: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  681481545: (i) => [i.Contents],
  3256556792: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3849074793: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  360485395: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.EnergySequence, i.UserDefinedEnergySequence, i.ElectricCurrentType, i.InputVoltage, i.InputFrequency, i.FullLoadCurrent, i.MinimumCircuitCurrent, i.MaximumPowerInput, i.RatedPowerInput, i.InputPhase],
  1758889154: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4123344466: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.AssemblyPlace, i.PredefinedType],
  1623761950: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2590856083: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1704287377: (i) => [i.Position, i.SemiAxis1, i.SemiAxis2],
  2107101300: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1962604670: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3272907226: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  3174744832: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3390157468: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  807026263: (i) => [i.Outer],
  3737207727: (i) => [i.Outer, i.Voids],
  647756555: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2489546625: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2827207264: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2143335405: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1287392070: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3907093117: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3198132628: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3815607619: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1482959167: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1834744321: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1339347760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2297155007: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3009222698: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  263784265: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  814719939: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  200128114: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3009204131: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.UAxes, i.VAxes, i.WAxes],
  2706460486: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  1251058090: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1806887404: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2391368822: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.InventoryType, i.Jurisdiction, i.ResponsiblePersons, i.LastUpdateDate, i.CurrentValue, i.OriginalValue],
  4288270099: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3827777499: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity, i.SkillSet],
  1051575348: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1161773419: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2506943328: (i) => [i.Contents],
  377706215: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NominalDiameter, i.NominalLength],
  2108223431: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3181161470: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  977012517: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1916936684: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TaskId, i.Status, i.WorkMethod, i.IsMilestone, i.Priority, i.MoveFrom, i.MoveTo, i.PunchList],
  4143007308: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor, i.PredefinedType],
  3588315303: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3425660407: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TaskId, i.Status, i.WorkMethod, i.IsMilestone, i.Priority, i.ActionID],
  2837617999: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2382730787: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LifeCyclePhase],
  3327091369: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PermitID],
  804291784: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4231323485: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4017108033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3724593414: (i) => [i.Points],
  3740093272: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  2744685151: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ProcedureID, i.ProcedureType, i.UserDefinedProcedureType],
  2904328755: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ID, i.PredefinedType, i.Status],
  3642467123: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Records, i.PredefinedType],
  3651124850: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1842657554: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2250791053: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3248260540: (i) => [i.Contents],
  2893384427: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2324767716: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  160246688: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects],
  2863920197: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl, i.TimeForTask],
  1768891740: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3517283431: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ActualStart, i.EarlyStart, i.LateStart, i.ScheduleStart, i.ActualFinish, i.EarlyFinish, i.LateFinish, i.ScheduleFinish, i.ScheduleDuration, i.ActualDuration, i.RemainingTime, i.FreeFloat, i.TotalFloat, i.IsCritical, i.StatusTime, i.StartFloat, i.FinishFloat, i.Completion],
  4105383287: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ServiceLifeType, i.ServiceLifeDuration],
  4097777520: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.RefLatitude, i.RefLongitude, i.RefElevation, i.LandTitleNumber, i.SiteAddress],
  2533589738: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3856911033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.InteriorOrExteriorSpace, i.ElevationWithFlooring],
  1305183839: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  652456506: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.SpaceProgramIdentifier, i.MaxRequiredArea, i.MinRequiredArea, i.RequestedLocation, i.StandardRequiredArea],
  3812236995: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3112655638: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1039846685: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  682877961: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy],
  1179482911: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition],
  4243806635: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition],
  214636428: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType],
  2445595289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType],
  1807405624: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy, i.ProjectedOrTrue],
  1721250024: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy, i.ProjectedOrTrue, i.VaryingAppliedLoadLocation, i.SubsequentAppliedLoads],
  1252848954: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.ActionType, i.ActionSource, i.Coefficient, i.Purpose],
  1621171031: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy, i.ProjectedOrTrue],
  3987759626: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy, i.ProjectedOrTrue, i.VaryingAppliedLoadLocation, i.SubsequentAppliedLoads],
  2082059205: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy],
  734778138: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition],
  1235345126: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  2986769608: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheoryType, i.ResultForLoadGroup, i.IsLinear],
  1975003073: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition],
  148013059: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity, i.SubContractor, i.JobDescription],
  2315554128: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2254336722: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  5716631: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1637806684: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ApplicableDates, i.TimeSeriesScheduleType, i.TimeSeries],
  1692211062: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1620046519: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OperationType, i.CapacityByWeight, i.CapacityByNumber],
  3593883385: (i) => [i.BasisCurve, i.Trim1, i.Trim2, i.SenseAgreement, i.MasterRepresentation],
  1600972822: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1911125066: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  728799441: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2769231204: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1898987631: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1133259667: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1028945134: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identifier, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.WorkControlType, i.UserDefinedControlType],
  4218914973: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identifier, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.WorkControlType, i.UserDefinedControlType],
  3342526732: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identifier, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.WorkControlType, i.UserDefinedControlType],
  1033361043: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  1213861670: (i) => [i.Segments, i.SelfIntersect],
  3821786052: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.RequestID],
  1411407467: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3352864051: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1871374353: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2470393545: (i) => [i.Contents],
  3460190687: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.AssetID, i.OriginalValue, i.CurrentValue, i.TotalReplacementCost, i.Owner, i.User, i.ResponsiblePerson, i.IncorporationDate, i.DepreciatedValue],
  1967976161: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect],
  819618141: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1916977116: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect],
  231477066: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3299480353: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  52481810: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2979338954: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1095909175: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.CompositionType],
  1909888760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  395041908: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3293546465: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1285652485: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2951183804: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2611217952: (i) => [i.Position, i.Radius],
  2301859152: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  843113511: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3850581409: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2816379211: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2188551683: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  1163958913: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Criterion, i.CriterionDateTime],
  3898045240: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity],
  1060000209: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity, i.Suppliers, i.UsageRatio],
  488727124: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity],
  335055490: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2954562838: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1973544240: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3495092785: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3961806047: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4147604152: (i) => [i.Contents],
  1335981549: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2635815018: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1599208980: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2063403501: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1945004755: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3040386961: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3041715199: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.FlowDirection],
  395920057: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth],
  869906466: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3760055223: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2030761528: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  855621170: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.FeatureLength],
  663422040: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3277789161: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1534661035: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1365060375: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1217240411: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  712377611: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1634875225: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  857184966: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1658829314: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  346874300: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1810631287: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4222183408: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2058353004: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4278956645: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4037862832: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3132237377: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  987401354: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  707683696: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2223149337: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3508470533: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  900683007: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1073191201: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1687234759: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType, i.ConstructionType],
  3171933400: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2262370178: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3024970846: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.ShapeType],
  3283111854: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3055160366: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect, i.WeightsData],
  3027567501: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade],
  2320036040: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.MeshLength, i.MeshWidth, i.LongitudinalBarNominalDiameter, i.TransverseBarNominalDiameter, i.LongitudinalBarCrossSectionArea, i.TransverseBarCrossSectionArea, i.LongitudinalBarSpacing, i.TransverseBarSpacing],
  2016517767: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.ShapeType],
  1376911519: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.FeatureLength, i.Radius],
  1783015770: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1529196076: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  331165859: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.ShapeType],
  4252922144: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NumberOfRiser, i.NumberOfTreads, i.RiserHeight, i.TreadLength],
  2515109513: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.OrientationOf2DPlane, i.LoadedBy, i.HasResults],
  3824725483: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.TensionForce, i.PreStress, i.FrictionCoefficient, i.AnchorageSlip, i.MinCurvatureRadius],
  2347447852: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade],
  3313531582: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2391406946: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3512223829: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3304561284: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth],
  2874132201: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3001207471: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  753842376: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2454782716: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.FeatureLength, i.Width, i.Height],
  578613899: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1052013943: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1062813311: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.ControlElementId],
  3700593921: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.DistributionPointFunction, i.UserDefinedFunction],
  979691226: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.NominalDiameter, i.CrossSectionArea, i.BarLength, i.BarRole, i.BarSurface]
};
TypeInitialisers[1] = {
  3699917729: (v) => new IFC2X3.IfcAbsorbedDoseMeasure(v),
  4182062534: (v) => new IFC2X3.IfcAccelerationMeasure(v),
  360377573: (v) => new IFC2X3.IfcAmountOfSubstanceMeasure(v),
  632304761: (v) => new IFC2X3.IfcAngularVelocityMeasure(v),
  2650437152: (v) => new IFC2X3.IfcAreaMeasure(v),
  2735952531: (v) => new IFC2X3.IfcBoolean(v),
  1867003952: (v) => new IFC2X3.IfcBoxAlignment(v),
  2991860651: (v) => new IFC2X3.IfcComplexNumber(v),
  3812528620: (v) => new IFC2X3.IfcCompoundPlaneAngleMeasure(v),
  3238673880: (v) => new IFC2X3.IfcContextDependentMeasure(v),
  1778710042: (v) => new IFC2X3.IfcCountMeasure(v),
  94842927: (v) => new IFC2X3.IfcCurvatureMeasure(v),
  86635668: (v) => new IFC2X3.IfcDayInMonthNumber(v),
  300323983: (v) => new IFC2X3.IfcDaylightSavingHour(v),
  1514641115: (v) => new IFC2X3.IfcDescriptiveMeasure(v),
  4134073009: (v) => new IFC2X3.IfcDimensionCount(v),
  524656162: (v) => new IFC2X3.IfcDoseEquivalentMeasure(v),
  69416015: (v) => new IFC2X3.IfcDynamicViscosityMeasure(v),
  1827137117: (v) => new IFC2X3.IfcElectricCapacitanceMeasure(v),
  3818826038: (v) => new IFC2X3.IfcElectricChargeMeasure(v),
  2093906313: (v) => new IFC2X3.IfcElectricConductanceMeasure(v),
  3790457270: (v) => new IFC2X3.IfcElectricCurrentMeasure(v),
  2951915441: (v) => new IFC2X3.IfcElectricResistanceMeasure(v),
  2506197118: (v) => new IFC2X3.IfcElectricVoltageMeasure(v),
  2078135608: (v) => new IFC2X3.IfcEnergyMeasure(v),
  1102727119: (v) => new IFC2X3.IfcFontStyle(v),
  2715512545: (v) => new IFC2X3.IfcFontVariant(v),
  2590844177: (v) => new IFC2X3.IfcFontWeight(v),
  1361398929: (v) => new IFC2X3.IfcForceMeasure(v),
  3044325142: (v) => new IFC2X3.IfcFrequencyMeasure(v),
  3064340077: (v) => new IFC2X3.IfcGloballyUniqueId(v),
  3113092358: (v) => new IFC2X3.IfcHeatFluxDensityMeasure(v),
  1158859006: (v) => new IFC2X3.IfcHeatingValueMeasure(v),
  2589826445: (v) => new IFC2X3.IfcHourInDay(v),
  983778844: (v) => new IFC2X3.IfcIdentifier(v),
  3358199106: (v) => new IFC2X3.IfcIlluminanceMeasure(v),
  2679005408: (v) => new IFC2X3.IfcInductanceMeasure(v),
  1939436016: (v) => new IFC2X3.IfcInteger(v),
  3809634241: (v) => new IFC2X3.IfcIntegerCountRateMeasure(v),
  3686016028: (v) => new IFC2X3.IfcIonConcentrationMeasure(v),
  3192672207: (v) => new IFC2X3.IfcIsothermalMoistureCapacityMeasure(v),
  2054016361: (v) => new IFC2X3.IfcKinematicViscosityMeasure(v),
  3258342251: (v) => new IFC2X3.IfcLabel(v),
  1243674935: (v) => new IFC2X3.IfcLengthMeasure(v),
  191860431: (v) => new IFC2X3.IfcLinearForceMeasure(v),
  2128979029: (v) => new IFC2X3.IfcLinearMomentMeasure(v),
  1307019551: (v) => new IFC2X3.IfcLinearStiffnessMeasure(v),
  3086160713: (v) => new IFC2X3.IfcLinearVelocityMeasure(v),
  503418787: (v) => new IFC2X3.IfcLogical(v),
  2095003142: (v) => new IFC2X3.IfcLuminousFluxMeasure(v),
  2755797622: (v) => new IFC2X3.IfcLuminousIntensityDistributionMeasure(v),
  151039812: (v) => new IFC2X3.IfcLuminousIntensityMeasure(v),
  286949696: (v) => new IFC2X3.IfcMagneticFluxDensityMeasure(v),
  2486716878: (v) => new IFC2X3.IfcMagneticFluxMeasure(v),
  1477762836: (v) => new IFC2X3.IfcMassDensityMeasure(v),
  4017473158: (v) => new IFC2X3.IfcMassFlowRateMeasure(v),
  3124614049: (v) => new IFC2X3.IfcMassMeasure(v),
  3531705166: (v) => new IFC2X3.IfcMassPerLengthMeasure(v),
  102610177: (v) => new IFC2X3.IfcMinuteInHour(v),
  3341486342: (v) => new IFC2X3.IfcModulusOfElasticityMeasure(v),
  2173214787: (v) => new IFC2X3.IfcModulusOfLinearSubgradeReactionMeasure(v),
  1052454078: (v) => new IFC2X3.IfcModulusOfRotationalSubgradeReactionMeasure(v),
  1753493141: (v) => new IFC2X3.IfcModulusOfSubgradeReactionMeasure(v),
  3177669450: (v) => new IFC2X3.IfcMoistureDiffusivityMeasure(v),
  1648970520: (v) => new IFC2X3.IfcMolecularWeightMeasure(v),
  3114022597: (v) => new IFC2X3.IfcMomentOfInertiaMeasure(v),
  2615040989: (v) => new IFC2X3.IfcMonetaryMeasure(v),
  765770214: (v) => new IFC2X3.IfcMonthInYearNumber(v),
  2095195183: (v) => new IFC2X3.IfcNormalisedRatioMeasure(v),
  2395907400: (v) => new IFC2X3.IfcNumericMeasure(v),
  929793134: (v) => new IFC2X3.IfcPHMeasure(v),
  2260317790: (v) => new IFC2X3.IfcParameterValue(v),
  2642773653: (v) => new IFC2X3.IfcPlanarForceMeasure(v),
  4042175685: (v) => new IFC2X3.IfcPlaneAngleMeasure(v),
  2815919920: (v) => new IFC2X3.IfcPositiveLengthMeasure(v),
  3054510233: (v) => new IFC2X3.IfcPositivePlaneAngleMeasure(v),
  1245737093: (v) => new IFC2X3.IfcPositiveRatioMeasure(v),
  1364037233: (v) => new IFC2X3.IfcPowerMeasure(v),
  2169031380: (v) => new IFC2X3.IfcPresentableText(v),
  3665567075: (v) => new IFC2X3.IfcPressureMeasure(v),
  3972513137: (v) => new IFC2X3.IfcRadioActivityMeasure(v),
  96294661: (v) => new IFC2X3.IfcRatioMeasure(v),
  200335297: (v) => new IFC2X3.IfcReal(v),
  2133746277: (v) => new IFC2X3.IfcRotationalFrequencyMeasure(v),
  1755127002: (v) => new IFC2X3.IfcRotationalMassMeasure(v),
  3211557302: (v) => new IFC2X3.IfcRotationalStiffnessMeasure(v),
  2766185779: (v) => new IFC2X3.IfcSecondInMinute(v),
  3467162246: (v) => new IFC2X3.IfcSectionModulusMeasure(v),
  2190458107: (v) => new IFC2X3.IfcSectionalAreaIntegralMeasure(v),
  408310005: (v) => new IFC2X3.IfcShearModulusMeasure(v),
  3471399674: (v) => new IFC2X3.IfcSolidAngleMeasure(v),
  846465480: (v) => new IFC2X3.IfcSoundPowerMeasure(v),
  993287707: (v) => new IFC2X3.IfcSoundPressureMeasure(v),
  3477203348: (v) => new IFC2X3.IfcSpecificHeatCapacityMeasure(v),
  2757832317: (v) => new IFC2X3.IfcSpecularExponent(v),
  361837227: (v) => new IFC2X3.IfcSpecularRoughness(v),
  58845555: (v) => new IFC2X3.IfcTemperatureGradientMeasure(v),
  2801250643: (v) => new IFC2X3.IfcText(v),
  1460886941: (v) => new IFC2X3.IfcTextAlignment(v),
  3490877962: (v) => new IFC2X3.IfcTextDecoration(v),
  603696268: (v) => new IFC2X3.IfcTextFontName(v),
  296282323: (v) => new IFC2X3.IfcTextTransformation(v),
  232962298: (v) => new IFC2X3.IfcThermalAdmittanceMeasure(v),
  2645777649: (v) => new IFC2X3.IfcThermalConductivityMeasure(v),
  2281867870: (v) => new IFC2X3.IfcThermalExpansionCoefficientMeasure(v),
  857959152: (v) => new IFC2X3.IfcThermalResistanceMeasure(v),
  2016195849: (v) => new IFC2X3.IfcThermalTransmittanceMeasure(v),
  743184107: (v) => new IFC2X3.IfcThermodynamicTemperatureMeasure(v),
  2726807636: (v) => new IFC2X3.IfcTimeMeasure(v),
  2591213694: (v) => new IFC2X3.IfcTimeStamp(v),
  1278329552: (v) => new IFC2X3.IfcTorqueMeasure(v),
  3345633955: (v) => new IFC2X3.IfcVaporPermeabilityMeasure(v),
  3458127941: (v) => new IFC2X3.IfcVolumeMeasure(v),
  2593997549: (v) => new IFC2X3.IfcVolumetricFlowRateMeasure(v),
  51269191: (v) => new IFC2X3.IfcWarpingConstantMeasure(v),
  1718600412: (v) => new IFC2X3.IfcWarpingMomentMeasure(v),
  4065007721: (v) => new IFC2X3.IfcYearNumber(v)
};
var IFC2X3;
(function(IFC2X32) {
  class IfcAbsorbedDoseMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcAbsorbedDoseMeasure = IfcAbsorbedDoseMeasure;
  class IfcAccelerationMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcAccelerationMeasure = IfcAccelerationMeasure;
  class IfcAmountOfSubstanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcAmountOfSubstanceMeasure = IfcAmountOfSubstanceMeasure;
  class IfcAngularVelocityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcAngularVelocityMeasure = IfcAngularVelocityMeasure;
  class IfcAreaMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcAreaMeasure = IfcAreaMeasure;
  class IfcBoolean {
    constructor(value) {
      this.value = value;
      this.type = 3;
    }
  }
  IFC2X32.IfcBoolean = IfcBoolean;
  class IfcBoxAlignment {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC2X32.IfcBoxAlignment = IfcBoxAlignment;
  class IfcComplexNumber {
    constructor(value) {
      this.value = value;
    }
  }
  IFC2X32.IfcComplexNumber = IfcComplexNumber;
  ;
  class IfcCompoundPlaneAngleMeasure {
    constructor(value) {
      this.value = value;
    }
  }
  IFC2X32.IfcCompoundPlaneAngleMeasure = IfcCompoundPlaneAngleMeasure;
  ;
  class IfcContextDependentMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcContextDependentMeasure = IfcContextDependentMeasure;
  class IfcCountMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcCountMeasure = IfcCountMeasure;
  class IfcCurvatureMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcCurvatureMeasure = IfcCurvatureMeasure;
  class IfcDayInMonthNumber {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcDayInMonthNumber = IfcDayInMonthNumber;
  class IfcDaylightSavingHour {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcDaylightSavingHour = IfcDaylightSavingHour;
  class IfcDescriptiveMeasure {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC2X32.IfcDescriptiveMeasure = IfcDescriptiveMeasure;
  class IfcDimensionCount {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcDimensionCount = IfcDimensionCount;
  class IfcDoseEquivalentMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcDoseEquivalentMeasure = IfcDoseEquivalentMeasure;
  class IfcDynamicViscosityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcDynamicViscosityMeasure = IfcDynamicViscosityMeasure;
  class IfcElectricCapacitanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcElectricCapacitanceMeasure = IfcElectricCapacitanceMeasure;
  class IfcElectricChargeMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcElectricChargeMeasure = IfcElectricChargeMeasure;
  class IfcElectricConductanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcElectricConductanceMeasure = IfcElectricConductanceMeasure;
  class IfcElectricCurrentMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcElectricCurrentMeasure = IfcElectricCurrentMeasure;
  class IfcElectricResistanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcElectricResistanceMeasure = IfcElectricResistanceMeasure;
  class IfcElectricVoltageMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcElectricVoltageMeasure = IfcElectricVoltageMeasure;
  class IfcEnergyMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcEnergyMeasure = IfcEnergyMeasure;
  class IfcFontStyle {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC2X32.IfcFontStyle = IfcFontStyle;
  class IfcFontVariant {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC2X32.IfcFontVariant = IfcFontVariant;
  class IfcFontWeight {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC2X32.IfcFontWeight = IfcFontWeight;
  class IfcForceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcForceMeasure = IfcForceMeasure;
  class IfcFrequencyMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcFrequencyMeasure = IfcFrequencyMeasure;
  class IfcGloballyUniqueId {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC2X32.IfcGloballyUniqueId = IfcGloballyUniqueId;
  class IfcHeatFluxDensityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcHeatFluxDensityMeasure = IfcHeatFluxDensityMeasure;
  class IfcHeatingValueMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcHeatingValueMeasure = IfcHeatingValueMeasure;
  class IfcHourInDay {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcHourInDay = IfcHourInDay;
  class IfcIdentifier {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC2X32.IfcIdentifier = IfcIdentifier;
  class IfcIlluminanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcIlluminanceMeasure = IfcIlluminanceMeasure;
  class IfcInductanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcInductanceMeasure = IfcInductanceMeasure;
  class IfcInteger {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcInteger = IfcInteger;
  class IfcIntegerCountRateMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcIntegerCountRateMeasure = IfcIntegerCountRateMeasure;
  class IfcIonConcentrationMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcIonConcentrationMeasure = IfcIonConcentrationMeasure;
  class IfcIsothermalMoistureCapacityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcIsothermalMoistureCapacityMeasure = IfcIsothermalMoistureCapacityMeasure;
  class IfcKinematicViscosityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcKinematicViscosityMeasure = IfcKinematicViscosityMeasure;
  class IfcLabel {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC2X32.IfcLabel = IfcLabel;
  class IfcLengthMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcLengthMeasure = IfcLengthMeasure;
  class IfcLinearForceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcLinearForceMeasure = IfcLinearForceMeasure;
  class IfcLinearMomentMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcLinearMomentMeasure = IfcLinearMomentMeasure;
  class IfcLinearStiffnessMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcLinearStiffnessMeasure = IfcLinearStiffnessMeasure;
  class IfcLinearVelocityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcLinearVelocityMeasure = IfcLinearVelocityMeasure;
  class IfcLogical {
    constructor(value) {
      this.value = value;
      this.type = 3;
    }
  }
  IFC2X32.IfcLogical = IfcLogical;
  class IfcLuminousFluxMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcLuminousFluxMeasure = IfcLuminousFluxMeasure;
  class IfcLuminousIntensityDistributionMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcLuminousIntensityDistributionMeasure = IfcLuminousIntensityDistributionMeasure;
  class IfcLuminousIntensityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcLuminousIntensityMeasure = IfcLuminousIntensityMeasure;
  class IfcMagneticFluxDensityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcMagneticFluxDensityMeasure = IfcMagneticFluxDensityMeasure;
  class IfcMagneticFluxMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcMagneticFluxMeasure = IfcMagneticFluxMeasure;
  class IfcMassDensityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcMassDensityMeasure = IfcMassDensityMeasure;
  class IfcMassFlowRateMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcMassFlowRateMeasure = IfcMassFlowRateMeasure;
  class IfcMassMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcMassMeasure = IfcMassMeasure;
  class IfcMassPerLengthMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcMassPerLengthMeasure = IfcMassPerLengthMeasure;
  class IfcMinuteInHour {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcMinuteInHour = IfcMinuteInHour;
  class IfcModulusOfElasticityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcModulusOfElasticityMeasure = IfcModulusOfElasticityMeasure;
  class IfcModulusOfLinearSubgradeReactionMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcModulusOfLinearSubgradeReactionMeasure = IfcModulusOfLinearSubgradeReactionMeasure;
  class IfcModulusOfRotationalSubgradeReactionMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcModulusOfRotationalSubgradeReactionMeasure = IfcModulusOfRotationalSubgradeReactionMeasure;
  class IfcModulusOfSubgradeReactionMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcModulusOfSubgradeReactionMeasure = IfcModulusOfSubgradeReactionMeasure;
  class IfcMoistureDiffusivityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcMoistureDiffusivityMeasure = IfcMoistureDiffusivityMeasure;
  class IfcMolecularWeightMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcMolecularWeightMeasure = IfcMolecularWeightMeasure;
  class IfcMomentOfInertiaMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcMomentOfInertiaMeasure = IfcMomentOfInertiaMeasure;
  class IfcMonetaryMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcMonetaryMeasure = IfcMonetaryMeasure;
  class IfcMonthInYearNumber {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcMonthInYearNumber = IfcMonthInYearNumber;
  class IfcNormalisedRatioMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcNormalisedRatioMeasure = IfcNormalisedRatioMeasure;
  class IfcNumericMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcNumericMeasure = IfcNumericMeasure;
  class IfcPHMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcPHMeasure = IfcPHMeasure;
  class IfcParameterValue {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcParameterValue = IfcParameterValue;
  class IfcPlanarForceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcPlanarForceMeasure = IfcPlanarForceMeasure;
  class IfcPlaneAngleMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcPlaneAngleMeasure = IfcPlaneAngleMeasure;
  class IfcPositiveLengthMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcPositiveLengthMeasure = IfcPositiveLengthMeasure;
  class IfcPositivePlaneAngleMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcPositivePlaneAngleMeasure = IfcPositivePlaneAngleMeasure;
  class IfcPositiveRatioMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcPositiveRatioMeasure = IfcPositiveRatioMeasure;
  class IfcPowerMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcPowerMeasure = IfcPowerMeasure;
  class IfcPresentableText {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC2X32.IfcPresentableText = IfcPresentableText;
  class IfcPressureMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcPressureMeasure = IfcPressureMeasure;
  class IfcRadioActivityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcRadioActivityMeasure = IfcRadioActivityMeasure;
  class IfcRatioMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcRatioMeasure = IfcRatioMeasure;
  class IfcReal {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcReal = IfcReal;
  class IfcRotationalFrequencyMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcRotationalFrequencyMeasure = IfcRotationalFrequencyMeasure;
  class IfcRotationalMassMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcRotationalMassMeasure = IfcRotationalMassMeasure;
  class IfcRotationalStiffnessMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcRotationalStiffnessMeasure = IfcRotationalStiffnessMeasure;
  class IfcSecondInMinute {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcSecondInMinute = IfcSecondInMinute;
  class IfcSectionModulusMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcSectionModulusMeasure = IfcSectionModulusMeasure;
  class IfcSectionalAreaIntegralMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcSectionalAreaIntegralMeasure = IfcSectionalAreaIntegralMeasure;
  class IfcShearModulusMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcShearModulusMeasure = IfcShearModulusMeasure;
  class IfcSolidAngleMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcSolidAngleMeasure = IfcSolidAngleMeasure;
  class IfcSoundPowerMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcSoundPowerMeasure = IfcSoundPowerMeasure;
  class IfcSoundPressureMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcSoundPressureMeasure = IfcSoundPressureMeasure;
  class IfcSpecificHeatCapacityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcSpecificHeatCapacityMeasure = IfcSpecificHeatCapacityMeasure;
  class IfcSpecularExponent {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcSpecularExponent = IfcSpecularExponent;
  class IfcSpecularRoughness {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcSpecularRoughness = IfcSpecularRoughness;
  class IfcTemperatureGradientMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcTemperatureGradientMeasure = IfcTemperatureGradientMeasure;
  class IfcText {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC2X32.IfcText = IfcText;
  class IfcTextAlignment {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC2X32.IfcTextAlignment = IfcTextAlignment;
  class IfcTextDecoration {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC2X32.IfcTextDecoration = IfcTextDecoration;
  class IfcTextFontName {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC2X32.IfcTextFontName = IfcTextFontName;
  class IfcTextTransformation {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC2X32.IfcTextTransformation = IfcTextTransformation;
  class IfcThermalAdmittanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcThermalAdmittanceMeasure = IfcThermalAdmittanceMeasure;
  class IfcThermalConductivityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcThermalConductivityMeasure = IfcThermalConductivityMeasure;
  class IfcThermalExpansionCoefficientMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcThermalExpansionCoefficientMeasure = IfcThermalExpansionCoefficientMeasure;
  class IfcThermalResistanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcThermalResistanceMeasure = IfcThermalResistanceMeasure;
  class IfcThermalTransmittanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcThermalTransmittanceMeasure = IfcThermalTransmittanceMeasure;
  class IfcThermodynamicTemperatureMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcThermodynamicTemperatureMeasure = IfcThermodynamicTemperatureMeasure;
  class IfcTimeMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcTimeMeasure = IfcTimeMeasure;
  class IfcTimeStamp {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcTimeStamp = IfcTimeStamp;
  class IfcTorqueMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcTorqueMeasure = IfcTorqueMeasure;
  class IfcVaporPermeabilityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcVaporPermeabilityMeasure = IfcVaporPermeabilityMeasure;
  class IfcVolumeMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcVolumeMeasure = IfcVolumeMeasure;
  class IfcVolumetricFlowRateMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcVolumetricFlowRateMeasure = IfcVolumetricFlowRateMeasure;
  class IfcWarpingConstantMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcWarpingConstantMeasure = IfcWarpingConstantMeasure;
  class IfcWarpingMomentMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcWarpingMomentMeasure = IfcWarpingMomentMeasure;
  class IfcYearNumber {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC2X32.IfcYearNumber = IfcYearNumber;
  class IfcActionSourceTypeEnum {
  }
  IfcActionSourceTypeEnum.DEAD_LOAD_G = { type: 3, value: "DEAD_LOAD_G" };
  IfcActionSourceTypeEnum.COMPLETION_G1 = { type: 3, value: "COMPLETION_G1" };
  IfcActionSourceTypeEnum.LIVE_LOAD_Q = { type: 3, value: "LIVE_LOAD_Q" };
  IfcActionSourceTypeEnum.SNOW_S = { type: 3, value: "SNOW_S" };
  IfcActionSourceTypeEnum.WIND_W = { type: 3, value: "WIND_W" };
  IfcActionSourceTypeEnum.PRESTRESSING_P = { type: 3, value: "PRESTRESSING_P" };
  IfcActionSourceTypeEnum.SETTLEMENT_U = { type: 3, value: "SETTLEMENT_U" };
  IfcActionSourceTypeEnum.TEMPERATURE_T = { type: 3, value: "TEMPERATURE_T" };
  IfcActionSourceTypeEnum.EARTHQUAKE_E = { type: 3, value: "EARTHQUAKE_E" };
  IfcActionSourceTypeEnum.FIRE = { type: 3, value: "FIRE" };
  IfcActionSourceTypeEnum.IMPULSE = { type: 3, value: "IMPULSE" };
  IfcActionSourceTypeEnum.IMPACT = { type: 3, value: "IMPACT" };
  IfcActionSourceTypeEnum.TRANSPORT = { type: 3, value: "TRANSPORT" };
  IfcActionSourceTypeEnum.ERECTION = { type: 3, value: "ERECTION" };
  IfcActionSourceTypeEnum.PROPPING = { type: 3, value: "PROPPING" };
  IfcActionSourceTypeEnum.SYSTEM_IMPERFECTION = { type: 3, value: "SYSTEM_IMPERFECTION" };
  IfcActionSourceTypeEnum.SHRINKAGE = { type: 3, value: "SHRINKAGE" };
  IfcActionSourceTypeEnum.CREEP = { type: 3, value: "CREEP" };
  IfcActionSourceTypeEnum.LACK_OF_FIT = { type: 3, value: "LACK_OF_FIT" };
  IfcActionSourceTypeEnum.BUOYANCY = { type: 3, value: "BUOYANCY" };
  IfcActionSourceTypeEnum.ICE = { type: 3, value: "ICE" };
  IfcActionSourceTypeEnum.CURRENT = { type: 3, value: "CURRENT" };
  IfcActionSourceTypeEnum.WAVE = { type: 3, value: "WAVE" };
  IfcActionSourceTypeEnum.RAIN = { type: 3, value: "RAIN" };
  IfcActionSourceTypeEnum.BRAKES = { type: 3, value: "BRAKES" };
  IfcActionSourceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcActionSourceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcActionSourceTypeEnum = IfcActionSourceTypeEnum;
  class IfcActionTypeEnum {
  }
  IfcActionTypeEnum.PERMANENT_G = { type: 3, value: "PERMANENT_G" };
  IfcActionTypeEnum.VARIABLE_Q = { type: 3, value: "VARIABLE_Q" };
  IfcActionTypeEnum.EXTRAORDINARY_A = { type: 3, value: "EXTRAORDINARY_A" };
  IfcActionTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcActionTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcActionTypeEnum = IfcActionTypeEnum;
  class IfcActuatorTypeEnum {
  }
  IfcActuatorTypeEnum.ELECTRICACTUATOR = { type: 3, value: "ELECTRICACTUATOR" };
  IfcActuatorTypeEnum.HANDOPERATEDACTUATOR = { type: 3, value: "HANDOPERATEDACTUATOR" };
  IfcActuatorTypeEnum.HYDRAULICACTUATOR = { type: 3, value: "HYDRAULICACTUATOR" };
  IfcActuatorTypeEnum.PNEUMATICACTUATOR = { type: 3, value: "PNEUMATICACTUATOR" };
  IfcActuatorTypeEnum.THERMOSTATICACTUATOR = { type: 3, value: "THERMOSTATICACTUATOR" };
  IfcActuatorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcActuatorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcActuatorTypeEnum = IfcActuatorTypeEnum;
  class IfcAddressTypeEnum {
  }
  IfcAddressTypeEnum.OFFICE = { type: 3, value: "OFFICE" };
  IfcAddressTypeEnum.SITE = { type: 3, value: "SITE" };
  IfcAddressTypeEnum.HOME = { type: 3, value: "HOME" };
  IfcAddressTypeEnum.DISTRIBUTIONPOINT = { type: 3, value: "DISTRIBUTIONPOINT" };
  IfcAddressTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IFC2X32.IfcAddressTypeEnum = IfcAddressTypeEnum;
  class IfcAheadOrBehind {
  }
  IfcAheadOrBehind.AHEAD = { type: 3, value: "AHEAD" };
  IfcAheadOrBehind.BEHIND = { type: 3, value: "BEHIND" };
  IFC2X32.IfcAheadOrBehind = IfcAheadOrBehind;
  class IfcAirTerminalBoxTypeEnum {
  }
  IfcAirTerminalBoxTypeEnum.CONSTANTFLOW = { type: 3, value: "CONSTANTFLOW" };
  IfcAirTerminalBoxTypeEnum.VARIABLEFLOWPRESSUREDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREDEPENDANT" };
  IfcAirTerminalBoxTypeEnum.VARIABLEFLOWPRESSUREINDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREINDEPENDANT" };
  IfcAirTerminalBoxTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAirTerminalBoxTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcAirTerminalBoxTypeEnum = IfcAirTerminalBoxTypeEnum;
  class IfcAirTerminalTypeEnum {
  }
  IfcAirTerminalTypeEnum.GRILLE = { type: 3, value: "GRILLE" };
  IfcAirTerminalTypeEnum.REGISTER = { type: 3, value: "REGISTER" };
  IfcAirTerminalTypeEnum.DIFFUSER = { type: 3, value: "DIFFUSER" };
  IfcAirTerminalTypeEnum.EYEBALL = { type: 3, value: "EYEBALL" };
  IfcAirTerminalTypeEnum.IRIS = { type: 3, value: "IRIS" };
  IfcAirTerminalTypeEnum.LINEARGRILLE = { type: 3, value: "LINEARGRILLE" };
  IfcAirTerminalTypeEnum.LINEARDIFFUSER = { type: 3, value: "LINEARDIFFUSER" };
  IfcAirTerminalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAirTerminalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcAirTerminalTypeEnum = IfcAirTerminalTypeEnum;
  class IfcAirToAirHeatRecoveryTypeEnum {
  }
  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATECOUNTERFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECOUNTERFLOWEXCHANGER" };
  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATECROSSFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECROSSFLOWEXCHANGER" };
  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATEPARALLELFLOWEXCHANGER = { type: 3, value: "FIXEDPLATEPARALLELFLOWEXCHANGER" };
  IfcAirToAirHeatRecoveryTypeEnum.ROTARYWHEEL = { type: 3, value: "ROTARYWHEEL" };
  IfcAirToAirHeatRecoveryTypeEnum.RUNAROUNDCOILLOOP = { type: 3, value: "RUNAROUNDCOILLOOP" };
  IfcAirToAirHeatRecoveryTypeEnum.HEATPIPE = { type: 3, value: "HEATPIPE" };
  IfcAirToAirHeatRecoveryTypeEnum.TWINTOWERENTHALPYRECOVERYLOOPS = { type: 3, value: "TWINTOWERENTHALPYRECOVERYLOOPS" };
  IfcAirToAirHeatRecoveryTypeEnum.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS" };
  IfcAirToAirHeatRecoveryTypeEnum.THERMOSIPHONCOILTYPEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS" };
  IfcAirToAirHeatRecoveryTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAirToAirHeatRecoveryTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcAirToAirHeatRecoveryTypeEnum = IfcAirToAirHeatRecoveryTypeEnum;
  class IfcAlarmTypeEnum {
  }
  IfcAlarmTypeEnum.BELL = { type: 3, value: "BELL" };
  IfcAlarmTypeEnum.BREAKGLASSBUTTON = { type: 3, value: "BREAKGLASSBUTTON" };
  IfcAlarmTypeEnum.LIGHT = { type: 3, value: "LIGHT" };
  IfcAlarmTypeEnum.MANUALPULLBOX = { type: 3, value: "MANUALPULLBOX" };
  IfcAlarmTypeEnum.SIREN = { type: 3, value: "SIREN" };
  IfcAlarmTypeEnum.WHISTLE = { type: 3, value: "WHISTLE" };
  IfcAlarmTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAlarmTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcAlarmTypeEnum = IfcAlarmTypeEnum;
  class IfcAnalysisModelTypeEnum {
  }
  IfcAnalysisModelTypeEnum.IN_PLANE_LOADING_2D = { type: 3, value: "IN_PLANE_LOADING_2D" };
  IfcAnalysisModelTypeEnum.OUT_PLANE_LOADING_2D = { type: 3, value: "OUT_PLANE_LOADING_2D" };
  IfcAnalysisModelTypeEnum.LOADING_3D = { type: 3, value: "LOADING_3D" };
  IfcAnalysisModelTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAnalysisModelTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcAnalysisModelTypeEnum = IfcAnalysisModelTypeEnum;
  class IfcAnalysisTheoryTypeEnum {
  }
  IfcAnalysisTheoryTypeEnum.FIRST_ORDER_THEORY = { type: 3, value: "FIRST_ORDER_THEORY" };
  IfcAnalysisTheoryTypeEnum.SECOND_ORDER_THEORY = { type: 3, value: "SECOND_ORDER_THEORY" };
  IfcAnalysisTheoryTypeEnum.THIRD_ORDER_THEORY = { type: 3, value: "THIRD_ORDER_THEORY" };
  IfcAnalysisTheoryTypeEnum.FULL_NONLINEAR_THEORY = { type: 3, value: "FULL_NONLINEAR_THEORY" };
  IfcAnalysisTheoryTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAnalysisTheoryTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcAnalysisTheoryTypeEnum = IfcAnalysisTheoryTypeEnum;
  class IfcArithmeticOperatorEnum {
  }
  IfcArithmeticOperatorEnum.ADD = { type: 3, value: "ADD" };
  IfcArithmeticOperatorEnum.DIVIDE = { type: 3, value: "DIVIDE" };
  IfcArithmeticOperatorEnum.MULTIPLY = { type: 3, value: "MULTIPLY" };
  IfcArithmeticOperatorEnum.SUBTRACT = { type: 3, value: "SUBTRACT" };
  IFC2X32.IfcArithmeticOperatorEnum = IfcArithmeticOperatorEnum;
  class IfcAssemblyPlaceEnum {
  }
  IfcAssemblyPlaceEnum.SITE = { type: 3, value: "SITE" };
  IfcAssemblyPlaceEnum.FACTORY = { type: 3, value: "FACTORY" };
  IfcAssemblyPlaceEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcAssemblyPlaceEnum = IfcAssemblyPlaceEnum;
  class IfcBSplineCurveForm {
  }
  IfcBSplineCurveForm.POLYLINE_FORM = { type: 3, value: "POLYLINE_FORM" };
  IfcBSplineCurveForm.CIRCULAR_ARC = { type: 3, value: "CIRCULAR_ARC" };
  IfcBSplineCurveForm.ELLIPTIC_ARC = { type: 3, value: "ELLIPTIC_ARC" };
  IfcBSplineCurveForm.PARABOLIC_ARC = { type: 3, value: "PARABOLIC_ARC" };
  IfcBSplineCurveForm.HYPERBOLIC_ARC = { type: 3, value: "HYPERBOLIC_ARC" };
  IfcBSplineCurveForm.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  IFC2X32.IfcBSplineCurveForm = IfcBSplineCurveForm;
  class IfcBeamTypeEnum {
  }
  IfcBeamTypeEnum.BEAM = { type: 3, value: "BEAM" };
  IfcBeamTypeEnum.JOIST = { type: 3, value: "JOIST" };
  IfcBeamTypeEnum.LINTEL = { type: 3, value: "LINTEL" };
  IfcBeamTypeEnum.T_BEAM = { type: 3, value: "T_BEAM" };
  IfcBeamTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBeamTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcBeamTypeEnum = IfcBeamTypeEnum;
  class IfcBenchmarkEnum {
  }
  IfcBenchmarkEnum.GREATERTHAN = { type: 3, value: "GREATERTHAN" };
  IfcBenchmarkEnum.GREATERTHANOREQUALTO = { type: 3, value: "GREATERTHANOREQUALTO" };
  IfcBenchmarkEnum.LESSTHAN = { type: 3, value: "LESSTHAN" };
  IfcBenchmarkEnum.LESSTHANOREQUALTO = { type: 3, value: "LESSTHANOREQUALTO" };
  IfcBenchmarkEnum.EQUALTO = { type: 3, value: "EQUALTO" };
  IfcBenchmarkEnum.NOTEQUALTO = { type: 3, value: "NOTEQUALTO" };
  IFC2X32.IfcBenchmarkEnum = IfcBenchmarkEnum;
  class IfcBoilerTypeEnum {
  }
  IfcBoilerTypeEnum.WATER = { type: 3, value: "WATER" };
  IfcBoilerTypeEnum.STEAM = { type: 3, value: "STEAM" };
  IfcBoilerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBoilerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcBoilerTypeEnum = IfcBoilerTypeEnum;
  class IfcBooleanOperator {
  }
  IfcBooleanOperator.UNION = { type: 3, value: "UNION" };
  IfcBooleanOperator.INTERSECTION = { type: 3, value: "INTERSECTION" };
  IfcBooleanOperator.DIFFERENCE = { type: 3, value: "DIFFERENCE" };
  IFC2X32.IfcBooleanOperator = IfcBooleanOperator;
  class IfcBuildingElementProxyTypeEnum {
  }
  IfcBuildingElementProxyTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBuildingElementProxyTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcBuildingElementProxyTypeEnum = IfcBuildingElementProxyTypeEnum;
  class IfcCableCarrierFittingTypeEnum {
  }
  IfcCableCarrierFittingTypeEnum.BEND = { type: 3, value: "BEND" };
  IfcCableCarrierFittingTypeEnum.CROSS = { type: 3, value: "CROSS" };
  IfcCableCarrierFittingTypeEnum.REDUCER = { type: 3, value: "REDUCER" };
  IfcCableCarrierFittingTypeEnum.TEE = { type: 3, value: "TEE" };
  IfcCableCarrierFittingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCableCarrierFittingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcCableCarrierFittingTypeEnum = IfcCableCarrierFittingTypeEnum;
  class IfcCableCarrierSegmentTypeEnum {
  }
  IfcCableCarrierSegmentTypeEnum.CABLELADDERSEGMENT = { type: 3, value: "CABLELADDERSEGMENT" };
  IfcCableCarrierSegmentTypeEnum.CABLETRAYSEGMENT = { type: 3, value: "CABLETRAYSEGMENT" };
  IfcCableCarrierSegmentTypeEnum.CABLETRUNKINGSEGMENT = { type: 3, value: "CABLETRUNKINGSEGMENT" };
  IfcCableCarrierSegmentTypeEnum.CONDUITSEGMENT = { type: 3, value: "CONDUITSEGMENT" };
  IfcCableCarrierSegmentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCableCarrierSegmentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcCableCarrierSegmentTypeEnum = IfcCableCarrierSegmentTypeEnum;
  class IfcCableSegmentTypeEnum {
  }
  IfcCableSegmentTypeEnum.CABLESEGMENT = { type: 3, value: "CABLESEGMENT" };
  IfcCableSegmentTypeEnum.CONDUCTORSEGMENT = { type: 3, value: "CONDUCTORSEGMENT" };
  IfcCableSegmentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCableSegmentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcCableSegmentTypeEnum = IfcCableSegmentTypeEnum;
  class IfcChangeActionEnum {
  }
  IfcChangeActionEnum.NOCHANGE = { type: 3, value: "NOCHANGE" };
  IfcChangeActionEnum.MODIFIED = { type: 3, value: "MODIFIED" };
  IfcChangeActionEnum.ADDED = { type: 3, value: "ADDED" };
  IfcChangeActionEnum.DELETED = { type: 3, value: "DELETED" };
  IfcChangeActionEnum.MODIFIEDADDED = { type: 3, value: "MODIFIEDADDED" };
  IfcChangeActionEnum.MODIFIEDDELETED = { type: 3, value: "MODIFIEDDELETED" };
  IFC2X32.IfcChangeActionEnum = IfcChangeActionEnum;
  class IfcChillerTypeEnum {
  }
  IfcChillerTypeEnum.AIRCOOLED = { type: 3, value: "AIRCOOLED" };
  IfcChillerTypeEnum.WATERCOOLED = { type: 3, value: "WATERCOOLED" };
  IfcChillerTypeEnum.HEATRECOVERY = { type: 3, value: "HEATRECOVERY" };
  IfcChillerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcChillerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcChillerTypeEnum = IfcChillerTypeEnum;
  class IfcCoilTypeEnum {
  }
  IfcCoilTypeEnum.DXCOOLINGCOIL = { type: 3, value: "DXCOOLINGCOIL" };
  IfcCoilTypeEnum.WATERCOOLINGCOIL = { type: 3, value: "WATERCOOLINGCOIL" };
  IfcCoilTypeEnum.STEAMHEATINGCOIL = { type: 3, value: "STEAMHEATINGCOIL" };
  IfcCoilTypeEnum.WATERHEATINGCOIL = { type: 3, value: "WATERHEATINGCOIL" };
  IfcCoilTypeEnum.ELECTRICHEATINGCOIL = { type: 3, value: "ELECTRICHEATINGCOIL" };
  IfcCoilTypeEnum.GASHEATINGCOIL = { type: 3, value: "GASHEATINGCOIL" };
  IfcCoilTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCoilTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcCoilTypeEnum = IfcCoilTypeEnum;
  class IfcColumnTypeEnum {
  }
  IfcColumnTypeEnum.COLUMN = { type: 3, value: "COLUMN" };
  IfcColumnTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcColumnTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcColumnTypeEnum = IfcColumnTypeEnum;
  class IfcCompressorTypeEnum {
  }
  IfcCompressorTypeEnum.DYNAMIC = { type: 3, value: "DYNAMIC" };
  IfcCompressorTypeEnum.RECIPROCATING = { type: 3, value: "RECIPROCATING" };
  IfcCompressorTypeEnum.ROTARY = { type: 3, value: "ROTARY" };
  IfcCompressorTypeEnum.SCROLL = { type: 3, value: "SCROLL" };
  IfcCompressorTypeEnum.TROCHOIDAL = { type: 3, value: "TROCHOIDAL" };
  IfcCompressorTypeEnum.SINGLESTAGE = { type: 3, value: "SINGLESTAGE" };
  IfcCompressorTypeEnum.BOOSTER = { type: 3, value: "BOOSTER" };
  IfcCompressorTypeEnum.OPENTYPE = { type: 3, value: "OPENTYPE" };
  IfcCompressorTypeEnum.HERMETIC = { type: 3, value: "HERMETIC" };
  IfcCompressorTypeEnum.SEMIHERMETIC = { type: 3, value: "SEMIHERMETIC" };
  IfcCompressorTypeEnum.WELDEDSHELLHERMETIC = { type: 3, value: "WELDEDSHELLHERMETIC" };
  IfcCompressorTypeEnum.ROLLINGPISTON = { type: 3, value: "ROLLINGPISTON" };
  IfcCompressorTypeEnum.ROTARYVANE = { type: 3, value: "ROTARYVANE" };
  IfcCompressorTypeEnum.SINGLESCREW = { type: 3, value: "SINGLESCREW" };
  IfcCompressorTypeEnum.TWINSCREW = { type: 3, value: "TWINSCREW" };
  IfcCompressorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCompressorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcCompressorTypeEnum = IfcCompressorTypeEnum;
  class IfcCondenserTypeEnum {
  }
  IfcCondenserTypeEnum.WATERCOOLEDSHELLTUBE = { type: 3, value: "WATERCOOLEDSHELLTUBE" };
  IfcCondenserTypeEnum.WATERCOOLEDSHELLCOIL = { type: 3, value: "WATERCOOLEDSHELLCOIL" };
  IfcCondenserTypeEnum.WATERCOOLEDTUBEINTUBE = { type: 3, value: "WATERCOOLEDTUBEINTUBE" };
  IfcCondenserTypeEnum.WATERCOOLEDBRAZEDPLATE = { type: 3, value: "WATERCOOLEDBRAZEDPLATE" };
  IfcCondenserTypeEnum.AIRCOOLED = { type: 3, value: "AIRCOOLED" };
  IfcCondenserTypeEnum.EVAPORATIVECOOLED = { type: 3, value: "EVAPORATIVECOOLED" };
  IfcCondenserTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCondenserTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcCondenserTypeEnum = IfcCondenserTypeEnum;
  class IfcConnectionTypeEnum {
  }
  IfcConnectionTypeEnum.ATPATH = { type: 3, value: "ATPATH" };
  IfcConnectionTypeEnum.ATSTART = { type: 3, value: "ATSTART" };
  IfcConnectionTypeEnum.ATEND = { type: 3, value: "ATEND" };
  IfcConnectionTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcConnectionTypeEnum = IfcConnectionTypeEnum;
  class IfcConstraintEnum {
  }
  IfcConstraintEnum.HARD = { type: 3, value: "HARD" };
  IfcConstraintEnum.SOFT = { type: 3, value: "SOFT" };
  IfcConstraintEnum.ADVISORY = { type: 3, value: "ADVISORY" };
  IfcConstraintEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcConstraintEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcConstraintEnum = IfcConstraintEnum;
  class IfcControllerTypeEnum {
  }
  IfcControllerTypeEnum.FLOATING = { type: 3, value: "FLOATING" };
  IfcControllerTypeEnum.PROPORTIONAL = { type: 3, value: "PROPORTIONAL" };
  IfcControllerTypeEnum.PROPORTIONALINTEGRAL = { type: 3, value: "PROPORTIONALINTEGRAL" };
  IfcControllerTypeEnum.PROPORTIONALINTEGRALDERIVATIVE = { type: 3, value: "PROPORTIONALINTEGRALDERIVATIVE" };
  IfcControllerTypeEnum.TIMEDTWOPOSITION = { type: 3, value: "TIMEDTWOPOSITION" };
  IfcControllerTypeEnum.TWOPOSITION = { type: 3, value: "TWOPOSITION" };
  IfcControllerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcControllerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcControllerTypeEnum = IfcControllerTypeEnum;
  class IfcCooledBeamTypeEnum {
  }
  IfcCooledBeamTypeEnum.ACTIVE = { type: 3, value: "ACTIVE" };
  IfcCooledBeamTypeEnum.PASSIVE = { type: 3, value: "PASSIVE" };
  IfcCooledBeamTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCooledBeamTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcCooledBeamTypeEnum = IfcCooledBeamTypeEnum;
  class IfcCoolingTowerTypeEnum {
  }
  IfcCoolingTowerTypeEnum.NATURALDRAFT = { type: 3, value: "NATURALDRAFT" };
  IfcCoolingTowerTypeEnum.MECHANICALINDUCEDDRAFT = { type: 3, value: "MECHANICALINDUCEDDRAFT" };
  IfcCoolingTowerTypeEnum.MECHANICALFORCEDDRAFT = { type: 3, value: "MECHANICALFORCEDDRAFT" };
  IfcCoolingTowerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCoolingTowerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcCoolingTowerTypeEnum = IfcCoolingTowerTypeEnum;
  class IfcCostScheduleTypeEnum {
  }
  IfcCostScheduleTypeEnum.BUDGET = { type: 3, value: "BUDGET" };
  IfcCostScheduleTypeEnum.COSTPLAN = { type: 3, value: "COSTPLAN" };
  IfcCostScheduleTypeEnum.ESTIMATE = { type: 3, value: "ESTIMATE" };
  IfcCostScheduleTypeEnum.TENDER = { type: 3, value: "TENDER" };
  IfcCostScheduleTypeEnum.PRICEDBILLOFQUANTITIES = { type: 3, value: "PRICEDBILLOFQUANTITIES" };
  IfcCostScheduleTypeEnum.UNPRICEDBILLOFQUANTITIES = { type: 3, value: "UNPRICEDBILLOFQUANTITIES" };
  IfcCostScheduleTypeEnum.SCHEDULEOFRATES = { type: 3, value: "SCHEDULEOFRATES" };
  IfcCostScheduleTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCostScheduleTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcCostScheduleTypeEnum = IfcCostScheduleTypeEnum;
  class IfcCoveringTypeEnum {
  }
  IfcCoveringTypeEnum.CEILING = { type: 3, value: "CEILING" };
  IfcCoveringTypeEnum.FLOORING = { type: 3, value: "FLOORING" };
  IfcCoveringTypeEnum.CLADDING = { type: 3, value: "CLADDING" };
  IfcCoveringTypeEnum.ROOFING = { type: 3, value: "ROOFING" };
  IfcCoveringTypeEnum.INSULATION = { type: 3, value: "INSULATION" };
  IfcCoveringTypeEnum.MEMBRANE = { type: 3, value: "MEMBRANE" };
  IfcCoveringTypeEnum.SLEEVING = { type: 3, value: "SLEEVING" };
  IfcCoveringTypeEnum.WRAPPING = { type: 3, value: "WRAPPING" };
  IfcCoveringTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCoveringTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcCoveringTypeEnum = IfcCoveringTypeEnum;
  class IfcCurrencyEnum {
  }
  IfcCurrencyEnum.AED = { type: 3, value: "AED" };
  IfcCurrencyEnum.AES = { type: 3, value: "AES" };
  IfcCurrencyEnum.ATS = { type: 3, value: "ATS" };
  IfcCurrencyEnum.AUD = { type: 3, value: "AUD" };
  IfcCurrencyEnum.BBD = { type: 3, value: "BBD" };
  IfcCurrencyEnum.BEG = { type: 3, value: "BEG" };
  IfcCurrencyEnum.BGL = { type: 3, value: "BGL" };
  IfcCurrencyEnum.BHD = { type: 3, value: "BHD" };
  IfcCurrencyEnum.BMD = { type: 3, value: "BMD" };
  IfcCurrencyEnum.BND = { type: 3, value: "BND" };
  IfcCurrencyEnum.BRL = { type: 3, value: "BRL" };
  IfcCurrencyEnum.BSD = { type: 3, value: "BSD" };
  IfcCurrencyEnum.BWP = { type: 3, value: "BWP" };
  IfcCurrencyEnum.BZD = { type: 3, value: "BZD" };
  IfcCurrencyEnum.CAD = { type: 3, value: "CAD" };
  IfcCurrencyEnum.CBD = { type: 3, value: "CBD" };
  IfcCurrencyEnum.CHF = { type: 3, value: "CHF" };
  IfcCurrencyEnum.CLP = { type: 3, value: "CLP" };
  IfcCurrencyEnum.CNY = { type: 3, value: "CNY" };
  IfcCurrencyEnum.CYS = { type: 3, value: "CYS" };
  IfcCurrencyEnum.CZK = { type: 3, value: "CZK" };
  IfcCurrencyEnum.DDP = { type: 3, value: "DDP" };
  IfcCurrencyEnum.DEM = { type: 3, value: "DEM" };
  IfcCurrencyEnum.DKK = { type: 3, value: "DKK" };
  IfcCurrencyEnum.EGL = { type: 3, value: "EGL" };
  IfcCurrencyEnum.EST = { type: 3, value: "EST" };
  IfcCurrencyEnum.EUR = { type: 3, value: "EUR" };
  IfcCurrencyEnum.FAK = { type: 3, value: "FAK" };
  IfcCurrencyEnum.FIM = { type: 3, value: "FIM" };
  IfcCurrencyEnum.FJD = { type: 3, value: "FJD" };
  IfcCurrencyEnum.FKP = { type: 3, value: "FKP" };
  IfcCurrencyEnum.FRF = { type: 3, value: "FRF" };
  IfcCurrencyEnum.GBP = { type: 3, value: "GBP" };
  IfcCurrencyEnum.GIP = { type: 3, value: "GIP" };
  IfcCurrencyEnum.GMD = { type: 3, value: "GMD" };
  IfcCurrencyEnum.GRX = { type: 3, value: "GRX" };
  IfcCurrencyEnum.HKD = { type: 3, value: "HKD" };
  IfcCurrencyEnum.HUF = { type: 3, value: "HUF" };
  IfcCurrencyEnum.ICK = { type: 3, value: "ICK" };
  IfcCurrencyEnum.IDR = { type: 3, value: "IDR" };
  IfcCurrencyEnum.ILS = { type: 3, value: "ILS" };
  IfcCurrencyEnum.INR = { type: 3, value: "INR" };
  IfcCurrencyEnum.IRP = { type: 3, value: "IRP" };
  IfcCurrencyEnum.ITL = { type: 3, value: "ITL" };
  IfcCurrencyEnum.JMD = { type: 3, value: "JMD" };
  IfcCurrencyEnum.JOD = { type: 3, value: "JOD" };
  IfcCurrencyEnum.JPY = { type: 3, value: "JPY" };
  IfcCurrencyEnum.KES = { type: 3, value: "KES" };
  IfcCurrencyEnum.KRW = { type: 3, value: "KRW" };
  IfcCurrencyEnum.KWD = { type: 3, value: "KWD" };
  IfcCurrencyEnum.KYD = { type: 3, value: "KYD" };
  IfcCurrencyEnum.LKR = { type: 3, value: "LKR" };
  IfcCurrencyEnum.LUF = { type: 3, value: "LUF" };
  IfcCurrencyEnum.MTL = { type: 3, value: "MTL" };
  IfcCurrencyEnum.MUR = { type: 3, value: "MUR" };
  IfcCurrencyEnum.MXN = { type: 3, value: "MXN" };
  IfcCurrencyEnum.MYR = { type: 3, value: "MYR" };
  IfcCurrencyEnum.NLG = { type: 3, value: "NLG" };
  IfcCurrencyEnum.NZD = { type: 3, value: "NZD" };
  IfcCurrencyEnum.OMR = { type: 3, value: "OMR" };
  IfcCurrencyEnum.PGK = { type: 3, value: "PGK" };
  IfcCurrencyEnum.PHP = { type: 3, value: "PHP" };
  IfcCurrencyEnum.PKR = { type: 3, value: "PKR" };
  IfcCurrencyEnum.PLN = { type: 3, value: "PLN" };
  IfcCurrencyEnum.PTN = { type: 3, value: "PTN" };
  IfcCurrencyEnum.QAR = { type: 3, value: "QAR" };
  IfcCurrencyEnum.RUR = { type: 3, value: "RUR" };
  IfcCurrencyEnum.SAR = { type: 3, value: "SAR" };
  IfcCurrencyEnum.SCR = { type: 3, value: "SCR" };
  IfcCurrencyEnum.SEK = { type: 3, value: "SEK" };
  IfcCurrencyEnum.SGD = { type: 3, value: "SGD" };
  IfcCurrencyEnum.SKP = { type: 3, value: "SKP" };
  IfcCurrencyEnum.THB = { type: 3, value: "THB" };
  IfcCurrencyEnum.TRL = { type: 3, value: "TRL" };
  IfcCurrencyEnum.TTD = { type: 3, value: "TTD" };
  IfcCurrencyEnum.TWD = { type: 3, value: "TWD" };
  IfcCurrencyEnum.USD = { type: 3, value: "USD" };
  IfcCurrencyEnum.VEB = { type: 3, value: "VEB" };
  IfcCurrencyEnum.VND = { type: 3, value: "VND" };
  IfcCurrencyEnum.XEU = { type: 3, value: "XEU" };
  IfcCurrencyEnum.ZAR = { type: 3, value: "ZAR" };
  IfcCurrencyEnum.ZWD = { type: 3, value: "ZWD" };
  IfcCurrencyEnum.NOK = { type: 3, value: "NOK" };
  IFC2X32.IfcCurrencyEnum = IfcCurrencyEnum;
  class IfcCurtainWallTypeEnum {
  }
  IfcCurtainWallTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCurtainWallTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcCurtainWallTypeEnum = IfcCurtainWallTypeEnum;
  class IfcDamperTypeEnum {
  }
  IfcDamperTypeEnum.CONTROLDAMPER = { type: 3, value: "CONTROLDAMPER" };
  IfcDamperTypeEnum.FIREDAMPER = { type: 3, value: "FIREDAMPER" };
  IfcDamperTypeEnum.SMOKEDAMPER = { type: 3, value: "SMOKEDAMPER" };
  IfcDamperTypeEnum.FIRESMOKEDAMPER = { type: 3, value: "FIRESMOKEDAMPER" };
  IfcDamperTypeEnum.BACKDRAFTDAMPER = { type: 3, value: "BACKDRAFTDAMPER" };
  IfcDamperTypeEnum.RELIEFDAMPER = { type: 3, value: "RELIEFDAMPER" };
  IfcDamperTypeEnum.BLASTDAMPER = { type: 3, value: "BLASTDAMPER" };
  IfcDamperTypeEnum.GRAVITYDAMPER = { type: 3, value: "GRAVITYDAMPER" };
  IfcDamperTypeEnum.GRAVITYRELIEFDAMPER = { type: 3, value: "GRAVITYRELIEFDAMPER" };
  IfcDamperTypeEnum.BALANCINGDAMPER = { type: 3, value: "BALANCINGDAMPER" };
  IfcDamperTypeEnum.FUMEHOODEXHAUST = { type: 3, value: "FUMEHOODEXHAUST" };
  IfcDamperTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDamperTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcDamperTypeEnum = IfcDamperTypeEnum;
  class IfcDataOriginEnum {
  }
  IfcDataOriginEnum.MEASURED = { type: 3, value: "MEASURED" };
  IfcDataOriginEnum.PREDICTED = { type: 3, value: "PREDICTED" };
  IfcDataOriginEnum.SIMULATED = { type: 3, value: "SIMULATED" };
  IfcDataOriginEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDataOriginEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcDataOriginEnum = IfcDataOriginEnum;
  class IfcDerivedUnitEnum {
  }
  IfcDerivedUnitEnum.ANGULARVELOCITYUNIT = { type: 3, value: "ANGULARVELOCITYUNIT" };
  IfcDerivedUnitEnum.COMPOUNDPLANEANGLEUNIT = { type: 3, value: "COMPOUNDPLANEANGLEUNIT" };
  IfcDerivedUnitEnum.DYNAMICVISCOSITYUNIT = { type: 3, value: "DYNAMICVISCOSITYUNIT" };
  IfcDerivedUnitEnum.HEATFLUXDENSITYUNIT = { type: 3, value: "HEATFLUXDENSITYUNIT" };
  IfcDerivedUnitEnum.INTEGERCOUNTRATEUNIT = { type: 3, value: "INTEGERCOUNTRATEUNIT" };
  IfcDerivedUnitEnum.ISOTHERMALMOISTURECAPACITYUNIT = { type: 3, value: "ISOTHERMALMOISTURECAPACITYUNIT" };
  IfcDerivedUnitEnum.KINEMATICVISCOSITYUNIT = { type: 3, value: "KINEMATICVISCOSITYUNIT" };
  IfcDerivedUnitEnum.LINEARVELOCITYUNIT = { type: 3, value: "LINEARVELOCITYUNIT" };
  IfcDerivedUnitEnum.MASSDENSITYUNIT = { type: 3, value: "MASSDENSITYUNIT" };
  IfcDerivedUnitEnum.MASSFLOWRATEUNIT = { type: 3, value: "MASSFLOWRATEUNIT" };
  IfcDerivedUnitEnum.MOISTUREDIFFUSIVITYUNIT = { type: 3, value: "MOISTUREDIFFUSIVITYUNIT" };
  IfcDerivedUnitEnum.MOLECULARWEIGHTUNIT = { type: 3, value: "MOLECULARWEIGHTUNIT" };
  IfcDerivedUnitEnum.SPECIFICHEATCAPACITYUNIT = { type: 3, value: "SPECIFICHEATCAPACITYUNIT" };
  IfcDerivedUnitEnum.THERMALADMITTANCEUNIT = { type: 3, value: "THERMALADMITTANCEUNIT" };
  IfcDerivedUnitEnum.THERMALCONDUCTANCEUNIT = { type: 3, value: "THERMALCONDUCTANCEUNIT" };
  IfcDerivedUnitEnum.THERMALRESISTANCEUNIT = { type: 3, value: "THERMALRESISTANCEUNIT" };
  IfcDerivedUnitEnum.THERMALTRANSMITTANCEUNIT = { type: 3, value: "THERMALTRANSMITTANCEUNIT" };
  IfcDerivedUnitEnum.VAPORPERMEABILITYUNIT = { type: 3, value: "VAPORPERMEABILITYUNIT" };
  IfcDerivedUnitEnum.VOLUMETRICFLOWRATEUNIT = { type: 3, value: "VOLUMETRICFLOWRATEUNIT" };
  IfcDerivedUnitEnum.ROTATIONALFREQUENCYUNIT = { type: 3, value: "ROTATIONALFREQUENCYUNIT" };
  IfcDerivedUnitEnum.TORQUEUNIT = { type: 3, value: "TORQUEUNIT" };
  IfcDerivedUnitEnum.MOMENTOFINERTIAUNIT = { type: 3, value: "MOMENTOFINERTIAUNIT" };
  IfcDerivedUnitEnum.LINEARMOMENTUNIT = { type: 3, value: "LINEARMOMENTUNIT" };
  IfcDerivedUnitEnum.LINEARFORCEUNIT = { type: 3, value: "LINEARFORCEUNIT" };
  IfcDerivedUnitEnum.PLANARFORCEUNIT = { type: 3, value: "PLANARFORCEUNIT" };
  IfcDerivedUnitEnum.MODULUSOFELASTICITYUNIT = { type: 3, value: "MODULUSOFELASTICITYUNIT" };
  IfcDerivedUnitEnum.SHEARMODULUSUNIT = { type: 3, value: "SHEARMODULUSUNIT" };
  IfcDerivedUnitEnum.LINEARSTIFFNESSUNIT = { type: 3, value: "LINEARSTIFFNESSUNIT" };
  IfcDerivedUnitEnum.ROTATIONALSTIFFNESSUNIT = { type: 3, value: "ROTATIONALSTIFFNESSUNIT" };
  IfcDerivedUnitEnum.MODULUSOFSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFSUBGRADEREACTIONUNIT" };
  IfcDerivedUnitEnum.ACCELERATIONUNIT = { type: 3, value: "ACCELERATIONUNIT" };
  IfcDerivedUnitEnum.CURVATUREUNIT = { type: 3, value: "CURVATUREUNIT" };
  IfcDerivedUnitEnum.HEATINGVALUEUNIT = { type: 3, value: "HEATINGVALUEUNIT" };
  IfcDerivedUnitEnum.IONCONCENTRATIONUNIT = { type: 3, value: "IONCONCENTRATIONUNIT" };
  IfcDerivedUnitEnum.LUMINOUSINTENSITYDISTRIBUTIONUNIT = { type: 3, value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT" };
  IfcDerivedUnitEnum.MASSPERLENGTHUNIT = { type: 3, value: "MASSPERLENGTHUNIT" };
  IfcDerivedUnitEnum.MODULUSOFLINEARSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT" };
  IfcDerivedUnitEnum.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT" };
  IfcDerivedUnitEnum.PHUNIT = { type: 3, value: "PHUNIT" };
  IfcDerivedUnitEnum.ROTATIONALMASSUNIT = { type: 3, value: "ROTATIONALMASSUNIT" };
  IfcDerivedUnitEnum.SECTIONAREAINTEGRALUNIT = { type: 3, value: "SECTIONAREAINTEGRALUNIT" };
  IfcDerivedUnitEnum.SECTIONMODULUSUNIT = { type: 3, value: "SECTIONMODULUSUNIT" };
  IfcDerivedUnitEnum.SOUNDPOWERUNIT = { type: 3, value: "SOUNDPOWERUNIT" };
  IfcDerivedUnitEnum.SOUNDPRESSUREUNIT = { type: 3, value: "SOUNDPRESSUREUNIT" };
  IfcDerivedUnitEnum.TEMPERATUREGRADIENTUNIT = { type: 3, value: "TEMPERATUREGRADIENTUNIT" };
  IfcDerivedUnitEnum.THERMALEXPANSIONCOEFFICIENTUNIT = { type: 3, value: "THERMALEXPANSIONCOEFFICIENTUNIT" };
  IfcDerivedUnitEnum.WARPINGCONSTANTUNIT = { type: 3, value: "WARPINGCONSTANTUNIT" };
  IfcDerivedUnitEnum.WARPINGMOMENTUNIT = { type: 3, value: "WARPINGMOMENTUNIT" };
  IfcDerivedUnitEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IFC2X32.IfcDerivedUnitEnum = IfcDerivedUnitEnum;
  class IfcDimensionExtentUsage {
  }
  IfcDimensionExtentUsage.ORIGIN = { type: 3, value: "ORIGIN" };
  IfcDimensionExtentUsage.TARGET = { type: 3, value: "TARGET" };
  IFC2X32.IfcDimensionExtentUsage = IfcDimensionExtentUsage;
  class IfcDirectionSenseEnum {
  }
  IfcDirectionSenseEnum.POSITIVE = { type: 3, value: "POSITIVE" };
  IfcDirectionSenseEnum.NEGATIVE = { type: 3, value: "NEGATIVE" };
  IFC2X32.IfcDirectionSenseEnum = IfcDirectionSenseEnum;
  class IfcDistributionChamberElementTypeEnum {
  }
  IfcDistributionChamberElementTypeEnum.FORMEDDUCT = { type: 3, value: "FORMEDDUCT" };
  IfcDistributionChamberElementTypeEnum.INSPECTIONCHAMBER = { type: 3, value: "INSPECTIONCHAMBER" };
  IfcDistributionChamberElementTypeEnum.INSPECTIONPIT = { type: 3, value: "INSPECTIONPIT" };
  IfcDistributionChamberElementTypeEnum.MANHOLE = { type: 3, value: "MANHOLE" };
  IfcDistributionChamberElementTypeEnum.METERCHAMBER = { type: 3, value: "METERCHAMBER" };
  IfcDistributionChamberElementTypeEnum.SUMP = { type: 3, value: "SUMP" };
  IfcDistributionChamberElementTypeEnum.TRENCH = { type: 3, value: "TRENCH" };
  IfcDistributionChamberElementTypeEnum.VALVECHAMBER = { type: 3, value: "VALVECHAMBER" };
  IfcDistributionChamberElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDistributionChamberElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcDistributionChamberElementTypeEnum = IfcDistributionChamberElementTypeEnum;
  class IfcDocumentConfidentialityEnum {
  }
  IfcDocumentConfidentialityEnum.PUBLIC = { type: 3, value: "PUBLIC" };
  IfcDocumentConfidentialityEnum.RESTRICTED = { type: 3, value: "RESTRICTED" };
  IfcDocumentConfidentialityEnum.CONFIDENTIAL = { type: 3, value: "CONFIDENTIAL" };
  IfcDocumentConfidentialityEnum.PERSONAL = { type: 3, value: "PERSONAL" };
  IfcDocumentConfidentialityEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDocumentConfidentialityEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcDocumentConfidentialityEnum = IfcDocumentConfidentialityEnum;
  class IfcDocumentStatusEnum {
  }
  IfcDocumentStatusEnum.DRAFT = { type: 3, value: "DRAFT" };
  IfcDocumentStatusEnum.FINALDRAFT = { type: 3, value: "FINALDRAFT" };
  IfcDocumentStatusEnum.FINAL = { type: 3, value: "FINAL" };
  IfcDocumentStatusEnum.REVISION = { type: 3, value: "REVISION" };
  IfcDocumentStatusEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcDocumentStatusEnum = IfcDocumentStatusEnum;
  class IfcDoorPanelOperationEnum {
  }
  IfcDoorPanelOperationEnum.SWINGING = { type: 3, value: "SWINGING" };
  IfcDoorPanelOperationEnum.DOUBLE_ACTING = { type: 3, value: "DOUBLE_ACTING" };
  IfcDoorPanelOperationEnum.SLIDING = { type: 3, value: "SLIDING" };
  IfcDoorPanelOperationEnum.FOLDING = { type: 3, value: "FOLDING" };
  IfcDoorPanelOperationEnum.REVOLVING = { type: 3, value: "REVOLVING" };
  IfcDoorPanelOperationEnum.ROLLINGUP = { type: 3, value: "ROLLINGUP" };
  IfcDoorPanelOperationEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDoorPanelOperationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcDoorPanelOperationEnum = IfcDoorPanelOperationEnum;
  class IfcDoorPanelPositionEnum {
  }
  IfcDoorPanelPositionEnum.LEFT = { type: 3, value: "LEFT" };
  IfcDoorPanelPositionEnum.MIDDLE = { type: 3, value: "MIDDLE" };
  IfcDoorPanelPositionEnum.RIGHT = { type: 3, value: "RIGHT" };
  IfcDoorPanelPositionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcDoorPanelPositionEnum = IfcDoorPanelPositionEnum;
  class IfcDoorStyleConstructionEnum {
  }
  IfcDoorStyleConstructionEnum.ALUMINIUM = { type: 3, value: "ALUMINIUM" };
  IfcDoorStyleConstructionEnum.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" };
  IfcDoorStyleConstructionEnum.STEEL = { type: 3, value: "STEEL" };
  IfcDoorStyleConstructionEnum.WOOD = { type: 3, value: "WOOD" };
  IfcDoorStyleConstructionEnum.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" };
  IfcDoorStyleConstructionEnum.ALUMINIUM_PLASTIC = { type: 3, value: "ALUMINIUM_PLASTIC" };
  IfcDoorStyleConstructionEnum.PLASTIC = { type: 3, value: "PLASTIC" };
  IfcDoorStyleConstructionEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDoorStyleConstructionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcDoorStyleConstructionEnum = IfcDoorStyleConstructionEnum;
  class IfcDoorStyleOperationEnum {
  }
  IfcDoorStyleOperationEnum.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" };
  IfcDoorStyleOperationEnum.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING" };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT" };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT" };
  IfcDoorStyleOperationEnum.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" };
  IfcDoorStyleOperationEnum.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_DOUBLE_SWING = { type: 3, value: "DOUBLE_DOOR_DOUBLE_SWING" };
  IfcDoorStyleOperationEnum.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" };
  IfcDoorStyleOperationEnum.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SLIDING = { type: 3, value: "DOUBLE_DOOR_SLIDING" };
  IfcDoorStyleOperationEnum.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" };
  IfcDoorStyleOperationEnum.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_FOLDING = { type: 3, value: "DOUBLE_DOOR_FOLDING" };
  IfcDoorStyleOperationEnum.REVOLVING = { type: 3, value: "REVOLVING" };
  IfcDoorStyleOperationEnum.ROLLINGUP = { type: 3, value: "ROLLINGUP" };
  IfcDoorStyleOperationEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDoorStyleOperationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcDoorStyleOperationEnum = IfcDoorStyleOperationEnum;
  class IfcDuctFittingTypeEnum {
  }
  IfcDuctFittingTypeEnum.BEND = { type: 3, value: "BEND" };
  IfcDuctFittingTypeEnum.CONNECTOR = { type: 3, value: "CONNECTOR" };
  IfcDuctFittingTypeEnum.ENTRY = { type: 3, value: "ENTRY" };
  IfcDuctFittingTypeEnum.EXIT = { type: 3, value: "EXIT" };
  IfcDuctFittingTypeEnum.JUNCTION = { type: 3, value: "JUNCTION" };
  IfcDuctFittingTypeEnum.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" };
  IfcDuctFittingTypeEnum.TRANSITION = { type: 3, value: "TRANSITION" };
  IfcDuctFittingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDuctFittingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcDuctFittingTypeEnum = IfcDuctFittingTypeEnum;
  class IfcDuctSegmentTypeEnum {
  }
  IfcDuctSegmentTypeEnum.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" };
  IfcDuctSegmentTypeEnum.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" };
  IfcDuctSegmentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDuctSegmentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcDuctSegmentTypeEnum = IfcDuctSegmentTypeEnum;
  class IfcDuctSilencerTypeEnum {
  }
  IfcDuctSilencerTypeEnum.FLATOVAL = { type: 3, value: "FLATOVAL" };
  IfcDuctSilencerTypeEnum.RECTANGULAR = { type: 3, value: "RECTANGULAR" };
  IfcDuctSilencerTypeEnum.ROUND = { type: 3, value: "ROUND" };
  IfcDuctSilencerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDuctSilencerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcDuctSilencerTypeEnum = IfcDuctSilencerTypeEnum;
  class IfcElectricApplianceTypeEnum {
  }
  IfcElectricApplianceTypeEnum.COMPUTER = { type: 3, value: "COMPUTER" };
  IfcElectricApplianceTypeEnum.DIRECTWATERHEATER = { type: 3, value: "DIRECTWATERHEATER" };
  IfcElectricApplianceTypeEnum.DISHWASHER = { type: 3, value: "DISHWASHER" };
  IfcElectricApplianceTypeEnum.ELECTRICCOOKER = { type: 3, value: "ELECTRICCOOKER" };
  IfcElectricApplianceTypeEnum.ELECTRICHEATER = { type: 3, value: "ELECTRICHEATER" };
  IfcElectricApplianceTypeEnum.FACSIMILE = { type: 3, value: "FACSIMILE" };
  IfcElectricApplianceTypeEnum.FREESTANDINGFAN = { type: 3, value: "FREESTANDINGFAN" };
  IfcElectricApplianceTypeEnum.FREEZER = { type: 3, value: "FREEZER" };
  IfcElectricApplianceTypeEnum.FRIDGE_FREEZER = { type: 3, value: "FRIDGE_FREEZER" };
  IfcElectricApplianceTypeEnum.HANDDRYER = { type: 3, value: "HANDDRYER" };
  IfcElectricApplianceTypeEnum.INDIRECTWATERHEATER = { type: 3, value: "INDIRECTWATERHEATER" };
  IfcElectricApplianceTypeEnum.MICROWAVE = { type: 3, value: "MICROWAVE" };
  IfcElectricApplianceTypeEnum.PHOTOCOPIER = { type: 3, value: "PHOTOCOPIER" };
  IfcElectricApplianceTypeEnum.PRINTER = { type: 3, value: "PRINTER" };
  IfcElectricApplianceTypeEnum.REFRIGERATOR = { type: 3, value: "REFRIGERATOR" };
  IfcElectricApplianceTypeEnum.RADIANTHEATER = { type: 3, value: "RADIANTHEATER" };
  IfcElectricApplianceTypeEnum.SCANNER = { type: 3, value: "SCANNER" };
  IfcElectricApplianceTypeEnum.TELEPHONE = { type: 3, value: "TELEPHONE" };
  IfcElectricApplianceTypeEnum.TUMBLEDRYER = { type: 3, value: "TUMBLEDRYER" };
  IfcElectricApplianceTypeEnum.TV = { type: 3, value: "TV" };
  IfcElectricApplianceTypeEnum.VENDINGMACHINE = { type: 3, value: "VENDINGMACHINE" };
  IfcElectricApplianceTypeEnum.WASHINGMACHINE = { type: 3, value: "WASHINGMACHINE" };
  IfcElectricApplianceTypeEnum.WATERHEATER = { type: 3, value: "WATERHEATER" };
  IfcElectricApplianceTypeEnum.WATERCOOLER = { type: 3, value: "WATERCOOLER" };
  IfcElectricApplianceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricApplianceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcElectricApplianceTypeEnum = IfcElectricApplianceTypeEnum;
  class IfcElectricCurrentEnum {
  }
  IfcElectricCurrentEnum.ALTERNATING = { type: 3, value: "ALTERNATING" };
  IfcElectricCurrentEnum.DIRECT = { type: 3, value: "DIRECT" };
  IfcElectricCurrentEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcElectricCurrentEnum = IfcElectricCurrentEnum;
  class IfcElectricDistributionPointFunctionEnum {
  }
  IfcElectricDistributionPointFunctionEnum.ALARMPANEL = { type: 3, value: "ALARMPANEL" };
  IfcElectricDistributionPointFunctionEnum.CONSUMERUNIT = { type: 3, value: "CONSUMERUNIT" };
  IfcElectricDistributionPointFunctionEnum.CONTROLPANEL = { type: 3, value: "CONTROLPANEL" };
  IfcElectricDistributionPointFunctionEnum.DISTRIBUTIONBOARD = { type: 3, value: "DISTRIBUTIONBOARD" };
  IfcElectricDistributionPointFunctionEnum.GASDETECTORPANEL = { type: 3, value: "GASDETECTORPANEL" };
  IfcElectricDistributionPointFunctionEnum.INDICATORPANEL = { type: 3, value: "INDICATORPANEL" };
  IfcElectricDistributionPointFunctionEnum.MIMICPANEL = { type: 3, value: "MIMICPANEL" };
  IfcElectricDistributionPointFunctionEnum.MOTORCONTROLCENTRE = { type: 3, value: "MOTORCONTROLCENTRE" };
  IfcElectricDistributionPointFunctionEnum.SWITCHBOARD = { type: 3, value: "SWITCHBOARD" };
  IfcElectricDistributionPointFunctionEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricDistributionPointFunctionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcElectricDistributionPointFunctionEnum = IfcElectricDistributionPointFunctionEnum;
  class IfcElectricFlowStorageDeviceTypeEnum {
  }
  IfcElectricFlowStorageDeviceTypeEnum.BATTERY = { type: 3, value: "BATTERY" };
  IfcElectricFlowStorageDeviceTypeEnum.CAPACITORBANK = { type: 3, value: "CAPACITORBANK" };
  IfcElectricFlowStorageDeviceTypeEnum.HARMONICFILTER = { type: 3, value: "HARMONICFILTER" };
  IfcElectricFlowStorageDeviceTypeEnum.INDUCTORBANK = { type: 3, value: "INDUCTORBANK" };
  IfcElectricFlowStorageDeviceTypeEnum.UPS = { type: 3, value: "UPS" };
  IfcElectricFlowStorageDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricFlowStorageDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcElectricFlowStorageDeviceTypeEnum = IfcElectricFlowStorageDeviceTypeEnum;
  class IfcElectricGeneratorTypeEnum {
  }
  IfcElectricGeneratorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricGeneratorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcElectricGeneratorTypeEnum = IfcElectricGeneratorTypeEnum;
  class IfcElectricHeaterTypeEnum {
  }
  IfcElectricHeaterTypeEnum.ELECTRICPOINTHEATER = { type: 3, value: "ELECTRICPOINTHEATER" };
  IfcElectricHeaterTypeEnum.ELECTRICCABLEHEATER = { type: 3, value: "ELECTRICCABLEHEATER" };
  IfcElectricHeaterTypeEnum.ELECTRICMATHEATER = { type: 3, value: "ELECTRICMATHEATER" };
  IfcElectricHeaterTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricHeaterTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcElectricHeaterTypeEnum = IfcElectricHeaterTypeEnum;
  class IfcElectricMotorTypeEnum {
  }
  IfcElectricMotorTypeEnum.DC = { type: 3, value: "DC" };
  IfcElectricMotorTypeEnum.INDUCTION = { type: 3, value: "INDUCTION" };
  IfcElectricMotorTypeEnum.POLYPHASE = { type: 3, value: "POLYPHASE" };
  IfcElectricMotorTypeEnum.RELUCTANCESYNCHRONOUS = { type: 3, value: "RELUCTANCESYNCHRONOUS" };
  IfcElectricMotorTypeEnum.SYNCHRONOUS = { type: 3, value: "SYNCHRONOUS" };
  IfcElectricMotorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricMotorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcElectricMotorTypeEnum = IfcElectricMotorTypeEnum;
  class IfcElectricTimeControlTypeEnum {
  }
  IfcElectricTimeControlTypeEnum.TIMECLOCK = { type: 3, value: "TIMECLOCK" };
  IfcElectricTimeControlTypeEnum.TIMEDELAY = { type: 3, value: "TIMEDELAY" };
  IfcElectricTimeControlTypeEnum.RELAY = { type: 3, value: "RELAY" };
  IfcElectricTimeControlTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricTimeControlTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcElectricTimeControlTypeEnum = IfcElectricTimeControlTypeEnum;
  class IfcElementAssemblyTypeEnum {
  }
  IfcElementAssemblyTypeEnum.ACCESSORY_ASSEMBLY = { type: 3, value: "ACCESSORY_ASSEMBLY" };
  IfcElementAssemblyTypeEnum.ARCH = { type: 3, value: "ARCH" };
  IfcElementAssemblyTypeEnum.BEAM_GRID = { type: 3, value: "BEAM_GRID" };
  IfcElementAssemblyTypeEnum.BRACED_FRAME = { type: 3, value: "BRACED_FRAME" };
  IfcElementAssemblyTypeEnum.GIRDER = { type: 3, value: "GIRDER" };
  IfcElementAssemblyTypeEnum.REINFORCEMENT_UNIT = { type: 3, value: "REINFORCEMENT_UNIT" };
  IfcElementAssemblyTypeEnum.RIGID_FRAME = { type: 3, value: "RIGID_FRAME" };
  IfcElementAssemblyTypeEnum.SLAB_FIELD = { type: 3, value: "SLAB_FIELD" };
  IfcElementAssemblyTypeEnum.TRUSS = { type: 3, value: "TRUSS" };
  IfcElementAssemblyTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElementAssemblyTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcElementAssemblyTypeEnum = IfcElementAssemblyTypeEnum;
  class IfcElementCompositionEnum {
  }
  IfcElementCompositionEnum.COMPLEX = { type: 3, value: "COMPLEX" };
  IfcElementCompositionEnum.ELEMENT = { type: 3, value: "ELEMENT" };
  IfcElementCompositionEnum.PARTIAL = { type: 3, value: "PARTIAL" };
  IFC2X32.IfcElementCompositionEnum = IfcElementCompositionEnum;
  class IfcEnergySequenceEnum {
  }
  IfcEnergySequenceEnum.PRIMARY = { type: 3, value: "PRIMARY" };
  IfcEnergySequenceEnum.SECONDARY = { type: 3, value: "SECONDARY" };
  IfcEnergySequenceEnum.TERTIARY = { type: 3, value: "TERTIARY" };
  IfcEnergySequenceEnum.AUXILIARY = { type: 3, value: "AUXILIARY" };
  IfcEnergySequenceEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcEnergySequenceEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcEnergySequenceEnum = IfcEnergySequenceEnum;
  class IfcEnvironmentalImpactCategoryEnum {
  }
  IfcEnvironmentalImpactCategoryEnum.COMBINEDVALUE = { type: 3, value: "COMBINEDVALUE" };
  IfcEnvironmentalImpactCategoryEnum.DISPOSAL = { type: 3, value: "DISPOSAL" };
  IfcEnvironmentalImpactCategoryEnum.EXTRACTION = { type: 3, value: "EXTRACTION" };
  IfcEnvironmentalImpactCategoryEnum.INSTALLATION = { type: 3, value: "INSTALLATION" };
  IfcEnvironmentalImpactCategoryEnum.MANUFACTURE = { type: 3, value: "MANUFACTURE" };
  IfcEnvironmentalImpactCategoryEnum.TRANSPORTATION = { type: 3, value: "TRANSPORTATION" };
  IfcEnvironmentalImpactCategoryEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcEnvironmentalImpactCategoryEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcEnvironmentalImpactCategoryEnum = IfcEnvironmentalImpactCategoryEnum;
  class IfcEvaporativeCoolerTypeEnum {
  }
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER" };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER" };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER" };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER" };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVEAIRWASHER = { type: 3, value: "DIRECTEVAPORATIVEAIRWASHER" };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = { type: 3, value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER" };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVEWETCOIL = { type: 3, value: "INDIRECTEVAPORATIVEWETCOIL" };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = { type: 3, value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER" };
  IfcEvaporativeCoolerTypeEnum.INDIRECTDIRECTCOMBINATION = { type: 3, value: "INDIRECTDIRECTCOMBINATION" };
  IfcEvaporativeCoolerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcEvaporativeCoolerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcEvaporativeCoolerTypeEnum = IfcEvaporativeCoolerTypeEnum;
  class IfcEvaporatorTypeEnum {
  }
  IfcEvaporatorTypeEnum.DIRECTEXPANSIONSHELLANDTUBE = { type: 3, value: "DIRECTEXPANSIONSHELLANDTUBE" };
  IfcEvaporatorTypeEnum.DIRECTEXPANSIONTUBEINTUBE = { type: 3, value: "DIRECTEXPANSIONTUBEINTUBE" };
  IfcEvaporatorTypeEnum.DIRECTEXPANSIONBRAZEDPLATE = { type: 3, value: "DIRECTEXPANSIONBRAZEDPLATE" };
  IfcEvaporatorTypeEnum.FLOODEDSHELLANDTUBE = { type: 3, value: "FLOODEDSHELLANDTUBE" };
  IfcEvaporatorTypeEnum.SHELLANDCOIL = { type: 3, value: "SHELLANDCOIL" };
  IfcEvaporatorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcEvaporatorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcEvaporatorTypeEnum = IfcEvaporatorTypeEnum;
  class IfcFanTypeEnum {
  }
  IfcFanTypeEnum.CENTRIFUGALFORWARDCURVED = { type: 3, value: "CENTRIFUGALFORWARDCURVED" };
  IfcFanTypeEnum.CENTRIFUGALRADIAL = { type: 3, value: "CENTRIFUGALRADIAL" };
  IfcFanTypeEnum.CENTRIFUGALBACKWARDINCLINEDCURVED = { type: 3, value: "CENTRIFUGALBACKWARDINCLINEDCURVED" };
  IfcFanTypeEnum.CENTRIFUGALAIRFOIL = { type: 3, value: "CENTRIFUGALAIRFOIL" };
  IfcFanTypeEnum.TUBEAXIAL = { type: 3, value: "TUBEAXIAL" };
  IfcFanTypeEnum.VANEAXIAL = { type: 3, value: "VANEAXIAL" };
  IfcFanTypeEnum.PROPELLORAXIAL = { type: 3, value: "PROPELLORAXIAL" };
  IfcFanTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFanTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcFanTypeEnum = IfcFanTypeEnum;
  class IfcFilterTypeEnum {
  }
  IfcFilterTypeEnum.AIRPARTICLEFILTER = { type: 3, value: "AIRPARTICLEFILTER" };
  IfcFilterTypeEnum.ODORFILTER = { type: 3, value: "ODORFILTER" };
  IfcFilterTypeEnum.OILFILTER = { type: 3, value: "OILFILTER" };
  IfcFilterTypeEnum.STRAINER = { type: 3, value: "STRAINER" };
  IfcFilterTypeEnum.WATERFILTER = { type: 3, value: "WATERFILTER" };
  IfcFilterTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFilterTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcFilterTypeEnum = IfcFilterTypeEnum;
  class IfcFireSuppressionTerminalTypeEnum {
  }
  IfcFireSuppressionTerminalTypeEnum.BREECHINGINLET = { type: 3, value: "BREECHINGINLET" };
  IfcFireSuppressionTerminalTypeEnum.FIREHYDRANT = { type: 3, value: "FIREHYDRANT" };
  IfcFireSuppressionTerminalTypeEnum.HOSEREEL = { type: 3, value: "HOSEREEL" };
  IfcFireSuppressionTerminalTypeEnum.SPRINKLER = { type: 3, value: "SPRINKLER" };
  IfcFireSuppressionTerminalTypeEnum.SPRINKLERDEFLECTOR = { type: 3, value: "SPRINKLERDEFLECTOR" };
  IfcFireSuppressionTerminalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFireSuppressionTerminalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcFireSuppressionTerminalTypeEnum = IfcFireSuppressionTerminalTypeEnum;
  class IfcFlowDirectionEnum {
  }
  IfcFlowDirectionEnum.SOURCE = { type: 3, value: "SOURCE" };
  IfcFlowDirectionEnum.SINK = { type: 3, value: "SINK" };
  IfcFlowDirectionEnum.SOURCEANDSINK = { type: 3, value: "SOURCEANDSINK" };
  IfcFlowDirectionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcFlowDirectionEnum = IfcFlowDirectionEnum;
  class IfcFlowInstrumentTypeEnum {
  }
  IfcFlowInstrumentTypeEnum.PRESSUREGAUGE = { type: 3, value: "PRESSUREGAUGE" };
  IfcFlowInstrumentTypeEnum.THERMOMETER = { type: 3, value: "THERMOMETER" };
  IfcFlowInstrumentTypeEnum.AMMETER = { type: 3, value: "AMMETER" };
  IfcFlowInstrumentTypeEnum.FREQUENCYMETER = { type: 3, value: "FREQUENCYMETER" };
  IfcFlowInstrumentTypeEnum.POWERFACTORMETER = { type: 3, value: "POWERFACTORMETER" };
  IfcFlowInstrumentTypeEnum.PHASEANGLEMETER = { type: 3, value: "PHASEANGLEMETER" };
  IfcFlowInstrumentTypeEnum.VOLTMETER_PEAK = { type: 3, value: "VOLTMETER_PEAK" };
  IfcFlowInstrumentTypeEnum.VOLTMETER_RMS = { type: 3, value: "VOLTMETER_RMS" };
  IfcFlowInstrumentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFlowInstrumentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcFlowInstrumentTypeEnum = IfcFlowInstrumentTypeEnum;
  class IfcFlowMeterTypeEnum {
  }
  IfcFlowMeterTypeEnum.ELECTRICMETER = { type: 3, value: "ELECTRICMETER" };
  IfcFlowMeterTypeEnum.ENERGYMETER = { type: 3, value: "ENERGYMETER" };
  IfcFlowMeterTypeEnum.FLOWMETER = { type: 3, value: "FLOWMETER" };
  IfcFlowMeterTypeEnum.GASMETER = { type: 3, value: "GASMETER" };
  IfcFlowMeterTypeEnum.OILMETER = { type: 3, value: "OILMETER" };
  IfcFlowMeterTypeEnum.WATERMETER = { type: 3, value: "WATERMETER" };
  IfcFlowMeterTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFlowMeterTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcFlowMeterTypeEnum = IfcFlowMeterTypeEnum;
  class IfcFootingTypeEnum {
  }
  IfcFootingTypeEnum.FOOTING_BEAM = { type: 3, value: "FOOTING_BEAM" };
  IfcFootingTypeEnum.PAD_FOOTING = { type: 3, value: "PAD_FOOTING" };
  IfcFootingTypeEnum.PILE_CAP = { type: 3, value: "PILE_CAP" };
  IfcFootingTypeEnum.STRIP_FOOTING = { type: 3, value: "STRIP_FOOTING" };
  IfcFootingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFootingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcFootingTypeEnum = IfcFootingTypeEnum;
  class IfcGasTerminalTypeEnum {
  }
  IfcGasTerminalTypeEnum.GASAPPLIANCE = { type: 3, value: "GASAPPLIANCE" };
  IfcGasTerminalTypeEnum.GASBOOSTER = { type: 3, value: "GASBOOSTER" };
  IfcGasTerminalTypeEnum.GASBURNER = { type: 3, value: "GASBURNER" };
  IfcGasTerminalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcGasTerminalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcGasTerminalTypeEnum = IfcGasTerminalTypeEnum;
  class IfcGeometricProjectionEnum {
  }
  IfcGeometricProjectionEnum.GRAPH_VIEW = { type: 3, value: "GRAPH_VIEW" };
  IfcGeometricProjectionEnum.SKETCH_VIEW = { type: 3, value: "SKETCH_VIEW" };
  IfcGeometricProjectionEnum.MODEL_VIEW = { type: 3, value: "MODEL_VIEW" };
  IfcGeometricProjectionEnum.PLAN_VIEW = { type: 3, value: "PLAN_VIEW" };
  IfcGeometricProjectionEnum.REFLECTED_PLAN_VIEW = { type: 3, value: "REFLECTED_PLAN_VIEW" };
  IfcGeometricProjectionEnum.SECTION_VIEW = { type: 3, value: "SECTION_VIEW" };
  IfcGeometricProjectionEnum.ELEVATION_VIEW = { type: 3, value: "ELEVATION_VIEW" };
  IfcGeometricProjectionEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcGeometricProjectionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcGeometricProjectionEnum = IfcGeometricProjectionEnum;
  class IfcGlobalOrLocalEnum {
  }
  IfcGlobalOrLocalEnum.GLOBAL_COORDS = { type: 3, value: "GLOBAL_COORDS" };
  IfcGlobalOrLocalEnum.LOCAL_COORDS = { type: 3, value: "LOCAL_COORDS" };
  IFC2X32.IfcGlobalOrLocalEnum = IfcGlobalOrLocalEnum;
  class IfcHeatExchangerTypeEnum {
  }
  IfcHeatExchangerTypeEnum.PLATE = { type: 3, value: "PLATE" };
  IfcHeatExchangerTypeEnum.SHELLANDTUBE = { type: 3, value: "SHELLANDTUBE" };
  IfcHeatExchangerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcHeatExchangerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcHeatExchangerTypeEnum = IfcHeatExchangerTypeEnum;
  class IfcHumidifierTypeEnum {
  }
  IfcHumidifierTypeEnum.STEAMINJECTION = { type: 3, value: "STEAMINJECTION" };
  IfcHumidifierTypeEnum.ADIABATICAIRWASHER = { type: 3, value: "ADIABATICAIRWASHER" };
  IfcHumidifierTypeEnum.ADIABATICPAN = { type: 3, value: "ADIABATICPAN" };
  IfcHumidifierTypeEnum.ADIABATICWETTEDELEMENT = { type: 3, value: "ADIABATICWETTEDELEMENT" };
  IfcHumidifierTypeEnum.ADIABATICATOMIZING = { type: 3, value: "ADIABATICATOMIZING" };
  IfcHumidifierTypeEnum.ADIABATICULTRASONIC = { type: 3, value: "ADIABATICULTRASONIC" };
  IfcHumidifierTypeEnum.ADIABATICRIGIDMEDIA = { type: 3, value: "ADIABATICRIGIDMEDIA" };
  IfcHumidifierTypeEnum.ADIABATICCOMPRESSEDAIRNOZZLE = { type: 3, value: "ADIABATICCOMPRESSEDAIRNOZZLE" };
  IfcHumidifierTypeEnum.ASSISTEDELECTRIC = { type: 3, value: "ASSISTEDELECTRIC" };
  IfcHumidifierTypeEnum.ASSISTEDNATURALGAS = { type: 3, value: "ASSISTEDNATURALGAS" };
  IfcHumidifierTypeEnum.ASSISTEDPROPANE = { type: 3, value: "ASSISTEDPROPANE" };
  IfcHumidifierTypeEnum.ASSISTEDBUTANE = { type: 3, value: "ASSISTEDBUTANE" };
  IfcHumidifierTypeEnum.ASSISTEDSTEAM = { type: 3, value: "ASSISTEDSTEAM" };
  IfcHumidifierTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcHumidifierTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcHumidifierTypeEnum = IfcHumidifierTypeEnum;
  class IfcInternalOrExternalEnum {
  }
  IfcInternalOrExternalEnum.INTERNAL = { type: 3, value: "INTERNAL" };
  IfcInternalOrExternalEnum.EXTERNAL = { type: 3, value: "EXTERNAL" };
  IfcInternalOrExternalEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcInternalOrExternalEnum = IfcInternalOrExternalEnum;
  class IfcInventoryTypeEnum {
  }
  IfcInventoryTypeEnum.ASSETINVENTORY = { type: 3, value: "ASSETINVENTORY" };
  IfcInventoryTypeEnum.SPACEINVENTORY = { type: 3, value: "SPACEINVENTORY" };
  IfcInventoryTypeEnum.FURNITUREINVENTORY = { type: 3, value: "FURNITUREINVENTORY" };
  IfcInventoryTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcInventoryTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcInventoryTypeEnum = IfcInventoryTypeEnum;
  class IfcJunctionBoxTypeEnum {
  }
  IfcJunctionBoxTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcJunctionBoxTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcJunctionBoxTypeEnum = IfcJunctionBoxTypeEnum;
  class IfcLampTypeEnum {
  }
  IfcLampTypeEnum.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" };
  IfcLampTypeEnum.FLUORESCENT = { type: 3, value: "FLUORESCENT" };
  IfcLampTypeEnum.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" };
  IfcLampTypeEnum.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" };
  IfcLampTypeEnum.METALHALIDE = { type: 3, value: "METALHALIDE" };
  IfcLampTypeEnum.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" };
  IfcLampTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcLampTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcLampTypeEnum = IfcLampTypeEnum;
  class IfcLayerSetDirectionEnum {
  }
  IfcLayerSetDirectionEnum.AXIS1 = { type: 3, value: "AXIS1" };
  IfcLayerSetDirectionEnum.AXIS2 = { type: 3, value: "AXIS2" };
  IfcLayerSetDirectionEnum.AXIS3 = { type: 3, value: "AXIS3" };
  IFC2X32.IfcLayerSetDirectionEnum = IfcLayerSetDirectionEnum;
  class IfcLightDistributionCurveEnum {
  }
  IfcLightDistributionCurveEnum.TYPE_A = { type: 3, value: "TYPE_A" };
  IfcLightDistributionCurveEnum.TYPE_B = { type: 3, value: "TYPE_B" };
  IfcLightDistributionCurveEnum.TYPE_C = { type: 3, value: "TYPE_C" };
  IfcLightDistributionCurveEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcLightDistributionCurveEnum = IfcLightDistributionCurveEnum;
  class IfcLightEmissionSourceEnum {
  }
  IfcLightEmissionSourceEnum.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" };
  IfcLightEmissionSourceEnum.FLUORESCENT = { type: 3, value: "FLUORESCENT" };
  IfcLightEmissionSourceEnum.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" };
  IfcLightEmissionSourceEnum.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" };
  IfcLightEmissionSourceEnum.LIGHTEMITTINGDIODE = { type: 3, value: "LIGHTEMITTINGDIODE" };
  IfcLightEmissionSourceEnum.LOWPRESSURESODIUM = { type: 3, value: "LOWPRESSURESODIUM" };
  IfcLightEmissionSourceEnum.LOWVOLTAGEHALOGEN = { type: 3, value: "LOWVOLTAGEHALOGEN" };
  IfcLightEmissionSourceEnum.MAINVOLTAGEHALOGEN = { type: 3, value: "MAINVOLTAGEHALOGEN" };
  IfcLightEmissionSourceEnum.METALHALIDE = { type: 3, value: "METALHALIDE" };
  IfcLightEmissionSourceEnum.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" };
  IfcLightEmissionSourceEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcLightEmissionSourceEnum = IfcLightEmissionSourceEnum;
  class IfcLightFixtureTypeEnum {
  }
  IfcLightFixtureTypeEnum.POINTSOURCE = { type: 3, value: "POINTSOURCE" };
  IfcLightFixtureTypeEnum.DIRECTIONSOURCE = { type: 3, value: "DIRECTIONSOURCE" };
  IfcLightFixtureTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcLightFixtureTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcLightFixtureTypeEnum = IfcLightFixtureTypeEnum;
  class IfcLoadGroupTypeEnum {
  }
  IfcLoadGroupTypeEnum.LOAD_GROUP = { type: 3, value: "LOAD_GROUP" };
  IfcLoadGroupTypeEnum.LOAD_CASE = { type: 3, value: "LOAD_CASE" };
  IfcLoadGroupTypeEnum.LOAD_COMBINATION_GROUP = { type: 3, value: "LOAD_COMBINATION_GROUP" };
  IfcLoadGroupTypeEnum.LOAD_COMBINATION = { type: 3, value: "LOAD_COMBINATION" };
  IfcLoadGroupTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcLoadGroupTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcLoadGroupTypeEnum = IfcLoadGroupTypeEnum;
  class IfcLogicalOperatorEnum {
  }
  IfcLogicalOperatorEnum.LOGICALAND = { type: 3, value: "LOGICALAND" };
  IfcLogicalOperatorEnum.LOGICALOR = { type: 3, value: "LOGICALOR" };
  IFC2X32.IfcLogicalOperatorEnum = IfcLogicalOperatorEnum;
  class IfcMemberTypeEnum {
  }
  IfcMemberTypeEnum.BRACE = { type: 3, value: "BRACE" };
  IfcMemberTypeEnum.CHORD = { type: 3, value: "CHORD" };
  IfcMemberTypeEnum.COLLAR = { type: 3, value: "COLLAR" };
  IfcMemberTypeEnum.MEMBER = { type: 3, value: "MEMBER" };
  IfcMemberTypeEnum.MULLION = { type: 3, value: "MULLION" };
  IfcMemberTypeEnum.PLATE = { type: 3, value: "PLATE" };
  IfcMemberTypeEnum.POST = { type: 3, value: "POST" };
  IfcMemberTypeEnum.PURLIN = { type: 3, value: "PURLIN" };
  IfcMemberTypeEnum.RAFTER = { type: 3, value: "RAFTER" };
  IfcMemberTypeEnum.STRINGER = { type: 3, value: "STRINGER" };
  IfcMemberTypeEnum.STRUT = { type: 3, value: "STRUT" };
  IfcMemberTypeEnum.STUD = { type: 3, value: "STUD" };
  IfcMemberTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcMemberTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcMemberTypeEnum = IfcMemberTypeEnum;
  class IfcMotorConnectionTypeEnum {
  }
  IfcMotorConnectionTypeEnum.BELTDRIVE = { type: 3, value: "BELTDRIVE" };
  IfcMotorConnectionTypeEnum.COUPLING = { type: 3, value: "COUPLING" };
  IfcMotorConnectionTypeEnum.DIRECTDRIVE = { type: 3, value: "DIRECTDRIVE" };
  IfcMotorConnectionTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcMotorConnectionTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcMotorConnectionTypeEnum = IfcMotorConnectionTypeEnum;
  class IfcNullStyle {
  }
  IfcNullStyle.NULL = { type: 3, value: "NULL" };
  IFC2X32.IfcNullStyle = IfcNullStyle;
  class IfcObjectTypeEnum {
  }
  IfcObjectTypeEnum.PRODUCT = { type: 3, value: "PRODUCT" };
  IfcObjectTypeEnum.PROCESS = { type: 3, value: "PROCESS" };
  IfcObjectTypeEnum.CONTROL = { type: 3, value: "CONTROL" };
  IfcObjectTypeEnum.RESOURCE = { type: 3, value: "RESOURCE" };
  IfcObjectTypeEnum.ACTOR = { type: 3, value: "ACTOR" };
  IfcObjectTypeEnum.GROUP = { type: 3, value: "GROUP" };
  IfcObjectTypeEnum.PROJECT = { type: 3, value: "PROJECT" };
  IfcObjectTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcObjectTypeEnum = IfcObjectTypeEnum;
  class IfcObjectiveEnum {
  }
  IfcObjectiveEnum.CODECOMPLIANCE = { type: 3, value: "CODECOMPLIANCE" };
  IfcObjectiveEnum.DESIGNINTENT = { type: 3, value: "DESIGNINTENT" };
  IfcObjectiveEnum.HEALTHANDSAFETY = { type: 3, value: "HEALTHANDSAFETY" };
  IfcObjectiveEnum.REQUIREMENT = { type: 3, value: "REQUIREMENT" };
  IfcObjectiveEnum.SPECIFICATION = { type: 3, value: "SPECIFICATION" };
  IfcObjectiveEnum.TRIGGERCONDITION = { type: 3, value: "TRIGGERCONDITION" };
  IfcObjectiveEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcObjectiveEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcObjectiveEnum = IfcObjectiveEnum;
  class IfcOccupantTypeEnum {
  }
  IfcOccupantTypeEnum.ASSIGNEE = { type: 3, value: "ASSIGNEE" };
  IfcOccupantTypeEnum.ASSIGNOR = { type: 3, value: "ASSIGNOR" };
  IfcOccupantTypeEnum.LESSEE = { type: 3, value: "LESSEE" };
  IfcOccupantTypeEnum.LESSOR = { type: 3, value: "LESSOR" };
  IfcOccupantTypeEnum.LETTINGAGENT = { type: 3, value: "LETTINGAGENT" };
  IfcOccupantTypeEnum.OWNER = { type: 3, value: "OWNER" };
  IfcOccupantTypeEnum.TENANT = { type: 3, value: "TENANT" };
  IfcOccupantTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcOccupantTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcOccupantTypeEnum = IfcOccupantTypeEnum;
  class IfcOutletTypeEnum {
  }
  IfcOutletTypeEnum.AUDIOVISUALOUTLET = { type: 3, value: "AUDIOVISUALOUTLET" };
  IfcOutletTypeEnum.COMMUNICATIONSOUTLET = { type: 3, value: "COMMUNICATIONSOUTLET" };
  IfcOutletTypeEnum.POWEROUTLET = { type: 3, value: "POWEROUTLET" };
  IfcOutletTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcOutletTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcOutletTypeEnum = IfcOutletTypeEnum;
  class IfcPermeableCoveringOperationEnum {
  }
  IfcPermeableCoveringOperationEnum.GRILL = { type: 3, value: "GRILL" };
  IfcPermeableCoveringOperationEnum.LOUVER = { type: 3, value: "LOUVER" };
  IfcPermeableCoveringOperationEnum.SCREEN = { type: 3, value: "SCREEN" };
  IfcPermeableCoveringOperationEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPermeableCoveringOperationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcPermeableCoveringOperationEnum = IfcPermeableCoveringOperationEnum;
  class IfcPhysicalOrVirtualEnum {
  }
  IfcPhysicalOrVirtualEnum.PHYSICAL = { type: 3, value: "PHYSICAL" };
  IfcPhysicalOrVirtualEnum.VIRTUAL = { type: 3, value: "VIRTUAL" };
  IfcPhysicalOrVirtualEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcPhysicalOrVirtualEnum = IfcPhysicalOrVirtualEnum;
  class IfcPileConstructionEnum {
  }
  IfcPileConstructionEnum.CAST_IN_PLACE = { type: 3, value: "CAST_IN_PLACE" };
  IfcPileConstructionEnum.COMPOSITE = { type: 3, value: "COMPOSITE" };
  IfcPileConstructionEnum.PRECAST_CONCRETE = { type: 3, value: "PRECAST_CONCRETE" };
  IfcPileConstructionEnum.PREFAB_STEEL = { type: 3, value: "PREFAB_STEEL" };
  IfcPileConstructionEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPileConstructionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcPileConstructionEnum = IfcPileConstructionEnum;
  class IfcPileTypeEnum {
  }
  IfcPileTypeEnum.COHESION = { type: 3, value: "COHESION" };
  IfcPileTypeEnum.FRICTION = { type: 3, value: "FRICTION" };
  IfcPileTypeEnum.SUPPORT = { type: 3, value: "SUPPORT" };
  IfcPileTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPileTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcPileTypeEnum = IfcPileTypeEnum;
  class IfcPipeFittingTypeEnum {
  }
  IfcPipeFittingTypeEnum.BEND = { type: 3, value: "BEND" };
  IfcPipeFittingTypeEnum.CONNECTOR = { type: 3, value: "CONNECTOR" };
  IfcPipeFittingTypeEnum.ENTRY = { type: 3, value: "ENTRY" };
  IfcPipeFittingTypeEnum.EXIT = { type: 3, value: "EXIT" };
  IfcPipeFittingTypeEnum.JUNCTION = { type: 3, value: "JUNCTION" };
  IfcPipeFittingTypeEnum.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" };
  IfcPipeFittingTypeEnum.TRANSITION = { type: 3, value: "TRANSITION" };
  IfcPipeFittingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPipeFittingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcPipeFittingTypeEnum = IfcPipeFittingTypeEnum;
  class IfcPipeSegmentTypeEnum {
  }
  IfcPipeSegmentTypeEnum.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" };
  IfcPipeSegmentTypeEnum.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" };
  IfcPipeSegmentTypeEnum.GUTTER = { type: 3, value: "GUTTER" };
  IfcPipeSegmentTypeEnum.SPOOL = { type: 3, value: "SPOOL" };
  IfcPipeSegmentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPipeSegmentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcPipeSegmentTypeEnum = IfcPipeSegmentTypeEnum;
  class IfcPlateTypeEnum {
  }
  IfcPlateTypeEnum.CURTAIN_PANEL = { type: 3, value: "CURTAIN_PANEL" };
  IfcPlateTypeEnum.SHEET = { type: 3, value: "SHEET" };
  IfcPlateTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPlateTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcPlateTypeEnum = IfcPlateTypeEnum;
  class IfcProcedureTypeEnum {
  }
  IfcProcedureTypeEnum.ADVICE_CAUTION = { type: 3, value: "ADVICE_CAUTION" };
  IfcProcedureTypeEnum.ADVICE_NOTE = { type: 3, value: "ADVICE_NOTE" };
  IfcProcedureTypeEnum.ADVICE_WARNING = { type: 3, value: "ADVICE_WARNING" };
  IfcProcedureTypeEnum.CALIBRATION = { type: 3, value: "CALIBRATION" };
  IfcProcedureTypeEnum.DIAGNOSTIC = { type: 3, value: "DIAGNOSTIC" };
  IfcProcedureTypeEnum.SHUTDOWN = { type: 3, value: "SHUTDOWN" };
  IfcProcedureTypeEnum.STARTUP = { type: 3, value: "STARTUP" };
  IfcProcedureTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcProcedureTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcProcedureTypeEnum = IfcProcedureTypeEnum;
  class IfcProfileTypeEnum {
  }
  IfcProfileTypeEnum.CURVE = { type: 3, value: "CURVE" };
  IfcProfileTypeEnum.AREA = { type: 3, value: "AREA" };
  IFC2X32.IfcProfileTypeEnum = IfcProfileTypeEnum;
  class IfcProjectOrderRecordTypeEnum {
  }
  IfcProjectOrderRecordTypeEnum.CHANGE = { type: 3, value: "CHANGE" };
  IfcProjectOrderRecordTypeEnum.MAINTENANCE = { type: 3, value: "MAINTENANCE" };
  IfcProjectOrderRecordTypeEnum.MOVE = { type: 3, value: "MOVE" };
  IfcProjectOrderRecordTypeEnum.PURCHASE = { type: 3, value: "PURCHASE" };
  IfcProjectOrderRecordTypeEnum.WORK = { type: 3, value: "WORK" };
  IfcProjectOrderRecordTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcProjectOrderRecordTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcProjectOrderRecordTypeEnum = IfcProjectOrderRecordTypeEnum;
  class IfcProjectOrderTypeEnum {
  }
  IfcProjectOrderTypeEnum.CHANGEORDER = { type: 3, value: "CHANGEORDER" };
  IfcProjectOrderTypeEnum.MAINTENANCEWORKORDER = { type: 3, value: "MAINTENANCEWORKORDER" };
  IfcProjectOrderTypeEnum.MOVEORDER = { type: 3, value: "MOVEORDER" };
  IfcProjectOrderTypeEnum.PURCHASEORDER = { type: 3, value: "PURCHASEORDER" };
  IfcProjectOrderTypeEnum.WORKORDER = { type: 3, value: "WORKORDER" };
  IfcProjectOrderTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcProjectOrderTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcProjectOrderTypeEnum = IfcProjectOrderTypeEnum;
  class IfcProjectedOrTrueLengthEnum {
  }
  IfcProjectedOrTrueLengthEnum.PROJECTED_LENGTH = { type: 3, value: "PROJECTED_LENGTH" };
  IfcProjectedOrTrueLengthEnum.TRUE_LENGTH = { type: 3, value: "TRUE_LENGTH" };
  IFC2X32.IfcProjectedOrTrueLengthEnum = IfcProjectedOrTrueLengthEnum;
  class IfcPropertySourceEnum {
  }
  IfcPropertySourceEnum.DESIGN = { type: 3, value: "DESIGN" };
  IfcPropertySourceEnum.DESIGNMAXIMUM = { type: 3, value: "DESIGNMAXIMUM" };
  IfcPropertySourceEnum.DESIGNMINIMUM = { type: 3, value: "DESIGNMINIMUM" };
  IfcPropertySourceEnum.SIMULATED = { type: 3, value: "SIMULATED" };
  IfcPropertySourceEnum.ASBUILT = { type: 3, value: "ASBUILT" };
  IfcPropertySourceEnum.COMMISSIONING = { type: 3, value: "COMMISSIONING" };
  IfcPropertySourceEnum.MEASURED = { type: 3, value: "MEASURED" };
  IfcPropertySourceEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPropertySourceEnum.NOTKNOWN = { type: 3, value: "NOTKNOWN" };
  IFC2X32.IfcPropertySourceEnum = IfcPropertySourceEnum;
  class IfcProtectiveDeviceTypeEnum {
  }
  IfcProtectiveDeviceTypeEnum.FUSEDISCONNECTOR = { type: 3, value: "FUSEDISCONNECTOR" };
  IfcProtectiveDeviceTypeEnum.CIRCUITBREAKER = { type: 3, value: "CIRCUITBREAKER" };
  IfcProtectiveDeviceTypeEnum.EARTHFAILUREDEVICE = { type: 3, value: "EARTHFAILUREDEVICE" };
  IfcProtectiveDeviceTypeEnum.RESIDUALCURRENTCIRCUITBREAKER = { type: 3, value: "RESIDUALCURRENTCIRCUITBREAKER" };
  IfcProtectiveDeviceTypeEnum.RESIDUALCURRENTSWITCH = { type: 3, value: "RESIDUALCURRENTSWITCH" };
  IfcProtectiveDeviceTypeEnum.VARISTOR = { type: 3, value: "VARISTOR" };
  IfcProtectiveDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcProtectiveDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcProtectiveDeviceTypeEnum = IfcProtectiveDeviceTypeEnum;
  class IfcPumpTypeEnum {
  }
  IfcPumpTypeEnum.CIRCULATOR = { type: 3, value: "CIRCULATOR" };
  IfcPumpTypeEnum.ENDSUCTION = { type: 3, value: "ENDSUCTION" };
  IfcPumpTypeEnum.SPLITCASE = { type: 3, value: "SPLITCASE" };
  IfcPumpTypeEnum.VERTICALINLINE = { type: 3, value: "VERTICALINLINE" };
  IfcPumpTypeEnum.VERTICALTURBINE = { type: 3, value: "VERTICALTURBINE" };
  IfcPumpTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPumpTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcPumpTypeEnum = IfcPumpTypeEnum;
  class IfcRailingTypeEnum {
  }
  IfcRailingTypeEnum.HANDRAIL = { type: 3, value: "HANDRAIL" };
  IfcRailingTypeEnum.GUARDRAIL = { type: 3, value: "GUARDRAIL" };
  IfcRailingTypeEnum.BALUSTRADE = { type: 3, value: "BALUSTRADE" };
  IfcRailingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcRailingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcRailingTypeEnum = IfcRailingTypeEnum;
  class IfcRampFlightTypeEnum {
  }
  IfcRampFlightTypeEnum.STRAIGHT = { type: 3, value: "STRAIGHT" };
  IfcRampFlightTypeEnum.SPIRAL = { type: 3, value: "SPIRAL" };
  IfcRampFlightTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcRampFlightTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcRampFlightTypeEnum = IfcRampFlightTypeEnum;
  class IfcRampTypeEnum {
  }
  IfcRampTypeEnum.STRAIGHT_RUN_RAMP = { type: 3, value: "STRAIGHT_RUN_RAMP" };
  IfcRampTypeEnum.TWO_STRAIGHT_RUN_RAMP = { type: 3, value: "TWO_STRAIGHT_RUN_RAMP" };
  IfcRampTypeEnum.QUARTER_TURN_RAMP = { type: 3, value: "QUARTER_TURN_RAMP" };
  IfcRampTypeEnum.TWO_QUARTER_TURN_RAMP = { type: 3, value: "TWO_QUARTER_TURN_RAMP" };
  IfcRampTypeEnum.HALF_TURN_RAMP = { type: 3, value: "HALF_TURN_RAMP" };
  IfcRampTypeEnum.SPIRAL_RAMP = { type: 3, value: "SPIRAL_RAMP" };
  IfcRampTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcRampTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcRampTypeEnum = IfcRampTypeEnum;
  class IfcReflectanceMethodEnum {
  }
  IfcReflectanceMethodEnum.BLINN = { type: 3, value: "BLINN" };
  IfcReflectanceMethodEnum.FLAT = { type: 3, value: "FLAT" };
  IfcReflectanceMethodEnum.GLASS = { type: 3, value: "GLASS" };
  IfcReflectanceMethodEnum.MATT = { type: 3, value: "MATT" };
  IfcReflectanceMethodEnum.METAL = { type: 3, value: "METAL" };
  IfcReflectanceMethodEnum.MIRROR = { type: 3, value: "MIRROR" };
  IfcReflectanceMethodEnum.PHONG = { type: 3, value: "PHONG" };
  IfcReflectanceMethodEnum.PLASTIC = { type: 3, value: "PLASTIC" };
  IfcReflectanceMethodEnum.STRAUSS = { type: 3, value: "STRAUSS" };
  IfcReflectanceMethodEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcReflectanceMethodEnum = IfcReflectanceMethodEnum;
  class IfcReinforcingBarRoleEnum {
  }
  IfcReinforcingBarRoleEnum.MAIN = { type: 3, value: "MAIN" };
  IfcReinforcingBarRoleEnum.SHEAR = { type: 3, value: "SHEAR" };
  IfcReinforcingBarRoleEnum.LIGATURE = { type: 3, value: "LIGATURE" };
  IfcReinforcingBarRoleEnum.STUD = { type: 3, value: "STUD" };
  IfcReinforcingBarRoleEnum.PUNCHING = { type: 3, value: "PUNCHING" };
  IfcReinforcingBarRoleEnum.EDGE = { type: 3, value: "EDGE" };
  IfcReinforcingBarRoleEnum.RING = { type: 3, value: "RING" };
  IfcReinforcingBarRoleEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcReinforcingBarRoleEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcReinforcingBarRoleEnum = IfcReinforcingBarRoleEnum;
  class IfcReinforcingBarSurfaceEnum {
  }
  IfcReinforcingBarSurfaceEnum.PLAIN = { type: 3, value: "PLAIN" };
  IfcReinforcingBarSurfaceEnum.TEXTURED = { type: 3, value: "TEXTURED" };
  IFC2X32.IfcReinforcingBarSurfaceEnum = IfcReinforcingBarSurfaceEnum;
  class IfcResourceConsumptionEnum {
  }
  IfcResourceConsumptionEnum.CONSUMED = { type: 3, value: "CONSUMED" };
  IfcResourceConsumptionEnum.PARTIALLYCONSUMED = { type: 3, value: "PARTIALLYCONSUMED" };
  IfcResourceConsumptionEnum.NOTCONSUMED = { type: 3, value: "NOTCONSUMED" };
  IfcResourceConsumptionEnum.OCCUPIED = { type: 3, value: "OCCUPIED" };
  IfcResourceConsumptionEnum.PARTIALLYOCCUPIED = { type: 3, value: "PARTIALLYOCCUPIED" };
  IfcResourceConsumptionEnum.NOTOCCUPIED = { type: 3, value: "NOTOCCUPIED" };
  IfcResourceConsumptionEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcResourceConsumptionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcResourceConsumptionEnum = IfcResourceConsumptionEnum;
  class IfcRibPlateDirectionEnum {
  }
  IfcRibPlateDirectionEnum.DIRECTION_X = { type: 3, value: "DIRECTION_X" };
  IfcRibPlateDirectionEnum.DIRECTION_Y = { type: 3, value: "DIRECTION_Y" };
  IFC2X32.IfcRibPlateDirectionEnum = IfcRibPlateDirectionEnum;
  class IfcRoleEnum {
  }
  IfcRoleEnum.SUPPLIER = { type: 3, value: "SUPPLIER" };
  IfcRoleEnum.MANUFACTURER = { type: 3, value: "MANUFACTURER" };
  IfcRoleEnum.CONTRACTOR = { type: 3, value: "CONTRACTOR" };
  IfcRoleEnum.SUBCONTRACTOR = { type: 3, value: "SUBCONTRACTOR" };
  IfcRoleEnum.ARCHITECT = { type: 3, value: "ARCHITECT" };
  IfcRoleEnum.STRUCTURALENGINEER = { type: 3, value: "STRUCTURALENGINEER" };
  IfcRoleEnum.COSTENGINEER = { type: 3, value: "COSTENGINEER" };
  IfcRoleEnum.CLIENT = { type: 3, value: "CLIENT" };
  IfcRoleEnum.BUILDINGOWNER = { type: 3, value: "BUILDINGOWNER" };
  IfcRoleEnum.BUILDINGOPERATOR = { type: 3, value: "BUILDINGOPERATOR" };
  IfcRoleEnum.MECHANICALENGINEER = { type: 3, value: "MECHANICALENGINEER" };
  IfcRoleEnum.ELECTRICALENGINEER = { type: 3, value: "ELECTRICALENGINEER" };
  IfcRoleEnum.PROJECTMANAGER = { type: 3, value: "PROJECTMANAGER" };
  IfcRoleEnum.FACILITIESMANAGER = { type: 3, value: "FACILITIESMANAGER" };
  IfcRoleEnum.CIVILENGINEER = { type: 3, value: "CIVILENGINEER" };
  IfcRoleEnum.COMISSIONINGENGINEER = { type: 3, value: "COMISSIONINGENGINEER" };
  IfcRoleEnum.ENGINEER = { type: 3, value: "ENGINEER" };
  IfcRoleEnum.OWNER = { type: 3, value: "OWNER" };
  IfcRoleEnum.CONSULTANT = { type: 3, value: "CONSULTANT" };
  IfcRoleEnum.CONSTRUCTIONMANAGER = { type: 3, value: "CONSTRUCTIONMANAGER" };
  IfcRoleEnum.FIELDCONSTRUCTIONMANAGER = { type: 3, value: "FIELDCONSTRUCTIONMANAGER" };
  IfcRoleEnum.RESELLER = { type: 3, value: "RESELLER" };
  IfcRoleEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IFC2X32.IfcRoleEnum = IfcRoleEnum;
  class IfcRoofTypeEnum {
  }
  IfcRoofTypeEnum.FLAT_ROOF = { type: 3, value: "FLAT_ROOF" };
  IfcRoofTypeEnum.SHED_ROOF = { type: 3, value: "SHED_ROOF" };
  IfcRoofTypeEnum.GABLE_ROOF = { type: 3, value: "GABLE_ROOF" };
  IfcRoofTypeEnum.HIP_ROOF = { type: 3, value: "HIP_ROOF" };
  IfcRoofTypeEnum.HIPPED_GABLE_ROOF = { type: 3, value: "HIPPED_GABLE_ROOF" };
  IfcRoofTypeEnum.GAMBREL_ROOF = { type: 3, value: "GAMBREL_ROOF" };
  IfcRoofTypeEnum.MANSARD_ROOF = { type: 3, value: "MANSARD_ROOF" };
  IfcRoofTypeEnum.BARREL_ROOF = { type: 3, value: "BARREL_ROOF" };
  IfcRoofTypeEnum.RAINBOW_ROOF = { type: 3, value: "RAINBOW_ROOF" };
  IfcRoofTypeEnum.BUTTERFLY_ROOF = { type: 3, value: "BUTTERFLY_ROOF" };
  IfcRoofTypeEnum.PAVILION_ROOF = { type: 3, value: "PAVILION_ROOF" };
  IfcRoofTypeEnum.DOME_ROOF = { type: 3, value: "DOME_ROOF" };
  IfcRoofTypeEnum.FREEFORM = { type: 3, value: "FREEFORM" };
  IfcRoofTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcRoofTypeEnum = IfcRoofTypeEnum;
  class IfcSIPrefix {
  }
  IfcSIPrefix.EXA = { type: 3, value: "EXA" };
  IfcSIPrefix.PETA = { type: 3, value: "PETA" };
  IfcSIPrefix.TERA = { type: 3, value: "TERA" };
  IfcSIPrefix.GIGA = { type: 3, value: "GIGA" };
  IfcSIPrefix.MEGA = { type: 3, value: "MEGA" };
  IfcSIPrefix.KILO = { type: 3, value: "KILO" };
  IfcSIPrefix.HECTO = { type: 3, value: "HECTO" };
  IfcSIPrefix.DECA = { type: 3, value: "DECA" };
  IfcSIPrefix.DECI = { type: 3, value: "DECI" };
  IfcSIPrefix.CENTI = { type: 3, value: "CENTI" };
  IfcSIPrefix.MILLI = { type: 3, value: "MILLI" };
  IfcSIPrefix.MICRO = { type: 3, value: "MICRO" };
  IfcSIPrefix.NANO = { type: 3, value: "NANO" };
  IfcSIPrefix.PICO = { type: 3, value: "PICO" };
  IfcSIPrefix.FEMTO = { type: 3, value: "FEMTO" };
  IfcSIPrefix.ATTO = { type: 3, value: "ATTO" };
  IFC2X32.IfcSIPrefix = IfcSIPrefix;
  class IfcSIUnitName {
  }
  IfcSIUnitName.AMPERE = { type: 3, value: "AMPERE" };
  IfcSIUnitName.BECQUEREL = { type: 3, value: "BECQUEREL" };
  IfcSIUnitName.CANDELA = { type: 3, value: "CANDELA" };
  IfcSIUnitName.COULOMB = { type: 3, value: "COULOMB" };
  IfcSIUnitName.CUBIC_METRE = { type: 3, value: "CUBIC_METRE" };
  IfcSIUnitName.DEGREE_CELSIUS = { type: 3, value: "DEGREE_CELSIUS" };
  IfcSIUnitName.FARAD = { type: 3, value: "FARAD" };
  IfcSIUnitName.GRAM = { type: 3, value: "GRAM" };
  IfcSIUnitName.GRAY = { type: 3, value: "GRAY" };
  IfcSIUnitName.HENRY = { type: 3, value: "HENRY" };
  IfcSIUnitName.HERTZ = { type: 3, value: "HERTZ" };
  IfcSIUnitName.JOULE = { type: 3, value: "JOULE" };
  IfcSIUnitName.KELVIN = { type: 3, value: "KELVIN" };
  IfcSIUnitName.LUMEN = { type: 3, value: "LUMEN" };
  IfcSIUnitName.LUX = { type: 3, value: "LUX" };
  IfcSIUnitName.METRE = { type: 3, value: "METRE" };
  IfcSIUnitName.MOLE = { type: 3, value: "MOLE" };
  IfcSIUnitName.NEWTON = { type: 3, value: "NEWTON" };
  IfcSIUnitName.OHM = { type: 3, value: "OHM" };
  IfcSIUnitName.PASCAL = { type: 3, value: "PASCAL" };
  IfcSIUnitName.RADIAN = { type: 3, value: "RADIAN" };
  IfcSIUnitName.SECOND = { type: 3, value: "SECOND" };
  IfcSIUnitName.SIEMENS = { type: 3, value: "SIEMENS" };
  IfcSIUnitName.SIEVERT = { type: 3, value: "SIEVERT" };
  IfcSIUnitName.SQUARE_METRE = { type: 3, value: "SQUARE_METRE" };
  IfcSIUnitName.STERADIAN = { type: 3, value: "STERADIAN" };
  IfcSIUnitName.TESLA = { type: 3, value: "TESLA" };
  IfcSIUnitName.VOLT = { type: 3, value: "VOLT" };
  IfcSIUnitName.WATT = { type: 3, value: "WATT" };
  IfcSIUnitName.WEBER = { type: 3, value: "WEBER" };
  IFC2X32.IfcSIUnitName = IfcSIUnitName;
  class IfcSanitaryTerminalTypeEnum {
  }
  IfcSanitaryTerminalTypeEnum.BATH = { type: 3, value: "BATH" };
  IfcSanitaryTerminalTypeEnum.BIDET = { type: 3, value: "BIDET" };
  IfcSanitaryTerminalTypeEnum.CISTERN = { type: 3, value: "CISTERN" };
  IfcSanitaryTerminalTypeEnum.SHOWER = { type: 3, value: "SHOWER" };
  IfcSanitaryTerminalTypeEnum.SINK = { type: 3, value: "SINK" };
  IfcSanitaryTerminalTypeEnum.SANITARYFOUNTAIN = { type: 3, value: "SANITARYFOUNTAIN" };
  IfcSanitaryTerminalTypeEnum.TOILETPAN = { type: 3, value: "TOILETPAN" };
  IfcSanitaryTerminalTypeEnum.URINAL = { type: 3, value: "URINAL" };
  IfcSanitaryTerminalTypeEnum.WASHHANDBASIN = { type: 3, value: "WASHHANDBASIN" };
  IfcSanitaryTerminalTypeEnum.WCSEAT = { type: 3, value: "WCSEAT" };
  IfcSanitaryTerminalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSanitaryTerminalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcSanitaryTerminalTypeEnum = IfcSanitaryTerminalTypeEnum;
  class IfcSectionTypeEnum {
  }
  IfcSectionTypeEnum.UNIFORM = { type: 3, value: "UNIFORM" };
  IfcSectionTypeEnum.TAPERED = { type: 3, value: "TAPERED" };
  IFC2X32.IfcSectionTypeEnum = IfcSectionTypeEnum;
  class IfcSensorTypeEnum {
  }
  IfcSensorTypeEnum.CO2SENSOR = { type: 3, value: "CO2SENSOR" };
  IfcSensorTypeEnum.FIRESENSOR = { type: 3, value: "FIRESENSOR" };
  IfcSensorTypeEnum.FLOWSENSOR = { type: 3, value: "FLOWSENSOR" };
  IfcSensorTypeEnum.GASSENSOR = { type: 3, value: "GASSENSOR" };
  IfcSensorTypeEnum.HEATSENSOR = { type: 3, value: "HEATSENSOR" };
  IfcSensorTypeEnum.HUMIDITYSENSOR = { type: 3, value: "HUMIDITYSENSOR" };
  IfcSensorTypeEnum.LIGHTSENSOR = { type: 3, value: "LIGHTSENSOR" };
  IfcSensorTypeEnum.MOISTURESENSOR = { type: 3, value: "MOISTURESENSOR" };
  IfcSensorTypeEnum.MOVEMENTSENSOR = { type: 3, value: "MOVEMENTSENSOR" };
  IfcSensorTypeEnum.PRESSURESENSOR = { type: 3, value: "PRESSURESENSOR" };
  IfcSensorTypeEnum.SMOKESENSOR = { type: 3, value: "SMOKESENSOR" };
  IfcSensorTypeEnum.SOUNDSENSOR = { type: 3, value: "SOUNDSENSOR" };
  IfcSensorTypeEnum.TEMPERATURESENSOR = { type: 3, value: "TEMPERATURESENSOR" };
  IfcSensorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSensorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcSensorTypeEnum = IfcSensorTypeEnum;
  class IfcSequenceEnum {
  }
  IfcSequenceEnum.START_START = { type: 3, value: "START_START" };
  IfcSequenceEnum.START_FINISH = { type: 3, value: "START_FINISH" };
  IfcSequenceEnum.FINISH_START = { type: 3, value: "FINISH_START" };
  IfcSequenceEnum.FINISH_FINISH = { type: 3, value: "FINISH_FINISH" };
  IfcSequenceEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcSequenceEnum = IfcSequenceEnum;
  class IfcServiceLifeFactorTypeEnum {
  }
  IfcServiceLifeFactorTypeEnum.A_QUALITYOFCOMPONENTS = { type: 3, value: "A_QUALITYOFCOMPONENTS" };
  IfcServiceLifeFactorTypeEnum.B_DESIGNLEVEL = { type: 3, value: "B_DESIGNLEVEL" };
  IfcServiceLifeFactorTypeEnum.C_WORKEXECUTIONLEVEL = { type: 3, value: "C_WORKEXECUTIONLEVEL" };
  IfcServiceLifeFactorTypeEnum.D_INDOORENVIRONMENT = { type: 3, value: "D_INDOORENVIRONMENT" };
  IfcServiceLifeFactorTypeEnum.E_OUTDOORENVIRONMENT = { type: 3, value: "E_OUTDOORENVIRONMENT" };
  IfcServiceLifeFactorTypeEnum.F_INUSECONDITIONS = { type: 3, value: "F_INUSECONDITIONS" };
  IfcServiceLifeFactorTypeEnum.G_MAINTENANCELEVEL = { type: 3, value: "G_MAINTENANCELEVEL" };
  IfcServiceLifeFactorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcServiceLifeFactorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcServiceLifeFactorTypeEnum = IfcServiceLifeFactorTypeEnum;
  class IfcServiceLifeTypeEnum {
  }
  IfcServiceLifeTypeEnum.ACTUALSERVICELIFE = { type: 3, value: "ACTUALSERVICELIFE" };
  IfcServiceLifeTypeEnum.EXPECTEDSERVICELIFE = { type: 3, value: "EXPECTEDSERVICELIFE" };
  IfcServiceLifeTypeEnum.OPTIMISTICREFERENCESERVICELIFE = { type: 3, value: "OPTIMISTICREFERENCESERVICELIFE" };
  IfcServiceLifeTypeEnum.PESSIMISTICREFERENCESERVICELIFE = { type: 3, value: "PESSIMISTICREFERENCESERVICELIFE" };
  IfcServiceLifeTypeEnum.REFERENCESERVICELIFE = { type: 3, value: "REFERENCESERVICELIFE" };
  IFC2X32.IfcServiceLifeTypeEnum = IfcServiceLifeTypeEnum;
  class IfcSlabTypeEnum {
  }
  IfcSlabTypeEnum.FLOOR = { type: 3, value: "FLOOR" };
  IfcSlabTypeEnum.ROOF = { type: 3, value: "ROOF" };
  IfcSlabTypeEnum.LANDING = { type: 3, value: "LANDING" };
  IfcSlabTypeEnum.BASESLAB = { type: 3, value: "BASESLAB" };
  IfcSlabTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSlabTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcSlabTypeEnum = IfcSlabTypeEnum;
  class IfcSoundScaleEnum {
  }
  IfcSoundScaleEnum.DBA = { type: 3, value: "DBA" };
  IfcSoundScaleEnum.DBB = { type: 3, value: "DBB" };
  IfcSoundScaleEnum.DBC = { type: 3, value: "DBC" };
  IfcSoundScaleEnum.NC = { type: 3, value: "NC" };
  IfcSoundScaleEnum.NR = { type: 3, value: "NR" };
  IfcSoundScaleEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSoundScaleEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcSoundScaleEnum = IfcSoundScaleEnum;
  class IfcSpaceHeaterTypeEnum {
  }
  IfcSpaceHeaterTypeEnum.SECTIONALRADIATOR = { type: 3, value: "SECTIONALRADIATOR" };
  IfcSpaceHeaterTypeEnum.PANELRADIATOR = { type: 3, value: "PANELRADIATOR" };
  IfcSpaceHeaterTypeEnum.TUBULARRADIATOR = { type: 3, value: "TUBULARRADIATOR" };
  IfcSpaceHeaterTypeEnum.CONVECTOR = { type: 3, value: "CONVECTOR" };
  IfcSpaceHeaterTypeEnum.BASEBOARDHEATER = { type: 3, value: "BASEBOARDHEATER" };
  IfcSpaceHeaterTypeEnum.FINNEDTUBEUNIT = { type: 3, value: "FINNEDTUBEUNIT" };
  IfcSpaceHeaterTypeEnum.UNITHEATER = { type: 3, value: "UNITHEATER" };
  IfcSpaceHeaterTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSpaceHeaterTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcSpaceHeaterTypeEnum = IfcSpaceHeaterTypeEnum;
  class IfcSpaceTypeEnum {
  }
  IfcSpaceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSpaceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcSpaceTypeEnum = IfcSpaceTypeEnum;
  class IfcStackTerminalTypeEnum {
  }
  IfcStackTerminalTypeEnum.BIRDCAGE = { type: 3, value: "BIRDCAGE" };
  IfcStackTerminalTypeEnum.COWL = { type: 3, value: "COWL" };
  IfcStackTerminalTypeEnum.RAINWATERHOPPER = { type: 3, value: "RAINWATERHOPPER" };
  IfcStackTerminalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStackTerminalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcStackTerminalTypeEnum = IfcStackTerminalTypeEnum;
  class IfcStairFlightTypeEnum {
  }
  IfcStairFlightTypeEnum.STRAIGHT = { type: 3, value: "STRAIGHT" };
  IfcStairFlightTypeEnum.WINDER = { type: 3, value: "WINDER" };
  IfcStairFlightTypeEnum.SPIRAL = { type: 3, value: "SPIRAL" };
  IfcStairFlightTypeEnum.CURVED = { type: 3, value: "CURVED" };
  IfcStairFlightTypeEnum.FREEFORM = { type: 3, value: "FREEFORM" };
  IfcStairFlightTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStairFlightTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcStairFlightTypeEnum = IfcStairFlightTypeEnum;
  class IfcStairTypeEnum {
  }
  IfcStairTypeEnum.STRAIGHT_RUN_STAIR = { type: 3, value: "STRAIGHT_RUN_STAIR" };
  IfcStairTypeEnum.TWO_STRAIGHT_RUN_STAIR = { type: 3, value: "TWO_STRAIGHT_RUN_STAIR" };
  IfcStairTypeEnum.QUARTER_WINDING_STAIR = { type: 3, value: "QUARTER_WINDING_STAIR" };
  IfcStairTypeEnum.QUARTER_TURN_STAIR = { type: 3, value: "QUARTER_TURN_STAIR" };
  IfcStairTypeEnum.HALF_WINDING_STAIR = { type: 3, value: "HALF_WINDING_STAIR" };
  IfcStairTypeEnum.HALF_TURN_STAIR = { type: 3, value: "HALF_TURN_STAIR" };
  IfcStairTypeEnum.TWO_QUARTER_WINDING_STAIR = { type: 3, value: "TWO_QUARTER_WINDING_STAIR" };
  IfcStairTypeEnum.TWO_QUARTER_TURN_STAIR = { type: 3, value: "TWO_QUARTER_TURN_STAIR" };
  IfcStairTypeEnum.THREE_QUARTER_WINDING_STAIR = { type: 3, value: "THREE_QUARTER_WINDING_STAIR" };
  IfcStairTypeEnum.THREE_QUARTER_TURN_STAIR = { type: 3, value: "THREE_QUARTER_TURN_STAIR" };
  IfcStairTypeEnum.SPIRAL_STAIR = { type: 3, value: "SPIRAL_STAIR" };
  IfcStairTypeEnum.DOUBLE_RETURN_STAIR = { type: 3, value: "DOUBLE_RETURN_STAIR" };
  IfcStairTypeEnum.CURVED_RUN_STAIR = { type: 3, value: "CURVED_RUN_STAIR" };
  IfcStairTypeEnum.TWO_CURVED_RUN_STAIR = { type: 3, value: "TWO_CURVED_RUN_STAIR" };
  IfcStairTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStairTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcStairTypeEnum = IfcStairTypeEnum;
  class IfcStateEnum {
  }
  IfcStateEnum.READWRITE = { type: 3, value: "READWRITE" };
  IfcStateEnum.READONLY = { type: 3, value: "READONLY" };
  IfcStateEnum.LOCKED = { type: 3, value: "LOCKED" };
  IfcStateEnum.READWRITELOCKED = { type: 3, value: "READWRITELOCKED" };
  IfcStateEnum.READONLYLOCKED = { type: 3, value: "READONLYLOCKED" };
  IFC2X32.IfcStateEnum = IfcStateEnum;
  class IfcStructuralCurveTypeEnum {
  }
  IfcStructuralCurveTypeEnum.RIGID_JOINED_MEMBER = { type: 3, value: "RIGID_JOINED_MEMBER" };
  IfcStructuralCurveTypeEnum.PIN_JOINED_MEMBER = { type: 3, value: "PIN_JOINED_MEMBER" };
  IfcStructuralCurveTypeEnum.CABLE = { type: 3, value: "CABLE" };
  IfcStructuralCurveTypeEnum.TENSION_MEMBER = { type: 3, value: "TENSION_MEMBER" };
  IfcStructuralCurveTypeEnum.COMPRESSION_MEMBER = { type: 3, value: "COMPRESSION_MEMBER" };
  IfcStructuralCurveTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStructuralCurveTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcStructuralCurveTypeEnum = IfcStructuralCurveTypeEnum;
  class IfcStructuralSurfaceTypeEnum {
  }
  IfcStructuralSurfaceTypeEnum.BENDING_ELEMENT = { type: 3, value: "BENDING_ELEMENT" };
  IfcStructuralSurfaceTypeEnum.MEMBRANE_ELEMENT = { type: 3, value: "MEMBRANE_ELEMENT" };
  IfcStructuralSurfaceTypeEnum.SHELL = { type: 3, value: "SHELL" };
  IfcStructuralSurfaceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStructuralSurfaceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcStructuralSurfaceTypeEnum = IfcStructuralSurfaceTypeEnum;
  class IfcSurfaceSide {
  }
  IfcSurfaceSide.POSITIVE = { type: 3, value: "POSITIVE" };
  IfcSurfaceSide.NEGATIVE = { type: 3, value: "NEGATIVE" };
  IfcSurfaceSide.BOTH = { type: 3, value: "BOTH" };
  IFC2X32.IfcSurfaceSide = IfcSurfaceSide;
  class IfcSurfaceTextureEnum {
  }
  IfcSurfaceTextureEnum.BUMP = { type: 3, value: "BUMP" };
  IfcSurfaceTextureEnum.OPACITY = { type: 3, value: "OPACITY" };
  IfcSurfaceTextureEnum.REFLECTION = { type: 3, value: "REFLECTION" };
  IfcSurfaceTextureEnum.SELFILLUMINATION = { type: 3, value: "SELFILLUMINATION" };
  IfcSurfaceTextureEnum.SHININESS = { type: 3, value: "SHININESS" };
  IfcSurfaceTextureEnum.SPECULAR = { type: 3, value: "SPECULAR" };
  IfcSurfaceTextureEnum.TEXTURE = { type: 3, value: "TEXTURE" };
  IfcSurfaceTextureEnum.TRANSPARENCYMAP = { type: 3, value: "TRANSPARENCYMAP" };
  IfcSurfaceTextureEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcSurfaceTextureEnum = IfcSurfaceTextureEnum;
  class IfcSwitchingDeviceTypeEnum {
  }
  IfcSwitchingDeviceTypeEnum.CONTACTOR = { type: 3, value: "CONTACTOR" };
  IfcSwitchingDeviceTypeEnum.EMERGENCYSTOP = { type: 3, value: "EMERGENCYSTOP" };
  IfcSwitchingDeviceTypeEnum.STARTER = { type: 3, value: "STARTER" };
  IfcSwitchingDeviceTypeEnum.SWITCHDISCONNECTOR = { type: 3, value: "SWITCHDISCONNECTOR" };
  IfcSwitchingDeviceTypeEnum.TOGGLESWITCH = { type: 3, value: "TOGGLESWITCH" };
  IfcSwitchingDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSwitchingDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcSwitchingDeviceTypeEnum = IfcSwitchingDeviceTypeEnum;
  class IfcTankTypeEnum {
  }
  IfcTankTypeEnum.PREFORMED = { type: 3, value: "PREFORMED" };
  IfcTankTypeEnum.SECTIONAL = { type: 3, value: "SECTIONAL" };
  IfcTankTypeEnum.EXPANSION = { type: 3, value: "EXPANSION" };
  IfcTankTypeEnum.PRESSUREVESSEL = { type: 3, value: "PRESSUREVESSEL" };
  IfcTankTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTankTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcTankTypeEnum = IfcTankTypeEnum;
  class IfcTendonTypeEnum {
  }
  IfcTendonTypeEnum.STRAND = { type: 3, value: "STRAND" };
  IfcTendonTypeEnum.WIRE = { type: 3, value: "WIRE" };
  IfcTendonTypeEnum.BAR = { type: 3, value: "BAR" };
  IfcTendonTypeEnum.COATED = { type: 3, value: "COATED" };
  IfcTendonTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTendonTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcTendonTypeEnum = IfcTendonTypeEnum;
  class IfcTextPath {
  }
  IfcTextPath.LEFT = { type: 3, value: "LEFT" };
  IfcTextPath.RIGHT = { type: 3, value: "RIGHT" };
  IfcTextPath.UP = { type: 3, value: "UP" };
  IfcTextPath.DOWN = { type: 3, value: "DOWN" };
  IFC2X32.IfcTextPath = IfcTextPath;
  class IfcThermalLoadSourceEnum {
  }
  IfcThermalLoadSourceEnum.PEOPLE = { type: 3, value: "PEOPLE" };
  IfcThermalLoadSourceEnum.LIGHTING = { type: 3, value: "LIGHTING" };
  IfcThermalLoadSourceEnum.EQUIPMENT = { type: 3, value: "EQUIPMENT" };
  IfcThermalLoadSourceEnum.VENTILATIONINDOORAIR = { type: 3, value: "VENTILATIONINDOORAIR" };
  IfcThermalLoadSourceEnum.VENTILATIONOUTSIDEAIR = { type: 3, value: "VENTILATIONOUTSIDEAIR" };
  IfcThermalLoadSourceEnum.RECIRCULATEDAIR = { type: 3, value: "RECIRCULATEDAIR" };
  IfcThermalLoadSourceEnum.EXHAUSTAIR = { type: 3, value: "EXHAUSTAIR" };
  IfcThermalLoadSourceEnum.AIREXCHANGERATE = { type: 3, value: "AIREXCHANGERATE" };
  IfcThermalLoadSourceEnum.DRYBULBTEMPERATURE = { type: 3, value: "DRYBULBTEMPERATURE" };
  IfcThermalLoadSourceEnum.RELATIVEHUMIDITY = { type: 3, value: "RELATIVEHUMIDITY" };
  IfcThermalLoadSourceEnum.INFILTRATION = { type: 3, value: "INFILTRATION" };
  IfcThermalLoadSourceEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcThermalLoadSourceEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcThermalLoadSourceEnum = IfcThermalLoadSourceEnum;
  class IfcThermalLoadTypeEnum {
  }
  IfcThermalLoadTypeEnum.SENSIBLE = { type: 3, value: "SENSIBLE" };
  IfcThermalLoadTypeEnum.LATENT = { type: 3, value: "LATENT" };
  IfcThermalLoadTypeEnum.RADIANT = { type: 3, value: "RADIANT" };
  IfcThermalLoadTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcThermalLoadTypeEnum = IfcThermalLoadTypeEnum;
  class IfcTimeSeriesDataTypeEnum {
  }
  IfcTimeSeriesDataTypeEnum.CONTINUOUS = { type: 3, value: "CONTINUOUS" };
  IfcTimeSeriesDataTypeEnum.DISCRETE = { type: 3, value: "DISCRETE" };
  IfcTimeSeriesDataTypeEnum.DISCRETEBINARY = { type: 3, value: "DISCRETEBINARY" };
  IfcTimeSeriesDataTypeEnum.PIECEWISEBINARY = { type: 3, value: "PIECEWISEBINARY" };
  IfcTimeSeriesDataTypeEnum.PIECEWISECONSTANT = { type: 3, value: "PIECEWISECONSTANT" };
  IfcTimeSeriesDataTypeEnum.PIECEWISECONTINUOUS = { type: 3, value: "PIECEWISECONTINUOUS" };
  IfcTimeSeriesDataTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcTimeSeriesDataTypeEnum = IfcTimeSeriesDataTypeEnum;
  class IfcTimeSeriesScheduleTypeEnum {
  }
  IfcTimeSeriesScheduleTypeEnum.ANNUAL = { type: 3, value: "ANNUAL" };
  IfcTimeSeriesScheduleTypeEnum.MONTHLY = { type: 3, value: "MONTHLY" };
  IfcTimeSeriesScheduleTypeEnum.WEEKLY = { type: 3, value: "WEEKLY" };
  IfcTimeSeriesScheduleTypeEnum.DAILY = { type: 3, value: "DAILY" };
  IfcTimeSeriesScheduleTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTimeSeriesScheduleTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcTimeSeriesScheduleTypeEnum = IfcTimeSeriesScheduleTypeEnum;
  class IfcTransformerTypeEnum {
  }
  IfcTransformerTypeEnum.CURRENT = { type: 3, value: "CURRENT" };
  IfcTransformerTypeEnum.FREQUENCY = { type: 3, value: "FREQUENCY" };
  IfcTransformerTypeEnum.VOLTAGE = { type: 3, value: "VOLTAGE" };
  IfcTransformerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTransformerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcTransformerTypeEnum = IfcTransformerTypeEnum;
  class IfcTransitionCode {
  }
  IfcTransitionCode.DISCONTINUOUS = { type: 3, value: "DISCONTINUOUS" };
  IfcTransitionCode.CONTINUOUS = { type: 3, value: "CONTINUOUS" };
  IfcTransitionCode.CONTSAMEGRADIENT = { type: 3, value: "CONTSAMEGRADIENT" };
  IfcTransitionCode.CONTSAMEGRADIENTSAMECURVATURE = { type: 3, value: "CONTSAMEGRADIENTSAMECURVATURE" };
  IFC2X32.IfcTransitionCode = IfcTransitionCode;
  class IfcTransportElementTypeEnum {
  }
  IfcTransportElementTypeEnum.ELEVATOR = { type: 3, value: "ELEVATOR" };
  IfcTransportElementTypeEnum.ESCALATOR = { type: 3, value: "ESCALATOR" };
  IfcTransportElementTypeEnum.MOVINGWALKWAY = { type: 3, value: "MOVINGWALKWAY" };
  IfcTransportElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTransportElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcTransportElementTypeEnum = IfcTransportElementTypeEnum;
  class IfcTrimmingPreference {
  }
  IfcTrimmingPreference.CARTESIAN = { type: 3, value: "CARTESIAN" };
  IfcTrimmingPreference.PARAMETER = { type: 3, value: "PARAMETER" };
  IfcTrimmingPreference.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  IFC2X32.IfcTrimmingPreference = IfcTrimmingPreference;
  class IfcTubeBundleTypeEnum {
  }
  IfcTubeBundleTypeEnum.FINNED = { type: 3, value: "FINNED" };
  IfcTubeBundleTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTubeBundleTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcTubeBundleTypeEnum = IfcTubeBundleTypeEnum;
  class IfcUnitEnum {
  }
  IfcUnitEnum.ABSORBEDDOSEUNIT = { type: 3, value: "ABSORBEDDOSEUNIT" };
  IfcUnitEnum.AMOUNTOFSUBSTANCEUNIT = { type: 3, value: "AMOUNTOFSUBSTANCEUNIT" };
  IfcUnitEnum.AREAUNIT = { type: 3, value: "AREAUNIT" };
  IfcUnitEnum.DOSEEQUIVALENTUNIT = { type: 3, value: "DOSEEQUIVALENTUNIT" };
  IfcUnitEnum.ELECTRICCAPACITANCEUNIT = { type: 3, value: "ELECTRICCAPACITANCEUNIT" };
  IfcUnitEnum.ELECTRICCHARGEUNIT = { type: 3, value: "ELECTRICCHARGEUNIT" };
  IfcUnitEnum.ELECTRICCONDUCTANCEUNIT = { type: 3, value: "ELECTRICCONDUCTANCEUNIT" };
  IfcUnitEnum.ELECTRICCURRENTUNIT = { type: 3, value: "ELECTRICCURRENTUNIT" };
  IfcUnitEnum.ELECTRICRESISTANCEUNIT = { type: 3, value: "ELECTRICRESISTANCEUNIT" };
  IfcUnitEnum.ELECTRICVOLTAGEUNIT = { type: 3, value: "ELECTRICVOLTAGEUNIT" };
  IfcUnitEnum.ENERGYUNIT = { type: 3, value: "ENERGYUNIT" };
  IfcUnitEnum.FORCEUNIT = { type: 3, value: "FORCEUNIT" };
  IfcUnitEnum.FREQUENCYUNIT = { type: 3, value: "FREQUENCYUNIT" };
  IfcUnitEnum.ILLUMINANCEUNIT = { type: 3, value: "ILLUMINANCEUNIT" };
  IfcUnitEnum.INDUCTANCEUNIT = { type: 3, value: "INDUCTANCEUNIT" };
  IfcUnitEnum.LENGTHUNIT = { type: 3, value: "LENGTHUNIT" };
  IfcUnitEnum.LUMINOUSFLUXUNIT = { type: 3, value: "LUMINOUSFLUXUNIT" };
  IfcUnitEnum.LUMINOUSINTENSITYUNIT = { type: 3, value: "LUMINOUSINTENSITYUNIT" };
  IfcUnitEnum.MAGNETICFLUXDENSITYUNIT = { type: 3, value: "MAGNETICFLUXDENSITYUNIT" };
  IfcUnitEnum.MAGNETICFLUXUNIT = { type: 3, value: "MAGNETICFLUXUNIT" };
  IfcUnitEnum.MASSUNIT = { type: 3, value: "MASSUNIT" };
  IfcUnitEnum.PLANEANGLEUNIT = { type: 3, value: "PLANEANGLEUNIT" };
  IfcUnitEnum.POWERUNIT = { type: 3, value: "POWERUNIT" };
  IfcUnitEnum.PRESSUREUNIT = { type: 3, value: "PRESSUREUNIT" };
  IfcUnitEnum.RADIOACTIVITYUNIT = { type: 3, value: "RADIOACTIVITYUNIT" };
  IfcUnitEnum.SOLIDANGLEUNIT = { type: 3, value: "SOLIDANGLEUNIT" };
  IfcUnitEnum.THERMODYNAMICTEMPERATUREUNIT = { type: 3, value: "THERMODYNAMICTEMPERATUREUNIT" };
  IfcUnitEnum.TIMEUNIT = { type: 3, value: "TIMEUNIT" };
  IfcUnitEnum.VOLUMEUNIT = { type: 3, value: "VOLUMEUNIT" };
  IfcUnitEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IFC2X32.IfcUnitEnum = IfcUnitEnum;
  class IfcUnitaryEquipmentTypeEnum {
  }
  IfcUnitaryEquipmentTypeEnum.AIRHANDLER = { type: 3, value: "AIRHANDLER" };
  IfcUnitaryEquipmentTypeEnum.AIRCONDITIONINGUNIT = { type: 3, value: "AIRCONDITIONINGUNIT" };
  IfcUnitaryEquipmentTypeEnum.SPLITSYSTEM = { type: 3, value: "SPLITSYSTEM" };
  IfcUnitaryEquipmentTypeEnum.ROOFTOPUNIT = { type: 3, value: "ROOFTOPUNIT" };
  IfcUnitaryEquipmentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcUnitaryEquipmentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcUnitaryEquipmentTypeEnum = IfcUnitaryEquipmentTypeEnum;
  class IfcValveTypeEnum {
  }
  IfcValveTypeEnum.AIRRELEASE = { type: 3, value: "AIRRELEASE" };
  IfcValveTypeEnum.ANTIVACUUM = { type: 3, value: "ANTIVACUUM" };
  IfcValveTypeEnum.CHANGEOVER = { type: 3, value: "CHANGEOVER" };
  IfcValveTypeEnum.CHECK = { type: 3, value: "CHECK" };
  IfcValveTypeEnum.COMMISSIONING = { type: 3, value: "COMMISSIONING" };
  IfcValveTypeEnum.DIVERTING = { type: 3, value: "DIVERTING" };
  IfcValveTypeEnum.DRAWOFFCOCK = { type: 3, value: "DRAWOFFCOCK" };
  IfcValveTypeEnum.DOUBLECHECK = { type: 3, value: "DOUBLECHECK" };
  IfcValveTypeEnum.DOUBLEREGULATING = { type: 3, value: "DOUBLEREGULATING" };
  IfcValveTypeEnum.FAUCET = { type: 3, value: "FAUCET" };
  IfcValveTypeEnum.FLUSHING = { type: 3, value: "FLUSHING" };
  IfcValveTypeEnum.GASCOCK = { type: 3, value: "GASCOCK" };
  IfcValveTypeEnum.GASTAP = { type: 3, value: "GASTAP" };
  IfcValveTypeEnum.ISOLATING = { type: 3, value: "ISOLATING" };
  IfcValveTypeEnum.MIXING = { type: 3, value: "MIXING" };
  IfcValveTypeEnum.PRESSUREREDUCING = { type: 3, value: "PRESSUREREDUCING" };
  IfcValveTypeEnum.PRESSURERELIEF = { type: 3, value: "PRESSURERELIEF" };
  IfcValveTypeEnum.REGULATING = { type: 3, value: "REGULATING" };
  IfcValveTypeEnum.SAFETYCUTOFF = { type: 3, value: "SAFETYCUTOFF" };
  IfcValveTypeEnum.STEAMTRAP = { type: 3, value: "STEAMTRAP" };
  IfcValveTypeEnum.STOPCOCK = { type: 3, value: "STOPCOCK" };
  IfcValveTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcValveTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcValveTypeEnum = IfcValveTypeEnum;
  class IfcVibrationIsolatorTypeEnum {
  }
  IfcVibrationIsolatorTypeEnum.COMPRESSION = { type: 3, value: "COMPRESSION" };
  IfcVibrationIsolatorTypeEnum.SPRING = { type: 3, value: "SPRING" };
  IfcVibrationIsolatorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcVibrationIsolatorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcVibrationIsolatorTypeEnum = IfcVibrationIsolatorTypeEnum;
  class IfcWallTypeEnum {
  }
  IfcWallTypeEnum.STANDARD = { type: 3, value: "STANDARD" };
  IfcWallTypeEnum.POLYGONAL = { type: 3, value: "POLYGONAL" };
  IfcWallTypeEnum.SHEAR = { type: 3, value: "SHEAR" };
  IfcWallTypeEnum.ELEMENTEDWALL = { type: 3, value: "ELEMENTEDWALL" };
  IfcWallTypeEnum.PLUMBINGWALL = { type: 3, value: "PLUMBINGWALL" };
  IfcWallTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWallTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcWallTypeEnum = IfcWallTypeEnum;
  class IfcWasteTerminalTypeEnum {
  }
  IfcWasteTerminalTypeEnum.FLOORTRAP = { type: 3, value: "FLOORTRAP" };
  IfcWasteTerminalTypeEnum.FLOORWASTE = { type: 3, value: "FLOORWASTE" };
  IfcWasteTerminalTypeEnum.GULLYSUMP = { type: 3, value: "GULLYSUMP" };
  IfcWasteTerminalTypeEnum.GULLYTRAP = { type: 3, value: "GULLYTRAP" };
  IfcWasteTerminalTypeEnum.GREASEINTERCEPTOR = { type: 3, value: "GREASEINTERCEPTOR" };
  IfcWasteTerminalTypeEnum.OILINTERCEPTOR = { type: 3, value: "OILINTERCEPTOR" };
  IfcWasteTerminalTypeEnum.PETROLINTERCEPTOR = { type: 3, value: "PETROLINTERCEPTOR" };
  IfcWasteTerminalTypeEnum.ROOFDRAIN = { type: 3, value: "ROOFDRAIN" };
  IfcWasteTerminalTypeEnum.WASTEDISPOSALUNIT = { type: 3, value: "WASTEDISPOSALUNIT" };
  IfcWasteTerminalTypeEnum.WASTETRAP = { type: 3, value: "WASTETRAP" };
  IfcWasteTerminalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWasteTerminalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcWasteTerminalTypeEnum = IfcWasteTerminalTypeEnum;
  class IfcWindowPanelOperationEnum {
  }
  IfcWindowPanelOperationEnum.SIDEHUNGRIGHTHAND = { type: 3, value: "SIDEHUNGRIGHTHAND" };
  IfcWindowPanelOperationEnum.SIDEHUNGLEFTHAND = { type: 3, value: "SIDEHUNGLEFTHAND" };
  IfcWindowPanelOperationEnum.TILTANDTURNRIGHTHAND = { type: 3, value: "TILTANDTURNRIGHTHAND" };
  IfcWindowPanelOperationEnum.TILTANDTURNLEFTHAND = { type: 3, value: "TILTANDTURNLEFTHAND" };
  IfcWindowPanelOperationEnum.TOPHUNG = { type: 3, value: "TOPHUNG" };
  IfcWindowPanelOperationEnum.BOTTOMHUNG = { type: 3, value: "BOTTOMHUNG" };
  IfcWindowPanelOperationEnum.PIVOTHORIZONTAL = { type: 3, value: "PIVOTHORIZONTAL" };
  IfcWindowPanelOperationEnum.PIVOTVERTICAL = { type: 3, value: "PIVOTVERTICAL" };
  IfcWindowPanelOperationEnum.SLIDINGHORIZONTAL = { type: 3, value: "SLIDINGHORIZONTAL" };
  IfcWindowPanelOperationEnum.SLIDINGVERTICAL = { type: 3, value: "SLIDINGVERTICAL" };
  IfcWindowPanelOperationEnum.REMOVABLECASEMENT = { type: 3, value: "REMOVABLECASEMENT" };
  IfcWindowPanelOperationEnum.FIXEDCASEMENT = { type: 3, value: "FIXEDCASEMENT" };
  IfcWindowPanelOperationEnum.OTHEROPERATION = { type: 3, value: "OTHEROPERATION" };
  IfcWindowPanelOperationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcWindowPanelOperationEnum = IfcWindowPanelOperationEnum;
  class IfcWindowPanelPositionEnum {
  }
  IfcWindowPanelPositionEnum.LEFT = { type: 3, value: "LEFT" };
  IfcWindowPanelPositionEnum.MIDDLE = { type: 3, value: "MIDDLE" };
  IfcWindowPanelPositionEnum.RIGHT = { type: 3, value: "RIGHT" };
  IfcWindowPanelPositionEnum.BOTTOM = { type: 3, value: "BOTTOM" };
  IfcWindowPanelPositionEnum.TOP = { type: 3, value: "TOP" };
  IfcWindowPanelPositionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcWindowPanelPositionEnum = IfcWindowPanelPositionEnum;
  class IfcWindowStyleConstructionEnum {
  }
  IfcWindowStyleConstructionEnum.ALUMINIUM = { type: 3, value: "ALUMINIUM" };
  IfcWindowStyleConstructionEnum.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" };
  IfcWindowStyleConstructionEnum.STEEL = { type: 3, value: "STEEL" };
  IfcWindowStyleConstructionEnum.WOOD = { type: 3, value: "WOOD" };
  IfcWindowStyleConstructionEnum.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" };
  IfcWindowStyleConstructionEnum.PLASTIC = { type: 3, value: "PLASTIC" };
  IfcWindowStyleConstructionEnum.OTHER_CONSTRUCTION = { type: 3, value: "OTHER_CONSTRUCTION" };
  IfcWindowStyleConstructionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcWindowStyleConstructionEnum = IfcWindowStyleConstructionEnum;
  class IfcWindowStyleOperationEnum {
  }
  IfcWindowStyleOperationEnum.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" };
  IfcWindowStyleOperationEnum.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" };
  IfcWindowStyleOperationEnum.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" };
  IfcWindowStyleOperationEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWindowStyleOperationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcWindowStyleOperationEnum = IfcWindowStyleOperationEnum;
  class IfcWorkControlTypeEnum {
  }
  IfcWorkControlTypeEnum.ACTUAL = { type: 3, value: "ACTUAL" };
  IfcWorkControlTypeEnum.BASELINE = { type: 3, value: "BASELINE" };
  IfcWorkControlTypeEnum.PLANNED = { type: 3, value: "PLANNED" };
  IfcWorkControlTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWorkControlTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC2X32.IfcWorkControlTypeEnum = IfcWorkControlTypeEnum;
  class IfcActorRole extends IfcLineObject {
    constructor(expressID, Role, UserDefinedRole, Description) {
      super(expressID);
      this.Role = Role;
      this.UserDefinedRole = UserDefinedRole;
      this.Description = Description;
      this.type = 3630933823;
    }
  }
  IFC2X32.IfcActorRole = IfcActorRole;
  class IfcAddress extends IfcLineObject {
    constructor(expressID, Purpose, Description, UserDefinedPurpose) {
      super(expressID);
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.type = 618182010;
    }
  }
  IFC2X32.IfcAddress = IfcAddress;
  class IfcApplication extends IfcLineObject {
    constructor(expressID, ApplicationDeveloper, Version, ApplicationFullName, ApplicationIdentifier) {
      super(expressID);
      this.ApplicationDeveloper = ApplicationDeveloper;
      this.Version = Version;
      this.ApplicationFullName = ApplicationFullName;
      this.ApplicationIdentifier = ApplicationIdentifier;
      this.type = 639542469;
    }
  }
  IFC2X32.IfcApplication = IfcApplication;
  class IfcAppliedValue extends IfcLineObject {
    constructor(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.AppliedValue = AppliedValue;
      this.UnitBasis = UnitBasis;
      this.ApplicableDate = ApplicableDate;
      this.FixedUntilDate = FixedUntilDate;
      this.type = 411424972;
    }
  }
  IFC2X32.IfcAppliedValue = IfcAppliedValue;
  class IfcAppliedValueRelationship extends IfcLineObject {
    constructor(expressID, ComponentOfTotal, Components, ArithmeticOperator, Name, Description) {
      super(expressID);
      this.ComponentOfTotal = ComponentOfTotal;
      this.Components = Components;
      this.ArithmeticOperator = ArithmeticOperator;
      this.Name = Name;
      this.Description = Description;
      this.type = 1110488051;
    }
  }
  IFC2X32.IfcAppliedValueRelationship = IfcAppliedValueRelationship;
  class IfcApproval extends IfcLineObject {
    constructor(expressID, Description, ApprovalDateTime, ApprovalStatus, ApprovalLevel, ApprovalQualifier, Name, Identifier) {
      super(expressID);
      this.Description = Description;
      this.ApprovalDateTime = ApprovalDateTime;
      this.ApprovalStatus = ApprovalStatus;
      this.ApprovalLevel = ApprovalLevel;
      this.ApprovalQualifier = ApprovalQualifier;
      this.Name = Name;
      this.Identifier = Identifier;
      this.type = 130549933;
    }
  }
  IFC2X32.IfcApproval = IfcApproval;
  class IfcApprovalActorRelationship extends IfcLineObject {
    constructor(expressID, Actor, Approval, Role) {
      super(expressID);
      this.Actor = Actor;
      this.Approval = Approval;
      this.Role = Role;
      this.type = 2080292479;
    }
  }
  IFC2X32.IfcApprovalActorRelationship = IfcApprovalActorRelationship;
  class IfcApprovalPropertyRelationship extends IfcLineObject {
    constructor(expressID, ApprovedProperties, Approval) {
      super(expressID);
      this.ApprovedProperties = ApprovedProperties;
      this.Approval = Approval;
      this.type = 390851274;
    }
  }
  IFC2X32.IfcApprovalPropertyRelationship = IfcApprovalPropertyRelationship;
  class IfcApprovalRelationship extends IfcLineObject {
    constructor(expressID, RelatedApproval, RelatingApproval, Description, Name) {
      super(expressID);
      this.RelatedApproval = RelatedApproval;
      this.RelatingApproval = RelatingApproval;
      this.Description = Description;
      this.Name = Name;
      this.type = 3869604511;
    }
  }
  IFC2X32.IfcApprovalRelationship = IfcApprovalRelationship;
  class IfcBoundaryCondition extends IfcLineObject {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 4037036970;
    }
  }
  IFC2X32.IfcBoundaryCondition = IfcBoundaryCondition;
  class IfcBoundaryEdgeCondition extends IfcBoundaryCondition {
    constructor(expressID, Name, LinearStiffnessByLengthX, LinearStiffnessByLengthY, LinearStiffnessByLengthZ, RotationalStiffnessByLengthX, RotationalStiffnessByLengthY, RotationalStiffnessByLengthZ) {
      super(expressID, Name);
      this.Name = Name;
      this.LinearStiffnessByLengthX = LinearStiffnessByLengthX;
      this.LinearStiffnessByLengthY = LinearStiffnessByLengthY;
      this.LinearStiffnessByLengthZ = LinearStiffnessByLengthZ;
      this.RotationalStiffnessByLengthX = RotationalStiffnessByLengthX;
      this.RotationalStiffnessByLengthY = RotationalStiffnessByLengthY;
      this.RotationalStiffnessByLengthZ = RotationalStiffnessByLengthZ;
      this.type = 1560379544;
    }
  }
  IFC2X32.IfcBoundaryEdgeCondition = IfcBoundaryEdgeCondition;
  class IfcBoundaryFaceCondition extends IfcBoundaryCondition {
    constructor(expressID, Name, LinearStiffnessByAreaX, LinearStiffnessByAreaY, LinearStiffnessByAreaZ) {
      super(expressID, Name);
      this.Name = Name;
      this.LinearStiffnessByAreaX = LinearStiffnessByAreaX;
      this.LinearStiffnessByAreaY = LinearStiffnessByAreaY;
      this.LinearStiffnessByAreaZ = LinearStiffnessByAreaZ;
      this.type = 3367102660;
    }
  }
  IFC2X32.IfcBoundaryFaceCondition = IfcBoundaryFaceCondition;
  class IfcBoundaryNodeCondition extends IfcBoundaryCondition {
    constructor(expressID, Name, LinearStiffnessX, LinearStiffnessY, LinearStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ) {
      super(expressID, Name);
      this.Name = Name;
      this.LinearStiffnessX = LinearStiffnessX;
      this.LinearStiffnessY = LinearStiffnessY;
      this.LinearStiffnessZ = LinearStiffnessZ;
      this.RotationalStiffnessX = RotationalStiffnessX;
      this.RotationalStiffnessY = RotationalStiffnessY;
      this.RotationalStiffnessZ = RotationalStiffnessZ;
      this.type = 1387855156;
    }
  }
  IFC2X32.IfcBoundaryNodeCondition = IfcBoundaryNodeCondition;
  class IfcBoundaryNodeConditionWarping extends IfcBoundaryNodeCondition {
    constructor(expressID, Name, LinearStiffnessX, LinearStiffnessY, LinearStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ, WarpingStiffness) {
      super(expressID, Name, LinearStiffnessX, LinearStiffnessY, LinearStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ);
      this.Name = Name;
      this.LinearStiffnessX = LinearStiffnessX;
      this.LinearStiffnessY = LinearStiffnessY;
      this.LinearStiffnessZ = LinearStiffnessZ;
      this.RotationalStiffnessX = RotationalStiffnessX;
      this.RotationalStiffnessY = RotationalStiffnessY;
      this.RotationalStiffnessZ = RotationalStiffnessZ;
      this.WarpingStiffness = WarpingStiffness;
      this.type = 2069777674;
    }
  }
  IFC2X32.IfcBoundaryNodeConditionWarping = IfcBoundaryNodeConditionWarping;
  class IfcCalendarDate extends IfcLineObject {
    constructor(expressID, DayComponent, MonthComponent, YearComponent) {
      super(expressID);
      this.DayComponent = DayComponent;
      this.MonthComponent = MonthComponent;
      this.YearComponent = YearComponent;
      this.type = 622194075;
    }
  }
  IFC2X32.IfcCalendarDate = IfcCalendarDate;
  class IfcClassification extends IfcLineObject {
    constructor(expressID, Source, Edition, EditionDate, Name) {
      super(expressID);
      this.Source = Source;
      this.Edition = Edition;
      this.EditionDate = EditionDate;
      this.Name = Name;
      this.type = 747523909;
    }
  }
  IFC2X32.IfcClassification = IfcClassification;
  class IfcClassificationItem extends IfcLineObject {
    constructor(expressID, Notation, ItemOf, Title) {
      super(expressID);
      this.Notation = Notation;
      this.ItemOf = ItemOf;
      this.Title = Title;
      this.type = 1767535486;
    }
  }
  IFC2X32.IfcClassificationItem = IfcClassificationItem;
  class IfcClassificationItemRelationship extends IfcLineObject {
    constructor(expressID, RelatingItem, RelatedItems) {
      super(expressID);
      this.RelatingItem = RelatingItem;
      this.RelatedItems = RelatedItems;
      this.type = 1098599126;
    }
  }
  IFC2X32.IfcClassificationItemRelationship = IfcClassificationItemRelationship;
  class IfcClassificationNotation extends IfcLineObject {
    constructor(expressID, NotationFacets) {
      super(expressID);
      this.NotationFacets = NotationFacets;
      this.type = 938368621;
    }
  }
  IFC2X32.IfcClassificationNotation = IfcClassificationNotation;
  class IfcClassificationNotationFacet extends IfcLineObject {
    constructor(expressID, NotationValue) {
      super(expressID);
      this.NotationValue = NotationValue;
      this.type = 3639012971;
    }
  }
  IFC2X32.IfcClassificationNotationFacet = IfcClassificationNotationFacet;
  class IfcColourSpecification extends IfcLineObject {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 3264961684;
    }
  }
  IFC2X32.IfcColourSpecification = IfcColourSpecification;
  class IfcConnectionGeometry extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 2859738748;
    }
  }
  IFC2X32.IfcConnectionGeometry = IfcConnectionGeometry;
  class IfcConnectionPointGeometry extends IfcConnectionGeometry {
    constructor(expressID, PointOnRelatingElement, PointOnRelatedElement) {
      super(expressID);
      this.PointOnRelatingElement = PointOnRelatingElement;
      this.PointOnRelatedElement = PointOnRelatedElement;
      this.type = 2614616156;
    }
  }
  IFC2X32.IfcConnectionPointGeometry = IfcConnectionPointGeometry;
  class IfcConnectionPortGeometry extends IfcConnectionGeometry {
    constructor(expressID, LocationAtRelatingElement, LocationAtRelatedElement, ProfileOfPort) {
      super(expressID);
      this.LocationAtRelatingElement = LocationAtRelatingElement;
      this.LocationAtRelatedElement = LocationAtRelatedElement;
      this.ProfileOfPort = ProfileOfPort;
      this.type = 4257277454;
    }
  }
  IFC2X32.IfcConnectionPortGeometry = IfcConnectionPortGeometry;
  class IfcConnectionSurfaceGeometry extends IfcConnectionGeometry {
    constructor(expressID, SurfaceOnRelatingElement, SurfaceOnRelatedElement) {
      super(expressID);
      this.SurfaceOnRelatingElement = SurfaceOnRelatingElement;
      this.SurfaceOnRelatedElement = SurfaceOnRelatedElement;
      this.type = 2732653382;
    }
  }
  IFC2X32.IfcConnectionSurfaceGeometry = IfcConnectionSurfaceGeometry;
  class IfcConstraint extends IfcLineObject {
    constructor(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.type = 1959218052;
    }
  }
  IFC2X32.IfcConstraint = IfcConstraint;
  class IfcConstraintAggregationRelationship extends IfcLineObject {
    constructor(expressID, Name, Description, RelatingConstraint, RelatedConstraints, LogicalAggregator) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.RelatingConstraint = RelatingConstraint;
      this.RelatedConstraints = RelatedConstraints;
      this.LogicalAggregator = LogicalAggregator;
      this.type = 1658513725;
    }
  }
  IFC2X32.IfcConstraintAggregationRelationship = IfcConstraintAggregationRelationship;
  class IfcConstraintClassificationRelationship extends IfcLineObject {
    constructor(expressID, ClassifiedConstraint, RelatedClassifications) {
      super(expressID);
      this.ClassifiedConstraint = ClassifiedConstraint;
      this.RelatedClassifications = RelatedClassifications;
      this.type = 613356794;
    }
  }
  IFC2X32.IfcConstraintClassificationRelationship = IfcConstraintClassificationRelationship;
  class IfcConstraintRelationship extends IfcLineObject {
    constructor(expressID, Name, Description, RelatingConstraint, RelatedConstraints) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.RelatingConstraint = RelatingConstraint;
      this.RelatedConstraints = RelatedConstraints;
      this.type = 347226245;
    }
  }
  IFC2X32.IfcConstraintRelationship = IfcConstraintRelationship;
  class IfcCoordinatedUniversalTimeOffset extends IfcLineObject {
    constructor(expressID, HourOffset, MinuteOffset, Sense) {
      super(expressID);
      this.HourOffset = HourOffset;
      this.MinuteOffset = MinuteOffset;
      this.Sense = Sense;
      this.type = 1065062679;
    }
  }
  IFC2X32.IfcCoordinatedUniversalTimeOffset = IfcCoordinatedUniversalTimeOffset;
  class IfcCostValue extends IfcAppliedValue {
    constructor(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, CostType, Condition) {
      super(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate);
      this.Name = Name;
      this.Description = Description;
      this.AppliedValue = AppliedValue;
      this.UnitBasis = UnitBasis;
      this.ApplicableDate = ApplicableDate;
      this.FixedUntilDate = FixedUntilDate;
      this.CostType = CostType;
      this.Condition = Condition;
      this.type = 602808272;
    }
  }
  IFC2X32.IfcCostValue = IfcCostValue;
  class IfcCurrencyRelationship extends IfcLineObject {
    constructor(expressID, RelatingMonetaryUnit, RelatedMonetaryUnit, ExchangeRate, RateDateTime, RateSource) {
      super(expressID);
      this.RelatingMonetaryUnit = RelatingMonetaryUnit;
      this.RelatedMonetaryUnit = RelatedMonetaryUnit;
      this.ExchangeRate = ExchangeRate;
      this.RateDateTime = RateDateTime;
      this.RateSource = RateSource;
      this.type = 539742890;
    }
  }
  IFC2X32.IfcCurrencyRelationship = IfcCurrencyRelationship;
  class IfcCurveStyleFont extends IfcLineObject {
    constructor(expressID, Name, PatternList) {
      super(expressID);
      this.Name = Name;
      this.PatternList = PatternList;
      this.type = 1105321065;
    }
  }
  IFC2X32.IfcCurveStyleFont = IfcCurveStyleFont;
  class IfcCurveStyleFontAndScaling extends IfcLineObject {
    constructor(expressID, Name, CurveFont, CurveFontScaling) {
      super(expressID);
      this.Name = Name;
      this.CurveFont = CurveFont;
      this.CurveFontScaling = CurveFontScaling;
      this.type = 2367409068;
    }
  }
  IFC2X32.IfcCurveStyleFontAndScaling = IfcCurveStyleFontAndScaling;
  class IfcCurveStyleFontPattern extends IfcLineObject {
    constructor(expressID, VisibleSegmentLength, InvisibleSegmentLength) {
      super(expressID);
      this.VisibleSegmentLength = VisibleSegmentLength;
      this.InvisibleSegmentLength = InvisibleSegmentLength;
      this.type = 3510044353;
    }
  }
  IFC2X32.IfcCurveStyleFontPattern = IfcCurveStyleFontPattern;
  class IfcDateAndTime extends IfcLineObject {
    constructor(expressID, DateComponent, TimeComponent) {
      super(expressID);
      this.DateComponent = DateComponent;
      this.TimeComponent = TimeComponent;
      this.type = 1072939445;
    }
  }
  IFC2X32.IfcDateAndTime = IfcDateAndTime;
  class IfcDerivedUnit extends IfcLineObject {
    constructor(expressID, Elements, UnitType, UserDefinedType) {
      super(expressID);
      this.Elements = Elements;
      this.UnitType = UnitType;
      this.UserDefinedType = UserDefinedType;
      this.type = 1765591967;
    }
  }
  IFC2X32.IfcDerivedUnit = IfcDerivedUnit;
  class IfcDerivedUnitElement extends IfcLineObject {
    constructor(expressID, Unit, Exponent) {
      super(expressID);
      this.Unit = Unit;
      this.Exponent = Exponent;
      this.type = 1045800335;
    }
  }
  IFC2X32.IfcDerivedUnitElement = IfcDerivedUnitElement;
  class IfcDimensionalExponents extends IfcLineObject {
    constructor(expressID, LengthExponent, MassExponent, TimeExponent, ElectricCurrentExponent, ThermodynamicTemperatureExponent, AmountOfSubstanceExponent, LuminousIntensityExponent) {
      super(expressID);
      this.LengthExponent = LengthExponent;
      this.MassExponent = MassExponent;
      this.TimeExponent = TimeExponent;
      this.ElectricCurrentExponent = ElectricCurrentExponent;
      this.ThermodynamicTemperatureExponent = ThermodynamicTemperatureExponent;
      this.AmountOfSubstanceExponent = AmountOfSubstanceExponent;
      this.LuminousIntensityExponent = LuminousIntensityExponent;
      this.type = 2949456006;
    }
  }
  IFC2X32.IfcDimensionalExponents = IfcDimensionalExponents;
  class IfcDocumentElectronicFormat extends IfcLineObject {
    constructor(expressID, FileExtension, MimeContentType, MimeSubtype) {
      super(expressID);
      this.FileExtension = FileExtension;
      this.MimeContentType = MimeContentType;
      this.MimeSubtype = MimeSubtype;
      this.type = 1376555844;
    }
  }
  IFC2X32.IfcDocumentElectronicFormat = IfcDocumentElectronicFormat;
  class IfcDocumentInformation extends IfcLineObject {
    constructor(expressID, DocumentId, Name, Description, DocumentReferences, Purpose, IntendedUse, Scope, Revision, DocumentOwner, Editors, CreationTime, LastRevisionTime, ElectronicFormat, ValidFrom, ValidUntil, Confidentiality, Status) {
      super(expressID);
      this.DocumentId = DocumentId;
      this.Name = Name;
      this.Description = Description;
      this.DocumentReferences = DocumentReferences;
      this.Purpose = Purpose;
      this.IntendedUse = IntendedUse;
      this.Scope = Scope;
      this.Revision = Revision;
      this.DocumentOwner = DocumentOwner;
      this.Editors = Editors;
      this.CreationTime = CreationTime;
      this.LastRevisionTime = LastRevisionTime;
      this.ElectronicFormat = ElectronicFormat;
      this.ValidFrom = ValidFrom;
      this.ValidUntil = ValidUntil;
      this.Confidentiality = Confidentiality;
      this.Status = Status;
      this.type = 1154170062;
    }
  }
  IFC2X32.IfcDocumentInformation = IfcDocumentInformation;
  class IfcDocumentInformationRelationship extends IfcLineObject {
    constructor(expressID, RelatingDocument, RelatedDocuments, RelationshipType) {
      super(expressID);
      this.RelatingDocument = RelatingDocument;
      this.RelatedDocuments = RelatedDocuments;
      this.RelationshipType = RelationshipType;
      this.type = 770865208;
    }
  }
  IFC2X32.IfcDocumentInformationRelationship = IfcDocumentInformationRelationship;
  class IfcDraughtingCalloutRelationship extends IfcLineObject {
    constructor(expressID, Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.RelatingDraughtingCallout = RelatingDraughtingCallout;
      this.RelatedDraughtingCallout = RelatedDraughtingCallout;
      this.type = 3796139169;
    }
  }
  IFC2X32.IfcDraughtingCalloutRelationship = IfcDraughtingCalloutRelationship;
  class IfcEnvironmentalImpactValue extends IfcAppliedValue {
    constructor(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, ImpactType, Category, UserDefinedCategory) {
      super(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate);
      this.Name = Name;
      this.Description = Description;
      this.AppliedValue = AppliedValue;
      this.UnitBasis = UnitBasis;
      this.ApplicableDate = ApplicableDate;
      this.FixedUntilDate = FixedUntilDate;
      this.ImpactType = ImpactType;
      this.Category = Category;
      this.UserDefinedCategory = UserDefinedCategory;
      this.type = 1648886627;
    }
  }
  IFC2X32.IfcEnvironmentalImpactValue = IfcEnvironmentalImpactValue;
  class IfcExternalReference extends IfcLineObject {
    constructor(expressID, Location, ItemReference, Name) {
      super(expressID);
      this.Location = Location;
      this.ItemReference = ItemReference;
      this.Name = Name;
      this.type = 3200245327;
    }
  }
  IFC2X32.IfcExternalReference = IfcExternalReference;
  class IfcExternallyDefinedHatchStyle extends IfcExternalReference {
    constructor(expressID, Location, ItemReference, Name) {
      super(expressID, Location, ItemReference, Name);
      this.Location = Location;
      this.ItemReference = ItemReference;
      this.Name = Name;
      this.type = 2242383968;
    }
  }
  IFC2X32.IfcExternallyDefinedHatchStyle = IfcExternallyDefinedHatchStyle;
  class IfcExternallyDefinedSurfaceStyle extends IfcExternalReference {
    constructor(expressID, Location, ItemReference, Name) {
      super(expressID, Location, ItemReference, Name);
      this.Location = Location;
      this.ItemReference = ItemReference;
      this.Name = Name;
      this.type = 1040185647;
    }
  }
  IFC2X32.IfcExternallyDefinedSurfaceStyle = IfcExternallyDefinedSurfaceStyle;
  class IfcExternallyDefinedSymbol extends IfcExternalReference {
    constructor(expressID, Location, ItemReference, Name) {
      super(expressID, Location, ItemReference, Name);
      this.Location = Location;
      this.ItemReference = ItemReference;
      this.Name = Name;
      this.type = 3207319532;
    }
  }
  IFC2X32.IfcExternallyDefinedSymbol = IfcExternallyDefinedSymbol;
  class IfcExternallyDefinedTextFont extends IfcExternalReference {
    constructor(expressID, Location, ItemReference, Name) {
      super(expressID, Location, ItemReference, Name);
      this.Location = Location;
      this.ItemReference = ItemReference;
      this.Name = Name;
      this.type = 3548104201;
    }
  }
  IFC2X32.IfcExternallyDefinedTextFont = IfcExternallyDefinedTextFont;
  class IfcGridAxis extends IfcLineObject {
    constructor(expressID, AxisTag, AxisCurve, SameSense) {
      super(expressID);
      this.AxisTag = AxisTag;
      this.AxisCurve = AxisCurve;
      this.SameSense = SameSense;
      this.type = 852622518;
    }
  }
  IFC2X32.IfcGridAxis = IfcGridAxis;
  class IfcIrregularTimeSeriesValue extends IfcLineObject {
    constructor(expressID, TimeStamp, ListValues) {
      super(expressID);
      this.TimeStamp = TimeStamp;
      this.ListValues = ListValues;
      this.type = 3020489413;
    }
  }
  IFC2X32.IfcIrregularTimeSeriesValue = IfcIrregularTimeSeriesValue;
  class IfcLibraryInformation extends IfcLineObject {
    constructor(expressID, Name, Version, Publisher, VersionDate, LibraryReference) {
      super(expressID);
      this.Name = Name;
      this.Version = Version;
      this.Publisher = Publisher;
      this.VersionDate = VersionDate;
      this.LibraryReference = LibraryReference;
      this.type = 2655187982;
    }
  }
  IFC2X32.IfcLibraryInformation = IfcLibraryInformation;
  class IfcLibraryReference extends IfcExternalReference {
    constructor(expressID, Location, ItemReference, Name) {
      super(expressID, Location, ItemReference, Name);
      this.Location = Location;
      this.ItemReference = ItemReference;
      this.Name = Name;
      this.type = 3452421091;
    }
  }
  IFC2X32.IfcLibraryReference = IfcLibraryReference;
  class IfcLightDistributionData extends IfcLineObject {
    constructor(expressID, MainPlaneAngle, SecondaryPlaneAngle, LuminousIntensity) {
      super(expressID);
      this.MainPlaneAngle = MainPlaneAngle;
      this.SecondaryPlaneAngle = SecondaryPlaneAngle;
      this.LuminousIntensity = LuminousIntensity;
      this.type = 4162380809;
    }
  }
  IFC2X32.IfcLightDistributionData = IfcLightDistributionData;
  class IfcLightIntensityDistribution extends IfcLineObject {
    constructor(expressID, LightDistributionCurve, DistributionData) {
      super(expressID);
      this.LightDistributionCurve = LightDistributionCurve;
      this.DistributionData = DistributionData;
      this.type = 1566485204;
    }
  }
  IFC2X32.IfcLightIntensityDistribution = IfcLightIntensityDistribution;
  class IfcLocalTime extends IfcLineObject {
    constructor(expressID, HourComponent, MinuteComponent, SecondComponent, Zone, DaylightSavingOffset) {
      super(expressID);
      this.HourComponent = HourComponent;
      this.MinuteComponent = MinuteComponent;
      this.SecondComponent = SecondComponent;
      this.Zone = Zone;
      this.DaylightSavingOffset = DaylightSavingOffset;
      this.type = 30780891;
    }
  }
  IFC2X32.IfcLocalTime = IfcLocalTime;
  class IfcMaterial extends IfcLineObject {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 1838606355;
    }
  }
  IFC2X32.IfcMaterial = IfcMaterial;
  class IfcMaterialClassificationRelationship extends IfcLineObject {
    constructor(expressID, MaterialClassifications, ClassifiedMaterial) {
      super(expressID);
      this.MaterialClassifications = MaterialClassifications;
      this.ClassifiedMaterial = ClassifiedMaterial;
      this.type = 1847130766;
    }
  }
  IFC2X32.IfcMaterialClassificationRelationship = IfcMaterialClassificationRelationship;
  class IfcMaterialLayer extends IfcLineObject {
    constructor(expressID, Material, LayerThickness, IsVentilated) {
      super(expressID);
      this.Material = Material;
      this.LayerThickness = LayerThickness;
      this.IsVentilated = IsVentilated;
      this.type = 248100487;
    }
  }
  IFC2X32.IfcMaterialLayer = IfcMaterialLayer;
  class IfcMaterialLayerSet extends IfcLineObject {
    constructor(expressID, MaterialLayers, LayerSetName) {
      super(expressID);
      this.MaterialLayers = MaterialLayers;
      this.LayerSetName = LayerSetName;
      this.type = 3303938423;
    }
  }
  IFC2X32.IfcMaterialLayerSet = IfcMaterialLayerSet;
  class IfcMaterialLayerSetUsage extends IfcLineObject {
    constructor(expressID, ForLayerSet, LayerSetDirection, DirectionSense, OffsetFromReferenceLine) {
      super(expressID);
      this.ForLayerSet = ForLayerSet;
      this.LayerSetDirection = LayerSetDirection;
      this.DirectionSense = DirectionSense;
      this.OffsetFromReferenceLine = OffsetFromReferenceLine;
      this.type = 1303795690;
    }
  }
  IFC2X32.IfcMaterialLayerSetUsage = IfcMaterialLayerSetUsage;
  class IfcMaterialList extends IfcLineObject {
    constructor(expressID, Materials) {
      super(expressID);
      this.Materials = Materials;
      this.type = 2199411900;
    }
  }
  IFC2X32.IfcMaterialList = IfcMaterialList;
  class IfcMaterialProperties extends IfcLineObject {
    constructor(expressID, Material) {
      super(expressID);
      this.Material = Material;
      this.type = 3265635763;
    }
  }
  IFC2X32.IfcMaterialProperties = IfcMaterialProperties;
  class IfcMeasureWithUnit extends IfcLineObject {
    constructor(expressID, ValueComponent, UnitComponent) {
      super(expressID);
      this.ValueComponent = ValueComponent;
      this.UnitComponent = UnitComponent;
      this.type = 2597039031;
    }
  }
  IFC2X32.IfcMeasureWithUnit = IfcMeasureWithUnit;
  class IfcMechanicalMaterialProperties extends IfcMaterialProperties {
    constructor(expressID, Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient) {
      super(expressID, Material);
      this.Material = Material;
      this.DynamicViscosity = DynamicViscosity;
      this.YoungModulus = YoungModulus;
      this.ShearModulus = ShearModulus;
      this.PoissonRatio = PoissonRatio;
      this.ThermalExpansionCoefficient = ThermalExpansionCoefficient;
      this.type = 4256014907;
    }
  }
  IFC2X32.IfcMechanicalMaterialProperties = IfcMechanicalMaterialProperties;
  class IfcMechanicalSteelMaterialProperties extends IfcMechanicalMaterialProperties {
    constructor(expressID, Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient, YieldStress, UltimateStress, UltimateStrain, HardeningModule, ProportionalStress, PlasticStrain, Relaxations) {
      super(expressID, Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient);
      this.Material = Material;
      this.DynamicViscosity = DynamicViscosity;
      this.YoungModulus = YoungModulus;
      this.ShearModulus = ShearModulus;
      this.PoissonRatio = PoissonRatio;
      this.ThermalExpansionCoefficient = ThermalExpansionCoefficient;
      this.YieldStress = YieldStress;
      this.UltimateStress = UltimateStress;
      this.UltimateStrain = UltimateStrain;
      this.HardeningModule = HardeningModule;
      this.ProportionalStress = ProportionalStress;
      this.PlasticStrain = PlasticStrain;
      this.Relaxations = Relaxations;
      this.type = 677618848;
    }
  }
  IFC2X32.IfcMechanicalSteelMaterialProperties = IfcMechanicalSteelMaterialProperties;
  class IfcMetric extends IfcConstraint {
    constructor(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, Benchmark, ValueSource, DataValue) {
      super(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.Benchmark = Benchmark;
      this.ValueSource = ValueSource;
      this.DataValue = DataValue;
      this.type = 3368373690;
    }
  }
  IFC2X32.IfcMetric = IfcMetric;
  class IfcMonetaryUnit extends IfcLineObject {
    constructor(expressID, Currency) {
      super(expressID);
      this.Currency = Currency;
      this.type = 2706619895;
    }
  }
  IFC2X32.IfcMonetaryUnit = IfcMonetaryUnit;
  class IfcNamedUnit extends IfcLineObject {
    constructor(expressID, Dimensions, UnitType) {
      super(expressID);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.type = 1918398963;
    }
  }
  IFC2X32.IfcNamedUnit = IfcNamedUnit;
  class IfcObjectPlacement extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 3701648758;
    }
  }
  IFC2X32.IfcObjectPlacement = IfcObjectPlacement;
  class IfcObjective extends IfcConstraint {
    constructor(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, BenchmarkValues, ResultValues, ObjectiveQualifier, UserDefinedQualifier) {
      super(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.BenchmarkValues = BenchmarkValues;
      this.ResultValues = ResultValues;
      this.ObjectiveQualifier = ObjectiveQualifier;
      this.UserDefinedQualifier = UserDefinedQualifier;
      this.type = 2251480897;
    }
  }
  IFC2X32.IfcObjective = IfcObjective;
  class IfcOpticalMaterialProperties extends IfcMaterialProperties {
    constructor(expressID, Material, VisibleTransmittance, SolarTransmittance, ThermalIrTransmittance, ThermalIrEmissivityBack, ThermalIrEmissivityFront, VisibleReflectanceBack, VisibleReflectanceFront, SolarReflectanceFront, SolarReflectanceBack) {
      super(expressID, Material);
      this.Material = Material;
      this.VisibleTransmittance = VisibleTransmittance;
      this.SolarTransmittance = SolarTransmittance;
      this.ThermalIrTransmittance = ThermalIrTransmittance;
      this.ThermalIrEmissivityBack = ThermalIrEmissivityBack;
      this.ThermalIrEmissivityFront = ThermalIrEmissivityFront;
      this.VisibleReflectanceBack = VisibleReflectanceBack;
      this.VisibleReflectanceFront = VisibleReflectanceFront;
      this.SolarReflectanceFront = SolarReflectanceFront;
      this.SolarReflectanceBack = SolarReflectanceBack;
      this.type = 1227763645;
    }
  }
  IFC2X32.IfcOpticalMaterialProperties = IfcOpticalMaterialProperties;
  class IfcOrganization extends IfcLineObject {
    constructor(expressID, Id, Name, Description, Roles, Addresses) {
      super(expressID);
      this.Id = Id;
      this.Name = Name;
      this.Description = Description;
      this.Roles = Roles;
      this.Addresses = Addresses;
      this.type = 4251960020;
    }
  }
  IFC2X32.IfcOrganization = IfcOrganization;
  class IfcOrganizationRelationship extends IfcLineObject {
    constructor(expressID, Name, Description, RelatingOrganization, RelatedOrganizations) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.RelatingOrganization = RelatingOrganization;
      this.RelatedOrganizations = RelatedOrganizations;
      this.type = 1411181986;
    }
  }
  IFC2X32.IfcOrganizationRelationship = IfcOrganizationRelationship;
  class IfcOwnerHistory extends IfcLineObject {
    constructor(expressID, OwningUser, OwningApplication, State, ChangeAction, LastModifiedDate, LastModifyingUser, LastModifyingApplication, CreationDate) {
      super(expressID);
      this.OwningUser = OwningUser;
      this.OwningApplication = OwningApplication;
      this.State = State;
      this.ChangeAction = ChangeAction;
      this.LastModifiedDate = LastModifiedDate;
      this.LastModifyingUser = LastModifyingUser;
      this.LastModifyingApplication = LastModifyingApplication;
      this.CreationDate = CreationDate;
      this.type = 1207048766;
    }
  }
  IFC2X32.IfcOwnerHistory = IfcOwnerHistory;
  class IfcPerson extends IfcLineObject {
    constructor(expressID, Id, FamilyName, GivenName, MiddleNames, PrefixTitles, SuffixTitles, Roles, Addresses) {
      super(expressID);
      this.Id = Id;
      this.FamilyName = FamilyName;
      this.GivenName = GivenName;
      this.MiddleNames = MiddleNames;
      this.PrefixTitles = PrefixTitles;
      this.SuffixTitles = SuffixTitles;
      this.Roles = Roles;
      this.Addresses = Addresses;
      this.type = 2077209135;
    }
  }
  IFC2X32.IfcPerson = IfcPerson;
  class IfcPersonAndOrganization extends IfcLineObject {
    constructor(expressID, ThePerson, TheOrganization, Roles) {
      super(expressID);
      this.ThePerson = ThePerson;
      this.TheOrganization = TheOrganization;
      this.Roles = Roles;
      this.type = 101040310;
    }
  }
  IFC2X32.IfcPersonAndOrganization = IfcPersonAndOrganization;
  class IfcPhysicalQuantity extends IfcLineObject {
    constructor(expressID, Name, Description) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.type = 2483315170;
    }
  }
  IFC2X32.IfcPhysicalQuantity = IfcPhysicalQuantity;
  class IfcPhysicalSimpleQuantity extends IfcPhysicalQuantity {
    constructor(expressID, Name, Description, Unit) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.type = 2226359599;
    }
  }
  IFC2X32.IfcPhysicalSimpleQuantity = IfcPhysicalSimpleQuantity;
  class IfcPostalAddress extends IfcAddress {
    constructor(expressID, Purpose, Description, UserDefinedPurpose, InternalLocation, AddressLines, PostalBox, Town, Region, PostalCode, Country) {
      super(expressID, Purpose, Description, UserDefinedPurpose);
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.InternalLocation = InternalLocation;
      this.AddressLines = AddressLines;
      this.PostalBox = PostalBox;
      this.Town = Town;
      this.Region = Region;
      this.PostalCode = PostalCode;
      this.Country = Country;
      this.type = 3355820592;
    }
  }
  IFC2X32.IfcPostalAddress = IfcPostalAddress;
  class IfcPreDefinedItem extends IfcLineObject {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 3727388367;
    }
  }
  IFC2X32.IfcPreDefinedItem = IfcPreDefinedItem;
  class IfcPreDefinedSymbol extends IfcPreDefinedItem {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 990879717;
    }
  }
  IFC2X32.IfcPreDefinedSymbol = IfcPreDefinedSymbol;
  class IfcPreDefinedTerminatorSymbol extends IfcPreDefinedSymbol {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 3213052703;
    }
  }
  IFC2X32.IfcPreDefinedTerminatorSymbol = IfcPreDefinedTerminatorSymbol;
  class IfcPreDefinedTextFont extends IfcPreDefinedItem {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 1775413392;
    }
  }
  IFC2X32.IfcPreDefinedTextFont = IfcPreDefinedTextFont;
  class IfcPresentationLayerAssignment extends IfcLineObject {
    constructor(expressID, Name, Description, AssignedItems, Identifier) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.AssignedItems = AssignedItems;
      this.Identifier = Identifier;
      this.type = 2022622350;
    }
  }
  IFC2X32.IfcPresentationLayerAssignment = IfcPresentationLayerAssignment;
  class IfcPresentationLayerWithStyle extends IfcPresentationLayerAssignment {
    constructor(expressID, Name, Description, AssignedItems, Identifier, LayerOn, LayerFrozen, LayerBlocked, LayerStyles) {
      super(expressID, Name, Description, AssignedItems, Identifier);
      this.Name = Name;
      this.Description = Description;
      this.AssignedItems = AssignedItems;
      this.Identifier = Identifier;
      this.LayerOn = LayerOn;
      this.LayerFrozen = LayerFrozen;
      this.LayerBlocked = LayerBlocked;
      this.LayerStyles = LayerStyles;
      this.type = 1304840413;
    }
  }
  IFC2X32.IfcPresentationLayerWithStyle = IfcPresentationLayerWithStyle;
  class IfcPresentationStyle extends IfcLineObject {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 3119450353;
    }
  }
  IFC2X32.IfcPresentationStyle = IfcPresentationStyle;
  class IfcPresentationStyleAssignment extends IfcLineObject {
    constructor(expressID, Styles) {
      super(expressID);
      this.Styles = Styles;
      this.type = 2417041796;
    }
  }
  IFC2X32.IfcPresentationStyleAssignment = IfcPresentationStyleAssignment;
  class IfcProductRepresentation extends IfcLineObject {
    constructor(expressID, Name, Description, Representations) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.type = 2095639259;
    }
  }
  IFC2X32.IfcProductRepresentation = IfcProductRepresentation;
  class IfcProductsOfCombustionProperties extends IfcMaterialProperties {
    constructor(expressID, Material, SpecificHeatCapacity, N20Content, COContent, CO2Content) {
      super(expressID, Material);
      this.Material = Material;
      this.SpecificHeatCapacity = SpecificHeatCapacity;
      this.N20Content = N20Content;
      this.COContent = COContent;
      this.CO2Content = CO2Content;
      this.type = 2267347899;
    }
  }
  IFC2X32.IfcProductsOfCombustionProperties = IfcProductsOfCombustionProperties;
  class IfcProfileDef extends IfcLineObject {
    constructor(expressID, ProfileType, ProfileName) {
      super(expressID);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.type = 3958567839;
    }
  }
  IFC2X32.IfcProfileDef = IfcProfileDef;
  class IfcProfileProperties extends IfcLineObject {
    constructor(expressID, ProfileName, ProfileDefinition) {
      super(expressID);
      this.ProfileName = ProfileName;
      this.ProfileDefinition = ProfileDefinition;
      this.type = 2802850158;
    }
  }
  IFC2X32.IfcProfileProperties = IfcProfileProperties;
  class IfcProperty extends IfcLineObject {
    constructor(expressID, Name, Description) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.type = 2598011224;
    }
  }
  IFC2X32.IfcProperty = IfcProperty;
  class IfcPropertyConstraintRelationship extends IfcLineObject {
    constructor(expressID, RelatingConstraint, RelatedProperties, Name, Description) {
      super(expressID);
      this.RelatingConstraint = RelatingConstraint;
      this.RelatedProperties = RelatedProperties;
      this.Name = Name;
      this.Description = Description;
      this.type = 3896028662;
    }
  }
  IFC2X32.IfcPropertyConstraintRelationship = IfcPropertyConstraintRelationship;
  class IfcPropertyDependencyRelationship extends IfcLineObject {
    constructor(expressID, DependingProperty, DependantProperty, Name, Description, Expression) {
      super(expressID);
      this.DependingProperty = DependingProperty;
      this.DependantProperty = DependantProperty;
      this.Name = Name;
      this.Description = Description;
      this.Expression = Expression;
      this.type = 148025276;
    }
  }
  IFC2X32.IfcPropertyDependencyRelationship = IfcPropertyDependencyRelationship;
  class IfcPropertyEnumeration extends IfcLineObject {
    constructor(expressID, Name, EnumerationValues, Unit) {
      super(expressID);
      this.Name = Name;
      this.EnumerationValues = EnumerationValues;
      this.Unit = Unit;
      this.type = 3710013099;
    }
  }
  IFC2X32.IfcPropertyEnumeration = IfcPropertyEnumeration;
  class IfcQuantityArea extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, AreaValue) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.AreaValue = AreaValue;
      this.type = 2044713172;
    }
  }
  IFC2X32.IfcQuantityArea = IfcQuantityArea;
  class IfcQuantityCount extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, CountValue) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.CountValue = CountValue;
      this.type = 2093928680;
    }
  }
  IFC2X32.IfcQuantityCount = IfcQuantityCount;
  class IfcQuantityLength extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, LengthValue) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.LengthValue = LengthValue;
      this.type = 931644368;
    }
  }
  IFC2X32.IfcQuantityLength = IfcQuantityLength;
  class IfcQuantityTime extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, TimeValue) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.TimeValue = TimeValue;
      this.type = 3252649465;
    }
  }
  IFC2X32.IfcQuantityTime = IfcQuantityTime;
  class IfcQuantityVolume extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, VolumeValue) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.VolumeValue = VolumeValue;
      this.type = 2405470396;
    }
  }
  IFC2X32.IfcQuantityVolume = IfcQuantityVolume;
  class IfcQuantityWeight extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, WeightValue) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.WeightValue = WeightValue;
      this.type = 825690147;
    }
  }
  IFC2X32.IfcQuantityWeight = IfcQuantityWeight;
  class IfcReferencesValueDocument extends IfcLineObject {
    constructor(expressID, ReferencedDocument, ReferencingValues, Name, Description) {
      super(expressID);
      this.ReferencedDocument = ReferencedDocument;
      this.ReferencingValues = ReferencingValues;
      this.Name = Name;
      this.Description = Description;
      this.type = 2692823254;
    }
  }
  IFC2X32.IfcReferencesValueDocument = IfcReferencesValueDocument;
  class IfcReinforcementBarProperties extends IfcLineObject {
    constructor(expressID, TotalCrossSectionArea, SteelGrade, BarSurface, EffectiveDepth, NominalBarDiameter, BarCount) {
      super(expressID);
      this.TotalCrossSectionArea = TotalCrossSectionArea;
      this.SteelGrade = SteelGrade;
      this.BarSurface = BarSurface;
      this.EffectiveDepth = EffectiveDepth;
      this.NominalBarDiameter = NominalBarDiameter;
      this.BarCount = BarCount;
      this.type = 1580146022;
    }
  }
  IFC2X32.IfcReinforcementBarProperties = IfcReinforcementBarProperties;
  class IfcRelaxation extends IfcLineObject {
    constructor(expressID, RelaxationValue, InitialStress) {
      super(expressID);
      this.RelaxationValue = RelaxationValue;
      this.InitialStress = InitialStress;
      this.type = 1222501353;
    }
  }
  IFC2X32.IfcRelaxation = IfcRelaxation;
  class IfcRepresentation extends IfcLineObject {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 1076942058;
    }
  }
  IFC2X32.IfcRepresentation = IfcRepresentation;
  class IfcRepresentationContext extends IfcLineObject {
    constructor(expressID, ContextIdentifier, ContextType) {
      super(expressID);
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.type = 3377609919;
    }
  }
  IFC2X32.IfcRepresentationContext = IfcRepresentationContext;
  class IfcRepresentationItem extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 3008791417;
    }
  }
  IFC2X32.IfcRepresentationItem = IfcRepresentationItem;
  class IfcRepresentationMap extends IfcLineObject {
    constructor(expressID, MappingOrigin, MappedRepresentation) {
      super(expressID);
      this.MappingOrigin = MappingOrigin;
      this.MappedRepresentation = MappedRepresentation;
      this.type = 1660063152;
    }
  }
  IFC2X32.IfcRepresentationMap = IfcRepresentationMap;
  class IfcRibPlateProfileProperties extends IfcProfileProperties {
    constructor(expressID, ProfileName, ProfileDefinition, Thickness, RibHeight, RibWidth, RibSpacing, Direction) {
      super(expressID, ProfileName, ProfileDefinition);
      this.ProfileName = ProfileName;
      this.ProfileDefinition = ProfileDefinition;
      this.Thickness = Thickness;
      this.RibHeight = RibHeight;
      this.RibWidth = RibWidth;
      this.RibSpacing = RibSpacing;
      this.Direction = Direction;
      this.type = 3679540991;
    }
  }
  IFC2X32.IfcRibPlateProfileProperties = IfcRibPlateProfileProperties;
  class IfcRoot extends IfcLineObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 2341007311;
    }
  }
  IFC2X32.IfcRoot = IfcRoot;
  class IfcSIUnit extends IfcNamedUnit {
    constructor(expressID, UnitType, Prefix, Name) {
      super(expressID, new Handle(0), UnitType);
      this.UnitType = UnitType;
      this.Prefix = Prefix;
      this.Name = Name;
      this.type = 448429030;
    }
  }
  IFC2X32.IfcSIUnit = IfcSIUnit;
  class IfcSectionProperties extends IfcLineObject {
    constructor(expressID, SectionType, StartProfile, EndProfile) {
      super(expressID);
      this.SectionType = SectionType;
      this.StartProfile = StartProfile;
      this.EndProfile = EndProfile;
      this.type = 2042790032;
    }
  }
  IFC2X32.IfcSectionProperties = IfcSectionProperties;
  class IfcSectionReinforcementProperties extends IfcLineObject {
    constructor(expressID, LongitudinalStartPosition, LongitudinalEndPosition, TransversePosition, ReinforcementRole, SectionDefinition, CrossSectionReinforcementDefinitions) {
      super(expressID);
      this.LongitudinalStartPosition = LongitudinalStartPosition;
      this.LongitudinalEndPosition = LongitudinalEndPosition;
      this.TransversePosition = TransversePosition;
      this.ReinforcementRole = ReinforcementRole;
      this.SectionDefinition = SectionDefinition;
      this.CrossSectionReinforcementDefinitions = CrossSectionReinforcementDefinitions;
      this.type = 4165799628;
    }
  }
  IFC2X32.IfcSectionReinforcementProperties = IfcSectionReinforcementProperties;
  class IfcShapeAspect extends IfcLineObject {
    constructor(expressID, ShapeRepresentations, Name, Description, ProductDefinitional, PartOfProductDefinitionShape) {
      super(expressID);
      this.ShapeRepresentations = ShapeRepresentations;
      this.Name = Name;
      this.Description = Description;
      this.ProductDefinitional = ProductDefinitional;
      this.PartOfProductDefinitionShape = PartOfProductDefinitionShape;
      this.type = 867548509;
    }
  }
  IFC2X32.IfcShapeAspect = IfcShapeAspect;
  class IfcShapeModel extends IfcRepresentation {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 3982875396;
    }
  }
  IFC2X32.IfcShapeModel = IfcShapeModel;
  class IfcShapeRepresentation extends IfcShapeModel {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 4240577450;
    }
  }
  IFC2X32.IfcShapeRepresentation = IfcShapeRepresentation;
  class IfcSimpleProperty extends IfcProperty {
    constructor(expressID, Name, Description) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.type = 3692461612;
    }
  }
  IFC2X32.IfcSimpleProperty = IfcSimpleProperty;
  class IfcStructuralConnectionCondition extends IfcLineObject {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 2273995522;
    }
  }
  IFC2X32.IfcStructuralConnectionCondition = IfcStructuralConnectionCondition;
  class IfcStructuralLoad extends IfcLineObject {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 2162789131;
    }
  }
  IFC2X32.IfcStructuralLoad = IfcStructuralLoad;
  class IfcStructuralLoadStatic extends IfcStructuralLoad {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 2525727697;
    }
  }
  IFC2X32.IfcStructuralLoadStatic = IfcStructuralLoadStatic;
  class IfcStructuralLoadTemperature extends IfcStructuralLoadStatic {
    constructor(expressID, Name, DeltaT_Constant, DeltaT_Y, DeltaT_Z) {
      super(expressID, Name);
      this.Name = Name;
      this.DeltaT_Constant = DeltaT_Constant;
      this.DeltaT_Y = DeltaT_Y;
      this.DeltaT_Z = DeltaT_Z;
      this.type = 3408363356;
    }
  }
  IFC2X32.IfcStructuralLoadTemperature = IfcStructuralLoadTemperature;
  class IfcStyleModel extends IfcRepresentation {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 2830218821;
    }
  }
  IFC2X32.IfcStyleModel = IfcStyleModel;
  class IfcStyledItem extends IfcRepresentationItem {
    constructor(expressID, Item, Styles, Name) {
      super(expressID);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 3958052878;
    }
  }
  IFC2X32.IfcStyledItem = IfcStyledItem;
  class IfcStyledRepresentation extends IfcStyleModel {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 3049322572;
    }
  }
  IFC2X32.IfcStyledRepresentation = IfcStyledRepresentation;
  class IfcSurfaceStyle extends IfcPresentationStyle {
    constructor(expressID, Name, Side, Styles) {
      super(expressID, Name);
      this.Name = Name;
      this.Side = Side;
      this.Styles = Styles;
      this.type = 1300840506;
    }
  }
  IFC2X32.IfcSurfaceStyle = IfcSurfaceStyle;
  class IfcSurfaceStyleLighting extends IfcLineObject {
    constructor(expressID, DiffuseTransmissionColour, DiffuseReflectionColour, TransmissionColour, ReflectanceColour) {
      super(expressID);
      this.DiffuseTransmissionColour = DiffuseTransmissionColour;
      this.DiffuseReflectionColour = DiffuseReflectionColour;
      this.TransmissionColour = TransmissionColour;
      this.ReflectanceColour = ReflectanceColour;
      this.type = 3303107099;
    }
  }
  IFC2X32.IfcSurfaceStyleLighting = IfcSurfaceStyleLighting;
  class IfcSurfaceStyleRefraction extends IfcLineObject {
    constructor(expressID, RefractionIndex, DispersionFactor) {
      super(expressID);
      this.RefractionIndex = RefractionIndex;
      this.DispersionFactor = DispersionFactor;
      this.type = 1607154358;
    }
  }
  IFC2X32.IfcSurfaceStyleRefraction = IfcSurfaceStyleRefraction;
  class IfcSurfaceStyleShading extends IfcLineObject {
    constructor(expressID, SurfaceColour) {
      super(expressID);
      this.SurfaceColour = SurfaceColour;
      this.type = 846575682;
    }
  }
  IFC2X32.IfcSurfaceStyleShading = IfcSurfaceStyleShading;
  class IfcSurfaceStyleWithTextures extends IfcLineObject {
    constructor(expressID, Textures) {
      super(expressID);
      this.Textures = Textures;
      this.type = 1351298697;
    }
  }
  IFC2X32.IfcSurfaceStyleWithTextures = IfcSurfaceStyleWithTextures;
  class IfcSurfaceTexture extends IfcLineObject {
    constructor(expressID, RepeatS, RepeatT, TextureType, TextureTransform) {
      super(expressID);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.TextureType = TextureType;
      this.TextureTransform = TextureTransform;
      this.type = 626085974;
    }
  }
  IFC2X32.IfcSurfaceTexture = IfcSurfaceTexture;
  class IfcSymbolStyle extends IfcPresentationStyle {
    constructor(expressID, Name, StyleOfSymbol) {
      super(expressID, Name);
      this.Name = Name;
      this.StyleOfSymbol = StyleOfSymbol;
      this.type = 1290481447;
    }
  }
  IFC2X32.IfcSymbolStyle = IfcSymbolStyle;
  class IfcTable extends IfcLineObject {
    constructor(expressID, Name, Rows) {
      super(expressID);
      this.Name = Name;
      this.Rows = Rows;
      this.type = 985171141;
    }
  }
  IFC2X32.IfcTable = IfcTable;
  class IfcTableRow extends IfcLineObject {
    constructor(expressID, RowCells, IsHeading) {
      super(expressID);
      this.RowCells = RowCells;
      this.IsHeading = IsHeading;
      this.type = 531007025;
    }
  }
  IFC2X32.IfcTableRow = IfcTableRow;
  class IfcTelecomAddress extends IfcAddress {
    constructor(expressID, Purpose, Description, UserDefinedPurpose, TelephoneNumbers, FacsimileNumbers, PagerNumber, ElectronicMailAddresses, WWWHomePageURL) {
      super(expressID, Purpose, Description, UserDefinedPurpose);
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.TelephoneNumbers = TelephoneNumbers;
      this.FacsimileNumbers = FacsimileNumbers;
      this.PagerNumber = PagerNumber;
      this.ElectronicMailAddresses = ElectronicMailAddresses;
      this.WWWHomePageURL = WWWHomePageURL;
      this.type = 912023232;
    }
  }
  IFC2X32.IfcTelecomAddress = IfcTelecomAddress;
  class IfcTextStyle extends IfcPresentationStyle {
    constructor(expressID, Name, TextCharacterAppearance, TextStyle, TextFontStyle) {
      super(expressID, Name);
      this.Name = Name;
      this.TextCharacterAppearance = TextCharacterAppearance;
      this.TextStyle = TextStyle;
      this.TextFontStyle = TextFontStyle;
      this.type = 1447204868;
    }
  }
  IFC2X32.IfcTextStyle = IfcTextStyle;
  class IfcTextStyleFontModel extends IfcPreDefinedTextFont {
    constructor(expressID, Name, FontFamily, FontStyle, FontVariant, FontWeight, FontSize) {
      super(expressID, Name);
      this.Name = Name;
      this.FontFamily = FontFamily;
      this.FontStyle = FontStyle;
      this.FontVariant = FontVariant;
      this.FontWeight = FontWeight;
      this.FontSize = FontSize;
      this.type = 1983826977;
    }
  }
  IFC2X32.IfcTextStyleFontModel = IfcTextStyleFontModel;
  class IfcTextStyleForDefinedFont extends IfcLineObject {
    constructor(expressID, Colour, BackgroundColour) {
      super(expressID);
      this.Colour = Colour;
      this.BackgroundColour = BackgroundColour;
      this.type = 2636378356;
    }
  }
  IFC2X32.IfcTextStyleForDefinedFont = IfcTextStyleForDefinedFont;
  class IfcTextStyleTextModel extends IfcLineObject {
    constructor(expressID, TextIndent, TextAlign, TextDecoration, LetterSpacing, WordSpacing, TextTransform, LineHeight) {
      super(expressID);
      this.TextIndent = TextIndent;
      this.TextAlign = TextAlign;
      this.TextDecoration = TextDecoration;
      this.LetterSpacing = LetterSpacing;
      this.WordSpacing = WordSpacing;
      this.TextTransform = TextTransform;
      this.LineHeight = LineHeight;
      this.type = 1640371178;
    }
  }
  IFC2X32.IfcTextStyleTextModel = IfcTextStyleTextModel;
  class IfcTextStyleWithBoxCharacteristics extends IfcLineObject {
    constructor(expressID, BoxHeight, BoxWidth, BoxSlantAngle, BoxRotateAngle, CharacterSpacing) {
      super(expressID);
      this.BoxHeight = BoxHeight;
      this.BoxWidth = BoxWidth;
      this.BoxSlantAngle = BoxSlantAngle;
      this.BoxRotateAngle = BoxRotateAngle;
      this.CharacterSpacing = CharacterSpacing;
      this.type = 1484833681;
    }
  }
  IFC2X32.IfcTextStyleWithBoxCharacteristics = IfcTextStyleWithBoxCharacteristics;
  class IfcTextureCoordinate extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 280115917;
    }
  }
  IFC2X32.IfcTextureCoordinate = IfcTextureCoordinate;
  class IfcTextureCoordinateGenerator extends IfcTextureCoordinate {
    constructor(expressID, Mode, Parameter) {
      super(expressID);
      this.Mode = Mode;
      this.Parameter = Parameter;
      this.type = 1742049831;
    }
  }
  IFC2X32.IfcTextureCoordinateGenerator = IfcTextureCoordinateGenerator;
  class IfcTextureMap extends IfcTextureCoordinate {
    constructor(expressID, TextureMaps) {
      super(expressID);
      this.TextureMaps = TextureMaps;
      this.type = 2552916305;
    }
  }
  IFC2X32.IfcTextureMap = IfcTextureMap;
  class IfcTextureVertex extends IfcLineObject {
    constructor(expressID, Coordinates) {
      super(expressID);
      this.Coordinates = Coordinates;
      this.type = 1210645708;
    }
  }
  IFC2X32.IfcTextureVertex = IfcTextureVertex;
  class IfcThermalMaterialProperties extends IfcMaterialProperties {
    constructor(expressID, Material, SpecificHeatCapacity, BoilingPoint, FreezingPoint, ThermalConductivity) {
      super(expressID, Material);
      this.Material = Material;
      this.SpecificHeatCapacity = SpecificHeatCapacity;
      this.BoilingPoint = BoilingPoint;
      this.FreezingPoint = FreezingPoint;
      this.ThermalConductivity = ThermalConductivity;
      this.type = 3317419933;
    }
  }
  IFC2X32.IfcThermalMaterialProperties = IfcThermalMaterialProperties;
  class IfcTimeSeries extends IfcLineObject {
    constructor(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.type = 3101149627;
    }
  }
  IFC2X32.IfcTimeSeries = IfcTimeSeries;
  class IfcTimeSeriesReferenceRelationship extends IfcLineObject {
    constructor(expressID, ReferencedTimeSeries, TimeSeriesReferences) {
      super(expressID);
      this.ReferencedTimeSeries = ReferencedTimeSeries;
      this.TimeSeriesReferences = TimeSeriesReferences;
      this.type = 1718945513;
    }
  }
  IFC2X32.IfcTimeSeriesReferenceRelationship = IfcTimeSeriesReferenceRelationship;
  class IfcTimeSeriesValue extends IfcLineObject {
    constructor(expressID, ListValues) {
      super(expressID);
      this.ListValues = ListValues;
      this.type = 581633288;
    }
  }
  IFC2X32.IfcTimeSeriesValue = IfcTimeSeriesValue;
  class IfcTopologicalRepresentationItem extends IfcRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 1377556343;
    }
  }
  IFC2X32.IfcTopologicalRepresentationItem = IfcTopologicalRepresentationItem;
  class IfcTopologyRepresentation extends IfcShapeModel {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 1735638870;
    }
  }
  IFC2X32.IfcTopologyRepresentation = IfcTopologyRepresentation;
  class IfcUnitAssignment extends IfcLineObject {
    constructor(expressID, Units) {
      super(expressID);
      this.Units = Units;
      this.type = 180925521;
    }
  }
  IFC2X32.IfcUnitAssignment = IfcUnitAssignment;
  class IfcVertex extends IfcTopologicalRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 2799835756;
    }
  }
  IFC2X32.IfcVertex = IfcVertex;
  class IfcVertexBasedTextureMap extends IfcLineObject {
    constructor(expressID, TextureVertices, TexturePoints) {
      super(expressID);
      this.TextureVertices = TextureVertices;
      this.TexturePoints = TexturePoints;
      this.type = 3304826586;
    }
  }
  IFC2X32.IfcVertexBasedTextureMap = IfcVertexBasedTextureMap;
  class IfcVertexPoint extends IfcVertex {
    constructor(expressID, VertexGeometry) {
      super(expressID);
      this.VertexGeometry = VertexGeometry;
      this.type = 1907098498;
    }
  }
  IFC2X32.IfcVertexPoint = IfcVertexPoint;
  class IfcVirtualGridIntersection extends IfcLineObject {
    constructor(expressID, IntersectingAxes, OffsetDistances) {
      super(expressID);
      this.IntersectingAxes = IntersectingAxes;
      this.OffsetDistances = OffsetDistances;
      this.type = 891718957;
    }
  }
  IFC2X32.IfcVirtualGridIntersection = IfcVirtualGridIntersection;
  class IfcWaterProperties extends IfcMaterialProperties {
    constructor(expressID, Material, IsPotable, Hardness, AlkalinityConcentration, AcidityConcentration, ImpuritiesContent, PHLevel, DissolvedSolidsContent) {
      super(expressID, Material);
      this.Material = Material;
      this.IsPotable = IsPotable;
      this.Hardness = Hardness;
      this.AlkalinityConcentration = AlkalinityConcentration;
      this.AcidityConcentration = AcidityConcentration;
      this.ImpuritiesContent = ImpuritiesContent;
      this.PHLevel = PHLevel;
      this.DissolvedSolidsContent = DissolvedSolidsContent;
      this.type = 1065908215;
    }
  }
  IFC2X32.IfcWaterProperties = IfcWaterProperties;
  class IfcAnnotationOccurrence extends IfcStyledItem {
    constructor(expressID, Item, Styles, Name) {
      super(expressID, Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 2442683028;
    }
  }
  IFC2X32.IfcAnnotationOccurrence = IfcAnnotationOccurrence;
  class IfcAnnotationSurfaceOccurrence extends IfcAnnotationOccurrence {
    constructor(expressID, Item, Styles, Name) {
      super(expressID, Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 962685235;
    }
  }
  IFC2X32.IfcAnnotationSurfaceOccurrence = IfcAnnotationSurfaceOccurrence;
  class IfcAnnotationSymbolOccurrence extends IfcAnnotationOccurrence {
    constructor(expressID, Item, Styles, Name) {
      super(expressID, Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 3612888222;
    }
  }
  IFC2X32.IfcAnnotationSymbolOccurrence = IfcAnnotationSymbolOccurrence;
  class IfcAnnotationTextOccurrence extends IfcAnnotationOccurrence {
    constructor(expressID, Item, Styles, Name) {
      super(expressID, Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 2297822566;
    }
  }
  IFC2X32.IfcAnnotationTextOccurrence = IfcAnnotationTextOccurrence;
  class IfcArbitraryClosedProfileDef extends IfcProfileDef {
    constructor(expressID, ProfileType, ProfileName, OuterCurve) {
      super(expressID, ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.OuterCurve = OuterCurve;
      this.type = 3798115385;
    }
  }
  IFC2X32.IfcArbitraryClosedProfileDef = IfcArbitraryClosedProfileDef;
  class IfcArbitraryOpenProfileDef extends IfcProfileDef {
    constructor(expressID, ProfileType, ProfileName, Curve) {
      super(expressID, ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Curve = Curve;
      this.type = 1310608509;
    }
  }
  IFC2X32.IfcArbitraryOpenProfileDef = IfcArbitraryOpenProfileDef;
  class IfcArbitraryProfileDefWithVoids extends IfcArbitraryClosedProfileDef {
    constructor(expressID, ProfileType, ProfileName, OuterCurve, InnerCurves) {
      super(expressID, ProfileType, ProfileName, OuterCurve);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.OuterCurve = OuterCurve;
      this.InnerCurves = InnerCurves;
      this.type = 2705031697;
    }
  }
  IFC2X32.IfcArbitraryProfileDefWithVoids = IfcArbitraryProfileDefWithVoids;
  class IfcBlobTexture extends IfcSurfaceTexture {
    constructor(expressID, RepeatS, RepeatT, TextureType, TextureTransform, RasterFormat, RasterCode) {
      super(expressID, RepeatS, RepeatT, TextureType, TextureTransform);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.TextureType = TextureType;
      this.TextureTransform = TextureTransform;
      this.RasterFormat = RasterFormat;
      this.RasterCode = RasterCode;
      this.type = 616511568;
    }
  }
  IFC2X32.IfcBlobTexture = IfcBlobTexture;
  class IfcCenterLineProfileDef extends IfcArbitraryOpenProfileDef {
    constructor(expressID, ProfileType, ProfileName, Curve, Thickness) {
      super(expressID, ProfileType, ProfileName, Curve);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Curve = Curve;
      this.Thickness = Thickness;
      this.type = 3150382593;
    }
  }
  IFC2X32.IfcCenterLineProfileDef = IfcCenterLineProfileDef;
  class IfcClassificationReference extends IfcExternalReference {
    constructor(expressID, Location, ItemReference, Name, ReferencedSource) {
      super(expressID, Location, ItemReference, Name);
      this.Location = Location;
      this.ItemReference = ItemReference;
      this.Name = Name;
      this.ReferencedSource = ReferencedSource;
      this.type = 647927063;
    }
  }
  IFC2X32.IfcClassificationReference = IfcClassificationReference;
  class IfcColourRgb extends IfcColourSpecification {
    constructor(expressID, Name, Red, Green, Blue) {
      super(expressID, Name);
      this.Name = Name;
      this.Red = Red;
      this.Green = Green;
      this.Blue = Blue;
      this.type = 776857604;
    }
  }
  IFC2X32.IfcColourRgb = IfcColourRgb;
  class IfcComplexProperty extends IfcProperty {
    constructor(expressID, Name, Description, UsageName, HasProperties) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.UsageName = UsageName;
      this.HasProperties = HasProperties;
      this.type = 2542286263;
    }
  }
  IFC2X32.IfcComplexProperty = IfcComplexProperty;
  class IfcCompositeProfileDef extends IfcProfileDef {
    constructor(expressID, ProfileType, ProfileName, Profiles, Label) {
      super(expressID, ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Profiles = Profiles;
      this.Label = Label;
      this.type = 1485152156;
    }
  }
  IFC2X32.IfcCompositeProfileDef = IfcCompositeProfileDef;
  class IfcConnectedFaceSet extends IfcTopologicalRepresentationItem {
    constructor(expressID, CfsFaces) {
      super(expressID);
      this.CfsFaces = CfsFaces;
      this.type = 370225590;
    }
  }
  IFC2X32.IfcConnectedFaceSet = IfcConnectedFaceSet;
  class IfcConnectionCurveGeometry extends IfcConnectionGeometry {
    constructor(expressID, CurveOnRelatingElement, CurveOnRelatedElement) {
      super(expressID);
      this.CurveOnRelatingElement = CurveOnRelatingElement;
      this.CurveOnRelatedElement = CurveOnRelatedElement;
      this.type = 1981873012;
    }
  }
  IFC2X32.IfcConnectionCurveGeometry = IfcConnectionCurveGeometry;
  class IfcConnectionPointEccentricity extends IfcConnectionPointGeometry {
    constructor(expressID, PointOnRelatingElement, PointOnRelatedElement, EccentricityInX, EccentricityInY, EccentricityInZ) {
      super(expressID, PointOnRelatingElement, PointOnRelatedElement);
      this.PointOnRelatingElement = PointOnRelatingElement;
      this.PointOnRelatedElement = PointOnRelatedElement;
      this.EccentricityInX = EccentricityInX;
      this.EccentricityInY = EccentricityInY;
      this.EccentricityInZ = EccentricityInZ;
      this.type = 45288368;
    }
  }
  IFC2X32.IfcConnectionPointEccentricity = IfcConnectionPointEccentricity;
  class IfcContextDependentUnit extends IfcNamedUnit {
    constructor(expressID, Dimensions, UnitType, Name) {
      super(expressID, Dimensions, UnitType);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.Name = Name;
      this.type = 3050246964;
    }
  }
  IFC2X32.IfcContextDependentUnit = IfcContextDependentUnit;
  class IfcConversionBasedUnit extends IfcNamedUnit {
    constructor(expressID, Dimensions, UnitType, Name, ConversionFactor) {
      super(expressID, Dimensions, UnitType);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.Name = Name;
      this.ConversionFactor = ConversionFactor;
      this.type = 2889183280;
    }
  }
  IFC2X32.IfcConversionBasedUnit = IfcConversionBasedUnit;
  class IfcCurveStyle extends IfcPresentationStyle {
    constructor(expressID, Name, CurveFont, CurveWidth, CurveColour) {
      super(expressID, Name);
      this.Name = Name;
      this.CurveFont = CurveFont;
      this.CurveWidth = CurveWidth;
      this.CurveColour = CurveColour;
      this.type = 3800577675;
    }
  }
  IFC2X32.IfcCurveStyle = IfcCurveStyle;
  class IfcDerivedProfileDef extends IfcProfileDef {
    constructor(expressID, ProfileType, ProfileName, ParentProfile, Operator, Label) {
      super(expressID, ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.ParentProfile = ParentProfile;
      this.Operator = Operator;
      this.Label = Label;
      this.type = 3632507154;
    }
  }
  IFC2X32.IfcDerivedProfileDef = IfcDerivedProfileDef;
  class IfcDimensionCalloutRelationship extends IfcDraughtingCalloutRelationship {
    constructor(expressID, Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout) {
      super(expressID, Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout);
      this.Name = Name;
      this.Description = Description;
      this.RelatingDraughtingCallout = RelatingDraughtingCallout;
      this.RelatedDraughtingCallout = RelatedDraughtingCallout;
      this.type = 2273265877;
    }
  }
  IFC2X32.IfcDimensionCalloutRelationship = IfcDimensionCalloutRelationship;
  class IfcDimensionPair extends IfcDraughtingCalloutRelationship {
    constructor(expressID, Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout) {
      super(expressID, Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout);
      this.Name = Name;
      this.Description = Description;
      this.RelatingDraughtingCallout = RelatingDraughtingCallout;
      this.RelatedDraughtingCallout = RelatedDraughtingCallout;
      this.type = 1694125774;
    }
  }
  IFC2X32.IfcDimensionPair = IfcDimensionPair;
  class IfcDocumentReference extends IfcExternalReference {
    constructor(expressID, Location, ItemReference, Name) {
      super(expressID, Location, ItemReference, Name);
      this.Location = Location;
      this.ItemReference = ItemReference;
      this.Name = Name;
      this.type = 3732053477;
    }
  }
  IFC2X32.IfcDocumentReference = IfcDocumentReference;
  class IfcDraughtingPreDefinedTextFont extends IfcPreDefinedTextFont {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 4170525392;
    }
  }
  IFC2X32.IfcDraughtingPreDefinedTextFont = IfcDraughtingPreDefinedTextFont;
  class IfcEdge extends IfcTopologicalRepresentationItem {
    constructor(expressID, EdgeStart, EdgeEnd) {
      super(expressID);
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.type = 3900360178;
    }
  }
  IFC2X32.IfcEdge = IfcEdge;
  class IfcEdgeCurve extends IfcEdge {
    constructor(expressID, EdgeStart, EdgeEnd, EdgeGeometry, SameSense) {
      super(expressID, EdgeStart, EdgeEnd);
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.EdgeGeometry = EdgeGeometry;
      this.SameSense = SameSense;
      this.type = 476780140;
    }
  }
  IFC2X32.IfcEdgeCurve = IfcEdgeCurve;
  class IfcExtendedMaterialProperties extends IfcMaterialProperties {
    constructor(expressID, Material, ExtendedProperties, Description, Name) {
      super(expressID, Material);
      this.Material = Material;
      this.ExtendedProperties = ExtendedProperties;
      this.Description = Description;
      this.Name = Name;
      this.type = 1860660968;
    }
  }
  IFC2X32.IfcExtendedMaterialProperties = IfcExtendedMaterialProperties;
  class IfcFace extends IfcTopologicalRepresentationItem {
    constructor(expressID, Bounds) {
      super(expressID);
      this.Bounds = Bounds;
      this.type = 2556980723;
    }
  }
  IFC2X32.IfcFace = IfcFace;
  class IfcFaceBound extends IfcTopologicalRepresentationItem {
    constructor(expressID, Bound, Orientation) {
      super(expressID);
      this.Bound = Bound;
      this.Orientation = Orientation;
      this.type = 1809719519;
    }
  }
  IFC2X32.IfcFaceBound = IfcFaceBound;
  class IfcFaceOuterBound extends IfcFaceBound {
    constructor(expressID, Bound, Orientation) {
      super(expressID, Bound, Orientation);
      this.Bound = Bound;
      this.Orientation = Orientation;
      this.type = 803316827;
    }
  }
  IFC2X32.IfcFaceOuterBound = IfcFaceOuterBound;
  class IfcFaceSurface extends IfcFace {
    constructor(expressID, Bounds, FaceSurface, SameSense) {
      super(expressID, Bounds);
      this.Bounds = Bounds;
      this.FaceSurface = FaceSurface;
      this.SameSense = SameSense;
      this.type = 3008276851;
    }
  }
  IFC2X32.IfcFaceSurface = IfcFaceSurface;
  class IfcFailureConnectionCondition extends IfcStructuralConnectionCondition {
    constructor(expressID, Name, TensionFailureX, TensionFailureY, TensionFailureZ, CompressionFailureX, CompressionFailureY, CompressionFailureZ) {
      super(expressID, Name);
      this.Name = Name;
      this.TensionFailureX = TensionFailureX;
      this.TensionFailureY = TensionFailureY;
      this.TensionFailureZ = TensionFailureZ;
      this.CompressionFailureX = CompressionFailureX;
      this.CompressionFailureY = CompressionFailureY;
      this.CompressionFailureZ = CompressionFailureZ;
      this.type = 4219587988;
    }
  }
  IFC2X32.IfcFailureConnectionCondition = IfcFailureConnectionCondition;
  class IfcFillAreaStyle extends IfcPresentationStyle {
    constructor(expressID, Name, FillStyles) {
      super(expressID, Name);
      this.Name = Name;
      this.FillStyles = FillStyles;
      this.type = 738692330;
    }
  }
  IFC2X32.IfcFillAreaStyle = IfcFillAreaStyle;
  class IfcFuelProperties extends IfcMaterialProperties {
    constructor(expressID, Material, CombustionTemperature, CarbonContent, LowerHeatingValue, HigherHeatingValue) {
      super(expressID, Material);
      this.Material = Material;
      this.CombustionTemperature = CombustionTemperature;
      this.CarbonContent = CarbonContent;
      this.LowerHeatingValue = LowerHeatingValue;
      this.HigherHeatingValue = HigherHeatingValue;
      this.type = 3857492461;
    }
  }
  IFC2X32.IfcFuelProperties = IfcFuelProperties;
  class IfcGeneralMaterialProperties extends IfcMaterialProperties {
    constructor(expressID, Material, MolecularWeight, Porosity, MassDensity) {
      super(expressID, Material);
      this.Material = Material;
      this.MolecularWeight = MolecularWeight;
      this.Porosity = Porosity;
      this.MassDensity = MassDensity;
      this.type = 803998398;
    }
  }
  IFC2X32.IfcGeneralMaterialProperties = IfcGeneralMaterialProperties;
  class IfcGeneralProfileProperties extends IfcProfileProperties {
    constructor(expressID, ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea) {
      super(expressID, ProfileName, ProfileDefinition);
      this.ProfileName = ProfileName;
      this.ProfileDefinition = ProfileDefinition;
      this.PhysicalWeight = PhysicalWeight;
      this.Perimeter = Perimeter;
      this.MinimumPlateThickness = MinimumPlateThickness;
      this.MaximumPlateThickness = MaximumPlateThickness;
      this.CrossSectionArea = CrossSectionArea;
      this.type = 1446786286;
    }
  }
  IFC2X32.IfcGeneralProfileProperties = IfcGeneralProfileProperties;
  class IfcGeometricRepresentationContext extends IfcRepresentationContext {
    constructor(expressID, ContextIdentifier, ContextType, CoordinateSpaceDimension, Precision, WorldCoordinateSystem, TrueNorth) {
      super(expressID, ContextIdentifier, ContextType);
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.CoordinateSpaceDimension = CoordinateSpaceDimension;
      this.Precision = Precision;
      this.WorldCoordinateSystem = WorldCoordinateSystem;
      this.TrueNorth = TrueNorth;
      this.type = 3448662350;
    }
  }
  IFC2X32.IfcGeometricRepresentationContext = IfcGeometricRepresentationContext;
  class IfcGeometricRepresentationItem extends IfcRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 2453401579;
    }
  }
  IFC2X32.IfcGeometricRepresentationItem = IfcGeometricRepresentationItem;
  class IfcGeometricRepresentationSubContext extends IfcGeometricRepresentationContext {
    constructor(expressID, ContextIdentifier, ContextType, ParentContext, TargetScale, TargetView, UserDefinedTargetView) {
      super(expressID, ContextIdentifier, ContextType, new IfcDimensionCount(0), null, new Handle(0), null);
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.ParentContext = ParentContext;
      this.TargetScale = TargetScale;
      this.TargetView = TargetView;
      this.UserDefinedTargetView = UserDefinedTargetView;
      this.type = 4142052618;
    }
  }
  IFC2X32.IfcGeometricRepresentationSubContext = IfcGeometricRepresentationSubContext;
  class IfcGeometricSet extends IfcGeometricRepresentationItem {
    constructor(expressID, Elements) {
      super(expressID);
      this.Elements = Elements;
      this.type = 3590301190;
    }
  }
  IFC2X32.IfcGeometricSet = IfcGeometricSet;
  class IfcGridPlacement extends IfcObjectPlacement {
    constructor(expressID, PlacementLocation, PlacementRefDirection) {
      super(expressID);
      this.PlacementLocation = PlacementLocation;
      this.PlacementRefDirection = PlacementRefDirection;
      this.type = 178086475;
    }
  }
  IFC2X32.IfcGridPlacement = IfcGridPlacement;
  class IfcHalfSpaceSolid extends IfcGeometricRepresentationItem {
    constructor(expressID, BaseSurface, AgreementFlag) {
      super(expressID);
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.type = 812098782;
    }
  }
  IFC2X32.IfcHalfSpaceSolid = IfcHalfSpaceSolid;
  class IfcHygroscopicMaterialProperties extends IfcMaterialProperties {
    constructor(expressID, Material, UpperVaporResistanceFactor, LowerVaporResistanceFactor, IsothermalMoistureCapacity, VaporPermeability, MoistureDiffusivity) {
      super(expressID, Material);
      this.Material = Material;
      this.UpperVaporResistanceFactor = UpperVaporResistanceFactor;
      this.LowerVaporResistanceFactor = LowerVaporResistanceFactor;
      this.IsothermalMoistureCapacity = IsothermalMoistureCapacity;
      this.VaporPermeability = VaporPermeability;
      this.MoistureDiffusivity = MoistureDiffusivity;
      this.type = 2445078500;
    }
  }
  IFC2X32.IfcHygroscopicMaterialProperties = IfcHygroscopicMaterialProperties;
  class IfcImageTexture extends IfcSurfaceTexture {
    constructor(expressID, RepeatS, RepeatT, TextureType, TextureTransform, UrlReference) {
      super(expressID, RepeatS, RepeatT, TextureType, TextureTransform);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.TextureType = TextureType;
      this.TextureTransform = TextureTransform;
      this.UrlReference = UrlReference;
      this.type = 3905492369;
    }
  }
  IFC2X32.IfcImageTexture = IfcImageTexture;
  class IfcIrregularTimeSeries extends IfcTimeSeries {
    constructor(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, Values) {
      super(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.Values = Values;
      this.type = 3741457305;
    }
  }
  IFC2X32.IfcIrregularTimeSeries = IfcIrregularTimeSeries;
  class IfcLightSource extends IfcGeometricRepresentationItem {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity) {
      super(expressID);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.type = 1402838566;
    }
  }
  IFC2X32.IfcLightSource = IfcLightSource;
  class IfcLightSourceAmbient extends IfcLightSource {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity) {
      super(expressID, Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.type = 125510826;
    }
  }
  IFC2X32.IfcLightSourceAmbient = IfcLightSourceAmbient;
  class IfcLightSourceDirectional extends IfcLightSource {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity, Orientation) {
      super(expressID, Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Orientation = Orientation;
      this.type = 2604431987;
    }
  }
  IFC2X32.IfcLightSourceDirectional = IfcLightSourceDirectional;
  class IfcLightSourceGoniometric extends IfcLightSource {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, ColourAppearance, ColourTemperature, LuminousFlux, LightEmissionSource, LightDistributionDataSource) {
      super(expressID, Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.ColourAppearance = ColourAppearance;
      this.ColourTemperature = ColourTemperature;
      this.LuminousFlux = LuminousFlux;
      this.LightEmissionSource = LightEmissionSource;
      this.LightDistributionDataSource = LightDistributionDataSource;
      this.type = 4266656042;
    }
  }
  IFC2X32.IfcLightSourceGoniometric = IfcLightSourceGoniometric;
  class IfcLightSourcePositional extends IfcLightSource {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation) {
      super(expressID, Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.Radius = Radius;
      this.ConstantAttenuation = ConstantAttenuation;
      this.DistanceAttenuation = DistanceAttenuation;
      this.QuadricAttenuation = QuadricAttenuation;
      this.type = 1520743889;
    }
  }
  IFC2X32.IfcLightSourcePositional = IfcLightSourcePositional;
  class IfcLightSourceSpot extends IfcLightSourcePositional {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation, Orientation, ConcentrationExponent, SpreadAngle, BeamWidthAngle) {
      super(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.Radius = Radius;
      this.ConstantAttenuation = ConstantAttenuation;
      this.DistanceAttenuation = DistanceAttenuation;
      this.QuadricAttenuation = QuadricAttenuation;
      this.Orientation = Orientation;
      this.ConcentrationExponent = ConcentrationExponent;
      this.SpreadAngle = SpreadAngle;
      this.BeamWidthAngle = BeamWidthAngle;
      this.type = 3422422726;
    }
  }
  IFC2X32.IfcLightSourceSpot = IfcLightSourceSpot;
  class IfcLocalPlacement extends IfcObjectPlacement {
    constructor(expressID, PlacementRelTo, RelativePlacement) {
      super(expressID);
      this.PlacementRelTo = PlacementRelTo;
      this.RelativePlacement = RelativePlacement;
      this.type = 2624227202;
    }
  }
  IFC2X32.IfcLocalPlacement = IfcLocalPlacement;
  class IfcLoop extends IfcTopologicalRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 1008929658;
    }
  }
  IFC2X32.IfcLoop = IfcLoop;
  class IfcMappedItem extends IfcRepresentationItem {
    constructor(expressID, MappingSource, MappingTarget) {
      super(expressID);
      this.MappingSource = MappingSource;
      this.MappingTarget = MappingTarget;
      this.type = 2347385850;
    }
  }
  IFC2X32.IfcMappedItem = IfcMappedItem;
  class IfcMaterialDefinitionRepresentation extends IfcProductRepresentation {
    constructor(expressID, Name, Description, Representations, RepresentedMaterial) {
      super(expressID, Name, Description, Representations);
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.RepresentedMaterial = RepresentedMaterial;
      this.type = 2022407955;
    }
  }
  IFC2X32.IfcMaterialDefinitionRepresentation = IfcMaterialDefinitionRepresentation;
  class IfcMechanicalConcreteMaterialProperties extends IfcMechanicalMaterialProperties {
    constructor(expressID, Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient, CompressiveStrength, MaxAggregateSize, AdmixturesDescription, Workability, ProtectivePoreRatio, WaterImpermeability) {
      super(expressID, Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient);
      this.Material = Material;
      this.DynamicViscosity = DynamicViscosity;
      this.YoungModulus = YoungModulus;
      this.ShearModulus = ShearModulus;
      this.PoissonRatio = PoissonRatio;
      this.ThermalExpansionCoefficient = ThermalExpansionCoefficient;
      this.CompressiveStrength = CompressiveStrength;
      this.MaxAggregateSize = MaxAggregateSize;
      this.AdmixturesDescription = AdmixturesDescription;
      this.Workability = Workability;
      this.ProtectivePoreRatio = ProtectivePoreRatio;
      this.WaterImpermeability = WaterImpermeability;
      this.type = 1430189142;
    }
  }
  IFC2X32.IfcMechanicalConcreteMaterialProperties = IfcMechanicalConcreteMaterialProperties;
  class IfcObjectDefinition extends IfcRoot {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 219451334;
    }
  }
  IFC2X32.IfcObjectDefinition = IfcObjectDefinition;
  class IfcOneDirectionRepeatFactor extends IfcGeometricRepresentationItem {
    constructor(expressID, RepeatFactor) {
      super(expressID);
      this.RepeatFactor = RepeatFactor;
      this.type = 2833995503;
    }
  }
  IFC2X32.IfcOneDirectionRepeatFactor = IfcOneDirectionRepeatFactor;
  class IfcOpenShell extends IfcConnectedFaceSet {
    constructor(expressID, CfsFaces) {
      super(expressID, CfsFaces);
      this.CfsFaces = CfsFaces;
      this.type = 2665983363;
    }
  }
  IFC2X32.IfcOpenShell = IfcOpenShell;
  class IfcOrientedEdge extends IfcEdge {
    constructor(expressID, EdgeElement, Orientation) {
      super(expressID, new Handle(0), new Handle(0));
      this.EdgeElement = EdgeElement;
      this.Orientation = Orientation;
      this.type = 1029017970;
    }
  }
  IFC2X32.IfcOrientedEdge = IfcOrientedEdge;
  class IfcParameterizedProfileDef extends IfcProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position) {
      super(expressID, ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.type = 2529465313;
    }
  }
  IFC2X32.IfcParameterizedProfileDef = IfcParameterizedProfileDef;
  class IfcPath extends IfcTopologicalRepresentationItem {
    constructor(expressID, EdgeList) {
      super(expressID);
      this.EdgeList = EdgeList;
      this.type = 2519244187;
    }
  }
  IFC2X32.IfcPath = IfcPath;
  class IfcPhysicalComplexQuantity extends IfcPhysicalQuantity {
    constructor(expressID, Name, Description, HasQuantities, Discrimination, Quality, Usage) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.HasQuantities = HasQuantities;
      this.Discrimination = Discrimination;
      this.Quality = Quality;
      this.Usage = Usage;
      this.type = 3021840470;
    }
  }
  IFC2X32.IfcPhysicalComplexQuantity = IfcPhysicalComplexQuantity;
  class IfcPixelTexture extends IfcSurfaceTexture {
    constructor(expressID, RepeatS, RepeatT, TextureType, TextureTransform, Width, Height, ColourComponents, Pixel) {
      super(expressID, RepeatS, RepeatT, TextureType, TextureTransform);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.TextureType = TextureType;
      this.TextureTransform = TextureTransform;
      this.Width = Width;
      this.Height = Height;
      this.ColourComponents = ColourComponents;
      this.Pixel = Pixel;
      this.type = 597895409;
    }
  }
  IFC2X32.IfcPixelTexture = IfcPixelTexture;
  class IfcPlacement extends IfcGeometricRepresentationItem {
    constructor(expressID, Location) {
      super(expressID);
      this.Location = Location;
      this.type = 2004835150;
    }
  }
  IFC2X32.IfcPlacement = IfcPlacement;
  class IfcPlanarExtent extends IfcGeometricRepresentationItem {
    constructor(expressID, SizeInX, SizeInY) {
      super(expressID);
      this.SizeInX = SizeInX;
      this.SizeInY = SizeInY;
      this.type = 1663979128;
    }
  }
  IFC2X32.IfcPlanarExtent = IfcPlanarExtent;
  class IfcPoint extends IfcGeometricRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 2067069095;
    }
  }
  IFC2X32.IfcPoint = IfcPoint;
  class IfcPointOnCurve extends IfcPoint {
    constructor(expressID, BasisCurve, PointParameter) {
      super(expressID);
      this.BasisCurve = BasisCurve;
      this.PointParameter = PointParameter;
      this.type = 4022376103;
    }
  }
  IFC2X32.IfcPointOnCurve = IfcPointOnCurve;
  class IfcPointOnSurface extends IfcPoint {
    constructor(expressID, BasisSurface, PointParameterU, PointParameterV) {
      super(expressID);
      this.BasisSurface = BasisSurface;
      this.PointParameterU = PointParameterU;
      this.PointParameterV = PointParameterV;
      this.type = 1423911732;
    }
  }
  IFC2X32.IfcPointOnSurface = IfcPointOnSurface;
  class IfcPolyLoop extends IfcLoop {
    constructor(expressID, Polygon) {
      super(expressID);
      this.Polygon = Polygon;
      this.type = 2924175390;
    }
  }
  IFC2X32.IfcPolyLoop = IfcPolyLoop;
  class IfcPolygonalBoundedHalfSpace extends IfcHalfSpaceSolid {
    constructor(expressID, BaseSurface, AgreementFlag, Position, PolygonalBoundary) {
      super(expressID, BaseSurface, AgreementFlag);
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.Position = Position;
      this.PolygonalBoundary = PolygonalBoundary;
      this.type = 2775532180;
    }
  }
  IFC2X32.IfcPolygonalBoundedHalfSpace = IfcPolygonalBoundedHalfSpace;
  class IfcPreDefinedColour extends IfcPreDefinedItem {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 759155922;
    }
  }
  IFC2X32.IfcPreDefinedColour = IfcPreDefinedColour;
  class IfcPreDefinedCurveFont extends IfcPreDefinedItem {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 2559016684;
    }
  }
  IFC2X32.IfcPreDefinedCurveFont = IfcPreDefinedCurveFont;
  class IfcPreDefinedDimensionSymbol extends IfcPreDefinedSymbol {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 433424934;
    }
  }
  IFC2X32.IfcPreDefinedDimensionSymbol = IfcPreDefinedDimensionSymbol;
  class IfcPreDefinedPointMarkerSymbol extends IfcPreDefinedSymbol {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 179317114;
    }
  }
  IFC2X32.IfcPreDefinedPointMarkerSymbol = IfcPreDefinedPointMarkerSymbol;
  class IfcProductDefinitionShape extends IfcProductRepresentation {
    constructor(expressID, Name, Description, Representations) {
      super(expressID, Name, Description, Representations);
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.type = 673634403;
    }
  }
  IFC2X32.IfcProductDefinitionShape = IfcProductDefinitionShape;
  class IfcPropertyBoundedValue extends IfcSimpleProperty {
    constructor(expressID, Name, Description, UpperBoundValue, LowerBoundValue, Unit) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.UpperBoundValue = UpperBoundValue;
      this.LowerBoundValue = LowerBoundValue;
      this.Unit = Unit;
      this.type = 871118103;
    }
  }
  IFC2X32.IfcPropertyBoundedValue = IfcPropertyBoundedValue;
  class IfcPropertyDefinition extends IfcRoot {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 1680319473;
    }
  }
  IFC2X32.IfcPropertyDefinition = IfcPropertyDefinition;
  class IfcPropertyEnumeratedValue extends IfcSimpleProperty {
    constructor(expressID, Name, Description, EnumerationValues, EnumerationReference) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.EnumerationValues = EnumerationValues;
      this.EnumerationReference = EnumerationReference;
      this.type = 4166981789;
    }
  }
  IFC2X32.IfcPropertyEnumeratedValue = IfcPropertyEnumeratedValue;
  class IfcPropertyListValue extends IfcSimpleProperty {
    constructor(expressID, Name, Description, ListValues, Unit) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.ListValues = ListValues;
      this.Unit = Unit;
      this.type = 2752243245;
    }
  }
  IFC2X32.IfcPropertyListValue = IfcPropertyListValue;
  class IfcPropertyReferenceValue extends IfcSimpleProperty {
    constructor(expressID, Name, Description, UsageName, PropertyReference) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.UsageName = UsageName;
      this.PropertyReference = PropertyReference;
      this.type = 941946838;
    }
  }
  IFC2X32.IfcPropertyReferenceValue = IfcPropertyReferenceValue;
  class IfcPropertySetDefinition extends IfcPropertyDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 3357820518;
    }
  }
  IFC2X32.IfcPropertySetDefinition = IfcPropertySetDefinition;
  class IfcPropertySingleValue extends IfcSimpleProperty {
    constructor(expressID, Name, Description, NominalValue, Unit) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.NominalValue = NominalValue;
      this.Unit = Unit;
      this.type = 3650150729;
    }
  }
  IFC2X32.IfcPropertySingleValue = IfcPropertySingleValue;
  class IfcPropertyTableValue extends IfcSimpleProperty {
    constructor(expressID, Name, Description, DefiningValues, DefinedValues, Expression, DefiningUnit, DefinedUnit) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.DefiningValues = DefiningValues;
      this.DefinedValues = DefinedValues;
      this.Expression = Expression;
      this.DefiningUnit = DefiningUnit;
      this.DefinedUnit = DefinedUnit;
      this.type = 110355661;
    }
  }
  IFC2X32.IfcPropertyTableValue = IfcPropertyTableValue;
  class IfcRectangleProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, XDim, YDim) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.type = 3615266464;
    }
  }
  IFC2X32.IfcRectangleProfileDef = IfcRectangleProfileDef;
  class IfcRegularTimeSeries extends IfcTimeSeries {
    constructor(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, TimeStep, Values) {
      super(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.TimeStep = TimeStep;
      this.Values = Values;
      this.type = 3413951693;
    }
  }
  IFC2X32.IfcRegularTimeSeries = IfcRegularTimeSeries;
  class IfcReinforcementDefinitionProperties extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, DefinitionType, ReinforcementSectionDefinitions) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.DefinitionType = DefinitionType;
      this.ReinforcementSectionDefinitions = ReinforcementSectionDefinitions;
      this.type = 3765753017;
    }
  }
  IFC2X32.IfcReinforcementDefinitionProperties = IfcReinforcementDefinitionProperties;
  class IfcRelationship extends IfcRoot {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 478536968;
    }
  }
  IFC2X32.IfcRelationship = IfcRelationship;
  class IfcRoundedRectangleProfileDef extends IfcRectangleProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, XDim, YDim, RoundingRadius) {
      super(expressID, ProfileType, ProfileName, Position, XDim, YDim);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.RoundingRadius = RoundingRadius;
      this.type = 2778083089;
    }
  }
  IFC2X32.IfcRoundedRectangleProfileDef = IfcRoundedRectangleProfileDef;
  class IfcSectionedSpine extends IfcGeometricRepresentationItem {
    constructor(expressID, SpineCurve, CrossSections, CrossSectionPositions) {
      super(expressID);
      this.SpineCurve = SpineCurve;
      this.CrossSections = CrossSections;
      this.CrossSectionPositions = CrossSectionPositions;
      this.type = 1509187699;
    }
  }
  IFC2X32.IfcSectionedSpine = IfcSectionedSpine;
  class IfcServiceLifeFactor extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, PredefinedType, UpperValue, MostUsedValue, LowerValue) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.PredefinedType = PredefinedType;
      this.UpperValue = UpperValue;
      this.MostUsedValue = MostUsedValue;
      this.LowerValue = LowerValue;
      this.type = 2411513650;
    }
  }
  IFC2X32.IfcServiceLifeFactor = IfcServiceLifeFactor;
  class IfcShellBasedSurfaceModel extends IfcGeometricRepresentationItem {
    constructor(expressID, SbsmBoundary) {
      super(expressID);
      this.SbsmBoundary = SbsmBoundary;
      this.type = 4124623270;
    }
  }
  IFC2X32.IfcShellBasedSurfaceModel = IfcShellBasedSurfaceModel;
  class IfcSlippageConnectionCondition extends IfcStructuralConnectionCondition {
    constructor(expressID, Name, SlippageX, SlippageY, SlippageZ) {
      super(expressID, Name);
      this.Name = Name;
      this.SlippageX = SlippageX;
      this.SlippageY = SlippageY;
      this.SlippageZ = SlippageZ;
      this.type = 2609359061;
    }
  }
  IFC2X32.IfcSlippageConnectionCondition = IfcSlippageConnectionCondition;
  class IfcSolidModel extends IfcGeometricRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 723233188;
    }
  }
  IFC2X32.IfcSolidModel = IfcSolidModel;
  class IfcSoundProperties extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, IsAttenuating, SoundScale, SoundValues) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.IsAttenuating = IsAttenuating;
      this.SoundScale = SoundScale;
      this.SoundValues = SoundValues;
      this.type = 2485662743;
    }
  }
  IFC2X32.IfcSoundProperties = IfcSoundProperties;
  class IfcSoundValue extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, SoundLevelTimeSeries, Frequency, SoundLevelSingleValue) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.SoundLevelTimeSeries = SoundLevelTimeSeries;
      this.Frequency = Frequency;
      this.SoundLevelSingleValue = SoundLevelSingleValue;
      this.type = 1202362311;
    }
  }
  IFC2X32.IfcSoundValue = IfcSoundValue;
  class IfcSpaceThermalLoadProperties extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableValueRatio, ThermalLoadSource, PropertySource, SourceDescription, MaximumValue, MinimumValue, ThermalLoadTimeSeriesValues, UserDefinedThermalLoadSource, UserDefinedPropertySource, ThermalLoadType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableValueRatio = ApplicableValueRatio;
      this.ThermalLoadSource = ThermalLoadSource;
      this.PropertySource = PropertySource;
      this.SourceDescription = SourceDescription;
      this.MaximumValue = MaximumValue;
      this.MinimumValue = MinimumValue;
      this.ThermalLoadTimeSeriesValues = ThermalLoadTimeSeriesValues;
      this.UserDefinedThermalLoadSource = UserDefinedThermalLoadSource;
      this.UserDefinedPropertySource = UserDefinedPropertySource;
      this.ThermalLoadType = ThermalLoadType;
      this.type = 390701378;
    }
  }
  IFC2X32.IfcSpaceThermalLoadProperties = IfcSpaceThermalLoadProperties;
  class IfcStructuralLoadLinearForce extends IfcStructuralLoadStatic {
    constructor(expressID, Name, LinearForceX, LinearForceY, LinearForceZ, LinearMomentX, LinearMomentY, LinearMomentZ) {
      super(expressID, Name);
      this.Name = Name;
      this.LinearForceX = LinearForceX;
      this.LinearForceY = LinearForceY;
      this.LinearForceZ = LinearForceZ;
      this.LinearMomentX = LinearMomentX;
      this.LinearMomentY = LinearMomentY;
      this.LinearMomentZ = LinearMomentZ;
      this.type = 1595516126;
    }
  }
  IFC2X32.IfcStructuralLoadLinearForce = IfcStructuralLoadLinearForce;
  class IfcStructuralLoadPlanarForce extends IfcStructuralLoadStatic {
    constructor(expressID, Name, PlanarForceX, PlanarForceY, PlanarForceZ) {
      super(expressID, Name);
      this.Name = Name;
      this.PlanarForceX = PlanarForceX;
      this.PlanarForceY = PlanarForceY;
      this.PlanarForceZ = PlanarForceZ;
      this.type = 2668620305;
    }
  }
  IFC2X32.IfcStructuralLoadPlanarForce = IfcStructuralLoadPlanarForce;
  class IfcStructuralLoadSingleDisplacement extends IfcStructuralLoadStatic {
    constructor(expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ) {
      super(expressID, Name);
      this.Name = Name;
      this.DisplacementX = DisplacementX;
      this.DisplacementY = DisplacementY;
      this.DisplacementZ = DisplacementZ;
      this.RotationalDisplacementRX = RotationalDisplacementRX;
      this.RotationalDisplacementRY = RotationalDisplacementRY;
      this.RotationalDisplacementRZ = RotationalDisplacementRZ;
      this.type = 2473145415;
    }
  }
  IFC2X32.IfcStructuralLoadSingleDisplacement = IfcStructuralLoadSingleDisplacement;
  class IfcStructuralLoadSingleDisplacementDistortion extends IfcStructuralLoadSingleDisplacement {
    constructor(expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ, Distortion) {
      super(expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ);
      this.Name = Name;
      this.DisplacementX = DisplacementX;
      this.DisplacementY = DisplacementY;
      this.DisplacementZ = DisplacementZ;
      this.RotationalDisplacementRX = RotationalDisplacementRX;
      this.RotationalDisplacementRY = RotationalDisplacementRY;
      this.RotationalDisplacementRZ = RotationalDisplacementRZ;
      this.Distortion = Distortion;
      this.type = 1973038258;
    }
  }
  IFC2X32.IfcStructuralLoadSingleDisplacementDistortion = IfcStructuralLoadSingleDisplacementDistortion;
  class IfcStructuralLoadSingleForce extends IfcStructuralLoadStatic {
    constructor(expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ) {
      super(expressID, Name);
      this.Name = Name;
      this.ForceX = ForceX;
      this.ForceY = ForceY;
      this.ForceZ = ForceZ;
      this.MomentX = MomentX;
      this.MomentY = MomentY;
      this.MomentZ = MomentZ;
      this.type = 1597423693;
    }
  }
  IFC2X32.IfcStructuralLoadSingleForce = IfcStructuralLoadSingleForce;
  class IfcStructuralLoadSingleForceWarping extends IfcStructuralLoadSingleForce {
    constructor(expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ, WarpingMoment) {
      super(expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ);
      this.Name = Name;
      this.ForceX = ForceX;
      this.ForceY = ForceY;
      this.ForceZ = ForceZ;
      this.MomentX = MomentX;
      this.MomentY = MomentY;
      this.MomentZ = MomentZ;
      this.WarpingMoment = WarpingMoment;
      this.type = 1190533807;
    }
  }
  IFC2X32.IfcStructuralLoadSingleForceWarping = IfcStructuralLoadSingleForceWarping;
  class IfcStructuralProfileProperties extends IfcGeneralProfileProperties {
    constructor(expressID, ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea, TorsionalConstantX, MomentOfInertiaYZ, MomentOfInertiaY, MomentOfInertiaZ, WarpingConstant, ShearCentreZ, ShearCentreY, ShearDeformationAreaZ, ShearDeformationAreaY, MaximumSectionModulusY, MinimumSectionModulusY, MaximumSectionModulusZ, MinimumSectionModulusZ, TorsionalSectionModulus, CentreOfGravityInX, CentreOfGravityInY) {
      super(expressID, ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea);
      this.ProfileName = ProfileName;
      this.ProfileDefinition = ProfileDefinition;
      this.PhysicalWeight = PhysicalWeight;
      this.Perimeter = Perimeter;
      this.MinimumPlateThickness = MinimumPlateThickness;
      this.MaximumPlateThickness = MaximumPlateThickness;
      this.CrossSectionArea = CrossSectionArea;
      this.TorsionalConstantX = TorsionalConstantX;
      this.MomentOfInertiaYZ = MomentOfInertiaYZ;
      this.MomentOfInertiaY = MomentOfInertiaY;
      this.MomentOfInertiaZ = MomentOfInertiaZ;
      this.WarpingConstant = WarpingConstant;
      this.ShearCentreZ = ShearCentreZ;
      this.ShearCentreY = ShearCentreY;
      this.ShearDeformationAreaZ = ShearDeformationAreaZ;
      this.ShearDeformationAreaY = ShearDeformationAreaY;
      this.MaximumSectionModulusY = MaximumSectionModulusY;
      this.MinimumSectionModulusY = MinimumSectionModulusY;
      this.MaximumSectionModulusZ = MaximumSectionModulusZ;
      this.MinimumSectionModulusZ = MinimumSectionModulusZ;
      this.TorsionalSectionModulus = TorsionalSectionModulus;
      this.CentreOfGravityInX = CentreOfGravityInX;
      this.CentreOfGravityInY = CentreOfGravityInY;
      this.type = 3843319758;
    }
  }
  IFC2X32.IfcStructuralProfileProperties = IfcStructuralProfileProperties;
  class IfcStructuralSteelProfileProperties extends IfcStructuralProfileProperties {
    constructor(expressID, ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea, TorsionalConstantX, MomentOfInertiaYZ, MomentOfInertiaY, MomentOfInertiaZ, WarpingConstant, ShearCentreZ, ShearCentreY, ShearDeformationAreaZ, ShearDeformationAreaY, MaximumSectionModulusY, MinimumSectionModulusY, MaximumSectionModulusZ, MinimumSectionModulusZ, TorsionalSectionModulus, CentreOfGravityInX, CentreOfGravityInY, ShearAreaZ, ShearAreaY, PlasticShapeFactorY, PlasticShapeFactorZ) {
      super(expressID, ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea, TorsionalConstantX, MomentOfInertiaYZ, MomentOfInertiaY, MomentOfInertiaZ, WarpingConstant, ShearCentreZ, ShearCentreY, ShearDeformationAreaZ, ShearDeformationAreaY, MaximumSectionModulusY, MinimumSectionModulusY, MaximumSectionModulusZ, MinimumSectionModulusZ, TorsionalSectionModulus, CentreOfGravityInX, CentreOfGravityInY);
      this.ProfileName = ProfileName;
      this.ProfileDefinition = ProfileDefinition;
      this.PhysicalWeight = PhysicalWeight;
      this.Perimeter = Perimeter;
      this.MinimumPlateThickness = MinimumPlateThickness;
      this.MaximumPlateThickness = MaximumPlateThickness;
      this.CrossSectionArea = CrossSectionArea;
      this.TorsionalConstantX = TorsionalConstantX;
      this.MomentOfInertiaYZ = MomentOfInertiaYZ;
      this.MomentOfInertiaY = MomentOfInertiaY;
      this.MomentOfInertiaZ = MomentOfInertiaZ;
      this.WarpingConstant = WarpingConstant;
      this.ShearCentreZ = ShearCentreZ;
      this.ShearCentreY = ShearCentreY;
      this.ShearDeformationAreaZ = ShearDeformationAreaZ;
      this.ShearDeformationAreaY = ShearDeformationAreaY;
      this.MaximumSectionModulusY = MaximumSectionModulusY;
      this.MinimumSectionModulusY = MinimumSectionModulusY;
      this.MaximumSectionModulusZ = MaximumSectionModulusZ;
      this.MinimumSectionModulusZ = MinimumSectionModulusZ;
      this.TorsionalSectionModulus = TorsionalSectionModulus;
      this.CentreOfGravityInX = CentreOfGravityInX;
      this.CentreOfGravityInY = CentreOfGravityInY;
      this.ShearAreaZ = ShearAreaZ;
      this.ShearAreaY = ShearAreaY;
      this.PlasticShapeFactorY = PlasticShapeFactorY;
      this.PlasticShapeFactorZ = PlasticShapeFactorZ;
      this.type = 3653947884;
    }
  }
  IFC2X32.IfcStructuralSteelProfileProperties = IfcStructuralSteelProfileProperties;
  class IfcSubedge extends IfcEdge {
    constructor(expressID, EdgeStart, EdgeEnd, ParentEdge) {
      super(expressID, EdgeStart, EdgeEnd);
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.ParentEdge = ParentEdge;
      this.type = 2233826070;
    }
  }
  IFC2X32.IfcSubedge = IfcSubedge;
  class IfcSurface extends IfcGeometricRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 2513912981;
    }
  }
  IFC2X32.IfcSurface = IfcSurface;
  class IfcSurfaceStyleRendering extends IfcSurfaceStyleShading {
    constructor(expressID, SurfaceColour, Transparency, DiffuseColour, TransmissionColour, DiffuseTransmissionColour, ReflectionColour, SpecularColour, SpecularHighlight, ReflectanceMethod) {
      super(expressID, SurfaceColour);
      this.SurfaceColour = SurfaceColour;
      this.Transparency = Transparency;
      this.DiffuseColour = DiffuseColour;
      this.TransmissionColour = TransmissionColour;
      this.DiffuseTransmissionColour = DiffuseTransmissionColour;
      this.ReflectionColour = ReflectionColour;
      this.SpecularColour = SpecularColour;
      this.SpecularHighlight = SpecularHighlight;
      this.ReflectanceMethod = ReflectanceMethod;
      this.type = 1878645084;
    }
  }
  IFC2X32.IfcSurfaceStyleRendering = IfcSurfaceStyleRendering;
  class IfcSweptAreaSolid extends IfcSolidModel {
    constructor(expressID, SweptArea, Position) {
      super(expressID);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.type = 2247615214;
    }
  }
  IFC2X32.IfcSweptAreaSolid = IfcSweptAreaSolid;
  class IfcSweptDiskSolid extends IfcSolidModel {
    constructor(expressID, Directrix, Radius, InnerRadius, StartParam, EndParam) {
      super(expressID);
      this.Directrix = Directrix;
      this.Radius = Radius;
      this.InnerRadius = InnerRadius;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.type = 1260650574;
    }
  }
  IFC2X32.IfcSweptDiskSolid = IfcSweptDiskSolid;
  class IfcSweptSurface extends IfcSurface {
    constructor(expressID, SweptCurve, Position) {
      super(expressID);
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.type = 230924584;
    }
  }
  IFC2X32.IfcSweptSurface = IfcSweptSurface;
  class IfcTShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, WebEdgeRadius, WebSlope, FlangeSlope, CentreOfGravityInY) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.FlangeEdgeRadius = FlangeEdgeRadius;
      this.WebEdgeRadius = WebEdgeRadius;
      this.WebSlope = WebSlope;
      this.FlangeSlope = FlangeSlope;
      this.CentreOfGravityInY = CentreOfGravityInY;
      this.type = 3071757647;
    }
  }
  IFC2X32.IfcTShapeProfileDef = IfcTShapeProfileDef;
  class IfcTerminatorSymbol extends IfcAnnotationSymbolOccurrence {
    constructor(expressID, Item, Styles, Name, AnnotatedCurve) {
      super(expressID, Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.AnnotatedCurve = AnnotatedCurve;
      this.type = 3028897424;
    }
  }
  IFC2X32.IfcTerminatorSymbol = IfcTerminatorSymbol;
  class IfcTextLiteral extends IfcGeometricRepresentationItem {
    constructor(expressID, Literal, Placement, Path) {
      super(expressID);
      this.Literal = Literal;
      this.Placement = Placement;
      this.Path = Path;
      this.type = 4282788508;
    }
  }
  IFC2X32.IfcTextLiteral = IfcTextLiteral;
  class IfcTextLiteralWithExtent extends IfcTextLiteral {
    constructor(expressID, Literal, Placement, Path, Extent, BoxAlignment) {
      super(expressID, Literal, Placement, Path);
      this.Literal = Literal;
      this.Placement = Placement;
      this.Path = Path;
      this.Extent = Extent;
      this.BoxAlignment = BoxAlignment;
      this.type = 3124975700;
    }
  }
  IFC2X32.IfcTextLiteralWithExtent = IfcTextLiteralWithExtent;
  class IfcTrapeziumProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, BottomXDim, TopXDim, YDim, TopXOffset) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.BottomXDim = BottomXDim;
      this.TopXDim = TopXDim;
      this.YDim = YDim;
      this.TopXOffset = TopXOffset;
      this.type = 2715220739;
    }
  }
  IFC2X32.IfcTrapeziumProfileDef = IfcTrapeziumProfileDef;
  class IfcTwoDirectionRepeatFactor extends IfcOneDirectionRepeatFactor {
    constructor(expressID, RepeatFactor, SecondRepeatFactor) {
      super(expressID, RepeatFactor);
      this.RepeatFactor = RepeatFactor;
      this.SecondRepeatFactor = SecondRepeatFactor;
      this.type = 1345879162;
    }
  }
  IFC2X32.IfcTwoDirectionRepeatFactor = IfcTwoDirectionRepeatFactor;
  class IfcTypeObject extends IfcObjectDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.type = 1628702193;
    }
  }
  IFC2X32.IfcTypeObject = IfcTypeObject;
  class IfcTypeProduct extends IfcTypeObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.type = 2347495698;
    }
  }
  IFC2X32.IfcTypeProduct = IfcTypeProduct;
  class IfcUShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius, FlangeSlope, CentreOfGravityInX) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.FlangeSlope = FlangeSlope;
      this.CentreOfGravityInX = CentreOfGravityInX;
      this.type = 427810014;
    }
  }
  IFC2X32.IfcUShapeProfileDef = IfcUShapeProfileDef;
  class IfcVector extends IfcGeometricRepresentationItem {
    constructor(expressID, Orientation, Magnitude) {
      super(expressID);
      this.Orientation = Orientation;
      this.Magnitude = Magnitude;
      this.type = 1417489154;
    }
  }
  IFC2X32.IfcVector = IfcVector;
  class IfcVertexLoop extends IfcLoop {
    constructor(expressID, LoopVertex) {
      super(expressID);
      this.LoopVertex = LoopVertex;
      this.type = 2759199220;
    }
  }
  IFC2X32.IfcVertexLoop = IfcVertexLoop;
  class IfcWindowLiningProperties extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, TransomThickness, MullionThickness, FirstTransomOffset, SecondTransomOffset, FirstMullionOffset, SecondMullionOffset, ShapeAspectStyle) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.LiningDepth = LiningDepth;
      this.LiningThickness = LiningThickness;
      this.TransomThickness = TransomThickness;
      this.MullionThickness = MullionThickness;
      this.FirstTransomOffset = FirstTransomOffset;
      this.SecondTransomOffset = SecondTransomOffset;
      this.FirstMullionOffset = FirstMullionOffset;
      this.SecondMullionOffset = SecondMullionOffset;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 336235671;
    }
  }
  IFC2X32.IfcWindowLiningProperties = IfcWindowLiningProperties;
  class IfcWindowPanelProperties extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.OperationType = OperationType;
      this.PanelPosition = PanelPosition;
      this.FrameDepth = FrameDepth;
      this.FrameThickness = FrameThickness;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 512836454;
    }
  }
  IFC2X32.IfcWindowPanelProperties = IfcWindowPanelProperties;
  class IfcWindowStyle extends IfcTypeProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ConstructionType, OperationType, ParameterTakesPrecedence, Sizeable) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ConstructionType = ConstructionType;
      this.OperationType = OperationType;
      this.ParameterTakesPrecedence = ParameterTakesPrecedence;
      this.Sizeable = Sizeable;
      this.type = 1299126871;
    }
  }
  IFC2X32.IfcWindowStyle = IfcWindowStyle;
  class IfcZShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.type = 2543172580;
    }
  }
  IFC2X32.IfcZShapeProfileDef = IfcZShapeProfileDef;
  class IfcAnnotationCurveOccurrence extends IfcAnnotationOccurrence {
    constructor(expressID, Item, Styles, Name) {
      super(expressID, Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 3288037868;
    }
  }
  IFC2X32.IfcAnnotationCurveOccurrence = IfcAnnotationCurveOccurrence;
  class IfcAnnotationFillArea extends IfcGeometricRepresentationItem {
    constructor(expressID, OuterBoundary, InnerBoundaries) {
      super(expressID);
      this.OuterBoundary = OuterBoundary;
      this.InnerBoundaries = InnerBoundaries;
      this.type = 669184980;
    }
  }
  IFC2X32.IfcAnnotationFillArea = IfcAnnotationFillArea;
  class IfcAnnotationFillAreaOccurrence extends IfcAnnotationOccurrence {
    constructor(expressID, Item, Styles, Name, FillStyleTarget, GlobalOrLocal) {
      super(expressID, Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.FillStyleTarget = FillStyleTarget;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 2265737646;
    }
  }
  IFC2X32.IfcAnnotationFillAreaOccurrence = IfcAnnotationFillAreaOccurrence;
  class IfcAnnotationSurface extends IfcGeometricRepresentationItem {
    constructor(expressID, Item, TextureCoordinates) {
      super(expressID);
      this.Item = Item;
      this.TextureCoordinates = TextureCoordinates;
      this.type = 1302238472;
    }
  }
  IFC2X32.IfcAnnotationSurface = IfcAnnotationSurface;
  class IfcAxis1Placement extends IfcPlacement {
    constructor(expressID, Location, Axis) {
      super(expressID, Location);
      this.Location = Location;
      this.Axis = Axis;
      this.type = 4261334040;
    }
  }
  IFC2X32.IfcAxis1Placement = IfcAxis1Placement;
  class IfcAxis2Placement2D extends IfcPlacement {
    constructor(expressID, Location, RefDirection) {
      super(expressID, Location);
      this.Location = Location;
      this.RefDirection = RefDirection;
      this.type = 3125803723;
    }
  }
  IFC2X32.IfcAxis2Placement2D = IfcAxis2Placement2D;
  class IfcAxis2Placement3D extends IfcPlacement {
    constructor(expressID, Location, Axis, RefDirection) {
      super(expressID, Location);
      this.Location = Location;
      this.Axis = Axis;
      this.RefDirection = RefDirection;
      this.type = 2740243338;
    }
  }
  IFC2X32.IfcAxis2Placement3D = IfcAxis2Placement3D;
  class IfcBooleanResult extends IfcGeometricRepresentationItem {
    constructor(expressID, Operator, FirstOperand, SecondOperand) {
      super(expressID);
      this.Operator = Operator;
      this.FirstOperand = FirstOperand;
      this.SecondOperand = SecondOperand;
      this.type = 2736907675;
    }
  }
  IFC2X32.IfcBooleanResult = IfcBooleanResult;
  class IfcBoundedSurface extends IfcSurface {
    constructor(expressID) {
      super(expressID);
      this.type = 4182860854;
    }
  }
  IFC2X32.IfcBoundedSurface = IfcBoundedSurface;
  class IfcBoundingBox extends IfcGeometricRepresentationItem {
    constructor(expressID, Corner, XDim, YDim, ZDim) {
      super(expressID);
      this.Corner = Corner;
      this.XDim = XDim;
      this.YDim = YDim;
      this.ZDim = ZDim;
      this.type = 2581212453;
    }
  }
  IFC2X32.IfcBoundingBox = IfcBoundingBox;
  class IfcBoxedHalfSpace extends IfcHalfSpaceSolid {
    constructor(expressID, BaseSurface, AgreementFlag, Enclosure) {
      super(expressID, BaseSurface, AgreementFlag);
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.Enclosure = Enclosure;
      this.type = 2713105998;
    }
  }
  IFC2X32.IfcBoxedHalfSpace = IfcBoxedHalfSpace;
  class IfcCShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Depth, Width, WallThickness, Girth, InternalFilletRadius, CentreOfGravityInX) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.Width = Width;
      this.WallThickness = WallThickness;
      this.Girth = Girth;
      this.InternalFilletRadius = InternalFilletRadius;
      this.CentreOfGravityInX = CentreOfGravityInX;
      this.type = 2898889636;
    }
  }
  IFC2X32.IfcCShapeProfileDef = IfcCShapeProfileDef;
  class IfcCartesianPoint extends IfcPoint {
    constructor(expressID, Coordinates) {
      super(expressID);
      this.Coordinates = Coordinates;
      this.type = 1123145078;
    }
  }
  IFC2X32.IfcCartesianPoint = IfcCartesianPoint;
  class IfcCartesianTransformationOperator extends IfcGeometricRepresentationItem {
    constructor(expressID, Axis1, Axis2, LocalOrigin, Scale) {
      super(expressID);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.type = 59481748;
    }
  }
  IFC2X32.IfcCartesianTransformationOperator = IfcCartesianTransformationOperator;
  class IfcCartesianTransformationOperator2D extends IfcCartesianTransformationOperator {
    constructor(expressID, Axis1, Axis2, LocalOrigin, Scale) {
      super(expressID, Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.type = 3749851601;
    }
  }
  IFC2X32.IfcCartesianTransformationOperator2D = IfcCartesianTransformationOperator2D;
  class IfcCartesianTransformationOperator2DnonUniform extends IfcCartesianTransformationOperator2D {
    constructor(expressID, Axis1, Axis2, LocalOrigin, Scale, Scale2) {
      super(expressID, Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Scale2 = Scale2;
      this.type = 3486308946;
    }
  }
  IFC2X32.IfcCartesianTransformationOperator2DnonUniform = IfcCartesianTransformationOperator2DnonUniform;
  class IfcCartesianTransformationOperator3D extends IfcCartesianTransformationOperator {
    constructor(expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3) {
      super(expressID, Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Axis3 = Axis3;
      this.type = 3331915920;
    }
  }
  IFC2X32.IfcCartesianTransformationOperator3D = IfcCartesianTransformationOperator3D;
  class IfcCartesianTransformationOperator3DnonUniform extends IfcCartesianTransformationOperator3D {
    constructor(expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3, Scale2, Scale3) {
      super(expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Axis3 = Axis3;
      this.Scale2 = Scale2;
      this.Scale3 = Scale3;
      this.type = 1416205885;
    }
  }
  IFC2X32.IfcCartesianTransformationOperator3DnonUniform = IfcCartesianTransformationOperator3DnonUniform;
  class IfcCircleProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Radius) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Radius = Radius;
      this.type = 1383045692;
    }
  }
  IFC2X32.IfcCircleProfileDef = IfcCircleProfileDef;
  class IfcClosedShell extends IfcConnectedFaceSet {
    constructor(expressID, CfsFaces) {
      super(expressID, CfsFaces);
      this.CfsFaces = CfsFaces;
      this.type = 2205249479;
    }
  }
  IFC2X32.IfcClosedShell = IfcClosedShell;
  class IfcCompositeCurveSegment extends IfcGeometricRepresentationItem {
    constructor(expressID, Transition, SameSense, ParentCurve) {
      super(expressID);
      this.Transition = Transition;
      this.SameSense = SameSense;
      this.ParentCurve = ParentCurve;
      this.type = 2485617015;
    }
  }
  IFC2X32.IfcCompositeCurveSegment = IfcCompositeCurveSegment;
  class IfcCraneRailAShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, OverallHeight, BaseWidth2, Radius, HeadWidth, HeadDepth2, HeadDepth3, WebThickness, BaseWidth4, BaseDepth1, BaseDepth2, BaseDepth3, CentreOfGravityInY) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.OverallHeight = OverallHeight;
      this.BaseWidth2 = BaseWidth2;
      this.Radius = Radius;
      this.HeadWidth = HeadWidth;
      this.HeadDepth2 = HeadDepth2;
      this.HeadDepth3 = HeadDepth3;
      this.WebThickness = WebThickness;
      this.BaseWidth4 = BaseWidth4;
      this.BaseDepth1 = BaseDepth1;
      this.BaseDepth2 = BaseDepth2;
      this.BaseDepth3 = BaseDepth3;
      this.CentreOfGravityInY = CentreOfGravityInY;
      this.type = 4133800736;
    }
  }
  IFC2X32.IfcCraneRailAShapeProfileDef = IfcCraneRailAShapeProfileDef;
  class IfcCraneRailFShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, OverallHeight, HeadWidth, Radius, HeadDepth2, HeadDepth3, WebThickness, BaseDepth1, BaseDepth2, CentreOfGravityInY) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.OverallHeight = OverallHeight;
      this.HeadWidth = HeadWidth;
      this.Radius = Radius;
      this.HeadDepth2 = HeadDepth2;
      this.HeadDepth3 = HeadDepth3;
      this.WebThickness = WebThickness;
      this.BaseDepth1 = BaseDepth1;
      this.BaseDepth2 = BaseDepth2;
      this.CentreOfGravityInY = CentreOfGravityInY;
      this.type = 194851669;
    }
  }
  IFC2X32.IfcCraneRailFShapeProfileDef = IfcCraneRailFShapeProfileDef;
  class IfcCsgPrimitive3D extends IfcGeometricRepresentationItem {
    constructor(expressID, Position) {
      super(expressID);
      this.Position = Position;
      this.type = 2506170314;
    }
  }
  IFC2X32.IfcCsgPrimitive3D = IfcCsgPrimitive3D;
  class IfcCsgSolid extends IfcSolidModel {
    constructor(expressID, TreeRootExpression) {
      super(expressID);
      this.TreeRootExpression = TreeRootExpression;
      this.type = 2147822146;
    }
  }
  IFC2X32.IfcCsgSolid = IfcCsgSolid;
  class IfcCurve extends IfcGeometricRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 2601014836;
    }
  }
  IFC2X32.IfcCurve = IfcCurve;
  class IfcCurveBoundedPlane extends IfcBoundedSurface {
    constructor(expressID, BasisSurface, OuterBoundary, InnerBoundaries) {
      super(expressID);
      this.BasisSurface = BasisSurface;
      this.OuterBoundary = OuterBoundary;
      this.InnerBoundaries = InnerBoundaries;
      this.type = 2827736869;
    }
  }
  IFC2X32.IfcCurveBoundedPlane = IfcCurveBoundedPlane;
  class IfcDefinedSymbol extends IfcGeometricRepresentationItem {
    constructor(expressID, Definition, Target) {
      super(expressID);
      this.Definition = Definition;
      this.Target = Target;
      this.type = 693772133;
    }
  }
  IFC2X32.IfcDefinedSymbol = IfcDefinedSymbol;
  class IfcDimensionCurve extends IfcAnnotationCurveOccurrence {
    constructor(expressID, Item, Styles, Name) {
      super(expressID, Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 606661476;
    }
  }
  IFC2X32.IfcDimensionCurve = IfcDimensionCurve;
  class IfcDimensionCurveTerminator extends IfcTerminatorSymbol {
    constructor(expressID, Item, Styles, Name, AnnotatedCurve, Role) {
      super(expressID, Item, Styles, Name, AnnotatedCurve);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.AnnotatedCurve = AnnotatedCurve;
      this.Role = Role;
      this.type = 4054601972;
    }
  }
  IFC2X32.IfcDimensionCurveTerminator = IfcDimensionCurveTerminator;
  class IfcDirection extends IfcGeometricRepresentationItem {
    constructor(expressID, DirectionRatios) {
      super(expressID);
      this.DirectionRatios = DirectionRatios;
      this.type = 32440307;
    }
  }
  IFC2X32.IfcDirection = IfcDirection;
  class IfcDoorLiningProperties extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, ThresholdDepth, ThresholdThickness, TransomThickness, TransomOffset, LiningOffset, ThresholdOffset, CasingThickness, CasingDepth, ShapeAspectStyle) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.LiningDepth = LiningDepth;
      this.LiningThickness = LiningThickness;
      this.ThresholdDepth = ThresholdDepth;
      this.ThresholdThickness = ThresholdThickness;
      this.TransomThickness = TransomThickness;
      this.TransomOffset = TransomOffset;
      this.LiningOffset = LiningOffset;
      this.ThresholdOffset = ThresholdOffset;
      this.CasingThickness = CasingThickness;
      this.CasingDepth = CasingDepth;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 2963535650;
    }
  }
  IFC2X32.IfcDoorLiningProperties = IfcDoorLiningProperties;
  class IfcDoorPanelProperties extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, PanelDepth, PanelOperation, PanelWidth, PanelPosition, ShapeAspectStyle) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.PanelDepth = PanelDepth;
      this.PanelOperation = PanelOperation;
      this.PanelWidth = PanelWidth;
      this.PanelPosition = PanelPosition;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 1714330368;
    }
  }
  IFC2X32.IfcDoorPanelProperties = IfcDoorPanelProperties;
  class IfcDoorStyle extends IfcTypeProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, OperationType, ConstructionType, ParameterTakesPrecedence, Sizeable) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.OperationType = OperationType;
      this.ConstructionType = ConstructionType;
      this.ParameterTakesPrecedence = ParameterTakesPrecedence;
      this.Sizeable = Sizeable;
      this.type = 526551008;
    }
  }
  IFC2X32.IfcDoorStyle = IfcDoorStyle;
  class IfcDraughtingCallout extends IfcGeometricRepresentationItem {
    constructor(expressID, Contents) {
      super(expressID);
      this.Contents = Contents;
      this.type = 3073041342;
    }
  }
  IFC2X32.IfcDraughtingCallout = IfcDraughtingCallout;
  class IfcDraughtingPreDefinedColour extends IfcPreDefinedColour {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 445594917;
    }
  }
  IFC2X32.IfcDraughtingPreDefinedColour = IfcDraughtingPreDefinedColour;
  class IfcDraughtingPreDefinedCurveFont extends IfcPreDefinedCurveFont {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 4006246654;
    }
  }
  IFC2X32.IfcDraughtingPreDefinedCurveFont = IfcDraughtingPreDefinedCurveFont;
  class IfcEdgeLoop extends IfcLoop {
    constructor(expressID, EdgeList) {
      super(expressID);
      this.EdgeList = EdgeList;
      this.type = 1472233963;
    }
  }
  IFC2X32.IfcEdgeLoop = IfcEdgeLoop;
  class IfcElementQuantity extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, MethodOfMeasurement, Quantities) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.MethodOfMeasurement = MethodOfMeasurement;
      this.Quantities = Quantities;
      this.type = 1883228015;
    }
  }
  IFC2X32.IfcElementQuantity = IfcElementQuantity;
  class IfcElementType extends IfcTypeProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 339256511;
    }
  }
  IFC2X32.IfcElementType = IfcElementType;
  class IfcElementarySurface extends IfcSurface {
    constructor(expressID, Position) {
      super(expressID);
      this.Position = Position;
      this.type = 2777663545;
    }
  }
  IFC2X32.IfcElementarySurface = IfcElementarySurface;
  class IfcEllipseProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, SemiAxis1, SemiAxis2) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.SemiAxis1 = SemiAxis1;
      this.SemiAxis2 = SemiAxis2;
      this.type = 2835456948;
    }
  }
  IFC2X32.IfcEllipseProfileDef = IfcEllipseProfileDef;
  class IfcEnergyProperties extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, EnergySequence, UserDefinedEnergySequence) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.EnergySequence = EnergySequence;
      this.UserDefinedEnergySequence = UserDefinedEnergySequence;
      this.type = 80994333;
    }
  }
  IFC2X32.IfcEnergyProperties = IfcEnergyProperties;
  class IfcExtrudedAreaSolid extends IfcSweptAreaSolid {
    constructor(expressID, SweptArea, Position, ExtrudedDirection, Depth) {
      super(expressID, SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.ExtrudedDirection = ExtrudedDirection;
      this.Depth = Depth;
      this.type = 477187591;
    }
  }
  IFC2X32.IfcExtrudedAreaSolid = IfcExtrudedAreaSolid;
  class IfcFaceBasedSurfaceModel extends IfcGeometricRepresentationItem {
    constructor(expressID, FbsmFaces) {
      super(expressID);
      this.FbsmFaces = FbsmFaces;
      this.type = 2047409740;
    }
  }
  IFC2X32.IfcFaceBasedSurfaceModel = IfcFaceBasedSurfaceModel;
  class IfcFillAreaStyleHatching extends IfcGeometricRepresentationItem {
    constructor(expressID, HatchLineAppearance, StartOfNextHatchLine, PointOfReferenceHatchLine, PatternStart, HatchLineAngle) {
      super(expressID);
      this.HatchLineAppearance = HatchLineAppearance;
      this.StartOfNextHatchLine = StartOfNextHatchLine;
      this.PointOfReferenceHatchLine = PointOfReferenceHatchLine;
      this.PatternStart = PatternStart;
      this.HatchLineAngle = HatchLineAngle;
      this.type = 374418227;
    }
  }
  IFC2X32.IfcFillAreaStyleHatching = IfcFillAreaStyleHatching;
  class IfcFillAreaStyleTileSymbolWithStyle extends IfcGeometricRepresentationItem {
    constructor(expressID, Symbol2) {
      super(expressID);
      this.Symbol = Symbol2;
      this.type = 4203026998;
    }
  }
  IFC2X32.IfcFillAreaStyleTileSymbolWithStyle = IfcFillAreaStyleTileSymbolWithStyle;
  class IfcFillAreaStyleTiles extends IfcGeometricRepresentationItem {
    constructor(expressID, TilingPattern, Tiles, TilingScale) {
      super(expressID);
      this.TilingPattern = TilingPattern;
      this.Tiles = Tiles;
      this.TilingScale = TilingScale;
      this.type = 315944413;
    }
  }
  IFC2X32.IfcFillAreaStyleTiles = IfcFillAreaStyleTiles;
  class IfcFluidFlowProperties extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, PropertySource, FlowConditionTimeSeries, VelocityTimeSeries, FlowrateTimeSeries, Fluid, PressureTimeSeries, UserDefinedPropertySource, TemperatureSingleValue, WetBulbTemperatureSingleValue, WetBulbTemperatureTimeSeries, TemperatureTimeSeries, FlowrateSingleValue, FlowConditionSingleValue, VelocitySingleValue, PressureSingleValue) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.PropertySource = PropertySource;
      this.FlowConditionTimeSeries = FlowConditionTimeSeries;
      this.VelocityTimeSeries = VelocityTimeSeries;
      this.FlowrateTimeSeries = FlowrateTimeSeries;
      this.Fluid = Fluid;
      this.PressureTimeSeries = PressureTimeSeries;
      this.UserDefinedPropertySource = UserDefinedPropertySource;
      this.TemperatureSingleValue = TemperatureSingleValue;
      this.WetBulbTemperatureSingleValue = WetBulbTemperatureSingleValue;
      this.WetBulbTemperatureTimeSeries = WetBulbTemperatureTimeSeries;
      this.TemperatureTimeSeries = TemperatureTimeSeries;
      this.FlowrateSingleValue = FlowrateSingleValue;
      this.FlowConditionSingleValue = FlowConditionSingleValue;
      this.VelocitySingleValue = VelocitySingleValue;
      this.PressureSingleValue = PressureSingleValue;
      this.type = 3455213021;
    }
  }
  IFC2X32.IfcFluidFlowProperties = IfcFluidFlowProperties;
  class IfcFurnishingElementType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 4238390223;
    }
  }
  IFC2X32.IfcFurnishingElementType = IfcFurnishingElementType;
  class IfcFurnitureType extends IfcFurnishingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, AssemblyPlace) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.AssemblyPlace = AssemblyPlace;
      this.type = 1268542332;
    }
  }
  IFC2X32.IfcFurnitureType = IfcFurnitureType;
  class IfcGeometricCurveSet extends IfcGeometricSet {
    constructor(expressID, Elements) {
      super(expressID, Elements);
      this.Elements = Elements;
      this.type = 987898635;
    }
  }
  IFC2X32.IfcGeometricCurveSet = IfcGeometricCurveSet;
  class IfcIShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.OverallWidth = OverallWidth;
      this.OverallDepth = OverallDepth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.type = 1484403080;
    }
  }
  IFC2X32.IfcIShapeProfileDef = IfcIShapeProfileDef;
  class IfcLShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Depth, Width, Thickness, FilletRadius, EdgeRadius, LegSlope, CentreOfGravityInX, CentreOfGravityInY) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.Width = Width;
      this.Thickness = Thickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.LegSlope = LegSlope;
      this.CentreOfGravityInX = CentreOfGravityInX;
      this.CentreOfGravityInY = CentreOfGravityInY;
      this.type = 572779678;
    }
  }
  IFC2X32.IfcLShapeProfileDef = IfcLShapeProfileDef;
  class IfcLine extends IfcCurve {
    constructor(expressID, Pnt, Dir) {
      super(expressID);
      this.Pnt = Pnt;
      this.Dir = Dir;
      this.type = 1281925730;
    }
  }
  IFC2X32.IfcLine = IfcLine;
  class IfcManifoldSolidBrep extends IfcSolidModel {
    constructor(expressID, Outer) {
      super(expressID);
      this.Outer = Outer;
      this.type = 1425443689;
    }
  }
  IFC2X32.IfcManifoldSolidBrep = IfcManifoldSolidBrep;
  class IfcObject extends IfcObjectDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 3888040117;
    }
  }
  IFC2X32.IfcObject = IfcObject;
  class IfcOffsetCurve2D extends IfcCurve {
    constructor(expressID, BasisCurve, Distance, SelfIntersect) {
      super(expressID);
      this.BasisCurve = BasisCurve;
      this.Distance = Distance;
      this.SelfIntersect = SelfIntersect;
      this.type = 3388369263;
    }
  }
  IFC2X32.IfcOffsetCurve2D = IfcOffsetCurve2D;
  class IfcOffsetCurve3D extends IfcCurve {
    constructor(expressID, BasisCurve, Distance, SelfIntersect, RefDirection) {
      super(expressID);
      this.BasisCurve = BasisCurve;
      this.Distance = Distance;
      this.SelfIntersect = SelfIntersect;
      this.RefDirection = RefDirection;
      this.type = 3505215534;
    }
  }
  IFC2X32.IfcOffsetCurve3D = IfcOffsetCurve3D;
  class IfcPermeableCoveringProperties extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.OperationType = OperationType;
      this.PanelPosition = PanelPosition;
      this.FrameDepth = FrameDepth;
      this.FrameThickness = FrameThickness;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 3566463478;
    }
  }
  IFC2X32.IfcPermeableCoveringProperties = IfcPermeableCoveringProperties;
  class IfcPlanarBox extends IfcPlanarExtent {
    constructor(expressID, SizeInX, SizeInY, Placement) {
      super(expressID, SizeInX, SizeInY);
      this.SizeInX = SizeInX;
      this.SizeInY = SizeInY;
      this.Placement = Placement;
      this.type = 603570806;
    }
  }
  IFC2X32.IfcPlanarBox = IfcPlanarBox;
  class IfcPlane extends IfcElementarySurface {
    constructor(expressID, Position) {
      super(expressID, Position);
      this.Position = Position;
      this.type = 220341763;
    }
  }
  IFC2X32.IfcPlane = IfcPlane;
  class IfcProcess extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2945172077;
    }
  }
  IFC2X32.IfcProcess = IfcProcess;
  class IfcProduct extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 4208778838;
    }
  }
  IFC2X32.IfcProduct = IfcProduct;
  class IfcProject extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.Phase = Phase;
      this.RepresentationContexts = RepresentationContexts;
      this.UnitsInContext = UnitsInContext;
      this.type = 103090709;
    }
  }
  IFC2X32.IfcProject = IfcProject;
  class IfcProjectionCurve extends IfcAnnotationCurveOccurrence {
    constructor(expressID, Item, Styles, Name) {
      super(expressID, Item, Styles, Name);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 4194566429;
    }
  }
  IFC2X32.IfcProjectionCurve = IfcProjectionCurve;
  class IfcPropertySet extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, HasProperties) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.HasProperties = HasProperties;
      this.type = 1451395588;
    }
  }
  IFC2X32.IfcPropertySet = IfcPropertySet;
  class IfcProxy extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, ProxyType, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.ProxyType = ProxyType;
      this.Tag = Tag;
      this.type = 3219374653;
    }
  }
  IFC2X32.IfcProxy = IfcProxy;
  class IfcRectangleHollowProfileDef extends IfcRectangleProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, XDim, YDim, WallThickness, InnerFilletRadius, OuterFilletRadius) {
      super(expressID, ProfileType, ProfileName, Position, XDim, YDim);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.WallThickness = WallThickness;
      this.InnerFilletRadius = InnerFilletRadius;
      this.OuterFilletRadius = OuterFilletRadius;
      this.type = 2770003689;
    }
  }
  IFC2X32.IfcRectangleHollowProfileDef = IfcRectangleHollowProfileDef;
  class IfcRectangularPyramid extends IfcCsgPrimitive3D {
    constructor(expressID, Position, XLength, YLength, Height) {
      super(expressID, Position);
      this.Position = Position;
      this.XLength = XLength;
      this.YLength = YLength;
      this.Height = Height;
      this.type = 2798486643;
    }
  }
  IFC2X32.IfcRectangularPyramid = IfcRectangularPyramid;
  class IfcRectangularTrimmedSurface extends IfcBoundedSurface {
    constructor(expressID, BasisSurface, U1, V1, U2, V2, Usense, Vsense) {
      super(expressID);
      this.BasisSurface = BasisSurface;
      this.U1 = U1;
      this.V1 = V1;
      this.U2 = U2;
      this.V2 = V2;
      this.Usense = Usense;
      this.Vsense = Vsense;
      this.type = 3454111270;
    }
  }
  IFC2X32.IfcRectangularTrimmedSurface = IfcRectangularTrimmedSurface;
  class IfcRelAssigns extends IfcRelationship {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.type = 3939117080;
    }
  }
  IFC2X32.IfcRelAssigns = IfcRelAssigns;
  class IfcRelAssignsToActor extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingActor = RelatingActor;
      this.ActingRole = ActingRole;
      this.type = 1683148259;
    }
  }
  IFC2X32.IfcRelAssignsToActor = IfcRelAssignsToActor;
  class IfcRelAssignsToControl extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingControl = RelatingControl;
      this.type = 2495723537;
    }
  }
  IFC2X32.IfcRelAssignsToControl = IfcRelAssignsToControl;
  class IfcRelAssignsToGroup extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingGroup = RelatingGroup;
      this.type = 1307041759;
    }
  }
  IFC2X32.IfcRelAssignsToGroup = IfcRelAssignsToGroup;
  class IfcRelAssignsToProcess extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProcess, QuantityInProcess) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingProcess = RelatingProcess;
      this.QuantityInProcess = QuantityInProcess;
      this.type = 4278684876;
    }
  }
  IFC2X32.IfcRelAssignsToProcess = IfcRelAssignsToProcess;
  class IfcRelAssignsToProduct extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProduct) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingProduct = RelatingProduct;
      this.type = 2857406711;
    }
  }
  IFC2X32.IfcRelAssignsToProduct = IfcRelAssignsToProduct;
  class IfcRelAssignsToProjectOrder extends IfcRelAssignsToControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingControl = RelatingControl;
      this.type = 3372526763;
    }
  }
  IFC2X32.IfcRelAssignsToProjectOrder = IfcRelAssignsToProjectOrder;
  class IfcRelAssignsToResource extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingResource) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingResource = RelatingResource;
      this.type = 205026976;
    }
  }
  IFC2X32.IfcRelAssignsToResource = IfcRelAssignsToResource;
  class IfcRelAssociates extends IfcRelationship {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.type = 1865459582;
    }
  }
  IFC2X32.IfcRelAssociates = IfcRelAssociates;
  class IfcRelAssociatesAppliedValue extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingAppliedValue) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingAppliedValue = RelatingAppliedValue;
      this.type = 1327628568;
    }
  }
  IFC2X32.IfcRelAssociatesAppliedValue = IfcRelAssociatesAppliedValue;
  class IfcRelAssociatesApproval extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingApproval) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingApproval = RelatingApproval;
      this.type = 4095574036;
    }
  }
  IFC2X32.IfcRelAssociatesApproval = IfcRelAssociatesApproval;
  class IfcRelAssociatesClassification extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingClassification) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingClassification = RelatingClassification;
      this.type = 919958153;
    }
  }
  IFC2X32.IfcRelAssociatesClassification = IfcRelAssociatesClassification;
  class IfcRelAssociatesConstraint extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, Intent, RelatingConstraint) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.Intent = Intent;
      this.RelatingConstraint = RelatingConstraint;
      this.type = 2728634034;
    }
  }
  IFC2X32.IfcRelAssociatesConstraint = IfcRelAssociatesConstraint;
  class IfcRelAssociatesDocument extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingDocument) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingDocument = RelatingDocument;
      this.type = 982818633;
    }
  }
  IFC2X32.IfcRelAssociatesDocument = IfcRelAssociatesDocument;
  class IfcRelAssociatesLibrary extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingLibrary) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingLibrary = RelatingLibrary;
      this.type = 3840914261;
    }
  }
  IFC2X32.IfcRelAssociatesLibrary = IfcRelAssociatesLibrary;
  class IfcRelAssociatesMaterial extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingMaterial) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingMaterial = RelatingMaterial;
      this.type = 2655215786;
    }
  }
  IFC2X32.IfcRelAssociatesMaterial = IfcRelAssociatesMaterial;
  class IfcRelAssociatesProfileProperties extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingProfileProperties, ProfileSectionLocation, ProfileOrientation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingProfileProperties = RelatingProfileProperties;
      this.ProfileSectionLocation = ProfileSectionLocation;
      this.ProfileOrientation = ProfileOrientation;
      this.type = 2851387026;
    }
  }
  IFC2X32.IfcRelAssociatesProfileProperties = IfcRelAssociatesProfileProperties;
  class IfcRelConnects extends IfcRelationship {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 826625072;
    }
  }
  IFC2X32.IfcRelConnects = IfcRelConnects;
  class IfcRelConnectsElements extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.type = 1204542856;
    }
  }
  IFC2X32.IfcRelConnectsElements = IfcRelConnectsElements;
  class IfcRelConnectsPathElements extends IfcRelConnectsElements {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RelatingPriorities, RelatedPriorities, RelatedConnectionType, RelatingConnectionType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.RelatingPriorities = RelatingPriorities;
      this.RelatedPriorities = RelatedPriorities;
      this.RelatedConnectionType = RelatedConnectionType;
      this.RelatingConnectionType = RelatingConnectionType;
      this.type = 3945020480;
    }
  }
  IFC2X32.IfcRelConnectsPathElements = IfcRelConnectsPathElements;
  class IfcRelConnectsPortToElement extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingPort = RelatingPort;
      this.RelatedElement = RelatedElement;
      this.type = 4201705270;
    }
  }
  IFC2X32.IfcRelConnectsPortToElement = IfcRelConnectsPortToElement;
  class IfcRelConnectsPorts extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedPort, RealizingElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingPort = RelatingPort;
      this.RelatedPort = RelatedPort;
      this.RealizingElement = RealizingElement;
      this.type = 3190031847;
    }
  }
  IFC2X32.IfcRelConnectsPorts = IfcRelConnectsPorts;
  class IfcRelConnectsStructuralActivity extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedStructuralActivity) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedStructuralActivity = RelatedStructuralActivity;
      this.type = 2127690289;
    }
  }
  IFC2X32.IfcRelConnectsStructuralActivity = IfcRelConnectsStructuralActivity;
  class IfcRelConnectsStructuralElement extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedStructuralMember) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedStructuralMember = RelatedStructuralMember;
      this.type = 3912681535;
    }
  }
  IFC2X32.IfcRelConnectsStructuralElement = IfcRelConnectsStructuralElement;
  class IfcRelConnectsStructuralMember extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingStructuralMember = RelatingStructuralMember;
      this.RelatedStructuralConnection = RelatedStructuralConnection;
      this.AppliedCondition = AppliedCondition;
      this.AdditionalConditions = AdditionalConditions;
      this.SupportedLength = SupportedLength;
      this.ConditionCoordinateSystem = ConditionCoordinateSystem;
      this.type = 1638771189;
    }
  }
  IFC2X32.IfcRelConnectsStructuralMember = IfcRelConnectsStructuralMember;
  class IfcRelConnectsWithEccentricity extends IfcRelConnectsStructuralMember {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem, ConnectionConstraint) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingStructuralMember = RelatingStructuralMember;
      this.RelatedStructuralConnection = RelatedStructuralConnection;
      this.AppliedCondition = AppliedCondition;
      this.AdditionalConditions = AdditionalConditions;
      this.SupportedLength = SupportedLength;
      this.ConditionCoordinateSystem = ConditionCoordinateSystem;
      this.ConnectionConstraint = ConnectionConstraint;
      this.type = 504942748;
    }
  }
  IFC2X32.IfcRelConnectsWithEccentricity = IfcRelConnectsWithEccentricity;
  class IfcRelConnectsWithRealizingElements extends IfcRelConnectsElements {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RealizingElements, ConnectionType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.RealizingElements = RealizingElements;
      this.ConnectionType = ConnectionType;
      this.type = 3678494232;
    }
  }
  IFC2X32.IfcRelConnectsWithRealizingElements = IfcRelConnectsWithRealizingElements;
  class IfcRelContainedInSpatialStructure extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedElements = RelatedElements;
      this.RelatingStructure = RelatingStructure;
      this.type = 3242617779;
    }
  }
  IFC2X32.IfcRelContainedInSpatialStructure = IfcRelContainedInSpatialStructure;
  class IfcRelCoversBldgElements extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedCoverings) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingBuildingElement = RelatingBuildingElement;
      this.RelatedCoverings = RelatedCoverings;
      this.type = 886880790;
    }
  }
  IFC2X32.IfcRelCoversBldgElements = IfcRelCoversBldgElements;
  class IfcRelCoversSpaces extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedSpace, RelatedCoverings) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedSpace = RelatedSpace;
      this.RelatedCoverings = RelatedCoverings;
      this.type = 2802773753;
    }
  }
  IFC2X32.IfcRelCoversSpaces = IfcRelCoversSpaces;
  class IfcRelDecomposes extends IfcRelationship {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingObject = RelatingObject;
      this.RelatedObjects = RelatedObjects;
      this.type = 2551354335;
    }
  }
  IFC2X32.IfcRelDecomposes = IfcRelDecomposes;
  class IfcRelDefines extends IfcRelationship {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.type = 693640335;
    }
  }
  IFC2X32.IfcRelDefines = IfcRelDefines;
  class IfcRelDefinesByProperties extends IfcRelDefines {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingPropertyDefinition = RelatingPropertyDefinition;
      this.type = 4186316022;
    }
  }
  IFC2X32.IfcRelDefinesByProperties = IfcRelDefinesByProperties;
  class IfcRelDefinesByType extends IfcRelDefines {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingType = RelatingType;
      this.type = 781010003;
    }
  }
  IFC2X32.IfcRelDefinesByType = IfcRelDefinesByType;
  class IfcRelFillsElement extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingOpeningElement, RelatedBuildingElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingOpeningElement = RelatingOpeningElement;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.type = 3940055652;
    }
  }
  IFC2X32.IfcRelFillsElement = IfcRelFillsElement;
  class IfcRelFlowControlElements extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedControlElements, RelatingFlowElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedControlElements = RelatedControlElements;
      this.RelatingFlowElement = RelatingFlowElement;
      this.type = 279856033;
    }
  }
  IFC2X32.IfcRelFlowControlElements = IfcRelFlowControlElements;
  class IfcRelInteractionRequirements extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, DailyInteraction, ImportanceRating, LocationOfInteraction, RelatedSpaceProgram, RelatingSpaceProgram) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.DailyInteraction = DailyInteraction;
      this.ImportanceRating = ImportanceRating;
      this.LocationOfInteraction = LocationOfInteraction;
      this.RelatedSpaceProgram = RelatedSpaceProgram;
      this.RelatingSpaceProgram = RelatingSpaceProgram;
      this.type = 4189434867;
    }
  }
  IFC2X32.IfcRelInteractionRequirements = IfcRelInteractionRequirements;
  class IfcRelNests extends IfcRelDecomposes {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingObject = RelatingObject;
      this.RelatedObjects = RelatedObjects;
      this.type = 3268803585;
    }
  }
  IFC2X32.IfcRelNests = IfcRelNests;
  class IfcRelOccupiesSpaces extends IfcRelAssignsToActor {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingActor = RelatingActor;
      this.ActingRole = ActingRole;
      this.type = 2051452291;
    }
  }
  IFC2X32.IfcRelOccupiesSpaces = IfcRelOccupiesSpaces;
  class IfcRelOverridesProperties extends IfcRelDefinesByProperties {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition, OverridingProperties) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingPropertyDefinition = RelatingPropertyDefinition;
      this.OverridingProperties = OverridingProperties;
      this.type = 202636808;
    }
  }
  IFC2X32.IfcRelOverridesProperties = IfcRelOverridesProperties;
  class IfcRelProjectsElement extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedFeatureElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedFeatureElement = RelatedFeatureElement;
      this.type = 750771296;
    }
  }
  IFC2X32.IfcRelProjectsElement = IfcRelProjectsElement;
  class IfcRelReferencedInSpatialStructure extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedElements = RelatedElements;
      this.RelatingStructure = RelatingStructure;
      this.type = 1245217292;
    }
  }
  IFC2X32.IfcRelReferencedInSpatialStructure = IfcRelReferencedInSpatialStructure;
  class IfcRelSchedulesCostItems extends IfcRelAssignsToControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingControl = RelatingControl;
      this.type = 1058617721;
    }
  }
  IFC2X32.IfcRelSchedulesCostItems = IfcRelSchedulesCostItems;
  class IfcRelSequence extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingProcess, RelatedProcess, TimeLag, SequenceType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingProcess = RelatingProcess;
      this.RelatedProcess = RelatedProcess;
      this.TimeLag = TimeLag;
      this.SequenceType = SequenceType;
      this.type = 4122056220;
    }
  }
  IFC2X32.IfcRelSequence = IfcRelSequence;
  class IfcRelServicesBuildings extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSystem, RelatedBuildings) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSystem = RelatingSystem;
      this.RelatedBuildings = RelatedBuildings;
      this.type = 366585022;
    }
  }
  IFC2X32.IfcRelServicesBuildings = IfcRelServicesBuildings;
  class IfcRelSpaceBoundary extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.ConnectionGeometry = ConnectionGeometry;
      this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      this.InternalOrExternalBoundary = InternalOrExternalBoundary;
      this.type = 3451746338;
    }
  }
  IFC2X32.IfcRelSpaceBoundary = IfcRelSpaceBoundary;
  class IfcRelVoidsElement extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedOpeningElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingBuildingElement = RelatingBuildingElement;
      this.RelatedOpeningElement = RelatedOpeningElement;
      this.type = 1401173127;
    }
  }
  IFC2X32.IfcRelVoidsElement = IfcRelVoidsElement;
  class IfcResource extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2914609552;
    }
  }
  IFC2X32.IfcResource = IfcResource;
  class IfcRevolvedAreaSolid extends IfcSweptAreaSolid {
    constructor(expressID, SweptArea, Position, Axis, Angle) {
      super(expressID, SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Axis = Axis;
      this.Angle = Angle;
      this.type = 1856042241;
    }
  }
  IFC2X32.IfcRevolvedAreaSolid = IfcRevolvedAreaSolid;
  class IfcRightCircularCone extends IfcCsgPrimitive3D {
    constructor(expressID, Position, Height, BottomRadius) {
      super(expressID, Position);
      this.Position = Position;
      this.Height = Height;
      this.BottomRadius = BottomRadius;
      this.type = 4158566097;
    }
  }
  IFC2X32.IfcRightCircularCone = IfcRightCircularCone;
  class IfcRightCircularCylinder extends IfcCsgPrimitive3D {
    constructor(expressID, Position, Height, Radius) {
      super(expressID, Position);
      this.Position = Position;
      this.Height = Height;
      this.Radius = Radius;
      this.type = 3626867408;
    }
  }
  IFC2X32.IfcRightCircularCylinder = IfcRightCircularCylinder;
  class IfcSpatialStructureElement extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.type = 2706606064;
    }
  }
  IFC2X32.IfcSpatialStructureElement = IfcSpatialStructureElement;
  class IfcSpatialStructureElementType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3893378262;
    }
  }
  IFC2X32.IfcSpatialStructureElementType = IfcSpatialStructureElementType;
  class IfcSphere extends IfcCsgPrimitive3D {
    constructor(expressID, Position, Radius) {
      super(expressID, Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 451544542;
    }
  }
  IFC2X32.IfcSphere = IfcSphere;
  class IfcStructuralActivity extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 3544373492;
    }
  }
  IFC2X32.IfcStructuralActivity = IfcStructuralActivity;
  class IfcStructuralItem extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 3136571912;
    }
  }
  IFC2X32.IfcStructuralItem = IfcStructuralItem;
  class IfcStructuralMember extends IfcStructuralItem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 530289379;
    }
  }
  IFC2X32.IfcStructuralMember = IfcStructuralMember;
  class IfcStructuralReaction extends IfcStructuralActivity {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 3689010777;
    }
  }
  IFC2X32.IfcStructuralReaction = IfcStructuralReaction;
  class IfcStructuralSurfaceMember extends IfcStructuralMember {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Thickness = Thickness;
      this.type = 3979015343;
    }
  }
  IFC2X32.IfcStructuralSurfaceMember = IfcStructuralSurfaceMember;
  class IfcStructuralSurfaceMemberVarying extends IfcStructuralSurfaceMember {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness, SubsequentThickness, VaryingThicknessLocation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Thickness = Thickness;
      this.SubsequentThickness = SubsequentThickness;
      this.VaryingThicknessLocation = VaryingThicknessLocation;
      this.type = 2218152070;
    }
  }
  IFC2X32.IfcStructuralSurfaceMemberVarying = IfcStructuralSurfaceMemberVarying;
  class IfcStructuredDimensionCallout extends IfcDraughtingCallout {
    constructor(expressID, Contents) {
      super(expressID, Contents);
      this.Contents = Contents;
      this.type = 4070609034;
    }
  }
  IFC2X32.IfcStructuredDimensionCallout = IfcStructuredDimensionCallout;
  class IfcSurfaceCurveSweptAreaSolid extends IfcSweptAreaSolid {
    constructor(expressID, SweptArea, Position, Directrix, StartParam, EndParam, ReferenceSurface) {
      super(expressID, SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Directrix = Directrix;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.ReferenceSurface = ReferenceSurface;
      this.type = 2028607225;
    }
  }
  IFC2X32.IfcSurfaceCurveSweptAreaSolid = IfcSurfaceCurveSweptAreaSolid;
  class IfcSurfaceOfLinearExtrusion extends IfcSweptSurface {
    constructor(expressID, SweptCurve, Position, ExtrudedDirection, Depth) {
      super(expressID, SweptCurve, Position);
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.ExtrudedDirection = ExtrudedDirection;
      this.Depth = Depth;
      this.type = 2809605785;
    }
  }
  IFC2X32.IfcSurfaceOfLinearExtrusion = IfcSurfaceOfLinearExtrusion;
  class IfcSurfaceOfRevolution extends IfcSweptSurface {
    constructor(expressID, SweptCurve, Position, AxisPosition) {
      super(expressID, SweptCurve, Position);
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.AxisPosition = AxisPosition;
      this.type = 4124788165;
    }
  }
  IFC2X32.IfcSurfaceOfRevolution = IfcSurfaceOfRevolution;
  class IfcSystemFurnitureElementType extends IfcFurnishingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1580310250;
    }
  }
  IFC2X32.IfcSystemFurnitureElementType = IfcSystemFurnitureElementType;
  class IfcTask extends IfcProcess {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TaskId = TaskId;
      this.Status = Status;
      this.WorkMethod = WorkMethod;
      this.IsMilestone = IsMilestone;
      this.Priority = Priority;
      this.type = 3473067441;
    }
  }
  IFC2X32.IfcTask = IfcTask;
  class IfcTransportElementType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2097647324;
    }
  }
  IFC2X32.IfcTransportElementType = IfcTransportElementType;
  class IfcActor extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheActor = TheActor;
      this.type = 2296667514;
    }
  }
  IFC2X32.IfcActor = IfcActor;
  class IfcAnnotation extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 1674181508;
    }
  }
  IFC2X32.IfcAnnotation = IfcAnnotation;
  class IfcAsymmetricIShapeProfileDef extends IfcIShapeProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius, TopFlangeWidth, TopFlangeThickness, TopFlangeFilletRadius, CentreOfGravityInY) {
      super(expressID, ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.OverallWidth = OverallWidth;
      this.OverallDepth = OverallDepth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.TopFlangeWidth = TopFlangeWidth;
      this.TopFlangeThickness = TopFlangeThickness;
      this.TopFlangeFilletRadius = TopFlangeFilletRadius;
      this.CentreOfGravityInY = CentreOfGravityInY;
      this.type = 3207858831;
    }
  }
  IFC2X32.IfcAsymmetricIShapeProfileDef = IfcAsymmetricIShapeProfileDef;
  class IfcBlock extends IfcCsgPrimitive3D {
    constructor(expressID, Position, XLength, YLength, ZLength) {
      super(expressID, Position);
      this.Position = Position;
      this.XLength = XLength;
      this.YLength = YLength;
      this.ZLength = ZLength;
      this.type = 1334484129;
    }
  }
  IFC2X32.IfcBlock = IfcBlock;
  class IfcBooleanClippingResult extends IfcBooleanResult {
    constructor(expressID, Operator, FirstOperand, SecondOperand) {
      super(expressID, Operator, FirstOperand, SecondOperand);
      this.Operator = Operator;
      this.FirstOperand = FirstOperand;
      this.SecondOperand = SecondOperand;
      this.type = 3649129432;
    }
  }
  IFC2X32.IfcBooleanClippingResult = IfcBooleanClippingResult;
  class IfcBoundedCurve extends IfcCurve {
    constructor(expressID) {
      super(expressID);
      this.type = 1260505505;
    }
  }
  IFC2X32.IfcBoundedCurve = IfcBoundedCurve;
  class IfcBuilding extends IfcSpatialStructureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, ElevationOfRefHeight, ElevationOfTerrain, BuildingAddress) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.ElevationOfRefHeight = ElevationOfRefHeight;
      this.ElevationOfTerrain = ElevationOfTerrain;
      this.BuildingAddress = BuildingAddress;
      this.type = 4031249490;
    }
  }
  IFC2X32.IfcBuilding = IfcBuilding;
  class IfcBuildingElementType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1950629157;
    }
  }
  IFC2X32.IfcBuildingElementType = IfcBuildingElementType;
  class IfcBuildingStorey extends IfcSpatialStructureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, Elevation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.Elevation = Elevation;
      this.type = 3124254112;
    }
  }
  IFC2X32.IfcBuildingStorey = IfcBuildingStorey;
  class IfcCircleHollowProfileDef extends IfcCircleProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Radius, WallThickness) {
      super(expressID, ProfileType, ProfileName, Position, Radius);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Radius = Radius;
      this.WallThickness = WallThickness;
      this.type = 2937912522;
    }
  }
  IFC2X32.IfcCircleHollowProfileDef = IfcCircleHollowProfileDef;
  class IfcColumnType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 300633059;
    }
  }
  IFC2X32.IfcColumnType = IfcColumnType;
  class IfcCompositeCurve extends IfcBoundedCurve {
    constructor(expressID, Segments, SelfIntersect) {
      super(expressID);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 3732776249;
    }
  }
  IFC2X32.IfcCompositeCurve = IfcCompositeCurve;
  class IfcConic extends IfcCurve {
    constructor(expressID, Position) {
      super(expressID);
      this.Position = Position;
      this.type = 2510884976;
    }
  }
  IFC2X32.IfcConic = IfcConic;
  class IfcConstructionResource extends IfcResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ResourceIdentifier = ResourceIdentifier;
      this.ResourceGroup = ResourceGroup;
      this.ResourceConsumption = ResourceConsumption;
      this.BaseQuantity = BaseQuantity;
      this.type = 2559216714;
    }
  }
  IFC2X32.IfcConstructionResource = IfcConstructionResource;
  class IfcControl extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 3293443760;
    }
  }
  IFC2X32.IfcControl = IfcControl;
  class IfcCostItem extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 3895139033;
    }
  }
  IFC2X32.IfcCostItem = IfcCostItem;
  class IfcCostSchedule extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, SubmittedBy, PreparedBy, SubmittedOn, Status, TargetUsers, UpdateDate, ID, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.SubmittedBy = SubmittedBy;
      this.PreparedBy = PreparedBy;
      this.SubmittedOn = SubmittedOn;
      this.Status = Status;
      this.TargetUsers = TargetUsers;
      this.UpdateDate = UpdateDate;
      this.ID = ID;
      this.PredefinedType = PredefinedType;
      this.type = 1419761937;
    }
  }
  IFC2X32.IfcCostSchedule = IfcCostSchedule;
  class IfcCoveringType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1916426348;
    }
  }
  IFC2X32.IfcCoveringType = IfcCoveringType;
  class IfcCrewResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ResourceIdentifier = ResourceIdentifier;
      this.ResourceGroup = ResourceGroup;
      this.ResourceConsumption = ResourceConsumption;
      this.BaseQuantity = BaseQuantity;
      this.type = 3295246426;
    }
  }
  IFC2X32.IfcCrewResource = IfcCrewResource;
  class IfcCurtainWallType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1457835157;
    }
  }
  IFC2X32.IfcCurtainWallType = IfcCurtainWallType;
  class IfcDimensionCurveDirectedCallout extends IfcDraughtingCallout {
    constructor(expressID, Contents) {
      super(expressID, Contents);
      this.Contents = Contents;
      this.type = 681481545;
    }
  }
  IFC2X32.IfcDimensionCurveDirectedCallout = IfcDimensionCurveDirectedCallout;
  class IfcDistributionElementType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3256556792;
    }
  }
  IFC2X32.IfcDistributionElementType = IfcDistributionElementType;
  class IfcDistributionFlowElementType extends IfcDistributionElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3849074793;
    }
  }
  IFC2X32.IfcDistributionFlowElementType = IfcDistributionFlowElementType;
  class IfcElectricalBaseProperties extends IfcEnergyProperties {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, EnergySequence, UserDefinedEnergySequence, ElectricCurrentType, InputVoltage, InputFrequency, FullLoadCurrent, MinimumCircuitCurrent, MaximumPowerInput, RatedPowerInput, InputPhase) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, EnergySequence, UserDefinedEnergySequence);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.EnergySequence = EnergySequence;
      this.UserDefinedEnergySequence = UserDefinedEnergySequence;
      this.ElectricCurrentType = ElectricCurrentType;
      this.InputVoltage = InputVoltage;
      this.InputFrequency = InputFrequency;
      this.FullLoadCurrent = FullLoadCurrent;
      this.MinimumCircuitCurrent = MinimumCircuitCurrent;
      this.MaximumPowerInput = MaximumPowerInput;
      this.RatedPowerInput = RatedPowerInput;
      this.InputPhase = InputPhase;
      this.type = 360485395;
    }
  }
  IFC2X32.IfcElectricalBaseProperties = IfcElectricalBaseProperties;
  class IfcElement extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1758889154;
    }
  }
  IFC2X32.IfcElement = IfcElement;
  class IfcElementAssembly extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, AssemblyPlace, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.AssemblyPlace = AssemblyPlace;
      this.PredefinedType = PredefinedType;
      this.type = 4123344466;
    }
  }
  IFC2X32.IfcElementAssembly = IfcElementAssembly;
  class IfcElementComponent extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1623761950;
    }
  }
  IFC2X32.IfcElementComponent = IfcElementComponent;
  class IfcElementComponentType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2590856083;
    }
  }
  IFC2X32.IfcElementComponentType = IfcElementComponentType;
  class IfcEllipse extends IfcConic {
    constructor(expressID, Position, SemiAxis1, SemiAxis2) {
      super(expressID, Position);
      this.Position = Position;
      this.SemiAxis1 = SemiAxis1;
      this.SemiAxis2 = SemiAxis2;
      this.type = 1704287377;
    }
  }
  IFC2X32.IfcEllipse = IfcEllipse;
  class IfcEnergyConversionDeviceType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2107101300;
    }
  }
  IFC2X32.IfcEnergyConversionDeviceType = IfcEnergyConversionDeviceType;
  class IfcEquipmentElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1962604670;
    }
  }
  IFC2X32.IfcEquipmentElement = IfcEquipmentElement;
  class IfcEquipmentStandard extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 3272907226;
    }
  }
  IFC2X32.IfcEquipmentStandard = IfcEquipmentStandard;
  class IfcEvaporativeCoolerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3174744832;
    }
  }
  IFC2X32.IfcEvaporativeCoolerType = IfcEvaporativeCoolerType;
  class IfcEvaporatorType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3390157468;
    }
  }
  IFC2X32.IfcEvaporatorType = IfcEvaporatorType;
  class IfcFacetedBrep extends IfcManifoldSolidBrep {
    constructor(expressID, Outer) {
      super(expressID, Outer);
      this.Outer = Outer;
      this.type = 807026263;
    }
  }
  IFC2X32.IfcFacetedBrep = IfcFacetedBrep;
  class IfcFacetedBrepWithVoids extends IfcManifoldSolidBrep {
    constructor(expressID, Outer, Voids) {
      super(expressID, Outer);
      this.Outer = Outer;
      this.Voids = Voids;
      this.type = 3737207727;
    }
  }
  IFC2X32.IfcFacetedBrepWithVoids = IfcFacetedBrepWithVoids;
  class IfcFastener extends IfcElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 647756555;
    }
  }
  IFC2X32.IfcFastener = IfcFastener;
  class IfcFastenerType extends IfcElementComponentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2489546625;
    }
  }
  IFC2X32.IfcFastenerType = IfcFastenerType;
  class IfcFeatureElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2827207264;
    }
  }
  IFC2X32.IfcFeatureElement = IfcFeatureElement;
  class IfcFeatureElementAddition extends IfcFeatureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2143335405;
    }
  }
  IFC2X32.IfcFeatureElementAddition = IfcFeatureElementAddition;
  class IfcFeatureElementSubtraction extends IfcFeatureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1287392070;
    }
  }
  IFC2X32.IfcFeatureElementSubtraction = IfcFeatureElementSubtraction;
  class IfcFlowControllerType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3907093117;
    }
  }
  IFC2X32.IfcFlowControllerType = IfcFlowControllerType;
  class IfcFlowFittingType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3198132628;
    }
  }
  IFC2X32.IfcFlowFittingType = IfcFlowFittingType;
  class IfcFlowMeterType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3815607619;
    }
  }
  IFC2X32.IfcFlowMeterType = IfcFlowMeterType;
  class IfcFlowMovingDeviceType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1482959167;
    }
  }
  IFC2X32.IfcFlowMovingDeviceType = IfcFlowMovingDeviceType;
  class IfcFlowSegmentType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1834744321;
    }
  }
  IFC2X32.IfcFlowSegmentType = IfcFlowSegmentType;
  class IfcFlowStorageDeviceType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1339347760;
    }
  }
  IFC2X32.IfcFlowStorageDeviceType = IfcFlowStorageDeviceType;
  class IfcFlowTerminalType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2297155007;
    }
  }
  IFC2X32.IfcFlowTerminalType = IfcFlowTerminalType;
  class IfcFlowTreatmentDeviceType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3009222698;
    }
  }
  IFC2X32.IfcFlowTreatmentDeviceType = IfcFlowTreatmentDeviceType;
  class IfcFurnishingElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 263784265;
    }
  }
  IFC2X32.IfcFurnishingElement = IfcFurnishingElement;
  class IfcFurnitureStandard extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 814719939;
    }
  }
  IFC2X32.IfcFurnitureStandard = IfcFurnitureStandard;
  class IfcGasTerminalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 200128114;
    }
  }
  IFC2X32.IfcGasTerminalType = IfcGasTerminalType;
  class IfcGrid extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, UAxes, VAxes, WAxes) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.UAxes = UAxes;
      this.VAxes = VAxes;
      this.WAxes = WAxes;
      this.type = 3009204131;
    }
  }
  IFC2X32.IfcGrid = IfcGrid;
  class IfcGroup extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2706460486;
    }
  }
  IFC2X32.IfcGroup = IfcGroup;
  class IfcHeatExchangerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1251058090;
    }
  }
  IFC2X32.IfcHeatExchangerType = IfcHeatExchangerType;
  class IfcHumidifierType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1806887404;
    }
  }
  IFC2X32.IfcHumidifierType = IfcHumidifierType;
  class IfcInventory extends IfcGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, InventoryType, Jurisdiction, ResponsiblePersons, LastUpdateDate, CurrentValue, OriginalValue) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.InventoryType = InventoryType;
      this.Jurisdiction = Jurisdiction;
      this.ResponsiblePersons = ResponsiblePersons;
      this.LastUpdateDate = LastUpdateDate;
      this.CurrentValue = CurrentValue;
      this.OriginalValue = OriginalValue;
      this.type = 2391368822;
    }
  }
  IFC2X32.IfcInventory = IfcInventory;
  class IfcJunctionBoxType extends IfcFlowFittingType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4288270099;
    }
  }
  IFC2X32.IfcJunctionBoxType = IfcJunctionBoxType;
  class IfcLaborResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity, SkillSet) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ResourceIdentifier = ResourceIdentifier;
      this.ResourceGroup = ResourceGroup;
      this.ResourceConsumption = ResourceConsumption;
      this.BaseQuantity = BaseQuantity;
      this.SkillSet = SkillSet;
      this.type = 3827777499;
    }
  }
  IFC2X32.IfcLaborResource = IfcLaborResource;
  class IfcLampType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1051575348;
    }
  }
  IFC2X32.IfcLampType = IfcLampType;
  class IfcLightFixtureType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1161773419;
    }
  }
  IFC2X32.IfcLightFixtureType = IfcLightFixtureType;
  class IfcLinearDimension extends IfcDimensionCurveDirectedCallout {
    constructor(expressID, Contents) {
      super(expressID, Contents);
      this.Contents = Contents;
      this.type = 2506943328;
    }
  }
  IFC2X32.IfcLinearDimension = IfcLinearDimension;
  class IfcMechanicalFastener extends IfcFastener {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NominalDiameter, NominalLength) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.NominalDiameter = NominalDiameter;
      this.NominalLength = NominalLength;
      this.type = 377706215;
    }
  }
  IFC2X32.IfcMechanicalFastener = IfcMechanicalFastener;
  class IfcMechanicalFastenerType extends IfcFastenerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2108223431;
    }
  }
  IFC2X32.IfcMechanicalFastenerType = IfcMechanicalFastenerType;
  class IfcMemberType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3181161470;
    }
  }
  IFC2X32.IfcMemberType = IfcMemberType;
  class IfcMotorConnectionType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 977012517;
    }
  }
  IFC2X32.IfcMotorConnectionType = IfcMotorConnectionType;
  class IfcMove extends IfcTask {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority, MoveFrom, MoveTo, PunchList) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TaskId = TaskId;
      this.Status = Status;
      this.WorkMethod = WorkMethod;
      this.IsMilestone = IsMilestone;
      this.Priority = Priority;
      this.MoveFrom = MoveFrom;
      this.MoveTo = MoveTo;
      this.PunchList = PunchList;
      this.type = 1916936684;
    }
  }
  IFC2X32.IfcMove = IfcMove;
  class IfcOccupant extends IfcActor {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheActor = TheActor;
      this.PredefinedType = PredefinedType;
      this.type = 4143007308;
    }
  }
  IFC2X32.IfcOccupant = IfcOccupant;
  class IfcOpeningElement extends IfcFeatureElementSubtraction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3588315303;
    }
  }
  IFC2X32.IfcOpeningElement = IfcOpeningElement;
  class IfcOrderAction extends IfcTask {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority, ActionID) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TaskId = TaskId;
      this.Status = Status;
      this.WorkMethod = WorkMethod;
      this.IsMilestone = IsMilestone;
      this.Priority = Priority;
      this.ActionID = ActionID;
      this.type = 3425660407;
    }
  }
  IFC2X32.IfcOrderAction = IfcOrderAction;
  class IfcOutletType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2837617999;
    }
  }
  IFC2X32.IfcOutletType = IfcOutletType;
  class IfcPerformanceHistory extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LifeCyclePhase) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LifeCyclePhase = LifeCyclePhase;
      this.type = 2382730787;
    }
  }
  IFC2X32.IfcPerformanceHistory = IfcPerformanceHistory;
  class IfcPermit extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PermitID) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PermitID = PermitID;
      this.type = 3327091369;
    }
  }
  IFC2X32.IfcPermit = IfcPermit;
  class IfcPipeFittingType extends IfcFlowFittingType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 804291784;
    }
  }
  IFC2X32.IfcPipeFittingType = IfcPipeFittingType;
  class IfcPipeSegmentType extends IfcFlowSegmentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4231323485;
    }
  }
  IFC2X32.IfcPipeSegmentType = IfcPipeSegmentType;
  class IfcPlateType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4017108033;
    }
  }
  IFC2X32.IfcPlateType = IfcPlateType;
  class IfcPolyline extends IfcBoundedCurve {
    constructor(expressID, Points) {
      super(expressID);
      this.Points = Points;
      this.type = 3724593414;
    }
  }
  IFC2X32.IfcPolyline = IfcPolyline;
  class IfcPort extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 3740093272;
    }
  }
  IFC2X32.IfcPort = IfcPort;
  class IfcProcedure extends IfcProcess {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ProcedureID, ProcedureType, UserDefinedProcedureType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ProcedureID = ProcedureID;
      this.ProcedureType = ProcedureType;
      this.UserDefinedProcedureType = UserDefinedProcedureType;
      this.type = 2744685151;
    }
  }
  IFC2X32.IfcProcedure = IfcProcedure;
  class IfcProjectOrder extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ID, PredefinedType, Status) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ID = ID;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.type = 2904328755;
    }
  }
  IFC2X32.IfcProjectOrder = IfcProjectOrder;
  class IfcProjectOrderRecord extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Records, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Records = Records;
      this.PredefinedType = PredefinedType;
      this.type = 3642467123;
    }
  }
  IFC2X32.IfcProjectOrderRecord = IfcProjectOrderRecord;
  class IfcProjectionElement extends IfcFeatureElementAddition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3651124850;
    }
  }
  IFC2X32.IfcProjectionElement = IfcProjectionElement;
  class IfcProtectiveDeviceType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1842657554;
    }
  }
  IFC2X32.IfcProtectiveDeviceType = IfcProtectiveDeviceType;
  class IfcPumpType extends IfcFlowMovingDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2250791053;
    }
  }
  IFC2X32.IfcPumpType = IfcPumpType;
  class IfcRadiusDimension extends IfcDimensionCurveDirectedCallout {
    constructor(expressID, Contents) {
      super(expressID, Contents);
      this.Contents = Contents;
      this.type = 3248260540;
    }
  }
  IFC2X32.IfcRadiusDimension = IfcRadiusDimension;
  class IfcRailingType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2893384427;
    }
  }
  IFC2X32.IfcRailingType = IfcRailingType;
  class IfcRampFlightType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2324767716;
    }
  }
  IFC2X32.IfcRampFlightType = IfcRampFlightType;
  class IfcRelAggregates extends IfcRelDecomposes {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingObject = RelatingObject;
      this.RelatedObjects = RelatedObjects;
      this.type = 160246688;
    }
  }
  IFC2X32.IfcRelAggregates = IfcRelAggregates;
  class IfcRelAssignsTasks extends IfcRelAssignsToControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl, TimeForTask) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingControl = RelatingControl;
      this.TimeForTask = TimeForTask;
      this.type = 2863920197;
    }
  }
  IFC2X32.IfcRelAssignsTasks = IfcRelAssignsTasks;
  class IfcSanitaryTerminalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1768891740;
    }
  }
  IFC2X32.IfcSanitaryTerminalType = IfcSanitaryTerminalType;
  class IfcScheduleTimeControl extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ActualStart, EarlyStart, LateStart, ScheduleStart, ActualFinish, EarlyFinish, LateFinish, ScheduleFinish, ScheduleDuration, ActualDuration, RemainingTime, FreeFloat, TotalFloat, IsCritical, StatusTime, StartFloat, FinishFloat, Completion) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ActualStart = ActualStart;
      this.EarlyStart = EarlyStart;
      this.LateStart = LateStart;
      this.ScheduleStart = ScheduleStart;
      this.ActualFinish = ActualFinish;
      this.EarlyFinish = EarlyFinish;
      this.LateFinish = LateFinish;
      this.ScheduleFinish = ScheduleFinish;
      this.ScheduleDuration = ScheduleDuration;
      this.ActualDuration = ActualDuration;
      this.RemainingTime = RemainingTime;
      this.FreeFloat = FreeFloat;
      this.TotalFloat = TotalFloat;
      this.IsCritical = IsCritical;
      this.StatusTime = StatusTime;
      this.StartFloat = StartFloat;
      this.FinishFloat = FinishFloat;
      this.Completion = Completion;
      this.type = 3517283431;
    }
  }
  IFC2X32.IfcScheduleTimeControl = IfcScheduleTimeControl;
  class IfcServiceLife extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ServiceLifeType, ServiceLifeDuration) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ServiceLifeType = ServiceLifeType;
      this.ServiceLifeDuration = ServiceLifeDuration;
      this.type = 4105383287;
    }
  }
  IFC2X32.IfcServiceLife = IfcServiceLife;
  class IfcSite extends IfcSpatialStructureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, RefLatitude, RefLongitude, RefElevation, LandTitleNumber, SiteAddress) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.RefLatitude = RefLatitude;
      this.RefLongitude = RefLongitude;
      this.RefElevation = RefElevation;
      this.LandTitleNumber = LandTitleNumber;
      this.SiteAddress = SiteAddress;
      this.type = 4097777520;
    }
  }
  IFC2X32.IfcSite = IfcSite;
  class IfcSlabType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2533589738;
    }
  }
  IFC2X32.IfcSlabType = IfcSlabType;
  class IfcSpace extends IfcSpatialStructureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, InteriorOrExteriorSpace, ElevationWithFlooring) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.InteriorOrExteriorSpace = InteriorOrExteriorSpace;
      this.ElevationWithFlooring = ElevationWithFlooring;
      this.type = 3856911033;
    }
  }
  IFC2X32.IfcSpace = IfcSpace;
  class IfcSpaceHeaterType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1305183839;
    }
  }
  IFC2X32.IfcSpaceHeaterType = IfcSpaceHeaterType;
  class IfcSpaceProgram extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, SpaceProgramIdentifier, MaxRequiredArea, MinRequiredArea, RequestedLocation, StandardRequiredArea) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.SpaceProgramIdentifier = SpaceProgramIdentifier;
      this.MaxRequiredArea = MaxRequiredArea;
      this.MinRequiredArea = MinRequiredArea;
      this.RequestedLocation = RequestedLocation;
      this.StandardRequiredArea = StandardRequiredArea;
      this.type = 652456506;
    }
  }
  IFC2X32.IfcSpaceProgram = IfcSpaceProgram;
  class IfcSpaceType extends IfcSpatialStructureElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3812236995;
    }
  }
  IFC2X32.IfcSpaceType = IfcSpaceType;
  class IfcStackTerminalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3112655638;
    }
  }
  IFC2X32.IfcStackTerminalType = IfcStackTerminalType;
  class IfcStairFlightType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1039846685;
    }
  }
  IFC2X32.IfcStairFlightType = IfcStairFlightType;
  class IfcStructuralAction extends IfcStructuralActivity {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.CausedBy = CausedBy;
      this.type = 682877961;
    }
  }
  IFC2X32.IfcStructuralAction = IfcStructuralAction;
  class IfcStructuralConnection extends IfcStructuralItem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.type = 1179482911;
    }
  }
  IFC2X32.IfcStructuralConnection = IfcStructuralConnection;
  class IfcStructuralCurveConnection extends IfcStructuralConnection {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.type = 4243806635;
    }
  }
  IFC2X32.IfcStructuralCurveConnection = IfcStructuralCurveConnection;
  class IfcStructuralCurveMember extends IfcStructuralMember {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.type = 214636428;
    }
  }
  IFC2X32.IfcStructuralCurveMember = IfcStructuralCurveMember;
  class IfcStructuralCurveMemberVarying extends IfcStructuralCurveMember {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.type = 2445595289;
    }
  }
  IFC2X32.IfcStructuralCurveMemberVarying = IfcStructuralCurveMemberVarying;
  class IfcStructuralLinearAction extends IfcStructuralAction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.CausedBy = CausedBy;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.type = 1807405624;
    }
  }
  IFC2X32.IfcStructuralLinearAction = IfcStructuralLinearAction;
  class IfcStructuralLinearActionVarying extends IfcStructuralLinearAction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue, VaryingAppliedLoadLocation, SubsequentAppliedLoads) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.CausedBy = CausedBy;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.VaryingAppliedLoadLocation = VaryingAppliedLoadLocation;
      this.SubsequentAppliedLoads = SubsequentAppliedLoads;
      this.type = 1721250024;
    }
  }
  IFC2X32.IfcStructuralLinearActionVarying = IfcStructuralLinearActionVarying;
  class IfcStructuralLoadGroup extends IfcGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.ActionType = ActionType;
      this.ActionSource = ActionSource;
      this.Coefficient = Coefficient;
      this.Purpose = Purpose;
      this.type = 1252848954;
    }
  }
  IFC2X32.IfcStructuralLoadGroup = IfcStructuralLoadGroup;
  class IfcStructuralPlanarAction extends IfcStructuralAction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.CausedBy = CausedBy;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.type = 1621171031;
    }
  }
  IFC2X32.IfcStructuralPlanarAction = IfcStructuralPlanarAction;
  class IfcStructuralPlanarActionVarying extends IfcStructuralPlanarAction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue, VaryingAppliedLoadLocation, SubsequentAppliedLoads) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.CausedBy = CausedBy;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.VaryingAppliedLoadLocation = VaryingAppliedLoadLocation;
      this.SubsequentAppliedLoads = SubsequentAppliedLoads;
      this.type = 3987759626;
    }
  }
  IFC2X32.IfcStructuralPlanarActionVarying = IfcStructuralPlanarActionVarying;
  class IfcStructuralPointAction extends IfcStructuralAction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.CausedBy = CausedBy;
      this.type = 2082059205;
    }
  }
  IFC2X32.IfcStructuralPointAction = IfcStructuralPointAction;
  class IfcStructuralPointConnection extends IfcStructuralConnection {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.type = 734778138;
    }
  }
  IFC2X32.IfcStructuralPointConnection = IfcStructuralPointConnection;
  class IfcStructuralPointReaction extends IfcStructuralReaction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 1235345126;
    }
  }
  IFC2X32.IfcStructuralPointReaction = IfcStructuralPointReaction;
  class IfcStructuralResultGroup extends IfcGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheoryType, ResultForLoadGroup, IsLinear) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheoryType = TheoryType;
      this.ResultForLoadGroup = ResultForLoadGroup;
      this.IsLinear = IsLinear;
      this.type = 2986769608;
    }
  }
  IFC2X32.IfcStructuralResultGroup = IfcStructuralResultGroup;
  class IfcStructuralSurfaceConnection extends IfcStructuralConnection {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.type = 1975003073;
    }
  }
  IFC2X32.IfcStructuralSurfaceConnection = IfcStructuralSurfaceConnection;
  class IfcSubContractResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity, SubContractor, JobDescription) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ResourceIdentifier = ResourceIdentifier;
      this.ResourceGroup = ResourceGroup;
      this.ResourceConsumption = ResourceConsumption;
      this.BaseQuantity = BaseQuantity;
      this.SubContractor = SubContractor;
      this.JobDescription = JobDescription;
      this.type = 148013059;
    }
  }
  IFC2X32.IfcSubContractResource = IfcSubContractResource;
  class IfcSwitchingDeviceType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2315554128;
    }
  }
  IFC2X32.IfcSwitchingDeviceType = IfcSwitchingDeviceType;
  class IfcSystem extends IfcGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2254336722;
    }
  }
  IFC2X32.IfcSystem = IfcSystem;
  class IfcTankType extends IfcFlowStorageDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 5716631;
    }
  }
  IFC2X32.IfcTankType = IfcTankType;
  class IfcTimeSeriesSchedule extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ApplicableDates, TimeSeriesScheduleType, TimeSeries) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ApplicableDates = ApplicableDates;
      this.TimeSeriesScheduleType = TimeSeriesScheduleType;
      this.TimeSeries = TimeSeries;
      this.type = 1637806684;
    }
  }
  IFC2X32.IfcTimeSeriesSchedule = IfcTimeSeriesSchedule;
  class IfcTransformerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1692211062;
    }
  }
  IFC2X32.IfcTransformerType = IfcTransformerType;
  class IfcTransportElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OperationType, CapacityByWeight, CapacityByNumber) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OperationType = OperationType;
      this.CapacityByWeight = CapacityByWeight;
      this.CapacityByNumber = CapacityByNumber;
      this.type = 1620046519;
    }
  }
  IFC2X32.IfcTransportElement = IfcTransportElement;
  class IfcTrimmedCurve extends IfcBoundedCurve {
    constructor(expressID, BasisCurve, Trim1, Trim2, SenseAgreement, MasterRepresentation) {
      super(expressID);
      this.BasisCurve = BasisCurve;
      this.Trim1 = Trim1;
      this.Trim2 = Trim2;
      this.SenseAgreement = SenseAgreement;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 3593883385;
    }
  }
  IFC2X32.IfcTrimmedCurve = IfcTrimmedCurve;
  class IfcTubeBundleType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1600972822;
    }
  }
  IFC2X32.IfcTubeBundleType = IfcTubeBundleType;
  class IfcUnitaryEquipmentType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1911125066;
    }
  }
  IFC2X32.IfcUnitaryEquipmentType = IfcUnitaryEquipmentType;
  class IfcValveType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 728799441;
    }
  }
  IFC2X32.IfcValveType = IfcValveType;
  class IfcVirtualElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2769231204;
    }
  }
  IFC2X32.IfcVirtualElement = IfcVirtualElement;
  class IfcWallType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1898987631;
    }
  }
  IFC2X32.IfcWallType = IfcWallType;
  class IfcWasteTerminalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1133259667;
    }
  }
  IFC2X32.IfcWasteTerminalType = IfcWasteTerminalType;
  class IfcWorkControl extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identifier = Identifier;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.WorkControlType = WorkControlType;
      this.UserDefinedControlType = UserDefinedControlType;
      this.type = 1028945134;
    }
  }
  IFC2X32.IfcWorkControl = IfcWorkControl;
  class IfcWorkPlan extends IfcWorkControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identifier = Identifier;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.WorkControlType = WorkControlType;
      this.UserDefinedControlType = UserDefinedControlType;
      this.type = 4218914973;
    }
  }
  IFC2X32.IfcWorkPlan = IfcWorkPlan;
  class IfcWorkSchedule extends IfcWorkControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identifier = Identifier;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.WorkControlType = WorkControlType;
      this.UserDefinedControlType = UserDefinedControlType;
      this.type = 3342526732;
    }
  }
  IFC2X32.IfcWorkSchedule = IfcWorkSchedule;
  class IfcZone extends IfcGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 1033361043;
    }
  }
  IFC2X32.IfcZone = IfcZone;
  class Ifc2DCompositeCurve extends IfcCompositeCurve {
    constructor(expressID, Segments, SelfIntersect) {
      super(expressID, Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 1213861670;
    }
  }
  IFC2X32.Ifc2DCompositeCurve = Ifc2DCompositeCurve;
  class IfcActionRequest extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, RequestID) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.RequestID = RequestID;
      this.type = 3821786052;
    }
  }
  IFC2X32.IfcActionRequest = IfcActionRequest;
  class IfcAirTerminalBoxType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1411407467;
    }
  }
  IFC2X32.IfcAirTerminalBoxType = IfcAirTerminalBoxType;
  class IfcAirTerminalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3352864051;
    }
  }
  IFC2X32.IfcAirTerminalType = IfcAirTerminalType;
  class IfcAirToAirHeatRecoveryType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1871374353;
    }
  }
  IFC2X32.IfcAirToAirHeatRecoveryType = IfcAirToAirHeatRecoveryType;
  class IfcAngularDimension extends IfcDimensionCurveDirectedCallout {
    constructor(expressID, Contents) {
      super(expressID, Contents);
      this.Contents = Contents;
      this.type = 2470393545;
    }
  }
  IFC2X32.IfcAngularDimension = IfcAngularDimension;
  class IfcAsset extends IfcGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, AssetID, OriginalValue, CurrentValue, TotalReplacementCost, Owner, User, ResponsiblePerson, IncorporationDate, DepreciatedValue) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.AssetID = AssetID;
      this.OriginalValue = OriginalValue;
      this.CurrentValue = CurrentValue;
      this.TotalReplacementCost = TotalReplacementCost;
      this.Owner = Owner;
      this.User = User;
      this.ResponsiblePerson = ResponsiblePerson;
      this.IncorporationDate = IncorporationDate;
      this.DepreciatedValue = DepreciatedValue;
      this.type = 3460190687;
    }
  }
  IFC2X32.IfcAsset = IfcAsset;
  class IfcBSplineCurve extends IfcBoundedCurve {
    constructor(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect) {
      super(expressID);
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.type = 1967976161;
    }
  }
  IFC2X32.IfcBSplineCurve = IfcBSplineCurve;
  class IfcBeamType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 819618141;
    }
  }
  IFC2X32.IfcBeamType = IfcBeamType;
  class IfcBezierCurve extends IfcBSplineCurve {
    constructor(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect) {
      super(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect);
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.type = 1916977116;
    }
  }
  IFC2X32.IfcBezierCurve = IfcBezierCurve;
  class IfcBoilerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 231477066;
    }
  }
  IFC2X32.IfcBoilerType = IfcBoilerType;
  class IfcBuildingElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3299480353;
    }
  }
  IFC2X32.IfcBuildingElement = IfcBuildingElement;
  class IfcBuildingElementComponent extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 52481810;
    }
  }
  IFC2X32.IfcBuildingElementComponent = IfcBuildingElementComponent;
  class IfcBuildingElementPart extends IfcBuildingElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2979338954;
    }
  }
  IFC2X32.IfcBuildingElementPart = IfcBuildingElementPart;
  class IfcBuildingElementProxy extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, CompositionType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.CompositionType = CompositionType;
      this.type = 1095909175;
    }
  }
  IFC2X32.IfcBuildingElementProxy = IfcBuildingElementProxy;
  class IfcBuildingElementProxyType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1909888760;
    }
  }
  IFC2X32.IfcBuildingElementProxyType = IfcBuildingElementProxyType;
  class IfcCableCarrierFittingType extends IfcFlowFittingType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 395041908;
    }
  }
  IFC2X32.IfcCableCarrierFittingType = IfcCableCarrierFittingType;
  class IfcCableCarrierSegmentType extends IfcFlowSegmentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3293546465;
    }
  }
  IFC2X32.IfcCableCarrierSegmentType = IfcCableCarrierSegmentType;
  class IfcCableSegmentType extends IfcFlowSegmentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1285652485;
    }
  }
  IFC2X32.IfcCableSegmentType = IfcCableSegmentType;
  class IfcChillerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2951183804;
    }
  }
  IFC2X32.IfcChillerType = IfcChillerType;
  class IfcCircle extends IfcConic {
    constructor(expressID, Position, Radius) {
      super(expressID, Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 2611217952;
    }
  }
  IFC2X32.IfcCircle = IfcCircle;
  class IfcCoilType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2301859152;
    }
  }
  IFC2X32.IfcCoilType = IfcCoilType;
  class IfcColumn extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 843113511;
    }
  }
  IFC2X32.IfcColumn = IfcColumn;
  class IfcCompressorType extends IfcFlowMovingDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3850581409;
    }
  }
  IFC2X32.IfcCompressorType = IfcCompressorType;
  class IfcCondenserType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2816379211;
    }
  }
  IFC2X32.IfcCondenserType = IfcCondenserType;
  class IfcCondition extends IfcGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2188551683;
    }
  }
  IFC2X32.IfcCondition = IfcCondition;
  class IfcConditionCriterion extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Criterion, CriterionDateTime) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Criterion = Criterion;
      this.CriterionDateTime = CriterionDateTime;
      this.type = 1163958913;
    }
  }
  IFC2X32.IfcConditionCriterion = IfcConditionCriterion;
  class IfcConstructionEquipmentResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ResourceIdentifier = ResourceIdentifier;
      this.ResourceGroup = ResourceGroup;
      this.ResourceConsumption = ResourceConsumption;
      this.BaseQuantity = BaseQuantity;
      this.type = 3898045240;
    }
  }
  IFC2X32.IfcConstructionEquipmentResource = IfcConstructionEquipmentResource;
  class IfcConstructionMaterialResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity, Suppliers, UsageRatio) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ResourceIdentifier = ResourceIdentifier;
      this.ResourceGroup = ResourceGroup;
      this.ResourceConsumption = ResourceConsumption;
      this.BaseQuantity = BaseQuantity;
      this.Suppliers = Suppliers;
      this.UsageRatio = UsageRatio;
      this.type = 1060000209;
    }
  }
  IFC2X32.IfcConstructionMaterialResource = IfcConstructionMaterialResource;
  class IfcConstructionProductResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ResourceIdentifier = ResourceIdentifier;
      this.ResourceGroup = ResourceGroup;
      this.ResourceConsumption = ResourceConsumption;
      this.BaseQuantity = BaseQuantity;
      this.type = 488727124;
    }
  }
  IFC2X32.IfcConstructionProductResource = IfcConstructionProductResource;
  class IfcCooledBeamType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 335055490;
    }
  }
  IFC2X32.IfcCooledBeamType = IfcCooledBeamType;
  class IfcCoolingTowerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2954562838;
    }
  }
  IFC2X32.IfcCoolingTowerType = IfcCoolingTowerType;
  class IfcCovering extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1973544240;
    }
  }
  IFC2X32.IfcCovering = IfcCovering;
  class IfcCurtainWall extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3495092785;
    }
  }
  IFC2X32.IfcCurtainWall = IfcCurtainWall;
  class IfcDamperType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3961806047;
    }
  }
  IFC2X32.IfcDamperType = IfcDamperType;
  class IfcDiameterDimension extends IfcDimensionCurveDirectedCallout {
    constructor(expressID, Contents) {
      super(expressID, Contents);
      this.Contents = Contents;
      this.type = 4147604152;
    }
  }
  IFC2X32.IfcDiameterDimension = IfcDiameterDimension;
  class IfcDiscreteAccessory extends IfcElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1335981549;
    }
  }
  IFC2X32.IfcDiscreteAccessory = IfcDiscreteAccessory;
  class IfcDiscreteAccessoryType extends IfcElementComponentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2635815018;
    }
  }
  IFC2X32.IfcDiscreteAccessoryType = IfcDiscreteAccessoryType;
  class IfcDistributionChamberElementType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1599208980;
    }
  }
  IFC2X32.IfcDistributionChamberElementType = IfcDistributionChamberElementType;
  class IfcDistributionControlElementType extends IfcDistributionElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2063403501;
    }
  }
  IFC2X32.IfcDistributionControlElementType = IfcDistributionControlElementType;
  class IfcDistributionElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1945004755;
    }
  }
  IFC2X32.IfcDistributionElement = IfcDistributionElement;
  class IfcDistributionFlowElement extends IfcDistributionElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3040386961;
    }
  }
  IFC2X32.IfcDistributionFlowElement = IfcDistributionFlowElement;
  class IfcDistributionPort extends IfcPort {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, FlowDirection) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.FlowDirection = FlowDirection;
      this.type = 3041715199;
    }
  }
  IFC2X32.IfcDistributionPort = IfcDistributionPort;
  class IfcDoor extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OverallHeight = OverallHeight;
      this.OverallWidth = OverallWidth;
      this.type = 395920057;
    }
  }
  IFC2X32.IfcDoor = IfcDoor;
  class IfcDuctFittingType extends IfcFlowFittingType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 869906466;
    }
  }
  IFC2X32.IfcDuctFittingType = IfcDuctFittingType;
  class IfcDuctSegmentType extends IfcFlowSegmentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3760055223;
    }
  }
  IFC2X32.IfcDuctSegmentType = IfcDuctSegmentType;
  class IfcDuctSilencerType extends IfcFlowTreatmentDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2030761528;
    }
  }
  IFC2X32.IfcDuctSilencerType = IfcDuctSilencerType;
  class IfcEdgeFeature extends IfcFeatureElementSubtraction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.FeatureLength = FeatureLength;
      this.type = 855621170;
    }
  }
  IFC2X32.IfcEdgeFeature = IfcEdgeFeature;
  class IfcElectricApplianceType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 663422040;
    }
  }
  IFC2X32.IfcElectricApplianceType = IfcElectricApplianceType;
  class IfcElectricFlowStorageDeviceType extends IfcFlowStorageDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3277789161;
    }
  }
  IFC2X32.IfcElectricFlowStorageDeviceType = IfcElectricFlowStorageDeviceType;
  class IfcElectricGeneratorType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1534661035;
    }
  }
  IFC2X32.IfcElectricGeneratorType = IfcElectricGeneratorType;
  class IfcElectricHeaterType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1365060375;
    }
  }
  IFC2X32.IfcElectricHeaterType = IfcElectricHeaterType;
  class IfcElectricMotorType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1217240411;
    }
  }
  IFC2X32.IfcElectricMotorType = IfcElectricMotorType;
  class IfcElectricTimeControlType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 712377611;
    }
  }
  IFC2X32.IfcElectricTimeControlType = IfcElectricTimeControlType;
  class IfcElectricalCircuit extends IfcSystem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 1634875225;
    }
  }
  IFC2X32.IfcElectricalCircuit = IfcElectricalCircuit;
  class IfcElectricalElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 857184966;
    }
  }
  IFC2X32.IfcElectricalElement = IfcElectricalElement;
  class IfcEnergyConversionDevice extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1658829314;
    }
  }
  IFC2X32.IfcEnergyConversionDevice = IfcEnergyConversionDevice;
  class IfcFanType extends IfcFlowMovingDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 346874300;
    }
  }
  IFC2X32.IfcFanType = IfcFanType;
  class IfcFilterType extends IfcFlowTreatmentDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1810631287;
    }
  }
  IFC2X32.IfcFilterType = IfcFilterType;
  class IfcFireSuppressionTerminalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4222183408;
    }
  }
  IFC2X32.IfcFireSuppressionTerminalType = IfcFireSuppressionTerminalType;
  class IfcFlowController extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2058353004;
    }
  }
  IFC2X32.IfcFlowController = IfcFlowController;
  class IfcFlowFitting extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 4278956645;
    }
  }
  IFC2X32.IfcFlowFitting = IfcFlowFitting;
  class IfcFlowInstrumentType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4037862832;
    }
  }
  IFC2X32.IfcFlowInstrumentType = IfcFlowInstrumentType;
  class IfcFlowMovingDevice extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3132237377;
    }
  }
  IFC2X32.IfcFlowMovingDevice = IfcFlowMovingDevice;
  class IfcFlowSegment extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 987401354;
    }
  }
  IFC2X32.IfcFlowSegment = IfcFlowSegment;
  class IfcFlowStorageDevice extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 707683696;
    }
  }
  IFC2X32.IfcFlowStorageDevice = IfcFlowStorageDevice;
  class IfcFlowTerminal extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2223149337;
    }
  }
  IFC2X32.IfcFlowTerminal = IfcFlowTerminal;
  class IfcFlowTreatmentDevice extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3508470533;
    }
  }
  IFC2X32.IfcFlowTreatmentDevice = IfcFlowTreatmentDevice;
  class IfcFooting extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 900683007;
    }
  }
  IFC2X32.IfcFooting = IfcFooting;
  class IfcMember extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1073191201;
    }
  }
  IFC2X32.IfcMember = IfcMember;
  class IfcPile extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType, ConstructionType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.ConstructionType = ConstructionType;
      this.type = 1687234759;
    }
  }
  IFC2X32.IfcPile = IfcPile;
  class IfcPlate extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3171933400;
    }
  }
  IFC2X32.IfcPlate = IfcPlate;
  class IfcRailing extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2262370178;
    }
  }
  IFC2X32.IfcRailing = IfcRailing;
  class IfcRamp extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, ShapeType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.ShapeType = ShapeType;
      this.type = 3024970846;
    }
  }
  IFC2X32.IfcRamp = IfcRamp;
  class IfcRampFlight extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3283111854;
    }
  }
  IFC2X32.IfcRampFlight = IfcRampFlight;
  class IfcRationalBezierCurve extends IfcBezierCurve {
    constructor(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, WeightsData) {
      super(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect);
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.WeightsData = WeightsData;
      this.type = 3055160366;
    }
  }
  IFC2X32.IfcRationalBezierCurve = IfcRationalBezierCurve;
  class IfcReinforcingElement extends IfcBuildingElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.type = 3027567501;
    }
  }
  IFC2X32.IfcReinforcingElement = IfcReinforcingElement;
  class IfcReinforcingMesh extends IfcReinforcingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.MeshLength = MeshLength;
      this.MeshWidth = MeshWidth;
      this.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
      this.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
      this.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
      this.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
      this.LongitudinalBarSpacing = LongitudinalBarSpacing;
      this.TransverseBarSpacing = TransverseBarSpacing;
      this.type = 2320036040;
    }
  }
  IFC2X32.IfcReinforcingMesh = IfcReinforcingMesh;
  class IfcRoof extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, ShapeType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.ShapeType = ShapeType;
      this.type = 2016517767;
    }
  }
  IFC2X32.IfcRoof = IfcRoof;
  class IfcRoundedEdgeFeature extends IfcEdgeFeature {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength, Radius) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.FeatureLength = FeatureLength;
      this.Radius = Radius;
      this.type = 1376911519;
    }
  }
  IFC2X32.IfcRoundedEdgeFeature = IfcRoundedEdgeFeature;
  class IfcSensorType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1783015770;
    }
  }
  IFC2X32.IfcSensorType = IfcSensorType;
  class IfcSlab extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1529196076;
    }
  }
  IFC2X32.IfcSlab = IfcSlab;
  class IfcStair extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, ShapeType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.ShapeType = ShapeType;
      this.type = 331165859;
    }
  }
  IFC2X32.IfcStair = IfcStair;
  class IfcStairFlight extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NumberOfRiser, NumberOfTreads, RiserHeight, TreadLength) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.NumberOfRiser = NumberOfRiser;
      this.NumberOfTreads = NumberOfTreads;
      this.RiserHeight = RiserHeight;
      this.TreadLength = TreadLength;
      this.type = 4252922144;
    }
  }
  IFC2X32.IfcStairFlight = IfcStairFlight;
  class IfcStructuralAnalysisModel extends IfcSystem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, OrientationOf2DPlane, LoadedBy, HasResults) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.OrientationOf2DPlane = OrientationOf2DPlane;
      this.LoadedBy = LoadedBy;
      this.HasResults = HasResults;
      this.type = 2515109513;
    }
  }
  IFC2X32.IfcStructuralAnalysisModel = IfcStructuralAnalysisModel;
  class IfcTendon extends IfcReinforcingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType, NominalDiameter, CrossSectionArea, TensionForce, PreStress, FrictionCoefficient, AnchorageSlip, MinCurvatureRadius) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.TensionForce = TensionForce;
      this.PreStress = PreStress;
      this.FrictionCoefficient = FrictionCoefficient;
      this.AnchorageSlip = AnchorageSlip;
      this.MinCurvatureRadius = MinCurvatureRadius;
      this.type = 3824725483;
    }
  }
  IFC2X32.IfcTendon = IfcTendon;
  class IfcTendonAnchor extends IfcReinforcingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.type = 2347447852;
    }
  }
  IFC2X32.IfcTendonAnchor = IfcTendonAnchor;
  class IfcVibrationIsolatorType extends IfcDiscreteAccessoryType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3313531582;
    }
  }
  IFC2X32.IfcVibrationIsolatorType = IfcVibrationIsolatorType;
  class IfcWall extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2391406946;
    }
  }
  IFC2X32.IfcWall = IfcWall;
  class IfcWallStandardCase extends IfcWall {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3512223829;
    }
  }
  IFC2X32.IfcWallStandardCase = IfcWallStandardCase;
  class IfcWindow extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OverallHeight = OverallHeight;
      this.OverallWidth = OverallWidth;
      this.type = 3304561284;
    }
  }
  IFC2X32.IfcWindow = IfcWindow;
  class IfcActuatorType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2874132201;
    }
  }
  IFC2X32.IfcActuatorType = IfcActuatorType;
  class IfcAlarmType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3001207471;
    }
  }
  IFC2X32.IfcAlarmType = IfcAlarmType;
  class IfcBeam extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 753842376;
    }
  }
  IFC2X32.IfcBeam = IfcBeam;
  class IfcChamferEdgeFeature extends IfcEdgeFeature {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength, Width, Height) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.FeatureLength = FeatureLength;
      this.Width = Width;
      this.Height = Height;
      this.type = 2454782716;
    }
  }
  IFC2X32.IfcChamferEdgeFeature = IfcChamferEdgeFeature;
  class IfcControllerType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 578613899;
    }
  }
  IFC2X32.IfcControllerType = IfcControllerType;
  class IfcDistributionChamberElement extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1052013943;
    }
  }
  IFC2X32.IfcDistributionChamberElement = IfcDistributionChamberElement;
  class IfcDistributionControlElement extends IfcDistributionElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, ControlElementId) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.ControlElementId = ControlElementId;
      this.type = 1062813311;
    }
  }
  IFC2X32.IfcDistributionControlElement = IfcDistributionControlElement;
  class IfcElectricDistributionPoint extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, DistributionPointFunction, UserDefinedFunction) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.DistributionPointFunction = DistributionPointFunction;
      this.UserDefinedFunction = UserDefinedFunction;
      this.type = 3700593921;
    }
  }
  IFC2X32.IfcElectricDistributionPoint = IfcElectricDistributionPoint;
  class IfcReinforcingBar extends IfcReinforcingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, NominalDiameter, CrossSectionArea, BarLength, BarRole, BarSurface) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.BarLength = BarLength;
      this.BarRole = BarRole;
      this.BarSurface = BarSurface;
      this.type = 979691226;
    }
  }
  IFC2X32.IfcReinforcingBar = IfcReinforcingBar;
})(IFC2X3 || (IFC2X3 = {}));
SchemaNames[2] = "IFC4_3";
FromRawLineData[2] = {
  3630933823: (id, v) => new IFC4_3.IfcActorRole(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcText(v[2].value)),
  618182010: (id, v) => new IFC4_3.IfcAddress(id, v[0], !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value)),
  2879124712: (id, v) => new IFC4_3.IfcAlignmentParameterSegment(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value)),
  3633395639: (id, v) => new IFC4_3.IfcAlignmentVerticalSegment(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new IFC4_3.IfcLengthMeasure(v[2].value), new IFC4_3.IfcNonNegativeLengthMeasure(v[3].value), new IFC4_3.IfcLengthMeasure(v[4].value), new IFC4_3.IfcRatioMeasure(v[5].value), new IFC4_3.IfcRatioMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcLengthMeasure(v[7].value), v[8]),
  639542469: (id, v) => new IFC4_3.IfcApplication(id, new Handle(v[0].value), new IFC4_3.IfcLabel(v[1].value), new IFC4_3.IfcLabel(v[2].value), new IFC4_3.IfcIdentifier(v[3].value)),
  411424972: (id, v) => new IFC4_3.IfcAppliedValue(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcDate(v[4].value), !v[5] ? null : new IFC4_3.IfcDate(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], !v[9] ? null : v[9].map((p) => new Handle(p.value))),
  130549933: (id, v) => new IFC4_3.IfcApproval(id, !v[0] ? null : new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcText(v[2].value), !v[3] ? null : new IFC4_3.IfcDateTime(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value)),
  4037036970: (id, v) => new IFC4_3.IfcBoundaryCondition(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value)),
  1560379544: (id, v) => new IFC4_3.IfcBoundaryEdgeCondition(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : TypeInitialiser(2, v[1]), !v[2] ? null : TypeInitialiser(2, v[2]), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : TypeInitialiser(2, v[4]), !v[5] ? null : TypeInitialiser(2, v[5]), !v[6] ? null : TypeInitialiser(2, v[6])),
  3367102660: (id, v) => new IFC4_3.IfcBoundaryFaceCondition(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : TypeInitialiser(2, v[1]), !v[2] ? null : TypeInitialiser(2, v[2]), !v[3] ? null : TypeInitialiser(2, v[3])),
  1387855156: (id, v) => new IFC4_3.IfcBoundaryNodeCondition(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : TypeInitialiser(2, v[1]), !v[2] ? null : TypeInitialiser(2, v[2]), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : TypeInitialiser(2, v[4]), !v[5] ? null : TypeInitialiser(2, v[5]), !v[6] ? null : TypeInitialiser(2, v[6])),
  2069777674: (id, v) => new IFC4_3.IfcBoundaryNodeConditionWarping(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : TypeInitialiser(2, v[1]), !v[2] ? null : TypeInitialiser(2, v[2]), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : TypeInitialiser(2, v[4]), !v[5] ? null : TypeInitialiser(2, v[5]), !v[6] ? null : TypeInitialiser(2, v[6]), !v[7] ? null : TypeInitialiser(2, v[7])),
  2859738748: (id, _) => new IFC4_3.IfcConnectionGeometry(id),
  2614616156: (id, v) => new IFC4_3.IfcConnectionPointGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  2732653382: (id, v) => new IFC4_3.IfcConnectionSurfaceGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  775493141: (id, v) => new IFC4_3.IfcConnectionVolumeGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  1959218052: (id, v) => new IFC4_3.IfcConstraint(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2], !v[3] ? null : new IFC4_3.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new IFC4_3.IfcDateTime(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value)),
  1785450214: (id, v) => new IFC4_3.IfcCoordinateOperation(id, new Handle(v[0].value), new Handle(v[1].value)),
  1466758467: (id, v) => new IFC4_3.IfcCoordinateReferenceSystem(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new IFC4_3.IfcIdentifier(v[2].value), !v[3] ? null : new IFC4_3.IfcIdentifier(v[3].value)),
  602808272: (id, v) => new IFC4_3.IfcCostValue(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcDate(v[4].value), !v[5] ? null : new IFC4_3.IfcDate(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], !v[9] ? null : v[9].map((p) => new Handle(p.value))),
  1765591967: (id, v) => new IFC4_3.IfcDerivedUnit(id, v[0].map((p) => new Handle(p.value)), v[1], !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcLabel(v[3].value)),
  1045800335: (id, v) => new IFC4_3.IfcDerivedUnitElement(id, new Handle(v[0].value), v[1].value),
  2949456006: (id, v) => new IFC4_3.IfcDimensionalExponents(id, v[0].value, v[1].value, v[2].value, v[3].value, v[4].value, v[5].value, v[6].value),
  4294318154: (id, _) => new IFC4_3.IfcExternalInformation(id),
  3200245327: (id, v) => new IFC4_3.IfcExternalReference(id, !v[0] ? null : new IFC4_3.IfcURIReference(v[0].value), !v[1] ? null : new IFC4_3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value)),
  2242383968: (id, v) => new IFC4_3.IfcExternallyDefinedHatchStyle(id, !v[0] ? null : new IFC4_3.IfcURIReference(v[0].value), !v[1] ? null : new IFC4_3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value)),
  1040185647: (id, v) => new IFC4_3.IfcExternallyDefinedSurfaceStyle(id, !v[0] ? null : new IFC4_3.IfcURIReference(v[0].value), !v[1] ? null : new IFC4_3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value)),
  3548104201: (id, v) => new IFC4_3.IfcExternallyDefinedTextFont(id, !v[0] ? null : new IFC4_3.IfcURIReference(v[0].value), !v[1] ? null : new IFC4_3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value)),
  852622518: (id, v) => new IFC4_3.IfcGridAxis(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new Handle(v[1].value), new IFC4_3.IfcBoolean(v[2].value)),
  3020489413: (id, v) => new IFC4_3.IfcIrregularTimeSeriesValue(id, new IFC4_3.IfcDateTime(v[0].value), v[1].map((p) => TypeInitialiser(2, p))),
  2655187982: (id, v) => new IFC4_3.IfcLibraryInformation(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new IFC4_3.IfcDateTime(v[3].value), !v[4] ? null : new IFC4_3.IfcURIReference(v[4].value), !v[5] ? null : new IFC4_3.IfcText(v[5].value)),
  3452421091: (id, v) => new IFC4_3.IfcLibraryReference(id, !v[0] ? null : new IFC4_3.IfcURIReference(v[0].value), !v[1] ? null : new IFC4_3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLanguageId(v[4].value), !v[5] ? null : new Handle(v[5].value)),
  4162380809: (id, v) => new IFC4_3.IfcLightDistributionData(id, new IFC4_3.IfcPlaneAngleMeasure(v[0].value), v[1].map((p) => new IFC4_3.IfcPlaneAngleMeasure(p.value)), v[2].map((p) => new IFC4_3.IfcLuminousIntensityDistributionMeasure(p.value))),
  1566485204: (id, v) => new IFC4_3.IfcLightIntensityDistribution(id, v[0], v[1].map((p) => new Handle(p.value))),
  3057273783: (id, v) => new IFC4_3.IfcMapConversion(id, new Handle(v[0].value), new Handle(v[1].value), new IFC4_3.IfcLengthMeasure(v[2].value), new IFC4_3.IfcLengthMeasure(v[3].value), new IFC4_3.IfcLengthMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcReal(v[5].value), !v[6] ? null : new IFC4_3.IfcReal(v[6].value), !v[7] ? null : new IFC4_3.IfcReal(v[7].value), !v[8] ? null : new IFC4_3.IfcReal(v[8].value), !v[9] ? null : new IFC4_3.IfcReal(v[9].value)),
  1847130766: (id, v) => new IFC4_3.IfcMaterialClassificationRelationship(id, v[0].map((p) => new Handle(p.value)), new Handle(v[1].value)),
  760658860: (id, _) => new IFC4_3.IfcMaterialDefinition(id),
  248100487: (id, v) => new IFC4_3.IfcMaterialLayer(id, !v[0] ? null : new Handle(v[0].value), new IFC4_3.IfcNonNegativeLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLogical(v[2].value), !v[3] ? null : new IFC4_3.IfcLabel(v[3].value), !v[4] ? null : new IFC4_3.IfcText(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : new IFC4_3.IfcInteger(v[6].value)),
  3303938423: (id, v) => new IFC4_3.IfcMaterialLayerSet(id, v[0].map((p) => new Handle(p.value)), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcText(v[2].value)),
  1847252529: (id, v) => new IFC4_3.IfcMaterialLayerWithOffsets(id, !v[0] ? null : new Handle(v[0].value), new IFC4_3.IfcNonNegativeLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLogical(v[2].value), !v[3] ? null : new IFC4_3.IfcLabel(v[3].value), !v[4] ? null : new IFC4_3.IfcText(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : new IFC4_3.IfcInteger(v[6].value), v[7], new IFC4_3.IfcLengthMeasure(v[8].value)),
  2199411900: (id, v) => new IFC4_3.IfcMaterialList(id, v[0].map((p) => new Handle(p.value))),
  2235152071: (id, v) => new IFC4_3.IfcMaterialProfile(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcInteger(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value)),
  164193824: (id, v) => new IFC4_3.IfcMaterialProfileSet(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), !v[3] ? null : new Handle(v[3].value)),
  552965576: (id, v) => new IFC4_3.IfcMaterialProfileWithOffsets(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcInteger(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), new IFC4_3.IfcLengthMeasure(v[6].value)),
  1507914824: (id, _) => new IFC4_3.IfcMaterialUsageDefinition(id),
  2597039031: (id, v) => new IFC4_3.IfcMeasureWithUnit(id, TypeInitialiser(2, v[0]), new Handle(v[1].value)),
  3368373690: (id, v) => new IFC4_3.IfcMetric(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2], !v[3] ? null : new IFC4_3.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new IFC4_3.IfcDateTime(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), v[7], !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value)),
  2706619895: (id, v) => new IFC4_3.IfcMonetaryUnit(id, new IFC4_3.IfcLabel(v[0].value)),
  1918398963: (id, v) => new IFC4_3.IfcNamedUnit(id, new Handle(v[0].value), v[1]),
  3701648758: (id, v) => new IFC4_3.IfcObjectPlacement(id, !v[0] ? null : new Handle(v[0].value)),
  2251480897: (id, v) => new IFC4_3.IfcObjective(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2], !v[3] ? null : new IFC4_3.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new IFC4_3.IfcDateTime(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), v[8], v[9], !v[10] ? null : new IFC4_3.IfcLabel(v[10].value)),
  4251960020: (id, v) => new IFC4_3.IfcOrganization(id, !v[0] ? null : new IFC4_3.IfcIdentifier(v[0].value), new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcText(v[2].value), !v[3] ? null : v[3].map((p) => new Handle(p.value)), !v[4] ? null : v[4].map((p) => new Handle(p.value))),
  1207048766: (id, v) => new IFC4_3.IfcOwnerHistory(id, new Handle(v[0].value), new Handle(v[1].value), v[2], v[3], !v[4] ? null : new IFC4_3.IfcTimeStamp(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new IFC4_3.IfcTimeStamp(v[7].value)),
  2077209135: (id, v) => new IFC4_3.IfcPerson(id, !v[0] ? null : new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : v[3].map((p) => new IFC4_3.IfcLabel(p.value)), !v[4] ? null : v[4].map((p) => new IFC4_3.IfcLabel(p.value)), !v[5] ? null : v[5].map((p) => new IFC4_3.IfcLabel(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : v[7].map((p) => new Handle(p.value))),
  101040310: (id, v) => new IFC4_3.IfcPersonAndOrganization(id, new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : v[2].map((p) => new Handle(p.value))),
  2483315170: (id, v) => new IFC4_3.IfcPhysicalQuantity(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value)),
  2226359599: (id, v) => new IFC4_3.IfcPhysicalSimpleQuantity(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value)),
  3355820592: (id, v) => new IFC4_3.IfcPostalAddress(id, v[0], !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcLabel(v[3].value), !v[4] ? null : v[4].map((p) => new IFC4_3.IfcLabel(p.value)), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : new IFC4_3.IfcLabel(v[9].value)),
  677532197: (id, _) => new IFC4_3.IfcPresentationItem(id),
  2022622350: (id, v) => new IFC4_3.IfcPresentationLayerAssignment(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), !v[3] ? null : new IFC4_3.IfcIdentifier(v[3].value)),
  1304840413: (id, v) => new IFC4_3.IfcPresentationLayerWithStyle(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), !v[3] ? null : new IFC4_3.IfcIdentifier(v[3].value), new IFC4_3.IfcLogical(v[4].value), new IFC4_3.IfcLogical(v[5].value), new IFC4_3.IfcLogical(v[6].value), v[7].map((p) => new Handle(p.value))),
  3119450353: (id, v) => new IFC4_3.IfcPresentationStyle(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value)),
  2095639259: (id, v) => new IFC4_3.IfcProductRepresentation(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map((p) => new Handle(p.value))),
  3958567839: (id, v) => new IFC4_3.IfcProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value)),
  3843373140: (id, v) => new IFC4_3.IfcProjectedCRS(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new IFC4_3.IfcIdentifier(v[2].value), !v[3] ? null : new IFC4_3.IfcIdentifier(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  986844984: (id, _) => new IFC4_3.IfcPropertyAbstraction(id),
  3710013099: (id, v) => new IFC4_3.IfcPropertyEnumeration(id, new IFC4_3.IfcLabel(v[0].value), v[1].map((p) => TypeInitialiser(2, p)), !v[2] ? null : new Handle(v[2].value)),
  2044713172: (id, v) => new IFC4_3.IfcQuantityArea(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcAreaMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value)),
  2093928680: (id, v) => new IFC4_3.IfcQuantityCount(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcCountMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value)),
  931644368: (id, v) => new IFC4_3.IfcQuantityLength(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value)),
  2691318326: (id, v) => new IFC4_3.IfcQuantityNumber(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcNumericMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value)),
  3252649465: (id, v) => new IFC4_3.IfcQuantityTime(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcTimeMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value)),
  2405470396: (id, v) => new IFC4_3.IfcQuantityVolume(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcVolumeMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value)),
  825690147: (id, v) => new IFC4_3.IfcQuantityWeight(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcMassMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value)),
  3915482550: (id, v) => new IFC4_3.IfcRecurrencePattern(id, v[0], !v[1] ? null : v[1].map((p) => new IFC4_3.IfcDayInMonthNumber(p.value)), !v[2] ? null : v[2].map((p) => new IFC4_3.IfcDayInWeekNumber(p.value)), !v[3] ? null : v[3].map((p) => new IFC4_3.IfcMonthInYearNumber(p.value)), !v[4] ? null : new IFC4_3.IfcInteger(v[4].value), !v[5] ? null : new IFC4_3.IfcInteger(v[5].value), !v[6] ? null : new IFC4_3.IfcInteger(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value))),
  2433181523: (id, v) => new IFC4_3.IfcReference(id, !v[0] ? null : new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : v[3].map((p) => new IFC4_3.IfcInteger(p.value)), !v[4] ? null : new Handle(v[4].value)),
  1076942058: (id, v) => new IFC4_3.IfcRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  3377609919: (id, v) => new IFC4_3.IfcRepresentationContext(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value)),
  3008791417: (id, _) => new IFC4_3.IfcRepresentationItem(id),
  1660063152: (id, v) => new IFC4_3.IfcRepresentationMap(id, new Handle(v[0].value), new Handle(v[1].value)),
  2439245199: (id, v) => new IFC4_3.IfcResourceLevelRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value)),
  2341007311: (id, v) => new IFC4_3.IfcRoot(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value)),
  448429030: (id, v) => new IFC4_3.IfcSIUnit(id, new Handle(v[0].value), v[1], v[2], v[3]),
  1054537805: (id, v) => new IFC4_3.IfcSchedulingTime(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4_3.IfcLabel(v[2].value)),
  867548509: (id, v) => new IFC4_3.IfcShapeAspect(id, v[0].map((p) => new Handle(p.value)), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcText(v[2].value), new IFC4_3.IfcLogical(v[3].value), !v[4] ? null : new Handle(v[4].value)),
  3982875396: (id, v) => new IFC4_3.IfcShapeModel(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  4240577450: (id, v) => new IFC4_3.IfcShapeRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  2273995522: (id, v) => new IFC4_3.IfcStructuralConnectionCondition(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value)),
  2162789131: (id, v) => new IFC4_3.IfcStructuralLoad(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value)),
  3478079324: (id, v) => new IFC4_3.IfcStructuralLoadConfiguration(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : v[2].map((p) => new IFC4_3.IfcLengthMeasure(p.value))),
  609421318: (id, v) => new IFC4_3.IfcStructuralLoadOrResult(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value)),
  2525727697: (id, v) => new IFC4_3.IfcStructuralLoadStatic(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value)),
  3408363356: (id, v) => new IFC4_3.IfcStructuralLoadTemperature(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcThermodynamicTemperatureMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcThermodynamicTemperatureMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcThermodynamicTemperatureMeasure(v[3].value)),
  2830218821: (id, v) => new IFC4_3.IfcStyleModel(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  3958052878: (id, v) => new IFC4_3.IfcStyledItem(id, !v[0] ? null : new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value)),
  3049322572: (id, v) => new IFC4_3.IfcStyledRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  2934153892: (id, v) => new IFC4_3.IfcSurfaceReinforcementArea(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : v[1].map((p) => new IFC4_3.IfcLengthMeasure(p.value)), !v[2] ? null : v[2].map((p) => new IFC4_3.IfcLengthMeasure(p.value)), !v[3] ? null : new IFC4_3.IfcRatioMeasure(v[3].value)),
  1300840506: (id, v) => new IFC4_3.IfcSurfaceStyle(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1], v[2].map((p) => new Handle(p.value))),
  3303107099: (id, v) => new IFC4_3.IfcSurfaceStyleLighting(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new Handle(v[3].value)),
  1607154358: (id, v) => new IFC4_3.IfcSurfaceStyleRefraction(id, !v[0] ? null : new IFC4_3.IfcReal(v[0].value), !v[1] ? null : new IFC4_3.IfcReal(v[1].value)),
  846575682: (id, v) => new IFC4_3.IfcSurfaceStyleShading(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[1].value)),
  1351298697: (id, v) => new IFC4_3.IfcSurfaceStyleWithTextures(id, v[0].map((p) => new Handle(p.value))),
  626085974: (id, v) => new IFC4_3.IfcSurfaceTexture(id, new IFC4_3.IfcBoolean(v[0].value), new IFC4_3.IfcBoolean(v[1].value), !v[2] ? null : new IFC4_3.IfcIdentifier(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map((p) => new IFC4_3.IfcIdentifier(p.value))),
  985171141: (id, v) => new IFC4_3.IfcTable(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : v[1].map((p) => new Handle(p.value)), !v[2] ? null : v[2].map((p) => new Handle(p.value))),
  2043862942: (id, v) => new IFC4_3.IfcTableColumn(id, !v[0] ? null : new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcText(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value)),
  531007025: (id, v) => new IFC4_3.IfcTableRow(id, !v[0] ? null : v[0].map((p) => TypeInitialiser(2, p)), !v[1] ? null : new IFC4_3.IfcBoolean(v[1].value)),
  1549132990: (id, v) => new IFC4_3.IfcTaskTime(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), v[3], !v[4] ? null : new IFC4_3.IfcDuration(v[4].value), !v[5] ? null : new IFC4_3.IfcDateTime(v[5].value), !v[6] ? null : new IFC4_3.IfcDateTime(v[6].value), !v[7] ? null : new IFC4_3.IfcDateTime(v[7].value), !v[8] ? null : new IFC4_3.IfcDateTime(v[8].value), !v[9] ? null : new IFC4_3.IfcDateTime(v[9].value), !v[10] ? null : new IFC4_3.IfcDateTime(v[10].value), !v[11] ? null : new IFC4_3.IfcDuration(v[11].value), !v[12] ? null : new IFC4_3.IfcDuration(v[12].value), !v[13] ? null : new IFC4_3.IfcBoolean(v[13].value), !v[14] ? null : new IFC4_3.IfcDateTime(v[14].value), !v[15] ? null : new IFC4_3.IfcDuration(v[15].value), !v[16] ? null : new IFC4_3.IfcDateTime(v[16].value), !v[17] ? null : new IFC4_3.IfcDateTime(v[17].value), !v[18] ? null : new IFC4_3.IfcDuration(v[18].value), !v[19] ? null : new IFC4_3.IfcPositiveRatioMeasure(v[19].value)),
  2771591690: (id, v) => new IFC4_3.IfcTaskTimeRecurring(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), v[3], !v[4] ? null : new IFC4_3.IfcDuration(v[4].value), !v[5] ? null : new IFC4_3.IfcDateTime(v[5].value), !v[6] ? null : new IFC4_3.IfcDateTime(v[6].value), !v[7] ? null : new IFC4_3.IfcDateTime(v[7].value), !v[8] ? null : new IFC4_3.IfcDateTime(v[8].value), !v[9] ? null : new IFC4_3.IfcDateTime(v[9].value), !v[10] ? null : new IFC4_3.IfcDateTime(v[10].value), !v[11] ? null : new IFC4_3.IfcDuration(v[11].value), !v[12] ? null : new IFC4_3.IfcDuration(v[12].value), !v[13] ? null : new IFC4_3.IfcBoolean(v[13].value), !v[14] ? null : new IFC4_3.IfcDateTime(v[14].value), !v[15] ? null : new IFC4_3.IfcDuration(v[15].value), !v[16] ? null : new IFC4_3.IfcDateTime(v[16].value), !v[17] ? null : new IFC4_3.IfcDateTime(v[17].value), !v[18] ? null : new IFC4_3.IfcDuration(v[18].value), !v[19] ? null : new IFC4_3.IfcPositiveRatioMeasure(v[19].value), new Handle(v[20].value)),
  912023232: (id, v) => new IFC4_3.IfcTelecomAddress(id, v[0], !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : v[3].map((p) => new IFC4_3.IfcLabel(p.value)), !v[4] ? null : v[4].map((p) => new IFC4_3.IfcLabel(p.value)), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : v[6].map((p) => new IFC4_3.IfcLabel(p.value)), !v[7] ? null : new IFC4_3.IfcURIReference(v[7].value), !v[8] ? null : v[8].map((p) => new IFC4_3.IfcURIReference(p.value))),
  1447204868: (id, v) => new IFC4_3.IfcTextStyle(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcBoolean(v[4].value)),
  2636378356: (id, v) => new IFC4_3.IfcTextStyleForDefinedFont(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  1640371178: (id, v) => new IFC4_3.IfcTextStyleTextModel(id, !v[0] ? null : TypeInitialiser(2, v[0]), !v[1] ? null : new IFC4_3.IfcTextAlignment(v[1].value), !v[2] ? null : new IFC4_3.IfcTextDecoration(v[2].value), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : TypeInitialiser(2, v[4]), !v[5] ? null : new IFC4_3.IfcTextTransformation(v[5].value), !v[6] ? null : TypeInitialiser(2, v[6])),
  280115917: (id, v) => new IFC4_3.IfcTextureCoordinate(id, v[0].map((p) => new Handle(p.value))),
  1742049831: (id, v) => new IFC4_3.IfcTextureCoordinateGenerator(id, v[0].map((p) => new Handle(p.value)), new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : v[2].map((p) => new IFC4_3.IfcReal(p.value))),
  222769930: (id, v) => new IFC4_3.IfcTextureCoordinateIndices(id, v[0].map((p) => new IFC4_3.IfcPositiveInteger(p.value)), new Handle(v[1].value)),
  1010789467: (id, v) => new IFC4_3.IfcTextureCoordinateIndicesWithVoids(id, v[0].map((p) => new IFC4_3.IfcPositiveInteger(p.value)), new Handle(v[1].value), v[2].map((p) => new IFC4_3.IfcPositiveInteger(p.value))),
  2552916305: (id, v) => new IFC4_3.IfcTextureMap(id, v[0].map((p) => new Handle(p.value)), v[1].map((p) => new Handle(p.value)), new Handle(v[2].value)),
  1210645708: (id, v) => new IFC4_3.IfcTextureVertex(id, v[0].map((p) => new IFC4_3.IfcParameterValue(p.value))),
  3611470254: (id, v) => new IFC4_3.IfcTextureVertexList(id, v[0].map((p) => new IFC4_3.IfcParameterValue(p.value))),
  1199560280: (id, v) => new IFC4_3.IfcTimePeriod(id, new IFC4_3.IfcTime(v[0].value), new IFC4_3.IfcTime(v[1].value)),
  3101149627: (id, v) => new IFC4_3.IfcTimeSeries(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new IFC4_3.IfcDateTime(v[2].value), new IFC4_3.IfcDateTime(v[3].value), v[4], v[5], !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  581633288: (id, v) => new IFC4_3.IfcTimeSeriesValue(id, v[0].map((p) => TypeInitialiser(2, p))),
  1377556343: (id, _) => new IFC4_3.IfcTopologicalRepresentationItem(id),
  1735638870: (id, v) => new IFC4_3.IfcTopologyRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  180925521: (id, v) => new IFC4_3.IfcUnitAssignment(id, v[0].map((p) => new Handle(p.value))),
  2799835756: (id, _) => new IFC4_3.IfcVertex(id),
  1907098498: (id, v) => new IFC4_3.IfcVertexPoint(id, new Handle(v[0].value)),
  891718957: (id, v) => new IFC4_3.IfcVirtualGridIntersection(id, v[0].map((p) => new Handle(p.value)), v[1].map((p) => new IFC4_3.IfcLengthMeasure(p.value))),
  1236880293: (id, v) => new IFC4_3.IfcWorkTime(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcDate(v[4].value), !v[5] ? null : new IFC4_3.IfcDate(v[5].value)),
  3752311538: (id, v) => new IFC4_3.IfcAlignmentCantSegment(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new IFC4_3.IfcLengthMeasure(v[2].value), new IFC4_3.IfcNonNegativeLengthMeasure(v[3].value), new IFC4_3.IfcLengthMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcLengthMeasure(v[5].value), new IFC4_3.IfcLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcLengthMeasure(v[7].value), v[8]),
  536804194: (id, v) => new IFC4_3.IfcAlignmentHorizontalSegment(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC4_3.IfcPlaneAngleMeasure(v[3].value), new IFC4_3.IfcLengthMeasure(v[4].value), new IFC4_3.IfcLengthMeasure(v[5].value), new IFC4_3.IfcNonNegativeLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[7].value), v[8]),
  3869604511: (id, v) => new IFC4_3.IfcApprovalRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value))),
  3798115385: (id, v) => new IFC4_3.IfcArbitraryClosedProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new Handle(v[2].value)),
  1310608509: (id, v) => new IFC4_3.IfcArbitraryOpenProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new Handle(v[2].value)),
  2705031697: (id, v) => new IFC4_3.IfcArbitraryProfileDefWithVoids(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value))),
  616511568: (id, v) => new IFC4_3.IfcBlobTexture(id, new IFC4_3.IfcBoolean(v[0].value), new IFC4_3.IfcBoolean(v[1].value), !v[2] ? null : new IFC4_3.IfcIdentifier(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map((p) => new IFC4_3.IfcIdentifier(p.value)), new IFC4_3.IfcIdentifier(v[5].value), new IFC4_3.IfcBinary(v[6].value)),
  3150382593: (id, v) => new IFC4_3.IfcCenterLineProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value)),
  747523909: (id, v) => new IFC4_3.IfcClassification(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcDate(v[2].value), new IFC4_3.IfcLabel(v[3].value), !v[4] ? null : new IFC4_3.IfcText(v[4].value), !v[5] ? null : new IFC4_3.IfcURIReference(v[5].value), !v[6] ? null : v[6].map((p) => new IFC4_3.IfcIdentifier(p.value))),
  647927063: (id, v) => new IFC4_3.IfcClassificationReference(id, !v[0] ? null : new IFC4_3.IfcURIReference(v[0].value), !v[1] ? null : new IFC4_3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcText(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value)),
  3285139300: (id, v) => new IFC4_3.IfcColourRgbList(id, v[0].map((p) => new IFC4_3.IfcNormalisedRatioMeasure(p.value))),
  3264961684: (id, v) => new IFC4_3.IfcColourSpecification(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value)),
  1485152156: (id, v) => new IFC4_3.IfcCompositeProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), v[2].map((p) => new Handle(p.value)), !v[3] ? null : new IFC4_3.IfcLabel(v[3].value)),
  370225590: (id, v) => new IFC4_3.IfcConnectedFaceSet(id, v[0].map((p) => new Handle(p.value))),
  1981873012: (id, v) => new IFC4_3.IfcConnectionCurveGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  45288368: (id, v) => new IFC4_3.IfcConnectionPointEccentricity(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLengthMeasure(v[4].value)),
  3050246964: (id, v) => new IFC4_3.IfcContextDependentUnit(id, new Handle(v[0].value), v[1], new IFC4_3.IfcLabel(v[2].value)),
  2889183280: (id, v) => new IFC4_3.IfcConversionBasedUnit(id, new Handle(v[0].value), v[1], new IFC4_3.IfcLabel(v[2].value), new Handle(v[3].value)),
  2713554722: (id, v) => new IFC4_3.IfcConversionBasedUnitWithOffset(id, new Handle(v[0].value), v[1], new IFC4_3.IfcLabel(v[2].value), new Handle(v[3].value), new IFC4_3.IfcReal(v[4].value)),
  539742890: (id, v) => new IFC4_3.IfcCurrencyRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value), new IFC4_3.IfcPositiveRatioMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcDateTime(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  3800577675: (id, v) => new IFC4_3.IfcCurveStyle(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : TypeInitialiser(2, v[2]), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcBoolean(v[4].value)),
  1105321065: (id, v) => new IFC4_3.IfcCurveStyleFont(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1].map((p) => new Handle(p.value))),
  2367409068: (id, v) => new IFC4_3.IfcCurveStyleFontAndScaling(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new Handle(v[1].value), new IFC4_3.IfcPositiveRatioMeasure(v[2].value)),
  3510044353: (id, v) => new IFC4_3.IfcCurveStyleFontPattern(id, new IFC4_3.IfcLengthMeasure(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value)),
  3632507154: (id, v) => new IFC4_3.IfcDerivedProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value)),
  1154170062: (id, v) => new IFC4_3.IfcDocumentInformation(id, new IFC4_3.IfcIdentifier(v[0].value), new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcText(v[2].value), !v[3] ? null : new IFC4_3.IfcURIReference(v[3].value), !v[4] ? null : new IFC4_3.IfcText(v[4].value), !v[5] ? null : new IFC4_3.IfcText(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new Handle(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new IFC4_3.IfcDateTime(v[10].value), !v[11] ? null : new IFC4_3.IfcDateTime(v[11].value), !v[12] ? null : new IFC4_3.IfcIdentifier(v[12].value), !v[13] ? null : new IFC4_3.IfcDate(v[13].value), !v[14] ? null : new IFC4_3.IfcDate(v[14].value), v[15], v[16]),
  770865208: (id, v) => new IFC4_3.IfcDocumentInformationRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value)), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value)),
  3732053477: (id, v) => new IFC4_3.IfcDocumentReference(id, !v[0] ? null : new IFC4_3.IfcURIReference(v[0].value), !v[1] ? null : new IFC4_3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value)),
  3900360178: (id, v) => new IFC4_3.IfcEdge(id, new Handle(v[0].value), new Handle(v[1].value)),
  476780140: (id, v) => new IFC4_3.IfcEdgeCurve(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new IFC4_3.IfcBoolean(v[3].value)),
  211053100: (id, v) => new IFC4_3.IfcEventTime(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcDateTime(v[3].value), !v[4] ? null : new IFC4_3.IfcDateTime(v[4].value), !v[5] ? null : new IFC4_3.IfcDateTime(v[5].value), !v[6] ? null : new IFC4_3.IfcDateTime(v[6].value)),
  297599258: (id, v) => new IFC4_3.IfcExtendedProperties(id, !v[0] ? null : new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map((p) => new Handle(p.value))),
  1437805879: (id, v) => new IFC4_3.IfcExternalReferenceRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value))),
  2556980723: (id, v) => new IFC4_3.IfcFace(id, v[0].map((p) => new Handle(p.value))),
  1809719519: (id, v) => new IFC4_3.IfcFaceBound(id, new Handle(v[0].value), new IFC4_3.IfcBoolean(v[1].value)),
  803316827: (id, v) => new IFC4_3.IfcFaceOuterBound(id, new Handle(v[0].value), new IFC4_3.IfcBoolean(v[1].value)),
  3008276851: (id, v) => new IFC4_3.IfcFaceSurface(id, v[0].map((p) => new Handle(p.value)), new Handle(v[1].value), new IFC4_3.IfcBoolean(v[2].value)),
  4219587988: (id, v) => new IFC4_3.IfcFailureConnectionCondition(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcForceMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcForceMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcForceMeasure(v[6].value)),
  738692330: (id, v) => new IFC4_3.IfcFillAreaStyle(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC4_3.IfcBoolean(v[2].value)),
  3448662350: (id, v) => new IFC4_3.IfcGeometricRepresentationContext(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new IFC4_3.IfcDimensionCount(v[2].value), !v[3] ? null : new IFC4_3.IfcReal(v[3].value), new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value)),
  2453401579: (id, _) => new IFC4_3.IfcGeometricRepresentationItem(id),
  4142052618: (id, v) => new IFC4_3.IfcGeometricRepresentationSubContext(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcPositiveRatioMeasure(v[4].value), v[5], !v[6] ? null : new IFC4_3.IfcLabel(v[6].value)),
  3590301190: (id, v) => new IFC4_3.IfcGeometricSet(id, v[0].map((p) => new Handle(p.value))),
  178086475: (id, v) => new IFC4_3.IfcGridPlacement(id, !v[0] ? null : new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value)),
  812098782: (id, v) => new IFC4_3.IfcHalfSpaceSolid(id, new Handle(v[0].value), new IFC4_3.IfcBoolean(v[1].value)),
  3905492369: (id, v) => new IFC4_3.IfcImageTexture(id, new IFC4_3.IfcBoolean(v[0].value), new IFC4_3.IfcBoolean(v[1].value), !v[2] ? null : new IFC4_3.IfcIdentifier(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map((p) => new IFC4_3.IfcIdentifier(p.value)), new IFC4_3.IfcURIReference(v[5].value)),
  3570813810: (id, v) => new IFC4_3.IfcIndexedColourMap(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[1].value), new Handle(v[2].value), v[3].map((p) => new IFC4_3.IfcPositiveInteger(p.value))),
  1437953363: (id, v) => new IFC4_3.IfcIndexedTextureMap(id, v[0].map((p) => new Handle(p.value)), new Handle(v[1].value), new Handle(v[2].value)),
  2133299955: (id, v) => new IFC4_3.IfcIndexedTriangleTextureMap(id, v[0].map((p) => new Handle(p.value)), new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : v[3].map((p) => new IFC4_3.IfcPositiveInteger(p.value))),
  3741457305: (id, v) => new IFC4_3.IfcIrregularTimeSeries(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new IFC4_3.IfcDateTime(v[2].value), new IFC4_3.IfcDateTime(v[3].value), v[4], v[5], !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), v[8].map((p) => new Handle(p.value))),
  1585845231: (id, v) => new IFC4_3.IfcLagTime(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), TypeInitialiser(2, v[3]), v[4]),
  1402838566: (id, v) => new IFC4_3.IfcLightSource(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[3].value)),
  125510826: (id, v) => new IFC4_3.IfcLightSourceAmbient(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[3].value)),
  2604431987: (id, v) => new IFC4_3.IfcLightSourceDirectional(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value)),
  4266656042: (id, v) => new IFC4_3.IfcLightSourceGoniometric(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), new IFC4_3.IfcThermodynamicTemperatureMeasure(v[6].value), new IFC4_3.IfcLuminousFluxMeasure(v[7].value), v[8], new Handle(v[9].value)),
  1520743889: (id, v) => new IFC4_3.IfcLightSourcePositional(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcReal(v[6].value), new IFC4_3.IfcReal(v[7].value), new IFC4_3.IfcReal(v[8].value)),
  3422422726: (id, v) => new IFC4_3.IfcLightSourceSpot(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcReal(v[6].value), new IFC4_3.IfcReal(v[7].value), new IFC4_3.IfcReal(v[8].value), new Handle(v[9].value), !v[10] ? null : new IFC4_3.IfcReal(v[10].value), new IFC4_3.IfcPositivePlaneAngleMeasure(v[11].value), new IFC4_3.IfcPositivePlaneAngleMeasure(v[12].value)),
  388784114: (id, v) => new IFC4_3.IfcLinearPlacement(id, !v[0] ? null : new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value)),
  2624227202: (id, v) => new IFC4_3.IfcLocalPlacement(id, !v[0] ? null : new Handle(v[0].value), new Handle(v[1].value)),
  1008929658: (id, _) => new IFC4_3.IfcLoop(id),
  2347385850: (id, v) => new IFC4_3.IfcMappedItem(id, new Handle(v[0].value), new Handle(v[1].value)),
  1838606355: (id, v) => new IFC4_3.IfcMaterial(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value)),
  3708119e3: (id, v) => new IFC4_3.IfcMaterialConstituent(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value)),
  2852063980: (id, v) => new IFC4_3.IfcMaterialConstituentSet(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : v[2].map((p) => new Handle(p.value))),
  2022407955: (id, v) => new IFC4_3.IfcMaterialDefinitionRepresentation(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), new Handle(v[3].value)),
  1303795690: (id, v) => new IFC4_3.IfcMaterialLayerSetUsage(id, new Handle(v[0].value), v[1], v[2], new IFC4_3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[4].value)),
  3079605661: (id, v) => new IFC4_3.IfcMaterialProfileSetUsage(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcCardinalPointReference(v[1].value), !v[2] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[2].value)),
  3404854881: (id, v) => new IFC4_3.IfcMaterialProfileSetUsageTapering(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcCardinalPointReference(v[1].value), !v[2] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcCardinalPointReference(v[4].value)),
  3265635763: (id, v) => new IFC4_3.IfcMaterialProperties(id, !v[0] ? null : new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), new Handle(v[3].value)),
  853536259: (id, v) => new IFC4_3.IfcMaterialRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value)), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value)),
  2998442950: (id, v) => new IFC4_3.IfcMirroredProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value)),
  219451334: (id, v) => new IFC4_3.IfcObjectDefinition(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value)),
  182550632: (id, v) => new IFC4_3.IfcOpenCrossProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new IFC4_3.IfcBoolean(v[2].value), v[3].map((p) => new IFC4_3.IfcNonNegativeLengthMeasure(p.value)), v[4].map((p) => new IFC4_3.IfcPlaneAngleMeasure(p.value)), !v[5] ? null : v[5].map((p) => new IFC4_3.IfcLabel(p.value)), !v[6] ? null : new Handle(v[6].value)),
  2665983363: (id, v) => new IFC4_3.IfcOpenShell(id, v[0].map((p) => new Handle(p.value))),
  1411181986: (id, v) => new IFC4_3.IfcOrganizationRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value))),
  1029017970: (id, v) => new IFC4_3.IfcOrientedEdge(id, new Handle(v[0].value), new Handle(v[1].value), new IFC4_3.IfcBoolean(v[2].value)),
  2529465313: (id, v) => new IFC4_3.IfcParameterizedProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value)),
  2519244187: (id, v) => new IFC4_3.IfcPath(id, v[0].map((p) => new Handle(p.value))),
  3021840470: (id, v) => new IFC4_3.IfcPhysicalComplexQuantity(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), new IFC4_3.IfcLabel(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value)),
  597895409: (id, v) => new IFC4_3.IfcPixelTexture(id, new IFC4_3.IfcBoolean(v[0].value), new IFC4_3.IfcBoolean(v[1].value), !v[2] ? null : new IFC4_3.IfcIdentifier(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map((p) => new IFC4_3.IfcIdentifier(p.value)), new IFC4_3.IfcInteger(v[5].value), new IFC4_3.IfcInteger(v[6].value), new IFC4_3.IfcInteger(v[7].value), v[8].map((p) => new IFC4_3.IfcBinary(p.value))),
  2004835150: (id, v) => new IFC4_3.IfcPlacement(id, new Handle(v[0].value)),
  1663979128: (id, v) => new IFC4_3.IfcPlanarExtent(id, new IFC4_3.IfcLengthMeasure(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value)),
  2067069095: (id, _) => new IFC4_3.IfcPoint(id),
  2165702409: (id, v) => new IFC4_3.IfcPointByDistanceExpression(id, TypeInitialiser(2, v[0]), !v[1] ? null : new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value), new Handle(v[4].value)),
  4022376103: (id, v) => new IFC4_3.IfcPointOnCurve(id, new Handle(v[0].value), new IFC4_3.IfcParameterValue(v[1].value)),
  1423911732: (id, v) => new IFC4_3.IfcPointOnSurface(id, new Handle(v[0].value), new IFC4_3.IfcParameterValue(v[1].value), new IFC4_3.IfcParameterValue(v[2].value)),
  2924175390: (id, v) => new IFC4_3.IfcPolyLoop(id, v[0].map((p) => new Handle(p.value))),
  2775532180: (id, v) => new IFC4_3.IfcPolygonalBoundedHalfSpace(id, new Handle(v[0].value), new IFC4_3.IfcBoolean(v[1].value), new Handle(v[2].value), new Handle(v[3].value)),
  3727388367: (id, v) => new IFC4_3.IfcPreDefinedItem(id, new IFC4_3.IfcLabel(v[0].value)),
  3778827333: (id, _) => new IFC4_3.IfcPreDefinedProperties(id),
  1775413392: (id, v) => new IFC4_3.IfcPreDefinedTextFont(id, new IFC4_3.IfcLabel(v[0].value)),
  673634403: (id, v) => new IFC4_3.IfcProductDefinitionShape(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map((p) => new Handle(p.value))),
  2802850158: (id, v) => new IFC4_3.IfcProfileProperties(id, !v[0] ? null : new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), new Handle(v[3].value)),
  2598011224: (id, v) => new IFC4_3.IfcProperty(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value)),
  1680319473: (id, v) => new IFC4_3.IfcPropertyDefinition(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value)),
  148025276: (id, v) => new IFC4_3.IfcPropertyDependencyRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcText(v[4].value)),
  3357820518: (id, v) => new IFC4_3.IfcPropertySetDefinition(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value)),
  1482703590: (id, v) => new IFC4_3.IfcPropertyTemplateDefinition(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value)),
  2090586900: (id, v) => new IFC4_3.IfcQuantitySet(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value)),
  3615266464: (id, v) => new IFC4_3.IfcRectangleProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value)),
  3413951693: (id, v) => new IFC4_3.IfcRegularTimeSeries(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new IFC4_3.IfcDateTime(v[2].value), new IFC4_3.IfcDateTime(v[3].value), v[4], v[5], !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), new IFC4_3.IfcTimeMeasure(v[8].value), v[9].map((p) => new Handle(p.value))),
  1580146022: (id, v) => new IFC4_3.IfcReinforcementBarProperties(id, new IFC4_3.IfcAreaMeasure(v[0].value), new IFC4_3.IfcLabel(v[1].value), v[2], !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcCountMeasure(v[5].value)),
  478536968: (id, v) => new IFC4_3.IfcRelationship(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value)),
  2943643501: (id, v) => new IFC4_3.IfcResourceApprovalRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), new Handle(v[3].value)),
  1608871552: (id, v) => new IFC4_3.IfcResourceConstraintRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value))),
  1042787934: (id, v) => new IFC4_3.IfcResourceTime(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcDuration(v[3].value), !v[4] ? null : new IFC4_3.IfcPositiveRatioMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcDateTime(v[5].value), !v[6] ? null : new IFC4_3.IfcDateTime(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcDuration(v[8].value), !v[9] ? null : new IFC4_3.IfcBoolean(v[9].value), !v[10] ? null : new IFC4_3.IfcDateTime(v[10].value), !v[11] ? null : new IFC4_3.IfcDuration(v[11].value), !v[12] ? null : new IFC4_3.IfcPositiveRatioMeasure(v[12].value), !v[13] ? null : new IFC4_3.IfcDateTime(v[13].value), !v[14] ? null : new IFC4_3.IfcDateTime(v[14].value), !v[15] ? null : new IFC4_3.IfcDuration(v[15].value), !v[16] ? null : new IFC4_3.IfcPositiveRatioMeasure(v[16].value), !v[17] ? null : new IFC4_3.IfcPositiveRatioMeasure(v[17].value)),
  2778083089: (id, v) => new IFC4_3.IfcRoundedRectangleProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value)),
  2042790032: (id, v) => new IFC4_3.IfcSectionProperties(id, v[0], new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value)),
  4165799628: (id, v) => new IFC4_3.IfcSectionReinforcementProperties(id, new IFC4_3.IfcLengthMeasure(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), v[3], new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  1509187699: (id, v) => new IFC4_3.IfcSectionedSpine(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), v[2].map((p) => new Handle(p.value))),
  823603102: (id, v) => new IFC4_3.IfcSegment(id, v[0]),
  4124623270: (id, v) => new IFC4_3.IfcShellBasedSurfaceModel(id, v[0].map((p) => new Handle(p.value))),
  3692461612: (id, v) => new IFC4_3.IfcSimpleProperty(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value)),
  2609359061: (id, v) => new IFC4_3.IfcSlippageConnectionCondition(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value)),
  723233188: (id, _) => new IFC4_3.IfcSolidModel(id),
  1595516126: (id, v) => new IFC4_3.IfcStructuralLoadLinearForce(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLinearForceMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLinearForceMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLinearForceMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLinearMomentMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcLinearMomentMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcLinearMomentMeasure(v[6].value)),
  2668620305: (id, v) => new IFC4_3.IfcStructuralLoadPlanarForce(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcPlanarForceMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcPlanarForceMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcPlanarForceMeasure(v[3].value)),
  2473145415: (id, v) => new IFC4_3.IfcStructuralLoadSingleDisplacement(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[6].value)),
  1973038258: (id, v) => new IFC4_3.IfcStructuralLoadSingleDisplacementDistortion(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcCurvatureMeasure(v[7].value)),
  1597423693: (id, v) => new IFC4_3.IfcStructuralLoadSingleForce(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcTorqueMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcTorqueMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcTorqueMeasure(v[6].value)),
  1190533807: (id, v) => new IFC4_3.IfcStructuralLoadSingleForceWarping(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcTorqueMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcTorqueMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcTorqueMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcWarpingMomentMeasure(v[7].value)),
  2233826070: (id, v) => new IFC4_3.IfcSubedge(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value)),
  2513912981: (id, _) => new IFC4_3.IfcSurface(id),
  1878645084: (id, v) => new IFC4_3.IfcSurfaceStyleRendering(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : TypeInitialiser(2, v[7]), v[8]),
  2247615214: (id, v) => new IFC4_3.IfcSweptAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  1260650574: (id, v) => new IFC4_3.IfcSweptDiskSolid(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcParameterValue(v[3].value), !v[4] ? null : new IFC4_3.IfcParameterValue(v[4].value)),
  1096409881: (id, v) => new IFC4_3.IfcSweptDiskSolidPolygonal(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcParameterValue(v[3].value), !v[4] ? null : new IFC4_3.IfcParameterValue(v[4].value), !v[5] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[5].value)),
  230924584: (id, v) => new IFC4_3.IfcSweptSurface(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  3071757647: (id, v) => new IFC4_3.IfcTShapeProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[9].value), !v[10] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[11].value)),
  901063453: (id, _) => new IFC4_3.IfcTessellatedItem(id),
  4282788508: (id, v) => new IFC4_3.IfcTextLiteral(id, new IFC4_3.IfcPresentableText(v[0].value), new Handle(v[1].value), v[2]),
  3124975700: (id, v) => new IFC4_3.IfcTextLiteralWithExtent(id, new IFC4_3.IfcPresentableText(v[0].value), new Handle(v[1].value), v[2], new Handle(v[3].value), new IFC4_3.IfcBoxAlignment(v[4].value)),
  1983826977: (id, v) => new IFC4_3.IfcTextStyleFontModel(id, new IFC4_3.IfcLabel(v[0].value), v[1].map((p) => new IFC4_3.IfcTextFontName(p.value)), !v[2] ? null : new IFC4_3.IfcFontStyle(v[2].value), !v[3] ? null : new IFC4_3.IfcFontVariant(v[3].value), !v[4] ? null : new IFC4_3.IfcFontWeight(v[4].value), TypeInitialiser(2, v[5])),
  2715220739: (id, v) => new IFC4_3.IfcTrapeziumProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcLengthMeasure(v[6].value)),
  1628702193: (id, v) => new IFC4_3.IfcTypeObject(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value))),
  3736923433: (id, v) => new IFC4_3.IfcTypeProcess(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  2347495698: (id, v) => new IFC4_3.IfcTypeProduct(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value)),
  3698973494: (id, v) => new IFC4_3.IfcTypeResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  427810014: (id, v) => new IFC4_3.IfcUShapeProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[9].value)),
  1417489154: (id, v) => new IFC4_3.IfcVector(id, new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value)),
  2759199220: (id, v) => new IFC4_3.IfcVertexLoop(id, new Handle(v[0].value)),
  2543172580: (id, v) => new IFC4_3.IfcZShapeProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[8].value)),
  3406155212: (id, v) => new IFC4_3.IfcAdvancedFace(id, v[0].map((p) => new Handle(p.value)), new Handle(v[1].value), new IFC4_3.IfcBoolean(v[2].value)),
  669184980: (id, v) => new IFC4_3.IfcAnnotationFillArea(id, new Handle(v[0].value), !v[1] ? null : v[1].map((p) => new Handle(p.value))),
  3207858831: (id, v) => new IFC4_3.IfcAsymmetricIShapeProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value), new IFC4_3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[11].value), !v[12] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[12].value), !v[13] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[13].value), !v[14] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[14].value)),
  4261334040: (id, v) => new IFC4_3.IfcAxis1Placement(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  3125803723: (id, v) => new IFC4_3.IfcAxis2Placement2D(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  2740243338: (id, v) => new IFC4_3.IfcAxis2Placement3D(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value)),
  3425423356: (id, v) => new IFC4_3.IfcAxis2PlacementLinear(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value)),
  2736907675: (id, v) => new IFC4_3.IfcBooleanResult(id, v[0], new Handle(v[1].value), new Handle(v[2].value)),
  4182860854: (id, _) => new IFC4_3.IfcBoundedSurface(id),
  2581212453: (id, v) => new IFC4_3.IfcBoundingBox(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), new IFC4_3.IfcPositiveLengthMeasure(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value)),
  2713105998: (id, v) => new IFC4_3.IfcBoxedHalfSpace(id, new Handle(v[0].value), new IFC4_3.IfcBoolean(v[1].value), new Handle(v[2].value)),
  2898889636: (id, v) => new IFC4_3.IfcCShapeProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value)),
  1123145078: (id, v) => new IFC4_3.IfcCartesianPoint(id, v[0].map((p) => new IFC4_3.IfcLengthMeasure(p.value))),
  574549367: (id, _) => new IFC4_3.IfcCartesianPointList(id),
  1675464909: (id, v) => new IFC4_3.IfcCartesianPointList2D(id, v[0].map((p) => new IFC4_3.IfcLengthMeasure(p.value)), !v[1] ? null : v[1].map((p) => new IFC4_3.IfcLabel(p.value))),
  2059837836: (id, v) => new IFC4_3.IfcCartesianPointList3D(id, v[0].map((p) => new IFC4_3.IfcLengthMeasure(p.value)), !v[1] ? null : v[1].map((p) => new IFC4_3.IfcLabel(p.value))),
  59481748: (id, v) => new IFC4_3.IfcCartesianTransformationOperator(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4_3.IfcReal(v[3].value)),
  3749851601: (id, v) => new IFC4_3.IfcCartesianTransformationOperator2D(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4_3.IfcReal(v[3].value)),
  3486308946: (id, v) => new IFC4_3.IfcCartesianTransformationOperator2DnonUniform(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4_3.IfcReal(v[3].value), !v[4] ? null : new IFC4_3.IfcReal(v[4].value)),
  3331915920: (id, v) => new IFC4_3.IfcCartesianTransformationOperator3D(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4_3.IfcReal(v[3].value), !v[4] ? null : new Handle(v[4].value)),
  1416205885: (id, v) => new IFC4_3.IfcCartesianTransformationOperator3DnonUniform(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4_3.IfcReal(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new IFC4_3.IfcReal(v[5].value), !v[6] ? null : new IFC4_3.IfcReal(v[6].value)),
  1383045692: (id, v) => new IFC4_3.IfcCircleProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value)),
  2205249479: (id, v) => new IFC4_3.IfcClosedShell(id, v[0].map((p) => new Handle(p.value))),
  776857604: (id, v) => new IFC4_3.IfcColourRgb(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new IFC4_3.IfcNormalisedRatioMeasure(v[1].value), new IFC4_3.IfcNormalisedRatioMeasure(v[2].value), new IFC4_3.IfcNormalisedRatioMeasure(v[3].value)),
  2542286263: (id, v) => new IFC4_3.IfcComplexProperty(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new IFC4_3.IfcIdentifier(v[2].value), v[3].map((p) => new Handle(p.value))),
  2485617015: (id, v) => new IFC4_3.IfcCompositeCurveSegment(id, v[0], new IFC4_3.IfcBoolean(v[1].value), new Handle(v[2].value)),
  2574617495: (id, v) => new IFC4_3.IfcConstructionResourceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new Handle(v[10].value)),
  3419103109: (id, v) => new IFC4_3.IfcContext(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : new Handle(v[8].value)),
  1815067380: (id, v) => new IFC4_3.IfcCrewResourceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new Handle(v[10].value), v[11]),
  2506170314: (id, v) => new IFC4_3.IfcCsgPrimitive3D(id, new Handle(v[0].value)),
  2147822146: (id, v) => new IFC4_3.IfcCsgSolid(id, new Handle(v[0].value)),
  2601014836: (id, _) => new IFC4_3.IfcCurve(id),
  2827736869: (id, v) => new IFC4_3.IfcCurveBoundedPlane(id, new Handle(v[0].value), new Handle(v[1].value), v[2].map((p) => new Handle(p.value))),
  2629017746: (id, v) => new IFC4_3.IfcCurveBoundedSurface(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), new IFC4_3.IfcBoolean(v[2].value)),
  4212018352: (id, v) => new IFC4_3.IfcCurveSegment(id, v[0], new Handle(v[1].value), TypeInitialiser(2, v[2]), TypeInitialiser(2, v[3]), new Handle(v[4].value)),
  32440307: (id, v) => new IFC4_3.IfcDirection(id, v[0].map((p) => new IFC4_3.IfcReal(p.value))),
  593015953: (id, v) => new IFC4_3.IfcDirectrixCurveSweptAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : TypeInitialiser(2, v[4])),
  1472233963: (id, v) => new IFC4_3.IfcEdgeLoop(id, v[0].map((p) => new Handle(p.value))),
  1883228015: (id, v) => new IFC4_3.IfcElementQuantity(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5].map((p) => new Handle(p.value))),
  339256511: (id, v) => new IFC4_3.IfcElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  2777663545: (id, v) => new IFC4_3.IfcElementarySurface(id, new Handle(v[0].value)),
  2835456948: (id, v) => new IFC4_3.IfcEllipseProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value)),
  4024345920: (id, v) => new IFC4_3.IfcEventType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], v[10], !v[11] ? null : new IFC4_3.IfcLabel(v[11].value)),
  477187591: (id, v) => new IFC4_3.IfcExtrudedAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value)),
  2804161546: (id, v) => new IFC4_3.IfcExtrudedAreaSolidTapered(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new Handle(v[4].value)),
  2047409740: (id, v) => new IFC4_3.IfcFaceBasedSurfaceModel(id, v[0].map((p) => new Handle(p.value))),
  374418227: (id, v) => new IFC4_3.IfcFillAreaStyleHatching(id, new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), new IFC4_3.IfcPlaneAngleMeasure(v[4].value)),
  315944413: (id, v) => new IFC4_3.IfcFillAreaStyleTiles(id, v[0].map((p) => new Handle(p.value)), v[1].map((p) => new Handle(p.value)), new IFC4_3.IfcPositiveRatioMeasure(v[2].value)),
  2652556860: (id, v) => new IFC4_3.IfcFixedReferenceSweptAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : TypeInitialiser(2, v[4]), new Handle(v[5].value)),
  4238390223: (id, v) => new IFC4_3.IfcFurnishingElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  1268542332: (id, v) => new IFC4_3.IfcFurnitureType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], v[10]),
  4095422895: (id, v) => new IFC4_3.IfcGeographicElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  987898635: (id, v) => new IFC4_3.IfcGeometricCurveSet(id, v[0].map((p) => new Handle(p.value))),
  1484403080: (id, v) => new IFC4_3.IfcIShapeProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[9].value)),
  178912537: (id, v) => new IFC4_3.IfcIndexedPolygonalFace(id, v[0].map((p) => new IFC4_3.IfcPositiveInteger(p.value))),
  2294589976: (id, v) => new IFC4_3.IfcIndexedPolygonalFaceWithVoids(id, v[0].map((p) => new IFC4_3.IfcPositiveInteger(p.value)), v[1].map((p) => new IFC4_3.IfcPositiveInteger(p.value))),
  3465909080: (id, v) => new IFC4_3.IfcIndexedPolygonalTextureMap(id, v[0].map((p) => new Handle(p.value)), new Handle(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value))),
  572779678: (id, v) => new IFC4_3.IfcLShapeProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[8].value)),
  428585644: (id, v) => new IFC4_3.IfcLaborResourceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new Handle(v[10].value), v[11]),
  1281925730: (id, v) => new IFC4_3.IfcLine(id, new Handle(v[0].value), new Handle(v[1].value)),
  1425443689: (id, v) => new IFC4_3.IfcManifoldSolidBrep(id, new Handle(v[0].value)),
  3888040117: (id, v) => new IFC4_3.IfcObject(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value)),
  590820931: (id, v) => new IFC4_3.IfcOffsetCurve(id, new Handle(v[0].value)),
  3388369263: (id, v) => new IFC4_3.IfcOffsetCurve2D(id, new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), new IFC4_3.IfcLogical(v[2].value)),
  3505215534: (id, v) => new IFC4_3.IfcOffsetCurve3D(id, new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), new IFC4_3.IfcLogical(v[2].value), new Handle(v[3].value)),
  2485787929: (id, v) => new IFC4_3.IfcOffsetCurveByDistances(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value)),
  1682466193: (id, v) => new IFC4_3.IfcPcurve(id, new Handle(v[0].value), new Handle(v[1].value)),
  603570806: (id, v) => new IFC4_3.IfcPlanarBox(id, new IFC4_3.IfcLengthMeasure(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), new Handle(v[2].value)),
  220341763: (id, v) => new IFC4_3.IfcPlane(id, new Handle(v[0].value)),
  3381221214: (id, v) => new IFC4_3.IfcPolynomialCurve(id, new Handle(v[0].value), !v[1] ? null : v[1].map((p) => new IFC4_3.IfcReal(p.value)), !v[2] ? null : v[2].map((p) => new IFC4_3.IfcReal(p.value)), !v[3] ? null : v[3].map((p) => new IFC4_3.IfcReal(p.value))),
  759155922: (id, v) => new IFC4_3.IfcPreDefinedColour(id, new IFC4_3.IfcLabel(v[0].value)),
  2559016684: (id, v) => new IFC4_3.IfcPreDefinedCurveFont(id, new IFC4_3.IfcLabel(v[0].value)),
  3967405729: (id, v) => new IFC4_3.IfcPreDefinedPropertySet(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value)),
  569719735: (id, v) => new IFC4_3.IfcProcedureType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2945172077: (id, v) => new IFC4_3.IfcProcess(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value)),
  4208778838: (id, v) => new IFC4_3.IfcProduct(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  103090709: (id, v) => new IFC4_3.IfcProject(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : new Handle(v[8].value)),
  653396225: (id, v) => new IFC4_3.IfcProjectLibrary(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : new Handle(v[8].value)),
  871118103: (id, v) => new IFC4_3.IfcPropertyBoundedValue(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : TypeInitialiser(2, v[2]), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : TypeInitialiser(2, v[5])),
  4166981789: (id, v) => new IFC4_3.IfcPropertyEnumeratedValue(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : v[2].map((p) => TypeInitialiser(2, p)), !v[3] ? null : new Handle(v[3].value)),
  2752243245: (id, v) => new IFC4_3.IfcPropertyListValue(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : v[2].map((p) => TypeInitialiser(2, p)), !v[3] ? null : new Handle(v[3].value)),
  941946838: (id, v) => new IFC4_3.IfcPropertyReferenceValue(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new IFC4_3.IfcText(v[2].value), !v[3] ? null : new Handle(v[3].value)),
  1451395588: (id, v) => new IFC4_3.IfcPropertySet(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value))),
  492091185: (id, v) => new IFC4_3.IfcPropertySetTemplate(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4], !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), v[6].map((p) => new Handle(p.value))),
  3650150729: (id, v) => new IFC4_3.IfcPropertySingleValue(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : TypeInitialiser(2, v[2]), !v[3] ? null : new Handle(v[3].value)),
  110355661: (id, v) => new IFC4_3.IfcPropertyTableValue(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : v[2].map((p) => TypeInitialiser(2, p)), !v[3] ? null : v[3].map((p) => TypeInitialiser(2, p)), !v[4] ? null : new IFC4_3.IfcText(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7]),
  3521284610: (id, v) => new IFC4_3.IfcPropertyTemplate(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value)),
  2770003689: (id, v) => new IFC4_3.IfcRectangleHollowProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value)),
  2798486643: (id, v) => new IFC4_3.IfcRectangularPyramid(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), new IFC4_3.IfcPositiveLengthMeasure(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value)),
  3454111270: (id, v) => new IFC4_3.IfcRectangularTrimmedSurface(id, new Handle(v[0].value), new IFC4_3.IfcParameterValue(v[1].value), new IFC4_3.IfcParameterValue(v[2].value), new IFC4_3.IfcParameterValue(v[3].value), new IFC4_3.IfcParameterValue(v[4].value), new IFC4_3.IfcBoolean(v[5].value), new IFC4_3.IfcBoolean(v[6].value)),
  3765753017: (id, v) => new IFC4_3.IfcReinforcementDefinitionProperties(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5].map((p) => new Handle(p.value))),
  3939117080: (id, v) => new IFC4_3.IfcRelAssigns(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5]),
  1683148259: (id, v) => new IFC4_3.IfcRelAssignsToActor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  2495723537: (id, v) => new IFC4_3.IfcRelAssignsToControl(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value)),
  1307041759: (id, v) => new IFC4_3.IfcRelAssignsToGroup(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value)),
  1027710054: (id, v) => new IFC4_3.IfcRelAssignsToGroupByFactor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value), new IFC4_3.IfcRatioMeasure(v[7].value)),
  4278684876: (id, v) => new IFC4_3.IfcRelAssignsToProcess(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  2857406711: (id, v) => new IFC4_3.IfcRelAssignsToProduct(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value)),
  205026976: (id, v) => new IFC4_3.IfcRelAssignsToResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value)),
  1865459582: (id, v) => new IFC4_3.IfcRelAssociates(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value))),
  4095574036: (id, v) => new IFC4_3.IfcRelAssociatesApproval(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  919958153: (id, v) => new IFC4_3.IfcRelAssociatesClassification(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  2728634034: (id, v) => new IFC4_3.IfcRelAssociatesConstraint(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), new Handle(v[6].value)),
  982818633: (id, v) => new IFC4_3.IfcRelAssociatesDocument(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  3840914261: (id, v) => new IFC4_3.IfcRelAssociatesLibrary(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  2655215786: (id, v) => new IFC4_3.IfcRelAssociatesMaterial(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  1033248425: (id, v) => new IFC4_3.IfcRelAssociatesProfileDef(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  826625072: (id, v) => new IFC4_3.IfcRelConnects(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value)),
  1204542856: (id, v) => new IFC4_3.IfcRelConnectsElements(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value)),
  3945020480: (id, v) => new IFC4_3.IfcRelConnectsPathElements(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value), v[7].map((p) => new IFC4_3.IfcInteger(p.value)), v[8].map((p) => new IFC4_3.IfcInteger(p.value)), v[9], v[10]),
  4201705270: (id, v) => new IFC4_3.IfcRelConnectsPortToElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value)),
  3190031847: (id, v) => new IFC4_3.IfcRelConnectsPorts(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  2127690289: (id, v) => new IFC4_3.IfcRelConnectsStructuralActivity(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value)),
  1638771189: (id, v) => new IFC4_3.IfcRelConnectsStructuralMember(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new IFC4_3.IfcLengthMeasure(v[8].value), !v[9] ? null : new Handle(v[9].value)),
  504942748: (id, v) => new IFC4_3.IfcRelConnectsWithEccentricity(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new IFC4_3.IfcLengthMeasure(v[8].value), !v[9] ? null : new Handle(v[9].value), new Handle(v[10].value)),
  3678494232: (id, v) => new IFC4_3.IfcRelConnectsWithRealizingElements(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value), v[7].map((p) => new Handle(p.value)), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  3242617779: (id, v) => new IFC4_3.IfcRelContainedInSpatialStructure(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  886880790: (id, v) => new IFC4_3.IfcRelCoversBldgElements(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  2802773753: (id, v) => new IFC4_3.IfcRelCoversSpaces(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  2565941209: (id, v) => new IFC4_3.IfcRelDeclares(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  2551354335: (id, v) => new IFC4_3.IfcRelDecomposes(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value)),
  693640335: (id, v) => new IFC4_3.IfcRelDefines(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value)),
  1462361463: (id, v) => new IFC4_3.IfcRelDefinesByObject(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  4186316022: (id, v) => new IFC4_3.IfcRelDefinesByProperties(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  307848117: (id, v) => new IFC4_3.IfcRelDefinesByTemplate(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  781010003: (id, v) => new IFC4_3.IfcRelDefinesByType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  3940055652: (id, v) => new IFC4_3.IfcRelFillsElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value)),
  279856033: (id, v) => new IFC4_3.IfcRelFlowControlElements(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  427948657: (id, v) => new IFC4_3.IfcRelInterferesElements(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new IFC4_3.IfcIdentifier(v[8].value), new IFC4_3.IfcLogical(v[9].value)),
  3268803585: (id, v) => new IFC4_3.IfcRelNests(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  1441486842: (id, v) => new IFC4_3.IfcRelPositions(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  750771296: (id, v) => new IFC4_3.IfcRelProjectsElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value)),
  1245217292: (id, v) => new IFC4_3.IfcRelReferencedInSpatialStructure(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  4122056220: (id, v) => new IFC4_3.IfcRelSequence(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  366585022: (id, v) => new IFC4_3.IfcRelServicesBuildings(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  3451746338: (id, v) => new IFC4_3.IfcRelSpaceBoundary(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8]),
  3523091289: (id, v) => new IFC4_3.IfcRelSpaceBoundary1stLevel(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8], !v[9] ? null : new Handle(v[9].value)),
  1521410863: (id, v) => new IFC4_3.IfcRelSpaceBoundary2ndLevel(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8], !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value)),
  1401173127: (id, v) => new IFC4_3.IfcRelVoidsElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value)),
  816062949: (id, v) => new IFC4_3.IfcReparametrisedCompositeCurveSegment(id, v[0], new IFC4_3.IfcBoolean(v[1].value), new Handle(v[2].value), new IFC4_3.IfcParameterValue(v[3].value)),
  2914609552: (id, v) => new IFC4_3.IfcResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value)),
  1856042241: (id, v) => new IFC4_3.IfcRevolvedAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4_3.IfcPlaneAngleMeasure(v[3].value)),
  3243963512: (id, v) => new IFC4_3.IfcRevolvedAreaSolidTapered(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4_3.IfcPlaneAngleMeasure(v[3].value), new Handle(v[4].value)),
  4158566097: (id, v) => new IFC4_3.IfcRightCircularCone(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), new IFC4_3.IfcPositiveLengthMeasure(v[2].value)),
  3626867408: (id, v) => new IFC4_3.IfcRightCircularCylinder(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), new IFC4_3.IfcPositiveLengthMeasure(v[2].value)),
  1862484736: (id, v) => new IFC4_3.IfcSectionedSolid(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value))),
  1290935644: (id, v) => new IFC4_3.IfcSectionedSolidHorizontal(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), v[2].map((p) => new Handle(p.value))),
  1356537516: (id, v) => new IFC4_3.IfcSectionedSurface(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), v[2].map((p) => new Handle(p.value))),
  3663146110: (id, v) => new IFC4_3.IfcSimplePropertyTemplate(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4], !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new IFC4_3.IfcLabel(v[10].value), v[11]),
  1412071761: (id, v) => new IFC4_3.IfcSpatialElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value)),
  710998568: (id, v) => new IFC4_3.IfcSpatialElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  2706606064: (id, v) => new IFC4_3.IfcSpatialStructureElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8]),
  3893378262: (id, v) => new IFC4_3.IfcSpatialStructureElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  463610769: (id, v) => new IFC4_3.IfcSpatialZone(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8]),
  2481509218: (id, v) => new IFC4_3.IfcSpatialZoneType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4_3.IfcLabel(v[10].value)),
  451544542: (id, v) => new IFC4_3.IfcSphere(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value)),
  4015995234: (id, v) => new IFC4_3.IfcSphericalSurface(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value)),
  2735484536: (id, v) => new IFC4_3.IfcSpiral(id, !v[0] ? null : new Handle(v[0].value)),
  3544373492: (id, v) => new IFC4_3.IfcStructuralActivity(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]),
  3136571912: (id, v) => new IFC4_3.IfcStructuralItem(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  530289379: (id, v) => new IFC4_3.IfcStructuralMember(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  3689010777: (id, v) => new IFC4_3.IfcStructuralReaction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]),
  3979015343: (id, v) => new IFC4_3.IfcStructuralSurfaceMember(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[8].value)),
  2218152070: (id, v) => new IFC4_3.IfcStructuralSurfaceMemberVarying(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[8].value)),
  603775116: (id, v) => new IFC4_3.IfcStructuralSurfaceReaction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9]),
  4095615324: (id, v) => new IFC4_3.IfcSubContractResourceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new Handle(v[10].value), v[11]),
  699246055: (id, v) => new IFC4_3.IfcSurfaceCurve(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), v[2]),
  2028607225: (id, v) => new IFC4_3.IfcSurfaceCurveSweptAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : TypeInitialiser(2, v[4]), new Handle(v[5].value)),
  2809605785: (id, v) => new IFC4_3.IfcSurfaceOfLinearExtrusion(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4_3.IfcLengthMeasure(v[3].value)),
  4124788165: (id, v) => new IFC4_3.IfcSurfaceOfRevolution(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value)),
  1580310250: (id, v) => new IFC4_3.IfcSystemFurnitureElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3473067441: (id, v) => new IFC4_3.IfcTask(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), new IFC4_3.IfcBoolean(v[9].value), !v[10] ? null : new IFC4_3.IfcInteger(v[10].value), !v[11] ? null : new Handle(v[11].value), v[12]),
  3206491090: (id, v) => new IFC4_3.IfcTaskType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4_3.IfcLabel(v[10].value)),
  2387106220: (id, v) => new IFC4_3.IfcTessellatedFaceSet(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcBoolean(v[1].value)),
  782932809: (id, v) => new IFC4_3.IfcThirdOrderPolynomialSpiral(id, !v[0] ? null : new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLengthMeasure(v[4].value)),
  1935646853: (id, v) => new IFC4_3.IfcToroidalSurface(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), new IFC4_3.IfcPositiveLengthMeasure(v[2].value)),
  3665877780: (id, v) => new IFC4_3.IfcTransportationDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  2916149573: (id, v) => new IFC4_3.IfcTriangulatedFaceSet(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcBoolean(v[1].value), !v[2] ? null : v[2].map((p) => new IFC4_3.IfcParameterValue(p.value)), v[3].map((p) => new IFC4_3.IfcPositiveInteger(p.value)), !v[4] ? null : v[4].map((p) => new IFC4_3.IfcPositiveInteger(p.value))),
  1229763772: (id, v) => new IFC4_3.IfcTriangulatedIrregularNetwork(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcBoolean(v[1].value), !v[2] ? null : v[2].map((p) => new IFC4_3.IfcParameterValue(p.value)), v[3].map((p) => new IFC4_3.IfcPositiveInteger(p.value)), !v[4] ? null : v[4].map((p) => new IFC4_3.IfcPositiveInteger(p.value)), v[5].map((p) => new IFC4_3.IfcInteger(p.value))),
  3651464721: (id, v) => new IFC4_3.IfcVehicleType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  336235671: (id, v) => new IFC4_3.IfcWindowLiningProperties(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[9].value), !v[10] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[11].value), !v[12] ? null : new Handle(v[12].value), !v[13] ? null : new IFC4_3.IfcLengthMeasure(v[13].value), !v[14] ? null : new IFC4_3.IfcLengthMeasure(v[14].value), !v[15] ? null : new IFC4_3.IfcLengthMeasure(v[15].value)),
  512836454: (id, v) => new IFC4_3.IfcWindowPanelProperties(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4], v[5], !v[6] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new Handle(v[8].value)),
  2296667514: (id, v) => new IFC4_3.IfcActor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), new Handle(v[5].value)),
  1635779807: (id, v) => new IFC4_3.IfcAdvancedBrep(id, new Handle(v[0].value)),
  2603310189: (id, v) => new IFC4_3.IfcAdvancedBrepWithVoids(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value))),
  1674181508: (id, v) => new IFC4_3.IfcAnnotation(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7]),
  2887950389: (id, v) => new IFC4_3.IfcBSplineSurface(id, new IFC4_3.IfcInteger(v[0].value), new IFC4_3.IfcInteger(v[1].value), v[2].map((p) => new Handle(p.value)), v[3], new IFC4_3.IfcLogical(v[4].value), new IFC4_3.IfcLogical(v[5].value), new IFC4_3.IfcLogical(v[6].value)),
  167062518: (id, v) => new IFC4_3.IfcBSplineSurfaceWithKnots(id, new IFC4_3.IfcInteger(v[0].value), new IFC4_3.IfcInteger(v[1].value), v[2].map((p) => new Handle(p.value)), v[3], new IFC4_3.IfcLogical(v[4].value), new IFC4_3.IfcLogical(v[5].value), new IFC4_3.IfcLogical(v[6].value), v[7].map((p) => new IFC4_3.IfcInteger(p.value)), v[8].map((p) => new IFC4_3.IfcInteger(p.value)), v[9].map((p) => new IFC4_3.IfcParameterValue(p.value)), v[10].map((p) => new IFC4_3.IfcParameterValue(p.value)), v[11]),
  1334484129: (id, v) => new IFC4_3.IfcBlock(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), new IFC4_3.IfcPositiveLengthMeasure(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value)),
  3649129432: (id, v) => new IFC4_3.IfcBooleanClippingResult(id, v[0], new Handle(v[1].value), new Handle(v[2].value)),
  1260505505: (id, _) => new IFC4_3.IfcBoundedCurve(id),
  3124254112: (id, v) => new IFC4_3.IfcBuildingStorey(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcLengthMeasure(v[9].value)),
  1626504194: (id, v) => new IFC4_3.IfcBuiltElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  2197970202: (id, v) => new IFC4_3.IfcChimneyType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2937912522: (id, v) => new IFC4_3.IfcCircleHollowProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value)),
  3893394355: (id, v) => new IFC4_3.IfcCivilElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  3497074424: (id, v) => new IFC4_3.IfcClothoid(id, !v[0] ? null : new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value)),
  300633059: (id, v) => new IFC4_3.IfcColumnType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3875453745: (id, v) => new IFC4_3.IfcComplexPropertyTemplate(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5], !v[6] ? null : v[6].map((p) => new Handle(p.value))),
  3732776249: (id, v) => new IFC4_3.IfcCompositeCurve(id, v[0].map((p) => new Handle(p.value)), new IFC4_3.IfcLogical(v[1].value)),
  15328376: (id, v) => new IFC4_3.IfcCompositeCurveOnSurface(id, v[0].map((p) => new Handle(p.value)), new IFC4_3.IfcLogical(v[1].value)),
  2510884976: (id, v) => new IFC4_3.IfcConic(id, new Handle(v[0].value)),
  2185764099: (id, v) => new IFC4_3.IfcConstructionEquipmentResourceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new Handle(v[10].value), v[11]),
  4105962743: (id, v) => new IFC4_3.IfcConstructionMaterialResourceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new Handle(v[10].value), v[11]),
  1525564444: (id, v) => new IFC4_3.IfcConstructionProductResourceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new Handle(v[10].value), v[11]),
  2559216714: (id, v) => new IFC4_3.IfcConstructionResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map((p) => new Handle(p.value)), !v[9] ? null : new Handle(v[9].value)),
  3293443760: (id, v) => new IFC4_3.IfcControl(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value)),
  2000195564: (id, v) => new IFC4_3.IfcCosineSpiral(id, !v[0] ? null : new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value)),
  3895139033: (id, v) => new IFC4_3.IfcCostItem(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), v[6], !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : v[8].map((p) => new Handle(p.value))),
  1419761937: (id, v) => new IFC4_3.IfcCostSchedule(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcDateTime(v[8].value), !v[9] ? null : new IFC4_3.IfcDateTime(v[9].value)),
  4189326743: (id, v) => new IFC4_3.IfcCourseType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1916426348: (id, v) => new IFC4_3.IfcCoveringType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3295246426: (id, v) => new IFC4_3.IfcCrewResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map((p) => new Handle(p.value)), !v[9] ? null : new Handle(v[9].value), v[10]),
  1457835157: (id, v) => new IFC4_3.IfcCurtainWallType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1213902940: (id, v) => new IFC4_3.IfcCylindricalSurface(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value)),
  1306400036: (id, v) => new IFC4_3.IfcDeepFoundationType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  4234616927: (id, v) => new IFC4_3.IfcDirectrixDerivedReferenceSweptAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : TypeInitialiser(2, v[4]), new Handle(v[5].value)),
  3256556792: (id, v) => new IFC4_3.IfcDistributionElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  3849074793: (id, v) => new IFC4_3.IfcDistributionFlowElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  2963535650: (id, v) => new IFC4_3.IfcDoorLiningProperties(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcLengthMeasure(v[9].value), !v[10] ? null : new IFC4_3.IfcLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcLengthMeasure(v[11].value), !v[12] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[12].value), !v[13] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[13].value), !v[14] ? null : new Handle(v[14].value), !v[15] ? null : new IFC4_3.IfcLengthMeasure(v[15].value), !v[16] ? null : new IFC4_3.IfcLengthMeasure(v[16].value)),
  1714330368: (id, v) => new IFC4_3.IfcDoorPanelProperties(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[4].value), v[5], !v[6] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value)),
  2323601079: (id, v) => new IFC4_3.IfcDoorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], v[10], !v[11] ? null : new IFC4_3.IfcBoolean(v[11].value), !v[12] ? null : new IFC4_3.IfcLabel(v[12].value)),
  445594917: (id, v) => new IFC4_3.IfcDraughtingPreDefinedColour(id, new IFC4_3.IfcLabel(v[0].value)),
  4006246654: (id, v) => new IFC4_3.IfcDraughtingPreDefinedCurveFont(id, new IFC4_3.IfcLabel(v[0].value)),
  1758889154: (id, v) => new IFC4_3.IfcElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  4123344466: (id, v) => new IFC4_3.IfcElementAssembly(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8], v[9]),
  2397081782: (id, v) => new IFC4_3.IfcElementAssemblyType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1623761950: (id, v) => new IFC4_3.IfcElementComponent(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  2590856083: (id, v) => new IFC4_3.IfcElementComponentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  1704287377: (id, v) => new IFC4_3.IfcEllipse(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), new IFC4_3.IfcPositiveLengthMeasure(v[2].value)),
  2107101300: (id, v) => new IFC4_3.IfcEnergyConversionDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  132023988: (id, v) => new IFC4_3.IfcEngineType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3174744832: (id, v) => new IFC4_3.IfcEvaporativeCoolerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3390157468: (id, v) => new IFC4_3.IfcEvaporatorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  4148101412: (id, v) => new IFC4_3.IfcEvent(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), v[7], v[8], !v[9] ? null : new IFC4_3.IfcLabel(v[9].value), !v[10] ? null : new Handle(v[10].value)),
  2853485674: (id, v) => new IFC4_3.IfcExternalSpatialStructureElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value)),
  807026263: (id, v) => new IFC4_3.IfcFacetedBrep(id, new Handle(v[0].value)),
  3737207727: (id, v) => new IFC4_3.IfcFacetedBrepWithVoids(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value))),
  24185140: (id, v) => new IFC4_3.IfcFacility(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8]),
  1310830890: (id, v) => new IFC4_3.IfcFacilityPart(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9]),
  4228831410: (id, v) => new IFC4_3.IfcFacilityPartCommon(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9], v[10]),
  647756555: (id, v) => new IFC4_3.IfcFastener(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2489546625: (id, v) => new IFC4_3.IfcFastenerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2827207264: (id, v) => new IFC4_3.IfcFeatureElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  2143335405: (id, v) => new IFC4_3.IfcFeatureElementAddition(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  1287392070: (id, v) => new IFC4_3.IfcFeatureElementSubtraction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  3907093117: (id, v) => new IFC4_3.IfcFlowControllerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  3198132628: (id, v) => new IFC4_3.IfcFlowFittingType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  3815607619: (id, v) => new IFC4_3.IfcFlowMeterType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1482959167: (id, v) => new IFC4_3.IfcFlowMovingDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  1834744321: (id, v) => new IFC4_3.IfcFlowSegmentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  1339347760: (id, v) => new IFC4_3.IfcFlowStorageDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  2297155007: (id, v) => new IFC4_3.IfcFlowTerminalType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  3009222698: (id, v) => new IFC4_3.IfcFlowTreatmentDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  1893162501: (id, v) => new IFC4_3.IfcFootingType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  263784265: (id, v) => new IFC4_3.IfcFurnishingElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  1509553395: (id, v) => new IFC4_3.IfcFurniture(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3493046030: (id, v) => new IFC4_3.IfcGeographicElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  4230923436: (id, v) => new IFC4_3.IfcGeotechnicalElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  1594536857: (id, v) => new IFC4_3.IfcGeotechnicalStratum(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2898700619: (id, v) => new IFC4_3.IfcGradientCurve(id, v[0].map((p) => new Handle(p.value)), new IFC4_3.IfcLogical(v[1].value), new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value)),
  2706460486: (id, v) => new IFC4_3.IfcGroup(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value)),
  1251058090: (id, v) => new IFC4_3.IfcHeatExchangerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1806887404: (id, v) => new IFC4_3.IfcHumidifierType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2568555532: (id, v) => new IFC4_3.IfcImpactProtectionDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3948183225: (id, v) => new IFC4_3.IfcImpactProtectionDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2571569899: (id, v) => new IFC4_3.IfcIndexedPolyCurve(id, new Handle(v[0].value), !v[1] ? null : v[1].map((p) => TypeInitialiser(2, p)), new IFC4_3.IfcLogical(v[2].value)),
  3946677679: (id, v) => new IFC4_3.IfcInterceptorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3113134337: (id, v) => new IFC4_3.IfcIntersectionCurve(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), v[2]),
  2391368822: (id, v) => new IFC4_3.IfcInventory(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5], !v[6] ? null : new Handle(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : new IFC4_3.IfcDate(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value)),
  4288270099: (id, v) => new IFC4_3.IfcJunctionBoxType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  679976338: (id, v) => new IFC4_3.IfcKerbType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), new IFC4_3.IfcBoolean(v[9].value)),
  3827777499: (id, v) => new IFC4_3.IfcLaborResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map((p) => new Handle(p.value)), !v[9] ? null : new Handle(v[9].value), v[10]),
  1051575348: (id, v) => new IFC4_3.IfcLampType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1161773419: (id, v) => new IFC4_3.IfcLightFixtureType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2176059722: (id, v) => new IFC4_3.IfcLinearElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  1770583370: (id, v) => new IFC4_3.IfcLiquidTerminalType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  525669439: (id, v) => new IFC4_3.IfcMarineFacility(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9]),
  976884017: (id, v) => new IFC4_3.IfcMarinePart(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9], v[10]),
  377706215: (id, v) => new IFC4_3.IfcMechanicalFastener(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[9].value), v[10]),
  2108223431: (id, v) => new IFC4_3.IfcMechanicalFastenerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[11].value)),
  1114901282: (id, v) => new IFC4_3.IfcMedicalDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3181161470: (id, v) => new IFC4_3.IfcMemberType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1950438474: (id, v) => new IFC4_3.IfcMobileTelecommunicationsApplianceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  710110818: (id, v) => new IFC4_3.IfcMooringDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  977012517: (id, v) => new IFC4_3.IfcMotorConnectionType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  506776471: (id, v) => new IFC4_3.IfcNavigationElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  4143007308: (id, v) => new IFC4_3.IfcOccupant(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), new Handle(v[5].value), v[6]),
  3588315303: (id, v) => new IFC4_3.IfcOpeningElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2837617999: (id, v) => new IFC4_3.IfcOutletType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  514975943: (id, v) => new IFC4_3.IfcPavementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2382730787: (id, v) => new IFC4_3.IfcPerformanceHistory(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), new IFC4_3.IfcLabel(v[6].value), v[7]),
  3566463478: (id, v) => new IFC4_3.IfcPermeableCoveringProperties(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4], v[5], !v[6] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new Handle(v[8].value)),
  3327091369: (id, v) => new IFC4_3.IfcPermit(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcText(v[8].value)),
  1158309216: (id, v) => new IFC4_3.IfcPileType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  804291784: (id, v) => new IFC4_3.IfcPipeFittingType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  4231323485: (id, v) => new IFC4_3.IfcPipeSegmentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  4017108033: (id, v) => new IFC4_3.IfcPlateType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2839578677: (id, v) => new IFC4_3.IfcPolygonalFaceSet(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcBoolean(v[1].value), v[2].map((p) => new Handle(p.value)), !v[3] ? null : v[3].map((p) => new IFC4_3.IfcPositiveInteger(p.value))),
  3724593414: (id, v) => new IFC4_3.IfcPolyline(id, v[0].map((p) => new Handle(p.value))),
  3740093272: (id, v) => new IFC4_3.IfcPort(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  1946335990: (id, v) => new IFC4_3.IfcPositioningElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  2744685151: (id, v) => new IFC4_3.IfcProcedure(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), v[7]),
  2904328755: (id, v) => new IFC4_3.IfcProjectOrder(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcText(v[8].value)),
  3651124850: (id, v) => new IFC4_3.IfcProjectionElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1842657554: (id, v) => new IFC4_3.IfcProtectiveDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2250791053: (id, v) => new IFC4_3.IfcPumpType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1763565496: (id, v) => new IFC4_3.IfcRailType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2893384427: (id, v) => new IFC4_3.IfcRailingType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3992365140: (id, v) => new IFC4_3.IfcRailway(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9]),
  1891881377: (id, v) => new IFC4_3.IfcRailwayPart(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9], v[10]),
  2324767716: (id, v) => new IFC4_3.IfcRampFlightType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1469900589: (id, v) => new IFC4_3.IfcRampType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  683857671: (id, v) => new IFC4_3.IfcRationalBSplineSurfaceWithKnots(id, new IFC4_3.IfcInteger(v[0].value), new IFC4_3.IfcInteger(v[1].value), v[2].map((p) => new Handle(p.value)), v[3], new IFC4_3.IfcLogical(v[4].value), new IFC4_3.IfcLogical(v[5].value), new IFC4_3.IfcLogical(v[6].value), v[7].map((p) => new IFC4_3.IfcInteger(p.value)), v[8].map((p) => new IFC4_3.IfcInteger(p.value)), v[9].map((p) => new IFC4_3.IfcParameterValue(p.value)), v[10].map((p) => new IFC4_3.IfcParameterValue(p.value)), v[11], v[12].map((p) => new IFC4_3.IfcReal(p.value))),
  4021432810: (id, v) => new IFC4_3.IfcReferent(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7]),
  3027567501: (id, v) => new IFC4_3.IfcReinforcingElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  964333572: (id, v) => new IFC4_3.IfcReinforcingElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  2320036040: (id, v) => new IFC4_3.IfcReinforcingMesh(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[11].value), !v[12] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[12].value), !v[13] ? null : new IFC4_3.IfcAreaMeasure(v[13].value), !v[14] ? null : new IFC4_3.IfcAreaMeasure(v[14].value), !v[15] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[15].value), !v[16] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[16].value), v[17]),
  2310774935: (id, v) => new IFC4_3.IfcReinforcingMeshType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[11].value), !v[12] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[12].value), !v[13] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[13].value), !v[14] ? null : new IFC4_3.IfcAreaMeasure(v[14].value), !v[15] ? null : new IFC4_3.IfcAreaMeasure(v[15].value), !v[16] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[16].value), !v[17] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[17].value), !v[18] ? null : new IFC4_3.IfcLabel(v[18].value), !v[19] ? null : v[19].map((p) => TypeInitialiser(2, p))),
  3818125796: (id, v) => new IFC4_3.IfcRelAdheresToElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  160246688: (id, v) => new IFC4_3.IfcRelAggregates(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  146592293: (id, v) => new IFC4_3.IfcRoad(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9]),
  550521510: (id, v) => new IFC4_3.IfcRoadPart(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9], v[10]),
  2781568857: (id, v) => new IFC4_3.IfcRoofType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1768891740: (id, v) => new IFC4_3.IfcSanitaryTerminalType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2157484638: (id, v) => new IFC4_3.IfcSeamCurve(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), v[2]),
  3649235739: (id, v) => new IFC4_3.IfcSecondOrderPolynomialSpiral(id, !v[0] ? null : new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value)),
  544395925: (id, v) => new IFC4_3.IfcSegmentedReferenceCurve(id, v[0].map((p) => new Handle(p.value)), new IFC4_3.IfcLogical(v[1].value), new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value)),
  1027922057: (id, v) => new IFC4_3.IfcSeventhOrderPolynomialSpiral(id, !v[0] ? null : new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLengthMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcLengthMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcLengthMeasure(v[7].value), !v[8] ? null : new IFC4_3.IfcLengthMeasure(v[8].value)),
  4074543187: (id, v) => new IFC4_3.IfcShadingDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  33720170: (id, v) => new IFC4_3.IfcSign(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3599934289: (id, v) => new IFC4_3.IfcSignType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1894708472: (id, v) => new IFC4_3.IfcSignalType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  42703149: (id, v) => new IFC4_3.IfcSineSpiral(id, !v[0] ? null : new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value)),
  4097777520: (id, v) => new IFC4_3.IfcSite(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcCompoundPlaneAngleMeasure(v[9].value), !v[10] ? null : new IFC4_3.IfcCompoundPlaneAngleMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcLengthMeasure(v[11].value), !v[12] ? null : new IFC4_3.IfcLabel(v[12].value), !v[13] ? null : new Handle(v[13].value)),
  2533589738: (id, v) => new IFC4_3.IfcSlabType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1072016465: (id, v) => new IFC4_3.IfcSolarDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3856911033: (id, v) => new IFC4_3.IfcSpace(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9], !v[10] ? null : new IFC4_3.IfcLengthMeasure(v[10].value)),
  1305183839: (id, v) => new IFC4_3.IfcSpaceHeaterType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3812236995: (id, v) => new IFC4_3.IfcSpaceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4_3.IfcLabel(v[10].value)),
  3112655638: (id, v) => new IFC4_3.IfcStackTerminalType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1039846685: (id, v) => new IFC4_3.IfcStairFlightType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  338393293: (id, v) => new IFC4_3.IfcStairType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  682877961: (id, v) => new IFC4_3.IfcStructuralAction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcBoolean(v[9].value)),
  1179482911: (id, v) => new IFC4_3.IfcStructuralConnection(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  1004757350: (id, v) => new IFC4_3.IfcStructuralCurveAction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcBoolean(v[9].value), v[10], v[11]),
  4243806635: (id, v) => new IFC4_3.IfcStructuralCurveConnection(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), new Handle(v[8].value)),
  214636428: (id, v) => new IFC4_3.IfcStructuralCurveMember(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], new Handle(v[8].value)),
  2445595289: (id, v) => new IFC4_3.IfcStructuralCurveMemberVarying(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], new Handle(v[8].value)),
  2757150158: (id, v) => new IFC4_3.IfcStructuralCurveReaction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9]),
  1807405624: (id, v) => new IFC4_3.IfcStructuralLinearAction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcBoolean(v[9].value), v[10], v[11]),
  1252848954: (id, v) => new IFC4_3.IfcStructuralLoadGroup(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5], v[6], v[7], !v[8] ? null : new IFC4_3.IfcRatioMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcLabel(v[9].value)),
  2082059205: (id, v) => new IFC4_3.IfcStructuralPointAction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcBoolean(v[9].value)),
  734778138: (id, v) => new IFC4_3.IfcStructuralPointConnection(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value)),
  1235345126: (id, v) => new IFC4_3.IfcStructuralPointReaction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]),
  2986769608: (id, v) => new IFC4_3.IfcStructuralResultGroup(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5], !v[6] ? null : new Handle(v[6].value), new IFC4_3.IfcBoolean(v[7].value)),
  3657597509: (id, v) => new IFC4_3.IfcStructuralSurfaceAction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcBoolean(v[9].value), v[10], v[11]),
  1975003073: (id, v) => new IFC4_3.IfcStructuralSurfaceConnection(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  148013059: (id, v) => new IFC4_3.IfcSubContractResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map((p) => new Handle(p.value)), !v[9] ? null : new Handle(v[9].value), v[10]),
  3101698114: (id, v) => new IFC4_3.IfcSurfaceFeature(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2315554128: (id, v) => new IFC4_3.IfcSwitchingDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2254336722: (id, v) => new IFC4_3.IfcSystem(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value)),
  413509423: (id, v) => new IFC4_3.IfcSystemFurnitureElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  5716631: (id, v) => new IFC4_3.IfcTankType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3824725483: (id, v) => new IFC4_3.IfcTendon(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcAreaMeasure(v[11].value), !v[12] ? null : new IFC4_3.IfcForceMeasure(v[12].value), !v[13] ? null : new IFC4_3.IfcPressureMeasure(v[13].value), !v[14] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[14].value), !v[15] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[15].value), !v[16] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[16].value)),
  2347447852: (id, v) => new IFC4_3.IfcTendonAnchor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3081323446: (id, v) => new IFC4_3.IfcTendonAnchorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3663046924: (id, v) => new IFC4_3.IfcTendonConduit(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2281632017: (id, v) => new IFC4_3.IfcTendonConduitType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2415094496: (id, v) => new IFC4_3.IfcTendonType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcAreaMeasure(v[11].value), !v[12] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[12].value)),
  618700268: (id, v) => new IFC4_3.IfcTrackElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1692211062: (id, v) => new IFC4_3.IfcTransformerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2097647324: (id, v) => new IFC4_3.IfcTransportElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1953115116: (id, v) => new IFC4_3.IfcTransportationDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  3593883385: (id, v) => new IFC4_3.IfcTrimmedCurve(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), v[2].map((p) => new Handle(p.value)), new IFC4_3.IfcBoolean(v[3].value), v[4]),
  1600972822: (id, v) => new IFC4_3.IfcTubeBundleType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1911125066: (id, v) => new IFC4_3.IfcUnitaryEquipmentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  728799441: (id, v) => new IFC4_3.IfcValveType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  840318589: (id, v) => new IFC4_3.IfcVehicle(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1530820697: (id, v) => new IFC4_3.IfcVibrationDamper(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3956297820: (id, v) => new IFC4_3.IfcVibrationDamperType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2391383451: (id, v) => new IFC4_3.IfcVibrationIsolator(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3313531582: (id, v) => new IFC4_3.IfcVibrationIsolatorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2769231204: (id, v) => new IFC4_3.IfcVirtualElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  926996030: (id, v) => new IFC4_3.IfcVoidingFeature(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1898987631: (id, v) => new IFC4_3.IfcWallType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1133259667: (id, v) => new IFC4_3.IfcWasteTerminalType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  4009809668: (id, v) => new IFC4_3.IfcWindowType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], v[10], !v[11] ? null : new IFC4_3.IfcBoolean(v[11].value), !v[12] ? null : new IFC4_3.IfcLabel(v[12].value)),
  4088093105: (id, v) => new IFC4_3.IfcWorkCalendar(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : v[7].map((p) => new Handle(p.value)), v[8]),
  1028945134: (id, v) => new IFC4_3.IfcWorkControl(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), new IFC4_3.IfcDateTime(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : new IFC4_3.IfcDuration(v[9].value), !v[10] ? null : new IFC4_3.IfcDuration(v[10].value), new IFC4_3.IfcDateTime(v[11].value), !v[12] ? null : new IFC4_3.IfcDateTime(v[12].value)),
  4218914973: (id, v) => new IFC4_3.IfcWorkPlan(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), new IFC4_3.IfcDateTime(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : new IFC4_3.IfcDuration(v[9].value), !v[10] ? null : new IFC4_3.IfcDuration(v[10].value), new IFC4_3.IfcDateTime(v[11].value), !v[12] ? null : new IFC4_3.IfcDateTime(v[12].value), v[13]),
  3342526732: (id, v) => new IFC4_3.IfcWorkSchedule(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), new IFC4_3.IfcDateTime(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : new IFC4_3.IfcDuration(v[9].value), !v[10] ? null : new IFC4_3.IfcDuration(v[10].value), new IFC4_3.IfcDateTime(v[11].value), !v[12] ? null : new IFC4_3.IfcDateTime(v[12].value), v[13]),
  1033361043: (id, v) => new IFC4_3.IfcZone(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value)),
  3821786052: (id, v) => new IFC4_3.IfcActionRequest(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcText(v[8].value)),
  1411407467: (id, v) => new IFC4_3.IfcAirTerminalBoxType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3352864051: (id, v) => new IFC4_3.IfcAirTerminalType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1871374353: (id, v) => new IFC4_3.IfcAirToAirHeatRecoveryType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  4266260250: (id, v) => new IFC4_3.IfcAlignmentCant(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new IFC4_3.IfcPositiveLengthMeasure(v[7].value)),
  1545765605: (id, v) => new IFC4_3.IfcAlignmentHorizontal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  317615605: (id, v) => new IFC4_3.IfcAlignmentSegment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value)),
  1662888072: (id, v) => new IFC4_3.IfcAlignmentVertical(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  3460190687: (id, v) => new IFC4_3.IfcAsset(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value), !v[11] ? null : new Handle(v[11].value), !v[12] ? null : new IFC4_3.IfcDate(v[12].value), !v[13] ? null : new Handle(v[13].value)),
  1532957894: (id, v) => new IFC4_3.IfcAudioVisualApplianceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1967976161: (id, v) => new IFC4_3.IfcBSplineCurve(id, new IFC4_3.IfcInteger(v[0].value), v[1].map((p) => new Handle(p.value)), v[2], new IFC4_3.IfcLogical(v[3].value), new IFC4_3.IfcLogical(v[4].value)),
  2461110595: (id, v) => new IFC4_3.IfcBSplineCurveWithKnots(id, new IFC4_3.IfcInteger(v[0].value), v[1].map((p) => new Handle(p.value)), v[2], new IFC4_3.IfcLogical(v[3].value), new IFC4_3.IfcLogical(v[4].value), v[5].map((p) => new IFC4_3.IfcInteger(p.value)), v[6].map((p) => new IFC4_3.IfcParameterValue(p.value)), v[7]),
  819618141: (id, v) => new IFC4_3.IfcBeamType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3649138523: (id, v) => new IFC4_3.IfcBearingType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  231477066: (id, v) => new IFC4_3.IfcBoilerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1136057603: (id, v) => new IFC4_3.IfcBoundaryCurve(id, v[0].map((p) => new Handle(p.value)), new IFC4_3.IfcLogical(v[1].value)),
  644574406: (id, v) => new IFC4_3.IfcBridge(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9]),
  963979645: (id, v) => new IFC4_3.IfcBridgePart(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9], v[10]),
  4031249490: (id, v) => new IFC4_3.IfcBuilding(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcLengthMeasure(v[9].value), !v[10] ? null : new IFC4_3.IfcLengthMeasure(v[10].value), !v[11] ? null : new Handle(v[11].value)),
  2979338954: (id, v) => new IFC4_3.IfcBuildingElementPart(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  39481116: (id, v) => new IFC4_3.IfcBuildingElementPartType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1909888760: (id, v) => new IFC4_3.IfcBuildingElementProxyType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1177604601: (id, v) => new IFC4_3.IfcBuildingSystem(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5], !v[6] ? null : new IFC4_3.IfcLabel(v[6].value)),
  1876633798: (id, v) => new IFC4_3.IfcBuiltElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  3862327254: (id, v) => new IFC4_3.IfcBuiltSystem(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5], !v[6] ? null : new IFC4_3.IfcLabel(v[6].value)),
  2188180465: (id, v) => new IFC4_3.IfcBurnerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  395041908: (id, v) => new IFC4_3.IfcCableCarrierFittingType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3293546465: (id, v) => new IFC4_3.IfcCableCarrierSegmentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2674252688: (id, v) => new IFC4_3.IfcCableFittingType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1285652485: (id, v) => new IFC4_3.IfcCableSegmentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3203706013: (id, v) => new IFC4_3.IfcCaissonFoundationType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2951183804: (id, v) => new IFC4_3.IfcChillerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3296154744: (id, v) => new IFC4_3.IfcChimney(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2611217952: (id, v) => new IFC4_3.IfcCircle(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value)),
  1677625105: (id, v) => new IFC4_3.IfcCivilElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  2301859152: (id, v) => new IFC4_3.IfcCoilType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  843113511: (id, v) => new IFC4_3.IfcColumn(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  400855858: (id, v) => new IFC4_3.IfcCommunicationsApplianceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3850581409: (id, v) => new IFC4_3.IfcCompressorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2816379211: (id, v) => new IFC4_3.IfcCondenserType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3898045240: (id, v) => new IFC4_3.IfcConstructionEquipmentResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map((p) => new Handle(p.value)), !v[9] ? null : new Handle(v[9].value), v[10]),
  1060000209: (id, v) => new IFC4_3.IfcConstructionMaterialResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map((p) => new Handle(p.value)), !v[9] ? null : new Handle(v[9].value), v[10]),
  488727124: (id, v) => new IFC4_3.IfcConstructionProductResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map((p) => new Handle(p.value)), !v[9] ? null : new Handle(v[9].value), v[10]),
  2940368186: (id, v) => new IFC4_3.IfcConveyorSegmentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  335055490: (id, v) => new IFC4_3.IfcCooledBeamType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2954562838: (id, v) => new IFC4_3.IfcCoolingTowerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1502416096: (id, v) => new IFC4_3.IfcCourse(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1973544240: (id, v) => new IFC4_3.IfcCovering(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3495092785: (id, v) => new IFC4_3.IfcCurtainWall(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3961806047: (id, v) => new IFC4_3.IfcDamperType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3426335179: (id, v) => new IFC4_3.IfcDeepFoundation(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  1335981549: (id, v) => new IFC4_3.IfcDiscreteAccessory(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2635815018: (id, v) => new IFC4_3.IfcDiscreteAccessoryType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  479945903: (id, v) => new IFC4_3.IfcDistributionBoardType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1599208980: (id, v) => new IFC4_3.IfcDistributionChamberElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2063403501: (id, v) => new IFC4_3.IfcDistributionControlElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value)),
  1945004755: (id, v) => new IFC4_3.IfcDistributionElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  3040386961: (id, v) => new IFC4_3.IfcDistributionFlowElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  3041715199: (id, v) => new IFC4_3.IfcDistributionPort(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8], v[9]),
  3205830791: (id, v) => new IFC4_3.IfcDistributionSystem(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), v[6]),
  395920057: (id, v) => new IFC4_3.IfcDoor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[9].value), v[10], v[11], !v[12] ? null : new IFC4_3.IfcLabel(v[12].value)),
  869906466: (id, v) => new IFC4_3.IfcDuctFittingType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3760055223: (id, v) => new IFC4_3.IfcDuctSegmentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2030761528: (id, v) => new IFC4_3.IfcDuctSilencerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3071239417: (id, v) => new IFC4_3.IfcEarthworksCut(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1077100507: (id, v) => new IFC4_3.IfcEarthworksElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  3376911765: (id, v) => new IFC4_3.IfcEarthworksFill(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  663422040: (id, v) => new IFC4_3.IfcElectricApplianceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2417008758: (id, v) => new IFC4_3.IfcElectricDistributionBoardType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3277789161: (id, v) => new IFC4_3.IfcElectricFlowStorageDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2142170206: (id, v) => new IFC4_3.IfcElectricFlowTreatmentDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1534661035: (id, v) => new IFC4_3.IfcElectricGeneratorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1217240411: (id, v) => new IFC4_3.IfcElectricMotorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  712377611: (id, v) => new IFC4_3.IfcElectricTimeControlType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1658829314: (id, v) => new IFC4_3.IfcEnergyConversionDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  2814081492: (id, v) => new IFC4_3.IfcEngine(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3747195512: (id, v) => new IFC4_3.IfcEvaporativeCooler(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  484807127: (id, v) => new IFC4_3.IfcEvaporator(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1209101575: (id, v) => new IFC4_3.IfcExternalSpatialElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8]),
  346874300: (id, v) => new IFC4_3.IfcFanType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1810631287: (id, v) => new IFC4_3.IfcFilterType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  4222183408: (id, v) => new IFC4_3.IfcFireSuppressionTerminalType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2058353004: (id, v) => new IFC4_3.IfcFlowController(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  4278956645: (id, v) => new IFC4_3.IfcFlowFitting(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  4037862832: (id, v) => new IFC4_3.IfcFlowInstrumentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  2188021234: (id, v) => new IFC4_3.IfcFlowMeter(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3132237377: (id, v) => new IFC4_3.IfcFlowMovingDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  987401354: (id, v) => new IFC4_3.IfcFlowSegment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  707683696: (id, v) => new IFC4_3.IfcFlowStorageDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  2223149337: (id, v) => new IFC4_3.IfcFlowTerminal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  3508470533: (id, v) => new IFC4_3.IfcFlowTreatmentDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  900683007: (id, v) => new IFC4_3.IfcFooting(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2713699986: (id, v) => new IFC4_3.IfcGeotechnicalAssembly(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  3009204131: (id, v) => new IFC4_3.IfcGrid(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7].map((p) => new Handle(p.value)), v[8].map((p) => new Handle(p.value)), !v[9] ? null : v[9].map((p) => new Handle(p.value)), v[10]),
  3319311131: (id, v) => new IFC4_3.IfcHeatExchanger(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2068733104: (id, v) => new IFC4_3.IfcHumidifier(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  4175244083: (id, v) => new IFC4_3.IfcInterceptor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2176052936: (id, v) => new IFC4_3.IfcJunctionBox(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2696325953: (id, v) => new IFC4_3.IfcKerb(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), new IFC4_3.IfcBoolean(v[8].value)),
  76236018: (id, v) => new IFC4_3.IfcLamp(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  629592764: (id, v) => new IFC4_3.IfcLightFixture(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1154579445: (id, v) => new IFC4_3.IfcLinearPositioningElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  1638804497: (id, v) => new IFC4_3.IfcLiquidTerminal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1437502449: (id, v) => new IFC4_3.IfcMedicalDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1073191201: (id, v) => new IFC4_3.IfcMember(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2078563270: (id, v) => new IFC4_3.IfcMobileTelecommunicationsAppliance(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  234836483: (id, v) => new IFC4_3.IfcMooringDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2474470126: (id, v) => new IFC4_3.IfcMotorConnection(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2182337498: (id, v) => new IFC4_3.IfcNavigationElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  144952367: (id, v) => new IFC4_3.IfcOuterBoundaryCurve(id, v[0].map((p) => new Handle(p.value)), new IFC4_3.IfcLogical(v[1].value)),
  3694346114: (id, v) => new IFC4_3.IfcOutlet(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1383356374: (id, v) => new IFC4_3.IfcPavement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1687234759: (id, v) => new IFC4_3.IfcPile(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8], v[9]),
  310824031: (id, v) => new IFC4_3.IfcPipeFitting(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3612865200: (id, v) => new IFC4_3.IfcPipeSegment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3171933400: (id, v) => new IFC4_3.IfcPlate(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  738039164: (id, v) => new IFC4_3.IfcProtectiveDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  655969474: (id, v) => new IFC4_3.IfcProtectiveDeviceTrippingUnitType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  90941305: (id, v) => new IFC4_3.IfcPump(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3290496277: (id, v) => new IFC4_3.IfcRail(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2262370178: (id, v) => new IFC4_3.IfcRailing(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3024970846: (id, v) => new IFC4_3.IfcRamp(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3283111854: (id, v) => new IFC4_3.IfcRampFlight(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1232101972: (id, v) => new IFC4_3.IfcRationalBSplineCurveWithKnots(id, new IFC4_3.IfcInteger(v[0].value), v[1].map((p) => new Handle(p.value)), v[2], new IFC4_3.IfcLogical(v[3].value), new IFC4_3.IfcLogical(v[4].value), v[5].map((p) => new IFC4_3.IfcInteger(p.value)), v[6].map((p) => new IFC4_3.IfcParameterValue(p.value)), v[7], v[8].map((p) => new IFC4_3.IfcReal(p.value))),
  3798194928: (id, v) => new IFC4_3.IfcReinforcedSoil(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  979691226: (id, v) => new IFC4_3.IfcReinforcingBar(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC4_3.IfcAreaMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[11].value), v[12], v[13]),
  2572171363: (id, v) => new IFC4_3.IfcReinforcingBarType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcAreaMeasure(v[11].value), !v[12] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[12].value), v[13], !v[14] ? null : new IFC4_3.IfcLabel(v[14].value), !v[15] ? null : v[15].map((p) => TypeInitialiser(2, p))),
  2016517767: (id, v) => new IFC4_3.IfcRoof(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3053780830: (id, v) => new IFC4_3.IfcSanitaryTerminal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1783015770: (id, v) => new IFC4_3.IfcSensorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1329646415: (id, v) => new IFC4_3.IfcShadingDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  991950508: (id, v) => new IFC4_3.IfcSignal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1529196076: (id, v) => new IFC4_3.IfcSlab(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3420628829: (id, v) => new IFC4_3.IfcSolarDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1999602285: (id, v) => new IFC4_3.IfcSpaceHeater(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1404847402: (id, v) => new IFC4_3.IfcStackTerminal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  331165859: (id, v) => new IFC4_3.IfcStair(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  4252922144: (id, v) => new IFC4_3.IfcStairFlight(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcInteger(v[8].value), !v[9] ? null : new IFC4_3.IfcInteger(v[9].value), !v[10] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[11].value), v[12]),
  2515109513: (id, v) => new IFC4_3.IfcStructuralAnalysisModel(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5], !v[6] ? null : new Handle(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : v[8].map((p) => new Handle(p.value)), !v[9] ? null : new Handle(v[9].value)),
  385403989: (id, v) => new IFC4_3.IfcStructuralLoadCase(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5], v[6], v[7], !v[8] ? null : new IFC4_3.IfcRatioMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcLabel(v[9].value), !v[10] ? null : v[10].map((p) => new IFC4_3.IfcRatioMeasure(p.value))),
  1621171031: (id, v) => new IFC4_3.IfcStructuralPlanarAction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcBoolean(v[9].value), v[10], v[11]),
  1162798199: (id, v) => new IFC4_3.IfcSwitchingDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  812556717: (id, v) => new IFC4_3.IfcTank(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3425753595: (id, v) => new IFC4_3.IfcTrackElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3825984169: (id, v) => new IFC4_3.IfcTransformer(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1620046519: (id, v) => new IFC4_3.IfcTransportElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3026737570: (id, v) => new IFC4_3.IfcTubeBundle(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3179687236: (id, v) => new IFC4_3.IfcUnitaryControlElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  4292641817: (id, v) => new IFC4_3.IfcUnitaryEquipment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  4207607924: (id, v) => new IFC4_3.IfcValve(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2391406946: (id, v) => new IFC4_3.IfcWall(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3512223829: (id, v) => new IFC4_3.IfcWallStandardCase(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  4237592921: (id, v) => new IFC4_3.IfcWasteTerminal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3304561284: (id, v) => new IFC4_3.IfcWindow(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[9].value), v[10], v[11], !v[12] ? null : new IFC4_3.IfcLabel(v[12].value)),
  2874132201: (id, v) => new IFC4_3.IfcActuatorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  1634111441: (id, v) => new IFC4_3.IfcAirTerminal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  177149247: (id, v) => new IFC4_3.IfcAirTerminalBox(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2056796094: (id, v) => new IFC4_3.IfcAirToAirHeatRecovery(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3001207471: (id, v) => new IFC4_3.IfcAlarmType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  325726236: (id, v) => new IFC4_3.IfcAlignment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7]),
  277319702: (id, v) => new IFC4_3.IfcAudioVisualAppliance(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  753842376: (id, v) => new IFC4_3.IfcBeam(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  4196446775: (id, v) => new IFC4_3.IfcBearing(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  32344328: (id, v) => new IFC4_3.IfcBoiler(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3314249567: (id, v) => new IFC4_3.IfcBorehole(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  1095909175: (id, v) => new IFC4_3.IfcBuildingElementProxy(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2938176219: (id, v) => new IFC4_3.IfcBurner(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  635142910: (id, v) => new IFC4_3.IfcCableCarrierFitting(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3758799889: (id, v) => new IFC4_3.IfcCableCarrierSegment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1051757585: (id, v) => new IFC4_3.IfcCableFitting(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  4217484030: (id, v) => new IFC4_3.IfcCableSegment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3999819293: (id, v) => new IFC4_3.IfcCaissonFoundation(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3902619387: (id, v) => new IFC4_3.IfcChiller(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  639361253: (id, v) => new IFC4_3.IfcCoil(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3221913625: (id, v) => new IFC4_3.IfcCommunicationsAppliance(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3571504051: (id, v) => new IFC4_3.IfcCompressor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2272882330: (id, v) => new IFC4_3.IfcCondenser(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  578613899: (id, v) => new IFC4_3.IfcControllerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]),
  3460952963: (id, v) => new IFC4_3.IfcConveyorSegment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  4136498852: (id, v) => new IFC4_3.IfcCooledBeam(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3640358203: (id, v) => new IFC4_3.IfcCoolingTower(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  4074379575: (id, v) => new IFC4_3.IfcDamper(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3693000487: (id, v) => new IFC4_3.IfcDistributionBoard(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1052013943: (id, v) => new IFC4_3.IfcDistributionChamberElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  562808652: (id, v) => new IFC4_3.IfcDistributionCircuit(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), v[6]),
  1062813311: (id, v) => new IFC4_3.IfcDistributionControlElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  342316401: (id, v) => new IFC4_3.IfcDuctFitting(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3518393246: (id, v) => new IFC4_3.IfcDuctSegment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1360408905: (id, v) => new IFC4_3.IfcDuctSilencer(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1904799276: (id, v) => new IFC4_3.IfcElectricAppliance(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  862014818: (id, v) => new IFC4_3.IfcElectricDistributionBoard(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3310460725: (id, v) => new IFC4_3.IfcElectricFlowStorageDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  24726584: (id, v) => new IFC4_3.IfcElectricFlowTreatmentDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  264262732: (id, v) => new IFC4_3.IfcElectricGenerator(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  402227799: (id, v) => new IFC4_3.IfcElectricMotor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1003880860: (id, v) => new IFC4_3.IfcElectricTimeControl(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3415622556: (id, v) => new IFC4_3.IfcFan(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  819412036: (id, v) => new IFC4_3.IfcFilter(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  1426591983: (id, v) => new IFC4_3.IfcFireSuppressionTerminal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  182646315: (id, v) => new IFC4_3.IfcFlowInstrument(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  2680139844: (id, v) => new IFC4_3.IfcGeomodel(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  1971632696: (id, v) => new IFC4_3.IfcGeoslice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value)),
  2295281155: (id, v) => new IFC4_3.IfcProtectiveDeviceTrippingUnit(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  4086658281: (id, v) => new IFC4_3.IfcSensor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  630975310: (id, v) => new IFC4_3.IfcUnitaryControlElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  4288193352: (id, v) => new IFC4_3.IfcActuator(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  3087945054: (id, v) => new IFC4_3.IfcAlarm(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]),
  25142252: (id, v) => new IFC4_3.IfcController(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8])
};
InheritanceDef[2] = {
  618182010: [IFCTELECOMADDRESS, IFCPOSTALADDRESS],
  2879124712: [IFCALIGNMENTHORIZONTALSEGMENT, IFCALIGNMENTCANTSEGMENT, IFCALIGNMENTVERTICALSEGMENT],
  411424972: [IFCCOSTVALUE],
  4037036970: [IFCBOUNDARYNODECONDITIONWARPING, IFCBOUNDARYNODECONDITION, IFCBOUNDARYFACECONDITION, IFCBOUNDARYEDGECONDITION],
  1387855156: [IFCBOUNDARYNODECONDITIONWARPING],
  2859738748: [IFCCONNECTIONCURVEGEOMETRY, IFCCONNECTIONVOLUMEGEOMETRY, IFCCONNECTIONSURFACEGEOMETRY, IFCCONNECTIONPOINTECCENTRICITY, IFCCONNECTIONPOINTGEOMETRY],
  2614616156: [IFCCONNECTIONPOINTECCENTRICITY],
  1959218052: [IFCOBJECTIVE, IFCMETRIC],
  1785450214: [IFCMAPCONVERSION],
  1466758467: [IFCPROJECTEDCRS],
  4294318154: [IFCDOCUMENTINFORMATION, IFCCLASSIFICATION, IFCLIBRARYINFORMATION],
  3200245327: [IFCDOCUMENTREFERENCE, IFCCLASSIFICATIONREFERENCE, IFCLIBRARYREFERENCE, IFCEXTERNALLYDEFINEDTEXTFONT, IFCEXTERNALLYDEFINEDSURFACESTYLE, IFCEXTERNALLYDEFINEDHATCHSTYLE],
  760658860: [IFCMATERIALCONSTITUENTSET, IFCMATERIALCONSTITUENT, IFCMATERIAL, IFCMATERIALPROFILESET, IFCMATERIALPROFILEWITHOFFSETS, IFCMATERIALPROFILE, IFCMATERIALLAYERSET, IFCMATERIALLAYERWITHOFFSETS, IFCMATERIALLAYER],
  248100487: [IFCMATERIALLAYERWITHOFFSETS],
  2235152071: [IFCMATERIALPROFILEWITHOFFSETS],
  1507914824: [IFCMATERIALPROFILESETUSAGETAPERING, IFCMATERIALPROFILESETUSAGE, IFCMATERIALLAYERSETUSAGE],
  1918398963: [IFCCONVERSIONBASEDUNITWITHOFFSET, IFCCONVERSIONBASEDUNIT, IFCCONTEXTDEPENDENTUNIT, IFCSIUNIT],
  3701648758: [IFCLOCALPLACEMENT, IFCLINEARPLACEMENT, IFCGRIDPLACEMENT],
  2483315170: [IFCPHYSICALCOMPLEXQUANTITY, IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYNUMBER, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA, IFCPHYSICALSIMPLEQUANTITY],
  2226359599: [IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYNUMBER, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA],
  677532197: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT, IFCPREDEFINEDITEM, IFCINDEXEDCOLOURMAP, IFCCURVESTYLEFONTPATTERN, IFCCURVESTYLEFONTANDSCALING, IFCCURVESTYLEFONT, IFCCOLOURRGB, IFCCOLOURSPECIFICATION, IFCCOLOURRGBLIST, IFCTEXTUREVERTEXLIST, IFCTEXTUREVERTEX, IFCINDEXEDPOLYGONALTEXTUREMAP, IFCINDEXEDTRIANGLETEXTUREMAP, IFCINDEXEDTEXTUREMAP, IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR, IFCTEXTURECOORDINATE, IFCTEXTSTYLETEXTMODEL, IFCTEXTSTYLEFORDEFINEDFONT, IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE, IFCSURFACETEXTURE, IFCSURFACESTYLEWITHTEXTURES, IFCSURFACESTYLERENDERING, IFCSURFACESTYLESHADING, IFCSURFACESTYLEREFRACTION, IFCSURFACESTYLELIGHTING],
  2022622350: [IFCPRESENTATIONLAYERWITHSTYLE],
  3119450353: [IFCFILLAREASTYLE, IFCCURVESTYLE, IFCTEXTSTYLE, IFCSURFACESTYLE],
  2095639259: [IFCPRODUCTDEFINITIONSHAPE, IFCMATERIALDEFINITIONREPRESENTATION],
  3958567839: [IFCLSHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF, IFCPARAMETERIZEDPROFILEDEF, IFCOPENCROSSPROFILEDEF, IFCMIRROREDPROFILEDEF, IFCDERIVEDPROFILEDEF, IFCCOMPOSITEPROFILEDEF, IFCCENTERLINEPROFILEDEF, IFCARBITRARYOPENPROFILEDEF, IFCARBITRARYPROFILEDEFWITHVOIDS, IFCARBITRARYCLOSEDPROFILEDEF],
  986844984: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY, IFCPROPERTY, IFCSECTIONREINFORCEMENTPROPERTIES, IFCSECTIONPROPERTIES, IFCREINFORCEMENTBARPROPERTIES, IFCPREDEFINEDPROPERTIES, IFCPROFILEPROPERTIES, IFCMATERIALPROPERTIES, IFCEXTENDEDPROPERTIES, IFCPROPERTYENUMERATION],
  1076942058: [IFCSTYLEDREPRESENTATION, IFCSTYLEMODEL, IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION, IFCSHAPEMODEL],
  3377609919: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT, IFCGEOMETRICREPRESENTATIONCONTEXT],
  3008791417: [IFCMAPPEDITEM, IFCFILLAREASTYLETILES, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIRECTION, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCSINESPIRAL, IFCSEVENTHORDERPOLYNOMIALSPIRAL, IFCSECONDORDERPOLYNOMIALSPIRAL, IFCCOSINESPIRAL, IFCCLOTHOID, IFCTHIRDORDERPOLYNOMIALSPIRAL, IFCSPIRAL, IFCPOLYNOMIALCURVE, IFCPCURVE, IFCOFFSETCURVEBYDISTANCES, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCOFFSETCURVE, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D, IFCCARTESIANPOINTLIST, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPOLYGONALFACESET, IFCTRIANGULATEDIRREGULARNETWORK, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE, IFCTESSELLATEDITEM, IFCSECTIONEDSURFACE, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCSECTIONEDSOLIDHORIZONTAL, IFCSECTIONEDSOLID, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCDIRECTRIXCURVESWEPTAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCCURVESEGMENT, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT, IFCSEGMENT, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINTBYDISTANCEEXPRESSION, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENTLINEAR, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET, IFCGEOMETRICREPRESENTATIONITEM, IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCADVANCEDFACE, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX, IFCTOPOLOGICALREPRESENTATIONITEM, IFCSTYLEDITEM],
  2439245199: [IFCRESOURCECONSTRAINTRELATIONSHIP, IFCRESOURCEAPPROVALRELATIONSHIP, IFCPROPERTYDEPENDENCYRELATIONSHIP, IFCORGANIZATIONRELATIONSHIP, IFCMATERIALRELATIONSHIP, IFCEXTERNALREFERENCERELATIONSHIP, IFCDOCUMENTINFORMATIONRELATIONSHIP, IFCCURRENCYRELATIONSHIP, IFCAPPROVALRELATIONSHIP],
  2341007311: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELADHERESTOELEMENT, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELDECLARES, IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPOSITIONS, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESPROFILEDEF, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS, IFCRELATIONSHIP, IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE, IFCPROPERTYTEMPLATEDEFINITION, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET, IFCPROPERTYSETDEFINITION, IFCPROPERTYDEFINITION, IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT, IFCPOSITIONINGELEMENT, IFCDISTRIBUTIONPORT, IFCPORT, IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT, IFCLINEARELEMENT, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS, IFCOBJECT, IFCPROJECTLIBRARY, IFCPROJECT, IFCCONTEXT, IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS, IFCTYPEOBJECT, IFCOBJECTDEFINITION],
  1054537805: [IFCRESOURCETIME, IFCLAGTIME, IFCEVENTTIME, IFCWORKTIME, IFCTASKTIMERECURRING, IFCTASKTIME],
  3982875396: [IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION],
  2273995522: [IFCSLIPPAGECONNECTIONCONDITION, IFCFAILURECONNECTIONCONDITION],
  2162789131: [IFCSURFACEREINFORCEMENTAREA, IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC, IFCSTRUCTURALLOADORRESULT, IFCSTRUCTURALLOADCONFIGURATION],
  609421318: [IFCSURFACEREINFORCEMENTAREA, IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC],
  2525727697: [IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE],
  2830218821: [IFCSTYLEDREPRESENTATION],
  846575682: [IFCSURFACESTYLERENDERING],
  626085974: [IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE],
  1549132990: [IFCTASKTIMERECURRING],
  280115917: [IFCINDEXEDPOLYGONALTEXTUREMAP, IFCINDEXEDTRIANGLETEXTUREMAP, IFCINDEXEDTEXTUREMAP, IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR],
  222769930: [IFCTEXTURECOORDINATEINDICESWITHVOIDS],
  3101149627: [IFCREGULARTIMESERIES, IFCIRREGULARTIMESERIES],
  1377556343: [IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCADVANCEDFACE, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX],
  2799835756: [IFCVERTEXPOINT],
  3798115385: [IFCARBITRARYPROFILEDEFWITHVOIDS],
  1310608509: [IFCCENTERLINEPROFILEDEF],
  3264961684: [IFCCOLOURRGB],
  370225590: [IFCCLOSEDSHELL, IFCOPENSHELL],
  2889183280: [IFCCONVERSIONBASEDUNITWITHOFFSET],
  3632507154: [IFCMIRROREDPROFILEDEF],
  3900360178: [IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE],
  297599258: [IFCPROFILEPROPERTIES, IFCMATERIALPROPERTIES],
  2556980723: [IFCADVANCEDFACE, IFCFACESURFACE],
  1809719519: [IFCFACEOUTERBOUND],
  3008276851: [IFCADVANCEDFACE],
  3448662350: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT],
  2453401579: [IFCFILLAREASTYLETILES, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIRECTION, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCSINESPIRAL, IFCSEVENTHORDERPOLYNOMIALSPIRAL, IFCSECONDORDERPOLYNOMIALSPIRAL, IFCCOSINESPIRAL, IFCCLOTHOID, IFCTHIRDORDERPOLYNOMIALSPIRAL, IFCSPIRAL, IFCPOLYNOMIALCURVE, IFCPCURVE, IFCOFFSETCURVEBYDISTANCES, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCOFFSETCURVE, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D, IFCCARTESIANPOINTLIST, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPOLYGONALFACESET, IFCTRIANGULATEDIRREGULARNETWORK, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE, IFCTESSELLATEDITEM, IFCSECTIONEDSURFACE, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCSECTIONEDSOLIDHORIZONTAL, IFCSECTIONEDSOLID, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCDIRECTRIXCURVESWEPTAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCCURVESEGMENT, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT, IFCSEGMENT, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINTBYDISTANCEEXPRESSION, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENTLINEAR, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET],
  3590301190: [IFCGEOMETRICCURVESET],
  812098782: [IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE],
  1437953363: [IFCINDEXEDPOLYGONALTEXTUREMAP, IFCINDEXEDTRIANGLETEXTUREMAP],
  1402838566: [IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT],
  1520743889: [IFCLIGHTSOURCESPOT],
  1008929658: [IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP],
  3079605661: [IFCMATERIALPROFILESETUSAGETAPERING],
  219451334: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT, IFCPOSITIONINGELEMENT, IFCDISTRIBUTIONPORT, IFCPORT, IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT, IFCLINEARELEMENT, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS, IFCOBJECT, IFCPROJECTLIBRARY, IFCPROJECT, IFCCONTEXT, IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS, IFCTYPEOBJECT],
  2529465313: [IFCLSHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF],
  2004835150: [IFCAXIS2PLACEMENTLINEAR, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT],
  1663979128: [IFCPLANARBOX],
  2067069095: [IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINTBYDISTANCEEXPRESSION],
  3727388367: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT],
  3778827333: [IFCSECTIONREINFORCEMENTPROPERTIES, IFCSECTIONPROPERTIES, IFCREINFORCEMENTBARPROPERTIES],
  1775413392: [IFCTEXTSTYLEFONTMODEL],
  2598011224: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY],
  1680319473: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE, IFCPROPERTYTEMPLATEDEFINITION, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET, IFCPROPERTYSETDEFINITION],
  3357820518: [IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET],
  1482703590: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE],
  2090586900: [IFCELEMENTQUANTITY],
  3615266464: [IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF],
  478536968: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELADHERESTOELEMENT, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELDECLARES, IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPOSITIONS, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESPROFILEDEF, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS],
  823603102: [IFCCURVESEGMENT, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT],
  3692461612: [IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE],
  723233188: [IFCSECTIONEDSOLIDHORIZONTAL, IFCSECTIONEDSOLID, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCDIRECTRIXCURVESWEPTAREASOLID, IFCSWEPTAREASOLID],
  2473145415: [IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION],
  1597423693: [IFCSTRUCTURALLOADSINGLEFORCEWARPING],
  2513912981: [IFCSECTIONEDSURFACE, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE],
  2247615214: [IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCDIRECTRIXCURVESWEPTAREASOLID],
  1260650574: [IFCSWEPTDISKSOLIDPOLYGONAL],
  230924584: [IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION],
  901063453: [IFCPOLYGONALFACESET, IFCTRIANGULATEDIRREGULARNETWORK, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE],
  4282788508: [IFCTEXTLITERALWITHEXTENT],
  1628702193: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS],
  3736923433: [IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE],
  2347495698: [IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE],
  3698973494: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE],
  2736907675: [IFCBOOLEANCLIPPINGRESULT],
  4182860854: [IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE],
  574549367: [IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D],
  59481748: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D],
  3749851601: [IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM],
  3331915920: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM],
  1383045692: [IFCCIRCLEHOLLOWPROFILEDEF],
  2485617015: [IFCREPARAMETRISEDCOMPOSITECURVESEGMENT],
  2574617495: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE],
  3419103109: [IFCPROJECTLIBRARY, IFCPROJECT],
  2506170314: [IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID],
  2601014836: [IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCSINESPIRAL, IFCSEVENTHORDERPOLYNOMIALSPIRAL, IFCSECONDORDERPOLYNOMIALSPIRAL, IFCCOSINESPIRAL, IFCCLOTHOID, IFCTHIRDORDERPOLYNOMIALSPIRAL, IFCSPIRAL, IFCPOLYNOMIALCURVE, IFCPCURVE, IFCOFFSETCURVEBYDISTANCES, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCOFFSETCURVE, IFCLINE],
  593015953: [IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID],
  339256511: [IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE],
  2777663545: [IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE],
  477187591: [IFCEXTRUDEDAREASOLIDTAPERED],
  2652556860: [IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID],
  4238390223: [IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE],
  178912537: [IFCINDEXEDPOLYGONALFACEWITHVOIDS],
  1425443689: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP],
  3888040117: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT, IFCPOSITIONINGELEMENT, IFCDISTRIBUTIONPORT, IFCPORT, IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT, IFCLINEARELEMENT, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS],
  590820931: [IFCOFFSETCURVEBYDISTANCES, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D],
  759155922: [IFCDRAUGHTINGPREDEFINEDCOLOUR],
  2559016684: [IFCDRAUGHTINGPREDEFINEDCURVEFONT],
  3967405729: [IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES],
  2945172077: [IFCPROCEDURE, IFCEVENT, IFCTASK],
  4208778838: [IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT, IFCPOSITIONINGELEMENT, IFCDISTRIBUTIONPORT, IFCPORT, IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT, IFCLINEARELEMENT, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT],
  3521284610: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE],
  3939117080: [IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR],
  1307041759: [IFCRELASSIGNSTOGROUPBYFACTOR],
  1865459582: [IFCRELASSOCIATESPROFILEDEF, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL],
  826625072: [IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPOSITIONS, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS],
  1204542856: [IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS],
  1638771189: [IFCRELCONNECTSWITHECCENTRICITY],
  2551354335: [IFCRELAGGREGATES, IFCRELADHERESTOELEMENT, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS],
  693640335: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT],
  3451746338: [IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL],
  3523091289: [IFCRELSPACEBOUNDARY2NDLEVEL],
  2914609552: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE],
  1856042241: [IFCREVOLVEDAREASOLIDTAPERED],
  1862484736: [IFCSECTIONEDSOLIDHORIZONTAL],
  1412071761: [IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT],
  710998568: [IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE],
  2706606064: [IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY],
  3893378262: [IFCSPACETYPE],
  2735484536: [IFCSINESPIRAL, IFCSEVENTHORDERPOLYNOMIALSPIRAL, IFCSECONDORDERPOLYNOMIALSPIRAL, IFCCOSINESPIRAL, IFCCLOTHOID, IFCTHIRDORDERPOLYNOMIALSPIRAL],
  3544373492: [IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION],
  3136571912: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER],
  530289379: [IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER],
  3689010777: [IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION],
  3979015343: [IFCSTRUCTURALSURFACEMEMBERVARYING],
  699246055: [IFCSEAMCURVE, IFCINTERSECTIONCURVE],
  2387106220: [IFCPOLYGONALFACESET, IFCTRIANGULATEDIRREGULARNETWORK, IFCTRIANGULATEDFACESET],
  3665877780: [IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE],
  2916149573: [IFCTRIANGULATEDIRREGULARNETWORK],
  2296667514: [IFCOCCUPANT],
  1635779807: [IFCADVANCEDBREPWITHVOIDS],
  2887950389: [IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS],
  167062518: [IFCRATIONALBSPLINESURFACEWITHKNOTS],
  1260505505: [IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE],
  1626504194: [IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE],
  3732776249: [IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE],
  15328376: [IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE],
  2510884976: [IFCCIRCLE, IFCELLIPSE],
  2559216714: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE],
  3293443760: [IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM],
  1306400036: [IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE],
  3256556792: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE],
  3849074793: [IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE],
  1758889154: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY],
  1623761950: [IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER],
  2590856083: [IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE],
  2107101300: [IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE],
  2853485674: [IFCEXTERNALSPATIALELEMENT],
  807026263: [IFCFACETEDBREPWITHVOIDS],
  24185140: [IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY],
  1310830890: [IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON],
  2827207264: [IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION],
  2143335405: [IFCPROJECTIONELEMENT],
  1287392070: [IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT],
  3907093117: [IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE],
  3198132628: [IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE],
  1482959167: [IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE],
  1834744321: [IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE],
  1339347760: [IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE],
  2297155007: [IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE],
  3009222698: [IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE],
  263784265: [IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE],
  4230923436: [IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM],
  2706460486: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY],
  2176059722: [IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT],
  3740093272: [IFCDISTRIBUTIONPORT],
  1946335990: [IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT],
  3027567501: [IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH],
  964333572: [IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE],
  682877961: [IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION],
  1179482911: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION],
  1004757350: [IFCSTRUCTURALLINEARACTION],
  214636428: [IFCSTRUCTURALCURVEMEMBERVARYING],
  1252848954: [IFCSTRUCTURALLOADCASE],
  3657597509: [IFCSTRUCTURALPLANARACTION],
  2254336722: [IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE],
  1953115116: [IFCTRANSPORTELEMENT, IFCVEHICLE],
  1028945134: [IFCWORKSCHEDULE, IFCWORKPLAN],
  1967976161: [IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS],
  2461110595: [IFCRATIONALBSPLINECURVEWITHKNOTS],
  1136057603: [IFCOUTERBOUNDARYCURVE],
  1876633798: [IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY],
  3426335179: [IFCCAISSONFOUNDATION, IFCPILE],
  2063403501: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE],
  1945004755: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT],
  3040386961: [IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE],
  3205830791: [IFCDISTRIBUTIONCIRCUIT],
  1077100507: [IFCREINFORCEDSOIL, IFCEARTHWORKSFILL],
  1658829314: [IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE],
  2058353004: [IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER],
  4278956645: [IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX],
  3132237377: [IFCFAN, IFCCOMPRESSOR, IFCPUMP],
  987401354: [IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT],
  707683696: [IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK],
  2223149337: [IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP],
  3508470533: [IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR],
  2713699986: [IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE],
  1154579445: [IFCALIGNMENT],
  2391406946: [IFCWALLSTANDARDCASE],
  1062813311: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT]
};
InversePropertyDef[2] = {
  3630933823: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  618182010: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  411424972: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  130549933: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["ApprovedObjects", IFCRELASSOCIATESAPPROVAL, 5, true], ["ApprovedResources", IFCRESOURCEAPPROVALRELATIONSHIP, 3, true], ["IsRelatedWith", IFCAPPROVALRELATIONSHIP, 3, true], ["Relates", IFCAPPROVALRELATIONSHIP, 2, true]],
  1959218052: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  1466758467: [["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  602808272: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3200245327: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  2242383968: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  1040185647: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  3548104201: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  852622518: [["PartOfW", IFCGRID, 9, true], ["PartOfV", IFCGRID, 8, true], ["PartOfU", IFCGRID, 7, true], ["HasIntersections", IFCVIRTUALGRIDINTERSECTION, 0, true]],
  2655187982: [["LibraryInfoForObjects", IFCRELASSOCIATESLIBRARY, 5, true], ["HasLibraryReferences", IFCLIBRARYREFERENCE, 5, true]],
  3452421091: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["LibraryRefForObjects", IFCRELASSOCIATESLIBRARY, 5, true]],
  760658860: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  248100487: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, false]],
  3303938423: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  1847252529: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, false]],
  2235152071: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialProfileSet", IFCMATERIALPROFILESET, 2, false]],
  164193824: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  552965576: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialProfileSet", IFCMATERIALPROFILESET, 2, false]],
  1507914824: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3368373690: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  3701648758: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCOBJECTPLACEMENT, 0, true]],
  2251480897: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  4251960020: [["IsRelatedBy", IFCORGANIZATIONRELATIONSHIP, 3, true], ["Relates", IFCORGANIZATIONRELATIONSHIP, 2, true], ["Engages", IFCPERSONANDORGANIZATION, 1, true]],
  2077209135: [["EngagedIn", IFCPERSONANDORGANIZATION, 0, true]],
  2483315170: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2226359599: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3355820592: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  3958567839: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3843373140: [["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  986844984: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3710013099: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2044713172: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2093928680: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  931644368: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2691318326: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3252649465: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2405470396: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  825690147: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  1076942058: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3377609919: [["RepresentationsInContext", IFCREPRESENTATION, 0, true]],
  3008791417: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1660063152: [["HasShapeAspects", IFCSHAPEASPECT, 4, true], ["MapUsage", IFCMAPPEDITEM, 0, true]],
  867548509: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3982875396: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  4240577450: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  2830218821: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3958052878: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3049322572: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  626085974: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  912023232: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  222769930: [["ToTexMap", IFCINDEXEDPOLYGONALTEXTUREMAP, 3, false]],
  1010789467: [["ToTexMap", IFCINDEXEDPOLYGONALTEXTUREMAP, 3, false]],
  3101149627: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1377556343: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1735638870: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  2799835756: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1907098498: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3798115385: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1310608509: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2705031697: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  616511568: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  3150382593: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  747523909: [["ClassificationForObjects", IFCRELASSOCIATESCLASSIFICATION, 5, true], ["HasReferences", IFCCLASSIFICATIONREFERENCE, 3, true]],
  647927063: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["ClassificationRefForObjects", IFCRELASSOCIATESCLASSIFICATION, 5, true], ["HasReferences", IFCCLASSIFICATIONREFERENCE, 3, true]],
  1485152156: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  370225590: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3050246964: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2889183280: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2713554722: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3632507154: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1154170062: [["DocumentInfoForObjects", IFCRELASSOCIATESDOCUMENT, 5, true], ["HasDocumentReferences", IFCDOCUMENTREFERENCE, 4, true], ["IsPointedTo", IFCDOCUMENTINFORMATIONRELATIONSHIP, 3, true], ["IsPointer", IFCDOCUMENTINFORMATIONRELATIONSHIP, 2, true]],
  3732053477: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["DocumentRefForObjects", IFCRELASSOCIATESDOCUMENT, 5, true]],
  3900360178: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  476780140: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  297599258: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2556980723: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  1809719519: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  803316827: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3008276851: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  3448662350: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true], ["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  2453401579: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4142052618: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true], ["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  3590301190: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  178086475: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCOBJECTPLACEMENT, 0, true]],
  812098782: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3905492369: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  3741457305: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1402838566: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  125510826: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2604431987: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4266656042: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1520743889: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3422422726: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  388784114: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCOBJECTPLACEMENT, 0, true]],
  2624227202: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCOBJECTPLACEMENT, 0, true]],
  1008929658: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2347385850: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1838606355: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["HasRepresentation", IFCMATERIALDEFINITIONREPRESENTATION, 3, true], ["IsRelatedWith", IFCMATERIALRELATIONSHIP, 3, true], ["RelatesTo", IFCMATERIALRELATIONSHIP, 2, true]],
  3708119e3: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialConstituentSet", IFCMATERIALCONSTITUENTSET, 2, false]],
  2852063980: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  1303795690: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3079605661: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3404854881: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3265635763: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2998442950: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  219451334: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  182550632: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2665983363: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1029017970: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2529465313: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2519244187: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3021840470: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  597895409: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  2004835150: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1663979128: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2067069095: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2165702409: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4022376103: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1423911732: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2924175390: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2775532180: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3778827333: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  673634403: [["ShapeOfProduct", IFCPRODUCT, 6, true], ["HasShapeAspects", IFCSHAPEASPECT, 4, true]],
  2802850158: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2598011224: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  1680319473: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  3357820518: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  1482703590: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  2090586900: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3615266464: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3413951693: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1580146022: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2778083089: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2042790032: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  4165799628: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1509187699: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  823603102: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  4124623270: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3692461612: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  723233188: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2233826070: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2513912981: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2247615214: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260650574: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1096409881: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  230924584: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3071757647: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  901063453: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4282788508: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3124975700: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2715220739: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1628702193: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true]],
  3736923433: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2347495698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3698973494: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  427810014: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1417489154: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2759199220: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2543172580: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3406155212: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  669184980: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3207858831: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  4261334040: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3125803723: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2740243338: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3425423356: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2736907675: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4182860854: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2581212453: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2713105998: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2898889636: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1123145078: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  574549367: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1675464909: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2059837836: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  59481748: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3749851601: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3486308946: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3331915920: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1416205885: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1383045692: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2205249479: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2542286263: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  2485617015: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  2574617495: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3419103109: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  1815067380: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2506170314: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2147822146: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2601014836: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2827736869: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2629017746: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4212018352: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  32440307: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  593015953: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1472233963: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1883228015: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  339256511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2777663545: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2835456948: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  4024345920: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  477187591: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2804161546: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2047409740: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  374418227: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  315944413: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2652556860: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4238390223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1268542332: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4095422895: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  987898635: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1484403080: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  178912537: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["ToFaceSet", IFCPOLYGONALFACESET, 2, true], ["HasTexCoords", IFCTEXTURECOORDINATEINDICES, 1, true]],
  2294589976: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["ToFaceSet", IFCPOLYGONALFACESET, 2, true], ["HasTexCoords", IFCTEXTURECOORDINATEINDICES, 1, true]],
  572779678: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  428585644: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1281925730: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1425443689: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3888040117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true]],
  590820931: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3388369263: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3505215534: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2485787929: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1682466193: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  603570806: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  220341763: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3381221214: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3967405729: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  569719735: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2945172077: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  4208778838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  103090709: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  653396225: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  871118103: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  4166981789: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  2752243245: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  941946838: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  1451395588: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  492091185: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Defines", IFCRELDEFINESBYTEMPLATE, 5, true]],
  3650150729: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  110355661: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  3521284610: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  2770003689: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2798486643: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3454111270: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3765753017: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3523091289: [["InnerBoundaries", IFCRELSPACEBOUNDARY1STLEVEL, 9, true]],
  1521410863: [["InnerBoundaries", IFCRELSPACEBOUNDARY1STLEVEL, 9, true], ["Corresponds", IFCRELSPACEBOUNDARY2NDLEVEL, 10, true]],
  816062949: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  2914609552: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1856042241: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3243963512: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4158566097: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3626867408: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1862484736: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1290935644: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1356537516: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3663146110: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  1412071761: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  710998568: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2706606064: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  3893378262: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  463610769: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  2481509218: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  451544542: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4015995234: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2735484536: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3544373492: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  3136571912: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true]],
  530289379: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  3689010777: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  3979015343: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2218152070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  603775116: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  4095615324: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  699246055: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2028607225: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2809605785: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4124788165: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1580310250: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3473067441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  3206491090: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2387106220: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  782932809: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1935646853: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3665877780: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2916149573: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  1229763772: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  3651464721: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  336235671: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  512836454: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  2296667514: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  1635779807: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2603310189: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1674181508: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2887950389: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  167062518: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1334484129: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3649129432: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260505505: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3124254112: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  1626504194: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2197970202: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2937912522: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3893394355: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3497074424: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  300633059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3875453745: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  3732776249: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  15328376: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2510884976: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2185764099: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  4105962743: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1525564444: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2559216714: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3293443760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  2000195564: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3895139033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1419761937: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  4189326743: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1916426348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3295246426: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1457835157: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1213902940: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1306400036: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4234616927: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3256556792: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3849074793: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2963535650: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  1714330368: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  2323601079: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1758889154: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  4123344466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2397081782: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1623761950: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2590856083: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1704287377: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2107101300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  132023988: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3174744832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3390157468: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4148101412: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2853485674: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  807026263: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3737207727: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  24185140: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  1310830890: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  4228831410: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  647756555: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2489546625: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2827207264: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2143335405: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1287392070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  3907093117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3198132628: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3815607619: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1482959167: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1834744321: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1339347760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2297155007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3009222698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1893162501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  263784265: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1509553395: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3493046030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  4230923436: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1594536857: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2898700619: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2706460486: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1251058090: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1806887404: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2568555532: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3948183225: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2571569899: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3946677679: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3113134337: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2391368822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  4288270099: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  679976338: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3827777499: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1051575348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1161773419: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2176059722: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1770583370: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  525669439: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  976884017: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  377706215: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2108223431: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1114901282: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3181161470: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1950438474: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  710110818: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  977012517: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  506776471: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4143007308: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  3588315303: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false], ["HasFillings", IFCRELFILLSELEMENT, 4, true]],
  2837617999: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  514975943: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2382730787: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3566463478: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3327091369: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1158309216: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  804291784: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4231323485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4017108033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2839578677: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  3724593414: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3740093272: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, true], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  1946335990: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["Positions", IFCRELPOSITIONS, 4, true]],
  2744685151: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2904328755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3651124850: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1842657554: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2250791053: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1763565496: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2893384427: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3992365140: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  1891881377: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  2324767716: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1469900589: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  683857671: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4021432810: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["Positions", IFCRELPOSITIONS, 4, true]],
  3027567501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  964333572: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2320036040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2310774935: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  146592293: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  550521510: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  2781568857: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1768891740: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2157484638: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3649235739: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  544395925: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1027922057: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4074543187: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  33720170: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3599934289: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1894708472: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  42703149: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4097777520: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  2533589738: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1072016465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3856911033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasCoverings", IFCRELCOVERSSPACES, 4, true], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, true]],
  1305183839: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3812236995: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3112655638: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1039846685: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  338393293: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  682877961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1179482911: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  1004757350: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  4243806635: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  214636428: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2445595289: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2757150158: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1807405624: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1252848954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, true], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, true]],
  2082059205: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  734778138: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  1235345126: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  2986769608: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ResultGroupFor", IFCSTRUCTURALANALYSISMODEL, 8, true]],
  3657597509: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1975003073: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  148013059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3101698114: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["AdheresToElement", IFCRELADHERESTOELEMENT, 5, false]],
  2315554128: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2254336722: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  413509423: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  5716631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3824725483: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2347447852: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3081323446: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3663046924: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2281632017: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2415094496: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  618700268: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1692211062: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2097647324: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1953115116: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3593883385: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1600972822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1911125066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  728799441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  840318589: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1530820697: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3956297820: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2391383451: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3313531582: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2769231204: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  926996030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  1898987631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1133259667: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4009809668: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4088093105: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1028945134: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  4218914973: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3342526732: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1033361043: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  3821786052: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1411407467: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3352864051: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1871374353: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4266260250: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1545765605: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  317615605: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1662888072: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  3460190687: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1532957894: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1967976161: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2461110595: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  819618141: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3649138523: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  231477066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1136057603: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  644574406: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  963979645: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  4031249490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  2979338954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  39481116: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1909888760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1177604601: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1876633798: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3862327254: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  2188180465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  395041908: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3293546465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2674252688: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1285652485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3203706013: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2951183804: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3296154744: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2611217952: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1677625105: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2301859152: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  843113511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  400855858: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3850581409: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2816379211: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3898045240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1060000209: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  488727124: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2940368186: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  335055490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2954562838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1502416096: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1973544240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["CoversSpaces", IFCRELCOVERSSPACES, 5, true], ["CoversElements", IFCRELCOVERSBLDGELEMENTS, 5, true]],
  3495092785: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3961806047: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3426335179: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1335981549: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2635815018: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  479945903: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1599208980: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2063403501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1945004755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true]],
  3040386961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3041715199: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, true], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  3205830791: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  395920057: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  869906466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3760055223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2030761528: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3071239417: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  1077100507: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3376911765: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  663422040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2417008758: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3277789161: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2142170206: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1534661035: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1217240411: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  712377611: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1658829314: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2814081492: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3747195512: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  484807127: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1209101575: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, true]],
  346874300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1810631287: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4222183408: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2058353004: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4278956645: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4037862832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2188021234: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3132237377: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  987401354: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  707683696: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2223149337: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3508470533: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  900683007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2713699986: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3009204131: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["Positions", IFCRELPOSITIONS, 4, true]],
  3319311131: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2068733104: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4175244083: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2176052936: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2696325953: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  76236018: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  629592764: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1154579445: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["Positions", IFCRELPOSITIONS, 4, true]],
  1638804497: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1437502449: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1073191201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2078563270: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  234836483: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2474470126: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2182337498: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  144952367: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3694346114: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1383356374: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1687234759: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  310824031: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3612865200: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3171933400: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  738039164: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  655969474: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  90941305: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3290496277: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2262370178: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3024970846: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3283111854: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1232101972: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3798194928: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  979691226: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2572171363: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2016517767: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3053780830: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1783015770: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1329646415: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  991950508: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1529196076: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3420628829: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1999602285: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1404847402: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  331165859: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  4252922144: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2515109513: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  385403989: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, true], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, true]],
  1621171031: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1162798199: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  812556717: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3425753595: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3825984169: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1620046519: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3026737570: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3179687236: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4292641817: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4207607924: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2391406946: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3512223829: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  4237592921: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3304561284: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2874132201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1634111441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  177149247: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2056796094: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3001207471: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  325726236: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["Positions", IFCRELPOSITIONS, 4, true]],
  277319702: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  753842376: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  4196446775: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  32344328: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3314249567: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1095909175: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2938176219: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  635142910: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3758799889: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1051757585: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4217484030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3999819293: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3902619387: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  639361253: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3221913625: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3571504051: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2272882330: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  578613899: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3460952963: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4136498852: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3640358203: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4074379575: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3693000487: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1052013943: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  562808652: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1062813311: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  342316401: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3518393246: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1360408905: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1904799276: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  862014818: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3310460725: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  24726584: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  264262732: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  402227799: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1003880860: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3415622556: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  819412036: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1426591983: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  182646315: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  2680139844: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1971632696: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2295281155: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  4086658281: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  630975310: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  4288193352: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  3087945054: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  25142252: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]]
};
Constructors[2] = {
  3630933823: (ID, a) => new IFC4_3.IfcActorRole(ID, a[0], a[1], a[2]),
  618182010: (ID, a) => new IFC4_3.IfcAddress(ID, a[0], a[1], a[2]),
  2879124712: (ID, a) => new IFC4_3.IfcAlignmentParameterSegment(ID, a[0], a[1]),
  3633395639: (ID, a) => new IFC4_3.IfcAlignmentVerticalSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  639542469: (ID, a) => new IFC4_3.IfcApplication(ID, a[0], a[1], a[2], a[3]),
  411424972: (ID, a) => new IFC4_3.IfcAppliedValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  130549933: (ID, a) => new IFC4_3.IfcApproval(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4037036970: (ID, a) => new IFC4_3.IfcBoundaryCondition(ID, a[0]),
  1560379544: (ID, a) => new IFC4_3.IfcBoundaryEdgeCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3367102660: (ID, a) => new IFC4_3.IfcBoundaryFaceCondition(ID, a[0], a[1], a[2], a[3]),
  1387855156: (ID, a) => new IFC4_3.IfcBoundaryNodeCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2069777674: (ID, a) => new IFC4_3.IfcBoundaryNodeConditionWarping(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2859738748: (ID, _) => new IFC4_3.IfcConnectionGeometry(ID),
  2614616156: (ID, a) => new IFC4_3.IfcConnectionPointGeometry(ID, a[0], a[1]),
  2732653382: (ID, a) => new IFC4_3.IfcConnectionSurfaceGeometry(ID, a[0], a[1]),
  775493141: (ID, a) => new IFC4_3.IfcConnectionVolumeGeometry(ID, a[0], a[1]),
  1959218052: (ID, a) => new IFC4_3.IfcConstraint(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1785450214: (ID, a) => new IFC4_3.IfcCoordinateOperation(ID, a[0], a[1]),
  1466758467: (ID, a) => new IFC4_3.IfcCoordinateReferenceSystem(ID, a[0], a[1], a[2], a[3]),
  602808272: (ID, a) => new IFC4_3.IfcCostValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1765591967: (ID, a) => new IFC4_3.IfcDerivedUnit(ID, a[0], a[1], a[2], a[3]),
  1045800335: (ID, a) => new IFC4_3.IfcDerivedUnitElement(ID, a[0], a[1]),
  2949456006: (ID, a) => new IFC4_3.IfcDimensionalExponents(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  4294318154: (ID, _) => new IFC4_3.IfcExternalInformation(ID),
  3200245327: (ID, a) => new IFC4_3.IfcExternalReference(ID, a[0], a[1], a[2]),
  2242383968: (ID, a) => new IFC4_3.IfcExternallyDefinedHatchStyle(ID, a[0], a[1], a[2]),
  1040185647: (ID, a) => new IFC4_3.IfcExternallyDefinedSurfaceStyle(ID, a[0], a[1], a[2]),
  3548104201: (ID, a) => new IFC4_3.IfcExternallyDefinedTextFont(ID, a[0], a[1], a[2]),
  852622518: (ID, a) => new IFC4_3.IfcGridAxis(ID, a[0], a[1], a[2]),
  3020489413: (ID, a) => new IFC4_3.IfcIrregularTimeSeriesValue(ID, a[0], a[1]),
  2655187982: (ID, a) => new IFC4_3.IfcLibraryInformation(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3452421091: (ID, a) => new IFC4_3.IfcLibraryReference(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  4162380809: (ID, a) => new IFC4_3.IfcLightDistributionData(ID, a[0], a[1], a[2]),
  1566485204: (ID, a) => new IFC4_3.IfcLightIntensityDistribution(ID, a[0], a[1]),
  3057273783: (ID, a) => new IFC4_3.IfcMapConversion(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1847130766: (ID, a) => new IFC4_3.IfcMaterialClassificationRelationship(ID, a[0], a[1]),
  760658860: (ID, _) => new IFC4_3.IfcMaterialDefinition(ID),
  248100487: (ID, a) => new IFC4_3.IfcMaterialLayer(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3303938423: (ID, a) => new IFC4_3.IfcMaterialLayerSet(ID, a[0], a[1], a[2]),
  1847252529: (ID, a) => new IFC4_3.IfcMaterialLayerWithOffsets(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2199411900: (ID, a) => new IFC4_3.IfcMaterialList(ID, a[0]),
  2235152071: (ID, a) => new IFC4_3.IfcMaterialProfile(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  164193824: (ID, a) => new IFC4_3.IfcMaterialProfileSet(ID, a[0], a[1], a[2], a[3]),
  552965576: (ID, a) => new IFC4_3.IfcMaterialProfileWithOffsets(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1507914824: (ID, _) => new IFC4_3.IfcMaterialUsageDefinition(ID),
  2597039031: (ID, a) => new IFC4_3.IfcMeasureWithUnit(ID, a[0], a[1]),
  3368373690: (ID, a) => new IFC4_3.IfcMetric(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2706619895: (ID, a) => new IFC4_3.IfcMonetaryUnit(ID, a[0]),
  1918398963: (ID, a) => new IFC4_3.IfcNamedUnit(ID, a[0], a[1]),
  3701648758: (ID, a) => new IFC4_3.IfcObjectPlacement(ID, a[0]),
  2251480897: (ID, a) => new IFC4_3.IfcObjective(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4251960020: (ID, a) => new IFC4_3.IfcOrganization(ID, a[0], a[1], a[2], a[3], a[4]),
  1207048766: (ID, a) => new IFC4_3.IfcOwnerHistory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2077209135: (ID, a) => new IFC4_3.IfcPerson(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  101040310: (ID, a) => new IFC4_3.IfcPersonAndOrganization(ID, a[0], a[1], a[2]),
  2483315170: (ID, a) => new IFC4_3.IfcPhysicalQuantity(ID, a[0], a[1]),
  2226359599: (ID, a) => new IFC4_3.IfcPhysicalSimpleQuantity(ID, a[0], a[1], a[2]),
  3355820592: (ID, a) => new IFC4_3.IfcPostalAddress(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  677532197: (ID, _) => new IFC4_3.IfcPresentationItem(ID),
  2022622350: (ID, a) => new IFC4_3.IfcPresentationLayerAssignment(ID, a[0], a[1], a[2], a[3]),
  1304840413: (ID, a) => new IFC4_3.IfcPresentationLayerWithStyle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3119450353: (ID, a) => new IFC4_3.IfcPresentationStyle(ID, a[0]),
  2095639259: (ID, a) => new IFC4_3.IfcProductRepresentation(ID, a[0], a[1], a[2]),
  3958567839: (ID, a) => new IFC4_3.IfcProfileDef(ID, a[0], a[1]),
  3843373140: (ID, a) => new IFC4_3.IfcProjectedCRS(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  986844984: (ID, _) => new IFC4_3.IfcPropertyAbstraction(ID),
  3710013099: (ID, a) => new IFC4_3.IfcPropertyEnumeration(ID, a[0], a[1], a[2]),
  2044713172: (ID, a) => new IFC4_3.IfcQuantityArea(ID, a[0], a[1], a[2], a[3], a[4]),
  2093928680: (ID, a) => new IFC4_3.IfcQuantityCount(ID, a[0], a[1], a[2], a[3], a[4]),
  931644368: (ID, a) => new IFC4_3.IfcQuantityLength(ID, a[0], a[1], a[2], a[3], a[4]),
  2691318326: (ID, a) => new IFC4_3.IfcQuantityNumber(ID, a[0], a[1], a[2], a[3], a[4]),
  3252649465: (ID, a) => new IFC4_3.IfcQuantityTime(ID, a[0], a[1], a[2], a[3], a[4]),
  2405470396: (ID, a) => new IFC4_3.IfcQuantityVolume(ID, a[0], a[1], a[2], a[3], a[4]),
  825690147: (ID, a) => new IFC4_3.IfcQuantityWeight(ID, a[0], a[1], a[2], a[3], a[4]),
  3915482550: (ID, a) => new IFC4_3.IfcRecurrencePattern(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2433181523: (ID, a) => new IFC4_3.IfcReference(ID, a[0], a[1], a[2], a[3], a[4]),
  1076942058: (ID, a) => new IFC4_3.IfcRepresentation(ID, a[0], a[1], a[2], a[3]),
  3377609919: (ID, a) => new IFC4_3.IfcRepresentationContext(ID, a[0], a[1]),
  3008791417: (ID, _) => new IFC4_3.IfcRepresentationItem(ID),
  1660063152: (ID, a) => new IFC4_3.IfcRepresentationMap(ID, a[0], a[1]),
  2439245199: (ID, a) => new IFC4_3.IfcResourceLevelRelationship(ID, a[0], a[1]),
  2341007311: (ID, a) => new IFC4_3.IfcRoot(ID, a[0], a[1], a[2], a[3]),
  448429030: (ID, a) => new IFC4_3.IfcSIUnit(ID, a[0], a[1], a[2], a[3]),
  1054537805: (ID, a) => new IFC4_3.IfcSchedulingTime(ID, a[0], a[1], a[2]),
  867548509: (ID, a) => new IFC4_3.IfcShapeAspect(ID, a[0], a[1], a[2], a[3], a[4]),
  3982875396: (ID, a) => new IFC4_3.IfcShapeModel(ID, a[0], a[1], a[2], a[3]),
  4240577450: (ID, a) => new IFC4_3.IfcShapeRepresentation(ID, a[0], a[1], a[2], a[3]),
  2273995522: (ID, a) => new IFC4_3.IfcStructuralConnectionCondition(ID, a[0]),
  2162789131: (ID, a) => new IFC4_3.IfcStructuralLoad(ID, a[0]),
  3478079324: (ID, a) => new IFC4_3.IfcStructuralLoadConfiguration(ID, a[0], a[1], a[2]),
  609421318: (ID, a) => new IFC4_3.IfcStructuralLoadOrResult(ID, a[0]),
  2525727697: (ID, a) => new IFC4_3.IfcStructuralLoadStatic(ID, a[0]),
  3408363356: (ID, a) => new IFC4_3.IfcStructuralLoadTemperature(ID, a[0], a[1], a[2], a[3]),
  2830218821: (ID, a) => new IFC4_3.IfcStyleModel(ID, a[0], a[1], a[2], a[3]),
  3958052878: (ID, a) => new IFC4_3.IfcStyledItem(ID, a[0], a[1], a[2]),
  3049322572: (ID, a) => new IFC4_3.IfcStyledRepresentation(ID, a[0], a[1], a[2], a[3]),
  2934153892: (ID, a) => new IFC4_3.IfcSurfaceReinforcementArea(ID, a[0], a[1], a[2], a[3]),
  1300840506: (ID, a) => new IFC4_3.IfcSurfaceStyle(ID, a[0], a[1], a[2]),
  3303107099: (ID, a) => new IFC4_3.IfcSurfaceStyleLighting(ID, a[0], a[1], a[2], a[3]),
  1607154358: (ID, a) => new IFC4_3.IfcSurfaceStyleRefraction(ID, a[0], a[1]),
  846575682: (ID, a) => new IFC4_3.IfcSurfaceStyleShading(ID, a[0], a[1]),
  1351298697: (ID, a) => new IFC4_3.IfcSurfaceStyleWithTextures(ID, a[0]),
  626085974: (ID, a) => new IFC4_3.IfcSurfaceTexture(ID, a[0], a[1], a[2], a[3], a[4]),
  985171141: (ID, a) => new IFC4_3.IfcTable(ID, a[0], a[1], a[2]),
  2043862942: (ID, a) => new IFC4_3.IfcTableColumn(ID, a[0], a[1], a[2], a[3], a[4]),
  531007025: (ID, a) => new IFC4_3.IfcTableRow(ID, a[0], a[1]),
  1549132990: (ID, a) => new IFC4_3.IfcTaskTime(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19]),
  2771591690: (ID, a) => new IFC4_3.IfcTaskTimeRecurring(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20]),
  912023232: (ID, a) => new IFC4_3.IfcTelecomAddress(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1447204868: (ID, a) => new IFC4_3.IfcTextStyle(ID, a[0], a[1], a[2], a[3], a[4]),
  2636378356: (ID, a) => new IFC4_3.IfcTextStyleForDefinedFont(ID, a[0], a[1]),
  1640371178: (ID, a) => new IFC4_3.IfcTextStyleTextModel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  280115917: (ID, a) => new IFC4_3.IfcTextureCoordinate(ID, a[0]),
  1742049831: (ID, a) => new IFC4_3.IfcTextureCoordinateGenerator(ID, a[0], a[1], a[2]),
  222769930: (ID, a) => new IFC4_3.IfcTextureCoordinateIndices(ID, a[0], a[1]),
  1010789467: (ID, a) => new IFC4_3.IfcTextureCoordinateIndicesWithVoids(ID, a[0], a[1], a[2]),
  2552916305: (ID, a) => new IFC4_3.IfcTextureMap(ID, a[0], a[1], a[2]),
  1210645708: (ID, a) => new IFC4_3.IfcTextureVertex(ID, a[0]),
  3611470254: (ID, a) => new IFC4_3.IfcTextureVertexList(ID, a[0]),
  1199560280: (ID, a) => new IFC4_3.IfcTimePeriod(ID, a[0], a[1]),
  3101149627: (ID, a) => new IFC4_3.IfcTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  581633288: (ID, a) => new IFC4_3.IfcTimeSeriesValue(ID, a[0]),
  1377556343: (ID, _) => new IFC4_3.IfcTopologicalRepresentationItem(ID),
  1735638870: (ID, a) => new IFC4_3.IfcTopologyRepresentation(ID, a[0], a[1], a[2], a[3]),
  180925521: (ID, a) => new IFC4_3.IfcUnitAssignment(ID, a[0]),
  2799835756: (ID, _) => new IFC4_3.IfcVertex(ID),
  1907098498: (ID, a) => new IFC4_3.IfcVertexPoint(ID, a[0]),
  891718957: (ID, a) => new IFC4_3.IfcVirtualGridIntersection(ID, a[0], a[1]),
  1236880293: (ID, a) => new IFC4_3.IfcWorkTime(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3752311538: (ID, a) => new IFC4_3.IfcAlignmentCantSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  536804194: (ID, a) => new IFC4_3.IfcAlignmentHorizontalSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3869604511: (ID, a) => new IFC4_3.IfcApprovalRelationship(ID, a[0], a[1], a[2], a[3]),
  3798115385: (ID, a) => new IFC4_3.IfcArbitraryClosedProfileDef(ID, a[0], a[1], a[2]),
  1310608509: (ID, a) => new IFC4_3.IfcArbitraryOpenProfileDef(ID, a[0], a[1], a[2]),
  2705031697: (ID, a) => new IFC4_3.IfcArbitraryProfileDefWithVoids(ID, a[0], a[1], a[2], a[3]),
  616511568: (ID, a) => new IFC4_3.IfcBlobTexture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3150382593: (ID, a) => new IFC4_3.IfcCenterLineProfileDef(ID, a[0], a[1], a[2], a[3]),
  747523909: (ID, a) => new IFC4_3.IfcClassification(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  647927063: (ID, a) => new IFC4_3.IfcClassificationReference(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3285139300: (ID, a) => new IFC4_3.IfcColourRgbList(ID, a[0]),
  3264961684: (ID, a) => new IFC4_3.IfcColourSpecification(ID, a[0]),
  1485152156: (ID, a) => new IFC4_3.IfcCompositeProfileDef(ID, a[0], a[1], a[2], a[3]),
  370225590: (ID, a) => new IFC4_3.IfcConnectedFaceSet(ID, a[0]),
  1981873012: (ID, a) => new IFC4_3.IfcConnectionCurveGeometry(ID, a[0], a[1]),
  45288368: (ID, a) => new IFC4_3.IfcConnectionPointEccentricity(ID, a[0], a[1], a[2], a[3], a[4]),
  3050246964: (ID, a) => new IFC4_3.IfcContextDependentUnit(ID, a[0], a[1], a[2]),
  2889183280: (ID, a) => new IFC4_3.IfcConversionBasedUnit(ID, a[0], a[1], a[2], a[3]),
  2713554722: (ID, a) => new IFC4_3.IfcConversionBasedUnitWithOffset(ID, a[0], a[1], a[2], a[3], a[4]),
  539742890: (ID, a) => new IFC4_3.IfcCurrencyRelationship(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3800577675: (ID, a) => new IFC4_3.IfcCurveStyle(ID, a[0], a[1], a[2], a[3], a[4]),
  1105321065: (ID, a) => new IFC4_3.IfcCurveStyleFont(ID, a[0], a[1]),
  2367409068: (ID, a) => new IFC4_3.IfcCurveStyleFontAndScaling(ID, a[0], a[1], a[2]),
  3510044353: (ID, a) => new IFC4_3.IfcCurveStyleFontPattern(ID, a[0], a[1]),
  3632507154: (ID, a) => new IFC4_3.IfcDerivedProfileDef(ID, a[0], a[1], a[2], a[3], a[4]),
  1154170062: (ID, a) => new IFC4_3.IfcDocumentInformation(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  770865208: (ID, a) => new IFC4_3.IfcDocumentInformationRelationship(ID, a[0], a[1], a[2], a[3], a[4]),
  3732053477: (ID, a) => new IFC4_3.IfcDocumentReference(ID, a[0], a[1], a[2], a[3], a[4]),
  3900360178: (ID, a) => new IFC4_3.IfcEdge(ID, a[0], a[1]),
  476780140: (ID, a) => new IFC4_3.IfcEdgeCurve(ID, a[0], a[1], a[2], a[3]),
  211053100: (ID, a) => new IFC4_3.IfcEventTime(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  297599258: (ID, a) => new IFC4_3.IfcExtendedProperties(ID, a[0], a[1], a[2]),
  1437805879: (ID, a) => new IFC4_3.IfcExternalReferenceRelationship(ID, a[0], a[1], a[2], a[3]),
  2556980723: (ID, a) => new IFC4_3.IfcFace(ID, a[0]),
  1809719519: (ID, a) => new IFC4_3.IfcFaceBound(ID, a[0], a[1]),
  803316827: (ID, a) => new IFC4_3.IfcFaceOuterBound(ID, a[0], a[1]),
  3008276851: (ID, a) => new IFC4_3.IfcFaceSurface(ID, a[0], a[1], a[2]),
  4219587988: (ID, a) => new IFC4_3.IfcFailureConnectionCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  738692330: (ID, a) => new IFC4_3.IfcFillAreaStyle(ID, a[0], a[1], a[2]),
  3448662350: (ID, a) => new IFC4_3.IfcGeometricRepresentationContext(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2453401579: (ID, _) => new IFC4_3.IfcGeometricRepresentationItem(ID),
  4142052618: (ID, a) => new IFC4_3.IfcGeometricRepresentationSubContext(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3590301190: (ID, a) => new IFC4_3.IfcGeometricSet(ID, a[0]),
  178086475: (ID, a) => new IFC4_3.IfcGridPlacement(ID, a[0], a[1], a[2]),
  812098782: (ID, a) => new IFC4_3.IfcHalfSpaceSolid(ID, a[0], a[1]),
  3905492369: (ID, a) => new IFC4_3.IfcImageTexture(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3570813810: (ID, a) => new IFC4_3.IfcIndexedColourMap(ID, a[0], a[1], a[2], a[3]),
  1437953363: (ID, a) => new IFC4_3.IfcIndexedTextureMap(ID, a[0], a[1], a[2]),
  2133299955: (ID, a) => new IFC4_3.IfcIndexedTriangleTextureMap(ID, a[0], a[1], a[2], a[3]),
  3741457305: (ID, a) => new IFC4_3.IfcIrregularTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1585845231: (ID, a) => new IFC4_3.IfcLagTime(ID, a[0], a[1], a[2], a[3], a[4]),
  1402838566: (ID, a) => new IFC4_3.IfcLightSource(ID, a[0], a[1], a[2], a[3]),
  125510826: (ID, a) => new IFC4_3.IfcLightSourceAmbient(ID, a[0], a[1], a[2], a[3]),
  2604431987: (ID, a) => new IFC4_3.IfcLightSourceDirectional(ID, a[0], a[1], a[2], a[3], a[4]),
  4266656042: (ID, a) => new IFC4_3.IfcLightSourceGoniometric(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1520743889: (ID, a) => new IFC4_3.IfcLightSourcePositional(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3422422726: (ID, a) => new IFC4_3.IfcLightSourceSpot(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  388784114: (ID, a) => new IFC4_3.IfcLinearPlacement(ID, a[0], a[1], a[2]),
  2624227202: (ID, a) => new IFC4_3.IfcLocalPlacement(ID, a[0], a[1]),
  1008929658: (ID, _) => new IFC4_3.IfcLoop(ID),
  2347385850: (ID, a) => new IFC4_3.IfcMappedItem(ID, a[0], a[1]),
  1838606355: (ID, a) => new IFC4_3.IfcMaterial(ID, a[0], a[1], a[2]),
  3708119e3: (ID, a) => new IFC4_3.IfcMaterialConstituent(ID, a[0], a[1], a[2], a[3], a[4]),
  2852063980: (ID, a) => new IFC4_3.IfcMaterialConstituentSet(ID, a[0], a[1], a[2]),
  2022407955: (ID, a) => new IFC4_3.IfcMaterialDefinitionRepresentation(ID, a[0], a[1], a[2], a[3]),
  1303795690: (ID, a) => new IFC4_3.IfcMaterialLayerSetUsage(ID, a[0], a[1], a[2], a[3], a[4]),
  3079605661: (ID, a) => new IFC4_3.IfcMaterialProfileSetUsage(ID, a[0], a[1], a[2]),
  3404854881: (ID, a) => new IFC4_3.IfcMaterialProfileSetUsageTapering(ID, a[0], a[1], a[2], a[3], a[4]),
  3265635763: (ID, a) => new IFC4_3.IfcMaterialProperties(ID, a[0], a[1], a[2], a[3]),
  853536259: (ID, a) => new IFC4_3.IfcMaterialRelationship(ID, a[0], a[1], a[2], a[3], a[4]),
  2998442950: (ID, a) => new IFC4_3.IfcMirroredProfileDef(ID, a[0], a[1], a[2], a[3], a[4]),
  219451334: (ID, a) => new IFC4_3.IfcObjectDefinition(ID, a[0], a[1], a[2], a[3]),
  182550632: (ID, a) => new IFC4_3.IfcOpenCrossProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2665983363: (ID, a) => new IFC4_3.IfcOpenShell(ID, a[0]),
  1411181986: (ID, a) => new IFC4_3.IfcOrganizationRelationship(ID, a[0], a[1], a[2], a[3]),
  1029017970: (ID, a) => new IFC4_3.IfcOrientedEdge(ID, a[0], a[1], a[2]),
  2529465313: (ID, a) => new IFC4_3.IfcParameterizedProfileDef(ID, a[0], a[1], a[2]),
  2519244187: (ID, a) => new IFC4_3.IfcPath(ID, a[0]),
  3021840470: (ID, a) => new IFC4_3.IfcPhysicalComplexQuantity(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  597895409: (ID, a) => new IFC4_3.IfcPixelTexture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2004835150: (ID, a) => new IFC4_3.IfcPlacement(ID, a[0]),
  1663979128: (ID, a) => new IFC4_3.IfcPlanarExtent(ID, a[0], a[1]),
  2067069095: (ID, _) => new IFC4_3.IfcPoint(ID),
  2165702409: (ID, a) => new IFC4_3.IfcPointByDistanceExpression(ID, a[0], a[1], a[2], a[3], a[4]),
  4022376103: (ID, a) => new IFC4_3.IfcPointOnCurve(ID, a[0], a[1]),
  1423911732: (ID, a) => new IFC4_3.IfcPointOnSurface(ID, a[0], a[1], a[2]),
  2924175390: (ID, a) => new IFC4_3.IfcPolyLoop(ID, a[0]),
  2775532180: (ID, a) => new IFC4_3.IfcPolygonalBoundedHalfSpace(ID, a[0], a[1], a[2], a[3]),
  3727388367: (ID, a) => new IFC4_3.IfcPreDefinedItem(ID, a[0]),
  3778827333: (ID, _) => new IFC4_3.IfcPreDefinedProperties(ID),
  1775413392: (ID, a) => new IFC4_3.IfcPreDefinedTextFont(ID, a[0]),
  673634403: (ID, a) => new IFC4_3.IfcProductDefinitionShape(ID, a[0], a[1], a[2]),
  2802850158: (ID, a) => new IFC4_3.IfcProfileProperties(ID, a[0], a[1], a[2], a[3]),
  2598011224: (ID, a) => new IFC4_3.IfcProperty(ID, a[0], a[1]),
  1680319473: (ID, a) => new IFC4_3.IfcPropertyDefinition(ID, a[0], a[1], a[2], a[3]),
  148025276: (ID, a) => new IFC4_3.IfcPropertyDependencyRelationship(ID, a[0], a[1], a[2], a[3], a[4]),
  3357820518: (ID, a) => new IFC4_3.IfcPropertySetDefinition(ID, a[0], a[1], a[2], a[3]),
  1482703590: (ID, a) => new IFC4_3.IfcPropertyTemplateDefinition(ID, a[0], a[1], a[2], a[3]),
  2090586900: (ID, a) => new IFC4_3.IfcQuantitySet(ID, a[0], a[1], a[2], a[3]),
  3615266464: (ID, a) => new IFC4_3.IfcRectangleProfileDef(ID, a[0], a[1], a[2], a[3], a[4]),
  3413951693: (ID, a) => new IFC4_3.IfcRegularTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1580146022: (ID, a) => new IFC4_3.IfcReinforcementBarProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  478536968: (ID, a) => new IFC4_3.IfcRelationship(ID, a[0], a[1], a[2], a[3]),
  2943643501: (ID, a) => new IFC4_3.IfcResourceApprovalRelationship(ID, a[0], a[1], a[2], a[3]),
  1608871552: (ID, a) => new IFC4_3.IfcResourceConstraintRelationship(ID, a[0], a[1], a[2], a[3]),
  1042787934: (ID, a) => new IFC4_3.IfcResourceTime(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17]),
  2778083089: (ID, a) => new IFC4_3.IfcRoundedRectangleProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2042790032: (ID, a) => new IFC4_3.IfcSectionProperties(ID, a[0], a[1], a[2]),
  4165799628: (ID, a) => new IFC4_3.IfcSectionReinforcementProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1509187699: (ID, a) => new IFC4_3.IfcSectionedSpine(ID, a[0], a[1], a[2]),
  823603102: (ID, a) => new IFC4_3.IfcSegment(ID, a[0]),
  4124623270: (ID, a) => new IFC4_3.IfcShellBasedSurfaceModel(ID, a[0]),
  3692461612: (ID, a) => new IFC4_3.IfcSimpleProperty(ID, a[0], a[1]),
  2609359061: (ID, a) => new IFC4_3.IfcSlippageConnectionCondition(ID, a[0], a[1], a[2], a[3]),
  723233188: (ID, _) => new IFC4_3.IfcSolidModel(ID),
  1595516126: (ID, a) => new IFC4_3.IfcStructuralLoadLinearForce(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2668620305: (ID, a) => new IFC4_3.IfcStructuralLoadPlanarForce(ID, a[0], a[1], a[2], a[3]),
  2473145415: (ID, a) => new IFC4_3.IfcStructuralLoadSingleDisplacement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1973038258: (ID, a) => new IFC4_3.IfcStructuralLoadSingleDisplacementDistortion(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1597423693: (ID, a) => new IFC4_3.IfcStructuralLoadSingleForce(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1190533807: (ID, a) => new IFC4_3.IfcStructuralLoadSingleForceWarping(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2233826070: (ID, a) => new IFC4_3.IfcSubedge(ID, a[0], a[1], a[2]),
  2513912981: (ID, _) => new IFC4_3.IfcSurface(ID),
  1878645084: (ID, a) => new IFC4_3.IfcSurfaceStyleRendering(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2247615214: (ID, a) => new IFC4_3.IfcSweptAreaSolid(ID, a[0], a[1]),
  1260650574: (ID, a) => new IFC4_3.IfcSweptDiskSolid(ID, a[0], a[1], a[2], a[3], a[4]),
  1096409881: (ID, a) => new IFC4_3.IfcSweptDiskSolidPolygonal(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  230924584: (ID, a) => new IFC4_3.IfcSweptSurface(ID, a[0], a[1]),
  3071757647: (ID, a) => new IFC4_3.IfcTShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  901063453: (ID, _) => new IFC4_3.IfcTessellatedItem(ID),
  4282788508: (ID, a) => new IFC4_3.IfcTextLiteral(ID, a[0], a[1], a[2]),
  3124975700: (ID, a) => new IFC4_3.IfcTextLiteralWithExtent(ID, a[0], a[1], a[2], a[3], a[4]),
  1983826977: (ID, a) => new IFC4_3.IfcTextStyleFontModel(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2715220739: (ID, a) => new IFC4_3.IfcTrapeziumProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1628702193: (ID, a) => new IFC4_3.IfcTypeObject(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3736923433: (ID, a) => new IFC4_3.IfcTypeProcess(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2347495698: (ID, a) => new IFC4_3.IfcTypeProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3698973494: (ID, a) => new IFC4_3.IfcTypeResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  427810014: (ID, a) => new IFC4_3.IfcUShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1417489154: (ID, a) => new IFC4_3.IfcVector(ID, a[0], a[1]),
  2759199220: (ID, a) => new IFC4_3.IfcVertexLoop(ID, a[0]),
  2543172580: (ID, a) => new IFC4_3.IfcZShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3406155212: (ID, a) => new IFC4_3.IfcAdvancedFace(ID, a[0], a[1], a[2]),
  669184980: (ID, a) => new IFC4_3.IfcAnnotationFillArea(ID, a[0], a[1]),
  3207858831: (ID, a) => new IFC4_3.IfcAsymmetricIShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
  4261334040: (ID, a) => new IFC4_3.IfcAxis1Placement(ID, a[0], a[1]),
  3125803723: (ID, a) => new IFC4_3.IfcAxis2Placement2D(ID, a[0], a[1]),
  2740243338: (ID, a) => new IFC4_3.IfcAxis2Placement3D(ID, a[0], a[1], a[2]),
  3425423356: (ID, a) => new IFC4_3.IfcAxis2PlacementLinear(ID, a[0], a[1], a[2]),
  2736907675: (ID, a) => new IFC4_3.IfcBooleanResult(ID, a[0], a[1], a[2]),
  4182860854: (ID, _) => new IFC4_3.IfcBoundedSurface(ID),
  2581212453: (ID, a) => new IFC4_3.IfcBoundingBox(ID, a[0], a[1], a[2], a[3]),
  2713105998: (ID, a) => new IFC4_3.IfcBoxedHalfSpace(ID, a[0], a[1], a[2]),
  2898889636: (ID, a) => new IFC4_3.IfcCShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1123145078: (ID, a) => new IFC4_3.IfcCartesianPoint(ID, a[0]),
  574549367: (ID, _) => new IFC4_3.IfcCartesianPointList(ID),
  1675464909: (ID, a) => new IFC4_3.IfcCartesianPointList2D(ID, a[0], a[1]),
  2059837836: (ID, a) => new IFC4_3.IfcCartesianPointList3D(ID, a[0], a[1]),
  59481748: (ID, a) => new IFC4_3.IfcCartesianTransformationOperator(ID, a[0], a[1], a[2], a[3]),
  3749851601: (ID, a) => new IFC4_3.IfcCartesianTransformationOperator2D(ID, a[0], a[1], a[2], a[3]),
  3486308946: (ID, a) => new IFC4_3.IfcCartesianTransformationOperator2DnonUniform(ID, a[0], a[1], a[2], a[3], a[4]),
  3331915920: (ID, a) => new IFC4_3.IfcCartesianTransformationOperator3D(ID, a[0], a[1], a[2], a[3], a[4]),
  1416205885: (ID, a) => new IFC4_3.IfcCartesianTransformationOperator3DnonUniform(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1383045692: (ID, a) => new IFC4_3.IfcCircleProfileDef(ID, a[0], a[1], a[2], a[3]),
  2205249479: (ID, a) => new IFC4_3.IfcClosedShell(ID, a[0]),
  776857604: (ID, a) => new IFC4_3.IfcColourRgb(ID, a[0], a[1], a[2], a[3]),
  2542286263: (ID, a) => new IFC4_3.IfcComplexProperty(ID, a[0], a[1], a[2], a[3]),
  2485617015: (ID, a) => new IFC4_3.IfcCompositeCurveSegment(ID, a[0], a[1], a[2]),
  2574617495: (ID, a) => new IFC4_3.IfcConstructionResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3419103109: (ID, a) => new IFC4_3.IfcContext(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1815067380: (ID, a) => new IFC4_3.IfcCrewResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2506170314: (ID, a) => new IFC4_3.IfcCsgPrimitive3D(ID, a[0]),
  2147822146: (ID, a) => new IFC4_3.IfcCsgSolid(ID, a[0]),
  2601014836: (ID, _) => new IFC4_3.IfcCurve(ID),
  2827736869: (ID, a) => new IFC4_3.IfcCurveBoundedPlane(ID, a[0], a[1], a[2]),
  2629017746: (ID, a) => new IFC4_3.IfcCurveBoundedSurface(ID, a[0], a[1], a[2]),
  4212018352: (ID, a) => new IFC4_3.IfcCurveSegment(ID, a[0], a[1], a[2], a[3], a[4]),
  32440307: (ID, a) => new IFC4_3.IfcDirection(ID, a[0]),
  593015953: (ID, a) => new IFC4_3.IfcDirectrixCurveSweptAreaSolid(ID, a[0], a[1], a[2], a[3], a[4]),
  1472233963: (ID, a) => new IFC4_3.IfcEdgeLoop(ID, a[0]),
  1883228015: (ID, a) => new IFC4_3.IfcElementQuantity(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  339256511: (ID, a) => new IFC4_3.IfcElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2777663545: (ID, a) => new IFC4_3.IfcElementarySurface(ID, a[0]),
  2835456948: (ID, a) => new IFC4_3.IfcEllipseProfileDef(ID, a[0], a[1], a[2], a[3], a[4]),
  4024345920: (ID, a) => new IFC4_3.IfcEventType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  477187591: (ID, a) => new IFC4_3.IfcExtrudedAreaSolid(ID, a[0], a[1], a[2], a[3]),
  2804161546: (ID, a) => new IFC4_3.IfcExtrudedAreaSolidTapered(ID, a[0], a[1], a[2], a[3], a[4]),
  2047409740: (ID, a) => new IFC4_3.IfcFaceBasedSurfaceModel(ID, a[0]),
  374418227: (ID, a) => new IFC4_3.IfcFillAreaStyleHatching(ID, a[0], a[1], a[2], a[3], a[4]),
  315944413: (ID, a) => new IFC4_3.IfcFillAreaStyleTiles(ID, a[0], a[1], a[2]),
  2652556860: (ID, a) => new IFC4_3.IfcFixedReferenceSweptAreaSolid(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  4238390223: (ID, a) => new IFC4_3.IfcFurnishingElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1268542332: (ID, a) => new IFC4_3.IfcFurnitureType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4095422895: (ID, a) => new IFC4_3.IfcGeographicElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  987898635: (ID, a) => new IFC4_3.IfcGeometricCurveSet(ID, a[0]),
  1484403080: (ID, a) => new IFC4_3.IfcIShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  178912537: (ID, a) => new IFC4_3.IfcIndexedPolygonalFace(ID, a[0]),
  2294589976: (ID, a) => new IFC4_3.IfcIndexedPolygonalFaceWithVoids(ID, a[0], a[1]),
  3465909080: (ID, a) => new IFC4_3.IfcIndexedPolygonalTextureMap(ID, a[0], a[1], a[2], a[3]),
  572779678: (ID, a) => new IFC4_3.IfcLShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  428585644: (ID, a) => new IFC4_3.IfcLaborResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1281925730: (ID, a) => new IFC4_3.IfcLine(ID, a[0], a[1]),
  1425443689: (ID, a) => new IFC4_3.IfcManifoldSolidBrep(ID, a[0]),
  3888040117: (ID, a) => new IFC4_3.IfcObject(ID, a[0], a[1], a[2], a[3], a[4]),
  590820931: (ID, a) => new IFC4_3.IfcOffsetCurve(ID, a[0]),
  3388369263: (ID, a) => new IFC4_3.IfcOffsetCurve2D(ID, a[0], a[1], a[2]),
  3505215534: (ID, a) => new IFC4_3.IfcOffsetCurve3D(ID, a[0], a[1], a[2], a[3]),
  2485787929: (ID, a) => new IFC4_3.IfcOffsetCurveByDistances(ID, a[0], a[1], a[2]),
  1682466193: (ID, a) => new IFC4_3.IfcPcurve(ID, a[0], a[1]),
  603570806: (ID, a) => new IFC4_3.IfcPlanarBox(ID, a[0], a[1], a[2]),
  220341763: (ID, a) => new IFC4_3.IfcPlane(ID, a[0]),
  3381221214: (ID, a) => new IFC4_3.IfcPolynomialCurve(ID, a[0], a[1], a[2], a[3]),
  759155922: (ID, a) => new IFC4_3.IfcPreDefinedColour(ID, a[0]),
  2559016684: (ID, a) => new IFC4_3.IfcPreDefinedCurveFont(ID, a[0]),
  3967405729: (ID, a) => new IFC4_3.IfcPreDefinedPropertySet(ID, a[0], a[1], a[2], a[3]),
  569719735: (ID, a) => new IFC4_3.IfcProcedureType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2945172077: (ID, a) => new IFC4_3.IfcProcess(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  4208778838: (ID, a) => new IFC4_3.IfcProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  103090709: (ID, a) => new IFC4_3.IfcProject(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  653396225: (ID, a) => new IFC4_3.IfcProjectLibrary(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  871118103: (ID, a) => new IFC4_3.IfcPropertyBoundedValue(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  4166981789: (ID, a) => new IFC4_3.IfcPropertyEnumeratedValue(ID, a[0], a[1], a[2], a[3]),
  2752243245: (ID, a) => new IFC4_3.IfcPropertyListValue(ID, a[0], a[1], a[2], a[3]),
  941946838: (ID, a) => new IFC4_3.IfcPropertyReferenceValue(ID, a[0], a[1], a[2], a[3]),
  1451395588: (ID, a) => new IFC4_3.IfcPropertySet(ID, a[0], a[1], a[2], a[3], a[4]),
  492091185: (ID, a) => new IFC4_3.IfcPropertySetTemplate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3650150729: (ID, a) => new IFC4_3.IfcPropertySingleValue(ID, a[0], a[1], a[2], a[3]),
  110355661: (ID, a) => new IFC4_3.IfcPropertyTableValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3521284610: (ID, a) => new IFC4_3.IfcPropertyTemplate(ID, a[0], a[1], a[2], a[3]),
  2770003689: (ID, a) => new IFC4_3.IfcRectangleHollowProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2798486643: (ID, a) => new IFC4_3.IfcRectangularPyramid(ID, a[0], a[1], a[2], a[3]),
  3454111270: (ID, a) => new IFC4_3.IfcRectangularTrimmedSurface(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3765753017: (ID, a) => new IFC4_3.IfcReinforcementDefinitionProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3939117080: (ID, a) => new IFC4_3.IfcRelAssigns(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1683148259: (ID, a) => new IFC4_3.IfcRelAssignsToActor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2495723537: (ID, a) => new IFC4_3.IfcRelAssignsToControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1307041759: (ID, a) => new IFC4_3.IfcRelAssignsToGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1027710054: (ID, a) => new IFC4_3.IfcRelAssignsToGroupByFactor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4278684876: (ID, a) => new IFC4_3.IfcRelAssignsToProcess(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2857406711: (ID, a) => new IFC4_3.IfcRelAssignsToProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  205026976: (ID, a) => new IFC4_3.IfcRelAssignsToResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1865459582: (ID, a) => new IFC4_3.IfcRelAssociates(ID, a[0], a[1], a[2], a[3], a[4]),
  4095574036: (ID, a) => new IFC4_3.IfcRelAssociatesApproval(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  919958153: (ID, a) => new IFC4_3.IfcRelAssociatesClassification(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2728634034: (ID, a) => new IFC4_3.IfcRelAssociatesConstraint(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  982818633: (ID, a) => new IFC4_3.IfcRelAssociatesDocument(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3840914261: (ID, a) => new IFC4_3.IfcRelAssociatesLibrary(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2655215786: (ID, a) => new IFC4_3.IfcRelAssociatesMaterial(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1033248425: (ID, a) => new IFC4_3.IfcRelAssociatesProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  826625072: (ID, a) => new IFC4_3.IfcRelConnects(ID, a[0], a[1], a[2], a[3]),
  1204542856: (ID, a) => new IFC4_3.IfcRelConnectsElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3945020480: (ID, a) => new IFC4_3.IfcRelConnectsPathElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4201705270: (ID, a) => new IFC4_3.IfcRelConnectsPortToElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3190031847: (ID, a) => new IFC4_3.IfcRelConnectsPorts(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2127690289: (ID, a) => new IFC4_3.IfcRelConnectsStructuralActivity(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1638771189: (ID, a) => new IFC4_3.IfcRelConnectsStructuralMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  504942748: (ID, a) => new IFC4_3.IfcRelConnectsWithEccentricity(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3678494232: (ID, a) => new IFC4_3.IfcRelConnectsWithRealizingElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3242617779: (ID, a) => new IFC4_3.IfcRelContainedInSpatialStructure(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  886880790: (ID, a) => new IFC4_3.IfcRelCoversBldgElements(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2802773753: (ID, a) => new IFC4_3.IfcRelCoversSpaces(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2565941209: (ID, a) => new IFC4_3.IfcRelDeclares(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2551354335: (ID, a) => new IFC4_3.IfcRelDecomposes(ID, a[0], a[1], a[2], a[3]),
  693640335: (ID, a) => new IFC4_3.IfcRelDefines(ID, a[0], a[1], a[2], a[3]),
  1462361463: (ID, a) => new IFC4_3.IfcRelDefinesByObject(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  4186316022: (ID, a) => new IFC4_3.IfcRelDefinesByProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  307848117: (ID, a) => new IFC4_3.IfcRelDefinesByTemplate(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  781010003: (ID, a) => new IFC4_3.IfcRelDefinesByType(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3940055652: (ID, a) => new IFC4_3.IfcRelFillsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  279856033: (ID, a) => new IFC4_3.IfcRelFlowControlElements(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  427948657: (ID, a) => new IFC4_3.IfcRelInterferesElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3268803585: (ID, a) => new IFC4_3.IfcRelNests(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1441486842: (ID, a) => new IFC4_3.IfcRelPositions(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  750771296: (ID, a) => new IFC4_3.IfcRelProjectsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1245217292: (ID, a) => new IFC4_3.IfcRelReferencedInSpatialStructure(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  4122056220: (ID, a) => new IFC4_3.IfcRelSequence(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  366585022: (ID, a) => new IFC4_3.IfcRelServicesBuildings(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3451746338: (ID, a) => new IFC4_3.IfcRelSpaceBoundary(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3523091289: (ID, a) => new IFC4_3.IfcRelSpaceBoundary1stLevel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1521410863: (ID, a) => new IFC4_3.IfcRelSpaceBoundary2ndLevel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1401173127: (ID, a) => new IFC4_3.IfcRelVoidsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  816062949: (ID, a) => new IFC4_3.IfcReparametrisedCompositeCurveSegment(ID, a[0], a[1], a[2], a[3]),
  2914609552: (ID, a) => new IFC4_3.IfcResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1856042241: (ID, a) => new IFC4_3.IfcRevolvedAreaSolid(ID, a[0], a[1], a[2], a[3]),
  3243963512: (ID, a) => new IFC4_3.IfcRevolvedAreaSolidTapered(ID, a[0], a[1], a[2], a[3], a[4]),
  4158566097: (ID, a) => new IFC4_3.IfcRightCircularCone(ID, a[0], a[1], a[2]),
  3626867408: (ID, a) => new IFC4_3.IfcRightCircularCylinder(ID, a[0], a[1], a[2]),
  1862484736: (ID, a) => new IFC4_3.IfcSectionedSolid(ID, a[0], a[1]),
  1290935644: (ID, a) => new IFC4_3.IfcSectionedSolidHorizontal(ID, a[0], a[1], a[2]),
  1356537516: (ID, a) => new IFC4_3.IfcSectionedSurface(ID, a[0], a[1], a[2]),
  3663146110: (ID, a) => new IFC4_3.IfcSimplePropertyTemplate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1412071761: (ID, a) => new IFC4_3.IfcSpatialElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  710998568: (ID, a) => new IFC4_3.IfcSpatialElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2706606064: (ID, a) => new IFC4_3.IfcSpatialStructureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3893378262: (ID, a) => new IFC4_3.IfcSpatialStructureElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  463610769: (ID, a) => new IFC4_3.IfcSpatialZone(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2481509218: (ID, a) => new IFC4_3.IfcSpatialZoneType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  451544542: (ID, a) => new IFC4_3.IfcSphere(ID, a[0], a[1]),
  4015995234: (ID, a) => new IFC4_3.IfcSphericalSurface(ID, a[0], a[1]),
  2735484536: (ID, a) => new IFC4_3.IfcSpiral(ID, a[0]),
  3544373492: (ID, a) => new IFC4_3.IfcStructuralActivity(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3136571912: (ID, a) => new IFC4_3.IfcStructuralItem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  530289379: (ID, a) => new IFC4_3.IfcStructuralMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3689010777: (ID, a) => new IFC4_3.IfcStructuralReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3979015343: (ID, a) => new IFC4_3.IfcStructuralSurfaceMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2218152070: (ID, a) => new IFC4_3.IfcStructuralSurfaceMemberVarying(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  603775116: (ID, a) => new IFC4_3.IfcStructuralSurfaceReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4095615324: (ID, a) => new IFC4_3.IfcSubContractResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  699246055: (ID, a) => new IFC4_3.IfcSurfaceCurve(ID, a[0], a[1], a[2]),
  2028607225: (ID, a) => new IFC4_3.IfcSurfaceCurveSweptAreaSolid(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2809605785: (ID, a) => new IFC4_3.IfcSurfaceOfLinearExtrusion(ID, a[0], a[1], a[2], a[3]),
  4124788165: (ID, a) => new IFC4_3.IfcSurfaceOfRevolution(ID, a[0], a[1], a[2]),
  1580310250: (ID, a) => new IFC4_3.IfcSystemFurnitureElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3473067441: (ID, a) => new IFC4_3.IfcTask(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  3206491090: (ID, a) => new IFC4_3.IfcTaskType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2387106220: (ID, a) => new IFC4_3.IfcTessellatedFaceSet(ID, a[0], a[1]),
  782932809: (ID, a) => new IFC4_3.IfcThirdOrderPolynomialSpiral(ID, a[0], a[1], a[2], a[3], a[4]),
  1935646853: (ID, a) => new IFC4_3.IfcToroidalSurface(ID, a[0], a[1], a[2]),
  3665877780: (ID, a) => new IFC4_3.IfcTransportationDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2916149573: (ID, a) => new IFC4_3.IfcTriangulatedFaceSet(ID, a[0], a[1], a[2], a[3], a[4]),
  1229763772: (ID, a) => new IFC4_3.IfcTriangulatedIrregularNetwork(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3651464721: (ID, a) => new IFC4_3.IfcVehicleType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  336235671: (ID, a) => new IFC4_3.IfcWindowLiningProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]),
  512836454: (ID, a) => new IFC4_3.IfcWindowPanelProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2296667514: (ID, a) => new IFC4_3.IfcActor(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1635779807: (ID, a) => new IFC4_3.IfcAdvancedBrep(ID, a[0]),
  2603310189: (ID, a) => new IFC4_3.IfcAdvancedBrepWithVoids(ID, a[0], a[1]),
  1674181508: (ID, a) => new IFC4_3.IfcAnnotation(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2887950389: (ID, a) => new IFC4_3.IfcBSplineSurface(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  167062518: (ID, a) => new IFC4_3.IfcBSplineSurfaceWithKnots(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1334484129: (ID, a) => new IFC4_3.IfcBlock(ID, a[0], a[1], a[2], a[3]),
  3649129432: (ID, a) => new IFC4_3.IfcBooleanClippingResult(ID, a[0], a[1], a[2]),
  1260505505: (ID, _) => new IFC4_3.IfcBoundedCurve(ID),
  3124254112: (ID, a) => new IFC4_3.IfcBuildingStorey(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1626504194: (ID, a) => new IFC4_3.IfcBuiltElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2197970202: (ID, a) => new IFC4_3.IfcChimneyType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2937912522: (ID, a) => new IFC4_3.IfcCircleHollowProfileDef(ID, a[0], a[1], a[2], a[3], a[4]),
  3893394355: (ID, a) => new IFC4_3.IfcCivilElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3497074424: (ID, a) => new IFC4_3.IfcClothoid(ID, a[0], a[1]),
  300633059: (ID, a) => new IFC4_3.IfcColumnType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3875453745: (ID, a) => new IFC4_3.IfcComplexPropertyTemplate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3732776249: (ID, a) => new IFC4_3.IfcCompositeCurve(ID, a[0], a[1]),
  15328376: (ID, a) => new IFC4_3.IfcCompositeCurveOnSurface(ID, a[0], a[1]),
  2510884976: (ID, a) => new IFC4_3.IfcConic(ID, a[0]),
  2185764099: (ID, a) => new IFC4_3.IfcConstructionEquipmentResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  4105962743: (ID, a) => new IFC4_3.IfcConstructionMaterialResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1525564444: (ID, a) => new IFC4_3.IfcConstructionProductResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2559216714: (ID, a) => new IFC4_3.IfcConstructionResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3293443760: (ID, a) => new IFC4_3.IfcControl(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2000195564: (ID, a) => new IFC4_3.IfcCosineSpiral(ID, a[0], a[1], a[2]),
  3895139033: (ID, a) => new IFC4_3.IfcCostItem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1419761937: (ID, a) => new IFC4_3.IfcCostSchedule(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4189326743: (ID, a) => new IFC4_3.IfcCourseType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1916426348: (ID, a) => new IFC4_3.IfcCoveringType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3295246426: (ID, a) => new IFC4_3.IfcCrewResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1457835157: (ID, a) => new IFC4_3.IfcCurtainWallType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1213902940: (ID, a) => new IFC4_3.IfcCylindricalSurface(ID, a[0], a[1]),
  1306400036: (ID, a) => new IFC4_3.IfcDeepFoundationType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4234616927: (ID, a) => new IFC4_3.IfcDirectrixDerivedReferenceSweptAreaSolid(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3256556792: (ID, a) => new IFC4_3.IfcDistributionElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3849074793: (ID, a) => new IFC4_3.IfcDistributionFlowElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2963535650: (ID, a) => new IFC4_3.IfcDoorLiningProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  1714330368: (ID, a) => new IFC4_3.IfcDoorPanelProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2323601079: (ID, a) => new IFC4_3.IfcDoorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  445594917: (ID, a) => new IFC4_3.IfcDraughtingPreDefinedColour(ID, a[0]),
  4006246654: (ID, a) => new IFC4_3.IfcDraughtingPreDefinedCurveFont(ID, a[0]),
  1758889154: (ID, a) => new IFC4_3.IfcElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4123344466: (ID, a) => new IFC4_3.IfcElementAssembly(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2397081782: (ID, a) => new IFC4_3.IfcElementAssemblyType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1623761950: (ID, a) => new IFC4_3.IfcElementComponent(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2590856083: (ID, a) => new IFC4_3.IfcElementComponentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1704287377: (ID, a) => new IFC4_3.IfcEllipse(ID, a[0], a[1], a[2]),
  2107101300: (ID, a) => new IFC4_3.IfcEnergyConversionDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  132023988: (ID, a) => new IFC4_3.IfcEngineType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3174744832: (ID, a) => new IFC4_3.IfcEvaporativeCoolerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3390157468: (ID, a) => new IFC4_3.IfcEvaporatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4148101412: (ID, a) => new IFC4_3.IfcEvent(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2853485674: (ID, a) => new IFC4_3.IfcExternalSpatialStructureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  807026263: (ID, a) => new IFC4_3.IfcFacetedBrep(ID, a[0]),
  3737207727: (ID, a) => new IFC4_3.IfcFacetedBrepWithVoids(ID, a[0], a[1]),
  24185140: (ID, a) => new IFC4_3.IfcFacility(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1310830890: (ID, a) => new IFC4_3.IfcFacilityPart(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4228831410: (ID, a) => new IFC4_3.IfcFacilityPartCommon(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  647756555: (ID, a) => new IFC4_3.IfcFastener(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2489546625: (ID, a) => new IFC4_3.IfcFastenerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2827207264: (ID, a) => new IFC4_3.IfcFeatureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2143335405: (ID, a) => new IFC4_3.IfcFeatureElementAddition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1287392070: (ID, a) => new IFC4_3.IfcFeatureElementSubtraction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3907093117: (ID, a) => new IFC4_3.IfcFlowControllerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3198132628: (ID, a) => new IFC4_3.IfcFlowFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3815607619: (ID, a) => new IFC4_3.IfcFlowMeterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1482959167: (ID, a) => new IFC4_3.IfcFlowMovingDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1834744321: (ID, a) => new IFC4_3.IfcFlowSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1339347760: (ID, a) => new IFC4_3.IfcFlowStorageDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2297155007: (ID, a) => new IFC4_3.IfcFlowTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3009222698: (ID, a) => new IFC4_3.IfcFlowTreatmentDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1893162501: (ID, a) => new IFC4_3.IfcFootingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  263784265: (ID, a) => new IFC4_3.IfcFurnishingElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1509553395: (ID, a) => new IFC4_3.IfcFurniture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3493046030: (ID, a) => new IFC4_3.IfcGeographicElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4230923436: (ID, a) => new IFC4_3.IfcGeotechnicalElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1594536857: (ID, a) => new IFC4_3.IfcGeotechnicalStratum(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2898700619: (ID, a) => new IFC4_3.IfcGradientCurve(ID, a[0], a[1], a[2], a[3]),
  2706460486: (ID, a) => new IFC4_3.IfcGroup(ID, a[0], a[1], a[2], a[3], a[4]),
  1251058090: (ID, a) => new IFC4_3.IfcHeatExchangerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1806887404: (ID, a) => new IFC4_3.IfcHumidifierType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2568555532: (ID, a) => new IFC4_3.IfcImpactProtectionDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3948183225: (ID, a) => new IFC4_3.IfcImpactProtectionDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2571569899: (ID, a) => new IFC4_3.IfcIndexedPolyCurve(ID, a[0], a[1], a[2]),
  3946677679: (ID, a) => new IFC4_3.IfcInterceptorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3113134337: (ID, a) => new IFC4_3.IfcIntersectionCurve(ID, a[0], a[1], a[2]),
  2391368822: (ID, a) => new IFC4_3.IfcInventory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4288270099: (ID, a) => new IFC4_3.IfcJunctionBoxType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  679976338: (ID, a) => new IFC4_3.IfcKerbType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3827777499: (ID, a) => new IFC4_3.IfcLaborResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1051575348: (ID, a) => new IFC4_3.IfcLampType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1161773419: (ID, a) => new IFC4_3.IfcLightFixtureType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2176059722: (ID, a) => new IFC4_3.IfcLinearElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1770583370: (ID, a) => new IFC4_3.IfcLiquidTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  525669439: (ID, a) => new IFC4_3.IfcMarineFacility(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  976884017: (ID, a) => new IFC4_3.IfcMarinePart(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  377706215: (ID, a) => new IFC4_3.IfcMechanicalFastener(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2108223431: (ID, a) => new IFC4_3.IfcMechanicalFastenerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1114901282: (ID, a) => new IFC4_3.IfcMedicalDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3181161470: (ID, a) => new IFC4_3.IfcMemberType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1950438474: (ID, a) => new IFC4_3.IfcMobileTelecommunicationsApplianceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  710110818: (ID, a) => new IFC4_3.IfcMooringDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  977012517: (ID, a) => new IFC4_3.IfcMotorConnectionType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  506776471: (ID, a) => new IFC4_3.IfcNavigationElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4143007308: (ID, a) => new IFC4_3.IfcOccupant(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3588315303: (ID, a) => new IFC4_3.IfcOpeningElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2837617999: (ID, a) => new IFC4_3.IfcOutletType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  514975943: (ID, a) => new IFC4_3.IfcPavementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2382730787: (ID, a) => new IFC4_3.IfcPerformanceHistory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3566463478: (ID, a) => new IFC4_3.IfcPermeableCoveringProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3327091369: (ID, a) => new IFC4_3.IfcPermit(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1158309216: (ID, a) => new IFC4_3.IfcPileType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  804291784: (ID, a) => new IFC4_3.IfcPipeFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4231323485: (ID, a) => new IFC4_3.IfcPipeSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4017108033: (ID, a) => new IFC4_3.IfcPlateType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2839578677: (ID, a) => new IFC4_3.IfcPolygonalFaceSet(ID, a[0], a[1], a[2], a[3]),
  3724593414: (ID, a) => new IFC4_3.IfcPolyline(ID, a[0]),
  3740093272: (ID, a) => new IFC4_3.IfcPort(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1946335990: (ID, a) => new IFC4_3.IfcPositioningElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2744685151: (ID, a) => new IFC4_3.IfcProcedure(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2904328755: (ID, a) => new IFC4_3.IfcProjectOrder(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3651124850: (ID, a) => new IFC4_3.IfcProjectionElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1842657554: (ID, a) => new IFC4_3.IfcProtectiveDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2250791053: (ID, a) => new IFC4_3.IfcPumpType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1763565496: (ID, a) => new IFC4_3.IfcRailType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2893384427: (ID, a) => new IFC4_3.IfcRailingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3992365140: (ID, a) => new IFC4_3.IfcRailway(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1891881377: (ID, a) => new IFC4_3.IfcRailwayPart(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2324767716: (ID, a) => new IFC4_3.IfcRampFlightType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1469900589: (ID, a) => new IFC4_3.IfcRampType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  683857671: (ID, a) => new IFC4_3.IfcRationalBSplineSurfaceWithKnots(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  4021432810: (ID, a) => new IFC4_3.IfcReferent(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3027567501: (ID, a) => new IFC4_3.IfcReinforcingElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  964333572: (ID, a) => new IFC4_3.IfcReinforcingElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2320036040: (ID, a) => new IFC4_3.IfcReinforcingMesh(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17]),
  2310774935: (ID, a) => new IFC4_3.IfcReinforcingMeshType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19]),
  3818125796: (ID, a) => new IFC4_3.IfcRelAdheresToElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  160246688: (ID, a) => new IFC4_3.IfcRelAggregates(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  146592293: (ID, a) => new IFC4_3.IfcRoad(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  550521510: (ID, a) => new IFC4_3.IfcRoadPart(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2781568857: (ID, a) => new IFC4_3.IfcRoofType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1768891740: (ID, a) => new IFC4_3.IfcSanitaryTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2157484638: (ID, a) => new IFC4_3.IfcSeamCurve(ID, a[0], a[1], a[2]),
  3649235739: (ID, a) => new IFC4_3.IfcSecondOrderPolynomialSpiral(ID, a[0], a[1], a[2], a[3]),
  544395925: (ID, a) => new IFC4_3.IfcSegmentedReferenceCurve(ID, a[0], a[1], a[2], a[3]),
  1027922057: (ID, a) => new IFC4_3.IfcSeventhOrderPolynomialSpiral(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4074543187: (ID, a) => new IFC4_3.IfcShadingDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  33720170: (ID, a) => new IFC4_3.IfcSign(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3599934289: (ID, a) => new IFC4_3.IfcSignType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1894708472: (ID, a) => new IFC4_3.IfcSignalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  42703149: (ID, a) => new IFC4_3.IfcSineSpiral(ID, a[0], a[1], a[2], a[3]),
  4097777520: (ID, a) => new IFC4_3.IfcSite(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  2533589738: (ID, a) => new IFC4_3.IfcSlabType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1072016465: (ID, a) => new IFC4_3.IfcSolarDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3856911033: (ID, a) => new IFC4_3.IfcSpace(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1305183839: (ID, a) => new IFC4_3.IfcSpaceHeaterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3812236995: (ID, a) => new IFC4_3.IfcSpaceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3112655638: (ID, a) => new IFC4_3.IfcStackTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1039846685: (ID, a) => new IFC4_3.IfcStairFlightType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  338393293: (ID, a) => new IFC4_3.IfcStairType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  682877961: (ID, a) => new IFC4_3.IfcStructuralAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1179482911: (ID, a) => new IFC4_3.IfcStructuralConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1004757350: (ID, a) => new IFC4_3.IfcStructuralCurveAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  4243806635: (ID, a) => new IFC4_3.IfcStructuralCurveConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  214636428: (ID, a) => new IFC4_3.IfcStructuralCurveMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2445595289: (ID, a) => new IFC4_3.IfcStructuralCurveMemberVarying(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2757150158: (ID, a) => new IFC4_3.IfcStructuralCurveReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1807405624: (ID, a) => new IFC4_3.IfcStructuralLinearAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1252848954: (ID, a) => new IFC4_3.IfcStructuralLoadGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2082059205: (ID, a) => new IFC4_3.IfcStructuralPointAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  734778138: (ID, a) => new IFC4_3.IfcStructuralPointConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1235345126: (ID, a) => new IFC4_3.IfcStructuralPointReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2986769608: (ID, a) => new IFC4_3.IfcStructuralResultGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3657597509: (ID, a) => new IFC4_3.IfcStructuralSurfaceAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1975003073: (ID, a) => new IFC4_3.IfcStructuralSurfaceConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  148013059: (ID, a) => new IFC4_3.IfcSubContractResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3101698114: (ID, a) => new IFC4_3.IfcSurfaceFeature(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2315554128: (ID, a) => new IFC4_3.IfcSwitchingDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2254336722: (ID, a) => new IFC4_3.IfcSystem(ID, a[0], a[1], a[2], a[3], a[4]),
  413509423: (ID, a) => new IFC4_3.IfcSystemFurnitureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  5716631: (ID, a) => new IFC4_3.IfcTankType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3824725483: (ID, a) => new IFC4_3.IfcTendon(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  2347447852: (ID, a) => new IFC4_3.IfcTendonAnchor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3081323446: (ID, a) => new IFC4_3.IfcTendonAnchorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3663046924: (ID, a) => new IFC4_3.IfcTendonConduit(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2281632017: (ID, a) => new IFC4_3.IfcTendonConduitType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2415094496: (ID, a) => new IFC4_3.IfcTendonType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  618700268: (ID, a) => new IFC4_3.IfcTrackElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1692211062: (ID, a) => new IFC4_3.IfcTransformerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2097647324: (ID, a) => new IFC4_3.IfcTransportElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1953115116: (ID, a) => new IFC4_3.IfcTransportationDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3593883385: (ID, a) => new IFC4_3.IfcTrimmedCurve(ID, a[0], a[1], a[2], a[3], a[4]),
  1600972822: (ID, a) => new IFC4_3.IfcTubeBundleType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1911125066: (ID, a) => new IFC4_3.IfcUnitaryEquipmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  728799441: (ID, a) => new IFC4_3.IfcValveType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  840318589: (ID, a) => new IFC4_3.IfcVehicle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1530820697: (ID, a) => new IFC4_3.IfcVibrationDamper(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3956297820: (ID, a) => new IFC4_3.IfcVibrationDamperType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2391383451: (ID, a) => new IFC4_3.IfcVibrationIsolator(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3313531582: (ID, a) => new IFC4_3.IfcVibrationIsolatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2769231204: (ID, a) => new IFC4_3.IfcVirtualElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  926996030: (ID, a) => new IFC4_3.IfcVoidingFeature(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1898987631: (ID, a) => new IFC4_3.IfcWallType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1133259667: (ID, a) => new IFC4_3.IfcWasteTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4009809668: (ID, a) => new IFC4_3.IfcWindowType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  4088093105: (ID, a) => new IFC4_3.IfcWorkCalendar(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1028945134: (ID, a) => new IFC4_3.IfcWorkControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  4218914973: (ID, a) => new IFC4_3.IfcWorkPlan(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  3342526732: (ID, a) => new IFC4_3.IfcWorkSchedule(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  1033361043: (ID, a) => new IFC4_3.IfcZone(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3821786052: (ID, a) => new IFC4_3.IfcActionRequest(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1411407467: (ID, a) => new IFC4_3.IfcAirTerminalBoxType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3352864051: (ID, a) => new IFC4_3.IfcAirTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1871374353: (ID, a) => new IFC4_3.IfcAirToAirHeatRecoveryType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4266260250: (ID, a) => new IFC4_3.IfcAlignmentCant(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1545765605: (ID, a) => new IFC4_3.IfcAlignmentHorizontal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  317615605: (ID, a) => new IFC4_3.IfcAlignmentSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1662888072: (ID, a) => new IFC4_3.IfcAlignmentVertical(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3460190687: (ID, a) => new IFC4_3.IfcAsset(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  1532957894: (ID, a) => new IFC4_3.IfcAudioVisualApplianceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1967976161: (ID, a) => new IFC4_3.IfcBSplineCurve(ID, a[0], a[1], a[2], a[3], a[4]),
  2461110595: (ID, a) => new IFC4_3.IfcBSplineCurveWithKnots(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  819618141: (ID, a) => new IFC4_3.IfcBeamType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3649138523: (ID, a) => new IFC4_3.IfcBearingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  231477066: (ID, a) => new IFC4_3.IfcBoilerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1136057603: (ID, a) => new IFC4_3.IfcBoundaryCurve(ID, a[0], a[1]),
  644574406: (ID, a) => new IFC4_3.IfcBridge(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  963979645: (ID, a) => new IFC4_3.IfcBridgePart(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4031249490: (ID, a) => new IFC4_3.IfcBuilding(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2979338954: (ID, a) => new IFC4_3.IfcBuildingElementPart(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  39481116: (ID, a) => new IFC4_3.IfcBuildingElementPartType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1909888760: (ID, a) => new IFC4_3.IfcBuildingElementProxyType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1177604601: (ID, a) => new IFC4_3.IfcBuildingSystem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1876633798: (ID, a) => new IFC4_3.IfcBuiltElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3862327254: (ID, a) => new IFC4_3.IfcBuiltSystem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2188180465: (ID, a) => new IFC4_3.IfcBurnerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  395041908: (ID, a) => new IFC4_3.IfcCableCarrierFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3293546465: (ID, a) => new IFC4_3.IfcCableCarrierSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2674252688: (ID, a) => new IFC4_3.IfcCableFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1285652485: (ID, a) => new IFC4_3.IfcCableSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3203706013: (ID, a) => new IFC4_3.IfcCaissonFoundationType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2951183804: (ID, a) => new IFC4_3.IfcChillerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3296154744: (ID, a) => new IFC4_3.IfcChimney(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2611217952: (ID, a) => new IFC4_3.IfcCircle(ID, a[0], a[1]),
  1677625105: (ID, a) => new IFC4_3.IfcCivilElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2301859152: (ID, a) => new IFC4_3.IfcCoilType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  843113511: (ID, a) => new IFC4_3.IfcColumn(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  400855858: (ID, a) => new IFC4_3.IfcCommunicationsApplianceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3850581409: (ID, a) => new IFC4_3.IfcCompressorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2816379211: (ID, a) => new IFC4_3.IfcCondenserType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3898045240: (ID, a) => new IFC4_3.IfcConstructionEquipmentResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1060000209: (ID, a) => new IFC4_3.IfcConstructionMaterialResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  488727124: (ID, a) => new IFC4_3.IfcConstructionProductResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2940368186: (ID, a) => new IFC4_3.IfcConveyorSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  335055490: (ID, a) => new IFC4_3.IfcCooledBeamType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2954562838: (ID, a) => new IFC4_3.IfcCoolingTowerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1502416096: (ID, a) => new IFC4_3.IfcCourse(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1973544240: (ID, a) => new IFC4_3.IfcCovering(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3495092785: (ID, a) => new IFC4_3.IfcCurtainWall(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3961806047: (ID, a) => new IFC4_3.IfcDamperType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3426335179: (ID, a) => new IFC4_3.IfcDeepFoundation(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1335981549: (ID, a) => new IFC4_3.IfcDiscreteAccessory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2635815018: (ID, a) => new IFC4_3.IfcDiscreteAccessoryType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  479945903: (ID, a) => new IFC4_3.IfcDistributionBoardType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1599208980: (ID, a) => new IFC4_3.IfcDistributionChamberElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2063403501: (ID, a) => new IFC4_3.IfcDistributionControlElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1945004755: (ID, a) => new IFC4_3.IfcDistributionElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3040386961: (ID, a) => new IFC4_3.IfcDistributionFlowElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3041715199: (ID, a) => new IFC4_3.IfcDistributionPort(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3205830791: (ID, a) => new IFC4_3.IfcDistributionSystem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  395920057: (ID, a) => new IFC4_3.IfcDoor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  869906466: (ID, a) => new IFC4_3.IfcDuctFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3760055223: (ID, a) => new IFC4_3.IfcDuctSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2030761528: (ID, a) => new IFC4_3.IfcDuctSilencerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3071239417: (ID, a) => new IFC4_3.IfcEarthworksCut(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1077100507: (ID, a) => new IFC4_3.IfcEarthworksElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3376911765: (ID, a) => new IFC4_3.IfcEarthworksFill(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  663422040: (ID, a) => new IFC4_3.IfcElectricApplianceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2417008758: (ID, a) => new IFC4_3.IfcElectricDistributionBoardType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3277789161: (ID, a) => new IFC4_3.IfcElectricFlowStorageDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2142170206: (ID, a) => new IFC4_3.IfcElectricFlowTreatmentDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1534661035: (ID, a) => new IFC4_3.IfcElectricGeneratorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1217240411: (ID, a) => new IFC4_3.IfcElectricMotorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  712377611: (ID, a) => new IFC4_3.IfcElectricTimeControlType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1658829314: (ID, a) => new IFC4_3.IfcEnergyConversionDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2814081492: (ID, a) => new IFC4_3.IfcEngine(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3747195512: (ID, a) => new IFC4_3.IfcEvaporativeCooler(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  484807127: (ID, a) => new IFC4_3.IfcEvaporator(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1209101575: (ID, a) => new IFC4_3.IfcExternalSpatialElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  346874300: (ID, a) => new IFC4_3.IfcFanType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1810631287: (ID, a) => new IFC4_3.IfcFilterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4222183408: (ID, a) => new IFC4_3.IfcFireSuppressionTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2058353004: (ID, a) => new IFC4_3.IfcFlowController(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4278956645: (ID, a) => new IFC4_3.IfcFlowFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4037862832: (ID, a) => new IFC4_3.IfcFlowInstrumentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2188021234: (ID, a) => new IFC4_3.IfcFlowMeter(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3132237377: (ID, a) => new IFC4_3.IfcFlowMovingDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  987401354: (ID, a) => new IFC4_3.IfcFlowSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  707683696: (ID, a) => new IFC4_3.IfcFlowStorageDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2223149337: (ID, a) => new IFC4_3.IfcFlowTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3508470533: (ID, a) => new IFC4_3.IfcFlowTreatmentDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  900683007: (ID, a) => new IFC4_3.IfcFooting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2713699986: (ID, a) => new IFC4_3.IfcGeotechnicalAssembly(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3009204131: (ID, a) => new IFC4_3.IfcGrid(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3319311131: (ID, a) => new IFC4_3.IfcHeatExchanger(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2068733104: (ID, a) => new IFC4_3.IfcHumidifier(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4175244083: (ID, a) => new IFC4_3.IfcInterceptor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2176052936: (ID, a) => new IFC4_3.IfcJunctionBox(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2696325953: (ID, a) => new IFC4_3.IfcKerb(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  76236018: (ID, a) => new IFC4_3.IfcLamp(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  629592764: (ID, a) => new IFC4_3.IfcLightFixture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1154579445: (ID, a) => new IFC4_3.IfcLinearPositioningElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1638804497: (ID, a) => new IFC4_3.IfcLiquidTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1437502449: (ID, a) => new IFC4_3.IfcMedicalDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1073191201: (ID, a) => new IFC4_3.IfcMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2078563270: (ID, a) => new IFC4_3.IfcMobileTelecommunicationsAppliance(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  234836483: (ID, a) => new IFC4_3.IfcMooringDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2474470126: (ID, a) => new IFC4_3.IfcMotorConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2182337498: (ID, a) => new IFC4_3.IfcNavigationElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  144952367: (ID, a) => new IFC4_3.IfcOuterBoundaryCurve(ID, a[0], a[1]),
  3694346114: (ID, a) => new IFC4_3.IfcOutlet(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1383356374: (ID, a) => new IFC4_3.IfcPavement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1687234759: (ID, a) => new IFC4_3.IfcPile(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  310824031: (ID, a) => new IFC4_3.IfcPipeFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3612865200: (ID, a) => new IFC4_3.IfcPipeSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3171933400: (ID, a) => new IFC4_3.IfcPlate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  738039164: (ID, a) => new IFC4_3.IfcProtectiveDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  655969474: (ID, a) => new IFC4_3.IfcProtectiveDeviceTrippingUnitType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  90941305: (ID, a) => new IFC4_3.IfcPump(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3290496277: (ID, a) => new IFC4_3.IfcRail(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2262370178: (ID, a) => new IFC4_3.IfcRailing(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3024970846: (ID, a) => new IFC4_3.IfcRamp(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3283111854: (ID, a) => new IFC4_3.IfcRampFlight(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1232101972: (ID, a) => new IFC4_3.IfcRationalBSplineCurveWithKnots(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3798194928: (ID, a) => new IFC4_3.IfcReinforcedSoil(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  979691226: (ID, a) => new IFC4_3.IfcReinforcingBar(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  2572171363: (ID, a) => new IFC4_3.IfcReinforcingBarType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]),
  2016517767: (ID, a) => new IFC4_3.IfcRoof(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3053780830: (ID, a) => new IFC4_3.IfcSanitaryTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1783015770: (ID, a) => new IFC4_3.IfcSensorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1329646415: (ID, a) => new IFC4_3.IfcShadingDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  991950508: (ID, a) => new IFC4_3.IfcSignal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1529196076: (ID, a) => new IFC4_3.IfcSlab(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3420628829: (ID, a) => new IFC4_3.IfcSolarDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1999602285: (ID, a) => new IFC4_3.IfcSpaceHeater(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1404847402: (ID, a) => new IFC4_3.IfcStackTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  331165859: (ID, a) => new IFC4_3.IfcStair(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4252922144: (ID, a) => new IFC4_3.IfcStairFlight(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  2515109513: (ID, a) => new IFC4_3.IfcStructuralAnalysisModel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  385403989: (ID, a) => new IFC4_3.IfcStructuralLoadCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1621171031: (ID, a) => new IFC4_3.IfcStructuralPlanarAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1162798199: (ID, a) => new IFC4_3.IfcSwitchingDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  812556717: (ID, a) => new IFC4_3.IfcTank(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3425753595: (ID, a) => new IFC4_3.IfcTrackElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3825984169: (ID, a) => new IFC4_3.IfcTransformer(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1620046519: (ID, a) => new IFC4_3.IfcTransportElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3026737570: (ID, a) => new IFC4_3.IfcTubeBundle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3179687236: (ID, a) => new IFC4_3.IfcUnitaryControlElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4292641817: (ID, a) => new IFC4_3.IfcUnitaryEquipment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4207607924: (ID, a) => new IFC4_3.IfcValve(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2391406946: (ID, a) => new IFC4_3.IfcWall(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3512223829: (ID, a) => new IFC4_3.IfcWallStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4237592921: (ID, a) => new IFC4_3.IfcWasteTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3304561284: (ID, a) => new IFC4_3.IfcWindow(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  2874132201: (ID, a) => new IFC4_3.IfcActuatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1634111441: (ID, a) => new IFC4_3.IfcAirTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  177149247: (ID, a) => new IFC4_3.IfcAirTerminalBox(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2056796094: (ID, a) => new IFC4_3.IfcAirToAirHeatRecovery(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3001207471: (ID, a) => new IFC4_3.IfcAlarmType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  325726236: (ID, a) => new IFC4_3.IfcAlignment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  277319702: (ID, a) => new IFC4_3.IfcAudioVisualAppliance(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  753842376: (ID, a) => new IFC4_3.IfcBeam(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4196446775: (ID, a) => new IFC4_3.IfcBearing(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  32344328: (ID, a) => new IFC4_3.IfcBoiler(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3314249567: (ID, a) => new IFC4_3.IfcBorehole(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1095909175: (ID, a) => new IFC4_3.IfcBuildingElementProxy(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2938176219: (ID, a) => new IFC4_3.IfcBurner(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  635142910: (ID, a) => new IFC4_3.IfcCableCarrierFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3758799889: (ID, a) => new IFC4_3.IfcCableCarrierSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1051757585: (ID, a) => new IFC4_3.IfcCableFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4217484030: (ID, a) => new IFC4_3.IfcCableSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3999819293: (ID, a) => new IFC4_3.IfcCaissonFoundation(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3902619387: (ID, a) => new IFC4_3.IfcChiller(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  639361253: (ID, a) => new IFC4_3.IfcCoil(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3221913625: (ID, a) => new IFC4_3.IfcCommunicationsAppliance(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3571504051: (ID, a) => new IFC4_3.IfcCompressor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2272882330: (ID, a) => new IFC4_3.IfcCondenser(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  578613899: (ID, a) => new IFC4_3.IfcControllerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3460952963: (ID, a) => new IFC4_3.IfcConveyorSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4136498852: (ID, a) => new IFC4_3.IfcCooledBeam(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3640358203: (ID, a) => new IFC4_3.IfcCoolingTower(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4074379575: (ID, a) => new IFC4_3.IfcDamper(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3693000487: (ID, a) => new IFC4_3.IfcDistributionBoard(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1052013943: (ID, a) => new IFC4_3.IfcDistributionChamberElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  562808652: (ID, a) => new IFC4_3.IfcDistributionCircuit(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1062813311: (ID, a) => new IFC4_3.IfcDistributionControlElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  342316401: (ID, a) => new IFC4_3.IfcDuctFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3518393246: (ID, a) => new IFC4_3.IfcDuctSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1360408905: (ID, a) => new IFC4_3.IfcDuctSilencer(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1904799276: (ID, a) => new IFC4_3.IfcElectricAppliance(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  862014818: (ID, a) => new IFC4_3.IfcElectricDistributionBoard(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3310460725: (ID, a) => new IFC4_3.IfcElectricFlowStorageDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  24726584: (ID, a) => new IFC4_3.IfcElectricFlowTreatmentDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  264262732: (ID, a) => new IFC4_3.IfcElectricGenerator(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  402227799: (ID, a) => new IFC4_3.IfcElectricMotor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1003880860: (ID, a) => new IFC4_3.IfcElectricTimeControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3415622556: (ID, a) => new IFC4_3.IfcFan(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  819412036: (ID, a) => new IFC4_3.IfcFilter(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1426591983: (ID, a) => new IFC4_3.IfcFireSuppressionTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  182646315: (ID, a) => new IFC4_3.IfcFlowInstrument(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2680139844: (ID, a) => new IFC4_3.IfcGeomodel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1971632696: (ID, a) => new IFC4_3.IfcGeoslice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2295281155: (ID, a) => new IFC4_3.IfcProtectiveDeviceTrippingUnit(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4086658281: (ID, a) => new IFC4_3.IfcSensor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  630975310: (ID, a) => new IFC4_3.IfcUnitaryControlElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4288193352: (ID, a) => new IFC4_3.IfcActuator(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3087945054: (ID, a) => new IFC4_3.IfcAlarm(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  25142252: (ID, a) => new IFC4_3.IfcController(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8])
};
ToRawLineData[2] = {
  3630933823: (i) => [i.Role, i.UserDefinedRole, i.Description],
  618182010: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose],
  2879124712: (i) => [i.StartTag, i.EndTag],
  3633395639: (i) => [i.StartTag, i.EndTag, i.StartDistAlong, i.HorizontalLength, i.StartHeight, i.StartGradient, i.EndGradient, i.RadiusOfCurvature, i.PredefinedType],
  639542469: (i) => [i.ApplicationDeveloper, i.Version, i.ApplicationFullName, i.ApplicationIdentifier],
  411424972: (i) => [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.Category, i.Condition, i.ArithmeticOperator, i.Components],
  130549933: (i) => [i.Identifier, i.Name, i.Description, i.TimeOfApproval, i.Status, i.Level, i.Qualifier, i.RequestingApproval, i.GivingApproval],
  4037036970: (i) => [i.Name],
  1560379544: (i) => [i.Name, !i.TranslationalStiffnessByLengthX ? null : Labelise(i.TranslationalStiffnessByLengthX), !i.TranslationalStiffnessByLengthY ? null : Labelise(i.TranslationalStiffnessByLengthY), !i.TranslationalStiffnessByLengthZ ? null : Labelise(i.TranslationalStiffnessByLengthZ), !i.RotationalStiffnessByLengthX ? null : Labelise(i.RotationalStiffnessByLengthX), !i.RotationalStiffnessByLengthY ? null : Labelise(i.RotationalStiffnessByLengthY), !i.RotationalStiffnessByLengthZ ? null : Labelise(i.RotationalStiffnessByLengthZ)],
  3367102660: (i) => [i.Name, !i.TranslationalStiffnessByAreaX ? null : Labelise(i.TranslationalStiffnessByAreaX), !i.TranslationalStiffnessByAreaY ? null : Labelise(i.TranslationalStiffnessByAreaY), !i.TranslationalStiffnessByAreaZ ? null : Labelise(i.TranslationalStiffnessByAreaZ)],
  1387855156: (i) => [i.Name, !i.TranslationalStiffnessX ? null : Labelise(i.TranslationalStiffnessX), !i.TranslationalStiffnessY ? null : Labelise(i.TranslationalStiffnessY), !i.TranslationalStiffnessZ ? null : Labelise(i.TranslationalStiffnessZ), !i.RotationalStiffnessX ? null : Labelise(i.RotationalStiffnessX), !i.RotationalStiffnessY ? null : Labelise(i.RotationalStiffnessY), !i.RotationalStiffnessZ ? null : Labelise(i.RotationalStiffnessZ)],
  2069777674: (i) => [i.Name, !i.TranslationalStiffnessX ? null : Labelise(i.TranslationalStiffnessX), !i.TranslationalStiffnessY ? null : Labelise(i.TranslationalStiffnessY), !i.TranslationalStiffnessZ ? null : Labelise(i.TranslationalStiffnessZ), !i.RotationalStiffnessX ? null : Labelise(i.RotationalStiffnessX), !i.RotationalStiffnessY ? null : Labelise(i.RotationalStiffnessY), !i.RotationalStiffnessZ ? null : Labelise(i.RotationalStiffnessZ), !i.WarpingStiffness ? null : Labelise(i.WarpingStiffness)],
  2859738748: (_) => [],
  2614616156: (i) => [i.PointOnRelatingElement, i.PointOnRelatedElement],
  2732653382: (i) => [i.SurfaceOnRelatingElement, i.SurfaceOnRelatedElement],
  775493141: (i) => [i.VolumeOnRelatingElement, i.VolumeOnRelatedElement],
  1959218052: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade],
  1785450214: (i) => [i.SourceCRS, i.TargetCRS],
  1466758467: (i) => [i.Name, i.Description, i.GeodeticDatum, i.VerticalDatum],
  602808272: (i) => [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.Category, i.Condition, i.ArithmeticOperator, i.Components],
  1765591967: (i) => [i.Elements, i.UnitType, i.UserDefinedType, i.Name],
  1045800335: (i) => [i.Unit, i.Exponent],
  2949456006: (i) => [i.LengthExponent, i.MassExponent, i.TimeExponent, i.ElectricCurrentExponent, i.ThermodynamicTemperatureExponent, i.AmountOfSubstanceExponent, i.LuminousIntensityExponent],
  4294318154: (_) => [],
  3200245327: (i) => [i.Location, i.Identification, i.Name],
  2242383968: (i) => [i.Location, i.Identification, i.Name],
  1040185647: (i) => [i.Location, i.Identification, i.Name],
  3548104201: (i) => [i.Location, i.Identification, i.Name],
  852622518: (i) => [i.AxisTag, i.AxisCurve, i.SameSense],
  3020489413: (i) => [i.TimeStamp, i.ListValues.map((p) => Labelise(p))],
  2655187982: (i) => [i.Name, i.Version, i.Publisher, i.VersionDate, i.Location, i.Description],
  3452421091: (i) => [i.Location, i.Identification, i.Name, i.Description, i.Language, i.ReferencedLibrary],
  4162380809: (i) => [i.MainPlaneAngle, i.SecondaryPlaneAngle, i.LuminousIntensity],
  1566485204: (i) => [i.LightDistributionCurve, i.DistributionData],
  3057273783: (i) => [i.SourceCRS, i.TargetCRS, i.Eastings, i.Northings, i.OrthogonalHeight, i.XAxisAbscissa, i.XAxisOrdinate, i.Scale, i.ScaleY, i.ScaleZ],
  1847130766: (i) => [i.MaterialClassifications, i.ClassifiedMaterial],
  760658860: (_) => [],
  248100487: (i) => [i.Material, i.LayerThickness, i.IsVentilated, i.Name, i.Description, i.Category, i.Priority],
  3303938423: (i) => [i.MaterialLayers, i.LayerSetName, i.Description],
  1847252529: (i) => [i.Material, i.LayerThickness, i.IsVentilated, i.Name, i.Description, i.Category, i.Priority, i.OffsetDirection, i.OffsetValues],
  2199411900: (i) => [i.Materials],
  2235152071: (i) => [i.Name, i.Description, i.Material, i.Profile, i.Priority, i.Category],
  164193824: (i) => [i.Name, i.Description, i.MaterialProfiles, i.CompositeProfile],
  552965576: (i) => [i.Name, i.Description, i.Material, i.Profile, i.Priority, i.Category, i.OffsetValues],
  1507914824: (_) => [],
  2597039031: (i) => [Labelise(i.ValueComponent), i.UnitComponent],
  3368373690: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.Benchmark, i.ValueSource, i.DataValue, i.ReferencePath],
  2706619895: (i) => [i.Currency],
  1918398963: (i) => [i.Dimensions, i.UnitType],
  3701648758: (i) => [i.PlacementRelTo],
  2251480897: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.BenchmarkValues, i.LogicalAggregator, i.ObjectiveQualifier, i.UserDefinedQualifier],
  4251960020: (i) => [i.Identification, i.Name, i.Description, i.Roles, i.Addresses],
  1207048766: (i) => [i.OwningUser, i.OwningApplication, i.State, i.ChangeAction, i.LastModifiedDate, i.LastModifyingUser, i.LastModifyingApplication, i.CreationDate],
  2077209135: (i) => [i.Identification, i.FamilyName, i.GivenName, i.MiddleNames, i.PrefixTitles, i.SuffixTitles, i.Roles, i.Addresses],
  101040310: (i) => [i.ThePerson, i.TheOrganization, i.Roles],
  2483315170: (i) => [i.Name, i.Description],
  2226359599: (i) => [i.Name, i.Description, i.Unit],
  3355820592: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose, i.InternalLocation, i.AddressLines, i.PostalBox, i.Town, i.Region, i.PostalCode, i.Country],
  677532197: (_) => [],
  2022622350: (i) => [i.Name, i.Description, i.AssignedItems, i.Identifier],
  1304840413: (i) => [i.Name, i.Description, i.AssignedItems, i.Identifier, i.LayerOn, i.LayerFrozen, i.LayerBlocked, i.LayerStyles],
  3119450353: (i) => [i.Name],
  2095639259: (i) => [i.Name, i.Description, i.Representations],
  3958567839: (i) => [i.ProfileType, i.ProfileName],
  3843373140: (i) => [i.Name, i.Description, i.GeodeticDatum, i.VerticalDatum, i.MapProjection, i.MapZone, i.MapUnit],
  986844984: (_) => [],
  3710013099: (i) => [i.Name, i.EnumerationValues.map((p) => Labelise(p)), i.Unit],
  2044713172: (i) => [i.Name, i.Description, i.Unit, i.AreaValue, i.Formula],
  2093928680: (i) => [i.Name, i.Description, i.Unit, i.CountValue, i.Formula],
  931644368: (i) => [i.Name, i.Description, i.Unit, i.LengthValue, i.Formula],
  2691318326: (i) => [i.Name, i.Description, i.Unit, i.NumberValue, i.Formula],
  3252649465: (i) => [i.Name, i.Description, i.Unit, i.TimeValue, i.Formula],
  2405470396: (i) => [i.Name, i.Description, i.Unit, i.VolumeValue, i.Formula],
  825690147: (i) => [i.Name, i.Description, i.Unit, i.WeightValue, i.Formula],
  3915482550: (i) => [i.RecurrenceType, i.DayComponent, i.WeekdayComponent, i.MonthComponent, i.Position, i.Interval, i.Occurrences, i.TimePeriods],
  2433181523: (i) => [i.TypeIdentifier, i.AttributeIdentifier, i.InstanceName, i.ListPositions, i.InnerReference],
  1076942058: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  3377609919: (i) => [i.ContextIdentifier, i.ContextType],
  3008791417: (_) => [],
  1660063152: (i) => [i.MappingOrigin, i.MappedRepresentation],
  2439245199: (i) => [i.Name, i.Description],
  2341007311: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  448429030: (i) => [i.Dimensions, i.UnitType, i.Prefix, i.Name],
  1054537805: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin],
  867548509: (i) => [i.ShapeRepresentations, i.Name, i.Description, i.ProductDefinitional, i.PartOfProductDefinitionShape],
  3982875396: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  4240577450: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  2273995522: (i) => [i.Name],
  2162789131: (i) => [i.Name],
  3478079324: (i) => [i.Name, i.Values, i.Locations],
  609421318: (i) => [i.Name],
  2525727697: (i) => [i.Name],
  3408363356: (i) => [i.Name, i.DeltaTConstant, i.DeltaTY, i.DeltaTZ],
  2830218821: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  3958052878: (i) => [i.Item, i.Styles, i.Name],
  3049322572: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  2934153892: (i) => [i.Name, i.SurfaceReinforcement1, i.SurfaceReinforcement2, i.ShearReinforcement],
  1300840506: (i) => [i.Name, i.Side, i.Styles],
  3303107099: (i) => [i.DiffuseTransmissionColour, i.DiffuseReflectionColour, i.TransmissionColour, i.ReflectanceColour],
  1607154358: (i) => [i.RefractionIndex, i.DispersionFactor],
  846575682: (i) => [i.SurfaceColour, i.Transparency],
  1351298697: (i) => [i.Textures],
  626085974: (i) => [i.RepeatS, i.RepeatT, i.Mode, i.TextureTransform, i.Parameter],
  985171141: (i) => [i.Name, i.Rows, i.Columns],
  2043862942: (i) => [i.Identifier, i.Name, i.Description, i.Unit, i.ReferencePath],
  531007025: (i) => [!i.RowCells ? null : i.RowCells.map((p) => Labelise(p)), i.IsHeading],
  1549132990: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.DurationType, i.ScheduleDuration, i.ScheduleStart, i.ScheduleFinish, i.EarlyStart, i.EarlyFinish, i.LateStart, i.LateFinish, i.FreeFloat, i.TotalFloat, i.IsCritical, i.StatusTime, i.ActualDuration, i.ActualStart, i.ActualFinish, i.RemainingTime, i.Completion],
  2771591690: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.DurationType, i.ScheduleDuration, i.ScheduleStart, i.ScheduleFinish, i.EarlyStart, i.EarlyFinish, i.LateStart, i.LateFinish, i.FreeFloat, i.TotalFloat, i.IsCritical, i.StatusTime, i.ActualDuration, i.ActualStart, i.ActualFinish, i.RemainingTime, i.Completion, i.Recurrence],
  912023232: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose, i.TelephoneNumbers, i.FacsimileNumbers, i.PagerNumber, i.ElectronicMailAddresses, i.WWWHomePageURL, i.MessagingIDs],
  1447204868: (i) => [i.Name, i.TextCharacterAppearance, i.TextStyle, i.TextFontStyle, i.ModelOrDraughting],
  2636378356: (i) => [i.Colour, i.BackgroundColour],
  1640371178: (i) => [!i.TextIndent ? null : Labelise(i.TextIndent), i.TextAlign, i.TextDecoration, !i.LetterSpacing ? null : Labelise(i.LetterSpacing), !i.WordSpacing ? null : Labelise(i.WordSpacing), i.TextTransform, !i.LineHeight ? null : Labelise(i.LineHeight)],
  280115917: (i) => [i.Maps],
  1742049831: (i) => [i.Maps, i.Mode, i.Parameter],
  222769930: (i) => [i.TexCoordIndex, i.TexCoordsOf],
  1010789467: (i) => [i.TexCoordIndex, i.TexCoordsOf, i.InnerTexCoordIndices],
  2552916305: (i) => [i.Maps, i.Vertices, i.MappedTo],
  1210645708: (i) => [i.Coordinates],
  3611470254: (i) => [i.TexCoordsList],
  1199560280: (i) => [i.StartTime, i.EndTime],
  3101149627: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit],
  581633288: (i) => [i.ListValues.map((p) => Labelise(p))],
  1377556343: (_) => [],
  1735638870: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  180925521: (i) => [i.Units],
  2799835756: (_) => [],
  1907098498: (i) => [i.VertexGeometry],
  891718957: (i) => [i.IntersectingAxes, i.OffsetDistances],
  1236880293: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.RecurrencePattern, i.StartDate, i.FinishDate],
  3752311538: (i) => [i.StartTag, i.EndTag, i.StartDistAlong, i.HorizontalLength, i.StartCantLeft, i.EndCantLeft, i.StartCantRight, i.EndCantRight, i.PredefinedType],
  536804194: (i) => [i.StartTag, i.EndTag, i.StartPoint, i.StartDirection, i.StartRadiusOfCurvature, i.EndRadiusOfCurvature, i.SegmentLength, i.GravityCenterLineHeight, i.PredefinedType],
  3869604511: (i) => [i.Name, i.Description, i.RelatingApproval, i.RelatedApprovals],
  3798115385: (i) => [i.ProfileType, i.ProfileName, i.OuterCurve],
  1310608509: (i) => [i.ProfileType, i.ProfileName, i.Curve],
  2705031697: (i) => [i.ProfileType, i.ProfileName, i.OuterCurve, i.InnerCurves],
  616511568: (i) => [i.RepeatS, i.RepeatT, i.Mode, i.TextureTransform, i.Parameter, i.RasterFormat, i.RasterCode],
  3150382593: (i) => [i.ProfileType, i.ProfileName, i.Curve, i.Thickness],
  747523909: (i) => [i.Source, i.Edition, i.EditionDate, i.Name, i.Description, i.Specification, i.ReferenceTokens],
  647927063: (i) => [i.Location, i.Identification, i.Name, i.ReferencedSource, i.Description, i.Sort],
  3285139300: (i) => [i.ColourList],
  3264961684: (i) => [i.Name],
  1485152156: (i) => [i.ProfileType, i.ProfileName, i.Profiles, i.Label],
  370225590: (i) => [i.CfsFaces],
  1981873012: (i) => [i.CurveOnRelatingElement, i.CurveOnRelatedElement],
  45288368: (i) => [i.PointOnRelatingElement, i.PointOnRelatedElement, i.EccentricityInX, i.EccentricityInY, i.EccentricityInZ],
  3050246964: (i) => [i.Dimensions, i.UnitType, i.Name],
  2889183280: (i) => [i.Dimensions, i.UnitType, i.Name, i.ConversionFactor],
  2713554722: (i) => [i.Dimensions, i.UnitType, i.Name, i.ConversionFactor, i.ConversionOffset],
  539742890: (i) => [i.Name, i.Description, i.RelatingMonetaryUnit, i.RelatedMonetaryUnit, i.ExchangeRate, i.RateDateTime, i.RateSource],
  3800577675: (i) => [i.Name, i.CurveFont, !i.CurveWidth ? null : Labelise(i.CurveWidth), i.CurveColour, i.ModelOrDraughting],
  1105321065: (i) => [i.Name, i.PatternList],
  2367409068: (i) => [i.Name, i.CurveStyleFont, i.CurveFontScaling],
  3510044353: (i) => [i.VisibleSegmentLength, i.InvisibleSegmentLength],
  3632507154: (i) => [i.ProfileType, i.ProfileName, i.ParentProfile, i.Operator, i.Label],
  1154170062: (i) => [i.Identification, i.Name, i.Description, i.Location, i.Purpose, i.IntendedUse, i.Scope, i.Revision, i.DocumentOwner, i.Editors, i.CreationTime, i.LastRevisionTime, i.ElectronicFormat, i.ValidFrom, i.ValidUntil, i.Confidentiality, i.Status],
  770865208: (i) => [i.Name, i.Description, i.RelatingDocument, i.RelatedDocuments, i.RelationshipType],
  3732053477: (i) => [i.Location, i.Identification, i.Name, i.Description, i.ReferencedDocument],
  3900360178: (i) => [i.EdgeStart, i.EdgeEnd],
  476780140: (i) => [i.EdgeStart, i.EdgeEnd, i.EdgeGeometry, i.SameSense],
  211053100: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.ActualDate, i.EarlyDate, i.LateDate, i.ScheduleDate],
  297599258: (i) => [i.Name, i.Description, i.Properties],
  1437805879: (i) => [i.Name, i.Description, i.RelatingReference, i.RelatedResourceObjects],
  2556980723: (i) => [i.Bounds],
  1809719519: (i) => [i.Bound, i.Orientation],
  803316827: (i) => [i.Bound, i.Orientation],
  3008276851: (i) => [i.Bounds, i.FaceSurface, i.SameSense],
  4219587988: (i) => [i.Name, i.TensionFailureX, i.TensionFailureY, i.TensionFailureZ, i.CompressionFailureX, i.CompressionFailureY, i.CompressionFailureZ],
  738692330: (i) => [i.Name, i.FillStyles, i.ModelOrDraughting],
  3448662350: (i) => [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth],
  2453401579: (_) => [],
  4142052618: (i) => [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth, i.ParentContext, i.TargetScale, i.TargetView, i.UserDefinedTargetView],
  3590301190: (i) => [i.Elements],
  178086475: (i) => [i.PlacementRelTo, i.PlacementLocation, i.PlacementRefDirection],
  812098782: (i) => [i.BaseSurface, i.AgreementFlag],
  3905492369: (i) => [i.RepeatS, i.RepeatT, i.Mode, i.TextureTransform, i.Parameter, i.URLReference],
  3570813810: (i) => [i.MappedTo, i.Opacity, i.Colours, i.ColourIndex],
  1437953363: (i) => [i.Maps, i.MappedTo, i.TexCoords],
  2133299955: (i) => [i.Maps, i.MappedTo, i.TexCoords, i.TexCoordIndex],
  3741457305: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.Values],
  1585845231: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, Labelise(i.LagValue), i.DurationType],
  1402838566: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity],
  125510826: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity],
  2604431987: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Orientation],
  4266656042: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.ColourAppearance, i.ColourTemperature, i.LuminousFlux, i.LightEmissionSource, i.LightDistributionDataSource],
  1520743889: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation],
  3422422726: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation, i.Orientation, i.ConcentrationExponent, i.SpreadAngle, i.BeamWidthAngle],
  388784114: (i) => [i.PlacementRelTo, i.RelativePlacement, i.CartesianPosition],
  2624227202: (i) => [i.PlacementRelTo, i.RelativePlacement],
  1008929658: (_) => [],
  2347385850: (i) => [i.MappingSource, i.MappingTarget],
  1838606355: (i) => [i.Name, i.Description, i.Category],
  3708119e3: (i) => [i.Name, i.Description, i.Material, i.Fraction, i.Category],
  2852063980: (i) => [i.Name, i.Description, i.MaterialConstituents],
  2022407955: (i) => [i.Name, i.Description, i.Representations, i.RepresentedMaterial],
  1303795690: (i) => [i.ForLayerSet, i.LayerSetDirection, i.DirectionSense, i.OffsetFromReferenceLine, i.ReferenceExtent],
  3079605661: (i) => [i.ForProfileSet, i.CardinalPoint, i.ReferenceExtent],
  3404854881: (i) => [i.ForProfileSet, i.CardinalPoint, i.ReferenceExtent, i.ForProfileEndSet, i.CardinalEndPoint],
  3265635763: (i) => [i.Name, i.Description, i.Properties, i.Material],
  853536259: (i) => [i.Name, i.Description, i.RelatingMaterial, i.RelatedMaterials, i.MaterialExpression],
  2998442950: (i) => [i.ProfileType, i.ProfileName, i.ParentProfile, i.Operator, i.Label],
  219451334: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  182550632: (i) => [i.ProfileType, i.ProfileName, i.HorizontalWidths, i.Widths, i.Slopes, i.Tags, i.OffsetPoint],
  2665983363: (i) => [i.CfsFaces],
  1411181986: (i) => [i.Name, i.Description, i.RelatingOrganization, i.RelatedOrganizations],
  1029017970: (i) => [i.EdgeStart, i.EdgeEnd, i.EdgeElement, i.Orientation],
  2529465313: (i) => [i.ProfileType, i.ProfileName, i.Position],
  2519244187: (i) => [i.EdgeList],
  3021840470: (i) => [i.Name, i.Description, i.HasQuantities, i.Discrimination, i.Quality, i.Usage],
  597895409: (i) => [i.RepeatS, i.RepeatT, i.Mode, i.TextureTransform, i.Parameter, i.Width, i.Height, i.ColourComponents, i.Pixel],
  2004835150: (i) => [i.Location],
  1663979128: (i) => [i.SizeInX, i.SizeInY],
  2067069095: (_) => [],
  2165702409: (i) => [Labelise(i.DistanceAlong), i.OffsetLateral, i.OffsetVertical, i.OffsetLongitudinal, i.BasisCurve],
  4022376103: (i) => [i.BasisCurve, i.PointParameter],
  1423911732: (i) => [i.BasisSurface, i.PointParameterU, i.PointParameterV],
  2924175390: (i) => [i.Polygon],
  2775532180: (i) => [i.BaseSurface, i.AgreementFlag, i.Position, i.PolygonalBoundary],
  3727388367: (i) => [i.Name],
  3778827333: (_) => [],
  1775413392: (i) => [i.Name],
  673634403: (i) => [i.Name, i.Description, i.Representations],
  2802850158: (i) => [i.Name, i.Description, i.Properties, i.ProfileDefinition],
  2598011224: (i) => [i.Name, i.Specification],
  1680319473: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  148025276: (i) => [i.Name, i.Description, i.DependingProperty, i.DependantProperty, i.Expression],
  3357820518: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  1482703590: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  2090586900: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  3615266464: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim],
  3413951693: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.TimeStep, i.Values],
  1580146022: (i) => [i.TotalCrossSectionArea, i.SteelGrade, i.BarSurface, i.EffectiveDepth, i.NominalBarDiameter, i.BarCount],
  478536968: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  2943643501: (i) => [i.Name, i.Description, i.RelatedResourceObjects, i.RelatingApproval],
  1608871552: (i) => [i.Name, i.Description, i.RelatingConstraint, i.RelatedResourceObjects],
  1042787934: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.ScheduleWork, i.ScheduleUsage, i.ScheduleStart, i.ScheduleFinish, i.ScheduleContour, i.LevelingDelay, i.IsOverAllocated, i.StatusTime, i.ActualWork, i.ActualUsage, i.ActualStart, i.ActualFinish, i.RemainingWork, i.RemainingUsage, i.Completion],
  2778083089: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.RoundingRadius],
  2042790032: (i) => [i.SectionType, i.StartProfile, i.EndProfile],
  4165799628: (i) => [i.LongitudinalStartPosition, i.LongitudinalEndPosition, i.TransversePosition, i.ReinforcementRole, i.SectionDefinition, i.CrossSectionReinforcementDefinitions],
  1509187699: (i) => [i.SpineCurve, i.CrossSections, i.CrossSectionPositions],
  823603102: (i) => [i.Transition],
  4124623270: (i) => [i.SbsmBoundary],
  3692461612: (i) => [i.Name, i.Specification],
  2609359061: (i) => [i.Name, i.SlippageX, i.SlippageY, i.SlippageZ],
  723233188: (_) => [],
  1595516126: (i) => [i.Name, i.LinearForceX, i.LinearForceY, i.LinearForceZ, i.LinearMomentX, i.LinearMomentY, i.LinearMomentZ],
  2668620305: (i) => [i.Name, i.PlanarForceX, i.PlanarForceY, i.PlanarForceZ],
  2473145415: (i) => [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ],
  1973038258: (i) => [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ, i.Distortion],
  1597423693: (i) => [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ],
  1190533807: (i) => [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ, i.WarpingMoment],
  2233826070: (i) => [i.EdgeStart, i.EdgeEnd, i.ParentEdge],
  2513912981: (_) => [],
  1878645084: (i) => [i.SurfaceColour, i.Transparency, i.DiffuseColour, i.TransmissionColour, i.DiffuseTransmissionColour, i.ReflectionColour, i.SpecularColour, !i.SpecularHighlight ? null : Labelise(i.SpecularHighlight), i.ReflectanceMethod],
  2247615214: (i) => [i.SweptArea, i.Position],
  1260650574: (i) => [i.Directrix, i.Radius, i.InnerRadius, i.StartParam, i.EndParam],
  1096409881: (i) => [i.Directrix, i.Radius, i.InnerRadius, i.StartParam, i.EndParam, i.FilletRadius],
  230924584: (i) => [i.SweptCurve, i.Position],
  3071757647: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.FlangeEdgeRadius, i.WebEdgeRadius, i.WebSlope, i.FlangeSlope],
  901063453: (_) => [],
  4282788508: (i) => [i.Literal, i.Placement, i.Path],
  3124975700: (i) => [i.Literal, i.Placement, i.Path, i.Extent, i.BoxAlignment],
  1983826977: (i) => [i.Name, i.FontFamily, i.FontStyle, i.FontVariant, i.FontWeight, Labelise(i.FontSize)],
  2715220739: (i) => [i.ProfileType, i.ProfileName, i.Position, i.BottomXDim, i.TopXDim, i.YDim, i.TopXOffset],
  1628702193: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets],
  3736923433: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType],
  2347495698: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag],
  3698973494: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType],
  427810014: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius, i.FlangeSlope],
  1417489154: (i) => [i.Orientation, i.Magnitude],
  2759199220: (i) => [i.LoopVertex],
  2543172580: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius],
  3406155212: (i) => [i.Bounds, i.FaceSurface, i.SameSense],
  669184980: (i) => [i.OuterBoundary, i.InnerBoundaries],
  3207858831: (i) => [i.ProfileType, i.ProfileName, i.Position, i.BottomFlangeWidth, i.OverallDepth, i.WebThickness, i.BottomFlangeThickness, i.BottomFlangeFilletRadius, i.TopFlangeWidth, i.TopFlangeThickness, i.TopFlangeFilletRadius, i.BottomFlangeEdgeRadius, i.BottomFlangeSlope, i.TopFlangeEdgeRadius, i.TopFlangeSlope],
  4261334040: (i) => [i.Location, i.Axis],
  3125803723: (i) => [i.Location, i.RefDirection],
  2740243338: (i) => [i.Location, i.Axis, i.RefDirection],
  3425423356: (i) => [i.Location, i.Axis, i.RefDirection],
  2736907675: (i) => [i.Operator, i.FirstOperand, i.SecondOperand],
  4182860854: (_) => [],
  2581212453: (i) => [i.Corner, i.XDim, i.YDim, i.ZDim],
  2713105998: (i) => [i.BaseSurface, i.AgreementFlag, i.Enclosure],
  2898889636: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.WallThickness, i.Girth, i.InternalFilletRadius],
  1123145078: (i) => [i.Coordinates],
  574549367: (_) => [],
  1675464909: (i) => [i.CoordList, i.TagList],
  2059837836: (i) => [i.CoordList, i.TagList],
  59481748: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale],
  3749851601: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale],
  3486308946: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Scale2],
  3331915920: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3],
  1416205885: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3, i.Scale2, i.Scale3],
  1383045692: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Radius],
  2205249479: (i) => [i.CfsFaces],
  776857604: (i) => [i.Name, i.Red, i.Green, i.Blue],
  2542286263: (i) => [i.Name, i.Specification, i.UsageName, i.HasProperties],
  2485617015: (i) => [i.Transition, i.SameSense, i.ParentCurve],
  2574617495: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity],
  3419103109: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext],
  1815067380: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  2506170314: (i) => [i.Position],
  2147822146: (i) => [i.TreeRootExpression],
  2601014836: (_) => [],
  2827736869: (i) => [i.BasisSurface, i.OuterBoundary, i.InnerBoundaries],
  2629017746: (i) => [i.BasisSurface, i.Boundaries, i.ImplicitOuter],
  4212018352: (i) => [i.Transition, i.Placement, Labelise(i.SegmentStart), Labelise(i.SegmentLength), i.ParentCurve],
  32440307: (i) => [i.DirectionRatios],
  593015953: (i) => [i.SweptArea, i.Position, i.Directrix, !i.StartParam ? null : Labelise(i.StartParam), !i.EndParam ? null : Labelise(i.EndParam)],
  1472233963: (i) => [i.EdgeList],
  1883228015: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.MethodOfMeasurement, i.Quantities],
  339256511: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2777663545: (i) => [i.Position],
  2835456948: (i) => [i.ProfileType, i.ProfileName, i.Position, i.SemiAxis1, i.SemiAxis2],
  4024345920: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType, i.EventTriggerType, i.UserDefinedEventTriggerType],
  477187591: (i) => [i.SweptArea, i.Position, i.ExtrudedDirection, i.Depth],
  2804161546: (i) => [i.SweptArea, i.Position, i.ExtrudedDirection, i.Depth, i.EndSweptArea],
  2047409740: (i) => [i.FbsmFaces],
  374418227: (i) => [i.HatchLineAppearance, i.StartOfNextHatchLine, i.PointOfReferenceHatchLine, i.PatternStart, i.HatchLineAngle],
  315944413: (i) => [i.TilingPattern, i.Tiles, i.TilingScale],
  2652556860: (i) => [i.SweptArea, i.Position, i.Directrix, !i.StartParam ? null : Labelise(i.StartParam), !i.EndParam ? null : Labelise(i.EndParam), i.FixedReference],
  4238390223: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1268542332: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.AssemblyPlace, i.PredefinedType],
  4095422895: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  987898635: (i) => [i.Elements],
  1484403080: (i) => [i.ProfileType, i.ProfileName, i.Position, i.OverallWidth, i.OverallDepth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.FlangeEdgeRadius, i.FlangeSlope],
  178912537: (i) => [i.CoordIndex],
  2294589976: (i) => [i.CoordIndex, i.InnerCoordIndices],
  3465909080: (i) => [i.Maps, i.MappedTo, i.TexCoords, i.TexCoordIndices],
  572779678: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.Thickness, i.FilletRadius, i.EdgeRadius, i.LegSlope],
  428585644: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1281925730: (i) => [i.Pnt, i.Dir],
  1425443689: (i) => [i.Outer],
  3888040117: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  590820931: (i) => [i.BasisCurve],
  3388369263: (i) => [i.BasisCurve, i.Distance, i.SelfIntersect],
  3505215534: (i) => [i.BasisCurve, i.Distance, i.SelfIntersect, i.RefDirection],
  2485787929: (i) => [i.BasisCurve, i.OffsetValues, i.Tag],
  1682466193: (i) => [i.BasisSurface, i.ReferenceCurve],
  603570806: (i) => [i.SizeInX, i.SizeInY, i.Placement],
  220341763: (i) => [i.Position],
  3381221214: (i) => [i.Position, i.CoefficientsX, i.CoefficientsY, i.CoefficientsZ],
  759155922: (i) => [i.Name],
  2559016684: (i) => [i.Name],
  3967405729: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  569719735: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType],
  2945172077: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription],
  4208778838: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  103090709: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext],
  653396225: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext],
  871118103: (i) => [i.Name, i.Specification, !i.UpperBoundValue ? null : Labelise(i.UpperBoundValue), !i.LowerBoundValue ? null : Labelise(i.LowerBoundValue), i.Unit, !i.SetPointValue ? null : Labelise(i.SetPointValue)],
  4166981789: (i) => [i.Name, i.Specification, !i.EnumerationValues ? null : i.EnumerationValues.map((p) => Labelise(p)), i.EnumerationReference],
  2752243245: (i) => [i.Name, i.Specification, !i.ListValues ? null : i.ListValues.map((p) => Labelise(p)), i.Unit],
  941946838: (i) => [i.Name, i.Specification, i.UsageName, i.PropertyReference],
  1451395588: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.HasProperties],
  492091185: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.TemplateType, i.ApplicableEntity, i.HasPropertyTemplates],
  3650150729: (i) => [i.Name, i.Specification, !i.NominalValue ? null : Labelise(i.NominalValue), i.Unit],
  110355661: (i) => [i.Name, i.Specification, !i.DefiningValues ? null : i.DefiningValues.map((p) => Labelise(p)), !i.DefinedValues ? null : i.DefinedValues.map((p) => Labelise(p)), i.Expression, i.DefiningUnit, i.DefinedUnit, i.CurveInterpolation],
  3521284610: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  2770003689: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.WallThickness, i.InnerFilletRadius, i.OuterFilletRadius],
  2798486643: (i) => [i.Position, i.XLength, i.YLength, i.Height],
  3454111270: (i) => [i.BasisSurface, i.U1, i.V1, i.U2, i.V2, i.Usense, i.Vsense],
  3765753017: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.DefinitionType, i.ReinforcementSectionDefinitions],
  3939117080: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType],
  1683148259: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingActor, i.ActingRole],
  2495723537: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl],
  1307041759: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingGroup],
  1027710054: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingGroup, i.Factor],
  4278684876: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProcess, i.QuantityInProcess],
  2857406711: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProduct],
  205026976: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingResource],
  1865459582: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects],
  4095574036: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingApproval],
  919958153: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingClassification],
  2728634034: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.Intent, i.RelatingConstraint],
  982818633: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingDocument],
  3840914261: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingLibrary],
  2655215786: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingMaterial],
  1033248425: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingProfileDef],
  826625072: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  1204542856: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement],
  3945020480: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RelatingPriorities, i.RelatedPriorities, i.RelatedConnectionType, i.RelatingConnectionType],
  4201705270: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedElement],
  3190031847: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedPort, i.RealizingElement],
  2127690289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedStructuralActivity],
  1638771189: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem],
  504942748: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem, i.ConnectionConstraint],
  3678494232: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RealizingElements, i.ConnectionType],
  3242617779: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure],
  886880790: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedCoverings],
  2802773753: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedCoverings],
  2565941209: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingContext, i.RelatedDefinitions],
  2551354335: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  693640335: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  1462361463: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingObject],
  4186316022: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingPropertyDefinition],
  307848117: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedPropertySets, i.RelatingTemplate],
  781010003: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingType],
  3940055652: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingOpeningElement, i.RelatedBuildingElement],
  279856033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedControlElements, i.RelatingFlowElement],
  427948657: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedElement, i.InterferenceGeometry, i.InterferenceSpace, i.InterferenceType, i.ImpliedOrder],
  3268803585: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects],
  1441486842: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPositioningElement, i.RelatedProducts],
  750771296: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedFeatureElement],
  1245217292: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure],
  4122056220: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingProcess, i.RelatedProcess, i.TimeLag, i.SequenceType, i.UserDefinedSequenceType],
  366585022: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSystem, i.RelatedBuildings],
  3451746338: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary],
  3523091289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary, i.ParentBoundary],
  1521410863: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary, i.ParentBoundary, i.CorrespondingBoundary],
  1401173127: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedOpeningElement],
  816062949: (i) => [i.Transition, i.SameSense, i.ParentCurve, i.ParamLength],
  2914609552: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription],
  1856042241: (i) => [i.SweptArea, i.Position, i.Axis, i.Angle],
  3243963512: (i) => [i.SweptArea, i.Position, i.Axis, i.Angle, i.EndSweptArea],
  4158566097: (i) => [i.Position, i.Height, i.BottomRadius],
  3626867408: (i) => [i.Position, i.Height, i.Radius],
  1862484736: (i) => [i.Directrix, i.CrossSections],
  1290935644: (i) => [i.Directrix, i.CrossSections, i.CrossSectionPositions],
  1356537516: (i) => [i.Directrix, i.CrossSectionPositions, i.CrossSections],
  3663146110: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.TemplateType, i.PrimaryMeasureType, i.SecondaryMeasureType, i.Enumerators, i.PrimaryUnit, i.SecondaryUnit, i.Expression, i.AccessState],
  1412071761: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName],
  710998568: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2706606064: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType],
  3893378262: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  463610769: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.PredefinedType],
  2481509218: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.LongName],
  451544542: (i) => [i.Position, i.Radius],
  4015995234: (i) => [i.Position, i.Radius],
  2735484536: (i) => [i.Position],
  3544373492: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  3136571912: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  530289379: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  3689010777: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  3979015343: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness],
  2218152070: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness],
  603775116: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.PredefinedType],
  4095615324: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  699246055: (i) => [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation],
  2028607225: (i) => [i.SweptArea, i.Position, i.Directrix, !i.StartParam ? null : Labelise(i.StartParam), !i.EndParam ? null : Labelise(i.EndParam), i.ReferenceSurface],
  2809605785: (i) => [i.SweptCurve, i.Position, i.ExtrudedDirection, i.Depth],
  4124788165: (i) => [i.SweptCurve, i.Position, i.AxisPosition],
  1580310250: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3473067441: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Status, i.WorkMethod, i.IsMilestone, i.Priority, i.TaskTime, i.PredefinedType],
  3206491090: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType, i.WorkMethod],
  2387106220: (i) => [i.Coordinates, i.Closed],
  782932809: (i) => [i.Position, i.CubicTerm, i.QuadraticTerm, i.LinearTerm, i.ConstantTerm],
  1935646853: (i) => [i.Position, i.MajorRadius, i.MinorRadius],
  3665877780: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2916149573: (i) => [i.Coordinates, i.Closed, i.Normals, i.CoordIndex, i.PnIndex],
  1229763772: (i) => [i.Coordinates, i.Closed, i.Normals, i.CoordIndex, i.PnIndex, i.Flags],
  3651464721: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  336235671: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.TransomThickness, i.MullionThickness, i.FirstTransomOffset, i.SecondTransomOffset, i.FirstMullionOffset, i.SecondMullionOffset, i.ShapeAspectStyle, i.LiningOffset, i.LiningToPanelOffsetX, i.LiningToPanelOffsetY],
  512836454: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle],
  2296667514: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor],
  1635779807: (i) => [i.Outer],
  2603310189: (i) => [i.Outer, i.Voids],
  1674181508: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType],
  2887950389: (i) => [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, i.UClosed, i.VClosed, i.SelfIntersect],
  167062518: (i) => [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, i.UClosed, i.VClosed, i.SelfIntersect, i.UMultiplicities, i.VMultiplicities, i.UKnots, i.VKnots, i.KnotSpec],
  1334484129: (i) => [i.Position, i.XLength, i.YLength, i.ZLength],
  3649129432: (i) => [i.Operator, i.FirstOperand, i.SecondOperand],
  1260505505: (_) => [],
  3124254112: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.Elevation],
  1626504194: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2197970202: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2937912522: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Radius, i.WallThickness],
  3893394355: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3497074424: (i) => [i.Position, i.ClothoidConstant],
  300633059: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3875453745: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.UsageName, i.TemplateType, i.HasPropertyTemplates],
  3732776249: (i) => [i.Segments, i.SelfIntersect],
  15328376: (i) => [i.Segments, i.SelfIntersect],
  2510884976: (i) => [i.Position],
  2185764099: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  4105962743: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1525564444: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  2559216714: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity],
  3293443760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification],
  2000195564: (i) => [i.Position, i.CosineTerm, i.ConstantTerm],
  3895139033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.CostValues, i.CostQuantities],
  1419761937: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.SubmittedOn, i.UpdateDate],
  4189326743: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1916426348: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3295246426: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1457835157: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1213902940: (i) => [i.Position, i.Radius],
  1306400036: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  4234616927: (i) => [i.SweptArea, i.Position, i.Directrix, !i.StartParam ? null : Labelise(i.StartParam), !i.EndParam ? null : Labelise(i.EndParam), i.FixedReference],
  3256556792: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3849074793: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2963535650: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.ThresholdDepth, i.ThresholdThickness, i.TransomThickness, i.TransomOffset, i.LiningOffset, i.ThresholdOffset, i.CasingThickness, i.CasingDepth, i.ShapeAspectStyle, i.LiningToPanelOffsetX, i.LiningToPanelOffsetY],
  1714330368: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.PanelDepth, i.PanelOperation, i.PanelWidth, i.PanelPosition, i.ShapeAspectStyle],
  2323601079: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.OperationType, i.ParameterTakesPrecedence, i.UserDefinedOperationType],
  445594917: (i) => [i.Name],
  4006246654: (i) => [i.Name],
  1758889154: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4123344466: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.AssemblyPlace, i.PredefinedType],
  2397081782: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1623761950: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2590856083: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1704287377: (i) => [i.Position, i.SemiAxis1, i.SemiAxis2],
  2107101300: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  132023988: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3174744832: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3390157468: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4148101412: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.PredefinedType, i.EventTriggerType, i.UserDefinedEventTriggerType, i.EventOccurenceTime],
  2853485674: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName],
  807026263: (i) => [i.Outer],
  3737207727: (i) => [i.Outer, i.Voids],
  24185140: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType],
  1310830890: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType],
  4228831410: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType, i.PredefinedType],
  647756555: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2489546625: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2827207264: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2143335405: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1287392070: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3907093117: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3198132628: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3815607619: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1482959167: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1834744321: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1339347760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2297155007: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3009222698: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1893162501: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  263784265: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1509553395: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3493046030: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4230923436: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1594536857: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2898700619: (i) => [i.Segments, i.SelfIntersect, i.BaseCurve, i.EndPoint],
  2706460486: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  1251058090: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1806887404: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2568555532: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3948183225: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2571569899: (i) => [i.Points, !i.Segments ? null : i.Segments.map((p) => Labelise(p)), i.SelfIntersect],
  3946677679: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3113134337: (i) => [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation],
  2391368822: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.Jurisdiction, i.ResponsiblePersons, i.LastUpdateDate, i.CurrentValue, i.OriginalValue],
  4288270099: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  679976338: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.Mountable],
  3827777499: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1051575348: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1161773419: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2176059722: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  1770583370: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  525669439: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType],
  976884017: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType, i.PredefinedType],
  377706215: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NominalDiameter, i.NominalLength, i.PredefinedType],
  2108223431: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.NominalLength],
  1114901282: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3181161470: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1950438474: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  710110818: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  977012517: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  506776471: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4143007308: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor, i.PredefinedType],
  3588315303: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2837617999: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  514975943: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2382730787: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LifeCyclePhase, i.PredefinedType],
  3566463478: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle],
  3327091369: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription],
  1158309216: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  804291784: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4231323485: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4017108033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2839578677: (i) => [i.Coordinates, i.Closed, i.Faces, i.PnIndex],
  3724593414: (i) => [i.Points],
  3740093272: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  1946335990: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  2744685151: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.PredefinedType],
  2904328755: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription],
  3651124850: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1842657554: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2250791053: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1763565496: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2893384427: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3992365140: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType],
  1891881377: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType, i.PredefinedType],
  2324767716: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1469900589: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  683857671: (i) => [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, i.UClosed, i.VClosed, i.SelfIntersect, i.UMultiplicities, i.VMultiplicities, i.UKnots, i.VKnots, i.KnotSpec, i.WeightsData],
  4021432810: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType],
  3027567501: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade],
  964333572: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2320036040: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.MeshLength, i.MeshWidth, i.LongitudinalBarNominalDiameter, i.TransverseBarNominalDiameter, i.LongitudinalBarCrossSectionArea, i.TransverseBarCrossSectionArea, i.LongitudinalBarSpacing, i.TransverseBarSpacing, i.PredefinedType],
  2310774935: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.MeshLength, i.MeshWidth, i.LongitudinalBarNominalDiameter, i.TransverseBarNominalDiameter, i.LongitudinalBarCrossSectionArea, i.TransverseBarCrossSectionArea, i.LongitudinalBarSpacing, i.TransverseBarSpacing, i.BendingShapeCode, !i.BendingParameters ? null : i.BendingParameters.map((p) => Labelise(p))],
  3818125796: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedSurfaceFeatures],
  160246688: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects],
  146592293: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType],
  550521510: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType, i.PredefinedType],
  2781568857: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1768891740: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2157484638: (i) => [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation],
  3649235739: (i) => [i.Position, i.QuadraticTerm, i.LinearTerm, i.ConstantTerm],
  544395925: (i) => [i.Segments, i.SelfIntersect, i.BaseCurve, i.EndPoint],
  1027922057: (i) => [i.Position, i.SepticTerm, i.SexticTerm, i.QuinticTerm, i.QuarticTerm, i.CubicTerm, i.QuadraticTerm, i.LinearTerm, i.ConstantTerm],
  4074543187: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  33720170: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3599934289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1894708472: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  42703149: (i) => [i.Position, i.SineTerm, i.LinearTerm, i.ConstantTerm],
  4097777520: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.RefLatitude, i.RefLongitude, i.RefElevation, i.LandTitleNumber, i.SiteAddress],
  2533589738: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1072016465: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3856911033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType, i.ElevationWithFlooring],
  1305183839: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3812236995: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.LongName],
  3112655638: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1039846685: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  338393293: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  682877961: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad],
  1179482911: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition],
  1004757350: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.ProjectedOrTrue, i.PredefinedType],
  4243806635: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition, i.AxisDirection],
  214636428: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Axis],
  2445595289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Axis],
  2757150158: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.PredefinedType],
  1807405624: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.ProjectedOrTrue, i.PredefinedType],
  1252848954: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.ActionType, i.ActionSource, i.Coefficient, i.Purpose],
  2082059205: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad],
  734778138: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition, i.ConditionCoordinateSystem],
  1235345126: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  2986769608: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheoryType, i.ResultForLoadGroup, i.IsLinear],
  3657597509: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.ProjectedOrTrue, i.PredefinedType],
  1975003073: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition],
  148013059: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  3101698114: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2315554128: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2254336722: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  413509423: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  5716631: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3824725483: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.TensionForce, i.PreStress, i.FrictionCoefficient, i.AnchorageSlip, i.MinCurvatureRadius],
  2347447852: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType],
  3081323446: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3663046924: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType],
  2281632017: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2415094496: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.SheathDiameter],
  618700268: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1692211062: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2097647324: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1953115116: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3593883385: (i) => [i.BasisCurve, i.Trim1, i.Trim2, i.SenseAgreement, i.MasterRepresentation],
  1600972822: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1911125066: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  728799441: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  840318589: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1530820697: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3956297820: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2391383451: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3313531582: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2769231204: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  926996030: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1898987631: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1133259667: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4009809668: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.PartitioningType, i.ParameterTakesPrecedence, i.UserDefinedPartitioningType],
  4088093105: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.WorkingTimes, i.ExceptionTimes, i.PredefinedType],
  1028945134: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime],
  4218914973: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.PredefinedType],
  3342526732: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.PredefinedType],
  1033361043: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName],
  3821786052: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription],
  1411407467: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3352864051: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1871374353: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4266260250: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.RailHeadDistance],
  1545765605: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  317615605: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.DesignParameters],
  1662888072: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  3460190687: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.OriginalValue, i.CurrentValue, i.TotalReplacementCost, i.Owner, i.User, i.ResponsiblePerson, i.IncorporationDate, i.DepreciatedValue],
  1532957894: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1967976161: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect],
  2461110595: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect, i.KnotMultiplicities, i.Knots, i.KnotSpec],
  819618141: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3649138523: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  231477066: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1136057603: (i) => [i.Segments, i.SelfIntersect],
  644574406: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType],
  963979645: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType, i.PredefinedType],
  4031249490: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.ElevationOfRefHeight, i.ElevationOfTerrain, i.BuildingAddress],
  2979338954: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  39481116: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1909888760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1177604601: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.LongName],
  1876633798: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3862327254: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.LongName],
  2188180465: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  395041908: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3293546465: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2674252688: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1285652485: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3203706013: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2951183804: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3296154744: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2611217952: (i) => [i.Position, i.Radius],
  1677625105: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2301859152: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  843113511: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  400855858: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3850581409: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2816379211: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3898045240: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1060000209: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  488727124: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  2940368186: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  335055490: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2954562838: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1502416096: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1973544240: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3495092785: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3961806047: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3426335179: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1335981549: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2635815018: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  479945903: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1599208980: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2063403501: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1945004755: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3040386961: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3041715199: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.FlowDirection, i.PredefinedType, i.SystemType],
  3205830791: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.PredefinedType],
  395920057: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.OperationType, i.UserDefinedOperationType],
  869906466: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3760055223: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2030761528: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3071239417: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1077100507: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3376911765: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  663422040: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2417008758: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3277789161: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2142170206: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1534661035: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1217240411: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  712377611: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1658829314: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2814081492: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3747195512: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  484807127: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1209101575: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.PredefinedType],
  346874300: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1810631287: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4222183408: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2058353004: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4278956645: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4037862832: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2188021234: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3132237377: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  987401354: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  707683696: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2223149337: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3508470533: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  900683007: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2713699986: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3009204131: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.UAxes, i.VAxes, i.WAxes, i.PredefinedType],
  3319311131: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2068733104: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4175244083: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2176052936: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2696325953: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.Mountable],
  76236018: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  629592764: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1154579445: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  1638804497: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1437502449: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1073191201: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2078563270: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  234836483: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2474470126: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2182337498: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  144952367: (i) => [i.Segments, i.SelfIntersect],
  3694346114: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1383356374: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1687234759: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType, i.ConstructionType],
  310824031: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3612865200: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3171933400: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  738039164: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  655969474: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  90941305: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3290496277: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2262370178: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3024970846: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3283111854: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1232101972: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect, i.KnotMultiplicities, i.Knots, i.KnotSpec, i.WeightsData],
  3798194928: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  979691226: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.NominalDiameter, i.CrossSectionArea, i.BarLength, i.PredefinedType, i.BarSurface],
  2572171363: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.BarLength, i.BarSurface, i.BendingShapeCode, !i.BendingParameters ? null : i.BendingParameters.map((p) => Labelise(p))],
  2016517767: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3053780830: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1783015770: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1329646415: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  991950508: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1529196076: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3420628829: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1999602285: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1404847402: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  331165859: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4252922144: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NumberOfRisers, i.NumberOfTreads, i.RiserHeight, i.TreadLength, i.PredefinedType],
  2515109513: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.OrientationOf2DPlane, i.LoadedBy, i.HasResults, i.SharedPlacement],
  385403989: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.ActionType, i.ActionSource, i.Coefficient, i.Purpose, i.SelfWeightCoefficients],
  1621171031: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.ProjectedOrTrue, i.PredefinedType],
  1162798199: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  812556717: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3425753595: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3825984169: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1620046519: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3026737570: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3179687236: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4292641817: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4207607924: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2391406946: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3512223829: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4237592921: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3304561284: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.PartitioningType, i.UserDefinedPartitioningType],
  2874132201: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1634111441: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  177149247: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2056796094: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3001207471: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  325726236: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType],
  277319702: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  753842376: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4196446775: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  32344328: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3314249567: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1095909175: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2938176219: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  635142910: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3758799889: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1051757585: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4217484030: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3999819293: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3902619387: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  639361253: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3221913625: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3571504051: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2272882330: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  578613899: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3460952963: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4136498852: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3640358203: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4074379575: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3693000487: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1052013943: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  562808652: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.PredefinedType],
  1062813311: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  342316401: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3518393246: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1360408905: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1904799276: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  862014818: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3310460725: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  24726584: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  264262732: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  402227799: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1003880860: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3415622556: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  819412036: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1426591983: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  182646315: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2680139844: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1971632696: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2295281155: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4086658281: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  630975310: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4288193352: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3087945054: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  25142252: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType]
};
TypeInitialisers[2] = {
  3699917729: (v) => new IFC4_3.IfcAbsorbedDoseMeasure(v),
  4182062534: (v) => new IFC4_3.IfcAccelerationMeasure(v),
  360377573: (v) => new IFC4_3.IfcAmountOfSubstanceMeasure(v),
  632304761: (v) => new IFC4_3.IfcAngularVelocityMeasure(v),
  3683503648: (v) => new IFC4_3.IfcArcIndex(v),
  1500781891: (v) => new IFC4_3.IfcAreaDensityMeasure(v),
  2650437152: (v) => new IFC4_3.IfcAreaMeasure(v),
  2314439260: (v) => new IFC4_3.IfcBinary(v),
  2735952531: (v) => new IFC4_3.IfcBoolean(v),
  1867003952: (v) => new IFC4_3.IfcBoxAlignment(v),
  1683019596: (v) => new IFC4_3.IfcCardinalPointReference(v),
  2991860651: (v) => new IFC4_3.IfcComplexNumber(v),
  3812528620: (v) => new IFC4_3.IfcCompoundPlaneAngleMeasure(v),
  3238673880: (v) => new IFC4_3.IfcContextDependentMeasure(v),
  1778710042: (v) => new IFC4_3.IfcCountMeasure(v),
  94842927: (v) => new IFC4_3.IfcCurvatureMeasure(v),
  937566702: (v) => new IFC4_3.IfcDate(v),
  2195413836: (v) => new IFC4_3.IfcDateTime(v),
  86635668: (v) => new IFC4_3.IfcDayInMonthNumber(v),
  3701338814: (v) => new IFC4_3.IfcDayInWeekNumber(v),
  1514641115: (v) => new IFC4_3.IfcDescriptiveMeasure(v),
  4134073009: (v) => new IFC4_3.IfcDimensionCount(v),
  524656162: (v) => new IFC4_3.IfcDoseEquivalentMeasure(v),
  2541165894: (v) => new IFC4_3.IfcDuration(v),
  69416015: (v) => new IFC4_3.IfcDynamicViscosityMeasure(v),
  1827137117: (v) => new IFC4_3.IfcElectricCapacitanceMeasure(v),
  3818826038: (v) => new IFC4_3.IfcElectricChargeMeasure(v),
  2093906313: (v) => new IFC4_3.IfcElectricConductanceMeasure(v),
  3790457270: (v) => new IFC4_3.IfcElectricCurrentMeasure(v),
  2951915441: (v) => new IFC4_3.IfcElectricResistanceMeasure(v),
  2506197118: (v) => new IFC4_3.IfcElectricVoltageMeasure(v),
  2078135608: (v) => new IFC4_3.IfcEnergyMeasure(v),
  1102727119: (v) => new IFC4_3.IfcFontStyle(v),
  2715512545: (v) => new IFC4_3.IfcFontVariant(v),
  2590844177: (v) => new IFC4_3.IfcFontWeight(v),
  1361398929: (v) => new IFC4_3.IfcForceMeasure(v),
  3044325142: (v) => new IFC4_3.IfcFrequencyMeasure(v),
  3064340077: (v) => new IFC4_3.IfcGloballyUniqueId(v),
  3113092358: (v) => new IFC4_3.IfcHeatFluxDensityMeasure(v),
  1158859006: (v) => new IFC4_3.IfcHeatingValueMeasure(v),
  983778844: (v) => new IFC4_3.IfcIdentifier(v),
  3358199106: (v) => new IFC4_3.IfcIlluminanceMeasure(v),
  2679005408: (v) => new IFC4_3.IfcInductanceMeasure(v),
  1939436016: (v) => new IFC4_3.IfcInteger(v),
  3809634241: (v) => new IFC4_3.IfcIntegerCountRateMeasure(v),
  3686016028: (v) => new IFC4_3.IfcIonConcentrationMeasure(v),
  3192672207: (v) => new IFC4_3.IfcIsothermalMoistureCapacityMeasure(v),
  2054016361: (v) => new IFC4_3.IfcKinematicViscosityMeasure(v),
  3258342251: (v) => new IFC4_3.IfcLabel(v),
  1275358634: (v) => new IFC4_3.IfcLanguageId(v),
  1243674935: (v) => new IFC4_3.IfcLengthMeasure(v),
  1774176899: (v) => new IFC4_3.IfcLineIndex(v),
  191860431: (v) => new IFC4_3.IfcLinearForceMeasure(v),
  2128979029: (v) => new IFC4_3.IfcLinearMomentMeasure(v),
  1307019551: (v) => new IFC4_3.IfcLinearStiffnessMeasure(v),
  3086160713: (v) => new IFC4_3.IfcLinearVelocityMeasure(v),
  503418787: (v) => new IFC4_3.IfcLogical(v),
  2095003142: (v) => new IFC4_3.IfcLuminousFluxMeasure(v),
  2755797622: (v) => new IFC4_3.IfcLuminousIntensityDistributionMeasure(v),
  151039812: (v) => new IFC4_3.IfcLuminousIntensityMeasure(v),
  286949696: (v) => new IFC4_3.IfcMagneticFluxDensityMeasure(v),
  2486716878: (v) => new IFC4_3.IfcMagneticFluxMeasure(v),
  1477762836: (v) => new IFC4_3.IfcMassDensityMeasure(v),
  4017473158: (v) => new IFC4_3.IfcMassFlowRateMeasure(v),
  3124614049: (v) => new IFC4_3.IfcMassMeasure(v),
  3531705166: (v) => new IFC4_3.IfcMassPerLengthMeasure(v),
  3341486342: (v) => new IFC4_3.IfcModulusOfElasticityMeasure(v),
  2173214787: (v) => new IFC4_3.IfcModulusOfLinearSubgradeReactionMeasure(v),
  1052454078: (v) => new IFC4_3.IfcModulusOfRotationalSubgradeReactionMeasure(v),
  1753493141: (v) => new IFC4_3.IfcModulusOfSubgradeReactionMeasure(v),
  3177669450: (v) => new IFC4_3.IfcMoistureDiffusivityMeasure(v),
  1648970520: (v) => new IFC4_3.IfcMolecularWeightMeasure(v),
  3114022597: (v) => new IFC4_3.IfcMomentOfInertiaMeasure(v),
  2615040989: (v) => new IFC4_3.IfcMonetaryMeasure(v),
  765770214: (v) => new IFC4_3.IfcMonthInYearNumber(v),
  525895558: (v) => new IFC4_3.IfcNonNegativeLengthMeasure(v),
  2095195183: (v) => new IFC4_3.IfcNormalisedRatioMeasure(v),
  2395907400: (v) => new IFC4_3.IfcNumericMeasure(v),
  929793134: (v) => new IFC4_3.IfcPHMeasure(v),
  2260317790: (v) => new IFC4_3.IfcParameterValue(v),
  2642773653: (v) => new IFC4_3.IfcPlanarForceMeasure(v),
  4042175685: (v) => new IFC4_3.IfcPlaneAngleMeasure(v),
  1790229001: (v) => new IFC4_3.IfcPositiveInteger(v),
  2815919920: (v) => new IFC4_3.IfcPositiveLengthMeasure(v),
  3054510233: (v) => new IFC4_3.IfcPositivePlaneAngleMeasure(v),
  1245737093: (v) => new IFC4_3.IfcPositiveRatioMeasure(v),
  1364037233: (v) => new IFC4_3.IfcPowerMeasure(v),
  2169031380: (v) => new IFC4_3.IfcPresentableText(v),
  3665567075: (v) => new IFC4_3.IfcPressureMeasure(v),
  2798247006: (v) => new IFC4_3.IfcPropertySetDefinitionSet(v),
  3972513137: (v) => new IFC4_3.IfcRadioActivityMeasure(v),
  96294661: (v) => new IFC4_3.IfcRatioMeasure(v),
  200335297: (v) => new IFC4_3.IfcReal(v),
  2133746277: (v) => new IFC4_3.IfcRotationalFrequencyMeasure(v),
  1755127002: (v) => new IFC4_3.IfcRotationalMassMeasure(v),
  3211557302: (v) => new IFC4_3.IfcRotationalStiffnessMeasure(v),
  3467162246: (v) => new IFC4_3.IfcSectionModulusMeasure(v),
  2190458107: (v) => new IFC4_3.IfcSectionalAreaIntegralMeasure(v),
  408310005: (v) => new IFC4_3.IfcShearModulusMeasure(v),
  3471399674: (v) => new IFC4_3.IfcSolidAngleMeasure(v),
  4157543285: (v) => new IFC4_3.IfcSoundPowerLevelMeasure(v),
  846465480: (v) => new IFC4_3.IfcSoundPowerMeasure(v),
  3457685358: (v) => new IFC4_3.IfcSoundPressureLevelMeasure(v),
  993287707: (v) => new IFC4_3.IfcSoundPressureMeasure(v),
  3477203348: (v) => new IFC4_3.IfcSpecificHeatCapacityMeasure(v),
  2757832317: (v) => new IFC4_3.IfcSpecularExponent(v),
  361837227: (v) => new IFC4_3.IfcSpecularRoughness(v),
  58845555: (v) => new IFC4_3.IfcTemperatureGradientMeasure(v),
  1209108979: (v) => new IFC4_3.IfcTemperatureRateOfChangeMeasure(v),
  2801250643: (v) => new IFC4_3.IfcText(v),
  1460886941: (v) => new IFC4_3.IfcTextAlignment(v),
  3490877962: (v) => new IFC4_3.IfcTextDecoration(v),
  603696268: (v) => new IFC4_3.IfcTextFontName(v),
  296282323: (v) => new IFC4_3.IfcTextTransformation(v),
  232962298: (v) => new IFC4_3.IfcThermalAdmittanceMeasure(v),
  2645777649: (v) => new IFC4_3.IfcThermalConductivityMeasure(v),
  2281867870: (v) => new IFC4_3.IfcThermalExpansionCoefficientMeasure(v),
  857959152: (v) => new IFC4_3.IfcThermalResistanceMeasure(v),
  2016195849: (v) => new IFC4_3.IfcThermalTransmittanceMeasure(v),
  743184107: (v) => new IFC4_3.IfcThermodynamicTemperatureMeasure(v),
  4075327185: (v) => new IFC4_3.IfcTime(v),
  2726807636: (v) => new IFC4_3.IfcTimeMeasure(v),
  2591213694: (v) => new IFC4_3.IfcTimeStamp(v),
  1278329552: (v) => new IFC4_3.IfcTorqueMeasure(v),
  950732822: (v) => new IFC4_3.IfcURIReference(v),
  3345633955: (v) => new IFC4_3.IfcVaporPermeabilityMeasure(v),
  3458127941: (v) => new IFC4_3.IfcVolumeMeasure(v),
  2593997549: (v) => new IFC4_3.IfcVolumetricFlowRateMeasure(v),
  51269191: (v) => new IFC4_3.IfcWarpingConstantMeasure(v),
  1718600412: (v) => new IFC4_3.IfcWarpingMomentMeasure(v)
};
var IFC4_3;
(function(IFC4_32) {
  class IfcAbsorbedDoseMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcAbsorbedDoseMeasure = IfcAbsorbedDoseMeasure;
  class IfcAccelerationMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcAccelerationMeasure = IfcAccelerationMeasure;
  class IfcAmountOfSubstanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcAmountOfSubstanceMeasure = IfcAmountOfSubstanceMeasure;
  class IfcAngularVelocityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcAngularVelocityMeasure = IfcAngularVelocityMeasure;
  class IfcArcIndex {
    constructor(value) {
      this.value = value;
    }
  }
  IFC4_32.IfcArcIndex = IfcArcIndex;
  ;
  class IfcAreaDensityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcAreaDensityMeasure = IfcAreaDensityMeasure;
  class IfcAreaMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcAreaMeasure = IfcAreaMeasure;
  class IfcBinary {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcBinary = IfcBinary;
  class IfcBoolean {
    constructor(value) {
      this.value = value;
      this.type = 3;
    }
  }
  IFC4_32.IfcBoolean = IfcBoolean;
  class IfcBoxAlignment {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcBoxAlignment = IfcBoxAlignment;
  class IfcCardinalPointReference {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcCardinalPointReference = IfcCardinalPointReference;
  class IfcComplexNumber {
    constructor(value) {
      this.value = value;
    }
  }
  IFC4_32.IfcComplexNumber = IfcComplexNumber;
  ;
  class IfcCompoundPlaneAngleMeasure {
    constructor(value) {
      this.value = value;
    }
  }
  IFC4_32.IfcCompoundPlaneAngleMeasure = IfcCompoundPlaneAngleMeasure;
  ;
  class IfcContextDependentMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcContextDependentMeasure = IfcContextDependentMeasure;
  class IfcCountMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcCountMeasure = IfcCountMeasure;
  class IfcCurvatureMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcCurvatureMeasure = IfcCurvatureMeasure;
  class IfcDate {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcDate = IfcDate;
  class IfcDateTime {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcDateTime = IfcDateTime;
  class IfcDayInMonthNumber {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcDayInMonthNumber = IfcDayInMonthNumber;
  class IfcDayInWeekNumber {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcDayInWeekNumber = IfcDayInWeekNumber;
  class IfcDescriptiveMeasure {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcDescriptiveMeasure = IfcDescriptiveMeasure;
  class IfcDimensionCount {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcDimensionCount = IfcDimensionCount;
  class IfcDoseEquivalentMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcDoseEquivalentMeasure = IfcDoseEquivalentMeasure;
  class IfcDuration {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcDuration = IfcDuration;
  class IfcDynamicViscosityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcDynamicViscosityMeasure = IfcDynamicViscosityMeasure;
  class IfcElectricCapacitanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcElectricCapacitanceMeasure = IfcElectricCapacitanceMeasure;
  class IfcElectricChargeMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcElectricChargeMeasure = IfcElectricChargeMeasure;
  class IfcElectricConductanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcElectricConductanceMeasure = IfcElectricConductanceMeasure;
  class IfcElectricCurrentMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcElectricCurrentMeasure = IfcElectricCurrentMeasure;
  class IfcElectricResistanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcElectricResistanceMeasure = IfcElectricResistanceMeasure;
  class IfcElectricVoltageMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcElectricVoltageMeasure = IfcElectricVoltageMeasure;
  class IfcEnergyMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcEnergyMeasure = IfcEnergyMeasure;
  class IfcFontStyle {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcFontStyle = IfcFontStyle;
  class IfcFontVariant {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcFontVariant = IfcFontVariant;
  class IfcFontWeight {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcFontWeight = IfcFontWeight;
  class IfcForceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcForceMeasure = IfcForceMeasure;
  class IfcFrequencyMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcFrequencyMeasure = IfcFrequencyMeasure;
  class IfcGloballyUniqueId {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcGloballyUniqueId = IfcGloballyUniqueId;
  class IfcHeatFluxDensityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcHeatFluxDensityMeasure = IfcHeatFluxDensityMeasure;
  class IfcHeatingValueMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcHeatingValueMeasure = IfcHeatingValueMeasure;
  class IfcIdentifier {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcIdentifier = IfcIdentifier;
  class IfcIlluminanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcIlluminanceMeasure = IfcIlluminanceMeasure;
  class IfcInductanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcInductanceMeasure = IfcInductanceMeasure;
  class IfcInteger {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcInteger = IfcInteger;
  class IfcIntegerCountRateMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcIntegerCountRateMeasure = IfcIntegerCountRateMeasure;
  class IfcIonConcentrationMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcIonConcentrationMeasure = IfcIonConcentrationMeasure;
  class IfcIsothermalMoistureCapacityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcIsothermalMoistureCapacityMeasure = IfcIsothermalMoistureCapacityMeasure;
  class IfcKinematicViscosityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcKinematicViscosityMeasure = IfcKinematicViscosityMeasure;
  class IfcLabel {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcLabel = IfcLabel;
  class IfcLanguageId {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcLanguageId = IfcLanguageId;
  class IfcLengthMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcLengthMeasure = IfcLengthMeasure;
  class IfcLineIndex {
    constructor(value) {
      this.value = value;
    }
  }
  IFC4_32.IfcLineIndex = IfcLineIndex;
  ;
  class IfcLinearForceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcLinearForceMeasure = IfcLinearForceMeasure;
  class IfcLinearMomentMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcLinearMomentMeasure = IfcLinearMomentMeasure;
  class IfcLinearStiffnessMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcLinearStiffnessMeasure = IfcLinearStiffnessMeasure;
  class IfcLinearVelocityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcLinearVelocityMeasure = IfcLinearVelocityMeasure;
  class IfcLogical {
    constructor(value) {
      this.value = value;
      this.type = 3;
    }
  }
  IFC4_32.IfcLogical = IfcLogical;
  class IfcLuminousFluxMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcLuminousFluxMeasure = IfcLuminousFluxMeasure;
  class IfcLuminousIntensityDistributionMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcLuminousIntensityDistributionMeasure = IfcLuminousIntensityDistributionMeasure;
  class IfcLuminousIntensityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcLuminousIntensityMeasure = IfcLuminousIntensityMeasure;
  class IfcMagneticFluxDensityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcMagneticFluxDensityMeasure = IfcMagneticFluxDensityMeasure;
  class IfcMagneticFluxMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcMagneticFluxMeasure = IfcMagneticFluxMeasure;
  class IfcMassDensityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcMassDensityMeasure = IfcMassDensityMeasure;
  class IfcMassFlowRateMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcMassFlowRateMeasure = IfcMassFlowRateMeasure;
  class IfcMassMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcMassMeasure = IfcMassMeasure;
  class IfcMassPerLengthMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcMassPerLengthMeasure = IfcMassPerLengthMeasure;
  class IfcModulusOfElasticityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcModulusOfElasticityMeasure = IfcModulusOfElasticityMeasure;
  class IfcModulusOfLinearSubgradeReactionMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcModulusOfLinearSubgradeReactionMeasure = IfcModulusOfLinearSubgradeReactionMeasure;
  class IfcModulusOfRotationalSubgradeReactionMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcModulusOfRotationalSubgradeReactionMeasure = IfcModulusOfRotationalSubgradeReactionMeasure;
  class IfcModulusOfSubgradeReactionMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcModulusOfSubgradeReactionMeasure = IfcModulusOfSubgradeReactionMeasure;
  class IfcMoistureDiffusivityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcMoistureDiffusivityMeasure = IfcMoistureDiffusivityMeasure;
  class IfcMolecularWeightMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcMolecularWeightMeasure = IfcMolecularWeightMeasure;
  class IfcMomentOfInertiaMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcMomentOfInertiaMeasure = IfcMomentOfInertiaMeasure;
  class IfcMonetaryMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcMonetaryMeasure = IfcMonetaryMeasure;
  class IfcMonthInYearNumber {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcMonthInYearNumber = IfcMonthInYearNumber;
  class IfcNonNegativeLengthMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcNonNegativeLengthMeasure = IfcNonNegativeLengthMeasure;
  class IfcNormalisedRatioMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcNormalisedRatioMeasure = IfcNormalisedRatioMeasure;
  class IfcNumericMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcNumericMeasure = IfcNumericMeasure;
  class IfcPHMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcPHMeasure = IfcPHMeasure;
  class IfcParameterValue {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcParameterValue = IfcParameterValue;
  class IfcPlanarForceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcPlanarForceMeasure = IfcPlanarForceMeasure;
  class IfcPlaneAngleMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcPlaneAngleMeasure = IfcPlaneAngleMeasure;
  class IfcPositiveInteger {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcPositiveInteger = IfcPositiveInteger;
  class IfcPositiveLengthMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcPositiveLengthMeasure = IfcPositiveLengthMeasure;
  class IfcPositivePlaneAngleMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcPositivePlaneAngleMeasure = IfcPositivePlaneAngleMeasure;
  class IfcPositiveRatioMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcPositiveRatioMeasure = IfcPositiveRatioMeasure;
  class IfcPowerMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcPowerMeasure = IfcPowerMeasure;
  class IfcPresentableText {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcPresentableText = IfcPresentableText;
  class IfcPressureMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcPressureMeasure = IfcPressureMeasure;
  class IfcPropertySetDefinitionSet {
    constructor(value) {
      this.value = value;
    }
  }
  IFC4_32.IfcPropertySetDefinitionSet = IfcPropertySetDefinitionSet;
  ;
  class IfcRadioActivityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcRadioActivityMeasure = IfcRadioActivityMeasure;
  class IfcRatioMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcRatioMeasure = IfcRatioMeasure;
  class IfcReal {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcReal = IfcReal;
  class IfcRotationalFrequencyMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcRotationalFrequencyMeasure = IfcRotationalFrequencyMeasure;
  class IfcRotationalMassMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcRotationalMassMeasure = IfcRotationalMassMeasure;
  class IfcRotationalStiffnessMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcRotationalStiffnessMeasure = IfcRotationalStiffnessMeasure;
  class IfcSectionModulusMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcSectionModulusMeasure = IfcSectionModulusMeasure;
  class IfcSectionalAreaIntegralMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcSectionalAreaIntegralMeasure = IfcSectionalAreaIntegralMeasure;
  class IfcShearModulusMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcShearModulusMeasure = IfcShearModulusMeasure;
  class IfcSolidAngleMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcSolidAngleMeasure = IfcSolidAngleMeasure;
  class IfcSoundPowerLevelMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcSoundPowerLevelMeasure = IfcSoundPowerLevelMeasure;
  class IfcSoundPowerMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcSoundPowerMeasure = IfcSoundPowerMeasure;
  class IfcSoundPressureLevelMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcSoundPressureLevelMeasure = IfcSoundPressureLevelMeasure;
  class IfcSoundPressureMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcSoundPressureMeasure = IfcSoundPressureMeasure;
  class IfcSpecificHeatCapacityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcSpecificHeatCapacityMeasure = IfcSpecificHeatCapacityMeasure;
  class IfcSpecularExponent {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcSpecularExponent = IfcSpecularExponent;
  class IfcSpecularRoughness {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcSpecularRoughness = IfcSpecularRoughness;
  class IfcTemperatureGradientMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcTemperatureGradientMeasure = IfcTemperatureGradientMeasure;
  class IfcTemperatureRateOfChangeMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcTemperatureRateOfChangeMeasure = IfcTemperatureRateOfChangeMeasure;
  class IfcText {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcText = IfcText;
  class IfcTextAlignment {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcTextAlignment = IfcTextAlignment;
  class IfcTextDecoration {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcTextDecoration = IfcTextDecoration;
  class IfcTextFontName {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcTextFontName = IfcTextFontName;
  class IfcTextTransformation {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcTextTransformation = IfcTextTransformation;
  class IfcThermalAdmittanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcThermalAdmittanceMeasure = IfcThermalAdmittanceMeasure;
  class IfcThermalConductivityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcThermalConductivityMeasure = IfcThermalConductivityMeasure;
  class IfcThermalExpansionCoefficientMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcThermalExpansionCoefficientMeasure = IfcThermalExpansionCoefficientMeasure;
  class IfcThermalResistanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcThermalResistanceMeasure = IfcThermalResistanceMeasure;
  class IfcThermalTransmittanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcThermalTransmittanceMeasure = IfcThermalTransmittanceMeasure;
  class IfcThermodynamicTemperatureMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcThermodynamicTemperatureMeasure = IfcThermodynamicTemperatureMeasure;
  class IfcTime {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcTime = IfcTime;
  class IfcTimeMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcTimeMeasure = IfcTimeMeasure;
  class IfcTimeStamp {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcTimeStamp = IfcTimeStamp;
  class IfcTorqueMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcTorqueMeasure = IfcTorqueMeasure;
  class IfcURIReference {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC4_32.IfcURIReference = IfcURIReference;
  class IfcVaporPermeabilityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcVaporPermeabilityMeasure = IfcVaporPermeabilityMeasure;
  class IfcVolumeMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcVolumeMeasure = IfcVolumeMeasure;
  class IfcVolumetricFlowRateMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcVolumetricFlowRateMeasure = IfcVolumetricFlowRateMeasure;
  class IfcWarpingConstantMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcWarpingConstantMeasure = IfcWarpingConstantMeasure;
  class IfcWarpingMomentMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC4_32.IfcWarpingMomentMeasure = IfcWarpingMomentMeasure;
  class IfcActionRequestTypeEnum {
  }
  IfcActionRequestTypeEnum.EMAIL = { type: 3, value: "EMAIL" };
  IfcActionRequestTypeEnum.FAX = { type: 3, value: "FAX" };
  IfcActionRequestTypeEnum.PHONE = { type: 3, value: "PHONE" };
  IfcActionRequestTypeEnum.POST = { type: 3, value: "POST" };
  IfcActionRequestTypeEnum.VERBAL = { type: 3, value: "VERBAL" };
  IfcActionRequestTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcActionRequestTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcActionRequestTypeEnum = IfcActionRequestTypeEnum;
  class IfcActionSourceTypeEnum {
  }
  IfcActionSourceTypeEnum.BRAKES = { type: 3, value: "BRAKES" };
  IfcActionSourceTypeEnum.BUOYANCY = { type: 3, value: "BUOYANCY" };
  IfcActionSourceTypeEnum.COMPLETION_G1 = { type: 3, value: "COMPLETION_G1" };
  IfcActionSourceTypeEnum.CREEP = { type: 3, value: "CREEP" };
  IfcActionSourceTypeEnum.CURRENT = { type: 3, value: "CURRENT" };
  IfcActionSourceTypeEnum.DEAD_LOAD_G = { type: 3, value: "DEAD_LOAD_G" };
  IfcActionSourceTypeEnum.EARTHQUAKE_E = { type: 3, value: "EARTHQUAKE_E" };
  IfcActionSourceTypeEnum.ERECTION = { type: 3, value: "ERECTION" };
  IfcActionSourceTypeEnum.FIRE = { type: 3, value: "FIRE" };
  IfcActionSourceTypeEnum.ICE = { type: 3, value: "ICE" };
  IfcActionSourceTypeEnum.IMPACT = { type: 3, value: "IMPACT" };
  IfcActionSourceTypeEnum.IMPULSE = { type: 3, value: "IMPULSE" };
  IfcActionSourceTypeEnum.LACK_OF_FIT = { type: 3, value: "LACK_OF_FIT" };
  IfcActionSourceTypeEnum.LIVE_LOAD_Q = { type: 3, value: "LIVE_LOAD_Q" };
  IfcActionSourceTypeEnum.PRESTRESSING_P = { type: 3, value: "PRESTRESSING_P" };
  IfcActionSourceTypeEnum.PROPPING = { type: 3, value: "PROPPING" };
  IfcActionSourceTypeEnum.RAIN = { type: 3, value: "RAIN" };
  IfcActionSourceTypeEnum.SETTLEMENT_U = { type: 3, value: "SETTLEMENT_U" };
  IfcActionSourceTypeEnum.SHRINKAGE = { type: 3, value: "SHRINKAGE" };
  IfcActionSourceTypeEnum.SNOW_S = { type: 3, value: "SNOW_S" };
  IfcActionSourceTypeEnum.SYSTEM_IMPERFECTION = { type: 3, value: "SYSTEM_IMPERFECTION" };
  IfcActionSourceTypeEnum.TEMPERATURE_T = { type: 3, value: "TEMPERATURE_T" };
  IfcActionSourceTypeEnum.TRANSPORT = { type: 3, value: "TRANSPORT" };
  IfcActionSourceTypeEnum.WAVE = { type: 3, value: "WAVE" };
  IfcActionSourceTypeEnum.WIND_W = { type: 3, value: "WIND_W" };
  IfcActionSourceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcActionSourceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcActionSourceTypeEnum = IfcActionSourceTypeEnum;
  class IfcActionTypeEnum {
  }
  IfcActionTypeEnum.EXTRAORDINARY_A = { type: 3, value: "EXTRAORDINARY_A" };
  IfcActionTypeEnum.PERMANENT_G = { type: 3, value: "PERMANENT_G" };
  IfcActionTypeEnum.VARIABLE_Q = { type: 3, value: "VARIABLE_Q" };
  IfcActionTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcActionTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcActionTypeEnum = IfcActionTypeEnum;
  class IfcActuatorTypeEnum {
  }
  IfcActuatorTypeEnum.ELECTRICACTUATOR = { type: 3, value: "ELECTRICACTUATOR" };
  IfcActuatorTypeEnum.HANDOPERATEDACTUATOR = { type: 3, value: "HANDOPERATEDACTUATOR" };
  IfcActuatorTypeEnum.HYDRAULICACTUATOR = { type: 3, value: "HYDRAULICACTUATOR" };
  IfcActuatorTypeEnum.PNEUMATICACTUATOR = { type: 3, value: "PNEUMATICACTUATOR" };
  IfcActuatorTypeEnum.THERMOSTATICACTUATOR = { type: 3, value: "THERMOSTATICACTUATOR" };
  IfcActuatorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcActuatorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcActuatorTypeEnum = IfcActuatorTypeEnum;
  class IfcAddressTypeEnum {
  }
  IfcAddressTypeEnum.DISTRIBUTIONPOINT = { type: 3, value: "DISTRIBUTIONPOINT" };
  IfcAddressTypeEnum.HOME = { type: 3, value: "HOME" };
  IfcAddressTypeEnum.OFFICE = { type: 3, value: "OFFICE" };
  IfcAddressTypeEnum.SITE = { type: 3, value: "SITE" };
  IfcAddressTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IFC4_32.IfcAddressTypeEnum = IfcAddressTypeEnum;
  class IfcAirTerminalBoxTypeEnum {
  }
  IfcAirTerminalBoxTypeEnum.CONSTANTFLOW = { type: 3, value: "CONSTANTFLOW" };
  IfcAirTerminalBoxTypeEnum.VARIABLEFLOWPRESSUREDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREDEPENDANT" };
  IfcAirTerminalBoxTypeEnum.VARIABLEFLOWPRESSUREINDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREINDEPENDANT" };
  IfcAirTerminalBoxTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAirTerminalBoxTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcAirTerminalBoxTypeEnum = IfcAirTerminalBoxTypeEnum;
  class IfcAirTerminalTypeEnum {
  }
  IfcAirTerminalTypeEnum.DIFFUSER = { type: 3, value: "DIFFUSER" };
  IfcAirTerminalTypeEnum.GRILLE = { type: 3, value: "GRILLE" };
  IfcAirTerminalTypeEnum.LOUVRE = { type: 3, value: "LOUVRE" };
  IfcAirTerminalTypeEnum.REGISTER = { type: 3, value: "REGISTER" };
  IfcAirTerminalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAirTerminalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcAirTerminalTypeEnum = IfcAirTerminalTypeEnum;
  class IfcAirToAirHeatRecoveryTypeEnum {
  }
  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATECOUNTERFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECOUNTERFLOWEXCHANGER" };
  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATECROSSFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECROSSFLOWEXCHANGER" };
  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATEPARALLELFLOWEXCHANGER = { type: 3, value: "FIXEDPLATEPARALLELFLOWEXCHANGER" };
  IfcAirToAirHeatRecoveryTypeEnum.HEATPIPE = { type: 3, value: "HEATPIPE" };
  IfcAirToAirHeatRecoveryTypeEnum.ROTARYWHEEL = { type: 3, value: "ROTARYWHEEL" };
  IfcAirToAirHeatRecoveryTypeEnum.RUNAROUNDCOILLOOP = { type: 3, value: "RUNAROUNDCOILLOOP" };
  IfcAirToAirHeatRecoveryTypeEnum.THERMOSIPHONCOILTYPEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS" };
  IfcAirToAirHeatRecoveryTypeEnum.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS" };
  IfcAirToAirHeatRecoveryTypeEnum.TWINTOWERENTHALPYRECOVERYLOOPS = { type: 3, value: "TWINTOWERENTHALPYRECOVERYLOOPS" };
  IfcAirToAirHeatRecoveryTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAirToAirHeatRecoveryTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcAirToAirHeatRecoveryTypeEnum = IfcAirToAirHeatRecoveryTypeEnum;
  class IfcAlarmTypeEnum {
  }
  IfcAlarmTypeEnum.BELL = { type: 3, value: "BELL" };
  IfcAlarmTypeEnum.BREAKGLASSBUTTON = { type: 3, value: "BREAKGLASSBUTTON" };
  IfcAlarmTypeEnum.LIGHT = { type: 3, value: "LIGHT" };
  IfcAlarmTypeEnum.MANUALPULLBOX = { type: 3, value: "MANUALPULLBOX" };
  IfcAlarmTypeEnum.RAILWAYCROCODILE = { type: 3, value: "RAILWAYCROCODILE" };
  IfcAlarmTypeEnum.RAILWAYDETONATOR = { type: 3, value: "RAILWAYDETONATOR" };
  IfcAlarmTypeEnum.SIREN = { type: 3, value: "SIREN" };
  IfcAlarmTypeEnum.WHISTLE = { type: 3, value: "WHISTLE" };
  IfcAlarmTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAlarmTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcAlarmTypeEnum = IfcAlarmTypeEnum;
  class IfcAlignmentCantSegmentTypeEnum {
  }
  IfcAlignmentCantSegmentTypeEnum.BLOSSCURVE = { type: 3, value: "BLOSSCURVE" };
  IfcAlignmentCantSegmentTypeEnum.CONSTANTCANT = { type: 3, value: "CONSTANTCANT" };
  IfcAlignmentCantSegmentTypeEnum.COSINECURVE = { type: 3, value: "COSINECURVE" };
  IfcAlignmentCantSegmentTypeEnum.HELMERTCURVE = { type: 3, value: "HELMERTCURVE" };
  IfcAlignmentCantSegmentTypeEnum.LINEARTRANSITION = { type: 3, value: "LINEARTRANSITION" };
  IfcAlignmentCantSegmentTypeEnum.SINECURVE = { type: 3, value: "SINECURVE" };
  IfcAlignmentCantSegmentTypeEnum.VIENNESEBEND = { type: 3, value: "VIENNESEBEND" };
  IFC4_32.IfcAlignmentCantSegmentTypeEnum = IfcAlignmentCantSegmentTypeEnum;
  class IfcAlignmentHorizontalSegmentTypeEnum {
  }
  IfcAlignmentHorizontalSegmentTypeEnum.BLOSSCURVE = { type: 3, value: "BLOSSCURVE" };
  IfcAlignmentHorizontalSegmentTypeEnum.CIRCULARARC = { type: 3, value: "CIRCULARARC" };
  IfcAlignmentHorizontalSegmentTypeEnum.CLOTHOID = { type: 3, value: "CLOTHOID" };
  IfcAlignmentHorizontalSegmentTypeEnum.COSINECURVE = { type: 3, value: "COSINECURVE" };
  IfcAlignmentHorizontalSegmentTypeEnum.CUBIC = { type: 3, value: "CUBIC" };
  IfcAlignmentHorizontalSegmentTypeEnum.HELMERTCURVE = { type: 3, value: "HELMERTCURVE" };
  IfcAlignmentHorizontalSegmentTypeEnum.LINE = { type: 3, value: "LINE" };
  IfcAlignmentHorizontalSegmentTypeEnum.SINECURVE = { type: 3, value: "SINECURVE" };
  IfcAlignmentHorizontalSegmentTypeEnum.VIENNESEBEND = { type: 3, value: "VIENNESEBEND" };
  IFC4_32.IfcAlignmentHorizontalSegmentTypeEnum = IfcAlignmentHorizontalSegmentTypeEnum;
  class IfcAlignmentTypeEnum {
  }
  IfcAlignmentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAlignmentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcAlignmentTypeEnum = IfcAlignmentTypeEnum;
  class IfcAlignmentVerticalSegmentTypeEnum {
  }
  IfcAlignmentVerticalSegmentTypeEnum.CIRCULARARC = { type: 3, value: "CIRCULARARC" };
  IfcAlignmentVerticalSegmentTypeEnum.CLOTHOID = { type: 3, value: "CLOTHOID" };
  IfcAlignmentVerticalSegmentTypeEnum.CONSTANTGRADIENT = { type: 3, value: "CONSTANTGRADIENT" };
  IfcAlignmentVerticalSegmentTypeEnum.PARABOLICARC = { type: 3, value: "PARABOLICARC" };
  IFC4_32.IfcAlignmentVerticalSegmentTypeEnum = IfcAlignmentVerticalSegmentTypeEnum;
  class IfcAnalysisModelTypeEnum {
  }
  IfcAnalysisModelTypeEnum.IN_PLANE_LOADING_2D = { type: 3, value: "IN_PLANE_LOADING_2D" };
  IfcAnalysisModelTypeEnum.LOADING_3D = { type: 3, value: "LOADING_3D" };
  IfcAnalysisModelTypeEnum.OUT_PLANE_LOADING_2D = { type: 3, value: "OUT_PLANE_LOADING_2D" };
  IfcAnalysisModelTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAnalysisModelTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcAnalysisModelTypeEnum = IfcAnalysisModelTypeEnum;
  class IfcAnalysisTheoryTypeEnum {
  }
  IfcAnalysisTheoryTypeEnum.FIRST_ORDER_THEORY = { type: 3, value: "FIRST_ORDER_THEORY" };
  IfcAnalysisTheoryTypeEnum.FULL_NONLINEAR_THEORY = { type: 3, value: "FULL_NONLINEAR_THEORY" };
  IfcAnalysisTheoryTypeEnum.SECOND_ORDER_THEORY = { type: 3, value: "SECOND_ORDER_THEORY" };
  IfcAnalysisTheoryTypeEnum.THIRD_ORDER_THEORY = { type: 3, value: "THIRD_ORDER_THEORY" };
  IfcAnalysisTheoryTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAnalysisTheoryTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcAnalysisTheoryTypeEnum = IfcAnalysisTheoryTypeEnum;
  class IfcAnnotationTypeEnum {
  }
  IfcAnnotationTypeEnum.ASBUILTAREA = { type: 3, value: "ASBUILTAREA" };
  IfcAnnotationTypeEnum.ASBUILTLINE = { type: 3, value: "ASBUILTLINE" };
  IfcAnnotationTypeEnum.ASBUILTPOINT = { type: 3, value: "ASBUILTPOINT" };
  IfcAnnotationTypeEnum.ASSUMEDAREA = { type: 3, value: "ASSUMEDAREA" };
  IfcAnnotationTypeEnum.ASSUMEDLINE = { type: 3, value: "ASSUMEDLINE" };
  IfcAnnotationTypeEnum.ASSUMEDPOINT = { type: 3, value: "ASSUMEDPOINT" };
  IfcAnnotationTypeEnum.NON_PHYSICAL_SIGNAL = { type: 3, value: "NON_PHYSICAL_SIGNAL" };
  IfcAnnotationTypeEnum.SUPERELEVATIONEVENT = { type: 3, value: "SUPERELEVATIONEVENT" };
  IfcAnnotationTypeEnum.WIDTHEVENT = { type: 3, value: "WIDTHEVENT" };
  IfcAnnotationTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAnnotationTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcAnnotationTypeEnum = IfcAnnotationTypeEnum;
  class IfcArithmeticOperatorEnum {
  }
  IfcArithmeticOperatorEnum.ADD = { type: 3, value: "ADD" };
  IfcArithmeticOperatorEnum.DIVIDE = { type: 3, value: "DIVIDE" };
  IfcArithmeticOperatorEnum.MULTIPLY = { type: 3, value: "MULTIPLY" };
  IfcArithmeticOperatorEnum.SUBTRACT = { type: 3, value: "SUBTRACT" };
  IFC4_32.IfcArithmeticOperatorEnum = IfcArithmeticOperatorEnum;
  class IfcAssemblyPlaceEnum {
  }
  IfcAssemblyPlaceEnum.FACTORY = { type: 3, value: "FACTORY" };
  IfcAssemblyPlaceEnum.SITE = { type: 3, value: "SITE" };
  IfcAssemblyPlaceEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcAssemblyPlaceEnum = IfcAssemblyPlaceEnum;
  class IfcAudioVisualApplianceTypeEnum {
  }
  IfcAudioVisualApplianceTypeEnum.AMPLIFIER = { type: 3, value: "AMPLIFIER" };
  IfcAudioVisualApplianceTypeEnum.CAMERA = { type: 3, value: "CAMERA" };
  IfcAudioVisualApplianceTypeEnum.COMMUNICATIONTERMINAL = { type: 3, value: "COMMUNICATIONTERMINAL" };
  IfcAudioVisualApplianceTypeEnum.DISPLAY = { type: 3, value: "DISPLAY" };
  IfcAudioVisualApplianceTypeEnum.MICROPHONE = { type: 3, value: "MICROPHONE" };
  IfcAudioVisualApplianceTypeEnum.PLAYER = { type: 3, value: "PLAYER" };
  IfcAudioVisualApplianceTypeEnum.PROJECTOR = { type: 3, value: "PROJECTOR" };
  IfcAudioVisualApplianceTypeEnum.RECEIVER = { type: 3, value: "RECEIVER" };
  IfcAudioVisualApplianceTypeEnum.RECORDINGEQUIPMENT = { type: 3, value: "RECORDINGEQUIPMENT" };
  IfcAudioVisualApplianceTypeEnum.SPEAKER = { type: 3, value: "SPEAKER" };
  IfcAudioVisualApplianceTypeEnum.SWITCHER = { type: 3, value: "SWITCHER" };
  IfcAudioVisualApplianceTypeEnum.TELEPHONE = { type: 3, value: "TELEPHONE" };
  IfcAudioVisualApplianceTypeEnum.TUNER = { type: 3, value: "TUNER" };
  IfcAudioVisualApplianceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAudioVisualApplianceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcAudioVisualApplianceTypeEnum = IfcAudioVisualApplianceTypeEnum;
  class IfcBSplineCurveForm {
  }
  IfcBSplineCurveForm.CIRCULAR_ARC = { type: 3, value: "CIRCULAR_ARC" };
  IfcBSplineCurveForm.ELLIPTIC_ARC = { type: 3, value: "ELLIPTIC_ARC" };
  IfcBSplineCurveForm.HYPERBOLIC_ARC = { type: 3, value: "HYPERBOLIC_ARC" };
  IfcBSplineCurveForm.PARABOLIC_ARC = { type: 3, value: "PARABOLIC_ARC" };
  IfcBSplineCurveForm.POLYLINE_FORM = { type: 3, value: "POLYLINE_FORM" };
  IfcBSplineCurveForm.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  IFC4_32.IfcBSplineCurveForm = IfcBSplineCurveForm;
  class IfcBSplineSurfaceForm {
  }
  IfcBSplineSurfaceForm.CONICAL_SURF = { type: 3, value: "CONICAL_SURF" };
  IfcBSplineSurfaceForm.CYLINDRICAL_SURF = { type: 3, value: "CYLINDRICAL_SURF" };
  IfcBSplineSurfaceForm.GENERALISED_CONE = { type: 3, value: "GENERALISED_CONE" };
  IfcBSplineSurfaceForm.PLANE_SURF = { type: 3, value: "PLANE_SURF" };
  IfcBSplineSurfaceForm.QUADRIC_SURF = { type: 3, value: "QUADRIC_SURF" };
  IfcBSplineSurfaceForm.RULED_SURF = { type: 3, value: "RULED_SURF" };
  IfcBSplineSurfaceForm.SPHERICAL_SURF = { type: 3, value: "SPHERICAL_SURF" };
  IfcBSplineSurfaceForm.SURF_OF_LINEAR_EXTRUSION = { type: 3, value: "SURF_OF_LINEAR_EXTRUSION" };
  IfcBSplineSurfaceForm.SURF_OF_REVOLUTION = { type: 3, value: "SURF_OF_REVOLUTION" };
  IfcBSplineSurfaceForm.TOROIDAL_SURF = { type: 3, value: "TOROIDAL_SURF" };
  IfcBSplineSurfaceForm.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  IFC4_32.IfcBSplineSurfaceForm = IfcBSplineSurfaceForm;
  class IfcBeamTypeEnum {
  }
  IfcBeamTypeEnum.BEAM = { type: 3, value: "BEAM" };
  IfcBeamTypeEnum.CORNICE = { type: 3, value: "CORNICE" };
  IfcBeamTypeEnum.DIAPHRAGM = { type: 3, value: "DIAPHRAGM" };
  IfcBeamTypeEnum.EDGEBEAM = { type: 3, value: "EDGEBEAM" };
  IfcBeamTypeEnum.GIRDER_SEGMENT = { type: 3, value: "GIRDER_SEGMENT" };
  IfcBeamTypeEnum.HATSTONE = { type: 3, value: "HATSTONE" };
  IfcBeamTypeEnum.HOLLOWCORE = { type: 3, value: "HOLLOWCORE" };
  IfcBeamTypeEnum.JOIST = { type: 3, value: "JOIST" };
  IfcBeamTypeEnum.LINTEL = { type: 3, value: "LINTEL" };
  IfcBeamTypeEnum.PIERCAP = { type: 3, value: "PIERCAP" };
  IfcBeamTypeEnum.SPANDREL = { type: 3, value: "SPANDREL" };
  IfcBeamTypeEnum.T_BEAM = { type: 3, value: "T_BEAM" };
  IfcBeamTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBeamTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcBeamTypeEnum = IfcBeamTypeEnum;
  class IfcBearingTypeDisplacementEnum {
  }
  IfcBearingTypeDisplacementEnum.FIXED_MOVEMENT = { type: 3, value: "FIXED_MOVEMENT" };
  IfcBearingTypeDisplacementEnum.FREE_MOVEMENT = { type: 3, value: "FREE_MOVEMENT" };
  IfcBearingTypeDisplacementEnum.GUIDED_LONGITUDINAL = { type: 3, value: "GUIDED_LONGITUDINAL" };
  IfcBearingTypeDisplacementEnum.GUIDED_TRANSVERSAL = { type: 3, value: "GUIDED_TRANSVERSAL" };
  IfcBearingTypeDisplacementEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcBearingTypeDisplacementEnum = IfcBearingTypeDisplacementEnum;
  class IfcBearingTypeEnum {
  }
  IfcBearingTypeEnum.CYLINDRICAL = { type: 3, value: "CYLINDRICAL" };
  IfcBearingTypeEnum.DISK = { type: 3, value: "DISK" };
  IfcBearingTypeEnum.ELASTOMERIC = { type: 3, value: "ELASTOMERIC" };
  IfcBearingTypeEnum.GUIDE = { type: 3, value: "GUIDE" };
  IfcBearingTypeEnum.POT = { type: 3, value: "POT" };
  IfcBearingTypeEnum.ROCKER = { type: 3, value: "ROCKER" };
  IfcBearingTypeEnum.ROLLER = { type: 3, value: "ROLLER" };
  IfcBearingTypeEnum.SPHERICAL = { type: 3, value: "SPHERICAL" };
  IfcBearingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBearingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcBearingTypeEnum = IfcBearingTypeEnum;
  class IfcBenchmarkEnum {
  }
  IfcBenchmarkEnum.EQUALTO = { type: 3, value: "EQUALTO" };
  IfcBenchmarkEnum.GREATERTHAN = { type: 3, value: "GREATERTHAN" };
  IfcBenchmarkEnum.GREATERTHANOREQUALTO = { type: 3, value: "GREATERTHANOREQUALTO" };
  IfcBenchmarkEnum.INCLUDEDIN = { type: 3, value: "INCLUDEDIN" };
  IfcBenchmarkEnum.INCLUDES = { type: 3, value: "INCLUDES" };
  IfcBenchmarkEnum.LESSTHAN = { type: 3, value: "LESSTHAN" };
  IfcBenchmarkEnum.LESSTHANOREQUALTO = { type: 3, value: "LESSTHANOREQUALTO" };
  IfcBenchmarkEnum.NOTEQUALTO = { type: 3, value: "NOTEQUALTO" };
  IfcBenchmarkEnum.NOTINCLUDEDIN = { type: 3, value: "NOTINCLUDEDIN" };
  IfcBenchmarkEnum.NOTINCLUDES = { type: 3, value: "NOTINCLUDES" };
  IFC4_32.IfcBenchmarkEnum = IfcBenchmarkEnum;
  class IfcBoilerTypeEnum {
  }
  IfcBoilerTypeEnum.STEAM = { type: 3, value: "STEAM" };
  IfcBoilerTypeEnum.WATER = { type: 3, value: "WATER" };
  IfcBoilerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBoilerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcBoilerTypeEnum = IfcBoilerTypeEnum;
  class IfcBooleanOperator {
  }
  IfcBooleanOperator.DIFFERENCE = { type: 3, value: "DIFFERENCE" };
  IfcBooleanOperator.INTERSECTION = { type: 3, value: "INTERSECTION" };
  IfcBooleanOperator.UNION = { type: 3, value: "UNION" };
  IFC4_32.IfcBooleanOperator = IfcBooleanOperator;
  class IfcBridgePartTypeEnum {
  }
  IfcBridgePartTypeEnum.ABUTMENT = { type: 3, value: "ABUTMENT" };
  IfcBridgePartTypeEnum.DECK = { type: 3, value: "DECK" };
  IfcBridgePartTypeEnum.DECK_SEGMENT = { type: 3, value: "DECK_SEGMENT" };
  IfcBridgePartTypeEnum.FOUNDATION = { type: 3, value: "FOUNDATION" };
  IfcBridgePartTypeEnum.PIER = { type: 3, value: "PIER" };
  IfcBridgePartTypeEnum.PIER_SEGMENT = { type: 3, value: "PIER_SEGMENT" };
  IfcBridgePartTypeEnum.PYLON = { type: 3, value: "PYLON" };
  IfcBridgePartTypeEnum.SUBSTRUCTURE = { type: 3, value: "SUBSTRUCTURE" };
  IfcBridgePartTypeEnum.SUPERSTRUCTURE = { type: 3, value: "SUPERSTRUCTURE" };
  IfcBridgePartTypeEnum.SURFACESTRUCTURE = { type: 3, value: "SURFACESTRUCTURE" };
  IfcBridgePartTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBridgePartTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcBridgePartTypeEnum = IfcBridgePartTypeEnum;
  class IfcBridgeTypeEnum {
  }
  IfcBridgeTypeEnum.ARCHED = { type: 3, value: "ARCHED" };
  IfcBridgeTypeEnum.CABLE_STAYED = { type: 3, value: "CABLE_STAYED" };
  IfcBridgeTypeEnum.CANTILEVER = { type: 3, value: "CANTILEVER" };
  IfcBridgeTypeEnum.CULVERT = { type: 3, value: "CULVERT" };
  IfcBridgeTypeEnum.FRAMEWORK = { type: 3, value: "FRAMEWORK" };
  IfcBridgeTypeEnum.GIRDER = { type: 3, value: "GIRDER" };
  IfcBridgeTypeEnum.SUSPENSION = { type: 3, value: "SUSPENSION" };
  IfcBridgeTypeEnum.TRUSS = { type: 3, value: "TRUSS" };
  IfcBridgeTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBridgeTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcBridgeTypeEnum = IfcBridgeTypeEnum;
  class IfcBuildingElementPartTypeEnum {
  }
  IfcBuildingElementPartTypeEnum.APRON = { type: 3, value: "APRON" };
  IfcBuildingElementPartTypeEnum.ARMOURUNIT = { type: 3, value: "ARMOURUNIT" };
  IfcBuildingElementPartTypeEnum.INSULATION = { type: 3, value: "INSULATION" };
  IfcBuildingElementPartTypeEnum.PRECASTPANEL = { type: 3, value: "PRECASTPANEL" };
  IfcBuildingElementPartTypeEnum.SAFETYCAGE = { type: 3, value: "SAFETYCAGE" };
  IfcBuildingElementPartTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBuildingElementPartTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcBuildingElementPartTypeEnum = IfcBuildingElementPartTypeEnum;
  class IfcBuildingElementProxyTypeEnum {
  }
  IfcBuildingElementProxyTypeEnum.COMPLEX = { type: 3, value: "COMPLEX" };
  IfcBuildingElementProxyTypeEnum.ELEMENT = { type: 3, value: "ELEMENT" };
  IfcBuildingElementProxyTypeEnum.PARTIAL = { type: 3, value: "PARTIAL" };
  IfcBuildingElementProxyTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBuildingElementProxyTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcBuildingElementProxyTypeEnum = IfcBuildingElementProxyTypeEnum;
  class IfcBuildingSystemTypeEnum {
  }
  IfcBuildingSystemTypeEnum.EROSIONPREVENTION = { type: 3, value: "EROSIONPREVENTION" };
  IfcBuildingSystemTypeEnum.FENESTRATION = { type: 3, value: "FENESTRATION" };
  IfcBuildingSystemTypeEnum.FOUNDATION = { type: 3, value: "FOUNDATION" };
  IfcBuildingSystemTypeEnum.LOADBEARING = { type: 3, value: "LOADBEARING" };
  IfcBuildingSystemTypeEnum.OUTERSHELL = { type: 3, value: "OUTERSHELL" };
  IfcBuildingSystemTypeEnum.PRESTRESSING = { type: 3, value: "PRESTRESSING" };
  IfcBuildingSystemTypeEnum.REINFORCING = { type: 3, value: "REINFORCING" };
  IfcBuildingSystemTypeEnum.SHADING = { type: 3, value: "SHADING" };
  IfcBuildingSystemTypeEnum.TRANSPORT = { type: 3, value: "TRANSPORT" };
  IfcBuildingSystemTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBuildingSystemTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcBuildingSystemTypeEnum = IfcBuildingSystemTypeEnum;
  class IfcBuiltSystemTypeEnum {
  }
  IfcBuiltSystemTypeEnum.EROSIONPREVENTION = { type: 3, value: "EROSIONPREVENTION" };
  IfcBuiltSystemTypeEnum.FENESTRATION = { type: 3, value: "FENESTRATION" };
  IfcBuiltSystemTypeEnum.FOUNDATION = { type: 3, value: "FOUNDATION" };
  IfcBuiltSystemTypeEnum.LOADBEARING = { type: 3, value: "LOADBEARING" };
  IfcBuiltSystemTypeEnum.MOORING = { type: 3, value: "MOORING" };
  IfcBuiltSystemTypeEnum.OUTERSHELL = { type: 3, value: "OUTERSHELL" };
  IfcBuiltSystemTypeEnum.PRESTRESSING = { type: 3, value: "PRESTRESSING" };
  IfcBuiltSystemTypeEnum.RAILWAYLINE = { type: 3, value: "RAILWAYLINE" };
  IfcBuiltSystemTypeEnum.RAILWAYTRACK = { type: 3, value: "RAILWAYTRACK" };
  IfcBuiltSystemTypeEnum.REINFORCING = { type: 3, value: "REINFORCING" };
  IfcBuiltSystemTypeEnum.SHADING = { type: 3, value: "SHADING" };
  IfcBuiltSystemTypeEnum.TRACKCIRCUIT = { type: 3, value: "TRACKCIRCUIT" };
  IfcBuiltSystemTypeEnum.TRANSPORT = { type: 3, value: "TRANSPORT" };
  IfcBuiltSystemTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBuiltSystemTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcBuiltSystemTypeEnum = IfcBuiltSystemTypeEnum;
  class IfcBurnerTypeEnum {
  }
  IfcBurnerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBurnerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcBurnerTypeEnum = IfcBurnerTypeEnum;
  class IfcCableCarrierFittingTypeEnum {
  }
  IfcCableCarrierFittingTypeEnum.BEND = { type: 3, value: "BEND" };
  IfcCableCarrierFittingTypeEnum.CONNECTOR = { type: 3, value: "CONNECTOR" };
  IfcCableCarrierFittingTypeEnum.CROSS = { type: 3, value: "CROSS" };
  IfcCableCarrierFittingTypeEnum.JUNCTION = { type: 3, value: "JUNCTION" };
  IfcCableCarrierFittingTypeEnum.TEE = { type: 3, value: "TEE" };
  IfcCableCarrierFittingTypeEnum.TRANSITION = { type: 3, value: "TRANSITION" };
  IfcCableCarrierFittingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCableCarrierFittingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCableCarrierFittingTypeEnum = IfcCableCarrierFittingTypeEnum;
  class IfcCableCarrierSegmentTypeEnum {
  }
  IfcCableCarrierSegmentTypeEnum.CABLEBRACKET = { type: 3, value: "CABLEBRACKET" };
  IfcCableCarrierSegmentTypeEnum.CABLELADDERSEGMENT = { type: 3, value: "CABLELADDERSEGMENT" };
  IfcCableCarrierSegmentTypeEnum.CABLETRAYSEGMENT = { type: 3, value: "CABLETRAYSEGMENT" };
  IfcCableCarrierSegmentTypeEnum.CABLETRUNKINGSEGMENT = { type: 3, value: "CABLETRUNKINGSEGMENT" };
  IfcCableCarrierSegmentTypeEnum.CATENARYWIRE = { type: 3, value: "CATENARYWIRE" };
  IfcCableCarrierSegmentTypeEnum.CONDUITSEGMENT = { type: 3, value: "CONDUITSEGMENT" };
  IfcCableCarrierSegmentTypeEnum.DROPPER = { type: 3, value: "DROPPER" };
  IfcCableCarrierSegmentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCableCarrierSegmentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCableCarrierSegmentTypeEnum = IfcCableCarrierSegmentTypeEnum;
  class IfcCableFittingTypeEnum {
  }
  IfcCableFittingTypeEnum.CONNECTOR = { type: 3, value: "CONNECTOR" };
  IfcCableFittingTypeEnum.ENTRY = { type: 3, value: "ENTRY" };
  IfcCableFittingTypeEnum.EXIT = { type: 3, value: "EXIT" };
  IfcCableFittingTypeEnum.FANOUT = { type: 3, value: "FANOUT" };
  IfcCableFittingTypeEnum.JUNCTION = { type: 3, value: "JUNCTION" };
  IfcCableFittingTypeEnum.TRANSITION = { type: 3, value: "TRANSITION" };
  IfcCableFittingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCableFittingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCableFittingTypeEnum = IfcCableFittingTypeEnum;
  class IfcCableSegmentTypeEnum {
  }
  IfcCableSegmentTypeEnum.BUSBARSEGMENT = { type: 3, value: "BUSBARSEGMENT" };
  IfcCableSegmentTypeEnum.CABLESEGMENT = { type: 3, value: "CABLESEGMENT" };
  IfcCableSegmentTypeEnum.CONDUCTORSEGMENT = { type: 3, value: "CONDUCTORSEGMENT" };
  IfcCableSegmentTypeEnum.CONTACTWIRESEGMENT = { type: 3, value: "CONTACTWIRESEGMENT" };
  IfcCableSegmentTypeEnum.CORESEGMENT = { type: 3, value: "CORESEGMENT" };
  IfcCableSegmentTypeEnum.FIBERSEGMENT = { type: 3, value: "FIBERSEGMENT" };
  IfcCableSegmentTypeEnum.FIBERTUBE = { type: 3, value: "FIBERTUBE" };
  IfcCableSegmentTypeEnum.OPTICALCABLESEGMENT = { type: 3, value: "OPTICALCABLESEGMENT" };
  IfcCableSegmentTypeEnum.STITCHWIRE = { type: 3, value: "STITCHWIRE" };
  IfcCableSegmentTypeEnum.WIREPAIRSEGMENT = { type: 3, value: "WIREPAIRSEGMENT" };
  IfcCableSegmentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCableSegmentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCableSegmentTypeEnum = IfcCableSegmentTypeEnum;
  class IfcCaissonFoundationTypeEnum {
  }
  IfcCaissonFoundationTypeEnum.CAISSON = { type: 3, value: "CAISSON" };
  IfcCaissonFoundationTypeEnum.WELL = { type: 3, value: "WELL" };
  IfcCaissonFoundationTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCaissonFoundationTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCaissonFoundationTypeEnum = IfcCaissonFoundationTypeEnum;
  class IfcChangeActionEnum {
  }
  IfcChangeActionEnum.ADDED = { type: 3, value: "ADDED" };
  IfcChangeActionEnum.DELETED = { type: 3, value: "DELETED" };
  IfcChangeActionEnum.MODIFIED = { type: 3, value: "MODIFIED" };
  IfcChangeActionEnum.NOCHANGE = { type: 3, value: "NOCHANGE" };
  IfcChangeActionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcChangeActionEnum = IfcChangeActionEnum;
  class IfcChillerTypeEnum {
  }
  IfcChillerTypeEnum.AIRCOOLED = { type: 3, value: "AIRCOOLED" };
  IfcChillerTypeEnum.HEATRECOVERY = { type: 3, value: "HEATRECOVERY" };
  IfcChillerTypeEnum.WATERCOOLED = { type: 3, value: "WATERCOOLED" };
  IfcChillerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcChillerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcChillerTypeEnum = IfcChillerTypeEnum;
  class IfcChimneyTypeEnum {
  }
  IfcChimneyTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcChimneyTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcChimneyTypeEnum = IfcChimneyTypeEnum;
  class IfcCoilTypeEnum {
  }
  IfcCoilTypeEnum.DXCOOLINGCOIL = { type: 3, value: "DXCOOLINGCOIL" };
  IfcCoilTypeEnum.ELECTRICHEATINGCOIL = { type: 3, value: "ELECTRICHEATINGCOIL" };
  IfcCoilTypeEnum.GASHEATINGCOIL = { type: 3, value: "GASHEATINGCOIL" };
  IfcCoilTypeEnum.HYDRONICCOIL = { type: 3, value: "HYDRONICCOIL" };
  IfcCoilTypeEnum.STEAMHEATINGCOIL = { type: 3, value: "STEAMHEATINGCOIL" };
  IfcCoilTypeEnum.WATERCOOLINGCOIL = { type: 3, value: "WATERCOOLINGCOIL" };
  IfcCoilTypeEnum.WATERHEATINGCOIL = { type: 3, value: "WATERHEATINGCOIL" };
  IfcCoilTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCoilTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCoilTypeEnum = IfcCoilTypeEnum;
  class IfcColumnTypeEnum {
  }
  IfcColumnTypeEnum.COLUMN = { type: 3, value: "COLUMN" };
  IfcColumnTypeEnum.PIERSTEM = { type: 3, value: "PIERSTEM" };
  IfcColumnTypeEnum.PIERSTEM_SEGMENT = { type: 3, value: "PIERSTEM_SEGMENT" };
  IfcColumnTypeEnum.PILASTER = { type: 3, value: "PILASTER" };
  IfcColumnTypeEnum.STANDCOLUMN = { type: 3, value: "STANDCOLUMN" };
  IfcColumnTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcColumnTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcColumnTypeEnum = IfcColumnTypeEnum;
  class IfcCommunicationsApplianceTypeEnum {
  }
  IfcCommunicationsApplianceTypeEnum.ANTENNA = { type: 3, value: "ANTENNA" };
  IfcCommunicationsApplianceTypeEnum.AUTOMATON = { type: 3, value: "AUTOMATON" };
  IfcCommunicationsApplianceTypeEnum.COMPUTER = { type: 3, value: "COMPUTER" };
  IfcCommunicationsApplianceTypeEnum.FAX = { type: 3, value: "FAX" };
  IfcCommunicationsApplianceTypeEnum.GATEWAY = { type: 3, value: "GATEWAY" };
  IfcCommunicationsApplianceTypeEnum.INTELLIGENTPERIPHERAL = { type: 3, value: "INTELLIGENTPERIPHERAL" };
  IfcCommunicationsApplianceTypeEnum.IPNETWORKEQUIPMENT = { type: 3, value: "IPNETWORKEQUIPMENT" };
  IfcCommunicationsApplianceTypeEnum.LINESIDEELECTRONICUNIT = { type: 3, value: "LINESIDEELECTRONICUNIT" };
  IfcCommunicationsApplianceTypeEnum.MODEM = { type: 3, value: "MODEM" };
  IfcCommunicationsApplianceTypeEnum.NETWORKAPPLIANCE = { type: 3, value: "NETWORKAPPLIANCE" };
  IfcCommunicationsApplianceTypeEnum.NETWORKBRIDGE = { type: 3, value: "NETWORKBRIDGE" };
  IfcCommunicationsApplianceTypeEnum.NETWORKHUB = { type: 3, value: "NETWORKHUB" };
  IfcCommunicationsApplianceTypeEnum.OPTICALLINETERMINAL = { type: 3, value: "OPTICALLINETERMINAL" };
  IfcCommunicationsApplianceTypeEnum.OPTICALNETWORKUNIT = { type: 3, value: "OPTICALNETWORKUNIT" };
  IfcCommunicationsApplianceTypeEnum.PRINTER = { type: 3, value: "PRINTER" };
  IfcCommunicationsApplianceTypeEnum.RADIOBLOCKCENTER = { type: 3, value: "RADIOBLOCKCENTER" };
  IfcCommunicationsApplianceTypeEnum.REPEATER = { type: 3, value: "REPEATER" };
  IfcCommunicationsApplianceTypeEnum.ROUTER = { type: 3, value: "ROUTER" };
  IfcCommunicationsApplianceTypeEnum.SCANNER = { type: 3, value: "SCANNER" };
  IfcCommunicationsApplianceTypeEnum.TELECOMMAND = { type: 3, value: "TELECOMMAND" };
  IfcCommunicationsApplianceTypeEnum.TELEPHONYEXCHANGE = { type: 3, value: "TELEPHONYEXCHANGE" };
  IfcCommunicationsApplianceTypeEnum.TRANSITIONCOMPONENT = { type: 3, value: "TRANSITIONCOMPONENT" };
  IfcCommunicationsApplianceTypeEnum.TRANSPONDER = { type: 3, value: "TRANSPONDER" };
  IfcCommunicationsApplianceTypeEnum.TRANSPORTEQUIPMENT = { type: 3, value: "TRANSPORTEQUIPMENT" };
  IfcCommunicationsApplianceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCommunicationsApplianceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCommunicationsApplianceTypeEnum = IfcCommunicationsApplianceTypeEnum;
  class IfcComplexPropertyTemplateTypeEnum {
  }
  IfcComplexPropertyTemplateTypeEnum.P_COMPLEX = { type: 3, value: "P_COMPLEX" };
  IfcComplexPropertyTemplateTypeEnum.Q_COMPLEX = { type: 3, value: "Q_COMPLEX" };
  IFC4_32.IfcComplexPropertyTemplateTypeEnum = IfcComplexPropertyTemplateTypeEnum;
  class IfcCompressorTypeEnum {
  }
  IfcCompressorTypeEnum.BOOSTER = { type: 3, value: "BOOSTER" };
  IfcCompressorTypeEnum.DYNAMIC = { type: 3, value: "DYNAMIC" };
  IfcCompressorTypeEnum.HERMETIC = { type: 3, value: "HERMETIC" };
  IfcCompressorTypeEnum.OPENTYPE = { type: 3, value: "OPENTYPE" };
  IfcCompressorTypeEnum.RECIPROCATING = { type: 3, value: "RECIPROCATING" };
  IfcCompressorTypeEnum.ROLLINGPISTON = { type: 3, value: "ROLLINGPISTON" };
  IfcCompressorTypeEnum.ROTARY = { type: 3, value: "ROTARY" };
  IfcCompressorTypeEnum.ROTARYVANE = { type: 3, value: "ROTARYVANE" };
  IfcCompressorTypeEnum.SCROLL = { type: 3, value: "SCROLL" };
  IfcCompressorTypeEnum.SEMIHERMETIC = { type: 3, value: "SEMIHERMETIC" };
  IfcCompressorTypeEnum.SINGLESCREW = { type: 3, value: "SINGLESCREW" };
  IfcCompressorTypeEnum.SINGLESTAGE = { type: 3, value: "SINGLESTAGE" };
  IfcCompressorTypeEnum.TROCHOIDAL = { type: 3, value: "TROCHOIDAL" };
  IfcCompressorTypeEnum.TWINSCREW = { type: 3, value: "TWINSCREW" };
  IfcCompressorTypeEnum.WELDEDSHELLHERMETIC = { type: 3, value: "WELDEDSHELLHERMETIC" };
  IfcCompressorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCompressorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCompressorTypeEnum = IfcCompressorTypeEnum;
  class IfcCondenserTypeEnum {
  }
  IfcCondenserTypeEnum.AIRCOOLED = { type: 3, value: "AIRCOOLED" };
  IfcCondenserTypeEnum.EVAPORATIVECOOLED = { type: 3, value: "EVAPORATIVECOOLED" };
  IfcCondenserTypeEnum.WATERCOOLED = { type: 3, value: "WATERCOOLED" };
  IfcCondenserTypeEnum.WATERCOOLEDBRAZEDPLATE = { type: 3, value: "WATERCOOLEDBRAZEDPLATE" };
  IfcCondenserTypeEnum.WATERCOOLEDSHELLCOIL = { type: 3, value: "WATERCOOLEDSHELLCOIL" };
  IfcCondenserTypeEnum.WATERCOOLEDSHELLTUBE = { type: 3, value: "WATERCOOLEDSHELLTUBE" };
  IfcCondenserTypeEnum.WATERCOOLEDTUBEINTUBE = { type: 3, value: "WATERCOOLEDTUBEINTUBE" };
  IfcCondenserTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCondenserTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCondenserTypeEnum = IfcCondenserTypeEnum;
  class IfcConnectionTypeEnum {
  }
  IfcConnectionTypeEnum.ATEND = { type: 3, value: "ATEND" };
  IfcConnectionTypeEnum.ATPATH = { type: 3, value: "ATPATH" };
  IfcConnectionTypeEnum.ATSTART = { type: 3, value: "ATSTART" };
  IfcConnectionTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcConnectionTypeEnum = IfcConnectionTypeEnum;
  class IfcConstraintEnum {
  }
  IfcConstraintEnum.ADVISORY = { type: 3, value: "ADVISORY" };
  IfcConstraintEnum.HARD = { type: 3, value: "HARD" };
  IfcConstraintEnum.SOFT = { type: 3, value: "SOFT" };
  IfcConstraintEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcConstraintEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcConstraintEnum = IfcConstraintEnum;
  class IfcConstructionEquipmentResourceTypeEnum {
  }
  IfcConstructionEquipmentResourceTypeEnum.DEMOLISHING = { type: 3, value: "DEMOLISHING" };
  IfcConstructionEquipmentResourceTypeEnum.EARTHMOVING = { type: 3, value: "EARTHMOVING" };
  IfcConstructionEquipmentResourceTypeEnum.ERECTING = { type: 3, value: "ERECTING" };
  IfcConstructionEquipmentResourceTypeEnum.HEATING = { type: 3, value: "HEATING" };
  IfcConstructionEquipmentResourceTypeEnum.LIGHTING = { type: 3, value: "LIGHTING" };
  IfcConstructionEquipmentResourceTypeEnum.PAVING = { type: 3, value: "PAVING" };
  IfcConstructionEquipmentResourceTypeEnum.PUMPING = { type: 3, value: "PUMPING" };
  IfcConstructionEquipmentResourceTypeEnum.TRANSPORTING = { type: 3, value: "TRANSPORTING" };
  IfcConstructionEquipmentResourceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcConstructionEquipmentResourceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcConstructionEquipmentResourceTypeEnum = IfcConstructionEquipmentResourceTypeEnum;
  class IfcConstructionMaterialResourceTypeEnum {
  }
  IfcConstructionMaterialResourceTypeEnum.AGGREGATES = { type: 3, value: "AGGREGATES" };
  IfcConstructionMaterialResourceTypeEnum.CONCRETE = { type: 3, value: "CONCRETE" };
  IfcConstructionMaterialResourceTypeEnum.DRYWALL = { type: 3, value: "DRYWALL" };
  IfcConstructionMaterialResourceTypeEnum.FUEL = { type: 3, value: "FUEL" };
  IfcConstructionMaterialResourceTypeEnum.GYPSUM = { type: 3, value: "GYPSUM" };
  IfcConstructionMaterialResourceTypeEnum.MASONRY = { type: 3, value: "MASONRY" };
  IfcConstructionMaterialResourceTypeEnum.METAL = { type: 3, value: "METAL" };
  IfcConstructionMaterialResourceTypeEnum.PLASTIC = { type: 3, value: "PLASTIC" };
  IfcConstructionMaterialResourceTypeEnum.WOOD = { type: 3, value: "WOOD" };
  IfcConstructionMaterialResourceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcConstructionMaterialResourceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcConstructionMaterialResourceTypeEnum = IfcConstructionMaterialResourceTypeEnum;
  class IfcConstructionProductResourceTypeEnum {
  }
  IfcConstructionProductResourceTypeEnum.ASSEMBLY = { type: 3, value: "ASSEMBLY" };
  IfcConstructionProductResourceTypeEnum.FORMWORK = { type: 3, value: "FORMWORK" };
  IfcConstructionProductResourceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcConstructionProductResourceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcConstructionProductResourceTypeEnum = IfcConstructionProductResourceTypeEnum;
  class IfcControllerTypeEnum {
  }
  IfcControllerTypeEnum.FLOATING = { type: 3, value: "FLOATING" };
  IfcControllerTypeEnum.MULTIPOSITION = { type: 3, value: "MULTIPOSITION" };
  IfcControllerTypeEnum.PROGRAMMABLE = { type: 3, value: "PROGRAMMABLE" };
  IfcControllerTypeEnum.PROPORTIONAL = { type: 3, value: "PROPORTIONAL" };
  IfcControllerTypeEnum.TWOPOSITION = { type: 3, value: "TWOPOSITION" };
  IfcControllerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcControllerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcControllerTypeEnum = IfcControllerTypeEnum;
  class IfcConveyorSegmentTypeEnum {
  }
  IfcConveyorSegmentTypeEnum.BELTCONVEYOR = { type: 3, value: "BELTCONVEYOR" };
  IfcConveyorSegmentTypeEnum.BUCKETCONVEYOR = { type: 3, value: "BUCKETCONVEYOR" };
  IfcConveyorSegmentTypeEnum.CHUTECONVEYOR = { type: 3, value: "CHUTECONVEYOR" };
  IfcConveyorSegmentTypeEnum.SCREWCONVEYOR = { type: 3, value: "SCREWCONVEYOR" };
  IfcConveyorSegmentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcConveyorSegmentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcConveyorSegmentTypeEnum = IfcConveyorSegmentTypeEnum;
  class IfcCooledBeamTypeEnum {
  }
  IfcCooledBeamTypeEnum.ACTIVE = { type: 3, value: "ACTIVE" };
  IfcCooledBeamTypeEnum.PASSIVE = { type: 3, value: "PASSIVE" };
  IfcCooledBeamTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCooledBeamTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCooledBeamTypeEnum = IfcCooledBeamTypeEnum;
  class IfcCoolingTowerTypeEnum {
  }
  IfcCoolingTowerTypeEnum.MECHANICALFORCEDDRAFT = { type: 3, value: "MECHANICALFORCEDDRAFT" };
  IfcCoolingTowerTypeEnum.MECHANICALINDUCEDDRAFT = { type: 3, value: "MECHANICALINDUCEDDRAFT" };
  IfcCoolingTowerTypeEnum.NATURALDRAFT = { type: 3, value: "NATURALDRAFT" };
  IfcCoolingTowerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCoolingTowerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCoolingTowerTypeEnum = IfcCoolingTowerTypeEnum;
  class IfcCostItemTypeEnum {
  }
  IfcCostItemTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCostItemTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCostItemTypeEnum = IfcCostItemTypeEnum;
  class IfcCostScheduleTypeEnum {
  }
  IfcCostScheduleTypeEnum.BUDGET = { type: 3, value: "BUDGET" };
  IfcCostScheduleTypeEnum.COSTPLAN = { type: 3, value: "COSTPLAN" };
  IfcCostScheduleTypeEnum.ESTIMATE = { type: 3, value: "ESTIMATE" };
  IfcCostScheduleTypeEnum.PRICEDBILLOFQUANTITIES = { type: 3, value: "PRICEDBILLOFQUANTITIES" };
  IfcCostScheduleTypeEnum.SCHEDULEOFRATES = { type: 3, value: "SCHEDULEOFRATES" };
  IfcCostScheduleTypeEnum.TENDER = { type: 3, value: "TENDER" };
  IfcCostScheduleTypeEnum.UNPRICEDBILLOFQUANTITIES = { type: 3, value: "UNPRICEDBILLOFQUANTITIES" };
  IfcCostScheduleTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCostScheduleTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCostScheduleTypeEnum = IfcCostScheduleTypeEnum;
  class IfcCourseTypeEnum {
  }
  IfcCourseTypeEnum.ARMOUR = { type: 3, value: "ARMOUR" };
  IfcCourseTypeEnum.BALLASTBED = { type: 3, value: "BALLASTBED" };
  IfcCourseTypeEnum.CORE = { type: 3, value: "CORE" };
  IfcCourseTypeEnum.FILTER = { type: 3, value: "FILTER" };
  IfcCourseTypeEnum.PAVEMENT = { type: 3, value: "PAVEMENT" };
  IfcCourseTypeEnum.PROTECTION = { type: 3, value: "PROTECTION" };
  IfcCourseTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCourseTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCourseTypeEnum = IfcCourseTypeEnum;
  class IfcCoveringTypeEnum {
  }
  IfcCoveringTypeEnum.CEILING = { type: 3, value: "CEILING" };
  IfcCoveringTypeEnum.CLADDING = { type: 3, value: "CLADDING" };
  IfcCoveringTypeEnum.COPING = { type: 3, value: "COPING" };
  IfcCoveringTypeEnum.FLOORING = { type: 3, value: "FLOORING" };
  IfcCoveringTypeEnum.INSULATION = { type: 3, value: "INSULATION" };
  IfcCoveringTypeEnum.MEMBRANE = { type: 3, value: "MEMBRANE" };
  IfcCoveringTypeEnum.MOLDING = { type: 3, value: "MOLDING" };
  IfcCoveringTypeEnum.ROOFING = { type: 3, value: "ROOFING" };
  IfcCoveringTypeEnum.SKIRTINGBOARD = { type: 3, value: "SKIRTINGBOARD" };
  IfcCoveringTypeEnum.SLEEVING = { type: 3, value: "SLEEVING" };
  IfcCoveringTypeEnum.TOPPING = { type: 3, value: "TOPPING" };
  IfcCoveringTypeEnum.WRAPPING = { type: 3, value: "WRAPPING" };
  IfcCoveringTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCoveringTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCoveringTypeEnum = IfcCoveringTypeEnum;
  class IfcCrewResourceTypeEnum {
  }
  IfcCrewResourceTypeEnum.OFFICE = { type: 3, value: "OFFICE" };
  IfcCrewResourceTypeEnum.SITE = { type: 3, value: "SITE" };
  IfcCrewResourceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCrewResourceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCrewResourceTypeEnum = IfcCrewResourceTypeEnum;
  class IfcCurtainWallTypeEnum {
  }
  IfcCurtainWallTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCurtainWallTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCurtainWallTypeEnum = IfcCurtainWallTypeEnum;
  class IfcCurveInterpolationEnum {
  }
  IfcCurveInterpolationEnum.LINEAR = { type: 3, value: "LINEAR" };
  IfcCurveInterpolationEnum.LOG_LINEAR = { type: 3, value: "LOG_LINEAR" };
  IfcCurveInterpolationEnum.LOG_LOG = { type: 3, value: "LOG_LOG" };
  IfcCurveInterpolationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcCurveInterpolationEnum = IfcCurveInterpolationEnum;
  class IfcDamperTypeEnum {
  }
  IfcDamperTypeEnum.BACKDRAFTDAMPER = { type: 3, value: "BACKDRAFTDAMPER" };
  IfcDamperTypeEnum.BALANCINGDAMPER = { type: 3, value: "BALANCINGDAMPER" };
  IfcDamperTypeEnum.BLASTDAMPER = { type: 3, value: "BLASTDAMPER" };
  IfcDamperTypeEnum.CONTROLDAMPER = { type: 3, value: "CONTROLDAMPER" };
  IfcDamperTypeEnum.FIREDAMPER = { type: 3, value: "FIREDAMPER" };
  IfcDamperTypeEnum.FIRESMOKEDAMPER = { type: 3, value: "FIRESMOKEDAMPER" };
  IfcDamperTypeEnum.FUMEHOODEXHAUST = { type: 3, value: "FUMEHOODEXHAUST" };
  IfcDamperTypeEnum.GRAVITYDAMPER = { type: 3, value: "GRAVITYDAMPER" };
  IfcDamperTypeEnum.GRAVITYRELIEFDAMPER = { type: 3, value: "GRAVITYRELIEFDAMPER" };
  IfcDamperTypeEnum.RELIEFDAMPER = { type: 3, value: "RELIEFDAMPER" };
  IfcDamperTypeEnum.SMOKEDAMPER = { type: 3, value: "SMOKEDAMPER" };
  IfcDamperTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDamperTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDamperTypeEnum = IfcDamperTypeEnum;
  class IfcDataOriginEnum {
  }
  IfcDataOriginEnum.MEASURED = { type: 3, value: "MEASURED" };
  IfcDataOriginEnum.PREDICTED = { type: 3, value: "PREDICTED" };
  IfcDataOriginEnum.SIMULATED = { type: 3, value: "SIMULATED" };
  IfcDataOriginEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDataOriginEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDataOriginEnum = IfcDataOriginEnum;
  class IfcDerivedUnitEnum {
  }
  IfcDerivedUnitEnum.ACCELERATIONUNIT = { type: 3, value: "ACCELERATIONUNIT" };
  IfcDerivedUnitEnum.ANGULARVELOCITYUNIT = { type: 3, value: "ANGULARVELOCITYUNIT" };
  IfcDerivedUnitEnum.AREADENSITYUNIT = { type: 3, value: "AREADENSITYUNIT" };
  IfcDerivedUnitEnum.COMPOUNDPLANEANGLEUNIT = { type: 3, value: "COMPOUNDPLANEANGLEUNIT" };
  IfcDerivedUnitEnum.CURVATUREUNIT = { type: 3, value: "CURVATUREUNIT" };
  IfcDerivedUnitEnum.DYNAMICVISCOSITYUNIT = { type: 3, value: "DYNAMICVISCOSITYUNIT" };
  IfcDerivedUnitEnum.HEATFLUXDENSITYUNIT = { type: 3, value: "HEATFLUXDENSITYUNIT" };
  IfcDerivedUnitEnum.HEATINGVALUEUNIT = { type: 3, value: "HEATINGVALUEUNIT" };
  IfcDerivedUnitEnum.INTEGERCOUNTRATEUNIT = { type: 3, value: "INTEGERCOUNTRATEUNIT" };
  IfcDerivedUnitEnum.IONCONCENTRATIONUNIT = { type: 3, value: "IONCONCENTRATIONUNIT" };
  IfcDerivedUnitEnum.ISOTHERMALMOISTURECAPACITYUNIT = { type: 3, value: "ISOTHERMALMOISTURECAPACITYUNIT" };
  IfcDerivedUnitEnum.KINEMATICVISCOSITYUNIT = { type: 3, value: "KINEMATICVISCOSITYUNIT" };
  IfcDerivedUnitEnum.LINEARFORCEUNIT = { type: 3, value: "LINEARFORCEUNIT" };
  IfcDerivedUnitEnum.LINEARMOMENTUNIT = { type: 3, value: "LINEARMOMENTUNIT" };
  IfcDerivedUnitEnum.LINEARSTIFFNESSUNIT = { type: 3, value: "LINEARSTIFFNESSUNIT" };
  IfcDerivedUnitEnum.LINEARVELOCITYUNIT = { type: 3, value: "LINEARVELOCITYUNIT" };
  IfcDerivedUnitEnum.LUMINOUSINTENSITYDISTRIBUTIONUNIT = { type: 3, value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT" };
  IfcDerivedUnitEnum.MASSDENSITYUNIT = { type: 3, value: "MASSDENSITYUNIT" };
  IfcDerivedUnitEnum.MASSFLOWRATEUNIT = { type: 3, value: "MASSFLOWRATEUNIT" };
  IfcDerivedUnitEnum.MASSPERLENGTHUNIT = { type: 3, value: "MASSPERLENGTHUNIT" };
  IfcDerivedUnitEnum.MODULUSOFELASTICITYUNIT = { type: 3, value: "MODULUSOFELASTICITYUNIT" };
  IfcDerivedUnitEnum.MODULUSOFLINEARSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT" };
  IfcDerivedUnitEnum.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT" };
  IfcDerivedUnitEnum.MODULUSOFSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFSUBGRADEREACTIONUNIT" };
  IfcDerivedUnitEnum.MOISTUREDIFFUSIVITYUNIT = { type: 3, value: "MOISTUREDIFFUSIVITYUNIT" };
  IfcDerivedUnitEnum.MOLECULARWEIGHTUNIT = { type: 3, value: "MOLECULARWEIGHTUNIT" };
  IfcDerivedUnitEnum.MOMENTOFINERTIAUNIT = { type: 3, value: "MOMENTOFINERTIAUNIT" };
  IfcDerivedUnitEnum.PHUNIT = { type: 3, value: "PHUNIT" };
  IfcDerivedUnitEnum.PLANARFORCEUNIT = { type: 3, value: "PLANARFORCEUNIT" };
  IfcDerivedUnitEnum.ROTATIONALFREQUENCYUNIT = { type: 3, value: "ROTATIONALFREQUENCYUNIT" };
  IfcDerivedUnitEnum.ROTATIONALMASSUNIT = { type: 3, value: "ROTATIONALMASSUNIT" };
  IfcDerivedUnitEnum.ROTATIONALSTIFFNESSUNIT = { type: 3, value: "ROTATIONALSTIFFNESSUNIT" };
  IfcDerivedUnitEnum.SECTIONAREAINTEGRALUNIT = { type: 3, value: "SECTIONAREAINTEGRALUNIT" };
  IfcDerivedUnitEnum.SECTIONMODULUSUNIT = { type: 3, value: "SECTIONMODULUSUNIT" };
  IfcDerivedUnitEnum.SHEARMODULUSUNIT = { type: 3, value: "SHEARMODULUSUNIT" };
  IfcDerivedUnitEnum.SOUNDPOWERLEVELUNIT = { type: 3, value: "SOUNDPOWERLEVELUNIT" };
  IfcDerivedUnitEnum.SOUNDPOWERUNIT = { type: 3, value: "SOUNDPOWERUNIT" };
  IfcDerivedUnitEnum.SOUNDPRESSURELEVELUNIT = { type: 3, value: "SOUNDPRESSURELEVELUNIT" };
  IfcDerivedUnitEnum.SOUNDPRESSUREUNIT = { type: 3, value: "SOUNDPRESSUREUNIT" };
  IfcDerivedUnitEnum.SPECIFICHEATCAPACITYUNIT = { type: 3, value: "SPECIFICHEATCAPACITYUNIT" };
  IfcDerivedUnitEnum.TEMPERATUREGRADIENTUNIT = { type: 3, value: "TEMPERATUREGRADIENTUNIT" };
  IfcDerivedUnitEnum.TEMPERATURERATEOFCHANGEUNIT = { type: 3, value: "TEMPERATURERATEOFCHANGEUNIT" };
  IfcDerivedUnitEnum.THERMALADMITTANCEUNIT = { type: 3, value: "THERMALADMITTANCEUNIT" };
  IfcDerivedUnitEnum.THERMALCONDUCTANCEUNIT = { type: 3, value: "THERMALCONDUCTANCEUNIT" };
  IfcDerivedUnitEnum.THERMALEXPANSIONCOEFFICIENTUNIT = { type: 3, value: "THERMALEXPANSIONCOEFFICIENTUNIT" };
  IfcDerivedUnitEnum.THERMALRESISTANCEUNIT = { type: 3, value: "THERMALRESISTANCEUNIT" };
  IfcDerivedUnitEnum.THERMALTRANSMITTANCEUNIT = { type: 3, value: "THERMALTRANSMITTANCEUNIT" };
  IfcDerivedUnitEnum.TORQUEUNIT = { type: 3, value: "TORQUEUNIT" };
  IfcDerivedUnitEnum.VAPORPERMEABILITYUNIT = { type: 3, value: "VAPORPERMEABILITYUNIT" };
  IfcDerivedUnitEnum.VOLUMETRICFLOWRATEUNIT = { type: 3, value: "VOLUMETRICFLOWRATEUNIT" };
  IfcDerivedUnitEnum.WARPINGCONSTANTUNIT = { type: 3, value: "WARPINGCONSTANTUNIT" };
  IfcDerivedUnitEnum.WARPINGMOMENTUNIT = { type: 3, value: "WARPINGMOMENTUNIT" };
  IfcDerivedUnitEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IFC4_32.IfcDerivedUnitEnum = IfcDerivedUnitEnum;
  class IfcDirectionSenseEnum {
  }
  IfcDirectionSenseEnum.NEGATIVE = { type: 3, value: "NEGATIVE" };
  IfcDirectionSenseEnum.POSITIVE = { type: 3, value: "POSITIVE" };
  IFC4_32.IfcDirectionSenseEnum = IfcDirectionSenseEnum;
  class IfcDiscreteAccessoryTypeEnum {
  }
  IfcDiscreteAccessoryTypeEnum.ANCHORPLATE = { type: 3, value: "ANCHORPLATE" };
  IfcDiscreteAccessoryTypeEnum.BIRDPROTECTION = { type: 3, value: "BIRDPROTECTION" };
  IfcDiscreteAccessoryTypeEnum.BRACKET = { type: 3, value: "BRACKET" };
  IfcDiscreteAccessoryTypeEnum.CABLEARRANGER = { type: 3, value: "CABLEARRANGER" };
  IfcDiscreteAccessoryTypeEnum.ELASTIC_CUSHION = { type: 3, value: "ELASTIC_CUSHION" };
  IfcDiscreteAccessoryTypeEnum.EXPANSION_JOINT_DEVICE = { type: 3, value: "EXPANSION_JOINT_DEVICE" };
  IfcDiscreteAccessoryTypeEnum.FILLER = { type: 3, value: "FILLER" };
  IfcDiscreteAccessoryTypeEnum.FLASHING = { type: 3, value: "FLASHING" };
  IfcDiscreteAccessoryTypeEnum.INSULATOR = { type: 3, value: "INSULATOR" };
  IfcDiscreteAccessoryTypeEnum.LOCK = { type: 3, value: "LOCK" };
  IfcDiscreteAccessoryTypeEnum.PANEL_STRENGTHENING = { type: 3, value: "PANEL_STRENGTHENING" };
  IfcDiscreteAccessoryTypeEnum.POINTMACHINEMOUNTINGDEVICE = { type: 3, value: "POINTMACHINEMOUNTINGDEVICE" };
  IfcDiscreteAccessoryTypeEnum.POINT_MACHINE_LOCKING_DEVICE = { type: 3, value: "POINT_MACHINE_LOCKING_DEVICE" };
  IfcDiscreteAccessoryTypeEnum.RAILBRACE = { type: 3, value: "RAILBRACE" };
  IfcDiscreteAccessoryTypeEnum.RAILPAD = { type: 3, value: "RAILPAD" };
  IfcDiscreteAccessoryTypeEnum.RAIL_LUBRICATION = { type: 3, value: "RAIL_LUBRICATION" };
  IfcDiscreteAccessoryTypeEnum.RAIL_MECHANICAL_EQUIPMENT = { type: 3, value: "RAIL_MECHANICAL_EQUIPMENT" };
  IfcDiscreteAccessoryTypeEnum.SHOE = { type: 3, value: "SHOE" };
  IfcDiscreteAccessoryTypeEnum.SLIDINGCHAIR = { type: 3, value: "SLIDINGCHAIR" };
  IfcDiscreteAccessoryTypeEnum.SOUNDABSORPTION = { type: 3, value: "SOUNDABSORPTION" };
  IfcDiscreteAccessoryTypeEnum.TENSIONINGEQUIPMENT = { type: 3, value: "TENSIONINGEQUIPMENT" };
  IfcDiscreteAccessoryTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDiscreteAccessoryTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDiscreteAccessoryTypeEnum = IfcDiscreteAccessoryTypeEnum;
  class IfcDistributionBoardTypeEnum {
  }
  IfcDistributionBoardTypeEnum.CONSUMERUNIT = { type: 3, value: "CONSUMERUNIT" };
  IfcDistributionBoardTypeEnum.DISPATCHINGBOARD = { type: 3, value: "DISPATCHINGBOARD" };
  IfcDistributionBoardTypeEnum.DISTRIBUTIONBOARD = { type: 3, value: "DISTRIBUTIONBOARD" };
  IfcDistributionBoardTypeEnum.DISTRIBUTIONFRAME = { type: 3, value: "DISTRIBUTIONFRAME" };
  IfcDistributionBoardTypeEnum.MOTORCONTROLCENTRE = { type: 3, value: "MOTORCONTROLCENTRE" };
  IfcDistributionBoardTypeEnum.SWITCHBOARD = { type: 3, value: "SWITCHBOARD" };
  IfcDistributionBoardTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDistributionBoardTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDistributionBoardTypeEnum = IfcDistributionBoardTypeEnum;
  class IfcDistributionChamberElementTypeEnum {
  }
  IfcDistributionChamberElementTypeEnum.FORMEDDUCT = { type: 3, value: "FORMEDDUCT" };
  IfcDistributionChamberElementTypeEnum.INSPECTIONCHAMBER = { type: 3, value: "INSPECTIONCHAMBER" };
  IfcDistributionChamberElementTypeEnum.INSPECTIONPIT = { type: 3, value: "INSPECTIONPIT" };
  IfcDistributionChamberElementTypeEnum.MANHOLE = { type: 3, value: "MANHOLE" };
  IfcDistributionChamberElementTypeEnum.METERCHAMBER = { type: 3, value: "METERCHAMBER" };
  IfcDistributionChamberElementTypeEnum.SUMP = { type: 3, value: "SUMP" };
  IfcDistributionChamberElementTypeEnum.TRENCH = { type: 3, value: "TRENCH" };
  IfcDistributionChamberElementTypeEnum.VALVECHAMBER = { type: 3, value: "VALVECHAMBER" };
  IfcDistributionChamberElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDistributionChamberElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDistributionChamberElementTypeEnum = IfcDistributionChamberElementTypeEnum;
  class IfcDistributionPortTypeEnum {
  }
  IfcDistributionPortTypeEnum.CABLE = { type: 3, value: "CABLE" };
  IfcDistributionPortTypeEnum.CABLECARRIER = { type: 3, value: "CABLECARRIER" };
  IfcDistributionPortTypeEnum.DUCT = { type: 3, value: "DUCT" };
  IfcDistributionPortTypeEnum.PIPE = { type: 3, value: "PIPE" };
  IfcDistributionPortTypeEnum.WIRELESS = { type: 3, value: "WIRELESS" };
  IfcDistributionPortTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDistributionPortTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDistributionPortTypeEnum = IfcDistributionPortTypeEnum;
  class IfcDistributionSystemEnum {
  }
  IfcDistributionSystemEnum.AIRCONDITIONING = { type: 3, value: "AIRCONDITIONING" };
  IfcDistributionSystemEnum.AUDIOVISUAL = { type: 3, value: "AUDIOVISUAL" };
  IfcDistributionSystemEnum.CATENARY_SYSTEM = { type: 3, value: "CATENARY_SYSTEM" };
  IfcDistributionSystemEnum.CHEMICAL = { type: 3, value: "CHEMICAL" };
  IfcDistributionSystemEnum.CHILLEDWATER = { type: 3, value: "CHILLEDWATER" };
  IfcDistributionSystemEnum.COMMUNICATION = { type: 3, value: "COMMUNICATION" };
  IfcDistributionSystemEnum.COMPRESSEDAIR = { type: 3, value: "COMPRESSEDAIR" };
  IfcDistributionSystemEnum.CONDENSERWATER = { type: 3, value: "CONDENSERWATER" };
  IfcDistributionSystemEnum.CONTROL = { type: 3, value: "CONTROL" };
  IfcDistributionSystemEnum.CONVEYING = { type: 3, value: "CONVEYING" };
  IfcDistributionSystemEnum.DATA = { type: 3, value: "DATA" };
  IfcDistributionSystemEnum.DISPOSAL = { type: 3, value: "DISPOSAL" };
  IfcDistributionSystemEnum.DOMESTICCOLDWATER = { type: 3, value: "DOMESTICCOLDWATER" };
  IfcDistributionSystemEnum.DOMESTICHOTWATER = { type: 3, value: "DOMESTICHOTWATER" };
  IfcDistributionSystemEnum.DRAINAGE = { type: 3, value: "DRAINAGE" };
  IfcDistributionSystemEnum.EARTHING = { type: 3, value: "EARTHING" };
  IfcDistributionSystemEnum.ELECTRICAL = { type: 3, value: "ELECTRICAL" };
  IfcDistributionSystemEnum.ELECTROACOUSTIC = { type: 3, value: "ELECTROACOUSTIC" };
  IfcDistributionSystemEnum.EXHAUST = { type: 3, value: "EXHAUST" };
  IfcDistributionSystemEnum.FIREPROTECTION = { type: 3, value: "FIREPROTECTION" };
  IfcDistributionSystemEnum.FIXEDTRANSMISSIONNETWORK = { type: 3, value: "FIXEDTRANSMISSIONNETWORK" };
  IfcDistributionSystemEnum.FUEL = { type: 3, value: "FUEL" };
  IfcDistributionSystemEnum.GAS = { type: 3, value: "GAS" };
  IfcDistributionSystemEnum.HAZARDOUS = { type: 3, value: "HAZARDOUS" };
  IfcDistributionSystemEnum.HEATING = { type: 3, value: "HEATING" };
  IfcDistributionSystemEnum.LIGHTING = { type: 3, value: "LIGHTING" };
  IfcDistributionSystemEnum.LIGHTNINGPROTECTION = { type: 3, value: "LIGHTNINGPROTECTION" };
  IfcDistributionSystemEnum.MOBILENETWORK = { type: 3, value: "MOBILENETWORK" };
  IfcDistributionSystemEnum.MONITORINGSYSTEM = { type: 3, value: "MONITORINGSYSTEM" };
  IfcDistributionSystemEnum.MUNICIPALSOLIDWASTE = { type: 3, value: "MUNICIPALSOLIDWASTE" };
  IfcDistributionSystemEnum.OIL = { type: 3, value: "OIL" };
  IfcDistributionSystemEnum.OPERATIONAL = { type: 3, value: "OPERATIONAL" };
  IfcDistributionSystemEnum.OPERATIONALTELEPHONYSYSTEM = { type: 3, value: "OPERATIONALTELEPHONYSYSTEM" };
  IfcDistributionSystemEnum.OVERHEAD_CONTACTLINE_SYSTEM = { type: 3, value: "OVERHEAD_CONTACTLINE_SYSTEM" };
  IfcDistributionSystemEnum.POWERGENERATION = { type: 3, value: "POWERGENERATION" };
  IfcDistributionSystemEnum.RAINWATER = { type: 3, value: "RAINWATER" };
  IfcDistributionSystemEnum.REFRIGERATION = { type: 3, value: "REFRIGERATION" };
  IfcDistributionSystemEnum.RETURN_CIRCUIT = { type: 3, value: "RETURN_CIRCUIT" };
  IfcDistributionSystemEnum.SECURITY = { type: 3, value: "SECURITY" };
  IfcDistributionSystemEnum.SEWAGE = { type: 3, value: "SEWAGE" };
  IfcDistributionSystemEnum.SIGNAL = { type: 3, value: "SIGNAL" };
  IfcDistributionSystemEnum.STORMWATER = { type: 3, value: "STORMWATER" };
  IfcDistributionSystemEnum.TELEPHONE = { type: 3, value: "TELEPHONE" };
  IfcDistributionSystemEnum.TV = { type: 3, value: "TV" };
  IfcDistributionSystemEnum.VACUUM = { type: 3, value: "VACUUM" };
  IfcDistributionSystemEnum.VENT = { type: 3, value: "VENT" };
  IfcDistributionSystemEnum.VENTILATION = { type: 3, value: "VENTILATION" };
  IfcDistributionSystemEnum.WASTEWATER = { type: 3, value: "WASTEWATER" };
  IfcDistributionSystemEnum.WATERSUPPLY = { type: 3, value: "WATERSUPPLY" };
  IfcDistributionSystemEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDistributionSystemEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDistributionSystemEnum = IfcDistributionSystemEnum;
  class IfcDocumentConfidentialityEnum {
  }
  IfcDocumentConfidentialityEnum.CONFIDENTIAL = { type: 3, value: "CONFIDENTIAL" };
  IfcDocumentConfidentialityEnum.PERSONAL = { type: 3, value: "PERSONAL" };
  IfcDocumentConfidentialityEnum.PUBLIC = { type: 3, value: "PUBLIC" };
  IfcDocumentConfidentialityEnum.RESTRICTED = { type: 3, value: "RESTRICTED" };
  IfcDocumentConfidentialityEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDocumentConfidentialityEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDocumentConfidentialityEnum = IfcDocumentConfidentialityEnum;
  class IfcDocumentStatusEnum {
  }
  IfcDocumentStatusEnum.DRAFT = { type: 3, value: "DRAFT" };
  IfcDocumentStatusEnum.FINAL = { type: 3, value: "FINAL" };
  IfcDocumentStatusEnum.FINALDRAFT = { type: 3, value: "FINALDRAFT" };
  IfcDocumentStatusEnum.REVISION = { type: 3, value: "REVISION" };
  IfcDocumentStatusEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDocumentStatusEnum = IfcDocumentStatusEnum;
  class IfcDoorPanelOperationEnum {
  }
  IfcDoorPanelOperationEnum.DOUBLE_ACTING = { type: 3, value: "DOUBLE_ACTING" };
  IfcDoorPanelOperationEnum.FIXEDPANEL = { type: 3, value: "FIXEDPANEL" };
  IfcDoorPanelOperationEnum.FOLDING = { type: 3, value: "FOLDING" };
  IfcDoorPanelOperationEnum.REVOLVING = { type: 3, value: "REVOLVING" };
  IfcDoorPanelOperationEnum.ROLLINGUP = { type: 3, value: "ROLLINGUP" };
  IfcDoorPanelOperationEnum.SLIDING = { type: 3, value: "SLIDING" };
  IfcDoorPanelOperationEnum.SWINGING = { type: 3, value: "SWINGING" };
  IfcDoorPanelOperationEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDoorPanelOperationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDoorPanelOperationEnum = IfcDoorPanelOperationEnum;
  class IfcDoorPanelPositionEnum {
  }
  IfcDoorPanelPositionEnum.LEFT = { type: 3, value: "LEFT" };
  IfcDoorPanelPositionEnum.MIDDLE = { type: 3, value: "MIDDLE" };
  IfcDoorPanelPositionEnum.RIGHT = { type: 3, value: "RIGHT" };
  IfcDoorPanelPositionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDoorPanelPositionEnum = IfcDoorPanelPositionEnum;
  class IfcDoorStyleConstructionEnum {
  }
  IfcDoorStyleConstructionEnum.ALUMINIUM = { type: 3, value: "ALUMINIUM" };
  IfcDoorStyleConstructionEnum.ALUMINIUM_PLASTIC = { type: 3, value: "ALUMINIUM_PLASTIC" };
  IfcDoorStyleConstructionEnum.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" };
  IfcDoorStyleConstructionEnum.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" };
  IfcDoorStyleConstructionEnum.PLASTIC = { type: 3, value: "PLASTIC" };
  IfcDoorStyleConstructionEnum.STEEL = { type: 3, value: "STEEL" };
  IfcDoorStyleConstructionEnum.WOOD = { type: 3, value: "WOOD" };
  IfcDoorStyleConstructionEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDoorStyleConstructionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDoorStyleConstructionEnum = IfcDoorStyleConstructionEnum;
  class IfcDoorStyleOperationEnum {
  }
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_DOUBLE_SWING = { type: 3, value: "DOUBLE_DOOR_DOUBLE_SWING" };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_FOLDING = { type: 3, value: "DOUBLE_DOOR_FOLDING" };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING" };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT" };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT" };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SLIDING = { type: 3, value: "DOUBLE_DOOR_SLIDING" };
  IfcDoorStyleOperationEnum.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" };
  IfcDoorStyleOperationEnum.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" };
  IfcDoorStyleOperationEnum.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" };
  IfcDoorStyleOperationEnum.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" };
  IfcDoorStyleOperationEnum.REVOLVING = { type: 3, value: "REVOLVING" };
  IfcDoorStyleOperationEnum.ROLLINGUP = { type: 3, value: "ROLLINGUP" };
  IfcDoorStyleOperationEnum.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" };
  IfcDoorStyleOperationEnum.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" };
  IfcDoorStyleOperationEnum.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" };
  IfcDoorStyleOperationEnum.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" };
  IfcDoorStyleOperationEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDoorStyleOperationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDoorStyleOperationEnum = IfcDoorStyleOperationEnum;
  class IfcDoorTypeEnum {
  }
  IfcDoorTypeEnum.BOOM_BARRIER = { type: 3, value: "BOOM_BARRIER" };
  IfcDoorTypeEnum.DOOR = { type: 3, value: "DOOR" };
  IfcDoorTypeEnum.GATE = { type: 3, value: "GATE" };
  IfcDoorTypeEnum.TRAPDOOR = { type: 3, value: "TRAPDOOR" };
  IfcDoorTypeEnum.TURNSTILE = { type: 3, value: "TURNSTILE" };
  IfcDoorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDoorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDoorTypeEnum = IfcDoorTypeEnum;
  class IfcDoorTypeOperationEnum {
  }
  IfcDoorTypeOperationEnum.DOUBLE_PANEL_DOUBLE_SWING = { type: 3, value: "DOUBLE_PANEL_DOUBLE_SWING" };
  IfcDoorTypeOperationEnum.DOUBLE_PANEL_FOLDING = { type: 3, value: "DOUBLE_PANEL_FOLDING" };
  IfcDoorTypeOperationEnum.DOUBLE_PANEL_LIFTING_VERTICAL = { type: 3, value: "DOUBLE_PANEL_LIFTING_VERTICAL" };
  IfcDoorTypeOperationEnum.DOUBLE_PANEL_SINGLE_SWING = { type: 3, value: "DOUBLE_PANEL_SINGLE_SWING" };
  IfcDoorTypeOperationEnum.DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_LEFT" };
  IfcDoorTypeOperationEnum.DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_RIGHT" };
  IfcDoorTypeOperationEnum.DOUBLE_PANEL_SLIDING = { type: 3, value: "DOUBLE_PANEL_SLIDING" };
  IfcDoorTypeOperationEnum.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" };
  IfcDoorTypeOperationEnum.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" };
  IfcDoorTypeOperationEnum.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" };
  IfcDoorTypeOperationEnum.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" };
  IfcDoorTypeOperationEnum.LIFTING_HORIZONTAL = { type: 3, value: "LIFTING_HORIZONTAL" };
  IfcDoorTypeOperationEnum.LIFTING_VERTICAL_LEFT = { type: 3, value: "LIFTING_VERTICAL_LEFT" };
  IfcDoorTypeOperationEnum.LIFTING_VERTICAL_RIGHT = { type: 3, value: "LIFTING_VERTICAL_RIGHT" };
  IfcDoorTypeOperationEnum.REVOLVING_HORIZONTAL = { type: 3, value: "REVOLVING_HORIZONTAL" };
  IfcDoorTypeOperationEnum.REVOLVING_VERTICAL = { type: 3, value: "REVOLVING_VERTICAL" };
  IfcDoorTypeOperationEnum.ROLLINGUP = { type: 3, value: "ROLLINGUP" };
  IfcDoorTypeOperationEnum.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" };
  IfcDoorTypeOperationEnum.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" };
  IfcDoorTypeOperationEnum.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" };
  IfcDoorTypeOperationEnum.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" };
  IfcDoorTypeOperationEnum.SWING_FIXED_LEFT = { type: 3, value: "SWING_FIXED_LEFT" };
  IfcDoorTypeOperationEnum.SWING_FIXED_RIGHT = { type: 3, value: "SWING_FIXED_RIGHT" };
  IfcDoorTypeOperationEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDoorTypeOperationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDoorTypeOperationEnum = IfcDoorTypeOperationEnum;
  class IfcDuctFittingTypeEnum {
  }
  IfcDuctFittingTypeEnum.BEND = { type: 3, value: "BEND" };
  IfcDuctFittingTypeEnum.CONNECTOR = { type: 3, value: "CONNECTOR" };
  IfcDuctFittingTypeEnum.ENTRY = { type: 3, value: "ENTRY" };
  IfcDuctFittingTypeEnum.EXIT = { type: 3, value: "EXIT" };
  IfcDuctFittingTypeEnum.JUNCTION = { type: 3, value: "JUNCTION" };
  IfcDuctFittingTypeEnum.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" };
  IfcDuctFittingTypeEnum.TRANSITION = { type: 3, value: "TRANSITION" };
  IfcDuctFittingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDuctFittingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDuctFittingTypeEnum = IfcDuctFittingTypeEnum;
  class IfcDuctSegmentTypeEnum {
  }
  IfcDuctSegmentTypeEnum.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" };
  IfcDuctSegmentTypeEnum.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" };
  IfcDuctSegmentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDuctSegmentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDuctSegmentTypeEnum = IfcDuctSegmentTypeEnum;
  class IfcDuctSilencerTypeEnum {
  }
  IfcDuctSilencerTypeEnum.FLATOVAL = { type: 3, value: "FLATOVAL" };
  IfcDuctSilencerTypeEnum.RECTANGULAR = { type: 3, value: "RECTANGULAR" };
  IfcDuctSilencerTypeEnum.ROUND = { type: 3, value: "ROUND" };
  IfcDuctSilencerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDuctSilencerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcDuctSilencerTypeEnum = IfcDuctSilencerTypeEnum;
  class IfcEarthworksCutTypeEnum {
  }
  IfcEarthworksCutTypeEnum.BASE_EXCAVATION = { type: 3, value: "BASE_EXCAVATION" };
  IfcEarthworksCutTypeEnum.CUT = { type: 3, value: "CUT" };
  IfcEarthworksCutTypeEnum.DREDGING = { type: 3, value: "DREDGING" };
  IfcEarthworksCutTypeEnum.EXCAVATION = { type: 3, value: "EXCAVATION" };
  IfcEarthworksCutTypeEnum.OVEREXCAVATION = { type: 3, value: "OVEREXCAVATION" };
  IfcEarthworksCutTypeEnum.PAVEMENTMILLING = { type: 3, value: "PAVEMENTMILLING" };
  IfcEarthworksCutTypeEnum.STEPEXCAVATION = { type: 3, value: "STEPEXCAVATION" };
  IfcEarthworksCutTypeEnum.TOPSOILREMOVAL = { type: 3, value: "TOPSOILREMOVAL" };
  IfcEarthworksCutTypeEnum.TRENCH = { type: 3, value: "TRENCH" };
  IfcEarthworksCutTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcEarthworksCutTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcEarthworksCutTypeEnum = IfcEarthworksCutTypeEnum;
  class IfcEarthworksFillTypeEnum {
  }
  IfcEarthworksFillTypeEnum.BACKFILL = { type: 3, value: "BACKFILL" };
  IfcEarthworksFillTypeEnum.COUNTERWEIGHT = { type: 3, value: "COUNTERWEIGHT" };
  IfcEarthworksFillTypeEnum.EMBANKMENT = { type: 3, value: "EMBANKMENT" };
  IfcEarthworksFillTypeEnum.SLOPEFILL = { type: 3, value: "SLOPEFILL" };
  IfcEarthworksFillTypeEnum.SUBGRADE = { type: 3, value: "SUBGRADE" };
  IfcEarthworksFillTypeEnum.SUBGRADEBED = { type: 3, value: "SUBGRADEBED" };
  IfcEarthworksFillTypeEnum.TRANSITIONSECTION = { type: 3, value: "TRANSITIONSECTION" };
  IfcEarthworksFillTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcEarthworksFillTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcEarthworksFillTypeEnum = IfcEarthworksFillTypeEnum;
  class IfcElectricApplianceTypeEnum {
  }
  IfcElectricApplianceTypeEnum.DISHWASHER = { type: 3, value: "DISHWASHER" };
  IfcElectricApplianceTypeEnum.ELECTRICCOOKER = { type: 3, value: "ELECTRICCOOKER" };
  IfcElectricApplianceTypeEnum.FREESTANDINGELECTRICHEATER = { type: 3, value: "FREESTANDINGELECTRICHEATER" };
  IfcElectricApplianceTypeEnum.FREESTANDINGFAN = { type: 3, value: "FREESTANDINGFAN" };
  IfcElectricApplianceTypeEnum.FREESTANDINGWATERCOOLER = { type: 3, value: "FREESTANDINGWATERCOOLER" };
  IfcElectricApplianceTypeEnum.FREESTANDINGWATERHEATER = { type: 3, value: "FREESTANDINGWATERHEATER" };
  IfcElectricApplianceTypeEnum.FREEZER = { type: 3, value: "FREEZER" };
  IfcElectricApplianceTypeEnum.FRIDGE_FREEZER = { type: 3, value: "FRIDGE_FREEZER" };
  IfcElectricApplianceTypeEnum.HANDDRYER = { type: 3, value: "HANDDRYER" };
  IfcElectricApplianceTypeEnum.KITCHENMACHINE = { type: 3, value: "KITCHENMACHINE" };
  IfcElectricApplianceTypeEnum.MICROWAVE = { type: 3, value: "MICROWAVE" };
  IfcElectricApplianceTypeEnum.PHOTOCOPIER = { type: 3, value: "PHOTOCOPIER" };
  IfcElectricApplianceTypeEnum.REFRIGERATOR = { type: 3, value: "REFRIGERATOR" };
  IfcElectricApplianceTypeEnum.TUMBLEDRYER = { type: 3, value: "TUMBLEDRYER" };
  IfcElectricApplianceTypeEnum.VENDINGMACHINE = { type: 3, value: "VENDINGMACHINE" };
  IfcElectricApplianceTypeEnum.WASHINGMACHINE = { type: 3, value: "WASHINGMACHINE" };
  IfcElectricApplianceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricApplianceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcElectricApplianceTypeEnum = IfcElectricApplianceTypeEnum;
  class IfcElectricDistributionBoardTypeEnum {
  }
  IfcElectricDistributionBoardTypeEnum.CONSUMERUNIT = { type: 3, value: "CONSUMERUNIT" };
  IfcElectricDistributionBoardTypeEnum.DISTRIBUTIONBOARD = { type: 3, value: "DISTRIBUTIONBOARD" };
  IfcElectricDistributionBoardTypeEnum.MOTORCONTROLCENTRE = { type: 3, value: "MOTORCONTROLCENTRE" };
  IfcElectricDistributionBoardTypeEnum.SWITCHBOARD = { type: 3, value: "SWITCHBOARD" };
  IfcElectricDistributionBoardTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricDistributionBoardTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcElectricDistributionBoardTypeEnum = IfcElectricDistributionBoardTypeEnum;
  class IfcElectricFlowStorageDeviceTypeEnum {
  }
  IfcElectricFlowStorageDeviceTypeEnum.BATTERY = { type: 3, value: "BATTERY" };
  IfcElectricFlowStorageDeviceTypeEnum.CAPACITOR = { type: 3, value: "CAPACITOR" };
  IfcElectricFlowStorageDeviceTypeEnum.CAPACITORBANK = { type: 3, value: "CAPACITORBANK" };
  IfcElectricFlowStorageDeviceTypeEnum.COMPENSATOR = { type: 3, value: "COMPENSATOR" };
  IfcElectricFlowStorageDeviceTypeEnum.HARMONICFILTER = { type: 3, value: "HARMONICFILTER" };
  IfcElectricFlowStorageDeviceTypeEnum.INDUCTOR = { type: 3, value: "INDUCTOR" };
  IfcElectricFlowStorageDeviceTypeEnum.INDUCTORBANK = { type: 3, value: "INDUCTORBANK" };
  IfcElectricFlowStorageDeviceTypeEnum.RECHARGER = { type: 3, value: "RECHARGER" };
  IfcElectricFlowStorageDeviceTypeEnum.UPS = { type: 3, value: "UPS" };
  IfcElectricFlowStorageDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricFlowStorageDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcElectricFlowStorageDeviceTypeEnum = IfcElectricFlowStorageDeviceTypeEnum;
  class IfcElectricFlowTreatmentDeviceTypeEnum {
  }
  IfcElectricFlowTreatmentDeviceTypeEnum.ELECTRONICFILTER = { type: 3, value: "ELECTRONICFILTER" };
  IfcElectricFlowTreatmentDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricFlowTreatmentDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcElectricFlowTreatmentDeviceTypeEnum = IfcElectricFlowTreatmentDeviceTypeEnum;
  class IfcElectricGeneratorTypeEnum {
  }
  IfcElectricGeneratorTypeEnum.CHP = { type: 3, value: "CHP" };
  IfcElectricGeneratorTypeEnum.ENGINEGENERATOR = { type: 3, value: "ENGINEGENERATOR" };
  IfcElectricGeneratorTypeEnum.STANDALONE = { type: 3, value: "STANDALONE" };
  IfcElectricGeneratorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricGeneratorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcElectricGeneratorTypeEnum = IfcElectricGeneratorTypeEnum;
  class IfcElectricMotorTypeEnum {
  }
  IfcElectricMotorTypeEnum.DC = { type: 3, value: "DC" };
  IfcElectricMotorTypeEnum.INDUCTION = { type: 3, value: "INDUCTION" };
  IfcElectricMotorTypeEnum.POLYPHASE = { type: 3, value: "POLYPHASE" };
  IfcElectricMotorTypeEnum.RELUCTANCESYNCHRONOUS = { type: 3, value: "RELUCTANCESYNCHRONOUS" };
  IfcElectricMotorTypeEnum.SYNCHRONOUS = { type: 3, value: "SYNCHRONOUS" };
  IfcElectricMotorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricMotorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcElectricMotorTypeEnum = IfcElectricMotorTypeEnum;
  class IfcElectricTimeControlTypeEnum {
  }
  IfcElectricTimeControlTypeEnum.RELAY = { type: 3, value: "RELAY" };
  IfcElectricTimeControlTypeEnum.TIMECLOCK = { type: 3, value: "TIMECLOCK" };
  IfcElectricTimeControlTypeEnum.TIMEDELAY = { type: 3, value: "TIMEDELAY" };
  IfcElectricTimeControlTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricTimeControlTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcElectricTimeControlTypeEnum = IfcElectricTimeControlTypeEnum;
  class IfcElementAssemblyTypeEnum {
  }
  IfcElementAssemblyTypeEnum.ABUTMENT = { type: 3, value: "ABUTMENT" };
  IfcElementAssemblyTypeEnum.ACCESSORY_ASSEMBLY = { type: 3, value: "ACCESSORY_ASSEMBLY" };
  IfcElementAssemblyTypeEnum.ARCH = { type: 3, value: "ARCH" };
  IfcElementAssemblyTypeEnum.BEAM_GRID = { type: 3, value: "BEAM_GRID" };
  IfcElementAssemblyTypeEnum.BRACED_FRAME = { type: 3, value: "BRACED_FRAME" };
  IfcElementAssemblyTypeEnum.CROSS_BRACING = { type: 3, value: "CROSS_BRACING" };
  IfcElementAssemblyTypeEnum.DECK = { type: 3, value: "DECK" };
  IfcElementAssemblyTypeEnum.DILATATIONPANEL = { type: 3, value: "DILATATIONPANEL" };
  IfcElementAssemblyTypeEnum.ENTRANCEWORKS = { type: 3, value: "ENTRANCEWORKS" };
  IfcElementAssemblyTypeEnum.GIRDER = { type: 3, value: "GIRDER" };
  IfcElementAssemblyTypeEnum.GRID = { type: 3, value: "GRID" };
  IfcElementAssemblyTypeEnum.MAST = { type: 3, value: "MAST" };
  IfcElementAssemblyTypeEnum.PIER = { type: 3, value: "PIER" };
  IfcElementAssemblyTypeEnum.PYLON = { type: 3, value: "PYLON" };
  IfcElementAssemblyTypeEnum.RAIL_MECHANICAL_EQUIPMENT_ASSEMBLY = { type: 3, value: "RAIL_MECHANICAL_EQUIPMENT_ASSEMBLY" };
  IfcElementAssemblyTypeEnum.REINFORCEMENT_UNIT = { type: 3, value: "REINFORCEMENT_UNIT" };
  IfcElementAssemblyTypeEnum.RIGID_FRAME = { type: 3, value: "RIGID_FRAME" };
  IfcElementAssemblyTypeEnum.SHELTER = { type: 3, value: "SHELTER" };
  IfcElementAssemblyTypeEnum.SIGNALASSEMBLY = { type: 3, value: "SIGNALASSEMBLY" };
  IfcElementAssemblyTypeEnum.SLAB_FIELD = { type: 3, value: "SLAB_FIELD" };
  IfcElementAssemblyTypeEnum.SUMPBUSTER = { type: 3, value: "SUMPBUSTER" };
  IfcElementAssemblyTypeEnum.SUPPORTINGASSEMBLY = { type: 3, value: "SUPPORTINGASSEMBLY" };
  IfcElementAssemblyTypeEnum.SUSPENSIONASSEMBLY = { type: 3, value: "SUSPENSIONASSEMBLY" };
  IfcElementAssemblyTypeEnum.TRACKPANEL = { type: 3, value: "TRACKPANEL" };
  IfcElementAssemblyTypeEnum.TRACTION_SWITCHING_ASSEMBLY = { type: 3, value: "TRACTION_SWITCHING_ASSEMBLY" };
  IfcElementAssemblyTypeEnum.TRAFFIC_CALMING_DEVICE = { type: 3, value: "TRAFFIC_CALMING_DEVICE" };
  IfcElementAssemblyTypeEnum.TRUSS = { type: 3, value: "TRUSS" };
  IfcElementAssemblyTypeEnum.TURNOUTPANEL = { type: 3, value: "TURNOUTPANEL" };
  IfcElementAssemblyTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElementAssemblyTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcElementAssemblyTypeEnum = IfcElementAssemblyTypeEnum;
  class IfcElementCompositionEnum {
  }
  IfcElementCompositionEnum.COMPLEX = { type: 3, value: "COMPLEX" };
  IfcElementCompositionEnum.ELEMENT = { type: 3, value: "ELEMENT" };
  IfcElementCompositionEnum.PARTIAL = { type: 3, value: "PARTIAL" };
  IFC4_32.IfcElementCompositionEnum = IfcElementCompositionEnum;
  class IfcEngineTypeEnum {
  }
  IfcEngineTypeEnum.EXTERNALCOMBUSTION = { type: 3, value: "EXTERNALCOMBUSTION" };
  IfcEngineTypeEnum.INTERNALCOMBUSTION = { type: 3, value: "INTERNALCOMBUSTION" };
  IfcEngineTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcEngineTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcEngineTypeEnum = IfcEngineTypeEnum;
  class IfcEvaporativeCoolerTypeEnum {
  }
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVEAIRWASHER = { type: 3, value: "DIRECTEVAPORATIVEAIRWASHER" };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER" };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER" };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER" };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER" };
  IfcEvaporativeCoolerTypeEnum.INDIRECTDIRECTCOMBINATION = { type: 3, value: "INDIRECTDIRECTCOMBINATION" };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = { type: 3, value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER" };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = { type: 3, value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER" };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVEWETCOIL = { type: 3, value: "INDIRECTEVAPORATIVEWETCOIL" };
  IfcEvaporativeCoolerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcEvaporativeCoolerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcEvaporativeCoolerTypeEnum = IfcEvaporativeCoolerTypeEnum;
  class IfcEvaporatorTypeEnum {
  }
  IfcEvaporatorTypeEnum.DIRECTEXPANSION = { type: 3, value: "DIRECTEXPANSION" };
  IfcEvaporatorTypeEnum.DIRECTEXPANSIONBRAZEDPLATE = { type: 3, value: "DIRECTEXPANSIONBRAZEDPLATE" };
  IfcEvaporatorTypeEnum.DIRECTEXPANSIONSHELLANDTUBE = { type: 3, value: "DIRECTEXPANSIONSHELLANDTUBE" };
  IfcEvaporatorTypeEnum.DIRECTEXPANSIONTUBEINTUBE = { type: 3, value: "DIRECTEXPANSIONTUBEINTUBE" };
  IfcEvaporatorTypeEnum.FLOODEDSHELLANDTUBE = { type: 3, value: "FLOODEDSHELLANDTUBE" };
  IfcEvaporatorTypeEnum.SHELLANDCOIL = { type: 3, value: "SHELLANDCOIL" };
  IfcEvaporatorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcEvaporatorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcEvaporatorTypeEnum = IfcEvaporatorTypeEnum;
  class IfcEventTriggerTypeEnum {
  }
  IfcEventTriggerTypeEnum.EVENTCOMPLEX = { type: 3, value: "EVENTCOMPLEX" };
  IfcEventTriggerTypeEnum.EVENTMESSAGE = { type: 3, value: "EVENTMESSAGE" };
  IfcEventTriggerTypeEnum.EVENTRULE = { type: 3, value: "EVENTRULE" };
  IfcEventTriggerTypeEnum.EVENTTIME = { type: 3, value: "EVENTTIME" };
  IfcEventTriggerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcEventTriggerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcEventTriggerTypeEnum = IfcEventTriggerTypeEnum;
  class IfcEventTypeEnum {
  }
  IfcEventTypeEnum.ENDEVENT = { type: 3, value: "ENDEVENT" };
  IfcEventTypeEnum.INTERMEDIATEEVENT = { type: 3, value: "INTERMEDIATEEVENT" };
  IfcEventTypeEnum.STARTEVENT = { type: 3, value: "STARTEVENT" };
  IfcEventTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcEventTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcEventTypeEnum = IfcEventTypeEnum;
  class IfcExternalSpatialElementTypeEnum {
  }
  IfcExternalSpatialElementTypeEnum.EXTERNAL = { type: 3, value: "EXTERNAL" };
  IfcExternalSpatialElementTypeEnum.EXTERNAL_EARTH = { type: 3, value: "EXTERNAL_EARTH" };
  IfcExternalSpatialElementTypeEnum.EXTERNAL_FIRE = { type: 3, value: "EXTERNAL_FIRE" };
  IfcExternalSpatialElementTypeEnum.EXTERNAL_WATER = { type: 3, value: "EXTERNAL_WATER" };
  IfcExternalSpatialElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcExternalSpatialElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcExternalSpatialElementTypeEnum = IfcExternalSpatialElementTypeEnum;
  class IfcFacilityPartCommonTypeEnum {
  }
  IfcFacilityPartCommonTypeEnum.ABOVEGROUND = { type: 3, value: "ABOVEGROUND" };
  IfcFacilityPartCommonTypeEnum.BELOWGROUND = { type: 3, value: "BELOWGROUND" };
  IfcFacilityPartCommonTypeEnum.JUNCTION = { type: 3, value: "JUNCTION" };
  IfcFacilityPartCommonTypeEnum.LEVELCROSSING = { type: 3, value: "LEVELCROSSING" };
  IfcFacilityPartCommonTypeEnum.SEGMENT = { type: 3, value: "SEGMENT" };
  IfcFacilityPartCommonTypeEnum.SUBSTRUCTURE = { type: 3, value: "SUBSTRUCTURE" };
  IfcFacilityPartCommonTypeEnum.SUPERSTRUCTURE = { type: 3, value: "SUPERSTRUCTURE" };
  IfcFacilityPartCommonTypeEnum.TERMINAL = { type: 3, value: "TERMINAL" };
  IfcFacilityPartCommonTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFacilityPartCommonTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcFacilityPartCommonTypeEnum = IfcFacilityPartCommonTypeEnum;
  class IfcFacilityUsageEnum {
  }
  IfcFacilityUsageEnum.LATERAL = { type: 3, value: "LATERAL" };
  IfcFacilityUsageEnum.LONGITUDINAL = { type: 3, value: "LONGITUDINAL" };
  IfcFacilityUsageEnum.REGION = { type: 3, value: "REGION" };
  IfcFacilityUsageEnum.VERTICAL = { type: 3, value: "VERTICAL" };
  IfcFacilityUsageEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFacilityUsageEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcFacilityUsageEnum = IfcFacilityUsageEnum;
  class IfcFanTypeEnum {
  }
  IfcFanTypeEnum.CENTRIFUGALAIRFOIL = { type: 3, value: "CENTRIFUGALAIRFOIL" };
  IfcFanTypeEnum.CENTRIFUGALBACKWARDINCLINEDCURVED = { type: 3, value: "CENTRIFUGALBACKWARDINCLINEDCURVED" };
  IfcFanTypeEnum.CENTRIFUGALFORWARDCURVED = { type: 3, value: "CENTRIFUGALFORWARDCURVED" };
  IfcFanTypeEnum.CENTRIFUGALRADIAL = { type: 3, value: "CENTRIFUGALRADIAL" };
  IfcFanTypeEnum.PROPELLORAXIAL = { type: 3, value: "PROPELLORAXIAL" };
  IfcFanTypeEnum.TUBEAXIAL = { type: 3, value: "TUBEAXIAL" };
  IfcFanTypeEnum.VANEAXIAL = { type: 3, value: "VANEAXIAL" };
  IfcFanTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFanTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcFanTypeEnum = IfcFanTypeEnum;
  class IfcFastenerTypeEnum {
  }
  IfcFastenerTypeEnum.GLUE = { type: 3, value: "GLUE" };
  IfcFastenerTypeEnum.MORTAR = { type: 3, value: "MORTAR" };
  IfcFastenerTypeEnum.WELD = { type: 3, value: "WELD" };
  IfcFastenerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFastenerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcFastenerTypeEnum = IfcFastenerTypeEnum;
  class IfcFilterTypeEnum {
  }
  IfcFilterTypeEnum.AIRPARTICLEFILTER = { type: 3, value: "AIRPARTICLEFILTER" };
  IfcFilterTypeEnum.COMPRESSEDAIRFILTER = { type: 3, value: "COMPRESSEDAIRFILTER" };
  IfcFilterTypeEnum.ODORFILTER = { type: 3, value: "ODORFILTER" };
  IfcFilterTypeEnum.OILFILTER = { type: 3, value: "OILFILTER" };
  IfcFilterTypeEnum.STRAINER = { type: 3, value: "STRAINER" };
  IfcFilterTypeEnum.WATERFILTER = { type: 3, value: "WATERFILTER" };
  IfcFilterTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFilterTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcFilterTypeEnum = IfcFilterTypeEnum;
  class IfcFireSuppressionTerminalTypeEnum {
  }
  IfcFireSuppressionTerminalTypeEnum.BREECHINGINLET = { type: 3, value: "BREECHINGINLET" };
  IfcFireSuppressionTerminalTypeEnum.FIREHYDRANT = { type: 3, value: "FIREHYDRANT" };
  IfcFireSuppressionTerminalTypeEnum.FIREMONITOR = { type: 3, value: "FIREMONITOR" };
  IfcFireSuppressionTerminalTypeEnum.HOSEREEL = { type: 3, value: "HOSEREEL" };
  IfcFireSuppressionTerminalTypeEnum.SPRINKLER = { type: 3, value: "SPRINKLER" };
  IfcFireSuppressionTerminalTypeEnum.SPRINKLERDEFLECTOR = { type: 3, value: "SPRINKLERDEFLECTOR" };
  IfcFireSuppressionTerminalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFireSuppressionTerminalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcFireSuppressionTerminalTypeEnum = IfcFireSuppressionTerminalTypeEnum;
  class IfcFlowDirectionEnum {
  }
  IfcFlowDirectionEnum.SINK = { type: 3, value: "SINK" };
  IfcFlowDirectionEnum.SOURCE = { type: 3, value: "SOURCE" };
  IfcFlowDirectionEnum.SOURCEANDSINK = { type: 3, value: "SOURCEANDSINK" };
  IfcFlowDirectionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcFlowDirectionEnum = IfcFlowDirectionEnum;
  class IfcFlowInstrumentTypeEnum {
  }
  IfcFlowInstrumentTypeEnum.AMMETER = { type: 3, value: "AMMETER" };
  IfcFlowInstrumentTypeEnum.COMBINED = { type: 3, value: "COMBINED" };
  IfcFlowInstrumentTypeEnum.FREQUENCYMETER = { type: 3, value: "FREQUENCYMETER" };
  IfcFlowInstrumentTypeEnum.PHASEANGLEMETER = { type: 3, value: "PHASEANGLEMETER" };
  IfcFlowInstrumentTypeEnum.POWERFACTORMETER = { type: 3, value: "POWERFACTORMETER" };
  IfcFlowInstrumentTypeEnum.PRESSUREGAUGE = { type: 3, value: "PRESSUREGAUGE" };
  IfcFlowInstrumentTypeEnum.THERMOMETER = { type: 3, value: "THERMOMETER" };
  IfcFlowInstrumentTypeEnum.VOLTMETER = { type: 3, value: "VOLTMETER" };
  IfcFlowInstrumentTypeEnum.VOLTMETER_PEAK = { type: 3, value: "VOLTMETER_PEAK" };
  IfcFlowInstrumentTypeEnum.VOLTMETER_RMS = { type: 3, value: "VOLTMETER_RMS" };
  IfcFlowInstrumentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFlowInstrumentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcFlowInstrumentTypeEnum = IfcFlowInstrumentTypeEnum;
  class IfcFlowMeterTypeEnum {
  }
  IfcFlowMeterTypeEnum.ENERGYMETER = { type: 3, value: "ENERGYMETER" };
  IfcFlowMeterTypeEnum.GASMETER = { type: 3, value: "GASMETER" };
  IfcFlowMeterTypeEnum.OILMETER = { type: 3, value: "OILMETER" };
  IfcFlowMeterTypeEnum.WATERMETER = { type: 3, value: "WATERMETER" };
  IfcFlowMeterTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFlowMeterTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcFlowMeterTypeEnum = IfcFlowMeterTypeEnum;
  class IfcFootingTypeEnum {
  }
  IfcFootingTypeEnum.CAISSON_FOUNDATION = { type: 3, value: "CAISSON_FOUNDATION" };
  IfcFootingTypeEnum.FOOTING_BEAM = { type: 3, value: "FOOTING_BEAM" };
  IfcFootingTypeEnum.PAD_FOOTING = { type: 3, value: "PAD_FOOTING" };
  IfcFootingTypeEnum.PILE_CAP = { type: 3, value: "PILE_CAP" };
  IfcFootingTypeEnum.STRIP_FOOTING = { type: 3, value: "STRIP_FOOTING" };
  IfcFootingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFootingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcFootingTypeEnum = IfcFootingTypeEnum;
  class IfcFurnitureTypeEnum {
  }
  IfcFurnitureTypeEnum.BED = { type: 3, value: "BED" };
  IfcFurnitureTypeEnum.CHAIR = { type: 3, value: "CHAIR" };
  IfcFurnitureTypeEnum.DESK = { type: 3, value: "DESK" };
  IfcFurnitureTypeEnum.FILECABINET = { type: 3, value: "FILECABINET" };
  IfcFurnitureTypeEnum.SHELF = { type: 3, value: "SHELF" };
  IfcFurnitureTypeEnum.SOFA = { type: 3, value: "SOFA" };
  IfcFurnitureTypeEnum.TABLE = { type: 3, value: "TABLE" };
  IfcFurnitureTypeEnum.TECHNICALCABINET = { type: 3, value: "TECHNICALCABINET" };
  IfcFurnitureTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFurnitureTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcFurnitureTypeEnum = IfcFurnitureTypeEnum;
  class IfcGeographicElementTypeEnum {
  }
  IfcGeographicElementTypeEnum.SOIL_BORING_POINT = { type: 3, value: "SOIL_BORING_POINT" };
  IfcGeographicElementTypeEnum.TERRAIN = { type: 3, value: "TERRAIN" };
  IfcGeographicElementTypeEnum.VEGETATION = { type: 3, value: "VEGETATION" };
  IfcGeographicElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcGeographicElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcGeographicElementTypeEnum = IfcGeographicElementTypeEnum;
  class IfcGeometricProjectionEnum {
  }
  IfcGeometricProjectionEnum.ELEVATION_VIEW = { type: 3, value: "ELEVATION_VIEW" };
  IfcGeometricProjectionEnum.GRAPH_VIEW = { type: 3, value: "GRAPH_VIEW" };
  IfcGeometricProjectionEnum.MODEL_VIEW = { type: 3, value: "MODEL_VIEW" };
  IfcGeometricProjectionEnum.PLAN_VIEW = { type: 3, value: "PLAN_VIEW" };
  IfcGeometricProjectionEnum.REFLECTED_PLAN_VIEW = { type: 3, value: "REFLECTED_PLAN_VIEW" };
  IfcGeometricProjectionEnum.SECTION_VIEW = { type: 3, value: "SECTION_VIEW" };
  IfcGeometricProjectionEnum.SKETCH_VIEW = { type: 3, value: "SKETCH_VIEW" };
  IfcGeometricProjectionEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcGeometricProjectionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcGeometricProjectionEnum = IfcGeometricProjectionEnum;
  class IfcGeotechnicalStratumTypeEnum {
  }
  IfcGeotechnicalStratumTypeEnum.SOLID = { type: 3, value: "SOLID" };
  IfcGeotechnicalStratumTypeEnum.VOID = { type: 3, value: "VOID" };
  IfcGeotechnicalStratumTypeEnum.WATER = { type: 3, value: "WATER" };
  IfcGeotechnicalStratumTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcGeotechnicalStratumTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcGeotechnicalStratumTypeEnum = IfcGeotechnicalStratumTypeEnum;
  class IfcGlobalOrLocalEnum {
  }
  IfcGlobalOrLocalEnum.GLOBAL_COORDS = { type: 3, value: "GLOBAL_COORDS" };
  IfcGlobalOrLocalEnum.LOCAL_COORDS = { type: 3, value: "LOCAL_COORDS" };
  IFC4_32.IfcGlobalOrLocalEnum = IfcGlobalOrLocalEnum;
  class IfcGridTypeEnum {
  }
  IfcGridTypeEnum.IRREGULAR = { type: 3, value: "IRREGULAR" };
  IfcGridTypeEnum.RADIAL = { type: 3, value: "RADIAL" };
  IfcGridTypeEnum.RECTANGULAR = { type: 3, value: "RECTANGULAR" };
  IfcGridTypeEnum.TRIANGULAR = { type: 3, value: "TRIANGULAR" };
  IfcGridTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcGridTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcGridTypeEnum = IfcGridTypeEnum;
  class IfcHeatExchangerTypeEnum {
  }
  IfcHeatExchangerTypeEnum.PLATE = { type: 3, value: "PLATE" };
  IfcHeatExchangerTypeEnum.SHELLANDTUBE = { type: 3, value: "SHELLANDTUBE" };
  IfcHeatExchangerTypeEnum.TURNOUTHEATING = { type: 3, value: "TURNOUTHEATING" };
  IfcHeatExchangerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcHeatExchangerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcHeatExchangerTypeEnum = IfcHeatExchangerTypeEnum;
  class IfcHumidifierTypeEnum {
  }
  IfcHumidifierTypeEnum.ADIABATICAIRWASHER = { type: 3, value: "ADIABATICAIRWASHER" };
  IfcHumidifierTypeEnum.ADIABATICATOMIZING = { type: 3, value: "ADIABATICATOMIZING" };
  IfcHumidifierTypeEnum.ADIABATICCOMPRESSEDAIRNOZZLE = { type: 3, value: "ADIABATICCOMPRESSEDAIRNOZZLE" };
  IfcHumidifierTypeEnum.ADIABATICPAN = { type: 3, value: "ADIABATICPAN" };
  IfcHumidifierTypeEnum.ADIABATICRIGIDMEDIA = { type: 3, value: "ADIABATICRIGIDMEDIA" };
  IfcHumidifierTypeEnum.ADIABATICULTRASONIC = { type: 3, value: "ADIABATICULTRASONIC" };
  IfcHumidifierTypeEnum.ADIABATICWETTEDELEMENT = { type: 3, value: "ADIABATICWETTEDELEMENT" };
  IfcHumidifierTypeEnum.ASSISTEDBUTANE = { type: 3, value: "ASSISTEDBUTANE" };
  IfcHumidifierTypeEnum.ASSISTEDELECTRIC = { type: 3, value: "ASSISTEDELECTRIC" };
  IfcHumidifierTypeEnum.ASSISTEDNATURALGAS = { type: 3, value: "ASSISTEDNATURALGAS" };
  IfcHumidifierTypeEnum.ASSISTEDPROPANE = { type: 3, value: "ASSISTEDPROPANE" };
  IfcHumidifierTypeEnum.ASSISTEDSTEAM = { type: 3, value: "ASSISTEDSTEAM" };
  IfcHumidifierTypeEnum.STEAMINJECTION = { type: 3, value: "STEAMINJECTION" };
  IfcHumidifierTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcHumidifierTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcHumidifierTypeEnum = IfcHumidifierTypeEnum;
  class IfcImpactProtectionDeviceTypeEnum {
  }
  IfcImpactProtectionDeviceTypeEnum.BUMPER = { type: 3, value: "BUMPER" };
  IfcImpactProtectionDeviceTypeEnum.CRASHCUSHION = { type: 3, value: "CRASHCUSHION" };
  IfcImpactProtectionDeviceTypeEnum.DAMPINGSYSTEM = { type: 3, value: "DAMPINGSYSTEM" };
  IfcImpactProtectionDeviceTypeEnum.FENDER = { type: 3, value: "FENDER" };
  IfcImpactProtectionDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcImpactProtectionDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcImpactProtectionDeviceTypeEnum = IfcImpactProtectionDeviceTypeEnum;
  class IfcInterceptorTypeEnum {
  }
  IfcInterceptorTypeEnum.CYCLONIC = { type: 3, value: "CYCLONIC" };
  IfcInterceptorTypeEnum.GREASE = { type: 3, value: "GREASE" };
  IfcInterceptorTypeEnum.OIL = { type: 3, value: "OIL" };
  IfcInterceptorTypeEnum.PETROL = { type: 3, value: "PETROL" };
  IfcInterceptorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcInterceptorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcInterceptorTypeEnum = IfcInterceptorTypeEnum;
  class IfcInternalOrExternalEnum {
  }
  IfcInternalOrExternalEnum.EXTERNAL = { type: 3, value: "EXTERNAL" };
  IfcInternalOrExternalEnum.EXTERNAL_EARTH = { type: 3, value: "EXTERNAL_EARTH" };
  IfcInternalOrExternalEnum.EXTERNAL_FIRE = { type: 3, value: "EXTERNAL_FIRE" };
  IfcInternalOrExternalEnum.EXTERNAL_WATER = { type: 3, value: "EXTERNAL_WATER" };
  IfcInternalOrExternalEnum.INTERNAL = { type: 3, value: "INTERNAL" };
  IfcInternalOrExternalEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcInternalOrExternalEnum = IfcInternalOrExternalEnum;
  class IfcInventoryTypeEnum {
  }
  IfcInventoryTypeEnum.ASSETINVENTORY = { type: 3, value: "ASSETINVENTORY" };
  IfcInventoryTypeEnum.FURNITUREINVENTORY = { type: 3, value: "FURNITUREINVENTORY" };
  IfcInventoryTypeEnum.SPACEINVENTORY = { type: 3, value: "SPACEINVENTORY" };
  IfcInventoryTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcInventoryTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcInventoryTypeEnum = IfcInventoryTypeEnum;
  class IfcJunctionBoxTypeEnum {
  }
  IfcJunctionBoxTypeEnum.DATA = { type: 3, value: "DATA" };
  IfcJunctionBoxTypeEnum.POWER = { type: 3, value: "POWER" };
  IfcJunctionBoxTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcJunctionBoxTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcJunctionBoxTypeEnum = IfcJunctionBoxTypeEnum;
  class IfcKnotType {
  }
  IfcKnotType.PIECEWISE_BEZIER_KNOTS = { type: 3, value: "PIECEWISE_BEZIER_KNOTS" };
  IfcKnotType.QUASI_UNIFORM_KNOTS = { type: 3, value: "QUASI_UNIFORM_KNOTS" };
  IfcKnotType.UNIFORM_KNOTS = { type: 3, value: "UNIFORM_KNOTS" };
  IfcKnotType.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  IFC4_32.IfcKnotType = IfcKnotType;
  class IfcLaborResourceTypeEnum {
  }
  IfcLaborResourceTypeEnum.ADMINISTRATION = { type: 3, value: "ADMINISTRATION" };
  IfcLaborResourceTypeEnum.CARPENTRY = { type: 3, value: "CARPENTRY" };
  IfcLaborResourceTypeEnum.CLEANING = { type: 3, value: "CLEANING" };
  IfcLaborResourceTypeEnum.CONCRETE = { type: 3, value: "CONCRETE" };
  IfcLaborResourceTypeEnum.DRYWALL = { type: 3, value: "DRYWALL" };
  IfcLaborResourceTypeEnum.ELECTRIC = { type: 3, value: "ELECTRIC" };
  IfcLaborResourceTypeEnum.FINISHING = { type: 3, value: "FINISHING" };
  IfcLaborResourceTypeEnum.FLOORING = { type: 3, value: "FLOORING" };
  IfcLaborResourceTypeEnum.GENERAL = { type: 3, value: "GENERAL" };
  IfcLaborResourceTypeEnum.HVAC = { type: 3, value: "HVAC" };
  IfcLaborResourceTypeEnum.LANDSCAPING = { type: 3, value: "LANDSCAPING" };
  IfcLaborResourceTypeEnum.MASONRY = { type: 3, value: "MASONRY" };
  IfcLaborResourceTypeEnum.PAINTING = { type: 3, value: "PAINTING" };
  IfcLaborResourceTypeEnum.PAVING = { type: 3, value: "PAVING" };
  IfcLaborResourceTypeEnum.PLUMBING = { type: 3, value: "PLUMBING" };
  IfcLaborResourceTypeEnum.ROOFING = { type: 3, value: "ROOFING" };
  IfcLaborResourceTypeEnum.SITEGRADING = { type: 3, value: "SITEGRADING" };
  IfcLaborResourceTypeEnum.STEELWORK = { type: 3, value: "STEELWORK" };
  IfcLaborResourceTypeEnum.SURVEYING = { type: 3, value: "SURVEYING" };
  IfcLaborResourceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcLaborResourceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcLaborResourceTypeEnum = IfcLaborResourceTypeEnum;
  class IfcLampTypeEnum {
  }
  IfcLampTypeEnum.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" };
  IfcLampTypeEnum.FLUORESCENT = { type: 3, value: "FLUORESCENT" };
  IfcLampTypeEnum.HALOGEN = { type: 3, value: "HALOGEN" };
  IfcLampTypeEnum.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" };
  IfcLampTypeEnum.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" };
  IfcLampTypeEnum.LED = { type: 3, value: "LED" };
  IfcLampTypeEnum.METALHALIDE = { type: 3, value: "METALHALIDE" };
  IfcLampTypeEnum.OLED = { type: 3, value: "OLED" };
  IfcLampTypeEnum.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" };
  IfcLampTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcLampTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcLampTypeEnum = IfcLampTypeEnum;
  class IfcLayerSetDirectionEnum {
  }
  IfcLayerSetDirectionEnum.AXIS1 = { type: 3, value: "AXIS1" };
  IfcLayerSetDirectionEnum.AXIS2 = { type: 3, value: "AXIS2" };
  IfcLayerSetDirectionEnum.AXIS3 = { type: 3, value: "AXIS3" };
  IFC4_32.IfcLayerSetDirectionEnum = IfcLayerSetDirectionEnum;
  class IfcLightDistributionCurveEnum {
  }
  IfcLightDistributionCurveEnum.TYPE_A = { type: 3, value: "TYPE_A" };
  IfcLightDistributionCurveEnum.TYPE_B = { type: 3, value: "TYPE_B" };
  IfcLightDistributionCurveEnum.TYPE_C = { type: 3, value: "TYPE_C" };
  IfcLightDistributionCurveEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcLightDistributionCurveEnum = IfcLightDistributionCurveEnum;
  class IfcLightEmissionSourceEnum {
  }
  IfcLightEmissionSourceEnum.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" };
  IfcLightEmissionSourceEnum.FLUORESCENT = { type: 3, value: "FLUORESCENT" };
  IfcLightEmissionSourceEnum.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" };
  IfcLightEmissionSourceEnum.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" };
  IfcLightEmissionSourceEnum.LIGHTEMITTINGDIODE = { type: 3, value: "LIGHTEMITTINGDIODE" };
  IfcLightEmissionSourceEnum.LOWPRESSURESODIUM = { type: 3, value: "LOWPRESSURESODIUM" };
  IfcLightEmissionSourceEnum.LOWVOLTAGEHALOGEN = { type: 3, value: "LOWVOLTAGEHALOGEN" };
  IfcLightEmissionSourceEnum.MAINVOLTAGEHALOGEN = { type: 3, value: "MAINVOLTAGEHALOGEN" };
  IfcLightEmissionSourceEnum.METALHALIDE = { type: 3, value: "METALHALIDE" };
  IfcLightEmissionSourceEnum.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" };
  IfcLightEmissionSourceEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcLightEmissionSourceEnum = IfcLightEmissionSourceEnum;
  class IfcLightFixtureTypeEnum {
  }
  IfcLightFixtureTypeEnum.DIRECTIONSOURCE = { type: 3, value: "DIRECTIONSOURCE" };
  IfcLightFixtureTypeEnum.POINTSOURCE = { type: 3, value: "POINTSOURCE" };
  IfcLightFixtureTypeEnum.SECURITYLIGHTING = { type: 3, value: "SECURITYLIGHTING" };
  IfcLightFixtureTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcLightFixtureTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcLightFixtureTypeEnum = IfcLightFixtureTypeEnum;
  class IfcLiquidTerminalTypeEnum {
  }
  IfcLiquidTerminalTypeEnum.HOSEREEL = { type: 3, value: "HOSEREEL" };
  IfcLiquidTerminalTypeEnum.LOADINGARM = { type: 3, value: "LOADINGARM" };
  IfcLiquidTerminalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcLiquidTerminalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcLiquidTerminalTypeEnum = IfcLiquidTerminalTypeEnum;
  class IfcLoadGroupTypeEnum {
  }
  IfcLoadGroupTypeEnum.LOAD_CASE = { type: 3, value: "LOAD_CASE" };
  IfcLoadGroupTypeEnum.LOAD_COMBINATION = { type: 3, value: "LOAD_COMBINATION" };
  IfcLoadGroupTypeEnum.LOAD_GROUP = { type: 3, value: "LOAD_GROUP" };
  IfcLoadGroupTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcLoadGroupTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcLoadGroupTypeEnum = IfcLoadGroupTypeEnum;
  class IfcLogicalOperatorEnum {
  }
  IfcLogicalOperatorEnum.LOGICALAND = { type: 3, value: "LOGICALAND" };
  IfcLogicalOperatorEnum.LOGICALNOTAND = { type: 3, value: "LOGICALNOTAND" };
  IfcLogicalOperatorEnum.LOGICALNOTOR = { type: 3, value: "LOGICALNOTOR" };
  IfcLogicalOperatorEnum.LOGICALOR = { type: 3, value: "LOGICALOR" };
  IfcLogicalOperatorEnum.LOGICALXOR = { type: 3, value: "LOGICALXOR" };
  IFC4_32.IfcLogicalOperatorEnum = IfcLogicalOperatorEnum;
  class IfcMarineFacilityTypeEnum {
  }
  IfcMarineFacilityTypeEnum.BARRIERBEACH = { type: 3, value: "BARRIERBEACH" };
  IfcMarineFacilityTypeEnum.BREAKWATER = { type: 3, value: "BREAKWATER" };
  IfcMarineFacilityTypeEnum.CANAL = { type: 3, value: "CANAL" };
  IfcMarineFacilityTypeEnum.DRYDOCK = { type: 3, value: "DRYDOCK" };
  IfcMarineFacilityTypeEnum.FLOATINGDOCK = { type: 3, value: "FLOATINGDOCK" };
  IfcMarineFacilityTypeEnum.HYDROLIFT = { type: 3, value: "HYDROLIFT" };
  IfcMarineFacilityTypeEnum.JETTY = { type: 3, value: "JETTY" };
  IfcMarineFacilityTypeEnum.LAUNCHRECOVERY = { type: 3, value: "LAUNCHRECOVERY" };
  IfcMarineFacilityTypeEnum.MARINEDEFENCE = { type: 3, value: "MARINEDEFENCE" };
  IfcMarineFacilityTypeEnum.NAVIGATIONALCHANNEL = { type: 3, value: "NAVIGATIONALCHANNEL" };
  IfcMarineFacilityTypeEnum.PORT = { type: 3, value: "PORT" };
  IfcMarineFacilityTypeEnum.QUAY = { type: 3, value: "QUAY" };
  IfcMarineFacilityTypeEnum.REVETMENT = { type: 3, value: "REVETMENT" };
  IfcMarineFacilityTypeEnum.SHIPLIFT = { type: 3, value: "SHIPLIFT" };
  IfcMarineFacilityTypeEnum.SHIPLOCK = { type: 3, value: "SHIPLOCK" };
  IfcMarineFacilityTypeEnum.SHIPYARD = { type: 3, value: "SHIPYARD" };
  IfcMarineFacilityTypeEnum.SLIPWAY = { type: 3, value: "SLIPWAY" };
  IfcMarineFacilityTypeEnum.WATERWAY = { type: 3, value: "WATERWAY" };
  IfcMarineFacilityTypeEnum.WATERWAYSHIPLIFT = { type: 3, value: "WATERWAYSHIPLIFT" };
  IfcMarineFacilityTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcMarineFacilityTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcMarineFacilityTypeEnum = IfcMarineFacilityTypeEnum;
  class IfcMarinePartTypeEnum {
  }
  IfcMarinePartTypeEnum.ABOVEWATERLINE = { type: 3, value: "ABOVEWATERLINE" };
  IfcMarinePartTypeEnum.ANCHORAGE = { type: 3, value: "ANCHORAGE" };
  IfcMarinePartTypeEnum.APPROACHCHANNEL = { type: 3, value: "APPROACHCHANNEL" };
  IfcMarinePartTypeEnum.BELOWWATERLINE = { type: 3, value: "BELOWWATERLINE" };
  IfcMarinePartTypeEnum.BERTHINGSTRUCTURE = { type: 3, value: "BERTHINGSTRUCTURE" };
  IfcMarinePartTypeEnum.CHAMBER = { type: 3, value: "CHAMBER" };
  IfcMarinePartTypeEnum.CILL_LEVEL = { type: 3, value: "CILL_LEVEL" };
  IfcMarinePartTypeEnum.COPELEVEL = { type: 3, value: "COPELEVEL" };
  IfcMarinePartTypeEnum.CORE = { type: 3, value: "CORE" };
  IfcMarinePartTypeEnum.CREST = { type: 3, value: "CREST" };
  IfcMarinePartTypeEnum.GATEHEAD = { type: 3, value: "GATEHEAD" };
  IfcMarinePartTypeEnum.GUDINGSTRUCTURE = { type: 3, value: "GUDINGSTRUCTURE" };
  IfcMarinePartTypeEnum.HIGHWATERLINE = { type: 3, value: "HIGHWATERLINE" };
  IfcMarinePartTypeEnum.LANDFIELD = { type: 3, value: "LANDFIELD" };
  IfcMarinePartTypeEnum.LEEWARDSIDE = { type: 3, value: "LEEWARDSIDE" };
  IfcMarinePartTypeEnum.LOWWATERLINE = { type: 3, value: "LOWWATERLINE" };
  IfcMarinePartTypeEnum.MANUFACTURING = { type: 3, value: "MANUFACTURING" };
  IfcMarinePartTypeEnum.NAVIGATIONALAREA = { type: 3, value: "NAVIGATIONALAREA" };
  IfcMarinePartTypeEnum.PROTECTION = { type: 3, value: "PROTECTION" };
  IfcMarinePartTypeEnum.SHIPTRANSFER = { type: 3, value: "SHIPTRANSFER" };
  IfcMarinePartTypeEnum.STORAGEAREA = { type: 3, value: "STORAGEAREA" };
  IfcMarinePartTypeEnum.VEHICLESERVICING = { type: 3, value: "VEHICLESERVICING" };
  IfcMarinePartTypeEnum.WATERFIELD = { type: 3, value: "WATERFIELD" };
  IfcMarinePartTypeEnum.WEATHERSIDE = { type: 3, value: "WEATHERSIDE" };
  IfcMarinePartTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcMarinePartTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcMarinePartTypeEnum = IfcMarinePartTypeEnum;
  class IfcMechanicalFastenerTypeEnum {
  }
  IfcMechanicalFastenerTypeEnum.ANCHORBOLT = { type: 3, value: "ANCHORBOLT" };
  IfcMechanicalFastenerTypeEnum.BOLT = { type: 3, value: "BOLT" };
  IfcMechanicalFastenerTypeEnum.CHAIN = { type: 3, value: "CHAIN" };
  IfcMechanicalFastenerTypeEnum.COUPLER = { type: 3, value: "COUPLER" };
  IfcMechanicalFastenerTypeEnum.DOWEL = { type: 3, value: "DOWEL" };
  IfcMechanicalFastenerTypeEnum.NAIL = { type: 3, value: "NAIL" };
  IfcMechanicalFastenerTypeEnum.NAILPLATE = { type: 3, value: "NAILPLATE" };
  IfcMechanicalFastenerTypeEnum.RAILFASTENING = { type: 3, value: "RAILFASTENING" };
  IfcMechanicalFastenerTypeEnum.RAILJOINT = { type: 3, value: "RAILJOINT" };
  IfcMechanicalFastenerTypeEnum.RIVET = { type: 3, value: "RIVET" };
  IfcMechanicalFastenerTypeEnum.ROPE = { type: 3, value: "ROPE" };
  IfcMechanicalFastenerTypeEnum.SCREW = { type: 3, value: "SCREW" };
  IfcMechanicalFastenerTypeEnum.SHEARCONNECTOR = { type: 3, value: "SHEARCONNECTOR" };
  IfcMechanicalFastenerTypeEnum.STAPLE = { type: 3, value: "STAPLE" };
  IfcMechanicalFastenerTypeEnum.STUDSHEARCONNECTOR = { type: 3, value: "STUDSHEARCONNECTOR" };
  IfcMechanicalFastenerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcMechanicalFastenerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcMechanicalFastenerTypeEnum = IfcMechanicalFastenerTypeEnum;
  class IfcMedicalDeviceTypeEnum {
  }
  IfcMedicalDeviceTypeEnum.AIRSTATION = { type: 3, value: "AIRSTATION" };
  IfcMedicalDeviceTypeEnum.FEEDAIRUNIT = { type: 3, value: "FEEDAIRUNIT" };
  IfcMedicalDeviceTypeEnum.OXYGENGENERATOR = { type: 3, value: "OXYGENGENERATOR" };
  IfcMedicalDeviceTypeEnum.OXYGENPLANT = { type: 3, value: "OXYGENPLANT" };
  IfcMedicalDeviceTypeEnum.VACUUMSTATION = { type: 3, value: "VACUUMSTATION" };
  IfcMedicalDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcMedicalDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcMedicalDeviceTypeEnum = IfcMedicalDeviceTypeEnum;
  class IfcMemberTypeEnum {
  }
  IfcMemberTypeEnum.ARCH_SEGMENT = { type: 3, value: "ARCH_SEGMENT" };
  IfcMemberTypeEnum.BRACE = { type: 3, value: "BRACE" };
  IfcMemberTypeEnum.CHORD = { type: 3, value: "CHORD" };
  IfcMemberTypeEnum.COLLAR = { type: 3, value: "COLLAR" };
  IfcMemberTypeEnum.MEMBER = { type: 3, value: "MEMBER" };
  IfcMemberTypeEnum.MULLION = { type: 3, value: "MULLION" };
  IfcMemberTypeEnum.PLATE = { type: 3, value: "PLATE" };
  IfcMemberTypeEnum.POST = { type: 3, value: "POST" };
  IfcMemberTypeEnum.PURLIN = { type: 3, value: "PURLIN" };
  IfcMemberTypeEnum.RAFTER = { type: 3, value: "RAFTER" };
  IfcMemberTypeEnum.STAY_CABLE = { type: 3, value: "STAY_CABLE" };
  IfcMemberTypeEnum.STIFFENING_RIB = { type: 3, value: "STIFFENING_RIB" };
  IfcMemberTypeEnum.STRINGER = { type: 3, value: "STRINGER" };
  IfcMemberTypeEnum.STRUCTURALCABLE = { type: 3, value: "STRUCTURALCABLE" };
  IfcMemberTypeEnum.STRUT = { type: 3, value: "STRUT" };
  IfcMemberTypeEnum.STUD = { type: 3, value: "STUD" };
  IfcMemberTypeEnum.SUSPENDER = { type: 3, value: "SUSPENDER" };
  IfcMemberTypeEnum.SUSPENSION_CABLE = { type: 3, value: "SUSPENSION_CABLE" };
  IfcMemberTypeEnum.TIEBAR = { type: 3, value: "TIEBAR" };
  IfcMemberTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcMemberTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcMemberTypeEnum = IfcMemberTypeEnum;
  class IfcMobileTelecommunicationsApplianceTypeEnum {
  }
  IfcMobileTelecommunicationsApplianceTypeEnum.ACCESSPOINT = { type: 3, value: "ACCESSPOINT" };
  IfcMobileTelecommunicationsApplianceTypeEnum.BASEBANDUNIT = { type: 3, value: "BASEBANDUNIT" };
  IfcMobileTelecommunicationsApplianceTypeEnum.BASETRANSCEIVERSTATION = { type: 3, value: "BASETRANSCEIVERSTATION" };
  IfcMobileTelecommunicationsApplianceTypeEnum.E_UTRAN_NODE_B = { type: 3, value: "E_UTRAN_NODE_B" };
  IfcMobileTelecommunicationsApplianceTypeEnum.GATEWAY_GPRS_SUPPORT_NODE = { type: 3, value: "GATEWAY_GPRS_SUPPORT_NODE" };
  IfcMobileTelecommunicationsApplianceTypeEnum.MASTERUNIT = { type: 3, value: "MASTERUNIT" };
  IfcMobileTelecommunicationsApplianceTypeEnum.MOBILESWITCHINGCENTER = { type: 3, value: "MOBILESWITCHINGCENTER" };
  IfcMobileTelecommunicationsApplianceTypeEnum.MSCSERVER = { type: 3, value: "MSCSERVER" };
  IfcMobileTelecommunicationsApplianceTypeEnum.PACKETCONTROLUNIT = { type: 3, value: "PACKETCONTROLUNIT" };
  IfcMobileTelecommunicationsApplianceTypeEnum.REMOTERADIOUNIT = { type: 3, value: "REMOTERADIOUNIT" };
  IfcMobileTelecommunicationsApplianceTypeEnum.REMOTEUNIT = { type: 3, value: "REMOTEUNIT" };
  IfcMobileTelecommunicationsApplianceTypeEnum.SERVICE_GPRS_SUPPORT_NODE = { type: 3, value: "SERVICE_GPRS_SUPPORT_NODE" };
  IfcMobileTelecommunicationsApplianceTypeEnum.SUBSCRIBERSERVER = { type: 3, value: "SUBSCRIBERSERVER" };
  IfcMobileTelecommunicationsApplianceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcMobileTelecommunicationsApplianceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcMobileTelecommunicationsApplianceTypeEnum = IfcMobileTelecommunicationsApplianceTypeEnum;
  class IfcMooringDeviceTypeEnum {
  }
  IfcMooringDeviceTypeEnum.BOLLARD = { type: 3, value: "BOLLARD" };
  IfcMooringDeviceTypeEnum.LINETENSIONER = { type: 3, value: "LINETENSIONER" };
  IfcMooringDeviceTypeEnum.MAGNETICDEVICE = { type: 3, value: "MAGNETICDEVICE" };
  IfcMooringDeviceTypeEnum.MOORINGHOOKS = { type: 3, value: "MOORINGHOOKS" };
  IfcMooringDeviceTypeEnum.VACUUMDEVICE = { type: 3, value: "VACUUMDEVICE" };
  IfcMooringDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcMooringDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcMooringDeviceTypeEnum = IfcMooringDeviceTypeEnum;
  class IfcMotorConnectionTypeEnum {
  }
  IfcMotorConnectionTypeEnum.BELTDRIVE = { type: 3, value: "BELTDRIVE" };
  IfcMotorConnectionTypeEnum.COUPLING = { type: 3, value: "COUPLING" };
  IfcMotorConnectionTypeEnum.DIRECTDRIVE = { type: 3, value: "DIRECTDRIVE" };
  IfcMotorConnectionTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcMotorConnectionTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcMotorConnectionTypeEnum = IfcMotorConnectionTypeEnum;
  class IfcNavigationElementTypeEnum {
  }
  IfcNavigationElementTypeEnum.BEACON = { type: 3, value: "BEACON" };
  IfcNavigationElementTypeEnum.BUOY = { type: 3, value: "BUOY" };
  IfcNavigationElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcNavigationElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcNavigationElementTypeEnum = IfcNavigationElementTypeEnum;
  class IfcObjectTypeEnum {
  }
  IfcObjectTypeEnum.ACTOR = { type: 3, value: "ACTOR" };
  IfcObjectTypeEnum.CONTROL = { type: 3, value: "CONTROL" };
  IfcObjectTypeEnum.GROUP = { type: 3, value: "GROUP" };
  IfcObjectTypeEnum.PROCESS = { type: 3, value: "PROCESS" };
  IfcObjectTypeEnum.PRODUCT = { type: 3, value: "PRODUCT" };
  IfcObjectTypeEnum.PROJECT = { type: 3, value: "PROJECT" };
  IfcObjectTypeEnum.RESOURCE = { type: 3, value: "RESOURCE" };
  IfcObjectTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcObjectTypeEnum = IfcObjectTypeEnum;
  class IfcObjectiveEnum {
  }
  IfcObjectiveEnum.CODECOMPLIANCE = { type: 3, value: "CODECOMPLIANCE" };
  IfcObjectiveEnum.CODEWAIVER = { type: 3, value: "CODEWAIVER" };
  IfcObjectiveEnum.DESIGNINTENT = { type: 3, value: "DESIGNINTENT" };
  IfcObjectiveEnum.EXTERNAL = { type: 3, value: "EXTERNAL" };
  IfcObjectiveEnum.HEALTHANDSAFETY = { type: 3, value: "HEALTHANDSAFETY" };
  IfcObjectiveEnum.MERGECONFLICT = { type: 3, value: "MERGECONFLICT" };
  IfcObjectiveEnum.MODELVIEW = { type: 3, value: "MODELVIEW" };
  IfcObjectiveEnum.PARAMETER = { type: 3, value: "PARAMETER" };
  IfcObjectiveEnum.REQUIREMENT = { type: 3, value: "REQUIREMENT" };
  IfcObjectiveEnum.SPECIFICATION = { type: 3, value: "SPECIFICATION" };
  IfcObjectiveEnum.TRIGGERCONDITION = { type: 3, value: "TRIGGERCONDITION" };
  IfcObjectiveEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcObjectiveEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcObjectiveEnum = IfcObjectiveEnum;
  class IfcOccupantTypeEnum {
  }
  IfcOccupantTypeEnum.ASSIGNEE = { type: 3, value: "ASSIGNEE" };
  IfcOccupantTypeEnum.ASSIGNOR = { type: 3, value: "ASSIGNOR" };
  IfcOccupantTypeEnum.LESSEE = { type: 3, value: "LESSEE" };
  IfcOccupantTypeEnum.LESSOR = { type: 3, value: "LESSOR" };
  IfcOccupantTypeEnum.LETTINGAGENT = { type: 3, value: "LETTINGAGENT" };
  IfcOccupantTypeEnum.OWNER = { type: 3, value: "OWNER" };
  IfcOccupantTypeEnum.TENANT = { type: 3, value: "TENANT" };
  IfcOccupantTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcOccupantTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcOccupantTypeEnum = IfcOccupantTypeEnum;
  class IfcOpeningElementTypeEnum {
  }
  IfcOpeningElementTypeEnum.OPENING = { type: 3, value: "OPENING" };
  IfcOpeningElementTypeEnum.RECESS = { type: 3, value: "RECESS" };
  IfcOpeningElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcOpeningElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcOpeningElementTypeEnum = IfcOpeningElementTypeEnum;
  class IfcOutletTypeEnum {
  }
  IfcOutletTypeEnum.AUDIOVISUALOUTLET = { type: 3, value: "AUDIOVISUALOUTLET" };
  IfcOutletTypeEnum.COMMUNICATIONSOUTLET = { type: 3, value: "COMMUNICATIONSOUTLET" };
  IfcOutletTypeEnum.DATAOUTLET = { type: 3, value: "DATAOUTLET" };
  IfcOutletTypeEnum.POWEROUTLET = { type: 3, value: "POWEROUTLET" };
  IfcOutletTypeEnum.TELEPHONEOUTLET = { type: 3, value: "TELEPHONEOUTLET" };
  IfcOutletTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcOutletTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcOutletTypeEnum = IfcOutletTypeEnum;
  class IfcPavementTypeEnum {
  }
  IfcPavementTypeEnum.FLEXIBLE = { type: 3, value: "FLEXIBLE" };
  IfcPavementTypeEnum.RIGID = { type: 3, value: "RIGID" };
  IfcPavementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPavementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcPavementTypeEnum = IfcPavementTypeEnum;
  class IfcPerformanceHistoryTypeEnum {
  }
  IfcPerformanceHistoryTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPerformanceHistoryTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcPerformanceHistoryTypeEnum = IfcPerformanceHistoryTypeEnum;
  class IfcPermeableCoveringOperationEnum {
  }
  IfcPermeableCoveringOperationEnum.GRILL = { type: 3, value: "GRILL" };
  IfcPermeableCoveringOperationEnum.LOUVER = { type: 3, value: "LOUVER" };
  IfcPermeableCoveringOperationEnum.SCREEN = { type: 3, value: "SCREEN" };
  IfcPermeableCoveringOperationEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPermeableCoveringOperationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcPermeableCoveringOperationEnum = IfcPermeableCoveringOperationEnum;
  class IfcPermitTypeEnum {
  }
  IfcPermitTypeEnum.ACCESS = { type: 3, value: "ACCESS" };
  IfcPermitTypeEnum.BUILDING = { type: 3, value: "BUILDING" };
  IfcPermitTypeEnum.WORK = { type: 3, value: "WORK" };
  IfcPermitTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPermitTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcPermitTypeEnum = IfcPermitTypeEnum;
  class IfcPhysicalOrVirtualEnum {
  }
  IfcPhysicalOrVirtualEnum.PHYSICAL = { type: 3, value: "PHYSICAL" };
  IfcPhysicalOrVirtualEnum.VIRTUAL = { type: 3, value: "VIRTUAL" };
  IfcPhysicalOrVirtualEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcPhysicalOrVirtualEnum = IfcPhysicalOrVirtualEnum;
  class IfcPileConstructionEnum {
  }
  IfcPileConstructionEnum.CAST_IN_PLACE = { type: 3, value: "CAST_IN_PLACE" };
  IfcPileConstructionEnum.COMPOSITE = { type: 3, value: "COMPOSITE" };
  IfcPileConstructionEnum.PRECAST_CONCRETE = { type: 3, value: "PRECAST_CONCRETE" };
  IfcPileConstructionEnum.PREFAB_STEEL = { type: 3, value: "PREFAB_STEEL" };
  IfcPileConstructionEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPileConstructionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcPileConstructionEnum = IfcPileConstructionEnum;
  class IfcPileTypeEnum {
  }
  IfcPileTypeEnum.BORED = { type: 3, value: "BORED" };
  IfcPileTypeEnum.COHESION = { type: 3, value: "COHESION" };
  IfcPileTypeEnum.DRIVEN = { type: 3, value: "DRIVEN" };
  IfcPileTypeEnum.FRICTION = { type: 3, value: "FRICTION" };
  IfcPileTypeEnum.JETGROUTING = { type: 3, value: "JETGROUTING" };
  IfcPileTypeEnum.SUPPORT = { type: 3, value: "SUPPORT" };
  IfcPileTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPileTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcPileTypeEnum = IfcPileTypeEnum;
  class IfcPipeFittingTypeEnum {
  }
  IfcPipeFittingTypeEnum.BEND = { type: 3, value: "BEND" };
  IfcPipeFittingTypeEnum.CONNECTOR = { type: 3, value: "CONNECTOR" };
  IfcPipeFittingTypeEnum.ENTRY = { type: 3, value: "ENTRY" };
  IfcPipeFittingTypeEnum.EXIT = { type: 3, value: "EXIT" };
  IfcPipeFittingTypeEnum.JUNCTION = { type: 3, value: "JUNCTION" };
  IfcPipeFittingTypeEnum.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" };
  IfcPipeFittingTypeEnum.TRANSITION = { type: 3, value: "TRANSITION" };
  IfcPipeFittingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPipeFittingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcPipeFittingTypeEnum = IfcPipeFittingTypeEnum;
  class IfcPipeSegmentTypeEnum {
  }
  IfcPipeSegmentTypeEnum.CULVERT = { type: 3, value: "CULVERT" };
  IfcPipeSegmentTypeEnum.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" };
  IfcPipeSegmentTypeEnum.GUTTER = { type: 3, value: "GUTTER" };
  IfcPipeSegmentTypeEnum.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" };
  IfcPipeSegmentTypeEnum.SPOOL = { type: 3, value: "SPOOL" };
  IfcPipeSegmentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPipeSegmentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcPipeSegmentTypeEnum = IfcPipeSegmentTypeEnum;
  class IfcPlateTypeEnum {
  }
  IfcPlateTypeEnum.BASE_PLATE = { type: 3, value: "BASE_PLATE" };
  IfcPlateTypeEnum.COVER_PLATE = { type: 3, value: "COVER_PLATE" };
  IfcPlateTypeEnum.CURTAIN_PANEL = { type: 3, value: "CURTAIN_PANEL" };
  IfcPlateTypeEnum.FLANGE_PLATE = { type: 3, value: "FLANGE_PLATE" };
  IfcPlateTypeEnum.GUSSET_PLATE = { type: 3, value: "GUSSET_PLATE" };
  IfcPlateTypeEnum.SHEET = { type: 3, value: "SHEET" };
  IfcPlateTypeEnum.SPLICE_PLATE = { type: 3, value: "SPLICE_PLATE" };
  IfcPlateTypeEnum.STIFFENER_PLATE = { type: 3, value: "STIFFENER_PLATE" };
  IfcPlateTypeEnum.WEB_PLATE = { type: 3, value: "WEB_PLATE" };
  IfcPlateTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPlateTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcPlateTypeEnum = IfcPlateTypeEnum;
  class IfcPreferredSurfaceCurveRepresentation {
  }
  IfcPreferredSurfaceCurveRepresentation.CURVE3D = { type: 3, value: "CURVE3D" };
  IfcPreferredSurfaceCurveRepresentation.PCURVE_S1 = { type: 3, value: "PCURVE_S1" };
  IfcPreferredSurfaceCurveRepresentation.PCURVE_S2 = { type: 3, value: "PCURVE_S2" };
  IFC4_32.IfcPreferredSurfaceCurveRepresentation = IfcPreferredSurfaceCurveRepresentation;
  class IfcProcedureTypeEnum {
  }
  IfcProcedureTypeEnum.ADVICE_CAUTION = { type: 3, value: "ADVICE_CAUTION" };
  IfcProcedureTypeEnum.ADVICE_NOTE = { type: 3, value: "ADVICE_NOTE" };
  IfcProcedureTypeEnum.ADVICE_WARNING = { type: 3, value: "ADVICE_WARNING" };
  IfcProcedureTypeEnum.CALIBRATION = { type: 3, value: "CALIBRATION" };
  IfcProcedureTypeEnum.DIAGNOSTIC = { type: 3, value: "DIAGNOSTIC" };
  IfcProcedureTypeEnum.SHUTDOWN = { type: 3, value: "SHUTDOWN" };
  IfcProcedureTypeEnum.STARTUP = { type: 3, value: "STARTUP" };
  IfcProcedureTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcProcedureTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcProcedureTypeEnum = IfcProcedureTypeEnum;
  class IfcProfileTypeEnum {
  }
  IfcProfileTypeEnum.AREA = { type: 3, value: "AREA" };
  IfcProfileTypeEnum.CURVE = { type: 3, value: "CURVE" };
  IFC4_32.IfcProfileTypeEnum = IfcProfileTypeEnum;
  class IfcProjectOrderTypeEnum {
  }
  IfcProjectOrderTypeEnum.CHANGEORDER = { type: 3, value: "CHANGEORDER" };
  IfcProjectOrderTypeEnum.MAINTENANCEWORKORDER = { type: 3, value: "MAINTENANCEWORKORDER" };
  IfcProjectOrderTypeEnum.MOVEORDER = { type: 3, value: "MOVEORDER" };
  IfcProjectOrderTypeEnum.PURCHASEORDER = { type: 3, value: "PURCHASEORDER" };
  IfcProjectOrderTypeEnum.WORKORDER = { type: 3, value: "WORKORDER" };
  IfcProjectOrderTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcProjectOrderTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcProjectOrderTypeEnum = IfcProjectOrderTypeEnum;
  class IfcProjectedOrTrueLengthEnum {
  }
  IfcProjectedOrTrueLengthEnum.PROJECTED_LENGTH = { type: 3, value: "PROJECTED_LENGTH" };
  IfcProjectedOrTrueLengthEnum.TRUE_LENGTH = { type: 3, value: "TRUE_LENGTH" };
  IFC4_32.IfcProjectedOrTrueLengthEnum = IfcProjectedOrTrueLengthEnum;
  class IfcProjectionElementTypeEnum {
  }
  IfcProjectionElementTypeEnum.BLISTER = { type: 3, value: "BLISTER" };
  IfcProjectionElementTypeEnum.DEVIATOR = { type: 3, value: "DEVIATOR" };
  IfcProjectionElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcProjectionElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcProjectionElementTypeEnum = IfcProjectionElementTypeEnum;
  class IfcPropertySetTemplateTypeEnum {
  }
  IfcPropertySetTemplateTypeEnum.PSET_MATERIALDRIVEN = { type: 3, value: "PSET_MATERIALDRIVEN" };
  IfcPropertySetTemplateTypeEnum.PSET_OCCURRENCEDRIVEN = { type: 3, value: "PSET_OCCURRENCEDRIVEN" };
  IfcPropertySetTemplateTypeEnum.PSET_PERFORMANCEDRIVEN = { type: 3, value: "PSET_PERFORMANCEDRIVEN" };
  IfcPropertySetTemplateTypeEnum.PSET_PROFILEDRIVEN = { type: 3, value: "PSET_PROFILEDRIVEN" };
  IfcPropertySetTemplateTypeEnum.PSET_TYPEDRIVENONLY = { type: 3, value: "PSET_TYPEDRIVENONLY" };
  IfcPropertySetTemplateTypeEnum.PSET_TYPEDRIVENOVERRIDE = { type: 3, value: "PSET_TYPEDRIVENOVERRIDE" };
  IfcPropertySetTemplateTypeEnum.QTO_OCCURRENCEDRIVEN = { type: 3, value: "QTO_OCCURRENCEDRIVEN" };
  IfcPropertySetTemplateTypeEnum.QTO_TYPEDRIVENONLY = { type: 3, value: "QTO_TYPEDRIVENONLY" };
  IfcPropertySetTemplateTypeEnum.QTO_TYPEDRIVENOVERRIDE = { type: 3, value: "QTO_TYPEDRIVENOVERRIDE" };
  IfcPropertySetTemplateTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcPropertySetTemplateTypeEnum = IfcPropertySetTemplateTypeEnum;
  class IfcProtectiveDeviceTrippingUnitTypeEnum {
  }
  IfcProtectiveDeviceTrippingUnitTypeEnum.ELECTROMAGNETIC = { type: 3, value: "ELECTROMAGNETIC" };
  IfcProtectiveDeviceTrippingUnitTypeEnum.ELECTRONIC = { type: 3, value: "ELECTRONIC" };
  IfcProtectiveDeviceTrippingUnitTypeEnum.RESIDUALCURRENT = { type: 3, value: "RESIDUALCURRENT" };
  IfcProtectiveDeviceTrippingUnitTypeEnum.THERMAL = { type: 3, value: "THERMAL" };
  IfcProtectiveDeviceTrippingUnitTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcProtectiveDeviceTrippingUnitTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcProtectiveDeviceTrippingUnitTypeEnum = IfcProtectiveDeviceTrippingUnitTypeEnum;
  class IfcProtectiveDeviceTypeEnum {
  }
  IfcProtectiveDeviceTypeEnum.ANTI_ARCING_DEVICE = { type: 3, value: "ANTI_ARCING_DEVICE" };
  IfcProtectiveDeviceTypeEnum.CIRCUITBREAKER = { type: 3, value: "CIRCUITBREAKER" };
  IfcProtectiveDeviceTypeEnum.EARTHINGSWITCH = { type: 3, value: "EARTHINGSWITCH" };
  IfcProtectiveDeviceTypeEnum.EARTHLEAKAGECIRCUITBREAKER = { type: 3, value: "EARTHLEAKAGECIRCUITBREAKER" };
  IfcProtectiveDeviceTypeEnum.FUSEDISCONNECTOR = { type: 3, value: "FUSEDISCONNECTOR" };
  IfcProtectiveDeviceTypeEnum.RESIDUALCURRENTCIRCUITBREAKER = { type: 3, value: "RESIDUALCURRENTCIRCUITBREAKER" };
  IfcProtectiveDeviceTypeEnum.RESIDUALCURRENTSWITCH = { type: 3, value: "RESIDUALCURRENTSWITCH" };
  IfcProtectiveDeviceTypeEnum.SPARKGAP = { type: 3, value: "SPARKGAP" };
  IfcProtectiveDeviceTypeEnum.VARISTOR = { type: 3, value: "VARISTOR" };
  IfcProtectiveDeviceTypeEnum.VOLTAGELIMITER = { type: 3, value: "VOLTAGELIMITER" };
  IfcProtectiveDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcProtectiveDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcProtectiveDeviceTypeEnum = IfcProtectiveDeviceTypeEnum;
  class IfcPumpTypeEnum {
  }
  IfcPumpTypeEnum.CIRCULATOR = { type: 3, value: "CIRCULATOR" };
  IfcPumpTypeEnum.ENDSUCTION = { type: 3, value: "ENDSUCTION" };
  IfcPumpTypeEnum.SPLITCASE = { type: 3, value: "SPLITCASE" };
  IfcPumpTypeEnum.SUBMERSIBLEPUMP = { type: 3, value: "SUBMERSIBLEPUMP" };
  IfcPumpTypeEnum.SUMPPUMP = { type: 3, value: "SUMPPUMP" };
  IfcPumpTypeEnum.VERTICALINLINE = { type: 3, value: "VERTICALINLINE" };
  IfcPumpTypeEnum.VERTICALTURBINE = { type: 3, value: "VERTICALTURBINE" };
  IfcPumpTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPumpTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcPumpTypeEnum = IfcPumpTypeEnum;
  class IfcRailTypeEnum {
  }
  IfcRailTypeEnum.BLADE = { type: 3, value: "BLADE" };
  IfcRailTypeEnum.CHECKRAIL = { type: 3, value: "CHECKRAIL" };
  IfcRailTypeEnum.GUARDRAIL = { type: 3, value: "GUARDRAIL" };
  IfcRailTypeEnum.RACKRAIL = { type: 3, value: "RACKRAIL" };
  IfcRailTypeEnum.RAIL = { type: 3, value: "RAIL" };
  IfcRailTypeEnum.STOCKRAIL = { type: 3, value: "STOCKRAIL" };
  IfcRailTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcRailTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcRailTypeEnum = IfcRailTypeEnum;
  class IfcRailingTypeEnum {
  }
  IfcRailingTypeEnum.BALUSTRADE = { type: 3, value: "BALUSTRADE" };
  IfcRailingTypeEnum.FENCE = { type: 3, value: "FENCE" };
  IfcRailingTypeEnum.GUARDRAIL = { type: 3, value: "GUARDRAIL" };
  IfcRailingTypeEnum.HANDRAIL = { type: 3, value: "HANDRAIL" };
  IfcRailingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcRailingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcRailingTypeEnum = IfcRailingTypeEnum;
  class IfcRailwayPartTypeEnum {
  }
  IfcRailwayPartTypeEnum.DILATATIONSUPERSTRUCTURE = { type: 3, value: "DILATATIONSUPERSTRUCTURE" };
  IfcRailwayPartTypeEnum.LINESIDESTRUCTURE = { type: 3, value: "LINESIDESTRUCTURE" };
  IfcRailwayPartTypeEnum.LINESIDESTRUCTUREPART = { type: 3, value: "LINESIDESTRUCTUREPART" };
  IfcRailwayPartTypeEnum.PLAINTRACKSUPERSTRUCTURE = { type: 3, value: "PLAINTRACKSUPERSTRUCTURE" };
  IfcRailwayPartTypeEnum.SUPERSTRUCTURE = { type: 3, value: "SUPERSTRUCTURE" };
  IfcRailwayPartTypeEnum.TRACKSTRUCTURE = { type: 3, value: "TRACKSTRUCTURE" };
  IfcRailwayPartTypeEnum.TRACKSTRUCTUREPART = { type: 3, value: "TRACKSTRUCTUREPART" };
  IfcRailwayPartTypeEnum.TURNOUTSUPERSTRUCTURE = { type: 3, value: "TURNOUTSUPERSTRUCTURE" };
  IfcRailwayPartTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcRailwayPartTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcRailwayPartTypeEnum = IfcRailwayPartTypeEnum;
  class IfcRailwayTypeEnum {
  }
  IfcRailwayTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcRailwayTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcRailwayTypeEnum = IfcRailwayTypeEnum;
  class IfcRampFlightTypeEnum {
  }
  IfcRampFlightTypeEnum.SPIRAL = { type: 3, value: "SPIRAL" };
  IfcRampFlightTypeEnum.STRAIGHT = { type: 3, value: "STRAIGHT" };
  IfcRampFlightTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcRampFlightTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcRampFlightTypeEnum = IfcRampFlightTypeEnum;
  class IfcRampTypeEnum {
  }
  IfcRampTypeEnum.HALF_TURN_RAMP = { type: 3, value: "HALF_TURN_RAMP" };
  IfcRampTypeEnum.QUARTER_TURN_RAMP = { type: 3, value: "QUARTER_TURN_RAMP" };
  IfcRampTypeEnum.SPIRAL_RAMP = { type: 3, value: "SPIRAL_RAMP" };
  IfcRampTypeEnum.STRAIGHT_RUN_RAMP = { type: 3, value: "STRAIGHT_RUN_RAMP" };
  IfcRampTypeEnum.TWO_QUARTER_TURN_RAMP = { type: 3, value: "TWO_QUARTER_TURN_RAMP" };
  IfcRampTypeEnum.TWO_STRAIGHT_RUN_RAMP = { type: 3, value: "TWO_STRAIGHT_RUN_RAMP" };
  IfcRampTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcRampTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcRampTypeEnum = IfcRampTypeEnum;
  class IfcRecurrenceTypeEnum {
  }
  IfcRecurrenceTypeEnum.BY_DAY_COUNT = { type: 3, value: "BY_DAY_COUNT" };
  IfcRecurrenceTypeEnum.BY_WEEKDAY_COUNT = { type: 3, value: "BY_WEEKDAY_COUNT" };
  IfcRecurrenceTypeEnum.DAILY = { type: 3, value: "DAILY" };
  IfcRecurrenceTypeEnum.MONTHLY_BY_DAY_OF_MONTH = { type: 3, value: "MONTHLY_BY_DAY_OF_MONTH" };
  IfcRecurrenceTypeEnum.MONTHLY_BY_POSITION = { type: 3, value: "MONTHLY_BY_POSITION" };
  IfcRecurrenceTypeEnum.WEEKLY = { type: 3, value: "WEEKLY" };
  IfcRecurrenceTypeEnum.YEARLY_BY_DAY_OF_MONTH = { type: 3, value: "YEARLY_BY_DAY_OF_MONTH" };
  IfcRecurrenceTypeEnum.YEARLY_BY_POSITION = { type: 3, value: "YEARLY_BY_POSITION" };
  IFC4_32.IfcRecurrenceTypeEnum = IfcRecurrenceTypeEnum;
  class IfcReferentTypeEnum {
  }
  IfcReferentTypeEnum.BOUNDARY = { type: 3, value: "BOUNDARY" };
  IfcReferentTypeEnum.INTERSECTION = { type: 3, value: "INTERSECTION" };
  IfcReferentTypeEnum.KILOPOINT = { type: 3, value: "KILOPOINT" };
  IfcReferentTypeEnum.LANDMARK = { type: 3, value: "LANDMARK" };
  IfcReferentTypeEnum.MILEPOINT = { type: 3, value: "MILEPOINT" };
  IfcReferentTypeEnum.POSITION = { type: 3, value: "POSITION" };
  IfcReferentTypeEnum.REFERENCEMARKER = { type: 3, value: "REFERENCEMARKER" };
  IfcReferentTypeEnum.STATION = { type: 3, value: "STATION" };
  IfcReferentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcReferentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcReferentTypeEnum = IfcReferentTypeEnum;
  class IfcReflectanceMethodEnum {
  }
  IfcReflectanceMethodEnum.BLINN = { type: 3, value: "BLINN" };
  IfcReflectanceMethodEnum.FLAT = { type: 3, value: "FLAT" };
  IfcReflectanceMethodEnum.GLASS = { type: 3, value: "GLASS" };
  IfcReflectanceMethodEnum.MATT = { type: 3, value: "MATT" };
  IfcReflectanceMethodEnum.METAL = { type: 3, value: "METAL" };
  IfcReflectanceMethodEnum.MIRROR = { type: 3, value: "MIRROR" };
  IfcReflectanceMethodEnum.PHONG = { type: 3, value: "PHONG" };
  IfcReflectanceMethodEnum.PHYSICAL = { type: 3, value: "PHYSICAL" };
  IfcReflectanceMethodEnum.PLASTIC = { type: 3, value: "PLASTIC" };
  IfcReflectanceMethodEnum.STRAUSS = { type: 3, value: "STRAUSS" };
  IfcReflectanceMethodEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcReflectanceMethodEnum = IfcReflectanceMethodEnum;
  class IfcReinforcedSoilTypeEnum {
  }
  IfcReinforcedSoilTypeEnum.DYNAMICALLYCOMPACTED = { type: 3, value: "DYNAMICALLYCOMPACTED" };
  IfcReinforcedSoilTypeEnum.GROUTED = { type: 3, value: "GROUTED" };
  IfcReinforcedSoilTypeEnum.REPLACED = { type: 3, value: "REPLACED" };
  IfcReinforcedSoilTypeEnum.ROLLERCOMPACTED = { type: 3, value: "ROLLERCOMPACTED" };
  IfcReinforcedSoilTypeEnum.SURCHARGEPRELOADED = { type: 3, value: "SURCHARGEPRELOADED" };
  IfcReinforcedSoilTypeEnum.VERTICALLYDRAINED = { type: 3, value: "VERTICALLYDRAINED" };
  IfcReinforcedSoilTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcReinforcedSoilTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcReinforcedSoilTypeEnum = IfcReinforcedSoilTypeEnum;
  class IfcReinforcingBarRoleEnum {
  }
  IfcReinforcingBarRoleEnum.ANCHORING = { type: 3, value: "ANCHORING" };
  IfcReinforcingBarRoleEnum.EDGE = { type: 3, value: "EDGE" };
  IfcReinforcingBarRoleEnum.LIGATURE = { type: 3, value: "LIGATURE" };
  IfcReinforcingBarRoleEnum.MAIN = { type: 3, value: "MAIN" };
  IfcReinforcingBarRoleEnum.PUNCHING = { type: 3, value: "PUNCHING" };
  IfcReinforcingBarRoleEnum.RING = { type: 3, value: "RING" };
  IfcReinforcingBarRoleEnum.SHEAR = { type: 3, value: "SHEAR" };
  IfcReinforcingBarRoleEnum.STUD = { type: 3, value: "STUD" };
  IfcReinforcingBarRoleEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcReinforcingBarRoleEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcReinforcingBarRoleEnum = IfcReinforcingBarRoleEnum;
  class IfcReinforcingBarSurfaceEnum {
  }
  IfcReinforcingBarSurfaceEnum.PLAIN = { type: 3, value: "PLAIN" };
  IfcReinforcingBarSurfaceEnum.TEXTURED = { type: 3, value: "TEXTURED" };
  IFC4_32.IfcReinforcingBarSurfaceEnum = IfcReinforcingBarSurfaceEnum;
  class IfcReinforcingBarTypeEnum {
  }
  IfcReinforcingBarTypeEnum.ANCHORING = { type: 3, value: "ANCHORING" };
  IfcReinforcingBarTypeEnum.EDGE = { type: 3, value: "EDGE" };
  IfcReinforcingBarTypeEnum.LIGATURE = { type: 3, value: "LIGATURE" };
  IfcReinforcingBarTypeEnum.MAIN = { type: 3, value: "MAIN" };
  IfcReinforcingBarTypeEnum.PUNCHING = { type: 3, value: "PUNCHING" };
  IfcReinforcingBarTypeEnum.RING = { type: 3, value: "RING" };
  IfcReinforcingBarTypeEnum.SHEAR = { type: 3, value: "SHEAR" };
  IfcReinforcingBarTypeEnum.SPACEBAR = { type: 3, value: "SPACEBAR" };
  IfcReinforcingBarTypeEnum.STUD = { type: 3, value: "STUD" };
  IfcReinforcingBarTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcReinforcingBarTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcReinforcingBarTypeEnum = IfcReinforcingBarTypeEnum;
  class IfcReinforcingMeshTypeEnum {
  }
  IfcReinforcingMeshTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcReinforcingMeshTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcReinforcingMeshTypeEnum = IfcReinforcingMeshTypeEnum;
  class IfcRoadPartTypeEnum {
  }
  IfcRoadPartTypeEnum.BICYCLECROSSING = { type: 3, value: "BICYCLECROSSING" };
  IfcRoadPartTypeEnum.BUS_STOP = { type: 3, value: "BUS_STOP" };
  IfcRoadPartTypeEnum.CARRIAGEWAY = { type: 3, value: "CARRIAGEWAY" };
  IfcRoadPartTypeEnum.CENTRALISLAND = { type: 3, value: "CENTRALISLAND" };
  IfcRoadPartTypeEnum.CENTRALRESERVE = { type: 3, value: "CENTRALRESERVE" };
  IfcRoadPartTypeEnum.HARDSHOULDER = { type: 3, value: "HARDSHOULDER" };
  IfcRoadPartTypeEnum.INTERSECTION = { type: 3, value: "INTERSECTION" };
  IfcRoadPartTypeEnum.LAYBY = { type: 3, value: "LAYBY" };
  IfcRoadPartTypeEnum.PARKINGBAY = { type: 3, value: "PARKINGBAY" };
  IfcRoadPartTypeEnum.PASSINGBAY = { type: 3, value: "PASSINGBAY" };
  IfcRoadPartTypeEnum.PEDESTRIAN_CROSSING = { type: 3, value: "PEDESTRIAN_CROSSING" };
  IfcRoadPartTypeEnum.RAILWAYCROSSING = { type: 3, value: "RAILWAYCROSSING" };
  IfcRoadPartTypeEnum.REFUGEISLAND = { type: 3, value: "REFUGEISLAND" };
  IfcRoadPartTypeEnum.ROADSEGMENT = { type: 3, value: "ROADSEGMENT" };
  IfcRoadPartTypeEnum.ROADSIDE = { type: 3, value: "ROADSIDE" };
  IfcRoadPartTypeEnum.ROADSIDEPART = { type: 3, value: "ROADSIDEPART" };
  IfcRoadPartTypeEnum.ROADWAYPLATEAU = { type: 3, value: "ROADWAYPLATEAU" };
  IfcRoadPartTypeEnum.ROUNDABOUT = { type: 3, value: "ROUNDABOUT" };
  IfcRoadPartTypeEnum.SHOULDER = { type: 3, value: "SHOULDER" };
  IfcRoadPartTypeEnum.SIDEWALK = { type: 3, value: "SIDEWALK" };
  IfcRoadPartTypeEnum.SOFTSHOULDER = { type: 3, value: "SOFTSHOULDER" };
  IfcRoadPartTypeEnum.TOLLPLAZA = { type: 3, value: "TOLLPLAZA" };
  IfcRoadPartTypeEnum.TRAFFICISLAND = { type: 3, value: "TRAFFICISLAND" };
  IfcRoadPartTypeEnum.TRAFFICLANE = { type: 3, value: "TRAFFICLANE" };
  IfcRoadPartTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcRoadPartTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcRoadPartTypeEnum = IfcRoadPartTypeEnum;
  class IfcRoadTypeEnum {
  }
  IfcRoadTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcRoadTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcRoadTypeEnum = IfcRoadTypeEnum;
  class IfcRoleEnum {
  }
  IfcRoleEnum.ARCHITECT = { type: 3, value: "ARCHITECT" };
  IfcRoleEnum.BUILDINGOPERATOR = { type: 3, value: "BUILDINGOPERATOR" };
  IfcRoleEnum.BUILDINGOWNER = { type: 3, value: "BUILDINGOWNER" };
  IfcRoleEnum.CIVILENGINEER = { type: 3, value: "CIVILENGINEER" };
  IfcRoleEnum.CLIENT = { type: 3, value: "CLIENT" };
  IfcRoleEnum.COMMISSIONINGENGINEER = { type: 3, value: "COMMISSIONINGENGINEER" };
  IfcRoleEnum.CONSTRUCTIONMANAGER = { type: 3, value: "CONSTRUCTIONMANAGER" };
  IfcRoleEnum.CONSULTANT = { type: 3, value: "CONSULTANT" };
  IfcRoleEnum.CONTRACTOR = { type: 3, value: "CONTRACTOR" };
  IfcRoleEnum.COSTENGINEER = { type: 3, value: "COSTENGINEER" };
  IfcRoleEnum.ELECTRICALENGINEER = { type: 3, value: "ELECTRICALENGINEER" };
  IfcRoleEnum.ENGINEER = { type: 3, value: "ENGINEER" };
  IfcRoleEnum.FACILITIESMANAGER = { type: 3, value: "FACILITIESMANAGER" };
  IfcRoleEnum.FIELDCONSTRUCTIONMANAGER = { type: 3, value: "FIELDCONSTRUCTIONMANAGER" };
  IfcRoleEnum.MANUFACTURER = { type: 3, value: "MANUFACTURER" };
  IfcRoleEnum.MECHANICALENGINEER = { type: 3, value: "MECHANICALENGINEER" };
  IfcRoleEnum.OWNER = { type: 3, value: "OWNER" };
  IfcRoleEnum.PROJECTMANAGER = { type: 3, value: "PROJECTMANAGER" };
  IfcRoleEnum.RESELLER = { type: 3, value: "RESELLER" };
  IfcRoleEnum.STRUCTURALENGINEER = { type: 3, value: "STRUCTURALENGINEER" };
  IfcRoleEnum.SUBCONTRACTOR = { type: 3, value: "SUBCONTRACTOR" };
  IfcRoleEnum.SUPPLIER = { type: 3, value: "SUPPLIER" };
  IfcRoleEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IFC4_32.IfcRoleEnum = IfcRoleEnum;
  class IfcRoofTypeEnum {
  }
  IfcRoofTypeEnum.BARREL_ROOF = { type: 3, value: "BARREL_ROOF" };
  IfcRoofTypeEnum.BUTTERFLY_ROOF = { type: 3, value: "BUTTERFLY_ROOF" };
  IfcRoofTypeEnum.DOME_ROOF = { type: 3, value: "DOME_ROOF" };
  IfcRoofTypeEnum.FLAT_ROOF = { type: 3, value: "FLAT_ROOF" };
  IfcRoofTypeEnum.FREEFORM = { type: 3, value: "FREEFORM" };
  IfcRoofTypeEnum.GABLE_ROOF = { type: 3, value: "GABLE_ROOF" };
  IfcRoofTypeEnum.GAMBREL_ROOF = { type: 3, value: "GAMBREL_ROOF" };
  IfcRoofTypeEnum.HIPPED_GABLE_ROOF = { type: 3, value: "HIPPED_GABLE_ROOF" };
  IfcRoofTypeEnum.HIP_ROOF = { type: 3, value: "HIP_ROOF" };
  IfcRoofTypeEnum.MANSARD_ROOF = { type: 3, value: "MANSARD_ROOF" };
  IfcRoofTypeEnum.PAVILION_ROOF = { type: 3, value: "PAVILION_ROOF" };
  IfcRoofTypeEnum.RAINBOW_ROOF = { type: 3, value: "RAINBOW_ROOF" };
  IfcRoofTypeEnum.SHED_ROOF = { type: 3, value: "SHED_ROOF" };
  IfcRoofTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcRoofTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcRoofTypeEnum = IfcRoofTypeEnum;
  class IfcSIPrefix {
  }
  IfcSIPrefix.ATTO = { type: 3, value: "ATTO" };
  IfcSIPrefix.CENTI = { type: 3, value: "CENTI" };
  IfcSIPrefix.DECA = { type: 3, value: "DECA" };
  IfcSIPrefix.DECI = { type: 3, value: "DECI" };
  IfcSIPrefix.EXA = { type: 3, value: "EXA" };
  IfcSIPrefix.FEMTO = { type: 3, value: "FEMTO" };
  IfcSIPrefix.GIGA = { type: 3, value: "GIGA" };
  IfcSIPrefix.HECTO = { type: 3, value: "HECTO" };
  IfcSIPrefix.KILO = { type: 3, value: "KILO" };
  IfcSIPrefix.MEGA = { type: 3, value: "MEGA" };
  IfcSIPrefix.MICRO = { type: 3, value: "MICRO" };
  IfcSIPrefix.MILLI = { type: 3, value: "MILLI" };
  IfcSIPrefix.NANO = { type: 3, value: "NANO" };
  IfcSIPrefix.PETA = { type: 3, value: "PETA" };
  IfcSIPrefix.PICO = { type: 3, value: "PICO" };
  IfcSIPrefix.TERA = { type: 3, value: "TERA" };
  IFC4_32.IfcSIPrefix = IfcSIPrefix;
  class IfcSIUnitName {
  }
  IfcSIUnitName.AMPERE = { type: 3, value: "AMPERE" };
  IfcSIUnitName.BECQUEREL = { type: 3, value: "BECQUEREL" };
  IfcSIUnitName.CANDELA = { type: 3, value: "CANDELA" };
  IfcSIUnitName.COULOMB = { type: 3, value: "COULOMB" };
  IfcSIUnitName.CUBIC_METRE = { type: 3, value: "CUBIC_METRE" };
  IfcSIUnitName.DEGREE_CELSIUS = { type: 3, value: "DEGREE_CELSIUS" };
  IfcSIUnitName.FARAD = { type: 3, value: "FARAD" };
  IfcSIUnitName.GRAM = { type: 3, value: "GRAM" };
  IfcSIUnitName.GRAY = { type: 3, value: "GRAY" };
  IfcSIUnitName.HENRY = { type: 3, value: "HENRY" };
  IfcSIUnitName.HERTZ = { type: 3, value: "HERTZ" };
  IfcSIUnitName.JOULE = { type: 3, value: "JOULE" };
  IfcSIUnitName.KELVIN = { type: 3, value: "KELVIN" };
  IfcSIUnitName.LUMEN = { type: 3, value: "LUMEN" };
  IfcSIUnitName.LUX = { type: 3, value: "LUX" };
  IfcSIUnitName.METRE = { type: 3, value: "METRE" };
  IfcSIUnitName.MOLE = { type: 3, value: "MOLE" };
  IfcSIUnitName.NEWTON = { type: 3, value: "NEWTON" };
  IfcSIUnitName.OHM = { type: 3, value: "OHM" };
  IfcSIUnitName.PASCAL = { type: 3, value: "PASCAL" };
  IfcSIUnitName.RADIAN = { type: 3, value: "RADIAN" };
  IfcSIUnitName.SECOND = { type: 3, value: "SECOND" };
  IfcSIUnitName.SIEMENS = { type: 3, value: "SIEMENS" };
  IfcSIUnitName.SIEVERT = { type: 3, value: "SIEVERT" };
  IfcSIUnitName.SQUARE_METRE = { type: 3, value: "SQUARE_METRE" };
  IfcSIUnitName.STERADIAN = { type: 3, value: "STERADIAN" };
  IfcSIUnitName.TESLA = { type: 3, value: "TESLA" };
  IfcSIUnitName.VOLT = { type: 3, value: "VOLT" };
  IfcSIUnitName.WATT = { type: 3, value: "WATT" };
  IfcSIUnitName.WEBER = { type: 3, value: "WEBER" };
  IFC4_32.IfcSIUnitName = IfcSIUnitName;
  class IfcSanitaryTerminalTypeEnum {
  }
  IfcSanitaryTerminalTypeEnum.BATH = { type: 3, value: "BATH" };
  IfcSanitaryTerminalTypeEnum.BIDET = { type: 3, value: "BIDET" };
  IfcSanitaryTerminalTypeEnum.CISTERN = { type: 3, value: "CISTERN" };
  IfcSanitaryTerminalTypeEnum.SANITARYFOUNTAIN = { type: 3, value: "SANITARYFOUNTAIN" };
  IfcSanitaryTerminalTypeEnum.SHOWER = { type: 3, value: "SHOWER" };
  IfcSanitaryTerminalTypeEnum.SINK = { type: 3, value: "SINK" };
  IfcSanitaryTerminalTypeEnum.TOILETPAN = { type: 3, value: "TOILETPAN" };
  IfcSanitaryTerminalTypeEnum.URINAL = { type: 3, value: "URINAL" };
  IfcSanitaryTerminalTypeEnum.WASHHANDBASIN = { type: 3, value: "WASHHANDBASIN" };
  IfcSanitaryTerminalTypeEnum.WCSEAT = { type: 3, value: "WCSEAT" };
  IfcSanitaryTerminalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSanitaryTerminalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcSanitaryTerminalTypeEnum = IfcSanitaryTerminalTypeEnum;
  class IfcSectionTypeEnum {
  }
  IfcSectionTypeEnum.TAPERED = { type: 3, value: "TAPERED" };
  IfcSectionTypeEnum.UNIFORM = { type: 3, value: "UNIFORM" };
  IFC4_32.IfcSectionTypeEnum = IfcSectionTypeEnum;
  class IfcSensorTypeEnum {
  }
  IfcSensorTypeEnum.CO2SENSOR = { type: 3, value: "CO2SENSOR" };
  IfcSensorTypeEnum.CONDUCTANCESENSOR = { type: 3, value: "CONDUCTANCESENSOR" };
  IfcSensorTypeEnum.CONTACTSENSOR = { type: 3, value: "CONTACTSENSOR" };
  IfcSensorTypeEnum.COSENSOR = { type: 3, value: "COSENSOR" };
  IfcSensorTypeEnum.EARTHQUAKESENSOR = { type: 3, value: "EARTHQUAKESENSOR" };
  IfcSensorTypeEnum.FIRESENSOR = { type: 3, value: "FIRESENSOR" };
  IfcSensorTypeEnum.FLOWSENSOR = { type: 3, value: "FLOWSENSOR" };
  IfcSensorTypeEnum.FOREIGNOBJECTDETECTIONSENSOR = { type: 3, value: "FOREIGNOBJECTDETECTIONSENSOR" };
  IfcSensorTypeEnum.FROSTSENSOR = { type: 3, value: "FROSTSENSOR" };
  IfcSensorTypeEnum.GASSENSOR = { type: 3, value: "GASSENSOR" };
  IfcSensorTypeEnum.HEATSENSOR = { type: 3, value: "HEATSENSOR" };
  IfcSensorTypeEnum.HUMIDITYSENSOR = { type: 3, value: "HUMIDITYSENSOR" };
  IfcSensorTypeEnum.IDENTIFIERSENSOR = { type: 3, value: "IDENTIFIERSENSOR" };
  IfcSensorTypeEnum.IONCONCENTRATIONSENSOR = { type: 3, value: "IONCONCENTRATIONSENSOR" };
  IfcSensorTypeEnum.LEVELSENSOR = { type: 3, value: "LEVELSENSOR" };
  IfcSensorTypeEnum.LIGHTSENSOR = { type: 3, value: "LIGHTSENSOR" };
  IfcSensorTypeEnum.MOISTURESENSOR = { type: 3, value: "MOISTURESENSOR" };
  IfcSensorTypeEnum.MOVEMENTSENSOR = { type: 3, value: "MOVEMENTSENSOR" };
  IfcSensorTypeEnum.OBSTACLESENSOR = { type: 3, value: "OBSTACLESENSOR" };
  IfcSensorTypeEnum.PHSENSOR = { type: 3, value: "PHSENSOR" };
  IfcSensorTypeEnum.PRESSURESENSOR = { type: 3, value: "PRESSURESENSOR" };
  IfcSensorTypeEnum.RADIATIONSENSOR = { type: 3, value: "RADIATIONSENSOR" };
  IfcSensorTypeEnum.RADIOACTIVITYSENSOR = { type: 3, value: "RADIOACTIVITYSENSOR" };
  IfcSensorTypeEnum.RAINSENSOR = { type: 3, value: "RAINSENSOR" };
  IfcSensorTypeEnum.SMOKESENSOR = { type: 3, value: "SMOKESENSOR" };
  IfcSensorTypeEnum.SNOWDEPTHSENSOR = { type: 3, value: "SNOWDEPTHSENSOR" };
  IfcSensorTypeEnum.SOUNDSENSOR = { type: 3, value: "SOUNDSENSOR" };
  IfcSensorTypeEnum.TEMPERATURESENSOR = { type: 3, value: "TEMPERATURESENSOR" };
  IfcSensorTypeEnum.TRAINSENSOR = { type: 3, value: "TRAINSENSOR" };
  IfcSensorTypeEnum.TURNOUTCLOSURESENSOR = { type: 3, value: "TURNOUTCLOSURESENSOR" };
  IfcSensorTypeEnum.WHEELSENSOR = { type: 3, value: "WHEELSENSOR" };
  IfcSensorTypeEnum.WINDSENSOR = { type: 3, value: "WINDSENSOR" };
  IfcSensorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSensorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcSensorTypeEnum = IfcSensorTypeEnum;
  class IfcSequenceEnum {
  }
  IfcSequenceEnum.FINISH_FINISH = { type: 3, value: "FINISH_FINISH" };
  IfcSequenceEnum.FINISH_START = { type: 3, value: "FINISH_START" };
  IfcSequenceEnum.START_FINISH = { type: 3, value: "START_FINISH" };
  IfcSequenceEnum.START_START = { type: 3, value: "START_START" };
  IfcSequenceEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSequenceEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcSequenceEnum = IfcSequenceEnum;
  class IfcShadingDeviceTypeEnum {
  }
  IfcShadingDeviceTypeEnum.AWNING = { type: 3, value: "AWNING" };
  IfcShadingDeviceTypeEnum.JALOUSIE = { type: 3, value: "JALOUSIE" };
  IfcShadingDeviceTypeEnum.SHUTTER = { type: 3, value: "SHUTTER" };
  IfcShadingDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcShadingDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcShadingDeviceTypeEnum = IfcShadingDeviceTypeEnum;
  class IfcSignTypeEnum {
  }
  IfcSignTypeEnum.MARKER = { type: 3, value: "MARKER" };
  IfcSignTypeEnum.MIRROR = { type: 3, value: "MIRROR" };
  IfcSignTypeEnum.PICTORAL = { type: 3, value: "PICTORAL" };
  IfcSignTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSignTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcSignTypeEnum = IfcSignTypeEnum;
  class IfcSignalTypeEnum {
  }
  IfcSignalTypeEnum.AUDIO = { type: 3, value: "AUDIO" };
  IfcSignalTypeEnum.MIXED = { type: 3, value: "MIXED" };
  IfcSignalTypeEnum.VISUAL = { type: 3, value: "VISUAL" };
  IfcSignalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSignalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcSignalTypeEnum = IfcSignalTypeEnum;
  class IfcSimplePropertyTemplateTypeEnum {
  }
  IfcSimplePropertyTemplateTypeEnum.P_BOUNDEDVALUE = { type: 3, value: "P_BOUNDEDVALUE" };
  IfcSimplePropertyTemplateTypeEnum.P_ENUMERATEDVALUE = { type: 3, value: "P_ENUMERATEDVALUE" };
  IfcSimplePropertyTemplateTypeEnum.P_LISTVALUE = { type: 3, value: "P_LISTVALUE" };
  IfcSimplePropertyTemplateTypeEnum.P_REFERENCEVALUE = { type: 3, value: "P_REFERENCEVALUE" };
  IfcSimplePropertyTemplateTypeEnum.P_SINGLEVALUE = { type: 3, value: "P_SINGLEVALUE" };
  IfcSimplePropertyTemplateTypeEnum.P_TABLEVALUE = { type: 3, value: "P_TABLEVALUE" };
  IfcSimplePropertyTemplateTypeEnum.Q_AREA = { type: 3, value: "Q_AREA" };
  IfcSimplePropertyTemplateTypeEnum.Q_COUNT = { type: 3, value: "Q_COUNT" };
  IfcSimplePropertyTemplateTypeEnum.Q_LENGTH = { type: 3, value: "Q_LENGTH" };
  IfcSimplePropertyTemplateTypeEnum.Q_NUMBER = { type: 3, value: "Q_NUMBER" };
  IfcSimplePropertyTemplateTypeEnum.Q_TIME = { type: 3, value: "Q_TIME" };
  IfcSimplePropertyTemplateTypeEnum.Q_VOLUME = { type: 3, value: "Q_VOLUME" };
  IfcSimplePropertyTemplateTypeEnum.Q_WEIGHT = { type: 3, value: "Q_WEIGHT" };
  IFC4_32.IfcSimplePropertyTemplateTypeEnum = IfcSimplePropertyTemplateTypeEnum;
  class IfcSlabTypeEnum {
  }
  IfcSlabTypeEnum.APPROACH_SLAB = { type: 3, value: "APPROACH_SLAB" };
  IfcSlabTypeEnum.BASESLAB = { type: 3, value: "BASESLAB" };
  IfcSlabTypeEnum.FLOOR = { type: 3, value: "FLOOR" };
  IfcSlabTypeEnum.LANDING = { type: 3, value: "LANDING" };
  IfcSlabTypeEnum.PAVING = { type: 3, value: "PAVING" };
  IfcSlabTypeEnum.ROOF = { type: 3, value: "ROOF" };
  IfcSlabTypeEnum.SIDEWALK = { type: 3, value: "SIDEWALK" };
  IfcSlabTypeEnum.TRACKSLAB = { type: 3, value: "TRACKSLAB" };
  IfcSlabTypeEnum.WEARING = { type: 3, value: "WEARING" };
  IfcSlabTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSlabTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcSlabTypeEnum = IfcSlabTypeEnum;
  class IfcSolarDeviceTypeEnum {
  }
  IfcSolarDeviceTypeEnum.SOLARCOLLECTOR = { type: 3, value: "SOLARCOLLECTOR" };
  IfcSolarDeviceTypeEnum.SOLARPANEL = { type: 3, value: "SOLARPANEL" };
  IfcSolarDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSolarDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcSolarDeviceTypeEnum = IfcSolarDeviceTypeEnum;
  class IfcSpaceHeaterTypeEnum {
  }
  IfcSpaceHeaterTypeEnum.CONVECTOR = { type: 3, value: "CONVECTOR" };
  IfcSpaceHeaterTypeEnum.RADIATOR = { type: 3, value: "RADIATOR" };
  IfcSpaceHeaterTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSpaceHeaterTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcSpaceHeaterTypeEnum = IfcSpaceHeaterTypeEnum;
  class IfcSpaceTypeEnum {
  }
  IfcSpaceTypeEnum.BERTH = { type: 3, value: "BERTH" };
  IfcSpaceTypeEnum.EXTERNAL = { type: 3, value: "EXTERNAL" };
  IfcSpaceTypeEnum.GFA = { type: 3, value: "GFA" };
  IfcSpaceTypeEnum.INTERNAL = { type: 3, value: "INTERNAL" };
  IfcSpaceTypeEnum.PARKING = { type: 3, value: "PARKING" };
  IfcSpaceTypeEnum.SPACE = { type: 3, value: "SPACE" };
  IfcSpaceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSpaceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcSpaceTypeEnum = IfcSpaceTypeEnum;
  class IfcSpatialZoneTypeEnum {
  }
  IfcSpatialZoneTypeEnum.CONSTRUCTION = { type: 3, value: "CONSTRUCTION" };
  IfcSpatialZoneTypeEnum.FIRESAFETY = { type: 3, value: "FIRESAFETY" };
  IfcSpatialZoneTypeEnum.INTERFERENCE = { type: 3, value: "INTERFERENCE" };
  IfcSpatialZoneTypeEnum.LIGHTING = { type: 3, value: "LIGHTING" };
  IfcSpatialZoneTypeEnum.OCCUPANCY = { type: 3, value: "OCCUPANCY" };
  IfcSpatialZoneTypeEnum.RESERVATION = { type: 3, value: "RESERVATION" };
  IfcSpatialZoneTypeEnum.SECURITY = { type: 3, value: "SECURITY" };
  IfcSpatialZoneTypeEnum.THERMAL = { type: 3, value: "THERMAL" };
  IfcSpatialZoneTypeEnum.TRANSPORT = { type: 3, value: "TRANSPORT" };
  IfcSpatialZoneTypeEnum.VENTILATION = { type: 3, value: "VENTILATION" };
  IfcSpatialZoneTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSpatialZoneTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcSpatialZoneTypeEnum = IfcSpatialZoneTypeEnum;
  class IfcStackTerminalTypeEnum {
  }
  IfcStackTerminalTypeEnum.BIRDCAGE = { type: 3, value: "BIRDCAGE" };
  IfcStackTerminalTypeEnum.COWL = { type: 3, value: "COWL" };
  IfcStackTerminalTypeEnum.RAINWATERHOPPER = { type: 3, value: "RAINWATERHOPPER" };
  IfcStackTerminalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStackTerminalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcStackTerminalTypeEnum = IfcStackTerminalTypeEnum;
  class IfcStairFlightTypeEnum {
  }
  IfcStairFlightTypeEnum.CURVED = { type: 3, value: "CURVED" };
  IfcStairFlightTypeEnum.FREEFORM = { type: 3, value: "FREEFORM" };
  IfcStairFlightTypeEnum.SPIRAL = { type: 3, value: "SPIRAL" };
  IfcStairFlightTypeEnum.STRAIGHT = { type: 3, value: "STRAIGHT" };
  IfcStairFlightTypeEnum.WINDER = { type: 3, value: "WINDER" };
  IfcStairFlightTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStairFlightTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcStairFlightTypeEnum = IfcStairFlightTypeEnum;
  class IfcStairTypeEnum {
  }
  IfcStairTypeEnum.CURVED_RUN_STAIR = { type: 3, value: "CURVED_RUN_STAIR" };
  IfcStairTypeEnum.DOUBLE_RETURN_STAIR = { type: 3, value: "DOUBLE_RETURN_STAIR" };
  IfcStairTypeEnum.HALF_TURN_STAIR = { type: 3, value: "HALF_TURN_STAIR" };
  IfcStairTypeEnum.HALF_WINDING_STAIR = { type: 3, value: "HALF_WINDING_STAIR" };
  IfcStairTypeEnum.LADDER = { type: 3, value: "LADDER" };
  IfcStairTypeEnum.QUARTER_TURN_STAIR = { type: 3, value: "QUARTER_TURN_STAIR" };
  IfcStairTypeEnum.QUARTER_WINDING_STAIR = { type: 3, value: "QUARTER_WINDING_STAIR" };
  IfcStairTypeEnum.SPIRAL_STAIR = { type: 3, value: "SPIRAL_STAIR" };
  IfcStairTypeEnum.STRAIGHT_RUN_STAIR = { type: 3, value: "STRAIGHT_RUN_STAIR" };
  IfcStairTypeEnum.THREE_QUARTER_TURN_STAIR = { type: 3, value: "THREE_QUARTER_TURN_STAIR" };
  IfcStairTypeEnum.THREE_QUARTER_WINDING_STAIR = { type: 3, value: "THREE_QUARTER_WINDING_STAIR" };
  IfcStairTypeEnum.TWO_CURVED_RUN_STAIR = { type: 3, value: "TWO_CURVED_RUN_STAIR" };
  IfcStairTypeEnum.TWO_QUARTER_TURN_STAIR = { type: 3, value: "TWO_QUARTER_TURN_STAIR" };
  IfcStairTypeEnum.TWO_QUARTER_WINDING_STAIR = { type: 3, value: "TWO_QUARTER_WINDING_STAIR" };
  IfcStairTypeEnum.TWO_STRAIGHT_RUN_STAIR = { type: 3, value: "TWO_STRAIGHT_RUN_STAIR" };
  IfcStairTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStairTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcStairTypeEnum = IfcStairTypeEnum;
  class IfcStateEnum {
  }
  IfcStateEnum.LOCKED = { type: 3, value: "LOCKED" };
  IfcStateEnum.READONLY = { type: 3, value: "READONLY" };
  IfcStateEnum.READONLYLOCKED = { type: 3, value: "READONLYLOCKED" };
  IfcStateEnum.READWRITE = { type: 3, value: "READWRITE" };
  IfcStateEnum.READWRITELOCKED = { type: 3, value: "READWRITELOCKED" };
  IFC4_32.IfcStateEnum = IfcStateEnum;
  class IfcStructuralCurveActivityTypeEnum {
  }
  IfcStructuralCurveActivityTypeEnum.CONST = { type: 3, value: "CONST" };
  IfcStructuralCurveActivityTypeEnum.DISCRETE = { type: 3, value: "DISCRETE" };
  IfcStructuralCurveActivityTypeEnum.EQUIDISTANT = { type: 3, value: "EQUIDISTANT" };
  IfcStructuralCurveActivityTypeEnum.LINEAR = { type: 3, value: "LINEAR" };
  IfcStructuralCurveActivityTypeEnum.PARABOLA = { type: 3, value: "PARABOLA" };
  IfcStructuralCurveActivityTypeEnum.POLYGONAL = { type: 3, value: "POLYGONAL" };
  IfcStructuralCurveActivityTypeEnum.SINUS = { type: 3, value: "SINUS" };
  IfcStructuralCurveActivityTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStructuralCurveActivityTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcStructuralCurveActivityTypeEnum = IfcStructuralCurveActivityTypeEnum;
  class IfcStructuralCurveMemberTypeEnum {
  }
  IfcStructuralCurveMemberTypeEnum.CABLE = { type: 3, value: "CABLE" };
  IfcStructuralCurveMemberTypeEnum.COMPRESSION_MEMBER = { type: 3, value: "COMPRESSION_MEMBER" };
  IfcStructuralCurveMemberTypeEnum.PIN_JOINED_MEMBER = { type: 3, value: "PIN_JOINED_MEMBER" };
  IfcStructuralCurveMemberTypeEnum.RIGID_JOINED_MEMBER = { type: 3, value: "RIGID_JOINED_MEMBER" };
  IfcStructuralCurveMemberTypeEnum.TENSION_MEMBER = { type: 3, value: "TENSION_MEMBER" };
  IfcStructuralCurveMemberTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStructuralCurveMemberTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcStructuralCurveMemberTypeEnum = IfcStructuralCurveMemberTypeEnum;
  class IfcStructuralSurfaceActivityTypeEnum {
  }
  IfcStructuralSurfaceActivityTypeEnum.BILINEAR = { type: 3, value: "BILINEAR" };
  IfcStructuralSurfaceActivityTypeEnum.CONST = { type: 3, value: "CONST" };
  IfcStructuralSurfaceActivityTypeEnum.DISCRETE = { type: 3, value: "DISCRETE" };
  IfcStructuralSurfaceActivityTypeEnum.ISOCONTOUR = { type: 3, value: "ISOCONTOUR" };
  IfcStructuralSurfaceActivityTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStructuralSurfaceActivityTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcStructuralSurfaceActivityTypeEnum = IfcStructuralSurfaceActivityTypeEnum;
  class IfcStructuralSurfaceMemberTypeEnum {
  }
  IfcStructuralSurfaceMemberTypeEnum.BENDING_ELEMENT = { type: 3, value: "BENDING_ELEMENT" };
  IfcStructuralSurfaceMemberTypeEnum.MEMBRANE_ELEMENT = { type: 3, value: "MEMBRANE_ELEMENT" };
  IfcStructuralSurfaceMemberTypeEnum.SHELL = { type: 3, value: "SHELL" };
  IfcStructuralSurfaceMemberTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStructuralSurfaceMemberTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcStructuralSurfaceMemberTypeEnum = IfcStructuralSurfaceMemberTypeEnum;
  class IfcSubContractResourceTypeEnum {
  }
  IfcSubContractResourceTypeEnum.PURCHASE = { type: 3, value: "PURCHASE" };
  IfcSubContractResourceTypeEnum.WORK = { type: 3, value: "WORK" };
  IfcSubContractResourceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSubContractResourceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcSubContractResourceTypeEnum = IfcSubContractResourceTypeEnum;
  class IfcSurfaceFeatureTypeEnum {
  }
  IfcSurfaceFeatureTypeEnum.DEFECT = { type: 3, value: "DEFECT" };
  IfcSurfaceFeatureTypeEnum.HATCHMARKING = { type: 3, value: "HATCHMARKING" };
  IfcSurfaceFeatureTypeEnum.LINEMARKING = { type: 3, value: "LINEMARKING" };
  IfcSurfaceFeatureTypeEnum.MARK = { type: 3, value: "MARK" };
  IfcSurfaceFeatureTypeEnum.NONSKIDSURFACING = { type: 3, value: "NONSKIDSURFACING" };
  IfcSurfaceFeatureTypeEnum.PAVEMENTSURFACEMARKING = { type: 3, value: "PAVEMENTSURFACEMARKING" };
  IfcSurfaceFeatureTypeEnum.RUMBLESTRIP = { type: 3, value: "RUMBLESTRIP" };
  IfcSurfaceFeatureTypeEnum.SYMBOLMARKING = { type: 3, value: "SYMBOLMARKING" };
  IfcSurfaceFeatureTypeEnum.TAG = { type: 3, value: "TAG" };
  IfcSurfaceFeatureTypeEnum.TRANSVERSERUMBLESTRIP = { type: 3, value: "TRANSVERSERUMBLESTRIP" };
  IfcSurfaceFeatureTypeEnum.TREATMENT = { type: 3, value: "TREATMENT" };
  IfcSurfaceFeatureTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSurfaceFeatureTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcSurfaceFeatureTypeEnum = IfcSurfaceFeatureTypeEnum;
  class IfcSurfaceSide {
  }
  IfcSurfaceSide.BOTH = { type: 3, value: "BOTH" };
  IfcSurfaceSide.NEGATIVE = { type: 3, value: "NEGATIVE" };
  IfcSurfaceSide.POSITIVE = { type: 3, value: "POSITIVE" };
  IFC4_32.IfcSurfaceSide = IfcSurfaceSide;
  class IfcSwitchingDeviceTypeEnum {
  }
  IfcSwitchingDeviceTypeEnum.CONTACTOR = { type: 3, value: "CONTACTOR" };
  IfcSwitchingDeviceTypeEnum.DIMMERSWITCH = { type: 3, value: "DIMMERSWITCH" };
  IfcSwitchingDeviceTypeEnum.EMERGENCYSTOP = { type: 3, value: "EMERGENCYSTOP" };
  IfcSwitchingDeviceTypeEnum.KEYPAD = { type: 3, value: "KEYPAD" };
  IfcSwitchingDeviceTypeEnum.MOMENTARYSWITCH = { type: 3, value: "MOMENTARYSWITCH" };
  IfcSwitchingDeviceTypeEnum.RELAY = { type: 3, value: "RELAY" };
  IfcSwitchingDeviceTypeEnum.SELECTORSWITCH = { type: 3, value: "SELECTORSWITCH" };
  IfcSwitchingDeviceTypeEnum.STARTER = { type: 3, value: "STARTER" };
  IfcSwitchingDeviceTypeEnum.START_AND_STOP_EQUIPMENT = { type: 3, value: "START_AND_STOP_EQUIPMENT" };
  IfcSwitchingDeviceTypeEnum.SWITCHDISCONNECTOR = { type: 3, value: "SWITCHDISCONNECTOR" };
  IfcSwitchingDeviceTypeEnum.TOGGLESWITCH = { type: 3, value: "TOGGLESWITCH" };
  IfcSwitchingDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSwitchingDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcSwitchingDeviceTypeEnum = IfcSwitchingDeviceTypeEnum;
  class IfcSystemFurnitureElementTypeEnum {
  }
  IfcSystemFurnitureElementTypeEnum.PANEL = { type: 3, value: "PANEL" };
  IfcSystemFurnitureElementTypeEnum.SUBRACK = { type: 3, value: "SUBRACK" };
  IfcSystemFurnitureElementTypeEnum.WORKSURFACE = { type: 3, value: "WORKSURFACE" };
  IfcSystemFurnitureElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSystemFurnitureElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcSystemFurnitureElementTypeEnum = IfcSystemFurnitureElementTypeEnum;
  class IfcTankTypeEnum {
  }
  IfcTankTypeEnum.BASIN = { type: 3, value: "BASIN" };
  IfcTankTypeEnum.BREAKPRESSURE = { type: 3, value: "BREAKPRESSURE" };
  IfcTankTypeEnum.EXPANSION = { type: 3, value: "EXPANSION" };
  IfcTankTypeEnum.FEEDANDEXPANSION = { type: 3, value: "FEEDANDEXPANSION" };
  IfcTankTypeEnum.OILRETENTIONTRAY = { type: 3, value: "OILRETENTIONTRAY" };
  IfcTankTypeEnum.PRESSUREVESSEL = { type: 3, value: "PRESSUREVESSEL" };
  IfcTankTypeEnum.STORAGE = { type: 3, value: "STORAGE" };
  IfcTankTypeEnum.VESSEL = { type: 3, value: "VESSEL" };
  IfcTankTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTankTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcTankTypeEnum = IfcTankTypeEnum;
  class IfcTaskDurationEnum {
  }
  IfcTaskDurationEnum.ELAPSEDTIME = { type: 3, value: "ELAPSEDTIME" };
  IfcTaskDurationEnum.WORKTIME = { type: 3, value: "WORKTIME" };
  IfcTaskDurationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcTaskDurationEnum = IfcTaskDurationEnum;
  class IfcTaskTypeEnum {
  }
  IfcTaskTypeEnum.ADJUSTMENT = { type: 3, value: "ADJUSTMENT" };
  IfcTaskTypeEnum.ATTENDANCE = { type: 3, value: "ATTENDANCE" };
  IfcTaskTypeEnum.CALIBRATION = { type: 3, value: "CALIBRATION" };
  IfcTaskTypeEnum.CONSTRUCTION = { type: 3, value: "CONSTRUCTION" };
  IfcTaskTypeEnum.DEMOLITION = { type: 3, value: "DEMOLITION" };
  IfcTaskTypeEnum.DISMANTLE = { type: 3, value: "DISMANTLE" };
  IfcTaskTypeEnum.DISPOSAL = { type: 3, value: "DISPOSAL" };
  IfcTaskTypeEnum.EMERGENCY = { type: 3, value: "EMERGENCY" };
  IfcTaskTypeEnum.INSPECTION = { type: 3, value: "INSPECTION" };
  IfcTaskTypeEnum.INSTALLATION = { type: 3, value: "INSTALLATION" };
  IfcTaskTypeEnum.LOGISTIC = { type: 3, value: "LOGISTIC" };
  IfcTaskTypeEnum.MAINTENANCE = { type: 3, value: "MAINTENANCE" };
  IfcTaskTypeEnum.MOVE = { type: 3, value: "MOVE" };
  IfcTaskTypeEnum.OPERATION = { type: 3, value: "OPERATION" };
  IfcTaskTypeEnum.REMOVAL = { type: 3, value: "REMOVAL" };
  IfcTaskTypeEnum.RENOVATION = { type: 3, value: "RENOVATION" };
  IfcTaskTypeEnum.SAFETY = { type: 3, value: "SAFETY" };
  IfcTaskTypeEnum.SHUTDOWN = { type: 3, value: "SHUTDOWN" };
  IfcTaskTypeEnum.STARTUP = { type: 3, value: "STARTUP" };
  IfcTaskTypeEnum.TESTING = { type: 3, value: "TESTING" };
  IfcTaskTypeEnum.TROUBLESHOOTING = { type: 3, value: "TROUBLESHOOTING" };
  IfcTaskTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTaskTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcTaskTypeEnum = IfcTaskTypeEnum;
  class IfcTendonAnchorTypeEnum {
  }
  IfcTendonAnchorTypeEnum.COUPLER = { type: 3, value: "COUPLER" };
  IfcTendonAnchorTypeEnum.FIXED_END = { type: 3, value: "FIXED_END" };
  IfcTendonAnchorTypeEnum.TENSIONING_END = { type: 3, value: "TENSIONING_END" };
  IfcTendonAnchorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTendonAnchorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcTendonAnchorTypeEnum = IfcTendonAnchorTypeEnum;
  class IfcTendonConduitTypeEnum {
  }
  IfcTendonConduitTypeEnum.COUPLER = { type: 3, value: "COUPLER" };
  IfcTendonConduitTypeEnum.DIABOLO = { type: 3, value: "DIABOLO" };
  IfcTendonConduitTypeEnum.DUCT = { type: 3, value: "DUCT" };
  IfcTendonConduitTypeEnum.GROUTING_DUCT = { type: 3, value: "GROUTING_DUCT" };
  IfcTendonConduitTypeEnum.TRUMPET = { type: 3, value: "TRUMPET" };
  IfcTendonConduitTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTendonConduitTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcTendonConduitTypeEnum = IfcTendonConduitTypeEnum;
  class IfcTendonTypeEnum {
  }
  IfcTendonTypeEnum.BAR = { type: 3, value: "BAR" };
  IfcTendonTypeEnum.COATED = { type: 3, value: "COATED" };
  IfcTendonTypeEnum.STRAND = { type: 3, value: "STRAND" };
  IfcTendonTypeEnum.WIRE = { type: 3, value: "WIRE" };
  IfcTendonTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTendonTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcTendonTypeEnum = IfcTendonTypeEnum;
  class IfcTextPath {
  }
  IfcTextPath.DOWN = { type: 3, value: "DOWN" };
  IfcTextPath.LEFT = { type: 3, value: "LEFT" };
  IfcTextPath.RIGHT = { type: 3, value: "RIGHT" };
  IfcTextPath.UP = { type: 3, value: "UP" };
  IFC4_32.IfcTextPath = IfcTextPath;
  class IfcTimeSeriesDataTypeEnum {
  }
  IfcTimeSeriesDataTypeEnum.CONTINUOUS = { type: 3, value: "CONTINUOUS" };
  IfcTimeSeriesDataTypeEnum.DISCRETE = { type: 3, value: "DISCRETE" };
  IfcTimeSeriesDataTypeEnum.DISCRETEBINARY = { type: 3, value: "DISCRETEBINARY" };
  IfcTimeSeriesDataTypeEnum.PIECEWISEBINARY = { type: 3, value: "PIECEWISEBINARY" };
  IfcTimeSeriesDataTypeEnum.PIECEWISECONSTANT = { type: 3, value: "PIECEWISECONSTANT" };
  IfcTimeSeriesDataTypeEnum.PIECEWISECONTINUOUS = { type: 3, value: "PIECEWISECONTINUOUS" };
  IfcTimeSeriesDataTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcTimeSeriesDataTypeEnum = IfcTimeSeriesDataTypeEnum;
  class IfcTrackElementTypeEnum {
  }
  IfcTrackElementTypeEnum.BLOCKINGDEVICE = { type: 3, value: "BLOCKINGDEVICE" };
  IfcTrackElementTypeEnum.DERAILER = { type: 3, value: "DERAILER" };
  IfcTrackElementTypeEnum.FROG = { type: 3, value: "FROG" };
  IfcTrackElementTypeEnum.HALF_SET_OF_BLADES = { type: 3, value: "HALF_SET_OF_BLADES" };
  IfcTrackElementTypeEnum.SLEEPER = { type: 3, value: "SLEEPER" };
  IfcTrackElementTypeEnum.SPEEDREGULATOR = { type: 3, value: "SPEEDREGULATOR" };
  IfcTrackElementTypeEnum.TRACKENDOFALIGNMENT = { type: 3, value: "TRACKENDOFALIGNMENT" };
  IfcTrackElementTypeEnum.VEHICLESTOP = { type: 3, value: "VEHICLESTOP" };
  IfcTrackElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTrackElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcTrackElementTypeEnum = IfcTrackElementTypeEnum;
  class IfcTransformerTypeEnum {
  }
  IfcTransformerTypeEnum.CHOPPER = { type: 3, value: "CHOPPER" };
  IfcTransformerTypeEnum.COMBINED = { type: 3, value: "COMBINED" };
  IfcTransformerTypeEnum.CURRENT = { type: 3, value: "CURRENT" };
  IfcTransformerTypeEnum.FREQUENCY = { type: 3, value: "FREQUENCY" };
  IfcTransformerTypeEnum.INVERTER = { type: 3, value: "INVERTER" };
  IfcTransformerTypeEnum.RECTIFIER = { type: 3, value: "RECTIFIER" };
  IfcTransformerTypeEnum.VOLTAGE = { type: 3, value: "VOLTAGE" };
  IfcTransformerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTransformerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcTransformerTypeEnum = IfcTransformerTypeEnum;
  class IfcTransitionCode {
  }
  IfcTransitionCode.CONTINUOUS = { type: 3, value: "CONTINUOUS" };
  IfcTransitionCode.CONTSAMEGRADIENT = { type: 3, value: "CONTSAMEGRADIENT" };
  IfcTransitionCode.CONTSAMEGRADIENTSAMECURVATURE = { type: 3, value: "CONTSAMEGRADIENTSAMECURVATURE" };
  IfcTransitionCode.DISCONTINUOUS = { type: 3, value: "DISCONTINUOUS" };
  IFC4_32.IfcTransitionCode = IfcTransitionCode;
  class IfcTransportElementTypeEnum {
  }
  IfcTransportElementTypeEnum.CRANEWAY = { type: 3, value: "CRANEWAY" };
  IfcTransportElementTypeEnum.ELEVATOR = { type: 3, value: "ELEVATOR" };
  IfcTransportElementTypeEnum.ESCALATOR = { type: 3, value: "ESCALATOR" };
  IfcTransportElementTypeEnum.HAULINGGEAR = { type: 3, value: "HAULINGGEAR" };
  IfcTransportElementTypeEnum.LIFTINGGEAR = { type: 3, value: "LIFTINGGEAR" };
  IfcTransportElementTypeEnum.MOVINGWALKWAY = { type: 3, value: "MOVINGWALKWAY" };
  IfcTransportElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTransportElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcTransportElementTypeEnum = IfcTransportElementTypeEnum;
  class IfcTrimmingPreference {
  }
  IfcTrimmingPreference.CARTESIAN = { type: 3, value: "CARTESIAN" };
  IfcTrimmingPreference.PARAMETER = { type: 3, value: "PARAMETER" };
  IfcTrimmingPreference.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  IFC4_32.IfcTrimmingPreference = IfcTrimmingPreference;
  class IfcTubeBundleTypeEnum {
  }
  IfcTubeBundleTypeEnum.FINNED = { type: 3, value: "FINNED" };
  IfcTubeBundleTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTubeBundleTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcTubeBundleTypeEnum = IfcTubeBundleTypeEnum;
  class IfcUnitEnum {
  }
  IfcUnitEnum.ABSORBEDDOSEUNIT = { type: 3, value: "ABSORBEDDOSEUNIT" };
  IfcUnitEnum.AMOUNTOFSUBSTANCEUNIT = { type: 3, value: "AMOUNTOFSUBSTANCEUNIT" };
  IfcUnitEnum.AREAUNIT = { type: 3, value: "AREAUNIT" };
  IfcUnitEnum.DOSEEQUIVALENTUNIT = { type: 3, value: "DOSEEQUIVALENTUNIT" };
  IfcUnitEnum.ELECTRICCAPACITANCEUNIT = { type: 3, value: "ELECTRICCAPACITANCEUNIT" };
  IfcUnitEnum.ELECTRICCHARGEUNIT = { type: 3, value: "ELECTRICCHARGEUNIT" };
  IfcUnitEnum.ELECTRICCONDUCTANCEUNIT = { type: 3, value: "ELECTRICCONDUCTANCEUNIT" };
  IfcUnitEnum.ELECTRICCURRENTUNIT = { type: 3, value: "ELECTRICCURRENTUNIT" };
  IfcUnitEnum.ELECTRICRESISTANCEUNIT = { type: 3, value: "ELECTRICRESISTANCEUNIT" };
  IfcUnitEnum.ELECTRICVOLTAGEUNIT = { type: 3, value: "ELECTRICVOLTAGEUNIT" };
  IfcUnitEnum.ENERGYUNIT = { type: 3, value: "ENERGYUNIT" };
  IfcUnitEnum.FORCEUNIT = { type: 3, value: "FORCEUNIT" };
  IfcUnitEnum.FREQUENCYUNIT = { type: 3, value: "FREQUENCYUNIT" };
  IfcUnitEnum.ILLUMINANCEUNIT = { type: 3, value: "ILLUMINANCEUNIT" };
  IfcUnitEnum.INDUCTANCEUNIT = { type: 3, value: "INDUCTANCEUNIT" };
  IfcUnitEnum.LENGTHUNIT = { type: 3, value: "LENGTHUNIT" };
  IfcUnitEnum.LUMINOUSFLUXUNIT = { type: 3, value: "LUMINOUSFLUXUNIT" };
  IfcUnitEnum.LUMINOUSINTENSITYUNIT = { type: 3, value: "LUMINOUSINTENSITYUNIT" };
  IfcUnitEnum.MAGNETICFLUXDENSITYUNIT = { type: 3, value: "MAGNETICFLUXDENSITYUNIT" };
  IfcUnitEnum.MAGNETICFLUXUNIT = { type: 3, value: "MAGNETICFLUXUNIT" };
  IfcUnitEnum.MASSUNIT = { type: 3, value: "MASSUNIT" };
  IfcUnitEnum.PLANEANGLEUNIT = { type: 3, value: "PLANEANGLEUNIT" };
  IfcUnitEnum.POWERUNIT = { type: 3, value: "POWERUNIT" };
  IfcUnitEnum.PRESSUREUNIT = { type: 3, value: "PRESSUREUNIT" };
  IfcUnitEnum.RADIOACTIVITYUNIT = { type: 3, value: "RADIOACTIVITYUNIT" };
  IfcUnitEnum.SOLIDANGLEUNIT = { type: 3, value: "SOLIDANGLEUNIT" };
  IfcUnitEnum.THERMODYNAMICTEMPERATUREUNIT = { type: 3, value: "THERMODYNAMICTEMPERATUREUNIT" };
  IfcUnitEnum.TIMEUNIT = { type: 3, value: "TIMEUNIT" };
  IfcUnitEnum.VOLUMEUNIT = { type: 3, value: "VOLUMEUNIT" };
  IfcUnitEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IFC4_32.IfcUnitEnum = IfcUnitEnum;
  class IfcUnitaryControlElementTypeEnum {
  }
  IfcUnitaryControlElementTypeEnum.ALARMPANEL = { type: 3, value: "ALARMPANEL" };
  IfcUnitaryControlElementTypeEnum.BASESTATIONCONTROLLER = { type: 3, value: "BASESTATIONCONTROLLER" };
  IfcUnitaryControlElementTypeEnum.COMBINED = { type: 3, value: "COMBINED" };
  IfcUnitaryControlElementTypeEnum.CONTROLPANEL = { type: 3, value: "CONTROLPANEL" };
  IfcUnitaryControlElementTypeEnum.GASDETECTIONPANEL = { type: 3, value: "GASDETECTIONPANEL" };
  IfcUnitaryControlElementTypeEnum.HUMIDISTAT = { type: 3, value: "HUMIDISTAT" };
  IfcUnitaryControlElementTypeEnum.INDICATORPANEL = { type: 3, value: "INDICATORPANEL" };
  IfcUnitaryControlElementTypeEnum.MIMICPANEL = { type: 3, value: "MIMICPANEL" };
  IfcUnitaryControlElementTypeEnum.THERMOSTAT = { type: 3, value: "THERMOSTAT" };
  IfcUnitaryControlElementTypeEnum.WEATHERSTATION = { type: 3, value: "WEATHERSTATION" };
  IfcUnitaryControlElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcUnitaryControlElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcUnitaryControlElementTypeEnum = IfcUnitaryControlElementTypeEnum;
  class IfcUnitaryEquipmentTypeEnum {
  }
  IfcUnitaryEquipmentTypeEnum.AIRCONDITIONINGUNIT = { type: 3, value: "AIRCONDITIONINGUNIT" };
  IfcUnitaryEquipmentTypeEnum.AIRHANDLER = { type: 3, value: "AIRHANDLER" };
  IfcUnitaryEquipmentTypeEnum.DEHUMIDIFIER = { type: 3, value: "DEHUMIDIFIER" };
  IfcUnitaryEquipmentTypeEnum.ROOFTOPUNIT = { type: 3, value: "ROOFTOPUNIT" };
  IfcUnitaryEquipmentTypeEnum.SPLITSYSTEM = { type: 3, value: "SPLITSYSTEM" };
  IfcUnitaryEquipmentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcUnitaryEquipmentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcUnitaryEquipmentTypeEnum = IfcUnitaryEquipmentTypeEnum;
  class IfcValveTypeEnum {
  }
  IfcValveTypeEnum.AIRRELEASE = { type: 3, value: "AIRRELEASE" };
  IfcValveTypeEnum.ANTIVACUUM = { type: 3, value: "ANTIVACUUM" };
  IfcValveTypeEnum.CHANGEOVER = { type: 3, value: "CHANGEOVER" };
  IfcValveTypeEnum.CHECK = { type: 3, value: "CHECK" };
  IfcValveTypeEnum.COMMISSIONING = { type: 3, value: "COMMISSIONING" };
  IfcValveTypeEnum.DIVERTING = { type: 3, value: "DIVERTING" };
  IfcValveTypeEnum.DOUBLECHECK = { type: 3, value: "DOUBLECHECK" };
  IfcValveTypeEnum.DOUBLEREGULATING = { type: 3, value: "DOUBLEREGULATING" };
  IfcValveTypeEnum.DRAWOFFCOCK = { type: 3, value: "DRAWOFFCOCK" };
  IfcValveTypeEnum.FAUCET = { type: 3, value: "FAUCET" };
  IfcValveTypeEnum.FLUSHING = { type: 3, value: "FLUSHING" };
  IfcValveTypeEnum.GASCOCK = { type: 3, value: "GASCOCK" };
  IfcValveTypeEnum.GASTAP = { type: 3, value: "GASTAP" };
  IfcValveTypeEnum.ISOLATING = { type: 3, value: "ISOLATING" };
  IfcValveTypeEnum.MIXING = { type: 3, value: "MIXING" };
  IfcValveTypeEnum.PRESSUREREDUCING = { type: 3, value: "PRESSUREREDUCING" };
  IfcValveTypeEnum.PRESSURERELIEF = { type: 3, value: "PRESSURERELIEF" };
  IfcValveTypeEnum.REGULATING = { type: 3, value: "REGULATING" };
  IfcValveTypeEnum.SAFETYCUTOFF = { type: 3, value: "SAFETYCUTOFF" };
  IfcValveTypeEnum.STEAMTRAP = { type: 3, value: "STEAMTRAP" };
  IfcValveTypeEnum.STOPCOCK = { type: 3, value: "STOPCOCK" };
  IfcValveTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcValveTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcValveTypeEnum = IfcValveTypeEnum;
  class IfcVehicleTypeEnum {
  }
  IfcVehicleTypeEnum.CARGO = { type: 3, value: "CARGO" };
  IfcVehicleTypeEnum.ROLLINGSTOCK = { type: 3, value: "ROLLINGSTOCK" };
  IfcVehicleTypeEnum.VEHICLE = { type: 3, value: "VEHICLE" };
  IfcVehicleTypeEnum.VEHICLEAIR = { type: 3, value: "VEHICLEAIR" };
  IfcVehicleTypeEnum.VEHICLEMARINE = { type: 3, value: "VEHICLEMARINE" };
  IfcVehicleTypeEnum.VEHICLETRACKED = { type: 3, value: "VEHICLETRACKED" };
  IfcVehicleTypeEnum.VEHICLEWHEELED = { type: 3, value: "VEHICLEWHEELED" };
  IfcVehicleTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcVehicleTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcVehicleTypeEnum = IfcVehicleTypeEnum;
  class IfcVibrationDamperTypeEnum {
  }
  IfcVibrationDamperTypeEnum.AXIAL_YIELD = { type: 3, value: "AXIAL_YIELD" };
  IfcVibrationDamperTypeEnum.BENDING_YIELD = { type: 3, value: "BENDING_YIELD" };
  IfcVibrationDamperTypeEnum.FRICTION = { type: 3, value: "FRICTION" };
  IfcVibrationDamperTypeEnum.RUBBER = { type: 3, value: "RUBBER" };
  IfcVibrationDamperTypeEnum.SHEAR_YIELD = { type: 3, value: "SHEAR_YIELD" };
  IfcVibrationDamperTypeEnum.VISCOUS = { type: 3, value: "VISCOUS" };
  IfcVibrationDamperTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcVibrationDamperTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcVibrationDamperTypeEnum = IfcVibrationDamperTypeEnum;
  class IfcVibrationIsolatorTypeEnum {
  }
  IfcVibrationIsolatorTypeEnum.BASE = { type: 3, value: "BASE" };
  IfcVibrationIsolatorTypeEnum.COMPRESSION = { type: 3, value: "COMPRESSION" };
  IfcVibrationIsolatorTypeEnum.SPRING = { type: 3, value: "SPRING" };
  IfcVibrationIsolatorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcVibrationIsolatorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcVibrationIsolatorTypeEnum = IfcVibrationIsolatorTypeEnum;
  class IfcVirtualElementTypeEnum {
  }
  IfcVirtualElementTypeEnum.BOUNDARY = { type: 3, value: "BOUNDARY" };
  IfcVirtualElementTypeEnum.CLEARANCE = { type: 3, value: "CLEARANCE" };
  IfcVirtualElementTypeEnum.PROVISIONFORVOID = { type: 3, value: "PROVISIONFORVOID" };
  IfcVirtualElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcVirtualElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcVirtualElementTypeEnum = IfcVirtualElementTypeEnum;
  class IfcVoidingFeatureTypeEnum {
  }
  IfcVoidingFeatureTypeEnum.CHAMFER = { type: 3, value: "CHAMFER" };
  IfcVoidingFeatureTypeEnum.CUTOUT = { type: 3, value: "CUTOUT" };
  IfcVoidingFeatureTypeEnum.EDGE = { type: 3, value: "EDGE" };
  IfcVoidingFeatureTypeEnum.HOLE = { type: 3, value: "HOLE" };
  IfcVoidingFeatureTypeEnum.MITER = { type: 3, value: "MITER" };
  IfcVoidingFeatureTypeEnum.NOTCH = { type: 3, value: "NOTCH" };
  IfcVoidingFeatureTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcVoidingFeatureTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcVoidingFeatureTypeEnum = IfcVoidingFeatureTypeEnum;
  class IfcWallTypeEnum {
  }
  IfcWallTypeEnum.ELEMENTEDWALL = { type: 3, value: "ELEMENTEDWALL" };
  IfcWallTypeEnum.MOVABLE = { type: 3, value: "MOVABLE" };
  IfcWallTypeEnum.PARAPET = { type: 3, value: "PARAPET" };
  IfcWallTypeEnum.PARTITIONING = { type: 3, value: "PARTITIONING" };
  IfcWallTypeEnum.PLUMBINGWALL = { type: 3, value: "PLUMBINGWALL" };
  IfcWallTypeEnum.POLYGONAL = { type: 3, value: "POLYGONAL" };
  IfcWallTypeEnum.RETAININGWALL = { type: 3, value: "RETAININGWALL" };
  IfcWallTypeEnum.SHEAR = { type: 3, value: "SHEAR" };
  IfcWallTypeEnum.SOLIDWALL = { type: 3, value: "SOLIDWALL" };
  IfcWallTypeEnum.STANDARD = { type: 3, value: "STANDARD" };
  IfcWallTypeEnum.WAVEWALL = { type: 3, value: "WAVEWALL" };
  IfcWallTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWallTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcWallTypeEnum = IfcWallTypeEnum;
  class IfcWasteTerminalTypeEnum {
  }
  IfcWasteTerminalTypeEnum.FLOORTRAP = { type: 3, value: "FLOORTRAP" };
  IfcWasteTerminalTypeEnum.FLOORWASTE = { type: 3, value: "FLOORWASTE" };
  IfcWasteTerminalTypeEnum.GULLYSUMP = { type: 3, value: "GULLYSUMP" };
  IfcWasteTerminalTypeEnum.GULLYTRAP = { type: 3, value: "GULLYTRAP" };
  IfcWasteTerminalTypeEnum.ROOFDRAIN = { type: 3, value: "ROOFDRAIN" };
  IfcWasteTerminalTypeEnum.WASTEDISPOSALUNIT = { type: 3, value: "WASTEDISPOSALUNIT" };
  IfcWasteTerminalTypeEnum.WASTETRAP = { type: 3, value: "WASTETRAP" };
  IfcWasteTerminalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWasteTerminalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcWasteTerminalTypeEnum = IfcWasteTerminalTypeEnum;
  class IfcWindowPanelOperationEnum {
  }
  IfcWindowPanelOperationEnum.BOTTOMHUNG = { type: 3, value: "BOTTOMHUNG" };
  IfcWindowPanelOperationEnum.FIXEDCASEMENT = { type: 3, value: "FIXEDCASEMENT" };
  IfcWindowPanelOperationEnum.OTHEROPERATION = { type: 3, value: "OTHEROPERATION" };
  IfcWindowPanelOperationEnum.PIVOTHORIZONTAL = { type: 3, value: "PIVOTHORIZONTAL" };
  IfcWindowPanelOperationEnum.PIVOTVERTICAL = { type: 3, value: "PIVOTVERTICAL" };
  IfcWindowPanelOperationEnum.REMOVABLECASEMENT = { type: 3, value: "REMOVABLECASEMENT" };
  IfcWindowPanelOperationEnum.SIDEHUNGLEFTHAND = { type: 3, value: "SIDEHUNGLEFTHAND" };
  IfcWindowPanelOperationEnum.SIDEHUNGRIGHTHAND = { type: 3, value: "SIDEHUNGRIGHTHAND" };
  IfcWindowPanelOperationEnum.SLIDINGHORIZONTAL = { type: 3, value: "SLIDINGHORIZONTAL" };
  IfcWindowPanelOperationEnum.SLIDINGVERTICAL = { type: 3, value: "SLIDINGVERTICAL" };
  IfcWindowPanelOperationEnum.TILTANDTURNLEFTHAND = { type: 3, value: "TILTANDTURNLEFTHAND" };
  IfcWindowPanelOperationEnum.TILTANDTURNRIGHTHAND = { type: 3, value: "TILTANDTURNRIGHTHAND" };
  IfcWindowPanelOperationEnum.TOPHUNG = { type: 3, value: "TOPHUNG" };
  IfcWindowPanelOperationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcWindowPanelOperationEnum = IfcWindowPanelOperationEnum;
  class IfcWindowPanelPositionEnum {
  }
  IfcWindowPanelPositionEnum.BOTTOM = { type: 3, value: "BOTTOM" };
  IfcWindowPanelPositionEnum.LEFT = { type: 3, value: "LEFT" };
  IfcWindowPanelPositionEnum.MIDDLE = { type: 3, value: "MIDDLE" };
  IfcWindowPanelPositionEnum.RIGHT = { type: 3, value: "RIGHT" };
  IfcWindowPanelPositionEnum.TOP = { type: 3, value: "TOP" };
  IfcWindowPanelPositionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcWindowPanelPositionEnum = IfcWindowPanelPositionEnum;
  class IfcWindowStyleConstructionEnum {
  }
  IfcWindowStyleConstructionEnum.ALUMINIUM = { type: 3, value: "ALUMINIUM" };
  IfcWindowStyleConstructionEnum.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" };
  IfcWindowStyleConstructionEnum.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" };
  IfcWindowStyleConstructionEnum.OTHER_CONSTRUCTION = { type: 3, value: "OTHER_CONSTRUCTION" };
  IfcWindowStyleConstructionEnum.PLASTIC = { type: 3, value: "PLASTIC" };
  IfcWindowStyleConstructionEnum.STEEL = { type: 3, value: "STEEL" };
  IfcWindowStyleConstructionEnum.WOOD = { type: 3, value: "WOOD" };
  IfcWindowStyleConstructionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcWindowStyleConstructionEnum = IfcWindowStyleConstructionEnum;
  class IfcWindowStyleOperationEnum {
  }
  IfcWindowStyleOperationEnum.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" };
  IfcWindowStyleOperationEnum.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" };
  IfcWindowStyleOperationEnum.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" };
  IfcWindowStyleOperationEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWindowStyleOperationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcWindowStyleOperationEnum = IfcWindowStyleOperationEnum;
  class IfcWindowTypeEnum {
  }
  IfcWindowTypeEnum.LIGHTDOME = { type: 3, value: "LIGHTDOME" };
  IfcWindowTypeEnum.SKYLIGHT = { type: 3, value: "SKYLIGHT" };
  IfcWindowTypeEnum.WINDOW = { type: 3, value: "WINDOW" };
  IfcWindowTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWindowTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcWindowTypeEnum = IfcWindowTypeEnum;
  class IfcWindowTypePartitioningEnum {
  }
  IfcWindowTypePartitioningEnum.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" };
  IfcWindowTypePartitioningEnum.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" };
  IfcWindowTypePartitioningEnum.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" };
  IfcWindowTypePartitioningEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWindowTypePartitioningEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcWindowTypePartitioningEnum = IfcWindowTypePartitioningEnum;
  class IfcWorkCalendarTypeEnum {
  }
  IfcWorkCalendarTypeEnum.FIRSTSHIFT = { type: 3, value: "FIRSTSHIFT" };
  IfcWorkCalendarTypeEnum.SECONDSHIFT = { type: 3, value: "SECONDSHIFT" };
  IfcWorkCalendarTypeEnum.THIRDSHIFT = { type: 3, value: "THIRDSHIFT" };
  IfcWorkCalendarTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWorkCalendarTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcWorkCalendarTypeEnum = IfcWorkCalendarTypeEnum;
  class IfcWorkPlanTypeEnum {
  }
  IfcWorkPlanTypeEnum.ACTUAL = { type: 3, value: "ACTUAL" };
  IfcWorkPlanTypeEnum.BASELINE = { type: 3, value: "BASELINE" };
  IfcWorkPlanTypeEnum.PLANNED = { type: 3, value: "PLANNED" };
  IfcWorkPlanTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWorkPlanTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcWorkPlanTypeEnum = IfcWorkPlanTypeEnum;
  class IfcWorkScheduleTypeEnum {
  }
  IfcWorkScheduleTypeEnum.ACTUAL = { type: 3, value: "ACTUAL" };
  IfcWorkScheduleTypeEnum.BASELINE = { type: 3, value: "BASELINE" };
  IfcWorkScheduleTypeEnum.PLANNED = { type: 3, value: "PLANNED" };
  IfcWorkScheduleTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWorkScheduleTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC4_32.IfcWorkScheduleTypeEnum = IfcWorkScheduleTypeEnum;
  class IfcActorRole extends IfcLineObject {
    constructor(expressID, Role, UserDefinedRole, Description) {
      super(expressID);
      this.Role = Role;
      this.UserDefinedRole = UserDefinedRole;
      this.Description = Description;
      this.type = 3630933823;
    }
  }
  IFC4_32.IfcActorRole = IfcActorRole;
  class IfcAddress extends IfcLineObject {
    constructor(expressID, Purpose, Description, UserDefinedPurpose) {
      super(expressID);
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.type = 618182010;
    }
  }
  IFC4_32.IfcAddress = IfcAddress;
  class IfcAlignmentParameterSegment extends IfcLineObject {
    constructor(expressID, StartTag, EndTag) {
      super(expressID);
      this.StartTag = StartTag;
      this.EndTag = EndTag;
      this.type = 2879124712;
    }
  }
  IFC4_32.IfcAlignmentParameterSegment = IfcAlignmentParameterSegment;
  class IfcAlignmentVerticalSegment extends IfcAlignmentParameterSegment {
    constructor(expressID, StartTag, EndTag, StartDistAlong, HorizontalLength, StartHeight, StartGradient, EndGradient, RadiusOfCurvature, PredefinedType) {
      super(expressID, StartTag, EndTag);
      this.StartTag = StartTag;
      this.EndTag = EndTag;
      this.StartDistAlong = StartDistAlong;
      this.HorizontalLength = HorizontalLength;
      this.StartHeight = StartHeight;
      this.StartGradient = StartGradient;
      this.EndGradient = EndGradient;
      this.RadiusOfCurvature = RadiusOfCurvature;
      this.PredefinedType = PredefinedType;
      this.type = 3633395639;
    }
  }
  IFC4_32.IfcAlignmentVerticalSegment = IfcAlignmentVerticalSegment;
  class IfcApplication extends IfcLineObject {
    constructor(expressID, ApplicationDeveloper, Version, ApplicationFullName, ApplicationIdentifier) {
      super(expressID);
      this.ApplicationDeveloper = ApplicationDeveloper;
      this.Version = Version;
      this.ApplicationFullName = ApplicationFullName;
      this.ApplicationIdentifier = ApplicationIdentifier;
      this.type = 639542469;
    }
  }
  IFC4_32.IfcApplication = IfcApplication;
  class IfcAppliedValue extends IfcLineObject {
    constructor(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.AppliedValue = AppliedValue;
      this.UnitBasis = UnitBasis;
      this.ApplicableDate = ApplicableDate;
      this.FixedUntilDate = FixedUntilDate;
      this.Category = Category;
      this.Condition = Condition;
      this.ArithmeticOperator = ArithmeticOperator;
      this.Components = Components;
      this.type = 411424972;
    }
  }
  IFC4_32.IfcAppliedValue = IfcAppliedValue;
  class IfcApproval extends IfcLineObject {
    constructor(expressID, Identifier, Name, Description, TimeOfApproval, Status, Level, Qualifier, RequestingApproval, GivingApproval) {
      super(expressID);
      this.Identifier = Identifier;
      this.Name = Name;
      this.Description = Description;
      this.TimeOfApproval = TimeOfApproval;
      this.Status = Status;
      this.Level = Level;
      this.Qualifier = Qualifier;
      this.RequestingApproval = RequestingApproval;
      this.GivingApproval = GivingApproval;
      this.type = 130549933;
    }
  }
  IFC4_32.IfcApproval = IfcApproval;
  class IfcBoundaryCondition extends IfcLineObject {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 4037036970;
    }
  }
  IFC4_32.IfcBoundaryCondition = IfcBoundaryCondition;
  class IfcBoundaryEdgeCondition extends IfcBoundaryCondition {
    constructor(expressID, Name, TranslationalStiffnessByLengthX, TranslationalStiffnessByLengthY, TranslationalStiffnessByLengthZ, RotationalStiffnessByLengthX, RotationalStiffnessByLengthY, RotationalStiffnessByLengthZ) {
      super(expressID, Name);
      this.Name = Name;
      this.TranslationalStiffnessByLengthX = TranslationalStiffnessByLengthX;
      this.TranslationalStiffnessByLengthY = TranslationalStiffnessByLengthY;
      this.TranslationalStiffnessByLengthZ = TranslationalStiffnessByLengthZ;
      this.RotationalStiffnessByLengthX = RotationalStiffnessByLengthX;
      this.RotationalStiffnessByLengthY = RotationalStiffnessByLengthY;
      this.RotationalStiffnessByLengthZ = RotationalStiffnessByLengthZ;
      this.type = 1560379544;
    }
  }
  IFC4_32.IfcBoundaryEdgeCondition = IfcBoundaryEdgeCondition;
  class IfcBoundaryFaceCondition extends IfcBoundaryCondition {
    constructor(expressID, Name, TranslationalStiffnessByAreaX, TranslationalStiffnessByAreaY, TranslationalStiffnessByAreaZ) {
      super(expressID, Name);
      this.Name = Name;
      this.TranslationalStiffnessByAreaX = TranslationalStiffnessByAreaX;
      this.TranslationalStiffnessByAreaY = TranslationalStiffnessByAreaY;
      this.TranslationalStiffnessByAreaZ = TranslationalStiffnessByAreaZ;
      this.type = 3367102660;
    }
  }
  IFC4_32.IfcBoundaryFaceCondition = IfcBoundaryFaceCondition;
  class IfcBoundaryNodeCondition extends IfcBoundaryCondition {
    constructor(expressID, Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ) {
      super(expressID, Name);
      this.Name = Name;
      this.TranslationalStiffnessX = TranslationalStiffnessX;
      this.TranslationalStiffnessY = TranslationalStiffnessY;
      this.TranslationalStiffnessZ = TranslationalStiffnessZ;
      this.RotationalStiffnessX = RotationalStiffnessX;
      this.RotationalStiffnessY = RotationalStiffnessY;
      this.RotationalStiffnessZ = RotationalStiffnessZ;
      this.type = 1387855156;
    }
  }
  IFC4_32.IfcBoundaryNodeCondition = IfcBoundaryNodeCondition;
  class IfcBoundaryNodeConditionWarping extends IfcBoundaryNodeCondition {
    constructor(expressID, Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ, WarpingStiffness) {
      super(expressID, Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ);
      this.Name = Name;
      this.TranslationalStiffnessX = TranslationalStiffnessX;
      this.TranslationalStiffnessY = TranslationalStiffnessY;
      this.TranslationalStiffnessZ = TranslationalStiffnessZ;
      this.RotationalStiffnessX = RotationalStiffnessX;
      this.RotationalStiffnessY = RotationalStiffnessY;
      this.RotationalStiffnessZ = RotationalStiffnessZ;
      this.WarpingStiffness = WarpingStiffness;
      this.type = 2069777674;
    }
  }
  IFC4_32.IfcBoundaryNodeConditionWarping = IfcBoundaryNodeConditionWarping;
  class IfcConnectionGeometry extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 2859738748;
    }
  }
  IFC4_32.IfcConnectionGeometry = IfcConnectionGeometry;
  class IfcConnectionPointGeometry extends IfcConnectionGeometry {
    constructor(expressID, PointOnRelatingElement, PointOnRelatedElement) {
      super(expressID);
      this.PointOnRelatingElement = PointOnRelatingElement;
      this.PointOnRelatedElement = PointOnRelatedElement;
      this.type = 2614616156;
    }
  }
  IFC4_32.IfcConnectionPointGeometry = IfcConnectionPointGeometry;
  class IfcConnectionSurfaceGeometry extends IfcConnectionGeometry {
    constructor(expressID, SurfaceOnRelatingElement, SurfaceOnRelatedElement) {
      super(expressID);
      this.SurfaceOnRelatingElement = SurfaceOnRelatingElement;
      this.SurfaceOnRelatedElement = SurfaceOnRelatedElement;
      this.type = 2732653382;
    }
  }
  IFC4_32.IfcConnectionSurfaceGeometry = IfcConnectionSurfaceGeometry;
  class IfcConnectionVolumeGeometry extends IfcConnectionGeometry {
    constructor(expressID, VolumeOnRelatingElement, VolumeOnRelatedElement) {
      super(expressID);
      this.VolumeOnRelatingElement = VolumeOnRelatingElement;
      this.VolumeOnRelatedElement = VolumeOnRelatedElement;
      this.type = 775493141;
    }
  }
  IFC4_32.IfcConnectionVolumeGeometry = IfcConnectionVolumeGeometry;
  class IfcConstraint extends IfcLineObject {
    constructor(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.type = 1959218052;
    }
  }
  IFC4_32.IfcConstraint = IfcConstraint;
  class IfcCoordinateOperation extends IfcLineObject {
    constructor(expressID, SourceCRS, TargetCRS) {
      super(expressID);
      this.SourceCRS = SourceCRS;
      this.TargetCRS = TargetCRS;
      this.type = 1785450214;
    }
  }
  IFC4_32.IfcCoordinateOperation = IfcCoordinateOperation;
  class IfcCoordinateReferenceSystem extends IfcLineObject {
    constructor(expressID, Name, Description, GeodeticDatum, VerticalDatum) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.GeodeticDatum = GeodeticDatum;
      this.VerticalDatum = VerticalDatum;
      this.type = 1466758467;
    }
  }
  IFC4_32.IfcCoordinateReferenceSystem = IfcCoordinateReferenceSystem;
  class IfcCostValue extends IfcAppliedValue {
    constructor(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components) {
      super(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components);
      this.Name = Name;
      this.Description = Description;
      this.AppliedValue = AppliedValue;
      this.UnitBasis = UnitBasis;
      this.ApplicableDate = ApplicableDate;
      this.FixedUntilDate = FixedUntilDate;
      this.Category = Category;
      this.Condition = Condition;
      this.ArithmeticOperator = ArithmeticOperator;
      this.Components = Components;
      this.type = 602808272;
    }
  }
  IFC4_32.IfcCostValue = IfcCostValue;
  class IfcDerivedUnit extends IfcLineObject {
    constructor(expressID, Elements, UnitType, UserDefinedType, Name) {
      super(expressID);
      this.Elements = Elements;
      this.UnitType = UnitType;
      this.UserDefinedType = UserDefinedType;
      this.Name = Name;
      this.type = 1765591967;
    }
  }
  IFC4_32.IfcDerivedUnit = IfcDerivedUnit;
  class IfcDerivedUnitElement extends IfcLineObject {
    constructor(expressID, Unit, Exponent) {
      super(expressID);
      this.Unit = Unit;
      this.Exponent = Exponent;
      this.type = 1045800335;
    }
  }
  IFC4_32.IfcDerivedUnitElement = IfcDerivedUnitElement;
  class IfcDimensionalExponents extends IfcLineObject {
    constructor(expressID, LengthExponent, MassExponent, TimeExponent, ElectricCurrentExponent, ThermodynamicTemperatureExponent, AmountOfSubstanceExponent, LuminousIntensityExponent) {
      super(expressID);
      this.LengthExponent = LengthExponent;
      this.MassExponent = MassExponent;
      this.TimeExponent = TimeExponent;
      this.ElectricCurrentExponent = ElectricCurrentExponent;
      this.ThermodynamicTemperatureExponent = ThermodynamicTemperatureExponent;
      this.AmountOfSubstanceExponent = AmountOfSubstanceExponent;
      this.LuminousIntensityExponent = LuminousIntensityExponent;
      this.type = 2949456006;
    }
  }
  IFC4_32.IfcDimensionalExponents = IfcDimensionalExponents;
  class IfcExternalInformation extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 4294318154;
    }
  }
  IFC4_32.IfcExternalInformation = IfcExternalInformation;
  class IfcExternalReference extends IfcLineObject {
    constructor(expressID, Location, Identification, Name) {
      super(expressID);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.type = 3200245327;
    }
  }
  IFC4_32.IfcExternalReference = IfcExternalReference;
  class IfcExternallyDefinedHatchStyle extends IfcExternalReference {
    constructor(expressID, Location, Identification, Name) {
      super(expressID, Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.type = 2242383968;
    }
  }
  IFC4_32.IfcExternallyDefinedHatchStyle = IfcExternallyDefinedHatchStyle;
  class IfcExternallyDefinedSurfaceStyle extends IfcExternalReference {
    constructor(expressID, Location, Identification, Name) {
      super(expressID, Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.type = 1040185647;
    }
  }
  IFC4_32.IfcExternallyDefinedSurfaceStyle = IfcExternallyDefinedSurfaceStyle;
  class IfcExternallyDefinedTextFont extends IfcExternalReference {
    constructor(expressID, Location, Identification, Name) {
      super(expressID, Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.type = 3548104201;
    }
  }
  IFC4_32.IfcExternallyDefinedTextFont = IfcExternallyDefinedTextFont;
  class IfcGridAxis extends IfcLineObject {
    constructor(expressID, AxisTag, AxisCurve, SameSense) {
      super(expressID);
      this.AxisTag = AxisTag;
      this.AxisCurve = AxisCurve;
      this.SameSense = SameSense;
      this.type = 852622518;
    }
  }
  IFC4_32.IfcGridAxis = IfcGridAxis;
  class IfcIrregularTimeSeriesValue extends IfcLineObject {
    constructor(expressID, TimeStamp, ListValues) {
      super(expressID);
      this.TimeStamp = TimeStamp;
      this.ListValues = ListValues;
      this.type = 3020489413;
    }
  }
  IFC4_32.IfcIrregularTimeSeriesValue = IfcIrregularTimeSeriesValue;
  class IfcLibraryInformation extends IfcExternalInformation {
    constructor(expressID, Name, Version, Publisher, VersionDate, Location, Description) {
      super(expressID);
      this.Name = Name;
      this.Version = Version;
      this.Publisher = Publisher;
      this.VersionDate = VersionDate;
      this.Location = Location;
      this.Description = Description;
      this.type = 2655187982;
    }
  }
  IFC4_32.IfcLibraryInformation = IfcLibraryInformation;
  class IfcLibraryReference extends IfcExternalReference {
    constructor(expressID, Location, Identification, Name, Description, Language, ReferencedLibrary) {
      super(expressID, Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.Description = Description;
      this.Language = Language;
      this.ReferencedLibrary = ReferencedLibrary;
      this.type = 3452421091;
    }
  }
  IFC4_32.IfcLibraryReference = IfcLibraryReference;
  class IfcLightDistributionData extends IfcLineObject {
    constructor(expressID, MainPlaneAngle, SecondaryPlaneAngle, LuminousIntensity) {
      super(expressID);
      this.MainPlaneAngle = MainPlaneAngle;
      this.SecondaryPlaneAngle = SecondaryPlaneAngle;
      this.LuminousIntensity = LuminousIntensity;
      this.type = 4162380809;
    }
  }
  IFC4_32.IfcLightDistributionData = IfcLightDistributionData;
  class IfcLightIntensityDistribution extends IfcLineObject {
    constructor(expressID, LightDistributionCurve, DistributionData) {
      super(expressID);
      this.LightDistributionCurve = LightDistributionCurve;
      this.DistributionData = DistributionData;
      this.type = 1566485204;
    }
  }
  IFC4_32.IfcLightIntensityDistribution = IfcLightIntensityDistribution;
  class IfcMapConversion extends IfcCoordinateOperation {
    constructor(expressID, SourceCRS, TargetCRS, Eastings, Northings, OrthogonalHeight, XAxisAbscissa, XAxisOrdinate, Scale, ScaleY, ScaleZ) {
      super(expressID, SourceCRS, TargetCRS);
      this.SourceCRS = SourceCRS;
      this.TargetCRS = TargetCRS;
      this.Eastings = Eastings;
      this.Northings = Northings;
      this.OrthogonalHeight = OrthogonalHeight;
      this.XAxisAbscissa = XAxisAbscissa;
      this.XAxisOrdinate = XAxisOrdinate;
      this.Scale = Scale;
      this.ScaleY = ScaleY;
      this.ScaleZ = ScaleZ;
      this.type = 3057273783;
    }
  }
  IFC4_32.IfcMapConversion = IfcMapConversion;
  class IfcMaterialClassificationRelationship extends IfcLineObject {
    constructor(expressID, MaterialClassifications, ClassifiedMaterial) {
      super(expressID);
      this.MaterialClassifications = MaterialClassifications;
      this.ClassifiedMaterial = ClassifiedMaterial;
      this.type = 1847130766;
    }
  }
  IFC4_32.IfcMaterialClassificationRelationship = IfcMaterialClassificationRelationship;
  class IfcMaterialDefinition extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 760658860;
    }
  }
  IFC4_32.IfcMaterialDefinition = IfcMaterialDefinition;
  class IfcMaterialLayer extends IfcMaterialDefinition {
    constructor(expressID, Material, LayerThickness, IsVentilated, Name, Description, Category, Priority) {
      super(expressID);
      this.Material = Material;
      this.LayerThickness = LayerThickness;
      this.IsVentilated = IsVentilated;
      this.Name = Name;
      this.Description = Description;
      this.Category = Category;
      this.Priority = Priority;
      this.type = 248100487;
    }
  }
  IFC4_32.IfcMaterialLayer = IfcMaterialLayer;
  class IfcMaterialLayerSet extends IfcMaterialDefinition {
    constructor(expressID, MaterialLayers, LayerSetName, Description) {
      super(expressID);
      this.MaterialLayers = MaterialLayers;
      this.LayerSetName = LayerSetName;
      this.Description = Description;
      this.type = 3303938423;
    }
  }
  IFC4_32.IfcMaterialLayerSet = IfcMaterialLayerSet;
  class IfcMaterialLayerWithOffsets extends IfcMaterialLayer {
    constructor(expressID, Material, LayerThickness, IsVentilated, Name, Description, Category, Priority, OffsetDirection, OffsetValues) {
      super(expressID, Material, LayerThickness, IsVentilated, Name, Description, Category, Priority);
      this.Material = Material;
      this.LayerThickness = LayerThickness;
      this.IsVentilated = IsVentilated;
      this.Name = Name;
      this.Description = Description;
      this.Category = Category;
      this.Priority = Priority;
      this.OffsetDirection = OffsetDirection;
      this.OffsetValues = OffsetValues;
      this.type = 1847252529;
    }
  }
  IFC4_32.IfcMaterialLayerWithOffsets = IfcMaterialLayerWithOffsets;
  class IfcMaterialList extends IfcLineObject {
    constructor(expressID, Materials) {
      super(expressID);
      this.Materials = Materials;
      this.type = 2199411900;
    }
  }
  IFC4_32.IfcMaterialList = IfcMaterialList;
  class IfcMaterialProfile extends IfcMaterialDefinition {
    constructor(expressID, Name, Description, Material, Profile, Priority, Category) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.Material = Material;
      this.Profile = Profile;
      this.Priority = Priority;
      this.Category = Category;
      this.type = 2235152071;
    }
  }
  IFC4_32.IfcMaterialProfile = IfcMaterialProfile;
  class IfcMaterialProfileSet extends IfcMaterialDefinition {
    constructor(expressID, Name, Description, MaterialProfiles, CompositeProfile) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.MaterialProfiles = MaterialProfiles;
      this.CompositeProfile = CompositeProfile;
      this.type = 164193824;
    }
  }
  IFC4_32.IfcMaterialProfileSet = IfcMaterialProfileSet;
  class IfcMaterialProfileWithOffsets extends IfcMaterialProfile {
    constructor(expressID, Name, Description, Material, Profile, Priority, Category, OffsetValues) {
      super(expressID, Name, Description, Material, Profile, Priority, Category);
      this.Name = Name;
      this.Description = Description;
      this.Material = Material;
      this.Profile = Profile;
      this.Priority = Priority;
      this.Category = Category;
      this.OffsetValues = OffsetValues;
      this.type = 552965576;
    }
  }
  IFC4_32.IfcMaterialProfileWithOffsets = IfcMaterialProfileWithOffsets;
  class IfcMaterialUsageDefinition extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 1507914824;
    }
  }
  IFC4_32.IfcMaterialUsageDefinition = IfcMaterialUsageDefinition;
  class IfcMeasureWithUnit extends IfcLineObject {
    constructor(expressID, ValueComponent, UnitComponent) {
      super(expressID);
      this.ValueComponent = ValueComponent;
      this.UnitComponent = UnitComponent;
      this.type = 2597039031;
    }
  }
  IFC4_32.IfcMeasureWithUnit = IfcMeasureWithUnit;
  class IfcMetric extends IfcConstraint {
    constructor(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, Benchmark, ValueSource, DataValue, ReferencePath) {
      super(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.Benchmark = Benchmark;
      this.ValueSource = ValueSource;
      this.DataValue = DataValue;
      this.ReferencePath = ReferencePath;
      this.type = 3368373690;
    }
  }
  IFC4_32.IfcMetric = IfcMetric;
  class IfcMonetaryUnit extends IfcLineObject {
    constructor(expressID, Currency) {
      super(expressID);
      this.Currency = Currency;
      this.type = 2706619895;
    }
  }
  IFC4_32.IfcMonetaryUnit = IfcMonetaryUnit;
  class IfcNamedUnit extends IfcLineObject {
    constructor(expressID, Dimensions, UnitType) {
      super(expressID);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.type = 1918398963;
    }
  }
  IFC4_32.IfcNamedUnit = IfcNamedUnit;
  class IfcObjectPlacement extends IfcLineObject {
    constructor(expressID, PlacementRelTo) {
      super(expressID);
      this.PlacementRelTo = PlacementRelTo;
      this.type = 3701648758;
    }
  }
  IFC4_32.IfcObjectPlacement = IfcObjectPlacement;
  class IfcObjective extends IfcConstraint {
    constructor(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, BenchmarkValues, LogicalAggregator, ObjectiveQualifier, UserDefinedQualifier) {
      super(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.BenchmarkValues = BenchmarkValues;
      this.LogicalAggregator = LogicalAggregator;
      this.ObjectiveQualifier = ObjectiveQualifier;
      this.UserDefinedQualifier = UserDefinedQualifier;
      this.type = 2251480897;
    }
  }
  IFC4_32.IfcObjective = IfcObjective;
  class IfcOrganization extends IfcLineObject {
    constructor(expressID, Identification, Name, Description, Roles, Addresses) {
      super(expressID);
      this.Identification = Identification;
      this.Name = Name;
      this.Description = Description;
      this.Roles = Roles;
      this.Addresses = Addresses;
      this.type = 4251960020;
    }
  }
  IFC4_32.IfcOrganization = IfcOrganization;
  class IfcOwnerHistory extends IfcLineObject {
    constructor(expressID, OwningUser, OwningApplication, State, ChangeAction, LastModifiedDate, LastModifyingUser, LastModifyingApplication, CreationDate) {
      super(expressID);
      this.OwningUser = OwningUser;
      this.OwningApplication = OwningApplication;
      this.State = State;
      this.ChangeAction = ChangeAction;
      this.LastModifiedDate = LastModifiedDate;
      this.LastModifyingUser = LastModifyingUser;
      this.LastModifyingApplication = LastModifyingApplication;
      this.CreationDate = CreationDate;
      this.type = 1207048766;
    }
  }
  IFC4_32.IfcOwnerHistory = IfcOwnerHistory;
  class IfcPerson extends IfcLineObject {
    constructor(expressID, Identification, FamilyName, GivenName, MiddleNames, PrefixTitles, SuffixTitles, Roles, Addresses) {
      super(expressID);
      this.Identification = Identification;
      this.FamilyName = FamilyName;
      this.GivenName = GivenName;
      this.MiddleNames = MiddleNames;
      this.PrefixTitles = PrefixTitles;
      this.SuffixTitles = SuffixTitles;
      this.Roles = Roles;
      this.Addresses = Addresses;
      this.type = 2077209135;
    }
  }
  IFC4_32.IfcPerson = IfcPerson;
  class IfcPersonAndOrganization extends IfcLineObject {
    constructor(expressID, ThePerson, TheOrganization, Roles) {
      super(expressID);
      this.ThePerson = ThePerson;
      this.TheOrganization = TheOrganization;
      this.Roles = Roles;
      this.type = 101040310;
    }
  }
  IFC4_32.IfcPersonAndOrganization = IfcPersonAndOrganization;
  class IfcPhysicalQuantity extends IfcLineObject {
    constructor(expressID, Name, Description) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.type = 2483315170;
    }
  }
  IFC4_32.IfcPhysicalQuantity = IfcPhysicalQuantity;
  class IfcPhysicalSimpleQuantity extends IfcPhysicalQuantity {
    constructor(expressID, Name, Description, Unit) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.type = 2226359599;
    }
  }
  IFC4_32.IfcPhysicalSimpleQuantity = IfcPhysicalSimpleQuantity;
  class IfcPostalAddress extends IfcAddress {
    constructor(expressID, Purpose, Description, UserDefinedPurpose, InternalLocation, AddressLines, PostalBox, Town, Region, PostalCode, Country) {
      super(expressID, Purpose, Description, UserDefinedPurpose);
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.InternalLocation = InternalLocation;
      this.AddressLines = AddressLines;
      this.PostalBox = PostalBox;
      this.Town = Town;
      this.Region = Region;
      this.PostalCode = PostalCode;
      this.Country = Country;
      this.type = 3355820592;
    }
  }
  IFC4_32.IfcPostalAddress = IfcPostalAddress;
  class IfcPresentationItem extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 677532197;
    }
  }
  IFC4_32.IfcPresentationItem = IfcPresentationItem;
  class IfcPresentationLayerAssignment extends IfcLineObject {
    constructor(expressID, Name, Description, AssignedItems, Identifier) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.AssignedItems = AssignedItems;
      this.Identifier = Identifier;
      this.type = 2022622350;
    }
  }
  IFC4_32.IfcPresentationLayerAssignment = IfcPresentationLayerAssignment;
  class IfcPresentationLayerWithStyle extends IfcPresentationLayerAssignment {
    constructor(expressID, Name, Description, AssignedItems, Identifier, LayerOn, LayerFrozen, LayerBlocked, LayerStyles) {
      super(expressID, Name, Description, AssignedItems, Identifier);
      this.Name = Name;
      this.Description = Description;
      this.AssignedItems = AssignedItems;
      this.Identifier = Identifier;
      this.LayerOn = LayerOn;
      this.LayerFrozen = LayerFrozen;
      this.LayerBlocked = LayerBlocked;
      this.LayerStyles = LayerStyles;
      this.type = 1304840413;
    }
  }
  IFC4_32.IfcPresentationLayerWithStyle = IfcPresentationLayerWithStyle;
  class IfcPresentationStyle extends IfcLineObject {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 3119450353;
    }
  }
  IFC4_32.IfcPresentationStyle = IfcPresentationStyle;
  class IfcProductRepresentation extends IfcLineObject {
    constructor(expressID, Name, Description, Representations) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.type = 2095639259;
    }
  }
  IFC4_32.IfcProductRepresentation = IfcProductRepresentation;
  class IfcProfileDef extends IfcLineObject {
    constructor(expressID, ProfileType, ProfileName) {
      super(expressID);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.type = 3958567839;
    }
  }
  IFC4_32.IfcProfileDef = IfcProfileDef;
  class IfcProjectedCRS extends IfcCoordinateReferenceSystem {
    constructor(expressID, Name, Description, GeodeticDatum, VerticalDatum, MapProjection, MapZone, MapUnit) {
      super(expressID, Name, Description, GeodeticDatum, VerticalDatum);
      this.Name = Name;
      this.Description = Description;
      this.GeodeticDatum = GeodeticDatum;
      this.VerticalDatum = VerticalDatum;
      this.MapProjection = MapProjection;
      this.MapZone = MapZone;
      this.MapUnit = MapUnit;
      this.type = 3843373140;
    }
  }
  IFC4_32.IfcProjectedCRS = IfcProjectedCRS;
  class IfcPropertyAbstraction extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 986844984;
    }
  }
  IFC4_32.IfcPropertyAbstraction = IfcPropertyAbstraction;
  class IfcPropertyEnumeration extends IfcPropertyAbstraction {
    constructor(expressID, Name, EnumerationValues, Unit) {
      super(expressID);
      this.Name = Name;
      this.EnumerationValues = EnumerationValues;
      this.Unit = Unit;
      this.type = 3710013099;
    }
  }
  IFC4_32.IfcPropertyEnumeration = IfcPropertyEnumeration;
  class IfcQuantityArea extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, AreaValue, Formula) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.AreaValue = AreaValue;
      this.Formula = Formula;
      this.type = 2044713172;
    }
  }
  IFC4_32.IfcQuantityArea = IfcQuantityArea;
  class IfcQuantityCount extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, CountValue, Formula) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.CountValue = CountValue;
      this.Formula = Formula;
      this.type = 2093928680;
    }
  }
  IFC4_32.IfcQuantityCount = IfcQuantityCount;
  class IfcQuantityLength extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, LengthValue, Formula) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.LengthValue = LengthValue;
      this.Formula = Formula;
      this.type = 931644368;
    }
  }
  IFC4_32.IfcQuantityLength = IfcQuantityLength;
  class IfcQuantityNumber extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, NumberValue, Formula) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.NumberValue = NumberValue;
      this.Formula = Formula;
      this.type = 2691318326;
    }
  }
  IFC4_32.IfcQuantityNumber = IfcQuantityNumber;
  class IfcQuantityTime extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, TimeValue, Formula) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.TimeValue = TimeValue;
      this.Formula = Formula;
      this.type = 3252649465;
    }
  }
  IFC4_32.IfcQuantityTime = IfcQuantityTime;
  class IfcQuantityVolume extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, VolumeValue, Formula) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.VolumeValue = VolumeValue;
      this.Formula = Formula;
      this.type = 2405470396;
    }
  }
  IFC4_32.IfcQuantityVolume = IfcQuantityVolume;
  class IfcQuantityWeight extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, WeightValue, Formula) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.WeightValue = WeightValue;
      this.Formula = Formula;
      this.type = 825690147;
    }
  }
  IFC4_32.IfcQuantityWeight = IfcQuantityWeight;
  class IfcRecurrencePattern extends IfcLineObject {
    constructor(expressID, RecurrenceType, DayComponent, WeekdayComponent, MonthComponent, Position, Interval, Occurrences, TimePeriods) {
      super(expressID);
      this.RecurrenceType = RecurrenceType;
      this.DayComponent = DayComponent;
      this.WeekdayComponent = WeekdayComponent;
      this.MonthComponent = MonthComponent;
      this.Position = Position;
      this.Interval = Interval;
      this.Occurrences = Occurrences;
      this.TimePeriods = TimePeriods;
      this.type = 3915482550;
    }
  }
  IFC4_32.IfcRecurrencePattern = IfcRecurrencePattern;
  class IfcReference extends IfcLineObject {
    constructor(expressID, TypeIdentifier, AttributeIdentifier, InstanceName, ListPositions, InnerReference) {
      super(expressID);
      this.TypeIdentifier = TypeIdentifier;
      this.AttributeIdentifier = AttributeIdentifier;
      this.InstanceName = InstanceName;
      this.ListPositions = ListPositions;
      this.InnerReference = InnerReference;
      this.type = 2433181523;
    }
  }
  IFC4_32.IfcReference = IfcReference;
  class IfcRepresentation extends IfcLineObject {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 1076942058;
    }
  }
  IFC4_32.IfcRepresentation = IfcRepresentation;
  class IfcRepresentationContext extends IfcLineObject {
    constructor(expressID, ContextIdentifier, ContextType) {
      super(expressID);
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.type = 3377609919;
    }
  }
  IFC4_32.IfcRepresentationContext = IfcRepresentationContext;
  class IfcRepresentationItem extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 3008791417;
    }
  }
  IFC4_32.IfcRepresentationItem = IfcRepresentationItem;
  class IfcRepresentationMap extends IfcLineObject {
    constructor(expressID, MappingOrigin, MappedRepresentation) {
      super(expressID);
      this.MappingOrigin = MappingOrigin;
      this.MappedRepresentation = MappedRepresentation;
      this.type = 1660063152;
    }
  }
  IFC4_32.IfcRepresentationMap = IfcRepresentationMap;
  class IfcResourceLevelRelationship extends IfcLineObject {
    constructor(expressID, Name, Description) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.type = 2439245199;
    }
  }
  IFC4_32.IfcResourceLevelRelationship = IfcResourceLevelRelationship;
  class IfcRoot extends IfcLineObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 2341007311;
    }
  }
  IFC4_32.IfcRoot = IfcRoot;
  class IfcSIUnit extends IfcNamedUnit {
    constructor(expressID, Dimensions, UnitType, Prefix, Name) {
      super(expressID, Dimensions, UnitType);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.Prefix = Prefix;
      this.Name = Name;
      this.type = 448429030;
    }
  }
  IFC4_32.IfcSIUnit = IfcSIUnit;
  class IfcSchedulingTime extends IfcLineObject {
    constructor(expressID, Name, DataOrigin, UserDefinedDataOrigin) {
      super(expressID);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.type = 1054537805;
    }
  }
  IFC4_32.IfcSchedulingTime = IfcSchedulingTime;
  class IfcShapeAspect extends IfcLineObject {
    constructor(expressID, ShapeRepresentations, Name, Description, ProductDefinitional, PartOfProductDefinitionShape) {
      super(expressID);
      this.ShapeRepresentations = ShapeRepresentations;
      this.Name = Name;
      this.Description = Description;
      this.ProductDefinitional = ProductDefinitional;
      this.PartOfProductDefinitionShape = PartOfProductDefinitionShape;
      this.type = 867548509;
    }
  }
  IFC4_32.IfcShapeAspect = IfcShapeAspect;
  class IfcShapeModel extends IfcRepresentation {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 3982875396;
    }
  }
  IFC4_32.IfcShapeModel = IfcShapeModel;
  class IfcShapeRepresentation extends IfcShapeModel {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 4240577450;
    }
  }
  IFC4_32.IfcShapeRepresentation = IfcShapeRepresentation;
  class IfcStructuralConnectionCondition extends IfcLineObject {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 2273995522;
    }
  }
  IFC4_32.IfcStructuralConnectionCondition = IfcStructuralConnectionCondition;
  class IfcStructuralLoad extends IfcLineObject {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 2162789131;
    }
  }
  IFC4_32.IfcStructuralLoad = IfcStructuralLoad;
  class IfcStructuralLoadConfiguration extends IfcStructuralLoad {
    constructor(expressID, Name, Values, Locations) {
      super(expressID, Name);
      this.Name = Name;
      this.Values = Values;
      this.Locations = Locations;
      this.type = 3478079324;
    }
  }
  IFC4_32.IfcStructuralLoadConfiguration = IfcStructuralLoadConfiguration;
  class IfcStructuralLoadOrResult extends IfcStructuralLoad {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 609421318;
    }
  }
  IFC4_32.IfcStructuralLoadOrResult = IfcStructuralLoadOrResult;
  class IfcStructuralLoadStatic extends IfcStructuralLoadOrResult {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 2525727697;
    }
  }
  IFC4_32.IfcStructuralLoadStatic = IfcStructuralLoadStatic;
  class IfcStructuralLoadTemperature extends IfcStructuralLoadStatic {
    constructor(expressID, Name, DeltaTConstant, DeltaTY, DeltaTZ) {
      super(expressID, Name);
      this.Name = Name;
      this.DeltaTConstant = DeltaTConstant;
      this.DeltaTY = DeltaTY;
      this.DeltaTZ = DeltaTZ;
      this.type = 3408363356;
    }
  }
  IFC4_32.IfcStructuralLoadTemperature = IfcStructuralLoadTemperature;
  class IfcStyleModel extends IfcRepresentation {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 2830218821;
    }
  }
  IFC4_32.IfcStyleModel = IfcStyleModel;
  class IfcStyledItem extends IfcRepresentationItem {
    constructor(expressID, Item, Styles, Name) {
      super(expressID);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 3958052878;
    }
  }
  IFC4_32.IfcStyledItem = IfcStyledItem;
  class IfcStyledRepresentation extends IfcStyleModel {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 3049322572;
    }
  }
  IFC4_32.IfcStyledRepresentation = IfcStyledRepresentation;
  class IfcSurfaceReinforcementArea extends IfcStructuralLoadOrResult {
    constructor(expressID, Name, SurfaceReinforcement1, SurfaceReinforcement2, ShearReinforcement) {
      super(expressID, Name);
      this.Name = Name;
      this.SurfaceReinforcement1 = SurfaceReinforcement1;
      this.SurfaceReinforcement2 = SurfaceReinforcement2;
      this.ShearReinforcement = ShearReinforcement;
      this.type = 2934153892;
    }
  }
  IFC4_32.IfcSurfaceReinforcementArea = IfcSurfaceReinforcementArea;
  class IfcSurfaceStyle extends IfcPresentationStyle {
    constructor(expressID, Name, Side, Styles) {
      super(expressID, Name);
      this.Name = Name;
      this.Side = Side;
      this.Styles = Styles;
      this.type = 1300840506;
    }
  }
  IFC4_32.IfcSurfaceStyle = IfcSurfaceStyle;
  class IfcSurfaceStyleLighting extends IfcPresentationItem {
    constructor(expressID, DiffuseTransmissionColour, DiffuseReflectionColour, TransmissionColour, ReflectanceColour) {
      super(expressID);
      this.DiffuseTransmissionColour = DiffuseTransmissionColour;
      this.DiffuseReflectionColour = DiffuseReflectionColour;
      this.TransmissionColour = TransmissionColour;
      this.ReflectanceColour = ReflectanceColour;
      this.type = 3303107099;
    }
  }
  IFC4_32.IfcSurfaceStyleLighting = IfcSurfaceStyleLighting;
  class IfcSurfaceStyleRefraction extends IfcPresentationItem {
    constructor(expressID, RefractionIndex, DispersionFactor) {
      super(expressID);
      this.RefractionIndex = RefractionIndex;
      this.DispersionFactor = DispersionFactor;
      this.type = 1607154358;
    }
  }
  IFC4_32.IfcSurfaceStyleRefraction = IfcSurfaceStyleRefraction;
  class IfcSurfaceStyleShading extends IfcPresentationItem {
    constructor(expressID, SurfaceColour, Transparency) {
      super(expressID);
      this.SurfaceColour = SurfaceColour;
      this.Transparency = Transparency;
      this.type = 846575682;
    }
  }
  IFC4_32.IfcSurfaceStyleShading = IfcSurfaceStyleShading;
  class IfcSurfaceStyleWithTextures extends IfcPresentationItem {
    constructor(expressID, Textures) {
      super(expressID);
      this.Textures = Textures;
      this.type = 1351298697;
    }
  }
  IFC4_32.IfcSurfaceStyleWithTextures = IfcSurfaceStyleWithTextures;
  class IfcSurfaceTexture extends IfcPresentationItem {
    constructor(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter) {
      super(expressID);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.Mode = Mode;
      this.TextureTransform = TextureTransform;
      this.Parameter = Parameter;
      this.type = 626085974;
    }
  }
  IFC4_32.IfcSurfaceTexture = IfcSurfaceTexture;
  class IfcTable extends IfcLineObject {
    constructor(expressID, Name, Rows, Columns) {
      super(expressID);
      this.Name = Name;
      this.Rows = Rows;
      this.Columns = Columns;
      this.type = 985171141;
    }
  }
  IFC4_32.IfcTable = IfcTable;
  class IfcTableColumn extends IfcLineObject {
    constructor(expressID, Identifier, Name, Description, Unit, ReferencePath) {
      super(expressID);
      this.Identifier = Identifier;
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.ReferencePath = ReferencePath;
      this.type = 2043862942;
    }
  }
  IFC4_32.IfcTableColumn = IfcTableColumn;
  class IfcTableRow extends IfcLineObject {
    constructor(expressID, RowCells, IsHeading) {
      super(expressID);
      this.RowCells = RowCells;
      this.IsHeading = IsHeading;
      this.type = 531007025;
    }
  }
  IFC4_32.IfcTableRow = IfcTableRow;
  class IfcTaskTime extends IfcSchedulingTime {
    constructor(expressID, Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion) {
      super(expressID, Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.DurationType = DurationType;
      this.ScheduleDuration = ScheduleDuration;
      this.ScheduleStart = ScheduleStart;
      this.ScheduleFinish = ScheduleFinish;
      this.EarlyStart = EarlyStart;
      this.EarlyFinish = EarlyFinish;
      this.LateStart = LateStart;
      this.LateFinish = LateFinish;
      this.FreeFloat = FreeFloat;
      this.TotalFloat = TotalFloat;
      this.IsCritical = IsCritical;
      this.StatusTime = StatusTime;
      this.ActualDuration = ActualDuration;
      this.ActualStart = ActualStart;
      this.ActualFinish = ActualFinish;
      this.RemainingTime = RemainingTime;
      this.Completion = Completion;
      this.type = 1549132990;
    }
  }
  IFC4_32.IfcTaskTime = IfcTaskTime;
  class IfcTaskTimeRecurring extends IfcTaskTime {
    constructor(expressID, Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion, Recurrence) {
      super(expressID, Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.DurationType = DurationType;
      this.ScheduleDuration = ScheduleDuration;
      this.ScheduleStart = ScheduleStart;
      this.ScheduleFinish = ScheduleFinish;
      this.EarlyStart = EarlyStart;
      this.EarlyFinish = EarlyFinish;
      this.LateStart = LateStart;
      this.LateFinish = LateFinish;
      this.FreeFloat = FreeFloat;
      this.TotalFloat = TotalFloat;
      this.IsCritical = IsCritical;
      this.StatusTime = StatusTime;
      this.ActualDuration = ActualDuration;
      this.ActualStart = ActualStart;
      this.ActualFinish = ActualFinish;
      this.RemainingTime = RemainingTime;
      this.Completion = Completion;
      this.Recurrence = Recurrence;
      this.type = 2771591690;
    }
  }
  IFC4_32.IfcTaskTimeRecurring = IfcTaskTimeRecurring;
  class IfcTelecomAddress extends IfcAddress {
    constructor(expressID, Purpose, Description, UserDefinedPurpose, TelephoneNumbers, FacsimileNumbers, PagerNumber, ElectronicMailAddresses, WWWHomePageURL, MessagingIDs) {
      super(expressID, Purpose, Description, UserDefinedPurpose);
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.TelephoneNumbers = TelephoneNumbers;
      this.FacsimileNumbers = FacsimileNumbers;
      this.PagerNumber = PagerNumber;
      this.ElectronicMailAddresses = ElectronicMailAddresses;
      this.WWWHomePageURL = WWWHomePageURL;
      this.MessagingIDs = MessagingIDs;
      this.type = 912023232;
    }
  }
  IFC4_32.IfcTelecomAddress = IfcTelecomAddress;
  class IfcTextStyle extends IfcPresentationStyle {
    constructor(expressID, Name, TextCharacterAppearance, TextStyle, TextFontStyle, ModelOrDraughting) {
      super(expressID, Name);
      this.Name = Name;
      this.TextCharacterAppearance = TextCharacterAppearance;
      this.TextStyle = TextStyle;
      this.TextFontStyle = TextFontStyle;
      this.ModelOrDraughting = ModelOrDraughting;
      this.type = 1447204868;
    }
  }
  IFC4_32.IfcTextStyle = IfcTextStyle;
  class IfcTextStyleForDefinedFont extends IfcPresentationItem {
    constructor(expressID, Colour, BackgroundColour) {
      super(expressID);
      this.Colour = Colour;
      this.BackgroundColour = BackgroundColour;
      this.type = 2636378356;
    }
  }
  IFC4_32.IfcTextStyleForDefinedFont = IfcTextStyleForDefinedFont;
  class IfcTextStyleTextModel extends IfcPresentationItem {
    constructor(expressID, TextIndent, TextAlign, TextDecoration, LetterSpacing, WordSpacing, TextTransform, LineHeight) {
      super(expressID);
      this.TextIndent = TextIndent;
      this.TextAlign = TextAlign;
      this.TextDecoration = TextDecoration;
      this.LetterSpacing = LetterSpacing;
      this.WordSpacing = WordSpacing;
      this.TextTransform = TextTransform;
      this.LineHeight = LineHeight;
      this.type = 1640371178;
    }
  }
  IFC4_32.IfcTextStyleTextModel = IfcTextStyleTextModel;
  class IfcTextureCoordinate extends IfcPresentationItem {
    constructor(expressID, Maps) {
      super(expressID);
      this.Maps = Maps;
      this.type = 280115917;
    }
  }
  IFC4_32.IfcTextureCoordinate = IfcTextureCoordinate;
  class IfcTextureCoordinateGenerator extends IfcTextureCoordinate {
    constructor(expressID, Maps, Mode, Parameter) {
      super(expressID, Maps);
      this.Maps = Maps;
      this.Mode = Mode;
      this.Parameter = Parameter;
      this.type = 1742049831;
    }
  }
  IFC4_32.IfcTextureCoordinateGenerator = IfcTextureCoordinateGenerator;
  class IfcTextureCoordinateIndices extends IfcLineObject {
    constructor(expressID, TexCoordIndex, TexCoordsOf) {
      super(expressID);
      this.TexCoordIndex = TexCoordIndex;
      this.TexCoordsOf = TexCoordsOf;
      this.type = 222769930;
    }
  }
  IFC4_32.IfcTextureCoordinateIndices = IfcTextureCoordinateIndices;
  class IfcTextureCoordinateIndicesWithVoids extends IfcTextureCoordinateIndices {
    constructor(expressID, TexCoordIndex, TexCoordsOf, InnerTexCoordIndices) {
      super(expressID, TexCoordIndex, TexCoordsOf);
      this.TexCoordIndex = TexCoordIndex;
      this.TexCoordsOf = TexCoordsOf;
      this.InnerTexCoordIndices = InnerTexCoordIndices;
      this.type = 1010789467;
    }
  }
  IFC4_32.IfcTextureCoordinateIndicesWithVoids = IfcTextureCoordinateIndicesWithVoids;
  class IfcTextureMap extends IfcTextureCoordinate {
    constructor(expressID, Maps, Vertices, MappedTo) {
      super(expressID, Maps);
      this.Maps = Maps;
      this.Vertices = Vertices;
      this.MappedTo = MappedTo;
      this.type = 2552916305;
    }
  }
  IFC4_32.IfcTextureMap = IfcTextureMap;
  class IfcTextureVertex extends IfcPresentationItem {
    constructor(expressID, Coordinates) {
      super(expressID);
      this.Coordinates = Coordinates;
      this.type = 1210645708;
    }
  }
  IFC4_32.IfcTextureVertex = IfcTextureVertex;
  class IfcTextureVertexList extends IfcPresentationItem {
    constructor(expressID, TexCoordsList) {
      super(expressID);
      this.TexCoordsList = TexCoordsList;
      this.type = 3611470254;
    }
  }
  IFC4_32.IfcTextureVertexList = IfcTextureVertexList;
  class IfcTimePeriod extends IfcLineObject {
    constructor(expressID, StartTime, EndTime) {
      super(expressID);
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.type = 1199560280;
    }
  }
  IFC4_32.IfcTimePeriod = IfcTimePeriod;
  class IfcTimeSeries extends IfcLineObject {
    constructor(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.type = 3101149627;
    }
  }
  IFC4_32.IfcTimeSeries = IfcTimeSeries;
  class IfcTimeSeriesValue extends IfcLineObject {
    constructor(expressID, ListValues) {
      super(expressID);
      this.ListValues = ListValues;
      this.type = 581633288;
    }
  }
  IFC4_32.IfcTimeSeriesValue = IfcTimeSeriesValue;
  class IfcTopologicalRepresentationItem extends IfcRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 1377556343;
    }
  }
  IFC4_32.IfcTopologicalRepresentationItem = IfcTopologicalRepresentationItem;
  class IfcTopologyRepresentation extends IfcShapeModel {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 1735638870;
    }
  }
  IFC4_32.IfcTopologyRepresentation = IfcTopologyRepresentation;
  class IfcUnitAssignment extends IfcLineObject {
    constructor(expressID, Units) {
      super(expressID);
      this.Units = Units;
      this.type = 180925521;
    }
  }
  IFC4_32.IfcUnitAssignment = IfcUnitAssignment;
  class IfcVertex extends IfcTopologicalRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 2799835756;
    }
  }
  IFC4_32.IfcVertex = IfcVertex;
  class IfcVertexPoint extends IfcVertex {
    constructor(expressID, VertexGeometry) {
      super(expressID);
      this.VertexGeometry = VertexGeometry;
      this.type = 1907098498;
    }
  }
  IFC4_32.IfcVertexPoint = IfcVertexPoint;
  class IfcVirtualGridIntersection extends IfcLineObject {
    constructor(expressID, IntersectingAxes, OffsetDistances) {
      super(expressID);
      this.IntersectingAxes = IntersectingAxes;
      this.OffsetDistances = OffsetDistances;
      this.type = 891718957;
    }
  }
  IFC4_32.IfcVirtualGridIntersection = IfcVirtualGridIntersection;
  class IfcWorkTime extends IfcSchedulingTime {
    constructor(expressID, Name, DataOrigin, UserDefinedDataOrigin, RecurrencePattern, StartDate, FinishDate) {
      super(expressID, Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.RecurrencePattern = RecurrencePattern;
      this.StartDate = StartDate;
      this.FinishDate = FinishDate;
      this.type = 1236880293;
    }
  }
  IFC4_32.IfcWorkTime = IfcWorkTime;
  class IfcAlignmentCantSegment extends IfcAlignmentParameterSegment {
    constructor(expressID, StartTag, EndTag, StartDistAlong, HorizontalLength, StartCantLeft, EndCantLeft, StartCantRight, EndCantRight, PredefinedType) {
      super(expressID, StartTag, EndTag);
      this.StartTag = StartTag;
      this.EndTag = EndTag;
      this.StartDistAlong = StartDistAlong;
      this.HorizontalLength = HorizontalLength;
      this.StartCantLeft = StartCantLeft;
      this.EndCantLeft = EndCantLeft;
      this.StartCantRight = StartCantRight;
      this.EndCantRight = EndCantRight;
      this.PredefinedType = PredefinedType;
      this.type = 3752311538;
    }
  }
  IFC4_32.IfcAlignmentCantSegment = IfcAlignmentCantSegment;
  class IfcAlignmentHorizontalSegment extends IfcAlignmentParameterSegment {
    constructor(expressID, StartTag, EndTag, StartPoint, StartDirection, StartRadiusOfCurvature, EndRadiusOfCurvature, SegmentLength, GravityCenterLineHeight, PredefinedType) {
      super(expressID, StartTag, EndTag);
      this.StartTag = StartTag;
      this.EndTag = EndTag;
      this.StartPoint = StartPoint;
      this.StartDirection = StartDirection;
      this.StartRadiusOfCurvature = StartRadiusOfCurvature;
      this.EndRadiusOfCurvature = EndRadiusOfCurvature;
      this.SegmentLength = SegmentLength;
      this.GravityCenterLineHeight = GravityCenterLineHeight;
      this.PredefinedType = PredefinedType;
      this.type = 536804194;
    }
  }
  IFC4_32.IfcAlignmentHorizontalSegment = IfcAlignmentHorizontalSegment;
  class IfcApprovalRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, RelatingApproval, RelatedApprovals) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingApproval = RelatingApproval;
      this.RelatedApprovals = RelatedApprovals;
      this.type = 3869604511;
    }
  }
  IFC4_32.IfcApprovalRelationship = IfcApprovalRelationship;
  class IfcArbitraryClosedProfileDef extends IfcProfileDef {
    constructor(expressID, ProfileType, ProfileName, OuterCurve) {
      super(expressID, ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.OuterCurve = OuterCurve;
      this.type = 3798115385;
    }
  }
  IFC4_32.IfcArbitraryClosedProfileDef = IfcArbitraryClosedProfileDef;
  class IfcArbitraryOpenProfileDef extends IfcProfileDef {
    constructor(expressID, ProfileType, ProfileName, Curve) {
      super(expressID, ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Curve = Curve;
      this.type = 1310608509;
    }
  }
  IFC4_32.IfcArbitraryOpenProfileDef = IfcArbitraryOpenProfileDef;
  class IfcArbitraryProfileDefWithVoids extends IfcArbitraryClosedProfileDef {
    constructor(expressID, ProfileType, ProfileName, OuterCurve, InnerCurves) {
      super(expressID, ProfileType, ProfileName, OuterCurve);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.OuterCurve = OuterCurve;
      this.InnerCurves = InnerCurves;
      this.type = 2705031697;
    }
  }
  IFC4_32.IfcArbitraryProfileDefWithVoids = IfcArbitraryProfileDefWithVoids;
  class IfcBlobTexture extends IfcSurfaceTexture {
    constructor(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter, RasterFormat, RasterCode) {
      super(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.Mode = Mode;
      this.TextureTransform = TextureTransform;
      this.Parameter = Parameter;
      this.RasterFormat = RasterFormat;
      this.RasterCode = RasterCode;
      this.type = 616511568;
    }
  }
  IFC4_32.IfcBlobTexture = IfcBlobTexture;
  class IfcCenterLineProfileDef extends IfcArbitraryOpenProfileDef {
    constructor(expressID, ProfileType, ProfileName, Curve, Thickness) {
      super(expressID, ProfileType, ProfileName, Curve);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Curve = Curve;
      this.Thickness = Thickness;
      this.type = 3150382593;
    }
  }
  IFC4_32.IfcCenterLineProfileDef = IfcCenterLineProfileDef;
  class IfcClassification extends IfcExternalInformation {
    constructor(expressID, Source, Edition, EditionDate, Name, Description, Specification, ReferenceTokens) {
      super(expressID);
      this.Source = Source;
      this.Edition = Edition;
      this.EditionDate = EditionDate;
      this.Name = Name;
      this.Description = Description;
      this.Specification = Specification;
      this.ReferenceTokens = ReferenceTokens;
      this.type = 747523909;
    }
  }
  IFC4_32.IfcClassification = IfcClassification;
  class IfcClassificationReference extends IfcExternalReference {
    constructor(expressID, Location, Identification, Name, ReferencedSource, Description, Sort) {
      super(expressID, Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.ReferencedSource = ReferencedSource;
      this.Description = Description;
      this.Sort = Sort;
      this.type = 647927063;
    }
  }
  IFC4_32.IfcClassificationReference = IfcClassificationReference;
  class IfcColourRgbList extends IfcPresentationItem {
    constructor(expressID, ColourList) {
      super(expressID);
      this.ColourList = ColourList;
      this.type = 3285139300;
    }
  }
  IFC4_32.IfcColourRgbList = IfcColourRgbList;
  class IfcColourSpecification extends IfcPresentationItem {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 3264961684;
    }
  }
  IFC4_32.IfcColourSpecification = IfcColourSpecification;
  class IfcCompositeProfileDef extends IfcProfileDef {
    constructor(expressID, ProfileType, ProfileName, Profiles, Label) {
      super(expressID, ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Profiles = Profiles;
      this.Label = Label;
      this.type = 1485152156;
    }
  }
  IFC4_32.IfcCompositeProfileDef = IfcCompositeProfileDef;
  class IfcConnectedFaceSet extends IfcTopologicalRepresentationItem {
    constructor(expressID, CfsFaces) {
      super(expressID);
      this.CfsFaces = CfsFaces;
      this.type = 370225590;
    }
  }
  IFC4_32.IfcConnectedFaceSet = IfcConnectedFaceSet;
  class IfcConnectionCurveGeometry extends IfcConnectionGeometry {
    constructor(expressID, CurveOnRelatingElement, CurveOnRelatedElement) {
      super(expressID);
      this.CurveOnRelatingElement = CurveOnRelatingElement;
      this.CurveOnRelatedElement = CurveOnRelatedElement;
      this.type = 1981873012;
    }
  }
  IFC4_32.IfcConnectionCurveGeometry = IfcConnectionCurveGeometry;
  class IfcConnectionPointEccentricity extends IfcConnectionPointGeometry {
    constructor(expressID, PointOnRelatingElement, PointOnRelatedElement, EccentricityInX, EccentricityInY, EccentricityInZ) {
      super(expressID, PointOnRelatingElement, PointOnRelatedElement);
      this.PointOnRelatingElement = PointOnRelatingElement;
      this.PointOnRelatedElement = PointOnRelatedElement;
      this.EccentricityInX = EccentricityInX;
      this.EccentricityInY = EccentricityInY;
      this.EccentricityInZ = EccentricityInZ;
      this.type = 45288368;
    }
  }
  IFC4_32.IfcConnectionPointEccentricity = IfcConnectionPointEccentricity;
  class IfcContextDependentUnit extends IfcNamedUnit {
    constructor(expressID, Dimensions, UnitType, Name) {
      super(expressID, Dimensions, UnitType);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.Name = Name;
      this.type = 3050246964;
    }
  }
  IFC4_32.IfcContextDependentUnit = IfcContextDependentUnit;
  class IfcConversionBasedUnit extends IfcNamedUnit {
    constructor(expressID, Dimensions, UnitType, Name, ConversionFactor) {
      super(expressID, Dimensions, UnitType);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.Name = Name;
      this.ConversionFactor = ConversionFactor;
      this.type = 2889183280;
    }
  }
  IFC4_32.IfcConversionBasedUnit = IfcConversionBasedUnit;
  class IfcConversionBasedUnitWithOffset extends IfcConversionBasedUnit {
    constructor(expressID, Dimensions, UnitType, Name, ConversionFactor, ConversionOffset) {
      super(expressID, Dimensions, UnitType, Name, ConversionFactor);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.Name = Name;
      this.ConversionFactor = ConversionFactor;
      this.ConversionOffset = ConversionOffset;
      this.type = 2713554722;
    }
  }
  IFC4_32.IfcConversionBasedUnitWithOffset = IfcConversionBasedUnitWithOffset;
  class IfcCurrencyRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, RelatingMonetaryUnit, RelatedMonetaryUnit, ExchangeRate, RateDateTime, RateSource) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingMonetaryUnit = RelatingMonetaryUnit;
      this.RelatedMonetaryUnit = RelatedMonetaryUnit;
      this.ExchangeRate = ExchangeRate;
      this.RateDateTime = RateDateTime;
      this.RateSource = RateSource;
      this.type = 539742890;
    }
  }
  IFC4_32.IfcCurrencyRelationship = IfcCurrencyRelationship;
  class IfcCurveStyle extends IfcPresentationStyle {
    constructor(expressID, Name, CurveFont, CurveWidth, CurveColour, ModelOrDraughting) {
      super(expressID, Name);
      this.Name = Name;
      this.CurveFont = CurveFont;
      this.CurveWidth = CurveWidth;
      this.CurveColour = CurveColour;
      this.ModelOrDraughting = ModelOrDraughting;
      this.type = 3800577675;
    }
  }
  IFC4_32.IfcCurveStyle = IfcCurveStyle;
  class IfcCurveStyleFont extends IfcPresentationItem {
    constructor(expressID, Name, PatternList) {
      super(expressID);
      this.Name = Name;
      this.PatternList = PatternList;
      this.type = 1105321065;
    }
  }
  IFC4_32.IfcCurveStyleFont = IfcCurveStyleFont;
  class IfcCurveStyleFontAndScaling extends IfcPresentationItem {
    constructor(expressID, Name, CurveStyleFont, CurveFontScaling) {
      super(expressID);
      this.Name = Name;
      this.CurveStyleFont = CurveStyleFont;
      this.CurveFontScaling = CurveFontScaling;
      this.type = 2367409068;
    }
  }
  IFC4_32.IfcCurveStyleFontAndScaling = IfcCurveStyleFontAndScaling;
  class IfcCurveStyleFontPattern extends IfcPresentationItem {
    constructor(expressID, VisibleSegmentLength, InvisibleSegmentLength) {
      super(expressID);
      this.VisibleSegmentLength = VisibleSegmentLength;
      this.InvisibleSegmentLength = InvisibleSegmentLength;
      this.type = 3510044353;
    }
  }
  IFC4_32.IfcCurveStyleFontPattern = IfcCurveStyleFontPattern;
  class IfcDerivedProfileDef extends IfcProfileDef {
    constructor(expressID, ProfileType, ProfileName, ParentProfile, Operator, Label) {
      super(expressID, ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.ParentProfile = ParentProfile;
      this.Operator = Operator;
      this.Label = Label;
      this.type = 3632507154;
    }
  }
  IFC4_32.IfcDerivedProfileDef = IfcDerivedProfileDef;
  class IfcDocumentInformation extends IfcExternalInformation {
    constructor(expressID, Identification, Name, Description, Location, Purpose, IntendedUse, Scope, Revision, DocumentOwner, Editors, CreationTime, LastRevisionTime, ElectronicFormat, ValidFrom, ValidUntil, Confidentiality, Status) {
      super(expressID);
      this.Identification = Identification;
      this.Name = Name;
      this.Description = Description;
      this.Location = Location;
      this.Purpose = Purpose;
      this.IntendedUse = IntendedUse;
      this.Scope = Scope;
      this.Revision = Revision;
      this.DocumentOwner = DocumentOwner;
      this.Editors = Editors;
      this.CreationTime = CreationTime;
      this.LastRevisionTime = LastRevisionTime;
      this.ElectronicFormat = ElectronicFormat;
      this.ValidFrom = ValidFrom;
      this.ValidUntil = ValidUntil;
      this.Confidentiality = Confidentiality;
      this.Status = Status;
      this.type = 1154170062;
    }
  }
  IFC4_32.IfcDocumentInformation = IfcDocumentInformation;
  class IfcDocumentInformationRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, RelatingDocument, RelatedDocuments, RelationshipType) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingDocument = RelatingDocument;
      this.RelatedDocuments = RelatedDocuments;
      this.RelationshipType = RelationshipType;
      this.type = 770865208;
    }
  }
  IFC4_32.IfcDocumentInformationRelationship = IfcDocumentInformationRelationship;
  class IfcDocumentReference extends IfcExternalReference {
    constructor(expressID, Location, Identification, Name, Description, ReferencedDocument) {
      super(expressID, Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.Description = Description;
      this.ReferencedDocument = ReferencedDocument;
      this.type = 3732053477;
    }
  }
  IFC4_32.IfcDocumentReference = IfcDocumentReference;
  class IfcEdge extends IfcTopologicalRepresentationItem {
    constructor(expressID, EdgeStart, EdgeEnd) {
      super(expressID);
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.type = 3900360178;
    }
  }
  IFC4_32.IfcEdge = IfcEdge;
  class IfcEdgeCurve extends IfcEdge {
    constructor(expressID, EdgeStart, EdgeEnd, EdgeGeometry, SameSense) {
      super(expressID, EdgeStart, EdgeEnd);
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.EdgeGeometry = EdgeGeometry;
      this.SameSense = SameSense;
      this.type = 476780140;
    }
  }
  IFC4_32.IfcEdgeCurve = IfcEdgeCurve;
  class IfcEventTime extends IfcSchedulingTime {
    constructor(expressID, Name, DataOrigin, UserDefinedDataOrigin, ActualDate, EarlyDate, LateDate, ScheduleDate) {
      super(expressID, Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.ActualDate = ActualDate;
      this.EarlyDate = EarlyDate;
      this.LateDate = LateDate;
      this.ScheduleDate = ScheduleDate;
      this.type = 211053100;
    }
  }
  IFC4_32.IfcEventTime = IfcEventTime;
  class IfcExtendedProperties extends IfcPropertyAbstraction {
    constructor(expressID, Name, Description, Properties2) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.Properties = Properties2;
      this.type = 297599258;
    }
  }
  IFC4_32.IfcExtendedProperties = IfcExtendedProperties;
  class IfcExternalReferenceRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, RelatingReference, RelatedResourceObjects) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingReference = RelatingReference;
      this.RelatedResourceObjects = RelatedResourceObjects;
      this.type = 1437805879;
    }
  }
  IFC4_32.IfcExternalReferenceRelationship = IfcExternalReferenceRelationship;
  class IfcFace extends IfcTopologicalRepresentationItem {
    constructor(expressID, Bounds) {
      super(expressID);
      this.Bounds = Bounds;
      this.type = 2556980723;
    }
  }
  IFC4_32.IfcFace = IfcFace;
  class IfcFaceBound extends IfcTopologicalRepresentationItem {
    constructor(expressID, Bound, Orientation) {
      super(expressID);
      this.Bound = Bound;
      this.Orientation = Orientation;
      this.type = 1809719519;
    }
  }
  IFC4_32.IfcFaceBound = IfcFaceBound;
  class IfcFaceOuterBound extends IfcFaceBound {
    constructor(expressID, Bound, Orientation) {
      super(expressID, Bound, Orientation);
      this.Bound = Bound;
      this.Orientation = Orientation;
      this.type = 803316827;
    }
  }
  IFC4_32.IfcFaceOuterBound = IfcFaceOuterBound;
  class IfcFaceSurface extends IfcFace {
    constructor(expressID, Bounds, FaceSurface, SameSense) {
      super(expressID, Bounds);
      this.Bounds = Bounds;
      this.FaceSurface = FaceSurface;
      this.SameSense = SameSense;
      this.type = 3008276851;
    }
  }
  IFC4_32.IfcFaceSurface = IfcFaceSurface;
  class IfcFailureConnectionCondition extends IfcStructuralConnectionCondition {
    constructor(expressID, Name, TensionFailureX, TensionFailureY, TensionFailureZ, CompressionFailureX, CompressionFailureY, CompressionFailureZ) {
      super(expressID, Name);
      this.Name = Name;
      this.TensionFailureX = TensionFailureX;
      this.TensionFailureY = TensionFailureY;
      this.TensionFailureZ = TensionFailureZ;
      this.CompressionFailureX = CompressionFailureX;
      this.CompressionFailureY = CompressionFailureY;
      this.CompressionFailureZ = CompressionFailureZ;
      this.type = 4219587988;
    }
  }
  IFC4_32.IfcFailureConnectionCondition = IfcFailureConnectionCondition;
  class IfcFillAreaStyle extends IfcPresentationStyle {
    constructor(expressID, Name, FillStyles, ModelOrDraughting) {
      super(expressID, Name);
      this.Name = Name;
      this.FillStyles = FillStyles;
      this.ModelOrDraughting = ModelOrDraughting;
      this.type = 738692330;
    }
  }
  IFC4_32.IfcFillAreaStyle = IfcFillAreaStyle;
  class IfcGeometricRepresentationContext extends IfcRepresentationContext {
    constructor(expressID, ContextIdentifier, ContextType, CoordinateSpaceDimension, Precision, WorldCoordinateSystem, TrueNorth) {
      super(expressID, ContextIdentifier, ContextType);
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.CoordinateSpaceDimension = CoordinateSpaceDimension;
      this.Precision = Precision;
      this.WorldCoordinateSystem = WorldCoordinateSystem;
      this.TrueNorth = TrueNorth;
      this.type = 3448662350;
    }
  }
  IFC4_32.IfcGeometricRepresentationContext = IfcGeometricRepresentationContext;
  class IfcGeometricRepresentationItem extends IfcRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 2453401579;
    }
  }
  IFC4_32.IfcGeometricRepresentationItem = IfcGeometricRepresentationItem;
  class IfcGeometricRepresentationSubContext extends IfcGeometricRepresentationContext {
    constructor(expressID, ContextIdentifier, ContextType, WorldCoordinateSystem, ParentContext, TargetScale, TargetView, UserDefinedTargetView) {
      super(expressID, ContextIdentifier, ContextType, new IfcDimensionCount(0), null, WorldCoordinateSystem, null);
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.WorldCoordinateSystem = WorldCoordinateSystem;
      this.ParentContext = ParentContext;
      this.TargetScale = TargetScale;
      this.TargetView = TargetView;
      this.UserDefinedTargetView = UserDefinedTargetView;
      this.type = 4142052618;
    }
  }
  IFC4_32.IfcGeometricRepresentationSubContext = IfcGeometricRepresentationSubContext;
  class IfcGeometricSet extends IfcGeometricRepresentationItem {
    constructor(expressID, Elements) {
      super(expressID);
      this.Elements = Elements;
      this.type = 3590301190;
    }
  }
  IFC4_32.IfcGeometricSet = IfcGeometricSet;
  class IfcGridPlacement extends IfcObjectPlacement {
    constructor(expressID, PlacementRelTo, PlacementLocation, PlacementRefDirection) {
      super(expressID, PlacementRelTo);
      this.PlacementRelTo = PlacementRelTo;
      this.PlacementLocation = PlacementLocation;
      this.PlacementRefDirection = PlacementRefDirection;
      this.type = 178086475;
    }
  }
  IFC4_32.IfcGridPlacement = IfcGridPlacement;
  class IfcHalfSpaceSolid extends IfcGeometricRepresentationItem {
    constructor(expressID, BaseSurface, AgreementFlag) {
      super(expressID);
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.type = 812098782;
    }
  }
  IFC4_32.IfcHalfSpaceSolid = IfcHalfSpaceSolid;
  class IfcImageTexture extends IfcSurfaceTexture {
    constructor(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter, URLReference) {
      super(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.Mode = Mode;
      this.TextureTransform = TextureTransform;
      this.Parameter = Parameter;
      this.URLReference = URLReference;
      this.type = 3905492369;
    }
  }
  IFC4_32.IfcImageTexture = IfcImageTexture;
  class IfcIndexedColourMap extends IfcPresentationItem {
    constructor(expressID, MappedTo, Opacity, Colours, ColourIndex) {
      super(expressID);
      this.MappedTo = MappedTo;
      this.Opacity = Opacity;
      this.Colours = Colours;
      this.ColourIndex = ColourIndex;
      this.type = 3570813810;
    }
  }
  IFC4_32.IfcIndexedColourMap = IfcIndexedColourMap;
  class IfcIndexedTextureMap extends IfcTextureCoordinate {
    constructor(expressID, Maps, MappedTo, TexCoords) {
      super(expressID, Maps);
      this.Maps = Maps;
      this.MappedTo = MappedTo;
      this.TexCoords = TexCoords;
      this.type = 1437953363;
    }
  }
  IFC4_32.IfcIndexedTextureMap = IfcIndexedTextureMap;
  class IfcIndexedTriangleTextureMap extends IfcIndexedTextureMap {
    constructor(expressID, Maps, MappedTo, TexCoords, TexCoordIndex) {
      super(expressID, Maps, MappedTo, TexCoords);
      this.Maps = Maps;
      this.MappedTo = MappedTo;
      this.TexCoords = TexCoords;
      this.TexCoordIndex = TexCoordIndex;
      this.type = 2133299955;
    }
  }
  IFC4_32.IfcIndexedTriangleTextureMap = IfcIndexedTriangleTextureMap;
  class IfcIrregularTimeSeries extends IfcTimeSeries {
    constructor(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, Values) {
      super(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.Values = Values;
      this.type = 3741457305;
    }
  }
  IFC4_32.IfcIrregularTimeSeries = IfcIrregularTimeSeries;
  class IfcLagTime extends IfcSchedulingTime {
    constructor(expressID, Name, DataOrigin, UserDefinedDataOrigin, LagValue, DurationType) {
      super(expressID, Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.LagValue = LagValue;
      this.DurationType = DurationType;
      this.type = 1585845231;
    }
  }
  IFC4_32.IfcLagTime = IfcLagTime;
  class IfcLightSource extends IfcGeometricRepresentationItem {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity) {
      super(expressID);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.type = 1402838566;
    }
  }
  IFC4_32.IfcLightSource = IfcLightSource;
  class IfcLightSourceAmbient extends IfcLightSource {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity) {
      super(expressID, Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.type = 125510826;
    }
  }
  IFC4_32.IfcLightSourceAmbient = IfcLightSourceAmbient;
  class IfcLightSourceDirectional extends IfcLightSource {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity, Orientation) {
      super(expressID, Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Orientation = Orientation;
      this.type = 2604431987;
    }
  }
  IFC4_32.IfcLightSourceDirectional = IfcLightSourceDirectional;
  class IfcLightSourceGoniometric extends IfcLightSource {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, ColourAppearance, ColourTemperature, LuminousFlux, LightEmissionSource, LightDistributionDataSource) {
      super(expressID, Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.ColourAppearance = ColourAppearance;
      this.ColourTemperature = ColourTemperature;
      this.LuminousFlux = LuminousFlux;
      this.LightEmissionSource = LightEmissionSource;
      this.LightDistributionDataSource = LightDistributionDataSource;
      this.type = 4266656042;
    }
  }
  IFC4_32.IfcLightSourceGoniometric = IfcLightSourceGoniometric;
  class IfcLightSourcePositional extends IfcLightSource {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation) {
      super(expressID, Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.Radius = Radius;
      this.ConstantAttenuation = ConstantAttenuation;
      this.DistanceAttenuation = DistanceAttenuation;
      this.QuadricAttenuation = QuadricAttenuation;
      this.type = 1520743889;
    }
  }
  IFC4_32.IfcLightSourcePositional = IfcLightSourcePositional;
  class IfcLightSourceSpot extends IfcLightSourcePositional {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation, Orientation, ConcentrationExponent, SpreadAngle, BeamWidthAngle) {
      super(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.Radius = Radius;
      this.ConstantAttenuation = ConstantAttenuation;
      this.DistanceAttenuation = DistanceAttenuation;
      this.QuadricAttenuation = QuadricAttenuation;
      this.Orientation = Orientation;
      this.ConcentrationExponent = ConcentrationExponent;
      this.SpreadAngle = SpreadAngle;
      this.BeamWidthAngle = BeamWidthAngle;
      this.type = 3422422726;
    }
  }
  IFC4_32.IfcLightSourceSpot = IfcLightSourceSpot;
  class IfcLinearPlacement extends IfcObjectPlacement {
    constructor(expressID, PlacementRelTo, RelativePlacement, CartesianPosition) {
      super(expressID, PlacementRelTo);
      this.PlacementRelTo = PlacementRelTo;
      this.RelativePlacement = RelativePlacement;
      this.CartesianPosition = CartesianPosition;
      this.type = 388784114;
    }
  }
  IFC4_32.IfcLinearPlacement = IfcLinearPlacement;
  class IfcLocalPlacement extends IfcObjectPlacement {
    constructor(expressID, PlacementRelTo, RelativePlacement) {
      super(expressID, PlacementRelTo);
      this.PlacementRelTo = PlacementRelTo;
      this.RelativePlacement = RelativePlacement;
      this.type = 2624227202;
    }
  }
  IFC4_32.IfcLocalPlacement = IfcLocalPlacement;
  class IfcLoop extends IfcTopologicalRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 1008929658;
    }
  }
  IFC4_32.IfcLoop = IfcLoop;
  class IfcMappedItem extends IfcRepresentationItem {
    constructor(expressID, MappingSource, MappingTarget) {
      super(expressID);
      this.MappingSource = MappingSource;
      this.MappingTarget = MappingTarget;
      this.type = 2347385850;
    }
  }
  IFC4_32.IfcMappedItem = IfcMappedItem;
  class IfcMaterial extends IfcMaterialDefinition {
    constructor(expressID, Name, Description, Category) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.Category = Category;
      this.type = 1838606355;
    }
  }
  IFC4_32.IfcMaterial = IfcMaterial;
  class IfcMaterialConstituent extends IfcMaterialDefinition {
    constructor(expressID, Name, Description, Material, Fraction, Category) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.Material = Material;
      this.Fraction = Fraction;
      this.Category = Category;
      this.type = 3708119e3;
    }
  }
  IFC4_32.IfcMaterialConstituent = IfcMaterialConstituent;
  class IfcMaterialConstituentSet extends IfcMaterialDefinition {
    constructor(expressID, Name, Description, MaterialConstituents) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.MaterialConstituents = MaterialConstituents;
      this.type = 2852063980;
    }
  }
  IFC4_32.IfcMaterialConstituentSet = IfcMaterialConstituentSet;
  class IfcMaterialDefinitionRepresentation extends IfcProductRepresentation {
    constructor(expressID, Name, Description, Representations, RepresentedMaterial) {
      super(expressID, Name, Description, Representations);
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.RepresentedMaterial = RepresentedMaterial;
      this.type = 2022407955;
    }
  }
  IFC4_32.IfcMaterialDefinitionRepresentation = IfcMaterialDefinitionRepresentation;
  class IfcMaterialLayerSetUsage extends IfcMaterialUsageDefinition {
    constructor(expressID, ForLayerSet, LayerSetDirection, DirectionSense, OffsetFromReferenceLine, ReferenceExtent) {
      super(expressID);
      this.ForLayerSet = ForLayerSet;
      this.LayerSetDirection = LayerSetDirection;
      this.DirectionSense = DirectionSense;
      this.OffsetFromReferenceLine = OffsetFromReferenceLine;
      this.ReferenceExtent = ReferenceExtent;
      this.type = 1303795690;
    }
  }
  IFC4_32.IfcMaterialLayerSetUsage = IfcMaterialLayerSetUsage;
  class IfcMaterialProfileSetUsage extends IfcMaterialUsageDefinition {
    constructor(expressID, ForProfileSet, CardinalPoint, ReferenceExtent) {
      super(expressID);
      this.ForProfileSet = ForProfileSet;
      this.CardinalPoint = CardinalPoint;
      this.ReferenceExtent = ReferenceExtent;
      this.type = 3079605661;
    }
  }
  IFC4_32.IfcMaterialProfileSetUsage = IfcMaterialProfileSetUsage;
  class IfcMaterialProfileSetUsageTapering extends IfcMaterialProfileSetUsage {
    constructor(expressID, ForProfileSet, CardinalPoint, ReferenceExtent, ForProfileEndSet, CardinalEndPoint) {
      super(expressID, ForProfileSet, CardinalPoint, ReferenceExtent);
      this.ForProfileSet = ForProfileSet;
      this.CardinalPoint = CardinalPoint;
      this.ReferenceExtent = ReferenceExtent;
      this.ForProfileEndSet = ForProfileEndSet;
      this.CardinalEndPoint = CardinalEndPoint;
      this.type = 3404854881;
    }
  }
  IFC4_32.IfcMaterialProfileSetUsageTapering = IfcMaterialProfileSetUsageTapering;
  class IfcMaterialProperties extends IfcExtendedProperties {
    constructor(expressID, Name, Description, Properties2, Material) {
      super(expressID, Name, Description, Properties2);
      this.Name = Name;
      this.Description = Description;
      this.Properties = Properties2;
      this.Material = Material;
      this.type = 3265635763;
    }
  }
  IFC4_32.IfcMaterialProperties = IfcMaterialProperties;
  class IfcMaterialRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, RelatingMaterial, RelatedMaterials, MaterialExpression) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingMaterial = RelatingMaterial;
      this.RelatedMaterials = RelatedMaterials;
      this.MaterialExpression = MaterialExpression;
      this.type = 853536259;
    }
  }
  IFC4_32.IfcMaterialRelationship = IfcMaterialRelationship;
  class IfcMirroredProfileDef extends IfcDerivedProfileDef {
    constructor(expressID, ProfileType, ProfileName, ParentProfile, Operator, Label) {
      super(expressID, ProfileType, ProfileName, ParentProfile, Operator, Label);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.ParentProfile = ParentProfile;
      this.Operator = Operator;
      this.Label = Label;
      this.type = 2998442950;
    }
  }
  IFC4_32.IfcMirroredProfileDef = IfcMirroredProfileDef;
  class IfcObjectDefinition extends IfcRoot {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 219451334;
    }
  }
  IFC4_32.IfcObjectDefinition = IfcObjectDefinition;
  class IfcOpenCrossProfileDef extends IfcProfileDef {
    constructor(expressID, ProfileType, ProfileName, HorizontalWidths, Widths, Slopes, Tags, OffsetPoint) {
      super(expressID, ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.HorizontalWidths = HorizontalWidths;
      this.Widths = Widths;
      this.Slopes = Slopes;
      this.Tags = Tags;
      this.OffsetPoint = OffsetPoint;
      this.type = 182550632;
    }
  }
  IFC4_32.IfcOpenCrossProfileDef = IfcOpenCrossProfileDef;
  class IfcOpenShell extends IfcConnectedFaceSet {
    constructor(expressID, CfsFaces) {
      super(expressID, CfsFaces);
      this.CfsFaces = CfsFaces;
      this.type = 2665983363;
    }
  }
  IFC4_32.IfcOpenShell = IfcOpenShell;
  class IfcOrganizationRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, RelatingOrganization, RelatedOrganizations) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingOrganization = RelatingOrganization;
      this.RelatedOrganizations = RelatedOrganizations;
      this.type = 1411181986;
    }
  }
  IFC4_32.IfcOrganizationRelationship = IfcOrganizationRelationship;
  class IfcOrientedEdge extends IfcEdge {
    constructor(expressID, EdgeStart, EdgeElement, Orientation) {
      super(expressID, EdgeStart, new Handle(0));
      this.EdgeStart = EdgeStart;
      this.EdgeElement = EdgeElement;
      this.Orientation = Orientation;
      this.type = 1029017970;
    }
  }
  IFC4_32.IfcOrientedEdge = IfcOrientedEdge;
  class IfcParameterizedProfileDef extends IfcProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position) {
      super(expressID, ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.type = 2529465313;
    }
  }
  IFC4_32.IfcParameterizedProfileDef = IfcParameterizedProfileDef;
  class IfcPath extends IfcTopologicalRepresentationItem {
    constructor(expressID, EdgeList) {
      super(expressID);
      this.EdgeList = EdgeList;
      this.type = 2519244187;
    }
  }
  IFC4_32.IfcPath = IfcPath;
  class IfcPhysicalComplexQuantity extends IfcPhysicalQuantity {
    constructor(expressID, Name, Description, HasQuantities, Discrimination, Quality, Usage) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.HasQuantities = HasQuantities;
      this.Discrimination = Discrimination;
      this.Quality = Quality;
      this.Usage = Usage;
      this.type = 3021840470;
    }
  }
  IFC4_32.IfcPhysicalComplexQuantity = IfcPhysicalComplexQuantity;
  class IfcPixelTexture extends IfcSurfaceTexture {
    constructor(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter, Width, Height, ColourComponents, Pixel) {
      super(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.Mode = Mode;
      this.TextureTransform = TextureTransform;
      this.Parameter = Parameter;
      this.Width = Width;
      this.Height = Height;
      this.ColourComponents = ColourComponents;
      this.Pixel = Pixel;
      this.type = 597895409;
    }
  }
  IFC4_32.IfcPixelTexture = IfcPixelTexture;
  class IfcPlacement extends IfcGeometricRepresentationItem {
    constructor(expressID, Location) {
      super(expressID);
      this.Location = Location;
      this.type = 2004835150;
    }
  }
  IFC4_32.IfcPlacement = IfcPlacement;
  class IfcPlanarExtent extends IfcGeometricRepresentationItem {
    constructor(expressID, SizeInX, SizeInY) {
      super(expressID);
      this.SizeInX = SizeInX;
      this.SizeInY = SizeInY;
      this.type = 1663979128;
    }
  }
  IFC4_32.IfcPlanarExtent = IfcPlanarExtent;
  class IfcPoint extends IfcGeometricRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 2067069095;
    }
  }
  IFC4_32.IfcPoint = IfcPoint;
  class IfcPointByDistanceExpression extends IfcPoint {
    constructor(expressID, DistanceAlong, OffsetLateral, OffsetVertical, OffsetLongitudinal, BasisCurve) {
      super(expressID);
      this.DistanceAlong = DistanceAlong;
      this.OffsetLateral = OffsetLateral;
      this.OffsetVertical = OffsetVertical;
      this.OffsetLongitudinal = OffsetLongitudinal;
      this.BasisCurve = BasisCurve;
      this.type = 2165702409;
    }
  }
  IFC4_32.IfcPointByDistanceExpression = IfcPointByDistanceExpression;
  class IfcPointOnCurve extends IfcPoint {
    constructor(expressID, BasisCurve, PointParameter) {
      super(expressID);
      this.BasisCurve = BasisCurve;
      this.PointParameter = PointParameter;
      this.type = 4022376103;
    }
  }
  IFC4_32.IfcPointOnCurve = IfcPointOnCurve;
  class IfcPointOnSurface extends IfcPoint {
    constructor(expressID, BasisSurface, PointParameterU, PointParameterV) {
      super(expressID);
      this.BasisSurface = BasisSurface;
      this.PointParameterU = PointParameterU;
      this.PointParameterV = PointParameterV;
      this.type = 1423911732;
    }
  }
  IFC4_32.IfcPointOnSurface = IfcPointOnSurface;
  class IfcPolyLoop extends IfcLoop {
    constructor(expressID, Polygon) {
      super(expressID);
      this.Polygon = Polygon;
      this.type = 2924175390;
    }
  }
  IFC4_32.IfcPolyLoop = IfcPolyLoop;
  class IfcPolygonalBoundedHalfSpace extends IfcHalfSpaceSolid {
    constructor(expressID, BaseSurface, AgreementFlag, Position, PolygonalBoundary) {
      super(expressID, BaseSurface, AgreementFlag);
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.Position = Position;
      this.PolygonalBoundary = PolygonalBoundary;
      this.type = 2775532180;
    }
  }
  IFC4_32.IfcPolygonalBoundedHalfSpace = IfcPolygonalBoundedHalfSpace;
  class IfcPreDefinedItem extends IfcPresentationItem {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 3727388367;
    }
  }
  IFC4_32.IfcPreDefinedItem = IfcPreDefinedItem;
  class IfcPreDefinedProperties extends IfcPropertyAbstraction {
    constructor(expressID) {
      super(expressID);
      this.type = 3778827333;
    }
  }
  IFC4_32.IfcPreDefinedProperties = IfcPreDefinedProperties;
  class IfcPreDefinedTextFont extends IfcPreDefinedItem {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 1775413392;
    }
  }
  IFC4_32.IfcPreDefinedTextFont = IfcPreDefinedTextFont;
  class IfcProductDefinitionShape extends IfcProductRepresentation {
    constructor(expressID, Name, Description, Representations) {
      super(expressID, Name, Description, Representations);
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.type = 673634403;
    }
  }
  IFC4_32.IfcProductDefinitionShape = IfcProductDefinitionShape;
  class IfcProfileProperties extends IfcExtendedProperties {
    constructor(expressID, Name, Description, Properties2, ProfileDefinition) {
      super(expressID, Name, Description, Properties2);
      this.Name = Name;
      this.Description = Description;
      this.Properties = Properties2;
      this.ProfileDefinition = ProfileDefinition;
      this.type = 2802850158;
    }
  }
  IFC4_32.IfcProfileProperties = IfcProfileProperties;
  class IfcProperty extends IfcPropertyAbstraction {
    constructor(expressID, Name, Specification) {
      super(expressID);
      this.Name = Name;
      this.Specification = Specification;
      this.type = 2598011224;
    }
  }
  IFC4_32.IfcProperty = IfcProperty;
  class IfcPropertyDefinition extends IfcRoot {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 1680319473;
    }
  }
  IFC4_32.IfcPropertyDefinition = IfcPropertyDefinition;
  class IfcPropertyDependencyRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, DependingProperty, DependantProperty, Expression) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.DependingProperty = DependingProperty;
      this.DependantProperty = DependantProperty;
      this.Expression = Expression;
      this.type = 148025276;
    }
  }
  IFC4_32.IfcPropertyDependencyRelationship = IfcPropertyDependencyRelationship;
  class IfcPropertySetDefinition extends IfcPropertyDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 3357820518;
    }
  }
  IFC4_32.IfcPropertySetDefinition = IfcPropertySetDefinition;
  class IfcPropertyTemplateDefinition extends IfcPropertyDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 1482703590;
    }
  }
  IFC4_32.IfcPropertyTemplateDefinition = IfcPropertyTemplateDefinition;
  class IfcQuantitySet extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 2090586900;
    }
  }
  IFC4_32.IfcQuantitySet = IfcQuantitySet;
  class IfcRectangleProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, XDim, YDim) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.type = 3615266464;
    }
  }
  IFC4_32.IfcRectangleProfileDef = IfcRectangleProfileDef;
  class IfcRegularTimeSeries extends IfcTimeSeries {
    constructor(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, TimeStep, Values) {
      super(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.TimeStep = TimeStep;
      this.Values = Values;
      this.type = 3413951693;
    }
  }
  IFC4_32.IfcRegularTimeSeries = IfcRegularTimeSeries;
  class IfcReinforcementBarProperties extends IfcPreDefinedProperties {
    constructor(expressID, TotalCrossSectionArea, SteelGrade, BarSurface, EffectiveDepth, NominalBarDiameter, BarCount) {
      super(expressID);
      this.TotalCrossSectionArea = TotalCrossSectionArea;
      this.SteelGrade = SteelGrade;
      this.BarSurface = BarSurface;
      this.EffectiveDepth = EffectiveDepth;
      this.NominalBarDiameter = NominalBarDiameter;
      this.BarCount = BarCount;
      this.type = 1580146022;
    }
  }
  IFC4_32.IfcReinforcementBarProperties = IfcReinforcementBarProperties;
  class IfcRelationship extends IfcRoot {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 478536968;
    }
  }
  IFC4_32.IfcRelationship = IfcRelationship;
  class IfcResourceApprovalRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, RelatedResourceObjects, RelatingApproval) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatedResourceObjects = RelatedResourceObjects;
      this.RelatingApproval = RelatingApproval;
      this.type = 2943643501;
    }
  }
  IFC4_32.IfcResourceApprovalRelationship = IfcResourceApprovalRelationship;
  class IfcResourceConstraintRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, RelatingConstraint, RelatedResourceObjects) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingConstraint = RelatingConstraint;
      this.RelatedResourceObjects = RelatedResourceObjects;
      this.type = 1608871552;
    }
  }
  IFC4_32.IfcResourceConstraintRelationship = IfcResourceConstraintRelationship;
  class IfcResourceTime extends IfcSchedulingTime {
    constructor(expressID, Name, DataOrigin, UserDefinedDataOrigin, ScheduleWork, ScheduleUsage, ScheduleStart, ScheduleFinish, ScheduleContour, LevelingDelay, IsOverAllocated, StatusTime, ActualWork, ActualUsage, ActualStart, ActualFinish, RemainingWork, RemainingUsage, Completion) {
      super(expressID, Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.ScheduleWork = ScheduleWork;
      this.ScheduleUsage = ScheduleUsage;
      this.ScheduleStart = ScheduleStart;
      this.ScheduleFinish = ScheduleFinish;
      this.ScheduleContour = ScheduleContour;
      this.LevelingDelay = LevelingDelay;
      this.IsOverAllocated = IsOverAllocated;
      this.StatusTime = StatusTime;
      this.ActualWork = ActualWork;
      this.ActualUsage = ActualUsage;
      this.ActualStart = ActualStart;
      this.ActualFinish = ActualFinish;
      this.RemainingWork = RemainingWork;
      this.RemainingUsage = RemainingUsage;
      this.Completion = Completion;
      this.type = 1042787934;
    }
  }
  IFC4_32.IfcResourceTime = IfcResourceTime;
  class IfcRoundedRectangleProfileDef extends IfcRectangleProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, XDim, YDim, RoundingRadius) {
      super(expressID, ProfileType, ProfileName, Position, XDim, YDim);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.RoundingRadius = RoundingRadius;
      this.type = 2778083089;
    }
  }
  IFC4_32.IfcRoundedRectangleProfileDef = IfcRoundedRectangleProfileDef;
  class IfcSectionProperties extends IfcPreDefinedProperties {
    constructor(expressID, SectionType, StartProfile, EndProfile) {
      super(expressID);
      this.SectionType = SectionType;
      this.StartProfile = StartProfile;
      this.EndProfile = EndProfile;
      this.type = 2042790032;
    }
  }
  IFC4_32.IfcSectionProperties = IfcSectionProperties;
  class IfcSectionReinforcementProperties extends IfcPreDefinedProperties {
    constructor(expressID, LongitudinalStartPosition, LongitudinalEndPosition, TransversePosition, ReinforcementRole, SectionDefinition, CrossSectionReinforcementDefinitions) {
      super(expressID);
      this.LongitudinalStartPosition = LongitudinalStartPosition;
      this.LongitudinalEndPosition = LongitudinalEndPosition;
      this.TransversePosition = TransversePosition;
      this.ReinforcementRole = ReinforcementRole;
      this.SectionDefinition = SectionDefinition;
      this.CrossSectionReinforcementDefinitions = CrossSectionReinforcementDefinitions;
      this.type = 4165799628;
    }
  }
  IFC4_32.IfcSectionReinforcementProperties = IfcSectionReinforcementProperties;
  class IfcSectionedSpine extends IfcGeometricRepresentationItem {
    constructor(expressID, SpineCurve, CrossSections, CrossSectionPositions) {
      super(expressID);
      this.SpineCurve = SpineCurve;
      this.CrossSections = CrossSections;
      this.CrossSectionPositions = CrossSectionPositions;
      this.type = 1509187699;
    }
  }
  IFC4_32.IfcSectionedSpine = IfcSectionedSpine;
  class IfcSegment extends IfcGeometricRepresentationItem {
    constructor(expressID, Transition) {
      super(expressID);
      this.Transition = Transition;
      this.type = 823603102;
    }
  }
  IFC4_32.IfcSegment = IfcSegment;
  class IfcShellBasedSurfaceModel extends IfcGeometricRepresentationItem {
    constructor(expressID, SbsmBoundary) {
      super(expressID);
      this.SbsmBoundary = SbsmBoundary;
      this.type = 4124623270;
    }
  }
  IFC4_32.IfcShellBasedSurfaceModel = IfcShellBasedSurfaceModel;
  class IfcSimpleProperty extends IfcProperty {
    constructor(expressID, Name, Specification) {
      super(expressID, Name, Specification);
      this.Name = Name;
      this.Specification = Specification;
      this.type = 3692461612;
    }
  }
  IFC4_32.IfcSimpleProperty = IfcSimpleProperty;
  class IfcSlippageConnectionCondition extends IfcStructuralConnectionCondition {
    constructor(expressID, Name, SlippageX, SlippageY, SlippageZ) {
      super(expressID, Name);
      this.Name = Name;
      this.SlippageX = SlippageX;
      this.SlippageY = SlippageY;
      this.SlippageZ = SlippageZ;
      this.type = 2609359061;
    }
  }
  IFC4_32.IfcSlippageConnectionCondition = IfcSlippageConnectionCondition;
  class IfcSolidModel extends IfcGeometricRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 723233188;
    }
  }
  IFC4_32.IfcSolidModel = IfcSolidModel;
  class IfcStructuralLoadLinearForce extends IfcStructuralLoadStatic {
    constructor(expressID, Name, LinearForceX, LinearForceY, LinearForceZ, LinearMomentX, LinearMomentY, LinearMomentZ) {
      super(expressID, Name);
      this.Name = Name;
      this.LinearForceX = LinearForceX;
      this.LinearForceY = LinearForceY;
      this.LinearForceZ = LinearForceZ;
      this.LinearMomentX = LinearMomentX;
      this.LinearMomentY = LinearMomentY;
      this.LinearMomentZ = LinearMomentZ;
      this.type = 1595516126;
    }
  }
  IFC4_32.IfcStructuralLoadLinearForce = IfcStructuralLoadLinearForce;
  class IfcStructuralLoadPlanarForce extends IfcStructuralLoadStatic {
    constructor(expressID, Name, PlanarForceX, PlanarForceY, PlanarForceZ) {
      super(expressID, Name);
      this.Name = Name;
      this.PlanarForceX = PlanarForceX;
      this.PlanarForceY = PlanarForceY;
      this.PlanarForceZ = PlanarForceZ;
      this.type = 2668620305;
    }
  }
  IFC4_32.IfcStructuralLoadPlanarForce = IfcStructuralLoadPlanarForce;
  class IfcStructuralLoadSingleDisplacement extends IfcStructuralLoadStatic {
    constructor(expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ) {
      super(expressID, Name);
      this.Name = Name;
      this.DisplacementX = DisplacementX;
      this.DisplacementY = DisplacementY;
      this.DisplacementZ = DisplacementZ;
      this.RotationalDisplacementRX = RotationalDisplacementRX;
      this.RotationalDisplacementRY = RotationalDisplacementRY;
      this.RotationalDisplacementRZ = RotationalDisplacementRZ;
      this.type = 2473145415;
    }
  }
  IFC4_32.IfcStructuralLoadSingleDisplacement = IfcStructuralLoadSingleDisplacement;
  class IfcStructuralLoadSingleDisplacementDistortion extends IfcStructuralLoadSingleDisplacement {
    constructor(expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ, Distortion) {
      super(expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ);
      this.Name = Name;
      this.DisplacementX = DisplacementX;
      this.DisplacementY = DisplacementY;
      this.DisplacementZ = DisplacementZ;
      this.RotationalDisplacementRX = RotationalDisplacementRX;
      this.RotationalDisplacementRY = RotationalDisplacementRY;
      this.RotationalDisplacementRZ = RotationalDisplacementRZ;
      this.Distortion = Distortion;
      this.type = 1973038258;
    }
  }
  IFC4_32.IfcStructuralLoadSingleDisplacementDistortion = IfcStructuralLoadSingleDisplacementDistortion;
  class IfcStructuralLoadSingleForce extends IfcStructuralLoadStatic {
    constructor(expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ) {
      super(expressID, Name);
      this.Name = Name;
      this.ForceX = ForceX;
      this.ForceY = ForceY;
      this.ForceZ = ForceZ;
      this.MomentX = MomentX;
      this.MomentY = MomentY;
      this.MomentZ = MomentZ;
      this.type = 1597423693;
    }
  }
  IFC4_32.IfcStructuralLoadSingleForce = IfcStructuralLoadSingleForce;
  class IfcStructuralLoadSingleForceWarping extends IfcStructuralLoadSingleForce {
    constructor(expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ, WarpingMoment) {
      super(expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ);
      this.Name = Name;
      this.ForceX = ForceX;
      this.ForceY = ForceY;
      this.ForceZ = ForceZ;
      this.MomentX = MomentX;
      this.MomentY = MomentY;
      this.MomentZ = MomentZ;
      this.WarpingMoment = WarpingMoment;
      this.type = 1190533807;
    }
  }
  IFC4_32.IfcStructuralLoadSingleForceWarping = IfcStructuralLoadSingleForceWarping;
  class IfcSubedge extends IfcEdge {
    constructor(expressID, EdgeStart, EdgeEnd, ParentEdge) {
      super(expressID, EdgeStart, EdgeEnd);
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.ParentEdge = ParentEdge;
      this.type = 2233826070;
    }
  }
  IFC4_32.IfcSubedge = IfcSubedge;
  class IfcSurface extends IfcGeometricRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 2513912981;
    }
  }
  IFC4_32.IfcSurface = IfcSurface;
  class IfcSurfaceStyleRendering extends IfcSurfaceStyleShading {
    constructor(expressID, SurfaceColour, Transparency, DiffuseColour, TransmissionColour, DiffuseTransmissionColour, ReflectionColour, SpecularColour, SpecularHighlight, ReflectanceMethod) {
      super(expressID, SurfaceColour, Transparency);
      this.SurfaceColour = SurfaceColour;
      this.Transparency = Transparency;
      this.DiffuseColour = DiffuseColour;
      this.TransmissionColour = TransmissionColour;
      this.DiffuseTransmissionColour = DiffuseTransmissionColour;
      this.ReflectionColour = ReflectionColour;
      this.SpecularColour = SpecularColour;
      this.SpecularHighlight = SpecularHighlight;
      this.ReflectanceMethod = ReflectanceMethod;
      this.type = 1878645084;
    }
  }
  IFC4_32.IfcSurfaceStyleRendering = IfcSurfaceStyleRendering;
  class IfcSweptAreaSolid extends IfcSolidModel {
    constructor(expressID, SweptArea, Position) {
      super(expressID);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.type = 2247615214;
    }
  }
  IFC4_32.IfcSweptAreaSolid = IfcSweptAreaSolid;
  class IfcSweptDiskSolid extends IfcSolidModel {
    constructor(expressID, Directrix, Radius, InnerRadius, StartParam, EndParam) {
      super(expressID);
      this.Directrix = Directrix;
      this.Radius = Radius;
      this.InnerRadius = InnerRadius;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.type = 1260650574;
    }
  }
  IFC4_32.IfcSweptDiskSolid = IfcSweptDiskSolid;
  class IfcSweptDiskSolidPolygonal extends IfcSweptDiskSolid {
    constructor(expressID, Directrix, Radius, InnerRadius, StartParam, EndParam, FilletRadius) {
      super(expressID, Directrix, Radius, InnerRadius, StartParam, EndParam);
      this.Directrix = Directrix;
      this.Radius = Radius;
      this.InnerRadius = InnerRadius;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.FilletRadius = FilletRadius;
      this.type = 1096409881;
    }
  }
  IFC4_32.IfcSweptDiskSolidPolygonal = IfcSweptDiskSolidPolygonal;
  class IfcSweptSurface extends IfcSurface {
    constructor(expressID, SweptCurve, Position) {
      super(expressID);
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.type = 230924584;
    }
  }
  IFC4_32.IfcSweptSurface = IfcSweptSurface;
  class IfcTShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, WebEdgeRadius, WebSlope, FlangeSlope) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.FlangeEdgeRadius = FlangeEdgeRadius;
      this.WebEdgeRadius = WebEdgeRadius;
      this.WebSlope = WebSlope;
      this.FlangeSlope = FlangeSlope;
      this.type = 3071757647;
    }
  }
  IFC4_32.IfcTShapeProfileDef = IfcTShapeProfileDef;
  class IfcTessellatedItem extends IfcGeometricRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 901063453;
    }
  }
  IFC4_32.IfcTessellatedItem = IfcTessellatedItem;
  class IfcTextLiteral extends IfcGeometricRepresentationItem {
    constructor(expressID, Literal, Placement, Path) {
      super(expressID);
      this.Literal = Literal;
      this.Placement = Placement;
      this.Path = Path;
      this.type = 4282788508;
    }
  }
  IFC4_32.IfcTextLiteral = IfcTextLiteral;
  class IfcTextLiteralWithExtent extends IfcTextLiteral {
    constructor(expressID, Literal, Placement, Path, Extent, BoxAlignment) {
      super(expressID, Literal, Placement, Path);
      this.Literal = Literal;
      this.Placement = Placement;
      this.Path = Path;
      this.Extent = Extent;
      this.BoxAlignment = BoxAlignment;
      this.type = 3124975700;
    }
  }
  IFC4_32.IfcTextLiteralWithExtent = IfcTextLiteralWithExtent;
  class IfcTextStyleFontModel extends IfcPreDefinedTextFont {
    constructor(expressID, Name, FontFamily, FontStyle, FontVariant, FontWeight, FontSize) {
      super(expressID, Name);
      this.Name = Name;
      this.FontFamily = FontFamily;
      this.FontStyle = FontStyle;
      this.FontVariant = FontVariant;
      this.FontWeight = FontWeight;
      this.FontSize = FontSize;
      this.type = 1983826977;
    }
  }
  IFC4_32.IfcTextStyleFontModel = IfcTextStyleFontModel;
  class IfcTrapeziumProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, BottomXDim, TopXDim, YDim, TopXOffset) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.BottomXDim = BottomXDim;
      this.TopXDim = TopXDim;
      this.YDim = YDim;
      this.TopXOffset = TopXOffset;
      this.type = 2715220739;
    }
  }
  IFC4_32.IfcTrapeziumProfileDef = IfcTrapeziumProfileDef;
  class IfcTypeObject extends IfcObjectDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.type = 1628702193;
    }
  }
  IFC4_32.IfcTypeObject = IfcTypeObject;
  class IfcTypeProcess extends IfcTypeObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ProcessType = ProcessType;
      this.type = 3736923433;
    }
  }
  IFC4_32.IfcTypeProcess = IfcTypeProcess;
  class IfcTypeProduct extends IfcTypeObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.type = 2347495698;
    }
  }
  IFC4_32.IfcTypeProduct = IfcTypeProduct;
  class IfcTypeResource extends IfcTypeObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.type = 3698973494;
    }
  }
  IFC4_32.IfcTypeResource = IfcTypeResource;
  class IfcUShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius, FlangeSlope) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.FlangeSlope = FlangeSlope;
      this.type = 427810014;
    }
  }
  IFC4_32.IfcUShapeProfileDef = IfcUShapeProfileDef;
  class IfcVector extends IfcGeometricRepresentationItem {
    constructor(expressID, Orientation, Magnitude) {
      super(expressID);
      this.Orientation = Orientation;
      this.Magnitude = Magnitude;
      this.type = 1417489154;
    }
  }
  IFC4_32.IfcVector = IfcVector;
  class IfcVertexLoop extends IfcLoop {
    constructor(expressID, LoopVertex) {
      super(expressID);
      this.LoopVertex = LoopVertex;
      this.type = 2759199220;
    }
  }
  IFC4_32.IfcVertexLoop = IfcVertexLoop;
  class IfcZShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.type = 2543172580;
    }
  }
  IFC4_32.IfcZShapeProfileDef = IfcZShapeProfileDef;
  class IfcAdvancedFace extends IfcFaceSurface {
    constructor(expressID, Bounds, FaceSurface, SameSense) {
      super(expressID, Bounds, FaceSurface, SameSense);
      this.Bounds = Bounds;
      this.FaceSurface = FaceSurface;
      this.SameSense = SameSense;
      this.type = 3406155212;
    }
  }
  IFC4_32.IfcAdvancedFace = IfcAdvancedFace;
  class IfcAnnotationFillArea extends IfcGeometricRepresentationItem {
    constructor(expressID, OuterBoundary, InnerBoundaries) {
      super(expressID);
      this.OuterBoundary = OuterBoundary;
      this.InnerBoundaries = InnerBoundaries;
      this.type = 669184980;
    }
  }
  IFC4_32.IfcAnnotationFillArea = IfcAnnotationFillArea;
  class IfcAsymmetricIShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, BottomFlangeWidth, OverallDepth, WebThickness, BottomFlangeThickness, BottomFlangeFilletRadius, TopFlangeWidth, TopFlangeThickness, TopFlangeFilletRadius, BottomFlangeEdgeRadius, BottomFlangeSlope, TopFlangeEdgeRadius, TopFlangeSlope) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.BottomFlangeWidth = BottomFlangeWidth;
      this.OverallDepth = OverallDepth;
      this.WebThickness = WebThickness;
      this.BottomFlangeThickness = BottomFlangeThickness;
      this.BottomFlangeFilletRadius = BottomFlangeFilletRadius;
      this.TopFlangeWidth = TopFlangeWidth;
      this.TopFlangeThickness = TopFlangeThickness;
      this.TopFlangeFilletRadius = TopFlangeFilletRadius;
      this.BottomFlangeEdgeRadius = BottomFlangeEdgeRadius;
      this.BottomFlangeSlope = BottomFlangeSlope;
      this.TopFlangeEdgeRadius = TopFlangeEdgeRadius;
      this.TopFlangeSlope = TopFlangeSlope;
      this.type = 3207858831;
    }
  }
  IFC4_32.IfcAsymmetricIShapeProfileDef = IfcAsymmetricIShapeProfileDef;
  class IfcAxis1Placement extends IfcPlacement {
    constructor(expressID, Location, Axis) {
      super(expressID, Location);
      this.Location = Location;
      this.Axis = Axis;
      this.type = 4261334040;
    }
  }
  IFC4_32.IfcAxis1Placement = IfcAxis1Placement;
  class IfcAxis2Placement2D extends IfcPlacement {
    constructor(expressID, Location, RefDirection) {
      super(expressID, Location);
      this.Location = Location;
      this.RefDirection = RefDirection;
      this.type = 3125803723;
    }
  }
  IFC4_32.IfcAxis2Placement2D = IfcAxis2Placement2D;
  class IfcAxis2Placement3D extends IfcPlacement {
    constructor(expressID, Location, Axis, RefDirection) {
      super(expressID, Location);
      this.Location = Location;
      this.Axis = Axis;
      this.RefDirection = RefDirection;
      this.type = 2740243338;
    }
  }
  IFC4_32.IfcAxis2Placement3D = IfcAxis2Placement3D;
  class IfcAxis2PlacementLinear extends IfcPlacement {
    constructor(expressID, Location, Axis, RefDirection) {
      super(expressID, Location);
      this.Location = Location;
      this.Axis = Axis;
      this.RefDirection = RefDirection;
      this.type = 3425423356;
    }
  }
  IFC4_32.IfcAxis2PlacementLinear = IfcAxis2PlacementLinear;
  class IfcBooleanResult extends IfcGeometricRepresentationItem {
    constructor(expressID, Operator, FirstOperand, SecondOperand) {
      super(expressID);
      this.Operator = Operator;
      this.FirstOperand = FirstOperand;
      this.SecondOperand = SecondOperand;
      this.type = 2736907675;
    }
  }
  IFC4_32.IfcBooleanResult = IfcBooleanResult;
  class IfcBoundedSurface extends IfcSurface {
    constructor(expressID) {
      super(expressID);
      this.type = 4182860854;
    }
  }
  IFC4_32.IfcBoundedSurface = IfcBoundedSurface;
  class IfcBoundingBox extends IfcGeometricRepresentationItem {
    constructor(expressID, Corner, XDim, YDim, ZDim) {
      super(expressID);
      this.Corner = Corner;
      this.XDim = XDim;
      this.YDim = YDim;
      this.ZDim = ZDim;
      this.type = 2581212453;
    }
  }
  IFC4_32.IfcBoundingBox = IfcBoundingBox;
  class IfcBoxedHalfSpace extends IfcHalfSpaceSolid {
    constructor(expressID, BaseSurface, AgreementFlag, Enclosure) {
      super(expressID, BaseSurface, AgreementFlag);
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.Enclosure = Enclosure;
      this.type = 2713105998;
    }
  }
  IFC4_32.IfcBoxedHalfSpace = IfcBoxedHalfSpace;
  class IfcCShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Depth, Width, WallThickness, Girth, InternalFilletRadius) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.Width = Width;
      this.WallThickness = WallThickness;
      this.Girth = Girth;
      this.InternalFilletRadius = InternalFilletRadius;
      this.type = 2898889636;
    }
  }
  IFC4_32.IfcCShapeProfileDef = IfcCShapeProfileDef;
  class IfcCartesianPoint extends IfcPoint {
    constructor(expressID, Coordinates) {
      super(expressID);
      this.Coordinates = Coordinates;
      this.type = 1123145078;
    }
  }
  IFC4_32.IfcCartesianPoint = IfcCartesianPoint;
  class IfcCartesianPointList extends IfcGeometricRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 574549367;
    }
  }
  IFC4_32.IfcCartesianPointList = IfcCartesianPointList;
  class IfcCartesianPointList2D extends IfcCartesianPointList {
    constructor(expressID, CoordList, TagList) {
      super(expressID);
      this.CoordList = CoordList;
      this.TagList = TagList;
      this.type = 1675464909;
    }
  }
  IFC4_32.IfcCartesianPointList2D = IfcCartesianPointList2D;
  class IfcCartesianPointList3D extends IfcCartesianPointList {
    constructor(expressID, CoordList, TagList) {
      super(expressID);
      this.CoordList = CoordList;
      this.TagList = TagList;
      this.type = 2059837836;
    }
  }
  IFC4_32.IfcCartesianPointList3D = IfcCartesianPointList3D;
  class IfcCartesianTransformationOperator extends IfcGeometricRepresentationItem {
    constructor(expressID, Axis1, Axis2, LocalOrigin, Scale) {
      super(expressID);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.type = 59481748;
    }
  }
  IFC4_32.IfcCartesianTransformationOperator = IfcCartesianTransformationOperator;
  class IfcCartesianTransformationOperator2D extends IfcCartesianTransformationOperator {
    constructor(expressID, Axis1, Axis2, LocalOrigin, Scale) {
      super(expressID, Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.type = 3749851601;
    }
  }
  IFC4_32.IfcCartesianTransformationOperator2D = IfcCartesianTransformationOperator2D;
  class IfcCartesianTransformationOperator2DnonUniform extends IfcCartesianTransformationOperator2D {
    constructor(expressID, Axis1, Axis2, LocalOrigin, Scale, Scale2) {
      super(expressID, Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Scale2 = Scale2;
      this.type = 3486308946;
    }
  }
  IFC4_32.IfcCartesianTransformationOperator2DnonUniform = IfcCartesianTransformationOperator2DnonUniform;
  class IfcCartesianTransformationOperator3D extends IfcCartesianTransformationOperator {
    constructor(expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3) {
      super(expressID, Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Axis3 = Axis3;
      this.type = 3331915920;
    }
  }
  IFC4_32.IfcCartesianTransformationOperator3D = IfcCartesianTransformationOperator3D;
  class IfcCartesianTransformationOperator3DnonUniform extends IfcCartesianTransformationOperator3D {
    constructor(expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3, Scale2, Scale3) {
      super(expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Axis3 = Axis3;
      this.Scale2 = Scale2;
      this.Scale3 = Scale3;
      this.type = 1416205885;
    }
  }
  IFC4_32.IfcCartesianTransformationOperator3DnonUniform = IfcCartesianTransformationOperator3DnonUniform;
  class IfcCircleProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Radius) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Radius = Radius;
      this.type = 1383045692;
    }
  }
  IFC4_32.IfcCircleProfileDef = IfcCircleProfileDef;
  class IfcClosedShell extends IfcConnectedFaceSet {
    constructor(expressID, CfsFaces) {
      super(expressID, CfsFaces);
      this.CfsFaces = CfsFaces;
      this.type = 2205249479;
    }
  }
  IFC4_32.IfcClosedShell = IfcClosedShell;
  class IfcColourRgb extends IfcColourSpecification {
    constructor(expressID, Name, Red, Green, Blue) {
      super(expressID, Name);
      this.Name = Name;
      this.Red = Red;
      this.Green = Green;
      this.Blue = Blue;
      this.type = 776857604;
    }
  }
  IFC4_32.IfcColourRgb = IfcColourRgb;
  class IfcComplexProperty extends IfcProperty {
    constructor(expressID, Name, Specification, UsageName, HasProperties) {
      super(expressID, Name, Specification);
      this.Name = Name;
      this.Specification = Specification;
      this.UsageName = UsageName;
      this.HasProperties = HasProperties;
      this.type = 2542286263;
    }
  }
  IFC4_32.IfcComplexProperty = IfcComplexProperty;
  class IfcCompositeCurveSegment extends IfcSegment {
    constructor(expressID, Transition, SameSense, ParentCurve) {
      super(expressID, Transition);
      this.Transition = Transition;
      this.SameSense = SameSense;
      this.ParentCurve = ParentCurve;
      this.type = 2485617015;
    }
  }
  IFC4_32.IfcCompositeCurveSegment = IfcCompositeCurveSegment;
  class IfcConstructionResourceType extends IfcTypeResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.type = 2574617495;
    }
  }
  IFC4_32.IfcConstructionResourceType = IfcConstructionResourceType;
  class IfcContext extends IfcObjectDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.Phase = Phase;
      this.RepresentationContexts = RepresentationContexts;
      this.UnitsInContext = UnitsInContext;
      this.type = 3419103109;
    }
  }
  IFC4_32.IfcContext = IfcContext;
  class IfcCrewResourceType extends IfcConstructionResourceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 1815067380;
    }
  }
  IFC4_32.IfcCrewResourceType = IfcCrewResourceType;
  class IfcCsgPrimitive3D extends IfcGeometricRepresentationItem {
    constructor(expressID, Position) {
      super(expressID);
      this.Position = Position;
      this.type = 2506170314;
    }
  }
  IFC4_32.IfcCsgPrimitive3D = IfcCsgPrimitive3D;
  class IfcCsgSolid extends IfcSolidModel {
    constructor(expressID, TreeRootExpression) {
      super(expressID);
      this.TreeRootExpression = TreeRootExpression;
      this.type = 2147822146;
    }
  }
  IFC4_32.IfcCsgSolid = IfcCsgSolid;
  class IfcCurve extends IfcGeometricRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 2601014836;
    }
  }
  IFC4_32.IfcCurve = IfcCurve;
  class IfcCurveBoundedPlane extends IfcBoundedSurface {
    constructor(expressID, BasisSurface, OuterBoundary, InnerBoundaries) {
      super(expressID);
      this.BasisSurface = BasisSurface;
      this.OuterBoundary = OuterBoundary;
      this.InnerBoundaries = InnerBoundaries;
      this.type = 2827736869;
    }
  }
  IFC4_32.IfcCurveBoundedPlane = IfcCurveBoundedPlane;
  class IfcCurveBoundedSurface extends IfcBoundedSurface {
    constructor(expressID, BasisSurface, Boundaries, ImplicitOuter) {
      super(expressID);
      this.BasisSurface = BasisSurface;
      this.Boundaries = Boundaries;
      this.ImplicitOuter = ImplicitOuter;
      this.type = 2629017746;
    }
  }
  IFC4_32.IfcCurveBoundedSurface = IfcCurveBoundedSurface;
  class IfcCurveSegment extends IfcSegment {
    constructor(expressID, Transition, Placement, SegmentStart, SegmentLength, ParentCurve) {
      super(expressID, Transition);
      this.Transition = Transition;
      this.Placement = Placement;
      this.SegmentStart = SegmentStart;
      this.SegmentLength = SegmentLength;
      this.ParentCurve = ParentCurve;
      this.type = 4212018352;
    }
  }
  IFC4_32.IfcCurveSegment = IfcCurveSegment;
  class IfcDirection extends IfcGeometricRepresentationItem {
    constructor(expressID, DirectionRatios) {
      super(expressID);
      this.DirectionRatios = DirectionRatios;
      this.type = 32440307;
    }
  }
  IFC4_32.IfcDirection = IfcDirection;
  class IfcDirectrixCurveSweptAreaSolid extends IfcSweptAreaSolid {
    constructor(expressID, SweptArea, Position, Directrix, StartParam, EndParam) {
      super(expressID, SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Directrix = Directrix;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.type = 593015953;
    }
  }
  IFC4_32.IfcDirectrixCurveSweptAreaSolid = IfcDirectrixCurveSweptAreaSolid;
  class IfcEdgeLoop extends IfcLoop {
    constructor(expressID, EdgeList) {
      super(expressID);
      this.EdgeList = EdgeList;
      this.type = 1472233963;
    }
  }
  IFC4_32.IfcEdgeLoop = IfcEdgeLoop;
  class IfcElementQuantity extends IfcQuantitySet {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, MethodOfMeasurement, Quantities) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.MethodOfMeasurement = MethodOfMeasurement;
      this.Quantities = Quantities;
      this.type = 1883228015;
    }
  }
  IFC4_32.IfcElementQuantity = IfcElementQuantity;
  class IfcElementType extends IfcTypeProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 339256511;
    }
  }
  IFC4_32.IfcElementType = IfcElementType;
  class IfcElementarySurface extends IfcSurface {
    constructor(expressID, Position) {
      super(expressID);
      this.Position = Position;
      this.type = 2777663545;
    }
  }
  IFC4_32.IfcElementarySurface = IfcElementarySurface;
  class IfcEllipseProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, SemiAxis1, SemiAxis2) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.SemiAxis1 = SemiAxis1;
      this.SemiAxis2 = SemiAxis2;
      this.type = 2835456948;
    }
  }
  IFC4_32.IfcEllipseProfileDef = IfcEllipseProfileDef;
  class IfcEventType extends IfcTypeProcess {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType, EventTriggerType, UserDefinedEventTriggerType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ProcessType = ProcessType;
      this.PredefinedType = PredefinedType;
      this.EventTriggerType = EventTriggerType;
      this.UserDefinedEventTriggerType = UserDefinedEventTriggerType;
      this.type = 4024345920;
    }
  }
  IFC4_32.IfcEventType = IfcEventType;
  class IfcExtrudedAreaSolid extends IfcSweptAreaSolid {
    constructor(expressID, SweptArea, Position, ExtrudedDirection, Depth) {
      super(expressID, SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.ExtrudedDirection = ExtrudedDirection;
      this.Depth = Depth;
      this.type = 477187591;
    }
  }
  IFC4_32.IfcExtrudedAreaSolid = IfcExtrudedAreaSolid;
  class IfcExtrudedAreaSolidTapered extends IfcExtrudedAreaSolid {
    constructor(expressID, SweptArea, Position, ExtrudedDirection, Depth, EndSweptArea) {
      super(expressID, SweptArea, Position, ExtrudedDirection, Depth);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.ExtrudedDirection = ExtrudedDirection;
      this.Depth = Depth;
      this.EndSweptArea = EndSweptArea;
      this.type = 2804161546;
    }
  }
  IFC4_32.IfcExtrudedAreaSolidTapered = IfcExtrudedAreaSolidTapered;
  class IfcFaceBasedSurfaceModel extends IfcGeometricRepresentationItem {
    constructor(expressID, FbsmFaces) {
      super(expressID);
      this.FbsmFaces = FbsmFaces;
      this.type = 2047409740;
    }
  }
  IFC4_32.IfcFaceBasedSurfaceModel = IfcFaceBasedSurfaceModel;
  class IfcFillAreaStyleHatching extends IfcGeometricRepresentationItem {
    constructor(expressID, HatchLineAppearance, StartOfNextHatchLine, PointOfReferenceHatchLine, PatternStart, HatchLineAngle) {
      super(expressID);
      this.HatchLineAppearance = HatchLineAppearance;
      this.StartOfNextHatchLine = StartOfNextHatchLine;
      this.PointOfReferenceHatchLine = PointOfReferenceHatchLine;
      this.PatternStart = PatternStart;
      this.HatchLineAngle = HatchLineAngle;
      this.type = 374418227;
    }
  }
  IFC4_32.IfcFillAreaStyleHatching = IfcFillAreaStyleHatching;
  class IfcFillAreaStyleTiles extends IfcGeometricRepresentationItem {
    constructor(expressID, TilingPattern, Tiles, TilingScale) {
      super(expressID);
      this.TilingPattern = TilingPattern;
      this.Tiles = Tiles;
      this.TilingScale = TilingScale;
      this.type = 315944413;
    }
  }
  IFC4_32.IfcFillAreaStyleTiles = IfcFillAreaStyleTiles;
  class IfcFixedReferenceSweptAreaSolid extends IfcDirectrixCurveSweptAreaSolid {
    constructor(expressID, SweptArea, Position, Directrix, StartParam, EndParam, FixedReference) {
      super(expressID, SweptArea, Position, Directrix, StartParam, EndParam);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Directrix = Directrix;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.FixedReference = FixedReference;
      this.type = 2652556860;
    }
  }
  IFC4_32.IfcFixedReferenceSweptAreaSolid = IfcFixedReferenceSweptAreaSolid;
  class IfcFurnishingElementType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 4238390223;
    }
  }
  IFC4_32.IfcFurnishingElementType = IfcFurnishingElementType;
  class IfcFurnitureType extends IfcFurnishingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, AssemblyPlace, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.AssemblyPlace = AssemblyPlace;
      this.PredefinedType = PredefinedType;
      this.type = 1268542332;
    }
  }
  IFC4_32.IfcFurnitureType = IfcFurnitureType;
  class IfcGeographicElementType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4095422895;
    }
  }
  IFC4_32.IfcGeographicElementType = IfcGeographicElementType;
  class IfcGeometricCurveSet extends IfcGeometricSet {
    constructor(expressID, Elements) {
      super(expressID, Elements);
      this.Elements = Elements;
      this.type = 987898635;
    }
  }
  IFC4_32.IfcGeometricCurveSet = IfcGeometricCurveSet;
  class IfcIShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, FlangeSlope) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.OverallWidth = OverallWidth;
      this.OverallDepth = OverallDepth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.FlangeEdgeRadius = FlangeEdgeRadius;
      this.FlangeSlope = FlangeSlope;
      this.type = 1484403080;
    }
  }
  IFC4_32.IfcIShapeProfileDef = IfcIShapeProfileDef;
  class IfcIndexedPolygonalFace extends IfcTessellatedItem {
    constructor(expressID, CoordIndex) {
      super(expressID);
      this.CoordIndex = CoordIndex;
      this.type = 178912537;
    }
  }
  IFC4_32.IfcIndexedPolygonalFace = IfcIndexedPolygonalFace;
  class IfcIndexedPolygonalFaceWithVoids extends IfcIndexedPolygonalFace {
    constructor(expressID, CoordIndex, InnerCoordIndices) {
      super(expressID, CoordIndex);
      this.CoordIndex = CoordIndex;
      this.InnerCoordIndices = InnerCoordIndices;
      this.type = 2294589976;
    }
  }
  IFC4_32.IfcIndexedPolygonalFaceWithVoids = IfcIndexedPolygonalFaceWithVoids;
  class IfcIndexedPolygonalTextureMap extends IfcIndexedTextureMap {
    constructor(expressID, Maps, MappedTo, TexCoords, TexCoordIndices) {
      super(expressID, Maps, MappedTo, TexCoords);
      this.Maps = Maps;
      this.MappedTo = MappedTo;
      this.TexCoords = TexCoords;
      this.TexCoordIndices = TexCoordIndices;
      this.type = 3465909080;
    }
  }
  IFC4_32.IfcIndexedPolygonalTextureMap = IfcIndexedPolygonalTextureMap;
  class IfcLShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Depth, Width, Thickness, FilletRadius, EdgeRadius, LegSlope) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.Width = Width;
      this.Thickness = Thickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.LegSlope = LegSlope;
      this.type = 572779678;
    }
  }
  IFC4_32.IfcLShapeProfileDef = IfcLShapeProfileDef;
  class IfcLaborResourceType extends IfcConstructionResourceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 428585644;
    }
  }
  IFC4_32.IfcLaborResourceType = IfcLaborResourceType;
  class IfcLine extends IfcCurve {
    constructor(expressID, Pnt, Dir) {
      super(expressID);
      this.Pnt = Pnt;
      this.Dir = Dir;
      this.type = 1281925730;
    }
  }
  IFC4_32.IfcLine = IfcLine;
  class IfcManifoldSolidBrep extends IfcSolidModel {
    constructor(expressID, Outer) {
      super(expressID);
      this.Outer = Outer;
      this.type = 1425443689;
    }
  }
  IFC4_32.IfcManifoldSolidBrep = IfcManifoldSolidBrep;
  class IfcObject extends IfcObjectDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 3888040117;
    }
  }
  IFC4_32.IfcObject = IfcObject;
  class IfcOffsetCurve extends IfcCurve {
    constructor(expressID, BasisCurve) {
      super(expressID);
      this.BasisCurve = BasisCurve;
      this.type = 590820931;
    }
  }
  IFC4_32.IfcOffsetCurve = IfcOffsetCurve;
  class IfcOffsetCurve2D extends IfcOffsetCurve {
    constructor(expressID, BasisCurve, Distance, SelfIntersect) {
      super(expressID, BasisCurve);
      this.BasisCurve = BasisCurve;
      this.Distance = Distance;
      this.SelfIntersect = SelfIntersect;
      this.type = 3388369263;
    }
  }
  IFC4_32.IfcOffsetCurve2D = IfcOffsetCurve2D;
  class IfcOffsetCurve3D extends IfcOffsetCurve {
    constructor(expressID, BasisCurve, Distance, SelfIntersect, RefDirection) {
      super(expressID, BasisCurve);
      this.BasisCurve = BasisCurve;
      this.Distance = Distance;
      this.SelfIntersect = SelfIntersect;
      this.RefDirection = RefDirection;
      this.type = 3505215534;
    }
  }
  IFC4_32.IfcOffsetCurve3D = IfcOffsetCurve3D;
  class IfcOffsetCurveByDistances extends IfcOffsetCurve {
    constructor(expressID, BasisCurve, OffsetValues, Tag) {
      super(expressID, BasisCurve);
      this.BasisCurve = BasisCurve;
      this.OffsetValues = OffsetValues;
      this.Tag = Tag;
      this.type = 2485787929;
    }
  }
  IFC4_32.IfcOffsetCurveByDistances = IfcOffsetCurveByDistances;
  class IfcPcurve extends IfcCurve {
    constructor(expressID, BasisSurface, ReferenceCurve) {
      super(expressID);
      this.BasisSurface = BasisSurface;
      this.ReferenceCurve = ReferenceCurve;
      this.type = 1682466193;
    }
  }
  IFC4_32.IfcPcurve = IfcPcurve;
  class IfcPlanarBox extends IfcPlanarExtent {
    constructor(expressID, SizeInX, SizeInY, Placement) {
      super(expressID, SizeInX, SizeInY);
      this.SizeInX = SizeInX;
      this.SizeInY = SizeInY;
      this.Placement = Placement;
      this.type = 603570806;
    }
  }
  IFC4_32.IfcPlanarBox = IfcPlanarBox;
  class IfcPlane extends IfcElementarySurface {
    constructor(expressID, Position) {
      super(expressID, Position);
      this.Position = Position;
      this.type = 220341763;
    }
  }
  IFC4_32.IfcPlane = IfcPlane;
  class IfcPolynomialCurve extends IfcCurve {
    constructor(expressID, Position, CoefficientsX, CoefficientsY, CoefficientsZ) {
      super(expressID);
      this.Position = Position;
      this.CoefficientsX = CoefficientsX;
      this.CoefficientsY = CoefficientsY;
      this.CoefficientsZ = CoefficientsZ;
      this.type = 3381221214;
    }
  }
  IFC4_32.IfcPolynomialCurve = IfcPolynomialCurve;
  class IfcPreDefinedColour extends IfcPreDefinedItem {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 759155922;
    }
  }
  IFC4_32.IfcPreDefinedColour = IfcPreDefinedColour;
  class IfcPreDefinedCurveFont extends IfcPreDefinedItem {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 2559016684;
    }
  }
  IFC4_32.IfcPreDefinedCurveFont = IfcPreDefinedCurveFont;
  class IfcPreDefinedPropertySet extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 3967405729;
    }
  }
  IFC4_32.IfcPreDefinedPropertySet = IfcPreDefinedPropertySet;
  class IfcProcedureType extends IfcTypeProcess {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ProcessType = ProcessType;
      this.PredefinedType = PredefinedType;
      this.type = 569719735;
    }
  }
  IFC4_32.IfcProcedureType = IfcProcedureType;
  class IfcProcess extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.type = 2945172077;
    }
  }
  IFC4_32.IfcProcess = IfcProcess;
  class IfcProduct extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 4208778838;
    }
  }
  IFC4_32.IfcProduct = IfcProduct;
  class IfcProject extends IfcContext {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.Phase = Phase;
      this.RepresentationContexts = RepresentationContexts;
      this.UnitsInContext = UnitsInContext;
      this.type = 103090709;
    }
  }
  IFC4_32.IfcProject = IfcProject;
  class IfcProjectLibrary extends IfcContext {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.Phase = Phase;
      this.RepresentationContexts = RepresentationContexts;
      this.UnitsInContext = UnitsInContext;
      this.type = 653396225;
    }
  }
  IFC4_32.IfcProjectLibrary = IfcProjectLibrary;
  class IfcPropertyBoundedValue extends IfcSimpleProperty {
    constructor(expressID, Name, Specification, UpperBoundValue, LowerBoundValue, Unit, SetPointValue) {
      super(expressID, Name, Specification);
      this.Name = Name;
      this.Specification = Specification;
      this.UpperBoundValue = UpperBoundValue;
      this.LowerBoundValue = LowerBoundValue;
      this.Unit = Unit;
      this.SetPointValue = SetPointValue;
      this.type = 871118103;
    }
  }
  IFC4_32.IfcPropertyBoundedValue = IfcPropertyBoundedValue;
  class IfcPropertyEnumeratedValue extends IfcSimpleProperty {
    constructor(expressID, Name, Specification, EnumerationValues, EnumerationReference) {
      super(expressID, Name, Specification);
      this.Name = Name;
      this.Specification = Specification;
      this.EnumerationValues = EnumerationValues;
      this.EnumerationReference = EnumerationReference;
      this.type = 4166981789;
    }
  }
  IFC4_32.IfcPropertyEnumeratedValue = IfcPropertyEnumeratedValue;
  class IfcPropertyListValue extends IfcSimpleProperty {
    constructor(expressID, Name, Specification, ListValues, Unit) {
      super(expressID, Name, Specification);
      this.Name = Name;
      this.Specification = Specification;
      this.ListValues = ListValues;
      this.Unit = Unit;
      this.type = 2752243245;
    }
  }
  IFC4_32.IfcPropertyListValue = IfcPropertyListValue;
  class IfcPropertyReferenceValue extends IfcSimpleProperty {
    constructor(expressID, Name, Specification, UsageName, PropertyReference) {
      super(expressID, Name, Specification);
      this.Name = Name;
      this.Specification = Specification;
      this.UsageName = UsageName;
      this.PropertyReference = PropertyReference;
      this.type = 941946838;
    }
  }
  IFC4_32.IfcPropertyReferenceValue = IfcPropertyReferenceValue;
  class IfcPropertySet extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, HasProperties) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.HasProperties = HasProperties;
      this.type = 1451395588;
    }
  }
  IFC4_32.IfcPropertySet = IfcPropertySet;
  class IfcPropertySetTemplate extends IfcPropertyTemplateDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, TemplateType, ApplicableEntity, HasPropertyTemplates) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.TemplateType = TemplateType;
      this.ApplicableEntity = ApplicableEntity;
      this.HasPropertyTemplates = HasPropertyTemplates;
      this.type = 492091185;
    }
  }
  IFC4_32.IfcPropertySetTemplate = IfcPropertySetTemplate;
  class IfcPropertySingleValue extends IfcSimpleProperty {
    constructor(expressID, Name, Specification, NominalValue, Unit) {
      super(expressID, Name, Specification);
      this.Name = Name;
      this.Specification = Specification;
      this.NominalValue = NominalValue;
      this.Unit = Unit;
      this.type = 3650150729;
    }
  }
  IFC4_32.IfcPropertySingleValue = IfcPropertySingleValue;
  class IfcPropertyTableValue extends IfcSimpleProperty {
    constructor(expressID, Name, Specification, DefiningValues, DefinedValues, Expression, DefiningUnit, DefinedUnit, CurveInterpolation) {
      super(expressID, Name, Specification);
      this.Name = Name;
      this.Specification = Specification;
      this.DefiningValues = DefiningValues;
      this.DefinedValues = DefinedValues;
      this.Expression = Expression;
      this.DefiningUnit = DefiningUnit;
      this.DefinedUnit = DefinedUnit;
      this.CurveInterpolation = CurveInterpolation;
      this.type = 110355661;
    }
  }
  IFC4_32.IfcPropertyTableValue = IfcPropertyTableValue;
  class IfcPropertyTemplate extends IfcPropertyTemplateDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 3521284610;
    }
  }
  IFC4_32.IfcPropertyTemplate = IfcPropertyTemplate;
  class IfcRectangleHollowProfileDef extends IfcRectangleProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, XDim, YDim, WallThickness, InnerFilletRadius, OuterFilletRadius) {
      super(expressID, ProfileType, ProfileName, Position, XDim, YDim);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.WallThickness = WallThickness;
      this.InnerFilletRadius = InnerFilletRadius;
      this.OuterFilletRadius = OuterFilletRadius;
      this.type = 2770003689;
    }
  }
  IFC4_32.IfcRectangleHollowProfileDef = IfcRectangleHollowProfileDef;
  class IfcRectangularPyramid extends IfcCsgPrimitive3D {
    constructor(expressID, Position, XLength, YLength, Height) {
      super(expressID, Position);
      this.Position = Position;
      this.XLength = XLength;
      this.YLength = YLength;
      this.Height = Height;
      this.type = 2798486643;
    }
  }
  IFC4_32.IfcRectangularPyramid = IfcRectangularPyramid;
  class IfcRectangularTrimmedSurface extends IfcBoundedSurface {
    constructor(expressID, BasisSurface, U1, V1, U2, V2, Usense, Vsense) {
      super(expressID);
      this.BasisSurface = BasisSurface;
      this.U1 = U1;
      this.V1 = V1;
      this.U2 = U2;
      this.V2 = V2;
      this.Usense = Usense;
      this.Vsense = Vsense;
      this.type = 3454111270;
    }
  }
  IFC4_32.IfcRectangularTrimmedSurface = IfcRectangularTrimmedSurface;
  class IfcReinforcementDefinitionProperties extends IfcPreDefinedPropertySet {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, DefinitionType, ReinforcementSectionDefinitions) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.DefinitionType = DefinitionType;
      this.ReinforcementSectionDefinitions = ReinforcementSectionDefinitions;
      this.type = 3765753017;
    }
  }
  IFC4_32.IfcReinforcementDefinitionProperties = IfcReinforcementDefinitionProperties;
  class IfcRelAssigns extends IfcRelationship {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.type = 3939117080;
    }
  }
  IFC4_32.IfcRelAssigns = IfcRelAssigns;
  class IfcRelAssignsToActor extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingActor = RelatingActor;
      this.ActingRole = ActingRole;
      this.type = 1683148259;
    }
  }
  IFC4_32.IfcRelAssignsToActor = IfcRelAssignsToActor;
  class IfcRelAssignsToControl extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingControl = RelatingControl;
      this.type = 2495723537;
    }
  }
  IFC4_32.IfcRelAssignsToControl = IfcRelAssignsToControl;
  class IfcRelAssignsToGroup extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingGroup = RelatingGroup;
      this.type = 1307041759;
    }
  }
  IFC4_32.IfcRelAssignsToGroup = IfcRelAssignsToGroup;
  class IfcRelAssignsToGroupByFactor extends IfcRelAssignsToGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup, Factor) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingGroup = RelatingGroup;
      this.Factor = Factor;
      this.type = 1027710054;
    }
  }
  IFC4_32.IfcRelAssignsToGroupByFactor = IfcRelAssignsToGroupByFactor;
  class IfcRelAssignsToProcess extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProcess, QuantityInProcess) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingProcess = RelatingProcess;
      this.QuantityInProcess = QuantityInProcess;
      this.type = 4278684876;
    }
  }
  IFC4_32.IfcRelAssignsToProcess = IfcRelAssignsToProcess;
  class IfcRelAssignsToProduct extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProduct) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingProduct = RelatingProduct;
      this.type = 2857406711;
    }
  }
  IFC4_32.IfcRelAssignsToProduct = IfcRelAssignsToProduct;
  class IfcRelAssignsToResource extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingResource) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingResource = RelatingResource;
      this.type = 205026976;
    }
  }
  IFC4_32.IfcRelAssignsToResource = IfcRelAssignsToResource;
  class IfcRelAssociates extends IfcRelationship {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.type = 1865459582;
    }
  }
  IFC4_32.IfcRelAssociates = IfcRelAssociates;
  class IfcRelAssociatesApproval extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingApproval) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingApproval = RelatingApproval;
      this.type = 4095574036;
    }
  }
  IFC4_32.IfcRelAssociatesApproval = IfcRelAssociatesApproval;
  class IfcRelAssociatesClassification extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingClassification) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingClassification = RelatingClassification;
      this.type = 919958153;
    }
  }
  IFC4_32.IfcRelAssociatesClassification = IfcRelAssociatesClassification;
  class IfcRelAssociatesConstraint extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, Intent, RelatingConstraint) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.Intent = Intent;
      this.RelatingConstraint = RelatingConstraint;
      this.type = 2728634034;
    }
  }
  IFC4_32.IfcRelAssociatesConstraint = IfcRelAssociatesConstraint;
  class IfcRelAssociatesDocument extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingDocument) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingDocument = RelatingDocument;
      this.type = 982818633;
    }
  }
  IFC4_32.IfcRelAssociatesDocument = IfcRelAssociatesDocument;
  class IfcRelAssociatesLibrary extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingLibrary) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingLibrary = RelatingLibrary;
      this.type = 3840914261;
    }
  }
  IFC4_32.IfcRelAssociatesLibrary = IfcRelAssociatesLibrary;
  class IfcRelAssociatesMaterial extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingMaterial) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingMaterial = RelatingMaterial;
      this.type = 2655215786;
    }
  }
  IFC4_32.IfcRelAssociatesMaterial = IfcRelAssociatesMaterial;
  class IfcRelAssociatesProfileDef extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingProfileDef) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingProfileDef = RelatingProfileDef;
      this.type = 1033248425;
    }
  }
  IFC4_32.IfcRelAssociatesProfileDef = IfcRelAssociatesProfileDef;
  class IfcRelConnects extends IfcRelationship {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 826625072;
    }
  }
  IFC4_32.IfcRelConnects = IfcRelConnects;
  class IfcRelConnectsElements extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.type = 1204542856;
    }
  }
  IFC4_32.IfcRelConnectsElements = IfcRelConnectsElements;
  class IfcRelConnectsPathElements extends IfcRelConnectsElements {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RelatingPriorities, RelatedPriorities, RelatedConnectionType, RelatingConnectionType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.RelatingPriorities = RelatingPriorities;
      this.RelatedPriorities = RelatedPriorities;
      this.RelatedConnectionType = RelatedConnectionType;
      this.RelatingConnectionType = RelatingConnectionType;
      this.type = 3945020480;
    }
  }
  IFC4_32.IfcRelConnectsPathElements = IfcRelConnectsPathElements;
  class IfcRelConnectsPortToElement extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingPort = RelatingPort;
      this.RelatedElement = RelatedElement;
      this.type = 4201705270;
    }
  }
  IFC4_32.IfcRelConnectsPortToElement = IfcRelConnectsPortToElement;
  class IfcRelConnectsPorts extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedPort, RealizingElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingPort = RelatingPort;
      this.RelatedPort = RelatedPort;
      this.RealizingElement = RealizingElement;
      this.type = 3190031847;
    }
  }
  IFC4_32.IfcRelConnectsPorts = IfcRelConnectsPorts;
  class IfcRelConnectsStructuralActivity extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedStructuralActivity) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedStructuralActivity = RelatedStructuralActivity;
      this.type = 2127690289;
    }
  }
  IFC4_32.IfcRelConnectsStructuralActivity = IfcRelConnectsStructuralActivity;
  class IfcRelConnectsStructuralMember extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingStructuralMember = RelatingStructuralMember;
      this.RelatedStructuralConnection = RelatedStructuralConnection;
      this.AppliedCondition = AppliedCondition;
      this.AdditionalConditions = AdditionalConditions;
      this.SupportedLength = SupportedLength;
      this.ConditionCoordinateSystem = ConditionCoordinateSystem;
      this.type = 1638771189;
    }
  }
  IFC4_32.IfcRelConnectsStructuralMember = IfcRelConnectsStructuralMember;
  class IfcRelConnectsWithEccentricity extends IfcRelConnectsStructuralMember {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem, ConnectionConstraint) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingStructuralMember = RelatingStructuralMember;
      this.RelatedStructuralConnection = RelatedStructuralConnection;
      this.AppliedCondition = AppliedCondition;
      this.AdditionalConditions = AdditionalConditions;
      this.SupportedLength = SupportedLength;
      this.ConditionCoordinateSystem = ConditionCoordinateSystem;
      this.ConnectionConstraint = ConnectionConstraint;
      this.type = 504942748;
    }
  }
  IFC4_32.IfcRelConnectsWithEccentricity = IfcRelConnectsWithEccentricity;
  class IfcRelConnectsWithRealizingElements extends IfcRelConnectsElements {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RealizingElements, ConnectionType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.RealizingElements = RealizingElements;
      this.ConnectionType = ConnectionType;
      this.type = 3678494232;
    }
  }
  IFC4_32.IfcRelConnectsWithRealizingElements = IfcRelConnectsWithRealizingElements;
  class IfcRelContainedInSpatialStructure extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedElements = RelatedElements;
      this.RelatingStructure = RelatingStructure;
      this.type = 3242617779;
    }
  }
  IFC4_32.IfcRelContainedInSpatialStructure = IfcRelContainedInSpatialStructure;
  class IfcRelCoversBldgElements extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedCoverings) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingBuildingElement = RelatingBuildingElement;
      this.RelatedCoverings = RelatedCoverings;
      this.type = 886880790;
    }
  }
  IFC4_32.IfcRelCoversBldgElements = IfcRelCoversBldgElements;
  class IfcRelCoversSpaces extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedCoverings) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedCoverings = RelatedCoverings;
      this.type = 2802773753;
    }
  }
  IFC4_32.IfcRelCoversSpaces = IfcRelCoversSpaces;
  class IfcRelDeclares extends IfcRelationship {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingContext, RelatedDefinitions) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingContext = RelatingContext;
      this.RelatedDefinitions = RelatedDefinitions;
      this.type = 2565941209;
    }
  }
  IFC4_32.IfcRelDeclares = IfcRelDeclares;
  class IfcRelDecomposes extends IfcRelationship {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 2551354335;
    }
  }
  IFC4_32.IfcRelDecomposes = IfcRelDecomposes;
  class IfcRelDefines extends IfcRelationship {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 693640335;
    }
  }
  IFC4_32.IfcRelDefines = IfcRelDefines;
  class IfcRelDefinesByObject extends IfcRelDefines {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingObject) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingObject = RelatingObject;
      this.type = 1462361463;
    }
  }
  IFC4_32.IfcRelDefinesByObject = IfcRelDefinesByObject;
  class IfcRelDefinesByProperties extends IfcRelDefines {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingPropertyDefinition = RelatingPropertyDefinition;
      this.type = 4186316022;
    }
  }
  IFC4_32.IfcRelDefinesByProperties = IfcRelDefinesByProperties;
  class IfcRelDefinesByTemplate extends IfcRelDefines {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedPropertySets, RelatingTemplate) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedPropertySets = RelatedPropertySets;
      this.RelatingTemplate = RelatingTemplate;
      this.type = 307848117;
    }
  }
  IFC4_32.IfcRelDefinesByTemplate = IfcRelDefinesByTemplate;
  class IfcRelDefinesByType extends IfcRelDefines {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingType = RelatingType;
      this.type = 781010003;
    }
  }
  IFC4_32.IfcRelDefinesByType = IfcRelDefinesByType;
  class IfcRelFillsElement extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingOpeningElement, RelatedBuildingElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingOpeningElement = RelatingOpeningElement;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.type = 3940055652;
    }
  }
  IFC4_32.IfcRelFillsElement = IfcRelFillsElement;
  class IfcRelFlowControlElements extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedControlElements, RelatingFlowElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedControlElements = RelatedControlElements;
      this.RelatingFlowElement = RelatingFlowElement;
      this.type = 279856033;
    }
  }
  IFC4_32.IfcRelFlowControlElements = IfcRelFlowControlElements;
  class IfcRelInterferesElements extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedElement, InterferenceGeometry, InterferenceSpace, InterferenceType, ImpliedOrder) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.InterferenceGeometry = InterferenceGeometry;
      this.InterferenceSpace = InterferenceSpace;
      this.InterferenceType = InterferenceType;
      this.ImpliedOrder = ImpliedOrder;
      this.type = 427948657;
    }
  }
  IFC4_32.IfcRelInterferesElements = IfcRelInterferesElements;
  class IfcRelNests extends IfcRelDecomposes {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingObject = RelatingObject;
      this.RelatedObjects = RelatedObjects;
      this.type = 3268803585;
    }
  }
  IFC4_32.IfcRelNests = IfcRelNests;
  class IfcRelPositions extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingPositioningElement, RelatedProducts) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingPositioningElement = RelatingPositioningElement;
      this.RelatedProducts = RelatedProducts;
      this.type = 1441486842;
    }
  }
  IFC4_32.IfcRelPositions = IfcRelPositions;
  class IfcRelProjectsElement extends IfcRelDecomposes {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedFeatureElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedFeatureElement = RelatedFeatureElement;
      this.type = 750771296;
    }
  }
  IFC4_32.IfcRelProjectsElement = IfcRelProjectsElement;
  class IfcRelReferencedInSpatialStructure extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedElements = RelatedElements;
      this.RelatingStructure = RelatingStructure;
      this.type = 1245217292;
    }
  }
  IFC4_32.IfcRelReferencedInSpatialStructure = IfcRelReferencedInSpatialStructure;
  class IfcRelSequence extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingProcess, RelatedProcess, TimeLag, SequenceType, UserDefinedSequenceType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingProcess = RelatingProcess;
      this.RelatedProcess = RelatedProcess;
      this.TimeLag = TimeLag;
      this.SequenceType = SequenceType;
      this.UserDefinedSequenceType = UserDefinedSequenceType;
      this.type = 4122056220;
    }
  }
  IFC4_32.IfcRelSequence = IfcRelSequence;
  class IfcRelServicesBuildings extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSystem, RelatedBuildings) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSystem = RelatingSystem;
      this.RelatedBuildings = RelatedBuildings;
      this.type = 366585022;
    }
  }
  IFC4_32.IfcRelServicesBuildings = IfcRelServicesBuildings;
  class IfcRelSpaceBoundary extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.ConnectionGeometry = ConnectionGeometry;
      this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      this.InternalOrExternalBoundary = InternalOrExternalBoundary;
      this.type = 3451746338;
    }
  }
  IFC4_32.IfcRelSpaceBoundary = IfcRelSpaceBoundary;
  class IfcRelSpaceBoundary1stLevel extends IfcRelSpaceBoundary {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.ConnectionGeometry = ConnectionGeometry;
      this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      this.InternalOrExternalBoundary = InternalOrExternalBoundary;
      this.ParentBoundary = ParentBoundary;
      this.type = 3523091289;
    }
  }
  IFC4_32.IfcRelSpaceBoundary1stLevel = IfcRelSpaceBoundary1stLevel;
  class IfcRelSpaceBoundary2ndLevel extends IfcRelSpaceBoundary1stLevel {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary, CorrespondingBoundary) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.ConnectionGeometry = ConnectionGeometry;
      this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      this.InternalOrExternalBoundary = InternalOrExternalBoundary;
      this.ParentBoundary = ParentBoundary;
      this.CorrespondingBoundary = CorrespondingBoundary;
      this.type = 1521410863;
    }
  }
  IFC4_32.IfcRelSpaceBoundary2ndLevel = IfcRelSpaceBoundary2ndLevel;
  class IfcRelVoidsElement extends IfcRelDecomposes {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedOpeningElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingBuildingElement = RelatingBuildingElement;
      this.RelatedOpeningElement = RelatedOpeningElement;
      this.type = 1401173127;
    }
  }
  IFC4_32.IfcRelVoidsElement = IfcRelVoidsElement;
  class IfcReparametrisedCompositeCurveSegment extends IfcCompositeCurveSegment {
    constructor(expressID, Transition, SameSense, ParentCurve, ParamLength) {
      super(expressID, Transition, SameSense, ParentCurve);
      this.Transition = Transition;
      this.SameSense = SameSense;
      this.ParentCurve = ParentCurve;
      this.ParamLength = ParamLength;
      this.type = 816062949;
    }
  }
  IFC4_32.IfcReparametrisedCompositeCurveSegment = IfcReparametrisedCompositeCurveSegment;
  class IfcResource extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.type = 2914609552;
    }
  }
  IFC4_32.IfcResource = IfcResource;
  class IfcRevolvedAreaSolid extends IfcSweptAreaSolid {
    constructor(expressID, SweptArea, Position, Axis, Angle) {
      super(expressID, SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Axis = Axis;
      this.Angle = Angle;
      this.type = 1856042241;
    }
  }
  IFC4_32.IfcRevolvedAreaSolid = IfcRevolvedAreaSolid;
  class IfcRevolvedAreaSolidTapered extends IfcRevolvedAreaSolid {
    constructor(expressID, SweptArea, Position, Axis, Angle, EndSweptArea) {
      super(expressID, SweptArea, Position, Axis, Angle);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Axis = Axis;
      this.Angle = Angle;
      this.EndSweptArea = EndSweptArea;
      this.type = 3243963512;
    }
  }
  IFC4_32.IfcRevolvedAreaSolidTapered = IfcRevolvedAreaSolidTapered;
  class IfcRightCircularCone extends IfcCsgPrimitive3D {
    constructor(expressID, Position, Height, BottomRadius) {
      super(expressID, Position);
      this.Position = Position;
      this.Height = Height;
      this.BottomRadius = BottomRadius;
      this.type = 4158566097;
    }
  }
  IFC4_32.IfcRightCircularCone = IfcRightCircularCone;
  class IfcRightCircularCylinder extends IfcCsgPrimitive3D {
    constructor(expressID, Position, Height, Radius) {
      super(expressID, Position);
      this.Position = Position;
      this.Height = Height;
      this.Radius = Radius;
      this.type = 3626867408;
    }
  }
  IFC4_32.IfcRightCircularCylinder = IfcRightCircularCylinder;
  class IfcSectionedSolid extends IfcSolidModel {
    constructor(expressID, Directrix, CrossSections) {
      super(expressID);
      this.Directrix = Directrix;
      this.CrossSections = CrossSections;
      this.type = 1862484736;
    }
  }
  IFC4_32.IfcSectionedSolid = IfcSectionedSolid;
  class IfcSectionedSolidHorizontal extends IfcSectionedSolid {
    constructor(expressID, Directrix, CrossSections, CrossSectionPositions) {
      super(expressID, Directrix, CrossSections);
      this.Directrix = Directrix;
      this.CrossSections = CrossSections;
      this.CrossSectionPositions = CrossSectionPositions;
      this.type = 1290935644;
    }
  }
  IFC4_32.IfcSectionedSolidHorizontal = IfcSectionedSolidHorizontal;
  class IfcSectionedSurface extends IfcSurface {
    constructor(expressID, Directrix, CrossSectionPositions, CrossSections) {
      super(expressID);
      this.Directrix = Directrix;
      this.CrossSectionPositions = CrossSectionPositions;
      this.CrossSections = CrossSections;
      this.type = 1356537516;
    }
  }
  IFC4_32.IfcSectionedSurface = IfcSectionedSurface;
  class IfcSimplePropertyTemplate extends IfcPropertyTemplate {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, TemplateType, PrimaryMeasureType, SecondaryMeasureType, Enumerators, PrimaryUnit, SecondaryUnit, Expression, AccessState) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.TemplateType = TemplateType;
      this.PrimaryMeasureType = PrimaryMeasureType;
      this.SecondaryMeasureType = SecondaryMeasureType;
      this.Enumerators = Enumerators;
      this.PrimaryUnit = PrimaryUnit;
      this.SecondaryUnit = SecondaryUnit;
      this.Expression = Expression;
      this.AccessState = AccessState;
      this.type = 3663146110;
    }
  }
  IFC4_32.IfcSimplePropertyTemplate = IfcSimplePropertyTemplate;
  class IfcSpatialElement extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.type = 1412071761;
    }
  }
  IFC4_32.IfcSpatialElement = IfcSpatialElement;
  class IfcSpatialElementType extends IfcTypeProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 710998568;
    }
  }
  IFC4_32.IfcSpatialElementType = IfcSpatialElementType;
  class IfcSpatialStructureElement extends IfcSpatialElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.type = 2706606064;
    }
  }
  IFC4_32.IfcSpatialStructureElement = IfcSpatialStructureElement;
  class IfcSpatialStructureElementType extends IfcSpatialElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3893378262;
    }
  }
  IFC4_32.IfcSpatialStructureElementType = IfcSpatialStructureElementType;
  class IfcSpatialZone extends IfcSpatialElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.PredefinedType = PredefinedType;
      this.type = 463610769;
    }
  }
  IFC4_32.IfcSpatialZone = IfcSpatialZone;
  class IfcSpatialZoneType extends IfcSpatialElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, LongName) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.LongName = LongName;
      this.type = 2481509218;
    }
  }
  IFC4_32.IfcSpatialZoneType = IfcSpatialZoneType;
  class IfcSphere extends IfcCsgPrimitive3D {
    constructor(expressID, Position, Radius) {
      super(expressID, Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 451544542;
    }
  }
  IFC4_32.IfcSphere = IfcSphere;
  class IfcSphericalSurface extends IfcElementarySurface {
    constructor(expressID, Position, Radius) {
      super(expressID, Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 4015995234;
    }
  }
  IFC4_32.IfcSphericalSurface = IfcSphericalSurface;
  class IfcSpiral extends IfcCurve {
    constructor(expressID, Position) {
      super(expressID);
      this.Position = Position;
      this.type = 2735484536;
    }
  }
  IFC4_32.IfcSpiral = IfcSpiral;
  class IfcStructuralActivity extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 3544373492;
    }
  }
  IFC4_32.IfcStructuralActivity = IfcStructuralActivity;
  class IfcStructuralItem extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 3136571912;
    }
  }
  IFC4_32.IfcStructuralItem = IfcStructuralItem;
  class IfcStructuralMember extends IfcStructuralItem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 530289379;
    }
  }
  IFC4_32.IfcStructuralMember = IfcStructuralMember;
  class IfcStructuralReaction extends IfcStructuralActivity {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 3689010777;
    }
  }
  IFC4_32.IfcStructuralReaction = IfcStructuralReaction;
  class IfcStructuralSurfaceMember extends IfcStructuralMember {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Thickness = Thickness;
      this.type = 3979015343;
    }
  }
  IFC4_32.IfcStructuralSurfaceMember = IfcStructuralSurfaceMember;
  class IfcStructuralSurfaceMemberVarying extends IfcStructuralSurfaceMember {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Thickness = Thickness;
      this.type = 2218152070;
    }
  }
  IFC4_32.IfcStructuralSurfaceMemberVarying = IfcStructuralSurfaceMemberVarying;
  class IfcStructuralSurfaceReaction extends IfcStructuralReaction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.PredefinedType = PredefinedType;
      this.type = 603775116;
    }
  }
  IFC4_32.IfcStructuralSurfaceReaction = IfcStructuralSurfaceReaction;
  class IfcSubContractResourceType extends IfcConstructionResourceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 4095615324;
    }
  }
  IFC4_32.IfcSubContractResourceType = IfcSubContractResourceType;
  class IfcSurfaceCurve extends IfcCurve {
    constructor(expressID, Curve3D, AssociatedGeometry, MasterRepresentation) {
      super(expressID);
      this.Curve3D = Curve3D;
      this.AssociatedGeometry = AssociatedGeometry;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 699246055;
    }
  }
  IFC4_32.IfcSurfaceCurve = IfcSurfaceCurve;
  class IfcSurfaceCurveSweptAreaSolid extends IfcDirectrixCurveSweptAreaSolid {
    constructor(expressID, SweptArea, Position, Directrix, StartParam, EndParam, ReferenceSurface) {
      super(expressID, SweptArea, Position, Directrix, StartParam, EndParam);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Directrix = Directrix;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.ReferenceSurface = ReferenceSurface;
      this.type = 2028607225;
    }
  }
  IFC4_32.IfcSurfaceCurveSweptAreaSolid = IfcSurfaceCurveSweptAreaSolid;
  class IfcSurfaceOfLinearExtrusion extends IfcSweptSurface {
    constructor(expressID, SweptCurve, Position, ExtrudedDirection, Depth) {
      super(expressID, SweptCurve, Position);
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.ExtrudedDirection = ExtrudedDirection;
      this.Depth = Depth;
      this.type = 2809605785;
    }
  }
  IFC4_32.IfcSurfaceOfLinearExtrusion = IfcSurfaceOfLinearExtrusion;
  class IfcSurfaceOfRevolution extends IfcSweptSurface {
    constructor(expressID, SweptCurve, Position, AxisPosition) {
      super(expressID, SweptCurve, Position);
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.AxisPosition = AxisPosition;
      this.type = 4124788165;
    }
  }
  IFC4_32.IfcSurfaceOfRevolution = IfcSurfaceOfRevolution;
  class IfcSystemFurnitureElementType extends IfcFurnishingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1580310250;
    }
  }
  IFC4_32.IfcSystemFurnitureElementType = IfcSystemFurnitureElementType;
  class IfcTask extends IfcProcess {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Status, WorkMethod, IsMilestone, Priority, TaskTime, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Status = Status;
      this.WorkMethod = WorkMethod;
      this.IsMilestone = IsMilestone;
      this.Priority = Priority;
      this.TaskTime = TaskTime;
      this.PredefinedType = PredefinedType;
      this.type = 3473067441;
    }
  }
  IFC4_32.IfcTask = IfcTask;
  class IfcTaskType extends IfcTypeProcess {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType, WorkMethod) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ProcessType = ProcessType;
      this.PredefinedType = PredefinedType;
      this.WorkMethod = WorkMethod;
      this.type = 3206491090;
    }
  }
  IFC4_32.IfcTaskType = IfcTaskType;
  class IfcTessellatedFaceSet extends IfcTessellatedItem {
    constructor(expressID, Coordinates, Closed) {
      super(expressID);
      this.Coordinates = Coordinates;
      this.Closed = Closed;
      this.type = 2387106220;
    }
  }
  IFC4_32.IfcTessellatedFaceSet = IfcTessellatedFaceSet;
  class IfcThirdOrderPolynomialSpiral extends IfcSpiral {
    constructor(expressID, Position, CubicTerm, QuadraticTerm, LinearTerm, ConstantTerm) {
      super(expressID, Position);
      this.Position = Position;
      this.CubicTerm = CubicTerm;
      this.QuadraticTerm = QuadraticTerm;
      this.LinearTerm = LinearTerm;
      this.ConstantTerm = ConstantTerm;
      this.type = 782932809;
    }
  }
  IFC4_32.IfcThirdOrderPolynomialSpiral = IfcThirdOrderPolynomialSpiral;
  class IfcToroidalSurface extends IfcElementarySurface {
    constructor(expressID, Position, MajorRadius, MinorRadius) {
      super(expressID, Position);
      this.Position = Position;
      this.MajorRadius = MajorRadius;
      this.MinorRadius = MinorRadius;
      this.type = 1935646853;
    }
  }
  IFC4_32.IfcToroidalSurface = IfcToroidalSurface;
  class IfcTransportationDeviceType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3665877780;
    }
  }
  IFC4_32.IfcTransportationDeviceType = IfcTransportationDeviceType;
  class IfcTriangulatedFaceSet extends IfcTessellatedFaceSet {
    constructor(expressID, Coordinates, Closed, Normals, CoordIndex, PnIndex) {
      super(expressID, Coordinates, Closed);
      this.Coordinates = Coordinates;
      this.Closed = Closed;
      this.Normals = Normals;
      this.CoordIndex = CoordIndex;
      this.PnIndex = PnIndex;
      this.type = 2916149573;
    }
  }
  IFC4_32.IfcTriangulatedFaceSet = IfcTriangulatedFaceSet;
  class IfcTriangulatedIrregularNetwork extends IfcTriangulatedFaceSet {
    constructor(expressID, Coordinates, Closed, Normals, CoordIndex, PnIndex, Flags) {
      super(expressID, Coordinates, Closed, Normals, CoordIndex, PnIndex);
      this.Coordinates = Coordinates;
      this.Closed = Closed;
      this.Normals = Normals;
      this.CoordIndex = CoordIndex;
      this.PnIndex = PnIndex;
      this.Flags = Flags;
      this.type = 1229763772;
    }
  }
  IFC4_32.IfcTriangulatedIrregularNetwork = IfcTriangulatedIrregularNetwork;
  class IfcVehicleType extends IfcTransportationDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3651464721;
    }
  }
  IFC4_32.IfcVehicleType = IfcVehicleType;
  class IfcWindowLiningProperties extends IfcPreDefinedPropertySet {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, TransomThickness, MullionThickness, FirstTransomOffset, SecondTransomOffset, FirstMullionOffset, SecondMullionOffset, ShapeAspectStyle, LiningOffset, LiningToPanelOffsetX, LiningToPanelOffsetY) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.LiningDepth = LiningDepth;
      this.LiningThickness = LiningThickness;
      this.TransomThickness = TransomThickness;
      this.MullionThickness = MullionThickness;
      this.FirstTransomOffset = FirstTransomOffset;
      this.SecondTransomOffset = SecondTransomOffset;
      this.FirstMullionOffset = FirstMullionOffset;
      this.SecondMullionOffset = SecondMullionOffset;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.LiningOffset = LiningOffset;
      this.LiningToPanelOffsetX = LiningToPanelOffsetX;
      this.LiningToPanelOffsetY = LiningToPanelOffsetY;
      this.type = 336235671;
    }
  }
  IFC4_32.IfcWindowLiningProperties = IfcWindowLiningProperties;
  class IfcWindowPanelProperties extends IfcPreDefinedPropertySet {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.OperationType = OperationType;
      this.PanelPosition = PanelPosition;
      this.FrameDepth = FrameDepth;
      this.FrameThickness = FrameThickness;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 512836454;
    }
  }
  IFC4_32.IfcWindowPanelProperties = IfcWindowPanelProperties;
  class IfcActor extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheActor = TheActor;
      this.type = 2296667514;
    }
  }
  IFC4_32.IfcActor = IfcActor;
  class IfcAdvancedBrep extends IfcManifoldSolidBrep {
    constructor(expressID, Outer) {
      super(expressID, Outer);
      this.Outer = Outer;
      this.type = 1635779807;
    }
  }
  IFC4_32.IfcAdvancedBrep = IfcAdvancedBrep;
  class IfcAdvancedBrepWithVoids extends IfcAdvancedBrep {
    constructor(expressID, Outer, Voids) {
      super(expressID, Outer);
      this.Outer = Outer;
      this.Voids = Voids;
      this.type = 2603310189;
    }
  }
  IFC4_32.IfcAdvancedBrepWithVoids = IfcAdvancedBrepWithVoids;
  class IfcAnnotation extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.type = 1674181508;
    }
  }
  IFC4_32.IfcAnnotation = IfcAnnotation;
  class IfcBSplineSurface extends IfcBoundedSurface {
    constructor(expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect) {
      super(expressID);
      this.UDegree = UDegree;
      this.VDegree = VDegree;
      this.ControlPointsList = ControlPointsList;
      this.SurfaceForm = SurfaceForm;
      this.UClosed = UClosed;
      this.VClosed = VClosed;
      this.SelfIntersect = SelfIntersect;
      this.type = 2887950389;
    }
  }
  IFC4_32.IfcBSplineSurface = IfcBSplineSurface;
  class IfcBSplineSurfaceWithKnots extends IfcBSplineSurface {
    constructor(expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec) {
      super(expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect);
      this.UDegree = UDegree;
      this.VDegree = VDegree;
      this.ControlPointsList = ControlPointsList;
      this.SurfaceForm = SurfaceForm;
      this.UClosed = UClosed;
      this.VClosed = VClosed;
      this.SelfIntersect = SelfIntersect;
      this.UMultiplicities = UMultiplicities;
      this.VMultiplicities = VMultiplicities;
      this.UKnots = UKnots;
      this.VKnots = VKnots;
      this.KnotSpec = KnotSpec;
      this.type = 167062518;
    }
  }
  IFC4_32.IfcBSplineSurfaceWithKnots = IfcBSplineSurfaceWithKnots;
  class IfcBlock extends IfcCsgPrimitive3D {
    constructor(expressID, Position, XLength, YLength, ZLength) {
      super(expressID, Position);
      this.Position = Position;
      this.XLength = XLength;
      this.YLength = YLength;
      this.ZLength = ZLength;
      this.type = 1334484129;
    }
  }
  IFC4_32.IfcBlock = IfcBlock;
  class IfcBooleanClippingResult extends IfcBooleanResult {
    constructor(expressID, Operator, FirstOperand, SecondOperand) {
      super(expressID, Operator, FirstOperand, SecondOperand);
      this.Operator = Operator;
      this.FirstOperand = FirstOperand;
      this.SecondOperand = SecondOperand;
      this.type = 3649129432;
    }
  }
  IFC4_32.IfcBooleanClippingResult = IfcBooleanClippingResult;
  class IfcBoundedCurve extends IfcCurve {
    constructor(expressID) {
      super(expressID);
      this.type = 1260505505;
    }
  }
  IFC4_32.IfcBoundedCurve = IfcBoundedCurve;
  class IfcBuildingStorey extends IfcSpatialStructureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, Elevation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.Elevation = Elevation;
      this.type = 3124254112;
    }
  }
  IFC4_32.IfcBuildingStorey = IfcBuildingStorey;
  class IfcBuiltElementType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1626504194;
    }
  }
  IFC4_32.IfcBuiltElementType = IfcBuiltElementType;
  class IfcChimneyType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2197970202;
    }
  }
  IFC4_32.IfcChimneyType = IfcChimneyType;
  class IfcCircleHollowProfileDef extends IfcCircleProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Radius, WallThickness) {
      super(expressID, ProfileType, ProfileName, Position, Radius);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Radius = Radius;
      this.WallThickness = WallThickness;
      this.type = 2937912522;
    }
  }
  IFC4_32.IfcCircleHollowProfileDef = IfcCircleHollowProfileDef;
  class IfcCivilElementType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3893394355;
    }
  }
  IFC4_32.IfcCivilElementType = IfcCivilElementType;
  class IfcClothoid extends IfcSpiral {
    constructor(expressID, Position, ClothoidConstant) {
      super(expressID, Position);
      this.Position = Position;
      this.ClothoidConstant = ClothoidConstant;
      this.type = 3497074424;
    }
  }
  IFC4_32.IfcClothoid = IfcClothoid;
  class IfcColumnType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 300633059;
    }
  }
  IFC4_32.IfcColumnType = IfcColumnType;
  class IfcComplexPropertyTemplate extends IfcPropertyTemplate {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, UsageName, TemplateType, HasPropertyTemplates) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.UsageName = UsageName;
      this.TemplateType = TemplateType;
      this.HasPropertyTemplates = HasPropertyTemplates;
      this.type = 3875453745;
    }
  }
  IFC4_32.IfcComplexPropertyTemplate = IfcComplexPropertyTemplate;
  class IfcCompositeCurve extends IfcBoundedCurve {
    constructor(expressID, Segments, SelfIntersect) {
      super(expressID);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 3732776249;
    }
  }
  IFC4_32.IfcCompositeCurve = IfcCompositeCurve;
  class IfcCompositeCurveOnSurface extends IfcCompositeCurve {
    constructor(expressID, Segments, SelfIntersect) {
      super(expressID, Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 15328376;
    }
  }
  IFC4_32.IfcCompositeCurveOnSurface = IfcCompositeCurveOnSurface;
  class IfcConic extends IfcCurve {
    constructor(expressID, Position) {
      super(expressID);
      this.Position = Position;
      this.type = 2510884976;
    }
  }
  IFC4_32.IfcConic = IfcConic;
  class IfcConstructionEquipmentResourceType extends IfcConstructionResourceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 2185764099;
    }
  }
  IFC4_32.IfcConstructionEquipmentResourceType = IfcConstructionEquipmentResourceType;
  class IfcConstructionMaterialResourceType extends IfcConstructionResourceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 4105962743;
    }
  }
  IFC4_32.IfcConstructionMaterialResourceType = IfcConstructionMaterialResourceType;
  class IfcConstructionProductResourceType extends IfcConstructionResourceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 1525564444;
    }
  }
  IFC4_32.IfcConstructionProductResourceType = IfcConstructionProductResourceType;
  class IfcConstructionResource extends IfcResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.type = 2559216714;
    }
  }
  IFC4_32.IfcConstructionResource = IfcConstructionResource;
  class IfcControl extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.type = 3293443760;
    }
  }
  IFC4_32.IfcControl = IfcControl;
  class IfcCosineSpiral extends IfcSpiral {
    constructor(expressID, Position, CosineTerm, ConstantTerm) {
      super(expressID, Position);
      this.Position = Position;
      this.CosineTerm = CosineTerm;
      this.ConstantTerm = ConstantTerm;
      this.type = 2000195564;
    }
  }
  IFC4_32.IfcCosineSpiral = IfcCosineSpiral;
  class IfcCostItem extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, CostValues, CostQuantities) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.CostValues = CostValues;
      this.CostQuantities = CostQuantities;
      this.type = 3895139033;
    }
  }
  IFC4_32.IfcCostItem = IfcCostItem;
  class IfcCostSchedule extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, SubmittedOn, UpdateDate) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.SubmittedOn = SubmittedOn;
      this.UpdateDate = UpdateDate;
      this.type = 1419761937;
    }
  }
  IFC4_32.IfcCostSchedule = IfcCostSchedule;
  class IfcCourseType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4189326743;
    }
  }
  IFC4_32.IfcCourseType = IfcCourseType;
  class IfcCoveringType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1916426348;
    }
  }
  IFC4_32.IfcCoveringType = IfcCoveringType;
  class IfcCrewResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 3295246426;
    }
  }
  IFC4_32.IfcCrewResource = IfcCrewResource;
  class IfcCurtainWallType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1457835157;
    }
  }
  IFC4_32.IfcCurtainWallType = IfcCurtainWallType;
  class IfcCylindricalSurface extends IfcElementarySurface {
    constructor(expressID, Position, Radius) {
      super(expressID, Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 1213902940;
    }
  }
  IFC4_32.IfcCylindricalSurface = IfcCylindricalSurface;
  class IfcDeepFoundationType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1306400036;
    }
  }
  IFC4_32.IfcDeepFoundationType = IfcDeepFoundationType;
  class IfcDirectrixDerivedReferenceSweptAreaSolid extends IfcFixedReferenceSweptAreaSolid {
    constructor(expressID, SweptArea, Position, Directrix, StartParam, EndParam, FixedReference) {
      super(expressID, SweptArea, Position, Directrix, StartParam, EndParam, FixedReference);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Directrix = Directrix;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.FixedReference = FixedReference;
      this.type = 4234616927;
    }
  }
  IFC4_32.IfcDirectrixDerivedReferenceSweptAreaSolid = IfcDirectrixDerivedReferenceSweptAreaSolid;
  class IfcDistributionElementType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3256556792;
    }
  }
  IFC4_32.IfcDistributionElementType = IfcDistributionElementType;
  class IfcDistributionFlowElementType extends IfcDistributionElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3849074793;
    }
  }
  IFC4_32.IfcDistributionFlowElementType = IfcDistributionFlowElementType;
  class IfcDoorLiningProperties extends IfcPreDefinedPropertySet {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, ThresholdDepth, ThresholdThickness, TransomThickness, TransomOffset, LiningOffset, ThresholdOffset, CasingThickness, CasingDepth, ShapeAspectStyle, LiningToPanelOffsetX, LiningToPanelOffsetY) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.LiningDepth = LiningDepth;
      this.LiningThickness = LiningThickness;
      this.ThresholdDepth = ThresholdDepth;
      this.ThresholdThickness = ThresholdThickness;
      this.TransomThickness = TransomThickness;
      this.TransomOffset = TransomOffset;
      this.LiningOffset = LiningOffset;
      this.ThresholdOffset = ThresholdOffset;
      this.CasingThickness = CasingThickness;
      this.CasingDepth = CasingDepth;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.LiningToPanelOffsetX = LiningToPanelOffsetX;
      this.LiningToPanelOffsetY = LiningToPanelOffsetY;
      this.type = 2963535650;
    }
  }
  IFC4_32.IfcDoorLiningProperties = IfcDoorLiningProperties;
  class IfcDoorPanelProperties extends IfcPreDefinedPropertySet {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, PanelDepth, PanelOperation, PanelWidth, PanelPosition, ShapeAspectStyle) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.PanelDepth = PanelDepth;
      this.PanelOperation = PanelOperation;
      this.PanelWidth = PanelWidth;
      this.PanelPosition = PanelPosition;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 1714330368;
    }
  }
  IFC4_32.IfcDoorPanelProperties = IfcDoorPanelProperties;
  class IfcDoorType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, OperationType, ParameterTakesPrecedence, UserDefinedOperationType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.OperationType = OperationType;
      this.ParameterTakesPrecedence = ParameterTakesPrecedence;
      this.UserDefinedOperationType = UserDefinedOperationType;
      this.type = 2323601079;
    }
  }
  IFC4_32.IfcDoorType = IfcDoorType;
  class IfcDraughtingPreDefinedColour extends IfcPreDefinedColour {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 445594917;
    }
  }
  IFC4_32.IfcDraughtingPreDefinedColour = IfcDraughtingPreDefinedColour;
  class IfcDraughtingPreDefinedCurveFont extends IfcPreDefinedCurveFont {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 4006246654;
    }
  }
  IFC4_32.IfcDraughtingPreDefinedCurveFont = IfcDraughtingPreDefinedCurveFont;
  class IfcElement extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1758889154;
    }
  }
  IFC4_32.IfcElement = IfcElement;
  class IfcElementAssembly extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, AssemblyPlace, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.AssemblyPlace = AssemblyPlace;
      this.PredefinedType = PredefinedType;
      this.type = 4123344466;
    }
  }
  IFC4_32.IfcElementAssembly = IfcElementAssembly;
  class IfcElementAssemblyType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2397081782;
    }
  }
  IFC4_32.IfcElementAssemblyType = IfcElementAssemblyType;
  class IfcElementComponent extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1623761950;
    }
  }
  IFC4_32.IfcElementComponent = IfcElementComponent;
  class IfcElementComponentType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2590856083;
    }
  }
  IFC4_32.IfcElementComponentType = IfcElementComponentType;
  class IfcEllipse extends IfcConic {
    constructor(expressID, Position, SemiAxis1, SemiAxis2) {
      super(expressID, Position);
      this.Position = Position;
      this.SemiAxis1 = SemiAxis1;
      this.SemiAxis2 = SemiAxis2;
      this.type = 1704287377;
    }
  }
  IFC4_32.IfcEllipse = IfcEllipse;
  class IfcEnergyConversionDeviceType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2107101300;
    }
  }
  IFC4_32.IfcEnergyConversionDeviceType = IfcEnergyConversionDeviceType;
  class IfcEngineType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 132023988;
    }
  }
  IFC4_32.IfcEngineType = IfcEngineType;
  class IfcEvaporativeCoolerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3174744832;
    }
  }
  IFC4_32.IfcEvaporativeCoolerType = IfcEvaporativeCoolerType;
  class IfcEvaporatorType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3390157468;
    }
  }
  IFC4_32.IfcEvaporatorType = IfcEvaporatorType;
  class IfcEvent extends IfcProcess {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, PredefinedType, EventTriggerType, UserDefinedEventTriggerType, EventOccurenceTime) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.PredefinedType = PredefinedType;
      this.EventTriggerType = EventTriggerType;
      this.UserDefinedEventTriggerType = UserDefinedEventTriggerType;
      this.EventOccurenceTime = EventOccurenceTime;
      this.type = 4148101412;
    }
  }
  IFC4_32.IfcEvent = IfcEvent;
  class IfcExternalSpatialStructureElement extends IfcSpatialElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.type = 2853485674;
    }
  }
  IFC4_32.IfcExternalSpatialStructureElement = IfcExternalSpatialStructureElement;
  class IfcFacetedBrep extends IfcManifoldSolidBrep {
    constructor(expressID, Outer) {
      super(expressID, Outer);
      this.Outer = Outer;
      this.type = 807026263;
    }
  }
  IFC4_32.IfcFacetedBrep = IfcFacetedBrep;
  class IfcFacetedBrepWithVoids extends IfcFacetedBrep {
    constructor(expressID, Outer, Voids) {
      super(expressID, Outer);
      this.Outer = Outer;
      this.Voids = Voids;
      this.type = 3737207727;
    }
  }
  IFC4_32.IfcFacetedBrepWithVoids = IfcFacetedBrepWithVoids;
  class IfcFacility extends IfcSpatialStructureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.type = 24185140;
    }
  }
  IFC4_32.IfcFacility = IfcFacility;
  class IfcFacilityPart extends IfcSpatialStructureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.UsageType = UsageType;
      this.type = 1310830890;
    }
  }
  IFC4_32.IfcFacilityPart = IfcFacilityPart;
  class IfcFacilityPartCommon extends IfcFacilityPart {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.UsageType = UsageType;
      this.PredefinedType = PredefinedType;
      this.type = 4228831410;
    }
  }
  IFC4_32.IfcFacilityPartCommon = IfcFacilityPartCommon;
  class IfcFastener extends IfcElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 647756555;
    }
  }
  IFC4_32.IfcFastener = IfcFastener;
  class IfcFastenerType extends IfcElementComponentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2489546625;
    }
  }
  IFC4_32.IfcFastenerType = IfcFastenerType;
  class IfcFeatureElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2827207264;
    }
  }
  IFC4_32.IfcFeatureElement = IfcFeatureElement;
  class IfcFeatureElementAddition extends IfcFeatureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2143335405;
    }
  }
  IFC4_32.IfcFeatureElementAddition = IfcFeatureElementAddition;
  class IfcFeatureElementSubtraction extends IfcFeatureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1287392070;
    }
  }
  IFC4_32.IfcFeatureElementSubtraction = IfcFeatureElementSubtraction;
  class IfcFlowControllerType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3907093117;
    }
  }
  IFC4_32.IfcFlowControllerType = IfcFlowControllerType;
  class IfcFlowFittingType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3198132628;
    }
  }
  IFC4_32.IfcFlowFittingType = IfcFlowFittingType;
  class IfcFlowMeterType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3815607619;
    }
  }
  IFC4_32.IfcFlowMeterType = IfcFlowMeterType;
  class IfcFlowMovingDeviceType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1482959167;
    }
  }
  IFC4_32.IfcFlowMovingDeviceType = IfcFlowMovingDeviceType;
  class IfcFlowSegmentType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1834744321;
    }
  }
  IFC4_32.IfcFlowSegmentType = IfcFlowSegmentType;
  class IfcFlowStorageDeviceType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1339347760;
    }
  }
  IFC4_32.IfcFlowStorageDeviceType = IfcFlowStorageDeviceType;
  class IfcFlowTerminalType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2297155007;
    }
  }
  IFC4_32.IfcFlowTerminalType = IfcFlowTerminalType;
  class IfcFlowTreatmentDeviceType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3009222698;
    }
  }
  IFC4_32.IfcFlowTreatmentDeviceType = IfcFlowTreatmentDeviceType;
  class IfcFootingType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1893162501;
    }
  }
  IFC4_32.IfcFootingType = IfcFootingType;
  class IfcFurnishingElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 263784265;
    }
  }
  IFC4_32.IfcFurnishingElement = IfcFurnishingElement;
  class IfcFurniture extends IfcFurnishingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1509553395;
    }
  }
  IFC4_32.IfcFurniture = IfcFurniture;
  class IfcGeographicElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3493046030;
    }
  }
  IFC4_32.IfcGeographicElement = IfcGeographicElement;
  class IfcGeotechnicalElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 4230923436;
    }
  }
  IFC4_32.IfcGeotechnicalElement = IfcGeotechnicalElement;
  class IfcGeotechnicalStratum extends IfcGeotechnicalElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1594536857;
    }
  }
  IFC4_32.IfcGeotechnicalStratum = IfcGeotechnicalStratum;
  class IfcGradientCurve extends IfcCompositeCurve {
    constructor(expressID, Segments, SelfIntersect, BaseCurve, EndPoint) {
      super(expressID, Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.BaseCurve = BaseCurve;
      this.EndPoint = EndPoint;
      this.type = 2898700619;
    }
  }
  IFC4_32.IfcGradientCurve = IfcGradientCurve;
  class IfcGroup extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2706460486;
    }
  }
  IFC4_32.IfcGroup = IfcGroup;
  class IfcHeatExchangerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1251058090;
    }
  }
  IFC4_32.IfcHeatExchangerType = IfcHeatExchangerType;
  class IfcHumidifierType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1806887404;
    }
  }
  IFC4_32.IfcHumidifierType = IfcHumidifierType;
  class IfcImpactProtectionDevice extends IfcElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2568555532;
    }
  }
  IFC4_32.IfcImpactProtectionDevice = IfcImpactProtectionDevice;
  class IfcImpactProtectionDeviceType extends IfcElementComponentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3948183225;
    }
  }
  IFC4_32.IfcImpactProtectionDeviceType = IfcImpactProtectionDeviceType;
  class IfcIndexedPolyCurve extends IfcBoundedCurve {
    constructor(expressID, Points, Segments, SelfIntersect) {
      super(expressID);
      this.Points = Points;
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 2571569899;
    }
  }
  IFC4_32.IfcIndexedPolyCurve = IfcIndexedPolyCurve;
  class IfcInterceptorType extends IfcFlowTreatmentDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3946677679;
    }
  }
  IFC4_32.IfcInterceptorType = IfcInterceptorType;
  class IfcIntersectionCurve extends IfcSurfaceCurve {
    constructor(expressID, Curve3D, AssociatedGeometry, MasterRepresentation) {
      super(expressID, Curve3D, AssociatedGeometry, MasterRepresentation);
      this.Curve3D = Curve3D;
      this.AssociatedGeometry = AssociatedGeometry;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 3113134337;
    }
  }
  IFC4_32.IfcIntersectionCurve = IfcIntersectionCurve;
  class IfcInventory extends IfcGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, Jurisdiction, ResponsiblePersons, LastUpdateDate, CurrentValue, OriginalValue) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.Jurisdiction = Jurisdiction;
      this.ResponsiblePersons = ResponsiblePersons;
      this.LastUpdateDate = LastUpdateDate;
      this.CurrentValue = CurrentValue;
      this.OriginalValue = OriginalValue;
      this.type = 2391368822;
    }
  }
  IFC4_32.IfcInventory = IfcInventory;
  class IfcJunctionBoxType extends IfcFlowFittingType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4288270099;
    }
  }
  IFC4_32.IfcJunctionBoxType = IfcJunctionBoxType;
  class IfcKerbType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, Mountable) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.Mountable = Mountable;
      this.type = 679976338;
    }
  }
  IFC4_32.IfcKerbType = IfcKerbType;
  class IfcLaborResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 3827777499;
    }
  }
  IFC4_32.IfcLaborResource = IfcLaborResource;
  class IfcLampType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1051575348;
    }
  }
  IFC4_32.IfcLampType = IfcLampType;
  class IfcLightFixtureType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1161773419;
    }
  }
  IFC4_32.IfcLightFixtureType = IfcLightFixtureType;
  class IfcLinearElement extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 2176059722;
    }
  }
  IFC4_32.IfcLinearElement = IfcLinearElement;
  class IfcLiquidTerminalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1770583370;
    }
  }
  IFC4_32.IfcLiquidTerminalType = IfcLiquidTerminalType;
  class IfcMarineFacility extends IfcFacility {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.PredefinedType = PredefinedType;
      this.type = 525669439;
    }
  }
  IFC4_32.IfcMarineFacility = IfcMarineFacility;
  class IfcMarinePart extends IfcFacilityPart {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.UsageType = UsageType;
      this.PredefinedType = PredefinedType;
      this.type = 976884017;
    }
  }
  IFC4_32.IfcMarinePart = IfcMarinePart;
  class IfcMechanicalFastener extends IfcElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NominalDiameter, NominalLength, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.NominalDiameter = NominalDiameter;
      this.NominalLength = NominalLength;
      this.PredefinedType = PredefinedType;
      this.type = 377706215;
    }
  }
  IFC4_32.IfcMechanicalFastener = IfcMechanicalFastener;
  class IfcMechanicalFastenerType extends IfcElementComponentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, NominalLength) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.NominalLength = NominalLength;
      this.type = 2108223431;
    }
  }
  IFC4_32.IfcMechanicalFastenerType = IfcMechanicalFastenerType;
  class IfcMedicalDeviceType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1114901282;
    }
  }
  IFC4_32.IfcMedicalDeviceType = IfcMedicalDeviceType;
  class IfcMemberType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3181161470;
    }
  }
  IFC4_32.IfcMemberType = IfcMemberType;
  class IfcMobileTelecommunicationsApplianceType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1950438474;
    }
  }
  IFC4_32.IfcMobileTelecommunicationsApplianceType = IfcMobileTelecommunicationsApplianceType;
  class IfcMooringDeviceType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 710110818;
    }
  }
  IFC4_32.IfcMooringDeviceType = IfcMooringDeviceType;
  class IfcMotorConnectionType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 977012517;
    }
  }
  IFC4_32.IfcMotorConnectionType = IfcMotorConnectionType;
  class IfcNavigationElementType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 506776471;
    }
  }
  IFC4_32.IfcNavigationElementType = IfcNavigationElementType;
  class IfcOccupant extends IfcActor {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheActor = TheActor;
      this.PredefinedType = PredefinedType;
      this.type = 4143007308;
    }
  }
  IFC4_32.IfcOccupant = IfcOccupant;
  class IfcOpeningElement extends IfcFeatureElementSubtraction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3588315303;
    }
  }
  IFC4_32.IfcOpeningElement = IfcOpeningElement;
  class IfcOutletType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2837617999;
    }
  }
  IFC4_32.IfcOutletType = IfcOutletType;
  class IfcPavementType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 514975943;
    }
  }
  IFC4_32.IfcPavementType = IfcPavementType;
  class IfcPerformanceHistory extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LifeCyclePhase, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LifeCyclePhase = LifeCyclePhase;
      this.PredefinedType = PredefinedType;
      this.type = 2382730787;
    }
  }
  IFC4_32.IfcPerformanceHistory = IfcPerformanceHistory;
  class IfcPermeableCoveringProperties extends IfcPreDefinedPropertySet {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.OperationType = OperationType;
      this.PanelPosition = PanelPosition;
      this.FrameDepth = FrameDepth;
      this.FrameThickness = FrameThickness;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 3566463478;
    }
  }
  IFC4_32.IfcPermeableCoveringProperties = IfcPermeableCoveringProperties;
  class IfcPermit extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.LongDescription = LongDescription;
      this.type = 3327091369;
    }
  }
  IFC4_32.IfcPermit = IfcPermit;
  class IfcPileType extends IfcDeepFoundationType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1158309216;
    }
  }
  IFC4_32.IfcPileType = IfcPileType;
  class IfcPipeFittingType extends IfcFlowFittingType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 804291784;
    }
  }
  IFC4_32.IfcPipeFittingType = IfcPipeFittingType;
  class IfcPipeSegmentType extends IfcFlowSegmentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4231323485;
    }
  }
  IFC4_32.IfcPipeSegmentType = IfcPipeSegmentType;
  class IfcPlateType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4017108033;
    }
  }
  IFC4_32.IfcPlateType = IfcPlateType;
  class IfcPolygonalFaceSet extends IfcTessellatedFaceSet {
    constructor(expressID, Coordinates, Closed, Faces, PnIndex) {
      super(expressID, Coordinates, Closed);
      this.Coordinates = Coordinates;
      this.Closed = Closed;
      this.Faces = Faces;
      this.PnIndex = PnIndex;
      this.type = 2839578677;
    }
  }
  IFC4_32.IfcPolygonalFaceSet = IfcPolygonalFaceSet;
  class IfcPolyline extends IfcBoundedCurve {
    constructor(expressID, Points) {
      super(expressID);
      this.Points = Points;
      this.type = 3724593414;
    }
  }
  IFC4_32.IfcPolyline = IfcPolyline;
  class IfcPort extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 3740093272;
    }
  }
  IFC4_32.IfcPort = IfcPort;
  class IfcPositioningElement extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 1946335990;
    }
  }
  IFC4_32.IfcPositioningElement = IfcPositioningElement;
  class IfcProcedure extends IfcProcess {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.PredefinedType = PredefinedType;
      this.type = 2744685151;
    }
  }
  IFC4_32.IfcProcedure = IfcProcedure;
  class IfcProjectOrder extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.LongDescription = LongDescription;
      this.type = 2904328755;
    }
  }
  IFC4_32.IfcProjectOrder = IfcProjectOrder;
  class IfcProjectionElement extends IfcFeatureElementAddition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3651124850;
    }
  }
  IFC4_32.IfcProjectionElement = IfcProjectionElement;
  class IfcProtectiveDeviceType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1842657554;
    }
  }
  IFC4_32.IfcProtectiveDeviceType = IfcProtectiveDeviceType;
  class IfcPumpType extends IfcFlowMovingDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2250791053;
    }
  }
  IFC4_32.IfcPumpType = IfcPumpType;
  class IfcRailType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1763565496;
    }
  }
  IFC4_32.IfcRailType = IfcRailType;
  class IfcRailingType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2893384427;
    }
  }
  IFC4_32.IfcRailingType = IfcRailingType;
  class IfcRailway extends IfcFacility {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.PredefinedType = PredefinedType;
      this.type = 3992365140;
    }
  }
  IFC4_32.IfcRailway = IfcRailway;
  class IfcRailwayPart extends IfcFacilityPart {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.UsageType = UsageType;
      this.PredefinedType = PredefinedType;
      this.type = 1891881377;
    }
  }
  IFC4_32.IfcRailwayPart = IfcRailwayPart;
  class IfcRampFlightType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2324767716;
    }
  }
  IFC4_32.IfcRampFlightType = IfcRampFlightType;
  class IfcRampType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1469900589;
    }
  }
  IFC4_32.IfcRampType = IfcRampType;
  class IfcRationalBSplineSurfaceWithKnots extends IfcBSplineSurfaceWithKnots {
    constructor(expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec, WeightsData) {
      super(expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec);
      this.UDegree = UDegree;
      this.VDegree = VDegree;
      this.ControlPointsList = ControlPointsList;
      this.SurfaceForm = SurfaceForm;
      this.UClosed = UClosed;
      this.VClosed = VClosed;
      this.SelfIntersect = SelfIntersect;
      this.UMultiplicities = UMultiplicities;
      this.VMultiplicities = VMultiplicities;
      this.UKnots = UKnots;
      this.VKnots = VKnots;
      this.KnotSpec = KnotSpec;
      this.WeightsData = WeightsData;
      this.type = 683857671;
    }
  }
  IFC4_32.IfcRationalBSplineSurfaceWithKnots = IfcRationalBSplineSurfaceWithKnots;
  class IfcReferent extends IfcPositioningElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.type = 4021432810;
    }
  }
  IFC4_32.IfcReferent = IfcReferent;
  class IfcReinforcingElement extends IfcElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.type = 3027567501;
    }
  }
  IFC4_32.IfcReinforcingElement = IfcReinforcingElement;
  class IfcReinforcingElementType extends IfcElementComponentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 964333572;
    }
  }
  IFC4_32.IfcReinforcingElementType = IfcReinforcingElementType;
  class IfcReinforcingMesh extends IfcReinforcingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.MeshLength = MeshLength;
      this.MeshWidth = MeshWidth;
      this.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
      this.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
      this.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
      this.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
      this.LongitudinalBarSpacing = LongitudinalBarSpacing;
      this.TransverseBarSpacing = TransverseBarSpacing;
      this.PredefinedType = PredefinedType;
      this.type = 2320036040;
    }
  }
  IFC4_32.IfcReinforcingMesh = IfcReinforcingMesh;
  class IfcReinforcingMeshType extends IfcReinforcingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing, BendingShapeCode, BendingParameters) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.MeshLength = MeshLength;
      this.MeshWidth = MeshWidth;
      this.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
      this.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
      this.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
      this.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
      this.LongitudinalBarSpacing = LongitudinalBarSpacing;
      this.TransverseBarSpacing = TransverseBarSpacing;
      this.BendingShapeCode = BendingShapeCode;
      this.BendingParameters = BendingParameters;
      this.type = 2310774935;
    }
  }
  IFC4_32.IfcReinforcingMeshType = IfcReinforcingMeshType;
  class IfcRelAdheresToElement extends IfcRelDecomposes {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedSurfaceFeatures) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedSurfaceFeatures = RelatedSurfaceFeatures;
      this.type = 3818125796;
    }
  }
  IFC4_32.IfcRelAdheresToElement = IfcRelAdheresToElement;
  class IfcRelAggregates extends IfcRelDecomposes {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingObject = RelatingObject;
      this.RelatedObjects = RelatedObjects;
      this.type = 160246688;
    }
  }
  IFC4_32.IfcRelAggregates = IfcRelAggregates;
  class IfcRoad extends IfcFacility {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.PredefinedType = PredefinedType;
      this.type = 146592293;
    }
  }
  IFC4_32.IfcRoad = IfcRoad;
  class IfcRoadPart extends IfcFacilityPart {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.UsageType = UsageType;
      this.PredefinedType = PredefinedType;
      this.type = 550521510;
    }
  }
  IFC4_32.IfcRoadPart = IfcRoadPart;
  class IfcRoofType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2781568857;
    }
  }
  IFC4_32.IfcRoofType = IfcRoofType;
  class IfcSanitaryTerminalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1768891740;
    }
  }
  IFC4_32.IfcSanitaryTerminalType = IfcSanitaryTerminalType;
  class IfcSeamCurve extends IfcSurfaceCurve {
    constructor(expressID, Curve3D, AssociatedGeometry, MasterRepresentation) {
      super(expressID, Curve3D, AssociatedGeometry, MasterRepresentation);
      this.Curve3D = Curve3D;
      this.AssociatedGeometry = AssociatedGeometry;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 2157484638;
    }
  }
  IFC4_32.IfcSeamCurve = IfcSeamCurve;
  class IfcSecondOrderPolynomialSpiral extends IfcSpiral {
    constructor(expressID, Position, QuadraticTerm, LinearTerm, ConstantTerm) {
      super(expressID, Position);
      this.Position = Position;
      this.QuadraticTerm = QuadraticTerm;
      this.LinearTerm = LinearTerm;
      this.ConstantTerm = ConstantTerm;
      this.type = 3649235739;
    }
  }
  IFC4_32.IfcSecondOrderPolynomialSpiral = IfcSecondOrderPolynomialSpiral;
  class IfcSegmentedReferenceCurve extends IfcCompositeCurve {
    constructor(expressID, Segments, SelfIntersect, BaseCurve, EndPoint) {
      super(expressID, Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.BaseCurve = BaseCurve;
      this.EndPoint = EndPoint;
      this.type = 544395925;
    }
  }
  IFC4_32.IfcSegmentedReferenceCurve = IfcSegmentedReferenceCurve;
  class IfcSeventhOrderPolynomialSpiral extends IfcSpiral {
    constructor(expressID, Position, SepticTerm, SexticTerm, QuinticTerm, QuarticTerm, CubicTerm, QuadraticTerm, LinearTerm, ConstantTerm) {
      super(expressID, Position);
      this.Position = Position;
      this.SepticTerm = SepticTerm;
      this.SexticTerm = SexticTerm;
      this.QuinticTerm = QuinticTerm;
      this.QuarticTerm = QuarticTerm;
      this.CubicTerm = CubicTerm;
      this.QuadraticTerm = QuadraticTerm;
      this.LinearTerm = LinearTerm;
      this.ConstantTerm = ConstantTerm;
      this.type = 1027922057;
    }
  }
  IFC4_32.IfcSeventhOrderPolynomialSpiral = IfcSeventhOrderPolynomialSpiral;
  class IfcShadingDeviceType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4074543187;
    }
  }
  IFC4_32.IfcShadingDeviceType = IfcShadingDeviceType;
  class IfcSign extends IfcElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 33720170;
    }
  }
  IFC4_32.IfcSign = IfcSign;
  class IfcSignType extends IfcElementComponentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3599934289;
    }
  }
  IFC4_32.IfcSignType = IfcSignType;
  class IfcSignalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1894708472;
    }
  }
  IFC4_32.IfcSignalType = IfcSignalType;
  class IfcSineSpiral extends IfcSpiral {
    constructor(expressID, Position, SineTerm, LinearTerm, ConstantTerm) {
      super(expressID, Position);
      this.Position = Position;
      this.SineTerm = SineTerm;
      this.LinearTerm = LinearTerm;
      this.ConstantTerm = ConstantTerm;
      this.type = 42703149;
    }
  }
  IFC4_32.IfcSineSpiral = IfcSineSpiral;
  class IfcSite extends IfcSpatialStructureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, RefLatitude, RefLongitude, RefElevation, LandTitleNumber, SiteAddress) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.RefLatitude = RefLatitude;
      this.RefLongitude = RefLongitude;
      this.RefElevation = RefElevation;
      this.LandTitleNumber = LandTitleNumber;
      this.SiteAddress = SiteAddress;
      this.type = 4097777520;
    }
  }
  IFC4_32.IfcSite = IfcSite;
  class IfcSlabType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2533589738;
    }
  }
  IFC4_32.IfcSlabType = IfcSlabType;
  class IfcSolarDeviceType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1072016465;
    }
  }
  IFC4_32.IfcSolarDeviceType = IfcSolarDeviceType;
  class IfcSpace extends IfcSpatialStructureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType, ElevationWithFlooring) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.PredefinedType = PredefinedType;
      this.ElevationWithFlooring = ElevationWithFlooring;
      this.type = 3856911033;
    }
  }
  IFC4_32.IfcSpace = IfcSpace;
  class IfcSpaceHeaterType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1305183839;
    }
  }
  IFC4_32.IfcSpaceHeaterType = IfcSpaceHeaterType;
  class IfcSpaceType extends IfcSpatialStructureElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, LongName) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.LongName = LongName;
      this.type = 3812236995;
    }
  }
  IFC4_32.IfcSpaceType = IfcSpaceType;
  class IfcStackTerminalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3112655638;
    }
  }
  IFC4_32.IfcStackTerminalType = IfcStackTerminalType;
  class IfcStairFlightType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1039846685;
    }
  }
  IFC4_32.IfcStairFlightType = IfcStairFlightType;
  class IfcStairType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 338393293;
    }
  }
  IFC4_32.IfcStairType = IfcStairType;
  class IfcStructuralAction extends IfcStructuralActivity {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.type = 682877961;
    }
  }
  IFC4_32.IfcStructuralAction = IfcStructuralAction;
  class IfcStructuralConnection extends IfcStructuralItem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.type = 1179482911;
    }
  }
  IFC4_32.IfcStructuralConnection = IfcStructuralConnection;
  class IfcStructuralCurveAction extends IfcStructuralAction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.PredefinedType = PredefinedType;
      this.type = 1004757350;
    }
  }
  IFC4_32.IfcStructuralCurveAction = IfcStructuralCurveAction;
  class IfcStructuralCurveConnection extends IfcStructuralConnection {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition, AxisDirection) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.AxisDirection = AxisDirection;
      this.type = 4243806635;
    }
  }
  IFC4_32.IfcStructuralCurveConnection = IfcStructuralCurveConnection;
  class IfcStructuralCurveMember extends IfcStructuralMember {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Axis = Axis;
      this.type = 214636428;
    }
  }
  IFC4_32.IfcStructuralCurveMember = IfcStructuralCurveMember;
  class IfcStructuralCurveMemberVarying extends IfcStructuralCurveMember {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Axis = Axis;
      this.type = 2445595289;
    }
  }
  IFC4_32.IfcStructuralCurveMemberVarying = IfcStructuralCurveMemberVarying;
  class IfcStructuralCurveReaction extends IfcStructuralReaction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.PredefinedType = PredefinedType;
      this.type = 2757150158;
    }
  }
  IFC4_32.IfcStructuralCurveReaction = IfcStructuralCurveReaction;
  class IfcStructuralLinearAction extends IfcStructuralCurveAction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.PredefinedType = PredefinedType;
      this.type = 1807405624;
    }
  }
  IFC4_32.IfcStructuralLinearAction = IfcStructuralLinearAction;
  class IfcStructuralLoadGroup extends IfcGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.ActionType = ActionType;
      this.ActionSource = ActionSource;
      this.Coefficient = Coefficient;
      this.Purpose = Purpose;
      this.type = 1252848954;
    }
  }
  IFC4_32.IfcStructuralLoadGroup = IfcStructuralLoadGroup;
  class IfcStructuralPointAction extends IfcStructuralAction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.type = 2082059205;
    }
  }
  IFC4_32.IfcStructuralPointAction = IfcStructuralPointAction;
  class IfcStructuralPointConnection extends IfcStructuralConnection {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition, ConditionCoordinateSystem) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.ConditionCoordinateSystem = ConditionCoordinateSystem;
      this.type = 734778138;
    }
  }
  IFC4_32.IfcStructuralPointConnection = IfcStructuralPointConnection;
  class IfcStructuralPointReaction extends IfcStructuralReaction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 1235345126;
    }
  }
  IFC4_32.IfcStructuralPointReaction = IfcStructuralPointReaction;
  class IfcStructuralResultGroup extends IfcGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheoryType, ResultForLoadGroup, IsLinear) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheoryType = TheoryType;
      this.ResultForLoadGroup = ResultForLoadGroup;
      this.IsLinear = IsLinear;
      this.type = 2986769608;
    }
  }
  IFC4_32.IfcStructuralResultGroup = IfcStructuralResultGroup;
  class IfcStructuralSurfaceAction extends IfcStructuralAction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.PredefinedType = PredefinedType;
      this.type = 3657597509;
    }
  }
  IFC4_32.IfcStructuralSurfaceAction = IfcStructuralSurfaceAction;
  class IfcStructuralSurfaceConnection extends IfcStructuralConnection {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.type = 1975003073;
    }
  }
  IFC4_32.IfcStructuralSurfaceConnection = IfcStructuralSurfaceConnection;
  class IfcSubContractResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 148013059;
    }
  }
  IFC4_32.IfcSubContractResource = IfcSubContractResource;
  class IfcSurfaceFeature extends IfcFeatureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3101698114;
    }
  }
  IFC4_32.IfcSurfaceFeature = IfcSurfaceFeature;
  class IfcSwitchingDeviceType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2315554128;
    }
  }
  IFC4_32.IfcSwitchingDeviceType = IfcSwitchingDeviceType;
  class IfcSystem extends IfcGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2254336722;
    }
  }
  IFC4_32.IfcSystem = IfcSystem;
  class IfcSystemFurnitureElement extends IfcFurnishingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 413509423;
    }
  }
  IFC4_32.IfcSystemFurnitureElement = IfcSystemFurnitureElement;
  class IfcTankType extends IfcFlowStorageDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 5716631;
    }
  }
  IFC4_32.IfcTankType = IfcTankType;
  class IfcTendon extends IfcReinforcingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType, NominalDiameter, CrossSectionArea, TensionForce, PreStress, FrictionCoefficient, AnchorageSlip, MinCurvatureRadius) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.TensionForce = TensionForce;
      this.PreStress = PreStress;
      this.FrictionCoefficient = FrictionCoefficient;
      this.AnchorageSlip = AnchorageSlip;
      this.MinCurvatureRadius = MinCurvatureRadius;
      this.type = 3824725483;
    }
  }
  IFC4_32.IfcTendon = IfcTendon;
  class IfcTendonAnchor extends IfcReinforcingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.PredefinedType = PredefinedType;
      this.type = 2347447852;
    }
  }
  IFC4_32.IfcTendonAnchor = IfcTendonAnchor;
  class IfcTendonAnchorType extends IfcReinforcingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3081323446;
    }
  }
  IFC4_32.IfcTendonAnchorType = IfcTendonAnchorType;
  class IfcTendonConduit extends IfcReinforcingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.PredefinedType = PredefinedType;
      this.type = 3663046924;
    }
  }
  IFC4_32.IfcTendonConduit = IfcTendonConduit;
  class IfcTendonConduitType extends IfcReinforcingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2281632017;
    }
  }
  IFC4_32.IfcTendonConduitType = IfcTendonConduitType;
  class IfcTendonType extends IfcReinforcingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, CrossSectionArea, SheathDiameter) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.SheathDiameter = SheathDiameter;
      this.type = 2415094496;
    }
  }
  IFC4_32.IfcTendonType = IfcTendonType;
  class IfcTrackElementType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 618700268;
    }
  }
  IFC4_32.IfcTrackElementType = IfcTrackElementType;
  class IfcTransformerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1692211062;
    }
  }
  IFC4_32.IfcTransformerType = IfcTransformerType;
  class IfcTransportElementType extends IfcTransportationDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2097647324;
    }
  }
  IFC4_32.IfcTransportElementType = IfcTransportElementType;
  class IfcTransportationDevice extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1953115116;
    }
  }
  IFC4_32.IfcTransportationDevice = IfcTransportationDevice;
  class IfcTrimmedCurve extends IfcBoundedCurve {
    constructor(expressID, BasisCurve, Trim1, Trim2, SenseAgreement, MasterRepresentation) {
      super(expressID);
      this.BasisCurve = BasisCurve;
      this.Trim1 = Trim1;
      this.Trim2 = Trim2;
      this.SenseAgreement = SenseAgreement;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 3593883385;
    }
  }
  IFC4_32.IfcTrimmedCurve = IfcTrimmedCurve;
  class IfcTubeBundleType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1600972822;
    }
  }
  IFC4_32.IfcTubeBundleType = IfcTubeBundleType;
  class IfcUnitaryEquipmentType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1911125066;
    }
  }
  IFC4_32.IfcUnitaryEquipmentType = IfcUnitaryEquipmentType;
  class IfcValveType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 728799441;
    }
  }
  IFC4_32.IfcValveType = IfcValveType;
  class IfcVehicle extends IfcTransportationDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 840318589;
    }
  }
  IFC4_32.IfcVehicle = IfcVehicle;
  class IfcVibrationDamper extends IfcElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1530820697;
    }
  }
  IFC4_32.IfcVibrationDamper = IfcVibrationDamper;
  class IfcVibrationDamperType extends IfcElementComponentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3956297820;
    }
  }
  IFC4_32.IfcVibrationDamperType = IfcVibrationDamperType;
  class IfcVibrationIsolator extends IfcElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2391383451;
    }
  }
  IFC4_32.IfcVibrationIsolator = IfcVibrationIsolator;
  class IfcVibrationIsolatorType extends IfcElementComponentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3313531582;
    }
  }
  IFC4_32.IfcVibrationIsolatorType = IfcVibrationIsolatorType;
  class IfcVirtualElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2769231204;
    }
  }
  IFC4_32.IfcVirtualElement = IfcVirtualElement;
  class IfcVoidingFeature extends IfcFeatureElementSubtraction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 926996030;
    }
  }
  IFC4_32.IfcVoidingFeature = IfcVoidingFeature;
  class IfcWallType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1898987631;
    }
  }
  IFC4_32.IfcWallType = IfcWallType;
  class IfcWasteTerminalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1133259667;
    }
  }
  IFC4_32.IfcWasteTerminalType = IfcWasteTerminalType;
  class IfcWindowType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, PartitioningType, ParameterTakesPrecedence, UserDefinedPartitioningType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.PartitioningType = PartitioningType;
      this.ParameterTakesPrecedence = ParameterTakesPrecedence;
      this.UserDefinedPartitioningType = UserDefinedPartitioningType;
      this.type = 4009809668;
    }
  }
  IFC4_32.IfcWindowType = IfcWindowType;
  class IfcWorkCalendar extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, WorkingTimes, ExceptionTimes, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.WorkingTimes = WorkingTimes;
      this.ExceptionTimes = ExceptionTimes;
      this.PredefinedType = PredefinedType;
      this.type = 4088093105;
    }
  }
  IFC4_32.IfcWorkCalendar = IfcWorkCalendar;
  class IfcWorkControl extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.type = 1028945134;
    }
  }
  IFC4_32.IfcWorkControl = IfcWorkControl;
  class IfcWorkPlan extends IfcWorkControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.PredefinedType = PredefinedType;
      this.type = 4218914973;
    }
  }
  IFC4_32.IfcWorkPlan = IfcWorkPlan;
  class IfcWorkSchedule extends IfcWorkControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.PredefinedType = PredefinedType;
      this.type = 3342526732;
    }
  }
  IFC4_32.IfcWorkSchedule = IfcWorkSchedule;
  class IfcZone extends IfcSystem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.type = 1033361043;
    }
  }
  IFC4_32.IfcZone = IfcZone;
  class IfcActionRequest extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.LongDescription = LongDescription;
      this.type = 3821786052;
    }
  }
  IFC4_32.IfcActionRequest = IfcActionRequest;
  class IfcAirTerminalBoxType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1411407467;
    }
  }
  IFC4_32.IfcAirTerminalBoxType = IfcAirTerminalBoxType;
  class IfcAirTerminalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3352864051;
    }
  }
  IFC4_32.IfcAirTerminalType = IfcAirTerminalType;
  class IfcAirToAirHeatRecoveryType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1871374353;
    }
  }
  IFC4_32.IfcAirToAirHeatRecoveryType = IfcAirToAirHeatRecoveryType;
  class IfcAlignmentCant extends IfcLinearElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, RailHeadDistance) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.RailHeadDistance = RailHeadDistance;
      this.type = 4266260250;
    }
  }
  IFC4_32.IfcAlignmentCant = IfcAlignmentCant;
  class IfcAlignmentHorizontal extends IfcLinearElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 1545765605;
    }
  }
  IFC4_32.IfcAlignmentHorizontal = IfcAlignmentHorizontal;
  class IfcAlignmentSegment extends IfcLinearElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, DesignParameters) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.DesignParameters = DesignParameters;
      this.type = 317615605;
    }
  }
  IFC4_32.IfcAlignmentSegment = IfcAlignmentSegment;
  class IfcAlignmentVertical extends IfcLinearElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 1662888072;
    }
  }
  IFC4_32.IfcAlignmentVertical = IfcAlignmentVertical;
  class IfcAsset extends IfcGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, OriginalValue, CurrentValue, TotalReplacementCost, Owner, User, ResponsiblePerson, IncorporationDate, DepreciatedValue) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.OriginalValue = OriginalValue;
      this.CurrentValue = CurrentValue;
      this.TotalReplacementCost = TotalReplacementCost;
      this.Owner = Owner;
      this.User = User;
      this.ResponsiblePerson = ResponsiblePerson;
      this.IncorporationDate = IncorporationDate;
      this.DepreciatedValue = DepreciatedValue;
      this.type = 3460190687;
    }
  }
  IFC4_32.IfcAsset = IfcAsset;
  class IfcAudioVisualApplianceType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1532957894;
    }
  }
  IFC4_32.IfcAudioVisualApplianceType = IfcAudioVisualApplianceType;
  class IfcBSplineCurve extends IfcBoundedCurve {
    constructor(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect) {
      super(expressID);
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.type = 1967976161;
    }
  }
  IFC4_32.IfcBSplineCurve = IfcBSplineCurve;
  class IfcBSplineCurveWithKnots extends IfcBSplineCurve {
    constructor(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec) {
      super(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect);
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.KnotMultiplicities = KnotMultiplicities;
      this.Knots = Knots;
      this.KnotSpec = KnotSpec;
      this.type = 2461110595;
    }
  }
  IFC4_32.IfcBSplineCurveWithKnots = IfcBSplineCurveWithKnots;
  class IfcBeamType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 819618141;
    }
  }
  IFC4_32.IfcBeamType = IfcBeamType;
  class IfcBearingType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3649138523;
    }
  }
  IFC4_32.IfcBearingType = IfcBearingType;
  class IfcBoilerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 231477066;
    }
  }
  IFC4_32.IfcBoilerType = IfcBoilerType;
  class IfcBoundaryCurve extends IfcCompositeCurveOnSurface {
    constructor(expressID, Segments, SelfIntersect) {
      super(expressID, Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 1136057603;
    }
  }
  IFC4_32.IfcBoundaryCurve = IfcBoundaryCurve;
  class IfcBridge extends IfcFacility {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.PredefinedType = PredefinedType;
      this.type = 644574406;
    }
  }
  IFC4_32.IfcBridge = IfcBridge;
  class IfcBridgePart extends IfcFacilityPart {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.UsageType = UsageType;
      this.PredefinedType = PredefinedType;
      this.type = 963979645;
    }
  }
  IFC4_32.IfcBridgePart = IfcBridgePart;
  class IfcBuilding extends IfcFacility {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, ElevationOfRefHeight, ElevationOfTerrain, BuildingAddress) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.ElevationOfRefHeight = ElevationOfRefHeight;
      this.ElevationOfTerrain = ElevationOfTerrain;
      this.BuildingAddress = BuildingAddress;
      this.type = 4031249490;
    }
  }
  IFC4_32.IfcBuilding = IfcBuilding;
  class IfcBuildingElementPart extends IfcElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2979338954;
    }
  }
  IFC4_32.IfcBuildingElementPart = IfcBuildingElementPart;
  class IfcBuildingElementPartType extends IfcElementComponentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 39481116;
    }
  }
  IFC4_32.IfcBuildingElementPartType = IfcBuildingElementPartType;
  class IfcBuildingElementProxyType extends IfcBuiltElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1909888760;
    }
  }
  IFC4_32.IfcBuildingElementProxyType = IfcBuildingElementProxyType;
  class IfcBuildingSystem extends IfcSystem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, LongName) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.LongName = LongName;
      this.type = 1177604601;
    }
  }
  IFC4_32.IfcBuildingSystem = IfcBuildingSystem;
  class IfcBuiltElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1876633798;
    }
  }
  IFC4_32.IfcBuiltElement = IfcBuiltElement;
  class IfcBuiltSystem extends IfcSystem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, LongName) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.LongName = LongName;
      this.type = 3862327254;
    }
  }
  IFC4_32.IfcBuiltSystem = IfcBuiltSystem;
  class IfcBurnerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2188180465;
    }
  }
  IFC4_32.IfcBurnerType = IfcBurnerType;
  class IfcCableCarrierFittingType extends IfcFlowFittingType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 395041908;
    }
  }
  IFC4_32.IfcCableCarrierFittingType = IfcCableCarrierFittingType;
  class IfcCableCarrierSegmentType extends IfcFlowSegmentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3293546465;
    }
  }
  IFC4_32.IfcCableCarrierSegmentType = IfcCableCarrierSegmentType;
  class IfcCableFittingType extends IfcFlowFittingType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2674252688;
    }
  }
  IFC4_32.IfcCableFittingType = IfcCableFittingType;
  class IfcCableSegmentType extends IfcFlowSegmentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1285652485;
    }
  }
  IFC4_32.IfcCableSegmentType = IfcCableSegmentType;
  class IfcCaissonFoundationType extends IfcDeepFoundationType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3203706013;
    }
  }
  IFC4_32.IfcCaissonFoundationType = IfcCaissonFoundationType;
  class IfcChillerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2951183804;
    }
  }
  IFC4_32.IfcChillerType = IfcChillerType;
  class IfcChimney extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3296154744;
    }
  }
  IFC4_32.IfcChimney = IfcChimney;
  class IfcCircle extends IfcConic {
    constructor(expressID, Position, Radius) {
      super(expressID, Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 2611217952;
    }
  }
  IFC4_32.IfcCircle = IfcCircle;
  class IfcCivilElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1677625105;
    }
  }
  IFC4_32.IfcCivilElement = IfcCivilElement;
  class IfcCoilType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2301859152;
    }
  }
  IFC4_32.IfcCoilType = IfcCoilType;
  class IfcColumn extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 843113511;
    }
  }
  IFC4_32.IfcColumn = IfcColumn;
  class IfcCommunicationsApplianceType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 400855858;
    }
  }
  IFC4_32.IfcCommunicationsApplianceType = IfcCommunicationsApplianceType;
  class IfcCompressorType extends IfcFlowMovingDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3850581409;
    }
  }
  IFC4_32.IfcCompressorType = IfcCompressorType;
  class IfcCondenserType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2816379211;
    }
  }
  IFC4_32.IfcCondenserType = IfcCondenserType;
  class IfcConstructionEquipmentResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 3898045240;
    }
  }
  IFC4_32.IfcConstructionEquipmentResource = IfcConstructionEquipmentResource;
  class IfcConstructionMaterialResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 1060000209;
    }
  }
  IFC4_32.IfcConstructionMaterialResource = IfcConstructionMaterialResource;
  class IfcConstructionProductResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 488727124;
    }
  }
  IFC4_32.IfcConstructionProductResource = IfcConstructionProductResource;
  class IfcConveyorSegmentType extends IfcFlowSegmentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2940368186;
    }
  }
  IFC4_32.IfcConveyorSegmentType = IfcConveyorSegmentType;
  class IfcCooledBeamType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 335055490;
    }
  }
  IFC4_32.IfcCooledBeamType = IfcCooledBeamType;
  class IfcCoolingTowerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2954562838;
    }
  }
  IFC4_32.IfcCoolingTowerType = IfcCoolingTowerType;
  class IfcCourse extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1502416096;
    }
  }
  IFC4_32.IfcCourse = IfcCourse;
  class IfcCovering extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1973544240;
    }
  }
  IFC4_32.IfcCovering = IfcCovering;
  class IfcCurtainWall extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3495092785;
    }
  }
  IFC4_32.IfcCurtainWall = IfcCurtainWall;
  class IfcDamperType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3961806047;
    }
  }
  IFC4_32.IfcDamperType = IfcDamperType;
  class IfcDeepFoundation extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3426335179;
    }
  }
  IFC4_32.IfcDeepFoundation = IfcDeepFoundation;
  class IfcDiscreteAccessory extends IfcElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1335981549;
    }
  }
  IFC4_32.IfcDiscreteAccessory = IfcDiscreteAccessory;
  class IfcDiscreteAccessoryType extends IfcElementComponentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2635815018;
    }
  }
  IFC4_32.IfcDiscreteAccessoryType = IfcDiscreteAccessoryType;
  class IfcDistributionBoardType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 479945903;
    }
  }
  IFC4_32.IfcDistributionBoardType = IfcDistributionBoardType;
  class IfcDistributionChamberElementType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1599208980;
    }
  }
  IFC4_32.IfcDistributionChamberElementType = IfcDistributionChamberElementType;
  class IfcDistributionControlElementType extends IfcDistributionElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2063403501;
    }
  }
  IFC4_32.IfcDistributionControlElementType = IfcDistributionControlElementType;
  class IfcDistributionElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1945004755;
    }
  }
  IFC4_32.IfcDistributionElement = IfcDistributionElement;
  class IfcDistributionFlowElement extends IfcDistributionElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3040386961;
    }
  }
  IFC4_32.IfcDistributionFlowElement = IfcDistributionFlowElement;
  class IfcDistributionPort extends IfcPort {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, FlowDirection, PredefinedType, SystemType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.FlowDirection = FlowDirection;
      this.PredefinedType = PredefinedType;
      this.SystemType = SystemType;
      this.type = 3041715199;
    }
  }
  IFC4_32.IfcDistributionPort = IfcDistributionPort;
  class IfcDistributionSystem extends IfcSystem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.PredefinedType = PredefinedType;
      this.type = 3205830791;
    }
  }
  IFC4_32.IfcDistributionSystem = IfcDistributionSystem;
  class IfcDoor extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, OperationType, UserDefinedOperationType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OverallHeight = OverallHeight;
      this.OverallWidth = OverallWidth;
      this.PredefinedType = PredefinedType;
      this.OperationType = OperationType;
      this.UserDefinedOperationType = UserDefinedOperationType;
      this.type = 395920057;
    }
  }
  IFC4_32.IfcDoor = IfcDoor;
  class IfcDuctFittingType extends IfcFlowFittingType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 869906466;
    }
  }
  IFC4_32.IfcDuctFittingType = IfcDuctFittingType;
  class IfcDuctSegmentType extends IfcFlowSegmentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3760055223;
    }
  }
  IFC4_32.IfcDuctSegmentType = IfcDuctSegmentType;
  class IfcDuctSilencerType extends IfcFlowTreatmentDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2030761528;
    }
  }
  IFC4_32.IfcDuctSilencerType = IfcDuctSilencerType;
  class IfcEarthworksCut extends IfcFeatureElementSubtraction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3071239417;
    }
  }
  IFC4_32.IfcEarthworksCut = IfcEarthworksCut;
  class IfcEarthworksElement extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1077100507;
    }
  }
  IFC4_32.IfcEarthworksElement = IfcEarthworksElement;
  class IfcEarthworksFill extends IfcEarthworksElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3376911765;
    }
  }
  IFC4_32.IfcEarthworksFill = IfcEarthworksFill;
  class IfcElectricApplianceType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 663422040;
    }
  }
  IFC4_32.IfcElectricApplianceType = IfcElectricApplianceType;
  class IfcElectricDistributionBoardType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2417008758;
    }
  }
  IFC4_32.IfcElectricDistributionBoardType = IfcElectricDistributionBoardType;
  class IfcElectricFlowStorageDeviceType extends IfcFlowStorageDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3277789161;
    }
  }
  IFC4_32.IfcElectricFlowStorageDeviceType = IfcElectricFlowStorageDeviceType;
  class IfcElectricFlowTreatmentDeviceType extends IfcFlowTreatmentDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2142170206;
    }
  }
  IFC4_32.IfcElectricFlowTreatmentDeviceType = IfcElectricFlowTreatmentDeviceType;
  class IfcElectricGeneratorType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1534661035;
    }
  }
  IFC4_32.IfcElectricGeneratorType = IfcElectricGeneratorType;
  class IfcElectricMotorType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1217240411;
    }
  }
  IFC4_32.IfcElectricMotorType = IfcElectricMotorType;
  class IfcElectricTimeControlType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 712377611;
    }
  }
  IFC4_32.IfcElectricTimeControlType = IfcElectricTimeControlType;
  class IfcEnergyConversionDevice extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1658829314;
    }
  }
  IFC4_32.IfcEnergyConversionDevice = IfcEnergyConversionDevice;
  class IfcEngine extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2814081492;
    }
  }
  IFC4_32.IfcEngine = IfcEngine;
  class IfcEvaporativeCooler extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3747195512;
    }
  }
  IFC4_32.IfcEvaporativeCooler = IfcEvaporativeCooler;
  class IfcEvaporator extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 484807127;
    }
  }
  IFC4_32.IfcEvaporator = IfcEvaporator;
  class IfcExternalSpatialElement extends IfcExternalSpatialStructureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.PredefinedType = PredefinedType;
      this.type = 1209101575;
    }
  }
  IFC4_32.IfcExternalSpatialElement = IfcExternalSpatialElement;
  class IfcFanType extends IfcFlowMovingDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 346874300;
    }
  }
  IFC4_32.IfcFanType = IfcFanType;
  class IfcFilterType extends IfcFlowTreatmentDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1810631287;
    }
  }
  IFC4_32.IfcFilterType = IfcFilterType;
  class IfcFireSuppressionTerminalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4222183408;
    }
  }
  IFC4_32.IfcFireSuppressionTerminalType = IfcFireSuppressionTerminalType;
  class IfcFlowController extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2058353004;
    }
  }
  IFC4_32.IfcFlowController = IfcFlowController;
  class IfcFlowFitting extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 4278956645;
    }
  }
  IFC4_32.IfcFlowFitting = IfcFlowFitting;
  class IfcFlowInstrumentType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4037862832;
    }
  }
  IFC4_32.IfcFlowInstrumentType = IfcFlowInstrumentType;
  class IfcFlowMeter extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2188021234;
    }
  }
  IFC4_32.IfcFlowMeter = IfcFlowMeter;
  class IfcFlowMovingDevice extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3132237377;
    }
  }
  IFC4_32.IfcFlowMovingDevice = IfcFlowMovingDevice;
  class IfcFlowSegment extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 987401354;
    }
  }
  IFC4_32.IfcFlowSegment = IfcFlowSegment;
  class IfcFlowStorageDevice extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 707683696;
    }
  }
  IFC4_32.IfcFlowStorageDevice = IfcFlowStorageDevice;
  class IfcFlowTerminal extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2223149337;
    }
  }
  IFC4_32.IfcFlowTerminal = IfcFlowTerminal;
  class IfcFlowTreatmentDevice extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3508470533;
    }
  }
  IFC4_32.IfcFlowTreatmentDevice = IfcFlowTreatmentDevice;
  class IfcFooting extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 900683007;
    }
  }
  IFC4_32.IfcFooting = IfcFooting;
  class IfcGeotechnicalAssembly extends IfcGeotechnicalElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2713699986;
    }
  }
  IFC4_32.IfcGeotechnicalAssembly = IfcGeotechnicalAssembly;
  class IfcGrid extends IfcPositioningElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, UAxes, VAxes, WAxes, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.UAxes = UAxes;
      this.VAxes = VAxes;
      this.WAxes = WAxes;
      this.PredefinedType = PredefinedType;
      this.type = 3009204131;
    }
  }
  IFC4_32.IfcGrid = IfcGrid;
  class IfcHeatExchanger extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3319311131;
    }
  }
  IFC4_32.IfcHeatExchanger = IfcHeatExchanger;
  class IfcHumidifier extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2068733104;
    }
  }
  IFC4_32.IfcHumidifier = IfcHumidifier;
  class IfcInterceptor extends IfcFlowTreatmentDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4175244083;
    }
  }
  IFC4_32.IfcInterceptor = IfcInterceptor;
  class IfcJunctionBox extends IfcFlowFitting {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2176052936;
    }
  }
  IFC4_32.IfcJunctionBox = IfcJunctionBox;
  class IfcKerb extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, Mountable) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.Mountable = Mountable;
      this.type = 2696325953;
    }
  }
  IFC4_32.IfcKerb = IfcKerb;
  class IfcLamp extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 76236018;
    }
  }
  IFC4_32.IfcLamp = IfcLamp;
  class IfcLightFixture extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 629592764;
    }
  }
  IFC4_32.IfcLightFixture = IfcLightFixture;
  class IfcLinearPositioningElement extends IfcPositioningElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 1154579445;
    }
  }
  IFC4_32.IfcLinearPositioningElement = IfcLinearPositioningElement;
  class IfcLiquidTerminal extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1638804497;
    }
  }
  IFC4_32.IfcLiquidTerminal = IfcLiquidTerminal;
  class IfcMedicalDevice extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1437502449;
    }
  }
  IFC4_32.IfcMedicalDevice = IfcMedicalDevice;
  class IfcMember extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1073191201;
    }
  }
  IFC4_32.IfcMember = IfcMember;
  class IfcMobileTelecommunicationsAppliance extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2078563270;
    }
  }
  IFC4_32.IfcMobileTelecommunicationsAppliance = IfcMobileTelecommunicationsAppliance;
  class IfcMooringDevice extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 234836483;
    }
  }
  IFC4_32.IfcMooringDevice = IfcMooringDevice;
  class IfcMotorConnection extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2474470126;
    }
  }
  IFC4_32.IfcMotorConnection = IfcMotorConnection;
  class IfcNavigationElement extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2182337498;
    }
  }
  IFC4_32.IfcNavigationElement = IfcNavigationElement;
  class IfcOuterBoundaryCurve extends IfcBoundaryCurve {
    constructor(expressID, Segments, SelfIntersect) {
      super(expressID, Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 144952367;
    }
  }
  IFC4_32.IfcOuterBoundaryCurve = IfcOuterBoundaryCurve;
  class IfcOutlet extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3694346114;
    }
  }
  IFC4_32.IfcOutlet = IfcOutlet;
  class IfcPavement extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1383356374;
    }
  }
  IFC4_32.IfcPavement = IfcPavement;
  class IfcPile extends IfcDeepFoundation {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType, ConstructionType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.ConstructionType = ConstructionType;
      this.type = 1687234759;
    }
  }
  IFC4_32.IfcPile = IfcPile;
  class IfcPipeFitting extends IfcFlowFitting {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 310824031;
    }
  }
  IFC4_32.IfcPipeFitting = IfcPipeFitting;
  class IfcPipeSegment extends IfcFlowSegment {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3612865200;
    }
  }
  IFC4_32.IfcPipeSegment = IfcPipeSegment;
  class IfcPlate extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3171933400;
    }
  }
  IFC4_32.IfcPlate = IfcPlate;
  class IfcProtectiveDevice extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 738039164;
    }
  }
  IFC4_32.IfcProtectiveDevice = IfcProtectiveDevice;
  class IfcProtectiveDeviceTrippingUnitType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 655969474;
    }
  }
  IFC4_32.IfcProtectiveDeviceTrippingUnitType = IfcProtectiveDeviceTrippingUnitType;
  class IfcPump extends IfcFlowMovingDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 90941305;
    }
  }
  IFC4_32.IfcPump = IfcPump;
  class IfcRail extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3290496277;
    }
  }
  IFC4_32.IfcRail = IfcRail;
  class IfcRailing extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2262370178;
    }
  }
  IFC4_32.IfcRailing = IfcRailing;
  class IfcRamp extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3024970846;
    }
  }
  IFC4_32.IfcRamp = IfcRamp;
  class IfcRampFlight extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3283111854;
    }
  }
  IFC4_32.IfcRampFlight = IfcRampFlight;
  class IfcRationalBSplineCurveWithKnots extends IfcBSplineCurveWithKnots {
    constructor(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec, WeightsData) {
      super(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec);
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.KnotMultiplicities = KnotMultiplicities;
      this.Knots = Knots;
      this.KnotSpec = KnotSpec;
      this.WeightsData = WeightsData;
      this.type = 1232101972;
    }
  }
  IFC4_32.IfcRationalBSplineCurveWithKnots = IfcRationalBSplineCurveWithKnots;
  class IfcReinforcedSoil extends IfcEarthworksElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3798194928;
    }
  }
  IFC4_32.IfcReinforcedSoil = IfcReinforcedSoil;
  class IfcReinforcingBar extends IfcReinforcingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, NominalDiameter, CrossSectionArea, BarLength, PredefinedType, BarSurface) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.BarLength = BarLength;
      this.PredefinedType = PredefinedType;
      this.BarSurface = BarSurface;
      this.type = 979691226;
    }
  }
  IFC4_32.IfcReinforcingBar = IfcReinforcingBar;
  class IfcReinforcingBarType extends IfcReinforcingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, CrossSectionArea, BarLength, BarSurface, BendingShapeCode, BendingParameters) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.BarLength = BarLength;
      this.BarSurface = BarSurface;
      this.BendingShapeCode = BendingShapeCode;
      this.BendingParameters = BendingParameters;
      this.type = 2572171363;
    }
  }
  IFC4_32.IfcReinforcingBarType = IfcReinforcingBarType;
  class IfcRoof extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2016517767;
    }
  }
  IFC4_32.IfcRoof = IfcRoof;
  class IfcSanitaryTerminal extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3053780830;
    }
  }
  IFC4_32.IfcSanitaryTerminal = IfcSanitaryTerminal;
  class IfcSensorType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1783015770;
    }
  }
  IFC4_32.IfcSensorType = IfcSensorType;
  class IfcShadingDevice extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1329646415;
    }
  }
  IFC4_32.IfcShadingDevice = IfcShadingDevice;
  class IfcSignal extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 991950508;
    }
  }
  IFC4_32.IfcSignal = IfcSignal;
  class IfcSlab extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1529196076;
    }
  }
  IFC4_32.IfcSlab = IfcSlab;
  class IfcSolarDevice extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3420628829;
    }
  }
  IFC4_32.IfcSolarDevice = IfcSolarDevice;
  class IfcSpaceHeater extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1999602285;
    }
  }
  IFC4_32.IfcSpaceHeater = IfcSpaceHeater;
  class IfcStackTerminal extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1404847402;
    }
  }
  IFC4_32.IfcStackTerminal = IfcStackTerminal;
  class IfcStair extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 331165859;
    }
  }
  IFC4_32.IfcStair = IfcStair;
  class IfcStairFlight extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NumberOfRisers, NumberOfTreads, RiserHeight, TreadLength, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.NumberOfRisers = NumberOfRisers;
      this.NumberOfTreads = NumberOfTreads;
      this.RiserHeight = RiserHeight;
      this.TreadLength = TreadLength;
      this.PredefinedType = PredefinedType;
      this.type = 4252922144;
    }
  }
  IFC4_32.IfcStairFlight = IfcStairFlight;
  class IfcStructuralAnalysisModel extends IfcSystem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, OrientationOf2DPlane, LoadedBy, HasResults, SharedPlacement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.OrientationOf2DPlane = OrientationOf2DPlane;
      this.LoadedBy = LoadedBy;
      this.HasResults = HasResults;
      this.SharedPlacement = SharedPlacement;
      this.type = 2515109513;
    }
  }
  IFC4_32.IfcStructuralAnalysisModel = IfcStructuralAnalysisModel;
  class IfcStructuralLoadCase extends IfcStructuralLoadGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose, SelfWeightCoefficients) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.ActionType = ActionType;
      this.ActionSource = ActionSource;
      this.Coefficient = Coefficient;
      this.Purpose = Purpose;
      this.SelfWeightCoefficients = SelfWeightCoefficients;
      this.type = 385403989;
    }
  }
  IFC4_32.IfcStructuralLoadCase = IfcStructuralLoadCase;
  class IfcStructuralPlanarAction extends IfcStructuralSurfaceAction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.PredefinedType = PredefinedType;
      this.type = 1621171031;
    }
  }
  IFC4_32.IfcStructuralPlanarAction = IfcStructuralPlanarAction;
  class IfcSwitchingDevice extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1162798199;
    }
  }
  IFC4_32.IfcSwitchingDevice = IfcSwitchingDevice;
  class IfcTank extends IfcFlowStorageDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 812556717;
    }
  }
  IFC4_32.IfcTank = IfcTank;
  class IfcTrackElement extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3425753595;
    }
  }
  IFC4_32.IfcTrackElement = IfcTrackElement;
  class IfcTransformer extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3825984169;
    }
  }
  IFC4_32.IfcTransformer = IfcTransformer;
  class IfcTransportElement extends IfcTransportationDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1620046519;
    }
  }
  IFC4_32.IfcTransportElement = IfcTransportElement;
  class IfcTubeBundle extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3026737570;
    }
  }
  IFC4_32.IfcTubeBundle = IfcTubeBundle;
  class IfcUnitaryControlElementType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3179687236;
    }
  }
  IFC4_32.IfcUnitaryControlElementType = IfcUnitaryControlElementType;
  class IfcUnitaryEquipment extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4292641817;
    }
  }
  IFC4_32.IfcUnitaryEquipment = IfcUnitaryEquipment;
  class IfcValve extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4207607924;
    }
  }
  IFC4_32.IfcValve = IfcValve;
  class IfcWall extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2391406946;
    }
  }
  IFC4_32.IfcWall = IfcWall;
  class IfcWallStandardCase extends IfcWall {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3512223829;
    }
  }
  IFC4_32.IfcWallStandardCase = IfcWallStandardCase;
  class IfcWasteTerminal extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4237592921;
    }
  }
  IFC4_32.IfcWasteTerminal = IfcWasteTerminal;
  class IfcWindow extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, PartitioningType, UserDefinedPartitioningType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OverallHeight = OverallHeight;
      this.OverallWidth = OverallWidth;
      this.PredefinedType = PredefinedType;
      this.PartitioningType = PartitioningType;
      this.UserDefinedPartitioningType = UserDefinedPartitioningType;
      this.type = 3304561284;
    }
  }
  IFC4_32.IfcWindow = IfcWindow;
  class IfcActuatorType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2874132201;
    }
  }
  IFC4_32.IfcActuatorType = IfcActuatorType;
  class IfcAirTerminal extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1634111441;
    }
  }
  IFC4_32.IfcAirTerminal = IfcAirTerminal;
  class IfcAirTerminalBox extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 177149247;
    }
  }
  IFC4_32.IfcAirTerminalBox = IfcAirTerminalBox;
  class IfcAirToAirHeatRecovery extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2056796094;
    }
  }
  IFC4_32.IfcAirToAirHeatRecovery = IfcAirToAirHeatRecovery;
  class IfcAlarmType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3001207471;
    }
  }
  IFC4_32.IfcAlarmType = IfcAlarmType;
  class IfcAlignment extends IfcLinearPositioningElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.type = 325726236;
    }
  }
  IFC4_32.IfcAlignment = IfcAlignment;
  class IfcAudioVisualAppliance extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 277319702;
    }
  }
  IFC4_32.IfcAudioVisualAppliance = IfcAudioVisualAppliance;
  class IfcBeam extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 753842376;
    }
  }
  IFC4_32.IfcBeam = IfcBeam;
  class IfcBearing extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4196446775;
    }
  }
  IFC4_32.IfcBearing = IfcBearing;
  class IfcBoiler extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 32344328;
    }
  }
  IFC4_32.IfcBoiler = IfcBoiler;
  class IfcBorehole extends IfcGeotechnicalAssembly {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3314249567;
    }
  }
  IFC4_32.IfcBorehole = IfcBorehole;
  class IfcBuildingElementProxy extends IfcBuiltElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1095909175;
    }
  }
  IFC4_32.IfcBuildingElementProxy = IfcBuildingElementProxy;
  class IfcBurner extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2938176219;
    }
  }
  IFC4_32.IfcBurner = IfcBurner;
  class IfcCableCarrierFitting extends IfcFlowFitting {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 635142910;
    }
  }
  IFC4_32.IfcCableCarrierFitting = IfcCableCarrierFitting;
  class IfcCableCarrierSegment extends IfcFlowSegment {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3758799889;
    }
  }
  IFC4_32.IfcCableCarrierSegment = IfcCableCarrierSegment;
  class IfcCableFitting extends IfcFlowFitting {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1051757585;
    }
  }
  IFC4_32.IfcCableFitting = IfcCableFitting;
  class IfcCableSegment extends IfcFlowSegment {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4217484030;
    }
  }
  IFC4_32.IfcCableSegment = IfcCableSegment;
  class IfcCaissonFoundation extends IfcDeepFoundation {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3999819293;
    }
  }
  IFC4_32.IfcCaissonFoundation = IfcCaissonFoundation;
  class IfcChiller extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3902619387;
    }
  }
  IFC4_32.IfcChiller = IfcChiller;
  class IfcCoil extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 639361253;
    }
  }
  IFC4_32.IfcCoil = IfcCoil;
  class IfcCommunicationsAppliance extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3221913625;
    }
  }
  IFC4_32.IfcCommunicationsAppliance = IfcCommunicationsAppliance;
  class IfcCompressor extends IfcFlowMovingDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3571504051;
    }
  }
  IFC4_32.IfcCompressor = IfcCompressor;
  class IfcCondenser extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2272882330;
    }
  }
  IFC4_32.IfcCondenser = IfcCondenser;
  class IfcControllerType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 578613899;
    }
  }
  IFC4_32.IfcControllerType = IfcControllerType;
  class IfcConveyorSegment extends IfcFlowSegment {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3460952963;
    }
  }
  IFC4_32.IfcConveyorSegment = IfcConveyorSegment;
  class IfcCooledBeam extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4136498852;
    }
  }
  IFC4_32.IfcCooledBeam = IfcCooledBeam;
  class IfcCoolingTower extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3640358203;
    }
  }
  IFC4_32.IfcCoolingTower = IfcCoolingTower;
  class IfcDamper extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4074379575;
    }
  }
  IFC4_32.IfcDamper = IfcDamper;
  class IfcDistributionBoard extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3693000487;
    }
  }
  IFC4_32.IfcDistributionBoard = IfcDistributionBoard;
  class IfcDistributionChamberElement extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1052013943;
    }
  }
  IFC4_32.IfcDistributionChamberElement = IfcDistributionChamberElement;
  class IfcDistributionCircuit extends IfcDistributionSystem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.PredefinedType = PredefinedType;
      this.type = 562808652;
    }
  }
  IFC4_32.IfcDistributionCircuit = IfcDistributionCircuit;
  class IfcDistributionControlElement extends IfcDistributionElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1062813311;
    }
  }
  IFC4_32.IfcDistributionControlElement = IfcDistributionControlElement;
  class IfcDuctFitting extends IfcFlowFitting {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 342316401;
    }
  }
  IFC4_32.IfcDuctFitting = IfcDuctFitting;
  class IfcDuctSegment extends IfcFlowSegment {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3518393246;
    }
  }
  IFC4_32.IfcDuctSegment = IfcDuctSegment;
  class IfcDuctSilencer extends IfcFlowTreatmentDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1360408905;
    }
  }
  IFC4_32.IfcDuctSilencer = IfcDuctSilencer;
  class IfcElectricAppliance extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1904799276;
    }
  }
  IFC4_32.IfcElectricAppliance = IfcElectricAppliance;
  class IfcElectricDistributionBoard extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 862014818;
    }
  }
  IFC4_32.IfcElectricDistributionBoard = IfcElectricDistributionBoard;
  class IfcElectricFlowStorageDevice extends IfcFlowStorageDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3310460725;
    }
  }
  IFC4_32.IfcElectricFlowStorageDevice = IfcElectricFlowStorageDevice;
  class IfcElectricFlowTreatmentDevice extends IfcFlowTreatmentDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 24726584;
    }
  }
  IFC4_32.IfcElectricFlowTreatmentDevice = IfcElectricFlowTreatmentDevice;
  class IfcElectricGenerator extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 264262732;
    }
  }
  IFC4_32.IfcElectricGenerator = IfcElectricGenerator;
  class IfcElectricMotor extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 402227799;
    }
  }
  IFC4_32.IfcElectricMotor = IfcElectricMotor;
  class IfcElectricTimeControl extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1003880860;
    }
  }
  IFC4_32.IfcElectricTimeControl = IfcElectricTimeControl;
  class IfcFan extends IfcFlowMovingDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3415622556;
    }
  }
  IFC4_32.IfcFan = IfcFan;
  class IfcFilter extends IfcFlowTreatmentDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 819412036;
    }
  }
  IFC4_32.IfcFilter = IfcFilter;
  class IfcFireSuppressionTerminal extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1426591983;
    }
  }
  IFC4_32.IfcFireSuppressionTerminal = IfcFireSuppressionTerminal;
  class IfcFlowInstrument extends IfcDistributionControlElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 182646315;
    }
  }
  IFC4_32.IfcFlowInstrument = IfcFlowInstrument;
  class IfcGeomodel extends IfcGeotechnicalAssembly {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2680139844;
    }
  }
  IFC4_32.IfcGeomodel = IfcGeomodel;
  class IfcGeoslice extends IfcGeotechnicalAssembly {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1971632696;
    }
  }
  IFC4_32.IfcGeoslice = IfcGeoslice;
  class IfcProtectiveDeviceTrippingUnit extends IfcDistributionControlElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2295281155;
    }
  }
  IFC4_32.IfcProtectiveDeviceTrippingUnit = IfcProtectiveDeviceTrippingUnit;
  class IfcSensor extends IfcDistributionControlElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4086658281;
    }
  }
  IFC4_32.IfcSensor = IfcSensor;
  class IfcUnitaryControlElement extends IfcDistributionControlElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 630975310;
    }
  }
  IFC4_32.IfcUnitaryControlElement = IfcUnitaryControlElement;
  class IfcActuator extends IfcDistributionControlElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4288193352;
    }
  }
  IFC4_32.IfcActuator = IfcActuator;
  class IfcAlarm extends IfcDistributionControlElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3087945054;
    }
  }
  IFC4_32.IfcAlarm = IfcAlarm;
  class IfcController extends IfcDistributionControlElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 25142252;
    }
  }
  IFC4_32.IfcController = IfcController;
})(IFC4_3 || (IFC4_3 = {}));
SchemaNames[3] = "IFC4";
FromRawLineData[3] = {
  3630933823: (id, v) => new IFC4.IfcActorRole(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcText(v[2].value)),
  618182010: (id, v) => new IFC4.IfcAddress(id, v[0], !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value)),
  639542469: (id, v) => new IFC4.IfcApplication(id, new Handle(v[0].value), new IFC4.IfcLabel(v[1].value), new IFC4.IfcLabel(v[2].value), new IFC4.IfcIdentifier(v[3].value)),
  411424972: (id, v) => new IFC4.IfcAppliedValue(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4.IfcDate(v[4].value), !v[5] ? null : new IFC4.IfcDate(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8], !v[9] ? null : v[9].map((p) => new Handle(p.value))),
  130549933: (id, v) => new IFC4.IfcApproval(id, !v[0] ? null : new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcText(v[2].value), !v[3] ? null : new IFC4.IfcDateTime(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value)),
  4037036970: (id, v) => new IFC4.IfcBoundaryCondition(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value)),
  1560379544: (id, v) => new IFC4.IfcBoundaryEdgeCondition(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : TypeInitialiser(3, v[1]), !v[2] ? null : TypeInitialiser(3, v[2]), !v[3] ? null : TypeInitialiser(3, v[3]), !v[4] ? null : TypeInitialiser(3, v[4]), !v[5] ? null : TypeInitialiser(3, v[5]), !v[6] ? null : TypeInitialiser(3, v[6])),
  3367102660: (id, v) => new IFC4.IfcBoundaryFaceCondition(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : TypeInitialiser(3, v[1]), !v[2] ? null : TypeInitialiser(3, v[2]), !v[3] ? null : TypeInitialiser(3, v[3])),
  1387855156: (id, v) => new IFC4.IfcBoundaryNodeCondition(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : TypeInitialiser(3, v[1]), !v[2] ? null : TypeInitialiser(3, v[2]), !v[3] ? null : TypeInitialiser(3, v[3]), !v[4] ? null : TypeInitialiser(3, v[4]), !v[5] ? null : TypeInitialiser(3, v[5]), !v[6] ? null : TypeInitialiser(3, v[6])),
  2069777674: (id, v) => new IFC4.IfcBoundaryNodeConditionWarping(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : TypeInitialiser(3, v[1]), !v[2] ? null : TypeInitialiser(3, v[2]), !v[3] ? null : TypeInitialiser(3, v[3]), !v[4] ? null : TypeInitialiser(3, v[4]), !v[5] ? null : TypeInitialiser(3, v[5]), !v[6] ? null : TypeInitialiser(3, v[6]), !v[7] ? null : TypeInitialiser(3, v[7])),
  2859738748: (id, _) => new IFC4.IfcConnectionGeometry(id),
  2614616156: (id, v) => new IFC4.IfcConnectionPointGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  2732653382: (id, v) => new IFC4.IfcConnectionSurfaceGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  775493141: (id, v) => new IFC4.IfcConnectionVolumeGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  1959218052: (id, v) => new IFC4.IfcConstraint(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2], !v[3] ? null : new IFC4.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new IFC4.IfcDateTime(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value)),
  1785450214: (id, v) => new IFC4.IfcCoordinateOperation(id, new Handle(v[0].value), new Handle(v[1].value)),
  1466758467: (id, v) => new IFC4.IfcCoordinateReferenceSystem(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new IFC4.IfcIdentifier(v[2].value), !v[3] ? null : new IFC4.IfcIdentifier(v[3].value)),
  602808272: (id, v) => new IFC4.IfcCostValue(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4.IfcDate(v[4].value), !v[5] ? null : new IFC4.IfcDate(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8], !v[9] ? null : v[9].map((p) => new Handle(p.value))),
  1765591967: (id, v) => new IFC4.IfcDerivedUnit(id, v[0].map((p) => new Handle(p.value)), v[1], !v[2] ? null : new IFC4.IfcLabel(v[2].value)),
  1045800335: (id, v) => new IFC4.IfcDerivedUnitElement(id, new Handle(v[0].value), v[1].value),
  2949456006: (id, v) => new IFC4.IfcDimensionalExponents(id, v[0].value, v[1].value, v[2].value, v[3].value, v[4].value, v[5].value, v[6].value),
  4294318154: (id, _) => new IFC4.IfcExternalInformation(id),
  3200245327: (id, v) => new IFC4.IfcExternalReference(id, !v[0] ? null : new IFC4.IfcURIReference(v[0].value), !v[1] ? null : new IFC4.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value)),
  2242383968: (id, v) => new IFC4.IfcExternallyDefinedHatchStyle(id, !v[0] ? null : new IFC4.IfcURIReference(v[0].value), !v[1] ? null : new IFC4.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value)),
  1040185647: (id, v) => new IFC4.IfcExternallyDefinedSurfaceStyle(id, !v[0] ? null : new IFC4.IfcURIReference(v[0].value), !v[1] ? null : new IFC4.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value)),
  3548104201: (id, v) => new IFC4.IfcExternallyDefinedTextFont(id, !v[0] ? null : new IFC4.IfcURIReference(v[0].value), !v[1] ? null : new IFC4.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value)),
  852622518: (id, v) => new IFC4.IfcGridAxis(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new Handle(v[1].value), new IFC4.IfcBoolean(v[2].value)),
  3020489413: (id, v) => new IFC4.IfcIrregularTimeSeriesValue(id, new IFC4.IfcDateTime(v[0].value), v[1].map((p) => TypeInitialiser(3, p))),
  2655187982: (id, v) => new IFC4.IfcLibraryInformation(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new IFC4.IfcDateTime(v[3].value), !v[4] ? null : new IFC4.IfcURIReference(v[4].value), !v[5] ? null : new IFC4.IfcText(v[5].value)),
  3452421091: (id, v) => new IFC4.IfcLibraryReference(id, !v[0] ? null : new IFC4.IfcURIReference(v[0].value), !v[1] ? null : new IFC4.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLanguageId(v[4].value), !v[5] ? null : new Handle(v[5].value)),
  4162380809: (id, v) => new IFC4.IfcLightDistributionData(id, new IFC4.IfcPlaneAngleMeasure(v[0].value), v[1].map((p) => new IFC4.IfcPlaneAngleMeasure(p.value)), v[2].map((p) => new IFC4.IfcLuminousIntensityDistributionMeasure(p.value))),
  1566485204: (id, v) => new IFC4.IfcLightIntensityDistribution(id, v[0], v[1].map((p) => new Handle(p.value))),
  3057273783: (id, v) => new IFC4.IfcMapConversion(id, new Handle(v[0].value), new Handle(v[1].value), new IFC4.IfcLengthMeasure(v[2].value), new IFC4.IfcLengthMeasure(v[3].value), new IFC4.IfcLengthMeasure(v[4].value), !v[5] ? null : new IFC4.IfcReal(v[5].value), !v[6] ? null : new IFC4.IfcReal(v[6].value), !v[7] ? null : new IFC4.IfcReal(v[7].value)),
  1847130766: (id, v) => new IFC4.IfcMaterialClassificationRelationship(id, v[0].map((p) => new Handle(p.value)), new Handle(v[1].value)),
  760658860: (id, _) => new IFC4.IfcMaterialDefinition(id),
  248100487: (id, v) => new IFC4.IfcMaterialLayer(id, !v[0] ? null : new Handle(v[0].value), new IFC4.IfcNonNegativeLengthMeasure(v[1].value), !v[2] ? null : new IFC4.IfcLogical(v[2].value), !v[3] ? null : new IFC4.IfcLabel(v[3].value), !v[4] ? null : new IFC4.IfcText(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : new IFC4.IfcInteger(v[6].value)),
  3303938423: (id, v) => new IFC4.IfcMaterialLayerSet(id, v[0].map((p) => new Handle(p.value)), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcText(v[2].value)),
  1847252529: (id, v) => new IFC4.IfcMaterialLayerWithOffsets(id, !v[0] ? null : new Handle(v[0].value), new IFC4.IfcNonNegativeLengthMeasure(v[1].value), !v[2] ? null : new IFC4.IfcLogical(v[2].value), !v[3] ? null : new IFC4.IfcLabel(v[3].value), !v[4] ? null : new IFC4.IfcText(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : new IFC4.IfcInteger(v[6].value), v[7], new IFC4.IfcLengthMeasure(v[8].value)),
  2199411900: (id, v) => new IFC4.IfcMaterialList(id, v[0].map((p) => new Handle(p.value))),
  2235152071: (id, v) => new IFC4.IfcMaterialProfile(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4.IfcInteger(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value)),
  164193824: (id, v) => new IFC4.IfcMaterialProfileSet(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), !v[3] ? null : new Handle(v[3].value)),
  552965576: (id, v) => new IFC4.IfcMaterialProfileWithOffsets(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4.IfcInteger(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), new IFC4.IfcLengthMeasure(v[6].value)),
  1507914824: (id, _) => new IFC4.IfcMaterialUsageDefinition(id),
  2597039031: (id, v) => new IFC4.IfcMeasureWithUnit(id, TypeInitialiser(3, v[0]), new Handle(v[1].value)),
  3368373690: (id, v) => new IFC4.IfcMetric(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2], !v[3] ? null : new IFC4.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new IFC4.IfcDateTime(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), v[7], !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value)),
  2706619895: (id, v) => new IFC4.IfcMonetaryUnit(id, new IFC4.IfcLabel(v[0].value)),
  1918398963: (id, v) => new IFC4.IfcNamedUnit(id, new Handle(v[0].value), v[1]),
  3701648758: (id, _) => new IFC4.IfcObjectPlacement(id),
  2251480897: (id, v) => new IFC4.IfcObjective(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2], !v[3] ? null : new IFC4.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new IFC4.IfcDateTime(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), v[8], v[9], !v[10] ? null : new IFC4.IfcLabel(v[10].value)),
  4251960020: (id, v) => new IFC4.IfcOrganization(id, !v[0] ? null : new IFC4.IfcIdentifier(v[0].value), new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcText(v[2].value), !v[3] ? null : v[3].map((p) => new Handle(p.value)), !v[4] ? null : v[4].map((p) => new Handle(p.value))),
  1207048766: (id, v) => new IFC4.IfcOwnerHistory(id, new Handle(v[0].value), new Handle(v[1].value), v[2], v[3], !v[4] ? null : new IFC4.IfcTimeStamp(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new IFC4.IfcTimeStamp(v[7].value)),
  2077209135: (id, v) => new IFC4.IfcPerson(id, !v[0] ? null : new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : v[3].map((p) => new IFC4.IfcLabel(p.value)), !v[4] ? null : v[4].map((p) => new IFC4.IfcLabel(p.value)), !v[5] ? null : v[5].map((p) => new IFC4.IfcLabel(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : v[7].map((p) => new Handle(p.value))),
  101040310: (id, v) => new IFC4.IfcPersonAndOrganization(id, new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : v[2].map((p) => new Handle(p.value))),
  2483315170: (id, v) => new IFC4.IfcPhysicalQuantity(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value)),
  2226359599: (id, v) => new IFC4.IfcPhysicalSimpleQuantity(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value)),
  3355820592: (id, v) => new IFC4.IfcPostalAddress(id, v[0], !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcLabel(v[3].value), !v[4] ? null : v[4].map((p) => new IFC4.IfcLabel(p.value)), !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : new IFC4.IfcLabel(v[9].value)),
  677532197: (id, _) => new IFC4.IfcPresentationItem(id),
  2022622350: (id, v) => new IFC4.IfcPresentationLayerAssignment(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), !v[3] ? null : new IFC4.IfcIdentifier(v[3].value)),
  1304840413: (id, v) => new IFC4.IfcPresentationLayerWithStyle(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), !v[3] ? null : new IFC4.IfcIdentifier(v[3].value), new IFC4.IfcLogical(v[4].value), new IFC4.IfcLogical(v[5].value), new IFC4.IfcLogical(v[6].value), v[7].map((p) => new Handle(p.value))),
  3119450353: (id, v) => new IFC4.IfcPresentationStyle(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value)),
  2417041796: (id, v) => new IFC4.IfcPresentationStyleAssignment(id, v[0].map((p) => new Handle(p.value))),
  2095639259: (id, v) => new IFC4.IfcProductRepresentation(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map((p) => new Handle(p.value))),
  3958567839: (id, v) => new IFC4.IfcProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value)),
  3843373140: (id, v) => new IFC4.IfcProjectedCRS(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new IFC4.IfcIdentifier(v[2].value), !v[3] ? null : new IFC4.IfcIdentifier(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  986844984: (id, _) => new IFC4.IfcPropertyAbstraction(id),
  3710013099: (id, v) => new IFC4.IfcPropertyEnumeration(id, new IFC4.IfcLabel(v[0].value), v[1].map((p) => TypeInitialiser(3, p)), !v[2] ? null : new Handle(v[2].value)),
  2044713172: (id, v) => new IFC4.IfcQuantityArea(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcAreaMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value)),
  2093928680: (id, v) => new IFC4.IfcQuantityCount(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcCountMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value)),
  931644368: (id, v) => new IFC4.IfcQuantityLength(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value)),
  3252649465: (id, v) => new IFC4.IfcQuantityTime(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcTimeMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value)),
  2405470396: (id, v) => new IFC4.IfcQuantityVolume(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcVolumeMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value)),
  825690147: (id, v) => new IFC4.IfcQuantityWeight(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcMassMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value)),
  3915482550: (id, v) => new IFC4.IfcRecurrencePattern(id, v[0], !v[1] ? null : v[1].map((p) => new IFC4.IfcDayInMonthNumber(p.value)), !v[2] ? null : v[2].map((p) => new IFC4.IfcDayInWeekNumber(p.value)), !v[3] ? null : v[3].map((p) => new IFC4.IfcMonthInYearNumber(p.value)), !v[4] ? null : new IFC4.IfcInteger(v[4].value), !v[5] ? null : new IFC4.IfcInteger(v[5].value), !v[6] ? null : new IFC4.IfcInteger(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value))),
  2433181523: (id, v) => new IFC4.IfcReference(id, !v[0] ? null : new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : v[3].map((p) => new IFC4.IfcInteger(p.value)), !v[4] ? null : new Handle(v[4].value)),
  1076942058: (id, v) => new IFC4.IfcRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  3377609919: (id, v) => new IFC4.IfcRepresentationContext(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value)),
  3008791417: (id, _) => new IFC4.IfcRepresentationItem(id),
  1660063152: (id, v) => new IFC4.IfcRepresentationMap(id, new Handle(v[0].value), new Handle(v[1].value)),
  2439245199: (id, v) => new IFC4.IfcResourceLevelRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value)),
  2341007311: (id, v) => new IFC4.IfcRoot(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value)),
  448429030: (id, v) => new IFC4.IfcSIUnit(id, v[0], v[1], v[2]),
  1054537805: (id, v) => new IFC4.IfcSchedulingTime(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4.IfcLabel(v[2].value)),
  867548509: (id, v) => new IFC4.IfcShapeAspect(id, v[0].map((p) => new Handle(p.value)), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcText(v[2].value), new IFC4.IfcLogical(v[3].value), !v[4] ? null : new Handle(v[4].value)),
  3982875396: (id, v) => new IFC4.IfcShapeModel(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  4240577450: (id, v) => new IFC4.IfcShapeRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  2273995522: (id, v) => new IFC4.IfcStructuralConnectionCondition(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value)),
  2162789131: (id, v) => new IFC4.IfcStructuralLoad(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value)),
  3478079324: (id, v) => new IFC4.IfcStructuralLoadConfiguration(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : v[2].map((p) => new IFC4.IfcLengthMeasure(p.value))),
  609421318: (id, v) => new IFC4.IfcStructuralLoadOrResult(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value)),
  2525727697: (id, v) => new IFC4.IfcStructuralLoadStatic(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value)),
  3408363356: (id, v) => new IFC4.IfcStructuralLoadTemperature(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcThermodynamicTemperatureMeasure(v[1].value), !v[2] ? null : new IFC4.IfcThermodynamicTemperatureMeasure(v[2].value), !v[3] ? null : new IFC4.IfcThermodynamicTemperatureMeasure(v[3].value)),
  2830218821: (id, v) => new IFC4.IfcStyleModel(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  3958052878: (id, v) => new IFC4.IfcStyledItem(id, !v[0] ? null : new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC4.IfcLabel(v[2].value)),
  3049322572: (id, v) => new IFC4.IfcStyledRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  2934153892: (id, v) => new IFC4.IfcSurfaceReinforcementArea(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : v[1].map((p) => new IFC4.IfcLengthMeasure(p.value)), !v[2] ? null : v[2].map((p) => new IFC4.IfcLengthMeasure(p.value)), !v[3] ? null : new IFC4.IfcRatioMeasure(v[3].value)),
  1300840506: (id, v) => new IFC4.IfcSurfaceStyle(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1], v[2].map((p) => new Handle(p.value))),
  3303107099: (id, v) => new IFC4.IfcSurfaceStyleLighting(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new Handle(v[3].value)),
  1607154358: (id, v) => new IFC4.IfcSurfaceStyleRefraction(id, !v[0] ? null : new IFC4.IfcReal(v[0].value), !v[1] ? null : new IFC4.IfcReal(v[1].value)),
  846575682: (id, v) => new IFC4.IfcSurfaceStyleShading(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcNormalisedRatioMeasure(v[1].value)),
  1351298697: (id, v) => new IFC4.IfcSurfaceStyleWithTextures(id, v[0].map((p) => new Handle(p.value))),
  626085974: (id, v) => new IFC4.IfcSurfaceTexture(id, new IFC4.IfcBoolean(v[0].value), new IFC4.IfcBoolean(v[1].value), !v[2] ? null : new IFC4.IfcIdentifier(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map((p) => new IFC4.IfcIdentifier(p.value))),
  985171141: (id, v) => new IFC4.IfcTable(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : v[1].map((p) => new Handle(p.value)), !v[2] ? null : v[2].map((p) => new Handle(p.value))),
  2043862942: (id, v) => new IFC4.IfcTableColumn(id, !v[0] ? null : new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcText(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value)),
  531007025: (id, v) => new IFC4.IfcTableRow(id, !v[0] ? null : v[0].map((p) => TypeInitialiser(3, p)), !v[1] ? null : new IFC4.IfcBoolean(v[1].value)),
  1549132990: (id, v) => new IFC4.IfcTaskTime(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4.IfcLabel(v[2].value), v[3], !v[4] ? null : new IFC4.IfcDuration(v[4].value), !v[5] ? null : new IFC4.IfcDateTime(v[5].value), !v[6] ? null : new IFC4.IfcDateTime(v[6].value), !v[7] ? null : new IFC4.IfcDateTime(v[7].value), !v[8] ? null : new IFC4.IfcDateTime(v[8].value), !v[9] ? null : new IFC4.IfcDateTime(v[9].value), !v[10] ? null : new IFC4.IfcDateTime(v[10].value), !v[11] ? null : new IFC4.IfcDuration(v[11].value), !v[12] ? null : new IFC4.IfcDuration(v[12].value), !v[13] ? null : new IFC4.IfcBoolean(v[13].value), !v[14] ? null : new IFC4.IfcDateTime(v[14].value), !v[15] ? null : new IFC4.IfcDuration(v[15].value), !v[16] ? null : new IFC4.IfcDateTime(v[16].value), !v[17] ? null : new IFC4.IfcDateTime(v[17].value), !v[18] ? null : new IFC4.IfcDuration(v[18].value), !v[19] ? null : new IFC4.IfcPositiveRatioMeasure(v[19].value)),
  2771591690: (id, v) => new IFC4.IfcTaskTimeRecurring(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4.IfcLabel(v[2].value), v[3], !v[4] ? null : new IFC4.IfcDuration(v[4].value), !v[5] ? null : new IFC4.IfcDateTime(v[5].value), !v[6] ? null : new IFC4.IfcDateTime(v[6].value), !v[7] ? null : new IFC4.IfcDateTime(v[7].value), !v[8] ? null : new IFC4.IfcDateTime(v[8].value), !v[9] ? null : new IFC4.IfcDateTime(v[9].value), !v[10] ? null : new IFC4.IfcDateTime(v[10].value), !v[11] ? null : new IFC4.IfcDuration(v[11].value), !v[12] ? null : new IFC4.IfcDuration(v[12].value), !v[13] ? null : new IFC4.IfcBoolean(v[13].value), !v[14] ? null : new IFC4.IfcDateTime(v[14].value), !v[15] ? null : new IFC4.IfcDuration(v[15].value), !v[16] ? null : new IFC4.IfcDateTime(v[16].value), !v[17] ? null : new IFC4.IfcDateTime(v[17].value), !v[18] ? null : new IFC4.IfcDuration(v[18].value), !v[19] ? null : new IFC4.IfcPositiveRatioMeasure(v[19].value), new Handle(v[20].value)),
  912023232: (id, v) => new IFC4.IfcTelecomAddress(id, v[0], !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : v[3].map((p) => new IFC4.IfcLabel(p.value)), !v[4] ? null : v[4].map((p) => new IFC4.IfcLabel(p.value)), !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : v[6].map((p) => new IFC4.IfcLabel(p.value)), !v[7] ? null : new IFC4.IfcURIReference(v[7].value), !v[8] ? null : v[8].map((p) => new IFC4.IfcURIReference(p.value))),
  1447204868: (id, v) => new IFC4.IfcTextStyle(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4.IfcBoolean(v[4].value)),
  2636378356: (id, v) => new IFC4.IfcTextStyleForDefinedFont(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  1640371178: (id, v) => new IFC4.IfcTextStyleTextModel(id, !v[0] ? null : TypeInitialiser(3, v[0]), !v[1] ? null : new IFC4.IfcTextAlignment(v[1].value), !v[2] ? null : new IFC4.IfcTextDecoration(v[2].value), !v[3] ? null : TypeInitialiser(3, v[3]), !v[4] ? null : TypeInitialiser(3, v[4]), !v[5] ? null : new IFC4.IfcTextTransformation(v[5].value), !v[6] ? null : TypeInitialiser(3, v[6])),
  280115917: (id, v) => new IFC4.IfcTextureCoordinate(id, v[0].map((p) => new Handle(p.value))),
  1742049831: (id, v) => new IFC4.IfcTextureCoordinateGenerator(id, v[0].map((p) => new Handle(p.value)), new IFC4.IfcLabel(v[1].value), !v[2] ? null : v[2].map((p) => new IFC4.IfcReal(p.value))),
  2552916305: (id, v) => new IFC4.IfcTextureMap(id, v[0].map((p) => new Handle(p.value)), v[1].map((p) => new Handle(p.value)), new Handle(v[2].value)),
  1210645708: (id, v) => new IFC4.IfcTextureVertex(id, v[0].map((p) => new IFC4.IfcParameterValue(p.value))),
  3611470254: (id, v) => new IFC4.IfcTextureVertexList(id, v[0].map((p) => new IFC4.IfcParameterValue(p.value))),
  1199560280: (id, v) => new IFC4.IfcTimePeriod(id, new IFC4.IfcTime(v[0].value), new IFC4.IfcTime(v[1].value)),
  3101149627: (id, v) => new IFC4.IfcTimeSeries(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new IFC4.IfcDateTime(v[2].value), new IFC4.IfcDateTime(v[3].value), v[4], v[5], !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  581633288: (id, v) => new IFC4.IfcTimeSeriesValue(id, v[0].map((p) => TypeInitialiser(3, p))),
  1377556343: (id, _) => new IFC4.IfcTopologicalRepresentationItem(id),
  1735638870: (id, v) => new IFC4.IfcTopologyRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), v[3].map((p) => new Handle(p.value))),
  180925521: (id, v) => new IFC4.IfcUnitAssignment(id, v[0].map((p) => new Handle(p.value))),
  2799835756: (id, _) => new IFC4.IfcVertex(id),
  1907098498: (id, v) => new IFC4.IfcVertexPoint(id, new Handle(v[0].value)),
  891718957: (id, v) => new IFC4.IfcVirtualGridIntersection(id, v[0].map((p) => new Handle(p.value)), v[1].map((p) => new IFC4.IfcLengthMeasure(p.value))),
  1236880293: (id, v) => new IFC4.IfcWorkTime(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4.IfcDate(v[4].value), !v[5] ? null : new IFC4.IfcDate(v[5].value)),
  3869604511: (id, v) => new IFC4.IfcApprovalRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value))),
  3798115385: (id, v) => new IFC4.IfcArbitraryClosedProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), new Handle(v[2].value)),
  1310608509: (id, v) => new IFC4.IfcArbitraryOpenProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), new Handle(v[2].value)),
  2705031697: (id, v) => new IFC4.IfcArbitraryProfileDefWithVoids(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value))),
  616511568: (id, v) => new IFC4.IfcBlobTexture(id, new IFC4.IfcBoolean(v[0].value), new IFC4.IfcBoolean(v[1].value), !v[2] ? null : new IFC4.IfcIdentifier(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map((p) => new IFC4.IfcIdentifier(p.value)), new IFC4.IfcIdentifier(v[5].value), new IFC4.IfcBinary(v[6].value)),
  3150382593: (id, v) => new IFC4.IfcCenterLineProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value)),
  747523909: (id, v) => new IFC4.IfcClassification(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcDate(v[2].value), new IFC4.IfcLabel(v[3].value), !v[4] ? null : new IFC4.IfcText(v[4].value), !v[5] ? null : new IFC4.IfcURIReference(v[5].value), !v[6] ? null : v[6].map((p) => new IFC4.IfcIdentifier(p.value))),
  647927063: (id, v) => new IFC4.IfcClassificationReference(id, !v[0] ? null : new IFC4.IfcURIReference(v[0].value), !v[1] ? null : new IFC4.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4.IfcText(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value)),
  3285139300: (id, v) => new IFC4.IfcColourRgbList(id, v[0].map((p) => new IFC4.IfcNormalisedRatioMeasure(p.value))),
  3264961684: (id, v) => new IFC4.IfcColourSpecification(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value)),
  1485152156: (id, v) => new IFC4.IfcCompositeProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), v[2].map((p) => new Handle(p.value)), !v[3] ? null : new IFC4.IfcLabel(v[3].value)),
  370225590: (id, v) => new IFC4.IfcConnectedFaceSet(id, v[0].map((p) => new Handle(p.value))),
  1981873012: (id, v) => new IFC4.IfcConnectionCurveGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  45288368: (id, v) => new IFC4.IfcConnectionPointEccentricity(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLengthMeasure(v[4].value)),
  3050246964: (id, v) => new IFC4.IfcContextDependentUnit(id, new Handle(v[0].value), v[1], new IFC4.IfcLabel(v[2].value)),
  2889183280: (id, v) => new IFC4.IfcConversionBasedUnit(id, new Handle(v[0].value), v[1], new IFC4.IfcLabel(v[2].value), new Handle(v[3].value)),
  2713554722: (id, v) => new IFC4.IfcConversionBasedUnitWithOffset(id, new Handle(v[0].value), v[1], new IFC4.IfcLabel(v[2].value), new Handle(v[3].value), new IFC4.IfcReal(v[4].value)),
  539742890: (id, v) => new IFC4.IfcCurrencyRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value), new IFC4.IfcPositiveRatioMeasure(v[4].value), !v[5] ? null : new IFC4.IfcDateTime(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  3800577675: (id, v) => new IFC4.IfcCurveStyle(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : TypeInitialiser(3, v[2]), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4.IfcBoolean(v[4].value)),
  1105321065: (id, v) => new IFC4.IfcCurveStyleFont(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1].map((p) => new Handle(p.value))),
  2367409068: (id, v) => new IFC4.IfcCurveStyleFontAndScaling(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new Handle(v[1].value), new IFC4.IfcPositiveRatioMeasure(v[2].value)),
  3510044353: (id, v) => new IFC4.IfcCurveStyleFontPattern(id, new IFC4.IfcLengthMeasure(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value)),
  3632507154: (id, v) => new IFC4.IfcDerivedProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value)),
  1154170062: (id, v) => new IFC4.IfcDocumentInformation(id, new IFC4.IfcIdentifier(v[0].value), new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcText(v[2].value), !v[3] ? null : new IFC4.IfcURIReference(v[3].value), !v[4] ? null : new IFC4.IfcText(v[4].value), !v[5] ? null : new IFC4.IfcText(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new Handle(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new IFC4.IfcDateTime(v[10].value), !v[11] ? null : new IFC4.IfcDateTime(v[11].value), !v[12] ? null : new IFC4.IfcIdentifier(v[12].value), !v[13] ? null : new IFC4.IfcDate(v[13].value), !v[14] ? null : new IFC4.IfcDate(v[14].value), v[15], v[16]),
  770865208: (id, v) => new IFC4.IfcDocumentInformationRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value)), !v[4] ? null : new IFC4.IfcLabel(v[4].value)),
  3732053477: (id, v) => new IFC4.IfcDocumentReference(id, !v[0] ? null : new IFC4.IfcURIReference(v[0].value), !v[1] ? null : new IFC4.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value)),
  3900360178: (id, v) => new IFC4.IfcEdge(id, new Handle(v[0].value), new Handle(v[1].value)),
  476780140: (id, v) => new IFC4.IfcEdgeCurve(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new IFC4.IfcBoolean(v[3].value)),
  211053100: (id, v) => new IFC4.IfcEventTime(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcDateTime(v[3].value), !v[4] ? null : new IFC4.IfcDateTime(v[4].value), !v[5] ? null : new IFC4.IfcDateTime(v[5].value), !v[6] ? null : new IFC4.IfcDateTime(v[6].value)),
  297599258: (id, v) => new IFC4.IfcExtendedProperties(id, !v[0] ? null : new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map((p) => new Handle(p.value))),
  1437805879: (id, v) => new IFC4.IfcExternalReferenceRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value))),
  2556980723: (id, v) => new IFC4.IfcFace(id, v[0].map((p) => new Handle(p.value))),
  1809719519: (id, v) => new IFC4.IfcFaceBound(id, new Handle(v[0].value), new IFC4.IfcBoolean(v[1].value)),
  803316827: (id, v) => new IFC4.IfcFaceOuterBound(id, new Handle(v[0].value), new IFC4.IfcBoolean(v[1].value)),
  3008276851: (id, v) => new IFC4.IfcFaceSurface(id, v[0].map((p) => new Handle(p.value)), new Handle(v[1].value), new IFC4.IfcBoolean(v[2].value)),
  4219587988: (id, v) => new IFC4.IfcFailureConnectionCondition(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC4.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC4.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC4.IfcForceMeasure(v[4].value), !v[5] ? null : new IFC4.IfcForceMeasure(v[5].value), !v[6] ? null : new IFC4.IfcForceMeasure(v[6].value)),
  738692330: (id, v) => new IFC4.IfcFillAreaStyle(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1].map((p) => new Handle(p.value)), !v[2] ? null : new IFC4.IfcBoolean(v[2].value)),
  3448662350: (id, v) => new IFC4.IfcGeometricRepresentationContext(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), new IFC4.IfcDimensionCount(v[2].value), !v[3] ? null : new IFC4.IfcReal(v[3].value), new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value)),
  2453401579: (id, _) => new IFC4.IfcGeometricRepresentationItem(id),
  4142052618: (id, v) => new IFC4.IfcGeometricRepresentationSubContext(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcPositiveRatioMeasure(v[3].value), v[4], !v[5] ? null : new IFC4.IfcLabel(v[5].value)),
  3590301190: (id, v) => new IFC4.IfcGeometricSet(id, v[0].map((p) => new Handle(p.value))),
  178086475: (id, v) => new IFC4.IfcGridPlacement(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  812098782: (id, v) => new IFC4.IfcHalfSpaceSolid(id, new Handle(v[0].value), new IFC4.IfcBoolean(v[1].value)),
  3905492369: (id, v) => new IFC4.IfcImageTexture(id, new IFC4.IfcBoolean(v[0].value), new IFC4.IfcBoolean(v[1].value), !v[2] ? null : new IFC4.IfcIdentifier(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map((p) => new IFC4.IfcIdentifier(p.value)), new IFC4.IfcURIReference(v[5].value)),
  3570813810: (id, v) => new IFC4.IfcIndexedColourMap(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcNormalisedRatioMeasure(v[1].value), new Handle(v[2].value), v[3].map((p) => new IFC4.IfcPositiveInteger(p.value))),
  1437953363: (id, v) => new IFC4.IfcIndexedTextureMap(id, v[0].map((p) => new Handle(p.value)), new Handle(v[1].value), new Handle(v[2].value)),
  2133299955: (id, v) => new IFC4.IfcIndexedTriangleTextureMap(id, v[0].map((p) => new Handle(p.value)), new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : v[3].map((p) => new IFC4.IfcPositiveInteger(p.value))),
  3741457305: (id, v) => new IFC4.IfcIrregularTimeSeries(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new IFC4.IfcDateTime(v[2].value), new IFC4.IfcDateTime(v[3].value), v[4], v[5], !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), v[8].map((p) => new Handle(p.value))),
  1585845231: (id, v) => new IFC4.IfcLagTime(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4.IfcLabel(v[2].value), TypeInitialiser(3, v[3]), v[4]),
  1402838566: (id, v) => new IFC4.IfcLightSource(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4.IfcNormalisedRatioMeasure(v[3].value)),
  125510826: (id, v) => new IFC4.IfcLightSourceAmbient(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4.IfcNormalisedRatioMeasure(v[3].value)),
  2604431987: (id, v) => new IFC4.IfcLightSourceDirectional(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value)),
  4266656042: (id, v) => new IFC4.IfcLightSourceGoniometric(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), new IFC4.IfcThermodynamicTemperatureMeasure(v[6].value), new IFC4.IfcLuminousFluxMeasure(v[7].value), v[8], new Handle(v[9].value)),
  1520743889: (id, v) => new IFC4.IfcLightSourcePositional(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcReal(v[6].value), new IFC4.IfcReal(v[7].value), new IFC4.IfcReal(v[8].value)),
  3422422726: (id, v) => new IFC4.IfcLightSourceSpot(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcReal(v[6].value), new IFC4.IfcReal(v[7].value), new IFC4.IfcReal(v[8].value), new Handle(v[9].value), !v[10] ? null : new IFC4.IfcReal(v[10].value), new IFC4.IfcPositivePlaneAngleMeasure(v[11].value), new IFC4.IfcPositivePlaneAngleMeasure(v[12].value)),
  2624227202: (id, v) => new IFC4.IfcLocalPlacement(id, !v[0] ? null : new Handle(v[0].value), new Handle(v[1].value)),
  1008929658: (id, _) => new IFC4.IfcLoop(id),
  2347385850: (id, v) => new IFC4.IfcMappedItem(id, new Handle(v[0].value), new Handle(v[1].value)),
  1838606355: (id, v) => new IFC4.IfcMaterial(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value)),
  3708119e3: (id, v) => new IFC4.IfcMaterialConstituent(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcNormalisedRatioMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value)),
  2852063980: (id, v) => new IFC4.IfcMaterialConstituentSet(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : v[2].map((p) => new Handle(p.value))),
  2022407955: (id, v) => new IFC4.IfcMaterialDefinitionRepresentation(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), new Handle(v[3].value)),
  1303795690: (id, v) => new IFC4.IfcMaterialLayerSetUsage(id, new Handle(v[0].value), v[1], v[2], new IFC4.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4.IfcPositiveLengthMeasure(v[4].value)),
  3079605661: (id, v) => new IFC4.IfcMaterialProfileSetUsage(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcCardinalPointReference(v[1].value), !v[2] ? null : new IFC4.IfcPositiveLengthMeasure(v[2].value)),
  3404854881: (id, v) => new IFC4.IfcMaterialProfileSetUsageTapering(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcCardinalPointReference(v[1].value), !v[2] ? null : new IFC4.IfcPositiveLengthMeasure(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4.IfcCardinalPointReference(v[4].value)),
  3265635763: (id, v) => new IFC4.IfcMaterialProperties(id, !v[0] ? null : new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), new Handle(v[3].value)),
  853536259: (id, v) => new IFC4.IfcMaterialRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value)), !v[4] ? null : new IFC4.IfcLabel(v[4].value)),
  2998442950: (id, v) => new IFC4.IfcMirroredProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcLabel(v[3].value)),
  219451334: (id, v) => new IFC4.IfcObjectDefinition(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value)),
  2665983363: (id, v) => new IFC4.IfcOpenShell(id, v[0].map((p) => new Handle(p.value))),
  1411181986: (id, v) => new IFC4.IfcOrganizationRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value))),
  1029017970: (id, v) => new IFC4.IfcOrientedEdge(id, new Handle(v[0].value), new IFC4.IfcBoolean(v[1].value)),
  2529465313: (id, v) => new IFC4.IfcParameterizedProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value)),
  2519244187: (id, v) => new IFC4.IfcPath(id, v[0].map((p) => new Handle(p.value))),
  3021840470: (id, v) => new IFC4.IfcPhysicalComplexQuantity(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), new IFC4.IfcLabel(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value)),
  597895409: (id, v) => new IFC4.IfcPixelTexture(id, new IFC4.IfcBoolean(v[0].value), new IFC4.IfcBoolean(v[1].value), !v[2] ? null : new IFC4.IfcIdentifier(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map((p) => new IFC4.IfcIdentifier(p.value)), new IFC4.IfcInteger(v[5].value), new IFC4.IfcInteger(v[6].value), new IFC4.IfcInteger(v[7].value), v[8].map((p) => new IFC4.IfcBinary(p.value))),
  2004835150: (id, v) => new IFC4.IfcPlacement(id, new Handle(v[0].value)),
  1663979128: (id, v) => new IFC4.IfcPlanarExtent(id, new IFC4.IfcLengthMeasure(v[0].value), new IFC4.IfcLengthMeasure(v[1].value)),
  2067069095: (id, _) => new IFC4.IfcPoint(id),
  4022376103: (id, v) => new IFC4.IfcPointOnCurve(id, new Handle(v[0].value), new IFC4.IfcParameterValue(v[1].value)),
  1423911732: (id, v) => new IFC4.IfcPointOnSurface(id, new Handle(v[0].value), new IFC4.IfcParameterValue(v[1].value), new IFC4.IfcParameterValue(v[2].value)),
  2924175390: (id, v) => new IFC4.IfcPolyLoop(id, v[0].map((p) => new Handle(p.value))),
  2775532180: (id, v) => new IFC4.IfcPolygonalBoundedHalfSpace(id, new Handle(v[0].value), new IFC4.IfcBoolean(v[1].value), new Handle(v[2].value), new Handle(v[3].value)),
  3727388367: (id, v) => new IFC4.IfcPreDefinedItem(id, new IFC4.IfcLabel(v[0].value)),
  3778827333: (id, _) => new IFC4.IfcPreDefinedProperties(id),
  1775413392: (id, v) => new IFC4.IfcPreDefinedTextFont(id, new IFC4.IfcLabel(v[0].value)),
  673634403: (id, v) => new IFC4.IfcProductDefinitionShape(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map((p) => new Handle(p.value))),
  2802850158: (id, v) => new IFC4.IfcProfileProperties(id, !v[0] ? null : new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), new Handle(v[3].value)),
  2598011224: (id, v) => new IFC4.IfcProperty(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value)),
  1680319473: (id, v) => new IFC4.IfcPropertyDefinition(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value)),
  148025276: (id, v) => new IFC4.IfcPropertyDependencyRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4.IfcText(v[4].value)),
  3357820518: (id, v) => new IFC4.IfcPropertySetDefinition(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value)),
  1482703590: (id, v) => new IFC4.IfcPropertyTemplateDefinition(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value)),
  2090586900: (id, v) => new IFC4.IfcQuantitySet(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value)),
  3615266464: (id, v) => new IFC4.IfcRectangleProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value)),
  3413951693: (id, v) => new IFC4.IfcRegularTimeSeries(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new IFC4.IfcDateTime(v[2].value), new IFC4.IfcDateTime(v[3].value), v[4], v[5], !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), new IFC4.IfcTimeMeasure(v[8].value), v[9].map((p) => new Handle(p.value))),
  1580146022: (id, v) => new IFC4.IfcReinforcementBarProperties(id, new IFC4.IfcAreaMeasure(v[0].value), new IFC4.IfcLabel(v[1].value), v[2], !v[3] ? null : new IFC4.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC4.IfcCountMeasure(v[5].value)),
  478536968: (id, v) => new IFC4.IfcRelationship(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value)),
  2943643501: (id, v) => new IFC4.IfcResourceApprovalRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map((p) => new Handle(p.value)), new Handle(v[3].value)),
  1608871552: (id, v) => new IFC4.IfcResourceConstraintRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), v[3].map((p) => new Handle(p.value))),
  1042787934: (id, v) => new IFC4.IfcResourceTime(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcDuration(v[3].value), !v[4] ? null : new IFC4.IfcPositiveRatioMeasure(v[4].value), !v[5] ? null : new IFC4.IfcDateTime(v[5].value), !v[6] ? null : new IFC4.IfcDateTime(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcDuration(v[8].value), !v[9] ? null : new IFC4.IfcBoolean(v[9].value), !v[10] ? null : new IFC4.IfcDateTime(v[10].value), !v[11] ? null : new IFC4.IfcDuration(v[11].value), !v[12] ? null : new IFC4.IfcPositiveRatioMeasure(v[12].value), !v[13] ? null : new IFC4.IfcDateTime(v[13].value), !v[14] ? null : new IFC4.IfcDateTime(v[14].value), !v[15] ? null : new IFC4.IfcDuration(v[15].value), !v[16] ? null : new IFC4.IfcPositiveRatioMeasure(v[16].value), !v[17] ? null : new IFC4.IfcPositiveRatioMeasure(v[17].value)),
  2778083089: (id, v) => new IFC4.IfcRoundedRectangleProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value)),
  2042790032: (id, v) => new IFC4.IfcSectionProperties(id, v[0], new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value)),
  4165799628: (id, v) => new IFC4.IfcSectionReinforcementProperties(id, new IFC4.IfcLengthMeasure(v[0].value), new IFC4.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4.IfcLengthMeasure(v[2].value), v[3], new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  1509187699: (id, v) => new IFC4.IfcSectionedSpine(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), v[2].map((p) => new Handle(p.value))),
  4124623270: (id, v) => new IFC4.IfcShellBasedSurfaceModel(id, v[0].map((p) => new Handle(p.value))),
  3692461612: (id, v) => new IFC4.IfcSimpleProperty(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value)),
  2609359061: (id, v) => new IFC4.IfcSlippageConnectionCondition(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4.IfcLengthMeasure(v[3].value)),
  723233188: (id, _) => new IFC4.IfcSolidModel(id),
  1595516126: (id, v) => new IFC4.IfcStructuralLoadLinearForce(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLinearForceMeasure(v[1].value), !v[2] ? null : new IFC4.IfcLinearForceMeasure(v[2].value), !v[3] ? null : new IFC4.IfcLinearForceMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLinearMomentMeasure(v[4].value), !v[5] ? null : new IFC4.IfcLinearMomentMeasure(v[5].value), !v[6] ? null : new IFC4.IfcLinearMomentMeasure(v[6].value)),
  2668620305: (id, v) => new IFC4.IfcStructuralLoadPlanarForce(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcPlanarForceMeasure(v[1].value), !v[2] ? null : new IFC4.IfcPlanarForceMeasure(v[2].value), !v[3] ? null : new IFC4.IfcPlanarForceMeasure(v[3].value)),
  2473145415: (id, v) => new IFC4.IfcStructuralLoadSingleDisplacement(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4.IfcPlaneAngleMeasure(v[4].value), !v[5] ? null : new IFC4.IfcPlaneAngleMeasure(v[5].value), !v[6] ? null : new IFC4.IfcPlaneAngleMeasure(v[6].value)),
  1973038258: (id, v) => new IFC4.IfcStructuralLoadSingleDisplacementDistortion(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4.IfcPlaneAngleMeasure(v[4].value), !v[5] ? null : new IFC4.IfcPlaneAngleMeasure(v[5].value), !v[6] ? null : new IFC4.IfcPlaneAngleMeasure(v[6].value), !v[7] ? null : new IFC4.IfcCurvatureMeasure(v[7].value)),
  1597423693: (id, v) => new IFC4.IfcStructuralLoadSingleForce(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC4.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC4.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC4.IfcTorqueMeasure(v[4].value), !v[5] ? null : new IFC4.IfcTorqueMeasure(v[5].value), !v[6] ? null : new IFC4.IfcTorqueMeasure(v[6].value)),
  1190533807: (id, v) => new IFC4.IfcStructuralLoadSingleForceWarping(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC4.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC4.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC4.IfcTorqueMeasure(v[4].value), !v[5] ? null : new IFC4.IfcTorqueMeasure(v[5].value), !v[6] ? null : new IFC4.IfcTorqueMeasure(v[6].value), !v[7] ? null : new IFC4.IfcWarpingMomentMeasure(v[7].value)),
  2233826070: (id, v) => new IFC4.IfcSubedge(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value)),
  2513912981: (id, _) => new IFC4.IfcSurface(id),
  1878645084: (id, v) => new IFC4.IfcSurfaceStyleRendering(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcNormalisedRatioMeasure(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : TypeInitialiser(3, v[7]), v[8]),
  2247615214: (id, v) => new IFC4.IfcSweptAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  1260650574: (id, v) => new IFC4.IfcSweptDiskSolid(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), !v[2] ? null : new IFC4.IfcPositiveLengthMeasure(v[2].value), !v[3] ? null : new IFC4.IfcParameterValue(v[3].value), !v[4] ? null : new IFC4.IfcParameterValue(v[4].value)),
  1096409881: (id, v) => new IFC4.IfcSweptDiskSolidPolygonal(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), !v[2] ? null : new IFC4.IfcPositiveLengthMeasure(v[2].value), !v[3] ? null : new IFC4.IfcParameterValue(v[3].value), !v[4] ? null : new IFC4.IfcParameterValue(v[4].value), !v[5] ? null : new IFC4.IfcPositiveLengthMeasure(v[5].value)),
  230924584: (id, v) => new IFC4.IfcSweptSurface(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  3071757647: (id, v) => new IFC4.IfcTShapeProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[9].value), !v[10] ? null : new IFC4.IfcPlaneAngleMeasure(v[10].value), !v[11] ? null : new IFC4.IfcPlaneAngleMeasure(v[11].value)),
  901063453: (id, _) => new IFC4.IfcTessellatedItem(id),
  4282788508: (id, v) => new IFC4.IfcTextLiteral(id, new IFC4.IfcPresentableText(v[0].value), new Handle(v[1].value), v[2]),
  3124975700: (id, v) => new IFC4.IfcTextLiteralWithExtent(id, new IFC4.IfcPresentableText(v[0].value), new Handle(v[1].value), v[2], new Handle(v[3].value), new IFC4.IfcBoxAlignment(v[4].value)),
  1983826977: (id, v) => new IFC4.IfcTextStyleFontModel(id, new IFC4.IfcLabel(v[0].value), v[1].map((p) => new IFC4.IfcTextFontName(p.value)), !v[2] ? null : new IFC4.IfcFontStyle(v[2].value), !v[3] ? null : new IFC4.IfcFontVariant(v[3].value), !v[4] ? null : new IFC4.IfcFontWeight(v[4].value), TypeInitialiser(3, v[5])),
  2715220739: (id, v) => new IFC4.IfcTrapeziumProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcLengthMeasure(v[6].value)),
  1628702193: (id, v) => new IFC4.IfcTypeObject(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value))),
  3736923433: (id, v) => new IFC4.IfcTypeProcess(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  2347495698: (id, v) => new IFC4.IfcTypeProduct(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value)),
  3698973494: (id, v) => new IFC4.IfcTypeResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  427810014: (id, v) => new IFC4.IfcUShapeProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcPlaneAngleMeasure(v[9].value)),
  1417489154: (id, v) => new IFC4.IfcVector(id, new Handle(v[0].value), new IFC4.IfcLengthMeasure(v[1].value)),
  2759199220: (id, v) => new IFC4.IfcVertexLoop(id, new Handle(v[0].value)),
  1299126871: (id, v) => new IFC4.IfcWindowStyle(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8], v[9], new IFC4.IfcBoolean(v[10].value), new IFC4.IfcBoolean(v[11].value)),
  2543172580: (id, v) => new IFC4.IfcZShapeProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[8].value)),
  3406155212: (id, v) => new IFC4.IfcAdvancedFace(id, v[0].map((p) => new Handle(p.value)), new Handle(v[1].value), new IFC4.IfcBoolean(v[2].value)),
  669184980: (id, v) => new IFC4.IfcAnnotationFillArea(id, new Handle(v[0].value), !v[1] ? null : v[1].map((p) => new Handle(p.value))),
  3207858831: (id, v) => new IFC4.IfcAsymmetricIShapeProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value), new IFC4.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[11].value), !v[12] ? null : new IFC4.IfcPlaneAngleMeasure(v[12].value), !v[13] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[13].value), !v[14] ? null : new IFC4.IfcPlaneAngleMeasure(v[14].value)),
  4261334040: (id, v) => new IFC4.IfcAxis1Placement(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  3125803723: (id, v) => new IFC4.IfcAxis2Placement2D(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value)),
  2740243338: (id, v) => new IFC4.IfcAxis2Placement3D(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value)),
  2736907675: (id, v) => new IFC4.IfcBooleanResult(id, v[0], new Handle(v[1].value), new Handle(v[2].value)),
  4182860854: (id, _) => new IFC4.IfcBoundedSurface(id),
  2581212453: (id, v) => new IFC4.IfcBoundingBox(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), new IFC4.IfcPositiveLengthMeasure(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value)),
  2713105998: (id, v) => new IFC4.IfcBoxedHalfSpace(id, new Handle(v[0].value), new IFC4.IfcBoolean(v[1].value), new Handle(v[2].value)),
  2898889636: (id, v) => new IFC4.IfcCShapeProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value)),
  1123145078: (id, v) => new IFC4.IfcCartesianPoint(id, v[0].map((p) => new IFC4.IfcLengthMeasure(p.value))),
  574549367: (id, _) => new IFC4.IfcCartesianPointList(id),
  1675464909: (id, v) => new IFC4.IfcCartesianPointList2D(id, v[0].map((p) => new IFC4.IfcLengthMeasure(p.value))),
  2059837836: (id, v) => new IFC4.IfcCartesianPointList3D(id, v[0].map((p) => new IFC4.IfcLengthMeasure(p.value))),
  59481748: (id, v) => new IFC4.IfcCartesianTransformationOperator(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcReal(v[3].value)),
  3749851601: (id, v) => new IFC4.IfcCartesianTransformationOperator2D(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcReal(v[3].value)),
  3486308946: (id, v) => new IFC4.IfcCartesianTransformationOperator2DnonUniform(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcReal(v[3].value), !v[4] ? null : new IFC4.IfcReal(v[4].value)),
  3331915920: (id, v) => new IFC4.IfcCartesianTransformationOperator3D(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcReal(v[3].value), !v[4] ? null : new Handle(v[4].value)),
  1416205885: (id, v) => new IFC4.IfcCartesianTransformationOperator3DnonUniform(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcReal(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new IFC4.IfcReal(v[5].value), !v[6] ? null : new IFC4.IfcReal(v[6].value)),
  1383045692: (id, v) => new IFC4.IfcCircleProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value)),
  2205249479: (id, v) => new IFC4.IfcClosedShell(id, v[0].map((p) => new Handle(p.value))),
  776857604: (id, v) => new IFC4.IfcColourRgb(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new IFC4.IfcNormalisedRatioMeasure(v[1].value), new IFC4.IfcNormalisedRatioMeasure(v[2].value), new IFC4.IfcNormalisedRatioMeasure(v[3].value)),
  2542286263: (id, v) => new IFC4.IfcComplexProperty(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new IFC4.IfcIdentifier(v[2].value), v[3].map((p) => new Handle(p.value))),
  2485617015: (id, v) => new IFC4.IfcCompositeCurveSegment(id, v[0], new IFC4.IfcBoolean(v[1].value), new Handle(v[2].value)),
  2574617495: (id, v) => new IFC4.IfcConstructionResourceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new Handle(v[10].value)),
  3419103109: (id, v) => new IFC4.IfcContext(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : new Handle(v[8].value)),
  1815067380: (id, v) => new IFC4.IfcCrewResourceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new Handle(v[10].value), v[11]),
  2506170314: (id, v) => new IFC4.IfcCsgPrimitive3D(id, new Handle(v[0].value)),
  2147822146: (id, v) => new IFC4.IfcCsgSolid(id, new Handle(v[0].value)),
  2601014836: (id, _) => new IFC4.IfcCurve(id),
  2827736869: (id, v) => new IFC4.IfcCurveBoundedPlane(id, new Handle(v[0].value), new Handle(v[1].value), v[2].map((p) => new Handle(p.value))),
  2629017746: (id, v) => new IFC4.IfcCurveBoundedSurface(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), new IFC4.IfcBoolean(v[2].value)),
  32440307: (id, v) => new IFC4.IfcDirection(id, v[0].map((p) => new IFC4.IfcReal(p.value))),
  526551008: (id, v) => new IFC4.IfcDoorStyle(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8], v[9], new IFC4.IfcBoolean(v[10].value), new IFC4.IfcBoolean(v[11].value)),
  1472233963: (id, v) => new IFC4.IfcEdgeLoop(id, v[0].map((p) => new Handle(p.value))),
  1883228015: (id, v) => new IFC4.IfcElementQuantity(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5].map((p) => new Handle(p.value))),
  339256511: (id, v) => new IFC4.IfcElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  2777663545: (id, v) => new IFC4.IfcElementarySurface(id, new Handle(v[0].value)),
  2835456948: (id, v) => new IFC4.IfcEllipseProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value)),
  4024345920: (id, v) => new IFC4.IfcEventType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], v[10], !v[11] ? null : new IFC4.IfcLabel(v[11].value)),
  477187591: (id, v) => new IFC4.IfcExtrudedAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value)),
  2804161546: (id, v) => new IFC4.IfcExtrudedAreaSolidTapered(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new Handle(v[4].value)),
  2047409740: (id, v) => new IFC4.IfcFaceBasedSurfaceModel(id, v[0].map((p) => new Handle(p.value))),
  374418227: (id, v) => new IFC4.IfcFillAreaStyleHatching(id, new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), new IFC4.IfcPlaneAngleMeasure(v[4].value)),
  315944413: (id, v) => new IFC4.IfcFillAreaStyleTiles(id, v[0].map((p) => new Handle(p.value)), v[1].map((p) => new Handle(p.value)), new IFC4.IfcPositiveRatioMeasure(v[2].value)),
  2652556860: (id, v) => new IFC4.IfcFixedReferenceSweptAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcParameterValue(v[3].value), !v[4] ? null : new IFC4.IfcParameterValue(v[4].value), new Handle(v[5].value)),
  4238390223: (id, v) => new IFC4.IfcFurnishingElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  1268542332: (id, v) => new IFC4.IfcFurnitureType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], v[10]),
  4095422895: (id, v) => new IFC4.IfcGeographicElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  987898635: (id, v) => new IFC4.IfcGeometricCurveSet(id, v[0].map((p) => new Handle(p.value))),
  1484403080: (id, v) => new IFC4.IfcIShapeProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcPlaneAngleMeasure(v[9].value)),
  178912537: (id, v) => new IFC4.IfcIndexedPolygonalFace(id, v[0].map((p) => new IFC4.IfcPositiveInteger(p.value))),
  2294589976: (id, v) => new IFC4.IfcIndexedPolygonalFaceWithVoids(id, v[0].map((p) => new IFC4.IfcPositiveInteger(p.value)), v[1].map((p) => new IFC4.IfcPositiveInteger(p.value))),
  572779678: (id, v) => new IFC4.IfcLShapeProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), !v[4] ? null : new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4.IfcPlaneAngleMeasure(v[8].value)),
  428585644: (id, v) => new IFC4.IfcLaborResourceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new Handle(v[10].value), v[11]),
  1281925730: (id, v) => new IFC4.IfcLine(id, new Handle(v[0].value), new Handle(v[1].value)),
  1425443689: (id, v) => new IFC4.IfcManifoldSolidBrep(id, new Handle(v[0].value)),
  3888040117: (id, v) => new IFC4.IfcObject(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value)),
  3388369263: (id, v) => new IFC4.IfcOffsetCurve2D(id, new Handle(v[0].value), new IFC4.IfcLengthMeasure(v[1].value), new IFC4.IfcLogical(v[2].value)),
  3505215534: (id, v) => new IFC4.IfcOffsetCurve3D(id, new Handle(v[0].value), new IFC4.IfcLengthMeasure(v[1].value), new IFC4.IfcLogical(v[2].value), new Handle(v[3].value)),
  1682466193: (id, v) => new IFC4.IfcPcurve(id, new Handle(v[0].value), new Handle(v[1].value)),
  603570806: (id, v) => new IFC4.IfcPlanarBox(id, new IFC4.IfcLengthMeasure(v[0].value), new IFC4.IfcLengthMeasure(v[1].value), new Handle(v[2].value)),
  220341763: (id, v) => new IFC4.IfcPlane(id, new Handle(v[0].value)),
  759155922: (id, v) => new IFC4.IfcPreDefinedColour(id, new IFC4.IfcLabel(v[0].value)),
  2559016684: (id, v) => new IFC4.IfcPreDefinedCurveFont(id, new IFC4.IfcLabel(v[0].value)),
  3967405729: (id, v) => new IFC4.IfcPreDefinedPropertySet(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value)),
  569719735: (id, v) => new IFC4.IfcProcedureType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2945172077: (id, v) => new IFC4.IfcProcess(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value)),
  4208778838: (id, v) => new IFC4.IfcProduct(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  103090709: (id, v) => new IFC4.IfcProject(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : new Handle(v[8].value)),
  653396225: (id, v) => new IFC4.IfcProjectLibrary(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : new Handle(v[8].value)),
  871118103: (id, v) => new IFC4.IfcPropertyBoundedValue(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : TypeInitialiser(3, v[2]), !v[3] ? null : TypeInitialiser(3, v[3]), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : TypeInitialiser(3, v[5])),
  4166981789: (id, v) => new IFC4.IfcPropertyEnumeratedValue(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : v[2].map((p) => TypeInitialiser(3, p)), !v[3] ? null : new Handle(v[3].value)),
  2752243245: (id, v) => new IFC4.IfcPropertyListValue(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : v[2].map((p) => TypeInitialiser(3, p)), !v[3] ? null : new Handle(v[3].value)),
  941946838: (id, v) => new IFC4.IfcPropertyReferenceValue(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new IFC4.IfcText(v[2].value), !v[3] ? null : new Handle(v[3].value)),
  1451395588: (id, v) => new IFC4.IfcPropertySet(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value))),
  492091185: (id, v) => new IFC4.IfcPropertySetTemplate(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4], !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), v[6].map((p) => new Handle(p.value))),
  3650150729: (id, v) => new IFC4.IfcPropertySingleValue(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : TypeInitialiser(3, v[2]), !v[3] ? null : new Handle(v[3].value)),
  110355661: (id, v) => new IFC4.IfcPropertyTableValue(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : v[2].map((p) => TypeInitialiser(3, p)), !v[3] ? null : v[3].map((p) => TypeInitialiser(3, p)), !v[4] ? null : new IFC4.IfcText(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7]),
  3521284610: (id, v) => new IFC4.IfcPropertyTemplate(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value)),
  3219374653: (id, v) => new IFC4.IfcProxy(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  2770003689: (id, v) => new IFC4.IfcRectangleHollowProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value)),
  2798486643: (id, v) => new IFC4.IfcRectangularPyramid(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), new IFC4.IfcPositiveLengthMeasure(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value)),
  3454111270: (id, v) => new IFC4.IfcRectangularTrimmedSurface(id, new Handle(v[0].value), new IFC4.IfcParameterValue(v[1].value), new IFC4.IfcParameterValue(v[2].value), new IFC4.IfcParameterValue(v[3].value), new IFC4.IfcParameterValue(v[4].value), new IFC4.IfcBoolean(v[5].value), new IFC4.IfcBoolean(v[6].value)),
  3765753017: (id, v) => new IFC4.IfcReinforcementDefinitionProperties(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5].map((p) => new Handle(p.value))),
  3939117080: (id, v) => new IFC4.IfcRelAssigns(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5]),
  1683148259: (id, v) => new IFC4.IfcRelAssignsToActor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  2495723537: (id, v) => new IFC4.IfcRelAssignsToControl(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value)),
  1307041759: (id, v) => new IFC4.IfcRelAssignsToGroup(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value)),
  1027710054: (id, v) => new IFC4.IfcRelAssignsToGroupByFactor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value), new IFC4.IfcRatioMeasure(v[7].value)),
  4278684876: (id, v) => new IFC4.IfcRelAssignsToProcess(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  2857406711: (id, v) => new IFC4.IfcRelAssignsToProduct(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value)),
  205026976: (id, v) => new IFC4.IfcRelAssignsToResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), v[5], new Handle(v[6].value)),
  1865459582: (id, v) => new IFC4.IfcRelAssociates(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value))),
  4095574036: (id, v) => new IFC4.IfcRelAssociatesApproval(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  919958153: (id, v) => new IFC4.IfcRelAssociatesClassification(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  2728634034: (id, v) => new IFC4.IfcRelAssociatesConstraint(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), !v[5] ? null : new IFC4.IfcLabel(v[5].value), new Handle(v[6].value)),
  982818633: (id, v) => new IFC4.IfcRelAssociatesDocument(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  3840914261: (id, v) => new IFC4.IfcRelAssociatesLibrary(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  2655215786: (id, v) => new IFC4.IfcRelAssociatesMaterial(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  826625072: (id, v) => new IFC4.IfcRelConnects(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value)),
  1204542856: (id, v) => new IFC4.IfcRelConnectsElements(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value)),
  3945020480: (id, v) => new IFC4.IfcRelConnectsPathElements(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value), v[7].map((p) => new IFC4.IfcInteger(p.value)), v[8].map((p) => new IFC4.IfcInteger(p.value)), v[9], v[10]),
  4201705270: (id, v) => new IFC4.IfcRelConnectsPortToElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value)),
  3190031847: (id, v) => new IFC4.IfcRelConnectsPorts(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  2127690289: (id, v) => new IFC4.IfcRelConnectsStructuralActivity(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value)),
  1638771189: (id, v) => new IFC4.IfcRelConnectsStructuralMember(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new IFC4.IfcLengthMeasure(v[8].value), !v[9] ? null : new Handle(v[9].value)),
  504942748: (id, v) => new IFC4.IfcRelConnectsWithEccentricity(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new IFC4.IfcLengthMeasure(v[8].value), !v[9] ? null : new Handle(v[9].value), new Handle(v[10].value)),
  3678494232: (id, v) => new IFC4.IfcRelConnectsWithRealizingElements(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value), v[7].map((p) => new Handle(p.value)), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  3242617779: (id, v) => new IFC4.IfcRelContainedInSpatialStructure(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  886880790: (id, v) => new IFC4.IfcRelCoversBldgElements(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  2802773753: (id, v) => new IFC4.IfcRelCoversSpaces(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  2565941209: (id, v) => new IFC4.IfcRelDeclares(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  2551354335: (id, v) => new IFC4.IfcRelDecomposes(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value)),
  693640335: (id, v) => new IFC4.IfcRelDefines(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value)),
  1462361463: (id, v) => new IFC4.IfcRelDefinesByObject(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  4186316022: (id, v) => new IFC4.IfcRelDefinesByProperties(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  307848117: (id, v) => new IFC4.IfcRelDefinesByTemplate(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  781010003: (id, v) => new IFC4.IfcRelDefinesByType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  3940055652: (id, v) => new IFC4.IfcRelFillsElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value)),
  279856033: (id, v) => new IFC4.IfcRelFlowControlElements(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  427948657: (id, v) => new IFC4.IfcRelInterferesElements(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8].value),
  3268803585: (id, v) => new IFC4.IfcRelNests(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  750771296: (id, v) => new IFC4.IfcRelProjectsElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value)),
  1245217292: (id, v) => new IFC4.IfcRelReferencedInSpatialStructure(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map((p) => new Handle(p.value)), new Handle(v[5].value)),
  4122056220: (id, v) => new IFC4.IfcRelSequence(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  366585022: (id, v) => new IFC4.IfcRelServicesBuildings(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  3451746338: (id, v) => new IFC4.IfcRelSpaceBoundary(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8]),
  3523091289: (id, v) => new IFC4.IfcRelSpaceBoundary1stLevel(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8], !v[9] ? null : new Handle(v[9].value)),
  1521410863: (id, v) => new IFC4.IfcRelSpaceBoundary2ndLevel(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8], !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value)),
  1401173127: (id, v) => new IFC4.IfcRelVoidsElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value)),
  816062949: (id, v) => new IFC4.IfcReparametrisedCompositeCurveSegment(id, v[0], new IFC4.IfcBoolean(v[1].value), new Handle(v[2].value), new IFC4.IfcParameterValue(v[3].value)),
  2914609552: (id, v) => new IFC4.IfcResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value)),
  1856042241: (id, v) => new IFC4.IfcRevolvedAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4.IfcPlaneAngleMeasure(v[3].value)),
  3243963512: (id, v) => new IFC4.IfcRevolvedAreaSolidTapered(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4.IfcPlaneAngleMeasure(v[3].value), new Handle(v[4].value)),
  4158566097: (id, v) => new IFC4.IfcRightCircularCone(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), new IFC4.IfcPositiveLengthMeasure(v[2].value)),
  3626867408: (id, v) => new IFC4.IfcRightCircularCylinder(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), new IFC4.IfcPositiveLengthMeasure(v[2].value)),
  3663146110: (id, v) => new IFC4.IfcSimplePropertyTemplate(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4], !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new IFC4.IfcLabel(v[10].value), v[11]),
  1412071761: (id, v) => new IFC4.IfcSpatialElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value)),
  710998568: (id, v) => new IFC4.IfcSpatialElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  2706606064: (id, v) => new IFC4.IfcSpatialStructureElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8]),
  3893378262: (id, v) => new IFC4.IfcSpatialStructureElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  463610769: (id, v) => new IFC4.IfcSpatialZone(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8]),
  2481509218: (id, v) => new IFC4.IfcSpatialZoneType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4.IfcLabel(v[10].value)),
  451544542: (id, v) => new IFC4.IfcSphere(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value)),
  4015995234: (id, v) => new IFC4.IfcSphericalSurface(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value)),
  3544373492: (id, v) => new IFC4.IfcStructuralActivity(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]),
  3136571912: (id, v) => new IFC4.IfcStructuralItem(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  530289379: (id, v) => new IFC4.IfcStructuralMember(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  3689010777: (id, v) => new IFC4.IfcStructuralReaction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]),
  3979015343: (id, v) => new IFC4.IfcStructuralSurfaceMember(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC4.IfcPositiveLengthMeasure(v[8].value)),
  2218152070: (id, v) => new IFC4.IfcStructuralSurfaceMemberVarying(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC4.IfcPositiveLengthMeasure(v[8].value)),
  603775116: (id, v) => new IFC4.IfcStructuralSurfaceReaction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9]),
  4095615324: (id, v) => new IFC4.IfcSubContractResourceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new Handle(v[10].value), v[11]),
  699246055: (id, v) => new IFC4.IfcSurfaceCurve(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), v[2]),
  2028607225: (id, v) => new IFC4.IfcSurfaceCurveSweptAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcParameterValue(v[3].value), !v[4] ? null : new IFC4.IfcParameterValue(v[4].value), new Handle(v[5].value)),
  2809605785: (id, v) => new IFC4.IfcSurfaceOfLinearExtrusion(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4.IfcLengthMeasure(v[3].value)),
  4124788165: (id, v) => new IFC4.IfcSurfaceOfRevolution(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value)),
  1580310250: (id, v) => new IFC4.IfcSystemFurnitureElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3473067441: (id, v) => new IFC4.IfcTask(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), new IFC4.IfcBoolean(v[9].value), !v[10] ? null : new IFC4.IfcInteger(v[10].value), !v[11] ? null : new Handle(v[11].value), v[12]),
  3206491090: (id, v) => new IFC4.IfcTaskType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4.IfcLabel(v[10].value)),
  2387106220: (id, v) => new IFC4.IfcTessellatedFaceSet(id, new Handle(v[0].value)),
  1935646853: (id, v) => new IFC4.IfcToroidalSurface(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), new IFC4.IfcPositiveLengthMeasure(v[2].value)),
  2097647324: (id, v) => new IFC4.IfcTransportElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2916149573: (id, v) => new IFC4.IfcTriangulatedFaceSet(id, new Handle(v[0].value), !v[1] ? null : v[1].map((p) => new IFC4.IfcParameterValue(p.value)), !v[2] ? null : new IFC4.IfcBoolean(v[2].value), v[3].map((p) => new IFC4.IfcPositiveInteger(p.value)), !v[4] ? null : v[4].map((p) => new IFC4.IfcPositiveInteger(p.value))),
  336235671: (id, v) => new IFC4.IfcWindowLiningProperties(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[5].value), !v[6] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4.IfcNormalisedRatioMeasure(v[8].value), !v[9] ? null : new IFC4.IfcNormalisedRatioMeasure(v[9].value), !v[10] ? null : new IFC4.IfcNormalisedRatioMeasure(v[10].value), !v[11] ? null : new IFC4.IfcNormalisedRatioMeasure(v[11].value), !v[12] ? null : new Handle(v[12].value), !v[13] ? null : new IFC4.IfcLengthMeasure(v[13].value), !v[14] ? null : new IFC4.IfcLengthMeasure(v[14].value), !v[15] ? null : new IFC4.IfcLengthMeasure(v[15].value)),
  512836454: (id, v) => new IFC4.IfcWindowPanelProperties(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4], v[5], !v[6] ? null : new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new Handle(v[8].value)),
  2296667514: (id, v) => new IFC4.IfcActor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), new Handle(v[5].value)),
  1635779807: (id, v) => new IFC4.IfcAdvancedBrep(id, new Handle(v[0].value)),
  2603310189: (id, v) => new IFC4.IfcAdvancedBrepWithVoids(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value))),
  1674181508: (id, v) => new IFC4.IfcAnnotation(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  2887950389: (id, v) => new IFC4.IfcBSplineSurface(id, new IFC4.IfcInteger(v[0].value), new IFC4.IfcInteger(v[1].value), v[2].map((p) => new Handle(p.value)), v[3], new IFC4.IfcLogical(v[4].value), new IFC4.IfcLogical(v[5].value), new IFC4.IfcLogical(v[6].value)),
  167062518: (id, v) => new IFC4.IfcBSplineSurfaceWithKnots(id, new IFC4.IfcInteger(v[0].value), new IFC4.IfcInteger(v[1].value), v[2].map((p) => new Handle(p.value)), v[3], new IFC4.IfcLogical(v[4].value), new IFC4.IfcLogical(v[5].value), new IFC4.IfcLogical(v[6].value), v[7].map((p) => new IFC4.IfcInteger(p.value)), v[8].map((p) => new IFC4.IfcInteger(p.value)), v[9].map((p) => new IFC4.IfcParameterValue(p.value)), v[10].map((p) => new IFC4.IfcParameterValue(p.value)), v[11]),
  1334484129: (id, v) => new IFC4.IfcBlock(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), new IFC4.IfcPositiveLengthMeasure(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value)),
  3649129432: (id, v) => new IFC4.IfcBooleanClippingResult(id, v[0], new Handle(v[1].value), new Handle(v[2].value)),
  1260505505: (id, _) => new IFC4.IfcBoundedCurve(id),
  4031249490: (id, v) => new IFC4.IfcBuilding(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC4.IfcLengthMeasure(v[9].value), !v[10] ? null : new IFC4.IfcLengthMeasure(v[10].value), !v[11] ? null : new Handle(v[11].value)),
  1950629157: (id, v) => new IFC4.IfcBuildingElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  3124254112: (id, v) => new IFC4.IfcBuildingStorey(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC4.IfcLengthMeasure(v[9].value)),
  2197970202: (id, v) => new IFC4.IfcChimneyType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2937912522: (id, v) => new IFC4.IfcCircleHollowProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value)),
  3893394355: (id, v) => new IFC4.IfcCivilElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  300633059: (id, v) => new IFC4.IfcColumnType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3875453745: (id, v) => new IFC4.IfcComplexPropertyTemplate(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5], !v[6] ? null : v[6].map((p) => new Handle(p.value))),
  3732776249: (id, v) => new IFC4.IfcCompositeCurve(id, v[0].map((p) => new Handle(p.value)), new IFC4.IfcLogical(v[1].value)),
  15328376: (id, v) => new IFC4.IfcCompositeCurveOnSurface(id, v[0].map((p) => new Handle(p.value)), new IFC4.IfcLogical(v[1].value)),
  2510884976: (id, v) => new IFC4.IfcConic(id, new Handle(v[0].value)),
  2185764099: (id, v) => new IFC4.IfcConstructionEquipmentResourceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new Handle(v[10].value), v[11]),
  4105962743: (id, v) => new IFC4.IfcConstructionMaterialResourceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new Handle(v[10].value), v[11]),
  1525564444: (id, v) => new IFC4.IfcConstructionProductResourceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : v[9].map((p) => new Handle(p.value)), !v[10] ? null : new Handle(v[10].value), v[11]),
  2559216714: (id, v) => new IFC4.IfcConstructionResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map((p) => new Handle(p.value)), !v[9] ? null : new Handle(v[9].value)),
  3293443760: (id, v) => new IFC4.IfcControl(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value)),
  3895139033: (id, v) => new IFC4.IfcCostItem(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), v[6], !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : v[8].map((p) => new Handle(p.value))),
  1419761937: (id, v) => new IFC4.IfcCostSchedule(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcDateTime(v[8].value), !v[9] ? null : new IFC4.IfcDateTime(v[9].value)),
  1916426348: (id, v) => new IFC4.IfcCoveringType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3295246426: (id, v) => new IFC4.IfcCrewResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map((p) => new Handle(p.value)), !v[9] ? null : new Handle(v[9].value), v[10]),
  1457835157: (id, v) => new IFC4.IfcCurtainWallType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1213902940: (id, v) => new IFC4.IfcCylindricalSurface(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value)),
  3256556792: (id, v) => new IFC4.IfcDistributionElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  3849074793: (id, v) => new IFC4.IfcDistributionFlowElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  2963535650: (id, v) => new IFC4.IfcDoorLiningProperties(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[5].value), !v[6] ? null : new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcLengthMeasure(v[9].value), !v[10] ? null : new IFC4.IfcLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcLengthMeasure(v[11].value), !v[12] ? null : new IFC4.IfcPositiveLengthMeasure(v[12].value), !v[13] ? null : new IFC4.IfcPositiveLengthMeasure(v[13].value), !v[14] ? null : new Handle(v[14].value), !v[15] ? null : new IFC4.IfcLengthMeasure(v[15].value), !v[16] ? null : new IFC4.IfcLengthMeasure(v[16].value)),
  1714330368: (id, v) => new IFC4.IfcDoorPanelProperties(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcPositiveLengthMeasure(v[4].value), v[5], !v[6] ? null : new IFC4.IfcNormalisedRatioMeasure(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value)),
  2323601079: (id, v) => new IFC4.IfcDoorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], v[10], !v[11] ? null : new IFC4.IfcBoolean(v[11].value), !v[12] ? null : new IFC4.IfcLabel(v[12].value)),
  445594917: (id, v) => new IFC4.IfcDraughtingPreDefinedColour(id, new IFC4.IfcLabel(v[0].value)),
  4006246654: (id, v) => new IFC4.IfcDraughtingPreDefinedCurveFont(id, new IFC4.IfcLabel(v[0].value)),
  1758889154: (id, v) => new IFC4.IfcElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  4123344466: (id, v) => new IFC4.IfcElementAssembly(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8], v[9]),
  2397081782: (id, v) => new IFC4.IfcElementAssemblyType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1623761950: (id, v) => new IFC4.IfcElementComponent(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  2590856083: (id, v) => new IFC4.IfcElementComponentType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  1704287377: (id, v) => new IFC4.IfcEllipse(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), new IFC4.IfcPositiveLengthMeasure(v[2].value)),
  2107101300: (id, v) => new IFC4.IfcEnergyConversionDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  132023988: (id, v) => new IFC4.IfcEngineType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3174744832: (id, v) => new IFC4.IfcEvaporativeCoolerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3390157468: (id, v) => new IFC4.IfcEvaporatorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  4148101412: (id, v) => new IFC4.IfcEvent(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), v[7], v[8], !v[9] ? null : new IFC4.IfcLabel(v[9].value), !v[10] ? null : new Handle(v[10].value)),
  2853485674: (id, v) => new IFC4.IfcExternalSpatialStructureElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value)),
  807026263: (id, v) => new IFC4.IfcFacetedBrep(id, new Handle(v[0].value)),
  3737207727: (id, v) => new IFC4.IfcFacetedBrepWithVoids(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value))),
  647756555: (id, v) => new IFC4.IfcFastener(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  2489546625: (id, v) => new IFC4.IfcFastenerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2827207264: (id, v) => new IFC4.IfcFeatureElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  2143335405: (id, v) => new IFC4.IfcFeatureElementAddition(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  1287392070: (id, v) => new IFC4.IfcFeatureElementSubtraction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  3907093117: (id, v) => new IFC4.IfcFlowControllerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  3198132628: (id, v) => new IFC4.IfcFlowFittingType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  3815607619: (id, v) => new IFC4.IfcFlowMeterType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1482959167: (id, v) => new IFC4.IfcFlowMovingDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  1834744321: (id, v) => new IFC4.IfcFlowSegmentType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  1339347760: (id, v) => new IFC4.IfcFlowStorageDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  2297155007: (id, v) => new IFC4.IfcFlowTerminalType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  3009222698: (id, v) => new IFC4.IfcFlowTreatmentDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  1893162501: (id, v) => new IFC4.IfcFootingType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  263784265: (id, v) => new IFC4.IfcFurnishingElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  1509553395: (id, v) => new IFC4.IfcFurniture(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3493046030: (id, v) => new IFC4.IfcGeographicElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3009204131: (id, v) => new IFC4.IfcGrid(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7].map((p) => new Handle(p.value)), v[8].map((p) => new Handle(p.value)), !v[9] ? null : v[9].map((p) => new Handle(p.value)), v[10]),
  2706460486: (id, v) => new IFC4.IfcGroup(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value)),
  1251058090: (id, v) => new IFC4.IfcHeatExchangerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1806887404: (id, v) => new IFC4.IfcHumidifierType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2571569899: (id, v) => new IFC4.IfcIndexedPolyCurve(id, new Handle(v[0].value), !v[1] ? null : v[1].map((p) => TypeInitialiser(3, p)), !v[2] ? null : new IFC4.IfcBoolean(v[2].value)),
  3946677679: (id, v) => new IFC4.IfcInterceptorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3113134337: (id, v) => new IFC4.IfcIntersectionCurve(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), v[2]),
  2391368822: (id, v) => new IFC4.IfcInventory(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5], !v[6] ? null : new Handle(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : new IFC4.IfcDate(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value)),
  4288270099: (id, v) => new IFC4.IfcJunctionBoxType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3827777499: (id, v) => new IFC4.IfcLaborResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map((p) => new Handle(p.value)), !v[9] ? null : new Handle(v[9].value), v[10]),
  1051575348: (id, v) => new IFC4.IfcLampType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1161773419: (id, v) => new IFC4.IfcLightFixtureType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  377706215: (id, v) => new IFC4.IfcMechanicalFastener(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcPositiveLengthMeasure(v[9].value), v[10]),
  2108223431: (id, v) => new IFC4.IfcMechanicalFastenerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcPositiveLengthMeasure(v[11].value)),
  1114901282: (id, v) => new IFC4.IfcMedicalDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3181161470: (id, v) => new IFC4.IfcMemberType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  977012517: (id, v) => new IFC4.IfcMotorConnectionType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  4143007308: (id, v) => new IFC4.IfcOccupant(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), new Handle(v[5].value), v[6]),
  3588315303: (id, v) => new IFC4.IfcOpeningElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3079942009: (id, v) => new IFC4.IfcOpeningStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  2837617999: (id, v) => new IFC4.IfcOutletType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2382730787: (id, v) => new IFC4.IfcPerformanceHistory(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), new IFC4.IfcLabel(v[6].value), v[7]),
  3566463478: (id, v) => new IFC4.IfcPermeableCoveringProperties(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4], v[5], !v[6] ? null : new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new Handle(v[8].value)),
  3327091369: (id, v) => new IFC4.IfcPermit(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcText(v[8].value)),
  1158309216: (id, v) => new IFC4.IfcPileType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  804291784: (id, v) => new IFC4.IfcPipeFittingType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  4231323485: (id, v) => new IFC4.IfcPipeSegmentType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  4017108033: (id, v) => new IFC4.IfcPlateType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2839578677: (id, v) => new IFC4.IfcPolygonalFaceSet(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcBoolean(v[1].value), v[2].map((p) => new Handle(p.value)), !v[3] ? null : v[3].map((p) => new IFC4.IfcPositiveInteger(p.value))),
  3724593414: (id, v) => new IFC4.IfcPolyline(id, v[0].map((p) => new Handle(p.value))),
  3740093272: (id, v) => new IFC4.IfcPort(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value)),
  2744685151: (id, v) => new IFC4.IfcProcedure(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), v[7]),
  2904328755: (id, v) => new IFC4.IfcProjectOrder(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcText(v[8].value)),
  3651124850: (id, v) => new IFC4.IfcProjectionElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1842657554: (id, v) => new IFC4.IfcProtectiveDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2250791053: (id, v) => new IFC4.IfcPumpType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2893384427: (id, v) => new IFC4.IfcRailingType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2324767716: (id, v) => new IFC4.IfcRampFlightType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1469900589: (id, v) => new IFC4.IfcRampType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  683857671: (id, v) => new IFC4.IfcRationalBSplineSurfaceWithKnots(id, new IFC4.IfcInteger(v[0].value), new IFC4.IfcInteger(v[1].value), v[2].map((p) => new Handle(p.value)), v[3], new IFC4.IfcLogical(v[4].value), new IFC4.IfcLogical(v[5].value), new IFC4.IfcLogical(v[6].value), v[7].map((p) => new IFC4.IfcInteger(p.value)), v[8].map((p) => new IFC4.IfcInteger(p.value)), v[9].map((p) => new IFC4.IfcParameterValue(p.value)), v[10].map((p) => new IFC4.IfcParameterValue(p.value)), v[11], v[12].map((p) => new IFC4.IfcReal(p.value))),
  3027567501: (id, v) => new IFC4.IfcReinforcingElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  964333572: (id, v) => new IFC4.IfcReinforcingElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  2320036040: (id, v) => new IFC4.IfcReinforcingMesh(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : new IFC4.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC4.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcPositiveLengthMeasure(v[11].value), !v[12] ? null : new IFC4.IfcPositiveLengthMeasure(v[12].value), !v[13] ? null : new IFC4.IfcAreaMeasure(v[13].value), !v[14] ? null : new IFC4.IfcAreaMeasure(v[14].value), !v[15] ? null : new IFC4.IfcPositiveLengthMeasure(v[15].value), !v[16] ? null : new IFC4.IfcPositiveLengthMeasure(v[16].value), v[17]),
  2310774935: (id, v) => new IFC4.IfcReinforcingMeshType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcPositiveLengthMeasure(v[11].value), !v[12] ? null : new IFC4.IfcPositiveLengthMeasure(v[12].value), !v[13] ? null : new IFC4.IfcPositiveLengthMeasure(v[13].value), !v[14] ? null : new IFC4.IfcAreaMeasure(v[14].value), !v[15] ? null : new IFC4.IfcAreaMeasure(v[15].value), !v[16] ? null : new IFC4.IfcPositiveLengthMeasure(v[16].value), !v[17] ? null : new IFC4.IfcPositiveLengthMeasure(v[17].value), !v[18] ? null : new IFC4.IfcLabel(v[18].value), !v[19] ? null : v[19].map((p) => TypeInitialiser(3, p))),
  160246688: (id, v) => new IFC4.IfcRelAggregates(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), v[5].map((p) => new Handle(p.value))),
  2781568857: (id, v) => new IFC4.IfcRoofType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1768891740: (id, v) => new IFC4.IfcSanitaryTerminalType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2157484638: (id, v) => new IFC4.IfcSeamCurve(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), v[2]),
  4074543187: (id, v) => new IFC4.IfcShadingDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  4097777520: (id, v) => new IFC4.IfcSite(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC4.IfcCompoundPlaneAngleMeasure(v[9].value), !v[10] ? null : new IFC4.IfcCompoundPlaneAngleMeasure(v[10].value), !v[11] ? null : new IFC4.IfcLengthMeasure(v[11].value), !v[12] ? null : new IFC4.IfcLabel(v[12].value), !v[13] ? null : new Handle(v[13].value)),
  2533589738: (id, v) => new IFC4.IfcSlabType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1072016465: (id, v) => new IFC4.IfcSolarDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3856911033: (id, v) => new IFC4.IfcSpace(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8], v[9], !v[10] ? null : new IFC4.IfcLengthMeasure(v[10].value)),
  1305183839: (id, v) => new IFC4.IfcSpaceHeaterType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3812236995: (id, v) => new IFC4.IfcSpaceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4.IfcLabel(v[10].value)),
  3112655638: (id, v) => new IFC4.IfcStackTerminalType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1039846685: (id, v) => new IFC4.IfcStairFlightType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  338393293: (id, v) => new IFC4.IfcStairType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  682877961: (id, v) => new IFC4.IfcStructuralAction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4.IfcBoolean(v[9].value)),
  1179482911: (id, v) => new IFC4.IfcStructuralConnection(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  1004757350: (id, v) => new IFC4.IfcStructuralCurveAction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4.IfcBoolean(v[9].value), v[10], v[11]),
  4243806635: (id, v) => new IFC4.IfcStructuralCurveConnection(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), new Handle(v[8].value)),
  214636428: (id, v) => new IFC4.IfcStructuralCurveMember(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], new Handle(v[8].value)),
  2445595289: (id, v) => new IFC4.IfcStructuralCurveMemberVarying(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], new Handle(v[8].value)),
  2757150158: (id, v) => new IFC4.IfcStructuralCurveReaction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9]),
  1807405624: (id, v) => new IFC4.IfcStructuralLinearAction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4.IfcBoolean(v[9].value), v[10], v[11]),
  1252848954: (id, v) => new IFC4.IfcStructuralLoadGroup(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5], v[6], v[7], !v[8] ? null : new IFC4.IfcRatioMeasure(v[8].value), !v[9] ? null : new IFC4.IfcLabel(v[9].value)),
  2082059205: (id, v) => new IFC4.IfcStructuralPointAction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4.IfcBoolean(v[9].value)),
  734778138: (id, v) => new IFC4.IfcStructuralPointConnection(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value)),
  1235345126: (id, v) => new IFC4.IfcStructuralPointReaction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]),
  2986769608: (id, v) => new IFC4.IfcStructuralResultGroup(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5], !v[6] ? null : new Handle(v[6].value), new IFC4.IfcBoolean(v[7].value)),
  3657597509: (id, v) => new IFC4.IfcStructuralSurfaceAction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4.IfcBoolean(v[9].value), v[10], v[11]),
  1975003073: (id, v) => new IFC4.IfcStructuralSurfaceConnection(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value)),
  148013059: (id, v) => new IFC4.IfcSubContractResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map((p) => new Handle(p.value)), !v[9] ? null : new Handle(v[9].value), v[10]),
  3101698114: (id, v) => new IFC4.IfcSurfaceFeature(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  2315554128: (id, v) => new IFC4.IfcSwitchingDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2254336722: (id, v) => new IFC4.IfcSystem(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value)),
  413509423: (id, v) => new IFC4.IfcSystemFurnitureElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  5716631: (id, v) => new IFC4.IfcTankType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3824725483: (id, v) => new IFC4.IfcTendon(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcAreaMeasure(v[11].value), !v[12] ? null : new IFC4.IfcForceMeasure(v[12].value), !v[13] ? null : new IFC4.IfcPressureMeasure(v[13].value), !v[14] ? null : new IFC4.IfcNormalisedRatioMeasure(v[14].value), !v[15] ? null : new IFC4.IfcPositiveLengthMeasure(v[15].value), !v[16] ? null : new IFC4.IfcPositiveLengthMeasure(v[16].value)),
  2347447852: (id, v) => new IFC4.IfcTendonAnchor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3081323446: (id, v) => new IFC4.IfcTendonAnchorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2415094496: (id, v) => new IFC4.IfcTendonType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcAreaMeasure(v[11].value), !v[12] ? null : new IFC4.IfcPositiveLengthMeasure(v[12].value)),
  1692211062: (id, v) => new IFC4.IfcTransformerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1620046519: (id, v) => new IFC4.IfcTransportElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3593883385: (id, v) => new IFC4.IfcTrimmedCurve(id, new Handle(v[0].value), v[1].map((p) => new Handle(p.value)), v[2].map((p) => new Handle(p.value)), new IFC4.IfcBoolean(v[3].value), v[4]),
  1600972822: (id, v) => new IFC4.IfcTubeBundleType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1911125066: (id, v) => new IFC4.IfcUnitaryEquipmentType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  728799441: (id, v) => new IFC4.IfcValveType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2391383451: (id, v) => new IFC4.IfcVibrationIsolator(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3313531582: (id, v) => new IFC4.IfcVibrationIsolatorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2769231204: (id, v) => new IFC4.IfcVirtualElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  926996030: (id, v) => new IFC4.IfcVoidingFeature(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1898987631: (id, v) => new IFC4.IfcWallType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1133259667: (id, v) => new IFC4.IfcWasteTerminalType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  4009809668: (id, v) => new IFC4.IfcWindowType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], v[10], !v[11] ? null : new IFC4.IfcBoolean(v[11].value), !v[12] ? null : new IFC4.IfcLabel(v[12].value)),
  4088093105: (id, v) => new IFC4.IfcWorkCalendar(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : v[7].map((p) => new Handle(p.value)), v[8]),
  1028945134: (id, v) => new IFC4.IfcWorkControl(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), new IFC4.IfcDateTime(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : new IFC4.IfcDuration(v[9].value), !v[10] ? null : new IFC4.IfcDuration(v[10].value), new IFC4.IfcDateTime(v[11].value), !v[12] ? null : new IFC4.IfcDateTime(v[12].value)),
  4218914973: (id, v) => new IFC4.IfcWorkPlan(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), new IFC4.IfcDateTime(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : new IFC4.IfcDuration(v[9].value), !v[10] ? null : new IFC4.IfcDuration(v[10].value), new IFC4.IfcDateTime(v[11].value), !v[12] ? null : new IFC4.IfcDateTime(v[12].value), v[13]),
  3342526732: (id, v) => new IFC4.IfcWorkSchedule(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), new IFC4.IfcDateTime(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : new IFC4.IfcDuration(v[9].value), !v[10] ? null : new IFC4.IfcDuration(v[10].value), new IFC4.IfcDateTime(v[11].value), !v[12] ? null : new IFC4.IfcDateTime(v[12].value), v[13]),
  1033361043: (id, v) => new IFC4.IfcZone(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value)),
  3821786052: (id, v) => new IFC4.IfcActionRequest(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcText(v[8].value)),
  1411407467: (id, v) => new IFC4.IfcAirTerminalBoxType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3352864051: (id, v) => new IFC4.IfcAirTerminalType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1871374353: (id, v) => new IFC4.IfcAirToAirHeatRecoveryType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3460190687: (id, v) => new IFC4.IfcAsset(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value), !v[11] ? null : new Handle(v[11].value), !v[12] ? null : new IFC4.IfcDate(v[12].value), !v[13] ? null : new Handle(v[13].value)),
  1532957894: (id, v) => new IFC4.IfcAudioVisualApplianceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1967976161: (id, v) => new IFC4.IfcBSplineCurve(id, new IFC4.IfcInteger(v[0].value), v[1].map((p) => new Handle(p.value)), v[2], new IFC4.IfcLogical(v[3].value), new IFC4.IfcLogical(v[4].value)),
  2461110595: (id, v) => new IFC4.IfcBSplineCurveWithKnots(id, new IFC4.IfcInteger(v[0].value), v[1].map((p) => new Handle(p.value)), v[2], new IFC4.IfcLogical(v[3].value), new IFC4.IfcLogical(v[4].value), v[5].map((p) => new IFC4.IfcInteger(p.value)), v[6].map((p) => new IFC4.IfcParameterValue(p.value)), v[7]),
  819618141: (id, v) => new IFC4.IfcBeamType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  231477066: (id, v) => new IFC4.IfcBoilerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1136057603: (id, v) => new IFC4.IfcBoundaryCurve(id, v[0].map((p) => new Handle(p.value)), new IFC4.IfcLogical(v[1].value)),
  3299480353: (id, v) => new IFC4.IfcBuildingElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  2979338954: (id, v) => new IFC4.IfcBuildingElementPart(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  39481116: (id, v) => new IFC4.IfcBuildingElementPartType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1095909175: (id, v) => new IFC4.IfcBuildingElementProxy(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1909888760: (id, v) => new IFC4.IfcBuildingElementProxyType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1177604601: (id, v) => new IFC4.IfcBuildingSystem(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5], !v[6] ? null : new IFC4.IfcLabel(v[6].value)),
  2188180465: (id, v) => new IFC4.IfcBurnerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  395041908: (id, v) => new IFC4.IfcCableCarrierFittingType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3293546465: (id, v) => new IFC4.IfcCableCarrierSegmentType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2674252688: (id, v) => new IFC4.IfcCableFittingType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1285652485: (id, v) => new IFC4.IfcCableSegmentType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2951183804: (id, v) => new IFC4.IfcChillerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3296154744: (id, v) => new IFC4.IfcChimney(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  2611217952: (id, v) => new IFC4.IfcCircle(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value)),
  1677625105: (id, v) => new IFC4.IfcCivilElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  2301859152: (id, v) => new IFC4.IfcCoilType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  843113511: (id, v) => new IFC4.IfcColumn(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  905975707: (id, v) => new IFC4.IfcColumnStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  400855858: (id, v) => new IFC4.IfcCommunicationsApplianceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3850581409: (id, v) => new IFC4.IfcCompressorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2816379211: (id, v) => new IFC4.IfcCondenserType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3898045240: (id, v) => new IFC4.IfcConstructionEquipmentResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map((p) => new Handle(p.value)), !v[9] ? null : new Handle(v[9].value), v[10]),
  1060000209: (id, v) => new IFC4.IfcConstructionMaterialResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map((p) => new Handle(p.value)), !v[9] ? null : new Handle(v[9].value), v[10]),
  488727124: (id, v) => new IFC4.IfcConstructionProductResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map((p) => new Handle(p.value)), !v[9] ? null : new Handle(v[9].value), v[10]),
  335055490: (id, v) => new IFC4.IfcCooledBeamType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2954562838: (id, v) => new IFC4.IfcCoolingTowerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1973544240: (id, v) => new IFC4.IfcCovering(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3495092785: (id, v) => new IFC4.IfcCurtainWall(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3961806047: (id, v) => new IFC4.IfcDamperType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1335981549: (id, v) => new IFC4.IfcDiscreteAccessory(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  2635815018: (id, v) => new IFC4.IfcDiscreteAccessoryType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1599208980: (id, v) => new IFC4.IfcDistributionChamberElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2063403501: (id, v) => new IFC4.IfcDistributionControlElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value)),
  1945004755: (id, v) => new IFC4.IfcDistributionElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  3040386961: (id, v) => new IFC4.IfcDistributionFlowElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  3041715199: (id, v) => new IFC4.IfcDistributionPort(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8], v[9]),
  3205830791: (id, v) => new IFC4.IfcDistributionSystem(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), v[6]),
  395920057: (id, v) => new IFC4.IfcDoor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcPositiveLengthMeasure(v[9].value), v[10], v[11], !v[12] ? null : new IFC4.IfcLabel(v[12].value)),
  3242481149: (id, v) => new IFC4.IfcDoorStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcPositiveLengthMeasure(v[9].value), v[10], v[11], !v[12] ? null : new IFC4.IfcLabel(v[12].value)),
  869906466: (id, v) => new IFC4.IfcDuctFittingType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3760055223: (id, v) => new IFC4.IfcDuctSegmentType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2030761528: (id, v) => new IFC4.IfcDuctSilencerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  663422040: (id, v) => new IFC4.IfcElectricApplianceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2417008758: (id, v) => new IFC4.IfcElectricDistributionBoardType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  3277789161: (id, v) => new IFC4.IfcElectricFlowStorageDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1534661035: (id, v) => new IFC4.IfcElectricGeneratorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1217240411: (id, v) => new IFC4.IfcElectricMotorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  712377611: (id, v) => new IFC4.IfcElectricTimeControlType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1658829314: (id, v) => new IFC4.IfcEnergyConversionDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  2814081492: (id, v) => new IFC4.IfcEngine(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3747195512: (id, v) => new IFC4.IfcEvaporativeCooler(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  484807127: (id, v) => new IFC4.IfcEvaporator(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1209101575: (id, v) => new IFC4.IfcExternalSpatialElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8]),
  346874300: (id, v) => new IFC4.IfcFanType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1810631287: (id, v) => new IFC4.IfcFilterType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  4222183408: (id, v) => new IFC4.IfcFireSuppressionTerminalType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2058353004: (id, v) => new IFC4.IfcFlowController(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  4278956645: (id, v) => new IFC4.IfcFlowFitting(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  4037862832: (id, v) => new IFC4.IfcFlowInstrumentType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  2188021234: (id, v) => new IFC4.IfcFlowMeter(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3132237377: (id, v) => new IFC4.IfcFlowMovingDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  987401354: (id, v) => new IFC4.IfcFlowSegment(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  707683696: (id, v) => new IFC4.IfcFlowStorageDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  2223149337: (id, v) => new IFC4.IfcFlowTerminal(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  3508470533: (id, v) => new IFC4.IfcFlowTreatmentDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  900683007: (id, v) => new IFC4.IfcFooting(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3319311131: (id, v) => new IFC4.IfcHeatExchanger(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  2068733104: (id, v) => new IFC4.IfcHumidifier(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  4175244083: (id, v) => new IFC4.IfcInterceptor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  2176052936: (id, v) => new IFC4.IfcJunctionBox(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  76236018: (id, v) => new IFC4.IfcLamp(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  629592764: (id, v) => new IFC4.IfcLightFixture(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1437502449: (id, v) => new IFC4.IfcMedicalDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1073191201: (id, v) => new IFC4.IfcMember(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1911478936: (id, v) => new IFC4.IfcMemberStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  2474470126: (id, v) => new IFC4.IfcMotorConnection(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  144952367: (id, v) => new IFC4.IfcOuterBoundaryCurve(id, v[0].map((p) => new Handle(p.value)), new IFC4.IfcLogical(v[1].value)),
  3694346114: (id, v) => new IFC4.IfcOutlet(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1687234759: (id, v) => new IFC4.IfcPile(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8], v[9]),
  310824031: (id, v) => new IFC4.IfcPipeFitting(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3612865200: (id, v) => new IFC4.IfcPipeSegment(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3171933400: (id, v) => new IFC4.IfcPlate(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1156407060: (id, v) => new IFC4.IfcPlateStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  738039164: (id, v) => new IFC4.IfcProtectiveDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  655969474: (id, v) => new IFC4.IfcProtectiveDeviceTrippingUnitType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  90941305: (id, v) => new IFC4.IfcPump(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  2262370178: (id, v) => new IFC4.IfcRailing(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3024970846: (id, v) => new IFC4.IfcRamp(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3283111854: (id, v) => new IFC4.IfcRampFlight(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1232101972: (id, v) => new IFC4.IfcRationalBSplineCurveWithKnots(id, new IFC4.IfcInteger(v[0].value), v[1].map((p) => new Handle(p.value)), v[2], new IFC4.IfcLogical(v[3].value), new IFC4.IfcLogical(v[4].value), v[5].map((p) => new IFC4.IfcInteger(p.value)), v[6].map((p) => new IFC4.IfcParameterValue(p.value)), v[7], v[8].map((p) => new IFC4.IfcReal(p.value))),
  979691226: (id, v) => new IFC4.IfcReinforcingBar(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : new IFC4.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC4.IfcAreaMeasure(v[10].value), !v[11] ? null : new IFC4.IfcPositiveLengthMeasure(v[11].value), v[12], v[13]),
  2572171363: (id, v) => new IFC4.IfcReinforcingBarType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcAreaMeasure(v[11].value), !v[12] ? null : new IFC4.IfcPositiveLengthMeasure(v[12].value), v[13], !v[14] ? null : new IFC4.IfcLabel(v[14].value), !v[15] ? null : v[15].map((p) => TypeInitialiser(3, p))),
  2016517767: (id, v) => new IFC4.IfcRoof(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3053780830: (id, v) => new IFC4.IfcSanitaryTerminal(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1783015770: (id, v) => new IFC4.IfcSensorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1329646415: (id, v) => new IFC4.IfcShadingDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1529196076: (id, v) => new IFC4.IfcSlab(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3127900445: (id, v) => new IFC4.IfcSlabElementedCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3027962421: (id, v) => new IFC4.IfcSlabStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3420628829: (id, v) => new IFC4.IfcSolarDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1999602285: (id, v) => new IFC4.IfcSpaceHeater(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1404847402: (id, v) => new IFC4.IfcStackTerminal(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  331165859: (id, v) => new IFC4.IfcStair(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  4252922144: (id, v) => new IFC4.IfcStairFlight(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcInteger(v[8].value), !v[9] ? null : new IFC4.IfcInteger(v[9].value), !v[10] ? null : new IFC4.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcPositiveLengthMeasure(v[11].value), v[12]),
  2515109513: (id, v) => new IFC4.IfcStructuralAnalysisModel(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5], !v[6] ? null : new Handle(v[6].value), !v[7] ? null : v[7].map((p) => new Handle(p.value)), !v[8] ? null : v[8].map((p) => new Handle(p.value)), !v[9] ? null : new Handle(v[9].value)),
  385403989: (id, v) => new IFC4.IfcStructuralLoadCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5], v[6], v[7], !v[8] ? null : new IFC4.IfcRatioMeasure(v[8].value), !v[9] ? null : new IFC4.IfcLabel(v[9].value), !v[10] ? null : v[10].map((p) => new IFC4.IfcRatioMeasure(p.value))),
  1621171031: (id, v) => new IFC4.IfcStructuralPlanarAction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4.IfcBoolean(v[9].value), v[10], v[11]),
  1162798199: (id, v) => new IFC4.IfcSwitchingDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  812556717: (id, v) => new IFC4.IfcTank(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3825984169: (id, v) => new IFC4.IfcTransformer(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3026737570: (id, v) => new IFC4.IfcTubeBundle(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3179687236: (id, v) => new IFC4.IfcUnitaryControlElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  4292641817: (id, v) => new IFC4.IfcUnitaryEquipment(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  4207607924: (id, v) => new IFC4.IfcValve(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  2391406946: (id, v) => new IFC4.IfcWall(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  4156078855: (id, v) => new IFC4.IfcWallElementedCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3512223829: (id, v) => new IFC4.IfcWallStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  4237592921: (id, v) => new IFC4.IfcWasteTerminal(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3304561284: (id, v) => new IFC4.IfcWindow(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcPositiveLengthMeasure(v[9].value), v[10], v[11], !v[12] ? null : new IFC4.IfcLabel(v[12].value)),
  486154966: (id, v) => new IFC4.IfcWindowStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcPositiveLengthMeasure(v[9].value), v[10], v[11], !v[12] ? null : new IFC4.IfcLabel(v[12].value)),
  2874132201: (id, v) => new IFC4.IfcActuatorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  1634111441: (id, v) => new IFC4.IfcAirTerminal(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  177149247: (id, v) => new IFC4.IfcAirTerminalBox(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  2056796094: (id, v) => new IFC4.IfcAirToAirHeatRecovery(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3001207471: (id, v) => new IFC4.IfcAlarmType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  277319702: (id, v) => new IFC4.IfcAudioVisualAppliance(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  753842376: (id, v) => new IFC4.IfcBeam(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  2906023776: (id, v) => new IFC4.IfcBeamStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  32344328: (id, v) => new IFC4.IfcBoiler(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  2938176219: (id, v) => new IFC4.IfcBurner(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  635142910: (id, v) => new IFC4.IfcCableCarrierFitting(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3758799889: (id, v) => new IFC4.IfcCableCarrierSegment(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1051757585: (id, v) => new IFC4.IfcCableFitting(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  4217484030: (id, v) => new IFC4.IfcCableSegment(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3902619387: (id, v) => new IFC4.IfcChiller(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  639361253: (id, v) => new IFC4.IfcCoil(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3221913625: (id, v) => new IFC4.IfcCommunicationsAppliance(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3571504051: (id, v) => new IFC4.IfcCompressor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  2272882330: (id, v) => new IFC4.IfcCondenser(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  578613899: (id, v) => new IFC4.IfcControllerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map((p) => new Handle(p.value)), !v[6] ? null : v[6].map((p) => new Handle(p.value)), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]),
  4136498852: (id, v) => new IFC4.IfcCooledBeam(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3640358203: (id, v) => new IFC4.IfcCoolingTower(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  4074379575: (id, v) => new IFC4.IfcDamper(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1052013943: (id, v) => new IFC4.IfcDistributionChamberElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  562808652: (id, v) => new IFC4.IfcDistributionCircuit(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), v[6]),
  1062813311: (id, v) => new IFC4.IfcDistributionControlElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value)),
  342316401: (id, v) => new IFC4.IfcDuctFitting(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3518393246: (id, v) => new IFC4.IfcDuctSegment(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1360408905: (id, v) => new IFC4.IfcDuctSilencer(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1904799276: (id, v) => new IFC4.IfcElectricAppliance(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  862014818: (id, v) => new IFC4.IfcElectricDistributionBoard(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3310460725: (id, v) => new IFC4.IfcElectricFlowStorageDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  264262732: (id, v) => new IFC4.IfcElectricGenerator(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  402227799: (id, v) => new IFC4.IfcElectricMotor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1003880860: (id, v) => new IFC4.IfcElectricTimeControl(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3415622556: (id, v) => new IFC4.IfcFan(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  819412036: (id, v) => new IFC4.IfcFilter(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  1426591983: (id, v) => new IFC4.IfcFireSuppressionTerminal(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  182646315: (id, v) => new IFC4.IfcFlowInstrument(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  2295281155: (id, v) => new IFC4.IfcProtectiveDeviceTrippingUnit(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  4086658281: (id, v) => new IFC4.IfcSensor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  630975310: (id, v) => new IFC4.IfcUnitaryControlElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  4288193352: (id, v) => new IFC4.IfcActuator(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  3087945054: (id, v) => new IFC4.IfcAlarm(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]),
  25142252: (id, v) => new IFC4.IfcController(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8])
};
InheritanceDef[3] = {
  618182010: [IFCTELECOMADDRESS, IFCPOSTALADDRESS],
  411424972: [IFCCOSTVALUE],
  4037036970: [IFCBOUNDARYNODECONDITIONWARPING, IFCBOUNDARYNODECONDITION, IFCBOUNDARYFACECONDITION, IFCBOUNDARYEDGECONDITION],
  1387855156: [IFCBOUNDARYNODECONDITIONWARPING],
  2859738748: [IFCCONNECTIONCURVEGEOMETRY, IFCCONNECTIONVOLUMEGEOMETRY, IFCCONNECTIONSURFACEGEOMETRY, IFCCONNECTIONPOINTECCENTRICITY, IFCCONNECTIONPOINTGEOMETRY],
  2614616156: [IFCCONNECTIONPOINTECCENTRICITY],
  1959218052: [IFCOBJECTIVE, IFCMETRIC],
  1785450214: [IFCMAPCONVERSION],
  1466758467: [IFCPROJECTEDCRS],
  4294318154: [IFCDOCUMENTINFORMATION, IFCCLASSIFICATION, IFCLIBRARYINFORMATION],
  3200245327: [IFCDOCUMENTREFERENCE, IFCCLASSIFICATIONREFERENCE, IFCLIBRARYREFERENCE, IFCEXTERNALLYDEFINEDTEXTFONT, IFCEXTERNALLYDEFINEDSURFACESTYLE, IFCEXTERNALLYDEFINEDHATCHSTYLE],
  760658860: [IFCMATERIALCONSTITUENTSET, IFCMATERIALCONSTITUENT, IFCMATERIAL, IFCMATERIALPROFILESET, IFCMATERIALPROFILEWITHOFFSETS, IFCMATERIALPROFILE, IFCMATERIALLAYERSET, IFCMATERIALLAYERWITHOFFSETS, IFCMATERIALLAYER],
  248100487: [IFCMATERIALLAYERWITHOFFSETS],
  2235152071: [IFCMATERIALPROFILEWITHOFFSETS],
  1507914824: [IFCMATERIALPROFILESETUSAGETAPERING, IFCMATERIALPROFILESETUSAGE, IFCMATERIALLAYERSETUSAGE],
  1918398963: [IFCCONVERSIONBASEDUNITWITHOFFSET, IFCCONVERSIONBASEDUNIT, IFCCONTEXTDEPENDENTUNIT, IFCSIUNIT],
  3701648758: [IFCLOCALPLACEMENT, IFCGRIDPLACEMENT],
  2483315170: [IFCPHYSICALCOMPLEXQUANTITY, IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA, IFCPHYSICALSIMPLEQUANTITY],
  2226359599: [IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA],
  677532197: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT, IFCPREDEFINEDITEM, IFCINDEXEDCOLOURMAP, IFCCURVESTYLEFONTPATTERN, IFCCURVESTYLEFONTANDSCALING, IFCCURVESTYLEFONT, IFCCOLOURRGB, IFCCOLOURSPECIFICATION, IFCCOLOURRGBLIST, IFCTEXTUREVERTEXLIST, IFCTEXTUREVERTEX, IFCINDEXEDTRIANGLETEXTUREMAP, IFCINDEXEDTEXTUREMAP, IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR, IFCTEXTURECOORDINATE, IFCTEXTSTYLETEXTMODEL, IFCTEXTSTYLEFORDEFINEDFONT, IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE, IFCSURFACETEXTURE, IFCSURFACESTYLEWITHTEXTURES, IFCSURFACESTYLERENDERING, IFCSURFACESTYLESHADING, IFCSURFACESTYLEREFRACTION, IFCSURFACESTYLELIGHTING],
  2022622350: [IFCPRESENTATIONLAYERWITHSTYLE],
  3119450353: [IFCFILLAREASTYLE, IFCCURVESTYLE, IFCTEXTSTYLE, IFCSURFACESTYLE],
  2095639259: [IFCPRODUCTDEFINITIONSHAPE, IFCMATERIALDEFINITIONREPRESENTATION],
  3958567839: [IFCLSHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF, IFCPARAMETERIZEDPROFILEDEF, IFCMIRROREDPROFILEDEF, IFCDERIVEDPROFILEDEF, IFCCOMPOSITEPROFILEDEF, IFCCENTERLINEPROFILEDEF, IFCARBITRARYOPENPROFILEDEF, IFCARBITRARYPROFILEDEFWITHVOIDS, IFCARBITRARYCLOSEDPROFILEDEF],
  986844984: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY, IFCPROPERTY, IFCSECTIONREINFORCEMENTPROPERTIES, IFCSECTIONPROPERTIES, IFCREINFORCEMENTBARPROPERTIES, IFCPREDEFINEDPROPERTIES, IFCPROFILEPROPERTIES, IFCMATERIALPROPERTIES, IFCEXTENDEDPROPERTIES, IFCPROPERTYENUMERATION],
  1076942058: [IFCSTYLEDREPRESENTATION, IFCSTYLEMODEL, IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION, IFCSHAPEMODEL],
  3377609919: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT, IFCGEOMETRICREPRESENTATIONCONTEXT],
  3008791417: [IFCMAPPEDITEM, IFCFILLAREASTYLETILES, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIRECTION, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCPCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D, IFCCARTESIANPOINTLIST, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPOLYGONALFACESET, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE, IFCTESSELLATEDITEM, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET, IFCGEOMETRICREPRESENTATIONITEM, IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCADVANCEDFACE, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX, IFCTOPOLOGICALREPRESENTATIONITEM, IFCSTYLEDITEM],
  2439245199: [IFCRESOURCECONSTRAINTRELATIONSHIP, IFCRESOURCEAPPROVALRELATIONSHIP, IFCPROPERTYDEPENDENCYRELATIONSHIP, IFCORGANIZATIONRELATIONSHIP, IFCMATERIALRELATIONSHIP, IFCEXTERNALREFERENCERELATIONSHIP, IFCDOCUMENTINFORMATIONRELATIONSHIP, IFCCURRENCYRELATIONSHIP, IFCAPPROVALRELATIONSHIP],
  2341007311: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELDECLARES, IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS, IFCRELATIONSHIP, IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE, IFCPROPERTYTEMPLATEDEFINITION, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET, IFCPROPERTYSETDEFINITION, IFCPROPERTYDEFINITION, IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS, IFCOBJECT, IFCPROJECTLIBRARY, IFCPROJECT, IFCCONTEXT, IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS, IFCTYPEOBJECT, IFCOBJECTDEFINITION],
  1054537805: [IFCRESOURCETIME, IFCLAGTIME, IFCEVENTTIME, IFCWORKTIME, IFCTASKTIMERECURRING, IFCTASKTIME],
  3982875396: [IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION],
  2273995522: [IFCSLIPPAGECONNECTIONCONDITION, IFCFAILURECONNECTIONCONDITION],
  2162789131: [IFCSURFACEREINFORCEMENTAREA, IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC, IFCSTRUCTURALLOADORRESULT, IFCSTRUCTURALLOADCONFIGURATION],
  609421318: [IFCSURFACEREINFORCEMENTAREA, IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC],
  2525727697: [IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE],
  2830218821: [IFCSTYLEDREPRESENTATION],
  846575682: [IFCSURFACESTYLERENDERING],
  626085974: [IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE],
  1549132990: [IFCTASKTIMERECURRING],
  280115917: [IFCINDEXEDTRIANGLETEXTUREMAP, IFCINDEXEDTEXTUREMAP, IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR],
  3101149627: [IFCREGULARTIMESERIES, IFCIRREGULARTIMESERIES],
  1377556343: [IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCADVANCEDFACE, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX],
  2799835756: [IFCVERTEXPOINT],
  3798115385: [IFCARBITRARYPROFILEDEFWITHVOIDS],
  1310608509: [IFCCENTERLINEPROFILEDEF],
  3264961684: [IFCCOLOURRGB],
  370225590: [IFCCLOSEDSHELL, IFCOPENSHELL],
  2889183280: [IFCCONVERSIONBASEDUNITWITHOFFSET],
  3632507154: [IFCMIRROREDPROFILEDEF],
  3900360178: [IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE],
  297599258: [IFCPROFILEPROPERTIES, IFCMATERIALPROPERTIES],
  2556980723: [IFCADVANCEDFACE, IFCFACESURFACE],
  1809719519: [IFCFACEOUTERBOUND],
  3008276851: [IFCADVANCEDFACE],
  3448662350: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT],
  2453401579: [IFCFILLAREASTYLETILES, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIRECTION, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCPCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D, IFCCARTESIANPOINTLIST, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPOLYGONALFACESET, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE, IFCTESSELLATEDITEM, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET],
  3590301190: [IFCGEOMETRICCURVESET],
  812098782: [IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE],
  1437953363: [IFCINDEXEDTRIANGLETEXTUREMAP],
  1402838566: [IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT],
  1520743889: [IFCLIGHTSOURCESPOT],
  1008929658: [IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP],
  3079605661: [IFCMATERIALPROFILESETUSAGETAPERING],
  219451334: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS, IFCOBJECT, IFCPROJECTLIBRARY, IFCPROJECT, IFCCONTEXT, IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS, IFCTYPEOBJECT],
  2529465313: [IFCLSHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF],
  2004835150: [IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT],
  1663979128: [IFCPLANARBOX],
  2067069095: [IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE],
  3727388367: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT],
  3778827333: [IFCSECTIONREINFORCEMENTPROPERTIES, IFCSECTIONPROPERTIES, IFCREINFORCEMENTBARPROPERTIES],
  1775413392: [IFCTEXTSTYLEFONTMODEL],
  2598011224: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY],
  1680319473: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE, IFCPROPERTYTEMPLATEDEFINITION, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET, IFCPROPERTYSETDEFINITION],
  3357820518: [IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET],
  1482703590: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE],
  2090586900: [IFCELEMENTQUANTITY],
  3615266464: [IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF],
  478536968: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELDECLARES, IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS],
  3692461612: [IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE],
  723233188: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID],
  2473145415: [IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION],
  1597423693: [IFCSTRUCTURALLOADSINGLEFORCEWARPING],
  2513912981: [IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE],
  2247615214: [IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID],
  1260650574: [IFCSWEPTDISKSOLIDPOLYGONAL],
  230924584: [IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION],
  901063453: [IFCPOLYGONALFACESET, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE],
  4282788508: [IFCTEXTLITERALWITHEXTENT],
  1628702193: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS],
  3736923433: [IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE],
  2347495698: [IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE],
  3698973494: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE],
  2736907675: [IFCBOOLEANCLIPPINGRESULT],
  4182860854: [IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE],
  574549367: [IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D],
  59481748: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D],
  3749851601: [IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM],
  3331915920: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM],
  1383045692: [IFCCIRCLEHOLLOWPROFILEDEF],
  2485617015: [IFCREPARAMETRISEDCOMPOSITECURVESEGMENT],
  2574617495: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE],
  3419103109: [IFCPROJECTLIBRARY, IFCPROJECT],
  2506170314: [IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID],
  2601014836: [IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCPCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE],
  339256511: [IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE],
  2777663545: [IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE],
  477187591: [IFCEXTRUDEDAREASOLIDTAPERED],
  4238390223: [IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE],
  178912537: [IFCINDEXEDPOLYGONALFACEWITHVOIDS],
  1425443689: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP],
  3888040117: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS],
  759155922: [IFCDRAUGHTINGPREDEFINEDCOLOUR],
  2559016684: [IFCDRAUGHTINGPREDEFINEDCURVEFONT],
  3967405729: [IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES],
  2945172077: [IFCPROCEDURE, IFCEVENT, IFCTASK],
  4208778838: [IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPROXY],
  3521284610: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE],
  3939117080: [IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR],
  1307041759: [IFCRELASSIGNSTOGROUPBYFACTOR],
  1865459582: [IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL],
  826625072: [IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS],
  1204542856: [IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS],
  1638771189: [IFCRELCONNECTSWITHECCENTRICITY],
  2551354335: [IFCRELAGGREGATES, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS],
  693640335: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT],
  3451746338: [IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL],
  3523091289: [IFCRELSPACEBOUNDARY2NDLEVEL],
  2914609552: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE],
  1856042241: [IFCREVOLVEDAREASOLIDTAPERED],
  1412071761: [IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT],
  710998568: [IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE],
  2706606064: [IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING],
  3893378262: [IFCSPACETYPE],
  3544373492: [IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION],
  3136571912: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER],
  530289379: [IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER],
  3689010777: [IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION],
  3979015343: [IFCSTRUCTURALSURFACEMEMBERVARYING],
  699246055: [IFCSEAMCURVE, IFCINTERSECTIONCURVE],
  2387106220: [IFCPOLYGONALFACESET, IFCTRIANGULATEDFACESET],
  2296667514: [IFCOCCUPANT],
  1635779807: [IFCADVANCEDBREPWITHVOIDS],
  2887950389: [IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS],
  167062518: [IFCRATIONALBSPLINESURFACEWITHKNOTS],
  1260505505: [IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE],
  1950629157: [IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE],
  3732776249: [IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE],
  15328376: [IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE],
  2510884976: [IFCCIRCLE, IFCELLIPSE],
  2559216714: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE],
  3293443760: [IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM],
  3256556792: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE],
  3849074793: [IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE],
  1758889154: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY],
  1623761950: [IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER],
  2590856083: [IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE],
  2107101300: [IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE],
  2853485674: [IFCEXTERNALSPATIALELEMENT],
  807026263: [IFCFACETEDBREPWITHVOIDS],
  2827207264: [IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION],
  2143335405: [IFCPROJECTIONELEMENT],
  1287392070: [IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT],
  3907093117: [IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE],
  3198132628: [IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE],
  1482959167: [IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE],
  1834744321: [IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE],
  1339347760: [IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE],
  2297155007: [IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE],
  3009222698: [IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE],
  263784265: [IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE],
  2706460486: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY],
  3588315303: [IFCOPENINGSTANDARDCASE],
  3740093272: [IFCDISTRIBUTIONPORT],
  3027567501: [IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH],
  964333572: [IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE],
  682877961: [IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION],
  1179482911: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION],
  1004757350: [IFCSTRUCTURALLINEARACTION],
  214636428: [IFCSTRUCTURALCURVEMEMBERVARYING],
  1252848954: [IFCSTRUCTURALLOADCASE],
  3657597509: [IFCSTRUCTURALPLANARACTION],
  2254336722: [IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE],
  1028945134: [IFCWORKSCHEDULE, IFCWORKPLAN],
  1967976161: [IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS],
  2461110595: [IFCRATIONALBSPLINECURVEWITHKNOTS],
  1136057603: [IFCOUTERBOUNDARYCURVE],
  3299480353: [IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY],
  843113511: [IFCCOLUMNSTANDARDCASE],
  2063403501: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE],
  1945004755: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT],
  3040386961: [IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE],
  3205830791: [IFCDISTRIBUTIONCIRCUIT],
  395920057: [IFCDOORSTANDARDCASE],
  1658829314: [IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE],
  2058353004: [IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER],
  4278956645: [IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX],
  3132237377: [IFCFAN, IFCCOMPRESSOR, IFCPUMP],
  987401354: [IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT],
  707683696: [IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK],
  2223149337: [IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP],
  3508470533: [IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR],
  1073191201: [IFCMEMBERSTANDARDCASE],
  3171933400: [IFCPLATESTANDARDCASE],
  1529196076: [IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE],
  2391406946: [IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE],
  3304561284: [IFCWINDOWSTANDARDCASE],
  753842376: [IFCBEAMSTANDARDCASE],
  1062813311: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT]
};
InversePropertyDef[3] = {
  3630933823: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  618182010: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  411424972: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  130549933: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["ApprovedObjects", IFCRELASSOCIATESAPPROVAL, 5, true], ["ApprovedResources", IFCRESOURCEAPPROVALRELATIONSHIP, 3, true], ["IsRelatedWith", IFCAPPROVALRELATIONSHIP, 3, true], ["Relates", IFCAPPROVALRELATIONSHIP, 2, true]],
  1959218052: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  1466758467: [["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  602808272: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3200245327: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  2242383968: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  1040185647: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  3548104201: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  852622518: [["PartOfW", IFCGRID, 9, true], ["PartOfV", IFCGRID, 8, true], ["PartOfU", IFCGRID, 7, true], ["HasIntersections", IFCVIRTUALGRIDINTERSECTION, 0, true]],
  2655187982: [["LibraryInfoForObjects", IFCRELASSOCIATESLIBRARY, 5, true], ["HasLibraryReferences", IFCLIBRARYREFERENCE, 5, true]],
  3452421091: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["LibraryRefForObjects", IFCRELASSOCIATESLIBRARY, 5, true]],
  760658860: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  248100487: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, false]],
  3303938423: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  1847252529: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, false]],
  2235152071: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialProfileSet", IFCMATERIALPROFILESET, 2, false]],
  164193824: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  552965576: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialProfileSet", IFCMATERIALPROFILESET, 2, false]],
  1507914824: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3368373690: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  3701648758: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  2251480897: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  4251960020: [["IsRelatedBy", IFCORGANIZATIONRELATIONSHIP, 3, true], ["Relates", IFCORGANIZATIONRELATIONSHIP, 2, true], ["Engages", IFCPERSONANDORGANIZATION, 1, true]],
  2077209135: [["EngagedIn", IFCPERSONANDORGANIZATION, 0, true]],
  2483315170: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2226359599: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3355820592: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  3958567839: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3843373140: [["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  986844984: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3710013099: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2044713172: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2093928680: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  931644368: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3252649465: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2405470396: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  825690147: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  1076942058: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3377609919: [["RepresentationsInContext", IFCREPRESENTATION, 0, true]],
  3008791417: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1660063152: [["HasShapeAspects", IFCSHAPEASPECT, 4, true], ["MapUsage", IFCMAPPEDITEM, 0, true]],
  3982875396: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  4240577450: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  2830218821: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3958052878: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3049322572: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  626085974: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  912023232: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  3101149627: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1377556343: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1735638870: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  2799835756: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1907098498: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3798115385: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1310608509: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2705031697: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  616511568: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  3150382593: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  747523909: [["ClassificationForObjects", IFCRELASSOCIATESCLASSIFICATION, 5, true], ["HasReferences", IFCCLASSIFICATIONREFERENCE, 3, true]],
  647927063: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["ClassificationRefForObjects", IFCRELASSOCIATESCLASSIFICATION, 5, true], ["HasReferences", IFCCLASSIFICATIONREFERENCE, 3, true]],
  1485152156: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  370225590: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3050246964: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2889183280: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2713554722: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3632507154: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1154170062: [["DocumentInfoForObjects", IFCRELASSOCIATESDOCUMENT, 5, true], ["HasDocumentReferences", IFCDOCUMENTREFERENCE, 4, true], ["IsPointedTo", IFCDOCUMENTINFORMATIONRELATIONSHIP, 3, true], ["IsPointer", IFCDOCUMENTINFORMATIONRELATIONSHIP, 2, true]],
  3732053477: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["DocumentRefForObjects", IFCRELASSOCIATESDOCUMENT, 5, true]],
  3900360178: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  476780140: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  297599258: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2556980723: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  1809719519: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  803316827: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3008276851: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  3448662350: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true], ["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  2453401579: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4142052618: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true], ["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  3590301190: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  178086475: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  812098782: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3905492369: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  3741457305: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1402838566: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  125510826: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2604431987: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4266656042: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1520743889: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3422422726: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2624227202: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  1008929658: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2347385850: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1838606355: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["HasRepresentation", IFCMATERIALDEFINITIONREPRESENTATION, 3, true], ["IsRelatedWith", IFCMATERIALRELATIONSHIP, 3, true], ["RelatesTo", IFCMATERIALRELATIONSHIP, 2, true]],
  3708119e3: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialConstituentSet", IFCMATERIALCONSTITUENTSET, 2, false]],
  2852063980: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  1303795690: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3079605661: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3404854881: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3265635763: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2998442950: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  219451334: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  2665983363: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1029017970: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2529465313: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2519244187: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3021840470: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  597895409: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  2004835150: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1663979128: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2067069095: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4022376103: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1423911732: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2924175390: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2775532180: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3778827333: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  673634403: [["ShapeOfProduct", IFCPRODUCT, 6, true], ["HasShapeAspects", IFCSHAPEASPECT, 4, true]],
  2802850158: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2598011224: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  1680319473: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  3357820518: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  1482703590: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  2090586900: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3615266464: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3413951693: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1580146022: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2778083089: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2042790032: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  4165799628: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1509187699: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4124623270: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3692461612: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  723233188: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2233826070: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2513912981: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2247615214: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260650574: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1096409881: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  230924584: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3071757647: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  901063453: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4282788508: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3124975700: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2715220739: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1628702193: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true]],
  3736923433: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2347495698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3698973494: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  427810014: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1417489154: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2759199220: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1299126871: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2543172580: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3406155212: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  669184980: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3207858831: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  4261334040: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3125803723: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2740243338: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2736907675: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4182860854: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2581212453: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2713105998: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2898889636: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1123145078: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  574549367: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1675464909: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2059837836: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  59481748: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3749851601: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3486308946: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3331915920: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1416205885: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1383045692: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2205249479: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2542286263: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  2485617015: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  2574617495: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3419103109: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  1815067380: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2506170314: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2147822146: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2601014836: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2827736869: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2629017746: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  32440307: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  526551008: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1472233963: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1883228015: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  339256511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2777663545: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2835456948: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  4024345920: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  477187591: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2804161546: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2047409740: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  374418227: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  315944413: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2652556860: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4238390223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1268542332: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4095422895: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  987898635: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1484403080: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  178912537: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["ToFaceSet", IFCPOLYGONALFACESET, 2, true]],
  2294589976: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["ToFaceSet", IFCPOLYGONALFACESET, 2, true]],
  572779678: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  428585644: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1281925730: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1425443689: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3888040117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true]],
  3388369263: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3505215534: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1682466193: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  603570806: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  220341763: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3967405729: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  569719735: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2945172077: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  4208778838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  103090709: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  653396225: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  871118103: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  4166981789: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  2752243245: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  941946838: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  1451395588: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  492091185: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Defines", IFCRELDEFINESBYTEMPLATE, 5, true]],
  3650150729: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  110355661: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  3521284610: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  3219374653: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2770003689: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2798486643: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3454111270: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3765753017: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3523091289: [["InnerBoundaries", IFCRELSPACEBOUNDARY1STLEVEL, 9, true]],
  1521410863: [["InnerBoundaries", IFCRELSPACEBOUNDARY1STLEVEL, 9, true], ["Corresponds", IFCRELSPACEBOUNDARY2NDLEVEL, 10, true]],
  816062949: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  2914609552: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1856042241: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3243963512: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4158566097: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3626867408: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3663146110: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  1412071761: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  710998568: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2706606064: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  3893378262: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  463610769: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  2481509218: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  451544542: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4015995234: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3544373492: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  3136571912: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true]],
  530289379: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  3689010777: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  3979015343: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2218152070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  603775116: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  4095615324: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  699246055: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2028607225: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2809605785: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4124788165: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1580310250: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3473067441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  3206491090: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2387106220: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  1935646853: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2097647324: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2916149573: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  336235671: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  512836454: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  2296667514: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  1635779807: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2603310189: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1674181508: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2887950389: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  167062518: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1334484129: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3649129432: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260505505: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4031249490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  1950629157: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3124254112: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  2197970202: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2937912522: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3893394355: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  300633059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3875453745: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  3732776249: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  15328376: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2510884976: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2185764099: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  4105962743: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1525564444: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2559216714: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3293443760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3895139033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1419761937: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1916426348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3295246426: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1457835157: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1213902940: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3256556792: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3849074793: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2963535650: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  1714330368: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  2323601079: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1758889154: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  4123344466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2397081782: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1623761950: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2590856083: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1704287377: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2107101300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  132023988: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3174744832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3390157468: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4148101412: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2853485674: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  807026263: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3737207727: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  647756555: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2489546625: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2827207264: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2143335405: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1287392070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  3907093117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3198132628: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3815607619: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1482959167: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1834744321: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1339347760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2297155007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3009222698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1893162501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  263784265: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1509553395: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3493046030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3009204131: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2706460486: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true]],
  1251058090: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1806887404: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2571569899: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3946677679: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3113134337: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2391368822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true]],
  4288270099: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3827777499: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1051575348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1161773419: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  377706215: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2108223431: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1114901282: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3181161470: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  977012517: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4143007308: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  3588315303: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false], ["HasFillings", IFCRELFILLSELEMENT, 4, true]],
  3079942009: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false], ["HasFillings", IFCRELFILLSELEMENT, 4, true]],
  2837617999: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2382730787: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3566463478: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3327091369: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1158309216: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  804291784: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4231323485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4017108033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2839578677: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  3724593414: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3740093272: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, true], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  2744685151: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2904328755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3651124850: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1842657554: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2250791053: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2893384427: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2324767716: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1469900589: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  683857671: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3027567501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  964333572: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2320036040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2310774935: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2781568857: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1768891740: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2157484638: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4074543187: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4097777520: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  2533589738: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1072016465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3856911033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["HasCoverings", IFCRELCOVERSSPACES, 4, true], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, true]],
  1305183839: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3812236995: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3112655638: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1039846685: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  338393293: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  682877961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1179482911: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  1004757350: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  4243806635: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  214636428: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2445595289: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2757150158: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1807405624: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1252848954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, true], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, true]],
  2082059205: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  734778138: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  1235345126: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  2986769608: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ResultGroupFor", IFCSTRUCTURALANALYSISMODEL, 8, true]],
  3657597509: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1975003073: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  148013059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3101698114: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2315554128: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2254336722: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  413509423: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  5716631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3824725483: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2347447852: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3081323446: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2415094496: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1692211062: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1620046519: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3593883385: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1600972822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1911125066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  728799441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2391383451: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3313531582: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2769231204: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  926996030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  1898987631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1133259667: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4009809668: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4088093105: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1028945134: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  4218914973: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3342526732: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1033361043: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  3821786052: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1411407467: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3352864051: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1871374353: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3460190687: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true]],
  1532957894: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1967976161: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2461110595: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  819618141: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  231477066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1136057603: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3299480353: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2979338954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  39481116: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1095909175: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1909888760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1177604601: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  2188180465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  395041908: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3293546465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2674252688: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1285652485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2951183804: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3296154744: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2611217952: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1677625105: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2301859152: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  843113511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  905975707: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  400855858: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3850581409: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2816379211: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3898045240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1060000209: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  488727124: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  335055490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2954562838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1973544240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["CoversSpaces", IFCRELCOVERSSPACES, 5, true], ["CoversElements", IFCRELCOVERSBLDGELEMENTS, 5, true]],
  3495092785: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3961806047: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1335981549: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2635815018: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1599208980: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2063403501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1945004755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true]],
  3040386961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3041715199: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, true], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  3205830791: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  395920057: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3242481149: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  869906466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3760055223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2030761528: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  663422040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2417008758: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3277789161: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1534661035: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1217240411: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  712377611: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1658829314: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2814081492: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3747195512: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  484807127: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1209101575: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, true]],
  346874300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1810631287: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4222183408: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2058353004: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4278956645: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4037862832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2188021234: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3132237377: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  987401354: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  707683696: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2223149337: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3508470533: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  900683007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3319311131: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2068733104: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4175244083: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2176052936: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  76236018: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  629592764: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1437502449: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1073191201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1911478936: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2474470126: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  144952367: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3694346114: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1687234759: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  310824031: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3612865200: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3171933400: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1156407060: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  738039164: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  655969474: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  90941305: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2262370178: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3024970846: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3283111854: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1232101972: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  979691226: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2572171363: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2016517767: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3053780830: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1783015770: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1329646415: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1529196076: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3127900445: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3027962421: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3420628829: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1999602285: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1404847402: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  331165859: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  4252922144: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2515109513: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  385403989: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, true], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, true]],
  1621171031: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1162798199: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  812556717: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3825984169: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3026737570: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3179687236: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4292641817: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4207607924: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2391406946: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  4156078855: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3512223829: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  4237592921: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3304561284: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  486154966: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2874132201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1634111441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  177149247: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2056796094: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3001207471: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  277319702: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  753842376: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2906023776: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  32344328: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2938176219: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  635142910: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3758799889: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1051757585: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4217484030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3902619387: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  639361253: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3221913625: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3571504051: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2272882330: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  578613899: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4136498852: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3640358203: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4074379575: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1052013943: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  562808652: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  1062813311: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  342316401: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3518393246: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1360408905: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1904799276: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  862014818: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3310460725: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  264262732: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  402227799: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1003880860: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3415622556: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  819412036: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1426591983: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  182646315: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  2295281155: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  4086658281: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  630975310: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  4288193352: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  3087945054: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  25142252: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]]
};
Constructors[3] = {
  3630933823: (ID, a) => new IFC4.IfcActorRole(ID, a[0], a[1], a[2]),
  618182010: (ID, a) => new IFC4.IfcAddress(ID, a[0], a[1], a[2]),
  639542469: (ID, a) => new IFC4.IfcApplication(ID, a[0], a[1], a[2], a[3]),
  411424972: (ID, a) => new IFC4.IfcAppliedValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  130549933: (ID, a) => new IFC4.IfcApproval(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4037036970: (ID, a) => new IFC4.IfcBoundaryCondition(ID, a[0]),
  1560379544: (ID, a) => new IFC4.IfcBoundaryEdgeCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3367102660: (ID, a) => new IFC4.IfcBoundaryFaceCondition(ID, a[0], a[1], a[2], a[3]),
  1387855156: (ID, a) => new IFC4.IfcBoundaryNodeCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2069777674: (ID, a) => new IFC4.IfcBoundaryNodeConditionWarping(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2859738748: (ID, _) => new IFC4.IfcConnectionGeometry(ID),
  2614616156: (ID, a) => new IFC4.IfcConnectionPointGeometry(ID, a[0], a[1]),
  2732653382: (ID, a) => new IFC4.IfcConnectionSurfaceGeometry(ID, a[0], a[1]),
  775493141: (ID, a) => new IFC4.IfcConnectionVolumeGeometry(ID, a[0], a[1]),
  1959218052: (ID, a) => new IFC4.IfcConstraint(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1785450214: (ID, a) => new IFC4.IfcCoordinateOperation(ID, a[0], a[1]),
  1466758467: (ID, a) => new IFC4.IfcCoordinateReferenceSystem(ID, a[0], a[1], a[2], a[3]),
  602808272: (ID, a) => new IFC4.IfcCostValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1765591967: (ID, a) => new IFC4.IfcDerivedUnit(ID, a[0], a[1], a[2]),
  1045800335: (ID, a) => new IFC4.IfcDerivedUnitElement(ID, a[0], a[1]),
  2949456006: (ID, a) => new IFC4.IfcDimensionalExponents(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  4294318154: (ID, _) => new IFC4.IfcExternalInformation(ID),
  3200245327: (ID, a) => new IFC4.IfcExternalReference(ID, a[0], a[1], a[2]),
  2242383968: (ID, a) => new IFC4.IfcExternallyDefinedHatchStyle(ID, a[0], a[1], a[2]),
  1040185647: (ID, a) => new IFC4.IfcExternallyDefinedSurfaceStyle(ID, a[0], a[1], a[2]),
  3548104201: (ID, a) => new IFC4.IfcExternallyDefinedTextFont(ID, a[0], a[1], a[2]),
  852622518: (ID, a) => new IFC4.IfcGridAxis(ID, a[0], a[1], a[2]),
  3020489413: (ID, a) => new IFC4.IfcIrregularTimeSeriesValue(ID, a[0], a[1]),
  2655187982: (ID, a) => new IFC4.IfcLibraryInformation(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3452421091: (ID, a) => new IFC4.IfcLibraryReference(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  4162380809: (ID, a) => new IFC4.IfcLightDistributionData(ID, a[0], a[1], a[2]),
  1566485204: (ID, a) => new IFC4.IfcLightIntensityDistribution(ID, a[0], a[1]),
  3057273783: (ID, a) => new IFC4.IfcMapConversion(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1847130766: (ID, a) => new IFC4.IfcMaterialClassificationRelationship(ID, a[0], a[1]),
  760658860: (ID, _) => new IFC4.IfcMaterialDefinition(ID),
  248100487: (ID, a) => new IFC4.IfcMaterialLayer(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3303938423: (ID, a) => new IFC4.IfcMaterialLayerSet(ID, a[0], a[1], a[2]),
  1847252529: (ID, a) => new IFC4.IfcMaterialLayerWithOffsets(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2199411900: (ID, a) => new IFC4.IfcMaterialList(ID, a[0]),
  2235152071: (ID, a) => new IFC4.IfcMaterialProfile(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  164193824: (ID, a) => new IFC4.IfcMaterialProfileSet(ID, a[0], a[1], a[2], a[3]),
  552965576: (ID, a) => new IFC4.IfcMaterialProfileWithOffsets(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1507914824: (ID, _) => new IFC4.IfcMaterialUsageDefinition(ID),
  2597039031: (ID, a) => new IFC4.IfcMeasureWithUnit(ID, a[0], a[1]),
  3368373690: (ID, a) => new IFC4.IfcMetric(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2706619895: (ID, a) => new IFC4.IfcMonetaryUnit(ID, a[0]),
  1918398963: (ID, a) => new IFC4.IfcNamedUnit(ID, a[0], a[1]),
  3701648758: (ID, _) => new IFC4.IfcObjectPlacement(ID),
  2251480897: (ID, a) => new IFC4.IfcObjective(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4251960020: (ID, a) => new IFC4.IfcOrganization(ID, a[0], a[1], a[2], a[3], a[4]),
  1207048766: (ID, a) => new IFC4.IfcOwnerHistory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2077209135: (ID, a) => new IFC4.IfcPerson(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  101040310: (ID, a) => new IFC4.IfcPersonAndOrganization(ID, a[0], a[1], a[2]),
  2483315170: (ID, a) => new IFC4.IfcPhysicalQuantity(ID, a[0], a[1]),
  2226359599: (ID, a) => new IFC4.IfcPhysicalSimpleQuantity(ID, a[0], a[1], a[2]),
  3355820592: (ID, a) => new IFC4.IfcPostalAddress(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  677532197: (ID, _) => new IFC4.IfcPresentationItem(ID),
  2022622350: (ID, a) => new IFC4.IfcPresentationLayerAssignment(ID, a[0], a[1], a[2], a[3]),
  1304840413: (ID, a) => new IFC4.IfcPresentationLayerWithStyle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3119450353: (ID, a) => new IFC4.IfcPresentationStyle(ID, a[0]),
  2417041796: (ID, a) => new IFC4.IfcPresentationStyleAssignment(ID, a[0]),
  2095639259: (ID, a) => new IFC4.IfcProductRepresentation(ID, a[0], a[1], a[2]),
  3958567839: (ID, a) => new IFC4.IfcProfileDef(ID, a[0], a[1]),
  3843373140: (ID, a) => new IFC4.IfcProjectedCRS(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  986844984: (ID, _) => new IFC4.IfcPropertyAbstraction(ID),
  3710013099: (ID, a) => new IFC4.IfcPropertyEnumeration(ID, a[0], a[1], a[2]),
  2044713172: (ID, a) => new IFC4.IfcQuantityArea(ID, a[0], a[1], a[2], a[3], a[4]),
  2093928680: (ID, a) => new IFC4.IfcQuantityCount(ID, a[0], a[1], a[2], a[3], a[4]),
  931644368: (ID, a) => new IFC4.IfcQuantityLength(ID, a[0], a[1], a[2], a[3], a[4]),
  3252649465: (ID, a) => new IFC4.IfcQuantityTime(ID, a[0], a[1], a[2], a[3], a[4]),
  2405470396: (ID, a) => new IFC4.IfcQuantityVolume(ID, a[0], a[1], a[2], a[3], a[4]),
  825690147: (ID, a) => new IFC4.IfcQuantityWeight(ID, a[0], a[1], a[2], a[3], a[4]),
  3915482550: (ID, a) => new IFC4.IfcRecurrencePattern(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2433181523: (ID, a) => new IFC4.IfcReference(ID, a[0], a[1], a[2], a[3], a[4]),
  1076942058: (ID, a) => new IFC4.IfcRepresentation(ID, a[0], a[1], a[2], a[3]),
  3377609919: (ID, a) => new IFC4.IfcRepresentationContext(ID, a[0], a[1]),
  3008791417: (ID, _) => new IFC4.IfcRepresentationItem(ID),
  1660063152: (ID, a) => new IFC4.IfcRepresentationMap(ID, a[0], a[1]),
  2439245199: (ID, a) => new IFC4.IfcResourceLevelRelationship(ID, a[0], a[1]),
  2341007311: (ID, a) => new IFC4.IfcRoot(ID, a[0], a[1], a[2], a[3]),
  448429030: (ID, a) => new IFC4.IfcSIUnit(ID, a[0], a[1], a[2]),
  1054537805: (ID, a) => new IFC4.IfcSchedulingTime(ID, a[0], a[1], a[2]),
  867548509: (ID, a) => new IFC4.IfcShapeAspect(ID, a[0], a[1], a[2], a[3], a[4]),
  3982875396: (ID, a) => new IFC4.IfcShapeModel(ID, a[0], a[1], a[2], a[3]),
  4240577450: (ID, a) => new IFC4.IfcShapeRepresentation(ID, a[0], a[1], a[2], a[3]),
  2273995522: (ID, a) => new IFC4.IfcStructuralConnectionCondition(ID, a[0]),
  2162789131: (ID, a) => new IFC4.IfcStructuralLoad(ID, a[0]),
  3478079324: (ID, a) => new IFC4.IfcStructuralLoadConfiguration(ID, a[0], a[1], a[2]),
  609421318: (ID, a) => new IFC4.IfcStructuralLoadOrResult(ID, a[0]),
  2525727697: (ID, a) => new IFC4.IfcStructuralLoadStatic(ID, a[0]),
  3408363356: (ID, a) => new IFC4.IfcStructuralLoadTemperature(ID, a[0], a[1], a[2], a[3]),
  2830218821: (ID, a) => new IFC4.IfcStyleModel(ID, a[0], a[1], a[2], a[3]),
  3958052878: (ID, a) => new IFC4.IfcStyledItem(ID, a[0], a[1], a[2]),
  3049322572: (ID, a) => new IFC4.IfcStyledRepresentation(ID, a[0], a[1], a[2], a[3]),
  2934153892: (ID, a) => new IFC4.IfcSurfaceReinforcementArea(ID, a[0], a[1], a[2], a[3]),
  1300840506: (ID, a) => new IFC4.IfcSurfaceStyle(ID, a[0], a[1], a[2]),
  3303107099: (ID, a) => new IFC4.IfcSurfaceStyleLighting(ID, a[0], a[1], a[2], a[3]),
  1607154358: (ID, a) => new IFC4.IfcSurfaceStyleRefraction(ID, a[0], a[1]),
  846575682: (ID, a) => new IFC4.IfcSurfaceStyleShading(ID, a[0], a[1]),
  1351298697: (ID, a) => new IFC4.IfcSurfaceStyleWithTextures(ID, a[0]),
  626085974: (ID, a) => new IFC4.IfcSurfaceTexture(ID, a[0], a[1], a[2], a[3], a[4]),
  985171141: (ID, a) => new IFC4.IfcTable(ID, a[0], a[1], a[2]),
  2043862942: (ID, a) => new IFC4.IfcTableColumn(ID, a[0], a[1], a[2], a[3], a[4]),
  531007025: (ID, a) => new IFC4.IfcTableRow(ID, a[0], a[1]),
  1549132990: (ID, a) => new IFC4.IfcTaskTime(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19]),
  2771591690: (ID, a) => new IFC4.IfcTaskTimeRecurring(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20]),
  912023232: (ID, a) => new IFC4.IfcTelecomAddress(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1447204868: (ID, a) => new IFC4.IfcTextStyle(ID, a[0], a[1], a[2], a[3], a[4]),
  2636378356: (ID, a) => new IFC4.IfcTextStyleForDefinedFont(ID, a[0], a[1]),
  1640371178: (ID, a) => new IFC4.IfcTextStyleTextModel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  280115917: (ID, a) => new IFC4.IfcTextureCoordinate(ID, a[0]),
  1742049831: (ID, a) => new IFC4.IfcTextureCoordinateGenerator(ID, a[0], a[1], a[2]),
  2552916305: (ID, a) => new IFC4.IfcTextureMap(ID, a[0], a[1], a[2]),
  1210645708: (ID, a) => new IFC4.IfcTextureVertex(ID, a[0]),
  3611470254: (ID, a) => new IFC4.IfcTextureVertexList(ID, a[0]),
  1199560280: (ID, a) => new IFC4.IfcTimePeriod(ID, a[0], a[1]),
  3101149627: (ID, a) => new IFC4.IfcTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  581633288: (ID, a) => new IFC4.IfcTimeSeriesValue(ID, a[0]),
  1377556343: (ID, _) => new IFC4.IfcTopologicalRepresentationItem(ID),
  1735638870: (ID, a) => new IFC4.IfcTopologyRepresentation(ID, a[0], a[1], a[2], a[3]),
  180925521: (ID, a) => new IFC4.IfcUnitAssignment(ID, a[0]),
  2799835756: (ID, _) => new IFC4.IfcVertex(ID),
  1907098498: (ID, a) => new IFC4.IfcVertexPoint(ID, a[0]),
  891718957: (ID, a) => new IFC4.IfcVirtualGridIntersection(ID, a[0], a[1]),
  1236880293: (ID, a) => new IFC4.IfcWorkTime(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3869604511: (ID, a) => new IFC4.IfcApprovalRelationship(ID, a[0], a[1], a[2], a[3]),
  3798115385: (ID, a) => new IFC4.IfcArbitraryClosedProfileDef(ID, a[0], a[1], a[2]),
  1310608509: (ID, a) => new IFC4.IfcArbitraryOpenProfileDef(ID, a[0], a[1], a[2]),
  2705031697: (ID, a) => new IFC4.IfcArbitraryProfileDefWithVoids(ID, a[0], a[1], a[2], a[3]),
  616511568: (ID, a) => new IFC4.IfcBlobTexture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3150382593: (ID, a) => new IFC4.IfcCenterLineProfileDef(ID, a[0], a[1], a[2], a[3]),
  747523909: (ID, a) => new IFC4.IfcClassification(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  647927063: (ID, a) => new IFC4.IfcClassificationReference(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3285139300: (ID, a) => new IFC4.IfcColourRgbList(ID, a[0]),
  3264961684: (ID, a) => new IFC4.IfcColourSpecification(ID, a[0]),
  1485152156: (ID, a) => new IFC4.IfcCompositeProfileDef(ID, a[0], a[1], a[2], a[3]),
  370225590: (ID, a) => new IFC4.IfcConnectedFaceSet(ID, a[0]),
  1981873012: (ID, a) => new IFC4.IfcConnectionCurveGeometry(ID, a[0], a[1]),
  45288368: (ID, a) => new IFC4.IfcConnectionPointEccentricity(ID, a[0], a[1], a[2], a[3], a[4]),
  3050246964: (ID, a) => new IFC4.IfcContextDependentUnit(ID, a[0], a[1], a[2]),
  2889183280: (ID, a) => new IFC4.IfcConversionBasedUnit(ID, a[0], a[1], a[2], a[3]),
  2713554722: (ID, a) => new IFC4.IfcConversionBasedUnitWithOffset(ID, a[0], a[1], a[2], a[3], a[4]),
  539742890: (ID, a) => new IFC4.IfcCurrencyRelationship(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3800577675: (ID, a) => new IFC4.IfcCurveStyle(ID, a[0], a[1], a[2], a[3], a[4]),
  1105321065: (ID, a) => new IFC4.IfcCurveStyleFont(ID, a[0], a[1]),
  2367409068: (ID, a) => new IFC4.IfcCurveStyleFontAndScaling(ID, a[0], a[1], a[2]),
  3510044353: (ID, a) => new IFC4.IfcCurveStyleFontPattern(ID, a[0], a[1]),
  3632507154: (ID, a) => new IFC4.IfcDerivedProfileDef(ID, a[0], a[1], a[2], a[3], a[4]),
  1154170062: (ID, a) => new IFC4.IfcDocumentInformation(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  770865208: (ID, a) => new IFC4.IfcDocumentInformationRelationship(ID, a[0], a[1], a[2], a[3], a[4]),
  3732053477: (ID, a) => new IFC4.IfcDocumentReference(ID, a[0], a[1], a[2], a[3], a[4]),
  3900360178: (ID, a) => new IFC4.IfcEdge(ID, a[0], a[1]),
  476780140: (ID, a) => new IFC4.IfcEdgeCurve(ID, a[0], a[1], a[2], a[3]),
  211053100: (ID, a) => new IFC4.IfcEventTime(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  297599258: (ID, a) => new IFC4.IfcExtendedProperties(ID, a[0], a[1], a[2]),
  1437805879: (ID, a) => new IFC4.IfcExternalReferenceRelationship(ID, a[0], a[1], a[2], a[3]),
  2556980723: (ID, a) => new IFC4.IfcFace(ID, a[0]),
  1809719519: (ID, a) => new IFC4.IfcFaceBound(ID, a[0], a[1]),
  803316827: (ID, a) => new IFC4.IfcFaceOuterBound(ID, a[0], a[1]),
  3008276851: (ID, a) => new IFC4.IfcFaceSurface(ID, a[0], a[1], a[2]),
  4219587988: (ID, a) => new IFC4.IfcFailureConnectionCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  738692330: (ID, a) => new IFC4.IfcFillAreaStyle(ID, a[0], a[1], a[2]),
  3448662350: (ID, a) => new IFC4.IfcGeometricRepresentationContext(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2453401579: (ID, _) => new IFC4.IfcGeometricRepresentationItem(ID),
  4142052618: (ID, a) => new IFC4.IfcGeometricRepresentationSubContext(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3590301190: (ID, a) => new IFC4.IfcGeometricSet(ID, a[0]),
  178086475: (ID, a) => new IFC4.IfcGridPlacement(ID, a[0], a[1]),
  812098782: (ID, a) => new IFC4.IfcHalfSpaceSolid(ID, a[0], a[1]),
  3905492369: (ID, a) => new IFC4.IfcImageTexture(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3570813810: (ID, a) => new IFC4.IfcIndexedColourMap(ID, a[0], a[1], a[2], a[3]),
  1437953363: (ID, a) => new IFC4.IfcIndexedTextureMap(ID, a[0], a[1], a[2]),
  2133299955: (ID, a) => new IFC4.IfcIndexedTriangleTextureMap(ID, a[0], a[1], a[2], a[3]),
  3741457305: (ID, a) => new IFC4.IfcIrregularTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1585845231: (ID, a) => new IFC4.IfcLagTime(ID, a[0], a[1], a[2], a[3], a[4]),
  1402838566: (ID, a) => new IFC4.IfcLightSource(ID, a[0], a[1], a[2], a[3]),
  125510826: (ID, a) => new IFC4.IfcLightSourceAmbient(ID, a[0], a[1], a[2], a[3]),
  2604431987: (ID, a) => new IFC4.IfcLightSourceDirectional(ID, a[0], a[1], a[2], a[3], a[4]),
  4266656042: (ID, a) => new IFC4.IfcLightSourceGoniometric(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1520743889: (ID, a) => new IFC4.IfcLightSourcePositional(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3422422726: (ID, a) => new IFC4.IfcLightSourceSpot(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  2624227202: (ID, a) => new IFC4.IfcLocalPlacement(ID, a[0], a[1]),
  1008929658: (ID, _) => new IFC4.IfcLoop(ID),
  2347385850: (ID, a) => new IFC4.IfcMappedItem(ID, a[0], a[1]),
  1838606355: (ID, a) => new IFC4.IfcMaterial(ID, a[0], a[1], a[2]),
  3708119e3: (ID, a) => new IFC4.IfcMaterialConstituent(ID, a[0], a[1], a[2], a[3], a[4]),
  2852063980: (ID, a) => new IFC4.IfcMaterialConstituentSet(ID, a[0], a[1], a[2]),
  2022407955: (ID, a) => new IFC4.IfcMaterialDefinitionRepresentation(ID, a[0], a[1], a[2], a[3]),
  1303795690: (ID, a) => new IFC4.IfcMaterialLayerSetUsage(ID, a[0], a[1], a[2], a[3], a[4]),
  3079605661: (ID, a) => new IFC4.IfcMaterialProfileSetUsage(ID, a[0], a[1], a[2]),
  3404854881: (ID, a) => new IFC4.IfcMaterialProfileSetUsageTapering(ID, a[0], a[1], a[2], a[3], a[4]),
  3265635763: (ID, a) => new IFC4.IfcMaterialProperties(ID, a[0], a[1], a[2], a[3]),
  853536259: (ID, a) => new IFC4.IfcMaterialRelationship(ID, a[0], a[1], a[2], a[3], a[4]),
  2998442950: (ID, a) => new IFC4.IfcMirroredProfileDef(ID, a[0], a[1], a[2], a[3]),
  219451334: (ID, a) => new IFC4.IfcObjectDefinition(ID, a[0], a[1], a[2], a[3]),
  2665983363: (ID, a) => new IFC4.IfcOpenShell(ID, a[0]),
  1411181986: (ID, a) => new IFC4.IfcOrganizationRelationship(ID, a[0], a[1], a[2], a[3]),
  1029017970: (ID, a) => new IFC4.IfcOrientedEdge(ID, a[0], a[1]),
  2529465313: (ID, a) => new IFC4.IfcParameterizedProfileDef(ID, a[0], a[1], a[2]),
  2519244187: (ID, a) => new IFC4.IfcPath(ID, a[0]),
  3021840470: (ID, a) => new IFC4.IfcPhysicalComplexQuantity(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  597895409: (ID, a) => new IFC4.IfcPixelTexture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2004835150: (ID, a) => new IFC4.IfcPlacement(ID, a[0]),
  1663979128: (ID, a) => new IFC4.IfcPlanarExtent(ID, a[0], a[1]),
  2067069095: (ID, _) => new IFC4.IfcPoint(ID),
  4022376103: (ID, a) => new IFC4.IfcPointOnCurve(ID, a[0], a[1]),
  1423911732: (ID, a) => new IFC4.IfcPointOnSurface(ID, a[0], a[1], a[2]),
  2924175390: (ID, a) => new IFC4.IfcPolyLoop(ID, a[0]),
  2775532180: (ID, a) => new IFC4.IfcPolygonalBoundedHalfSpace(ID, a[0], a[1], a[2], a[3]),
  3727388367: (ID, a) => new IFC4.IfcPreDefinedItem(ID, a[0]),
  3778827333: (ID, _) => new IFC4.IfcPreDefinedProperties(ID),
  1775413392: (ID, a) => new IFC4.IfcPreDefinedTextFont(ID, a[0]),
  673634403: (ID, a) => new IFC4.IfcProductDefinitionShape(ID, a[0], a[1], a[2]),
  2802850158: (ID, a) => new IFC4.IfcProfileProperties(ID, a[0], a[1], a[2], a[3]),
  2598011224: (ID, a) => new IFC4.IfcProperty(ID, a[0], a[1]),
  1680319473: (ID, a) => new IFC4.IfcPropertyDefinition(ID, a[0], a[1], a[2], a[3]),
  148025276: (ID, a) => new IFC4.IfcPropertyDependencyRelationship(ID, a[0], a[1], a[2], a[3], a[4]),
  3357820518: (ID, a) => new IFC4.IfcPropertySetDefinition(ID, a[0], a[1], a[2], a[3]),
  1482703590: (ID, a) => new IFC4.IfcPropertyTemplateDefinition(ID, a[0], a[1], a[2], a[3]),
  2090586900: (ID, a) => new IFC4.IfcQuantitySet(ID, a[0], a[1], a[2], a[3]),
  3615266464: (ID, a) => new IFC4.IfcRectangleProfileDef(ID, a[0], a[1], a[2], a[3], a[4]),
  3413951693: (ID, a) => new IFC4.IfcRegularTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1580146022: (ID, a) => new IFC4.IfcReinforcementBarProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  478536968: (ID, a) => new IFC4.IfcRelationship(ID, a[0], a[1], a[2], a[3]),
  2943643501: (ID, a) => new IFC4.IfcResourceApprovalRelationship(ID, a[0], a[1], a[2], a[3]),
  1608871552: (ID, a) => new IFC4.IfcResourceConstraintRelationship(ID, a[0], a[1], a[2], a[3]),
  1042787934: (ID, a) => new IFC4.IfcResourceTime(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17]),
  2778083089: (ID, a) => new IFC4.IfcRoundedRectangleProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2042790032: (ID, a) => new IFC4.IfcSectionProperties(ID, a[0], a[1], a[2]),
  4165799628: (ID, a) => new IFC4.IfcSectionReinforcementProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1509187699: (ID, a) => new IFC4.IfcSectionedSpine(ID, a[0], a[1], a[2]),
  4124623270: (ID, a) => new IFC4.IfcShellBasedSurfaceModel(ID, a[0]),
  3692461612: (ID, a) => new IFC4.IfcSimpleProperty(ID, a[0], a[1]),
  2609359061: (ID, a) => new IFC4.IfcSlippageConnectionCondition(ID, a[0], a[1], a[2], a[3]),
  723233188: (ID, _) => new IFC4.IfcSolidModel(ID),
  1595516126: (ID, a) => new IFC4.IfcStructuralLoadLinearForce(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2668620305: (ID, a) => new IFC4.IfcStructuralLoadPlanarForce(ID, a[0], a[1], a[2], a[3]),
  2473145415: (ID, a) => new IFC4.IfcStructuralLoadSingleDisplacement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1973038258: (ID, a) => new IFC4.IfcStructuralLoadSingleDisplacementDistortion(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1597423693: (ID, a) => new IFC4.IfcStructuralLoadSingleForce(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1190533807: (ID, a) => new IFC4.IfcStructuralLoadSingleForceWarping(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2233826070: (ID, a) => new IFC4.IfcSubedge(ID, a[0], a[1], a[2]),
  2513912981: (ID, _) => new IFC4.IfcSurface(ID),
  1878645084: (ID, a) => new IFC4.IfcSurfaceStyleRendering(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2247615214: (ID, a) => new IFC4.IfcSweptAreaSolid(ID, a[0], a[1]),
  1260650574: (ID, a) => new IFC4.IfcSweptDiskSolid(ID, a[0], a[1], a[2], a[3], a[4]),
  1096409881: (ID, a) => new IFC4.IfcSweptDiskSolidPolygonal(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  230924584: (ID, a) => new IFC4.IfcSweptSurface(ID, a[0], a[1]),
  3071757647: (ID, a) => new IFC4.IfcTShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  901063453: (ID, _) => new IFC4.IfcTessellatedItem(ID),
  4282788508: (ID, a) => new IFC4.IfcTextLiteral(ID, a[0], a[1], a[2]),
  3124975700: (ID, a) => new IFC4.IfcTextLiteralWithExtent(ID, a[0], a[1], a[2], a[3], a[4]),
  1983826977: (ID, a) => new IFC4.IfcTextStyleFontModel(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2715220739: (ID, a) => new IFC4.IfcTrapeziumProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1628702193: (ID, a) => new IFC4.IfcTypeObject(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3736923433: (ID, a) => new IFC4.IfcTypeProcess(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2347495698: (ID, a) => new IFC4.IfcTypeProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3698973494: (ID, a) => new IFC4.IfcTypeResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  427810014: (ID, a) => new IFC4.IfcUShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1417489154: (ID, a) => new IFC4.IfcVector(ID, a[0], a[1]),
  2759199220: (ID, a) => new IFC4.IfcVertexLoop(ID, a[0]),
  1299126871: (ID, a) => new IFC4.IfcWindowStyle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2543172580: (ID, a) => new IFC4.IfcZShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3406155212: (ID, a) => new IFC4.IfcAdvancedFace(ID, a[0], a[1], a[2]),
  669184980: (ID, a) => new IFC4.IfcAnnotationFillArea(ID, a[0], a[1]),
  3207858831: (ID, a) => new IFC4.IfcAsymmetricIShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
  4261334040: (ID, a) => new IFC4.IfcAxis1Placement(ID, a[0], a[1]),
  3125803723: (ID, a) => new IFC4.IfcAxis2Placement2D(ID, a[0], a[1]),
  2740243338: (ID, a) => new IFC4.IfcAxis2Placement3D(ID, a[0], a[1], a[2]),
  2736907675: (ID, a) => new IFC4.IfcBooleanResult(ID, a[0], a[1], a[2]),
  4182860854: (ID, _) => new IFC4.IfcBoundedSurface(ID),
  2581212453: (ID, a) => new IFC4.IfcBoundingBox(ID, a[0], a[1], a[2], a[3]),
  2713105998: (ID, a) => new IFC4.IfcBoxedHalfSpace(ID, a[0], a[1], a[2]),
  2898889636: (ID, a) => new IFC4.IfcCShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1123145078: (ID, a) => new IFC4.IfcCartesianPoint(ID, a[0]),
  574549367: (ID, _) => new IFC4.IfcCartesianPointList(ID),
  1675464909: (ID, a) => new IFC4.IfcCartesianPointList2D(ID, a[0]),
  2059837836: (ID, a) => new IFC4.IfcCartesianPointList3D(ID, a[0]),
  59481748: (ID, a) => new IFC4.IfcCartesianTransformationOperator(ID, a[0], a[1], a[2], a[3]),
  3749851601: (ID, a) => new IFC4.IfcCartesianTransformationOperator2D(ID, a[0], a[1], a[2], a[3]),
  3486308946: (ID, a) => new IFC4.IfcCartesianTransformationOperator2DnonUniform(ID, a[0], a[1], a[2], a[3], a[4]),
  3331915920: (ID, a) => new IFC4.IfcCartesianTransformationOperator3D(ID, a[0], a[1], a[2], a[3], a[4]),
  1416205885: (ID, a) => new IFC4.IfcCartesianTransformationOperator3DnonUniform(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1383045692: (ID, a) => new IFC4.IfcCircleProfileDef(ID, a[0], a[1], a[2], a[3]),
  2205249479: (ID, a) => new IFC4.IfcClosedShell(ID, a[0]),
  776857604: (ID, a) => new IFC4.IfcColourRgb(ID, a[0], a[1], a[2], a[3]),
  2542286263: (ID, a) => new IFC4.IfcComplexProperty(ID, a[0], a[1], a[2], a[3]),
  2485617015: (ID, a) => new IFC4.IfcCompositeCurveSegment(ID, a[0], a[1], a[2]),
  2574617495: (ID, a) => new IFC4.IfcConstructionResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3419103109: (ID, a) => new IFC4.IfcContext(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1815067380: (ID, a) => new IFC4.IfcCrewResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2506170314: (ID, a) => new IFC4.IfcCsgPrimitive3D(ID, a[0]),
  2147822146: (ID, a) => new IFC4.IfcCsgSolid(ID, a[0]),
  2601014836: (ID, _) => new IFC4.IfcCurve(ID),
  2827736869: (ID, a) => new IFC4.IfcCurveBoundedPlane(ID, a[0], a[1], a[2]),
  2629017746: (ID, a) => new IFC4.IfcCurveBoundedSurface(ID, a[0], a[1], a[2]),
  32440307: (ID, a) => new IFC4.IfcDirection(ID, a[0]),
  526551008: (ID, a) => new IFC4.IfcDoorStyle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1472233963: (ID, a) => new IFC4.IfcEdgeLoop(ID, a[0]),
  1883228015: (ID, a) => new IFC4.IfcElementQuantity(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  339256511: (ID, a) => new IFC4.IfcElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2777663545: (ID, a) => new IFC4.IfcElementarySurface(ID, a[0]),
  2835456948: (ID, a) => new IFC4.IfcEllipseProfileDef(ID, a[0], a[1], a[2], a[3], a[4]),
  4024345920: (ID, a) => new IFC4.IfcEventType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  477187591: (ID, a) => new IFC4.IfcExtrudedAreaSolid(ID, a[0], a[1], a[2], a[3]),
  2804161546: (ID, a) => new IFC4.IfcExtrudedAreaSolidTapered(ID, a[0], a[1], a[2], a[3], a[4]),
  2047409740: (ID, a) => new IFC4.IfcFaceBasedSurfaceModel(ID, a[0]),
  374418227: (ID, a) => new IFC4.IfcFillAreaStyleHatching(ID, a[0], a[1], a[2], a[3], a[4]),
  315944413: (ID, a) => new IFC4.IfcFillAreaStyleTiles(ID, a[0], a[1], a[2]),
  2652556860: (ID, a) => new IFC4.IfcFixedReferenceSweptAreaSolid(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  4238390223: (ID, a) => new IFC4.IfcFurnishingElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1268542332: (ID, a) => new IFC4.IfcFurnitureType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4095422895: (ID, a) => new IFC4.IfcGeographicElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  987898635: (ID, a) => new IFC4.IfcGeometricCurveSet(ID, a[0]),
  1484403080: (ID, a) => new IFC4.IfcIShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  178912537: (ID, a) => new IFC4.IfcIndexedPolygonalFace(ID, a[0]),
  2294589976: (ID, a) => new IFC4.IfcIndexedPolygonalFaceWithVoids(ID, a[0], a[1]),
  572779678: (ID, a) => new IFC4.IfcLShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  428585644: (ID, a) => new IFC4.IfcLaborResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1281925730: (ID, a) => new IFC4.IfcLine(ID, a[0], a[1]),
  1425443689: (ID, a) => new IFC4.IfcManifoldSolidBrep(ID, a[0]),
  3888040117: (ID, a) => new IFC4.IfcObject(ID, a[0], a[1], a[2], a[3], a[4]),
  3388369263: (ID, a) => new IFC4.IfcOffsetCurve2D(ID, a[0], a[1], a[2]),
  3505215534: (ID, a) => new IFC4.IfcOffsetCurve3D(ID, a[0], a[1], a[2], a[3]),
  1682466193: (ID, a) => new IFC4.IfcPcurve(ID, a[0], a[1]),
  603570806: (ID, a) => new IFC4.IfcPlanarBox(ID, a[0], a[1], a[2]),
  220341763: (ID, a) => new IFC4.IfcPlane(ID, a[0]),
  759155922: (ID, a) => new IFC4.IfcPreDefinedColour(ID, a[0]),
  2559016684: (ID, a) => new IFC4.IfcPreDefinedCurveFont(ID, a[0]),
  3967405729: (ID, a) => new IFC4.IfcPreDefinedPropertySet(ID, a[0], a[1], a[2], a[3]),
  569719735: (ID, a) => new IFC4.IfcProcedureType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2945172077: (ID, a) => new IFC4.IfcProcess(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  4208778838: (ID, a) => new IFC4.IfcProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  103090709: (ID, a) => new IFC4.IfcProject(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  653396225: (ID, a) => new IFC4.IfcProjectLibrary(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  871118103: (ID, a) => new IFC4.IfcPropertyBoundedValue(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  4166981789: (ID, a) => new IFC4.IfcPropertyEnumeratedValue(ID, a[0], a[1], a[2], a[3]),
  2752243245: (ID, a) => new IFC4.IfcPropertyListValue(ID, a[0], a[1], a[2], a[3]),
  941946838: (ID, a) => new IFC4.IfcPropertyReferenceValue(ID, a[0], a[1], a[2], a[3]),
  1451395588: (ID, a) => new IFC4.IfcPropertySet(ID, a[0], a[1], a[2], a[3], a[4]),
  492091185: (ID, a) => new IFC4.IfcPropertySetTemplate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3650150729: (ID, a) => new IFC4.IfcPropertySingleValue(ID, a[0], a[1], a[2], a[3]),
  110355661: (ID, a) => new IFC4.IfcPropertyTableValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3521284610: (ID, a) => new IFC4.IfcPropertyTemplate(ID, a[0], a[1], a[2], a[3]),
  3219374653: (ID, a) => new IFC4.IfcProxy(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2770003689: (ID, a) => new IFC4.IfcRectangleHollowProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2798486643: (ID, a) => new IFC4.IfcRectangularPyramid(ID, a[0], a[1], a[2], a[3]),
  3454111270: (ID, a) => new IFC4.IfcRectangularTrimmedSurface(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3765753017: (ID, a) => new IFC4.IfcReinforcementDefinitionProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3939117080: (ID, a) => new IFC4.IfcRelAssigns(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1683148259: (ID, a) => new IFC4.IfcRelAssignsToActor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2495723537: (ID, a) => new IFC4.IfcRelAssignsToControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1307041759: (ID, a) => new IFC4.IfcRelAssignsToGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1027710054: (ID, a) => new IFC4.IfcRelAssignsToGroupByFactor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4278684876: (ID, a) => new IFC4.IfcRelAssignsToProcess(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2857406711: (ID, a) => new IFC4.IfcRelAssignsToProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  205026976: (ID, a) => new IFC4.IfcRelAssignsToResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1865459582: (ID, a) => new IFC4.IfcRelAssociates(ID, a[0], a[1], a[2], a[3], a[4]),
  4095574036: (ID, a) => new IFC4.IfcRelAssociatesApproval(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  919958153: (ID, a) => new IFC4.IfcRelAssociatesClassification(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2728634034: (ID, a) => new IFC4.IfcRelAssociatesConstraint(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  982818633: (ID, a) => new IFC4.IfcRelAssociatesDocument(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3840914261: (ID, a) => new IFC4.IfcRelAssociatesLibrary(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2655215786: (ID, a) => new IFC4.IfcRelAssociatesMaterial(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  826625072: (ID, a) => new IFC4.IfcRelConnects(ID, a[0], a[1], a[2], a[3]),
  1204542856: (ID, a) => new IFC4.IfcRelConnectsElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3945020480: (ID, a) => new IFC4.IfcRelConnectsPathElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4201705270: (ID, a) => new IFC4.IfcRelConnectsPortToElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3190031847: (ID, a) => new IFC4.IfcRelConnectsPorts(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2127690289: (ID, a) => new IFC4.IfcRelConnectsStructuralActivity(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1638771189: (ID, a) => new IFC4.IfcRelConnectsStructuralMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  504942748: (ID, a) => new IFC4.IfcRelConnectsWithEccentricity(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3678494232: (ID, a) => new IFC4.IfcRelConnectsWithRealizingElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3242617779: (ID, a) => new IFC4.IfcRelContainedInSpatialStructure(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  886880790: (ID, a) => new IFC4.IfcRelCoversBldgElements(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2802773753: (ID, a) => new IFC4.IfcRelCoversSpaces(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2565941209: (ID, a) => new IFC4.IfcRelDeclares(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2551354335: (ID, a) => new IFC4.IfcRelDecomposes(ID, a[0], a[1], a[2], a[3]),
  693640335: (ID, a) => new IFC4.IfcRelDefines(ID, a[0], a[1], a[2], a[3]),
  1462361463: (ID, a) => new IFC4.IfcRelDefinesByObject(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  4186316022: (ID, a) => new IFC4.IfcRelDefinesByProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  307848117: (ID, a) => new IFC4.IfcRelDefinesByTemplate(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  781010003: (ID, a) => new IFC4.IfcRelDefinesByType(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3940055652: (ID, a) => new IFC4.IfcRelFillsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  279856033: (ID, a) => new IFC4.IfcRelFlowControlElements(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  427948657: (ID, a) => new IFC4.IfcRelInterferesElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3268803585: (ID, a) => new IFC4.IfcRelNests(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  750771296: (ID, a) => new IFC4.IfcRelProjectsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1245217292: (ID, a) => new IFC4.IfcRelReferencedInSpatialStructure(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  4122056220: (ID, a) => new IFC4.IfcRelSequence(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  366585022: (ID, a) => new IFC4.IfcRelServicesBuildings(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3451746338: (ID, a) => new IFC4.IfcRelSpaceBoundary(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3523091289: (ID, a) => new IFC4.IfcRelSpaceBoundary1stLevel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1521410863: (ID, a) => new IFC4.IfcRelSpaceBoundary2ndLevel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1401173127: (ID, a) => new IFC4.IfcRelVoidsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  816062949: (ID, a) => new IFC4.IfcReparametrisedCompositeCurveSegment(ID, a[0], a[1], a[2], a[3]),
  2914609552: (ID, a) => new IFC4.IfcResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1856042241: (ID, a) => new IFC4.IfcRevolvedAreaSolid(ID, a[0], a[1], a[2], a[3]),
  3243963512: (ID, a) => new IFC4.IfcRevolvedAreaSolidTapered(ID, a[0], a[1], a[2], a[3], a[4]),
  4158566097: (ID, a) => new IFC4.IfcRightCircularCone(ID, a[0], a[1], a[2]),
  3626867408: (ID, a) => new IFC4.IfcRightCircularCylinder(ID, a[0], a[1], a[2]),
  3663146110: (ID, a) => new IFC4.IfcSimplePropertyTemplate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1412071761: (ID, a) => new IFC4.IfcSpatialElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  710998568: (ID, a) => new IFC4.IfcSpatialElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2706606064: (ID, a) => new IFC4.IfcSpatialStructureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3893378262: (ID, a) => new IFC4.IfcSpatialStructureElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  463610769: (ID, a) => new IFC4.IfcSpatialZone(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2481509218: (ID, a) => new IFC4.IfcSpatialZoneType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  451544542: (ID, a) => new IFC4.IfcSphere(ID, a[0], a[1]),
  4015995234: (ID, a) => new IFC4.IfcSphericalSurface(ID, a[0], a[1]),
  3544373492: (ID, a) => new IFC4.IfcStructuralActivity(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3136571912: (ID, a) => new IFC4.IfcStructuralItem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  530289379: (ID, a) => new IFC4.IfcStructuralMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3689010777: (ID, a) => new IFC4.IfcStructuralReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3979015343: (ID, a) => new IFC4.IfcStructuralSurfaceMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2218152070: (ID, a) => new IFC4.IfcStructuralSurfaceMemberVarying(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  603775116: (ID, a) => new IFC4.IfcStructuralSurfaceReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4095615324: (ID, a) => new IFC4.IfcSubContractResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  699246055: (ID, a) => new IFC4.IfcSurfaceCurve(ID, a[0], a[1], a[2]),
  2028607225: (ID, a) => new IFC4.IfcSurfaceCurveSweptAreaSolid(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2809605785: (ID, a) => new IFC4.IfcSurfaceOfLinearExtrusion(ID, a[0], a[1], a[2], a[3]),
  4124788165: (ID, a) => new IFC4.IfcSurfaceOfRevolution(ID, a[0], a[1], a[2]),
  1580310250: (ID, a) => new IFC4.IfcSystemFurnitureElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3473067441: (ID, a) => new IFC4.IfcTask(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  3206491090: (ID, a) => new IFC4.IfcTaskType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2387106220: (ID, a) => new IFC4.IfcTessellatedFaceSet(ID, a[0]),
  1935646853: (ID, a) => new IFC4.IfcToroidalSurface(ID, a[0], a[1], a[2]),
  2097647324: (ID, a) => new IFC4.IfcTransportElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2916149573: (ID, a) => new IFC4.IfcTriangulatedFaceSet(ID, a[0], a[1], a[2], a[3], a[4]),
  336235671: (ID, a) => new IFC4.IfcWindowLiningProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]),
  512836454: (ID, a) => new IFC4.IfcWindowPanelProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2296667514: (ID, a) => new IFC4.IfcActor(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  1635779807: (ID, a) => new IFC4.IfcAdvancedBrep(ID, a[0]),
  2603310189: (ID, a) => new IFC4.IfcAdvancedBrepWithVoids(ID, a[0], a[1]),
  1674181508: (ID, a) => new IFC4.IfcAnnotation(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2887950389: (ID, a) => new IFC4.IfcBSplineSurface(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  167062518: (ID, a) => new IFC4.IfcBSplineSurfaceWithKnots(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1334484129: (ID, a) => new IFC4.IfcBlock(ID, a[0], a[1], a[2], a[3]),
  3649129432: (ID, a) => new IFC4.IfcBooleanClippingResult(ID, a[0], a[1], a[2]),
  1260505505: (ID, _) => new IFC4.IfcBoundedCurve(ID),
  4031249490: (ID, a) => new IFC4.IfcBuilding(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1950629157: (ID, a) => new IFC4.IfcBuildingElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3124254112: (ID, a) => new IFC4.IfcBuildingStorey(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2197970202: (ID, a) => new IFC4.IfcChimneyType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2937912522: (ID, a) => new IFC4.IfcCircleHollowProfileDef(ID, a[0], a[1], a[2], a[3], a[4]),
  3893394355: (ID, a) => new IFC4.IfcCivilElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  300633059: (ID, a) => new IFC4.IfcColumnType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3875453745: (ID, a) => new IFC4.IfcComplexPropertyTemplate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3732776249: (ID, a) => new IFC4.IfcCompositeCurve(ID, a[0], a[1]),
  15328376: (ID, a) => new IFC4.IfcCompositeCurveOnSurface(ID, a[0], a[1]),
  2510884976: (ID, a) => new IFC4.IfcConic(ID, a[0]),
  2185764099: (ID, a) => new IFC4.IfcConstructionEquipmentResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  4105962743: (ID, a) => new IFC4.IfcConstructionMaterialResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1525564444: (ID, a) => new IFC4.IfcConstructionProductResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  2559216714: (ID, a) => new IFC4.IfcConstructionResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3293443760: (ID, a) => new IFC4.IfcControl(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3895139033: (ID, a) => new IFC4.IfcCostItem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1419761937: (ID, a) => new IFC4.IfcCostSchedule(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1916426348: (ID, a) => new IFC4.IfcCoveringType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3295246426: (ID, a) => new IFC4.IfcCrewResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1457835157: (ID, a) => new IFC4.IfcCurtainWallType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1213902940: (ID, a) => new IFC4.IfcCylindricalSurface(ID, a[0], a[1]),
  3256556792: (ID, a) => new IFC4.IfcDistributionElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3849074793: (ID, a) => new IFC4.IfcDistributionFlowElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2963535650: (ID, a) => new IFC4.IfcDoorLiningProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  1714330368: (ID, a) => new IFC4.IfcDoorPanelProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2323601079: (ID, a) => new IFC4.IfcDoorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  445594917: (ID, a) => new IFC4.IfcDraughtingPreDefinedColour(ID, a[0]),
  4006246654: (ID, a) => new IFC4.IfcDraughtingPreDefinedCurveFont(ID, a[0]),
  1758889154: (ID, a) => new IFC4.IfcElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4123344466: (ID, a) => new IFC4.IfcElementAssembly(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2397081782: (ID, a) => new IFC4.IfcElementAssemblyType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1623761950: (ID, a) => new IFC4.IfcElementComponent(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2590856083: (ID, a) => new IFC4.IfcElementComponentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1704287377: (ID, a) => new IFC4.IfcEllipse(ID, a[0], a[1], a[2]),
  2107101300: (ID, a) => new IFC4.IfcEnergyConversionDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  132023988: (ID, a) => new IFC4.IfcEngineType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3174744832: (ID, a) => new IFC4.IfcEvaporativeCoolerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3390157468: (ID, a) => new IFC4.IfcEvaporatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4148101412: (ID, a) => new IFC4.IfcEvent(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2853485674: (ID, a) => new IFC4.IfcExternalSpatialStructureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  807026263: (ID, a) => new IFC4.IfcFacetedBrep(ID, a[0]),
  3737207727: (ID, a) => new IFC4.IfcFacetedBrepWithVoids(ID, a[0], a[1]),
  647756555: (ID, a) => new IFC4.IfcFastener(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2489546625: (ID, a) => new IFC4.IfcFastenerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2827207264: (ID, a) => new IFC4.IfcFeatureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2143335405: (ID, a) => new IFC4.IfcFeatureElementAddition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1287392070: (ID, a) => new IFC4.IfcFeatureElementSubtraction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3907093117: (ID, a) => new IFC4.IfcFlowControllerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3198132628: (ID, a) => new IFC4.IfcFlowFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3815607619: (ID, a) => new IFC4.IfcFlowMeterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1482959167: (ID, a) => new IFC4.IfcFlowMovingDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1834744321: (ID, a) => new IFC4.IfcFlowSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1339347760: (ID, a) => new IFC4.IfcFlowStorageDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2297155007: (ID, a) => new IFC4.IfcFlowTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3009222698: (ID, a) => new IFC4.IfcFlowTreatmentDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1893162501: (ID, a) => new IFC4.IfcFootingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  263784265: (ID, a) => new IFC4.IfcFurnishingElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1509553395: (ID, a) => new IFC4.IfcFurniture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3493046030: (ID, a) => new IFC4.IfcGeographicElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3009204131: (ID, a) => new IFC4.IfcGrid(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2706460486: (ID, a) => new IFC4.IfcGroup(ID, a[0], a[1], a[2], a[3], a[4]),
  1251058090: (ID, a) => new IFC4.IfcHeatExchangerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1806887404: (ID, a) => new IFC4.IfcHumidifierType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2571569899: (ID, a) => new IFC4.IfcIndexedPolyCurve(ID, a[0], a[1], a[2]),
  3946677679: (ID, a) => new IFC4.IfcInterceptorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3113134337: (ID, a) => new IFC4.IfcIntersectionCurve(ID, a[0], a[1], a[2]),
  2391368822: (ID, a) => new IFC4.IfcInventory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  4288270099: (ID, a) => new IFC4.IfcJunctionBoxType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3827777499: (ID, a) => new IFC4.IfcLaborResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1051575348: (ID, a) => new IFC4.IfcLampType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1161773419: (ID, a) => new IFC4.IfcLightFixtureType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  377706215: (ID, a) => new IFC4.IfcMechanicalFastener(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  2108223431: (ID, a) => new IFC4.IfcMechanicalFastenerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1114901282: (ID, a) => new IFC4.IfcMedicalDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3181161470: (ID, a) => new IFC4.IfcMemberType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  977012517: (ID, a) => new IFC4.IfcMotorConnectionType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4143007308: (ID, a) => new IFC4.IfcOccupant(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  3588315303: (ID, a) => new IFC4.IfcOpeningElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3079942009: (ID, a) => new IFC4.IfcOpeningStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2837617999: (ID, a) => new IFC4.IfcOutletType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2382730787: (ID, a) => new IFC4.IfcPerformanceHistory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3566463478: (ID, a) => new IFC4.IfcPermeableCoveringProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3327091369: (ID, a) => new IFC4.IfcPermit(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1158309216: (ID, a) => new IFC4.IfcPileType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  804291784: (ID, a) => new IFC4.IfcPipeFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4231323485: (ID, a) => new IFC4.IfcPipeSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4017108033: (ID, a) => new IFC4.IfcPlateType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2839578677: (ID, a) => new IFC4.IfcPolygonalFaceSet(ID, a[0], a[1], a[2], a[3]),
  3724593414: (ID, a) => new IFC4.IfcPolyline(ID, a[0]),
  3740093272: (ID, a) => new IFC4.IfcPort(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2744685151: (ID, a) => new IFC4.IfcProcedure(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2904328755: (ID, a) => new IFC4.IfcProjectOrder(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3651124850: (ID, a) => new IFC4.IfcProjectionElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1842657554: (ID, a) => new IFC4.IfcProtectiveDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2250791053: (ID, a) => new IFC4.IfcPumpType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2893384427: (ID, a) => new IFC4.IfcRailingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2324767716: (ID, a) => new IFC4.IfcRampFlightType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1469900589: (ID, a) => new IFC4.IfcRampType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  683857671: (ID, a) => new IFC4.IfcRationalBSplineSurfaceWithKnots(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  3027567501: (ID, a) => new IFC4.IfcReinforcingElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  964333572: (ID, a) => new IFC4.IfcReinforcingElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2320036040: (ID, a) => new IFC4.IfcReinforcingMesh(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17]),
  2310774935: (ID, a) => new IFC4.IfcReinforcingMeshType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19]),
  160246688: (ID, a) => new IFC4.IfcRelAggregates(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  2781568857: (ID, a) => new IFC4.IfcRoofType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1768891740: (ID, a) => new IFC4.IfcSanitaryTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2157484638: (ID, a) => new IFC4.IfcSeamCurve(ID, a[0], a[1], a[2]),
  4074543187: (ID, a) => new IFC4.IfcShadingDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4097777520: (ID, a) => new IFC4.IfcSite(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  2533589738: (ID, a) => new IFC4.IfcSlabType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1072016465: (ID, a) => new IFC4.IfcSolarDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3856911033: (ID, a) => new IFC4.IfcSpace(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1305183839: (ID, a) => new IFC4.IfcSpaceHeaterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3812236995: (ID, a) => new IFC4.IfcSpaceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3112655638: (ID, a) => new IFC4.IfcStackTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1039846685: (ID, a) => new IFC4.IfcStairFlightType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  338393293: (ID, a) => new IFC4.IfcStairType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  682877961: (ID, a) => new IFC4.IfcStructuralAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1179482911: (ID, a) => new IFC4.IfcStructuralConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  1004757350: (ID, a) => new IFC4.IfcStructuralCurveAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  4243806635: (ID, a) => new IFC4.IfcStructuralCurveConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  214636428: (ID, a) => new IFC4.IfcStructuralCurveMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2445595289: (ID, a) => new IFC4.IfcStructuralCurveMemberVarying(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2757150158: (ID, a) => new IFC4.IfcStructuralCurveReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1807405624: (ID, a) => new IFC4.IfcStructuralLinearAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1252848954: (ID, a) => new IFC4.IfcStructuralLoadGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2082059205: (ID, a) => new IFC4.IfcStructuralPointAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  734778138: (ID, a) => new IFC4.IfcStructuralPointConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1235345126: (ID, a) => new IFC4.IfcStructuralPointReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2986769608: (ID, a) => new IFC4.IfcStructuralResultGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3657597509: (ID, a) => new IFC4.IfcStructuralSurfaceAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1975003073: (ID, a) => new IFC4.IfcStructuralSurfaceConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  148013059: (ID, a) => new IFC4.IfcSubContractResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  3101698114: (ID, a) => new IFC4.IfcSurfaceFeature(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2315554128: (ID, a) => new IFC4.IfcSwitchingDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2254336722: (ID, a) => new IFC4.IfcSystem(ID, a[0], a[1], a[2], a[3], a[4]),
  413509423: (ID, a) => new IFC4.IfcSystemFurnitureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  5716631: (ID, a) => new IFC4.IfcTankType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3824725483: (ID, a) => new IFC4.IfcTendon(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
  2347447852: (ID, a) => new IFC4.IfcTendonAnchor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3081323446: (ID, a) => new IFC4.IfcTendonAnchorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2415094496: (ID, a) => new IFC4.IfcTendonType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  1692211062: (ID, a) => new IFC4.IfcTransformerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1620046519: (ID, a) => new IFC4.IfcTransportElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3593883385: (ID, a) => new IFC4.IfcTrimmedCurve(ID, a[0], a[1], a[2], a[3], a[4]),
  1600972822: (ID, a) => new IFC4.IfcTubeBundleType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1911125066: (ID, a) => new IFC4.IfcUnitaryEquipmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  728799441: (ID, a) => new IFC4.IfcValveType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2391383451: (ID, a) => new IFC4.IfcVibrationIsolator(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3313531582: (ID, a) => new IFC4.IfcVibrationIsolatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2769231204: (ID, a) => new IFC4.IfcVirtualElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  926996030: (ID, a) => new IFC4.IfcVoidingFeature(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1898987631: (ID, a) => new IFC4.IfcWallType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1133259667: (ID, a) => new IFC4.IfcWasteTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4009809668: (ID, a) => new IFC4.IfcWindowType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  4088093105: (ID, a) => new IFC4.IfcWorkCalendar(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1028945134: (ID, a) => new IFC4.IfcWorkControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  4218914973: (ID, a) => new IFC4.IfcWorkPlan(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  3342526732: (ID, a) => new IFC4.IfcWorkSchedule(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  1033361043: (ID, a) => new IFC4.IfcZone(ID, a[0], a[1], a[2], a[3], a[4], a[5]),
  3821786052: (ID, a) => new IFC4.IfcActionRequest(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1411407467: (ID, a) => new IFC4.IfcAirTerminalBoxType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3352864051: (ID, a) => new IFC4.IfcAirTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1871374353: (ID, a) => new IFC4.IfcAirToAirHeatRecoveryType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3460190687: (ID, a) => new IFC4.IfcAsset(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  1532957894: (ID, a) => new IFC4.IfcAudioVisualApplianceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1967976161: (ID, a) => new IFC4.IfcBSplineCurve(ID, a[0], a[1], a[2], a[3], a[4]),
  2461110595: (ID, a) => new IFC4.IfcBSplineCurveWithKnots(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  819618141: (ID, a) => new IFC4.IfcBeamType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  231477066: (ID, a) => new IFC4.IfcBoilerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1136057603: (ID, a) => new IFC4.IfcBoundaryCurve(ID, a[0], a[1]),
  3299480353: (ID, a) => new IFC4.IfcBuildingElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2979338954: (ID, a) => new IFC4.IfcBuildingElementPart(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  39481116: (ID, a) => new IFC4.IfcBuildingElementPartType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1095909175: (ID, a) => new IFC4.IfcBuildingElementProxy(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1909888760: (ID, a) => new IFC4.IfcBuildingElementProxyType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1177604601: (ID, a) => new IFC4.IfcBuildingSystem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  2188180465: (ID, a) => new IFC4.IfcBurnerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  395041908: (ID, a) => new IFC4.IfcCableCarrierFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3293546465: (ID, a) => new IFC4.IfcCableCarrierSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2674252688: (ID, a) => new IFC4.IfcCableFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1285652485: (ID, a) => new IFC4.IfcCableSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2951183804: (ID, a) => new IFC4.IfcChillerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3296154744: (ID, a) => new IFC4.IfcChimney(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2611217952: (ID, a) => new IFC4.IfcCircle(ID, a[0], a[1]),
  1677625105: (ID, a) => new IFC4.IfcCivilElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2301859152: (ID, a) => new IFC4.IfcCoilType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  843113511: (ID, a) => new IFC4.IfcColumn(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  905975707: (ID, a) => new IFC4.IfcColumnStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  400855858: (ID, a) => new IFC4.IfcCommunicationsApplianceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3850581409: (ID, a) => new IFC4.IfcCompressorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2816379211: (ID, a) => new IFC4.IfcCondenserType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3898045240: (ID, a) => new IFC4.IfcConstructionEquipmentResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1060000209: (ID, a) => new IFC4.IfcConstructionMaterialResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  488727124: (ID, a) => new IFC4.IfcConstructionProductResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  335055490: (ID, a) => new IFC4.IfcCooledBeamType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2954562838: (ID, a) => new IFC4.IfcCoolingTowerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1973544240: (ID, a) => new IFC4.IfcCovering(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3495092785: (ID, a) => new IFC4.IfcCurtainWall(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3961806047: (ID, a) => new IFC4.IfcDamperType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1335981549: (ID, a) => new IFC4.IfcDiscreteAccessory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2635815018: (ID, a) => new IFC4.IfcDiscreteAccessoryType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1599208980: (ID, a) => new IFC4.IfcDistributionChamberElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2063403501: (ID, a) => new IFC4.IfcDistributionControlElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1945004755: (ID, a) => new IFC4.IfcDistributionElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3040386961: (ID, a) => new IFC4.IfcDistributionFlowElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3041715199: (ID, a) => new IFC4.IfcDistributionPort(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3205830791: (ID, a) => new IFC4.IfcDistributionSystem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  395920057: (ID, a) => new IFC4.IfcDoor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  3242481149: (ID, a) => new IFC4.IfcDoorStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  869906466: (ID, a) => new IFC4.IfcDuctFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3760055223: (ID, a) => new IFC4.IfcDuctSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2030761528: (ID, a) => new IFC4.IfcDuctSilencerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  663422040: (ID, a) => new IFC4.IfcElectricApplianceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2417008758: (ID, a) => new IFC4.IfcElectricDistributionBoardType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  3277789161: (ID, a) => new IFC4.IfcElectricFlowStorageDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1534661035: (ID, a) => new IFC4.IfcElectricGeneratorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1217240411: (ID, a) => new IFC4.IfcElectricMotorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  712377611: (ID, a) => new IFC4.IfcElectricTimeControlType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1658829314: (ID, a) => new IFC4.IfcEnergyConversionDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2814081492: (ID, a) => new IFC4.IfcEngine(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3747195512: (ID, a) => new IFC4.IfcEvaporativeCooler(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  484807127: (ID, a) => new IFC4.IfcEvaporator(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1209101575: (ID, a) => new IFC4.IfcExternalSpatialElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  346874300: (ID, a) => new IFC4.IfcFanType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1810631287: (ID, a) => new IFC4.IfcFilterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4222183408: (ID, a) => new IFC4.IfcFireSuppressionTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2058353004: (ID, a) => new IFC4.IfcFlowController(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4278956645: (ID, a) => new IFC4.IfcFlowFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  4037862832: (ID, a) => new IFC4.IfcFlowInstrumentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  2188021234: (ID, a) => new IFC4.IfcFlowMeter(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3132237377: (ID, a) => new IFC4.IfcFlowMovingDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  987401354: (ID, a) => new IFC4.IfcFlowSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  707683696: (ID, a) => new IFC4.IfcFlowStorageDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  2223149337: (ID, a) => new IFC4.IfcFlowTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  3508470533: (ID, a) => new IFC4.IfcFlowTreatmentDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  900683007: (ID, a) => new IFC4.IfcFooting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3319311131: (ID, a) => new IFC4.IfcHeatExchanger(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2068733104: (ID, a) => new IFC4.IfcHumidifier(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4175244083: (ID, a) => new IFC4.IfcInterceptor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2176052936: (ID, a) => new IFC4.IfcJunctionBox(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  76236018: (ID, a) => new IFC4.IfcLamp(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  629592764: (ID, a) => new IFC4.IfcLightFixture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1437502449: (ID, a) => new IFC4.IfcMedicalDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1073191201: (ID, a) => new IFC4.IfcMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1911478936: (ID, a) => new IFC4.IfcMemberStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2474470126: (ID, a) => new IFC4.IfcMotorConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  144952367: (ID, a) => new IFC4.IfcOuterBoundaryCurve(ID, a[0], a[1]),
  3694346114: (ID, a) => new IFC4.IfcOutlet(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1687234759: (ID, a) => new IFC4.IfcPile(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  310824031: (ID, a) => new IFC4.IfcPipeFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3612865200: (ID, a) => new IFC4.IfcPipeSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3171933400: (ID, a) => new IFC4.IfcPlate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1156407060: (ID, a) => new IFC4.IfcPlateStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  738039164: (ID, a) => new IFC4.IfcProtectiveDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  655969474: (ID, a) => new IFC4.IfcProtectiveDeviceTrippingUnitType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  90941305: (ID, a) => new IFC4.IfcPump(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2262370178: (ID, a) => new IFC4.IfcRailing(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3024970846: (ID, a) => new IFC4.IfcRamp(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3283111854: (ID, a) => new IFC4.IfcRampFlight(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1232101972: (ID, a) => new IFC4.IfcRationalBSplineCurveWithKnots(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  979691226: (ID, a) => new IFC4.IfcReinforcingBar(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
  2572171363: (ID, a) => new IFC4.IfcReinforcingBarType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]),
  2016517767: (ID, a) => new IFC4.IfcRoof(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3053780830: (ID, a) => new IFC4.IfcSanitaryTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1783015770: (ID, a) => new IFC4.IfcSensorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1329646415: (ID, a) => new IFC4.IfcShadingDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1529196076: (ID, a) => new IFC4.IfcSlab(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3127900445: (ID, a) => new IFC4.IfcSlabElementedCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3027962421: (ID, a) => new IFC4.IfcSlabStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3420628829: (ID, a) => new IFC4.IfcSolarDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1999602285: (ID, a) => new IFC4.IfcSpaceHeater(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1404847402: (ID, a) => new IFC4.IfcStackTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  331165859: (ID, a) => new IFC4.IfcStair(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4252922144: (ID, a) => new IFC4.IfcStairFlight(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  2515109513: (ID, a) => new IFC4.IfcStructuralAnalysisModel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  385403989: (ID, a) => new IFC4.IfcStructuralLoadCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
  1621171031: (ID, a) => new IFC4.IfcStructuralPlanarAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
  1162798199: (ID, a) => new IFC4.IfcSwitchingDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  812556717: (ID, a) => new IFC4.IfcTank(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3825984169: (ID, a) => new IFC4.IfcTransformer(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3026737570: (ID, a) => new IFC4.IfcTubeBundle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3179687236: (ID, a) => new IFC4.IfcUnitaryControlElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4292641817: (ID, a) => new IFC4.IfcUnitaryEquipment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4207607924: (ID, a) => new IFC4.IfcValve(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2391406946: (ID, a) => new IFC4.IfcWall(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4156078855: (ID, a) => new IFC4.IfcWallElementedCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3512223829: (ID, a) => new IFC4.IfcWallStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4237592921: (ID, a) => new IFC4.IfcWasteTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3304561284: (ID, a) => new IFC4.IfcWindow(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  486154966: (ID, a) => new IFC4.IfcWindowStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
  2874132201: (ID, a) => new IFC4.IfcActuatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  1634111441: (ID, a) => new IFC4.IfcAirTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  177149247: (ID, a) => new IFC4.IfcAirTerminalBox(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2056796094: (ID, a) => new IFC4.IfcAirToAirHeatRecovery(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3001207471: (ID, a) => new IFC4.IfcAlarmType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  277319702: (ID, a) => new IFC4.IfcAudioVisualAppliance(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  753842376: (ID, a) => new IFC4.IfcBeam(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2906023776: (ID, a) => new IFC4.IfcBeamStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  32344328: (ID, a) => new IFC4.IfcBoiler(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2938176219: (ID, a) => new IFC4.IfcBurner(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  635142910: (ID, a) => new IFC4.IfcCableCarrierFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3758799889: (ID, a) => new IFC4.IfcCableCarrierSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1051757585: (ID, a) => new IFC4.IfcCableFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4217484030: (ID, a) => new IFC4.IfcCableSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3902619387: (ID, a) => new IFC4.IfcChiller(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  639361253: (ID, a) => new IFC4.IfcCoil(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3221913625: (ID, a) => new IFC4.IfcCommunicationsAppliance(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3571504051: (ID, a) => new IFC4.IfcCompressor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2272882330: (ID, a) => new IFC4.IfcCondenser(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  578613899: (ID, a) => new IFC4.IfcControllerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
  4136498852: (ID, a) => new IFC4.IfcCooledBeam(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3640358203: (ID, a) => new IFC4.IfcCoolingTower(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4074379575: (ID, a) => new IFC4.IfcDamper(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1052013943: (ID, a) => new IFC4.IfcDistributionChamberElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  562808652: (ID, a) => new IFC4.IfcDistributionCircuit(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
  1062813311: (ID, a) => new IFC4.IfcDistributionControlElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
  342316401: (ID, a) => new IFC4.IfcDuctFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3518393246: (ID, a) => new IFC4.IfcDuctSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1360408905: (ID, a) => new IFC4.IfcDuctSilencer(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1904799276: (ID, a) => new IFC4.IfcElectricAppliance(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  862014818: (ID, a) => new IFC4.IfcElectricDistributionBoard(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3310460725: (ID, a) => new IFC4.IfcElectricFlowStorageDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  264262732: (ID, a) => new IFC4.IfcElectricGenerator(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  402227799: (ID, a) => new IFC4.IfcElectricMotor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1003880860: (ID, a) => new IFC4.IfcElectricTimeControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3415622556: (ID, a) => new IFC4.IfcFan(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  819412036: (ID, a) => new IFC4.IfcFilter(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  1426591983: (ID, a) => new IFC4.IfcFireSuppressionTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  182646315: (ID, a) => new IFC4.IfcFlowInstrument(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  2295281155: (ID, a) => new IFC4.IfcProtectiveDeviceTrippingUnit(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4086658281: (ID, a) => new IFC4.IfcSensor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  630975310: (ID, a) => new IFC4.IfcUnitaryControlElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  4288193352: (ID, a) => new IFC4.IfcActuator(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  3087945054: (ID, a) => new IFC4.IfcAlarm(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
  25142252: (ID, a) => new IFC4.IfcController(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8])
};
ToRawLineData[3] = {
  3630933823: (i) => [i.Role, i.UserDefinedRole, i.Description],
  618182010: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose],
  639542469: (i) => [i.ApplicationDeveloper, i.Version, i.ApplicationFullName, i.ApplicationIdentifier],
  411424972: (i) => [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.Category, i.Condition, i.ArithmeticOperator, i.Components],
  130549933: (i) => [i.Identifier, i.Name, i.Description, i.TimeOfApproval, i.Status, i.Level, i.Qualifier, i.RequestingApproval, i.GivingApproval],
  4037036970: (i) => [i.Name],
  1560379544: (i) => [i.Name, !i.TranslationalStiffnessByLengthX ? null : Labelise(i.TranslationalStiffnessByLengthX), !i.TranslationalStiffnessByLengthY ? null : Labelise(i.TranslationalStiffnessByLengthY), !i.TranslationalStiffnessByLengthZ ? null : Labelise(i.TranslationalStiffnessByLengthZ), !i.RotationalStiffnessByLengthX ? null : Labelise(i.RotationalStiffnessByLengthX), !i.RotationalStiffnessByLengthY ? null : Labelise(i.RotationalStiffnessByLengthY), !i.RotationalStiffnessByLengthZ ? null : Labelise(i.RotationalStiffnessByLengthZ)],
  3367102660: (i) => [i.Name, !i.TranslationalStiffnessByAreaX ? null : Labelise(i.TranslationalStiffnessByAreaX), !i.TranslationalStiffnessByAreaY ? null : Labelise(i.TranslationalStiffnessByAreaY), !i.TranslationalStiffnessByAreaZ ? null : Labelise(i.TranslationalStiffnessByAreaZ)],
  1387855156: (i) => [i.Name, !i.TranslationalStiffnessX ? null : Labelise(i.TranslationalStiffnessX), !i.TranslationalStiffnessY ? null : Labelise(i.TranslationalStiffnessY), !i.TranslationalStiffnessZ ? null : Labelise(i.TranslationalStiffnessZ), !i.RotationalStiffnessX ? null : Labelise(i.RotationalStiffnessX), !i.RotationalStiffnessY ? null : Labelise(i.RotationalStiffnessY), !i.RotationalStiffnessZ ? null : Labelise(i.RotationalStiffnessZ)],
  2069777674: (i) => [i.Name, !i.TranslationalStiffnessX ? null : Labelise(i.TranslationalStiffnessX), !i.TranslationalStiffnessY ? null : Labelise(i.TranslationalStiffnessY), !i.TranslationalStiffnessZ ? null : Labelise(i.TranslationalStiffnessZ), !i.RotationalStiffnessX ? null : Labelise(i.RotationalStiffnessX), !i.RotationalStiffnessY ? null : Labelise(i.RotationalStiffnessY), !i.RotationalStiffnessZ ? null : Labelise(i.RotationalStiffnessZ), !i.WarpingStiffness ? null : Labelise(i.WarpingStiffness)],
  2859738748: (_) => [],
  2614616156: (i) => [i.PointOnRelatingElement, i.PointOnRelatedElement],
  2732653382: (i) => [i.SurfaceOnRelatingElement, i.SurfaceOnRelatedElement],
  775493141: (i) => [i.VolumeOnRelatingElement, i.VolumeOnRelatedElement],
  1959218052: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade],
  1785450214: (i) => [i.SourceCRS, i.TargetCRS],
  1466758467: (i) => [i.Name, i.Description, i.GeodeticDatum, i.VerticalDatum],
  602808272: (i) => [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.Category, i.Condition, i.ArithmeticOperator, i.Components],
  1765591967: (i) => [i.Elements, i.UnitType, i.UserDefinedType],
  1045800335: (i) => [i.Unit, i.Exponent],
  2949456006: (i) => [i.LengthExponent, i.MassExponent, i.TimeExponent, i.ElectricCurrentExponent, i.ThermodynamicTemperatureExponent, i.AmountOfSubstanceExponent, i.LuminousIntensityExponent],
  4294318154: (_) => [],
  3200245327: (i) => [i.Location, i.Identification, i.Name],
  2242383968: (i) => [i.Location, i.Identification, i.Name],
  1040185647: (i) => [i.Location, i.Identification, i.Name],
  3548104201: (i) => [i.Location, i.Identification, i.Name],
  852622518: (i) => [i.AxisTag, i.AxisCurve, i.SameSense],
  3020489413: (i) => [i.TimeStamp, i.ListValues.map((p) => Labelise(p))],
  2655187982: (i) => [i.Name, i.Version, i.Publisher, i.VersionDate, i.Location, i.Description],
  3452421091: (i) => [i.Location, i.Identification, i.Name, i.Description, i.Language, i.ReferencedLibrary],
  4162380809: (i) => [i.MainPlaneAngle, i.SecondaryPlaneAngle, i.LuminousIntensity],
  1566485204: (i) => [i.LightDistributionCurve, i.DistributionData],
  3057273783: (i) => [i.SourceCRS, i.TargetCRS, i.Eastings, i.Northings, i.OrthogonalHeight, i.XAxisAbscissa, i.XAxisOrdinate, i.Scale],
  1847130766: (i) => [i.MaterialClassifications, i.ClassifiedMaterial],
  760658860: (_) => [],
  248100487: (i) => [i.Material, i.LayerThickness, i.IsVentilated, i.Name, i.Description, i.Category, i.Priority],
  3303938423: (i) => [i.MaterialLayers, i.LayerSetName, i.Description],
  1847252529: (i) => [i.Material, i.LayerThickness, i.IsVentilated, i.Name, i.Description, i.Category, i.Priority, i.OffsetDirection, i.OffsetValues],
  2199411900: (i) => [i.Materials],
  2235152071: (i) => [i.Name, i.Description, i.Material, i.Profile, i.Priority, i.Category],
  164193824: (i) => [i.Name, i.Description, i.MaterialProfiles, i.CompositeProfile],
  552965576: (i) => [i.Name, i.Description, i.Material, i.Profile, i.Priority, i.Category, i.OffsetValues],
  1507914824: (_) => [],
  2597039031: (i) => [Labelise(i.ValueComponent), i.UnitComponent],
  3368373690: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.Benchmark, i.ValueSource, i.DataValue, i.ReferencePath],
  2706619895: (i) => [i.Currency],
  1918398963: (i) => [i.Dimensions, i.UnitType],
  3701648758: (_) => [],
  2251480897: (i) => [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.BenchmarkValues, i.LogicalAggregator, i.ObjectiveQualifier, i.UserDefinedQualifier],
  4251960020: (i) => [i.Identification, i.Name, i.Description, i.Roles, i.Addresses],
  1207048766: (i) => [i.OwningUser, i.OwningApplication, i.State, i.ChangeAction, i.LastModifiedDate, i.LastModifyingUser, i.LastModifyingApplication, i.CreationDate],
  2077209135: (i) => [i.Identification, i.FamilyName, i.GivenName, i.MiddleNames, i.PrefixTitles, i.SuffixTitles, i.Roles, i.Addresses],
  101040310: (i) => [i.ThePerson, i.TheOrganization, i.Roles],
  2483315170: (i) => [i.Name, i.Description],
  2226359599: (i) => [i.Name, i.Description, i.Unit],
  3355820592: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose, i.InternalLocation, i.AddressLines, i.PostalBox, i.Town, i.Region, i.PostalCode, i.Country],
  677532197: (_) => [],
  2022622350: (i) => [i.Name, i.Description, i.AssignedItems, i.Identifier],
  1304840413: (i) => [i.Name, i.Description, i.AssignedItems, i.Identifier, i.LayerOn, i.LayerFrozen, i.LayerBlocked, i.LayerStyles],
  3119450353: (i) => [i.Name],
  2417041796: (i) => [i.Styles],
  2095639259: (i) => [i.Name, i.Description, i.Representations],
  3958567839: (i) => [i.ProfileType, i.ProfileName],
  3843373140: (i) => [i.Name, i.Description, i.GeodeticDatum, i.VerticalDatum, i.MapProjection, i.MapZone, i.MapUnit],
  986844984: (_) => [],
  3710013099: (i) => [i.Name, i.EnumerationValues.map((p) => Labelise(p)), i.Unit],
  2044713172: (i) => [i.Name, i.Description, i.Unit, i.AreaValue, i.Formula],
  2093928680: (i) => [i.Name, i.Description, i.Unit, i.CountValue, i.Formula],
  931644368: (i) => [i.Name, i.Description, i.Unit, i.LengthValue, i.Formula],
  3252649465: (i) => [i.Name, i.Description, i.Unit, i.TimeValue, i.Formula],
  2405470396: (i) => [i.Name, i.Description, i.Unit, i.VolumeValue, i.Formula],
  825690147: (i) => [i.Name, i.Description, i.Unit, i.WeightValue, i.Formula],
  3915482550: (i) => [i.RecurrenceType, i.DayComponent, i.WeekdayComponent, i.MonthComponent, i.Position, i.Interval, i.Occurrences, i.TimePeriods],
  2433181523: (i) => [i.TypeIdentifier, i.AttributeIdentifier, i.InstanceName, i.ListPositions, i.InnerReference],
  1076942058: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  3377609919: (i) => [i.ContextIdentifier, i.ContextType],
  3008791417: (_) => [],
  1660063152: (i) => [i.MappingOrigin, i.MappedRepresentation],
  2439245199: (i) => [i.Name, i.Description],
  2341007311: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  448429030: (i) => [i.Dimensions, i.UnitType, i.Prefix, i.Name],
  1054537805: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin],
  867548509: (i) => [i.ShapeRepresentations, i.Name, i.Description, i.ProductDefinitional, i.PartOfProductDefinitionShape],
  3982875396: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  4240577450: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  2273995522: (i) => [i.Name],
  2162789131: (i) => [i.Name],
  3478079324: (i) => [i.Name, i.Values, i.Locations],
  609421318: (i) => [i.Name],
  2525727697: (i) => [i.Name],
  3408363356: (i) => [i.Name, i.DeltaTConstant, i.DeltaTY, i.DeltaTZ],
  2830218821: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  3958052878: (i) => [i.Item, i.Styles, i.Name],
  3049322572: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  2934153892: (i) => [i.Name, i.SurfaceReinforcement1, i.SurfaceReinforcement2, i.ShearReinforcement],
  1300840506: (i) => [i.Name, i.Side, i.Styles],
  3303107099: (i) => [i.DiffuseTransmissionColour, i.DiffuseReflectionColour, i.TransmissionColour, i.ReflectanceColour],
  1607154358: (i) => [i.RefractionIndex, i.DispersionFactor],
  846575682: (i) => [i.SurfaceColour, i.Transparency],
  1351298697: (i) => [i.Textures],
  626085974: (i) => [i.RepeatS, i.RepeatT, i.Mode, i.TextureTransform, i.Parameter],
  985171141: (i) => [i.Name, i.Rows, i.Columns],
  2043862942: (i) => [i.Identifier, i.Name, i.Description, i.Unit, i.ReferencePath],
  531007025: (i) => [!i.RowCells ? null : i.RowCells.map((p) => Labelise(p)), i.IsHeading],
  1549132990: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.DurationType, i.ScheduleDuration, i.ScheduleStart, i.ScheduleFinish, i.EarlyStart, i.EarlyFinish, i.LateStart, i.LateFinish, i.FreeFloat, i.TotalFloat, i.IsCritical, i.StatusTime, i.ActualDuration, i.ActualStart, i.ActualFinish, i.RemainingTime, i.Completion],
  2771591690: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.DurationType, i.ScheduleDuration, i.ScheduleStart, i.ScheduleFinish, i.EarlyStart, i.EarlyFinish, i.LateStart, i.LateFinish, i.FreeFloat, i.TotalFloat, i.IsCritical, i.StatusTime, i.ActualDuration, i.ActualStart, i.ActualFinish, i.RemainingTime, i.Completion, i.Recurrence],
  912023232: (i) => [i.Purpose, i.Description, i.UserDefinedPurpose, i.TelephoneNumbers, i.FacsimileNumbers, i.PagerNumber, i.ElectronicMailAddresses, i.WWWHomePageURL, i.MessagingIDs],
  1447204868: (i) => [i.Name, i.TextCharacterAppearance, i.TextStyle, i.TextFontStyle, i.ModelOrDraughting],
  2636378356: (i) => [i.Colour, i.BackgroundColour],
  1640371178: (i) => [!i.TextIndent ? null : Labelise(i.TextIndent), i.TextAlign, i.TextDecoration, !i.LetterSpacing ? null : Labelise(i.LetterSpacing), !i.WordSpacing ? null : Labelise(i.WordSpacing), i.TextTransform, !i.LineHeight ? null : Labelise(i.LineHeight)],
  280115917: (i) => [i.Maps],
  1742049831: (i) => [i.Maps, i.Mode, i.Parameter],
  2552916305: (i) => [i.Maps, i.Vertices, i.MappedTo],
  1210645708: (i) => [i.Coordinates],
  3611470254: (i) => [i.TexCoordsList],
  1199560280: (i) => [i.StartTime, i.EndTime],
  3101149627: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit],
  581633288: (i) => [i.ListValues.map((p) => Labelise(p))],
  1377556343: (_) => [],
  1735638870: (i) => [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items],
  180925521: (i) => [i.Units],
  2799835756: (_) => [],
  1907098498: (i) => [i.VertexGeometry],
  891718957: (i) => [i.IntersectingAxes, i.OffsetDistances],
  1236880293: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.RecurrencePattern, i.Start, i.Finish],
  3869604511: (i) => [i.Name, i.Description, i.RelatingApproval, i.RelatedApprovals],
  3798115385: (i) => [i.ProfileType, i.ProfileName, i.OuterCurve],
  1310608509: (i) => [i.ProfileType, i.ProfileName, i.Curve],
  2705031697: (i) => [i.ProfileType, i.ProfileName, i.OuterCurve, i.InnerCurves],
  616511568: (i) => [i.RepeatS, i.RepeatT, i.Mode, i.TextureTransform, i.Parameter, i.RasterFormat, i.RasterCode],
  3150382593: (i) => [i.ProfileType, i.ProfileName, i.Curve, i.Thickness],
  747523909: (i) => [i.Source, i.Edition, i.EditionDate, i.Name, i.Description, i.Location, i.ReferenceTokens],
  647927063: (i) => [i.Location, i.Identification, i.Name, i.ReferencedSource, i.Description, i.Sort],
  3285139300: (i) => [i.ColourList],
  3264961684: (i) => [i.Name],
  1485152156: (i) => [i.ProfileType, i.ProfileName, i.Profiles, i.Label],
  370225590: (i) => [i.CfsFaces],
  1981873012: (i) => [i.CurveOnRelatingElement, i.CurveOnRelatedElement],
  45288368: (i) => [i.PointOnRelatingElement, i.PointOnRelatedElement, i.EccentricityInX, i.EccentricityInY, i.EccentricityInZ],
  3050246964: (i) => [i.Dimensions, i.UnitType, i.Name],
  2889183280: (i) => [i.Dimensions, i.UnitType, i.Name, i.ConversionFactor],
  2713554722: (i) => [i.Dimensions, i.UnitType, i.Name, i.ConversionFactor, i.ConversionOffset],
  539742890: (i) => [i.Name, i.Description, i.RelatingMonetaryUnit, i.RelatedMonetaryUnit, i.ExchangeRate, i.RateDateTime, i.RateSource],
  3800577675: (i) => [i.Name, i.CurveFont, !i.CurveWidth ? null : Labelise(i.CurveWidth), i.CurveColour, i.ModelOrDraughting],
  1105321065: (i) => [i.Name, i.PatternList],
  2367409068: (i) => [i.Name, i.CurveFont, i.CurveFontScaling],
  3510044353: (i) => [i.VisibleSegmentLength, i.InvisibleSegmentLength],
  3632507154: (i) => [i.ProfileType, i.ProfileName, i.ParentProfile, i.Operator, i.Label],
  1154170062: (i) => [i.Identification, i.Name, i.Description, i.Location, i.Purpose, i.IntendedUse, i.Scope, i.Revision, i.DocumentOwner, i.Editors, i.CreationTime, i.LastRevisionTime, i.ElectronicFormat, i.ValidFrom, i.ValidUntil, i.Confidentiality, i.Status],
  770865208: (i) => [i.Name, i.Description, i.RelatingDocument, i.RelatedDocuments, i.RelationshipType],
  3732053477: (i) => [i.Location, i.Identification, i.Name, i.Description, i.ReferencedDocument],
  3900360178: (i) => [i.EdgeStart, i.EdgeEnd],
  476780140: (i) => [i.EdgeStart, i.EdgeEnd, i.EdgeGeometry, i.SameSense],
  211053100: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.ActualDate, i.EarlyDate, i.LateDate, i.ScheduleDate],
  297599258: (i) => [i.Name, i.Description, i.Properties],
  1437805879: (i) => [i.Name, i.Description, i.RelatingReference, i.RelatedResourceObjects],
  2556980723: (i) => [i.Bounds],
  1809719519: (i) => [i.Bound, i.Orientation],
  803316827: (i) => [i.Bound, i.Orientation],
  3008276851: (i) => [i.Bounds, i.FaceSurface, i.SameSense],
  4219587988: (i) => [i.Name, i.TensionFailureX, i.TensionFailureY, i.TensionFailureZ, i.CompressionFailureX, i.CompressionFailureY, i.CompressionFailureZ],
  738692330: (i) => [i.Name, i.FillStyles, i.ModelorDraughting],
  3448662350: (i) => [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth],
  2453401579: (_) => [],
  4142052618: (i) => [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth, i.ParentContext, i.TargetScale, i.TargetView, i.UserDefinedTargetView],
  3590301190: (i) => [i.Elements],
  178086475: (i) => [i.PlacementLocation, i.PlacementRefDirection],
  812098782: (i) => [i.BaseSurface, i.AgreementFlag],
  3905492369: (i) => [i.RepeatS, i.RepeatT, i.Mode, i.TextureTransform, i.Parameter, i.URLReference],
  3570813810: (i) => [i.MappedTo, i.Opacity, i.Colours, i.ColourIndex],
  1437953363: (i) => [i.Maps, i.MappedTo, i.TexCoords],
  2133299955: (i) => [i.Maps, i.MappedTo, i.TexCoords, i.TexCoordIndex],
  3741457305: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.Values],
  1585845231: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, Labelise(i.LagValue), i.DurationType],
  1402838566: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity],
  125510826: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity],
  2604431987: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Orientation],
  4266656042: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.ColourAppearance, i.ColourTemperature, i.LuminousFlux, i.LightEmissionSource, i.LightDistributionDataSource],
  1520743889: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation],
  3422422726: (i) => [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation, i.Orientation, i.ConcentrationExponent, i.SpreadAngle, i.BeamWidthAngle],
  2624227202: (i) => [i.PlacementRelTo, i.RelativePlacement],
  1008929658: (_) => [],
  2347385850: (i) => [i.MappingSource, i.MappingTarget],
  1838606355: (i) => [i.Name, i.Description, i.Category],
  3708119e3: (i) => [i.Name, i.Description, i.Material, i.Fraction, i.Category],
  2852063980: (i) => [i.Name, i.Description, i.MaterialConstituents],
  2022407955: (i) => [i.Name, i.Description, i.Representations, i.RepresentedMaterial],
  1303795690: (i) => [i.ForLayerSet, i.LayerSetDirection, i.DirectionSense, i.OffsetFromReferenceLine, i.ReferenceExtent],
  3079605661: (i) => [i.ForProfileSet, i.CardinalPoint, i.ReferenceExtent],
  3404854881: (i) => [i.ForProfileSet, i.CardinalPoint, i.ReferenceExtent, i.ForProfileEndSet, i.CardinalEndPoint],
  3265635763: (i) => [i.Name, i.Description, i.Properties, i.Material],
  853536259: (i) => [i.Name, i.Description, i.RelatingMaterial, i.RelatedMaterials, i.Expression],
  2998442950: (i) => [i.ProfileType, i.ProfileName, i.ParentProfile, i.Operator, i.Label],
  219451334: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  2665983363: (i) => [i.CfsFaces],
  1411181986: (i) => [i.Name, i.Description, i.RelatingOrganization, i.RelatedOrganizations],
  1029017970: (i) => [i.EdgeStart, i.EdgeEnd, i.EdgeElement, i.Orientation],
  2529465313: (i) => [i.ProfileType, i.ProfileName, i.Position],
  2519244187: (i) => [i.EdgeList],
  3021840470: (i) => [i.Name, i.Description, i.HasQuantities, i.Discrimination, i.Quality, i.Usage],
  597895409: (i) => [i.RepeatS, i.RepeatT, i.Mode, i.TextureTransform, i.Parameter, i.Width, i.Height, i.ColourComponents, i.Pixel],
  2004835150: (i) => [i.Location],
  1663979128: (i) => [i.SizeInX, i.SizeInY],
  2067069095: (_) => [],
  4022376103: (i) => [i.BasisCurve, i.PointParameter],
  1423911732: (i) => [i.BasisSurface, i.PointParameterU, i.PointParameterV],
  2924175390: (i) => [i.Polygon],
  2775532180: (i) => [i.BaseSurface, i.AgreementFlag, i.Position, i.PolygonalBoundary],
  3727388367: (i) => [i.Name],
  3778827333: (_) => [],
  1775413392: (i) => [i.Name],
  673634403: (i) => [i.Name, i.Description, i.Representations],
  2802850158: (i) => [i.Name, i.Description, i.Properties, i.ProfileDefinition],
  2598011224: (i) => [i.Name, i.Description],
  1680319473: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  148025276: (i) => [i.Name, i.Description, i.DependingProperty, i.DependantProperty, i.Expression],
  3357820518: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  1482703590: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  2090586900: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  3615266464: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim],
  3413951693: (i) => [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.TimeStep, i.Values],
  1580146022: (i) => [i.TotalCrossSectionArea, i.SteelGrade, i.BarSurface, i.EffectiveDepth, i.NominalBarDiameter, i.BarCount],
  478536968: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  2943643501: (i) => [i.Name, i.Description, i.RelatedResourceObjects, i.RelatingApproval],
  1608871552: (i) => [i.Name, i.Description, i.RelatingConstraint, i.RelatedResourceObjects],
  1042787934: (i) => [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.ScheduleWork, i.ScheduleUsage, i.ScheduleStart, i.ScheduleFinish, i.ScheduleContour, i.LevelingDelay, i.IsOverAllocated, i.StatusTime, i.ActualWork, i.ActualUsage, i.ActualStart, i.ActualFinish, i.RemainingWork, i.RemainingUsage, i.Completion],
  2778083089: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.RoundingRadius],
  2042790032: (i) => [i.SectionType, i.StartProfile, i.EndProfile],
  4165799628: (i) => [i.LongitudinalStartPosition, i.LongitudinalEndPosition, i.TransversePosition, i.ReinforcementRole, i.SectionDefinition, i.CrossSectionReinforcementDefinitions],
  1509187699: (i) => [i.SpineCurve, i.CrossSections, i.CrossSectionPositions],
  4124623270: (i) => [i.SbsmBoundary],
  3692461612: (i) => [i.Name, i.Description],
  2609359061: (i) => [i.Name, i.SlippageX, i.SlippageY, i.SlippageZ],
  723233188: (_) => [],
  1595516126: (i) => [i.Name, i.LinearForceX, i.LinearForceY, i.LinearForceZ, i.LinearMomentX, i.LinearMomentY, i.LinearMomentZ],
  2668620305: (i) => [i.Name, i.PlanarForceX, i.PlanarForceY, i.PlanarForceZ],
  2473145415: (i) => [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ],
  1973038258: (i) => [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ, i.Distortion],
  1597423693: (i) => [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ],
  1190533807: (i) => [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ, i.WarpingMoment],
  2233826070: (i) => [i.EdgeStart, i.EdgeEnd, i.ParentEdge],
  2513912981: (_) => [],
  1878645084: (i) => [i.SurfaceColour, i.Transparency, i.DiffuseColour, i.TransmissionColour, i.DiffuseTransmissionColour, i.ReflectionColour, i.SpecularColour, !i.SpecularHighlight ? null : Labelise(i.SpecularHighlight), i.ReflectanceMethod],
  2247615214: (i) => [i.SweptArea, i.Position],
  1260650574: (i) => [i.Directrix, i.Radius, i.InnerRadius, i.StartParam, i.EndParam],
  1096409881: (i) => [i.Directrix, i.Radius, i.InnerRadius, i.StartParam, i.EndParam, i.FilletRadius],
  230924584: (i) => [i.SweptCurve, i.Position],
  3071757647: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.FlangeEdgeRadius, i.WebEdgeRadius, i.WebSlope, i.FlangeSlope],
  901063453: (_) => [],
  4282788508: (i) => [i.Literal, i.Placement, i.Path],
  3124975700: (i) => [i.Literal, i.Placement, i.Path, i.Extent, i.BoxAlignment],
  1983826977: (i) => [i.Name, i.FontFamily, i.FontStyle, i.FontVariant, i.FontWeight, Labelise(i.FontSize)],
  2715220739: (i) => [i.ProfileType, i.ProfileName, i.Position, i.BottomXDim, i.TopXDim, i.YDim, i.TopXOffset],
  1628702193: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets],
  3736923433: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType],
  2347495698: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag],
  3698973494: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType],
  427810014: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius, i.FlangeSlope],
  1417489154: (i) => [i.Orientation, i.Magnitude],
  2759199220: (i) => [i.LoopVertex],
  1299126871: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ConstructionType, i.OperationType, i.ParameterTakesPrecedence, i.Sizeable],
  2543172580: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius],
  3406155212: (i) => [i.Bounds, i.FaceSurface, i.SameSense],
  669184980: (i) => [i.OuterBoundary, i.InnerBoundaries],
  3207858831: (i) => [i.ProfileType, i.ProfileName, i.Position, i.BottomFlangeWidth, i.OverallDepth, i.WebThickness, i.BottomFlangeThickness, i.BottomFlangeFilletRadius, i.TopFlangeWidth, i.TopFlangeThickness, i.TopFlangeFilletRadius, i.BottomFlangeEdgeRadius, i.BottomFlangeSlope, i.TopFlangeEdgeRadius, i.TopFlangeSlope],
  4261334040: (i) => [i.Location, i.Axis],
  3125803723: (i) => [i.Location, i.RefDirection],
  2740243338: (i) => [i.Location, i.Axis, i.RefDirection],
  2736907675: (i) => [i.Operator, i.FirstOperand, i.SecondOperand],
  4182860854: (_) => [],
  2581212453: (i) => [i.Corner, i.XDim, i.YDim, i.ZDim],
  2713105998: (i) => [i.BaseSurface, i.AgreementFlag, i.Enclosure],
  2898889636: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.WallThickness, i.Girth, i.InternalFilletRadius],
  1123145078: (i) => [i.Coordinates],
  574549367: (_) => [],
  1675464909: (i) => [i.CoordList],
  2059837836: (i) => [i.CoordList],
  59481748: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale],
  3749851601: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale],
  3486308946: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Scale2],
  3331915920: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3],
  1416205885: (i) => [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3, i.Scale2, i.Scale3],
  1383045692: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Radius],
  2205249479: (i) => [i.CfsFaces],
  776857604: (i) => [i.Name, i.Red, i.Green, i.Blue],
  2542286263: (i) => [i.Name, i.Description, i.UsageName, i.HasProperties],
  2485617015: (i) => [i.Transition, i.SameSense, i.ParentCurve],
  2574617495: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity],
  3419103109: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext],
  1815067380: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  2506170314: (i) => [i.Position],
  2147822146: (i) => [i.TreeRootExpression],
  2601014836: (_) => [],
  2827736869: (i) => [i.BasisSurface, i.OuterBoundary, i.InnerBoundaries],
  2629017746: (i) => [i.BasisSurface, i.Boundaries, i.ImplicitOuter],
  32440307: (i) => [i.DirectionRatios],
  526551008: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.OperationType, i.ConstructionType, i.ParameterTakesPrecedence, i.Sizeable],
  1472233963: (i) => [i.EdgeList],
  1883228015: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.MethodOfMeasurement, i.Quantities],
  339256511: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2777663545: (i) => [i.Position],
  2835456948: (i) => [i.ProfileType, i.ProfileName, i.Position, i.SemiAxis1, i.SemiAxis2],
  4024345920: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType, i.EventTriggerType, i.UserDefinedEventTriggerType],
  477187591: (i) => [i.SweptArea, i.Position, i.ExtrudedDirection, i.Depth],
  2804161546: (i) => [i.SweptArea, i.Position, i.ExtrudedDirection, i.Depth, i.EndSweptArea],
  2047409740: (i) => [i.FbsmFaces],
  374418227: (i) => [i.HatchLineAppearance, i.StartOfNextHatchLine, i.PointOfReferenceHatchLine, i.PatternStart, i.HatchLineAngle],
  315944413: (i) => [i.TilingPattern, i.Tiles, i.TilingScale],
  2652556860: (i) => [i.SweptArea, i.Position, i.Directrix, i.StartParam, i.EndParam, i.FixedReference],
  4238390223: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1268542332: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.AssemblyPlace, i.PredefinedType],
  4095422895: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  987898635: (i) => [i.Elements],
  1484403080: (i) => [i.ProfileType, i.ProfileName, i.Position, i.OverallWidth, i.OverallDepth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.FlangeEdgeRadius, i.FlangeSlope],
  178912537: (i) => [i.CoordIndex],
  2294589976: (i) => [i.CoordIndex, i.InnerCoordIndices],
  572779678: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.Thickness, i.FilletRadius, i.EdgeRadius, i.LegSlope],
  428585644: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1281925730: (i) => [i.Pnt, i.Dir],
  1425443689: (i) => [i.Outer],
  3888040117: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  3388369263: (i) => [i.BasisCurve, i.Distance, i.SelfIntersect],
  3505215534: (i) => [i.BasisCurve, i.Distance, i.SelfIntersect, i.RefDirection],
  1682466193: (i) => [i.BasisSurface, i.ReferenceCurve],
  603570806: (i) => [i.SizeInX, i.SizeInY, i.Placement],
  220341763: (i) => [i.Position],
  759155922: (i) => [i.Name],
  2559016684: (i) => [i.Name],
  3967405729: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  569719735: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType],
  2945172077: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription],
  4208778838: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  103090709: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext],
  653396225: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext],
  871118103: (i) => [i.Name, i.Description, !i.UpperBoundValue ? null : Labelise(i.UpperBoundValue), !i.LowerBoundValue ? null : Labelise(i.LowerBoundValue), i.Unit, !i.SetPointValue ? null : Labelise(i.SetPointValue)],
  4166981789: (i) => [i.Name, i.Description, !i.EnumerationValues ? null : i.EnumerationValues.map((p) => Labelise(p)), i.EnumerationReference],
  2752243245: (i) => [i.Name, i.Description, !i.ListValues ? null : i.ListValues.map((p) => Labelise(p)), i.Unit],
  941946838: (i) => [i.Name, i.Description, i.UsageName, i.PropertyReference],
  1451395588: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.HasProperties],
  492091185: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.TemplateType, i.ApplicableEntity, i.HasPropertyTemplates],
  3650150729: (i) => [i.Name, i.Description, !i.NominalValue ? null : Labelise(i.NominalValue), i.Unit],
  110355661: (i) => [i.Name, i.Description, !i.DefiningValues ? null : i.DefiningValues.map((p) => Labelise(p)), !i.DefinedValues ? null : i.DefinedValues.map((p) => Labelise(p)), i.Expression, i.DefiningUnit, i.DefinedUnit, i.CurveInterpolation],
  3521284610: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  3219374653: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.ProxyType, i.Tag],
  2770003689: (i) => [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.WallThickness, i.InnerFilletRadius, i.OuterFilletRadius],
  2798486643: (i) => [i.Position, i.XLength, i.YLength, i.Height],
  3454111270: (i) => [i.BasisSurface, i.U1, i.V1, i.U2, i.V2, i.Usense, i.Vsense],
  3765753017: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.DefinitionType, i.ReinforcementSectionDefinitions],
  3939117080: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType],
  1683148259: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingActor, i.ActingRole],
  2495723537: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl],
  1307041759: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingGroup],
  1027710054: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingGroup, i.Factor],
  4278684876: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProcess, i.QuantityInProcess],
  2857406711: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProduct],
  205026976: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingResource],
  1865459582: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects],
  4095574036: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingApproval],
  919958153: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingClassification],
  2728634034: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.Intent, i.RelatingConstraint],
  982818633: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingDocument],
  3840914261: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingLibrary],
  2655215786: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingMaterial],
  826625072: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  1204542856: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement],
  3945020480: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RelatingPriorities, i.RelatedPriorities, i.RelatedConnectionType, i.RelatingConnectionType],
  4201705270: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedElement],
  3190031847: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedPort, i.RealizingElement],
  2127690289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedStructuralActivity],
  1638771189: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem],
  504942748: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem, i.ConnectionConstraint],
  3678494232: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RealizingElements, i.ConnectionType],
  3242617779: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure],
  886880790: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedCoverings],
  2802773753: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedCoverings],
  2565941209: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingContext, i.RelatedDefinitions],
  2551354335: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  693640335: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description],
  1462361463: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingObject],
  4186316022: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingPropertyDefinition],
  307848117: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedPropertySets, i.RelatingTemplate],
  781010003: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingType],
  3940055652: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingOpeningElement, i.RelatedBuildingElement],
  279856033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedControlElements, i.RelatingFlowElement],
  427948657: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedElement, i.InterferenceGeometry, i.InterferenceType, i.ImpliedOrder],
  3268803585: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects],
  750771296: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedFeatureElement],
  1245217292: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure],
  4122056220: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingProcess, i.RelatedProcess, i.TimeLag, i.SequenceType, i.UserDefinedSequenceType],
  366585022: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSystem, i.RelatedBuildings],
  3451746338: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary],
  3523091289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary, i.ParentBoundary],
  1521410863: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary, i.ParentBoundary, i.CorrespondingBoundary],
  1401173127: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedOpeningElement],
  816062949: (i) => [i.Transition, i.SameSense, i.ParentCurve, i.ParamLength],
  2914609552: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription],
  1856042241: (i) => [i.SweptArea, i.Position, i.Axis, i.Angle],
  3243963512: (i) => [i.SweptArea, i.Position, i.Axis, i.Angle, i.EndSweptArea],
  4158566097: (i) => [i.Position, i.Height, i.BottomRadius],
  3626867408: (i) => [i.Position, i.Height, i.Radius],
  3663146110: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.TemplateType, i.PrimaryMeasureType, i.SecondaryMeasureType, i.Enumerators, i.PrimaryUnit, i.SecondaryUnit, i.Expression, i.AccessState],
  1412071761: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName],
  710998568: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2706606064: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType],
  3893378262: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  463610769: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.PredefinedType],
  2481509218: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.LongName],
  451544542: (i) => [i.Position, i.Radius],
  4015995234: (i) => [i.Position, i.Radius],
  3544373492: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  3136571912: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  530289379: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  3689010777: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  3979015343: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness],
  2218152070: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness],
  603775116: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.PredefinedType],
  4095615324: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  699246055: (i) => [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation],
  2028607225: (i) => [i.SweptArea, i.Position, i.Directrix, i.StartParam, i.EndParam, i.ReferenceSurface],
  2809605785: (i) => [i.SweptCurve, i.Position, i.ExtrudedDirection, i.Depth],
  4124788165: (i) => [i.SweptCurve, i.Position, i.AxisPosition],
  1580310250: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3473067441: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Status, i.WorkMethod, i.IsMilestone, i.Priority, i.TaskTime, i.PredefinedType],
  3206491090: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType, i.WorkMethod],
  2387106220: (i) => [i.Coordinates],
  1935646853: (i) => [i.Position, i.MajorRadius, i.MinorRadius],
  2097647324: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2916149573: (i) => [i.Coordinates, i.Normals, i.Closed, i.CoordIndex, i.PnIndex],
  336235671: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.TransomThickness, i.MullionThickness, i.FirstTransomOffset, i.SecondTransomOffset, i.FirstMullionOffset, i.SecondMullionOffset, i.ShapeAspectStyle, i.LiningOffset, i.LiningToPanelOffsetX, i.LiningToPanelOffsetY],
  512836454: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle],
  2296667514: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor],
  1635779807: (i) => [i.Outer],
  2603310189: (i) => [i.Outer, i.Voids],
  1674181508: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  2887950389: (i) => [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, i.UClosed, i.VClosed, i.SelfIntersect],
  167062518: (i) => [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, i.UClosed, i.VClosed, i.SelfIntersect, i.UMultiplicities, i.VMultiplicities, i.UKnots, i.VKnots, i.KnotSpec],
  1334484129: (i) => [i.Position, i.XLength, i.YLength, i.ZLength],
  3649129432: (i) => [i.Operator, i.FirstOperand, i.SecondOperand],
  1260505505: (_) => [],
  4031249490: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.ElevationOfRefHeight, i.ElevationOfTerrain, i.BuildingAddress],
  1950629157: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3124254112: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.Elevation],
  2197970202: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2937912522: (i) => [i.ProfileType, i.ProfileName, i.Position, i.Radius, i.WallThickness],
  3893394355: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  300633059: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3875453745: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.UsageName, i.TemplateType, i.HasPropertyTemplates],
  3732776249: (i) => [i.Segments, i.SelfIntersect],
  15328376: (i) => [i.Segments, i.SelfIntersect],
  2510884976: (i) => [i.Position],
  2185764099: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  4105962743: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1525564444: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  2559216714: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity],
  3293443760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification],
  3895139033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.CostValues, i.CostQuantities],
  1419761937: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.SubmittedOn, i.UpdateDate],
  1916426348: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3295246426: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1457835157: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1213902940: (i) => [i.Position, i.Radius],
  3256556792: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3849074793: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2963535650: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.ThresholdDepth, i.ThresholdThickness, i.TransomThickness, i.TransomOffset, i.LiningOffset, i.ThresholdOffset, i.CasingThickness, i.CasingDepth, i.ShapeAspectStyle, i.LiningToPanelOffsetX, i.LiningToPanelOffsetY],
  1714330368: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.PanelDepth, i.PanelOperation, i.PanelWidth, i.PanelPosition, i.ShapeAspectStyle],
  2323601079: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.OperationType, i.ParameterTakesPrecedence, i.UserDefinedOperationType],
  445594917: (i) => [i.Name],
  4006246654: (i) => [i.Name],
  1758889154: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4123344466: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.AssemblyPlace, i.PredefinedType],
  2397081782: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1623761950: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2590856083: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1704287377: (i) => [i.Position, i.SemiAxis1, i.SemiAxis2],
  2107101300: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  132023988: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3174744832: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3390157468: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4148101412: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.PredefinedType, i.EventTriggerType, i.UserDefinedEventTriggerType, i.EventOccurenceTime],
  2853485674: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName],
  807026263: (i) => [i.Outer],
  3737207727: (i) => [i.Outer, i.Voids],
  647756555: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2489546625: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2827207264: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2143335405: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1287392070: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3907093117: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3198132628: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3815607619: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1482959167: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1834744321: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1339347760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2297155007: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  3009222698: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1893162501: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  263784265: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  1509553395: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3493046030: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3009204131: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.UAxes, i.VAxes, i.WAxes, i.PredefinedType],
  2706460486: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  1251058090: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1806887404: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2571569899: (i) => [i.Points, !i.Segments ? null : i.Segments.map((p) => Labelise(p)), i.SelfIntersect],
  3946677679: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3113134337: (i) => [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation],
  2391368822: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.Jurisdiction, i.ResponsiblePersons, i.LastUpdateDate, i.CurrentValue, i.OriginalValue],
  4288270099: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3827777499: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1051575348: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1161773419: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  377706215: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NominalDiameter, i.NominalLength, i.PredefinedType],
  2108223431: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.NominalLength],
  1114901282: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3181161470: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  977012517: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4143007308: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor, i.PredefinedType],
  3588315303: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3079942009: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2837617999: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2382730787: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LifeCyclePhase, i.PredefinedType],
  3566463478: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle],
  3327091369: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription],
  1158309216: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  804291784: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4231323485: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4017108033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2839578677: (i) => [i.Coordinates, i.Closed, i.Faces, i.PnIndex],
  3724593414: (i) => [i.Points],
  3740093272: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation],
  2744685151: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.PredefinedType],
  2904328755: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription],
  3651124850: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1842657554: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2250791053: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2893384427: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2324767716: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1469900589: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  683857671: (i) => [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, i.UClosed, i.VClosed, i.SelfIntersect, i.UMultiplicities, i.VMultiplicities, i.UKnots, i.VKnots, i.KnotSpec, i.WeightsData],
  3027567501: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade],
  964333572: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  2320036040: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.MeshLength, i.MeshWidth, i.LongitudinalBarNominalDiameter, i.TransverseBarNominalDiameter, i.LongitudinalBarCrossSectionArea, i.TransverseBarCrossSectionArea, i.LongitudinalBarSpacing, i.TransverseBarSpacing, i.PredefinedType],
  2310774935: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.MeshLength, i.MeshWidth, i.LongitudinalBarNominalDiameter, i.TransverseBarNominalDiameter, i.LongitudinalBarCrossSectionArea, i.TransverseBarCrossSectionArea, i.LongitudinalBarSpacing, i.TransverseBarSpacing, i.BendingShapeCode, !i.BendingParameters ? null : i.BendingParameters.map((p) => Labelise(p))],
  160246688: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects],
  2781568857: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1768891740: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2157484638: (i) => [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation],
  4074543187: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4097777520: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.RefLatitude, i.RefLongitude, i.RefElevation, i.LandTitleNumber, i.SiteAddress],
  2533589738: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1072016465: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3856911033: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType, i.ElevationWithFlooring],
  1305183839: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3812236995: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.LongName],
  3112655638: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1039846685: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  338393293: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  682877961: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad],
  1179482911: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition],
  1004757350: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.ProjectedOrTrue, i.PredefinedType],
  4243806635: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition, i.Axis],
  214636428: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Axis],
  2445595289: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Axis],
  2757150158: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.PredefinedType],
  1807405624: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.ProjectedOrTrue, i.PredefinedType],
  1252848954: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.ActionType, i.ActionSource, i.Coefficient, i.Purpose],
  2082059205: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad],
  734778138: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition, i.ConditionCoordinateSystem],
  1235345126: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal],
  2986769608: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheoryType, i.ResultForLoadGroup, i.IsLinear],
  3657597509: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.ProjectedOrTrue, i.PredefinedType],
  1975003073: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition],
  148013059: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  3101698114: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2315554128: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2254336722: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType],
  413509423: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  5716631: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3824725483: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.TensionForce, i.PreStress, i.FrictionCoefficient, i.AnchorageSlip, i.MinCurvatureRadius],
  2347447852: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType],
  3081323446: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2415094496: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.SheathDiameter],
  1692211062: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1620046519: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3593883385: (i) => [i.BasisCurve, i.Trim1, i.Trim2, i.SenseAgreement, i.MasterRepresentation],
  1600972822: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1911125066: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  728799441: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2391383451: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3313531582: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2769231204: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  926996030: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1898987631: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1133259667: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4009809668: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.PartitioningType, i.ParameterTakesPrecedence, i.UserDefinedPartitioningType],
  4088093105: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.WorkingTimes, i.ExceptionTimes, i.PredefinedType],
  1028945134: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime],
  4218914973: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.PredefinedType],
  3342526732: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.PredefinedType],
  1033361043: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName],
  3821786052: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription],
  1411407467: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3352864051: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1871374353: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3460190687: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.OriginalValue, i.CurrentValue, i.TotalReplacementCost, i.Owner, i.User, i.ResponsiblePerson, i.IncorporationDate, i.DepreciatedValue],
  1532957894: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1967976161: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect],
  2461110595: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect, i.KnotMultiplicities, i.Knots, i.KnotSpec],
  819618141: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  231477066: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1136057603: (i) => [i.Segments, i.SelfIntersect],
  3299480353: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2979338954: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  39481116: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1095909175: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1909888760: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1177604601: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.LongName],
  2188180465: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  395041908: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3293546465: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2674252688: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1285652485: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2951183804: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3296154744: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2611217952: (i) => [i.Position, i.Radius],
  1677625105: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2301859152: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  843113511: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  905975707: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  400855858: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3850581409: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2816379211: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3898045240: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  1060000209: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  488727124: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType],
  335055490: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2954562838: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1973544240: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3495092785: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3961806047: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1335981549: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2635815018: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1599208980: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2063403501: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType],
  1945004755: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3040386961: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3041715199: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.FlowDirection, i.PredefinedType, i.SystemType],
  3205830791: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.PredefinedType],
  395920057: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.OperationType, i.UserDefinedOperationType],
  3242481149: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.OperationType, i.UserDefinedOperationType],
  869906466: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3760055223: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2030761528: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  663422040: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2417008758: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  3277789161: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1534661035: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1217240411: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  712377611: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1658829314: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2814081492: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3747195512: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  484807127: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1209101575: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.PredefinedType],
  346874300: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1810631287: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4222183408: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2058353004: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4278956645: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  4037862832: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  2188021234: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3132237377: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  987401354: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  707683696: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  2223149337: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  3508470533: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  900683007: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3319311131: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2068733104: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4175244083: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2176052936: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  76236018: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  629592764: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1437502449: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1073191201: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1911478936: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2474470126: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  144952367: (i) => [i.Segments, i.SelfIntersect],
  3694346114: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1687234759: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType, i.ConstructionType],
  310824031: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3612865200: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3171933400: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1156407060: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  738039164: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  655969474: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  90941305: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2262370178: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3024970846: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3283111854: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1232101972: (i) => [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect, i.KnotMultiplicities, i.Knots, i.KnotSpec, i.WeightsData],
  979691226: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.NominalDiameter, i.CrossSectionArea, i.BarLength, i.PredefinedType, i.BarSurface],
  2572171363: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.BarLength, i.BarSurface, i.BendingShapeCode, !i.BendingParameters ? null : i.BendingParameters.map((p) => Labelise(p))],
  2016517767: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3053780830: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1783015770: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1329646415: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1529196076: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3127900445: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3027962421: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3420628829: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1999602285: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1404847402: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  331165859: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4252922144: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NumberOfRisers, i.NumberOfTreads, i.RiserHeight, i.TreadLength, i.PredefinedType],
  2515109513: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.OrientationOf2DPlane, i.LoadedBy, i.HasResults, i.SharedPlacement],
  385403989: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.ActionType, i.ActionSource, i.Coefficient, i.Purpose, i.SelfWeightCoefficients],
  1621171031: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.ProjectedOrTrue, i.PredefinedType],
  1162798199: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  812556717: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3825984169: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3026737570: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3179687236: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4292641817: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4207607924: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2391406946: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4156078855: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3512223829: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4237592921: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3304561284: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.PartitioningType, i.UserDefinedPartitioningType],
  486154966: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.PartitioningType, i.UserDefinedPartitioningType],
  2874132201: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  1634111441: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  177149247: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2056796094: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3001207471: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  277319702: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  753842376: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2906023776: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  32344328: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2938176219: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  635142910: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3758799889: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1051757585: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4217484030: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3902619387: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  639361253: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3221913625: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3571504051: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2272882330: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  578613899: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType],
  4136498852: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3640358203: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4074379575: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1052013943: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  562808652: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.PredefinedType],
  1062813311: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag],
  342316401: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3518393246: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1360408905: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1904799276: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  862014818: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3310460725: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  264262732: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  402227799: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1003880860: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3415622556: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  819412036: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  1426591983: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  182646315: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  2295281155: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4086658281: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  630975310: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  4288193352: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  3087945054: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType],
  25142252: (i) => [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType]
};
TypeInitialisers[3] = {
  3699917729: (v) => new IFC4.IfcAbsorbedDoseMeasure(v),
  4182062534: (v) => new IFC4.IfcAccelerationMeasure(v),
  360377573: (v) => new IFC4.IfcAmountOfSubstanceMeasure(v),
  632304761: (v) => new IFC4.IfcAngularVelocityMeasure(v),
  3683503648: (v) => new IFC4.IfcArcIndex(v),
  1500781891: (v) => new IFC4.IfcAreaDensityMeasure(v),
  2650437152: (v) => new IFC4.IfcAreaMeasure(v),
  2314439260: (v) => new IFC4.IfcBinary(v),
  2735952531: (v) => new IFC4.IfcBoolean(v),
  1867003952: (v) => new IFC4.IfcBoxAlignment(v),
  1683019596: (v) => new IFC4.IfcCardinalPointReference(v),
  2991860651: (v) => new IFC4.IfcComplexNumber(v),
  3812528620: (v) => new IFC4.IfcCompoundPlaneAngleMeasure(v),
  3238673880: (v) => new IFC4.IfcContextDependentMeasure(v),
  1778710042: (v) => new IFC4.IfcCountMeasure(v),
  94842927: (v) => new IFC4.IfcCurvatureMeasure(v),
  937566702: (v) => new IFC4.IfcDate(v),
  2195413836: (v) => new IFC4.IfcDateTime(v),
  86635668: (v) => new IFC4.IfcDayInMonthNumber(v),
  3701338814: (v) => new IFC4.IfcDayInWeekNumber(v),
  1514641115: (v) => new IFC4.IfcDescriptiveMeasure(v),
  4134073009: (v) => new IFC4.IfcDimensionCount(v),
  524656162: (v) => new IFC4.IfcDoseEquivalentMeasure(v),
  2541165894: (v) => new IFC4.IfcDuration(v),
  69416015: (v) => new IFC4.IfcDynamicViscosityMeasure(v),
  1827137117: (v) => new IFC4.IfcElectricCapacitanceMeasure(v),
  3818826038: (v) => new IFC4.IfcElectricChargeMeasure(v),
  2093906313: (v) => new IFC4.IfcElectricConductanceMeasure(v),
  3790457270: (v) => new IFC4.IfcElectricCurrentMeasure(v),
  2951915441: (v) => new IFC4.IfcElectricResistanceMeasure(v),
  2506197118: (v) => new IFC4.IfcElectricVoltageMeasure(v),
  2078135608: (v) => new IFC4.IfcEnergyMeasure(v),
  1102727119: (v) => new IFC4.IfcFontStyle(v),
  2715512545: (v) => new IFC4.IfcFontVariant(v),
  2590844177: (v) => new IFC4.IfcFontWeight(v),
  1361398929: (v) => new IFC4.IfcForceMeasure(v),
  3044325142: (v) => new IFC4.IfcFrequencyMeasure(v),
  3064340077: (v) => new IFC4.IfcGloballyUniqueId(v),
  3113092358: (v) => new IFC4.IfcHeatFluxDensityMeasure(v),
  1158859006: (v) => new IFC4.IfcHeatingValueMeasure(v),
  983778844: (v) => new IFC4.IfcIdentifier(v),
  3358199106: (v) => new IFC4.IfcIlluminanceMeasure(v),
  2679005408: (v) => new IFC4.IfcInductanceMeasure(v),
  1939436016: (v) => new IFC4.IfcInteger(v),
  3809634241: (v) => new IFC4.IfcIntegerCountRateMeasure(v),
  3686016028: (v) => new IFC4.IfcIonConcentrationMeasure(v),
  3192672207: (v) => new IFC4.IfcIsothermalMoistureCapacityMeasure(v),
  2054016361: (v) => new IFC4.IfcKinematicViscosityMeasure(v),
  3258342251: (v) => new IFC4.IfcLabel(v),
  1275358634: (v) => new IFC4.IfcLanguageId(v),
  1243674935: (v) => new IFC4.IfcLengthMeasure(v),
  1774176899: (v) => new IFC4.IfcLineIndex(v),
  191860431: (v) => new IFC4.IfcLinearForceMeasure(v),
  2128979029: (v) => new IFC4.IfcLinearMomentMeasure(v),
  1307019551: (v) => new IFC4.IfcLinearStiffnessMeasure(v),
  3086160713: (v) => new IFC4.IfcLinearVelocityMeasure(v),
  503418787: (v) => new IFC4.IfcLogical(v),
  2095003142: (v) => new IFC4.IfcLuminousFluxMeasure(v),
  2755797622: (v) => new IFC4.IfcLuminousIntensityDistributionMeasure(v),
  151039812: (v) => new IFC4.IfcLuminousIntensityMeasure(v),
  286949696: (v) => new IFC4.IfcMagneticFluxDensityMeasure(v),
  2486716878: (v) => new IFC4.IfcMagneticFluxMeasure(v),
  1477762836: (v) => new IFC4.IfcMassDensityMeasure(v),
  4017473158: (v) => new IFC4.IfcMassFlowRateMeasure(v),
  3124614049: (v) => new IFC4.IfcMassMeasure(v),
  3531705166: (v) => new IFC4.IfcMassPerLengthMeasure(v),
  3341486342: (v) => new IFC4.IfcModulusOfElasticityMeasure(v),
  2173214787: (v) => new IFC4.IfcModulusOfLinearSubgradeReactionMeasure(v),
  1052454078: (v) => new IFC4.IfcModulusOfRotationalSubgradeReactionMeasure(v),
  1753493141: (v) => new IFC4.IfcModulusOfSubgradeReactionMeasure(v),
  3177669450: (v) => new IFC4.IfcMoistureDiffusivityMeasure(v),
  1648970520: (v) => new IFC4.IfcMolecularWeightMeasure(v),
  3114022597: (v) => new IFC4.IfcMomentOfInertiaMeasure(v),
  2615040989: (v) => new IFC4.IfcMonetaryMeasure(v),
  765770214: (v) => new IFC4.IfcMonthInYearNumber(v),
  525895558: (v) => new IFC4.IfcNonNegativeLengthMeasure(v),
  2095195183: (v) => new IFC4.IfcNormalisedRatioMeasure(v),
  2395907400: (v) => new IFC4.IfcNumericMeasure(v),
  929793134: (v) => new IFC4.IfcPHMeasure(v),
  2260317790: (v) => new IFC4.IfcParameterValue(v),
  2642773653: (v) => new IFC4.IfcPlanarForceMeasure(v),
  4042175685: (v) => new IFC4.IfcPlaneAngleMeasure(v),
  1790229001: (v) => new IFC4.IfcPositiveInteger(v),
  2815919920: (v) => new IFC4.IfcPositiveLengthMeasure(v),
  3054510233: (v) => new IFC4.IfcPositivePlaneAngleMeasure(v),
  1245737093: (v) => new IFC4.IfcPositiveRatioMeasure(v),
  1364037233: (v) => new IFC4.IfcPowerMeasure(v),
  2169031380: (v) => new IFC4.IfcPresentableText(v),
  3665567075: (v) => new IFC4.IfcPressureMeasure(v),
  2798247006: (v) => new IFC4.IfcPropertySetDefinitionSet(v),
  3972513137: (v) => new IFC4.IfcRadioActivityMeasure(v),
  96294661: (v) => new IFC4.IfcRatioMeasure(v),
  200335297: (v) => new IFC4.IfcReal(v),
  2133746277: (v) => new IFC4.IfcRotationalFrequencyMeasure(v),
  1755127002: (v) => new IFC4.IfcRotationalMassMeasure(v),
  3211557302: (v) => new IFC4.IfcRotationalStiffnessMeasure(v),
  3467162246: (v) => new IFC4.IfcSectionModulusMeasure(v),
  2190458107: (v) => new IFC4.IfcSectionalAreaIntegralMeasure(v),
  408310005: (v) => new IFC4.IfcShearModulusMeasure(v),
  3471399674: (v) => new IFC4.IfcSolidAngleMeasure(v),
  4157543285: (v) => new IFC4.IfcSoundPowerLevelMeasure(v),
  846465480: (v) => new IFC4.IfcSoundPowerMeasure(v),
  3457685358: (v) => new IFC4.IfcSoundPressureLevelMeasure(v),
  993287707: (v) => new IFC4.IfcSoundPressureMeasure(v),
  3477203348: (v) => new IFC4.IfcSpecificHeatCapacityMeasure(v),
  2757832317: (v) => new IFC4.IfcSpecularExponent(v),
  361837227: (v) => new IFC4.IfcSpecularRoughness(v),
  58845555: (v) => new IFC4.IfcTemperatureGradientMeasure(v),
  1209108979: (v) => new IFC4.IfcTemperatureRateOfChangeMeasure(v),
  2801250643: (v) => new IFC4.IfcText(v),
  1460886941: (v) => new IFC4.IfcTextAlignment(v),
  3490877962: (v) => new IFC4.IfcTextDecoration(v),
  603696268: (v) => new IFC4.IfcTextFontName(v),
  296282323: (v) => new IFC4.IfcTextTransformation(v),
  232962298: (v) => new IFC4.IfcThermalAdmittanceMeasure(v),
  2645777649: (v) => new IFC4.IfcThermalConductivityMeasure(v),
  2281867870: (v) => new IFC4.IfcThermalExpansionCoefficientMeasure(v),
  857959152: (v) => new IFC4.IfcThermalResistanceMeasure(v),
  2016195849: (v) => new IFC4.IfcThermalTransmittanceMeasure(v),
  743184107: (v) => new IFC4.IfcThermodynamicTemperatureMeasure(v),
  4075327185: (v) => new IFC4.IfcTime(v),
  2726807636: (v) => new IFC4.IfcTimeMeasure(v),
  2591213694: (v) => new IFC4.IfcTimeStamp(v),
  1278329552: (v) => new IFC4.IfcTorqueMeasure(v),
  950732822: (v) => new IFC4.IfcURIReference(v),
  3345633955: (v) => new IFC4.IfcVaporPermeabilityMeasure(v),
  3458127941: (v) => new IFC4.IfcVolumeMeasure(v),
  2593997549: (v) => new IFC4.IfcVolumetricFlowRateMeasure(v),
  51269191: (v) => new IFC4.IfcWarpingConstantMeasure(v),
  1718600412: (v) => new IFC4.IfcWarpingMomentMeasure(v)
};
var IFC4;
(function(IFC42) {
  class IfcAbsorbedDoseMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcAbsorbedDoseMeasure = IfcAbsorbedDoseMeasure;
  class IfcAccelerationMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcAccelerationMeasure = IfcAccelerationMeasure;
  class IfcAmountOfSubstanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcAmountOfSubstanceMeasure = IfcAmountOfSubstanceMeasure;
  class IfcAngularVelocityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcAngularVelocityMeasure = IfcAngularVelocityMeasure;
  class IfcArcIndex {
    constructor(value) {
      this.value = value;
    }
  }
  IFC42.IfcArcIndex = IfcArcIndex;
  ;
  class IfcAreaDensityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcAreaDensityMeasure = IfcAreaDensityMeasure;
  class IfcAreaMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcAreaMeasure = IfcAreaMeasure;
  class IfcBinary {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcBinary = IfcBinary;
  class IfcBoolean {
    constructor(value) {
      this.value = value;
      this.type = 3;
    }
  }
  IFC42.IfcBoolean = IfcBoolean;
  class IfcBoxAlignment {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcBoxAlignment = IfcBoxAlignment;
  class IfcCardinalPointReference {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcCardinalPointReference = IfcCardinalPointReference;
  class IfcComplexNumber {
    constructor(value) {
      this.value = value;
    }
  }
  IFC42.IfcComplexNumber = IfcComplexNumber;
  ;
  class IfcCompoundPlaneAngleMeasure {
    constructor(value) {
      this.value = value;
    }
  }
  IFC42.IfcCompoundPlaneAngleMeasure = IfcCompoundPlaneAngleMeasure;
  ;
  class IfcContextDependentMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcContextDependentMeasure = IfcContextDependentMeasure;
  class IfcCountMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcCountMeasure = IfcCountMeasure;
  class IfcCurvatureMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcCurvatureMeasure = IfcCurvatureMeasure;
  class IfcDate {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcDate = IfcDate;
  class IfcDateTime {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcDateTime = IfcDateTime;
  class IfcDayInMonthNumber {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcDayInMonthNumber = IfcDayInMonthNumber;
  class IfcDayInWeekNumber {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcDayInWeekNumber = IfcDayInWeekNumber;
  class IfcDescriptiveMeasure {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcDescriptiveMeasure = IfcDescriptiveMeasure;
  class IfcDimensionCount {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcDimensionCount = IfcDimensionCount;
  class IfcDoseEquivalentMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcDoseEquivalentMeasure = IfcDoseEquivalentMeasure;
  class IfcDuration {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcDuration = IfcDuration;
  class IfcDynamicViscosityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcDynamicViscosityMeasure = IfcDynamicViscosityMeasure;
  class IfcElectricCapacitanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcElectricCapacitanceMeasure = IfcElectricCapacitanceMeasure;
  class IfcElectricChargeMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcElectricChargeMeasure = IfcElectricChargeMeasure;
  class IfcElectricConductanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcElectricConductanceMeasure = IfcElectricConductanceMeasure;
  class IfcElectricCurrentMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcElectricCurrentMeasure = IfcElectricCurrentMeasure;
  class IfcElectricResistanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcElectricResistanceMeasure = IfcElectricResistanceMeasure;
  class IfcElectricVoltageMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcElectricVoltageMeasure = IfcElectricVoltageMeasure;
  class IfcEnergyMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcEnergyMeasure = IfcEnergyMeasure;
  class IfcFontStyle {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcFontStyle = IfcFontStyle;
  class IfcFontVariant {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcFontVariant = IfcFontVariant;
  class IfcFontWeight {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcFontWeight = IfcFontWeight;
  class IfcForceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcForceMeasure = IfcForceMeasure;
  class IfcFrequencyMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcFrequencyMeasure = IfcFrequencyMeasure;
  class IfcGloballyUniqueId {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcGloballyUniqueId = IfcGloballyUniqueId;
  class IfcHeatFluxDensityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcHeatFluxDensityMeasure = IfcHeatFluxDensityMeasure;
  class IfcHeatingValueMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcHeatingValueMeasure = IfcHeatingValueMeasure;
  class IfcIdentifier {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcIdentifier = IfcIdentifier;
  class IfcIlluminanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcIlluminanceMeasure = IfcIlluminanceMeasure;
  class IfcInductanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcInductanceMeasure = IfcInductanceMeasure;
  class IfcInteger {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcInteger = IfcInteger;
  class IfcIntegerCountRateMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcIntegerCountRateMeasure = IfcIntegerCountRateMeasure;
  class IfcIonConcentrationMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcIonConcentrationMeasure = IfcIonConcentrationMeasure;
  class IfcIsothermalMoistureCapacityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcIsothermalMoistureCapacityMeasure = IfcIsothermalMoistureCapacityMeasure;
  class IfcKinematicViscosityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcKinematicViscosityMeasure = IfcKinematicViscosityMeasure;
  class IfcLabel {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcLabel = IfcLabel;
  class IfcLanguageId {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcLanguageId = IfcLanguageId;
  class IfcLengthMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcLengthMeasure = IfcLengthMeasure;
  class IfcLineIndex {
    constructor(value) {
      this.value = value;
    }
  }
  IFC42.IfcLineIndex = IfcLineIndex;
  ;
  class IfcLinearForceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcLinearForceMeasure = IfcLinearForceMeasure;
  class IfcLinearMomentMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcLinearMomentMeasure = IfcLinearMomentMeasure;
  class IfcLinearStiffnessMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcLinearStiffnessMeasure = IfcLinearStiffnessMeasure;
  class IfcLinearVelocityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcLinearVelocityMeasure = IfcLinearVelocityMeasure;
  class IfcLogical {
    constructor(value) {
      this.value = value;
      this.type = 3;
    }
  }
  IFC42.IfcLogical = IfcLogical;
  class IfcLuminousFluxMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcLuminousFluxMeasure = IfcLuminousFluxMeasure;
  class IfcLuminousIntensityDistributionMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcLuminousIntensityDistributionMeasure = IfcLuminousIntensityDistributionMeasure;
  class IfcLuminousIntensityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcLuminousIntensityMeasure = IfcLuminousIntensityMeasure;
  class IfcMagneticFluxDensityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcMagneticFluxDensityMeasure = IfcMagneticFluxDensityMeasure;
  class IfcMagneticFluxMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcMagneticFluxMeasure = IfcMagneticFluxMeasure;
  class IfcMassDensityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcMassDensityMeasure = IfcMassDensityMeasure;
  class IfcMassFlowRateMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcMassFlowRateMeasure = IfcMassFlowRateMeasure;
  class IfcMassMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcMassMeasure = IfcMassMeasure;
  class IfcMassPerLengthMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcMassPerLengthMeasure = IfcMassPerLengthMeasure;
  class IfcModulusOfElasticityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcModulusOfElasticityMeasure = IfcModulusOfElasticityMeasure;
  class IfcModulusOfLinearSubgradeReactionMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcModulusOfLinearSubgradeReactionMeasure = IfcModulusOfLinearSubgradeReactionMeasure;
  class IfcModulusOfRotationalSubgradeReactionMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcModulusOfRotationalSubgradeReactionMeasure = IfcModulusOfRotationalSubgradeReactionMeasure;
  class IfcModulusOfSubgradeReactionMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcModulusOfSubgradeReactionMeasure = IfcModulusOfSubgradeReactionMeasure;
  class IfcMoistureDiffusivityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcMoistureDiffusivityMeasure = IfcMoistureDiffusivityMeasure;
  class IfcMolecularWeightMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcMolecularWeightMeasure = IfcMolecularWeightMeasure;
  class IfcMomentOfInertiaMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcMomentOfInertiaMeasure = IfcMomentOfInertiaMeasure;
  class IfcMonetaryMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcMonetaryMeasure = IfcMonetaryMeasure;
  class IfcMonthInYearNumber {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcMonthInYearNumber = IfcMonthInYearNumber;
  class IfcNonNegativeLengthMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcNonNegativeLengthMeasure = IfcNonNegativeLengthMeasure;
  class IfcNormalisedRatioMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcNormalisedRatioMeasure = IfcNormalisedRatioMeasure;
  class IfcNumericMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcNumericMeasure = IfcNumericMeasure;
  class IfcPHMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcPHMeasure = IfcPHMeasure;
  class IfcParameterValue {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcParameterValue = IfcParameterValue;
  class IfcPlanarForceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcPlanarForceMeasure = IfcPlanarForceMeasure;
  class IfcPlaneAngleMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcPlaneAngleMeasure = IfcPlaneAngleMeasure;
  class IfcPositiveInteger {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcPositiveInteger = IfcPositiveInteger;
  class IfcPositiveLengthMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcPositiveLengthMeasure = IfcPositiveLengthMeasure;
  class IfcPositivePlaneAngleMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcPositivePlaneAngleMeasure = IfcPositivePlaneAngleMeasure;
  class IfcPositiveRatioMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcPositiveRatioMeasure = IfcPositiveRatioMeasure;
  class IfcPowerMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcPowerMeasure = IfcPowerMeasure;
  class IfcPresentableText {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcPresentableText = IfcPresentableText;
  class IfcPressureMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcPressureMeasure = IfcPressureMeasure;
  class IfcPropertySetDefinitionSet {
    constructor(value) {
      this.value = value;
    }
  }
  IFC42.IfcPropertySetDefinitionSet = IfcPropertySetDefinitionSet;
  ;
  class IfcRadioActivityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcRadioActivityMeasure = IfcRadioActivityMeasure;
  class IfcRatioMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcRatioMeasure = IfcRatioMeasure;
  class IfcReal {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcReal = IfcReal;
  class IfcRotationalFrequencyMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcRotationalFrequencyMeasure = IfcRotationalFrequencyMeasure;
  class IfcRotationalMassMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcRotationalMassMeasure = IfcRotationalMassMeasure;
  class IfcRotationalStiffnessMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcRotationalStiffnessMeasure = IfcRotationalStiffnessMeasure;
  class IfcSectionModulusMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcSectionModulusMeasure = IfcSectionModulusMeasure;
  class IfcSectionalAreaIntegralMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcSectionalAreaIntegralMeasure = IfcSectionalAreaIntegralMeasure;
  class IfcShearModulusMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcShearModulusMeasure = IfcShearModulusMeasure;
  class IfcSolidAngleMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcSolidAngleMeasure = IfcSolidAngleMeasure;
  class IfcSoundPowerLevelMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcSoundPowerLevelMeasure = IfcSoundPowerLevelMeasure;
  class IfcSoundPowerMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcSoundPowerMeasure = IfcSoundPowerMeasure;
  class IfcSoundPressureLevelMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcSoundPressureLevelMeasure = IfcSoundPressureLevelMeasure;
  class IfcSoundPressureMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcSoundPressureMeasure = IfcSoundPressureMeasure;
  class IfcSpecificHeatCapacityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcSpecificHeatCapacityMeasure = IfcSpecificHeatCapacityMeasure;
  class IfcSpecularExponent {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcSpecularExponent = IfcSpecularExponent;
  class IfcSpecularRoughness {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcSpecularRoughness = IfcSpecularRoughness;
  class IfcTemperatureGradientMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcTemperatureGradientMeasure = IfcTemperatureGradientMeasure;
  class IfcTemperatureRateOfChangeMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcTemperatureRateOfChangeMeasure = IfcTemperatureRateOfChangeMeasure;
  class IfcText {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcText = IfcText;
  class IfcTextAlignment {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcTextAlignment = IfcTextAlignment;
  class IfcTextDecoration {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcTextDecoration = IfcTextDecoration;
  class IfcTextFontName {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcTextFontName = IfcTextFontName;
  class IfcTextTransformation {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcTextTransformation = IfcTextTransformation;
  class IfcThermalAdmittanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcThermalAdmittanceMeasure = IfcThermalAdmittanceMeasure;
  class IfcThermalConductivityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcThermalConductivityMeasure = IfcThermalConductivityMeasure;
  class IfcThermalExpansionCoefficientMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcThermalExpansionCoefficientMeasure = IfcThermalExpansionCoefficientMeasure;
  class IfcThermalResistanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcThermalResistanceMeasure = IfcThermalResistanceMeasure;
  class IfcThermalTransmittanceMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcThermalTransmittanceMeasure = IfcThermalTransmittanceMeasure;
  class IfcThermodynamicTemperatureMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcThermodynamicTemperatureMeasure = IfcThermodynamicTemperatureMeasure;
  class IfcTime {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcTime = IfcTime;
  class IfcTimeMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcTimeMeasure = IfcTimeMeasure;
  class IfcTimeStamp {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcTimeStamp = IfcTimeStamp;
  class IfcTorqueMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcTorqueMeasure = IfcTorqueMeasure;
  class IfcURIReference {
    constructor(value) {
      this.value = value;
      this.type = 1;
    }
  }
  IFC42.IfcURIReference = IfcURIReference;
  class IfcVaporPermeabilityMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcVaporPermeabilityMeasure = IfcVaporPermeabilityMeasure;
  class IfcVolumeMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcVolumeMeasure = IfcVolumeMeasure;
  class IfcVolumetricFlowRateMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcVolumetricFlowRateMeasure = IfcVolumetricFlowRateMeasure;
  class IfcWarpingConstantMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcWarpingConstantMeasure = IfcWarpingConstantMeasure;
  class IfcWarpingMomentMeasure {
    constructor(value) {
      this.value = value;
      this.type = 4;
    }
  }
  IFC42.IfcWarpingMomentMeasure = IfcWarpingMomentMeasure;
  class IfcActionRequestTypeEnum {
  }
  IfcActionRequestTypeEnum.EMAIL = { type: 3, value: "EMAIL" };
  IfcActionRequestTypeEnum.FAX = { type: 3, value: "FAX" };
  IfcActionRequestTypeEnum.PHONE = { type: 3, value: "PHONE" };
  IfcActionRequestTypeEnum.POST = { type: 3, value: "POST" };
  IfcActionRequestTypeEnum.VERBAL = { type: 3, value: "VERBAL" };
  IfcActionRequestTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcActionRequestTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcActionRequestTypeEnum = IfcActionRequestTypeEnum;
  class IfcActionSourceTypeEnum {
  }
  IfcActionSourceTypeEnum.DEAD_LOAD_G = { type: 3, value: "DEAD_LOAD_G" };
  IfcActionSourceTypeEnum.COMPLETION_G1 = { type: 3, value: "COMPLETION_G1" };
  IfcActionSourceTypeEnum.LIVE_LOAD_Q = { type: 3, value: "LIVE_LOAD_Q" };
  IfcActionSourceTypeEnum.SNOW_S = { type: 3, value: "SNOW_S" };
  IfcActionSourceTypeEnum.WIND_W = { type: 3, value: "WIND_W" };
  IfcActionSourceTypeEnum.PRESTRESSING_P = { type: 3, value: "PRESTRESSING_P" };
  IfcActionSourceTypeEnum.SETTLEMENT_U = { type: 3, value: "SETTLEMENT_U" };
  IfcActionSourceTypeEnum.TEMPERATURE_T = { type: 3, value: "TEMPERATURE_T" };
  IfcActionSourceTypeEnum.EARTHQUAKE_E = { type: 3, value: "EARTHQUAKE_E" };
  IfcActionSourceTypeEnum.FIRE = { type: 3, value: "FIRE" };
  IfcActionSourceTypeEnum.IMPULSE = { type: 3, value: "IMPULSE" };
  IfcActionSourceTypeEnum.IMPACT = { type: 3, value: "IMPACT" };
  IfcActionSourceTypeEnum.TRANSPORT = { type: 3, value: "TRANSPORT" };
  IfcActionSourceTypeEnum.ERECTION = { type: 3, value: "ERECTION" };
  IfcActionSourceTypeEnum.PROPPING = { type: 3, value: "PROPPING" };
  IfcActionSourceTypeEnum.SYSTEM_IMPERFECTION = { type: 3, value: "SYSTEM_IMPERFECTION" };
  IfcActionSourceTypeEnum.SHRINKAGE = { type: 3, value: "SHRINKAGE" };
  IfcActionSourceTypeEnum.CREEP = { type: 3, value: "CREEP" };
  IfcActionSourceTypeEnum.LACK_OF_FIT = { type: 3, value: "LACK_OF_FIT" };
  IfcActionSourceTypeEnum.BUOYANCY = { type: 3, value: "BUOYANCY" };
  IfcActionSourceTypeEnum.ICE = { type: 3, value: "ICE" };
  IfcActionSourceTypeEnum.CURRENT = { type: 3, value: "CURRENT" };
  IfcActionSourceTypeEnum.WAVE = { type: 3, value: "WAVE" };
  IfcActionSourceTypeEnum.RAIN = { type: 3, value: "RAIN" };
  IfcActionSourceTypeEnum.BRAKES = { type: 3, value: "BRAKES" };
  IfcActionSourceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcActionSourceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcActionSourceTypeEnum = IfcActionSourceTypeEnum;
  class IfcActionTypeEnum {
  }
  IfcActionTypeEnum.PERMANENT_G = { type: 3, value: "PERMANENT_G" };
  IfcActionTypeEnum.VARIABLE_Q = { type: 3, value: "VARIABLE_Q" };
  IfcActionTypeEnum.EXTRAORDINARY_A = { type: 3, value: "EXTRAORDINARY_A" };
  IfcActionTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcActionTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcActionTypeEnum = IfcActionTypeEnum;
  class IfcActuatorTypeEnum {
  }
  IfcActuatorTypeEnum.ELECTRICACTUATOR = { type: 3, value: "ELECTRICACTUATOR" };
  IfcActuatorTypeEnum.HANDOPERATEDACTUATOR = { type: 3, value: "HANDOPERATEDACTUATOR" };
  IfcActuatorTypeEnum.HYDRAULICACTUATOR = { type: 3, value: "HYDRAULICACTUATOR" };
  IfcActuatorTypeEnum.PNEUMATICACTUATOR = { type: 3, value: "PNEUMATICACTUATOR" };
  IfcActuatorTypeEnum.THERMOSTATICACTUATOR = { type: 3, value: "THERMOSTATICACTUATOR" };
  IfcActuatorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcActuatorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcActuatorTypeEnum = IfcActuatorTypeEnum;
  class IfcAddressTypeEnum {
  }
  IfcAddressTypeEnum.OFFICE = { type: 3, value: "OFFICE" };
  IfcAddressTypeEnum.SITE = { type: 3, value: "SITE" };
  IfcAddressTypeEnum.HOME = { type: 3, value: "HOME" };
  IfcAddressTypeEnum.DISTRIBUTIONPOINT = { type: 3, value: "DISTRIBUTIONPOINT" };
  IfcAddressTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IFC42.IfcAddressTypeEnum = IfcAddressTypeEnum;
  class IfcAirTerminalBoxTypeEnum {
  }
  IfcAirTerminalBoxTypeEnum.CONSTANTFLOW = { type: 3, value: "CONSTANTFLOW" };
  IfcAirTerminalBoxTypeEnum.VARIABLEFLOWPRESSUREDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREDEPENDANT" };
  IfcAirTerminalBoxTypeEnum.VARIABLEFLOWPRESSUREINDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREINDEPENDANT" };
  IfcAirTerminalBoxTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAirTerminalBoxTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcAirTerminalBoxTypeEnum = IfcAirTerminalBoxTypeEnum;
  class IfcAirTerminalTypeEnum {
  }
  IfcAirTerminalTypeEnum.DIFFUSER = { type: 3, value: "DIFFUSER" };
  IfcAirTerminalTypeEnum.GRILLE = { type: 3, value: "GRILLE" };
  IfcAirTerminalTypeEnum.LOUVRE = { type: 3, value: "LOUVRE" };
  IfcAirTerminalTypeEnum.REGISTER = { type: 3, value: "REGISTER" };
  IfcAirTerminalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAirTerminalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcAirTerminalTypeEnum = IfcAirTerminalTypeEnum;
  class IfcAirToAirHeatRecoveryTypeEnum {
  }
  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATECOUNTERFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECOUNTERFLOWEXCHANGER" };
  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATECROSSFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECROSSFLOWEXCHANGER" };
  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATEPARALLELFLOWEXCHANGER = { type: 3, value: "FIXEDPLATEPARALLELFLOWEXCHANGER" };
  IfcAirToAirHeatRecoveryTypeEnum.ROTARYWHEEL = { type: 3, value: "ROTARYWHEEL" };
  IfcAirToAirHeatRecoveryTypeEnum.RUNAROUNDCOILLOOP = { type: 3, value: "RUNAROUNDCOILLOOP" };
  IfcAirToAirHeatRecoveryTypeEnum.HEATPIPE = { type: 3, value: "HEATPIPE" };
  IfcAirToAirHeatRecoveryTypeEnum.TWINTOWERENTHALPYRECOVERYLOOPS = { type: 3, value: "TWINTOWERENTHALPYRECOVERYLOOPS" };
  IfcAirToAirHeatRecoveryTypeEnum.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS" };
  IfcAirToAirHeatRecoveryTypeEnum.THERMOSIPHONCOILTYPEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS" };
  IfcAirToAirHeatRecoveryTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAirToAirHeatRecoveryTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcAirToAirHeatRecoveryTypeEnum = IfcAirToAirHeatRecoveryTypeEnum;
  class IfcAlarmTypeEnum {
  }
  IfcAlarmTypeEnum.BELL = { type: 3, value: "BELL" };
  IfcAlarmTypeEnum.BREAKGLASSBUTTON = { type: 3, value: "BREAKGLASSBUTTON" };
  IfcAlarmTypeEnum.LIGHT = { type: 3, value: "LIGHT" };
  IfcAlarmTypeEnum.MANUALPULLBOX = { type: 3, value: "MANUALPULLBOX" };
  IfcAlarmTypeEnum.SIREN = { type: 3, value: "SIREN" };
  IfcAlarmTypeEnum.WHISTLE = { type: 3, value: "WHISTLE" };
  IfcAlarmTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAlarmTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcAlarmTypeEnum = IfcAlarmTypeEnum;
  class IfcAnalysisModelTypeEnum {
  }
  IfcAnalysisModelTypeEnum.IN_PLANE_LOADING_2D = { type: 3, value: "IN_PLANE_LOADING_2D" };
  IfcAnalysisModelTypeEnum.OUT_PLANE_LOADING_2D = { type: 3, value: "OUT_PLANE_LOADING_2D" };
  IfcAnalysisModelTypeEnum.LOADING_3D = { type: 3, value: "LOADING_3D" };
  IfcAnalysisModelTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAnalysisModelTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcAnalysisModelTypeEnum = IfcAnalysisModelTypeEnum;
  class IfcAnalysisTheoryTypeEnum {
  }
  IfcAnalysisTheoryTypeEnum.FIRST_ORDER_THEORY = { type: 3, value: "FIRST_ORDER_THEORY" };
  IfcAnalysisTheoryTypeEnum.SECOND_ORDER_THEORY = { type: 3, value: "SECOND_ORDER_THEORY" };
  IfcAnalysisTheoryTypeEnum.THIRD_ORDER_THEORY = { type: 3, value: "THIRD_ORDER_THEORY" };
  IfcAnalysisTheoryTypeEnum.FULL_NONLINEAR_THEORY = { type: 3, value: "FULL_NONLINEAR_THEORY" };
  IfcAnalysisTheoryTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAnalysisTheoryTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcAnalysisTheoryTypeEnum = IfcAnalysisTheoryTypeEnum;
  class IfcArithmeticOperatorEnum {
  }
  IfcArithmeticOperatorEnum.ADD = { type: 3, value: "ADD" };
  IfcArithmeticOperatorEnum.DIVIDE = { type: 3, value: "DIVIDE" };
  IfcArithmeticOperatorEnum.MULTIPLY = { type: 3, value: "MULTIPLY" };
  IfcArithmeticOperatorEnum.SUBTRACT = { type: 3, value: "SUBTRACT" };
  IFC42.IfcArithmeticOperatorEnum = IfcArithmeticOperatorEnum;
  class IfcAssemblyPlaceEnum {
  }
  IfcAssemblyPlaceEnum.SITE = { type: 3, value: "SITE" };
  IfcAssemblyPlaceEnum.FACTORY = { type: 3, value: "FACTORY" };
  IfcAssemblyPlaceEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcAssemblyPlaceEnum = IfcAssemblyPlaceEnum;
  class IfcAudioVisualApplianceTypeEnum {
  }
  IfcAudioVisualApplianceTypeEnum.AMPLIFIER = { type: 3, value: "AMPLIFIER" };
  IfcAudioVisualApplianceTypeEnum.CAMERA = { type: 3, value: "CAMERA" };
  IfcAudioVisualApplianceTypeEnum.DISPLAY = { type: 3, value: "DISPLAY" };
  IfcAudioVisualApplianceTypeEnum.MICROPHONE = { type: 3, value: "MICROPHONE" };
  IfcAudioVisualApplianceTypeEnum.PLAYER = { type: 3, value: "PLAYER" };
  IfcAudioVisualApplianceTypeEnum.PROJECTOR = { type: 3, value: "PROJECTOR" };
  IfcAudioVisualApplianceTypeEnum.RECEIVER = { type: 3, value: "RECEIVER" };
  IfcAudioVisualApplianceTypeEnum.SPEAKER = { type: 3, value: "SPEAKER" };
  IfcAudioVisualApplianceTypeEnum.SWITCHER = { type: 3, value: "SWITCHER" };
  IfcAudioVisualApplianceTypeEnum.TELEPHONE = { type: 3, value: "TELEPHONE" };
  IfcAudioVisualApplianceTypeEnum.TUNER = { type: 3, value: "TUNER" };
  IfcAudioVisualApplianceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcAudioVisualApplianceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcAudioVisualApplianceTypeEnum = IfcAudioVisualApplianceTypeEnum;
  class IfcBSplineCurveForm {
  }
  IfcBSplineCurveForm.POLYLINE_FORM = { type: 3, value: "POLYLINE_FORM" };
  IfcBSplineCurveForm.CIRCULAR_ARC = { type: 3, value: "CIRCULAR_ARC" };
  IfcBSplineCurveForm.ELLIPTIC_ARC = { type: 3, value: "ELLIPTIC_ARC" };
  IfcBSplineCurveForm.PARABOLIC_ARC = { type: 3, value: "PARABOLIC_ARC" };
  IfcBSplineCurveForm.HYPERBOLIC_ARC = { type: 3, value: "HYPERBOLIC_ARC" };
  IfcBSplineCurveForm.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  IFC42.IfcBSplineCurveForm = IfcBSplineCurveForm;
  class IfcBSplineSurfaceForm {
  }
  IfcBSplineSurfaceForm.PLANE_SURF = { type: 3, value: "PLANE_SURF" };
  IfcBSplineSurfaceForm.CYLINDRICAL_SURF = { type: 3, value: "CYLINDRICAL_SURF" };
  IfcBSplineSurfaceForm.CONICAL_SURF = { type: 3, value: "CONICAL_SURF" };
  IfcBSplineSurfaceForm.SPHERICAL_SURF = { type: 3, value: "SPHERICAL_SURF" };
  IfcBSplineSurfaceForm.TOROIDAL_SURF = { type: 3, value: "TOROIDAL_SURF" };
  IfcBSplineSurfaceForm.SURF_OF_REVOLUTION = { type: 3, value: "SURF_OF_REVOLUTION" };
  IfcBSplineSurfaceForm.RULED_SURF = { type: 3, value: "RULED_SURF" };
  IfcBSplineSurfaceForm.GENERALISED_CONE = { type: 3, value: "GENERALISED_CONE" };
  IfcBSplineSurfaceForm.QUADRIC_SURF = { type: 3, value: "QUADRIC_SURF" };
  IfcBSplineSurfaceForm.SURF_OF_LINEAR_EXTRUSION = { type: 3, value: "SURF_OF_LINEAR_EXTRUSION" };
  IfcBSplineSurfaceForm.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  IFC42.IfcBSplineSurfaceForm = IfcBSplineSurfaceForm;
  class IfcBeamTypeEnum {
  }
  IfcBeamTypeEnum.BEAM = { type: 3, value: "BEAM" };
  IfcBeamTypeEnum.JOIST = { type: 3, value: "JOIST" };
  IfcBeamTypeEnum.HOLLOWCORE = { type: 3, value: "HOLLOWCORE" };
  IfcBeamTypeEnum.LINTEL = { type: 3, value: "LINTEL" };
  IfcBeamTypeEnum.SPANDREL = { type: 3, value: "SPANDREL" };
  IfcBeamTypeEnum.T_BEAM = { type: 3, value: "T_BEAM" };
  IfcBeamTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBeamTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcBeamTypeEnum = IfcBeamTypeEnum;
  class IfcBenchmarkEnum {
  }
  IfcBenchmarkEnum.GREATERTHAN = { type: 3, value: "GREATERTHAN" };
  IfcBenchmarkEnum.GREATERTHANOREQUALTO = { type: 3, value: "GREATERTHANOREQUALTO" };
  IfcBenchmarkEnum.LESSTHAN = { type: 3, value: "LESSTHAN" };
  IfcBenchmarkEnum.LESSTHANOREQUALTO = { type: 3, value: "LESSTHANOREQUALTO" };
  IfcBenchmarkEnum.EQUALTO = { type: 3, value: "EQUALTO" };
  IfcBenchmarkEnum.NOTEQUALTO = { type: 3, value: "NOTEQUALTO" };
  IfcBenchmarkEnum.INCLUDES = { type: 3, value: "INCLUDES" };
  IfcBenchmarkEnum.NOTINCLUDES = { type: 3, value: "NOTINCLUDES" };
  IfcBenchmarkEnum.INCLUDEDIN = { type: 3, value: "INCLUDEDIN" };
  IfcBenchmarkEnum.NOTINCLUDEDIN = { type: 3, value: "NOTINCLUDEDIN" };
  IFC42.IfcBenchmarkEnum = IfcBenchmarkEnum;
  class IfcBoilerTypeEnum {
  }
  IfcBoilerTypeEnum.WATER = { type: 3, value: "WATER" };
  IfcBoilerTypeEnum.STEAM = { type: 3, value: "STEAM" };
  IfcBoilerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBoilerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcBoilerTypeEnum = IfcBoilerTypeEnum;
  class IfcBooleanOperator {
  }
  IfcBooleanOperator.UNION = { type: 3, value: "UNION" };
  IfcBooleanOperator.INTERSECTION = { type: 3, value: "INTERSECTION" };
  IfcBooleanOperator.DIFFERENCE = { type: 3, value: "DIFFERENCE" };
  IFC42.IfcBooleanOperator = IfcBooleanOperator;
  class IfcBuildingElementPartTypeEnum {
  }
  IfcBuildingElementPartTypeEnum.INSULATION = { type: 3, value: "INSULATION" };
  IfcBuildingElementPartTypeEnum.PRECASTPANEL = { type: 3, value: "PRECASTPANEL" };
  IfcBuildingElementPartTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBuildingElementPartTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcBuildingElementPartTypeEnum = IfcBuildingElementPartTypeEnum;
  class IfcBuildingElementProxyTypeEnum {
  }
  IfcBuildingElementProxyTypeEnum.COMPLEX = { type: 3, value: "COMPLEX" };
  IfcBuildingElementProxyTypeEnum.ELEMENT = { type: 3, value: "ELEMENT" };
  IfcBuildingElementProxyTypeEnum.PARTIAL = { type: 3, value: "PARTIAL" };
  IfcBuildingElementProxyTypeEnum.PROVISIONFORVOID = { type: 3, value: "PROVISIONFORVOID" };
  IfcBuildingElementProxyTypeEnum.PROVISIONFORSPACE = { type: 3, value: "PROVISIONFORSPACE" };
  IfcBuildingElementProxyTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBuildingElementProxyTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcBuildingElementProxyTypeEnum = IfcBuildingElementProxyTypeEnum;
  class IfcBuildingSystemTypeEnum {
  }
  IfcBuildingSystemTypeEnum.FENESTRATION = { type: 3, value: "FENESTRATION" };
  IfcBuildingSystemTypeEnum.FOUNDATION = { type: 3, value: "FOUNDATION" };
  IfcBuildingSystemTypeEnum.LOADBEARING = { type: 3, value: "LOADBEARING" };
  IfcBuildingSystemTypeEnum.OUTERSHELL = { type: 3, value: "OUTERSHELL" };
  IfcBuildingSystemTypeEnum.SHADING = { type: 3, value: "SHADING" };
  IfcBuildingSystemTypeEnum.TRANSPORT = { type: 3, value: "TRANSPORT" };
  IfcBuildingSystemTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBuildingSystemTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcBuildingSystemTypeEnum = IfcBuildingSystemTypeEnum;
  class IfcBurnerTypeEnum {
  }
  IfcBurnerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcBurnerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcBurnerTypeEnum = IfcBurnerTypeEnum;
  class IfcCableCarrierFittingTypeEnum {
  }
  IfcCableCarrierFittingTypeEnum.BEND = { type: 3, value: "BEND" };
  IfcCableCarrierFittingTypeEnum.CROSS = { type: 3, value: "CROSS" };
  IfcCableCarrierFittingTypeEnum.REDUCER = { type: 3, value: "REDUCER" };
  IfcCableCarrierFittingTypeEnum.TEE = { type: 3, value: "TEE" };
  IfcCableCarrierFittingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCableCarrierFittingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcCableCarrierFittingTypeEnum = IfcCableCarrierFittingTypeEnum;
  class IfcCableCarrierSegmentTypeEnum {
  }
  IfcCableCarrierSegmentTypeEnum.CABLELADDERSEGMENT = { type: 3, value: "CABLELADDERSEGMENT" };
  IfcCableCarrierSegmentTypeEnum.CABLETRAYSEGMENT = { type: 3, value: "CABLETRAYSEGMENT" };
  IfcCableCarrierSegmentTypeEnum.CABLETRUNKINGSEGMENT = { type: 3, value: "CABLETRUNKINGSEGMENT" };
  IfcCableCarrierSegmentTypeEnum.CONDUITSEGMENT = { type: 3, value: "CONDUITSEGMENT" };
  IfcCableCarrierSegmentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCableCarrierSegmentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcCableCarrierSegmentTypeEnum = IfcCableCarrierSegmentTypeEnum;
  class IfcCableFittingTypeEnum {
  }
  IfcCableFittingTypeEnum.CONNECTOR = { type: 3, value: "CONNECTOR" };
  IfcCableFittingTypeEnum.ENTRY = { type: 3, value: "ENTRY" };
  IfcCableFittingTypeEnum.EXIT = { type: 3, value: "EXIT" };
  IfcCableFittingTypeEnum.JUNCTION = { type: 3, value: "JUNCTION" };
  IfcCableFittingTypeEnum.TRANSITION = { type: 3, value: "TRANSITION" };
  IfcCableFittingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCableFittingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcCableFittingTypeEnum = IfcCableFittingTypeEnum;
  class IfcCableSegmentTypeEnum {
  }
  IfcCableSegmentTypeEnum.BUSBARSEGMENT = { type: 3, value: "BUSBARSEGMENT" };
  IfcCableSegmentTypeEnum.CABLESEGMENT = { type: 3, value: "CABLESEGMENT" };
  IfcCableSegmentTypeEnum.CONDUCTORSEGMENT = { type: 3, value: "CONDUCTORSEGMENT" };
  IfcCableSegmentTypeEnum.CORESEGMENT = { type: 3, value: "CORESEGMENT" };
  IfcCableSegmentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCableSegmentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcCableSegmentTypeEnum = IfcCableSegmentTypeEnum;
  class IfcChangeActionEnum {
  }
  IfcChangeActionEnum.NOCHANGE = { type: 3, value: "NOCHANGE" };
  IfcChangeActionEnum.MODIFIED = { type: 3, value: "MODIFIED" };
  IfcChangeActionEnum.ADDED = { type: 3, value: "ADDED" };
  IfcChangeActionEnum.DELETED = { type: 3, value: "DELETED" };
  IfcChangeActionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcChangeActionEnum = IfcChangeActionEnum;
  class IfcChillerTypeEnum {
  }
  IfcChillerTypeEnum.AIRCOOLED = { type: 3, value: "AIRCOOLED" };
  IfcChillerTypeEnum.WATERCOOLED = { type: 3, value: "WATERCOOLED" };
  IfcChillerTypeEnum.HEATRECOVERY = { type: 3, value: "HEATRECOVERY" };
  IfcChillerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcChillerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcChillerTypeEnum = IfcChillerTypeEnum;
  class IfcChimneyTypeEnum {
  }
  IfcChimneyTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcChimneyTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcChimneyTypeEnum = IfcChimneyTypeEnum;
  class IfcCoilTypeEnum {
  }
  IfcCoilTypeEnum.DXCOOLINGCOIL = { type: 3, value: "DXCOOLINGCOIL" };
  IfcCoilTypeEnum.ELECTRICHEATINGCOIL = { type: 3, value: "ELECTRICHEATINGCOIL" };
  IfcCoilTypeEnum.GASHEATINGCOIL = { type: 3, value: "GASHEATINGCOIL" };
  IfcCoilTypeEnum.HYDRONICCOIL = { type: 3, value: "HYDRONICCOIL" };
  IfcCoilTypeEnum.STEAMHEATINGCOIL = { type: 3, value: "STEAMHEATINGCOIL" };
  IfcCoilTypeEnum.WATERCOOLINGCOIL = { type: 3, value: "WATERCOOLINGCOIL" };
  IfcCoilTypeEnum.WATERHEATINGCOIL = { type: 3, value: "WATERHEATINGCOIL" };
  IfcCoilTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCoilTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcCoilTypeEnum = IfcCoilTypeEnum;
  class IfcColumnTypeEnum {
  }
  IfcColumnTypeEnum.COLUMN = { type: 3, value: "COLUMN" };
  IfcColumnTypeEnum.PILASTER = { type: 3, value: "PILASTER" };
  IfcColumnTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcColumnTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcColumnTypeEnum = IfcColumnTypeEnum;
  class IfcCommunicationsApplianceTypeEnum {
  }
  IfcCommunicationsApplianceTypeEnum.ANTENNA = { type: 3, value: "ANTENNA" };
  IfcCommunicationsApplianceTypeEnum.COMPUTER = { type: 3, value: "COMPUTER" };
  IfcCommunicationsApplianceTypeEnum.FAX = { type: 3, value: "FAX" };
  IfcCommunicationsApplianceTypeEnum.GATEWAY = { type: 3, value: "GATEWAY" };
  IfcCommunicationsApplianceTypeEnum.MODEM = { type: 3, value: "MODEM" };
  IfcCommunicationsApplianceTypeEnum.NETWORKAPPLIANCE = { type: 3, value: "NETWORKAPPLIANCE" };
  IfcCommunicationsApplianceTypeEnum.NETWORKBRIDGE = { type: 3, value: "NETWORKBRIDGE" };
  IfcCommunicationsApplianceTypeEnum.NETWORKHUB = { type: 3, value: "NETWORKHUB" };
  IfcCommunicationsApplianceTypeEnum.PRINTER = { type: 3, value: "PRINTER" };
  IfcCommunicationsApplianceTypeEnum.REPEATER = { type: 3, value: "REPEATER" };
  IfcCommunicationsApplianceTypeEnum.ROUTER = { type: 3, value: "ROUTER" };
  IfcCommunicationsApplianceTypeEnum.SCANNER = { type: 3, value: "SCANNER" };
  IfcCommunicationsApplianceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCommunicationsApplianceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcCommunicationsApplianceTypeEnum = IfcCommunicationsApplianceTypeEnum;
  class IfcComplexPropertyTemplateTypeEnum {
  }
  IfcComplexPropertyTemplateTypeEnum.P_COMPLEX = { type: 3, value: "P_COMPLEX" };
  IfcComplexPropertyTemplateTypeEnum.Q_COMPLEX = { type: 3, value: "Q_COMPLEX" };
  IFC42.IfcComplexPropertyTemplateTypeEnum = IfcComplexPropertyTemplateTypeEnum;
  class IfcCompressorTypeEnum {
  }
  IfcCompressorTypeEnum.DYNAMIC = { type: 3, value: "DYNAMIC" };
  IfcCompressorTypeEnum.RECIPROCATING = { type: 3, value: "RECIPROCATING" };
  IfcCompressorTypeEnum.ROTARY = { type: 3, value: "ROTARY" };
  IfcCompressorTypeEnum.SCROLL = { type: 3, value: "SCROLL" };
  IfcCompressorTypeEnum.TROCHOIDAL = { type: 3, value: "TROCHOIDAL" };
  IfcCompressorTypeEnum.SINGLESTAGE = { type: 3, value: "SINGLESTAGE" };
  IfcCompressorTypeEnum.BOOSTER = { type: 3, value: "BOOSTER" };
  IfcCompressorTypeEnum.OPENTYPE = { type: 3, value: "OPENTYPE" };
  IfcCompressorTypeEnum.HERMETIC = { type: 3, value: "HERMETIC" };
  IfcCompressorTypeEnum.SEMIHERMETIC = { type: 3, value: "SEMIHERMETIC" };
  IfcCompressorTypeEnum.WELDEDSHELLHERMETIC = { type: 3, value: "WELDEDSHELLHERMETIC" };
  IfcCompressorTypeEnum.ROLLINGPISTON = { type: 3, value: "ROLLINGPISTON" };
  IfcCompressorTypeEnum.ROTARYVANE = { type: 3, value: "ROTARYVANE" };
  IfcCompressorTypeEnum.SINGLESCREW = { type: 3, value: "SINGLESCREW" };
  IfcCompressorTypeEnum.TWINSCREW = { type: 3, value: "TWINSCREW" };
  IfcCompressorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCompressorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcCompressorTypeEnum = IfcCompressorTypeEnum;
  class IfcCondenserTypeEnum {
  }
  IfcCondenserTypeEnum.AIRCOOLED = { type: 3, value: "AIRCOOLED" };
  IfcCondenserTypeEnum.EVAPORATIVECOOLED = { type: 3, value: "EVAPORATIVECOOLED" };
  IfcCondenserTypeEnum.WATERCOOLED = { type: 3, value: "WATERCOOLED" };
  IfcCondenserTypeEnum.WATERCOOLEDBRAZEDPLATE = { type: 3, value: "WATERCOOLEDBRAZEDPLATE" };
  IfcCondenserTypeEnum.WATERCOOLEDSHELLCOIL = { type: 3, value: "WATERCOOLEDSHELLCOIL" };
  IfcCondenserTypeEnum.WATERCOOLEDSHELLTUBE = { type: 3, value: "WATERCOOLEDSHELLTUBE" };
  IfcCondenserTypeEnum.WATERCOOLEDTUBEINTUBE = { type: 3, value: "WATERCOOLEDTUBEINTUBE" };
  IfcCondenserTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCondenserTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcCondenserTypeEnum = IfcCondenserTypeEnum;
  class IfcConnectionTypeEnum {
  }
  IfcConnectionTypeEnum.ATPATH = { type: 3, value: "ATPATH" };
  IfcConnectionTypeEnum.ATSTART = { type: 3, value: "ATSTART" };
  IfcConnectionTypeEnum.ATEND = { type: 3, value: "ATEND" };
  IfcConnectionTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcConnectionTypeEnum = IfcConnectionTypeEnum;
  class IfcConstraintEnum {
  }
  IfcConstraintEnum.HARD = { type: 3, value: "HARD" };
  IfcConstraintEnum.SOFT = { type: 3, value: "SOFT" };
  IfcConstraintEnum.ADVISORY = { type: 3, value: "ADVISORY" };
  IfcConstraintEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcConstraintEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcConstraintEnum = IfcConstraintEnum;
  class IfcConstructionEquipmentResourceTypeEnum {
  }
  IfcConstructionEquipmentResourceTypeEnum.DEMOLISHING = { type: 3, value: "DEMOLISHING" };
  IfcConstructionEquipmentResourceTypeEnum.EARTHMOVING = { type: 3, value: "EARTHMOVING" };
  IfcConstructionEquipmentResourceTypeEnum.ERECTING = { type: 3, value: "ERECTING" };
  IfcConstructionEquipmentResourceTypeEnum.HEATING = { type: 3, value: "HEATING" };
  IfcConstructionEquipmentResourceTypeEnum.LIGHTING = { type: 3, value: "LIGHTING" };
  IfcConstructionEquipmentResourceTypeEnum.PAVING = { type: 3, value: "PAVING" };
  IfcConstructionEquipmentResourceTypeEnum.PUMPING = { type: 3, value: "PUMPING" };
  IfcConstructionEquipmentResourceTypeEnum.TRANSPORTING = { type: 3, value: "TRANSPORTING" };
  IfcConstructionEquipmentResourceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcConstructionEquipmentResourceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcConstructionEquipmentResourceTypeEnum = IfcConstructionEquipmentResourceTypeEnum;
  class IfcConstructionMaterialResourceTypeEnum {
  }
  IfcConstructionMaterialResourceTypeEnum.AGGREGATES = { type: 3, value: "AGGREGATES" };
  IfcConstructionMaterialResourceTypeEnum.CONCRETE = { type: 3, value: "CONCRETE" };
  IfcConstructionMaterialResourceTypeEnum.DRYWALL = { type: 3, value: "DRYWALL" };
  IfcConstructionMaterialResourceTypeEnum.FUEL = { type: 3, value: "FUEL" };
  IfcConstructionMaterialResourceTypeEnum.GYPSUM = { type: 3, value: "GYPSUM" };
  IfcConstructionMaterialResourceTypeEnum.MASONRY = { type: 3, value: "MASONRY" };
  IfcConstructionMaterialResourceTypeEnum.METAL = { type: 3, value: "METAL" };
  IfcConstructionMaterialResourceTypeEnum.PLASTIC = { type: 3, value: "PLASTIC" };
  IfcConstructionMaterialResourceTypeEnum.WOOD = { type: 3, value: "WOOD" };
  IfcConstructionMaterialResourceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IfcConstructionMaterialResourceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IFC42.IfcConstructionMaterialResourceTypeEnum = IfcConstructionMaterialResourceTypeEnum;
  class IfcConstructionProductResourceTypeEnum {
  }
  IfcConstructionProductResourceTypeEnum.ASSEMBLY = { type: 3, value: "ASSEMBLY" };
  IfcConstructionProductResourceTypeEnum.FORMWORK = { type: 3, value: "FORMWORK" };
  IfcConstructionProductResourceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcConstructionProductResourceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcConstructionProductResourceTypeEnum = IfcConstructionProductResourceTypeEnum;
  class IfcControllerTypeEnum {
  }
  IfcControllerTypeEnum.FLOATING = { type: 3, value: "FLOATING" };
  IfcControllerTypeEnum.PROGRAMMABLE = { type: 3, value: "PROGRAMMABLE" };
  IfcControllerTypeEnum.PROPORTIONAL = { type: 3, value: "PROPORTIONAL" };
  IfcControllerTypeEnum.MULTIPOSITION = { type: 3, value: "MULTIPOSITION" };
  IfcControllerTypeEnum.TWOPOSITION = { type: 3, value: "TWOPOSITION" };
  IfcControllerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcControllerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcControllerTypeEnum = IfcControllerTypeEnum;
  class IfcCooledBeamTypeEnum {
  }
  IfcCooledBeamTypeEnum.ACTIVE = { type: 3, value: "ACTIVE" };
  IfcCooledBeamTypeEnum.PASSIVE = { type: 3, value: "PASSIVE" };
  IfcCooledBeamTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCooledBeamTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcCooledBeamTypeEnum = IfcCooledBeamTypeEnum;
  class IfcCoolingTowerTypeEnum {
  }
  IfcCoolingTowerTypeEnum.NATURALDRAFT = { type: 3, value: "NATURALDRAFT" };
  IfcCoolingTowerTypeEnum.MECHANICALINDUCEDDRAFT = { type: 3, value: "MECHANICALINDUCEDDRAFT" };
  IfcCoolingTowerTypeEnum.MECHANICALFORCEDDRAFT = { type: 3, value: "MECHANICALFORCEDDRAFT" };
  IfcCoolingTowerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCoolingTowerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcCoolingTowerTypeEnum = IfcCoolingTowerTypeEnum;
  class IfcCostItemTypeEnum {
  }
  IfcCostItemTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCostItemTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcCostItemTypeEnum = IfcCostItemTypeEnum;
  class IfcCostScheduleTypeEnum {
  }
  IfcCostScheduleTypeEnum.BUDGET = { type: 3, value: "BUDGET" };
  IfcCostScheduleTypeEnum.COSTPLAN = { type: 3, value: "COSTPLAN" };
  IfcCostScheduleTypeEnum.ESTIMATE = { type: 3, value: "ESTIMATE" };
  IfcCostScheduleTypeEnum.TENDER = { type: 3, value: "TENDER" };
  IfcCostScheduleTypeEnum.PRICEDBILLOFQUANTITIES = { type: 3, value: "PRICEDBILLOFQUANTITIES" };
  IfcCostScheduleTypeEnum.UNPRICEDBILLOFQUANTITIES = { type: 3, value: "UNPRICEDBILLOFQUANTITIES" };
  IfcCostScheduleTypeEnum.SCHEDULEOFRATES = { type: 3, value: "SCHEDULEOFRATES" };
  IfcCostScheduleTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCostScheduleTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcCostScheduleTypeEnum = IfcCostScheduleTypeEnum;
  class IfcCoveringTypeEnum {
  }
  IfcCoveringTypeEnum.CEILING = { type: 3, value: "CEILING" };
  IfcCoveringTypeEnum.FLOORING = { type: 3, value: "FLOORING" };
  IfcCoveringTypeEnum.CLADDING = { type: 3, value: "CLADDING" };
  IfcCoveringTypeEnum.ROOFING = { type: 3, value: "ROOFING" };
  IfcCoveringTypeEnum.MOLDING = { type: 3, value: "MOLDING" };
  IfcCoveringTypeEnum.SKIRTINGBOARD = { type: 3, value: "SKIRTINGBOARD" };
  IfcCoveringTypeEnum.INSULATION = { type: 3, value: "INSULATION" };
  IfcCoveringTypeEnum.MEMBRANE = { type: 3, value: "MEMBRANE" };
  IfcCoveringTypeEnum.SLEEVING = { type: 3, value: "SLEEVING" };
  IfcCoveringTypeEnum.WRAPPING = { type: 3, value: "WRAPPING" };
  IfcCoveringTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCoveringTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcCoveringTypeEnum = IfcCoveringTypeEnum;
  class IfcCrewResourceTypeEnum {
  }
  IfcCrewResourceTypeEnum.OFFICE = { type: 3, value: "OFFICE" };
  IfcCrewResourceTypeEnum.SITE = { type: 3, value: "SITE" };
  IfcCrewResourceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCrewResourceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcCrewResourceTypeEnum = IfcCrewResourceTypeEnum;
  class IfcCurtainWallTypeEnum {
  }
  IfcCurtainWallTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcCurtainWallTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcCurtainWallTypeEnum = IfcCurtainWallTypeEnum;
  class IfcCurveInterpolationEnum {
  }
  IfcCurveInterpolationEnum.LINEAR = { type: 3, value: "LINEAR" };
  IfcCurveInterpolationEnum.LOG_LINEAR = { type: 3, value: "LOG_LINEAR" };
  IfcCurveInterpolationEnum.LOG_LOG = { type: 3, value: "LOG_LOG" };
  IfcCurveInterpolationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcCurveInterpolationEnum = IfcCurveInterpolationEnum;
  class IfcDamperTypeEnum {
  }
  IfcDamperTypeEnum.BACKDRAFTDAMPER = { type: 3, value: "BACKDRAFTDAMPER" };
  IfcDamperTypeEnum.BALANCINGDAMPER = { type: 3, value: "BALANCINGDAMPER" };
  IfcDamperTypeEnum.BLASTDAMPER = { type: 3, value: "BLASTDAMPER" };
  IfcDamperTypeEnum.CONTROLDAMPER = { type: 3, value: "CONTROLDAMPER" };
  IfcDamperTypeEnum.FIREDAMPER = { type: 3, value: "FIREDAMPER" };
  IfcDamperTypeEnum.FIRESMOKEDAMPER = { type: 3, value: "FIRESMOKEDAMPER" };
  IfcDamperTypeEnum.FUMEHOODEXHAUST = { type: 3, value: "FUMEHOODEXHAUST" };
  IfcDamperTypeEnum.GRAVITYDAMPER = { type: 3, value: "GRAVITYDAMPER" };
  IfcDamperTypeEnum.GRAVITYRELIEFDAMPER = { type: 3, value: "GRAVITYRELIEFDAMPER" };
  IfcDamperTypeEnum.RELIEFDAMPER = { type: 3, value: "RELIEFDAMPER" };
  IfcDamperTypeEnum.SMOKEDAMPER = { type: 3, value: "SMOKEDAMPER" };
  IfcDamperTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDamperTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcDamperTypeEnum = IfcDamperTypeEnum;
  class IfcDataOriginEnum {
  }
  IfcDataOriginEnum.MEASURED = { type: 3, value: "MEASURED" };
  IfcDataOriginEnum.PREDICTED = { type: 3, value: "PREDICTED" };
  IfcDataOriginEnum.SIMULATED = { type: 3, value: "SIMULATED" };
  IfcDataOriginEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDataOriginEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcDataOriginEnum = IfcDataOriginEnum;
  class IfcDerivedUnitEnum {
  }
  IfcDerivedUnitEnum.ANGULARVELOCITYUNIT = { type: 3, value: "ANGULARVELOCITYUNIT" };
  IfcDerivedUnitEnum.AREADENSITYUNIT = { type: 3, value: "AREADENSITYUNIT" };
  IfcDerivedUnitEnum.COMPOUNDPLANEANGLEUNIT = { type: 3, value: "COMPOUNDPLANEANGLEUNIT" };
  IfcDerivedUnitEnum.DYNAMICVISCOSITYUNIT = { type: 3, value: "DYNAMICVISCOSITYUNIT" };
  IfcDerivedUnitEnum.HEATFLUXDENSITYUNIT = { type: 3, value: "HEATFLUXDENSITYUNIT" };
  IfcDerivedUnitEnum.INTEGERCOUNTRATEUNIT = { type: 3, value: "INTEGERCOUNTRATEUNIT" };
  IfcDerivedUnitEnum.ISOTHERMALMOISTURECAPACITYUNIT = { type: 3, value: "ISOTHERMALMOISTURECAPACITYUNIT" };
  IfcDerivedUnitEnum.KINEMATICVISCOSITYUNIT = { type: 3, value: "KINEMATICVISCOSITYUNIT" };
  IfcDerivedUnitEnum.LINEARVELOCITYUNIT = { type: 3, value: "LINEARVELOCITYUNIT" };
  IfcDerivedUnitEnum.MASSDENSITYUNIT = { type: 3, value: "MASSDENSITYUNIT" };
  IfcDerivedUnitEnum.MASSFLOWRATEUNIT = { type: 3, value: "MASSFLOWRATEUNIT" };
  IfcDerivedUnitEnum.MOISTUREDIFFUSIVITYUNIT = { type: 3, value: "MOISTUREDIFFUSIVITYUNIT" };
  IfcDerivedUnitEnum.MOLECULARWEIGHTUNIT = { type: 3, value: "MOLECULARWEIGHTUNIT" };
  IfcDerivedUnitEnum.SPECIFICHEATCAPACITYUNIT = { type: 3, value: "SPECIFICHEATCAPACITYUNIT" };
  IfcDerivedUnitEnum.THERMALADMITTANCEUNIT = { type: 3, value: "THERMALADMITTANCEUNIT" };
  IfcDerivedUnitEnum.THERMALCONDUCTANCEUNIT = { type: 3, value: "THERMALCONDUCTANCEUNIT" };
  IfcDerivedUnitEnum.THERMALRESISTANCEUNIT = { type: 3, value: "THERMALRESISTANCEUNIT" };
  IfcDerivedUnitEnum.THERMALTRANSMITTANCEUNIT = { type: 3, value: "THERMALTRANSMITTANCEUNIT" };
  IfcDerivedUnitEnum.VAPORPERMEABILITYUNIT = { type: 3, value: "VAPORPERMEABILITYUNIT" };
  IfcDerivedUnitEnum.VOLUMETRICFLOWRATEUNIT = { type: 3, value: "VOLUMETRICFLOWRATEUNIT" };
  IfcDerivedUnitEnum.ROTATIONALFREQUENCYUNIT = { type: 3, value: "ROTATIONALFREQUENCYUNIT" };
  IfcDerivedUnitEnum.TORQUEUNIT = { type: 3, value: "TORQUEUNIT" };
  IfcDerivedUnitEnum.MOMENTOFINERTIAUNIT = { type: 3, value: "MOMENTOFINERTIAUNIT" };
  IfcDerivedUnitEnum.LINEARMOMENTUNIT = { type: 3, value: "LINEARMOMENTUNIT" };
  IfcDerivedUnitEnum.LINEARFORCEUNIT = { type: 3, value: "LINEARFORCEUNIT" };
  IfcDerivedUnitEnum.PLANARFORCEUNIT = { type: 3, value: "PLANARFORCEUNIT" };
  IfcDerivedUnitEnum.MODULUSOFELASTICITYUNIT = { type: 3, value: "MODULUSOFELASTICITYUNIT" };
  IfcDerivedUnitEnum.SHEARMODULUSUNIT = { type: 3, value: "SHEARMODULUSUNIT" };
  IfcDerivedUnitEnum.LINEARSTIFFNESSUNIT = { type: 3, value: "LINEARSTIFFNESSUNIT" };
  IfcDerivedUnitEnum.ROTATIONALSTIFFNESSUNIT = { type: 3, value: "ROTATIONALSTIFFNESSUNIT" };
  IfcDerivedUnitEnum.MODULUSOFSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFSUBGRADEREACTIONUNIT" };
  IfcDerivedUnitEnum.ACCELERATIONUNIT = { type: 3, value: "ACCELERATIONUNIT" };
  IfcDerivedUnitEnum.CURVATUREUNIT = { type: 3, value: "CURVATUREUNIT" };
  IfcDerivedUnitEnum.HEATINGVALUEUNIT = { type: 3, value: "HEATINGVALUEUNIT" };
  IfcDerivedUnitEnum.IONCONCENTRATIONUNIT = { type: 3, value: "IONCONCENTRATIONUNIT" };
  IfcDerivedUnitEnum.LUMINOUSINTENSITYDISTRIBUTIONUNIT = { type: 3, value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT" };
  IfcDerivedUnitEnum.MASSPERLENGTHUNIT = { type: 3, value: "MASSPERLENGTHUNIT" };
  IfcDerivedUnitEnum.MODULUSOFLINEARSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT" };
  IfcDerivedUnitEnum.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT" };
  IfcDerivedUnitEnum.PHUNIT = { type: 3, value: "PHUNIT" };
  IfcDerivedUnitEnum.ROTATIONALMASSUNIT = { type: 3, value: "ROTATIONALMASSUNIT" };
  IfcDerivedUnitEnum.SECTIONAREAINTEGRALUNIT = { type: 3, value: "SECTIONAREAINTEGRALUNIT" };
  IfcDerivedUnitEnum.SECTIONMODULUSUNIT = { type: 3, value: "SECTIONMODULUSUNIT" };
  IfcDerivedUnitEnum.SOUNDPOWERLEVELUNIT = { type: 3, value: "SOUNDPOWERLEVELUNIT" };
  IfcDerivedUnitEnum.SOUNDPOWERUNIT = { type: 3, value: "SOUNDPOWERUNIT" };
  IfcDerivedUnitEnum.SOUNDPRESSURELEVELUNIT = { type: 3, value: "SOUNDPRESSURELEVELUNIT" };
  IfcDerivedUnitEnum.SOUNDPRESSUREUNIT = { type: 3, value: "SOUNDPRESSUREUNIT" };
  IfcDerivedUnitEnum.TEMPERATUREGRADIENTUNIT = { type: 3, value: "TEMPERATUREGRADIENTUNIT" };
  IfcDerivedUnitEnum.TEMPERATURERATEOFCHANGEUNIT = { type: 3, value: "TEMPERATURERATEOFCHANGEUNIT" };
  IfcDerivedUnitEnum.THERMALEXPANSIONCOEFFICIENTUNIT = { type: 3, value: "THERMALEXPANSIONCOEFFICIENTUNIT" };
  IfcDerivedUnitEnum.WARPINGCONSTANTUNIT = { type: 3, value: "WARPINGCONSTANTUNIT" };
  IfcDerivedUnitEnum.WARPINGMOMENTUNIT = { type: 3, value: "WARPINGMOMENTUNIT" };
  IfcDerivedUnitEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IFC42.IfcDerivedUnitEnum = IfcDerivedUnitEnum;
  class IfcDirectionSenseEnum {
  }
  IfcDirectionSenseEnum.POSITIVE = { type: 3, value: "POSITIVE" };
  IfcDirectionSenseEnum.NEGATIVE = { type: 3, value: "NEGATIVE" };
  IFC42.IfcDirectionSenseEnum = IfcDirectionSenseEnum;
  class IfcDiscreteAccessoryTypeEnum {
  }
  IfcDiscreteAccessoryTypeEnum.ANCHORPLATE = { type: 3, value: "ANCHORPLATE" };
  IfcDiscreteAccessoryTypeEnum.BRACKET = { type: 3, value: "BRACKET" };
  IfcDiscreteAccessoryTypeEnum.SHOE = { type: 3, value: "SHOE" };
  IfcDiscreteAccessoryTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDiscreteAccessoryTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcDiscreteAccessoryTypeEnum = IfcDiscreteAccessoryTypeEnum;
  class IfcDistributionChamberElementTypeEnum {
  }
  IfcDistributionChamberElementTypeEnum.FORMEDDUCT = { type: 3, value: "FORMEDDUCT" };
  IfcDistributionChamberElementTypeEnum.INSPECTIONCHAMBER = { type: 3, value: "INSPECTIONCHAMBER" };
  IfcDistributionChamberElementTypeEnum.INSPECTIONPIT = { type: 3, value: "INSPECTIONPIT" };
  IfcDistributionChamberElementTypeEnum.MANHOLE = { type: 3, value: "MANHOLE" };
  IfcDistributionChamberElementTypeEnum.METERCHAMBER = { type: 3, value: "METERCHAMBER" };
  IfcDistributionChamberElementTypeEnum.SUMP = { type: 3, value: "SUMP" };
  IfcDistributionChamberElementTypeEnum.TRENCH = { type: 3, value: "TRENCH" };
  IfcDistributionChamberElementTypeEnum.VALVECHAMBER = { type: 3, value: "VALVECHAMBER" };
  IfcDistributionChamberElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDistributionChamberElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcDistributionChamberElementTypeEnum = IfcDistributionChamberElementTypeEnum;
  class IfcDistributionPortTypeEnum {
  }
  IfcDistributionPortTypeEnum.CABLE = { type: 3, value: "CABLE" };
  IfcDistributionPortTypeEnum.CABLECARRIER = { type: 3, value: "CABLECARRIER" };
  IfcDistributionPortTypeEnum.DUCT = { type: 3, value: "DUCT" };
  IfcDistributionPortTypeEnum.PIPE = { type: 3, value: "PIPE" };
  IfcDistributionPortTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDistributionPortTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcDistributionPortTypeEnum = IfcDistributionPortTypeEnum;
  class IfcDistributionSystemEnum {
  }
  IfcDistributionSystemEnum.AIRCONDITIONING = { type: 3, value: "AIRCONDITIONING" };
  IfcDistributionSystemEnum.AUDIOVISUAL = { type: 3, value: "AUDIOVISUAL" };
  IfcDistributionSystemEnum.CHEMICAL = { type: 3, value: "CHEMICAL" };
  IfcDistributionSystemEnum.CHILLEDWATER = { type: 3, value: "CHILLEDWATER" };
  IfcDistributionSystemEnum.COMMUNICATION = { type: 3, value: "COMMUNICATION" };
  IfcDistributionSystemEnum.COMPRESSEDAIR = { type: 3, value: "COMPRESSEDAIR" };
  IfcDistributionSystemEnum.CONDENSERWATER = { type: 3, value: "CONDENSERWATER" };
  IfcDistributionSystemEnum.CONTROL = { type: 3, value: "CONTROL" };
  IfcDistributionSystemEnum.CONVEYING = { type: 3, value: "CONVEYING" };
  IfcDistributionSystemEnum.DATA = { type: 3, value: "DATA" };
  IfcDistributionSystemEnum.DISPOSAL = { type: 3, value: "DISPOSAL" };
  IfcDistributionSystemEnum.DOMESTICCOLDWATER = { type: 3, value: "DOMESTICCOLDWATER" };
  IfcDistributionSystemEnum.DOMESTICHOTWATER = { type: 3, value: "DOMESTICHOTWATER" };
  IfcDistributionSystemEnum.DRAINAGE = { type: 3, value: "DRAINAGE" };
  IfcDistributionSystemEnum.EARTHING = { type: 3, value: "EARTHING" };
  IfcDistributionSystemEnum.ELECTRICAL = { type: 3, value: "ELECTRICAL" };
  IfcDistributionSystemEnum.ELECTROACOUSTIC = { type: 3, value: "ELECTROACOUSTIC" };
  IfcDistributionSystemEnum.EXHAUST = { type: 3, value: "EXHAUST" };
  IfcDistributionSystemEnum.FIREPROTECTION = { type: 3, value: "FIREPROTECTION" };
  IfcDistributionSystemEnum.FUEL = { type: 3, value: "FUEL" };
  IfcDistributionSystemEnum.GAS = { type: 3, value: "GAS" };
  IfcDistributionSystemEnum.HAZARDOUS = { type: 3, value: "HAZARDOUS" };
  IfcDistributionSystemEnum.HEATING = { type: 3, value: "HEATING" };
  IfcDistributionSystemEnum.LIGHTING = { type: 3, value: "LIGHTING" };
  IfcDistributionSystemEnum.LIGHTNINGPROTECTION = { type: 3, value: "LIGHTNINGPROTECTION" };
  IfcDistributionSystemEnum.MUNICIPALSOLIDWASTE = { type: 3, value: "MUNICIPALSOLIDWASTE" };
  IfcDistributionSystemEnum.OIL = { type: 3, value: "OIL" };
  IfcDistributionSystemEnum.OPERATIONAL = { type: 3, value: "OPERATIONAL" };
  IfcDistributionSystemEnum.POWERGENERATION = { type: 3, value: "POWERGENERATION" };
  IfcDistributionSystemEnum.RAINWATER = { type: 3, value: "RAINWATER" };
  IfcDistributionSystemEnum.REFRIGERATION = { type: 3, value: "REFRIGERATION" };
  IfcDistributionSystemEnum.SECURITY = { type: 3, value: "SECURITY" };
  IfcDistributionSystemEnum.SEWAGE = { type: 3, value: "SEWAGE" };
  IfcDistributionSystemEnum.SIGNAL = { type: 3, value: "SIGNAL" };
  IfcDistributionSystemEnum.STORMWATER = { type: 3, value: "STORMWATER" };
  IfcDistributionSystemEnum.TELEPHONE = { type: 3, value: "TELEPHONE" };
  IfcDistributionSystemEnum.TV = { type: 3, value: "TV" };
  IfcDistributionSystemEnum.VACUUM = { type: 3, value: "VACUUM" };
  IfcDistributionSystemEnum.VENT = { type: 3, value: "VENT" };
  IfcDistributionSystemEnum.VENTILATION = { type: 3, value: "VENTILATION" };
  IfcDistributionSystemEnum.WASTEWATER = { type: 3, value: "WASTEWATER" };
  IfcDistributionSystemEnum.WATERSUPPLY = { type: 3, value: "WATERSUPPLY" };
  IfcDistributionSystemEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDistributionSystemEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcDistributionSystemEnum = IfcDistributionSystemEnum;
  class IfcDocumentConfidentialityEnum {
  }
  IfcDocumentConfidentialityEnum.PUBLIC = { type: 3, value: "PUBLIC" };
  IfcDocumentConfidentialityEnum.RESTRICTED = { type: 3, value: "RESTRICTED" };
  IfcDocumentConfidentialityEnum.CONFIDENTIAL = { type: 3, value: "CONFIDENTIAL" };
  IfcDocumentConfidentialityEnum.PERSONAL = { type: 3, value: "PERSONAL" };
  IfcDocumentConfidentialityEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDocumentConfidentialityEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcDocumentConfidentialityEnum = IfcDocumentConfidentialityEnum;
  class IfcDocumentStatusEnum {
  }
  IfcDocumentStatusEnum.DRAFT = { type: 3, value: "DRAFT" };
  IfcDocumentStatusEnum.FINALDRAFT = { type: 3, value: "FINALDRAFT" };
  IfcDocumentStatusEnum.FINAL = { type: 3, value: "FINAL" };
  IfcDocumentStatusEnum.REVISION = { type: 3, value: "REVISION" };
  IfcDocumentStatusEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcDocumentStatusEnum = IfcDocumentStatusEnum;
  class IfcDoorPanelOperationEnum {
  }
  IfcDoorPanelOperationEnum.SWINGING = { type: 3, value: "SWINGING" };
  IfcDoorPanelOperationEnum.DOUBLE_ACTING = { type: 3, value: "DOUBLE_ACTING" };
  IfcDoorPanelOperationEnum.SLIDING = { type: 3, value: "SLIDING" };
  IfcDoorPanelOperationEnum.FOLDING = { type: 3, value: "FOLDING" };
  IfcDoorPanelOperationEnum.REVOLVING = { type: 3, value: "REVOLVING" };
  IfcDoorPanelOperationEnum.ROLLINGUP = { type: 3, value: "ROLLINGUP" };
  IfcDoorPanelOperationEnum.FIXEDPANEL = { type: 3, value: "FIXEDPANEL" };
  IfcDoorPanelOperationEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDoorPanelOperationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcDoorPanelOperationEnum = IfcDoorPanelOperationEnum;
  class IfcDoorPanelPositionEnum {
  }
  IfcDoorPanelPositionEnum.LEFT = { type: 3, value: "LEFT" };
  IfcDoorPanelPositionEnum.MIDDLE = { type: 3, value: "MIDDLE" };
  IfcDoorPanelPositionEnum.RIGHT = { type: 3, value: "RIGHT" };
  IfcDoorPanelPositionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcDoorPanelPositionEnum = IfcDoorPanelPositionEnum;
  class IfcDoorStyleConstructionEnum {
  }
  IfcDoorStyleConstructionEnum.ALUMINIUM = { type: 3, value: "ALUMINIUM" };
  IfcDoorStyleConstructionEnum.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" };
  IfcDoorStyleConstructionEnum.STEEL = { type: 3, value: "STEEL" };
  IfcDoorStyleConstructionEnum.WOOD = { type: 3, value: "WOOD" };
  IfcDoorStyleConstructionEnum.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" };
  IfcDoorStyleConstructionEnum.ALUMINIUM_PLASTIC = { type: 3, value: "ALUMINIUM_PLASTIC" };
  IfcDoorStyleConstructionEnum.PLASTIC = { type: 3, value: "PLASTIC" };
  IfcDoorStyleConstructionEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDoorStyleConstructionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcDoorStyleConstructionEnum = IfcDoorStyleConstructionEnum;
  class IfcDoorStyleOperationEnum {
  }
  IfcDoorStyleOperationEnum.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" };
  IfcDoorStyleOperationEnum.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING" };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT" };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT" };
  IfcDoorStyleOperationEnum.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" };
  IfcDoorStyleOperationEnum.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_DOUBLE_SWING = { type: 3, value: "DOUBLE_DOOR_DOUBLE_SWING" };
  IfcDoorStyleOperationEnum.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" };
  IfcDoorStyleOperationEnum.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SLIDING = { type: 3, value: "DOUBLE_DOOR_SLIDING" };
  IfcDoorStyleOperationEnum.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" };
  IfcDoorStyleOperationEnum.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_FOLDING = { type: 3, value: "DOUBLE_DOOR_FOLDING" };
  IfcDoorStyleOperationEnum.REVOLVING = { type: 3, value: "REVOLVING" };
  IfcDoorStyleOperationEnum.ROLLINGUP = { type: 3, value: "ROLLINGUP" };
  IfcDoorStyleOperationEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDoorStyleOperationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcDoorStyleOperationEnum = IfcDoorStyleOperationEnum;
  class IfcDoorTypeEnum {
  }
  IfcDoorTypeEnum.DOOR = { type: 3, value: "DOOR" };
  IfcDoorTypeEnum.GATE = { type: 3, value: "GATE" };
  IfcDoorTypeEnum.TRAPDOOR = { type: 3, value: "TRAPDOOR" };
  IfcDoorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDoorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcDoorTypeEnum = IfcDoorTypeEnum;
  class IfcDoorTypeOperationEnum {
  }
  IfcDoorTypeOperationEnum.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" };
  IfcDoorTypeOperationEnum.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" };
  IfcDoorTypeOperationEnum.DOUBLE_DOOR_SINGLE_SWING = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING" };
  IfcDoorTypeOperationEnum.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT" };
  IfcDoorTypeOperationEnum.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT" };
  IfcDoorTypeOperationEnum.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" };
  IfcDoorTypeOperationEnum.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" };
  IfcDoorTypeOperationEnum.DOUBLE_DOOR_DOUBLE_SWING = { type: 3, value: "DOUBLE_DOOR_DOUBLE_SWING" };
  IfcDoorTypeOperationEnum.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" };
  IfcDoorTypeOperationEnum.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" };
  IfcDoorTypeOperationEnum.DOUBLE_DOOR_SLIDING = { type: 3, value: "DOUBLE_DOOR_SLIDING" };
  IfcDoorTypeOperationEnum.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" };
  IfcDoorTypeOperationEnum.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" };
  IfcDoorTypeOperationEnum.DOUBLE_DOOR_FOLDING = { type: 3, value: "DOUBLE_DOOR_FOLDING" };
  IfcDoorTypeOperationEnum.REVOLVING = { type: 3, value: "REVOLVING" };
  IfcDoorTypeOperationEnum.ROLLINGUP = { type: 3, value: "ROLLINGUP" };
  IfcDoorTypeOperationEnum.SWING_FIXED_LEFT = { type: 3, value: "SWING_FIXED_LEFT" };
  IfcDoorTypeOperationEnum.SWING_FIXED_RIGHT = { type: 3, value: "SWING_FIXED_RIGHT" };
  IfcDoorTypeOperationEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDoorTypeOperationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcDoorTypeOperationEnum = IfcDoorTypeOperationEnum;
  class IfcDuctFittingTypeEnum {
  }
  IfcDuctFittingTypeEnum.BEND = { type: 3, value: "BEND" };
  IfcDuctFittingTypeEnum.CONNECTOR = { type: 3, value: "CONNECTOR" };
  IfcDuctFittingTypeEnum.ENTRY = { type: 3, value: "ENTRY" };
  IfcDuctFittingTypeEnum.EXIT = { type: 3, value: "EXIT" };
  IfcDuctFittingTypeEnum.JUNCTION = { type: 3, value: "JUNCTION" };
  IfcDuctFittingTypeEnum.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" };
  IfcDuctFittingTypeEnum.TRANSITION = { type: 3, value: "TRANSITION" };
  IfcDuctFittingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDuctFittingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcDuctFittingTypeEnum = IfcDuctFittingTypeEnum;
  class IfcDuctSegmentTypeEnum {
  }
  IfcDuctSegmentTypeEnum.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" };
  IfcDuctSegmentTypeEnum.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" };
  IfcDuctSegmentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDuctSegmentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcDuctSegmentTypeEnum = IfcDuctSegmentTypeEnum;
  class IfcDuctSilencerTypeEnum {
  }
  IfcDuctSilencerTypeEnum.FLATOVAL = { type: 3, value: "FLATOVAL" };
  IfcDuctSilencerTypeEnum.RECTANGULAR = { type: 3, value: "RECTANGULAR" };
  IfcDuctSilencerTypeEnum.ROUND = { type: 3, value: "ROUND" };
  IfcDuctSilencerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcDuctSilencerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcDuctSilencerTypeEnum = IfcDuctSilencerTypeEnum;
  class IfcElectricApplianceTypeEnum {
  }
  IfcElectricApplianceTypeEnum.DISHWASHER = { type: 3, value: "DISHWASHER" };
  IfcElectricApplianceTypeEnum.ELECTRICCOOKER = { type: 3, value: "ELECTRICCOOKER" };
  IfcElectricApplianceTypeEnum.FREESTANDINGELECTRICHEATER = { type: 3, value: "FREESTANDINGELECTRICHEATER" };
  IfcElectricApplianceTypeEnum.FREESTANDINGFAN = { type: 3, value: "FREESTANDINGFAN" };
  IfcElectricApplianceTypeEnum.FREESTANDINGWATERHEATER = { type: 3, value: "FREESTANDINGWATERHEATER" };
  IfcElectricApplianceTypeEnum.FREESTANDINGWATERCOOLER = { type: 3, value: "FREESTANDINGWATERCOOLER" };
  IfcElectricApplianceTypeEnum.FREEZER = { type: 3, value: "FREEZER" };
  IfcElectricApplianceTypeEnum.FRIDGE_FREEZER = { type: 3, value: "FRIDGE_FREEZER" };
  IfcElectricApplianceTypeEnum.HANDDRYER = { type: 3, value: "HANDDRYER" };
  IfcElectricApplianceTypeEnum.KITCHENMACHINE = { type: 3, value: "KITCHENMACHINE" };
  IfcElectricApplianceTypeEnum.MICROWAVE = { type: 3, value: "MICROWAVE" };
  IfcElectricApplianceTypeEnum.PHOTOCOPIER = { type: 3, value: "PHOTOCOPIER" };
  IfcElectricApplianceTypeEnum.REFRIGERATOR = { type: 3, value: "REFRIGERATOR" };
  IfcElectricApplianceTypeEnum.TUMBLEDRYER = { type: 3, value: "TUMBLEDRYER" };
  IfcElectricApplianceTypeEnum.VENDINGMACHINE = { type: 3, value: "VENDINGMACHINE" };
  IfcElectricApplianceTypeEnum.WASHINGMACHINE = { type: 3, value: "WASHINGMACHINE" };
  IfcElectricApplianceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricApplianceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcElectricApplianceTypeEnum = IfcElectricApplianceTypeEnum;
  class IfcElectricDistributionBoardTypeEnum {
  }
  IfcElectricDistributionBoardTypeEnum.CONSUMERUNIT = { type: 3, value: "CONSUMERUNIT" };
  IfcElectricDistributionBoardTypeEnum.DISTRIBUTIONBOARD = { type: 3, value: "DISTRIBUTIONBOARD" };
  IfcElectricDistributionBoardTypeEnum.MOTORCONTROLCENTRE = { type: 3, value: "MOTORCONTROLCENTRE" };
  IfcElectricDistributionBoardTypeEnum.SWITCHBOARD = { type: 3, value: "SWITCHBOARD" };
  IfcElectricDistributionBoardTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricDistributionBoardTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcElectricDistributionBoardTypeEnum = IfcElectricDistributionBoardTypeEnum;
  class IfcElectricFlowStorageDeviceTypeEnum {
  }
  IfcElectricFlowStorageDeviceTypeEnum.BATTERY = { type: 3, value: "BATTERY" };
  IfcElectricFlowStorageDeviceTypeEnum.CAPACITORBANK = { type: 3, value: "CAPACITORBANK" };
  IfcElectricFlowStorageDeviceTypeEnum.HARMONICFILTER = { type: 3, value: "HARMONICFILTER" };
  IfcElectricFlowStorageDeviceTypeEnum.INDUCTORBANK = { type: 3, value: "INDUCTORBANK" };
  IfcElectricFlowStorageDeviceTypeEnum.UPS = { type: 3, value: "UPS" };
  IfcElectricFlowStorageDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricFlowStorageDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcElectricFlowStorageDeviceTypeEnum = IfcElectricFlowStorageDeviceTypeEnum;
  class IfcElectricGeneratorTypeEnum {
  }
  IfcElectricGeneratorTypeEnum.CHP = { type: 3, value: "CHP" };
  IfcElectricGeneratorTypeEnum.ENGINEGENERATOR = { type: 3, value: "ENGINEGENERATOR" };
  IfcElectricGeneratorTypeEnum.STANDALONE = { type: 3, value: "STANDALONE" };
  IfcElectricGeneratorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricGeneratorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcElectricGeneratorTypeEnum = IfcElectricGeneratorTypeEnum;
  class IfcElectricMotorTypeEnum {
  }
  IfcElectricMotorTypeEnum.DC = { type: 3, value: "DC" };
  IfcElectricMotorTypeEnum.INDUCTION = { type: 3, value: "INDUCTION" };
  IfcElectricMotorTypeEnum.POLYPHASE = { type: 3, value: "POLYPHASE" };
  IfcElectricMotorTypeEnum.RELUCTANCESYNCHRONOUS = { type: 3, value: "RELUCTANCESYNCHRONOUS" };
  IfcElectricMotorTypeEnum.SYNCHRONOUS = { type: 3, value: "SYNCHRONOUS" };
  IfcElectricMotorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricMotorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcElectricMotorTypeEnum = IfcElectricMotorTypeEnum;
  class IfcElectricTimeControlTypeEnum {
  }
  IfcElectricTimeControlTypeEnum.TIMECLOCK = { type: 3, value: "TIMECLOCK" };
  IfcElectricTimeControlTypeEnum.TIMEDELAY = { type: 3, value: "TIMEDELAY" };
  IfcElectricTimeControlTypeEnum.RELAY = { type: 3, value: "RELAY" };
  IfcElectricTimeControlTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElectricTimeControlTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcElectricTimeControlTypeEnum = IfcElectricTimeControlTypeEnum;
  class IfcElementAssemblyTypeEnum {
  }
  IfcElementAssemblyTypeEnum.ACCESSORY_ASSEMBLY = { type: 3, value: "ACCESSORY_ASSEMBLY" };
  IfcElementAssemblyTypeEnum.ARCH = { type: 3, value: "ARCH" };
  IfcElementAssemblyTypeEnum.BEAM_GRID = { type: 3, value: "BEAM_GRID" };
  IfcElementAssemblyTypeEnum.BRACED_FRAME = { type: 3, value: "BRACED_FRAME" };
  IfcElementAssemblyTypeEnum.GIRDER = { type: 3, value: "GIRDER" };
  IfcElementAssemblyTypeEnum.REINFORCEMENT_UNIT = { type: 3, value: "REINFORCEMENT_UNIT" };
  IfcElementAssemblyTypeEnum.RIGID_FRAME = { type: 3, value: "RIGID_FRAME" };
  IfcElementAssemblyTypeEnum.SLAB_FIELD = { type: 3, value: "SLAB_FIELD" };
  IfcElementAssemblyTypeEnum.TRUSS = { type: 3, value: "TRUSS" };
  IfcElementAssemblyTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcElementAssemblyTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcElementAssemblyTypeEnum = IfcElementAssemblyTypeEnum;
  class IfcElementCompositionEnum {
  }
  IfcElementCompositionEnum.COMPLEX = { type: 3, value: "COMPLEX" };
  IfcElementCompositionEnum.ELEMENT = { type: 3, value: "ELEMENT" };
  IfcElementCompositionEnum.PARTIAL = { type: 3, value: "PARTIAL" };
  IFC42.IfcElementCompositionEnum = IfcElementCompositionEnum;
  class IfcEngineTypeEnum {
  }
  IfcEngineTypeEnum.EXTERNALCOMBUSTION = { type: 3, value: "EXTERNALCOMBUSTION" };
  IfcEngineTypeEnum.INTERNALCOMBUSTION = { type: 3, value: "INTERNALCOMBUSTION" };
  IfcEngineTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcEngineTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcEngineTypeEnum = IfcEngineTypeEnum;
  class IfcEvaporativeCoolerTypeEnum {
  }
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER" };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER" };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER" };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER" };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVEAIRWASHER = { type: 3, value: "DIRECTEVAPORATIVEAIRWASHER" };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = { type: 3, value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER" };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVEWETCOIL = { type: 3, value: "INDIRECTEVAPORATIVEWETCOIL" };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = { type: 3, value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER" };
  IfcEvaporativeCoolerTypeEnum.INDIRECTDIRECTCOMBINATION = { type: 3, value: "INDIRECTDIRECTCOMBINATION" };
  IfcEvaporativeCoolerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcEvaporativeCoolerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcEvaporativeCoolerTypeEnum = IfcEvaporativeCoolerTypeEnum;
  class IfcEvaporatorTypeEnum {
  }
  IfcEvaporatorTypeEnum.DIRECTEXPANSION = { type: 3, value: "DIRECTEXPANSION" };
  IfcEvaporatorTypeEnum.DIRECTEXPANSIONSHELLANDTUBE = { type: 3, value: "DIRECTEXPANSIONSHELLANDTUBE" };
  IfcEvaporatorTypeEnum.DIRECTEXPANSIONTUBEINTUBE = { type: 3, value: "DIRECTEXPANSIONTUBEINTUBE" };
  IfcEvaporatorTypeEnum.DIRECTEXPANSIONBRAZEDPLATE = { type: 3, value: "DIRECTEXPANSIONBRAZEDPLATE" };
  IfcEvaporatorTypeEnum.FLOODEDSHELLANDTUBE = { type: 3, value: "FLOODEDSHELLANDTUBE" };
  IfcEvaporatorTypeEnum.SHELLANDCOIL = { type: 3, value: "SHELLANDCOIL" };
  IfcEvaporatorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcEvaporatorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcEvaporatorTypeEnum = IfcEvaporatorTypeEnum;
  class IfcEventTriggerTypeEnum {
  }
  IfcEventTriggerTypeEnum.EVENTRULE = { type: 3, value: "EVENTRULE" };
  IfcEventTriggerTypeEnum.EVENTMESSAGE = { type: 3, value: "EVENTMESSAGE" };
  IfcEventTriggerTypeEnum.EVENTTIME = { type: 3, value: "EVENTTIME" };
  IfcEventTriggerTypeEnum.EVENTCOMPLEX = { type: 3, value: "EVENTCOMPLEX" };
  IfcEventTriggerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcEventTriggerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcEventTriggerTypeEnum = IfcEventTriggerTypeEnum;
  class IfcEventTypeEnum {
  }
  IfcEventTypeEnum.STARTEVENT = { type: 3, value: "STARTEVENT" };
  IfcEventTypeEnum.ENDEVENT = { type: 3, value: "ENDEVENT" };
  IfcEventTypeEnum.INTERMEDIATEEVENT = { type: 3, value: "INTERMEDIATEEVENT" };
  IfcEventTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcEventTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcEventTypeEnum = IfcEventTypeEnum;
  class IfcExternalSpatialElementTypeEnum {
  }
  IfcExternalSpatialElementTypeEnum.EXTERNAL = { type: 3, value: "EXTERNAL" };
  IfcExternalSpatialElementTypeEnum.EXTERNAL_EARTH = { type: 3, value: "EXTERNAL_EARTH" };
  IfcExternalSpatialElementTypeEnum.EXTERNAL_WATER = { type: 3, value: "EXTERNAL_WATER" };
  IfcExternalSpatialElementTypeEnum.EXTERNAL_FIRE = { type: 3, value: "EXTERNAL_FIRE" };
  IfcExternalSpatialElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcExternalSpatialElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcExternalSpatialElementTypeEnum = IfcExternalSpatialElementTypeEnum;
  class IfcFanTypeEnum {
  }
  IfcFanTypeEnum.CENTRIFUGALFORWARDCURVED = { type: 3, value: "CENTRIFUGALFORWARDCURVED" };
  IfcFanTypeEnum.CENTRIFUGALRADIAL = { type: 3, value: "CENTRIFUGALRADIAL" };
  IfcFanTypeEnum.CENTRIFUGALBACKWARDINCLINEDCURVED = { type: 3, value: "CENTRIFUGALBACKWARDINCLINEDCURVED" };
  IfcFanTypeEnum.CENTRIFUGALAIRFOIL = { type: 3, value: "CENTRIFUGALAIRFOIL" };
  IfcFanTypeEnum.TUBEAXIAL = { type: 3, value: "TUBEAXIAL" };
  IfcFanTypeEnum.VANEAXIAL = { type: 3, value: "VANEAXIAL" };
  IfcFanTypeEnum.PROPELLORAXIAL = { type: 3, value: "PROPELLORAXIAL" };
  IfcFanTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFanTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcFanTypeEnum = IfcFanTypeEnum;
  class IfcFastenerTypeEnum {
  }
  IfcFastenerTypeEnum.GLUE = { type: 3, value: "GLUE" };
  IfcFastenerTypeEnum.MORTAR = { type: 3, value: "MORTAR" };
  IfcFastenerTypeEnum.WELD = { type: 3, value: "WELD" };
  IfcFastenerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFastenerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcFastenerTypeEnum = IfcFastenerTypeEnum;
  class IfcFilterTypeEnum {
  }
  IfcFilterTypeEnum.AIRPARTICLEFILTER = { type: 3, value: "AIRPARTICLEFILTER" };
  IfcFilterTypeEnum.COMPRESSEDAIRFILTER = { type: 3, value: "COMPRESSEDAIRFILTER" };
  IfcFilterTypeEnum.ODORFILTER = { type: 3, value: "ODORFILTER" };
  IfcFilterTypeEnum.OILFILTER = { type: 3, value: "OILFILTER" };
  IfcFilterTypeEnum.STRAINER = { type: 3, value: "STRAINER" };
  IfcFilterTypeEnum.WATERFILTER = { type: 3, value: "WATERFILTER" };
  IfcFilterTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFilterTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcFilterTypeEnum = IfcFilterTypeEnum;
  class IfcFireSuppressionTerminalTypeEnum {
  }
  IfcFireSuppressionTerminalTypeEnum.BREECHINGINLET = { type: 3, value: "BREECHINGINLET" };
  IfcFireSuppressionTerminalTypeEnum.FIREHYDRANT = { type: 3, value: "FIREHYDRANT" };
  IfcFireSuppressionTerminalTypeEnum.HOSEREEL = { type: 3, value: "HOSEREEL" };
  IfcFireSuppressionTerminalTypeEnum.SPRINKLER = { type: 3, value: "SPRINKLER" };
  IfcFireSuppressionTerminalTypeEnum.SPRINKLERDEFLECTOR = { type: 3, value: "SPRINKLERDEFLECTOR" };
  IfcFireSuppressionTerminalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFireSuppressionTerminalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcFireSuppressionTerminalTypeEnum = IfcFireSuppressionTerminalTypeEnum;
  class IfcFlowDirectionEnum {
  }
  IfcFlowDirectionEnum.SOURCE = { type: 3, value: "SOURCE" };
  IfcFlowDirectionEnum.SINK = { type: 3, value: "SINK" };
  IfcFlowDirectionEnum.SOURCEANDSINK = { type: 3, value: "SOURCEANDSINK" };
  IfcFlowDirectionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcFlowDirectionEnum = IfcFlowDirectionEnum;
  class IfcFlowInstrumentTypeEnum {
  }
  IfcFlowInstrumentTypeEnum.PRESSUREGAUGE = { type: 3, value: "PRESSUREGAUGE" };
  IfcFlowInstrumentTypeEnum.THERMOMETER = { type: 3, value: "THERMOMETER" };
  IfcFlowInstrumentTypeEnum.AMMETER = { type: 3, value: "AMMETER" };
  IfcFlowInstrumentTypeEnum.FREQUENCYMETER = { type: 3, value: "FREQUENCYMETER" };
  IfcFlowInstrumentTypeEnum.POWERFACTORMETER = { type: 3, value: "POWERFACTORMETER" };
  IfcFlowInstrumentTypeEnum.PHASEANGLEMETER = { type: 3, value: "PHASEANGLEMETER" };
  IfcFlowInstrumentTypeEnum.VOLTMETER_PEAK = { type: 3, value: "VOLTMETER_PEAK" };
  IfcFlowInstrumentTypeEnum.VOLTMETER_RMS = { type: 3, value: "VOLTMETER_RMS" };
  IfcFlowInstrumentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFlowInstrumentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcFlowInstrumentTypeEnum = IfcFlowInstrumentTypeEnum;
  class IfcFlowMeterTypeEnum {
  }
  IfcFlowMeterTypeEnum.ENERGYMETER = { type: 3, value: "ENERGYMETER" };
  IfcFlowMeterTypeEnum.GASMETER = { type: 3, value: "GASMETER" };
  IfcFlowMeterTypeEnum.OILMETER = { type: 3, value: "OILMETER" };
  IfcFlowMeterTypeEnum.WATERMETER = { type: 3, value: "WATERMETER" };
  IfcFlowMeterTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFlowMeterTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcFlowMeterTypeEnum = IfcFlowMeterTypeEnum;
  class IfcFootingTypeEnum {
  }
  IfcFootingTypeEnum.CAISSON_FOUNDATION = { type: 3, value: "CAISSON_FOUNDATION" };
  IfcFootingTypeEnum.FOOTING_BEAM = { type: 3, value: "FOOTING_BEAM" };
  IfcFootingTypeEnum.PAD_FOOTING = { type: 3, value: "PAD_FOOTING" };
  IfcFootingTypeEnum.PILE_CAP = { type: 3, value: "PILE_CAP" };
  IfcFootingTypeEnum.STRIP_FOOTING = { type: 3, value: "STRIP_FOOTING" };
  IfcFootingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFootingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcFootingTypeEnum = IfcFootingTypeEnum;
  class IfcFurnitureTypeEnum {
  }
  IfcFurnitureTypeEnum.CHAIR = { type: 3, value: "CHAIR" };
  IfcFurnitureTypeEnum.TABLE = { type: 3, value: "TABLE" };
  IfcFurnitureTypeEnum.DESK = { type: 3, value: "DESK" };
  IfcFurnitureTypeEnum.BED = { type: 3, value: "BED" };
  IfcFurnitureTypeEnum.FILECABINET = { type: 3, value: "FILECABINET" };
  IfcFurnitureTypeEnum.SHELF = { type: 3, value: "SHELF" };
  IfcFurnitureTypeEnum.SOFA = { type: 3, value: "SOFA" };
  IfcFurnitureTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcFurnitureTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcFurnitureTypeEnum = IfcFurnitureTypeEnum;
  class IfcGeographicElementTypeEnum {
  }
  IfcGeographicElementTypeEnum.TERRAIN = { type: 3, value: "TERRAIN" };
  IfcGeographicElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcGeographicElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcGeographicElementTypeEnum = IfcGeographicElementTypeEnum;
  class IfcGeometricProjectionEnum {
  }
  IfcGeometricProjectionEnum.GRAPH_VIEW = { type: 3, value: "GRAPH_VIEW" };
  IfcGeometricProjectionEnum.SKETCH_VIEW = { type: 3, value: "SKETCH_VIEW" };
  IfcGeometricProjectionEnum.MODEL_VIEW = { type: 3, value: "MODEL_VIEW" };
  IfcGeometricProjectionEnum.PLAN_VIEW = { type: 3, value: "PLAN_VIEW" };
  IfcGeometricProjectionEnum.REFLECTED_PLAN_VIEW = { type: 3, value: "REFLECTED_PLAN_VIEW" };
  IfcGeometricProjectionEnum.SECTION_VIEW = { type: 3, value: "SECTION_VIEW" };
  IfcGeometricProjectionEnum.ELEVATION_VIEW = { type: 3, value: "ELEVATION_VIEW" };
  IfcGeometricProjectionEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcGeometricProjectionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcGeometricProjectionEnum = IfcGeometricProjectionEnum;
  class IfcGlobalOrLocalEnum {
  }
  IfcGlobalOrLocalEnum.GLOBAL_COORDS = { type: 3, value: "GLOBAL_COORDS" };
  IfcGlobalOrLocalEnum.LOCAL_COORDS = { type: 3, value: "LOCAL_COORDS" };
  IFC42.IfcGlobalOrLocalEnum = IfcGlobalOrLocalEnum;
  class IfcGridTypeEnum {
  }
  IfcGridTypeEnum.RECTANGULAR = { type: 3, value: "RECTANGULAR" };
  IfcGridTypeEnum.RADIAL = { type: 3, value: "RADIAL" };
  IfcGridTypeEnum.TRIANGULAR = { type: 3, value: "TRIANGULAR" };
  IfcGridTypeEnum.IRREGULAR = { type: 3, value: "IRREGULAR" };
  IfcGridTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcGridTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcGridTypeEnum = IfcGridTypeEnum;
  class IfcHeatExchangerTypeEnum {
  }
  IfcHeatExchangerTypeEnum.PLATE = { type: 3, value: "PLATE" };
  IfcHeatExchangerTypeEnum.SHELLANDTUBE = { type: 3, value: "SHELLANDTUBE" };
  IfcHeatExchangerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcHeatExchangerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcHeatExchangerTypeEnum = IfcHeatExchangerTypeEnum;
  class IfcHumidifierTypeEnum {
  }
  IfcHumidifierTypeEnum.STEAMINJECTION = { type: 3, value: "STEAMINJECTION" };
  IfcHumidifierTypeEnum.ADIABATICAIRWASHER = { type: 3, value: "ADIABATICAIRWASHER" };
  IfcHumidifierTypeEnum.ADIABATICPAN = { type: 3, value: "ADIABATICPAN" };
  IfcHumidifierTypeEnum.ADIABATICWETTEDELEMENT = { type: 3, value: "ADIABATICWETTEDELEMENT" };
  IfcHumidifierTypeEnum.ADIABATICATOMIZING = { type: 3, value: "ADIABATICATOMIZING" };
  IfcHumidifierTypeEnum.ADIABATICULTRASONIC = { type: 3, value: "ADIABATICULTRASONIC" };
  IfcHumidifierTypeEnum.ADIABATICRIGIDMEDIA = { type: 3, value: "ADIABATICRIGIDMEDIA" };
  IfcHumidifierTypeEnum.ADIABATICCOMPRESSEDAIRNOZZLE = { type: 3, value: "ADIABATICCOMPRESSEDAIRNOZZLE" };
  IfcHumidifierTypeEnum.ASSISTEDELECTRIC = { type: 3, value: "ASSISTEDELECTRIC" };
  IfcHumidifierTypeEnum.ASSISTEDNATURALGAS = { type: 3, value: "ASSISTEDNATURALGAS" };
  IfcHumidifierTypeEnum.ASSISTEDPROPANE = { type: 3, value: "ASSISTEDPROPANE" };
  IfcHumidifierTypeEnum.ASSISTEDBUTANE = { type: 3, value: "ASSISTEDBUTANE" };
  IfcHumidifierTypeEnum.ASSISTEDSTEAM = { type: 3, value: "ASSISTEDSTEAM" };
  IfcHumidifierTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcHumidifierTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcHumidifierTypeEnum = IfcHumidifierTypeEnum;
  class IfcInterceptorTypeEnum {
  }
  IfcInterceptorTypeEnum.CYCLONIC = { type: 3, value: "CYCLONIC" };
  IfcInterceptorTypeEnum.GREASE = { type: 3, value: "GREASE" };
  IfcInterceptorTypeEnum.OIL = { type: 3, value: "OIL" };
  IfcInterceptorTypeEnum.PETROL = { type: 3, value: "PETROL" };
  IfcInterceptorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcInterceptorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcInterceptorTypeEnum = IfcInterceptorTypeEnum;
  class IfcInternalOrExternalEnum {
  }
  IfcInternalOrExternalEnum.INTERNAL = { type: 3, value: "INTERNAL" };
  IfcInternalOrExternalEnum.EXTERNAL = { type: 3, value: "EXTERNAL" };
  IfcInternalOrExternalEnum.EXTERNAL_EARTH = { type: 3, value: "EXTERNAL_EARTH" };
  IfcInternalOrExternalEnum.EXTERNAL_WATER = { type: 3, value: "EXTERNAL_WATER" };
  IfcInternalOrExternalEnum.EXTERNAL_FIRE = { type: 3, value: "EXTERNAL_FIRE" };
  IfcInternalOrExternalEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcInternalOrExternalEnum = IfcInternalOrExternalEnum;
  class IfcInventoryTypeEnum {
  }
  IfcInventoryTypeEnum.ASSETINVENTORY = { type: 3, value: "ASSETINVENTORY" };
  IfcInventoryTypeEnum.SPACEINVENTORY = { type: 3, value: "SPACEINVENTORY" };
  IfcInventoryTypeEnum.FURNITUREINVENTORY = { type: 3, value: "FURNITUREINVENTORY" };
  IfcInventoryTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcInventoryTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcInventoryTypeEnum = IfcInventoryTypeEnum;
  class IfcJunctionBoxTypeEnum {
  }
  IfcJunctionBoxTypeEnum.DATA = { type: 3, value: "DATA" };
  IfcJunctionBoxTypeEnum.POWER = { type: 3, value: "POWER" };
  IfcJunctionBoxTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcJunctionBoxTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcJunctionBoxTypeEnum = IfcJunctionBoxTypeEnum;
  class IfcKnotType {
  }
  IfcKnotType.UNIFORM_KNOTS = { type: 3, value: "UNIFORM_KNOTS" };
  IfcKnotType.QUASI_UNIFORM_KNOTS = { type: 3, value: "QUASI_UNIFORM_KNOTS" };
  IfcKnotType.PIECEWISE_BEZIER_KNOTS = { type: 3, value: "PIECEWISE_BEZIER_KNOTS" };
  IfcKnotType.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  IFC42.IfcKnotType = IfcKnotType;
  class IfcLaborResourceTypeEnum {
  }
  IfcLaborResourceTypeEnum.ADMINISTRATION = { type: 3, value: "ADMINISTRATION" };
  IfcLaborResourceTypeEnum.CARPENTRY = { type: 3, value: "CARPENTRY" };
  IfcLaborResourceTypeEnum.CLEANING = { type: 3, value: "CLEANING" };
  IfcLaborResourceTypeEnum.CONCRETE = { type: 3, value: "CONCRETE" };
  IfcLaborResourceTypeEnum.DRYWALL = { type: 3, value: "DRYWALL" };
  IfcLaborResourceTypeEnum.ELECTRIC = { type: 3, value: "ELECTRIC" };
  IfcLaborResourceTypeEnum.FINISHING = { type: 3, value: "FINISHING" };
  IfcLaborResourceTypeEnum.FLOORING = { type: 3, value: "FLOORING" };
  IfcLaborResourceTypeEnum.GENERAL = { type: 3, value: "GENERAL" };
  IfcLaborResourceTypeEnum.HVAC = { type: 3, value: "HVAC" };
  IfcLaborResourceTypeEnum.LANDSCAPING = { type: 3, value: "LANDSCAPING" };
  IfcLaborResourceTypeEnum.MASONRY = { type: 3, value: "MASONRY" };
  IfcLaborResourceTypeEnum.PAINTING = { type: 3, value: "PAINTING" };
  IfcLaborResourceTypeEnum.PAVING = { type: 3, value: "PAVING" };
  IfcLaborResourceTypeEnum.PLUMBING = { type: 3, value: "PLUMBING" };
  IfcLaborResourceTypeEnum.ROOFING = { type: 3, value: "ROOFING" };
  IfcLaborResourceTypeEnum.SITEGRADING = { type: 3, value: "SITEGRADING" };
  IfcLaborResourceTypeEnum.STEELWORK = { type: 3, value: "STEELWORK" };
  IfcLaborResourceTypeEnum.SURVEYING = { type: 3, value: "SURVEYING" };
  IfcLaborResourceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcLaborResourceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcLaborResourceTypeEnum = IfcLaborResourceTypeEnum;
  class IfcLampTypeEnum {
  }
  IfcLampTypeEnum.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" };
  IfcLampTypeEnum.FLUORESCENT = { type: 3, value: "FLUORESCENT" };
  IfcLampTypeEnum.HALOGEN = { type: 3, value: "HALOGEN" };
  IfcLampTypeEnum.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" };
  IfcLampTypeEnum.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" };
  IfcLampTypeEnum.LED = { type: 3, value: "LED" };
  IfcLampTypeEnum.METALHALIDE = { type: 3, value: "METALHALIDE" };
  IfcLampTypeEnum.OLED = { type: 3, value: "OLED" };
  IfcLampTypeEnum.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" };
  IfcLampTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcLampTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcLampTypeEnum = IfcLampTypeEnum;
  class IfcLayerSetDirectionEnum {
  }
  IfcLayerSetDirectionEnum.AXIS1 = { type: 3, value: "AXIS1" };
  IfcLayerSetDirectionEnum.AXIS2 = { type: 3, value: "AXIS2" };
  IfcLayerSetDirectionEnum.AXIS3 = { type: 3, value: "AXIS3" };
  IFC42.IfcLayerSetDirectionEnum = IfcLayerSetDirectionEnum;
  class IfcLightDistributionCurveEnum {
  }
  IfcLightDistributionCurveEnum.TYPE_A = { type: 3, value: "TYPE_A" };
  IfcLightDistributionCurveEnum.TYPE_B = { type: 3, value: "TYPE_B" };
  IfcLightDistributionCurveEnum.TYPE_C = { type: 3, value: "TYPE_C" };
  IfcLightDistributionCurveEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcLightDistributionCurveEnum = IfcLightDistributionCurveEnum;
  class IfcLightEmissionSourceEnum {
  }
  IfcLightEmissionSourceEnum.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" };
  IfcLightEmissionSourceEnum.FLUORESCENT = { type: 3, value: "FLUORESCENT" };
  IfcLightEmissionSourceEnum.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" };
  IfcLightEmissionSourceEnum.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" };
  IfcLightEmissionSourceEnum.LIGHTEMITTINGDIODE = { type: 3, value: "LIGHTEMITTINGDIODE" };
  IfcLightEmissionSourceEnum.LOWPRESSURESODIUM = { type: 3, value: "LOWPRESSURESODIUM" };
  IfcLightEmissionSourceEnum.LOWVOLTAGEHALOGEN = { type: 3, value: "LOWVOLTAGEHALOGEN" };
  IfcLightEmissionSourceEnum.MAINVOLTAGEHALOGEN = { type: 3, value: "MAINVOLTAGEHALOGEN" };
  IfcLightEmissionSourceEnum.METALHALIDE = { type: 3, value: "METALHALIDE" };
  IfcLightEmissionSourceEnum.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" };
  IfcLightEmissionSourceEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcLightEmissionSourceEnum = IfcLightEmissionSourceEnum;
  class IfcLightFixtureTypeEnum {
  }
  IfcLightFixtureTypeEnum.POINTSOURCE = { type: 3, value: "POINTSOURCE" };
  IfcLightFixtureTypeEnum.DIRECTIONSOURCE = { type: 3, value: "DIRECTIONSOURCE" };
  IfcLightFixtureTypeEnum.SECURITYLIGHTING = { type: 3, value: "SECURITYLIGHTING" };
  IfcLightFixtureTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcLightFixtureTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcLightFixtureTypeEnum = IfcLightFixtureTypeEnum;
  class IfcLoadGroupTypeEnum {
  }
  IfcLoadGroupTypeEnum.LOAD_GROUP = { type: 3, value: "LOAD_GROUP" };
  IfcLoadGroupTypeEnum.LOAD_CASE = { type: 3, value: "LOAD_CASE" };
  IfcLoadGroupTypeEnum.LOAD_COMBINATION = { type: 3, value: "LOAD_COMBINATION" };
  IfcLoadGroupTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcLoadGroupTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcLoadGroupTypeEnum = IfcLoadGroupTypeEnum;
  class IfcLogicalOperatorEnum {
  }
  IfcLogicalOperatorEnum.LOGICALAND = { type: 3, value: "LOGICALAND" };
  IfcLogicalOperatorEnum.LOGICALOR = { type: 3, value: "LOGICALOR" };
  IfcLogicalOperatorEnum.LOGICALXOR = { type: 3, value: "LOGICALXOR" };
  IfcLogicalOperatorEnum.LOGICALNOTAND = { type: 3, value: "LOGICALNOTAND" };
  IfcLogicalOperatorEnum.LOGICALNOTOR = { type: 3, value: "LOGICALNOTOR" };
  IFC42.IfcLogicalOperatorEnum = IfcLogicalOperatorEnum;
  class IfcMechanicalFastenerTypeEnum {
  }
  IfcMechanicalFastenerTypeEnum.ANCHORBOLT = { type: 3, value: "ANCHORBOLT" };
  IfcMechanicalFastenerTypeEnum.BOLT = { type: 3, value: "BOLT" };
  IfcMechanicalFastenerTypeEnum.DOWEL = { type: 3, value: "DOWEL" };
  IfcMechanicalFastenerTypeEnum.NAIL = { type: 3, value: "NAIL" };
  IfcMechanicalFastenerTypeEnum.NAILPLATE = { type: 3, value: "NAILPLATE" };
  IfcMechanicalFastenerTypeEnum.RIVET = { type: 3, value: "RIVET" };
  IfcMechanicalFastenerTypeEnum.SCREW = { type: 3, value: "SCREW" };
  IfcMechanicalFastenerTypeEnum.SHEARCONNECTOR = { type: 3, value: "SHEARCONNECTOR" };
  IfcMechanicalFastenerTypeEnum.STAPLE = { type: 3, value: "STAPLE" };
  IfcMechanicalFastenerTypeEnum.STUDSHEARCONNECTOR = { type: 3, value: "STUDSHEARCONNECTOR" };
  IfcMechanicalFastenerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcMechanicalFastenerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcMechanicalFastenerTypeEnum = IfcMechanicalFastenerTypeEnum;
  class IfcMedicalDeviceTypeEnum {
  }
  IfcMedicalDeviceTypeEnum.AIRSTATION = { type: 3, value: "AIRSTATION" };
  IfcMedicalDeviceTypeEnum.FEEDAIRUNIT = { type: 3, value: "FEEDAIRUNIT" };
  IfcMedicalDeviceTypeEnum.OXYGENGENERATOR = { type: 3, value: "OXYGENGENERATOR" };
  IfcMedicalDeviceTypeEnum.OXYGENPLANT = { type: 3, value: "OXYGENPLANT" };
  IfcMedicalDeviceTypeEnum.VACUUMSTATION = { type: 3, value: "VACUUMSTATION" };
  IfcMedicalDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcMedicalDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcMedicalDeviceTypeEnum = IfcMedicalDeviceTypeEnum;
  class IfcMemberTypeEnum {
  }
  IfcMemberTypeEnum.BRACE = { type: 3, value: "BRACE" };
  IfcMemberTypeEnum.CHORD = { type: 3, value: "CHORD" };
  IfcMemberTypeEnum.COLLAR = { type: 3, value: "COLLAR" };
  IfcMemberTypeEnum.MEMBER = { type: 3, value: "MEMBER" };
  IfcMemberTypeEnum.MULLION = { type: 3, value: "MULLION" };
  IfcMemberTypeEnum.PLATE = { type: 3, value: "PLATE" };
  IfcMemberTypeEnum.POST = { type: 3, value: "POST" };
  IfcMemberTypeEnum.PURLIN = { type: 3, value: "PURLIN" };
  IfcMemberTypeEnum.RAFTER = { type: 3, value: "RAFTER" };
  IfcMemberTypeEnum.STRINGER = { type: 3, value: "STRINGER" };
  IfcMemberTypeEnum.STRUT = { type: 3, value: "STRUT" };
  IfcMemberTypeEnum.STUD = { type: 3, value: "STUD" };
  IfcMemberTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcMemberTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcMemberTypeEnum = IfcMemberTypeEnum;
  class IfcMotorConnectionTypeEnum {
  }
  IfcMotorConnectionTypeEnum.BELTDRIVE = { type: 3, value: "BELTDRIVE" };
  IfcMotorConnectionTypeEnum.COUPLING = { type: 3, value: "COUPLING" };
  IfcMotorConnectionTypeEnum.DIRECTDRIVE = { type: 3, value: "DIRECTDRIVE" };
  IfcMotorConnectionTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcMotorConnectionTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcMotorConnectionTypeEnum = IfcMotorConnectionTypeEnum;
  class IfcNullStyle {
  }
  IfcNullStyle.NULL = { type: 3, value: "NULL" };
  IFC42.IfcNullStyle = IfcNullStyle;
  class IfcObjectTypeEnum {
  }
  IfcObjectTypeEnum.PRODUCT = { type: 3, value: "PRODUCT" };
  IfcObjectTypeEnum.PROCESS = { type: 3, value: "PROCESS" };
  IfcObjectTypeEnum.CONTROL = { type: 3, value: "CONTROL" };
  IfcObjectTypeEnum.RESOURCE = { type: 3, value: "RESOURCE" };
  IfcObjectTypeEnum.ACTOR = { type: 3, value: "ACTOR" };
  IfcObjectTypeEnum.GROUP = { type: 3, value: "GROUP" };
  IfcObjectTypeEnum.PROJECT = { type: 3, value: "PROJECT" };
  IfcObjectTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcObjectTypeEnum = IfcObjectTypeEnum;
  class IfcObjectiveEnum {
  }
  IfcObjectiveEnum.CODECOMPLIANCE = { type: 3, value: "CODECOMPLIANCE" };
  IfcObjectiveEnum.CODEWAIVER = { type: 3, value: "CODEWAIVER" };
  IfcObjectiveEnum.DESIGNINTENT = { type: 3, value: "DESIGNINTENT" };
  IfcObjectiveEnum.EXTERNAL = { type: 3, value: "EXTERNAL" };
  IfcObjectiveEnum.HEALTHANDSAFETY = { type: 3, value: "HEALTHANDSAFETY" };
  IfcObjectiveEnum.MERGECONFLICT = { type: 3, value: "MERGECONFLICT" };
  IfcObjectiveEnum.MODELVIEW = { type: 3, value: "MODELVIEW" };
  IfcObjectiveEnum.PARAMETER = { type: 3, value: "PARAMETER" };
  IfcObjectiveEnum.REQUIREMENT = { type: 3, value: "REQUIREMENT" };
  IfcObjectiveEnum.SPECIFICATION = { type: 3, value: "SPECIFICATION" };
  IfcObjectiveEnum.TRIGGERCONDITION = { type: 3, value: "TRIGGERCONDITION" };
  IfcObjectiveEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcObjectiveEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcObjectiveEnum = IfcObjectiveEnum;
  class IfcOccupantTypeEnum {
  }
  IfcOccupantTypeEnum.ASSIGNEE = { type: 3, value: "ASSIGNEE" };
  IfcOccupantTypeEnum.ASSIGNOR = { type: 3, value: "ASSIGNOR" };
  IfcOccupantTypeEnum.LESSEE = { type: 3, value: "LESSEE" };
  IfcOccupantTypeEnum.LESSOR = { type: 3, value: "LESSOR" };
  IfcOccupantTypeEnum.LETTINGAGENT = { type: 3, value: "LETTINGAGENT" };
  IfcOccupantTypeEnum.OWNER = { type: 3, value: "OWNER" };
  IfcOccupantTypeEnum.TENANT = { type: 3, value: "TENANT" };
  IfcOccupantTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcOccupantTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcOccupantTypeEnum = IfcOccupantTypeEnum;
  class IfcOpeningElementTypeEnum {
  }
  IfcOpeningElementTypeEnum.OPENING = { type: 3, value: "OPENING" };
  IfcOpeningElementTypeEnum.RECESS = { type: 3, value: "RECESS" };
  IfcOpeningElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcOpeningElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcOpeningElementTypeEnum = IfcOpeningElementTypeEnum;
  class IfcOutletTypeEnum {
  }
  IfcOutletTypeEnum.AUDIOVISUALOUTLET = { type: 3, value: "AUDIOVISUALOUTLET" };
  IfcOutletTypeEnum.COMMUNICATIONSOUTLET = { type: 3, value: "COMMUNICATIONSOUTLET" };
  IfcOutletTypeEnum.POWEROUTLET = { type: 3, value: "POWEROUTLET" };
  IfcOutletTypeEnum.DATAOUTLET = { type: 3, value: "DATAOUTLET" };
  IfcOutletTypeEnum.TELEPHONEOUTLET = { type: 3, value: "TELEPHONEOUTLET" };
  IfcOutletTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcOutletTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcOutletTypeEnum = IfcOutletTypeEnum;
  class IfcPerformanceHistoryTypeEnum {
  }
  IfcPerformanceHistoryTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPerformanceHistoryTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcPerformanceHistoryTypeEnum = IfcPerformanceHistoryTypeEnum;
  class IfcPermeableCoveringOperationEnum {
  }
  IfcPermeableCoveringOperationEnum.GRILL = { type: 3, value: "GRILL" };
  IfcPermeableCoveringOperationEnum.LOUVER = { type: 3, value: "LOUVER" };
  IfcPermeableCoveringOperationEnum.SCREEN = { type: 3, value: "SCREEN" };
  IfcPermeableCoveringOperationEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPermeableCoveringOperationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcPermeableCoveringOperationEnum = IfcPermeableCoveringOperationEnum;
  class IfcPermitTypeEnum {
  }
  IfcPermitTypeEnum.ACCESS = { type: 3, value: "ACCESS" };
  IfcPermitTypeEnum.BUILDING = { type: 3, value: "BUILDING" };
  IfcPermitTypeEnum.WORK = { type: 3, value: "WORK" };
  IfcPermitTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPermitTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcPermitTypeEnum = IfcPermitTypeEnum;
  class IfcPhysicalOrVirtualEnum {
  }
  IfcPhysicalOrVirtualEnum.PHYSICAL = { type: 3, value: "PHYSICAL" };
  IfcPhysicalOrVirtualEnum.VIRTUAL = { type: 3, value: "VIRTUAL" };
  IfcPhysicalOrVirtualEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcPhysicalOrVirtualEnum = IfcPhysicalOrVirtualEnum;
  class IfcPileConstructionEnum {
  }
  IfcPileConstructionEnum.CAST_IN_PLACE = { type: 3, value: "CAST_IN_PLACE" };
  IfcPileConstructionEnum.COMPOSITE = { type: 3, value: "COMPOSITE" };
  IfcPileConstructionEnum.PRECAST_CONCRETE = { type: 3, value: "PRECAST_CONCRETE" };
  IfcPileConstructionEnum.PREFAB_STEEL = { type: 3, value: "PREFAB_STEEL" };
  IfcPileConstructionEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPileConstructionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcPileConstructionEnum = IfcPileConstructionEnum;
  class IfcPileTypeEnum {
  }
  IfcPileTypeEnum.BORED = { type: 3, value: "BORED" };
  IfcPileTypeEnum.DRIVEN = { type: 3, value: "DRIVEN" };
  IfcPileTypeEnum.JETGROUTING = { type: 3, value: "JETGROUTING" };
  IfcPileTypeEnum.COHESION = { type: 3, value: "COHESION" };
  IfcPileTypeEnum.FRICTION = { type: 3, value: "FRICTION" };
  IfcPileTypeEnum.SUPPORT = { type: 3, value: "SUPPORT" };
  IfcPileTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPileTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcPileTypeEnum = IfcPileTypeEnum;
  class IfcPipeFittingTypeEnum {
  }
  IfcPipeFittingTypeEnum.BEND = { type: 3, value: "BEND" };
  IfcPipeFittingTypeEnum.CONNECTOR = { type: 3, value: "CONNECTOR" };
  IfcPipeFittingTypeEnum.ENTRY = { type: 3, value: "ENTRY" };
  IfcPipeFittingTypeEnum.EXIT = { type: 3, value: "EXIT" };
  IfcPipeFittingTypeEnum.JUNCTION = { type: 3, value: "JUNCTION" };
  IfcPipeFittingTypeEnum.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" };
  IfcPipeFittingTypeEnum.TRANSITION = { type: 3, value: "TRANSITION" };
  IfcPipeFittingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPipeFittingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcPipeFittingTypeEnum = IfcPipeFittingTypeEnum;
  class IfcPipeSegmentTypeEnum {
  }
  IfcPipeSegmentTypeEnum.CULVERT = { type: 3, value: "CULVERT" };
  IfcPipeSegmentTypeEnum.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" };
  IfcPipeSegmentTypeEnum.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" };
  IfcPipeSegmentTypeEnum.GUTTER = { type: 3, value: "GUTTER" };
  IfcPipeSegmentTypeEnum.SPOOL = { type: 3, value: "SPOOL" };
  IfcPipeSegmentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPipeSegmentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcPipeSegmentTypeEnum = IfcPipeSegmentTypeEnum;
  class IfcPlateTypeEnum {
  }
  IfcPlateTypeEnum.CURTAIN_PANEL = { type: 3, value: "CURTAIN_PANEL" };
  IfcPlateTypeEnum.SHEET = { type: 3, value: "SHEET" };
  IfcPlateTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPlateTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcPlateTypeEnum = IfcPlateTypeEnum;
  class IfcPreferredSurfaceCurveRepresentation {
  }
  IfcPreferredSurfaceCurveRepresentation.CURVE3D = { type: 3, value: "CURVE3D" };
  IfcPreferredSurfaceCurveRepresentation.PCURVE_S1 = { type: 3, value: "PCURVE_S1" };
  IfcPreferredSurfaceCurveRepresentation.PCURVE_S2 = { type: 3, value: "PCURVE_S2" };
  IFC42.IfcPreferredSurfaceCurveRepresentation = IfcPreferredSurfaceCurveRepresentation;
  class IfcProcedureTypeEnum {
  }
  IfcProcedureTypeEnum.ADVICE_CAUTION = { type: 3, value: "ADVICE_CAUTION" };
  IfcProcedureTypeEnum.ADVICE_NOTE = { type: 3, value: "ADVICE_NOTE" };
  IfcProcedureTypeEnum.ADVICE_WARNING = { type: 3, value: "ADVICE_WARNING" };
  IfcProcedureTypeEnum.CALIBRATION = { type: 3, value: "CALIBRATION" };
  IfcProcedureTypeEnum.DIAGNOSTIC = { type: 3, value: "DIAGNOSTIC" };
  IfcProcedureTypeEnum.SHUTDOWN = { type: 3, value: "SHUTDOWN" };
  IfcProcedureTypeEnum.STARTUP = { type: 3, value: "STARTUP" };
  IfcProcedureTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcProcedureTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcProcedureTypeEnum = IfcProcedureTypeEnum;
  class IfcProfileTypeEnum {
  }
  IfcProfileTypeEnum.CURVE = { type: 3, value: "CURVE" };
  IfcProfileTypeEnum.AREA = { type: 3, value: "AREA" };
  IFC42.IfcProfileTypeEnum = IfcProfileTypeEnum;
  class IfcProjectOrderTypeEnum {
  }
  IfcProjectOrderTypeEnum.CHANGEORDER = { type: 3, value: "CHANGEORDER" };
  IfcProjectOrderTypeEnum.MAINTENANCEWORKORDER = { type: 3, value: "MAINTENANCEWORKORDER" };
  IfcProjectOrderTypeEnum.MOVEORDER = { type: 3, value: "MOVEORDER" };
  IfcProjectOrderTypeEnum.PURCHASEORDER = { type: 3, value: "PURCHASEORDER" };
  IfcProjectOrderTypeEnum.WORKORDER = { type: 3, value: "WORKORDER" };
  IfcProjectOrderTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcProjectOrderTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcProjectOrderTypeEnum = IfcProjectOrderTypeEnum;
  class IfcProjectedOrTrueLengthEnum {
  }
  IfcProjectedOrTrueLengthEnum.PROJECTED_LENGTH = { type: 3, value: "PROJECTED_LENGTH" };
  IfcProjectedOrTrueLengthEnum.TRUE_LENGTH = { type: 3, value: "TRUE_LENGTH" };
  IFC42.IfcProjectedOrTrueLengthEnum = IfcProjectedOrTrueLengthEnum;
  class IfcProjectionElementTypeEnum {
  }
  IfcProjectionElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcProjectionElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcProjectionElementTypeEnum = IfcProjectionElementTypeEnum;
  class IfcPropertySetTemplateTypeEnum {
  }
  IfcPropertySetTemplateTypeEnum.PSET_TYPEDRIVENONLY = { type: 3, value: "PSET_TYPEDRIVENONLY" };
  IfcPropertySetTemplateTypeEnum.PSET_TYPEDRIVENOVERRIDE = { type: 3, value: "PSET_TYPEDRIVENOVERRIDE" };
  IfcPropertySetTemplateTypeEnum.PSET_OCCURRENCEDRIVEN = { type: 3, value: "PSET_OCCURRENCEDRIVEN" };
  IfcPropertySetTemplateTypeEnum.PSET_PERFORMANCEDRIVEN = { type: 3, value: "PSET_PERFORMANCEDRIVEN" };
  IfcPropertySetTemplateTypeEnum.QTO_TYPEDRIVENONLY = { type: 3, value: "QTO_TYPEDRIVENONLY" };
  IfcPropertySetTemplateTypeEnum.QTO_TYPEDRIVENOVERRIDE = { type: 3, value: "QTO_TYPEDRIVENOVERRIDE" };
  IfcPropertySetTemplateTypeEnum.QTO_OCCURRENCEDRIVEN = { type: 3, value: "QTO_OCCURRENCEDRIVEN" };
  IfcPropertySetTemplateTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcPropertySetTemplateTypeEnum = IfcPropertySetTemplateTypeEnum;
  class IfcProtectiveDeviceTrippingUnitTypeEnum {
  }
  IfcProtectiveDeviceTrippingUnitTypeEnum.ELECTRONIC = { type: 3, value: "ELECTRONIC" };
  IfcProtectiveDeviceTrippingUnitTypeEnum.ELECTROMAGNETIC = { type: 3, value: "ELECTROMAGNETIC" };
  IfcProtectiveDeviceTrippingUnitTypeEnum.RESIDUALCURRENT = { type: 3, value: "RESIDUALCURRENT" };
  IfcProtectiveDeviceTrippingUnitTypeEnum.THERMAL = { type: 3, value: "THERMAL" };
  IfcProtectiveDeviceTrippingUnitTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcProtectiveDeviceTrippingUnitTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcProtectiveDeviceTrippingUnitTypeEnum = IfcProtectiveDeviceTrippingUnitTypeEnum;
  class IfcProtectiveDeviceTypeEnum {
  }
  IfcProtectiveDeviceTypeEnum.CIRCUITBREAKER = { type: 3, value: "CIRCUITBREAKER" };
  IfcProtectiveDeviceTypeEnum.EARTHLEAKAGECIRCUITBREAKER = { type: 3, value: "EARTHLEAKAGECIRCUITBREAKER" };
  IfcProtectiveDeviceTypeEnum.EARTHINGSWITCH = { type: 3, value: "EARTHINGSWITCH" };
  IfcProtectiveDeviceTypeEnum.FUSEDISCONNECTOR = { type: 3, value: "FUSEDISCONNECTOR" };
  IfcProtectiveDeviceTypeEnum.RESIDUALCURRENTCIRCUITBREAKER = { type: 3, value: "RESIDUALCURRENTCIRCUITBREAKER" };
  IfcProtectiveDeviceTypeEnum.RESIDUALCURRENTSWITCH = { type: 3, value: "RESIDUALCURRENTSWITCH" };
  IfcProtectiveDeviceTypeEnum.VARISTOR = { type: 3, value: "VARISTOR" };
  IfcProtectiveDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcProtectiveDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcProtectiveDeviceTypeEnum = IfcProtectiveDeviceTypeEnum;
  class IfcPumpTypeEnum {
  }
  IfcPumpTypeEnum.CIRCULATOR = { type: 3, value: "CIRCULATOR" };
  IfcPumpTypeEnum.ENDSUCTION = { type: 3, value: "ENDSUCTION" };
  IfcPumpTypeEnum.SPLITCASE = { type: 3, value: "SPLITCASE" };
  IfcPumpTypeEnum.SUBMERSIBLEPUMP = { type: 3, value: "SUBMERSIBLEPUMP" };
  IfcPumpTypeEnum.SUMPPUMP = { type: 3, value: "SUMPPUMP" };
  IfcPumpTypeEnum.VERTICALINLINE = { type: 3, value: "VERTICALINLINE" };
  IfcPumpTypeEnum.VERTICALTURBINE = { type: 3, value: "VERTICALTURBINE" };
  IfcPumpTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcPumpTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcPumpTypeEnum = IfcPumpTypeEnum;
  class IfcRailingTypeEnum {
  }
  IfcRailingTypeEnum.HANDRAIL = { type: 3, value: "HANDRAIL" };
  IfcRailingTypeEnum.GUARDRAIL = { type: 3, value: "GUARDRAIL" };
  IfcRailingTypeEnum.BALUSTRADE = { type: 3, value: "BALUSTRADE" };
  IfcRailingTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcRailingTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcRailingTypeEnum = IfcRailingTypeEnum;
  class IfcRampFlightTypeEnum {
  }
  IfcRampFlightTypeEnum.STRAIGHT = { type: 3, value: "STRAIGHT" };
  IfcRampFlightTypeEnum.SPIRAL = { type: 3, value: "SPIRAL" };
  IfcRampFlightTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcRampFlightTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcRampFlightTypeEnum = IfcRampFlightTypeEnum;
  class IfcRampTypeEnum {
  }
  IfcRampTypeEnum.STRAIGHT_RUN_RAMP = { type: 3, value: "STRAIGHT_RUN_RAMP" };
  IfcRampTypeEnum.TWO_STRAIGHT_RUN_RAMP = { type: 3, value: "TWO_STRAIGHT_RUN_RAMP" };
  IfcRampTypeEnum.QUARTER_TURN_RAMP = { type: 3, value: "QUARTER_TURN_RAMP" };
  IfcRampTypeEnum.TWO_QUARTER_TURN_RAMP = { type: 3, value: "TWO_QUARTER_TURN_RAMP" };
  IfcRampTypeEnum.HALF_TURN_RAMP = { type: 3, value: "HALF_TURN_RAMP" };
  IfcRampTypeEnum.SPIRAL_RAMP = { type: 3, value: "SPIRAL_RAMP" };
  IfcRampTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcRampTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcRampTypeEnum = IfcRampTypeEnum;
  class IfcRecurrenceTypeEnum {
  }
  IfcRecurrenceTypeEnum.DAILY = { type: 3, value: "DAILY" };
  IfcRecurrenceTypeEnum.WEEKLY = { type: 3, value: "WEEKLY" };
  IfcRecurrenceTypeEnum.MONTHLY_BY_DAY_OF_MONTH = { type: 3, value: "MONTHLY_BY_DAY_OF_MONTH" };
  IfcRecurrenceTypeEnum.MONTHLY_BY_POSITION = { type: 3, value: "MONTHLY_BY_POSITION" };
  IfcRecurrenceTypeEnum.BY_DAY_COUNT = { type: 3, value: "BY_DAY_COUNT" };
  IfcRecurrenceTypeEnum.BY_WEEKDAY_COUNT = { type: 3, value: "BY_WEEKDAY_COUNT" };
  IfcRecurrenceTypeEnum.YEARLY_BY_DAY_OF_MONTH = { type: 3, value: "YEARLY_BY_DAY_OF_MONTH" };
  IfcRecurrenceTypeEnum.YEARLY_BY_POSITION = { type: 3, value: "YEARLY_BY_POSITION" };
  IFC42.IfcRecurrenceTypeEnum = IfcRecurrenceTypeEnum;
  class IfcReflectanceMethodEnum {
  }
  IfcReflectanceMethodEnum.BLINN = { type: 3, value: "BLINN" };
  IfcReflectanceMethodEnum.FLAT = { type: 3, value: "FLAT" };
  IfcReflectanceMethodEnum.GLASS = { type: 3, value: "GLASS" };
  IfcReflectanceMethodEnum.MATT = { type: 3, value: "MATT" };
  IfcReflectanceMethodEnum.METAL = { type: 3, value: "METAL" };
  IfcReflectanceMethodEnum.MIRROR = { type: 3, value: "MIRROR" };
  IfcReflectanceMethodEnum.PHONG = { type: 3, value: "PHONG" };
  IfcReflectanceMethodEnum.PLASTIC = { type: 3, value: "PLASTIC" };
  IfcReflectanceMethodEnum.STRAUSS = { type: 3, value: "STRAUSS" };
  IfcReflectanceMethodEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcReflectanceMethodEnum = IfcReflectanceMethodEnum;
  class IfcReinforcingBarRoleEnum {
  }
  IfcReinforcingBarRoleEnum.MAIN = { type: 3, value: "MAIN" };
  IfcReinforcingBarRoleEnum.SHEAR = { type: 3, value: "SHEAR" };
  IfcReinforcingBarRoleEnum.LIGATURE = { type: 3, value: "LIGATURE" };
  IfcReinforcingBarRoleEnum.STUD = { type: 3, value: "STUD" };
  IfcReinforcingBarRoleEnum.PUNCHING = { type: 3, value: "PUNCHING" };
  IfcReinforcingBarRoleEnum.EDGE = { type: 3, value: "EDGE" };
  IfcReinforcingBarRoleEnum.RING = { type: 3, value: "RING" };
  IfcReinforcingBarRoleEnum.ANCHORING = { type: 3, value: "ANCHORING" };
  IfcReinforcingBarRoleEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcReinforcingBarRoleEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcReinforcingBarRoleEnum = IfcReinforcingBarRoleEnum;
  class IfcReinforcingBarSurfaceEnum {
  }
  IfcReinforcingBarSurfaceEnum.PLAIN = { type: 3, value: "PLAIN" };
  IfcReinforcingBarSurfaceEnum.TEXTURED = { type: 3, value: "TEXTURED" };
  IFC42.IfcReinforcingBarSurfaceEnum = IfcReinforcingBarSurfaceEnum;
  class IfcReinforcingBarTypeEnum {
  }
  IfcReinforcingBarTypeEnum.ANCHORING = { type: 3, value: "ANCHORING" };
  IfcReinforcingBarTypeEnum.EDGE = { type: 3, value: "EDGE" };
  IfcReinforcingBarTypeEnum.LIGATURE = { type: 3, value: "LIGATURE" };
  IfcReinforcingBarTypeEnum.MAIN = { type: 3, value: "MAIN" };
  IfcReinforcingBarTypeEnum.PUNCHING = { type: 3, value: "PUNCHING" };
  IfcReinforcingBarTypeEnum.RING = { type: 3, value: "RING" };
  IfcReinforcingBarTypeEnum.SHEAR = { type: 3, value: "SHEAR" };
  IfcReinforcingBarTypeEnum.STUD = { type: 3, value: "STUD" };
  IfcReinforcingBarTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcReinforcingBarTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcReinforcingBarTypeEnum = IfcReinforcingBarTypeEnum;
  class IfcReinforcingMeshTypeEnum {
  }
  IfcReinforcingMeshTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcReinforcingMeshTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcReinforcingMeshTypeEnum = IfcReinforcingMeshTypeEnum;
  class IfcRoleEnum {
  }
  IfcRoleEnum.SUPPLIER = { type: 3, value: "SUPPLIER" };
  IfcRoleEnum.MANUFACTURER = { type: 3, value: "MANUFACTURER" };
  IfcRoleEnum.CONTRACTOR = { type: 3, value: "CONTRACTOR" };
  IfcRoleEnum.SUBCONTRACTOR = { type: 3, value: "SUBCONTRACTOR" };
  IfcRoleEnum.ARCHITECT = { type: 3, value: "ARCHITECT" };
  IfcRoleEnum.STRUCTURALENGINEER = { type: 3, value: "STRUCTURALENGINEER" };
  IfcRoleEnum.COSTENGINEER = { type: 3, value: "COSTENGINEER" };
  IfcRoleEnum.CLIENT = { type: 3, value: "CLIENT" };
  IfcRoleEnum.BUILDINGOWNER = { type: 3, value: "BUILDINGOWNER" };
  IfcRoleEnum.BUILDINGOPERATOR = { type: 3, value: "BUILDINGOPERATOR" };
  IfcRoleEnum.MECHANICALENGINEER = { type: 3, value: "MECHANICALENGINEER" };
  IfcRoleEnum.ELECTRICALENGINEER = { type: 3, value: "ELECTRICALENGINEER" };
  IfcRoleEnum.PROJECTMANAGER = { type: 3, value: "PROJECTMANAGER" };
  IfcRoleEnum.FACILITIESMANAGER = { type: 3, value: "FACILITIESMANAGER" };
  IfcRoleEnum.CIVILENGINEER = { type: 3, value: "CIVILENGINEER" };
  IfcRoleEnum.COMMISSIONINGENGINEER = { type: 3, value: "COMMISSIONINGENGINEER" };
  IfcRoleEnum.ENGINEER = { type: 3, value: "ENGINEER" };
  IfcRoleEnum.OWNER = { type: 3, value: "OWNER" };
  IfcRoleEnum.CONSULTANT = { type: 3, value: "CONSULTANT" };
  IfcRoleEnum.CONSTRUCTIONMANAGER = { type: 3, value: "CONSTRUCTIONMANAGER" };
  IfcRoleEnum.FIELDCONSTRUCTIONMANAGER = { type: 3, value: "FIELDCONSTRUCTIONMANAGER" };
  IfcRoleEnum.RESELLER = { type: 3, value: "RESELLER" };
  IfcRoleEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IFC42.IfcRoleEnum = IfcRoleEnum;
  class IfcRoofTypeEnum {
  }
  IfcRoofTypeEnum.FLAT_ROOF = { type: 3, value: "FLAT_ROOF" };
  IfcRoofTypeEnum.SHED_ROOF = { type: 3, value: "SHED_ROOF" };
  IfcRoofTypeEnum.GABLE_ROOF = { type: 3, value: "GABLE_ROOF" };
  IfcRoofTypeEnum.HIP_ROOF = { type: 3, value: "HIP_ROOF" };
  IfcRoofTypeEnum.HIPPED_GABLE_ROOF = { type: 3, value: "HIPPED_GABLE_ROOF" };
  IfcRoofTypeEnum.GAMBREL_ROOF = { type: 3, value: "GAMBREL_ROOF" };
  IfcRoofTypeEnum.MANSARD_ROOF = { type: 3, value: "MANSARD_ROOF" };
  IfcRoofTypeEnum.BARREL_ROOF = { type: 3, value: "BARREL_ROOF" };
  IfcRoofTypeEnum.RAINBOW_ROOF = { type: 3, value: "RAINBOW_ROOF" };
  IfcRoofTypeEnum.BUTTERFLY_ROOF = { type: 3, value: "BUTTERFLY_ROOF" };
  IfcRoofTypeEnum.PAVILION_ROOF = { type: 3, value: "PAVILION_ROOF" };
  IfcRoofTypeEnum.DOME_ROOF = { type: 3, value: "DOME_ROOF" };
  IfcRoofTypeEnum.FREEFORM = { type: 3, value: "FREEFORM" };
  IfcRoofTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcRoofTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcRoofTypeEnum = IfcRoofTypeEnum;
  class IfcSIPrefix {
  }
  IfcSIPrefix.EXA = { type: 3, value: "EXA" };
  IfcSIPrefix.PETA = { type: 3, value: "PETA" };
  IfcSIPrefix.TERA = { type: 3, value: "TERA" };
  IfcSIPrefix.GIGA = { type: 3, value: "GIGA" };
  IfcSIPrefix.MEGA = { type: 3, value: "MEGA" };
  IfcSIPrefix.KILO = { type: 3, value: "KILO" };
  IfcSIPrefix.HECTO = { type: 3, value: "HECTO" };
  IfcSIPrefix.DECA = { type: 3, value: "DECA" };
  IfcSIPrefix.DECI = { type: 3, value: "DECI" };
  IfcSIPrefix.CENTI = { type: 3, value: "CENTI" };
  IfcSIPrefix.MILLI = { type: 3, value: "MILLI" };
  IfcSIPrefix.MICRO = { type: 3, value: "MICRO" };
  IfcSIPrefix.NANO = { type: 3, value: "NANO" };
  IfcSIPrefix.PICO = { type: 3, value: "PICO" };
  IfcSIPrefix.FEMTO = { type: 3, value: "FEMTO" };
  IfcSIPrefix.ATTO = { type: 3, value: "ATTO" };
  IFC42.IfcSIPrefix = IfcSIPrefix;
  class IfcSIUnitName {
  }
  IfcSIUnitName.AMPERE = { type: 3, value: "AMPERE" };
  IfcSIUnitName.BECQUEREL = { type: 3, value: "BECQUEREL" };
  IfcSIUnitName.CANDELA = { type: 3, value: "CANDELA" };
  IfcSIUnitName.COULOMB = { type: 3, value: "COULOMB" };
  IfcSIUnitName.CUBIC_METRE = { type: 3, value: "CUBIC_METRE" };
  IfcSIUnitName.DEGREE_CELSIUS = { type: 3, value: "DEGREE_CELSIUS" };
  IfcSIUnitName.FARAD = { type: 3, value: "FARAD" };
  IfcSIUnitName.GRAM = { type: 3, value: "GRAM" };
  IfcSIUnitName.GRAY = { type: 3, value: "GRAY" };
  IfcSIUnitName.HENRY = { type: 3, value: "HENRY" };
  IfcSIUnitName.HERTZ = { type: 3, value: "HERTZ" };
  IfcSIUnitName.JOULE = { type: 3, value: "JOULE" };
  IfcSIUnitName.KELVIN = { type: 3, value: "KELVIN" };
  IfcSIUnitName.LUMEN = { type: 3, value: "LUMEN" };
  IfcSIUnitName.LUX = { type: 3, value: "LUX" };
  IfcSIUnitName.METRE = { type: 3, value: "METRE" };
  IfcSIUnitName.MOLE = { type: 3, value: "MOLE" };
  IfcSIUnitName.NEWTON = { type: 3, value: "NEWTON" };
  IfcSIUnitName.OHM = { type: 3, value: "OHM" };
  IfcSIUnitName.PASCAL = { type: 3, value: "PASCAL" };
  IfcSIUnitName.RADIAN = { type: 3, value: "RADIAN" };
  IfcSIUnitName.SECOND = { type: 3, value: "SECOND" };
  IfcSIUnitName.SIEMENS = { type: 3, value: "SIEMENS" };
  IfcSIUnitName.SIEVERT = { type: 3, value: "SIEVERT" };
  IfcSIUnitName.SQUARE_METRE = { type: 3, value: "SQUARE_METRE" };
  IfcSIUnitName.STERADIAN = { type: 3, value: "STERADIAN" };
  IfcSIUnitName.TESLA = { type: 3, value: "TESLA" };
  IfcSIUnitName.VOLT = { type: 3, value: "VOLT" };
  IfcSIUnitName.WATT = { type: 3, value: "WATT" };
  IfcSIUnitName.WEBER = { type: 3, value: "WEBER" };
  IFC42.IfcSIUnitName = IfcSIUnitName;
  class IfcSanitaryTerminalTypeEnum {
  }
  IfcSanitaryTerminalTypeEnum.BATH = { type: 3, value: "BATH" };
  IfcSanitaryTerminalTypeEnum.BIDET = { type: 3, value: "BIDET" };
  IfcSanitaryTerminalTypeEnum.CISTERN = { type: 3, value: "CISTERN" };
  IfcSanitaryTerminalTypeEnum.SHOWER = { type: 3, value: "SHOWER" };
  IfcSanitaryTerminalTypeEnum.SINK = { type: 3, value: "SINK" };
  IfcSanitaryTerminalTypeEnum.SANITARYFOUNTAIN = { type: 3, value: "SANITARYFOUNTAIN" };
  IfcSanitaryTerminalTypeEnum.TOILETPAN = { type: 3, value: "TOILETPAN" };
  IfcSanitaryTerminalTypeEnum.URINAL = { type: 3, value: "URINAL" };
  IfcSanitaryTerminalTypeEnum.WASHHANDBASIN = { type: 3, value: "WASHHANDBASIN" };
  IfcSanitaryTerminalTypeEnum.WCSEAT = { type: 3, value: "WCSEAT" };
  IfcSanitaryTerminalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSanitaryTerminalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcSanitaryTerminalTypeEnum = IfcSanitaryTerminalTypeEnum;
  class IfcSectionTypeEnum {
  }
  IfcSectionTypeEnum.UNIFORM = { type: 3, value: "UNIFORM" };
  IfcSectionTypeEnum.TAPERED = { type: 3, value: "TAPERED" };
  IFC42.IfcSectionTypeEnum = IfcSectionTypeEnum;
  class IfcSensorTypeEnum {
  }
  IfcSensorTypeEnum.COSENSOR = { type: 3, value: "COSENSOR" };
  IfcSensorTypeEnum.CO2SENSOR = { type: 3, value: "CO2SENSOR" };
  IfcSensorTypeEnum.CONDUCTANCESENSOR = { type: 3, value: "CONDUCTANCESENSOR" };
  IfcSensorTypeEnum.CONTACTSENSOR = { type: 3, value: "CONTACTSENSOR" };
  IfcSensorTypeEnum.FIRESENSOR = { type: 3, value: "FIRESENSOR" };
  IfcSensorTypeEnum.FLOWSENSOR = { type: 3, value: "FLOWSENSOR" };
  IfcSensorTypeEnum.FROSTSENSOR = { type: 3, value: "FROSTSENSOR" };
  IfcSensorTypeEnum.GASSENSOR = { type: 3, value: "GASSENSOR" };
  IfcSensorTypeEnum.HEATSENSOR = { type: 3, value: "HEATSENSOR" };
  IfcSensorTypeEnum.HUMIDITYSENSOR = { type: 3, value: "HUMIDITYSENSOR" };
  IfcSensorTypeEnum.IDENTIFIERSENSOR = { type: 3, value: "IDENTIFIERSENSOR" };
  IfcSensorTypeEnum.IONCONCENTRATIONSENSOR = { type: 3, value: "IONCONCENTRATIONSENSOR" };
  IfcSensorTypeEnum.LEVELSENSOR = { type: 3, value: "LEVELSENSOR" };
  IfcSensorTypeEnum.LIGHTSENSOR = { type: 3, value: "LIGHTSENSOR" };
  IfcSensorTypeEnum.MOISTURESENSOR = { type: 3, value: "MOISTURESENSOR" };
  IfcSensorTypeEnum.MOVEMENTSENSOR = { type: 3, value: "MOVEMENTSENSOR" };
  IfcSensorTypeEnum.PHSENSOR = { type: 3, value: "PHSENSOR" };
  IfcSensorTypeEnum.PRESSURESENSOR = { type: 3, value: "PRESSURESENSOR" };
  IfcSensorTypeEnum.RADIATIONSENSOR = { type: 3, value: "RADIATIONSENSOR" };
  IfcSensorTypeEnum.RADIOACTIVITYSENSOR = { type: 3, value: "RADIOACTIVITYSENSOR" };
  IfcSensorTypeEnum.SMOKESENSOR = { type: 3, value: "SMOKESENSOR" };
  IfcSensorTypeEnum.SOUNDSENSOR = { type: 3, value: "SOUNDSENSOR" };
  IfcSensorTypeEnum.TEMPERATURESENSOR = { type: 3, value: "TEMPERATURESENSOR" };
  IfcSensorTypeEnum.WINDSENSOR = { type: 3, value: "WINDSENSOR" };
  IfcSensorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSensorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcSensorTypeEnum = IfcSensorTypeEnum;
  class IfcSequenceEnum {
  }
  IfcSequenceEnum.START_START = { type: 3, value: "START_START" };
  IfcSequenceEnum.START_FINISH = { type: 3, value: "START_FINISH" };
  IfcSequenceEnum.FINISH_START = { type: 3, value: "FINISH_START" };
  IfcSequenceEnum.FINISH_FINISH = { type: 3, value: "FINISH_FINISH" };
  IfcSequenceEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSequenceEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcSequenceEnum = IfcSequenceEnum;
  class IfcShadingDeviceTypeEnum {
  }
  IfcShadingDeviceTypeEnum.JALOUSIE = { type: 3, value: "JALOUSIE" };
  IfcShadingDeviceTypeEnum.SHUTTER = { type: 3, value: "SHUTTER" };
  IfcShadingDeviceTypeEnum.AWNING = { type: 3, value: "AWNING" };
  IfcShadingDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcShadingDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcShadingDeviceTypeEnum = IfcShadingDeviceTypeEnum;
  class IfcSimplePropertyTemplateTypeEnum {
  }
  IfcSimplePropertyTemplateTypeEnum.P_SINGLEVALUE = { type: 3, value: "P_SINGLEVALUE" };
  IfcSimplePropertyTemplateTypeEnum.P_ENUMERATEDVALUE = { type: 3, value: "P_ENUMERATEDVALUE" };
  IfcSimplePropertyTemplateTypeEnum.P_BOUNDEDVALUE = { type: 3, value: "P_BOUNDEDVALUE" };
  IfcSimplePropertyTemplateTypeEnum.P_LISTVALUE = { type: 3, value: "P_LISTVALUE" };
  IfcSimplePropertyTemplateTypeEnum.P_TABLEVALUE = { type: 3, value: "P_TABLEVALUE" };
  IfcSimplePropertyTemplateTypeEnum.P_REFERENCEVALUE = { type: 3, value: "P_REFERENCEVALUE" };
  IfcSimplePropertyTemplateTypeEnum.Q_LENGTH = { type: 3, value: "Q_LENGTH" };
  IfcSimplePropertyTemplateTypeEnum.Q_AREA = { type: 3, value: "Q_AREA" };
  IfcSimplePropertyTemplateTypeEnum.Q_VOLUME = { type: 3, value: "Q_VOLUME" };
  IfcSimplePropertyTemplateTypeEnum.Q_COUNT = { type: 3, value: "Q_COUNT" };
  IfcSimplePropertyTemplateTypeEnum.Q_WEIGHT = { type: 3, value: "Q_WEIGHT" };
  IfcSimplePropertyTemplateTypeEnum.Q_TIME = { type: 3, value: "Q_TIME" };
  IFC42.IfcSimplePropertyTemplateTypeEnum = IfcSimplePropertyTemplateTypeEnum;
  class IfcSlabTypeEnum {
  }
  IfcSlabTypeEnum.FLOOR = { type: 3, value: "FLOOR" };
  IfcSlabTypeEnum.ROOF = { type: 3, value: "ROOF" };
  IfcSlabTypeEnum.LANDING = { type: 3, value: "LANDING" };
  IfcSlabTypeEnum.BASESLAB = { type: 3, value: "BASESLAB" };
  IfcSlabTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSlabTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcSlabTypeEnum = IfcSlabTypeEnum;
  class IfcSolarDeviceTypeEnum {
  }
  IfcSolarDeviceTypeEnum.SOLARCOLLECTOR = { type: 3, value: "SOLARCOLLECTOR" };
  IfcSolarDeviceTypeEnum.SOLARPANEL = { type: 3, value: "SOLARPANEL" };
  IfcSolarDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSolarDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcSolarDeviceTypeEnum = IfcSolarDeviceTypeEnum;
  class IfcSpaceHeaterTypeEnum {
  }
  IfcSpaceHeaterTypeEnum.CONVECTOR = { type: 3, value: "CONVECTOR" };
  IfcSpaceHeaterTypeEnum.RADIATOR = { type: 3, value: "RADIATOR" };
  IfcSpaceHeaterTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSpaceHeaterTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcSpaceHeaterTypeEnum = IfcSpaceHeaterTypeEnum;
  class IfcSpaceTypeEnum {
  }
  IfcSpaceTypeEnum.SPACE = { type: 3, value: "SPACE" };
  IfcSpaceTypeEnum.PARKING = { type: 3, value: "PARKING" };
  IfcSpaceTypeEnum.GFA = { type: 3, value: "GFA" };
  IfcSpaceTypeEnum.INTERNAL = { type: 3, value: "INTERNAL" };
  IfcSpaceTypeEnum.EXTERNAL = { type: 3, value: "EXTERNAL" };
  IfcSpaceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSpaceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcSpaceTypeEnum = IfcSpaceTypeEnum;
  class IfcSpatialZoneTypeEnum {
  }
  IfcSpatialZoneTypeEnum.CONSTRUCTION = { type: 3, value: "CONSTRUCTION" };
  IfcSpatialZoneTypeEnum.FIRESAFETY = { type: 3, value: "FIRESAFETY" };
  IfcSpatialZoneTypeEnum.LIGHTING = { type: 3, value: "LIGHTING" };
  IfcSpatialZoneTypeEnum.OCCUPANCY = { type: 3, value: "OCCUPANCY" };
  IfcSpatialZoneTypeEnum.SECURITY = { type: 3, value: "SECURITY" };
  IfcSpatialZoneTypeEnum.THERMAL = { type: 3, value: "THERMAL" };
  IfcSpatialZoneTypeEnum.TRANSPORT = { type: 3, value: "TRANSPORT" };
  IfcSpatialZoneTypeEnum.VENTILATION = { type: 3, value: "VENTILATION" };
  IfcSpatialZoneTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSpatialZoneTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcSpatialZoneTypeEnum = IfcSpatialZoneTypeEnum;
  class IfcStackTerminalTypeEnum {
  }
  IfcStackTerminalTypeEnum.BIRDCAGE = { type: 3, value: "BIRDCAGE" };
  IfcStackTerminalTypeEnum.COWL = { type: 3, value: "COWL" };
  IfcStackTerminalTypeEnum.RAINWATERHOPPER = { type: 3, value: "RAINWATERHOPPER" };
  IfcStackTerminalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStackTerminalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcStackTerminalTypeEnum = IfcStackTerminalTypeEnum;
  class IfcStairFlightTypeEnum {
  }
  IfcStairFlightTypeEnum.STRAIGHT = { type: 3, value: "STRAIGHT" };
  IfcStairFlightTypeEnum.WINDER = { type: 3, value: "WINDER" };
  IfcStairFlightTypeEnum.SPIRAL = { type: 3, value: "SPIRAL" };
  IfcStairFlightTypeEnum.CURVED = { type: 3, value: "CURVED" };
  IfcStairFlightTypeEnum.FREEFORM = { type: 3, value: "FREEFORM" };
  IfcStairFlightTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStairFlightTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcStairFlightTypeEnum = IfcStairFlightTypeEnum;
  class IfcStairTypeEnum {
  }
  IfcStairTypeEnum.STRAIGHT_RUN_STAIR = { type: 3, value: "STRAIGHT_RUN_STAIR" };
  IfcStairTypeEnum.TWO_STRAIGHT_RUN_STAIR = { type: 3, value: "TWO_STRAIGHT_RUN_STAIR" };
  IfcStairTypeEnum.QUARTER_WINDING_STAIR = { type: 3, value: "QUARTER_WINDING_STAIR" };
  IfcStairTypeEnum.QUARTER_TURN_STAIR = { type: 3, value: "QUARTER_TURN_STAIR" };
  IfcStairTypeEnum.HALF_WINDING_STAIR = { type: 3, value: "HALF_WINDING_STAIR" };
  IfcStairTypeEnum.HALF_TURN_STAIR = { type: 3, value: "HALF_TURN_STAIR" };
  IfcStairTypeEnum.TWO_QUARTER_WINDING_STAIR = { type: 3, value: "TWO_QUARTER_WINDING_STAIR" };
  IfcStairTypeEnum.TWO_QUARTER_TURN_STAIR = { type: 3, value: "TWO_QUARTER_TURN_STAIR" };
  IfcStairTypeEnum.THREE_QUARTER_WINDING_STAIR = { type: 3, value: "THREE_QUARTER_WINDING_STAIR" };
  IfcStairTypeEnum.THREE_QUARTER_TURN_STAIR = { type: 3, value: "THREE_QUARTER_TURN_STAIR" };
  IfcStairTypeEnum.SPIRAL_STAIR = { type: 3, value: "SPIRAL_STAIR" };
  IfcStairTypeEnum.DOUBLE_RETURN_STAIR = { type: 3, value: "DOUBLE_RETURN_STAIR" };
  IfcStairTypeEnum.CURVED_RUN_STAIR = { type: 3, value: "CURVED_RUN_STAIR" };
  IfcStairTypeEnum.TWO_CURVED_RUN_STAIR = { type: 3, value: "TWO_CURVED_RUN_STAIR" };
  IfcStairTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStairTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcStairTypeEnum = IfcStairTypeEnum;
  class IfcStateEnum {
  }
  IfcStateEnum.READWRITE = { type: 3, value: "READWRITE" };
  IfcStateEnum.READONLY = { type: 3, value: "READONLY" };
  IfcStateEnum.LOCKED = { type: 3, value: "LOCKED" };
  IfcStateEnum.READWRITELOCKED = { type: 3, value: "READWRITELOCKED" };
  IfcStateEnum.READONLYLOCKED = { type: 3, value: "READONLYLOCKED" };
  IFC42.IfcStateEnum = IfcStateEnum;
  class IfcStructuralCurveActivityTypeEnum {
  }
  IfcStructuralCurveActivityTypeEnum.CONST = { type: 3, value: "CONST" };
  IfcStructuralCurveActivityTypeEnum.LINEAR = { type: 3, value: "LINEAR" };
  IfcStructuralCurveActivityTypeEnum.POLYGONAL = { type: 3, value: "POLYGONAL" };
  IfcStructuralCurveActivityTypeEnum.EQUIDISTANT = { type: 3, value: "EQUIDISTANT" };
  IfcStructuralCurveActivityTypeEnum.SINUS = { type: 3, value: "SINUS" };
  IfcStructuralCurveActivityTypeEnum.PARABOLA = { type: 3, value: "PARABOLA" };
  IfcStructuralCurveActivityTypeEnum.DISCRETE = { type: 3, value: "DISCRETE" };
  IfcStructuralCurveActivityTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStructuralCurveActivityTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcStructuralCurveActivityTypeEnum = IfcStructuralCurveActivityTypeEnum;
  class IfcStructuralCurveMemberTypeEnum {
  }
  IfcStructuralCurveMemberTypeEnum.RIGID_JOINED_MEMBER = { type: 3, value: "RIGID_JOINED_MEMBER" };
  IfcStructuralCurveMemberTypeEnum.PIN_JOINED_MEMBER = { type: 3, value: "PIN_JOINED_MEMBER" };
  IfcStructuralCurveMemberTypeEnum.CABLE = { type: 3, value: "CABLE" };
  IfcStructuralCurveMemberTypeEnum.TENSION_MEMBER = { type: 3, value: "TENSION_MEMBER" };
  IfcStructuralCurveMemberTypeEnum.COMPRESSION_MEMBER = { type: 3, value: "COMPRESSION_MEMBER" };
  IfcStructuralCurveMemberTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStructuralCurveMemberTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcStructuralCurveMemberTypeEnum = IfcStructuralCurveMemberTypeEnum;
  class IfcStructuralSurfaceActivityTypeEnum {
  }
  IfcStructuralSurfaceActivityTypeEnum.CONST = { type: 3, value: "CONST" };
  IfcStructuralSurfaceActivityTypeEnum.BILINEAR = { type: 3, value: "BILINEAR" };
  IfcStructuralSurfaceActivityTypeEnum.DISCRETE = { type: 3, value: "DISCRETE" };
  IfcStructuralSurfaceActivityTypeEnum.ISOCONTOUR = { type: 3, value: "ISOCONTOUR" };
  IfcStructuralSurfaceActivityTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStructuralSurfaceActivityTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcStructuralSurfaceActivityTypeEnum = IfcStructuralSurfaceActivityTypeEnum;
  class IfcStructuralSurfaceMemberTypeEnum {
  }
  IfcStructuralSurfaceMemberTypeEnum.BENDING_ELEMENT = { type: 3, value: "BENDING_ELEMENT" };
  IfcStructuralSurfaceMemberTypeEnum.MEMBRANE_ELEMENT = { type: 3, value: "MEMBRANE_ELEMENT" };
  IfcStructuralSurfaceMemberTypeEnum.SHELL = { type: 3, value: "SHELL" };
  IfcStructuralSurfaceMemberTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcStructuralSurfaceMemberTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcStructuralSurfaceMemberTypeEnum = IfcStructuralSurfaceMemberTypeEnum;
  class IfcSubContractResourceTypeEnum {
  }
  IfcSubContractResourceTypeEnum.PURCHASE = { type: 3, value: "PURCHASE" };
  IfcSubContractResourceTypeEnum.WORK = { type: 3, value: "WORK" };
  IfcSubContractResourceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSubContractResourceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcSubContractResourceTypeEnum = IfcSubContractResourceTypeEnum;
  class IfcSurfaceFeatureTypeEnum {
  }
  IfcSurfaceFeatureTypeEnum.MARK = { type: 3, value: "MARK" };
  IfcSurfaceFeatureTypeEnum.TAG = { type: 3, value: "TAG" };
  IfcSurfaceFeatureTypeEnum.TREATMENT = { type: 3, value: "TREATMENT" };
  IfcSurfaceFeatureTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSurfaceFeatureTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcSurfaceFeatureTypeEnum = IfcSurfaceFeatureTypeEnum;
  class IfcSurfaceSide {
  }
  IfcSurfaceSide.POSITIVE = { type: 3, value: "POSITIVE" };
  IfcSurfaceSide.NEGATIVE = { type: 3, value: "NEGATIVE" };
  IfcSurfaceSide.BOTH = { type: 3, value: "BOTH" };
  IFC42.IfcSurfaceSide = IfcSurfaceSide;
  class IfcSwitchingDeviceTypeEnum {
  }
  IfcSwitchingDeviceTypeEnum.CONTACTOR = { type: 3, value: "CONTACTOR" };
  IfcSwitchingDeviceTypeEnum.DIMMERSWITCH = { type: 3, value: "DIMMERSWITCH" };
  IfcSwitchingDeviceTypeEnum.EMERGENCYSTOP = { type: 3, value: "EMERGENCYSTOP" };
  IfcSwitchingDeviceTypeEnum.KEYPAD = { type: 3, value: "KEYPAD" };
  IfcSwitchingDeviceTypeEnum.MOMENTARYSWITCH = { type: 3, value: "MOMENTARYSWITCH" };
  IfcSwitchingDeviceTypeEnum.SELECTORSWITCH = { type: 3, value: "SELECTORSWITCH" };
  IfcSwitchingDeviceTypeEnum.STARTER = { type: 3, value: "STARTER" };
  IfcSwitchingDeviceTypeEnum.SWITCHDISCONNECTOR = { type: 3, value: "SWITCHDISCONNECTOR" };
  IfcSwitchingDeviceTypeEnum.TOGGLESWITCH = { type: 3, value: "TOGGLESWITCH" };
  IfcSwitchingDeviceTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSwitchingDeviceTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcSwitchingDeviceTypeEnum = IfcSwitchingDeviceTypeEnum;
  class IfcSystemFurnitureElementTypeEnum {
  }
  IfcSystemFurnitureElementTypeEnum.PANEL = { type: 3, value: "PANEL" };
  IfcSystemFurnitureElementTypeEnum.WORKSURFACE = { type: 3, value: "WORKSURFACE" };
  IfcSystemFurnitureElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcSystemFurnitureElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcSystemFurnitureElementTypeEnum = IfcSystemFurnitureElementTypeEnum;
  class IfcTankTypeEnum {
  }
  IfcTankTypeEnum.BASIN = { type: 3, value: "BASIN" };
  IfcTankTypeEnum.BREAKPRESSURE = { type: 3, value: "BREAKPRESSURE" };
  IfcTankTypeEnum.EXPANSION = { type: 3, value: "EXPANSION" };
  IfcTankTypeEnum.FEEDANDEXPANSION = { type: 3, value: "FEEDANDEXPANSION" };
  IfcTankTypeEnum.PRESSUREVESSEL = { type: 3, value: "PRESSUREVESSEL" };
  IfcTankTypeEnum.STORAGE = { type: 3, value: "STORAGE" };
  IfcTankTypeEnum.VESSEL = { type: 3, value: "VESSEL" };
  IfcTankTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTankTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcTankTypeEnum = IfcTankTypeEnum;
  class IfcTaskDurationEnum {
  }
  IfcTaskDurationEnum.ELAPSEDTIME = { type: 3, value: "ELAPSEDTIME" };
  IfcTaskDurationEnum.WORKTIME = { type: 3, value: "WORKTIME" };
  IfcTaskDurationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcTaskDurationEnum = IfcTaskDurationEnum;
  class IfcTaskTypeEnum {
  }
  IfcTaskTypeEnum.ATTENDANCE = { type: 3, value: "ATTENDANCE" };
  IfcTaskTypeEnum.CONSTRUCTION = { type: 3, value: "CONSTRUCTION" };
  IfcTaskTypeEnum.DEMOLITION = { type: 3, value: "DEMOLITION" };
  IfcTaskTypeEnum.DISMANTLE = { type: 3, value: "DISMANTLE" };
  IfcTaskTypeEnum.DISPOSAL = { type: 3, value: "DISPOSAL" };
  IfcTaskTypeEnum.INSTALLATION = { type: 3, value: "INSTALLATION" };
  IfcTaskTypeEnum.LOGISTIC = { type: 3, value: "LOGISTIC" };
  IfcTaskTypeEnum.MAINTENANCE = { type: 3, value: "MAINTENANCE" };
  IfcTaskTypeEnum.MOVE = { type: 3, value: "MOVE" };
  IfcTaskTypeEnum.OPERATION = { type: 3, value: "OPERATION" };
  IfcTaskTypeEnum.REMOVAL = { type: 3, value: "REMOVAL" };
  IfcTaskTypeEnum.RENOVATION = { type: 3, value: "RENOVATION" };
  IfcTaskTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTaskTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcTaskTypeEnum = IfcTaskTypeEnum;
  class IfcTendonAnchorTypeEnum {
  }
  IfcTendonAnchorTypeEnum.COUPLER = { type: 3, value: "COUPLER" };
  IfcTendonAnchorTypeEnum.FIXED_END = { type: 3, value: "FIXED_END" };
  IfcTendonAnchorTypeEnum.TENSIONING_END = { type: 3, value: "TENSIONING_END" };
  IfcTendonAnchorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTendonAnchorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcTendonAnchorTypeEnum = IfcTendonAnchorTypeEnum;
  class IfcTendonTypeEnum {
  }
  IfcTendonTypeEnum.BAR = { type: 3, value: "BAR" };
  IfcTendonTypeEnum.COATED = { type: 3, value: "COATED" };
  IfcTendonTypeEnum.STRAND = { type: 3, value: "STRAND" };
  IfcTendonTypeEnum.WIRE = { type: 3, value: "WIRE" };
  IfcTendonTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTendonTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcTendonTypeEnum = IfcTendonTypeEnum;
  class IfcTextPath {
  }
  IfcTextPath.LEFT = { type: 3, value: "LEFT" };
  IfcTextPath.RIGHT = { type: 3, value: "RIGHT" };
  IfcTextPath.UP = { type: 3, value: "UP" };
  IfcTextPath.DOWN = { type: 3, value: "DOWN" };
  IFC42.IfcTextPath = IfcTextPath;
  class IfcTimeSeriesDataTypeEnum {
  }
  IfcTimeSeriesDataTypeEnum.CONTINUOUS = { type: 3, value: "CONTINUOUS" };
  IfcTimeSeriesDataTypeEnum.DISCRETE = { type: 3, value: "DISCRETE" };
  IfcTimeSeriesDataTypeEnum.DISCRETEBINARY = { type: 3, value: "DISCRETEBINARY" };
  IfcTimeSeriesDataTypeEnum.PIECEWISEBINARY = { type: 3, value: "PIECEWISEBINARY" };
  IfcTimeSeriesDataTypeEnum.PIECEWISECONSTANT = { type: 3, value: "PIECEWISECONSTANT" };
  IfcTimeSeriesDataTypeEnum.PIECEWISECONTINUOUS = { type: 3, value: "PIECEWISECONTINUOUS" };
  IfcTimeSeriesDataTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcTimeSeriesDataTypeEnum = IfcTimeSeriesDataTypeEnum;
  class IfcTransformerTypeEnum {
  }
  IfcTransformerTypeEnum.CURRENT = { type: 3, value: "CURRENT" };
  IfcTransformerTypeEnum.FREQUENCY = { type: 3, value: "FREQUENCY" };
  IfcTransformerTypeEnum.INVERTER = { type: 3, value: "INVERTER" };
  IfcTransformerTypeEnum.RECTIFIER = { type: 3, value: "RECTIFIER" };
  IfcTransformerTypeEnum.VOLTAGE = { type: 3, value: "VOLTAGE" };
  IfcTransformerTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTransformerTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcTransformerTypeEnum = IfcTransformerTypeEnum;
  class IfcTransitionCode {
  }
  IfcTransitionCode.DISCONTINUOUS = { type: 3, value: "DISCONTINUOUS" };
  IfcTransitionCode.CONTINUOUS = { type: 3, value: "CONTINUOUS" };
  IfcTransitionCode.CONTSAMEGRADIENT = { type: 3, value: "CONTSAMEGRADIENT" };
  IfcTransitionCode.CONTSAMEGRADIENTSAMECURVATURE = { type: 3, value: "CONTSAMEGRADIENTSAMECURVATURE" };
  IFC42.IfcTransitionCode = IfcTransitionCode;
  class IfcTransportElementTypeEnum {
  }
  IfcTransportElementTypeEnum.ELEVATOR = { type: 3, value: "ELEVATOR" };
  IfcTransportElementTypeEnum.ESCALATOR = { type: 3, value: "ESCALATOR" };
  IfcTransportElementTypeEnum.MOVINGWALKWAY = { type: 3, value: "MOVINGWALKWAY" };
  IfcTransportElementTypeEnum.CRANEWAY = { type: 3, value: "CRANEWAY" };
  IfcTransportElementTypeEnum.LIFTINGGEAR = { type: 3, value: "LIFTINGGEAR" };
  IfcTransportElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTransportElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcTransportElementTypeEnum = IfcTransportElementTypeEnum;
  class IfcTrimmingPreference {
  }
  IfcTrimmingPreference.CARTESIAN = { type: 3, value: "CARTESIAN" };
  IfcTrimmingPreference.PARAMETER = { type: 3, value: "PARAMETER" };
  IfcTrimmingPreference.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  IFC42.IfcTrimmingPreference = IfcTrimmingPreference;
  class IfcTubeBundleTypeEnum {
  }
  IfcTubeBundleTypeEnum.FINNED = { type: 3, value: "FINNED" };
  IfcTubeBundleTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcTubeBundleTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcTubeBundleTypeEnum = IfcTubeBundleTypeEnum;
  class IfcUnitEnum {
  }
  IfcUnitEnum.ABSORBEDDOSEUNIT = { type: 3, value: "ABSORBEDDOSEUNIT" };
  IfcUnitEnum.AMOUNTOFSUBSTANCEUNIT = { type: 3, value: "AMOUNTOFSUBSTANCEUNIT" };
  IfcUnitEnum.AREAUNIT = { type: 3, value: "AREAUNIT" };
  IfcUnitEnum.DOSEEQUIVALENTUNIT = { type: 3, value: "DOSEEQUIVALENTUNIT" };
  IfcUnitEnum.ELECTRICCAPACITANCEUNIT = { type: 3, value: "ELECTRICCAPACITANCEUNIT" };
  IfcUnitEnum.ELECTRICCHARGEUNIT = { type: 3, value: "ELECTRICCHARGEUNIT" };
  IfcUnitEnum.ELECTRICCONDUCTANCEUNIT = { type: 3, value: "ELECTRICCONDUCTANCEUNIT" };
  IfcUnitEnum.ELECTRICCURRENTUNIT = { type: 3, value: "ELECTRICCURRENTUNIT" };
  IfcUnitEnum.ELECTRICRESISTANCEUNIT = { type: 3, value: "ELECTRICRESISTANCEUNIT" };
  IfcUnitEnum.ELECTRICVOLTAGEUNIT = { type: 3, value: "ELECTRICVOLTAGEUNIT" };
  IfcUnitEnum.ENERGYUNIT = { type: 3, value: "ENERGYUNIT" };
  IfcUnitEnum.FORCEUNIT = { type: 3, value: "FORCEUNIT" };
  IfcUnitEnum.FREQUENCYUNIT = { type: 3, value: "FREQUENCYUNIT" };
  IfcUnitEnum.ILLUMINANCEUNIT = { type: 3, value: "ILLUMINANCEUNIT" };
  IfcUnitEnum.INDUCTANCEUNIT = { type: 3, value: "INDUCTANCEUNIT" };
  IfcUnitEnum.LENGTHUNIT = { type: 3, value: "LENGTHUNIT" };
  IfcUnitEnum.LUMINOUSFLUXUNIT = { type: 3, value: "LUMINOUSFLUXUNIT" };
  IfcUnitEnum.LUMINOUSINTENSITYUNIT = { type: 3, value: "LUMINOUSINTENSITYUNIT" };
  IfcUnitEnum.MAGNETICFLUXDENSITYUNIT = { type: 3, value: "MAGNETICFLUXDENSITYUNIT" };
  IfcUnitEnum.MAGNETICFLUXUNIT = { type: 3, value: "MAGNETICFLUXUNIT" };
  IfcUnitEnum.MASSUNIT = { type: 3, value: "MASSUNIT" };
  IfcUnitEnum.PLANEANGLEUNIT = { type: 3, value: "PLANEANGLEUNIT" };
  IfcUnitEnum.POWERUNIT = { type: 3, value: "POWERUNIT" };
  IfcUnitEnum.PRESSUREUNIT = { type: 3, value: "PRESSUREUNIT" };
  IfcUnitEnum.RADIOACTIVITYUNIT = { type: 3, value: "RADIOACTIVITYUNIT" };
  IfcUnitEnum.SOLIDANGLEUNIT = { type: 3, value: "SOLIDANGLEUNIT" };
  IfcUnitEnum.THERMODYNAMICTEMPERATUREUNIT = { type: 3, value: "THERMODYNAMICTEMPERATUREUNIT" };
  IfcUnitEnum.TIMEUNIT = { type: 3, value: "TIMEUNIT" };
  IfcUnitEnum.VOLUMEUNIT = { type: 3, value: "VOLUMEUNIT" };
  IfcUnitEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IFC42.IfcUnitEnum = IfcUnitEnum;
  class IfcUnitaryControlElementTypeEnum {
  }
  IfcUnitaryControlElementTypeEnum.ALARMPANEL = { type: 3, value: "ALARMPANEL" };
  IfcUnitaryControlElementTypeEnum.CONTROLPANEL = { type: 3, value: "CONTROLPANEL" };
  IfcUnitaryControlElementTypeEnum.GASDETECTIONPANEL = { type: 3, value: "GASDETECTIONPANEL" };
  IfcUnitaryControlElementTypeEnum.INDICATORPANEL = { type: 3, value: "INDICATORPANEL" };
  IfcUnitaryControlElementTypeEnum.MIMICPANEL = { type: 3, value: "MIMICPANEL" };
  IfcUnitaryControlElementTypeEnum.HUMIDISTAT = { type: 3, value: "HUMIDISTAT" };
  IfcUnitaryControlElementTypeEnum.THERMOSTAT = { type: 3, value: "THERMOSTAT" };
  IfcUnitaryControlElementTypeEnum.WEATHERSTATION = { type: 3, value: "WEATHERSTATION" };
  IfcUnitaryControlElementTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcUnitaryControlElementTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcUnitaryControlElementTypeEnum = IfcUnitaryControlElementTypeEnum;
  class IfcUnitaryEquipmentTypeEnum {
  }
  IfcUnitaryEquipmentTypeEnum.AIRHANDLER = { type: 3, value: "AIRHANDLER" };
  IfcUnitaryEquipmentTypeEnum.AIRCONDITIONINGUNIT = { type: 3, value: "AIRCONDITIONINGUNIT" };
  IfcUnitaryEquipmentTypeEnum.DEHUMIDIFIER = { type: 3, value: "DEHUMIDIFIER" };
  IfcUnitaryEquipmentTypeEnum.SPLITSYSTEM = { type: 3, value: "SPLITSYSTEM" };
  IfcUnitaryEquipmentTypeEnum.ROOFTOPUNIT = { type: 3, value: "ROOFTOPUNIT" };
  IfcUnitaryEquipmentTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcUnitaryEquipmentTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcUnitaryEquipmentTypeEnum = IfcUnitaryEquipmentTypeEnum;
  class IfcValveTypeEnum {
  }
  IfcValveTypeEnum.AIRRELEASE = { type: 3, value: "AIRRELEASE" };
  IfcValveTypeEnum.ANTIVACUUM = { type: 3, value: "ANTIVACUUM" };
  IfcValveTypeEnum.CHANGEOVER = { type: 3, value: "CHANGEOVER" };
  IfcValveTypeEnum.CHECK = { type: 3, value: "CHECK" };
  IfcValveTypeEnum.COMMISSIONING = { type: 3, value: "COMMISSIONING" };
  IfcValveTypeEnum.DIVERTING = { type: 3, value: "DIVERTING" };
  IfcValveTypeEnum.DRAWOFFCOCK = { type: 3, value: "DRAWOFFCOCK" };
  IfcValveTypeEnum.DOUBLECHECK = { type: 3, value: "DOUBLECHECK" };
  IfcValveTypeEnum.DOUBLEREGULATING = { type: 3, value: "DOUBLEREGULATING" };
  IfcValveTypeEnum.FAUCET = { type: 3, value: "FAUCET" };
  IfcValveTypeEnum.FLUSHING = { type: 3, value: "FLUSHING" };
  IfcValveTypeEnum.GASCOCK = { type: 3, value: "GASCOCK" };
  IfcValveTypeEnum.GASTAP = { type: 3, value: "GASTAP" };
  IfcValveTypeEnum.ISOLATING = { type: 3, value: "ISOLATING" };
  IfcValveTypeEnum.MIXING = { type: 3, value: "MIXING" };
  IfcValveTypeEnum.PRESSUREREDUCING = { type: 3, value: "PRESSUREREDUCING" };
  IfcValveTypeEnum.PRESSURERELIEF = { type: 3, value: "PRESSURERELIEF" };
  IfcValveTypeEnum.REGULATING = { type: 3, value: "REGULATING" };
  IfcValveTypeEnum.SAFETYCUTOFF = { type: 3, value: "SAFETYCUTOFF" };
  IfcValveTypeEnum.STEAMTRAP = { type: 3, value: "STEAMTRAP" };
  IfcValveTypeEnum.STOPCOCK = { type: 3, value: "STOPCOCK" };
  IfcValveTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcValveTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcValveTypeEnum = IfcValveTypeEnum;
  class IfcVibrationIsolatorTypeEnum {
  }
  IfcVibrationIsolatorTypeEnum.COMPRESSION = { type: 3, value: "COMPRESSION" };
  IfcVibrationIsolatorTypeEnum.SPRING = { type: 3, value: "SPRING" };
  IfcVibrationIsolatorTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcVibrationIsolatorTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcVibrationIsolatorTypeEnum = IfcVibrationIsolatorTypeEnum;
  class IfcVoidingFeatureTypeEnum {
  }
  IfcVoidingFeatureTypeEnum.CUTOUT = { type: 3, value: "CUTOUT" };
  IfcVoidingFeatureTypeEnum.NOTCH = { type: 3, value: "NOTCH" };
  IfcVoidingFeatureTypeEnum.HOLE = { type: 3, value: "HOLE" };
  IfcVoidingFeatureTypeEnum.MITER = { type: 3, value: "MITER" };
  IfcVoidingFeatureTypeEnum.CHAMFER = { type: 3, value: "CHAMFER" };
  IfcVoidingFeatureTypeEnum.EDGE = { type: 3, value: "EDGE" };
  IfcVoidingFeatureTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcVoidingFeatureTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcVoidingFeatureTypeEnum = IfcVoidingFeatureTypeEnum;
  class IfcWallTypeEnum {
  }
  IfcWallTypeEnum.MOVABLE = { type: 3, value: "MOVABLE" };
  IfcWallTypeEnum.PARAPET = { type: 3, value: "PARAPET" };
  IfcWallTypeEnum.PARTITIONING = { type: 3, value: "PARTITIONING" };
  IfcWallTypeEnum.PLUMBINGWALL = { type: 3, value: "PLUMBINGWALL" };
  IfcWallTypeEnum.SHEAR = { type: 3, value: "SHEAR" };
  IfcWallTypeEnum.SOLIDWALL = { type: 3, value: "SOLIDWALL" };
  IfcWallTypeEnum.STANDARD = { type: 3, value: "STANDARD" };
  IfcWallTypeEnum.POLYGONAL = { type: 3, value: "POLYGONAL" };
  IfcWallTypeEnum.ELEMENTEDWALL = { type: 3, value: "ELEMENTEDWALL" };
  IfcWallTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWallTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcWallTypeEnum = IfcWallTypeEnum;
  class IfcWasteTerminalTypeEnum {
  }
  IfcWasteTerminalTypeEnum.FLOORTRAP = { type: 3, value: "FLOORTRAP" };
  IfcWasteTerminalTypeEnum.FLOORWASTE = { type: 3, value: "FLOORWASTE" };
  IfcWasteTerminalTypeEnum.GULLYSUMP = { type: 3, value: "GULLYSUMP" };
  IfcWasteTerminalTypeEnum.GULLYTRAP = { type: 3, value: "GULLYTRAP" };
  IfcWasteTerminalTypeEnum.ROOFDRAIN = { type: 3, value: "ROOFDRAIN" };
  IfcWasteTerminalTypeEnum.WASTEDISPOSALUNIT = { type: 3, value: "WASTEDISPOSALUNIT" };
  IfcWasteTerminalTypeEnum.WASTETRAP = { type: 3, value: "WASTETRAP" };
  IfcWasteTerminalTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWasteTerminalTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcWasteTerminalTypeEnum = IfcWasteTerminalTypeEnum;
  class IfcWindowPanelOperationEnum {
  }
  IfcWindowPanelOperationEnum.SIDEHUNGRIGHTHAND = { type: 3, value: "SIDEHUNGRIGHTHAND" };
  IfcWindowPanelOperationEnum.SIDEHUNGLEFTHAND = { type: 3, value: "SIDEHUNGLEFTHAND" };
  IfcWindowPanelOperationEnum.TILTANDTURNRIGHTHAND = { type: 3, value: "TILTANDTURNRIGHTHAND" };
  IfcWindowPanelOperationEnum.TILTANDTURNLEFTHAND = { type: 3, value: "TILTANDTURNLEFTHAND" };
  IfcWindowPanelOperationEnum.TOPHUNG = { type: 3, value: "TOPHUNG" };
  IfcWindowPanelOperationEnum.BOTTOMHUNG = { type: 3, value: "BOTTOMHUNG" };
  IfcWindowPanelOperationEnum.PIVOTHORIZONTAL = { type: 3, value: "PIVOTHORIZONTAL" };
  IfcWindowPanelOperationEnum.PIVOTVERTICAL = { type: 3, value: "PIVOTVERTICAL" };
  IfcWindowPanelOperationEnum.SLIDINGHORIZONTAL = { type: 3, value: "SLIDINGHORIZONTAL" };
  IfcWindowPanelOperationEnum.SLIDINGVERTICAL = { type: 3, value: "SLIDINGVERTICAL" };
  IfcWindowPanelOperationEnum.REMOVABLECASEMENT = { type: 3, value: "REMOVABLECASEMENT" };
  IfcWindowPanelOperationEnum.FIXEDCASEMENT = { type: 3, value: "FIXEDCASEMENT" };
  IfcWindowPanelOperationEnum.OTHEROPERATION = { type: 3, value: "OTHEROPERATION" };
  IfcWindowPanelOperationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcWindowPanelOperationEnum = IfcWindowPanelOperationEnum;
  class IfcWindowPanelPositionEnum {
  }
  IfcWindowPanelPositionEnum.LEFT = { type: 3, value: "LEFT" };
  IfcWindowPanelPositionEnum.MIDDLE = { type: 3, value: "MIDDLE" };
  IfcWindowPanelPositionEnum.RIGHT = { type: 3, value: "RIGHT" };
  IfcWindowPanelPositionEnum.BOTTOM = { type: 3, value: "BOTTOM" };
  IfcWindowPanelPositionEnum.TOP = { type: 3, value: "TOP" };
  IfcWindowPanelPositionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcWindowPanelPositionEnum = IfcWindowPanelPositionEnum;
  class IfcWindowStyleConstructionEnum {
  }
  IfcWindowStyleConstructionEnum.ALUMINIUM = { type: 3, value: "ALUMINIUM" };
  IfcWindowStyleConstructionEnum.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" };
  IfcWindowStyleConstructionEnum.STEEL = { type: 3, value: "STEEL" };
  IfcWindowStyleConstructionEnum.WOOD = { type: 3, value: "WOOD" };
  IfcWindowStyleConstructionEnum.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" };
  IfcWindowStyleConstructionEnum.PLASTIC = { type: 3, value: "PLASTIC" };
  IfcWindowStyleConstructionEnum.OTHER_CONSTRUCTION = { type: 3, value: "OTHER_CONSTRUCTION" };
  IfcWindowStyleConstructionEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcWindowStyleConstructionEnum = IfcWindowStyleConstructionEnum;
  class IfcWindowStyleOperationEnum {
  }
  IfcWindowStyleOperationEnum.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" };
  IfcWindowStyleOperationEnum.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" };
  IfcWindowStyleOperationEnum.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" };
  IfcWindowStyleOperationEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWindowStyleOperationEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcWindowStyleOperationEnum = IfcWindowStyleOperationEnum;
  class IfcWindowTypeEnum {
  }
  IfcWindowTypeEnum.WINDOW = { type: 3, value: "WINDOW" };
  IfcWindowTypeEnum.SKYLIGHT = { type: 3, value: "SKYLIGHT" };
  IfcWindowTypeEnum.LIGHTDOME = { type: 3, value: "LIGHTDOME" };
  IfcWindowTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWindowTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcWindowTypeEnum = IfcWindowTypeEnum;
  class IfcWindowTypePartitioningEnum {
  }
  IfcWindowTypePartitioningEnum.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" };
  IfcWindowTypePartitioningEnum.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" };
  IfcWindowTypePartitioningEnum.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" };
  IfcWindowTypePartitioningEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWindowTypePartitioningEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcWindowTypePartitioningEnum = IfcWindowTypePartitioningEnum;
  class IfcWorkCalendarTypeEnum {
  }
  IfcWorkCalendarTypeEnum.FIRSTSHIFT = { type: 3, value: "FIRSTSHIFT" };
  IfcWorkCalendarTypeEnum.SECONDSHIFT = { type: 3, value: "SECONDSHIFT" };
  IfcWorkCalendarTypeEnum.THIRDSHIFT = { type: 3, value: "THIRDSHIFT" };
  IfcWorkCalendarTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWorkCalendarTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcWorkCalendarTypeEnum = IfcWorkCalendarTypeEnum;
  class IfcWorkPlanTypeEnum {
  }
  IfcWorkPlanTypeEnum.ACTUAL = { type: 3, value: "ACTUAL" };
  IfcWorkPlanTypeEnum.BASELINE = { type: 3, value: "BASELINE" };
  IfcWorkPlanTypeEnum.PLANNED = { type: 3, value: "PLANNED" };
  IfcWorkPlanTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWorkPlanTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcWorkPlanTypeEnum = IfcWorkPlanTypeEnum;
  class IfcWorkScheduleTypeEnum {
  }
  IfcWorkScheduleTypeEnum.ACTUAL = { type: 3, value: "ACTUAL" };
  IfcWorkScheduleTypeEnum.BASELINE = { type: 3, value: "BASELINE" };
  IfcWorkScheduleTypeEnum.PLANNED = { type: 3, value: "PLANNED" };
  IfcWorkScheduleTypeEnum.USERDEFINED = { type: 3, value: "USERDEFINED" };
  IfcWorkScheduleTypeEnum.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  IFC42.IfcWorkScheduleTypeEnum = IfcWorkScheduleTypeEnum;
  class IfcActorRole extends IfcLineObject {
    constructor(expressID, Role, UserDefinedRole, Description) {
      super(expressID);
      this.Role = Role;
      this.UserDefinedRole = UserDefinedRole;
      this.Description = Description;
      this.type = 3630933823;
    }
  }
  IFC42.IfcActorRole = IfcActorRole;
  class IfcAddress extends IfcLineObject {
    constructor(expressID, Purpose, Description, UserDefinedPurpose) {
      super(expressID);
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.type = 618182010;
    }
  }
  IFC42.IfcAddress = IfcAddress;
  class IfcApplication extends IfcLineObject {
    constructor(expressID, ApplicationDeveloper, Version, ApplicationFullName, ApplicationIdentifier) {
      super(expressID);
      this.ApplicationDeveloper = ApplicationDeveloper;
      this.Version = Version;
      this.ApplicationFullName = ApplicationFullName;
      this.ApplicationIdentifier = ApplicationIdentifier;
      this.type = 639542469;
    }
  }
  IFC42.IfcApplication = IfcApplication;
  class IfcAppliedValue extends IfcLineObject {
    constructor(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.AppliedValue = AppliedValue;
      this.UnitBasis = UnitBasis;
      this.ApplicableDate = ApplicableDate;
      this.FixedUntilDate = FixedUntilDate;
      this.Category = Category;
      this.Condition = Condition;
      this.ArithmeticOperator = ArithmeticOperator;
      this.Components = Components;
      this.type = 411424972;
    }
  }
  IFC42.IfcAppliedValue = IfcAppliedValue;
  class IfcApproval extends IfcLineObject {
    constructor(expressID, Identifier, Name, Description, TimeOfApproval, Status, Level, Qualifier, RequestingApproval, GivingApproval) {
      super(expressID);
      this.Identifier = Identifier;
      this.Name = Name;
      this.Description = Description;
      this.TimeOfApproval = TimeOfApproval;
      this.Status = Status;
      this.Level = Level;
      this.Qualifier = Qualifier;
      this.RequestingApproval = RequestingApproval;
      this.GivingApproval = GivingApproval;
      this.type = 130549933;
    }
  }
  IFC42.IfcApproval = IfcApproval;
  class IfcBoundaryCondition extends IfcLineObject {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 4037036970;
    }
  }
  IFC42.IfcBoundaryCondition = IfcBoundaryCondition;
  class IfcBoundaryEdgeCondition extends IfcBoundaryCondition {
    constructor(expressID, Name, TranslationalStiffnessByLengthX, TranslationalStiffnessByLengthY, TranslationalStiffnessByLengthZ, RotationalStiffnessByLengthX, RotationalStiffnessByLengthY, RotationalStiffnessByLengthZ) {
      super(expressID, Name);
      this.Name = Name;
      this.TranslationalStiffnessByLengthX = TranslationalStiffnessByLengthX;
      this.TranslationalStiffnessByLengthY = TranslationalStiffnessByLengthY;
      this.TranslationalStiffnessByLengthZ = TranslationalStiffnessByLengthZ;
      this.RotationalStiffnessByLengthX = RotationalStiffnessByLengthX;
      this.RotationalStiffnessByLengthY = RotationalStiffnessByLengthY;
      this.RotationalStiffnessByLengthZ = RotationalStiffnessByLengthZ;
      this.type = 1560379544;
    }
  }
  IFC42.IfcBoundaryEdgeCondition = IfcBoundaryEdgeCondition;
  class IfcBoundaryFaceCondition extends IfcBoundaryCondition {
    constructor(expressID, Name, TranslationalStiffnessByAreaX, TranslationalStiffnessByAreaY, TranslationalStiffnessByAreaZ) {
      super(expressID, Name);
      this.Name = Name;
      this.TranslationalStiffnessByAreaX = TranslationalStiffnessByAreaX;
      this.TranslationalStiffnessByAreaY = TranslationalStiffnessByAreaY;
      this.TranslationalStiffnessByAreaZ = TranslationalStiffnessByAreaZ;
      this.type = 3367102660;
    }
  }
  IFC42.IfcBoundaryFaceCondition = IfcBoundaryFaceCondition;
  class IfcBoundaryNodeCondition extends IfcBoundaryCondition {
    constructor(expressID, Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ) {
      super(expressID, Name);
      this.Name = Name;
      this.TranslationalStiffnessX = TranslationalStiffnessX;
      this.TranslationalStiffnessY = TranslationalStiffnessY;
      this.TranslationalStiffnessZ = TranslationalStiffnessZ;
      this.RotationalStiffnessX = RotationalStiffnessX;
      this.RotationalStiffnessY = RotationalStiffnessY;
      this.RotationalStiffnessZ = RotationalStiffnessZ;
      this.type = 1387855156;
    }
  }
  IFC42.IfcBoundaryNodeCondition = IfcBoundaryNodeCondition;
  class IfcBoundaryNodeConditionWarping extends IfcBoundaryNodeCondition {
    constructor(expressID, Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ, WarpingStiffness) {
      super(expressID, Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ);
      this.Name = Name;
      this.TranslationalStiffnessX = TranslationalStiffnessX;
      this.TranslationalStiffnessY = TranslationalStiffnessY;
      this.TranslationalStiffnessZ = TranslationalStiffnessZ;
      this.RotationalStiffnessX = RotationalStiffnessX;
      this.RotationalStiffnessY = RotationalStiffnessY;
      this.RotationalStiffnessZ = RotationalStiffnessZ;
      this.WarpingStiffness = WarpingStiffness;
      this.type = 2069777674;
    }
  }
  IFC42.IfcBoundaryNodeConditionWarping = IfcBoundaryNodeConditionWarping;
  class IfcConnectionGeometry extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 2859738748;
    }
  }
  IFC42.IfcConnectionGeometry = IfcConnectionGeometry;
  class IfcConnectionPointGeometry extends IfcConnectionGeometry {
    constructor(expressID, PointOnRelatingElement, PointOnRelatedElement) {
      super(expressID);
      this.PointOnRelatingElement = PointOnRelatingElement;
      this.PointOnRelatedElement = PointOnRelatedElement;
      this.type = 2614616156;
    }
  }
  IFC42.IfcConnectionPointGeometry = IfcConnectionPointGeometry;
  class IfcConnectionSurfaceGeometry extends IfcConnectionGeometry {
    constructor(expressID, SurfaceOnRelatingElement, SurfaceOnRelatedElement) {
      super(expressID);
      this.SurfaceOnRelatingElement = SurfaceOnRelatingElement;
      this.SurfaceOnRelatedElement = SurfaceOnRelatedElement;
      this.type = 2732653382;
    }
  }
  IFC42.IfcConnectionSurfaceGeometry = IfcConnectionSurfaceGeometry;
  class IfcConnectionVolumeGeometry extends IfcConnectionGeometry {
    constructor(expressID, VolumeOnRelatingElement, VolumeOnRelatedElement) {
      super(expressID);
      this.VolumeOnRelatingElement = VolumeOnRelatingElement;
      this.VolumeOnRelatedElement = VolumeOnRelatedElement;
      this.type = 775493141;
    }
  }
  IFC42.IfcConnectionVolumeGeometry = IfcConnectionVolumeGeometry;
  class IfcConstraint extends IfcLineObject {
    constructor(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.type = 1959218052;
    }
  }
  IFC42.IfcConstraint = IfcConstraint;
  class IfcCoordinateOperation extends IfcLineObject {
    constructor(expressID, SourceCRS, TargetCRS) {
      super(expressID);
      this.SourceCRS = SourceCRS;
      this.TargetCRS = TargetCRS;
      this.type = 1785450214;
    }
  }
  IFC42.IfcCoordinateOperation = IfcCoordinateOperation;
  class IfcCoordinateReferenceSystem extends IfcLineObject {
    constructor(expressID, Name, Description, GeodeticDatum, VerticalDatum) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.GeodeticDatum = GeodeticDatum;
      this.VerticalDatum = VerticalDatum;
      this.type = 1466758467;
    }
  }
  IFC42.IfcCoordinateReferenceSystem = IfcCoordinateReferenceSystem;
  class IfcCostValue extends IfcAppliedValue {
    constructor(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components) {
      super(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components);
      this.Name = Name;
      this.Description = Description;
      this.AppliedValue = AppliedValue;
      this.UnitBasis = UnitBasis;
      this.ApplicableDate = ApplicableDate;
      this.FixedUntilDate = FixedUntilDate;
      this.Category = Category;
      this.Condition = Condition;
      this.ArithmeticOperator = ArithmeticOperator;
      this.Components = Components;
      this.type = 602808272;
    }
  }
  IFC42.IfcCostValue = IfcCostValue;
  class IfcDerivedUnit extends IfcLineObject {
    constructor(expressID, Elements, UnitType, UserDefinedType) {
      super(expressID);
      this.Elements = Elements;
      this.UnitType = UnitType;
      this.UserDefinedType = UserDefinedType;
      this.type = 1765591967;
    }
  }
  IFC42.IfcDerivedUnit = IfcDerivedUnit;
  class IfcDerivedUnitElement extends IfcLineObject {
    constructor(expressID, Unit, Exponent) {
      super(expressID);
      this.Unit = Unit;
      this.Exponent = Exponent;
      this.type = 1045800335;
    }
  }
  IFC42.IfcDerivedUnitElement = IfcDerivedUnitElement;
  class IfcDimensionalExponents extends IfcLineObject {
    constructor(expressID, LengthExponent, MassExponent, TimeExponent, ElectricCurrentExponent, ThermodynamicTemperatureExponent, AmountOfSubstanceExponent, LuminousIntensityExponent) {
      super(expressID);
      this.LengthExponent = LengthExponent;
      this.MassExponent = MassExponent;
      this.TimeExponent = TimeExponent;
      this.ElectricCurrentExponent = ElectricCurrentExponent;
      this.ThermodynamicTemperatureExponent = ThermodynamicTemperatureExponent;
      this.AmountOfSubstanceExponent = AmountOfSubstanceExponent;
      this.LuminousIntensityExponent = LuminousIntensityExponent;
      this.type = 2949456006;
    }
  }
  IFC42.IfcDimensionalExponents = IfcDimensionalExponents;
  class IfcExternalInformation extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 4294318154;
    }
  }
  IFC42.IfcExternalInformation = IfcExternalInformation;
  class IfcExternalReference extends IfcLineObject {
    constructor(expressID, Location, Identification, Name) {
      super(expressID);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.type = 3200245327;
    }
  }
  IFC42.IfcExternalReference = IfcExternalReference;
  class IfcExternallyDefinedHatchStyle extends IfcExternalReference {
    constructor(expressID, Location, Identification, Name) {
      super(expressID, Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.type = 2242383968;
    }
  }
  IFC42.IfcExternallyDefinedHatchStyle = IfcExternallyDefinedHatchStyle;
  class IfcExternallyDefinedSurfaceStyle extends IfcExternalReference {
    constructor(expressID, Location, Identification, Name) {
      super(expressID, Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.type = 1040185647;
    }
  }
  IFC42.IfcExternallyDefinedSurfaceStyle = IfcExternallyDefinedSurfaceStyle;
  class IfcExternallyDefinedTextFont extends IfcExternalReference {
    constructor(expressID, Location, Identification, Name) {
      super(expressID, Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.type = 3548104201;
    }
  }
  IFC42.IfcExternallyDefinedTextFont = IfcExternallyDefinedTextFont;
  class IfcGridAxis extends IfcLineObject {
    constructor(expressID, AxisTag, AxisCurve, SameSense) {
      super(expressID);
      this.AxisTag = AxisTag;
      this.AxisCurve = AxisCurve;
      this.SameSense = SameSense;
      this.type = 852622518;
    }
  }
  IFC42.IfcGridAxis = IfcGridAxis;
  class IfcIrregularTimeSeriesValue extends IfcLineObject {
    constructor(expressID, TimeStamp, ListValues) {
      super(expressID);
      this.TimeStamp = TimeStamp;
      this.ListValues = ListValues;
      this.type = 3020489413;
    }
  }
  IFC42.IfcIrregularTimeSeriesValue = IfcIrregularTimeSeriesValue;
  class IfcLibraryInformation extends IfcExternalInformation {
    constructor(expressID, Name, Version, Publisher, VersionDate, Location, Description) {
      super(expressID);
      this.Name = Name;
      this.Version = Version;
      this.Publisher = Publisher;
      this.VersionDate = VersionDate;
      this.Location = Location;
      this.Description = Description;
      this.type = 2655187982;
    }
  }
  IFC42.IfcLibraryInformation = IfcLibraryInformation;
  class IfcLibraryReference extends IfcExternalReference {
    constructor(expressID, Location, Identification, Name, Description, Language, ReferencedLibrary) {
      super(expressID, Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.Description = Description;
      this.Language = Language;
      this.ReferencedLibrary = ReferencedLibrary;
      this.type = 3452421091;
    }
  }
  IFC42.IfcLibraryReference = IfcLibraryReference;
  class IfcLightDistributionData extends IfcLineObject {
    constructor(expressID, MainPlaneAngle, SecondaryPlaneAngle, LuminousIntensity) {
      super(expressID);
      this.MainPlaneAngle = MainPlaneAngle;
      this.SecondaryPlaneAngle = SecondaryPlaneAngle;
      this.LuminousIntensity = LuminousIntensity;
      this.type = 4162380809;
    }
  }
  IFC42.IfcLightDistributionData = IfcLightDistributionData;
  class IfcLightIntensityDistribution extends IfcLineObject {
    constructor(expressID, LightDistributionCurve, DistributionData) {
      super(expressID);
      this.LightDistributionCurve = LightDistributionCurve;
      this.DistributionData = DistributionData;
      this.type = 1566485204;
    }
  }
  IFC42.IfcLightIntensityDistribution = IfcLightIntensityDistribution;
  class IfcMapConversion extends IfcCoordinateOperation {
    constructor(expressID, SourceCRS, TargetCRS, Eastings, Northings, OrthogonalHeight, XAxisAbscissa, XAxisOrdinate, Scale) {
      super(expressID, SourceCRS, TargetCRS);
      this.SourceCRS = SourceCRS;
      this.TargetCRS = TargetCRS;
      this.Eastings = Eastings;
      this.Northings = Northings;
      this.OrthogonalHeight = OrthogonalHeight;
      this.XAxisAbscissa = XAxisAbscissa;
      this.XAxisOrdinate = XAxisOrdinate;
      this.Scale = Scale;
      this.type = 3057273783;
    }
  }
  IFC42.IfcMapConversion = IfcMapConversion;
  class IfcMaterialClassificationRelationship extends IfcLineObject {
    constructor(expressID, MaterialClassifications, ClassifiedMaterial) {
      super(expressID);
      this.MaterialClassifications = MaterialClassifications;
      this.ClassifiedMaterial = ClassifiedMaterial;
      this.type = 1847130766;
    }
  }
  IFC42.IfcMaterialClassificationRelationship = IfcMaterialClassificationRelationship;
  class IfcMaterialDefinition extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 760658860;
    }
  }
  IFC42.IfcMaterialDefinition = IfcMaterialDefinition;
  class IfcMaterialLayer extends IfcMaterialDefinition {
    constructor(expressID, Material, LayerThickness, IsVentilated, Name, Description, Category, Priority) {
      super(expressID);
      this.Material = Material;
      this.LayerThickness = LayerThickness;
      this.IsVentilated = IsVentilated;
      this.Name = Name;
      this.Description = Description;
      this.Category = Category;
      this.Priority = Priority;
      this.type = 248100487;
    }
  }
  IFC42.IfcMaterialLayer = IfcMaterialLayer;
  class IfcMaterialLayerSet extends IfcMaterialDefinition {
    constructor(expressID, MaterialLayers, LayerSetName, Description) {
      super(expressID);
      this.MaterialLayers = MaterialLayers;
      this.LayerSetName = LayerSetName;
      this.Description = Description;
      this.type = 3303938423;
    }
  }
  IFC42.IfcMaterialLayerSet = IfcMaterialLayerSet;
  class IfcMaterialLayerWithOffsets extends IfcMaterialLayer {
    constructor(expressID, Material, LayerThickness, IsVentilated, Name, Description, Category, Priority, OffsetDirection, OffsetValues) {
      super(expressID, Material, LayerThickness, IsVentilated, Name, Description, Category, Priority);
      this.Material = Material;
      this.LayerThickness = LayerThickness;
      this.IsVentilated = IsVentilated;
      this.Name = Name;
      this.Description = Description;
      this.Category = Category;
      this.Priority = Priority;
      this.OffsetDirection = OffsetDirection;
      this.OffsetValues = OffsetValues;
      this.type = 1847252529;
    }
  }
  IFC42.IfcMaterialLayerWithOffsets = IfcMaterialLayerWithOffsets;
  class IfcMaterialList extends IfcLineObject {
    constructor(expressID, Materials) {
      super(expressID);
      this.Materials = Materials;
      this.type = 2199411900;
    }
  }
  IFC42.IfcMaterialList = IfcMaterialList;
  class IfcMaterialProfile extends IfcMaterialDefinition {
    constructor(expressID, Name, Description, Material, Profile, Priority, Category) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.Material = Material;
      this.Profile = Profile;
      this.Priority = Priority;
      this.Category = Category;
      this.type = 2235152071;
    }
  }
  IFC42.IfcMaterialProfile = IfcMaterialProfile;
  class IfcMaterialProfileSet extends IfcMaterialDefinition {
    constructor(expressID, Name, Description, MaterialProfiles, CompositeProfile) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.MaterialProfiles = MaterialProfiles;
      this.CompositeProfile = CompositeProfile;
      this.type = 164193824;
    }
  }
  IFC42.IfcMaterialProfileSet = IfcMaterialProfileSet;
  class IfcMaterialProfileWithOffsets extends IfcMaterialProfile {
    constructor(expressID, Name, Description, Material, Profile, Priority, Category, OffsetValues) {
      super(expressID, Name, Description, Material, Profile, Priority, Category);
      this.Name = Name;
      this.Description = Description;
      this.Material = Material;
      this.Profile = Profile;
      this.Priority = Priority;
      this.Category = Category;
      this.OffsetValues = OffsetValues;
      this.type = 552965576;
    }
  }
  IFC42.IfcMaterialProfileWithOffsets = IfcMaterialProfileWithOffsets;
  class IfcMaterialUsageDefinition extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 1507914824;
    }
  }
  IFC42.IfcMaterialUsageDefinition = IfcMaterialUsageDefinition;
  class IfcMeasureWithUnit extends IfcLineObject {
    constructor(expressID, ValueComponent, UnitComponent) {
      super(expressID);
      this.ValueComponent = ValueComponent;
      this.UnitComponent = UnitComponent;
      this.type = 2597039031;
    }
  }
  IFC42.IfcMeasureWithUnit = IfcMeasureWithUnit;
  class IfcMetric extends IfcConstraint {
    constructor(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, Benchmark, ValueSource, DataValue, ReferencePath) {
      super(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.Benchmark = Benchmark;
      this.ValueSource = ValueSource;
      this.DataValue = DataValue;
      this.ReferencePath = ReferencePath;
      this.type = 3368373690;
    }
  }
  IFC42.IfcMetric = IfcMetric;
  class IfcMonetaryUnit extends IfcLineObject {
    constructor(expressID, Currency) {
      super(expressID);
      this.Currency = Currency;
      this.type = 2706619895;
    }
  }
  IFC42.IfcMonetaryUnit = IfcMonetaryUnit;
  class IfcNamedUnit extends IfcLineObject {
    constructor(expressID, Dimensions, UnitType) {
      super(expressID);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.type = 1918398963;
    }
  }
  IFC42.IfcNamedUnit = IfcNamedUnit;
  class IfcObjectPlacement extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 3701648758;
    }
  }
  IFC42.IfcObjectPlacement = IfcObjectPlacement;
  class IfcObjective extends IfcConstraint {
    constructor(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, BenchmarkValues, LogicalAggregator, ObjectiveQualifier, UserDefinedQualifier) {
      super(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      this.Name = Name;
      this.Description = Description;
      this.ConstraintGrade = ConstraintGrade;
      this.ConstraintSource = ConstraintSource;
      this.CreatingActor = CreatingActor;
      this.CreationTime = CreationTime;
      this.UserDefinedGrade = UserDefinedGrade;
      this.BenchmarkValues = BenchmarkValues;
      this.LogicalAggregator = LogicalAggregator;
      this.ObjectiveQualifier = ObjectiveQualifier;
      this.UserDefinedQualifier = UserDefinedQualifier;
      this.type = 2251480897;
    }
  }
  IFC42.IfcObjective = IfcObjective;
  class IfcOrganization extends IfcLineObject {
    constructor(expressID, Identification, Name, Description, Roles, Addresses) {
      super(expressID);
      this.Identification = Identification;
      this.Name = Name;
      this.Description = Description;
      this.Roles = Roles;
      this.Addresses = Addresses;
      this.type = 4251960020;
    }
  }
  IFC42.IfcOrganization = IfcOrganization;
  class IfcOwnerHistory extends IfcLineObject {
    constructor(expressID, OwningUser, OwningApplication, State, ChangeAction, LastModifiedDate, LastModifyingUser, LastModifyingApplication, CreationDate) {
      super(expressID);
      this.OwningUser = OwningUser;
      this.OwningApplication = OwningApplication;
      this.State = State;
      this.ChangeAction = ChangeAction;
      this.LastModifiedDate = LastModifiedDate;
      this.LastModifyingUser = LastModifyingUser;
      this.LastModifyingApplication = LastModifyingApplication;
      this.CreationDate = CreationDate;
      this.type = 1207048766;
    }
  }
  IFC42.IfcOwnerHistory = IfcOwnerHistory;
  class IfcPerson extends IfcLineObject {
    constructor(expressID, Identification, FamilyName, GivenName, MiddleNames, PrefixTitles, SuffixTitles, Roles, Addresses) {
      super(expressID);
      this.Identification = Identification;
      this.FamilyName = FamilyName;
      this.GivenName = GivenName;
      this.MiddleNames = MiddleNames;
      this.PrefixTitles = PrefixTitles;
      this.SuffixTitles = SuffixTitles;
      this.Roles = Roles;
      this.Addresses = Addresses;
      this.type = 2077209135;
    }
  }
  IFC42.IfcPerson = IfcPerson;
  class IfcPersonAndOrganization extends IfcLineObject {
    constructor(expressID, ThePerson, TheOrganization, Roles) {
      super(expressID);
      this.ThePerson = ThePerson;
      this.TheOrganization = TheOrganization;
      this.Roles = Roles;
      this.type = 101040310;
    }
  }
  IFC42.IfcPersonAndOrganization = IfcPersonAndOrganization;
  class IfcPhysicalQuantity extends IfcLineObject {
    constructor(expressID, Name, Description) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.type = 2483315170;
    }
  }
  IFC42.IfcPhysicalQuantity = IfcPhysicalQuantity;
  class IfcPhysicalSimpleQuantity extends IfcPhysicalQuantity {
    constructor(expressID, Name, Description, Unit) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.type = 2226359599;
    }
  }
  IFC42.IfcPhysicalSimpleQuantity = IfcPhysicalSimpleQuantity;
  class IfcPostalAddress extends IfcAddress {
    constructor(expressID, Purpose, Description, UserDefinedPurpose, InternalLocation, AddressLines, PostalBox, Town, Region, PostalCode, Country) {
      super(expressID, Purpose, Description, UserDefinedPurpose);
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.InternalLocation = InternalLocation;
      this.AddressLines = AddressLines;
      this.PostalBox = PostalBox;
      this.Town = Town;
      this.Region = Region;
      this.PostalCode = PostalCode;
      this.Country = Country;
      this.type = 3355820592;
    }
  }
  IFC42.IfcPostalAddress = IfcPostalAddress;
  class IfcPresentationItem extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 677532197;
    }
  }
  IFC42.IfcPresentationItem = IfcPresentationItem;
  class IfcPresentationLayerAssignment extends IfcLineObject {
    constructor(expressID, Name, Description, AssignedItems, Identifier) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.AssignedItems = AssignedItems;
      this.Identifier = Identifier;
      this.type = 2022622350;
    }
  }
  IFC42.IfcPresentationLayerAssignment = IfcPresentationLayerAssignment;
  class IfcPresentationLayerWithStyle extends IfcPresentationLayerAssignment {
    constructor(expressID, Name, Description, AssignedItems, Identifier, LayerOn, LayerFrozen, LayerBlocked, LayerStyles) {
      super(expressID, Name, Description, AssignedItems, Identifier);
      this.Name = Name;
      this.Description = Description;
      this.AssignedItems = AssignedItems;
      this.Identifier = Identifier;
      this.LayerOn = LayerOn;
      this.LayerFrozen = LayerFrozen;
      this.LayerBlocked = LayerBlocked;
      this.LayerStyles = LayerStyles;
      this.type = 1304840413;
    }
  }
  IFC42.IfcPresentationLayerWithStyle = IfcPresentationLayerWithStyle;
  class IfcPresentationStyle extends IfcLineObject {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 3119450353;
    }
  }
  IFC42.IfcPresentationStyle = IfcPresentationStyle;
  class IfcPresentationStyleAssignment extends IfcLineObject {
    constructor(expressID, Styles) {
      super(expressID);
      this.Styles = Styles;
      this.type = 2417041796;
    }
  }
  IFC42.IfcPresentationStyleAssignment = IfcPresentationStyleAssignment;
  class IfcProductRepresentation extends IfcLineObject {
    constructor(expressID, Name, Description, Representations) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.type = 2095639259;
    }
  }
  IFC42.IfcProductRepresentation = IfcProductRepresentation;
  class IfcProfileDef extends IfcLineObject {
    constructor(expressID, ProfileType, ProfileName) {
      super(expressID);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.type = 3958567839;
    }
  }
  IFC42.IfcProfileDef = IfcProfileDef;
  class IfcProjectedCRS extends IfcCoordinateReferenceSystem {
    constructor(expressID, Name, Description, GeodeticDatum, VerticalDatum, MapProjection, MapZone, MapUnit) {
      super(expressID, Name, Description, GeodeticDatum, VerticalDatum);
      this.Name = Name;
      this.Description = Description;
      this.GeodeticDatum = GeodeticDatum;
      this.VerticalDatum = VerticalDatum;
      this.MapProjection = MapProjection;
      this.MapZone = MapZone;
      this.MapUnit = MapUnit;
      this.type = 3843373140;
    }
  }
  IFC42.IfcProjectedCRS = IfcProjectedCRS;
  class IfcPropertyAbstraction extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 986844984;
    }
  }
  IFC42.IfcPropertyAbstraction = IfcPropertyAbstraction;
  class IfcPropertyEnumeration extends IfcPropertyAbstraction {
    constructor(expressID, Name, EnumerationValues, Unit) {
      super(expressID);
      this.Name = Name;
      this.EnumerationValues = EnumerationValues;
      this.Unit = Unit;
      this.type = 3710013099;
    }
  }
  IFC42.IfcPropertyEnumeration = IfcPropertyEnumeration;
  class IfcQuantityArea extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, AreaValue, Formula) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.AreaValue = AreaValue;
      this.Formula = Formula;
      this.type = 2044713172;
    }
  }
  IFC42.IfcQuantityArea = IfcQuantityArea;
  class IfcQuantityCount extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, CountValue, Formula) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.CountValue = CountValue;
      this.Formula = Formula;
      this.type = 2093928680;
    }
  }
  IFC42.IfcQuantityCount = IfcQuantityCount;
  class IfcQuantityLength extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, LengthValue, Formula) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.LengthValue = LengthValue;
      this.Formula = Formula;
      this.type = 931644368;
    }
  }
  IFC42.IfcQuantityLength = IfcQuantityLength;
  class IfcQuantityTime extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, TimeValue, Formula) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.TimeValue = TimeValue;
      this.Formula = Formula;
      this.type = 3252649465;
    }
  }
  IFC42.IfcQuantityTime = IfcQuantityTime;
  class IfcQuantityVolume extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, VolumeValue, Formula) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.VolumeValue = VolumeValue;
      this.Formula = Formula;
      this.type = 2405470396;
    }
  }
  IFC42.IfcQuantityVolume = IfcQuantityVolume;
  class IfcQuantityWeight extends IfcPhysicalSimpleQuantity {
    constructor(expressID, Name, Description, Unit, WeightValue, Formula) {
      super(expressID, Name, Description, Unit);
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.WeightValue = WeightValue;
      this.Formula = Formula;
      this.type = 825690147;
    }
  }
  IFC42.IfcQuantityWeight = IfcQuantityWeight;
  class IfcRecurrencePattern extends IfcLineObject {
    constructor(expressID, RecurrenceType, DayComponent, WeekdayComponent, MonthComponent, Position, Interval, Occurrences, TimePeriods) {
      super(expressID);
      this.RecurrenceType = RecurrenceType;
      this.DayComponent = DayComponent;
      this.WeekdayComponent = WeekdayComponent;
      this.MonthComponent = MonthComponent;
      this.Position = Position;
      this.Interval = Interval;
      this.Occurrences = Occurrences;
      this.TimePeriods = TimePeriods;
      this.type = 3915482550;
    }
  }
  IFC42.IfcRecurrencePattern = IfcRecurrencePattern;
  class IfcReference extends IfcLineObject {
    constructor(expressID, TypeIdentifier, AttributeIdentifier, InstanceName, ListPositions, InnerReference) {
      super(expressID);
      this.TypeIdentifier = TypeIdentifier;
      this.AttributeIdentifier = AttributeIdentifier;
      this.InstanceName = InstanceName;
      this.ListPositions = ListPositions;
      this.InnerReference = InnerReference;
      this.type = 2433181523;
    }
  }
  IFC42.IfcReference = IfcReference;
  class IfcRepresentation extends IfcLineObject {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 1076942058;
    }
  }
  IFC42.IfcRepresentation = IfcRepresentation;
  class IfcRepresentationContext extends IfcLineObject {
    constructor(expressID, ContextIdentifier, ContextType) {
      super(expressID);
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.type = 3377609919;
    }
  }
  IFC42.IfcRepresentationContext = IfcRepresentationContext;
  class IfcRepresentationItem extends IfcLineObject {
    constructor(expressID) {
      super(expressID);
      this.type = 3008791417;
    }
  }
  IFC42.IfcRepresentationItem = IfcRepresentationItem;
  class IfcRepresentationMap extends IfcLineObject {
    constructor(expressID, MappingOrigin, MappedRepresentation) {
      super(expressID);
      this.MappingOrigin = MappingOrigin;
      this.MappedRepresentation = MappedRepresentation;
      this.type = 1660063152;
    }
  }
  IFC42.IfcRepresentationMap = IfcRepresentationMap;
  class IfcResourceLevelRelationship extends IfcLineObject {
    constructor(expressID, Name, Description) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.type = 2439245199;
    }
  }
  IFC42.IfcResourceLevelRelationship = IfcResourceLevelRelationship;
  class IfcRoot extends IfcLineObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 2341007311;
    }
  }
  IFC42.IfcRoot = IfcRoot;
  class IfcSIUnit extends IfcNamedUnit {
    constructor(expressID, UnitType, Prefix, Name) {
      super(expressID, new Handle(0), UnitType);
      this.UnitType = UnitType;
      this.Prefix = Prefix;
      this.Name = Name;
      this.type = 448429030;
    }
  }
  IFC42.IfcSIUnit = IfcSIUnit;
  class IfcSchedulingTime extends IfcLineObject {
    constructor(expressID, Name, DataOrigin, UserDefinedDataOrigin) {
      super(expressID);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.type = 1054537805;
    }
  }
  IFC42.IfcSchedulingTime = IfcSchedulingTime;
  class IfcShapeAspect extends IfcLineObject {
    constructor(expressID, ShapeRepresentations, Name, Description, ProductDefinitional, PartOfProductDefinitionShape) {
      super(expressID);
      this.ShapeRepresentations = ShapeRepresentations;
      this.Name = Name;
      this.Description = Description;
      this.ProductDefinitional = ProductDefinitional;
      this.PartOfProductDefinitionShape = PartOfProductDefinitionShape;
      this.type = 867548509;
    }
  }
  IFC42.IfcShapeAspect = IfcShapeAspect;
  class IfcShapeModel extends IfcRepresentation {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 3982875396;
    }
  }
  IFC42.IfcShapeModel = IfcShapeModel;
  class IfcShapeRepresentation extends IfcShapeModel {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 4240577450;
    }
  }
  IFC42.IfcShapeRepresentation = IfcShapeRepresentation;
  class IfcStructuralConnectionCondition extends IfcLineObject {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 2273995522;
    }
  }
  IFC42.IfcStructuralConnectionCondition = IfcStructuralConnectionCondition;
  class IfcStructuralLoad extends IfcLineObject {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 2162789131;
    }
  }
  IFC42.IfcStructuralLoad = IfcStructuralLoad;
  class IfcStructuralLoadConfiguration extends IfcStructuralLoad {
    constructor(expressID, Name, Values, Locations) {
      super(expressID, Name);
      this.Name = Name;
      this.Values = Values;
      this.Locations = Locations;
      this.type = 3478079324;
    }
  }
  IFC42.IfcStructuralLoadConfiguration = IfcStructuralLoadConfiguration;
  class IfcStructuralLoadOrResult extends IfcStructuralLoad {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 609421318;
    }
  }
  IFC42.IfcStructuralLoadOrResult = IfcStructuralLoadOrResult;
  class IfcStructuralLoadStatic extends IfcStructuralLoadOrResult {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 2525727697;
    }
  }
  IFC42.IfcStructuralLoadStatic = IfcStructuralLoadStatic;
  class IfcStructuralLoadTemperature extends IfcStructuralLoadStatic {
    constructor(expressID, Name, DeltaTConstant, DeltaTY, DeltaTZ) {
      super(expressID, Name);
      this.Name = Name;
      this.DeltaTConstant = DeltaTConstant;
      this.DeltaTY = DeltaTY;
      this.DeltaTZ = DeltaTZ;
      this.type = 3408363356;
    }
  }
  IFC42.IfcStructuralLoadTemperature = IfcStructuralLoadTemperature;
  class IfcStyleModel extends IfcRepresentation {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 2830218821;
    }
  }
  IFC42.IfcStyleModel = IfcStyleModel;
  class IfcStyledItem extends IfcRepresentationItem {
    constructor(expressID, Item, Styles, Name) {
      super(expressID);
      this.Item = Item;
      this.Styles = Styles;
      this.Name = Name;
      this.type = 3958052878;
    }
  }
  IFC42.IfcStyledItem = IfcStyledItem;
  class IfcStyledRepresentation extends IfcStyleModel {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 3049322572;
    }
  }
  IFC42.IfcStyledRepresentation = IfcStyledRepresentation;
  class IfcSurfaceReinforcementArea extends IfcStructuralLoadOrResult {
    constructor(expressID, Name, SurfaceReinforcement1, SurfaceReinforcement2, ShearReinforcement) {
      super(expressID, Name);
      this.Name = Name;
      this.SurfaceReinforcement1 = SurfaceReinforcement1;
      this.SurfaceReinforcement2 = SurfaceReinforcement2;
      this.ShearReinforcement = ShearReinforcement;
      this.type = 2934153892;
    }
  }
  IFC42.IfcSurfaceReinforcementArea = IfcSurfaceReinforcementArea;
  class IfcSurfaceStyle extends IfcPresentationStyle {
    constructor(expressID, Name, Side, Styles) {
      super(expressID, Name);
      this.Name = Name;
      this.Side = Side;
      this.Styles = Styles;
      this.type = 1300840506;
    }
  }
  IFC42.IfcSurfaceStyle = IfcSurfaceStyle;
  class IfcSurfaceStyleLighting extends IfcPresentationItem {
    constructor(expressID, DiffuseTransmissionColour, DiffuseReflectionColour, TransmissionColour, ReflectanceColour) {
      super(expressID);
      this.DiffuseTransmissionColour = DiffuseTransmissionColour;
      this.DiffuseReflectionColour = DiffuseReflectionColour;
      this.TransmissionColour = TransmissionColour;
      this.ReflectanceColour = ReflectanceColour;
      this.type = 3303107099;
    }
  }
  IFC42.IfcSurfaceStyleLighting = IfcSurfaceStyleLighting;
  class IfcSurfaceStyleRefraction extends IfcPresentationItem {
    constructor(expressID, RefractionIndex, DispersionFactor) {
      super(expressID);
      this.RefractionIndex = RefractionIndex;
      this.DispersionFactor = DispersionFactor;
      this.type = 1607154358;
    }
  }
  IFC42.IfcSurfaceStyleRefraction = IfcSurfaceStyleRefraction;
  class IfcSurfaceStyleShading extends IfcPresentationItem {
    constructor(expressID, SurfaceColour, Transparency) {
      super(expressID);
      this.SurfaceColour = SurfaceColour;
      this.Transparency = Transparency;
      this.type = 846575682;
    }
  }
  IFC42.IfcSurfaceStyleShading = IfcSurfaceStyleShading;
  class IfcSurfaceStyleWithTextures extends IfcPresentationItem {
    constructor(expressID, Textures) {
      super(expressID);
      this.Textures = Textures;
      this.type = 1351298697;
    }
  }
  IFC42.IfcSurfaceStyleWithTextures = IfcSurfaceStyleWithTextures;
  class IfcSurfaceTexture extends IfcPresentationItem {
    constructor(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter) {
      super(expressID);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.Mode = Mode;
      this.TextureTransform = TextureTransform;
      this.Parameter = Parameter;
      this.type = 626085974;
    }
  }
  IFC42.IfcSurfaceTexture = IfcSurfaceTexture;
  class IfcTable extends IfcLineObject {
    constructor(expressID, Name, Rows, Columns) {
      super(expressID);
      this.Name = Name;
      this.Rows = Rows;
      this.Columns = Columns;
      this.type = 985171141;
    }
  }
  IFC42.IfcTable = IfcTable;
  class IfcTableColumn extends IfcLineObject {
    constructor(expressID, Identifier, Name, Description, Unit, ReferencePath) {
      super(expressID);
      this.Identifier = Identifier;
      this.Name = Name;
      this.Description = Description;
      this.Unit = Unit;
      this.ReferencePath = ReferencePath;
      this.type = 2043862942;
    }
  }
  IFC42.IfcTableColumn = IfcTableColumn;
  class IfcTableRow extends IfcLineObject {
    constructor(expressID, RowCells, IsHeading) {
      super(expressID);
      this.RowCells = RowCells;
      this.IsHeading = IsHeading;
      this.type = 531007025;
    }
  }
  IFC42.IfcTableRow = IfcTableRow;
  class IfcTaskTime extends IfcSchedulingTime {
    constructor(expressID, Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion) {
      super(expressID, Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.DurationType = DurationType;
      this.ScheduleDuration = ScheduleDuration;
      this.ScheduleStart = ScheduleStart;
      this.ScheduleFinish = ScheduleFinish;
      this.EarlyStart = EarlyStart;
      this.EarlyFinish = EarlyFinish;
      this.LateStart = LateStart;
      this.LateFinish = LateFinish;
      this.FreeFloat = FreeFloat;
      this.TotalFloat = TotalFloat;
      this.IsCritical = IsCritical;
      this.StatusTime = StatusTime;
      this.ActualDuration = ActualDuration;
      this.ActualStart = ActualStart;
      this.ActualFinish = ActualFinish;
      this.RemainingTime = RemainingTime;
      this.Completion = Completion;
      this.type = 1549132990;
    }
  }
  IFC42.IfcTaskTime = IfcTaskTime;
  class IfcTaskTimeRecurring extends IfcTaskTime {
    constructor(expressID, Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion, Recurrence) {
      super(expressID, Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.DurationType = DurationType;
      this.ScheduleDuration = ScheduleDuration;
      this.ScheduleStart = ScheduleStart;
      this.ScheduleFinish = ScheduleFinish;
      this.EarlyStart = EarlyStart;
      this.EarlyFinish = EarlyFinish;
      this.LateStart = LateStart;
      this.LateFinish = LateFinish;
      this.FreeFloat = FreeFloat;
      this.TotalFloat = TotalFloat;
      this.IsCritical = IsCritical;
      this.StatusTime = StatusTime;
      this.ActualDuration = ActualDuration;
      this.ActualStart = ActualStart;
      this.ActualFinish = ActualFinish;
      this.RemainingTime = RemainingTime;
      this.Completion = Completion;
      this.Recurrence = Recurrence;
      this.type = 2771591690;
    }
  }
  IFC42.IfcTaskTimeRecurring = IfcTaskTimeRecurring;
  class IfcTelecomAddress extends IfcAddress {
    constructor(expressID, Purpose, Description, UserDefinedPurpose, TelephoneNumbers, FacsimileNumbers, PagerNumber, ElectronicMailAddresses, WWWHomePageURL, MessagingIDs) {
      super(expressID, Purpose, Description, UserDefinedPurpose);
      this.Purpose = Purpose;
      this.Description = Description;
      this.UserDefinedPurpose = UserDefinedPurpose;
      this.TelephoneNumbers = TelephoneNumbers;
      this.FacsimileNumbers = FacsimileNumbers;
      this.PagerNumber = PagerNumber;
      this.ElectronicMailAddresses = ElectronicMailAddresses;
      this.WWWHomePageURL = WWWHomePageURL;
      this.MessagingIDs = MessagingIDs;
      this.type = 912023232;
    }
  }
  IFC42.IfcTelecomAddress = IfcTelecomAddress;
  class IfcTextStyle extends IfcPresentationStyle {
    constructor(expressID, Name, TextCharacterAppearance, TextStyle, TextFontStyle, ModelOrDraughting) {
      super(expressID, Name);
      this.Name = Name;
      this.TextCharacterAppearance = TextCharacterAppearance;
      this.TextStyle = TextStyle;
      this.TextFontStyle = TextFontStyle;
      this.ModelOrDraughting = ModelOrDraughting;
      this.type = 1447204868;
    }
  }
  IFC42.IfcTextStyle = IfcTextStyle;
  class IfcTextStyleForDefinedFont extends IfcPresentationItem {
    constructor(expressID, Colour, BackgroundColour) {
      super(expressID);
      this.Colour = Colour;
      this.BackgroundColour = BackgroundColour;
      this.type = 2636378356;
    }
  }
  IFC42.IfcTextStyleForDefinedFont = IfcTextStyleForDefinedFont;
  class IfcTextStyleTextModel extends IfcPresentationItem {
    constructor(expressID, TextIndent, TextAlign, TextDecoration, LetterSpacing, WordSpacing, TextTransform, LineHeight) {
      super(expressID);
      this.TextIndent = TextIndent;
      this.TextAlign = TextAlign;
      this.TextDecoration = TextDecoration;
      this.LetterSpacing = LetterSpacing;
      this.WordSpacing = WordSpacing;
      this.TextTransform = TextTransform;
      this.LineHeight = LineHeight;
      this.type = 1640371178;
    }
  }
  IFC42.IfcTextStyleTextModel = IfcTextStyleTextModel;
  class IfcTextureCoordinate extends IfcPresentationItem {
    constructor(expressID, Maps) {
      super(expressID);
      this.Maps = Maps;
      this.type = 280115917;
    }
  }
  IFC42.IfcTextureCoordinate = IfcTextureCoordinate;
  class IfcTextureCoordinateGenerator extends IfcTextureCoordinate {
    constructor(expressID, Maps, Mode, Parameter) {
      super(expressID, Maps);
      this.Maps = Maps;
      this.Mode = Mode;
      this.Parameter = Parameter;
      this.type = 1742049831;
    }
  }
  IFC42.IfcTextureCoordinateGenerator = IfcTextureCoordinateGenerator;
  class IfcTextureMap extends IfcTextureCoordinate {
    constructor(expressID, Maps, Vertices, MappedTo) {
      super(expressID, Maps);
      this.Maps = Maps;
      this.Vertices = Vertices;
      this.MappedTo = MappedTo;
      this.type = 2552916305;
    }
  }
  IFC42.IfcTextureMap = IfcTextureMap;
  class IfcTextureVertex extends IfcPresentationItem {
    constructor(expressID, Coordinates) {
      super(expressID);
      this.Coordinates = Coordinates;
      this.type = 1210645708;
    }
  }
  IFC42.IfcTextureVertex = IfcTextureVertex;
  class IfcTextureVertexList extends IfcPresentationItem {
    constructor(expressID, TexCoordsList) {
      super(expressID);
      this.TexCoordsList = TexCoordsList;
      this.type = 3611470254;
    }
  }
  IFC42.IfcTextureVertexList = IfcTextureVertexList;
  class IfcTimePeriod extends IfcLineObject {
    constructor(expressID, StartTime, EndTime) {
      super(expressID);
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.type = 1199560280;
    }
  }
  IFC42.IfcTimePeriod = IfcTimePeriod;
  class IfcTimeSeries extends IfcLineObject {
    constructor(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.type = 3101149627;
    }
  }
  IFC42.IfcTimeSeries = IfcTimeSeries;
  class IfcTimeSeriesValue extends IfcLineObject {
    constructor(expressID, ListValues) {
      super(expressID);
      this.ListValues = ListValues;
      this.type = 581633288;
    }
  }
  IFC42.IfcTimeSeriesValue = IfcTimeSeriesValue;
  class IfcTopologicalRepresentationItem extends IfcRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 1377556343;
    }
  }
  IFC42.IfcTopologicalRepresentationItem = IfcTopologicalRepresentationItem;
  class IfcTopologyRepresentation extends IfcShapeModel {
    constructor(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      super(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      this.ContextOfItems = ContextOfItems;
      this.RepresentationIdentifier = RepresentationIdentifier;
      this.RepresentationType = RepresentationType;
      this.Items = Items;
      this.type = 1735638870;
    }
  }
  IFC42.IfcTopologyRepresentation = IfcTopologyRepresentation;
  class IfcUnitAssignment extends IfcLineObject {
    constructor(expressID, Units) {
      super(expressID);
      this.Units = Units;
      this.type = 180925521;
    }
  }
  IFC42.IfcUnitAssignment = IfcUnitAssignment;
  class IfcVertex extends IfcTopologicalRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 2799835756;
    }
  }
  IFC42.IfcVertex = IfcVertex;
  class IfcVertexPoint extends IfcVertex {
    constructor(expressID, VertexGeometry) {
      super(expressID);
      this.VertexGeometry = VertexGeometry;
      this.type = 1907098498;
    }
  }
  IFC42.IfcVertexPoint = IfcVertexPoint;
  class IfcVirtualGridIntersection extends IfcLineObject {
    constructor(expressID, IntersectingAxes, OffsetDistances) {
      super(expressID);
      this.IntersectingAxes = IntersectingAxes;
      this.OffsetDistances = OffsetDistances;
      this.type = 891718957;
    }
  }
  IFC42.IfcVirtualGridIntersection = IfcVirtualGridIntersection;
  class IfcWorkTime extends IfcSchedulingTime {
    constructor(expressID, Name, DataOrigin, UserDefinedDataOrigin, RecurrencePattern, Start, Finish) {
      super(expressID, Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.RecurrencePattern = RecurrencePattern;
      this.Start = Start;
      this.Finish = Finish;
      this.type = 1236880293;
    }
  }
  IFC42.IfcWorkTime = IfcWorkTime;
  class IfcApprovalRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, RelatingApproval, RelatedApprovals) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingApproval = RelatingApproval;
      this.RelatedApprovals = RelatedApprovals;
      this.type = 3869604511;
    }
  }
  IFC42.IfcApprovalRelationship = IfcApprovalRelationship;
  class IfcArbitraryClosedProfileDef extends IfcProfileDef {
    constructor(expressID, ProfileType, ProfileName, OuterCurve) {
      super(expressID, ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.OuterCurve = OuterCurve;
      this.type = 3798115385;
    }
  }
  IFC42.IfcArbitraryClosedProfileDef = IfcArbitraryClosedProfileDef;
  class IfcArbitraryOpenProfileDef extends IfcProfileDef {
    constructor(expressID, ProfileType, ProfileName, Curve) {
      super(expressID, ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Curve = Curve;
      this.type = 1310608509;
    }
  }
  IFC42.IfcArbitraryOpenProfileDef = IfcArbitraryOpenProfileDef;
  class IfcArbitraryProfileDefWithVoids extends IfcArbitraryClosedProfileDef {
    constructor(expressID, ProfileType, ProfileName, OuterCurve, InnerCurves) {
      super(expressID, ProfileType, ProfileName, OuterCurve);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.OuterCurve = OuterCurve;
      this.InnerCurves = InnerCurves;
      this.type = 2705031697;
    }
  }
  IFC42.IfcArbitraryProfileDefWithVoids = IfcArbitraryProfileDefWithVoids;
  class IfcBlobTexture extends IfcSurfaceTexture {
    constructor(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter, RasterFormat, RasterCode) {
      super(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.Mode = Mode;
      this.TextureTransform = TextureTransform;
      this.Parameter = Parameter;
      this.RasterFormat = RasterFormat;
      this.RasterCode = RasterCode;
      this.type = 616511568;
    }
  }
  IFC42.IfcBlobTexture = IfcBlobTexture;
  class IfcCenterLineProfileDef extends IfcArbitraryOpenProfileDef {
    constructor(expressID, ProfileType, ProfileName, Curve, Thickness) {
      super(expressID, ProfileType, ProfileName, Curve);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Curve = Curve;
      this.Thickness = Thickness;
      this.type = 3150382593;
    }
  }
  IFC42.IfcCenterLineProfileDef = IfcCenterLineProfileDef;
  class IfcClassification extends IfcExternalInformation {
    constructor(expressID, Source, Edition, EditionDate, Name, Description, Location, ReferenceTokens) {
      super(expressID);
      this.Source = Source;
      this.Edition = Edition;
      this.EditionDate = EditionDate;
      this.Name = Name;
      this.Description = Description;
      this.Location = Location;
      this.ReferenceTokens = ReferenceTokens;
      this.type = 747523909;
    }
  }
  IFC42.IfcClassification = IfcClassification;
  class IfcClassificationReference extends IfcExternalReference {
    constructor(expressID, Location, Identification, Name, ReferencedSource, Description, Sort) {
      super(expressID, Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.ReferencedSource = ReferencedSource;
      this.Description = Description;
      this.Sort = Sort;
      this.type = 647927063;
    }
  }
  IFC42.IfcClassificationReference = IfcClassificationReference;
  class IfcColourRgbList extends IfcPresentationItem {
    constructor(expressID, ColourList) {
      super(expressID);
      this.ColourList = ColourList;
      this.type = 3285139300;
    }
  }
  IFC42.IfcColourRgbList = IfcColourRgbList;
  class IfcColourSpecification extends IfcPresentationItem {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 3264961684;
    }
  }
  IFC42.IfcColourSpecification = IfcColourSpecification;
  class IfcCompositeProfileDef extends IfcProfileDef {
    constructor(expressID, ProfileType, ProfileName, Profiles, Label) {
      super(expressID, ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Profiles = Profiles;
      this.Label = Label;
      this.type = 1485152156;
    }
  }
  IFC42.IfcCompositeProfileDef = IfcCompositeProfileDef;
  class IfcConnectedFaceSet extends IfcTopologicalRepresentationItem {
    constructor(expressID, CfsFaces) {
      super(expressID);
      this.CfsFaces = CfsFaces;
      this.type = 370225590;
    }
  }
  IFC42.IfcConnectedFaceSet = IfcConnectedFaceSet;
  class IfcConnectionCurveGeometry extends IfcConnectionGeometry {
    constructor(expressID, CurveOnRelatingElement, CurveOnRelatedElement) {
      super(expressID);
      this.CurveOnRelatingElement = CurveOnRelatingElement;
      this.CurveOnRelatedElement = CurveOnRelatedElement;
      this.type = 1981873012;
    }
  }
  IFC42.IfcConnectionCurveGeometry = IfcConnectionCurveGeometry;
  class IfcConnectionPointEccentricity extends IfcConnectionPointGeometry {
    constructor(expressID, PointOnRelatingElement, PointOnRelatedElement, EccentricityInX, EccentricityInY, EccentricityInZ) {
      super(expressID, PointOnRelatingElement, PointOnRelatedElement);
      this.PointOnRelatingElement = PointOnRelatingElement;
      this.PointOnRelatedElement = PointOnRelatedElement;
      this.EccentricityInX = EccentricityInX;
      this.EccentricityInY = EccentricityInY;
      this.EccentricityInZ = EccentricityInZ;
      this.type = 45288368;
    }
  }
  IFC42.IfcConnectionPointEccentricity = IfcConnectionPointEccentricity;
  class IfcContextDependentUnit extends IfcNamedUnit {
    constructor(expressID, Dimensions, UnitType, Name) {
      super(expressID, Dimensions, UnitType);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.Name = Name;
      this.type = 3050246964;
    }
  }
  IFC42.IfcContextDependentUnit = IfcContextDependentUnit;
  class IfcConversionBasedUnit extends IfcNamedUnit {
    constructor(expressID, Dimensions, UnitType, Name, ConversionFactor) {
      super(expressID, Dimensions, UnitType);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.Name = Name;
      this.ConversionFactor = ConversionFactor;
      this.type = 2889183280;
    }
  }
  IFC42.IfcConversionBasedUnit = IfcConversionBasedUnit;
  class IfcConversionBasedUnitWithOffset extends IfcConversionBasedUnit {
    constructor(expressID, Dimensions, UnitType, Name, ConversionFactor, ConversionOffset) {
      super(expressID, Dimensions, UnitType, Name, ConversionFactor);
      this.Dimensions = Dimensions;
      this.UnitType = UnitType;
      this.Name = Name;
      this.ConversionFactor = ConversionFactor;
      this.ConversionOffset = ConversionOffset;
      this.type = 2713554722;
    }
  }
  IFC42.IfcConversionBasedUnitWithOffset = IfcConversionBasedUnitWithOffset;
  class IfcCurrencyRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, RelatingMonetaryUnit, RelatedMonetaryUnit, ExchangeRate, RateDateTime, RateSource) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingMonetaryUnit = RelatingMonetaryUnit;
      this.RelatedMonetaryUnit = RelatedMonetaryUnit;
      this.ExchangeRate = ExchangeRate;
      this.RateDateTime = RateDateTime;
      this.RateSource = RateSource;
      this.type = 539742890;
    }
  }
  IFC42.IfcCurrencyRelationship = IfcCurrencyRelationship;
  class IfcCurveStyle extends IfcPresentationStyle {
    constructor(expressID, Name, CurveFont, CurveWidth, CurveColour, ModelOrDraughting) {
      super(expressID, Name);
      this.Name = Name;
      this.CurveFont = CurveFont;
      this.CurveWidth = CurveWidth;
      this.CurveColour = CurveColour;
      this.ModelOrDraughting = ModelOrDraughting;
      this.type = 3800577675;
    }
  }
  IFC42.IfcCurveStyle = IfcCurveStyle;
  class IfcCurveStyleFont extends IfcPresentationItem {
    constructor(expressID, Name, PatternList) {
      super(expressID);
      this.Name = Name;
      this.PatternList = PatternList;
      this.type = 1105321065;
    }
  }
  IFC42.IfcCurveStyleFont = IfcCurveStyleFont;
  class IfcCurveStyleFontAndScaling extends IfcPresentationItem {
    constructor(expressID, Name, CurveFont, CurveFontScaling) {
      super(expressID);
      this.Name = Name;
      this.CurveFont = CurveFont;
      this.CurveFontScaling = CurveFontScaling;
      this.type = 2367409068;
    }
  }
  IFC42.IfcCurveStyleFontAndScaling = IfcCurveStyleFontAndScaling;
  class IfcCurveStyleFontPattern extends IfcPresentationItem {
    constructor(expressID, VisibleSegmentLength, InvisibleSegmentLength) {
      super(expressID);
      this.VisibleSegmentLength = VisibleSegmentLength;
      this.InvisibleSegmentLength = InvisibleSegmentLength;
      this.type = 3510044353;
    }
  }
  IFC42.IfcCurveStyleFontPattern = IfcCurveStyleFontPattern;
  class IfcDerivedProfileDef extends IfcProfileDef {
    constructor(expressID, ProfileType, ProfileName, ParentProfile, Operator, Label) {
      super(expressID, ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.ParentProfile = ParentProfile;
      this.Operator = Operator;
      this.Label = Label;
      this.type = 3632507154;
    }
  }
  IFC42.IfcDerivedProfileDef = IfcDerivedProfileDef;
  class IfcDocumentInformation extends IfcExternalInformation {
    constructor(expressID, Identification, Name, Description, Location, Purpose, IntendedUse, Scope, Revision, DocumentOwner, Editors, CreationTime, LastRevisionTime, ElectronicFormat, ValidFrom, ValidUntil, Confidentiality, Status) {
      super(expressID);
      this.Identification = Identification;
      this.Name = Name;
      this.Description = Description;
      this.Location = Location;
      this.Purpose = Purpose;
      this.IntendedUse = IntendedUse;
      this.Scope = Scope;
      this.Revision = Revision;
      this.DocumentOwner = DocumentOwner;
      this.Editors = Editors;
      this.CreationTime = CreationTime;
      this.LastRevisionTime = LastRevisionTime;
      this.ElectronicFormat = ElectronicFormat;
      this.ValidFrom = ValidFrom;
      this.ValidUntil = ValidUntil;
      this.Confidentiality = Confidentiality;
      this.Status = Status;
      this.type = 1154170062;
    }
  }
  IFC42.IfcDocumentInformation = IfcDocumentInformation;
  class IfcDocumentInformationRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, RelatingDocument, RelatedDocuments, RelationshipType) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingDocument = RelatingDocument;
      this.RelatedDocuments = RelatedDocuments;
      this.RelationshipType = RelationshipType;
      this.type = 770865208;
    }
  }
  IFC42.IfcDocumentInformationRelationship = IfcDocumentInformationRelationship;
  class IfcDocumentReference extends IfcExternalReference {
    constructor(expressID, Location, Identification, Name, Description, ReferencedDocument) {
      super(expressID, Location, Identification, Name);
      this.Location = Location;
      this.Identification = Identification;
      this.Name = Name;
      this.Description = Description;
      this.ReferencedDocument = ReferencedDocument;
      this.type = 3732053477;
    }
  }
  IFC42.IfcDocumentReference = IfcDocumentReference;
  class IfcEdge extends IfcTopologicalRepresentationItem {
    constructor(expressID, EdgeStart, EdgeEnd) {
      super(expressID);
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.type = 3900360178;
    }
  }
  IFC42.IfcEdge = IfcEdge;
  class IfcEdgeCurve extends IfcEdge {
    constructor(expressID, EdgeStart, EdgeEnd, EdgeGeometry, SameSense) {
      super(expressID, EdgeStart, EdgeEnd);
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.EdgeGeometry = EdgeGeometry;
      this.SameSense = SameSense;
      this.type = 476780140;
    }
  }
  IFC42.IfcEdgeCurve = IfcEdgeCurve;
  class IfcEventTime extends IfcSchedulingTime {
    constructor(expressID, Name, DataOrigin, UserDefinedDataOrigin, ActualDate, EarlyDate, LateDate, ScheduleDate) {
      super(expressID, Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.ActualDate = ActualDate;
      this.EarlyDate = EarlyDate;
      this.LateDate = LateDate;
      this.ScheduleDate = ScheduleDate;
      this.type = 211053100;
    }
  }
  IFC42.IfcEventTime = IfcEventTime;
  class IfcExtendedProperties extends IfcPropertyAbstraction {
    constructor(expressID, Name, Description, Properties2) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.Properties = Properties2;
      this.type = 297599258;
    }
  }
  IFC42.IfcExtendedProperties = IfcExtendedProperties;
  class IfcExternalReferenceRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, RelatingReference, RelatedResourceObjects) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingReference = RelatingReference;
      this.RelatedResourceObjects = RelatedResourceObjects;
      this.type = 1437805879;
    }
  }
  IFC42.IfcExternalReferenceRelationship = IfcExternalReferenceRelationship;
  class IfcFace extends IfcTopologicalRepresentationItem {
    constructor(expressID, Bounds) {
      super(expressID);
      this.Bounds = Bounds;
      this.type = 2556980723;
    }
  }
  IFC42.IfcFace = IfcFace;
  class IfcFaceBound extends IfcTopologicalRepresentationItem {
    constructor(expressID, Bound, Orientation) {
      super(expressID);
      this.Bound = Bound;
      this.Orientation = Orientation;
      this.type = 1809719519;
    }
  }
  IFC42.IfcFaceBound = IfcFaceBound;
  class IfcFaceOuterBound extends IfcFaceBound {
    constructor(expressID, Bound, Orientation) {
      super(expressID, Bound, Orientation);
      this.Bound = Bound;
      this.Orientation = Orientation;
      this.type = 803316827;
    }
  }
  IFC42.IfcFaceOuterBound = IfcFaceOuterBound;
  class IfcFaceSurface extends IfcFace {
    constructor(expressID, Bounds, FaceSurface, SameSense) {
      super(expressID, Bounds);
      this.Bounds = Bounds;
      this.FaceSurface = FaceSurface;
      this.SameSense = SameSense;
      this.type = 3008276851;
    }
  }
  IFC42.IfcFaceSurface = IfcFaceSurface;
  class IfcFailureConnectionCondition extends IfcStructuralConnectionCondition {
    constructor(expressID, Name, TensionFailureX, TensionFailureY, TensionFailureZ, CompressionFailureX, CompressionFailureY, CompressionFailureZ) {
      super(expressID, Name);
      this.Name = Name;
      this.TensionFailureX = TensionFailureX;
      this.TensionFailureY = TensionFailureY;
      this.TensionFailureZ = TensionFailureZ;
      this.CompressionFailureX = CompressionFailureX;
      this.CompressionFailureY = CompressionFailureY;
      this.CompressionFailureZ = CompressionFailureZ;
      this.type = 4219587988;
    }
  }
  IFC42.IfcFailureConnectionCondition = IfcFailureConnectionCondition;
  class IfcFillAreaStyle extends IfcPresentationStyle {
    constructor(expressID, Name, FillStyles, ModelorDraughting) {
      super(expressID, Name);
      this.Name = Name;
      this.FillStyles = FillStyles;
      this.ModelorDraughting = ModelorDraughting;
      this.type = 738692330;
    }
  }
  IFC42.IfcFillAreaStyle = IfcFillAreaStyle;
  class IfcGeometricRepresentationContext extends IfcRepresentationContext {
    constructor(expressID, ContextIdentifier, ContextType, CoordinateSpaceDimension, Precision, WorldCoordinateSystem, TrueNorth) {
      super(expressID, ContextIdentifier, ContextType);
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.CoordinateSpaceDimension = CoordinateSpaceDimension;
      this.Precision = Precision;
      this.WorldCoordinateSystem = WorldCoordinateSystem;
      this.TrueNorth = TrueNorth;
      this.type = 3448662350;
    }
  }
  IFC42.IfcGeometricRepresentationContext = IfcGeometricRepresentationContext;
  class IfcGeometricRepresentationItem extends IfcRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 2453401579;
    }
  }
  IFC42.IfcGeometricRepresentationItem = IfcGeometricRepresentationItem;
  class IfcGeometricRepresentationSubContext extends IfcGeometricRepresentationContext {
    constructor(expressID, ContextIdentifier, ContextType, ParentContext, TargetScale, TargetView, UserDefinedTargetView) {
      super(expressID, ContextIdentifier, ContextType, new IfcDimensionCount(0), null, new Handle(0), null);
      this.ContextIdentifier = ContextIdentifier;
      this.ContextType = ContextType;
      this.ParentContext = ParentContext;
      this.TargetScale = TargetScale;
      this.TargetView = TargetView;
      this.UserDefinedTargetView = UserDefinedTargetView;
      this.type = 4142052618;
    }
  }
  IFC42.IfcGeometricRepresentationSubContext = IfcGeometricRepresentationSubContext;
  class IfcGeometricSet extends IfcGeometricRepresentationItem {
    constructor(expressID, Elements) {
      super(expressID);
      this.Elements = Elements;
      this.type = 3590301190;
    }
  }
  IFC42.IfcGeometricSet = IfcGeometricSet;
  class IfcGridPlacement extends IfcObjectPlacement {
    constructor(expressID, PlacementLocation, PlacementRefDirection) {
      super(expressID);
      this.PlacementLocation = PlacementLocation;
      this.PlacementRefDirection = PlacementRefDirection;
      this.type = 178086475;
    }
  }
  IFC42.IfcGridPlacement = IfcGridPlacement;
  class IfcHalfSpaceSolid extends IfcGeometricRepresentationItem {
    constructor(expressID, BaseSurface, AgreementFlag) {
      super(expressID);
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.type = 812098782;
    }
  }
  IFC42.IfcHalfSpaceSolid = IfcHalfSpaceSolid;
  class IfcImageTexture extends IfcSurfaceTexture {
    constructor(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter, URLReference) {
      super(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.Mode = Mode;
      this.TextureTransform = TextureTransform;
      this.Parameter = Parameter;
      this.URLReference = URLReference;
      this.type = 3905492369;
    }
  }
  IFC42.IfcImageTexture = IfcImageTexture;
  class IfcIndexedColourMap extends IfcPresentationItem {
    constructor(expressID, MappedTo, Opacity, Colours, ColourIndex) {
      super(expressID);
      this.MappedTo = MappedTo;
      this.Opacity = Opacity;
      this.Colours = Colours;
      this.ColourIndex = ColourIndex;
      this.type = 3570813810;
    }
  }
  IFC42.IfcIndexedColourMap = IfcIndexedColourMap;
  class IfcIndexedTextureMap extends IfcTextureCoordinate {
    constructor(expressID, Maps, MappedTo, TexCoords) {
      super(expressID, Maps);
      this.Maps = Maps;
      this.MappedTo = MappedTo;
      this.TexCoords = TexCoords;
      this.type = 1437953363;
    }
  }
  IFC42.IfcIndexedTextureMap = IfcIndexedTextureMap;
  class IfcIndexedTriangleTextureMap extends IfcIndexedTextureMap {
    constructor(expressID, Maps, MappedTo, TexCoords, TexCoordIndex) {
      super(expressID, Maps, MappedTo, TexCoords);
      this.Maps = Maps;
      this.MappedTo = MappedTo;
      this.TexCoords = TexCoords;
      this.TexCoordIndex = TexCoordIndex;
      this.type = 2133299955;
    }
  }
  IFC42.IfcIndexedTriangleTextureMap = IfcIndexedTriangleTextureMap;
  class IfcIrregularTimeSeries extends IfcTimeSeries {
    constructor(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, Values) {
      super(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.Values = Values;
      this.type = 3741457305;
    }
  }
  IFC42.IfcIrregularTimeSeries = IfcIrregularTimeSeries;
  class IfcLagTime extends IfcSchedulingTime {
    constructor(expressID, Name, DataOrigin, UserDefinedDataOrigin, LagValue, DurationType) {
      super(expressID, Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.LagValue = LagValue;
      this.DurationType = DurationType;
      this.type = 1585845231;
    }
  }
  IFC42.IfcLagTime = IfcLagTime;
  class IfcLightSource extends IfcGeometricRepresentationItem {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity) {
      super(expressID);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.type = 1402838566;
    }
  }
  IFC42.IfcLightSource = IfcLightSource;
  class IfcLightSourceAmbient extends IfcLightSource {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity) {
      super(expressID, Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.type = 125510826;
    }
  }
  IFC42.IfcLightSourceAmbient = IfcLightSourceAmbient;
  class IfcLightSourceDirectional extends IfcLightSource {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity, Orientation) {
      super(expressID, Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Orientation = Orientation;
      this.type = 2604431987;
    }
  }
  IFC42.IfcLightSourceDirectional = IfcLightSourceDirectional;
  class IfcLightSourceGoniometric extends IfcLightSource {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, ColourAppearance, ColourTemperature, LuminousFlux, LightEmissionSource, LightDistributionDataSource) {
      super(expressID, Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.ColourAppearance = ColourAppearance;
      this.ColourTemperature = ColourTemperature;
      this.LuminousFlux = LuminousFlux;
      this.LightEmissionSource = LightEmissionSource;
      this.LightDistributionDataSource = LightDistributionDataSource;
      this.type = 4266656042;
    }
  }
  IFC42.IfcLightSourceGoniometric = IfcLightSourceGoniometric;
  class IfcLightSourcePositional extends IfcLightSource {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation) {
      super(expressID, Name, LightColour, AmbientIntensity, Intensity);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.Radius = Radius;
      this.ConstantAttenuation = ConstantAttenuation;
      this.DistanceAttenuation = DistanceAttenuation;
      this.QuadricAttenuation = QuadricAttenuation;
      this.type = 1520743889;
    }
  }
  IFC42.IfcLightSourcePositional = IfcLightSourcePositional;
  class IfcLightSourceSpot extends IfcLightSourcePositional {
    constructor(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation, Orientation, ConcentrationExponent, SpreadAngle, BeamWidthAngle) {
      super(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation);
      this.Name = Name;
      this.LightColour = LightColour;
      this.AmbientIntensity = AmbientIntensity;
      this.Intensity = Intensity;
      this.Position = Position;
      this.Radius = Radius;
      this.ConstantAttenuation = ConstantAttenuation;
      this.DistanceAttenuation = DistanceAttenuation;
      this.QuadricAttenuation = QuadricAttenuation;
      this.Orientation = Orientation;
      this.ConcentrationExponent = ConcentrationExponent;
      this.SpreadAngle = SpreadAngle;
      this.BeamWidthAngle = BeamWidthAngle;
      this.type = 3422422726;
    }
  }
  IFC42.IfcLightSourceSpot = IfcLightSourceSpot;
  class IfcLocalPlacement extends IfcObjectPlacement {
    constructor(expressID, PlacementRelTo, RelativePlacement) {
      super(expressID);
      this.PlacementRelTo = PlacementRelTo;
      this.RelativePlacement = RelativePlacement;
      this.type = 2624227202;
    }
  }
  IFC42.IfcLocalPlacement = IfcLocalPlacement;
  class IfcLoop extends IfcTopologicalRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 1008929658;
    }
  }
  IFC42.IfcLoop = IfcLoop;
  class IfcMappedItem extends IfcRepresentationItem {
    constructor(expressID, MappingSource, MappingTarget) {
      super(expressID);
      this.MappingSource = MappingSource;
      this.MappingTarget = MappingTarget;
      this.type = 2347385850;
    }
  }
  IFC42.IfcMappedItem = IfcMappedItem;
  class IfcMaterial extends IfcMaterialDefinition {
    constructor(expressID, Name, Description, Category) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.Category = Category;
      this.type = 1838606355;
    }
  }
  IFC42.IfcMaterial = IfcMaterial;
  class IfcMaterialConstituent extends IfcMaterialDefinition {
    constructor(expressID, Name, Description, Material, Fraction, Category) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.Material = Material;
      this.Fraction = Fraction;
      this.Category = Category;
      this.type = 3708119e3;
    }
  }
  IFC42.IfcMaterialConstituent = IfcMaterialConstituent;
  class IfcMaterialConstituentSet extends IfcMaterialDefinition {
    constructor(expressID, Name, Description, MaterialConstituents) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.MaterialConstituents = MaterialConstituents;
      this.type = 2852063980;
    }
  }
  IFC42.IfcMaterialConstituentSet = IfcMaterialConstituentSet;
  class IfcMaterialDefinitionRepresentation extends IfcProductRepresentation {
    constructor(expressID, Name, Description, Representations, RepresentedMaterial) {
      super(expressID, Name, Description, Representations);
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.RepresentedMaterial = RepresentedMaterial;
      this.type = 2022407955;
    }
  }
  IFC42.IfcMaterialDefinitionRepresentation = IfcMaterialDefinitionRepresentation;
  class IfcMaterialLayerSetUsage extends IfcMaterialUsageDefinition {
    constructor(expressID, ForLayerSet, LayerSetDirection, DirectionSense, OffsetFromReferenceLine, ReferenceExtent) {
      super(expressID);
      this.ForLayerSet = ForLayerSet;
      this.LayerSetDirection = LayerSetDirection;
      this.DirectionSense = DirectionSense;
      this.OffsetFromReferenceLine = OffsetFromReferenceLine;
      this.ReferenceExtent = ReferenceExtent;
      this.type = 1303795690;
    }
  }
  IFC42.IfcMaterialLayerSetUsage = IfcMaterialLayerSetUsage;
  class IfcMaterialProfileSetUsage extends IfcMaterialUsageDefinition {
    constructor(expressID, ForProfileSet, CardinalPoint, ReferenceExtent) {
      super(expressID);
      this.ForProfileSet = ForProfileSet;
      this.CardinalPoint = CardinalPoint;
      this.ReferenceExtent = ReferenceExtent;
      this.type = 3079605661;
    }
  }
  IFC42.IfcMaterialProfileSetUsage = IfcMaterialProfileSetUsage;
  class IfcMaterialProfileSetUsageTapering extends IfcMaterialProfileSetUsage {
    constructor(expressID, ForProfileSet, CardinalPoint, ReferenceExtent, ForProfileEndSet, CardinalEndPoint) {
      super(expressID, ForProfileSet, CardinalPoint, ReferenceExtent);
      this.ForProfileSet = ForProfileSet;
      this.CardinalPoint = CardinalPoint;
      this.ReferenceExtent = ReferenceExtent;
      this.ForProfileEndSet = ForProfileEndSet;
      this.CardinalEndPoint = CardinalEndPoint;
      this.type = 3404854881;
    }
  }
  IFC42.IfcMaterialProfileSetUsageTapering = IfcMaterialProfileSetUsageTapering;
  class IfcMaterialProperties extends IfcExtendedProperties {
    constructor(expressID, Name, Description, Properties2, Material) {
      super(expressID, Name, Description, Properties2);
      this.Name = Name;
      this.Description = Description;
      this.Properties = Properties2;
      this.Material = Material;
      this.type = 3265635763;
    }
  }
  IFC42.IfcMaterialProperties = IfcMaterialProperties;
  class IfcMaterialRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, RelatingMaterial, RelatedMaterials, Expression) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingMaterial = RelatingMaterial;
      this.RelatedMaterials = RelatedMaterials;
      this.Expression = Expression;
      this.type = 853536259;
    }
  }
  IFC42.IfcMaterialRelationship = IfcMaterialRelationship;
  class IfcMirroredProfileDef extends IfcDerivedProfileDef {
    constructor(expressID, ProfileType, ProfileName, ParentProfile, Label) {
      super(expressID, ProfileType, ProfileName, ParentProfile, new Handle(0), Label);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.ParentProfile = ParentProfile;
      this.Label = Label;
      this.type = 2998442950;
    }
  }
  IFC42.IfcMirroredProfileDef = IfcMirroredProfileDef;
  class IfcObjectDefinition extends IfcRoot {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 219451334;
    }
  }
  IFC42.IfcObjectDefinition = IfcObjectDefinition;
  class IfcOpenShell extends IfcConnectedFaceSet {
    constructor(expressID, CfsFaces) {
      super(expressID, CfsFaces);
      this.CfsFaces = CfsFaces;
      this.type = 2665983363;
    }
  }
  IFC42.IfcOpenShell = IfcOpenShell;
  class IfcOrganizationRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, RelatingOrganization, RelatedOrganizations) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingOrganization = RelatingOrganization;
      this.RelatedOrganizations = RelatedOrganizations;
      this.type = 1411181986;
    }
  }
  IFC42.IfcOrganizationRelationship = IfcOrganizationRelationship;
  class IfcOrientedEdge extends IfcEdge {
    constructor(expressID, EdgeElement, Orientation) {
      super(expressID, new Handle(0), new Handle(0));
      this.EdgeElement = EdgeElement;
      this.Orientation = Orientation;
      this.type = 1029017970;
    }
  }
  IFC42.IfcOrientedEdge = IfcOrientedEdge;
  class IfcParameterizedProfileDef extends IfcProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position) {
      super(expressID, ProfileType, ProfileName);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.type = 2529465313;
    }
  }
  IFC42.IfcParameterizedProfileDef = IfcParameterizedProfileDef;
  class IfcPath extends IfcTopologicalRepresentationItem {
    constructor(expressID, EdgeList) {
      super(expressID);
      this.EdgeList = EdgeList;
      this.type = 2519244187;
    }
  }
  IFC42.IfcPath = IfcPath;
  class IfcPhysicalComplexQuantity extends IfcPhysicalQuantity {
    constructor(expressID, Name, Description, HasQuantities, Discrimination, Quality, Usage) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.HasQuantities = HasQuantities;
      this.Discrimination = Discrimination;
      this.Quality = Quality;
      this.Usage = Usage;
      this.type = 3021840470;
    }
  }
  IFC42.IfcPhysicalComplexQuantity = IfcPhysicalComplexQuantity;
  class IfcPixelTexture extends IfcSurfaceTexture {
    constructor(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter, Width, Height, ColourComponents, Pixel) {
      super(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      this.RepeatS = RepeatS;
      this.RepeatT = RepeatT;
      this.Mode = Mode;
      this.TextureTransform = TextureTransform;
      this.Parameter = Parameter;
      this.Width = Width;
      this.Height = Height;
      this.ColourComponents = ColourComponents;
      this.Pixel = Pixel;
      this.type = 597895409;
    }
  }
  IFC42.IfcPixelTexture = IfcPixelTexture;
  class IfcPlacement extends IfcGeometricRepresentationItem {
    constructor(expressID, Location) {
      super(expressID);
      this.Location = Location;
      this.type = 2004835150;
    }
  }
  IFC42.IfcPlacement = IfcPlacement;
  class IfcPlanarExtent extends IfcGeometricRepresentationItem {
    constructor(expressID, SizeInX, SizeInY) {
      super(expressID);
      this.SizeInX = SizeInX;
      this.SizeInY = SizeInY;
      this.type = 1663979128;
    }
  }
  IFC42.IfcPlanarExtent = IfcPlanarExtent;
  class IfcPoint extends IfcGeometricRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 2067069095;
    }
  }
  IFC42.IfcPoint = IfcPoint;
  class IfcPointOnCurve extends IfcPoint {
    constructor(expressID, BasisCurve, PointParameter) {
      super(expressID);
      this.BasisCurve = BasisCurve;
      this.PointParameter = PointParameter;
      this.type = 4022376103;
    }
  }
  IFC42.IfcPointOnCurve = IfcPointOnCurve;
  class IfcPointOnSurface extends IfcPoint {
    constructor(expressID, BasisSurface, PointParameterU, PointParameterV) {
      super(expressID);
      this.BasisSurface = BasisSurface;
      this.PointParameterU = PointParameterU;
      this.PointParameterV = PointParameterV;
      this.type = 1423911732;
    }
  }
  IFC42.IfcPointOnSurface = IfcPointOnSurface;
  class IfcPolyLoop extends IfcLoop {
    constructor(expressID, Polygon) {
      super(expressID);
      this.Polygon = Polygon;
      this.type = 2924175390;
    }
  }
  IFC42.IfcPolyLoop = IfcPolyLoop;
  class IfcPolygonalBoundedHalfSpace extends IfcHalfSpaceSolid {
    constructor(expressID, BaseSurface, AgreementFlag, Position, PolygonalBoundary) {
      super(expressID, BaseSurface, AgreementFlag);
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.Position = Position;
      this.PolygonalBoundary = PolygonalBoundary;
      this.type = 2775532180;
    }
  }
  IFC42.IfcPolygonalBoundedHalfSpace = IfcPolygonalBoundedHalfSpace;
  class IfcPreDefinedItem extends IfcPresentationItem {
    constructor(expressID, Name) {
      super(expressID);
      this.Name = Name;
      this.type = 3727388367;
    }
  }
  IFC42.IfcPreDefinedItem = IfcPreDefinedItem;
  class IfcPreDefinedProperties extends IfcPropertyAbstraction {
    constructor(expressID) {
      super(expressID);
      this.type = 3778827333;
    }
  }
  IFC42.IfcPreDefinedProperties = IfcPreDefinedProperties;
  class IfcPreDefinedTextFont extends IfcPreDefinedItem {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 1775413392;
    }
  }
  IFC42.IfcPreDefinedTextFont = IfcPreDefinedTextFont;
  class IfcProductDefinitionShape extends IfcProductRepresentation {
    constructor(expressID, Name, Description, Representations) {
      super(expressID, Name, Description, Representations);
      this.Name = Name;
      this.Description = Description;
      this.Representations = Representations;
      this.type = 673634403;
    }
  }
  IFC42.IfcProductDefinitionShape = IfcProductDefinitionShape;
  class IfcProfileProperties extends IfcExtendedProperties {
    constructor(expressID, Name, Description, Properties2, ProfileDefinition) {
      super(expressID, Name, Description, Properties2);
      this.Name = Name;
      this.Description = Description;
      this.Properties = Properties2;
      this.ProfileDefinition = ProfileDefinition;
      this.type = 2802850158;
    }
  }
  IFC42.IfcProfileProperties = IfcProfileProperties;
  class IfcProperty extends IfcPropertyAbstraction {
    constructor(expressID, Name, Description) {
      super(expressID);
      this.Name = Name;
      this.Description = Description;
      this.type = 2598011224;
    }
  }
  IFC42.IfcProperty = IfcProperty;
  class IfcPropertyDefinition extends IfcRoot {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 1680319473;
    }
  }
  IFC42.IfcPropertyDefinition = IfcPropertyDefinition;
  class IfcPropertyDependencyRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, DependingProperty, DependantProperty, Expression) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.DependingProperty = DependingProperty;
      this.DependantProperty = DependantProperty;
      this.Expression = Expression;
      this.type = 148025276;
    }
  }
  IFC42.IfcPropertyDependencyRelationship = IfcPropertyDependencyRelationship;
  class IfcPropertySetDefinition extends IfcPropertyDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 3357820518;
    }
  }
  IFC42.IfcPropertySetDefinition = IfcPropertySetDefinition;
  class IfcPropertyTemplateDefinition extends IfcPropertyDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 1482703590;
    }
  }
  IFC42.IfcPropertyTemplateDefinition = IfcPropertyTemplateDefinition;
  class IfcQuantitySet extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 2090586900;
    }
  }
  IFC42.IfcQuantitySet = IfcQuantitySet;
  class IfcRectangleProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, XDim, YDim) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.type = 3615266464;
    }
  }
  IFC42.IfcRectangleProfileDef = IfcRectangleProfileDef;
  class IfcRegularTimeSeries extends IfcTimeSeries {
    constructor(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, TimeStep, Values) {
      super(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      this.Name = Name;
      this.Description = Description;
      this.StartTime = StartTime;
      this.EndTime = EndTime;
      this.TimeSeriesDataType = TimeSeriesDataType;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.Unit = Unit;
      this.TimeStep = TimeStep;
      this.Values = Values;
      this.type = 3413951693;
    }
  }
  IFC42.IfcRegularTimeSeries = IfcRegularTimeSeries;
  class IfcReinforcementBarProperties extends IfcPreDefinedProperties {
    constructor(expressID, TotalCrossSectionArea, SteelGrade, BarSurface, EffectiveDepth, NominalBarDiameter, BarCount) {
      super(expressID);
      this.TotalCrossSectionArea = TotalCrossSectionArea;
      this.SteelGrade = SteelGrade;
      this.BarSurface = BarSurface;
      this.EffectiveDepth = EffectiveDepth;
      this.NominalBarDiameter = NominalBarDiameter;
      this.BarCount = BarCount;
      this.type = 1580146022;
    }
  }
  IFC42.IfcReinforcementBarProperties = IfcReinforcementBarProperties;
  class IfcRelationship extends IfcRoot {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 478536968;
    }
  }
  IFC42.IfcRelationship = IfcRelationship;
  class IfcResourceApprovalRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, RelatedResourceObjects, RelatingApproval) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatedResourceObjects = RelatedResourceObjects;
      this.RelatingApproval = RelatingApproval;
      this.type = 2943643501;
    }
  }
  IFC42.IfcResourceApprovalRelationship = IfcResourceApprovalRelationship;
  class IfcResourceConstraintRelationship extends IfcResourceLevelRelationship {
    constructor(expressID, Name, Description, RelatingConstraint, RelatedResourceObjects) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.RelatingConstraint = RelatingConstraint;
      this.RelatedResourceObjects = RelatedResourceObjects;
      this.type = 1608871552;
    }
  }
  IFC42.IfcResourceConstraintRelationship = IfcResourceConstraintRelationship;
  class IfcResourceTime extends IfcSchedulingTime {
    constructor(expressID, Name, DataOrigin, UserDefinedDataOrigin, ScheduleWork, ScheduleUsage, ScheduleStart, ScheduleFinish, ScheduleContour, LevelingDelay, IsOverAllocated, StatusTime, ActualWork, ActualUsage, ActualStart, ActualFinish, RemainingWork, RemainingUsage, Completion) {
      super(expressID, Name, DataOrigin, UserDefinedDataOrigin);
      this.Name = Name;
      this.DataOrigin = DataOrigin;
      this.UserDefinedDataOrigin = UserDefinedDataOrigin;
      this.ScheduleWork = ScheduleWork;
      this.ScheduleUsage = ScheduleUsage;
      this.ScheduleStart = ScheduleStart;
      this.ScheduleFinish = ScheduleFinish;
      this.ScheduleContour = ScheduleContour;
      this.LevelingDelay = LevelingDelay;
      this.IsOverAllocated = IsOverAllocated;
      this.StatusTime = StatusTime;
      this.ActualWork = ActualWork;
      this.ActualUsage = ActualUsage;
      this.ActualStart = ActualStart;
      this.ActualFinish = ActualFinish;
      this.RemainingWork = RemainingWork;
      this.RemainingUsage = RemainingUsage;
      this.Completion = Completion;
      this.type = 1042787934;
    }
  }
  IFC42.IfcResourceTime = IfcResourceTime;
  class IfcRoundedRectangleProfileDef extends IfcRectangleProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, XDim, YDim, RoundingRadius) {
      super(expressID, ProfileType, ProfileName, Position, XDim, YDim);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.RoundingRadius = RoundingRadius;
      this.type = 2778083089;
    }
  }
  IFC42.IfcRoundedRectangleProfileDef = IfcRoundedRectangleProfileDef;
  class IfcSectionProperties extends IfcPreDefinedProperties {
    constructor(expressID, SectionType, StartProfile, EndProfile) {
      super(expressID);
      this.SectionType = SectionType;
      this.StartProfile = StartProfile;
      this.EndProfile = EndProfile;
      this.type = 2042790032;
    }
  }
  IFC42.IfcSectionProperties = IfcSectionProperties;
  class IfcSectionReinforcementProperties extends IfcPreDefinedProperties {
    constructor(expressID, LongitudinalStartPosition, LongitudinalEndPosition, TransversePosition, ReinforcementRole, SectionDefinition, CrossSectionReinforcementDefinitions) {
      super(expressID);
      this.LongitudinalStartPosition = LongitudinalStartPosition;
      this.LongitudinalEndPosition = LongitudinalEndPosition;
      this.TransversePosition = TransversePosition;
      this.ReinforcementRole = ReinforcementRole;
      this.SectionDefinition = SectionDefinition;
      this.CrossSectionReinforcementDefinitions = CrossSectionReinforcementDefinitions;
      this.type = 4165799628;
    }
  }
  IFC42.IfcSectionReinforcementProperties = IfcSectionReinforcementProperties;
  class IfcSectionedSpine extends IfcGeometricRepresentationItem {
    constructor(expressID, SpineCurve, CrossSections, CrossSectionPositions) {
      super(expressID);
      this.SpineCurve = SpineCurve;
      this.CrossSections = CrossSections;
      this.CrossSectionPositions = CrossSectionPositions;
      this.type = 1509187699;
    }
  }
  IFC42.IfcSectionedSpine = IfcSectionedSpine;
  class IfcShellBasedSurfaceModel extends IfcGeometricRepresentationItem {
    constructor(expressID, SbsmBoundary) {
      super(expressID);
      this.SbsmBoundary = SbsmBoundary;
      this.type = 4124623270;
    }
  }
  IFC42.IfcShellBasedSurfaceModel = IfcShellBasedSurfaceModel;
  class IfcSimpleProperty extends IfcProperty {
    constructor(expressID, Name, Description) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.type = 3692461612;
    }
  }
  IFC42.IfcSimpleProperty = IfcSimpleProperty;
  class IfcSlippageConnectionCondition extends IfcStructuralConnectionCondition {
    constructor(expressID, Name, SlippageX, SlippageY, SlippageZ) {
      super(expressID, Name);
      this.Name = Name;
      this.SlippageX = SlippageX;
      this.SlippageY = SlippageY;
      this.SlippageZ = SlippageZ;
      this.type = 2609359061;
    }
  }
  IFC42.IfcSlippageConnectionCondition = IfcSlippageConnectionCondition;
  class IfcSolidModel extends IfcGeometricRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 723233188;
    }
  }
  IFC42.IfcSolidModel = IfcSolidModel;
  class IfcStructuralLoadLinearForce extends IfcStructuralLoadStatic {
    constructor(expressID, Name, LinearForceX, LinearForceY, LinearForceZ, LinearMomentX, LinearMomentY, LinearMomentZ) {
      super(expressID, Name);
      this.Name = Name;
      this.LinearForceX = LinearForceX;
      this.LinearForceY = LinearForceY;
      this.LinearForceZ = LinearForceZ;
      this.LinearMomentX = LinearMomentX;
      this.LinearMomentY = LinearMomentY;
      this.LinearMomentZ = LinearMomentZ;
      this.type = 1595516126;
    }
  }
  IFC42.IfcStructuralLoadLinearForce = IfcStructuralLoadLinearForce;
  class IfcStructuralLoadPlanarForce extends IfcStructuralLoadStatic {
    constructor(expressID, Name, PlanarForceX, PlanarForceY, PlanarForceZ) {
      super(expressID, Name);
      this.Name = Name;
      this.PlanarForceX = PlanarForceX;
      this.PlanarForceY = PlanarForceY;
      this.PlanarForceZ = PlanarForceZ;
      this.type = 2668620305;
    }
  }
  IFC42.IfcStructuralLoadPlanarForce = IfcStructuralLoadPlanarForce;
  class IfcStructuralLoadSingleDisplacement extends IfcStructuralLoadStatic {
    constructor(expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ) {
      super(expressID, Name);
      this.Name = Name;
      this.DisplacementX = DisplacementX;
      this.DisplacementY = DisplacementY;
      this.DisplacementZ = DisplacementZ;
      this.RotationalDisplacementRX = RotationalDisplacementRX;
      this.RotationalDisplacementRY = RotationalDisplacementRY;
      this.RotationalDisplacementRZ = RotationalDisplacementRZ;
      this.type = 2473145415;
    }
  }
  IFC42.IfcStructuralLoadSingleDisplacement = IfcStructuralLoadSingleDisplacement;
  class IfcStructuralLoadSingleDisplacementDistortion extends IfcStructuralLoadSingleDisplacement {
    constructor(expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ, Distortion) {
      super(expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ);
      this.Name = Name;
      this.DisplacementX = DisplacementX;
      this.DisplacementY = DisplacementY;
      this.DisplacementZ = DisplacementZ;
      this.RotationalDisplacementRX = RotationalDisplacementRX;
      this.RotationalDisplacementRY = RotationalDisplacementRY;
      this.RotationalDisplacementRZ = RotationalDisplacementRZ;
      this.Distortion = Distortion;
      this.type = 1973038258;
    }
  }
  IFC42.IfcStructuralLoadSingleDisplacementDistortion = IfcStructuralLoadSingleDisplacementDistortion;
  class IfcStructuralLoadSingleForce extends IfcStructuralLoadStatic {
    constructor(expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ) {
      super(expressID, Name);
      this.Name = Name;
      this.ForceX = ForceX;
      this.ForceY = ForceY;
      this.ForceZ = ForceZ;
      this.MomentX = MomentX;
      this.MomentY = MomentY;
      this.MomentZ = MomentZ;
      this.type = 1597423693;
    }
  }
  IFC42.IfcStructuralLoadSingleForce = IfcStructuralLoadSingleForce;
  class IfcStructuralLoadSingleForceWarping extends IfcStructuralLoadSingleForce {
    constructor(expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ, WarpingMoment) {
      super(expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ);
      this.Name = Name;
      this.ForceX = ForceX;
      this.ForceY = ForceY;
      this.ForceZ = ForceZ;
      this.MomentX = MomentX;
      this.MomentY = MomentY;
      this.MomentZ = MomentZ;
      this.WarpingMoment = WarpingMoment;
      this.type = 1190533807;
    }
  }
  IFC42.IfcStructuralLoadSingleForceWarping = IfcStructuralLoadSingleForceWarping;
  class IfcSubedge extends IfcEdge {
    constructor(expressID, EdgeStart, EdgeEnd, ParentEdge) {
      super(expressID, EdgeStart, EdgeEnd);
      this.EdgeStart = EdgeStart;
      this.EdgeEnd = EdgeEnd;
      this.ParentEdge = ParentEdge;
      this.type = 2233826070;
    }
  }
  IFC42.IfcSubedge = IfcSubedge;
  class IfcSurface extends IfcGeometricRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 2513912981;
    }
  }
  IFC42.IfcSurface = IfcSurface;
  class IfcSurfaceStyleRendering extends IfcSurfaceStyleShading {
    constructor(expressID, SurfaceColour, Transparency, DiffuseColour, TransmissionColour, DiffuseTransmissionColour, ReflectionColour, SpecularColour, SpecularHighlight, ReflectanceMethod) {
      super(expressID, SurfaceColour, Transparency);
      this.SurfaceColour = SurfaceColour;
      this.Transparency = Transparency;
      this.DiffuseColour = DiffuseColour;
      this.TransmissionColour = TransmissionColour;
      this.DiffuseTransmissionColour = DiffuseTransmissionColour;
      this.ReflectionColour = ReflectionColour;
      this.SpecularColour = SpecularColour;
      this.SpecularHighlight = SpecularHighlight;
      this.ReflectanceMethod = ReflectanceMethod;
      this.type = 1878645084;
    }
  }
  IFC42.IfcSurfaceStyleRendering = IfcSurfaceStyleRendering;
  class IfcSweptAreaSolid extends IfcSolidModel {
    constructor(expressID, SweptArea, Position) {
      super(expressID);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.type = 2247615214;
    }
  }
  IFC42.IfcSweptAreaSolid = IfcSweptAreaSolid;
  class IfcSweptDiskSolid extends IfcSolidModel {
    constructor(expressID, Directrix, Radius, InnerRadius, StartParam, EndParam) {
      super(expressID);
      this.Directrix = Directrix;
      this.Radius = Radius;
      this.InnerRadius = InnerRadius;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.type = 1260650574;
    }
  }
  IFC42.IfcSweptDiskSolid = IfcSweptDiskSolid;
  class IfcSweptDiskSolidPolygonal extends IfcSweptDiskSolid {
    constructor(expressID, Directrix, Radius, InnerRadius, StartParam, EndParam, FilletRadius) {
      super(expressID, Directrix, Radius, InnerRadius, StartParam, EndParam);
      this.Directrix = Directrix;
      this.Radius = Radius;
      this.InnerRadius = InnerRadius;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.FilletRadius = FilletRadius;
      this.type = 1096409881;
    }
  }
  IFC42.IfcSweptDiskSolidPolygonal = IfcSweptDiskSolidPolygonal;
  class IfcSweptSurface extends IfcSurface {
    constructor(expressID, SweptCurve, Position) {
      super(expressID);
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.type = 230924584;
    }
  }
  IFC42.IfcSweptSurface = IfcSweptSurface;
  class IfcTShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, WebEdgeRadius, WebSlope, FlangeSlope) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.FlangeEdgeRadius = FlangeEdgeRadius;
      this.WebEdgeRadius = WebEdgeRadius;
      this.WebSlope = WebSlope;
      this.FlangeSlope = FlangeSlope;
      this.type = 3071757647;
    }
  }
  IFC42.IfcTShapeProfileDef = IfcTShapeProfileDef;
  class IfcTessellatedItem extends IfcGeometricRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 901063453;
    }
  }
  IFC42.IfcTessellatedItem = IfcTessellatedItem;
  class IfcTextLiteral extends IfcGeometricRepresentationItem {
    constructor(expressID, Literal, Placement, Path) {
      super(expressID);
      this.Literal = Literal;
      this.Placement = Placement;
      this.Path = Path;
      this.type = 4282788508;
    }
  }
  IFC42.IfcTextLiteral = IfcTextLiteral;
  class IfcTextLiteralWithExtent extends IfcTextLiteral {
    constructor(expressID, Literal, Placement, Path, Extent, BoxAlignment) {
      super(expressID, Literal, Placement, Path);
      this.Literal = Literal;
      this.Placement = Placement;
      this.Path = Path;
      this.Extent = Extent;
      this.BoxAlignment = BoxAlignment;
      this.type = 3124975700;
    }
  }
  IFC42.IfcTextLiteralWithExtent = IfcTextLiteralWithExtent;
  class IfcTextStyleFontModel extends IfcPreDefinedTextFont {
    constructor(expressID, Name, FontFamily, FontStyle, FontVariant, FontWeight, FontSize) {
      super(expressID, Name);
      this.Name = Name;
      this.FontFamily = FontFamily;
      this.FontStyle = FontStyle;
      this.FontVariant = FontVariant;
      this.FontWeight = FontWeight;
      this.FontSize = FontSize;
      this.type = 1983826977;
    }
  }
  IFC42.IfcTextStyleFontModel = IfcTextStyleFontModel;
  class IfcTrapeziumProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, BottomXDim, TopXDim, YDim, TopXOffset) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.BottomXDim = BottomXDim;
      this.TopXDim = TopXDim;
      this.YDim = YDim;
      this.TopXOffset = TopXOffset;
      this.type = 2715220739;
    }
  }
  IFC42.IfcTrapeziumProfileDef = IfcTrapeziumProfileDef;
  class IfcTypeObject extends IfcObjectDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.type = 1628702193;
    }
  }
  IFC42.IfcTypeObject = IfcTypeObject;
  class IfcTypeProcess extends IfcTypeObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ProcessType = ProcessType;
      this.type = 3736923433;
    }
  }
  IFC42.IfcTypeProcess = IfcTypeProcess;
  class IfcTypeProduct extends IfcTypeObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.type = 2347495698;
    }
  }
  IFC42.IfcTypeProduct = IfcTypeProduct;
  class IfcTypeResource extends IfcTypeObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.type = 3698973494;
    }
  }
  IFC42.IfcTypeResource = IfcTypeResource;
  class IfcUShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius, FlangeSlope) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.FlangeSlope = FlangeSlope;
      this.type = 427810014;
    }
  }
  IFC42.IfcUShapeProfileDef = IfcUShapeProfileDef;
  class IfcVector extends IfcGeometricRepresentationItem {
    constructor(expressID, Orientation, Magnitude) {
      super(expressID);
      this.Orientation = Orientation;
      this.Magnitude = Magnitude;
      this.type = 1417489154;
    }
  }
  IFC42.IfcVector = IfcVector;
  class IfcVertexLoop extends IfcLoop {
    constructor(expressID, LoopVertex) {
      super(expressID);
      this.LoopVertex = LoopVertex;
      this.type = 2759199220;
    }
  }
  IFC42.IfcVertexLoop = IfcVertexLoop;
  class IfcWindowStyle extends IfcTypeProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ConstructionType, OperationType, ParameterTakesPrecedence, Sizeable) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ConstructionType = ConstructionType;
      this.OperationType = OperationType;
      this.ParameterTakesPrecedence = ParameterTakesPrecedence;
      this.Sizeable = Sizeable;
      this.type = 1299126871;
    }
  }
  IFC42.IfcWindowStyle = IfcWindowStyle;
  class IfcZShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.FlangeWidth = FlangeWidth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.type = 2543172580;
    }
  }
  IFC42.IfcZShapeProfileDef = IfcZShapeProfileDef;
  class IfcAdvancedFace extends IfcFaceSurface {
    constructor(expressID, Bounds, FaceSurface, SameSense) {
      super(expressID, Bounds, FaceSurface, SameSense);
      this.Bounds = Bounds;
      this.FaceSurface = FaceSurface;
      this.SameSense = SameSense;
      this.type = 3406155212;
    }
  }
  IFC42.IfcAdvancedFace = IfcAdvancedFace;
  class IfcAnnotationFillArea extends IfcGeometricRepresentationItem {
    constructor(expressID, OuterBoundary, InnerBoundaries) {
      super(expressID);
      this.OuterBoundary = OuterBoundary;
      this.InnerBoundaries = InnerBoundaries;
      this.type = 669184980;
    }
  }
  IFC42.IfcAnnotationFillArea = IfcAnnotationFillArea;
  class IfcAsymmetricIShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, BottomFlangeWidth, OverallDepth, WebThickness, BottomFlangeThickness, BottomFlangeFilletRadius, TopFlangeWidth, TopFlangeThickness, TopFlangeFilletRadius, BottomFlangeEdgeRadius, BottomFlangeSlope, TopFlangeEdgeRadius, TopFlangeSlope) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.BottomFlangeWidth = BottomFlangeWidth;
      this.OverallDepth = OverallDepth;
      this.WebThickness = WebThickness;
      this.BottomFlangeThickness = BottomFlangeThickness;
      this.BottomFlangeFilletRadius = BottomFlangeFilletRadius;
      this.TopFlangeWidth = TopFlangeWidth;
      this.TopFlangeThickness = TopFlangeThickness;
      this.TopFlangeFilletRadius = TopFlangeFilletRadius;
      this.BottomFlangeEdgeRadius = BottomFlangeEdgeRadius;
      this.BottomFlangeSlope = BottomFlangeSlope;
      this.TopFlangeEdgeRadius = TopFlangeEdgeRadius;
      this.TopFlangeSlope = TopFlangeSlope;
      this.type = 3207858831;
    }
  }
  IFC42.IfcAsymmetricIShapeProfileDef = IfcAsymmetricIShapeProfileDef;
  class IfcAxis1Placement extends IfcPlacement {
    constructor(expressID, Location, Axis) {
      super(expressID, Location);
      this.Location = Location;
      this.Axis = Axis;
      this.type = 4261334040;
    }
  }
  IFC42.IfcAxis1Placement = IfcAxis1Placement;
  class IfcAxis2Placement2D extends IfcPlacement {
    constructor(expressID, Location, RefDirection) {
      super(expressID, Location);
      this.Location = Location;
      this.RefDirection = RefDirection;
      this.type = 3125803723;
    }
  }
  IFC42.IfcAxis2Placement2D = IfcAxis2Placement2D;
  class IfcAxis2Placement3D extends IfcPlacement {
    constructor(expressID, Location, Axis, RefDirection) {
      super(expressID, Location);
      this.Location = Location;
      this.Axis = Axis;
      this.RefDirection = RefDirection;
      this.type = 2740243338;
    }
  }
  IFC42.IfcAxis2Placement3D = IfcAxis2Placement3D;
  class IfcBooleanResult extends IfcGeometricRepresentationItem {
    constructor(expressID, Operator, FirstOperand, SecondOperand) {
      super(expressID);
      this.Operator = Operator;
      this.FirstOperand = FirstOperand;
      this.SecondOperand = SecondOperand;
      this.type = 2736907675;
    }
  }
  IFC42.IfcBooleanResult = IfcBooleanResult;
  class IfcBoundedSurface extends IfcSurface {
    constructor(expressID) {
      super(expressID);
      this.type = 4182860854;
    }
  }
  IFC42.IfcBoundedSurface = IfcBoundedSurface;
  class IfcBoundingBox extends IfcGeometricRepresentationItem {
    constructor(expressID, Corner, XDim, YDim, ZDim) {
      super(expressID);
      this.Corner = Corner;
      this.XDim = XDim;
      this.YDim = YDim;
      this.ZDim = ZDim;
      this.type = 2581212453;
    }
  }
  IFC42.IfcBoundingBox = IfcBoundingBox;
  class IfcBoxedHalfSpace extends IfcHalfSpaceSolid {
    constructor(expressID, BaseSurface, AgreementFlag, Enclosure) {
      super(expressID, BaseSurface, AgreementFlag);
      this.BaseSurface = BaseSurface;
      this.AgreementFlag = AgreementFlag;
      this.Enclosure = Enclosure;
      this.type = 2713105998;
    }
  }
  IFC42.IfcBoxedHalfSpace = IfcBoxedHalfSpace;
  class IfcCShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Depth, Width, WallThickness, Girth, InternalFilletRadius) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.Width = Width;
      this.WallThickness = WallThickness;
      this.Girth = Girth;
      this.InternalFilletRadius = InternalFilletRadius;
      this.type = 2898889636;
    }
  }
  IFC42.IfcCShapeProfileDef = IfcCShapeProfileDef;
  class IfcCartesianPoint extends IfcPoint {
    constructor(expressID, Coordinates) {
      super(expressID);
      this.Coordinates = Coordinates;
      this.type = 1123145078;
    }
  }
  IFC42.IfcCartesianPoint = IfcCartesianPoint;
  class IfcCartesianPointList extends IfcGeometricRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 574549367;
    }
  }
  IFC42.IfcCartesianPointList = IfcCartesianPointList;
  class IfcCartesianPointList2D extends IfcCartesianPointList {
    constructor(expressID, CoordList) {
      super(expressID);
      this.CoordList = CoordList;
      this.type = 1675464909;
    }
  }
  IFC42.IfcCartesianPointList2D = IfcCartesianPointList2D;
  class IfcCartesianPointList3D extends IfcCartesianPointList {
    constructor(expressID, CoordList) {
      super(expressID);
      this.CoordList = CoordList;
      this.type = 2059837836;
    }
  }
  IFC42.IfcCartesianPointList3D = IfcCartesianPointList3D;
  class IfcCartesianTransformationOperator extends IfcGeometricRepresentationItem {
    constructor(expressID, Axis1, Axis2, LocalOrigin, Scale) {
      super(expressID);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.type = 59481748;
    }
  }
  IFC42.IfcCartesianTransformationOperator = IfcCartesianTransformationOperator;
  class IfcCartesianTransformationOperator2D extends IfcCartesianTransformationOperator {
    constructor(expressID, Axis1, Axis2, LocalOrigin, Scale) {
      super(expressID, Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.type = 3749851601;
    }
  }
  IFC42.IfcCartesianTransformationOperator2D = IfcCartesianTransformationOperator2D;
  class IfcCartesianTransformationOperator2DnonUniform extends IfcCartesianTransformationOperator2D {
    constructor(expressID, Axis1, Axis2, LocalOrigin, Scale, Scale2) {
      super(expressID, Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Scale2 = Scale2;
      this.type = 3486308946;
    }
  }
  IFC42.IfcCartesianTransformationOperator2DnonUniform = IfcCartesianTransformationOperator2DnonUniform;
  class IfcCartesianTransformationOperator3D extends IfcCartesianTransformationOperator {
    constructor(expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3) {
      super(expressID, Axis1, Axis2, LocalOrigin, Scale);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Axis3 = Axis3;
      this.type = 3331915920;
    }
  }
  IFC42.IfcCartesianTransformationOperator3D = IfcCartesianTransformationOperator3D;
  class IfcCartesianTransformationOperator3DnonUniform extends IfcCartesianTransformationOperator3D {
    constructor(expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3, Scale2, Scale3) {
      super(expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3);
      this.Axis1 = Axis1;
      this.Axis2 = Axis2;
      this.LocalOrigin = LocalOrigin;
      this.Scale = Scale;
      this.Axis3 = Axis3;
      this.Scale2 = Scale2;
      this.Scale3 = Scale3;
      this.type = 1416205885;
    }
  }
  IFC42.IfcCartesianTransformationOperator3DnonUniform = IfcCartesianTransformationOperator3DnonUniform;
  class IfcCircleProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Radius) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Radius = Radius;
      this.type = 1383045692;
    }
  }
  IFC42.IfcCircleProfileDef = IfcCircleProfileDef;
  class IfcClosedShell extends IfcConnectedFaceSet {
    constructor(expressID, CfsFaces) {
      super(expressID, CfsFaces);
      this.CfsFaces = CfsFaces;
      this.type = 2205249479;
    }
  }
  IFC42.IfcClosedShell = IfcClosedShell;
  class IfcColourRgb extends IfcColourSpecification {
    constructor(expressID, Name, Red, Green, Blue) {
      super(expressID, Name);
      this.Name = Name;
      this.Red = Red;
      this.Green = Green;
      this.Blue = Blue;
      this.type = 776857604;
    }
  }
  IFC42.IfcColourRgb = IfcColourRgb;
  class IfcComplexProperty extends IfcProperty {
    constructor(expressID, Name, Description, UsageName, HasProperties) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.UsageName = UsageName;
      this.HasProperties = HasProperties;
      this.type = 2542286263;
    }
  }
  IFC42.IfcComplexProperty = IfcComplexProperty;
  class IfcCompositeCurveSegment extends IfcGeometricRepresentationItem {
    constructor(expressID, Transition, SameSense, ParentCurve) {
      super(expressID);
      this.Transition = Transition;
      this.SameSense = SameSense;
      this.ParentCurve = ParentCurve;
      this.type = 2485617015;
    }
  }
  IFC42.IfcCompositeCurveSegment = IfcCompositeCurveSegment;
  class IfcConstructionResourceType extends IfcTypeResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.type = 2574617495;
    }
  }
  IFC42.IfcConstructionResourceType = IfcConstructionResourceType;
  class IfcContext extends IfcObjectDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.Phase = Phase;
      this.RepresentationContexts = RepresentationContexts;
      this.UnitsInContext = UnitsInContext;
      this.type = 3419103109;
    }
  }
  IFC42.IfcContext = IfcContext;
  class IfcCrewResourceType extends IfcConstructionResourceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 1815067380;
    }
  }
  IFC42.IfcCrewResourceType = IfcCrewResourceType;
  class IfcCsgPrimitive3D extends IfcGeometricRepresentationItem {
    constructor(expressID, Position) {
      super(expressID);
      this.Position = Position;
      this.type = 2506170314;
    }
  }
  IFC42.IfcCsgPrimitive3D = IfcCsgPrimitive3D;
  class IfcCsgSolid extends IfcSolidModel {
    constructor(expressID, TreeRootExpression) {
      super(expressID);
      this.TreeRootExpression = TreeRootExpression;
      this.type = 2147822146;
    }
  }
  IFC42.IfcCsgSolid = IfcCsgSolid;
  class IfcCurve extends IfcGeometricRepresentationItem {
    constructor(expressID) {
      super(expressID);
      this.type = 2601014836;
    }
  }
  IFC42.IfcCurve = IfcCurve;
  class IfcCurveBoundedPlane extends IfcBoundedSurface {
    constructor(expressID, BasisSurface, OuterBoundary, InnerBoundaries) {
      super(expressID);
      this.BasisSurface = BasisSurface;
      this.OuterBoundary = OuterBoundary;
      this.InnerBoundaries = InnerBoundaries;
      this.type = 2827736869;
    }
  }
  IFC42.IfcCurveBoundedPlane = IfcCurveBoundedPlane;
  class IfcCurveBoundedSurface extends IfcBoundedSurface {
    constructor(expressID, BasisSurface, Boundaries, ImplicitOuter) {
      super(expressID);
      this.BasisSurface = BasisSurface;
      this.Boundaries = Boundaries;
      this.ImplicitOuter = ImplicitOuter;
      this.type = 2629017746;
    }
  }
  IFC42.IfcCurveBoundedSurface = IfcCurveBoundedSurface;
  class IfcDirection extends IfcGeometricRepresentationItem {
    constructor(expressID, DirectionRatios) {
      super(expressID);
      this.DirectionRatios = DirectionRatios;
      this.type = 32440307;
    }
  }
  IFC42.IfcDirection = IfcDirection;
  class IfcDoorStyle extends IfcTypeProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, OperationType, ConstructionType, ParameterTakesPrecedence, Sizeable) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.OperationType = OperationType;
      this.ConstructionType = ConstructionType;
      this.ParameterTakesPrecedence = ParameterTakesPrecedence;
      this.Sizeable = Sizeable;
      this.type = 526551008;
    }
  }
  IFC42.IfcDoorStyle = IfcDoorStyle;
  class IfcEdgeLoop extends IfcLoop {
    constructor(expressID, EdgeList) {
      super(expressID);
      this.EdgeList = EdgeList;
      this.type = 1472233963;
    }
  }
  IFC42.IfcEdgeLoop = IfcEdgeLoop;
  class IfcElementQuantity extends IfcQuantitySet {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, MethodOfMeasurement, Quantities) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.MethodOfMeasurement = MethodOfMeasurement;
      this.Quantities = Quantities;
      this.type = 1883228015;
    }
  }
  IFC42.IfcElementQuantity = IfcElementQuantity;
  class IfcElementType extends IfcTypeProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 339256511;
    }
  }
  IFC42.IfcElementType = IfcElementType;
  class IfcElementarySurface extends IfcSurface {
    constructor(expressID, Position) {
      super(expressID);
      this.Position = Position;
      this.type = 2777663545;
    }
  }
  IFC42.IfcElementarySurface = IfcElementarySurface;
  class IfcEllipseProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, SemiAxis1, SemiAxis2) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.SemiAxis1 = SemiAxis1;
      this.SemiAxis2 = SemiAxis2;
      this.type = 2835456948;
    }
  }
  IFC42.IfcEllipseProfileDef = IfcEllipseProfileDef;
  class IfcEventType extends IfcTypeProcess {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType, EventTriggerType, UserDefinedEventTriggerType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ProcessType = ProcessType;
      this.PredefinedType = PredefinedType;
      this.EventTriggerType = EventTriggerType;
      this.UserDefinedEventTriggerType = UserDefinedEventTriggerType;
      this.type = 4024345920;
    }
  }
  IFC42.IfcEventType = IfcEventType;
  class IfcExtrudedAreaSolid extends IfcSweptAreaSolid {
    constructor(expressID, SweptArea, Position, ExtrudedDirection, Depth) {
      super(expressID, SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.ExtrudedDirection = ExtrudedDirection;
      this.Depth = Depth;
      this.type = 477187591;
    }
  }
  IFC42.IfcExtrudedAreaSolid = IfcExtrudedAreaSolid;
  class IfcExtrudedAreaSolidTapered extends IfcExtrudedAreaSolid {
    constructor(expressID, SweptArea, Position, ExtrudedDirection, Depth, EndSweptArea) {
      super(expressID, SweptArea, Position, ExtrudedDirection, Depth);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.ExtrudedDirection = ExtrudedDirection;
      this.Depth = Depth;
      this.EndSweptArea = EndSweptArea;
      this.type = 2804161546;
    }
  }
  IFC42.IfcExtrudedAreaSolidTapered = IfcExtrudedAreaSolidTapered;
  class IfcFaceBasedSurfaceModel extends IfcGeometricRepresentationItem {
    constructor(expressID, FbsmFaces) {
      super(expressID);
      this.FbsmFaces = FbsmFaces;
      this.type = 2047409740;
    }
  }
  IFC42.IfcFaceBasedSurfaceModel = IfcFaceBasedSurfaceModel;
  class IfcFillAreaStyleHatching extends IfcGeometricRepresentationItem {
    constructor(expressID, HatchLineAppearance, StartOfNextHatchLine, PointOfReferenceHatchLine, PatternStart, HatchLineAngle) {
      super(expressID);
      this.HatchLineAppearance = HatchLineAppearance;
      this.StartOfNextHatchLine = StartOfNextHatchLine;
      this.PointOfReferenceHatchLine = PointOfReferenceHatchLine;
      this.PatternStart = PatternStart;
      this.HatchLineAngle = HatchLineAngle;
      this.type = 374418227;
    }
  }
  IFC42.IfcFillAreaStyleHatching = IfcFillAreaStyleHatching;
  class IfcFillAreaStyleTiles extends IfcGeometricRepresentationItem {
    constructor(expressID, TilingPattern, Tiles, TilingScale) {
      super(expressID);
      this.TilingPattern = TilingPattern;
      this.Tiles = Tiles;
      this.TilingScale = TilingScale;
      this.type = 315944413;
    }
  }
  IFC42.IfcFillAreaStyleTiles = IfcFillAreaStyleTiles;
  class IfcFixedReferenceSweptAreaSolid extends IfcSweptAreaSolid {
    constructor(expressID, SweptArea, Position, Directrix, StartParam, EndParam, FixedReference) {
      super(expressID, SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Directrix = Directrix;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.FixedReference = FixedReference;
      this.type = 2652556860;
    }
  }
  IFC42.IfcFixedReferenceSweptAreaSolid = IfcFixedReferenceSweptAreaSolid;
  class IfcFurnishingElementType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 4238390223;
    }
  }
  IFC42.IfcFurnishingElementType = IfcFurnishingElementType;
  class IfcFurnitureType extends IfcFurnishingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, AssemblyPlace, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.AssemblyPlace = AssemblyPlace;
      this.PredefinedType = PredefinedType;
      this.type = 1268542332;
    }
  }
  IFC42.IfcFurnitureType = IfcFurnitureType;
  class IfcGeographicElementType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4095422895;
    }
  }
  IFC42.IfcGeographicElementType = IfcGeographicElementType;
  class IfcGeometricCurveSet extends IfcGeometricSet {
    constructor(expressID, Elements) {
      super(expressID, Elements);
      this.Elements = Elements;
      this.type = 987898635;
    }
  }
  IFC42.IfcGeometricCurveSet = IfcGeometricCurveSet;
  class IfcIShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, FlangeSlope) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.OverallWidth = OverallWidth;
      this.OverallDepth = OverallDepth;
      this.WebThickness = WebThickness;
      this.FlangeThickness = FlangeThickness;
      this.FilletRadius = FilletRadius;
      this.FlangeEdgeRadius = FlangeEdgeRadius;
      this.FlangeSlope = FlangeSlope;
      this.type = 1484403080;
    }
  }
  IFC42.IfcIShapeProfileDef = IfcIShapeProfileDef;
  class IfcIndexedPolygonalFace extends IfcTessellatedItem {
    constructor(expressID, CoordIndex) {
      super(expressID);
      this.CoordIndex = CoordIndex;
      this.type = 178912537;
    }
  }
  IFC42.IfcIndexedPolygonalFace = IfcIndexedPolygonalFace;
  class IfcIndexedPolygonalFaceWithVoids extends IfcIndexedPolygonalFace {
    constructor(expressID, CoordIndex, InnerCoordIndices) {
      super(expressID, CoordIndex);
      this.CoordIndex = CoordIndex;
      this.InnerCoordIndices = InnerCoordIndices;
      this.type = 2294589976;
    }
  }
  IFC42.IfcIndexedPolygonalFaceWithVoids = IfcIndexedPolygonalFaceWithVoids;
  class IfcLShapeProfileDef extends IfcParameterizedProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Depth, Width, Thickness, FilletRadius, EdgeRadius, LegSlope) {
      super(expressID, ProfileType, ProfileName, Position);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Depth = Depth;
      this.Width = Width;
      this.Thickness = Thickness;
      this.FilletRadius = FilletRadius;
      this.EdgeRadius = EdgeRadius;
      this.LegSlope = LegSlope;
      this.type = 572779678;
    }
  }
  IFC42.IfcLShapeProfileDef = IfcLShapeProfileDef;
  class IfcLaborResourceType extends IfcConstructionResourceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 428585644;
    }
  }
  IFC42.IfcLaborResourceType = IfcLaborResourceType;
  class IfcLine extends IfcCurve {
    constructor(expressID, Pnt, Dir) {
      super(expressID);
      this.Pnt = Pnt;
      this.Dir = Dir;
      this.type = 1281925730;
    }
  }
  IFC42.IfcLine = IfcLine;
  class IfcManifoldSolidBrep extends IfcSolidModel {
    constructor(expressID, Outer) {
      super(expressID);
      this.Outer = Outer;
      this.type = 1425443689;
    }
  }
  IFC42.IfcManifoldSolidBrep = IfcManifoldSolidBrep;
  class IfcObject extends IfcObjectDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 3888040117;
    }
  }
  IFC42.IfcObject = IfcObject;
  class IfcOffsetCurve2D extends IfcCurve {
    constructor(expressID, BasisCurve, Distance, SelfIntersect) {
      super(expressID);
      this.BasisCurve = BasisCurve;
      this.Distance = Distance;
      this.SelfIntersect = SelfIntersect;
      this.type = 3388369263;
    }
  }
  IFC42.IfcOffsetCurve2D = IfcOffsetCurve2D;
  class IfcOffsetCurve3D extends IfcCurve {
    constructor(expressID, BasisCurve, Distance, SelfIntersect, RefDirection) {
      super(expressID);
      this.BasisCurve = BasisCurve;
      this.Distance = Distance;
      this.SelfIntersect = SelfIntersect;
      this.RefDirection = RefDirection;
      this.type = 3505215534;
    }
  }
  IFC42.IfcOffsetCurve3D = IfcOffsetCurve3D;
  class IfcPcurve extends IfcCurve {
    constructor(expressID, BasisSurface, ReferenceCurve) {
      super(expressID);
      this.BasisSurface = BasisSurface;
      this.ReferenceCurve = ReferenceCurve;
      this.type = 1682466193;
    }
  }
  IFC42.IfcPcurve = IfcPcurve;
  class IfcPlanarBox extends IfcPlanarExtent {
    constructor(expressID, SizeInX, SizeInY, Placement) {
      super(expressID, SizeInX, SizeInY);
      this.SizeInX = SizeInX;
      this.SizeInY = SizeInY;
      this.Placement = Placement;
      this.type = 603570806;
    }
  }
  IFC42.IfcPlanarBox = IfcPlanarBox;
  class IfcPlane extends IfcElementarySurface {
    constructor(expressID, Position) {
      super(expressID, Position);
      this.Position = Position;
      this.type = 220341763;
    }
  }
  IFC42.IfcPlane = IfcPlane;
  class IfcPreDefinedColour extends IfcPreDefinedItem {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 759155922;
    }
  }
  IFC42.IfcPreDefinedColour = IfcPreDefinedColour;
  class IfcPreDefinedCurveFont extends IfcPreDefinedItem {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 2559016684;
    }
  }
  IFC42.IfcPreDefinedCurveFont = IfcPreDefinedCurveFont;
  class IfcPreDefinedPropertySet extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 3967405729;
    }
  }
  IFC42.IfcPreDefinedPropertySet = IfcPreDefinedPropertySet;
  class IfcProcedureType extends IfcTypeProcess {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ProcessType = ProcessType;
      this.PredefinedType = PredefinedType;
      this.type = 569719735;
    }
  }
  IFC42.IfcProcedureType = IfcProcedureType;
  class IfcProcess extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.type = 2945172077;
    }
  }
  IFC42.IfcProcess = IfcProcess;
  class IfcProduct extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 4208778838;
    }
  }
  IFC42.IfcProduct = IfcProduct;
  class IfcProject extends IfcContext {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.Phase = Phase;
      this.RepresentationContexts = RepresentationContexts;
      this.UnitsInContext = UnitsInContext;
      this.type = 103090709;
    }
  }
  IFC42.IfcProject = IfcProject;
  class IfcProjectLibrary extends IfcContext {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.Phase = Phase;
      this.RepresentationContexts = RepresentationContexts;
      this.UnitsInContext = UnitsInContext;
      this.type = 653396225;
    }
  }
  IFC42.IfcProjectLibrary = IfcProjectLibrary;
  class IfcPropertyBoundedValue extends IfcSimpleProperty {
    constructor(expressID, Name, Description, UpperBoundValue, LowerBoundValue, Unit, SetPointValue) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.UpperBoundValue = UpperBoundValue;
      this.LowerBoundValue = LowerBoundValue;
      this.Unit = Unit;
      this.SetPointValue = SetPointValue;
      this.type = 871118103;
    }
  }
  IFC42.IfcPropertyBoundedValue = IfcPropertyBoundedValue;
  class IfcPropertyEnumeratedValue extends IfcSimpleProperty {
    constructor(expressID, Name, Description, EnumerationValues, EnumerationReference) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.EnumerationValues = EnumerationValues;
      this.EnumerationReference = EnumerationReference;
      this.type = 4166981789;
    }
  }
  IFC42.IfcPropertyEnumeratedValue = IfcPropertyEnumeratedValue;
  class IfcPropertyListValue extends IfcSimpleProperty {
    constructor(expressID, Name, Description, ListValues, Unit) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.ListValues = ListValues;
      this.Unit = Unit;
      this.type = 2752243245;
    }
  }
  IFC42.IfcPropertyListValue = IfcPropertyListValue;
  class IfcPropertyReferenceValue extends IfcSimpleProperty {
    constructor(expressID, Name, Description, UsageName, PropertyReference) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.UsageName = UsageName;
      this.PropertyReference = PropertyReference;
      this.type = 941946838;
    }
  }
  IFC42.IfcPropertyReferenceValue = IfcPropertyReferenceValue;
  class IfcPropertySet extends IfcPropertySetDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, HasProperties) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.HasProperties = HasProperties;
      this.type = 1451395588;
    }
  }
  IFC42.IfcPropertySet = IfcPropertySet;
  class IfcPropertySetTemplate extends IfcPropertyTemplateDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, TemplateType, ApplicableEntity, HasPropertyTemplates) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.TemplateType = TemplateType;
      this.ApplicableEntity = ApplicableEntity;
      this.HasPropertyTemplates = HasPropertyTemplates;
      this.type = 492091185;
    }
  }
  IFC42.IfcPropertySetTemplate = IfcPropertySetTemplate;
  class IfcPropertySingleValue extends IfcSimpleProperty {
    constructor(expressID, Name, Description, NominalValue, Unit) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.NominalValue = NominalValue;
      this.Unit = Unit;
      this.type = 3650150729;
    }
  }
  IFC42.IfcPropertySingleValue = IfcPropertySingleValue;
  class IfcPropertyTableValue extends IfcSimpleProperty {
    constructor(expressID, Name, Description, DefiningValues, DefinedValues, Expression, DefiningUnit, DefinedUnit, CurveInterpolation) {
      super(expressID, Name, Description);
      this.Name = Name;
      this.Description = Description;
      this.DefiningValues = DefiningValues;
      this.DefinedValues = DefinedValues;
      this.Expression = Expression;
      this.DefiningUnit = DefiningUnit;
      this.DefinedUnit = DefinedUnit;
      this.CurveInterpolation = CurveInterpolation;
      this.type = 110355661;
    }
  }
  IFC42.IfcPropertyTableValue = IfcPropertyTableValue;
  class IfcPropertyTemplate extends IfcPropertyTemplateDefinition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 3521284610;
    }
  }
  IFC42.IfcPropertyTemplate = IfcPropertyTemplate;
  class IfcProxy extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, ProxyType, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.ProxyType = ProxyType;
      this.Tag = Tag;
      this.type = 3219374653;
    }
  }
  IFC42.IfcProxy = IfcProxy;
  class IfcRectangleHollowProfileDef extends IfcRectangleProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, XDim, YDim, WallThickness, InnerFilletRadius, OuterFilletRadius) {
      super(expressID, ProfileType, ProfileName, Position, XDim, YDim);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.XDim = XDim;
      this.YDim = YDim;
      this.WallThickness = WallThickness;
      this.InnerFilletRadius = InnerFilletRadius;
      this.OuterFilletRadius = OuterFilletRadius;
      this.type = 2770003689;
    }
  }
  IFC42.IfcRectangleHollowProfileDef = IfcRectangleHollowProfileDef;
  class IfcRectangularPyramid extends IfcCsgPrimitive3D {
    constructor(expressID, Position, XLength, YLength, Height) {
      super(expressID, Position);
      this.Position = Position;
      this.XLength = XLength;
      this.YLength = YLength;
      this.Height = Height;
      this.type = 2798486643;
    }
  }
  IFC42.IfcRectangularPyramid = IfcRectangularPyramid;
  class IfcRectangularTrimmedSurface extends IfcBoundedSurface {
    constructor(expressID, BasisSurface, U1, V1, U2, V2, Usense, Vsense) {
      super(expressID);
      this.BasisSurface = BasisSurface;
      this.U1 = U1;
      this.V1 = V1;
      this.U2 = U2;
      this.V2 = V2;
      this.Usense = Usense;
      this.Vsense = Vsense;
      this.type = 3454111270;
    }
  }
  IFC42.IfcRectangularTrimmedSurface = IfcRectangularTrimmedSurface;
  class IfcReinforcementDefinitionProperties extends IfcPreDefinedPropertySet {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, DefinitionType, ReinforcementSectionDefinitions) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.DefinitionType = DefinitionType;
      this.ReinforcementSectionDefinitions = ReinforcementSectionDefinitions;
      this.type = 3765753017;
    }
  }
  IFC42.IfcReinforcementDefinitionProperties = IfcReinforcementDefinitionProperties;
  class IfcRelAssigns extends IfcRelationship {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.type = 3939117080;
    }
  }
  IFC42.IfcRelAssigns = IfcRelAssigns;
  class IfcRelAssignsToActor extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingActor = RelatingActor;
      this.ActingRole = ActingRole;
      this.type = 1683148259;
    }
  }
  IFC42.IfcRelAssignsToActor = IfcRelAssignsToActor;
  class IfcRelAssignsToControl extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingControl = RelatingControl;
      this.type = 2495723537;
    }
  }
  IFC42.IfcRelAssignsToControl = IfcRelAssignsToControl;
  class IfcRelAssignsToGroup extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingGroup = RelatingGroup;
      this.type = 1307041759;
    }
  }
  IFC42.IfcRelAssignsToGroup = IfcRelAssignsToGroup;
  class IfcRelAssignsToGroupByFactor extends IfcRelAssignsToGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup, Factor) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingGroup = RelatingGroup;
      this.Factor = Factor;
      this.type = 1027710054;
    }
  }
  IFC42.IfcRelAssignsToGroupByFactor = IfcRelAssignsToGroupByFactor;
  class IfcRelAssignsToProcess extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProcess, QuantityInProcess) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingProcess = RelatingProcess;
      this.QuantityInProcess = QuantityInProcess;
      this.type = 4278684876;
    }
  }
  IFC42.IfcRelAssignsToProcess = IfcRelAssignsToProcess;
  class IfcRelAssignsToProduct extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProduct) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingProduct = RelatingProduct;
      this.type = 2857406711;
    }
  }
  IFC42.IfcRelAssignsToProduct = IfcRelAssignsToProduct;
  class IfcRelAssignsToResource extends IfcRelAssigns {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingResource) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatedObjectsType = RelatedObjectsType;
      this.RelatingResource = RelatingResource;
      this.type = 205026976;
    }
  }
  IFC42.IfcRelAssignsToResource = IfcRelAssignsToResource;
  class IfcRelAssociates extends IfcRelationship {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.type = 1865459582;
    }
  }
  IFC42.IfcRelAssociates = IfcRelAssociates;
  class IfcRelAssociatesApproval extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingApproval) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingApproval = RelatingApproval;
      this.type = 4095574036;
    }
  }
  IFC42.IfcRelAssociatesApproval = IfcRelAssociatesApproval;
  class IfcRelAssociatesClassification extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingClassification) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingClassification = RelatingClassification;
      this.type = 919958153;
    }
  }
  IFC42.IfcRelAssociatesClassification = IfcRelAssociatesClassification;
  class IfcRelAssociatesConstraint extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, Intent, RelatingConstraint) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.Intent = Intent;
      this.RelatingConstraint = RelatingConstraint;
      this.type = 2728634034;
    }
  }
  IFC42.IfcRelAssociatesConstraint = IfcRelAssociatesConstraint;
  class IfcRelAssociatesDocument extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingDocument) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingDocument = RelatingDocument;
      this.type = 982818633;
    }
  }
  IFC42.IfcRelAssociatesDocument = IfcRelAssociatesDocument;
  class IfcRelAssociatesLibrary extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingLibrary) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingLibrary = RelatingLibrary;
      this.type = 3840914261;
    }
  }
  IFC42.IfcRelAssociatesLibrary = IfcRelAssociatesLibrary;
  class IfcRelAssociatesMaterial extends IfcRelAssociates {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingMaterial) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingMaterial = RelatingMaterial;
      this.type = 2655215786;
    }
  }
  IFC42.IfcRelAssociatesMaterial = IfcRelAssociatesMaterial;
  class IfcRelConnects extends IfcRelationship {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 826625072;
    }
  }
  IFC42.IfcRelConnects = IfcRelConnects;
  class IfcRelConnectsElements extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.type = 1204542856;
    }
  }
  IFC42.IfcRelConnectsElements = IfcRelConnectsElements;
  class IfcRelConnectsPathElements extends IfcRelConnectsElements {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RelatingPriorities, RelatedPriorities, RelatedConnectionType, RelatingConnectionType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.RelatingPriorities = RelatingPriorities;
      this.RelatedPriorities = RelatedPriorities;
      this.RelatedConnectionType = RelatedConnectionType;
      this.RelatingConnectionType = RelatingConnectionType;
      this.type = 3945020480;
    }
  }
  IFC42.IfcRelConnectsPathElements = IfcRelConnectsPathElements;
  class IfcRelConnectsPortToElement extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingPort = RelatingPort;
      this.RelatedElement = RelatedElement;
      this.type = 4201705270;
    }
  }
  IFC42.IfcRelConnectsPortToElement = IfcRelConnectsPortToElement;
  class IfcRelConnectsPorts extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedPort, RealizingElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingPort = RelatingPort;
      this.RelatedPort = RelatedPort;
      this.RealizingElement = RealizingElement;
      this.type = 3190031847;
    }
  }
  IFC42.IfcRelConnectsPorts = IfcRelConnectsPorts;
  class IfcRelConnectsStructuralActivity extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedStructuralActivity) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedStructuralActivity = RelatedStructuralActivity;
      this.type = 2127690289;
    }
  }
  IFC42.IfcRelConnectsStructuralActivity = IfcRelConnectsStructuralActivity;
  class IfcRelConnectsStructuralMember extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingStructuralMember = RelatingStructuralMember;
      this.RelatedStructuralConnection = RelatedStructuralConnection;
      this.AppliedCondition = AppliedCondition;
      this.AdditionalConditions = AdditionalConditions;
      this.SupportedLength = SupportedLength;
      this.ConditionCoordinateSystem = ConditionCoordinateSystem;
      this.type = 1638771189;
    }
  }
  IFC42.IfcRelConnectsStructuralMember = IfcRelConnectsStructuralMember;
  class IfcRelConnectsWithEccentricity extends IfcRelConnectsStructuralMember {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem, ConnectionConstraint) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingStructuralMember = RelatingStructuralMember;
      this.RelatedStructuralConnection = RelatedStructuralConnection;
      this.AppliedCondition = AppliedCondition;
      this.AdditionalConditions = AdditionalConditions;
      this.SupportedLength = SupportedLength;
      this.ConditionCoordinateSystem = ConditionCoordinateSystem;
      this.ConnectionConstraint = ConnectionConstraint;
      this.type = 504942748;
    }
  }
  IFC42.IfcRelConnectsWithEccentricity = IfcRelConnectsWithEccentricity;
  class IfcRelConnectsWithRealizingElements extends IfcRelConnectsElements {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RealizingElements, ConnectionType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ConnectionGeometry = ConnectionGeometry;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.RealizingElements = RealizingElements;
      this.ConnectionType = ConnectionType;
      this.type = 3678494232;
    }
  }
  IFC42.IfcRelConnectsWithRealizingElements = IfcRelConnectsWithRealizingElements;
  class IfcRelContainedInSpatialStructure extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedElements = RelatedElements;
      this.RelatingStructure = RelatingStructure;
      this.type = 3242617779;
    }
  }
  IFC42.IfcRelContainedInSpatialStructure = IfcRelContainedInSpatialStructure;
  class IfcRelCoversBldgElements extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedCoverings) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingBuildingElement = RelatingBuildingElement;
      this.RelatedCoverings = RelatedCoverings;
      this.type = 886880790;
    }
  }
  IFC42.IfcRelCoversBldgElements = IfcRelCoversBldgElements;
  class IfcRelCoversSpaces extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedCoverings) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedCoverings = RelatedCoverings;
      this.type = 2802773753;
    }
  }
  IFC42.IfcRelCoversSpaces = IfcRelCoversSpaces;
  class IfcRelDeclares extends IfcRelationship {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingContext, RelatedDefinitions) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingContext = RelatingContext;
      this.RelatedDefinitions = RelatedDefinitions;
      this.type = 2565941209;
    }
  }
  IFC42.IfcRelDeclares = IfcRelDeclares;
  class IfcRelDecomposes extends IfcRelationship {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 2551354335;
    }
  }
  IFC42.IfcRelDecomposes = IfcRelDecomposes;
  class IfcRelDefines extends IfcRelationship {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.type = 693640335;
    }
  }
  IFC42.IfcRelDefines = IfcRelDefines;
  class IfcRelDefinesByObject extends IfcRelDefines {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingObject) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingObject = RelatingObject;
      this.type = 1462361463;
    }
  }
  IFC42.IfcRelDefinesByObject = IfcRelDefinesByObject;
  class IfcRelDefinesByProperties extends IfcRelDefines {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingPropertyDefinition = RelatingPropertyDefinition;
      this.type = 4186316022;
    }
  }
  IFC42.IfcRelDefinesByProperties = IfcRelDefinesByProperties;
  class IfcRelDefinesByTemplate extends IfcRelDefines {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedPropertySets, RelatingTemplate) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedPropertySets = RelatedPropertySets;
      this.RelatingTemplate = RelatingTemplate;
      this.type = 307848117;
    }
  }
  IFC42.IfcRelDefinesByTemplate = IfcRelDefinesByTemplate;
  class IfcRelDefinesByType extends IfcRelDefines {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedObjects = RelatedObjects;
      this.RelatingType = RelatingType;
      this.type = 781010003;
    }
  }
  IFC42.IfcRelDefinesByType = IfcRelDefinesByType;
  class IfcRelFillsElement extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingOpeningElement, RelatedBuildingElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingOpeningElement = RelatingOpeningElement;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.type = 3940055652;
    }
  }
  IFC42.IfcRelFillsElement = IfcRelFillsElement;
  class IfcRelFlowControlElements extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedControlElements, RelatingFlowElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedControlElements = RelatedControlElements;
      this.RelatingFlowElement = RelatingFlowElement;
      this.type = 279856033;
    }
  }
  IFC42.IfcRelFlowControlElements = IfcRelFlowControlElements;
  class IfcRelInterferesElements extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedElement, InterferenceGeometry, InterferenceType, ImpliedOrder) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedElement = RelatedElement;
      this.InterferenceGeometry = InterferenceGeometry;
      this.InterferenceType = InterferenceType;
      this.ImpliedOrder = ImpliedOrder;
      this.type = 427948657;
    }
  }
  IFC42.IfcRelInterferesElements = IfcRelInterferesElements;
  class IfcRelNests extends IfcRelDecomposes {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingObject = RelatingObject;
      this.RelatedObjects = RelatedObjects;
      this.type = 3268803585;
    }
  }
  IFC42.IfcRelNests = IfcRelNests;
  class IfcRelProjectsElement extends IfcRelDecomposes {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedFeatureElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingElement = RelatingElement;
      this.RelatedFeatureElement = RelatedFeatureElement;
      this.type = 750771296;
    }
  }
  IFC42.IfcRelProjectsElement = IfcRelProjectsElement;
  class IfcRelReferencedInSpatialStructure extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatedElements = RelatedElements;
      this.RelatingStructure = RelatingStructure;
      this.type = 1245217292;
    }
  }
  IFC42.IfcRelReferencedInSpatialStructure = IfcRelReferencedInSpatialStructure;
  class IfcRelSequence extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingProcess, RelatedProcess, TimeLag, SequenceType, UserDefinedSequenceType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingProcess = RelatingProcess;
      this.RelatedProcess = RelatedProcess;
      this.TimeLag = TimeLag;
      this.SequenceType = SequenceType;
      this.UserDefinedSequenceType = UserDefinedSequenceType;
      this.type = 4122056220;
    }
  }
  IFC42.IfcRelSequence = IfcRelSequence;
  class IfcRelServicesBuildings extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSystem, RelatedBuildings) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSystem = RelatingSystem;
      this.RelatedBuildings = RelatedBuildings;
      this.type = 366585022;
    }
  }
  IFC42.IfcRelServicesBuildings = IfcRelServicesBuildings;
  class IfcRelSpaceBoundary extends IfcRelConnects {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.ConnectionGeometry = ConnectionGeometry;
      this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      this.InternalOrExternalBoundary = InternalOrExternalBoundary;
      this.type = 3451746338;
    }
  }
  IFC42.IfcRelSpaceBoundary = IfcRelSpaceBoundary;
  class IfcRelSpaceBoundary1stLevel extends IfcRelSpaceBoundary {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.ConnectionGeometry = ConnectionGeometry;
      this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      this.InternalOrExternalBoundary = InternalOrExternalBoundary;
      this.ParentBoundary = ParentBoundary;
      this.type = 3523091289;
    }
  }
  IFC42.IfcRelSpaceBoundary1stLevel = IfcRelSpaceBoundary1stLevel;
  class IfcRelSpaceBoundary2ndLevel extends IfcRelSpaceBoundary1stLevel {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary, CorrespondingBoundary) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingSpace = RelatingSpace;
      this.RelatedBuildingElement = RelatedBuildingElement;
      this.ConnectionGeometry = ConnectionGeometry;
      this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      this.InternalOrExternalBoundary = InternalOrExternalBoundary;
      this.ParentBoundary = ParentBoundary;
      this.CorrespondingBoundary = CorrespondingBoundary;
      this.type = 1521410863;
    }
  }
  IFC42.IfcRelSpaceBoundary2ndLevel = IfcRelSpaceBoundary2ndLevel;
  class IfcRelVoidsElement extends IfcRelDecomposes {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedOpeningElement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingBuildingElement = RelatingBuildingElement;
      this.RelatedOpeningElement = RelatedOpeningElement;
      this.type = 1401173127;
    }
  }
  IFC42.IfcRelVoidsElement = IfcRelVoidsElement;
  class IfcReparametrisedCompositeCurveSegment extends IfcCompositeCurveSegment {
    constructor(expressID, Transition, SameSense, ParentCurve, ParamLength) {
      super(expressID, Transition, SameSense, ParentCurve);
      this.Transition = Transition;
      this.SameSense = SameSense;
      this.ParentCurve = ParentCurve;
      this.ParamLength = ParamLength;
      this.type = 816062949;
    }
  }
  IFC42.IfcReparametrisedCompositeCurveSegment = IfcReparametrisedCompositeCurveSegment;
  class IfcResource extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.type = 2914609552;
    }
  }
  IFC42.IfcResource = IfcResource;
  class IfcRevolvedAreaSolid extends IfcSweptAreaSolid {
    constructor(expressID, SweptArea, Position, Axis, Angle) {
      super(expressID, SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Axis = Axis;
      this.Angle = Angle;
      this.type = 1856042241;
    }
  }
  IFC42.IfcRevolvedAreaSolid = IfcRevolvedAreaSolid;
  class IfcRevolvedAreaSolidTapered extends IfcRevolvedAreaSolid {
    constructor(expressID, SweptArea, Position, Axis, Angle, EndSweptArea) {
      super(expressID, SweptArea, Position, Axis, Angle);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Axis = Axis;
      this.Angle = Angle;
      this.EndSweptArea = EndSweptArea;
      this.type = 3243963512;
    }
  }
  IFC42.IfcRevolvedAreaSolidTapered = IfcRevolvedAreaSolidTapered;
  class IfcRightCircularCone extends IfcCsgPrimitive3D {
    constructor(expressID, Position, Height, BottomRadius) {
      super(expressID, Position);
      this.Position = Position;
      this.Height = Height;
      this.BottomRadius = BottomRadius;
      this.type = 4158566097;
    }
  }
  IFC42.IfcRightCircularCone = IfcRightCircularCone;
  class IfcRightCircularCylinder extends IfcCsgPrimitive3D {
    constructor(expressID, Position, Height, Radius) {
      super(expressID, Position);
      this.Position = Position;
      this.Height = Height;
      this.Radius = Radius;
      this.type = 3626867408;
    }
  }
  IFC42.IfcRightCircularCylinder = IfcRightCircularCylinder;
  class IfcSimplePropertyTemplate extends IfcPropertyTemplate {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, TemplateType, PrimaryMeasureType, SecondaryMeasureType, Enumerators, PrimaryUnit, SecondaryUnit, Expression, AccessState) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.TemplateType = TemplateType;
      this.PrimaryMeasureType = PrimaryMeasureType;
      this.SecondaryMeasureType = SecondaryMeasureType;
      this.Enumerators = Enumerators;
      this.PrimaryUnit = PrimaryUnit;
      this.SecondaryUnit = SecondaryUnit;
      this.Expression = Expression;
      this.AccessState = AccessState;
      this.type = 3663146110;
    }
  }
  IFC42.IfcSimplePropertyTemplate = IfcSimplePropertyTemplate;
  class IfcSpatialElement extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.type = 1412071761;
    }
  }
  IFC42.IfcSpatialElement = IfcSpatialElement;
  class IfcSpatialElementType extends IfcTypeProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 710998568;
    }
  }
  IFC42.IfcSpatialElementType = IfcSpatialElementType;
  class IfcSpatialStructureElement extends IfcSpatialElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.type = 2706606064;
    }
  }
  IFC42.IfcSpatialStructureElement = IfcSpatialStructureElement;
  class IfcSpatialStructureElementType extends IfcSpatialElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3893378262;
    }
  }
  IFC42.IfcSpatialStructureElementType = IfcSpatialStructureElementType;
  class IfcSpatialZone extends IfcSpatialElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.PredefinedType = PredefinedType;
      this.type = 463610769;
    }
  }
  IFC42.IfcSpatialZone = IfcSpatialZone;
  class IfcSpatialZoneType extends IfcSpatialElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, LongName) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.LongName = LongName;
      this.type = 2481509218;
    }
  }
  IFC42.IfcSpatialZoneType = IfcSpatialZoneType;
  class IfcSphere extends IfcCsgPrimitive3D {
    constructor(expressID, Position, Radius) {
      super(expressID, Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 451544542;
    }
  }
  IFC42.IfcSphere = IfcSphere;
  class IfcSphericalSurface extends IfcElementarySurface {
    constructor(expressID, Position, Radius) {
      super(expressID, Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 4015995234;
    }
  }
  IFC42.IfcSphericalSurface = IfcSphericalSurface;
  class IfcStructuralActivity extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 3544373492;
    }
  }
  IFC42.IfcStructuralActivity = IfcStructuralActivity;
  class IfcStructuralItem extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 3136571912;
    }
  }
  IFC42.IfcStructuralItem = IfcStructuralItem;
  class IfcStructuralMember extends IfcStructuralItem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 530289379;
    }
  }
  IFC42.IfcStructuralMember = IfcStructuralMember;
  class IfcStructuralReaction extends IfcStructuralActivity {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 3689010777;
    }
  }
  IFC42.IfcStructuralReaction = IfcStructuralReaction;
  class IfcStructuralSurfaceMember extends IfcStructuralMember {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Thickness = Thickness;
      this.type = 3979015343;
    }
  }
  IFC42.IfcStructuralSurfaceMember = IfcStructuralSurfaceMember;
  class IfcStructuralSurfaceMemberVarying extends IfcStructuralSurfaceMember {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Thickness = Thickness;
      this.type = 2218152070;
    }
  }
  IFC42.IfcStructuralSurfaceMemberVarying = IfcStructuralSurfaceMemberVarying;
  class IfcStructuralSurfaceReaction extends IfcStructuralReaction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.PredefinedType = PredefinedType;
      this.type = 603775116;
    }
  }
  IFC42.IfcStructuralSurfaceReaction = IfcStructuralSurfaceReaction;
  class IfcSubContractResourceType extends IfcConstructionResourceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 4095615324;
    }
  }
  IFC42.IfcSubContractResourceType = IfcSubContractResourceType;
  class IfcSurfaceCurve extends IfcCurve {
    constructor(expressID, Curve3D, AssociatedGeometry, MasterRepresentation) {
      super(expressID);
      this.Curve3D = Curve3D;
      this.AssociatedGeometry = AssociatedGeometry;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 699246055;
    }
  }
  IFC42.IfcSurfaceCurve = IfcSurfaceCurve;
  class IfcSurfaceCurveSweptAreaSolid extends IfcSweptAreaSolid {
    constructor(expressID, SweptArea, Position, Directrix, StartParam, EndParam, ReferenceSurface) {
      super(expressID, SweptArea, Position);
      this.SweptArea = SweptArea;
      this.Position = Position;
      this.Directrix = Directrix;
      this.StartParam = StartParam;
      this.EndParam = EndParam;
      this.ReferenceSurface = ReferenceSurface;
      this.type = 2028607225;
    }
  }
  IFC42.IfcSurfaceCurveSweptAreaSolid = IfcSurfaceCurveSweptAreaSolid;
  class IfcSurfaceOfLinearExtrusion extends IfcSweptSurface {
    constructor(expressID, SweptCurve, Position, ExtrudedDirection, Depth) {
      super(expressID, SweptCurve, Position);
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.ExtrudedDirection = ExtrudedDirection;
      this.Depth = Depth;
      this.type = 2809605785;
    }
  }
  IFC42.IfcSurfaceOfLinearExtrusion = IfcSurfaceOfLinearExtrusion;
  class IfcSurfaceOfRevolution extends IfcSweptSurface {
    constructor(expressID, SweptCurve, Position, AxisPosition) {
      super(expressID, SweptCurve, Position);
      this.SweptCurve = SweptCurve;
      this.Position = Position;
      this.AxisPosition = AxisPosition;
      this.type = 4124788165;
    }
  }
  IFC42.IfcSurfaceOfRevolution = IfcSurfaceOfRevolution;
  class IfcSystemFurnitureElementType extends IfcFurnishingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1580310250;
    }
  }
  IFC42.IfcSystemFurnitureElementType = IfcSystemFurnitureElementType;
  class IfcTask extends IfcProcess {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Status, WorkMethod, IsMilestone, Priority, TaskTime, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Status = Status;
      this.WorkMethod = WorkMethod;
      this.IsMilestone = IsMilestone;
      this.Priority = Priority;
      this.TaskTime = TaskTime;
      this.PredefinedType = PredefinedType;
      this.type = 3473067441;
    }
  }
  IFC42.IfcTask = IfcTask;
  class IfcTaskType extends IfcTypeProcess {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType, WorkMethod) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ProcessType = ProcessType;
      this.PredefinedType = PredefinedType;
      this.WorkMethod = WorkMethod;
      this.type = 3206491090;
    }
  }
  IFC42.IfcTaskType = IfcTaskType;
  class IfcTessellatedFaceSet extends IfcTessellatedItem {
    constructor(expressID, Coordinates) {
      super(expressID);
      this.Coordinates = Coordinates;
      this.type = 2387106220;
    }
  }
  IFC42.IfcTessellatedFaceSet = IfcTessellatedFaceSet;
  class IfcToroidalSurface extends IfcElementarySurface {
    constructor(expressID, Position, MajorRadius, MinorRadius) {
      super(expressID, Position);
      this.Position = Position;
      this.MajorRadius = MajorRadius;
      this.MinorRadius = MinorRadius;
      this.type = 1935646853;
    }
  }
  IFC42.IfcToroidalSurface = IfcToroidalSurface;
  class IfcTransportElementType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2097647324;
    }
  }
  IFC42.IfcTransportElementType = IfcTransportElementType;
  class IfcTriangulatedFaceSet extends IfcTessellatedFaceSet {
    constructor(expressID, Coordinates, Normals, Closed, CoordIndex, PnIndex) {
      super(expressID, Coordinates);
      this.Coordinates = Coordinates;
      this.Normals = Normals;
      this.Closed = Closed;
      this.CoordIndex = CoordIndex;
      this.PnIndex = PnIndex;
      this.type = 2916149573;
    }
  }
  IFC42.IfcTriangulatedFaceSet = IfcTriangulatedFaceSet;
  class IfcWindowLiningProperties extends IfcPreDefinedPropertySet {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, TransomThickness, MullionThickness, FirstTransomOffset, SecondTransomOffset, FirstMullionOffset, SecondMullionOffset, ShapeAspectStyle, LiningOffset, LiningToPanelOffsetX, LiningToPanelOffsetY) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.LiningDepth = LiningDepth;
      this.LiningThickness = LiningThickness;
      this.TransomThickness = TransomThickness;
      this.MullionThickness = MullionThickness;
      this.FirstTransomOffset = FirstTransomOffset;
      this.SecondTransomOffset = SecondTransomOffset;
      this.FirstMullionOffset = FirstMullionOffset;
      this.SecondMullionOffset = SecondMullionOffset;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.LiningOffset = LiningOffset;
      this.LiningToPanelOffsetX = LiningToPanelOffsetX;
      this.LiningToPanelOffsetY = LiningToPanelOffsetY;
      this.type = 336235671;
    }
  }
  IFC42.IfcWindowLiningProperties = IfcWindowLiningProperties;
  class IfcWindowPanelProperties extends IfcPreDefinedPropertySet {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.OperationType = OperationType;
      this.PanelPosition = PanelPosition;
      this.FrameDepth = FrameDepth;
      this.FrameThickness = FrameThickness;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 512836454;
    }
  }
  IFC42.IfcWindowPanelProperties = IfcWindowPanelProperties;
  class IfcActor extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheActor = TheActor;
      this.type = 2296667514;
    }
  }
  IFC42.IfcActor = IfcActor;
  class IfcAdvancedBrep extends IfcManifoldSolidBrep {
    constructor(expressID, Outer) {
      super(expressID, Outer);
      this.Outer = Outer;
      this.type = 1635779807;
    }
  }
  IFC42.IfcAdvancedBrep = IfcAdvancedBrep;
  class IfcAdvancedBrepWithVoids extends IfcAdvancedBrep {
    constructor(expressID, Outer, Voids) {
      super(expressID, Outer);
      this.Outer = Outer;
      this.Voids = Voids;
      this.type = 2603310189;
    }
  }
  IFC42.IfcAdvancedBrepWithVoids = IfcAdvancedBrepWithVoids;
  class IfcAnnotation extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 1674181508;
    }
  }
  IFC42.IfcAnnotation = IfcAnnotation;
  class IfcBSplineSurface extends IfcBoundedSurface {
    constructor(expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect) {
      super(expressID);
      this.UDegree = UDegree;
      this.VDegree = VDegree;
      this.ControlPointsList = ControlPointsList;
      this.SurfaceForm = SurfaceForm;
      this.UClosed = UClosed;
      this.VClosed = VClosed;
      this.SelfIntersect = SelfIntersect;
      this.type = 2887950389;
    }
  }
  IFC42.IfcBSplineSurface = IfcBSplineSurface;
  class IfcBSplineSurfaceWithKnots extends IfcBSplineSurface {
    constructor(expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec) {
      super(expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect);
      this.UDegree = UDegree;
      this.VDegree = VDegree;
      this.ControlPointsList = ControlPointsList;
      this.SurfaceForm = SurfaceForm;
      this.UClosed = UClosed;
      this.VClosed = VClosed;
      this.SelfIntersect = SelfIntersect;
      this.UMultiplicities = UMultiplicities;
      this.VMultiplicities = VMultiplicities;
      this.UKnots = UKnots;
      this.VKnots = VKnots;
      this.KnotSpec = KnotSpec;
      this.type = 167062518;
    }
  }
  IFC42.IfcBSplineSurfaceWithKnots = IfcBSplineSurfaceWithKnots;
  class IfcBlock extends IfcCsgPrimitive3D {
    constructor(expressID, Position, XLength, YLength, ZLength) {
      super(expressID, Position);
      this.Position = Position;
      this.XLength = XLength;
      this.YLength = YLength;
      this.ZLength = ZLength;
      this.type = 1334484129;
    }
  }
  IFC42.IfcBlock = IfcBlock;
  class IfcBooleanClippingResult extends IfcBooleanResult {
    constructor(expressID, Operator, FirstOperand, SecondOperand) {
      super(expressID, Operator, FirstOperand, SecondOperand);
      this.Operator = Operator;
      this.FirstOperand = FirstOperand;
      this.SecondOperand = SecondOperand;
      this.type = 3649129432;
    }
  }
  IFC42.IfcBooleanClippingResult = IfcBooleanClippingResult;
  class IfcBoundedCurve extends IfcCurve {
    constructor(expressID) {
      super(expressID);
      this.type = 1260505505;
    }
  }
  IFC42.IfcBoundedCurve = IfcBoundedCurve;
  class IfcBuilding extends IfcSpatialStructureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, ElevationOfRefHeight, ElevationOfTerrain, BuildingAddress) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.ElevationOfRefHeight = ElevationOfRefHeight;
      this.ElevationOfTerrain = ElevationOfTerrain;
      this.BuildingAddress = BuildingAddress;
      this.type = 4031249490;
    }
  }
  IFC42.IfcBuilding = IfcBuilding;
  class IfcBuildingElementType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1950629157;
    }
  }
  IFC42.IfcBuildingElementType = IfcBuildingElementType;
  class IfcBuildingStorey extends IfcSpatialStructureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, Elevation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.Elevation = Elevation;
      this.type = 3124254112;
    }
  }
  IFC42.IfcBuildingStorey = IfcBuildingStorey;
  class IfcChimneyType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2197970202;
    }
  }
  IFC42.IfcChimneyType = IfcChimneyType;
  class IfcCircleHollowProfileDef extends IfcCircleProfileDef {
    constructor(expressID, ProfileType, ProfileName, Position, Radius, WallThickness) {
      super(expressID, ProfileType, ProfileName, Position, Radius);
      this.ProfileType = ProfileType;
      this.ProfileName = ProfileName;
      this.Position = Position;
      this.Radius = Radius;
      this.WallThickness = WallThickness;
      this.type = 2937912522;
    }
  }
  IFC42.IfcCircleHollowProfileDef = IfcCircleHollowProfileDef;
  class IfcCivilElementType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3893394355;
    }
  }
  IFC42.IfcCivilElementType = IfcCivilElementType;
  class IfcColumnType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 300633059;
    }
  }
  IFC42.IfcColumnType = IfcColumnType;
  class IfcComplexPropertyTemplate extends IfcPropertyTemplate {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, UsageName, TemplateType, HasPropertyTemplates) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.UsageName = UsageName;
      this.TemplateType = TemplateType;
      this.HasPropertyTemplates = HasPropertyTemplates;
      this.type = 3875453745;
    }
  }
  IFC42.IfcComplexPropertyTemplate = IfcComplexPropertyTemplate;
  class IfcCompositeCurve extends IfcBoundedCurve {
    constructor(expressID, Segments, SelfIntersect) {
      super(expressID);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 3732776249;
    }
  }
  IFC42.IfcCompositeCurve = IfcCompositeCurve;
  class IfcCompositeCurveOnSurface extends IfcCompositeCurve {
    constructor(expressID, Segments, SelfIntersect) {
      super(expressID, Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 15328376;
    }
  }
  IFC42.IfcCompositeCurveOnSurface = IfcCompositeCurveOnSurface;
  class IfcConic extends IfcCurve {
    constructor(expressID, Position) {
      super(expressID);
      this.Position = Position;
      this.type = 2510884976;
    }
  }
  IFC42.IfcConic = IfcConic;
  class IfcConstructionEquipmentResourceType extends IfcConstructionResourceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 2185764099;
    }
  }
  IFC42.IfcConstructionEquipmentResourceType = IfcConstructionEquipmentResourceType;
  class IfcConstructionMaterialResourceType extends IfcConstructionResourceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 4105962743;
    }
  }
  IFC42.IfcConstructionMaterialResourceType = IfcConstructionMaterialResourceType;
  class IfcConstructionProductResourceType extends IfcConstructionResourceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.ResourceType = ResourceType;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 1525564444;
    }
  }
  IFC42.IfcConstructionProductResourceType = IfcConstructionProductResourceType;
  class IfcConstructionResource extends IfcResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.type = 2559216714;
    }
  }
  IFC42.IfcConstructionResource = IfcConstructionResource;
  class IfcControl extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.type = 3293443760;
    }
  }
  IFC42.IfcControl = IfcControl;
  class IfcCostItem extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, CostValues, CostQuantities) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.CostValues = CostValues;
      this.CostQuantities = CostQuantities;
      this.type = 3895139033;
    }
  }
  IFC42.IfcCostItem = IfcCostItem;
  class IfcCostSchedule extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, SubmittedOn, UpdateDate) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.SubmittedOn = SubmittedOn;
      this.UpdateDate = UpdateDate;
      this.type = 1419761937;
    }
  }
  IFC42.IfcCostSchedule = IfcCostSchedule;
  class IfcCoveringType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1916426348;
    }
  }
  IFC42.IfcCoveringType = IfcCoveringType;
  class IfcCrewResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 3295246426;
    }
  }
  IFC42.IfcCrewResource = IfcCrewResource;
  class IfcCurtainWallType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1457835157;
    }
  }
  IFC42.IfcCurtainWallType = IfcCurtainWallType;
  class IfcCylindricalSurface extends IfcElementarySurface {
    constructor(expressID, Position, Radius) {
      super(expressID, Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 1213902940;
    }
  }
  IFC42.IfcCylindricalSurface = IfcCylindricalSurface;
  class IfcDistributionElementType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3256556792;
    }
  }
  IFC42.IfcDistributionElementType = IfcDistributionElementType;
  class IfcDistributionFlowElementType extends IfcDistributionElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3849074793;
    }
  }
  IFC42.IfcDistributionFlowElementType = IfcDistributionFlowElementType;
  class IfcDoorLiningProperties extends IfcPreDefinedPropertySet {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, ThresholdDepth, ThresholdThickness, TransomThickness, TransomOffset, LiningOffset, ThresholdOffset, CasingThickness, CasingDepth, ShapeAspectStyle, LiningToPanelOffsetX, LiningToPanelOffsetY) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.LiningDepth = LiningDepth;
      this.LiningThickness = LiningThickness;
      this.ThresholdDepth = ThresholdDepth;
      this.ThresholdThickness = ThresholdThickness;
      this.TransomThickness = TransomThickness;
      this.TransomOffset = TransomOffset;
      this.LiningOffset = LiningOffset;
      this.ThresholdOffset = ThresholdOffset;
      this.CasingThickness = CasingThickness;
      this.CasingDepth = CasingDepth;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.LiningToPanelOffsetX = LiningToPanelOffsetX;
      this.LiningToPanelOffsetY = LiningToPanelOffsetY;
      this.type = 2963535650;
    }
  }
  IFC42.IfcDoorLiningProperties = IfcDoorLiningProperties;
  class IfcDoorPanelProperties extends IfcPreDefinedPropertySet {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, PanelDepth, PanelOperation, PanelWidth, PanelPosition, ShapeAspectStyle) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.PanelDepth = PanelDepth;
      this.PanelOperation = PanelOperation;
      this.PanelWidth = PanelWidth;
      this.PanelPosition = PanelPosition;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 1714330368;
    }
  }
  IFC42.IfcDoorPanelProperties = IfcDoorPanelProperties;
  class IfcDoorType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, OperationType, ParameterTakesPrecedence, UserDefinedOperationType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.OperationType = OperationType;
      this.ParameterTakesPrecedence = ParameterTakesPrecedence;
      this.UserDefinedOperationType = UserDefinedOperationType;
      this.type = 2323601079;
    }
  }
  IFC42.IfcDoorType = IfcDoorType;
  class IfcDraughtingPreDefinedColour extends IfcPreDefinedColour {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 445594917;
    }
  }
  IFC42.IfcDraughtingPreDefinedColour = IfcDraughtingPreDefinedColour;
  class IfcDraughtingPreDefinedCurveFont extends IfcPreDefinedCurveFont {
    constructor(expressID, Name) {
      super(expressID, Name);
      this.Name = Name;
      this.type = 4006246654;
    }
  }
  IFC42.IfcDraughtingPreDefinedCurveFont = IfcDraughtingPreDefinedCurveFont;
  class IfcElement extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1758889154;
    }
  }
  IFC42.IfcElement = IfcElement;
  class IfcElementAssembly extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, AssemblyPlace, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.AssemblyPlace = AssemblyPlace;
      this.PredefinedType = PredefinedType;
      this.type = 4123344466;
    }
  }
  IFC42.IfcElementAssembly = IfcElementAssembly;
  class IfcElementAssemblyType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2397081782;
    }
  }
  IFC42.IfcElementAssemblyType = IfcElementAssemblyType;
  class IfcElementComponent extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1623761950;
    }
  }
  IFC42.IfcElementComponent = IfcElementComponent;
  class IfcElementComponentType extends IfcElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2590856083;
    }
  }
  IFC42.IfcElementComponentType = IfcElementComponentType;
  class IfcEllipse extends IfcConic {
    constructor(expressID, Position, SemiAxis1, SemiAxis2) {
      super(expressID, Position);
      this.Position = Position;
      this.SemiAxis1 = SemiAxis1;
      this.SemiAxis2 = SemiAxis2;
      this.type = 1704287377;
    }
  }
  IFC42.IfcEllipse = IfcEllipse;
  class IfcEnergyConversionDeviceType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2107101300;
    }
  }
  IFC42.IfcEnergyConversionDeviceType = IfcEnergyConversionDeviceType;
  class IfcEngineType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 132023988;
    }
  }
  IFC42.IfcEngineType = IfcEngineType;
  class IfcEvaporativeCoolerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3174744832;
    }
  }
  IFC42.IfcEvaporativeCoolerType = IfcEvaporativeCoolerType;
  class IfcEvaporatorType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3390157468;
    }
  }
  IFC42.IfcEvaporatorType = IfcEvaporatorType;
  class IfcEvent extends IfcProcess {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, PredefinedType, EventTriggerType, UserDefinedEventTriggerType, EventOccurenceTime) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.PredefinedType = PredefinedType;
      this.EventTriggerType = EventTriggerType;
      this.UserDefinedEventTriggerType = UserDefinedEventTriggerType;
      this.EventOccurenceTime = EventOccurenceTime;
      this.type = 4148101412;
    }
  }
  IFC42.IfcEvent = IfcEvent;
  class IfcExternalSpatialStructureElement extends IfcSpatialElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.type = 2853485674;
    }
  }
  IFC42.IfcExternalSpatialStructureElement = IfcExternalSpatialStructureElement;
  class IfcFacetedBrep extends IfcManifoldSolidBrep {
    constructor(expressID, Outer) {
      super(expressID, Outer);
      this.Outer = Outer;
      this.type = 807026263;
    }
  }
  IFC42.IfcFacetedBrep = IfcFacetedBrep;
  class IfcFacetedBrepWithVoids extends IfcFacetedBrep {
    constructor(expressID, Outer, Voids) {
      super(expressID, Outer);
      this.Outer = Outer;
      this.Voids = Voids;
      this.type = 3737207727;
    }
  }
  IFC42.IfcFacetedBrepWithVoids = IfcFacetedBrepWithVoids;
  class IfcFastener extends IfcElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 647756555;
    }
  }
  IFC42.IfcFastener = IfcFastener;
  class IfcFastenerType extends IfcElementComponentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2489546625;
    }
  }
  IFC42.IfcFastenerType = IfcFastenerType;
  class IfcFeatureElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2827207264;
    }
  }
  IFC42.IfcFeatureElement = IfcFeatureElement;
  class IfcFeatureElementAddition extends IfcFeatureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2143335405;
    }
  }
  IFC42.IfcFeatureElementAddition = IfcFeatureElementAddition;
  class IfcFeatureElementSubtraction extends IfcFeatureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1287392070;
    }
  }
  IFC42.IfcFeatureElementSubtraction = IfcFeatureElementSubtraction;
  class IfcFlowControllerType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3907093117;
    }
  }
  IFC42.IfcFlowControllerType = IfcFlowControllerType;
  class IfcFlowFittingType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3198132628;
    }
  }
  IFC42.IfcFlowFittingType = IfcFlowFittingType;
  class IfcFlowMeterType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3815607619;
    }
  }
  IFC42.IfcFlowMeterType = IfcFlowMeterType;
  class IfcFlowMovingDeviceType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1482959167;
    }
  }
  IFC42.IfcFlowMovingDeviceType = IfcFlowMovingDeviceType;
  class IfcFlowSegmentType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1834744321;
    }
  }
  IFC42.IfcFlowSegmentType = IfcFlowSegmentType;
  class IfcFlowStorageDeviceType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 1339347760;
    }
  }
  IFC42.IfcFlowStorageDeviceType = IfcFlowStorageDeviceType;
  class IfcFlowTerminalType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2297155007;
    }
  }
  IFC42.IfcFlowTerminalType = IfcFlowTerminalType;
  class IfcFlowTreatmentDeviceType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 3009222698;
    }
  }
  IFC42.IfcFlowTreatmentDeviceType = IfcFlowTreatmentDeviceType;
  class IfcFootingType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1893162501;
    }
  }
  IFC42.IfcFootingType = IfcFootingType;
  class IfcFurnishingElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 263784265;
    }
  }
  IFC42.IfcFurnishingElement = IfcFurnishingElement;
  class IfcFurniture extends IfcFurnishingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1509553395;
    }
  }
  IFC42.IfcFurniture = IfcFurniture;
  class IfcGeographicElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3493046030;
    }
  }
  IFC42.IfcGeographicElement = IfcGeographicElement;
  class IfcGrid extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, UAxes, VAxes, WAxes, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.UAxes = UAxes;
      this.VAxes = VAxes;
      this.WAxes = WAxes;
      this.PredefinedType = PredefinedType;
      this.type = 3009204131;
    }
  }
  IFC42.IfcGrid = IfcGrid;
  class IfcGroup extends IfcObject {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2706460486;
    }
  }
  IFC42.IfcGroup = IfcGroup;
  class IfcHeatExchangerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1251058090;
    }
  }
  IFC42.IfcHeatExchangerType = IfcHeatExchangerType;
  class IfcHumidifierType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1806887404;
    }
  }
  IFC42.IfcHumidifierType = IfcHumidifierType;
  class IfcIndexedPolyCurve extends IfcBoundedCurve {
    constructor(expressID, Points, Segments, SelfIntersect) {
      super(expressID);
      this.Points = Points;
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 2571569899;
    }
  }
  IFC42.IfcIndexedPolyCurve = IfcIndexedPolyCurve;
  class IfcInterceptorType extends IfcFlowTreatmentDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3946677679;
    }
  }
  IFC42.IfcInterceptorType = IfcInterceptorType;
  class IfcIntersectionCurve extends IfcSurfaceCurve {
    constructor(expressID, Curve3D, AssociatedGeometry, MasterRepresentation) {
      super(expressID, Curve3D, AssociatedGeometry, MasterRepresentation);
      this.Curve3D = Curve3D;
      this.AssociatedGeometry = AssociatedGeometry;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 3113134337;
    }
  }
  IFC42.IfcIntersectionCurve = IfcIntersectionCurve;
  class IfcInventory extends IfcGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, Jurisdiction, ResponsiblePersons, LastUpdateDate, CurrentValue, OriginalValue) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.Jurisdiction = Jurisdiction;
      this.ResponsiblePersons = ResponsiblePersons;
      this.LastUpdateDate = LastUpdateDate;
      this.CurrentValue = CurrentValue;
      this.OriginalValue = OriginalValue;
      this.type = 2391368822;
    }
  }
  IFC42.IfcInventory = IfcInventory;
  class IfcJunctionBoxType extends IfcFlowFittingType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4288270099;
    }
  }
  IFC42.IfcJunctionBoxType = IfcJunctionBoxType;
  class IfcLaborResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 3827777499;
    }
  }
  IFC42.IfcLaborResource = IfcLaborResource;
  class IfcLampType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1051575348;
    }
  }
  IFC42.IfcLampType = IfcLampType;
  class IfcLightFixtureType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1161773419;
    }
  }
  IFC42.IfcLightFixtureType = IfcLightFixtureType;
  class IfcMechanicalFastener extends IfcElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NominalDiameter, NominalLength, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.NominalDiameter = NominalDiameter;
      this.NominalLength = NominalLength;
      this.PredefinedType = PredefinedType;
      this.type = 377706215;
    }
  }
  IFC42.IfcMechanicalFastener = IfcMechanicalFastener;
  class IfcMechanicalFastenerType extends IfcElementComponentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, NominalLength) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.NominalLength = NominalLength;
      this.type = 2108223431;
    }
  }
  IFC42.IfcMechanicalFastenerType = IfcMechanicalFastenerType;
  class IfcMedicalDeviceType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1114901282;
    }
  }
  IFC42.IfcMedicalDeviceType = IfcMedicalDeviceType;
  class IfcMemberType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3181161470;
    }
  }
  IFC42.IfcMemberType = IfcMemberType;
  class IfcMotorConnectionType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 977012517;
    }
  }
  IFC42.IfcMotorConnectionType = IfcMotorConnectionType;
  class IfcOccupant extends IfcActor {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheActor = TheActor;
      this.PredefinedType = PredefinedType;
      this.type = 4143007308;
    }
  }
  IFC42.IfcOccupant = IfcOccupant;
  class IfcOpeningElement extends IfcFeatureElementSubtraction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3588315303;
    }
  }
  IFC42.IfcOpeningElement = IfcOpeningElement;
  class IfcOpeningStandardCase extends IfcOpeningElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3079942009;
    }
  }
  IFC42.IfcOpeningStandardCase = IfcOpeningStandardCase;
  class IfcOutletType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2837617999;
    }
  }
  IFC42.IfcOutletType = IfcOutletType;
  class IfcPerformanceHistory extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LifeCyclePhase, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LifeCyclePhase = LifeCyclePhase;
      this.PredefinedType = PredefinedType;
      this.type = 2382730787;
    }
  }
  IFC42.IfcPerformanceHistory = IfcPerformanceHistory;
  class IfcPermeableCoveringProperties extends IfcPreDefinedPropertySet {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.OperationType = OperationType;
      this.PanelPosition = PanelPosition;
      this.FrameDepth = FrameDepth;
      this.FrameThickness = FrameThickness;
      this.ShapeAspectStyle = ShapeAspectStyle;
      this.type = 3566463478;
    }
  }
  IFC42.IfcPermeableCoveringProperties = IfcPermeableCoveringProperties;
  class IfcPermit extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.LongDescription = LongDescription;
      this.type = 3327091369;
    }
  }
  IFC42.IfcPermit = IfcPermit;
  class IfcPileType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1158309216;
    }
  }
  IFC42.IfcPileType = IfcPileType;
  class IfcPipeFittingType extends IfcFlowFittingType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 804291784;
    }
  }
  IFC42.IfcPipeFittingType = IfcPipeFittingType;
  class IfcPipeSegmentType extends IfcFlowSegmentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4231323485;
    }
  }
  IFC42.IfcPipeSegmentType = IfcPipeSegmentType;
  class IfcPlateType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4017108033;
    }
  }
  IFC42.IfcPlateType = IfcPlateType;
  class IfcPolygonalFaceSet extends IfcTessellatedFaceSet {
    constructor(expressID, Coordinates, Closed, Faces, PnIndex) {
      super(expressID, Coordinates);
      this.Coordinates = Coordinates;
      this.Closed = Closed;
      this.Faces = Faces;
      this.PnIndex = PnIndex;
      this.type = 2839578677;
    }
  }
  IFC42.IfcPolygonalFaceSet = IfcPolygonalFaceSet;
  class IfcPolyline extends IfcBoundedCurve {
    constructor(expressID, Points) {
      super(expressID);
      this.Points = Points;
      this.type = 3724593414;
    }
  }
  IFC42.IfcPolyline = IfcPolyline;
  class IfcPort extends IfcProduct {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.type = 3740093272;
    }
  }
  IFC42.IfcPort = IfcPort;
  class IfcProcedure extends IfcProcess {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.PredefinedType = PredefinedType;
      this.type = 2744685151;
    }
  }
  IFC42.IfcProcedure = IfcProcedure;
  class IfcProjectOrder extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.LongDescription = LongDescription;
      this.type = 2904328755;
    }
  }
  IFC42.IfcProjectOrder = IfcProjectOrder;
  class IfcProjectionElement extends IfcFeatureElementAddition {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3651124850;
    }
  }
  IFC42.IfcProjectionElement = IfcProjectionElement;
  class IfcProtectiveDeviceType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1842657554;
    }
  }
  IFC42.IfcProtectiveDeviceType = IfcProtectiveDeviceType;
  class IfcPumpType extends IfcFlowMovingDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2250791053;
    }
  }
  IFC42.IfcPumpType = IfcPumpType;
  class IfcRailingType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2893384427;
    }
  }
  IFC42.IfcRailingType = IfcRailingType;
  class IfcRampFlightType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2324767716;
    }
  }
  IFC42.IfcRampFlightType = IfcRampFlightType;
  class IfcRampType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1469900589;
    }
  }
  IFC42.IfcRampType = IfcRampType;
  class IfcRationalBSplineSurfaceWithKnots extends IfcBSplineSurfaceWithKnots {
    constructor(expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec, WeightsData) {
      super(expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec);
      this.UDegree = UDegree;
      this.VDegree = VDegree;
      this.ControlPointsList = ControlPointsList;
      this.SurfaceForm = SurfaceForm;
      this.UClosed = UClosed;
      this.VClosed = VClosed;
      this.SelfIntersect = SelfIntersect;
      this.UMultiplicities = UMultiplicities;
      this.VMultiplicities = VMultiplicities;
      this.UKnots = UKnots;
      this.VKnots = VKnots;
      this.KnotSpec = KnotSpec;
      this.WeightsData = WeightsData;
      this.type = 683857671;
    }
  }
  IFC42.IfcRationalBSplineSurfaceWithKnots = IfcRationalBSplineSurfaceWithKnots;
  class IfcReinforcingElement extends IfcElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.type = 3027567501;
    }
  }
  IFC42.IfcReinforcingElement = IfcReinforcingElement;
  class IfcReinforcingElementType extends IfcElementComponentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 964333572;
    }
  }
  IFC42.IfcReinforcingElementType = IfcReinforcingElementType;
  class IfcReinforcingMesh extends IfcReinforcingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.MeshLength = MeshLength;
      this.MeshWidth = MeshWidth;
      this.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
      this.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
      this.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
      this.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
      this.LongitudinalBarSpacing = LongitudinalBarSpacing;
      this.TransverseBarSpacing = TransverseBarSpacing;
      this.PredefinedType = PredefinedType;
      this.type = 2320036040;
    }
  }
  IFC42.IfcReinforcingMesh = IfcReinforcingMesh;
  class IfcReinforcingMeshType extends IfcReinforcingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing, BendingShapeCode, BendingParameters) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.MeshLength = MeshLength;
      this.MeshWidth = MeshWidth;
      this.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
      this.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
      this.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
      this.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
      this.LongitudinalBarSpacing = LongitudinalBarSpacing;
      this.TransverseBarSpacing = TransverseBarSpacing;
      this.BendingShapeCode = BendingShapeCode;
      this.BendingParameters = BendingParameters;
      this.type = 2310774935;
    }
  }
  IFC42.IfcReinforcingMeshType = IfcReinforcingMeshType;
  class IfcRelAggregates extends IfcRelDecomposes {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      super(expressID, GlobalId, OwnerHistory, Name, Description);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.RelatingObject = RelatingObject;
      this.RelatedObjects = RelatedObjects;
      this.type = 160246688;
    }
  }
  IFC42.IfcRelAggregates = IfcRelAggregates;
  class IfcRoofType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2781568857;
    }
  }
  IFC42.IfcRoofType = IfcRoofType;
  class IfcSanitaryTerminalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1768891740;
    }
  }
  IFC42.IfcSanitaryTerminalType = IfcSanitaryTerminalType;
  class IfcSeamCurve extends IfcSurfaceCurve {
    constructor(expressID, Curve3D, AssociatedGeometry, MasterRepresentation) {
      super(expressID, Curve3D, AssociatedGeometry, MasterRepresentation);
      this.Curve3D = Curve3D;
      this.AssociatedGeometry = AssociatedGeometry;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 2157484638;
    }
  }
  IFC42.IfcSeamCurve = IfcSeamCurve;
  class IfcShadingDeviceType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4074543187;
    }
  }
  IFC42.IfcShadingDeviceType = IfcShadingDeviceType;
  class IfcSite extends IfcSpatialStructureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, RefLatitude, RefLongitude, RefElevation, LandTitleNumber, SiteAddress) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.RefLatitude = RefLatitude;
      this.RefLongitude = RefLongitude;
      this.RefElevation = RefElevation;
      this.LandTitleNumber = LandTitleNumber;
      this.SiteAddress = SiteAddress;
      this.type = 4097777520;
    }
  }
  IFC42.IfcSite = IfcSite;
  class IfcSlabType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2533589738;
    }
  }
  IFC42.IfcSlabType = IfcSlabType;
  class IfcSolarDeviceType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1072016465;
    }
  }
  IFC42.IfcSolarDeviceType = IfcSolarDeviceType;
  class IfcSpace extends IfcSpatialStructureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType, ElevationWithFlooring) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.CompositionType = CompositionType;
      this.PredefinedType = PredefinedType;
      this.ElevationWithFlooring = ElevationWithFlooring;
      this.type = 3856911033;
    }
  }
  IFC42.IfcSpace = IfcSpace;
  class IfcSpaceHeaterType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1305183839;
    }
  }
  IFC42.IfcSpaceHeaterType = IfcSpaceHeaterType;
  class IfcSpaceType extends IfcSpatialStructureElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, LongName) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.LongName = LongName;
      this.type = 3812236995;
    }
  }
  IFC42.IfcSpaceType = IfcSpaceType;
  class IfcStackTerminalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3112655638;
    }
  }
  IFC42.IfcStackTerminalType = IfcStackTerminalType;
  class IfcStairFlightType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1039846685;
    }
  }
  IFC42.IfcStairFlightType = IfcStairFlightType;
  class IfcStairType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 338393293;
    }
  }
  IFC42.IfcStairType = IfcStairType;
  class IfcStructuralAction extends IfcStructuralActivity {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.type = 682877961;
    }
  }
  IFC42.IfcStructuralAction = IfcStructuralAction;
  class IfcStructuralConnection extends IfcStructuralItem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.type = 1179482911;
    }
  }
  IFC42.IfcStructuralConnection = IfcStructuralConnection;
  class IfcStructuralCurveAction extends IfcStructuralAction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.PredefinedType = PredefinedType;
      this.type = 1004757350;
    }
  }
  IFC42.IfcStructuralCurveAction = IfcStructuralCurveAction;
  class IfcStructuralCurveConnection extends IfcStructuralConnection {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition, Axis) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.Axis = Axis;
      this.type = 4243806635;
    }
  }
  IFC42.IfcStructuralCurveConnection = IfcStructuralCurveConnection;
  class IfcStructuralCurveMember extends IfcStructuralMember {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Axis = Axis;
      this.type = 214636428;
    }
  }
  IFC42.IfcStructuralCurveMember = IfcStructuralCurveMember;
  class IfcStructuralCurveMemberVarying extends IfcStructuralCurveMember {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.PredefinedType = PredefinedType;
      this.Axis = Axis;
      this.type = 2445595289;
    }
  }
  IFC42.IfcStructuralCurveMemberVarying = IfcStructuralCurveMemberVarying;
  class IfcStructuralCurveReaction extends IfcStructuralReaction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.PredefinedType = PredefinedType;
      this.type = 2757150158;
    }
  }
  IFC42.IfcStructuralCurveReaction = IfcStructuralCurveReaction;
  class IfcStructuralLinearAction extends IfcStructuralCurveAction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.PredefinedType = PredefinedType;
      this.type = 1807405624;
    }
  }
  IFC42.IfcStructuralLinearAction = IfcStructuralLinearAction;
  class IfcStructuralLoadGroup extends IfcGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.ActionType = ActionType;
      this.ActionSource = ActionSource;
      this.Coefficient = Coefficient;
      this.Purpose = Purpose;
      this.type = 1252848954;
    }
  }
  IFC42.IfcStructuralLoadGroup = IfcStructuralLoadGroup;
  class IfcStructuralPointAction extends IfcStructuralAction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.type = 2082059205;
    }
  }
  IFC42.IfcStructuralPointAction = IfcStructuralPointAction;
  class IfcStructuralPointConnection extends IfcStructuralConnection {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition, ConditionCoordinateSystem) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.ConditionCoordinateSystem = ConditionCoordinateSystem;
      this.type = 734778138;
    }
  }
  IFC42.IfcStructuralPointConnection = IfcStructuralPointConnection;
  class IfcStructuralPointReaction extends IfcStructuralReaction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.type = 1235345126;
    }
  }
  IFC42.IfcStructuralPointReaction = IfcStructuralPointReaction;
  class IfcStructuralResultGroup extends IfcGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheoryType, ResultForLoadGroup, IsLinear) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.TheoryType = TheoryType;
      this.ResultForLoadGroup = ResultForLoadGroup;
      this.IsLinear = IsLinear;
      this.type = 2986769608;
    }
  }
  IFC42.IfcStructuralResultGroup = IfcStructuralResultGroup;
  class IfcStructuralSurfaceAction extends IfcStructuralAction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.PredefinedType = PredefinedType;
      this.type = 3657597509;
    }
  }
  IFC42.IfcStructuralSurfaceAction = IfcStructuralSurfaceAction;
  class IfcStructuralSurfaceConnection extends IfcStructuralConnection {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedCondition = AppliedCondition;
      this.type = 1975003073;
    }
  }
  IFC42.IfcStructuralSurfaceConnection = IfcStructuralSurfaceConnection;
  class IfcSubContractResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 148013059;
    }
  }
  IFC42.IfcSubContractResource = IfcSubContractResource;
  class IfcSurfaceFeature extends IfcFeatureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3101698114;
    }
  }
  IFC42.IfcSurfaceFeature = IfcSurfaceFeature;
  class IfcSwitchingDeviceType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2315554128;
    }
  }
  IFC42.IfcSwitchingDeviceType = IfcSwitchingDeviceType;
  class IfcSystem extends IfcGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.type = 2254336722;
    }
  }
  IFC42.IfcSystem = IfcSystem;
  class IfcSystemFurnitureElement extends IfcFurnishingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 413509423;
    }
  }
  IFC42.IfcSystemFurnitureElement = IfcSystemFurnitureElement;
  class IfcTankType extends IfcFlowStorageDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 5716631;
    }
  }
  IFC42.IfcTankType = IfcTankType;
  class IfcTendon extends IfcReinforcingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType, NominalDiameter, CrossSectionArea, TensionForce, PreStress, FrictionCoefficient, AnchorageSlip, MinCurvatureRadius) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.TensionForce = TensionForce;
      this.PreStress = PreStress;
      this.FrictionCoefficient = FrictionCoefficient;
      this.AnchorageSlip = AnchorageSlip;
      this.MinCurvatureRadius = MinCurvatureRadius;
      this.type = 3824725483;
    }
  }
  IFC42.IfcTendon = IfcTendon;
  class IfcTendonAnchor extends IfcReinforcingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.PredefinedType = PredefinedType;
      this.type = 2347447852;
    }
  }
  IFC42.IfcTendonAnchor = IfcTendonAnchor;
  class IfcTendonAnchorType extends IfcReinforcingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3081323446;
    }
  }
  IFC42.IfcTendonAnchorType = IfcTendonAnchorType;
  class IfcTendonType extends IfcReinforcingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, CrossSectionArea, SheathDiameter) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.SheathDiameter = SheathDiameter;
      this.type = 2415094496;
    }
  }
  IFC42.IfcTendonType = IfcTendonType;
  class IfcTransformerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1692211062;
    }
  }
  IFC42.IfcTransformerType = IfcTransformerType;
  class IfcTransportElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1620046519;
    }
  }
  IFC42.IfcTransportElement = IfcTransportElement;
  class IfcTrimmedCurve extends IfcBoundedCurve {
    constructor(expressID, BasisCurve, Trim1, Trim2, SenseAgreement, MasterRepresentation) {
      super(expressID);
      this.BasisCurve = BasisCurve;
      this.Trim1 = Trim1;
      this.Trim2 = Trim2;
      this.SenseAgreement = SenseAgreement;
      this.MasterRepresentation = MasterRepresentation;
      this.type = 3593883385;
    }
  }
  IFC42.IfcTrimmedCurve = IfcTrimmedCurve;
  class IfcTubeBundleType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1600972822;
    }
  }
  IFC42.IfcTubeBundleType = IfcTubeBundleType;
  class IfcUnitaryEquipmentType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1911125066;
    }
  }
  IFC42.IfcUnitaryEquipmentType = IfcUnitaryEquipmentType;
  class IfcValveType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 728799441;
    }
  }
  IFC42.IfcValveType = IfcValveType;
  class IfcVibrationIsolator extends IfcElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2391383451;
    }
  }
  IFC42.IfcVibrationIsolator = IfcVibrationIsolator;
  class IfcVibrationIsolatorType extends IfcElementComponentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3313531582;
    }
  }
  IFC42.IfcVibrationIsolatorType = IfcVibrationIsolatorType;
  class IfcVirtualElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2769231204;
    }
  }
  IFC42.IfcVirtualElement = IfcVirtualElement;
  class IfcVoidingFeature extends IfcFeatureElementSubtraction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 926996030;
    }
  }
  IFC42.IfcVoidingFeature = IfcVoidingFeature;
  class IfcWallType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1898987631;
    }
  }
  IFC42.IfcWallType = IfcWallType;
  class IfcWasteTerminalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1133259667;
    }
  }
  IFC42.IfcWasteTerminalType = IfcWasteTerminalType;
  class IfcWindowType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, PartitioningType, ParameterTakesPrecedence, UserDefinedPartitioningType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.PartitioningType = PartitioningType;
      this.ParameterTakesPrecedence = ParameterTakesPrecedence;
      this.UserDefinedPartitioningType = UserDefinedPartitioningType;
      this.type = 4009809668;
    }
  }
  IFC42.IfcWindowType = IfcWindowType;
  class IfcWorkCalendar extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, WorkingTimes, ExceptionTimes, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.WorkingTimes = WorkingTimes;
      this.ExceptionTimes = ExceptionTimes;
      this.PredefinedType = PredefinedType;
      this.type = 4088093105;
    }
  }
  IFC42.IfcWorkCalendar = IfcWorkCalendar;
  class IfcWorkControl extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.type = 1028945134;
    }
  }
  IFC42.IfcWorkControl = IfcWorkControl;
  class IfcWorkPlan extends IfcWorkControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.PredefinedType = PredefinedType;
      this.type = 4218914973;
    }
  }
  IFC42.IfcWorkPlan = IfcWorkPlan;
  class IfcWorkSchedule extends IfcWorkControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.CreationDate = CreationDate;
      this.Creators = Creators;
      this.Purpose = Purpose;
      this.Duration = Duration;
      this.TotalFloat = TotalFloat;
      this.StartTime = StartTime;
      this.FinishTime = FinishTime;
      this.PredefinedType = PredefinedType;
      this.type = 3342526732;
    }
  }
  IFC42.IfcWorkSchedule = IfcWorkSchedule;
  class IfcZone extends IfcSystem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.type = 1033361043;
    }
  }
  IFC42.IfcZone = IfcZone;
  class IfcActionRequest extends IfcControl {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.PredefinedType = PredefinedType;
      this.Status = Status;
      this.LongDescription = LongDescription;
      this.type = 3821786052;
    }
  }
  IFC42.IfcActionRequest = IfcActionRequest;
  class IfcAirTerminalBoxType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1411407467;
    }
  }
  IFC42.IfcAirTerminalBoxType = IfcAirTerminalBoxType;
  class IfcAirTerminalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3352864051;
    }
  }
  IFC42.IfcAirTerminalType = IfcAirTerminalType;
  class IfcAirToAirHeatRecoveryType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1871374353;
    }
  }
  IFC42.IfcAirToAirHeatRecoveryType = IfcAirToAirHeatRecoveryType;
  class IfcAsset extends IfcGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, OriginalValue, CurrentValue, TotalReplacementCost, Owner, User, ResponsiblePerson, IncorporationDate, DepreciatedValue) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.OriginalValue = OriginalValue;
      this.CurrentValue = CurrentValue;
      this.TotalReplacementCost = TotalReplacementCost;
      this.Owner = Owner;
      this.User = User;
      this.ResponsiblePerson = ResponsiblePerson;
      this.IncorporationDate = IncorporationDate;
      this.DepreciatedValue = DepreciatedValue;
      this.type = 3460190687;
    }
  }
  IFC42.IfcAsset = IfcAsset;
  class IfcAudioVisualApplianceType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1532957894;
    }
  }
  IFC42.IfcAudioVisualApplianceType = IfcAudioVisualApplianceType;
  class IfcBSplineCurve extends IfcBoundedCurve {
    constructor(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect) {
      super(expressID);
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.type = 1967976161;
    }
  }
  IFC42.IfcBSplineCurve = IfcBSplineCurve;
  class IfcBSplineCurveWithKnots extends IfcBSplineCurve {
    constructor(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec) {
      super(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect);
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.KnotMultiplicities = KnotMultiplicities;
      this.Knots = Knots;
      this.KnotSpec = KnotSpec;
      this.type = 2461110595;
    }
  }
  IFC42.IfcBSplineCurveWithKnots = IfcBSplineCurveWithKnots;
  class IfcBeamType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 819618141;
    }
  }
  IFC42.IfcBeamType = IfcBeamType;
  class IfcBoilerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 231477066;
    }
  }
  IFC42.IfcBoilerType = IfcBoilerType;
  class IfcBoundaryCurve extends IfcCompositeCurveOnSurface {
    constructor(expressID, Segments, SelfIntersect) {
      super(expressID, Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 1136057603;
    }
  }
  IFC42.IfcBoundaryCurve = IfcBoundaryCurve;
  class IfcBuildingElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3299480353;
    }
  }
  IFC42.IfcBuildingElement = IfcBuildingElement;
  class IfcBuildingElementPart extends IfcElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2979338954;
    }
  }
  IFC42.IfcBuildingElementPart = IfcBuildingElementPart;
  class IfcBuildingElementPartType extends IfcElementComponentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 39481116;
    }
  }
  IFC42.IfcBuildingElementPartType = IfcBuildingElementPartType;
  class IfcBuildingElementProxy extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1095909175;
    }
  }
  IFC42.IfcBuildingElementProxy = IfcBuildingElementProxy;
  class IfcBuildingElementProxyType extends IfcBuildingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1909888760;
    }
  }
  IFC42.IfcBuildingElementProxyType = IfcBuildingElementProxyType;
  class IfcBuildingSystem extends IfcSystem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, LongName) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.LongName = LongName;
      this.type = 1177604601;
    }
  }
  IFC42.IfcBuildingSystem = IfcBuildingSystem;
  class IfcBurnerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2188180465;
    }
  }
  IFC42.IfcBurnerType = IfcBurnerType;
  class IfcCableCarrierFittingType extends IfcFlowFittingType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 395041908;
    }
  }
  IFC42.IfcCableCarrierFittingType = IfcCableCarrierFittingType;
  class IfcCableCarrierSegmentType extends IfcFlowSegmentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3293546465;
    }
  }
  IFC42.IfcCableCarrierSegmentType = IfcCableCarrierSegmentType;
  class IfcCableFittingType extends IfcFlowFittingType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2674252688;
    }
  }
  IFC42.IfcCableFittingType = IfcCableFittingType;
  class IfcCableSegmentType extends IfcFlowSegmentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1285652485;
    }
  }
  IFC42.IfcCableSegmentType = IfcCableSegmentType;
  class IfcChillerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2951183804;
    }
  }
  IFC42.IfcChillerType = IfcChillerType;
  class IfcChimney extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3296154744;
    }
  }
  IFC42.IfcChimney = IfcChimney;
  class IfcCircle extends IfcConic {
    constructor(expressID, Position, Radius) {
      super(expressID, Position);
      this.Position = Position;
      this.Radius = Radius;
      this.type = 2611217952;
    }
  }
  IFC42.IfcCircle = IfcCircle;
  class IfcCivilElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1677625105;
    }
  }
  IFC42.IfcCivilElement = IfcCivilElement;
  class IfcCoilType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2301859152;
    }
  }
  IFC42.IfcCoilType = IfcCoilType;
  class IfcColumn extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 843113511;
    }
  }
  IFC42.IfcColumn = IfcColumn;
  class IfcColumnStandardCase extends IfcColumn {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 905975707;
    }
  }
  IFC42.IfcColumnStandardCase = IfcColumnStandardCase;
  class IfcCommunicationsApplianceType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 400855858;
    }
  }
  IFC42.IfcCommunicationsApplianceType = IfcCommunicationsApplianceType;
  class IfcCompressorType extends IfcFlowMovingDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3850581409;
    }
  }
  IFC42.IfcCompressorType = IfcCompressorType;
  class IfcCondenserType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2816379211;
    }
  }
  IFC42.IfcCondenserType = IfcCondenserType;
  class IfcConstructionEquipmentResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 3898045240;
    }
  }
  IFC42.IfcConstructionEquipmentResource = IfcConstructionEquipmentResource;
  class IfcConstructionMaterialResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 1060000209;
    }
  }
  IFC42.IfcConstructionMaterialResource = IfcConstructionMaterialResource;
  class IfcConstructionProductResource extends IfcConstructionResource {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.Identification = Identification;
      this.LongDescription = LongDescription;
      this.Usage = Usage;
      this.BaseCosts = BaseCosts;
      this.BaseQuantity = BaseQuantity;
      this.PredefinedType = PredefinedType;
      this.type = 488727124;
    }
  }
  IFC42.IfcConstructionProductResource = IfcConstructionProductResource;
  class IfcCooledBeamType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 335055490;
    }
  }
  IFC42.IfcCooledBeamType = IfcCooledBeamType;
  class IfcCoolingTowerType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2954562838;
    }
  }
  IFC42.IfcCoolingTowerType = IfcCoolingTowerType;
  class IfcCovering extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1973544240;
    }
  }
  IFC42.IfcCovering = IfcCovering;
  class IfcCurtainWall extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3495092785;
    }
  }
  IFC42.IfcCurtainWall = IfcCurtainWall;
  class IfcDamperType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3961806047;
    }
  }
  IFC42.IfcDamperType = IfcDamperType;
  class IfcDiscreteAccessory extends IfcElementComponent {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1335981549;
    }
  }
  IFC42.IfcDiscreteAccessory = IfcDiscreteAccessory;
  class IfcDiscreteAccessoryType extends IfcElementComponentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2635815018;
    }
  }
  IFC42.IfcDiscreteAccessoryType = IfcDiscreteAccessoryType;
  class IfcDistributionChamberElementType extends IfcDistributionFlowElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1599208980;
    }
  }
  IFC42.IfcDistributionChamberElementType = IfcDistributionChamberElementType;
  class IfcDistributionControlElementType extends IfcDistributionElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.type = 2063403501;
    }
  }
  IFC42.IfcDistributionControlElementType = IfcDistributionControlElementType;
  class IfcDistributionElement extends IfcElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1945004755;
    }
  }
  IFC42.IfcDistributionElement = IfcDistributionElement;
  class IfcDistributionFlowElement extends IfcDistributionElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3040386961;
    }
  }
  IFC42.IfcDistributionFlowElement = IfcDistributionFlowElement;
  class IfcDistributionPort extends IfcPort {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, FlowDirection, PredefinedType, SystemType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.FlowDirection = FlowDirection;
      this.PredefinedType = PredefinedType;
      this.SystemType = SystemType;
      this.type = 3041715199;
    }
  }
  IFC42.IfcDistributionPort = IfcDistributionPort;
  class IfcDistributionSystem extends IfcSystem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.PredefinedType = PredefinedType;
      this.type = 3205830791;
    }
  }
  IFC42.IfcDistributionSystem = IfcDistributionSystem;
  class IfcDoor extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, OperationType, UserDefinedOperationType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OverallHeight = OverallHeight;
      this.OverallWidth = OverallWidth;
      this.PredefinedType = PredefinedType;
      this.OperationType = OperationType;
      this.UserDefinedOperationType = UserDefinedOperationType;
      this.type = 395920057;
    }
  }
  IFC42.IfcDoor = IfcDoor;
  class IfcDoorStandardCase extends IfcDoor {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, OperationType, UserDefinedOperationType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, OperationType, UserDefinedOperationType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OverallHeight = OverallHeight;
      this.OverallWidth = OverallWidth;
      this.PredefinedType = PredefinedType;
      this.OperationType = OperationType;
      this.UserDefinedOperationType = UserDefinedOperationType;
      this.type = 3242481149;
    }
  }
  IFC42.IfcDoorStandardCase = IfcDoorStandardCase;
  class IfcDuctFittingType extends IfcFlowFittingType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 869906466;
    }
  }
  IFC42.IfcDuctFittingType = IfcDuctFittingType;
  class IfcDuctSegmentType extends IfcFlowSegmentType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3760055223;
    }
  }
  IFC42.IfcDuctSegmentType = IfcDuctSegmentType;
  class IfcDuctSilencerType extends IfcFlowTreatmentDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2030761528;
    }
  }
  IFC42.IfcDuctSilencerType = IfcDuctSilencerType;
  class IfcElectricApplianceType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 663422040;
    }
  }
  IFC42.IfcElectricApplianceType = IfcElectricApplianceType;
  class IfcElectricDistributionBoardType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2417008758;
    }
  }
  IFC42.IfcElectricDistributionBoardType = IfcElectricDistributionBoardType;
  class IfcElectricFlowStorageDeviceType extends IfcFlowStorageDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3277789161;
    }
  }
  IFC42.IfcElectricFlowStorageDeviceType = IfcElectricFlowStorageDeviceType;
  class IfcElectricGeneratorType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1534661035;
    }
  }
  IFC42.IfcElectricGeneratorType = IfcElectricGeneratorType;
  class IfcElectricMotorType extends IfcEnergyConversionDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1217240411;
    }
  }
  IFC42.IfcElectricMotorType = IfcElectricMotorType;
  class IfcElectricTimeControlType extends IfcFlowControllerType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 712377611;
    }
  }
  IFC42.IfcElectricTimeControlType = IfcElectricTimeControlType;
  class IfcEnergyConversionDevice extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1658829314;
    }
  }
  IFC42.IfcEnergyConversionDevice = IfcEnergyConversionDevice;
  class IfcEngine extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2814081492;
    }
  }
  IFC42.IfcEngine = IfcEngine;
  class IfcEvaporativeCooler extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3747195512;
    }
  }
  IFC42.IfcEvaporativeCooler = IfcEvaporativeCooler;
  class IfcEvaporator extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 484807127;
    }
  }
  IFC42.IfcEvaporator = IfcEvaporator;
  class IfcExternalSpatialElement extends IfcExternalSpatialStructureElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.LongName = LongName;
      this.PredefinedType = PredefinedType;
      this.type = 1209101575;
    }
  }
  IFC42.IfcExternalSpatialElement = IfcExternalSpatialElement;
  class IfcFanType extends IfcFlowMovingDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 346874300;
    }
  }
  IFC42.IfcFanType = IfcFanType;
  class IfcFilterType extends IfcFlowTreatmentDeviceType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1810631287;
    }
  }
  IFC42.IfcFilterType = IfcFilterType;
  class IfcFireSuppressionTerminalType extends IfcFlowTerminalType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4222183408;
    }
  }
  IFC42.IfcFireSuppressionTerminalType = IfcFireSuppressionTerminalType;
  class IfcFlowController extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2058353004;
    }
  }
  IFC42.IfcFlowController = IfcFlowController;
  class IfcFlowFitting extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 4278956645;
    }
  }
  IFC42.IfcFlowFitting = IfcFlowFitting;
  class IfcFlowInstrumentType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 4037862832;
    }
  }
  IFC42.IfcFlowInstrumentType = IfcFlowInstrumentType;
  class IfcFlowMeter extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2188021234;
    }
  }
  IFC42.IfcFlowMeter = IfcFlowMeter;
  class IfcFlowMovingDevice extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3132237377;
    }
  }
  IFC42.IfcFlowMovingDevice = IfcFlowMovingDevice;
  class IfcFlowSegment extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 987401354;
    }
  }
  IFC42.IfcFlowSegment = IfcFlowSegment;
  class IfcFlowStorageDevice extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 707683696;
    }
  }
  IFC42.IfcFlowStorageDevice = IfcFlowStorageDevice;
  class IfcFlowTerminal extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 2223149337;
    }
  }
  IFC42.IfcFlowTerminal = IfcFlowTerminal;
  class IfcFlowTreatmentDevice extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 3508470533;
    }
  }
  IFC42.IfcFlowTreatmentDevice = IfcFlowTreatmentDevice;
  class IfcFooting extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 900683007;
    }
  }
  IFC42.IfcFooting = IfcFooting;
  class IfcHeatExchanger extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3319311131;
    }
  }
  IFC42.IfcHeatExchanger = IfcHeatExchanger;
  class IfcHumidifier extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2068733104;
    }
  }
  IFC42.IfcHumidifier = IfcHumidifier;
  class IfcInterceptor extends IfcFlowTreatmentDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4175244083;
    }
  }
  IFC42.IfcInterceptor = IfcInterceptor;
  class IfcJunctionBox extends IfcFlowFitting {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2176052936;
    }
  }
  IFC42.IfcJunctionBox = IfcJunctionBox;
  class IfcLamp extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 76236018;
    }
  }
  IFC42.IfcLamp = IfcLamp;
  class IfcLightFixture extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 629592764;
    }
  }
  IFC42.IfcLightFixture = IfcLightFixture;
  class IfcMedicalDevice extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1437502449;
    }
  }
  IFC42.IfcMedicalDevice = IfcMedicalDevice;
  class IfcMember extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1073191201;
    }
  }
  IFC42.IfcMember = IfcMember;
  class IfcMemberStandardCase extends IfcMember {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1911478936;
    }
  }
  IFC42.IfcMemberStandardCase = IfcMemberStandardCase;
  class IfcMotorConnection extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2474470126;
    }
  }
  IFC42.IfcMotorConnection = IfcMotorConnection;
  class IfcOuterBoundaryCurve extends IfcBoundaryCurve {
    constructor(expressID, Segments, SelfIntersect) {
      super(expressID, Segments, SelfIntersect);
      this.Segments = Segments;
      this.SelfIntersect = SelfIntersect;
      this.type = 144952367;
    }
  }
  IFC42.IfcOuterBoundaryCurve = IfcOuterBoundaryCurve;
  class IfcOutlet extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3694346114;
    }
  }
  IFC42.IfcOutlet = IfcOutlet;
  class IfcPile extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType, ConstructionType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.ConstructionType = ConstructionType;
      this.type = 1687234759;
    }
  }
  IFC42.IfcPile = IfcPile;
  class IfcPipeFitting extends IfcFlowFitting {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 310824031;
    }
  }
  IFC42.IfcPipeFitting = IfcPipeFitting;
  class IfcPipeSegment extends IfcFlowSegment {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3612865200;
    }
  }
  IFC42.IfcPipeSegment = IfcPipeSegment;
  class IfcPlate extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3171933400;
    }
  }
  IFC42.IfcPlate = IfcPlate;
  class IfcPlateStandardCase extends IfcPlate {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1156407060;
    }
  }
  IFC42.IfcPlateStandardCase = IfcPlateStandardCase;
  class IfcProtectiveDevice extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 738039164;
    }
  }
  IFC42.IfcProtectiveDevice = IfcProtectiveDevice;
  class IfcProtectiveDeviceTrippingUnitType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 655969474;
    }
  }
  IFC42.IfcProtectiveDeviceTrippingUnitType = IfcProtectiveDeviceTrippingUnitType;
  class IfcPump extends IfcFlowMovingDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 90941305;
    }
  }
  IFC42.IfcPump = IfcPump;
  class IfcRailing extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2262370178;
    }
  }
  IFC42.IfcRailing = IfcRailing;
  class IfcRamp extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3024970846;
    }
  }
  IFC42.IfcRamp = IfcRamp;
  class IfcRampFlight extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3283111854;
    }
  }
  IFC42.IfcRampFlight = IfcRampFlight;
  class IfcRationalBSplineCurveWithKnots extends IfcBSplineCurveWithKnots {
    constructor(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec, WeightsData) {
      super(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec);
      this.Degree = Degree;
      this.ControlPointsList = ControlPointsList;
      this.CurveForm = CurveForm;
      this.ClosedCurve = ClosedCurve;
      this.SelfIntersect = SelfIntersect;
      this.KnotMultiplicities = KnotMultiplicities;
      this.Knots = Knots;
      this.KnotSpec = KnotSpec;
      this.WeightsData = WeightsData;
      this.type = 1232101972;
    }
  }
  IFC42.IfcRationalBSplineCurveWithKnots = IfcRationalBSplineCurveWithKnots;
  class IfcReinforcingBar extends IfcReinforcingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, NominalDiameter, CrossSectionArea, BarLength, PredefinedType, BarSurface) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.SteelGrade = SteelGrade;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.BarLength = BarLength;
      this.PredefinedType = PredefinedType;
      this.BarSurface = BarSurface;
      this.type = 979691226;
    }
  }
  IFC42.IfcReinforcingBar = IfcReinforcingBar;
  class IfcReinforcingBarType extends IfcReinforcingElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, CrossSectionArea, BarLength, BarSurface, BendingShapeCode, BendingParameters) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.NominalDiameter = NominalDiameter;
      this.CrossSectionArea = CrossSectionArea;
      this.BarLength = BarLength;
      this.BarSurface = BarSurface;
      this.BendingShapeCode = BendingShapeCode;
      this.BendingParameters = BendingParameters;
      this.type = 2572171363;
    }
  }
  IFC42.IfcReinforcingBarType = IfcReinforcingBarType;
  class IfcRoof extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2016517767;
    }
  }
  IFC42.IfcRoof = IfcRoof;
  class IfcSanitaryTerminal extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3053780830;
    }
  }
  IFC42.IfcSanitaryTerminal = IfcSanitaryTerminal;
  class IfcSensorType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 1783015770;
    }
  }
  IFC42.IfcSensorType = IfcSensorType;
  class IfcShadingDevice extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1329646415;
    }
  }
  IFC42.IfcShadingDevice = IfcShadingDevice;
  class IfcSlab extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1529196076;
    }
  }
  IFC42.IfcSlab = IfcSlab;
  class IfcSlabElementedCase extends IfcSlab {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3127900445;
    }
  }
  IFC42.IfcSlabElementedCase = IfcSlabElementedCase;
  class IfcSlabStandardCase extends IfcSlab {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3027962421;
    }
  }
  IFC42.IfcSlabStandardCase = IfcSlabStandardCase;
  class IfcSolarDevice extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3420628829;
    }
  }
  IFC42.IfcSolarDevice = IfcSolarDevice;
  class IfcSpaceHeater extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1999602285;
    }
  }
  IFC42.IfcSpaceHeater = IfcSpaceHeater;
  class IfcStackTerminal extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1404847402;
    }
  }
  IFC42.IfcStackTerminal = IfcStackTerminal;
  class IfcStair extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 331165859;
    }
  }
  IFC42.IfcStair = IfcStair;
  class IfcStairFlight extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NumberOfRisers, NumberOfTreads, RiserHeight, TreadLength, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.NumberOfRisers = NumberOfRisers;
      this.NumberOfTreads = NumberOfTreads;
      this.RiserHeight = RiserHeight;
      this.TreadLength = TreadLength;
      this.PredefinedType = PredefinedType;
      this.type = 4252922144;
    }
  }
  IFC42.IfcStairFlight = IfcStairFlight;
  class IfcStructuralAnalysisModel extends IfcSystem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, OrientationOf2DPlane, LoadedBy, HasResults, SharedPlacement) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.OrientationOf2DPlane = OrientationOf2DPlane;
      this.LoadedBy = LoadedBy;
      this.HasResults = HasResults;
      this.SharedPlacement = SharedPlacement;
      this.type = 2515109513;
    }
  }
  IFC42.IfcStructuralAnalysisModel = IfcStructuralAnalysisModel;
  class IfcStructuralLoadCase extends IfcStructuralLoadGroup {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose, SelfWeightCoefficients) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.PredefinedType = PredefinedType;
      this.ActionType = ActionType;
      this.ActionSource = ActionSource;
      this.Coefficient = Coefficient;
      this.Purpose = Purpose;
      this.SelfWeightCoefficients = SelfWeightCoefficients;
      this.type = 385403989;
    }
  }
  IFC42.IfcStructuralLoadCase = IfcStructuralLoadCase;
  class IfcStructuralPlanarAction extends IfcStructuralSurfaceAction {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.AppliedLoad = AppliedLoad;
      this.GlobalOrLocal = GlobalOrLocal;
      this.DestabilizingLoad = DestabilizingLoad;
      this.ProjectedOrTrue = ProjectedOrTrue;
      this.PredefinedType = PredefinedType;
      this.type = 1621171031;
    }
  }
  IFC42.IfcStructuralPlanarAction = IfcStructuralPlanarAction;
  class IfcSwitchingDevice extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1162798199;
    }
  }
  IFC42.IfcSwitchingDevice = IfcSwitchingDevice;
  class IfcTank extends IfcFlowStorageDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 812556717;
    }
  }
  IFC42.IfcTank = IfcTank;
  class IfcTransformer extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3825984169;
    }
  }
  IFC42.IfcTransformer = IfcTransformer;
  class IfcTubeBundle extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3026737570;
    }
  }
  IFC42.IfcTubeBundle = IfcTubeBundle;
  class IfcUnitaryControlElementType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3179687236;
    }
  }
  IFC42.IfcUnitaryControlElementType = IfcUnitaryControlElementType;
  class IfcUnitaryEquipment extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4292641817;
    }
  }
  IFC42.IfcUnitaryEquipment = IfcUnitaryEquipment;
  class IfcValve extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4207607924;
    }
  }
  IFC42.IfcValve = IfcValve;
  class IfcWall extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2391406946;
    }
  }
  IFC42.IfcWall = IfcWall;
  class IfcWallElementedCase extends IfcWall {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4156078855;
    }
  }
  IFC42.IfcWallElementedCase = IfcWallElementedCase;
  class IfcWallStandardCase extends IfcWall {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3512223829;
    }
  }
  IFC42.IfcWallStandardCase = IfcWallStandardCase;
  class IfcWasteTerminal extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4237592921;
    }
  }
  IFC42.IfcWasteTerminal = IfcWasteTerminal;
  class IfcWindow extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, PartitioningType, UserDefinedPartitioningType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OverallHeight = OverallHeight;
      this.OverallWidth = OverallWidth;
      this.PredefinedType = PredefinedType;
      this.PartitioningType = PartitioningType;
      this.UserDefinedPartitioningType = UserDefinedPartitioningType;
      this.type = 3304561284;
    }
  }
  IFC42.IfcWindow = IfcWindow;
  class IfcWindowStandardCase extends IfcWindow {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, PartitioningType, UserDefinedPartitioningType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, PartitioningType, UserDefinedPartitioningType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.OverallHeight = OverallHeight;
      this.OverallWidth = OverallWidth;
      this.PredefinedType = PredefinedType;
      this.PartitioningType = PartitioningType;
      this.UserDefinedPartitioningType = UserDefinedPartitioningType;
      this.type = 486154966;
    }
  }
  IFC42.IfcWindowStandardCase = IfcWindowStandardCase;
  class IfcActuatorType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 2874132201;
    }
  }
  IFC42.IfcActuatorType = IfcActuatorType;
  class IfcAirTerminal extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1634111441;
    }
  }
  IFC42.IfcAirTerminal = IfcAirTerminal;
  class IfcAirTerminalBox extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 177149247;
    }
  }
  IFC42.IfcAirTerminalBox = IfcAirTerminalBox;
  class IfcAirToAirHeatRecovery extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2056796094;
    }
  }
  IFC42.IfcAirToAirHeatRecovery = IfcAirToAirHeatRecovery;
  class IfcAlarmType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 3001207471;
    }
  }
  IFC42.IfcAlarmType = IfcAlarmType;
  class IfcAudioVisualAppliance extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 277319702;
    }
  }
  IFC42.IfcAudioVisualAppliance = IfcAudioVisualAppliance;
  class IfcBeam extends IfcBuildingElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 753842376;
    }
  }
  IFC42.IfcBeam = IfcBeam;
  class IfcBeamStandardCase extends IfcBeam {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2906023776;
    }
  }
  IFC42.IfcBeamStandardCase = IfcBeamStandardCase;
  class IfcBoiler extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 32344328;
    }
  }
  IFC42.IfcBoiler = IfcBoiler;
  class IfcBurner extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2938176219;
    }
  }
  IFC42.IfcBurner = IfcBurner;
  class IfcCableCarrierFitting extends IfcFlowFitting {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 635142910;
    }
  }
  IFC42.IfcCableCarrierFitting = IfcCableCarrierFitting;
  class IfcCableCarrierSegment extends IfcFlowSegment {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3758799889;
    }
  }
  IFC42.IfcCableCarrierSegment = IfcCableCarrierSegment;
  class IfcCableFitting extends IfcFlowFitting {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1051757585;
    }
  }
  IFC42.IfcCableFitting = IfcCableFitting;
  class IfcCableSegment extends IfcFlowSegment {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4217484030;
    }
  }
  IFC42.IfcCableSegment = IfcCableSegment;
  class IfcChiller extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3902619387;
    }
  }
  IFC42.IfcChiller = IfcChiller;
  class IfcCoil extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 639361253;
    }
  }
  IFC42.IfcCoil = IfcCoil;
  class IfcCommunicationsAppliance extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3221913625;
    }
  }
  IFC42.IfcCommunicationsAppliance = IfcCommunicationsAppliance;
  class IfcCompressor extends IfcFlowMovingDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3571504051;
    }
  }
  IFC42.IfcCompressor = IfcCompressor;
  class IfcCondenser extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2272882330;
    }
  }
  IFC42.IfcCondenser = IfcCondenser;
  class IfcControllerType extends IfcDistributionControlElementType {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ApplicableOccurrence = ApplicableOccurrence;
      this.HasPropertySets = HasPropertySets;
      this.RepresentationMaps = RepresentationMaps;
      this.Tag = Tag;
      this.ElementType = ElementType;
      this.PredefinedType = PredefinedType;
      this.type = 578613899;
    }
  }
  IFC42.IfcControllerType = IfcControllerType;
  class IfcCooledBeam extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4136498852;
    }
  }
  IFC42.IfcCooledBeam = IfcCooledBeam;
  class IfcCoolingTower extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3640358203;
    }
  }
  IFC42.IfcCoolingTower = IfcCoolingTower;
  class IfcDamper extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4074379575;
    }
  }
  IFC42.IfcDamper = IfcDamper;
  class IfcDistributionChamberElement extends IfcDistributionFlowElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1052013943;
    }
  }
  IFC42.IfcDistributionChamberElement = IfcDistributionChamberElement;
  class IfcDistributionCircuit extends IfcDistributionSystem {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.LongName = LongName;
      this.PredefinedType = PredefinedType;
      this.type = 562808652;
    }
  }
  IFC42.IfcDistributionCircuit = IfcDistributionCircuit;
  class IfcDistributionControlElement extends IfcDistributionElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.type = 1062813311;
    }
  }
  IFC42.IfcDistributionControlElement = IfcDistributionControlElement;
  class IfcDuctFitting extends IfcFlowFitting {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 342316401;
    }
  }
  IFC42.IfcDuctFitting = IfcDuctFitting;
  class IfcDuctSegment extends IfcFlowSegment {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3518393246;
    }
  }
  IFC42.IfcDuctSegment = IfcDuctSegment;
  class IfcDuctSilencer extends IfcFlowTreatmentDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1360408905;
    }
  }
  IFC42.IfcDuctSilencer = IfcDuctSilencer;
  class IfcElectricAppliance extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1904799276;
    }
  }
  IFC42.IfcElectricAppliance = IfcElectricAppliance;
  class IfcElectricDistributionBoard extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 862014818;
    }
  }
  IFC42.IfcElectricDistributionBoard = IfcElectricDistributionBoard;
  class IfcElectricFlowStorageDevice extends IfcFlowStorageDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3310460725;
    }
  }
  IFC42.IfcElectricFlowStorageDevice = IfcElectricFlowStorageDevice;
  class IfcElectricGenerator extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 264262732;
    }
  }
  IFC42.IfcElectricGenerator = IfcElectricGenerator;
  class IfcElectricMotor extends IfcEnergyConversionDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 402227799;
    }
  }
  IFC42.IfcElectricMotor = IfcElectricMotor;
  class IfcElectricTimeControl extends IfcFlowController {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1003880860;
    }
  }
  IFC42.IfcElectricTimeControl = IfcElectricTimeControl;
  class IfcFan extends IfcFlowMovingDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3415622556;
    }
  }
  IFC42.IfcFan = IfcFan;
  class IfcFilter extends IfcFlowTreatmentDevice {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 819412036;
    }
  }
  IFC42.IfcFilter = IfcFilter;
  class IfcFireSuppressionTerminal extends IfcFlowTerminal {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 1426591983;
    }
  }
  IFC42.IfcFireSuppressionTerminal = IfcFireSuppressionTerminal;
  class IfcFlowInstrument extends IfcDistributionControlElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 182646315;
    }
  }
  IFC42.IfcFlowInstrument = IfcFlowInstrument;
  class IfcProtectiveDeviceTrippingUnit extends IfcDistributionControlElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 2295281155;
    }
  }
  IFC42.IfcProtectiveDeviceTrippingUnit = IfcProtectiveDeviceTrippingUnit;
  class IfcSensor extends IfcDistributionControlElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4086658281;
    }
  }
  IFC42.IfcSensor = IfcSensor;
  class IfcUnitaryControlElement extends IfcDistributionControlElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 630975310;
    }
  }
  IFC42.IfcUnitaryControlElement = IfcUnitaryControlElement;
  class IfcActuator extends IfcDistributionControlElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 4288193352;
    }
  }
  IFC42.IfcActuator = IfcActuator;
  class IfcAlarm extends IfcDistributionControlElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 3087945054;
    }
  }
  IFC42.IfcAlarm = IfcAlarm;
  class IfcController extends IfcDistributionControlElement {
    constructor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      super(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      this.GlobalId = GlobalId;
      this.OwnerHistory = OwnerHistory;
      this.Name = Name;
      this.Description = Description;
      this.ObjectType = ObjectType;
      this.ObjectPlacement = ObjectPlacement;
      this.Representation = Representation;
      this.Tag = Tag;
      this.PredefinedType = PredefinedType;
      this.type = 25142252;
    }
  }
  IFC42.IfcController = IfcController;
})(IFC4 || (IFC4 = {}));

// dist/helpers/properties.ts
var PropsNames = {
  aggregates: {
    name: IFCRELAGGREGATES,
    relating: "RelatingObject",
    related: "RelatedObjects",
    key: "children"
  },
  spatial: {
    name: IFCRELCONTAINEDINSPATIALSTRUCTURE,
    relating: "RelatingStructure",
    related: "RelatedElements",
    key: "children"
  },
  psets: {
    name: IFCRELDEFINESBYPROPERTIES,
    relating: "RelatingPropertyDefinition",
    related: "RelatedObjects",
    key: "IsDefinedBy"
  },
  materials: {
    name: IFCRELASSOCIATESMATERIAL,
    relating: "RelatingMaterial",
    related: "RelatedObjects",
    key: "HasAssociations"
  },
  type: {
    name: IFCRELDEFINESBYTYPE,
    relating: "RelatingType",
    related: "RelatedObjects",
    key: "IsDefinedBy"
  }
};
var Properties = class {
  constructor(api) {
    this.api = api;
  }
  getItemProperties(modelID, id, recursive = false, inverse = false) {
    return __async(this, null, function* () {
      return this.api.GetLine(modelID, id, recursive, inverse);
    });
  }
  getPropertySets(modelID, elementID = 0, recursive = false) {
    return __async(this, null, function* () {
      return yield this.getRelatedProperties(modelID, elementID, PropsNames.psets, recursive);
    });
  }
  setPropertySets(modelID, elementID, psetID) {
    return __async(this, null, function* () {
      return this.setItemProperties(modelID, elementID, psetID, PropsNames.psets);
    });
  }
  getTypeProperties(modelID, elementID, recursive = false) {
    return __async(this, null, function* () {
      if (this.api.GetModelSchema(modelID) == "IFX2X3") {
        return yield this.getRelatedProperties(modelID, elementID, PropsNames.type, recursive);
      } else {
        return yield this.getRelatedProperties(modelID, elementID, __spreadProps(__spreadValues({}, PropsNames.type), { key: "IsTypedBy" }), recursive);
      }
    });
  }
  getMaterialsProperties(modelID, elementID = 0, recursive = false) {
    return __async(this, null, function* () {
      return yield this.getRelatedProperties(modelID, elementID, PropsNames.materials, recursive);
    });
  }
  setMaterialsProperties(modelID, elementID, materialID) {
    return __async(this, null, function* () {
      return this.setItemProperties(modelID, elementID, materialID, PropsNames.materials);
    });
  }
  getSpatialStructure(modelID, includeProperties = false) {
    return __async(this, null, function* () {
      const chunks = yield this.getSpatialTreeChunks(modelID);
      const allLines = yield this.api.GetLineIDsWithType(modelID, IFCPROJECT);
      const projectID = allLines.get(0);
      const project = Properties.newIfcProject(projectID);
      yield this.getSpatialNode(modelID, project, chunks, includeProperties);
      return project;
    });
  }
  getRelatedProperties(modelID, elementID, propsName, recursive = false) {
    return __async(this, null, function* () {
      const result = [];
      let rels = null;
      if (elementID !== 0)
        rels = yield this.api.GetLine(modelID, elementID, false, true)[propsName.key];
      else {
        let vec = this.api.GetLineIDsWithType(modelID, propsName.name);
        rels = [];
        for (let i = 0; i < vec.size(); ++i)
          rels.push({ value: vec.get(i) });
      }
      if (rels == null)
        return result;
      if (!Array.isArray(rels))
        rels = [rels];
      for (let i = 0; i < rels.length; i++) {
        let propSetIds = yield this.api.GetLine(modelID, rels[i].value, false, false)[propsName.relating];
        if (propSetIds == null)
          continue;
        if (!Array.isArray(propSetIds))
          propSetIds = [propSetIds];
        for (let x = 0; x < propSetIds.length; x++) {
          result.push(yield this.api.GetLine(modelID, propSetIds[x].value, recursive));
        }
      }
      return result;
    });
  }
  getChunks(modelID, chunks, propNames) {
    return __async(this, null, function* () {
      const relation = yield this.api.GetLineIDsWithType(modelID, propNames.name, true);
      for (let i = 0; i < relation.size(); i++) {
        const rel = yield this.api.GetLine(modelID, relation.get(i), false);
        this.saveChunk(chunks, propNames, rel);
      }
    });
  }
  static newIfcProject(id) {
    return {
      expressID: id,
      type: "IFCPROJECT",
      children: []
    };
  }
  getSpatialNode(modelID, node, treeChunks, includeProperties) {
    return __async(this, null, function* () {
      yield this.getChildren(modelID, node, treeChunks, PropsNames.aggregates, includeProperties);
      yield this.getChildren(modelID, node, treeChunks, PropsNames.spatial, includeProperties);
    });
  }
  getChildren(modelID, node, treeChunks, propNames, includeProperties) {
    return __async(this, null, function* () {
      const children = treeChunks[node.expressID];
      if (children == void 0)
        return;
      const prop = propNames.key;
      const nodes = [];
      for (let i = 0; i < children.length; i++) {
        const child = children[i];
        let node2 = this.newNode(child, this.api.GetLineType(modelID, child));
        if (includeProperties) {
          const properties = yield this.getItemProperties(modelID, node2.expressID);
          node2 = __spreadValues(__spreadValues({}, properties), node2);
        }
        yield this.getSpatialNode(modelID, node2, treeChunks, includeProperties);
        nodes.push(node2);
      }
      node[prop] = nodes;
    });
  }
  newNode(id, type) {
    return {
      expressID: id,
      type: this.api.GetNameFromTypeCode(type),
      children: []
    };
  }
  getSpatialTreeChunks(modelID) {
    return __async(this, null, function* () {
      const treeChunks = {};
      yield this.getChunks(modelID, treeChunks, PropsNames.aggregates);
      yield this.getChunks(modelID, treeChunks, PropsNames.spatial);
      return treeChunks;
    });
  }
  saveChunk(chunks, propNames, rel) {
    const relating = rel[propNames.relating].value;
    const related = rel[propNames.related].map((r) => r.value);
    if (chunks[relating] == void 0) {
      chunks[relating] = related;
    } else {
      chunks[relating] = chunks[relating].concat(related);
    }
  }
  setItemProperties(modelID, elementID, propID, propsName) {
    return __async(this, null, function* () {
      if (!Array.isArray(elementID))
        elementID = [elementID];
      if (!Array.isArray(propID))
        propID = [propID];
      let foundRel = 0;
      const rels = [];
      const elements = [];
      for (const elID of elementID) {
        const element = yield this.api.GetLine(modelID, elID, false, true);
        if (!element[propsName.key])
          continue;
        elements.push(element);
      }
      if (elements.length < 1)
        return false;
      const relations = this.api.GetLineIDsWithType(modelID, propsName.name);
      for (let i = 0; i < relations.size(); ++i) {
        const rel = yield this.api.GetLine(modelID, relations.get(i));
        if (propID.includes(Number(rel[propsName.relating].value))) {
          rels.push(rel);
          foundRel++;
        }
        if (foundRel == propID.length)
          break;
      }
      for (const element of elements) {
        for (const rel of rels) {
          if (!element[propsName.key].some((e) => e.value === rel.expressID))
            element[propsName.key].push({ type: 5, value: rel.expressID });
          if (!rel[propsName.related].some((e) => e.value === element.expressID)) {
            rel[propsName.related].push({ type: 5, value: element.expressID });
            this.api.WriteLine(modelID, rel);
          }
        }
        this.api.WriteLine(modelID, element);
      }
      return true;
    });
  }
};

// dist/helpers/log.ts
var LogLevel;
(function(LogLevel2) {
  LogLevel2[LogLevel2["LOG_LEVEL_DEBUG"] = 0] = "LOG_LEVEL_DEBUG";
  LogLevel2[LogLevel2["LOG_LEVEL_INFO"] = 1] = "LOG_LEVEL_INFO";
  LogLevel2[LogLevel2["LOG_LEVEL_WARN"] = 2] = "LOG_LEVEL_WARN";
  LogLevel2[LogLevel2["LOG_LEVEL_ERROR"] = 3] = "LOG_LEVEL_ERROR";
  LogLevel2[LogLevel2["LOG_LEVEL_OFF"] = 4] = "LOG_LEVEL_OFF";
})(LogLevel || (LogLevel = {}));
var Log = class {
  static setLogLevel(level) {
    this.logLevel = level;
  }
  static log(msg, ...args) {
    if (this.logLevel <= 3) {
      console.log(msg, ...args);
    }
  }
  static debug(msg, ...args) {
    if (this.logLevel <= 0) {
      console.trace("DEBUG: ", msg, ...args);
    }
  }
  static info(msg, ...args) {
    if (this.logLevel <= 1) {
      console.info("INFO: ", msg, ...args);
    }
  }
  static warn(msg, ...args) {
    if (this.logLevel <= 2) {
      console.warn("WARN: ", msg, ...args);
    }
  }
  static error(msg, ...args) {
    if (this.logLevel <= 3) {
      console.error("ERROR: ", msg, ...args);
    }
  }
};
Log.logLevel = 1;

// dist/web-ifc-api.ts
var WebIFCWasm;
if (typeof self !== "undefined" && self.crossOriginIsolated) {
  try {
    WebIFCWasm = require_web_ifc_mt();
  } catch (ex) {
    WebIFCWasm = require_web_ifc();
  }
} else {
  WebIFCWasm = require_web_ifc();
}
var UNKNOWN = 0;
var STRING = 1;
var LABEL = 2;
var ENUM = 3;
var REAL = 4;
var REF = 5;
var EMPTY = 6;
var SET_BEGIN = 7;
var SET_END = 8;
var LINE_END = 9;
function ms() {
  return new Date().getTime();
}
var IfcAPI2 = class {
  constructor() {
    this.wasmModule = void 0;
    this.wasmPath = "";
    this.isWasmPathAbsolute = false;
    this.modelSchemaList = [];
    this.ifcGuidMap = new Map();
    this.properties = new Properties(this);
  }
  Init(customLocateFileHandler) {
    return __async(this, null, function* () {
      if (WebIFCWasm) {
        let locateFileHandler = (path, prefix) => {
          if (path.endsWith(".wasm")) {
            if (this.isWasmPathAbsolute) {
              return this.wasmPath + path;
            }
            return prefix + this.wasmPath + path;
          }
          return prefix + path;
        };
        this.wasmModule = yield WebIFCWasm({ noInitialRun: true, locateFile: customLocateFileHandler || locateFileHandler });
      } else {
        Log.error(`Could not find wasm module at './web-ifc' from web-ifc-api.ts`);
      }
    });
  }
  OpenModels(dataSets, settings) {
    let s = __spreadValues({
      MEMORY_LIMIT: 3221225472
    }, settings);
    s.MEMORY_LIMIT = s.MEMORY_LIMIT / dataSets.length;
    let modelIDs = [];
    for (let dataSet of dataSets)
      modelIDs.push(this.OpenModel(dataSet, s));
    return modelIDs;
  }
  OpenModel(data, settings) {
    let s = __spreadValues({
      COORDINATE_TO_ORIGIN: false,
      USE_FAST_BOOLS: true,
      CIRCLE_SEGMENTS_LOW: 5,
      CIRCLE_SEGMENTS_MEDIUM: 8,
      CIRCLE_SEGMENTS_HIGH: 12,
      BOOL_ABORT_THRESHOLD: 1e4,
      TAPE_SIZE: 67108864,
      MEMORY_LIMIT: 3221225472
    }, settings);
    let result = this.wasmModule.OpenModel(s, (destPtr, offsetInSrc, destSize) => {
      let srcSize = Math.min(data.byteLength - offsetInSrc, destSize);
      let dest = this.wasmModule.HEAPU8.subarray(destPtr, destPtr + srcSize);
      let src = data.subarray(offsetInSrc, offsetInSrc + srcSize);
      dest.set(src);
      return srcSize;
    });
    this.modelSchemaList[result] = SchemaNames.indexOf(this.GetHeaderLine(result, FILE_SCHEMA).arguments[0][0].value);
    Log.info("Parsing Model using " + this.GetHeaderLine(result, FILE_SCHEMA).arguments[0][0].value + " Schema");
    return result;
  }
  GetModelSchema(modelID) {
    return SchemaNames[this.modelSchemaList[modelID]];
  }
  CreateModel(model, settings) {
    var _a, _b, _c;
    let s = __spreadValues({
      COORDINATE_TO_ORIGIN: false,
      USE_FAST_BOOLS: true,
      CIRCLE_SEGMENTS_LOW: 5,
      CIRCLE_SEGMENTS_MEDIUM: 8,
      CIRCLE_SEGMENTS_HIGH: 12,
      BOOL_ABORT_THRESHOLD: 1e4,
      TAPE_SIZE: 67108864,
      MEMORY_LIMIT: 3221225472
    }, settings);
    let result = this.wasmModule.CreateModel(s);
    this.modelSchemaList[result] = SchemaNames.indexOf(model.schema);
    const modelName = model.name || "web-ifc-model-" + result + ".ifc";
    const timestamp = new Date().toISOString().slice(0, 19);
    const description = ((_a = model.description) == null ? void 0 : _a.map((d) => ({ type: STRING, value: d }))) || [{ type: STRING, value: "ViewDefinition [CoordinationView]" }];
    const authors = ((_b = model.authors) == null ? void 0 : _b.map((a) => ({ type: STRING, value: a }))) || [null];
    const orgs = ((_c = model.organizations) == null ? void 0 : _c.map((o) => ({ type: STRING, value: o }))) || [null];
    const auth = model.authorization ? { type: STRING, value: model.authorization } : null;
    this.wasmModule.WriteHeaderLine(result, FILE_DESCRIPTION, [
      description,
      { type: STRING, value: "2;1" }
    ]);
    this.wasmModule.WriteHeaderLine(result, FILE_NAME, [
      { type: STRING, value: modelName },
      { type: STRING, value: timestamp },
      authors,
      orgs,
      { type: STRING, value: "ifcjs/web-ifc-api" },
      { type: STRING, value: "ifcjs/web-ifc-api" },
      auth
    ]);
    this.wasmModule.WriteHeaderLine(result, FILE_SCHEMA, [[{ type: STRING, value: model.schema }]]);
    return result;
  }
  SaveModel(modelID) {
    let modelSize = this.wasmModule.GetModelSize(modelID);
    const headerBytes = 512;
    let dataBuffer = new Uint8Array(modelSize + headerBytes);
    let size = 0;
    this.wasmModule.SaveModel(modelID, (srcPtr, srcSize) => {
      let src = this.wasmModule.HEAPU8.subarray(srcPtr, srcPtr + srcSize);
      size = srcSize;
      dataBuffer.set(src, 0);
    });
    let newBuffer = new Uint8Array(size);
    newBuffer.set(dataBuffer.subarray(0, size), 0);
    return newBuffer;
  }
  ExportFileAsIFC(modelID) {
    Log.warn("ExportFileAsIFC is deprecated, use SaveModel instead");
    return this.SaveModel(modelID);
  }
  GetGeometry(modelID, geometryExpressID) {
    return this.wasmModule.GetGeometry(modelID, geometryExpressID);
  }
  GetHeaderLine(modelID, headerType) {
    return this.wasmModule.GetHeaderLine(modelID, headerType);
  }
  GetAllTypesOfModel(modelID) {
    let typesNames = [];
    const elements = Object.keys(FromRawLineData[this.modelSchemaList[modelID]]).map((e) => parseInt(e));
    for (let i = 0; i < elements.length; i++) {
      const lines = this.GetLineIDsWithType(modelID, elements[i]);
      if (lines.size() > 0)
        typesNames.push({ typeID: elements[i], typeName: this.wasmModule.GetNameFromTypeCode(elements[i]) });
    }
    return typesNames;
  }
  GetLine(modelID, expressID, flatten = false, inverse = false) {
    let expressCheck = this.wasmModule.ValidateExpressID(modelID, expressID);
    if (!expressCheck) {
      return;
    }
    let rawLineData = this.GetRawLineData(modelID, expressID);
    let lineData = FromRawLineData[this.modelSchemaList[modelID]][rawLineData.type](rawLineData.ID, rawLineData.arguments);
    if (flatten) {
      this.FlattenLine(modelID, lineData);
    }
    let inverseData = InversePropertyDef[this.modelSchemaList[modelID]][rawLineData.type];
    if (inverse && inverseData != null) {
      for (let inverseProp of inverseData) {
        if (!inverseProp[3])
          lineData[inverseProp[0]] = null;
        else
          lineData[inverseProp[0]] = [];
        let targetTypes = [inverseProp[1]];
        if (typeof InheritanceDef[this.modelSchemaList[modelID]][inverseProp[1]] != "undefined") {
          targetTypes = targetTypes.concat(InheritanceDef[this.modelSchemaList[modelID]][inverseProp[1]]);
        }
        let inverseIDs = this.wasmModule.GetInversePropertyForItem(modelID, expressID, targetTypes, inverseProp[2], inverseProp[3]);
        if (!inverseProp[3] && inverseIDs.size() > 0) {
          if (!flatten)
            lineData[inverseProp[0]] = { type: 5, value: inverseIDs.get(0) };
          else
            lineData[inverseProp[0]] = this.GetLine(modelID, inverseIDs.get(0));
        } else {
          for (let x = 0; x < inverseIDs.size(); x++) {
            if (!flatten)
              lineData[inverseProp[0]].push({ type: 5, value: inverseIDs.get(x) });
            else
              lineData[inverseProp[0]].push(this.GetLine(modelID, inverseIDs.get(x)));
          }
        }
      }
    }
    return lineData;
  }
  GetNextExpressID(modelID, expressID) {
    return this.wasmModule.GetNextExpressID(modelID, expressID);
  }
  GetAndClearErrors(modelID) {
    return this.wasmModule.GetAndClearErrors(modelID);
  }
  CreateIfcEntity(modelID, type, ...args) {
    return Constructors[this.modelSchemaList[modelID]][type](-1, args);
  }
  CreateIfcType(modelID, type, value) {
    return TypeInitialisers[this.modelSchemaList[modelID]][type](value);
  }
  GetNameFromTypeCode(type) {
    return this.wasmModule.GetNameFromTypeCode(type);
  }
  GetTypeCodeFromName(modelID, typeName) {
    return this.wasmModule.GetTypeCodeFromName(modelID, typeName);
  }
  IsIfcElement(type) {
    return this.wasmModule.IsIfcElement(type);
  }
  GetIfcEntityList(modelID) {
    return Object.keys(FromRawLineData[this.modelSchemaList[modelID]]).map((x) => parseInt(x));
  }
  WriteLine(modelID, lineObject) {
    let property;
    for (property in lineObject) {
      const lineProperty = lineObject[property];
      if (lineProperty && lineProperty.expressID !== void 0) {
        this.WriteLine(modelID, lineProperty);
        lineObject[property] = new Handle(lineProperty.expressID);
      } else if (Array.isArray(lineProperty) && lineProperty.length > 0) {
        for (let i = 0; i < lineProperty.length; i++) {
          if (lineProperty[i].expressID !== void 0) {
            this.WriteLine(modelID, lineProperty[i]);
            lineObject[property][i] = new Handle(lineProperty[i].expressID);
          }
        }
      }
    }
    if (lineObject.expressID === void 0 || lineObject.expressID < 0) {
      lineObject.expressID = this.GetMaxExpressID(modelID) + 1;
    }
    let rawLineData = {
      ID: lineObject.expressID,
      type: lineObject.type,
      arguments: ToRawLineData[this.modelSchemaList[modelID]][lineObject.type](lineObject)
    };
    this.WriteRawLineData(modelID, rawLineData);
  }
  FlattenLine(modelID, line) {
    Object.keys(line).forEach((propertyName) => {
      let property = line[propertyName];
      if (property && property.type === 5) {
        if (property.value)
          line[propertyName] = this.GetLine(modelID, property.value, true);
      } else if (Array.isArray(property) && property.length > 0 && property[0].type === 5) {
        for (let i = 0; i < property.length; i++) {
          if (property[i].value)
            line[propertyName][i] = this.GetLine(modelID, property[i].value, true);
        }
      }
    });
  }
  GetRawLineData(modelID, expressID) {
    return this.wasmModule.GetLine(modelID, expressID);
  }
  WriteRawLineData(modelID, data) {
    this.wasmModule.WriteLine(modelID, data.ID, data.type, data.arguments);
  }
  GetLineIDsWithType(modelID, type, includeInherited = false) {
    let types = [];
    types.push(type);
    if (includeInherited && typeof InheritanceDef[this.modelSchemaList[modelID]][type] != "undefined") {
      types = types.concat(InheritanceDef[this.modelSchemaList[modelID]][type]);
    }
    return this.wasmModule.GetLineIDsWithType(modelID, types);
  }
  GetAllLines(modelID) {
    return this.wasmModule.GetAllLines(modelID);
  }
  SetGeometryTransformation(modelID, transformationMatrix) {
    if (transformationMatrix.length != 16) {
      throw new Error(`invalid matrix size: ${transformationMatrix.length}`);
    }
    this.wasmModule.SetGeometryTransformation(modelID, transformationMatrix);
  }
  GetCoordinationMatrix(modelID) {
    return this.wasmModule.GetCoordinationMatrix(modelID);
  }
  GetVertexArray(ptr, size) {
    return this.getSubArray(this.wasmModule.HEAPF32, ptr, size);
  }
  GetIndexArray(ptr, size) {
    return this.getSubArray(this.wasmModule.HEAPU32, ptr, size);
  }
  getSubArray(heap, startPtr, sizeBytes) {
    return heap.subarray(startPtr / 4, startPtr / 4 + sizeBytes).slice(0);
  }
  CloseModel(modelID) {
    this.ifcGuidMap.delete(modelID);
    this.wasmModule.CloseModel(modelID);
  }
  StreamAllMeshes(modelID, meshCallback) {
    this.wasmModule.StreamAllMeshes(modelID, meshCallback);
  }
  StreamAllMeshesWithTypes(modelID, types, meshCallback) {
    this.wasmModule.StreamAllMeshesWithTypes(modelID, types, meshCallback);
  }
  IsModelOpen(modelID) {
    return this.wasmModule.IsModelOpen(modelID);
  }
  LoadAllGeometry(modelID) {
    return this.wasmModule.LoadAllGeometry(modelID);
  }
  GetFlatMesh(modelID, expressID) {
    return this.wasmModule.GetFlatMesh(modelID, expressID);
  }
  GetMaxExpressID(modelID) {
    return this.wasmModule.GetMaxExpressID(modelID);
  }
  IncrementMaxExpressID(modelID, incrementSize) {
    Log.warn("IncrementMaxExpressID is deprecated, use GetNextExpressID or GetMaxExpressID instead");
    return this.wasmModule.GetMaxExpressID(modelID) + incrementSize;
  }
  GetLineType(modelID, expressID) {
    return this.wasmModule.GetLineType(modelID, expressID);
  }
  CreateIfcGuidToExpressIdMapping(modelID) {
    const map = new Map();
    let entities = this.GetIfcEntityList(modelID);
    for (const typeId of entities) {
      const lines = this.GetLineIDsWithType(modelID, typeId);
      const size = lines.size();
      for (let y = 0; y < size; y++) {
        const expressID = lines.get(y);
        const info = this.GetLine(modelID, expressID);
        if (info.GlobalId == null) {
          continue;
        }
        const globalID = info.GlobalId.value;
        map.set(expressID, globalID);
        map.set(globalID, expressID);
      }
    }
    this.ifcGuidMap.set(modelID, map);
  }
  SetWasmPath(path, absolute = false) {
    this.wasmPath = path;
    this.isWasmPathAbsolute = absolute;
  }
  SetLogLevel(level) {
    Log.setLogLevel(level);
    this.wasmModule.SetLogLevel(level);
  }
};
export {
  Constructors,
  EMPTY,
  ENUM,
  FILE_DESCRIPTION,
  FILE_NAME,
  FILE_SCHEMA,
  FromRawLineData,
  Handle,
  IFC2DCOMPOSITECURVE,
  IFC2X3,
  IFC4,
  IFC4_3,
  IFCABSORBEDDOSEMEASURE,
  IFCACCELERATIONMEASURE,
  IFCACTIONREQUEST,
  IFCACTOR,
  IFCACTORROLE,
  IFCACTUATOR,
  IFCACTUATORTYPE,
  IFCADDRESS,
  IFCADVANCEDBREP,
  IFCADVANCEDBREPWITHVOIDS,
  IFCADVANCEDFACE,
  IFCAIRTERMINAL,
  IFCAIRTERMINALBOX,
  IFCAIRTERMINALBOXTYPE,
  IFCAIRTERMINALTYPE,
  IFCAIRTOAIRHEATRECOVERY,
  IFCAIRTOAIRHEATRECOVERYTYPE,
  IFCALARM,
  IFCALARMTYPE,
  IFCALIGNMENT,
  IFCALIGNMENTCANT,
  IFCALIGNMENTCANTSEGMENT,
  IFCALIGNMENTHORIZONTAL,
  IFCALIGNMENTHORIZONTALSEGMENT,
  IFCALIGNMENTPARAMETERSEGMENT,
  IFCALIGNMENTSEGMENT,
  IFCALIGNMENTVERTICAL,
  IFCALIGNMENTVERTICALSEGMENT,
  IFCAMOUNTOFSUBSTANCEMEASURE,
  IFCANGULARDIMENSION,
  IFCANGULARVELOCITYMEASURE,
  IFCANNOTATION,
  IFCANNOTATIONCURVEOCCURRENCE,
  IFCANNOTATIONFILLAREA,
  IFCANNOTATIONFILLAREAOCCURRENCE,
  IFCANNOTATIONOCCURRENCE,
  IFCANNOTATIONSURFACE,
  IFCANNOTATIONSURFACEOCCURRENCE,
  IFCANNOTATIONSYMBOLOCCURRENCE,
  IFCANNOTATIONTEXTOCCURRENCE,
  IFCAPPLICATION,
  IFCAPPLIEDVALUE,
  IFCAPPLIEDVALUERELATIONSHIP,
  IFCAPPROVAL,
  IFCAPPROVALACTORRELATIONSHIP,
  IFCAPPROVALPROPERTYRELATIONSHIP,
  IFCAPPROVALRELATIONSHIP,
  IFCARBITRARYCLOSEDPROFILEDEF,
  IFCARBITRARYOPENPROFILEDEF,
  IFCARBITRARYPROFILEDEFWITHVOIDS,
  IFCARCINDEX,
  IFCAREADENSITYMEASURE,
  IFCAREAMEASURE,
  IFCASSET,
  IFCASYMMETRICISHAPEPROFILEDEF,
  IFCAUDIOVISUALAPPLIANCE,
  IFCAUDIOVISUALAPPLIANCETYPE,
  IFCAXIS1PLACEMENT,
  IFCAXIS2PLACEMENT2D,
  IFCAXIS2PLACEMENT3D,
  IFCAXIS2PLACEMENTLINEAR,
  IFCBEAM,
  IFCBEAMSTANDARDCASE,
  IFCBEAMTYPE,
  IFCBEARING,
  IFCBEARINGTYPE,
  IFCBEZIERCURVE,
  IFCBINARY,
  IFCBLOBTEXTURE,
  IFCBLOCK,
  IFCBOILER,
  IFCBOILERTYPE,
  IFCBOOLEAN,
  IFCBOOLEANCLIPPINGRESULT,
  IFCBOOLEANRESULT,
  IFCBOREHOLE,
  IFCBOUNDARYCONDITION,
  IFCBOUNDARYCURVE,
  IFCBOUNDARYEDGECONDITION,
  IFCBOUNDARYFACECONDITION,
  IFCBOUNDARYNODECONDITION,
  IFCBOUNDARYNODECONDITIONWARPING,
  IFCBOUNDEDCURVE,
  IFCBOUNDEDSURFACE,
  IFCBOUNDINGBOX,
  IFCBOXALIGNMENT,
  IFCBOXEDHALFSPACE,
  IFCBRIDGE,
  IFCBRIDGEPART,
  IFCBSPLINECURVE,
  IFCBSPLINECURVEWITHKNOTS,
  IFCBSPLINESURFACE,
  IFCBSPLINESURFACEWITHKNOTS,
  IFCBUILDING,
  IFCBUILDINGELEMENT,
  IFCBUILDINGELEMENTCOMPONENT,
  IFCBUILDINGELEMENTPART,
  IFCBUILDINGELEMENTPARTTYPE,
  IFCBUILDINGELEMENTPROXY,
  IFCBUILDINGELEMENTPROXYTYPE,
  IFCBUILDINGELEMENTTYPE,
  IFCBUILDINGSTOREY,
  IFCBUILDINGSYSTEM,
  IFCBUILTELEMENT,
  IFCBUILTELEMENTTYPE,
  IFCBUILTSYSTEM,
  IFCBURNER,
  IFCBURNERTYPE,
  IFCCABLECARRIERFITTING,
  IFCCABLECARRIERFITTINGTYPE,
  IFCCABLECARRIERSEGMENT,
  IFCCABLECARRIERSEGMENTTYPE,
  IFCCABLEFITTING,
  IFCCABLEFITTINGTYPE,
  IFCCABLESEGMENT,
  IFCCABLESEGMENTTYPE,
  IFCCAISSONFOUNDATION,
  IFCCAISSONFOUNDATIONTYPE,
  IFCCALENDARDATE,
  IFCCARDINALPOINTREFERENCE,
  IFCCARTESIANPOINT,
  IFCCARTESIANPOINTLIST,
  IFCCARTESIANPOINTLIST2D,
  IFCCARTESIANPOINTLIST3D,
  IFCCARTESIANTRANSFORMATIONOPERATOR,
  IFCCARTESIANTRANSFORMATIONOPERATOR2D,
  IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM,
  IFCCARTESIANTRANSFORMATIONOPERATOR3D,
  IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM,
  IFCCENTERLINEPROFILEDEF,
  IFCCHAMFEREDGEFEATURE,
  IFCCHILLER,
  IFCCHILLERTYPE,
  IFCCHIMNEY,
  IFCCHIMNEYTYPE,
  IFCCIRCLE,
  IFCCIRCLEHOLLOWPROFILEDEF,
  IFCCIRCLEPROFILEDEF,
  IFCCIVILELEMENT,
  IFCCIVILELEMENTTYPE,
  IFCCLASSIFICATION,
  IFCCLASSIFICATIONITEM,
  IFCCLASSIFICATIONITEMRELATIONSHIP,
  IFCCLASSIFICATIONNOTATION,
  IFCCLASSIFICATIONNOTATIONFACET,
  IFCCLASSIFICATIONREFERENCE,
  IFCCLOSEDSHELL,
  IFCCLOTHOID,
  IFCCOIL,
  IFCCOILTYPE,
  IFCCOLOURRGB,
  IFCCOLOURRGBLIST,
  IFCCOLOURSPECIFICATION,
  IFCCOLUMN,
  IFCCOLUMNSTANDARDCASE,
  IFCCOLUMNTYPE,
  IFCCOMMUNICATIONSAPPLIANCE,
  IFCCOMMUNICATIONSAPPLIANCETYPE,
  IFCCOMPLEXNUMBER,
  IFCCOMPLEXPROPERTY,
  IFCCOMPLEXPROPERTYTEMPLATE,
  IFCCOMPOSITECURVE,
  IFCCOMPOSITECURVEONSURFACE,
  IFCCOMPOSITECURVESEGMENT,
  IFCCOMPOSITEPROFILEDEF,
  IFCCOMPOUNDPLANEANGLEMEASURE,
  IFCCOMPRESSOR,
  IFCCOMPRESSORTYPE,
  IFCCONDENSER,
  IFCCONDENSERTYPE,
  IFCCONDITION,
  IFCCONDITIONCRITERION,
  IFCCONIC,
  IFCCONNECTEDFACESET,
  IFCCONNECTIONCURVEGEOMETRY,
  IFCCONNECTIONGEOMETRY,
  IFCCONNECTIONPOINTECCENTRICITY,
  IFCCONNECTIONPOINTGEOMETRY,
  IFCCONNECTIONPORTGEOMETRY,
  IFCCONNECTIONSURFACEGEOMETRY,
  IFCCONNECTIONVOLUMEGEOMETRY,
  IFCCONSTRAINT,
  IFCCONSTRAINTAGGREGATIONRELATIONSHIP,
  IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP,
  IFCCONSTRAINTRELATIONSHIP,
  IFCCONSTRUCTIONEQUIPMENTRESOURCE,
  IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE,
  IFCCONSTRUCTIONMATERIALRESOURCE,
  IFCCONSTRUCTIONMATERIALRESOURCETYPE,
  IFCCONSTRUCTIONPRODUCTRESOURCE,
  IFCCONSTRUCTIONPRODUCTRESOURCETYPE,
  IFCCONSTRUCTIONRESOURCE,
  IFCCONSTRUCTIONRESOURCETYPE,
  IFCCONTEXT,
  IFCCONTEXTDEPENDENTMEASURE,
  IFCCONTEXTDEPENDENTUNIT,
  IFCCONTROL,
  IFCCONTROLLER,
  IFCCONTROLLERTYPE,
  IFCCONVERSIONBASEDUNIT,
  IFCCONVERSIONBASEDUNITWITHOFFSET,
  IFCCONVEYORSEGMENT,
  IFCCONVEYORSEGMENTTYPE,
  IFCCOOLEDBEAM,
  IFCCOOLEDBEAMTYPE,
  IFCCOOLINGTOWER,
  IFCCOOLINGTOWERTYPE,
  IFCCOORDINATEDUNIVERSALTIMEOFFSET,
  IFCCOORDINATEOPERATION,
  IFCCOORDINATEREFERENCESYSTEM,
  IFCCOSINESPIRAL,
  IFCCOSTITEM,
  IFCCOSTSCHEDULE,
  IFCCOSTVALUE,
  IFCCOUNTMEASURE,
  IFCCOURSE,
  IFCCOURSETYPE,
  IFCCOVERING,
  IFCCOVERINGTYPE,
  IFCCRANERAILASHAPEPROFILEDEF,
  IFCCRANERAILFSHAPEPROFILEDEF,
  IFCCREWRESOURCE,
  IFCCREWRESOURCETYPE,
  IFCCSGPRIMITIVE3D,
  IFCCSGSOLID,
  IFCCSHAPEPROFILEDEF,
  IFCCURRENCYRELATIONSHIP,
  IFCCURTAINWALL,
  IFCCURTAINWALLTYPE,
  IFCCURVATUREMEASURE,
  IFCCURVE,
  IFCCURVEBOUNDEDPLANE,
  IFCCURVEBOUNDEDSURFACE,
  IFCCURVESEGMENT,
  IFCCURVESTYLE,
  IFCCURVESTYLEFONT,
  IFCCURVESTYLEFONTANDSCALING,
  IFCCURVESTYLEFONTPATTERN,
  IFCCYLINDRICALSURFACE,
  IFCDAMPER,
  IFCDAMPERTYPE,
  IFCDATE,
  IFCDATEANDTIME,
  IFCDATETIME,
  IFCDAYINMONTHNUMBER,
  IFCDAYINWEEKNUMBER,
  IFCDAYLIGHTSAVINGHOUR,
  IFCDEEPFOUNDATION,
  IFCDEEPFOUNDATIONTYPE,
  IFCDEFINEDSYMBOL,
  IFCDERIVEDPROFILEDEF,
  IFCDERIVEDUNIT,
  IFCDERIVEDUNITELEMENT,
  IFCDESCRIPTIVEMEASURE,
  IFCDIAMETERDIMENSION,
  IFCDIMENSIONALEXPONENTS,
  IFCDIMENSIONCALLOUTRELATIONSHIP,
  IFCDIMENSIONCOUNT,
  IFCDIMENSIONCURVE,
  IFCDIMENSIONCURVEDIRECTEDCALLOUT,
  IFCDIMENSIONCURVETERMINATOR,
  IFCDIMENSIONPAIR,
  IFCDIRECTION,
  IFCDIRECTRIXCURVESWEPTAREASOLID,
  IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID,
  IFCDISCRETEACCESSORY,
  IFCDISCRETEACCESSORYTYPE,
  IFCDISTRIBUTIONBOARD,
  IFCDISTRIBUTIONBOARDTYPE,
  IFCDISTRIBUTIONCHAMBERELEMENT,
  IFCDISTRIBUTIONCHAMBERELEMENTTYPE,
  IFCDISTRIBUTIONCIRCUIT,
  IFCDISTRIBUTIONCONTROLELEMENT,
  IFCDISTRIBUTIONCONTROLELEMENTTYPE,
  IFCDISTRIBUTIONELEMENT,
  IFCDISTRIBUTIONELEMENTTYPE,
  IFCDISTRIBUTIONFLOWELEMENT,
  IFCDISTRIBUTIONFLOWELEMENTTYPE,
  IFCDISTRIBUTIONPORT,
  IFCDISTRIBUTIONSYSTEM,
  IFCDOCUMENTELECTRONICFORMAT,
  IFCDOCUMENTINFORMATION,
  IFCDOCUMENTINFORMATIONRELATIONSHIP,
  IFCDOCUMENTREFERENCE,
  IFCDOOR,
  IFCDOORLININGPROPERTIES,
  IFCDOORPANELPROPERTIES,
  IFCDOORSTANDARDCASE,
  IFCDOORSTYLE,
  IFCDOORTYPE,
  IFCDOSEEQUIVALENTMEASURE,
  IFCDRAUGHTINGCALLOUT,
  IFCDRAUGHTINGCALLOUTRELATIONSHIP,
  IFCDRAUGHTINGPREDEFINEDCOLOUR,
  IFCDRAUGHTINGPREDEFINEDCURVEFONT,
  IFCDRAUGHTINGPREDEFINEDTEXTFONT,
  IFCDUCTFITTING,
  IFCDUCTFITTINGTYPE,
  IFCDUCTSEGMENT,
  IFCDUCTSEGMENTTYPE,
  IFCDUCTSILENCER,
  IFCDUCTSILENCERTYPE,
  IFCDURATION,
  IFCDYNAMICVISCOSITYMEASURE,
  IFCEARTHWORKSCUT,
  IFCEARTHWORKSELEMENT,
  IFCEARTHWORKSFILL,
  IFCEDGE,
  IFCEDGECURVE,
  IFCEDGEFEATURE,
  IFCEDGELOOP,
  IFCELECTRICALBASEPROPERTIES,
  IFCELECTRICALCIRCUIT,
  IFCELECTRICALELEMENT,
  IFCELECTRICAPPLIANCE,
  IFCELECTRICAPPLIANCETYPE,
  IFCELECTRICCAPACITANCEMEASURE,
  IFCELECTRICCHARGEMEASURE,
  IFCELECTRICCONDUCTANCEMEASURE,
  IFCELECTRICCURRENTMEASURE,
  IFCELECTRICDISTRIBUTIONBOARD,
  IFCELECTRICDISTRIBUTIONBOARDTYPE,
  IFCELECTRICDISTRIBUTIONPOINT,
  IFCELECTRICFLOWSTORAGEDEVICE,
  IFCELECTRICFLOWSTORAGEDEVICETYPE,
  IFCELECTRICFLOWTREATMENTDEVICE,
  IFCELECTRICFLOWTREATMENTDEVICETYPE,
  IFCELECTRICGENERATOR,
  IFCELECTRICGENERATORTYPE,
  IFCELECTRICHEATERTYPE,
  IFCELECTRICMOTOR,
  IFCELECTRICMOTORTYPE,
  IFCELECTRICRESISTANCEMEASURE,
  IFCELECTRICTIMECONTROL,
  IFCELECTRICTIMECONTROLTYPE,
  IFCELECTRICVOLTAGEMEASURE,
  IFCELEMENT,
  IFCELEMENTARYSURFACE,
  IFCELEMENTASSEMBLY,
  IFCELEMENTASSEMBLYTYPE,
  IFCELEMENTCOMPONENT,
  IFCELEMENTCOMPONENTTYPE,
  IFCELEMENTQUANTITY,
  IFCELEMENTTYPE,
  IFCELLIPSE,
  IFCELLIPSEPROFILEDEF,
  IFCENERGYCONVERSIONDEVICE,
  IFCENERGYCONVERSIONDEVICETYPE,
  IFCENERGYMEASURE,
  IFCENERGYPROPERTIES,
  IFCENGINE,
  IFCENGINETYPE,
  IFCENVIRONMENTALIMPACTVALUE,
  IFCEQUIPMENTELEMENT,
  IFCEQUIPMENTSTANDARD,
  IFCEVAPORATIVECOOLER,
  IFCEVAPORATIVECOOLERTYPE,
  IFCEVAPORATOR,
  IFCEVAPORATORTYPE,
  IFCEVENT,
  IFCEVENTTIME,
  IFCEVENTTYPE,
  IFCEXTENDEDMATERIALPROPERTIES,
  IFCEXTENDEDPROPERTIES,
  IFCEXTERNALINFORMATION,
  IFCEXTERNALLYDEFINEDHATCHSTYLE,
  IFCEXTERNALLYDEFINEDSURFACESTYLE,
  IFCEXTERNALLYDEFINEDSYMBOL,
  IFCEXTERNALLYDEFINEDTEXTFONT,
  IFCEXTERNALREFERENCE,
  IFCEXTERNALREFERENCERELATIONSHIP,
  IFCEXTERNALSPATIALELEMENT,
  IFCEXTERNALSPATIALSTRUCTUREELEMENT,
  IFCEXTRUDEDAREASOLID,
  IFCEXTRUDEDAREASOLIDTAPERED,
  IFCFACE,
  IFCFACEBASEDSURFACEMODEL,
  IFCFACEBOUND,
  IFCFACEOUTERBOUND,
  IFCFACESURFACE,
  IFCFACETEDBREP,
  IFCFACETEDBREPWITHVOIDS,
  IFCFACILITY,
  IFCFACILITYPART,
  IFCFACILITYPARTCOMMON,
  IFCFAILURECONNECTIONCONDITION,
  IFCFAN,
  IFCFANTYPE,
  IFCFASTENER,
  IFCFASTENERTYPE,
  IFCFEATUREELEMENT,
  IFCFEATUREELEMENTADDITION,
  IFCFEATUREELEMENTSUBTRACTION,
  IFCFILLAREASTYLE,
  IFCFILLAREASTYLEHATCHING,
  IFCFILLAREASTYLETILES,
  IFCFILLAREASTYLETILESYMBOLWITHSTYLE,
  IFCFILTER,
  IFCFILTERTYPE,
  IFCFIRESUPPRESSIONTERMINAL,
  IFCFIRESUPPRESSIONTERMINALTYPE,
  IFCFIXEDREFERENCESWEPTAREASOLID,
  IFCFLOWCONTROLLER,
  IFCFLOWCONTROLLERTYPE,
  IFCFLOWFITTING,
  IFCFLOWFITTINGTYPE,
  IFCFLOWINSTRUMENT,
  IFCFLOWINSTRUMENTTYPE,
  IFCFLOWMETER,
  IFCFLOWMETERTYPE,
  IFCFLOWMOVINGDEVICE,
  IFCFLOWMOVINGDEVICETYPE,
  IFCFLOWSEGMENT,
  IFCFLOWSEGMENTTYPE,
  IFCFLOWSTORAGEDEVICE,
  IFCFLOWSTORAGEDEVICETYPE,
  IFCFLOWTERMINAL,
  IFCFLOWTERMINALTYPE,
  IFCFLOWTREATMENTDEVICE,
  IFCFLOWTREATMENTDEVICETYPE,
  IFCFLUIDFLOWPROPERTIES,
  IFCFONTSTYLE,
  IFCFONTVARIANT,
  IFCFONTWEIGHT,
  IFCFOOTING,
  IFCFOOTINGTYPE,
  IFCFORCEMEASURE,
  IFCFREQUENCYMEASURE,
  IFCFUELPROPERTIES,
  IFCFURNISHINGELEMENT,
  IFCFURNISHINGELEMENTTYPE,
  IFCFURNITURE,
  IFCFURNITURESTANDARD,
  IFCFURNITURETYPE,
  IFCGASTERMINALTYPE,
  IFCGENERALMATERIALPROPERTIES,
  IFCGENERALPROFILEPROPERTIES,
  IFCGEOGRAPHICELEMENT,
  IFCGEOGRAPHICELEMENTTYPE,
  IFCGEOMETRICCURVESET,
  IFCGEOMETRICREPRESENTATIONCONTEXT,
  IFCGEOMETRICREPRESENTATIONITEM,
  IFCGEOMETRICREPRESENTATIONSUBCONTEXT,
  IFCGEOMETRICSET,
  IFCGEOMODEL,
  IFCGEOSLICE,
  IFCGEOTECHNICALASSEMBLY,
  IFCGEOTECHNICALELEMENT,
  IFCGEOTECHNICALSTRATUM,
  IFCGLOBALLYUNIQUEID,
  IFCGRADIENTCURVE,
  IFCGRID,
  IFCGRIDAXIS,
  IFCGRIDPLACEMENT,
  IFCGROUP,
  IFCHALFSPACESOLID,
  IFCHEATEXCHANGER,
  IFCHEATEXCHANGERTYPE,
  IFCHEATFLUXDENSITYMEASURE,
  IFCHEATINGVALUEMEASURE,
  IFCHOURINDAY,
  IFCHUMIDIFIER,
  IFCHUMIDIFIERTYPE,
  IFCHYGROSCOPICMATERIALPROPERTIES,
  IFCIDENTIFIER,
  IFCILLUMINANCEMEASURE,
  IFCIMAGETEXTURE,
  IFCIMPACTPROTECTIONDEVICE,
  IFCIMPACTPROTECTIONDEVICETYPE,
  IFCINDEXEDCOLOURMAP,
  IFCINDEXEDPOLYCURVE,
  IFCINDEXEDPOLYGONALFACE,
  IFCINDEXEDPOLYGONALFACEWITHVOIDS,
  IFCINDEXEDPOLYGONALTEXTUREMAP,
  IFCINDEXEDTEXTUREMAP,
  IFCINDEXEDTRIANGLETEXTUREMAP,
  IFCINDUCTANCEMEASURE,
  IFCINTEGER,
  IFCINTEGERCOUNTRATEMEASURE,
  IFCINTERCEPTOR,
  IFCINTERCEPTORTYPE,
  IFCINTERSECTIONCURVE,
  IFCINVENTORY,
  IFCIONCONCENTRATIONMEASURE,
  IFCIRREGULARTIMESERIES,
  IFCIRREGULARTIMESERIESVALUE,
  IFCISHAPEPROFILEDEF,
  IFCISOTHERMALMOISTURECAPACITYMEASURE,
  IFCJUNCTIONBOX,
  IFCJUNCTIONBOXTYPE,
  IFCKERB,
  IFCKERBTYPE,
  IFCKINEMATICVISCOSITYMEASURE,
  IFCLABEL,
  IFCLABORRESOURCE,
  IFCLABORRESOURCETYPE,
  IFCLAGTIME,
  IFCLAMP,
  IFCLAMPTYPE,
  IFCLANGUAGEID,
  IFCLENGTHMEASURE,
  IFCLIBRARYINFORMATION,
  IFCLIBRARYREFERENCE,
  IFCLIGHTDISTRIBUTIONDATA,
  IFCLIGHTFIXTURE,
  IFCLIGHTFIXTURETYPE,
  IFCLIGHTINTENSITYDISTRIBUTION,
  IFCLIGHTSOURCE,
  IFCLIGHTSOURCEAMBIENT,
  IFCLIGHTSOURCEDIRECTIONAL,
  IFCLIGHTSOURCEGONIOMETRIC,
  IFCLIGHTSOURCEPOSITIONAL,
  IFCLIGHTSOURCESPOT,
  IFCLINE,
  IFCLINEARDIMENSION,
  IFCLINEARELEMENT,
  IFCLINEARFORCEMEASURE,
  IFCLINEARMOMENTMEASURE,
  IFCLINEARPLACEMENT,
  IFCLINEARPOSITIONINGELEMENT,
  IFCLINEARSTIFFNESSMEASURE,
  IFCLINEARVELOCITYMEASURE,
  IFCLINEINDEX,
  IFCLIQUIDTERMINAL,
  IFCLIQUIDTERMINALTYPE,
  IFCLOCALPLACEMENT,
  IFCLOCALTIME,
  IFCLOGICAL,
  IFCLOOP,
  IFCLSHAPEPROFILEDEF,
  IFCLUMINOUSFLUXMEASURE,
  IFCLUMINOUSINTENSITYDISTRIBUTIONMEASURE,
  IFCLUMINOUSINTENSITYMEASURE,
  IFCMAGNETICFLUXDENSITYMEASURE,
  IFCMAGNETICFLUXMEASURE,
  IFCMANIFOLDSOLIDBREP,
  IFCMAPCONVERSION,
  IFCMAPPEDITEM,
  IFCMARINEFACILITY,
  IFCMARINEPART,
  IFCMASSDENSITYMEASURE,
  IFCMASSFLOWRATEMEASURE,
  IFCMASSMEASURE,
  IFCMASSPERLENGTHMEASURE,
  IFCMATERIAL,
  IFCMATERIALCLASSIFICATIONRELATIONSHIP,
  IFCMATERIALCONSTITUENT,
  IFCMATERIALCONSTITUENTSET,
  IFCMATERIALDEFINITION,
  IFCMATERIALDEFINITIONREPRESENTATION,
  IFCMATERIALLAYER,
  IFCMATERIALLAYERSET,
  IFCMATERIALLAYERSETUSAGE,
  IFCMATERIALLAYERWITHOFFSETS,
  IFCMATERIALLIST,
  IFCMATERIALPROFILE,
  IFCMATERIALPROFILESET,
  IFCMATERIALPROFILESETUSAGE,
  IFCMATERIALPROFILESETUSAGETAPERING,
  IFCMATERIALPROFILEWITHOFFSETS,
  IFCMATERIALPROPERTIES,
  IFCMATERIALRELATIONSHIP,
  IFCMATERIALUSAGEDEFINITION,
  IFCMEASUREWITHUNIT,
  IFCMECHANICALCONCRETEMATERIALPROPERTIES,
  IFCMECHANICALFASTENER,
  IFCMECHANICALFASTENERTYPE,
  IFCMECHANICALMATERIALPROPERTIES,
  IFCMECHANICALSTEELMATERIALPROPERTIES,
  IFCMEDICALDEVICE,
  IFCMEDICALDEVICETYPE,
  IFCMEMBER,
  IFCMEMBERSTANDARDCASE,
  IFCMEMBERTYPE,
  IFCMETRIC,
  IFCMINUTEINHOUR,
  IFCMIRROREDPROFILEDEF,
  IFCMOBILETELECOMMUNICATIONSAPPLIANCE,
  IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE,
  IFCMODULUSOFELASTICITYMEASURE,
  IFCMODULUSOFLINEARSUBGRADEREACTIONMEASURE,
  IFCMODULUSOFROTATIONALSUBGRADEREACTIONMEASURE,
  IFCMODULUSOFSUBGRADEREACTIONMEASURE,
  IFCMOISTUREDIFFUSIVITYMEASURE,
  IFCMOLECULARWEIGHTMEASURE,
  IFCMOMENTOFINERTIAMEASURE,
  IFCMONETARYMEASURE,
  IFCMONETARYUNIT,
  IFCMONTHINYEARNUMBER,
  IFCMOORINGDEVICE,
  IFCMOORINGDEVICETYPE,
  IFCMOTORCONNECTION,
  IFCMOTORCONNECTIONTYPE,
  IFCMOVE,
  IFCNAMEDUNIT,
  IFCNAVIGATIONELEMENT,
  IFCNAVIGATIONELEMENTTYPE,
  IFCNONNEGATIVELENGTHMEASURE,
  IFCNORMALISEDRATIOMEASURE,
  IFCNUMERICMEASURE,
  IFCOBJECT,
  IFCOBJECTDEFINITION,
  IFCOBJECTIVE,
  IFCOBJECTPLACEMENT,
  IFCOCCUPANT,
  IFCOFFSETCURVE,
  IFCOFFSETCURVE2D,
  IFCOFFSETCURVE3D,
  IFCOFFSETCURVEBYDISTANCES,
  IFCONEDIRECTIONREPEATFACTOR,
  IFCOPENCROSSPROFILEDEF,
  IFCOPENINGELEMENT,
  IFCOPENINGSTANDARDCASE,
  IFCOPENSHELL,
  IFCOPTICALMATERIALPROPERTIES,
  IFCORDERACTION,
  IFCORGANIZATION,
  IFCORGANIZATIONRELATIONSHIP,
  IFCORIENTEDEDGE,
  IFCOUTERBOUNDARYCURVE,
  IFCOUTLET,
  IFCOUTLETTYPE,
  IFCOWNERHISTORY,
  IFCPARAMETERIZEDPROFILEDEF,
  IFCPARAMETERVALUE,
  IFCPATH,
  IFCPAVEMENT,
  IFCPAVEMENTTYPE,
  IFCPCURVE,
  IFCPERFORMANCEHISTORY,
  IFCPERMEABLECOVERINGPROPERTIES,
  IFCPERMIT,
  IFCPERSON,
  IFCPERSONANDORGANIZATION,
  IFCPHMEASURE,
  IFCPHYSICALCOMPLEXQUANTITY,
  IFCPHYSICALQUANTITY,
  IFCPHYSICALSIMPLEQUANTITY,
  IFCPILE,
  IFCPILETYPE,
  IFCPIPEFITTING,
  IFCPIPEFITTINGTYPE,
  IFCPIPESEGMENT,
  IFCPIPESEGMENTTYPE,
  IFCPIXELTEXTURE,
  IFCPLACEMENT,
  IFCPLANARBOX,
  IFCPLANAREXTENT,
  IFCPLANARFORCEMEASURE,
  IFCPLANE,
  IFCPLANEANGLEMEASURE,
  IFCPLATE,
  IFCPLATESTANDARDCASE,
  IFCPLATETYPE,
  IFCPOINT,
  IFCPOINTBYDISTANCEEXPRESSION,
  IFCPOINTONCURVE,
  IFCPOINTONSURFACE,
  IFCPOLYGONALBOUNDEDHALFSPACE,
  IFCPOLYGONALFACESET,
  IFCPOLYLINE,
  IFCPOLYLOOP,
  IFCPOLYNOMIALCURVE,
  IFCPORT,
  IFCPOSITIONINGELEMENT,
  IFCPOSITIVEINTEGER,
  IFCPOSITIVELENGTHMEASURE,
  IFCPOSITIVEPLANEANGLEMEASURE,
  IFCPOSITIVERATIOMEASURE,
  IFCPOSTALADDRESS,
  IFCPOWERMEASURE,
  IFCPREDEFINEDCOLOUR,
  IFCPREDEFINEDCURVEFONT,
  IFCPREDEFINEDDIMENSIONSYMBOL,
  IFCPREDEFINEDITEM,
  IFCPREDEFINEDPOINTMARKERSYMBOL,
  IFCPREDEFINEDPROPERTIES,
  IFCPREDEFINEDPROPERTYSET,
  IFCPREDEFINEDSYMBOL,
  IFCPREDEFINEDTERMINATORSYMBOL,
  IFCPREDEFINEDTEXTFONT,
  IFCPRESENTABLETEXT,
  IFCPRESENTATIONITEM,
  IFCPRESENTATIONLAYERASSIGNMENT,
  IFCPRESENTATIONLAYERWITHSTYLE,
  IFCPRESENTATIONSTYLE,
  IFCPRESENTATIONSTYLEASSIGNMENT,
  IFCPRESSUREMEASURE,
  IFCPROCEDURE,
  IFCPROCEDURETYPE,
  IFCPROCESS,
  IFCPRODUCT,
  IFCPRODUCTDEFINITIONSHAPE,
  IFCPRODUCTREPRESENTATION,
  IFCPRODUCTSOFCOMBUSTIONPROPERTIES,
  IFCPROFILEDEF,
  IFCPROFILEPROPERTIES,
  IFCPROJECT,
  IFCPROJECTEDCRS,
  IFCPROJECTIONCURVE,
  IFCPROJECTIONELEMENT,
  IFCPROJECTLIBRARY,
  IFCPROJECTORDER,
  IFCPROJECTORDERRECORD,
  IFCPROPERTY,
  IFCPROPERTYABSTRACTION,
  IFCPROPERTYBOUNDEDVALUE,
  IFCPROPERTYCONSTRAINTRELATIONSHIP,
  IFCPROPERTYDEFINITION,
  IFCPROPERTYDEPENDENCYRELATIONSHIP,
  IFCPROPERTYENUMERATEDVALUE,
  IFCPROPERTYENUMERATION,
  IFCPROPERTYLISTVALUE,
  IFCPROPERTYREFERENCEVALUE,
  IFCPROPERTYSET,
  IFCPROPERTYSETDEFINITION,
  IFCPROPERTYSETDEFINITIONSET,
  IFCPROPERTYSETTEMPLATE,
  IFCPROPERTYSINGLEVALUE,
  IFCPROPERTYTABLEVALUE,
  IFCPROPERTYTEMPLATE,
  IFCPROPERTYTEMPLATEDEFINITION,
  IFCPROTECTIVEDEVICE,
  IFCPROTECTIVEDEVICETRIPPINGUNIT,
  IFCPROTECTIVEDEVICETRIPPINGUNITTYPE,
  IFCPROTECTIVEDEVICETYPE,
  IFCPROXY,
  IFCPUMP,
  IFCPUMPTYPE,
  IFCQUANTITYAREA,
  IFCQUANTITYCOUNT,
  IFCQUANTITYLENGTH,
  IFCQUANTITYNUMBER,
  IFCQUANTITYSET,
  IFCQUANTITYTIME,
  IFCQUANTITYVOLUME,
  IFCQUANTITYWEIGHT,
  IFCRADIOACTIVITYMEASURE,
  IFCRADIUSDIMENSION,
  IFCRAIL,
  IFCRAILING,
  IFCRAILINGTYPE,
  IFCRAILTYPE,
  IFCRAILWAY,
  IFCRAILWAYPART,
  IFCRAMP,
  IFCRAMPFLIGHT,
  IFCRAMPFLIGHTTYPE,
  IFCRAMPTYPE,
  IFCRATIOMEASURE,
  IFCRATIONALBEZIERCURVE,
  IFCRATIONALBSPLINECURVEWITHKNOTS,
  IFCRATIONALBSPLINESURFACEWITHKNOTS,
  IFCREAL,
  IFCRECTANGLEHOLLOWPROFILEDEF,
  IFCRECTANGLEPROFILEDEF,
  IFCRECTANGULARPYRAMID,
  IFCRECTANGULARTRIMMEDSURFACE,
  IFCRECURRENCEPATTERN,
  IFCREFERENCE,
  IFCREFERENCESVALUEDOCUMENT,
  IFCREFERENT,
  IFCREGULARTIMESERIES,
  IFCREINFORCEDSOIL,
  IFCREINFORCEMENTBARPROPERTIES,
  IFCREINFORCEMENTDEFINITIONPROPERTIES,
  IFCREINFORCINGBAR,
  IFCREINFORCINGBARTYPE,
  IFCREINFORCINGELEMENT,
  IFCREINFORCINGELEMENTTYPE,
  IFCREINFORCINGMESH,
  IFCREINFORCINGMESHTYPE,
  IFCRELADHERESTOELEMENT,
  IFCRELAGGREGATES,
  IFCRELASSIGNS,
  IFCRELASSIGNSTASKS,
  IFCRELASSIGNSTOACTOR,
  IFCRELASSIGNSTOCONTROL,
  IFCRELASSIGNSTOGROUP,
  IFCRELASSIGNSTOGROUPBYFACTOR,
  IFCRELASSIGNSTOPROCESS,
  IFCRELASSIGNSTOPRODUCT,
  IFCRELASSIGNSTOPROJECTORDER,
  IFCRELASSIGNSTORESOURCE,
  IFCRELASSOCIATES,
  IFCRELASSOCIATESAPPLIEDVALUE,
  IFCRELASSOCIATESAPPROVAL,
  IFCRELASSOCIATESCLASSIFICATION,
  IFCRELASSOCIATESCONSTRAINT,
  IFCRELASSOCIATESDOCUMENT,
  IFCRELASSOCIATESLIBRARY,
  IFCRELASSOCIATESMATERIAL,
  IFCRELASSOCIATESPROFILEDEF,
  IFCRELASSOCIATESPROFILEPROPERTIES,
  IFCRELATIONSHIP,
  IFCRELAXATION,
  IFCRELCONNECTS,
  IFCRELCONNECTSELEMENTS,
  IFCRELCONNECTSPATHELEMENTS,
  IFCRELCONNECTSPORTS,
  IFCRELCONNECTSPORTTOELEMENT,
  IFCRELCONNECTSSTRUCTURALACTIVITY,
  IFCRELCONNECTSSTRUCTURALELEMENT,
  IFCRELCONNECTSSTRUCTURALMEMBER,
  IFCRELCONNECTSWITHECCENTRICITY,
  IFCRELCONNECTSWITHREALIZINGELEMENTS,
  IFCRELCONTAINEDINSPATIALSTRUCTURE,
  IFCRELCOVERSBLDGELEMENTS,
  IFCRELCOVERSSPACES,
  IFCRELDECLARES,
  IFCRELDECOMPOSES,
  IFCRELDEFINES,
  IFCRELDEFINESBYOBJECT,
  IFCRELDEFINESBYPROPERTIES,
  IFCRELDEFINESBYTEMPLATE,
  IFCRELDEFINESBYTYPE,
  IFCRELFILLSELEMENT,
  IFCRELFLOWCONTROLELEMENTS,
  IFCRELINTERACTIONREQUIREMENTS,
  IFCRELINTERFERESELEMENTS,
  IFCRELNESTS,
  IFCRELOCCUPIESSPACES,
  IFCRELOVERRIDESPROPERTIES,
  IFCRELPOSITIONS,
  IFCRELPROJECTSELEMENT,
  IFCRELREFERENCEDINSPATIALSTRUCTURE,
  IFCRELSCHEDULESCOSTITEMS,
  IFCRELSEQUENCE,
  IFCRELSERVICESBUILDINGS,
  IFCRELSPACEBOUNDARY,
  IFCRELSPACEBOUNDARY1STLEVEL,
  IFCRELSPACEBOUNDARY2NDLEVEL,
  IFCRELVOIDSELEMENT,
  IFCREPARAMETRISEDCOMPOSITECURVESEGMENT,
  IFCREPRESENTATION,
  IFCREPRESENTATIONCONTEXT,
  IFCREPRESENTATIONITEM,
  IFCREPRESENTATIONMAP,
  IFCRESOURCE,
  IFCRESOURCEAPPROVALRELATIONSHIP,
  IFCRESOURCECONSTRAINTRELATIONSHIP,
  IFCRESOURCELEVELRELATIONSHIP,
  IFCRESOURCETIME,
  IFCREVOLVEDAREASOLID,
  IFCREVOLVEDAREASOLIDTAPERED,
  IFCRIBPLATEPROFILEPROPERTIES,
  IFCRIGHTCIRCULARCONE,
  IFCRIGHTCIRCULARCYLINDER,
  IFCROAD,
  IFCROADPART,
  IFCROOF,
  IFCROOFTYPE,
  IFCROOT,
  IFCROTATIONALFREQUENCYMEASURE,
  IFCROTATIONALMASSMEASURE,
  IFCROTATIONALSTIFFNESSMEASURE,
  IFCROUNDEDEDGEFEATURE,
  IFCROUNDEDRECTANGLEPROFILEDEF,
  IFCSANITARYTERMINAL,
  IFCSANITARYTERMINALTYPE,
  IFCSCHEDULETIMECONTROL,
  IFCSCHEDULINGTIME,
  IFCSEAMCURVE,
  IFCSECONDINMINUTE,
  IFCSECONDORDERPOLYNOMIALSPIRAL,
  IFCSECTIONALAREAINTEGRALMEASURE,
  IFCSECTIONEDSOLID,
  IFCSECTIONEDSOLIDHORIZONTAL,
  IFCSECTIONEDSPINE,
  IFCSECTIONEDSURFACE,
  IFCSECTIONMODULUSMEASURE,
  IFCSECTIONPROPERTIES,
  IFCSECTIONREINFORCEMENTPROPERTIES,
  IFCSEGMENT,
  IFCSEGMENTEDREFERENCECURVE,
  IFCSENSOR,
  IFCSENSORTYPE,
  IFCSERVICELIFE,
  IFCSERVICELIFEFACTOR,
  IFCSEVENTHORDERPOLYNOMIALSPIRAL,
  IFCSHADINGDEVICE,
  IFCSHADINGDEVICETYPE,
  IFCSHAPEASPECT,
  IFCSHAPEMODEL,
  IFCSHAPEREPRESENTATION,
  IFCSHEARMODULUSMEASURE,
  IFCSHELLBASEDSURFACEMODEL,
  IFCSIGN,
  IFCSIGNAL,
  IFCSIGNALTYPE,
  IFCSIGNTYPE,
  IFCSIMPLEPROPERTY,
  IFCSIMPLEPROPERTYTEMPLATE,
  IFCSINESPIRAL,
  IFCSITE,
  IFCSIUNIT,
  IFCSLAB,
  IFCSLABELEMENTEDCASE,
  IFCSLABSTANDARDCASE,
  IFCSLABTYPE,
  IFCSLIPPAGECONNECTIONCONDITION,
  IFCSOLARDEVICE,
  IFCSOLARDEVICETYPE,
  IFCSOLIDANGLEMEASURE,
  IFCSOLIDMODEL,
  IFCSOUNDPOWERLEVELMEASURE,
  IFCSOUNDPOWERMEASURE,
  IFCSOUNDPRESSURELEVELMEASURE,
  IFCSOUNDPRESSUREMEASURE,
  IFCSOUNDPROPERTIES,
  IFCSOUNDVALUE,
  IFCSPACE,
  IFCSPACEHEATER,
  IFCSPACEHEATERTYPE,
  IFCSPACEPROGRAM,
  IFCSPACETHERMALLOADPROPERTIES,
  IFCSPACETYPE,
  IFCSPATIALELEMENT,
  IFCSPATIALELEMENTTYPE,
  IFCSPATIALSTRUCTUREELEMENT,
  IFCSPATIALSTRUCTUREELEMENTTYPE,
  IFCSPATIALZONE,
  IFCSPATIALZONETYPE,
  IFCSPECIFICHEATCAPACITYMEASURE,
  IFCSPECULAREXPONENT,
  IFCSPECULARROUGHNESS,
  IFCSPHERE,
  IFCSPHERICALSURFACE,
  IFCSPIRAL,
  IFCSTACKTERMINAL,
  IFCSTACKTERMINALTYPE,
  IFCSTAIR,
  IFCSTAIRFLIGHT,
  IFCSTAIRFLIGHTTYPE,
  IFCSTAIRTYPE,
  IFCSTRUCTURALACTION,
  IFCSTRUCTURALACTIVITY,
  IFCSTRUCTURALANALYSISMODEL,
  IFCSTRUCTURALCONNECTION,
  IFCSTRUCTURALCONNECTIONCONDITION,
  IFCSTRUCTURALCURVEACTION,
  IFCSTRUCTURALCURVECONNECTION,
  IFCSTRUCTURALCURVEMEMBER,
  IFCSTRUCTURALCURVEMEMBERVARYING,
  IFCSTRUCTURALCURVEREACTION,
  IFCSTRUCTURALITEM,
  IFCSTRUCTURALLINEARACTION,
  IFCSTRUCTURALLINEARACTIONVARYING,
  IFCSTRUCTURALLOAD,
  IFCSTRUCTURALLOADCASE,
  IFCSTRUCTURALLOADCONFIGURATION,
  IFCSTRUCTURALLOADGROUP,
  IFCSTRUCTURALLOADLINEARFORCE,
  IFCSTRUCTURALLOADORRESULT,
  IFCSTRUCTURALLOADPLANARFORCE,
  IFCSTRUCTURALLOADSINGLEDISPLACEMENT,
  IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION,
  IFCSTRUCTURALLOADSINGLEFORCE,
  IFCSTRUCTURALLOADSINGLEFORCEWARPING,
  IFCSTRUCTURALLOADSTATIC,
  IFCSTRUCTURALLOADTEMPERATURE,
  IFCSTRUCTURALMEMBER,
  IFCSTRUCTURALPLANARACTION,
  IFCSTRUCTURALPLANARACTIONVARYING,
  IFCSTRUCTURALPOINTACTION,
  IFCSTRUCTURALPOINTCONNECTION,
  IFCSTRUCTURALPOINTREACTION,
  IFCSTRUCTURALPROFILEPROPERTIES,
  IFCSTRUCTURALREACTION,
  IFCSTRUCTURALRESULTGROUP,
  IFCSTRUCTURALSTEELPROFILEPROPERTIES,
  IFCSTRUCTURALSURFACEACTION,
  IFCSTRUCTURALSURFACECONNECTION,
  IFCSTRUCTURALSURFACEMEMBER,
  IFCSTRUCTURALSURFACEMEMBERVARYING,
  IFCSTRUCTURALSURFACEREACTION,
  IFCSTRUCTUREDDIMENSIONCALLOUT,
  IFCSTYLEDITEM,
  IFCSTYLEDREPRESENTATION,
  IFCSTYLEMODEL,
  IFCSUBCONTRACTRESOURCE,
  IFCSUBCONTRACTRESOURCETYPE,
  IFCSUBEDGE,
  IFCSURFACE,
  IFCSURFACECURVE,
  IFCSURFACECURVESWEPTAREASOLID,
  IFCSURFACEFEATURE,
  IFCSURFACEOFLINEAREXTRUSION,
  IFCSURFACEOFREVOLUTION,
  IFCSURFACEREINFORCEMENTAREA,
  IFCSURFACESTYLE,
  IFCSURFACESTYLELIGHTING,
  IFCSURFACESTYLEREFRACTION,
  IFCSURFACESTYLERENDERING,
  IFCSURFACESTYLESHADING,
  IFCSURFACESTYLEWITHTEXTURES,
  IFCSURFACETEXTURE,
  IFCSWEPTAREASOLID,
  IFCSWEPTDISKSOLID,
  IFCSWEPTDISKSOLIDPOLYGONAL,
  IFCSWEPTSURFACE,
  IFCSWITCHINGDEVICE,
  IFCSWITCHINGDEVICETYPE,
  IFCSYMBOLSTYLE,
  IFCSYSTEM,
  IFCSYSTEMFURNITUREELEMENT,
  IFCSYSTEMFURNITUREELEMENTTYPE,
  IFCTABLE,
  IFCTABLECOLUMN,
  IFCTABLEROW,
  IFCTANK,
  IFCTANKTYPE,
  IFCTASK,
  IFCTASKTIME,
  IFCTASKTIMERECURRING,
  IFCTASKTYPE,
  IFCTELECOMADDRESS,
  IFCTEMPERATUREGRADIENTMEASURE,
  IFCTEMPERATURERATEOFCHANGEMEASURE,
  IFCTENDON,
  IFCTENDONANCHOR,
  IFCTENDONANCHORTYPE,
  IFCTENDONCONDUIT,
  IFCTENDONCONDUITTYPE,
  IFCTENDONTYPE,
  IFCTERMINATORSYMBOL,
  IFCTESSELLATEDFACESET,
  IFCTESSELLATEDITEM,
  IFCTEXT,
  IFCTEXTALIGNMENT,
  IFCTEXTDECORATION,
  IFCTEXTFONTNAME,
  IFCTEXTLITERAL,
  IFCTEXTLITERALWITHEXTENT,
  IFCTEXTSTYLE,
  IFCTEXTSTYLEFONTMODEL,
  IFCTEXTSTYLEFORDEFINEDFONT,
  IFCTEXTSTYLETEXTMODEL,
  IFCTEXTSTYLEWITHBOXCHARACTERISTICS,
  IFCTEXTTRANSFORMATION,
  IFCTEXTURECOORDINATE,
  IFCTEXTURECOORDINATEGENERATOR,
  IFCTEXTURECOORDINATEINDICES,
  IFCTEXTURECOORDINATEINDICESWITHVOIDS,
  IFCTEXTUREMAP,
  IFCTEXTUREVERTEX,
  IFCTEXTUREVERTEXLIST,
  IFCTHERMALADMITTANCEMEASURE,
  IFCTHERMALCONDUCTIVITYMEASURE,
  IFCTHERMALEXPANSIONCOEFFICIENTMEASURE,
  IFCTHERMALMATERIALPROPERTIES,
  IFCTHERMALRESISTANCEMEASURE,
  IFCTHERMALTRANSMITTANCEMEASURE,
  IFCTHERMODYNAMICTEMPERATUREMEASURE,
  IFCTHIRDORDERPOLYNOMIALSPIRAL,
  IFCTIME,
  IFCTIMEMEASURE,
  IFCTIMEPERIOD,
  IFCTIMESERIES,
  IFCTIMESERIESREFERENCERELATIONSHIP,
  IFCTIMESERIESSCHEDULE,
  IFCTIMESERIESVALUE,
  IFCTIMESTAMP,
  IFCTOPOLOGICALREPRESENTATIONITEM,
  IFCTOPOLOGYREPRESENTATION,
  IFCTOROIDALSURFACE,
  IFCTORQUEMEASURE,
  IFCTRACKELEMENT,
  IFCTRACKELEMENTTYPE,
  IFCTRANSFORMER,
  IFCTRANSFORMERTYPE,
  IFCTRANSPORTATIONDEVICE,
  IFCTRANSPORTATIONDEVICETYPE,
  IFCTRANSPORTELEMENT,
  IFCTRANSPORTELEMENTTYPE,
  IFCTRAPEZIUMPROFILEDEF,
  IFCTRIANGULATEDFACESET,
  IFCTRIANGULATEDIRREGULARNETWORK,
  IFCTRIMMEDCURVE,
  IFCTSHAPEPROFILEDEF,
  IFCTUBEBUNDLE,
  IFCTUBEBUNDLETYPE,
  IFCTWODIRECTIONREPEATFACTOR,
  IFCTYPEOBJECT,
  IFCTYPEPROCESS,
  IFCTYPEPRODUCT,
  IFCTYPERESOURCE,
  IFCUNITARYCONTROLELEMENT,
  IFCUNITARYCONTROLELEMENTTYPE,
  IFCUNITARYEQUIPMENT,
  IFCUNITARYEQUIPMENTTYPE,
  IFCUNITASSIGNMENT,
  IFCURIREFERENCE,
  IFCUSHAPEPROFILEDEF,
  IFCVALVE,
  IFCVALVETYPE,
  IFCVAPORPERMEABILITYMEASURE,
  IFCVECTOR,
  IFCVEHICLE,
  IFCVEHICLETYPE,
  IFCVERTEX,
  IFCVERTEXBASEDTEXTUREMAP,
  IFCVERTEXLOOP,
  IFCVERTEXPOINT,
  IFCVIBRATIONDAMPER,
  IFCVIBRATIONDAMPERTYPE,
  IFCVIBRATIONISOLATOR,
  IFCVIBRATIONISOLATORTYPE,
  IFCVIRTUALELEMENT,
  IFCVIRTUALGRIDINTERSECTION,
  IFCVOIDINGFEATURE,
  IFCVOLUMEMEASURE,
  IFCVOLUMETRICFLOWRATEMEASURE,
  IFCWALL,
  IFCWALLELEMENTEDCASE,
  IFCWALLSTANDARDCASE,
  IFCWALLTYPE,
  IFCWARPINGCONSTANTMEASURE,
  IFCWARPINGMOMENTMEASURE,
  IFCWASTETERMINAL,
  IFCWASTETERMINALTYPE,
  IFCWATERPROPERTIES,
  IFCWINDOW,
  IFCWINDOWLININGPROPERTIES,
  IFCWINDOWPANELPROPERTIES,
  IFCWINDOWSTANDARDCASE,
  IFCWINDOWSTYLE,
  IFCWINDOWTYPE,
  IFCWORKCALENDAR,
  IFCWORKCONTROL,
  IFCWORKPLAN,
  IFCWORKSCHEDULE,
  IFCWORKTIME,
  IFCYEARNUMBER,
  IFCZONE,
  IFCZSHAPEPROFILEDEF,
  IfcAPI2 as IfcAPI,
  IfcLineObject,
  InheritanceDef,
  InversePropertyDef,
  LABEL,
  LINE_END,
  LogLevel,
  REAL,
  REF,
  SET_BEGIN,
  SET_END,
  STRING,
  SchemaNames,
  Schemas,
  ToRawLineData,
  TypeInitialisers,
  UNKNOWN,
  ms
};
